function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2d52"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2d52"] = parcelRequire;
}
parcelRequire.register("4XZfq", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $39dc2e9f7f872b5d$export$ffb0004e005737fa; }, function (v) { return $39dc2e9f7f872b5d$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $39dc2e9f7f872b5d$export$34b9dba7ce09269b; }, function (v) { return $39dc2e9f7f872b5d$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $39dc2e9f7f872b5d$export$25062201e9e25d76; }, function (v) { return $39dc2e9f7f872b5d$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $39dc2e9f7f872b5d$export$ffb0004e005737fa;
var $39dc2e9f7f872b5d$export$34b9dba7ce09269b;
var $39dc2e9f7f872b5d$export$25062201e9e25d76;
"use strict";

var $P551f = parcelRequire("P551f");
var $39dc2e9f7f872b5d$var$k = Symbol.for("react.element"), $39dc2e9f7f872b5d$var$l = Symbol.for("react.fragment"), $39dc2e9f7f872b5d$var$m = Object.prototype.hasOwnProperty, $39dc2e9f7f872b5d$var$n = $P551f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $39dc2e9f7f872b5d$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $39dc2e9f7f872b5d$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$39dc2e9f7f872b5d$var$m.call(a, b) && !$39dc2e9f7f872b5d$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $39dc2e9f7f872b5d$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $39dc2e9f7f872b5d$var$n.current
    };
}
$39dc2e9f7f872b5d$export$ffb0004e005737fa = $39dc2e9f7f872b5d$var$l;
$39dc2e9f7f872b5d$export$34b9dba7ce09269b = $39dc2e9f7f872b5d$var$q;
$39dc2e9f7f872b5d$export$25062201e9e25d76 = $39dc2e9f7f872b5d$var$q;

});
parcelRequire.register("P551f", function(module, exports) {
"use strict";

module.exports = (parcelRequire("4YaDA"));

});
parcelRequire.register("4YaDA", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $39e5046cd8f7919a$export$dca3b0875bd9a954; }, function (v) { return $39e5046cd8f7919a$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $39e5046cd8f7919a$export$16fa2f45be04daa8; }, function (v) { return $39e5046cd8f7919a$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $39e5046cd8f7919a$export$ffb0004e005737fa; }, function (v) { return $39e5046cd8f7919a$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $39e5046cd8f7919a$export$e2c29f18771995cb; }, function (v) { return $39e5046cd8f7919a$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $39e5046cd8f7919a$export$221d75b3f55bb0bd; }, function (v) { return $39e5046cd8f7919a$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $39e5046cd8f7919a$export$5f8d39834fd61797; }, function (v) { return $39e5046cd8f7919a$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $39e5046cd8f7919a$export$74bf444e3cd11ea5; }, function (v) { return $39e5046cd8f7919a$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $39e5046cd8f7919a$export$ae55be85d98224ed; }, function (v) { return $39e5046cd8f7919a$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $39e5046cd8f7919a$export$e530037191fcd5d7; }, function (v) { return $39e5046cd8f7919a$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $39e5046cd8f7919a$export$fd42f52fd3ae1109; }, function (v) { return $39e5046cd8f7919a$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $39e5046cd8f7919a$export$c8a8987d4410bf2d; }, function (v) { return $39e5046cd8f7919a$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $39e5046cd8f7919a$export$d38cd72104c1f0e9; }, function (v) { return $39e5046cd8f7919a$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $39e5046cd8f7919a$export$7d1e3a5e95ceca43; }, function (v) { return $39e5046cd8f7919a$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $39e5046cd8f7919a$export$257a8862b851cb5b; }, function (v) { return $39e5046cd8f7919a$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $39e5046cd8f7919a$export$a8257692ac88316c; }, function (v) { return $39e5046cd8f7919a$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $39e5046cd8f7919a$export$488013bae63b21da; }, function (v) { return $39e5046cd8f7919a$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $39e5046cd8f7919a$export$7c73462e0d25e514; }, function (v) { return $39e5046cd8f7919a$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $39e5046cd8f7919a$export$7568632d0d33d16d; }, function (v) { return $39e5046cd8f7919a$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $39e5046cd8f7919a$export$88948ce120ea2619; }, function (v) { return $39e5046cd8f7919a$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $39e5046cd8f7919a$export$35808ee640e87ca7; }, function (v) { return $39e5046cd8f7919a$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $39e5046cd8f7919a$export$fae74005e78b1a27; }, function (v) { return $39e5046cd8f7919a$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $39e5046cd8f7919a$export$dc8fbce3eb94dc1e; }, function (v) { return $39e5046cd8f7919a$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $39e5046cd8f7919a$export$6a7bc4e911dc01cf; }, function (v) { return $39e5046cd8f7919a$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $39e5046cd8f7919a$export$6d9c69b0de29b591; }, function (v) { return $39e5046cd8f7919a$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $39e5046cd8f7919a$export$f680877a34711e37; }, function (v) { return $39e5046cd8f7919a$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $39e5046cd8f7919a$export$d5a552a76deda3c2; }, function (v) { return $39e5046cd8f7919a$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $39e5046cd8f7919a$export$aaabe4eda9ed9969; }, function (v) { return $39e5046cd8f7919a$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $39e5046cd8f7919a$export$e5c5a5f917a5871c; }, function (v) { return $39e5046cd8f7919a$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $39e5046cd8f7919a$export$1538c33de8887b59; }, function (v) { return $39e5046cd8f7919a$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $39e5046cd8f7919a$export$13e3392192263954; }, function (v) { return $39e5046cd8f7919a$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $39e5046cd8f7919a$export$b8f5890fc79d6aca; }, function (v) { return $39e5046cd8f7919a$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $39e5046cd8f7919a$export$60241385465d0a34; }, function (v) { return $39e5046cd8f7919a$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $39e5046cd8f7919a$export$306c0aa65ff9ec16; }, function (v) { return $39e5046cd8f7919a$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $39e5046cd8f7919a$export$7b286972b8d8ccbf; }, function (v) { return $39e5046cd8f7919a$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $39e5046cd8f7919a$export$83d89fbfd8236492; }, function (v) { return $39e5046cd8f7919a$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $39e5046cd8f7919a$export$dca3b0875bd9a954;
var $39e5046cd8f7919a$export$16fa2f45be04daa8;
var $39e5046cd8f7919a$export$ffb0004e005737fa;
var $39e5046cd8f7919a$export$e2c29f18771995cb;
var $39e5046cd8f7919a$export$221d75b3f55bb0bd;
var $39e5046cd8f7919a$export$5f8d39834fd61797;
var $39e5046cd8f7919a$export$74bf444e3cd11ea5;
var $39e5046cd8f7919a$export$ae55be85d98224ed;
var $39e5046cd8f7919a$export$e530037191fcd5d7;
var $39e5046cd8f7919a$export$fd42f52fd3ae1109;
var $39e5046cd8f7919a$export$c8a8987d4410bf2d;
var $39e5046cd8f7919a$export$d38cd72104c1f0e9;
var $39e5046cd8f7919a$export$7d1e3a5e95ceca43;
var $39e5046cd8f7919a$export$257a8862b851cb5b;
var $39e5046cd8f7919a$export$a8257692ac88316c;
var $39e5046cd8f7919a$export$488013bae63b21da;
var $39e5046cd8f7919a$export$7c73462e0d25e514;
var $39e5046cd8f7919a$export$7568632d0d33d16d;
var $39e5046cd8f7919a$export$88948ce120ea2619;
var $39e5046cd8f7919a$export$35808ee640e87ca7;
var $39e5046cd8f7919a$export$fae74005e78b1a27;
var $39e5046cd8f7919a$export$dc8fbce3eb94dc1e;
var $39e5046cd8f7919a$export$6a7bc4e911dc01cf;
var $39e5046cd8f7919a$export$6d9c69b0de29b591;
var $39e5046cd8f7919a$export$f680877a34711e37;
var $39e5046cd8f7919a$export$d5a552a76deda3c2;
var $39e5046cd8f7919a$export$aaabe4eda9ed9969;
var $39e5046cd8f7919a$export$e5c5a5f917a5871c;
var $39e5046cd8f7919a$export$1538c33de8887b59;
var $39e5046cd8f7919a$export$13e3392192263954;
var $39e5046cd8f7919a$export$b8f5890fc79d6aca;
var $39e5046cd8f7919a$export$60241385465d0a34;
var $39e5046cd8f7919a$export$306c0aa65ff9ec16;
var $39e5046cd8f7919a$export$7b286972b8d8ccbf;
var $39e5046cd8f7919a$export$83d89fbfd8236492;
"use strict";
var $39e5046cd8f7919a$var$l = Symbol.for("react.element"), $39e5046cd8f7919a$var$n = Symbol.for("react.portal"), $39e5046cd8f7919a$var$p = Symbol.for("react.fragment"), $39e5046cd8f7919a$var$q = Symbol.for("react.strict_mode"), $39e5046cd8f7919a$var$r = Symbol.for("react.profiler"), $39e5046cd8f7919a$var$t = Symbol.for("react.provider"), $39e5046cd8f7919a$var$u = Symbol.for("react.context"), $39e5046cd8f7919a$var$v = Symbol.for("react.forward_ref"), $39e5046cd8f7919a$var$w = Symbol.for("react.suspense"), $39e5046cd8f7919a$var$x = Symbol.for("react.memo"), $39e5046cd8f7919a$var$y = Symbol.for("react.lazy"), $39e5046cd8f7919a$var$z = Symbol.iterator;
function $39e5046cd8f7919a$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $39e5046cd8f7919a$var$z && a[$39e5046cd8f7919a$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $39e5046cd8f7919a$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $39e5046cd8f7919a$var$C = Object.assign, $39e5046cd8f7919a$var$D = {};
function $39e5046cd8f7919a$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $39e5046cd8f7919a$var$D;
    this.updater = e || $39e5046cd8f7919a$var$B;
}
$39e5046cd8f7919a$var$E.prototype.isReactComponent = {};
$39e5046cd8f7919a$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$39e5046cd8f7919a$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $39e5046cd8f7919a$var$F() {}
$39e5046cd8f7919a$var$F.prototype = $39e5046cd8f7919a$var$E.prototype;
function $39e5046cd8f7919a$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $39e5046cd8f7919a$var$D;
    this.updater = e || $39e5046cd8f7919a$var$B;
}
var $39e5046cd8f7919a$var$H = $39e5046cd8f7919a$var$G.prototype = new $39e5046cd8f7919a$var$F;
$39e5046cd8f7919a$var$H.constructor = $39e5046cd8f7919a$var$G;
$39e5046cd8f7919a$var$C($39e5046cd8f7919a$var$H, $39e5046cd8f7919a$var$E.prototype);
$39e5046cd8f7919a$var$H.isPureReactComponent = !0;
var $39e5046cd8f7919a$var$I = Array.isArray, $39e5046cd8f7919a$var$J = Object.prototype.hasOwnProperty, $39e5046cd8f7919a$var$K = {
    current: null
}, $39e5046cd8f7919a$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $39e5046cd8f7919a$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$39e5046cd8f7919a$var$J.call(b, d) && !$39e5046cd8f7919a$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $39e5046cd8f7919a$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $39e5046cd8f7919a$var$K.current
    };
}
function $39e5046cd8f7919a$var$N(a, b) {
    return {
        $$typeof: $39e5046cd8f7919a$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $39e5046cd8f7919a$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $39e5046cd8f7919a$var$l;
}
function $39e5046cd8f7919a$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $39e5046cd8f7919a$var$P = /\/+/g;
function $39e5046cd8f7919a$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $39e5046cd8f7919a$var$escape("" + a.key) : b.toString(36);
}
function $39e5046cd8f7919a$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $39e5046cd8f7919a$var$l:
                case $39e5046cd8f7919a$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $39e5046cd8f7919a$var$Q(h, 0) : d, $39e5046cd8f7919a$var$I(c) ? (e = "", null != a && (e = a.replace($39e5046cd8f7919a$var$P, "$&/") + "/"), $39e5046cd8f7919a$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($39e5046cd8f7919a$var$O(c) && (c = $39e5046cd8f7919a$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($39e5046cd8f7919a$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($39e5046cd8f7919a$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $39e5046cd8f7919a$var$Q(k, g);
        h += $39e5046cd8f7919a$var$R(k, b, e, f, c);
    }
    else if (f = $39e5046cd8f7919a$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $39e5046cd8f7919a$var$Q(k, g++), h += $39e5046cd8f7919a$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $39e5046cd8f7919a$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $39e5046cd8f7919a$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $39e5046cd8f7919a$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $39e5046cd8f7919a$var$U = {
    current: null
}, $39e5046cd8f7919a$var$V = {
    transition: null
}, $39e5046cd8f7919a$var$W = {
    ReactCurrentDispatcher: $39e5046cd8f7919a$var$U,
    ReactCurrentBatchConfig: $39e5046cd8f7919a$var$V,
    ReactCurrentOwner: $39e5046cd8f7919a$var$K
};
$39e5046cd8f7919a$export$dca3b0875bd9a954 = {
    map: $39e5046cd8f7919a$var$S,
    forEach: function(a, b, e) {
        $39e5046cd8f7919a$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $39e5046cd8f7919a$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $39e5046cd8f7919a$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$39e5046cd8f7919a$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$39e5046cd8f7919a$export$16fa2f45be04daa8 = $39e5046cd8f7919a$var$E;
$39e5046cd8f7919a$export$ffb0004e005737fa = $39e5046cd8f7919a$var$p;
$39e5046cd8f7919a$export$e2c29f18771995cb = $39e5046cd8f7919a$var$r;
$39e5046cd8f7919a$export$221d75b3f55bb0bd = $39e5046cd8f7919a$var$G;
$39e5046cd8f7919a$export$5f8d39834fd61797 = $39e5046cd8f7919a$var$q;
$39e5046cd8f7919a$export$74bf444e3cd11ea5 = $39e5046cd8f7919a$var$w;
$39e5046cd8f7919a$export$ae55be85d98224ed = $39e5046cd8f7919a$var$W;
$39e5046cd8f7919a$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $39e5046cd8f7919a$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $39e5046cd8f7919a$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$39e5046cd8f7919a$var$J.call(b, f) && !$39e5046cd8f7919a$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $39e5046cd8f7919a$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$39e5046cd8f7919a$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $39e5046cd8f7919a$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $39e5046cd8f7919a$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$39e5046cd8f7919a$export$c8a8987d4410bf2d = $39e5046cd8f7919a$var$M;
$39e5046cd8f7919a$export$d38cd72104c1f0e9 = function(a) {
    var b = $39e5046cd8f7919a$var$M.bind(null, a);
    b.type = a;
    return b;
};
$39e5046cd8f7919a$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$39e5046cd8f7919a$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $39e5046cd8f7919a$var$v,
        render: a
    };
};
$39e5046cd8f7919a$export$a8257692ac88316c = $39e5046cd8f7919a$var$O;
$39e5046cd8f7919a$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $39e5046cd8f7919a$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $39e5046cd8f7919a$var$T
    };
};
$39e5046cd8f7919a$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $39e5046cd8f7919a$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$39e5046cd8f7919a$export$7568632d0d33d16d = function(a) {
    var b = $39e5046cd8f7919a$var$V.transition;
    $39e5046cd8f7919a$var$V.transition = {};
    try {
        a();
    } finally{
        $39e5046cd8f7919a$var$V.transition = b;
    }
};
$39e5046cd8f7919a$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$39e5046cd8f7919a$export$35808ee640e87ca7 = function(a, b) {
    return $39e5046cd8f7919a$var$U.current.useCallback(a, b);
};
$39e5046cd8f7919a$export$fae74005e78b1a27 = function(a) {
    return $39e5046cd8f7919a$var$U.current.useContext(a);
};
$39e5046cd8f7919a$export$dc8fbce3eb94dc1e = function() {};
$39e5046cd8f7919a$export$6a7bc4e911dc01cf = function(a) {
    return $39e5046cd8f7919a$var$U.current.useDeferredValue(a);
};
$39e5046cd8f7919a$export$6d9c69b0de29b591 = function(a, b) {
    return $39e5046cd8f7919a$var$U.current.useEffect(a, b);
};
$39e5046cd8f7919a$export$f680877a34711e37 = function() {
    return $39e5046cd8f7919a$var$U.current.useId();
};
$39e5046cd8f7919a$export$d5a552a76deda3c2 = function(a, b, e) {
    return $39e5046cd8f7919a$var$U.current.useImperativeHandle(a, b, e);
};
$39e5046cd8f7919a$export$aaabe4eda9ed9969 = function(a, b) {
    return $39e5046cd8f7919a$var$U.current.useInsertionEffect(a, b);
};
$39e5046cd8f7919a$export$e5c5a5f917a5871c = function(a, b) {
    return $39e5046cd8f7919a$var$U.current.useLayoutEffect(a, b);
};
$39e5046cd8f7919a$export$1538c33de8887b59 = function(a, b) {
    return $39e5046cd8f7919a$var$U.current.useMemo(a, b);
};
$39e5046cd8f7919a$export$13e3392192263954 = function(a, b, e) {
    return $39e5046cd8f7919a$var$U.current.useReducer(a, b, e);
};
$39e5046cd8f7919a$export$b8f5890fc79d6aca = function(a) {
    return $39e5046cd8f7919a$var$U.current.useRef(a);
};
$39e5046cd8f7919a$export$60241385465d0a34 = function(a) {
    return $39e5046cd8f7919a$var$U.current.useState(a);
};
$39e5046cd8f7919a$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $39e5046cd8f7919a$var$U.current.useSyncExternalStore(a, b, e);
};
$39e5046cd8f7919a$export$7b286972b8d8ccbf = function() {
    return $39e5046cd8f7919a$var$U.current.useTransition();
};
$39e5046cd8f7919a$export$83d89fbfd8236492 = "18.2.0";

});



parcelRequire.register("2S5uy", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $2174e2766e27089d$export$ae55be85d98224ed; }, function (v) { return $2174e2766e27089d$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $2174e2766e27089d$export$d39a5bbd09211389; }, function (v) { return $2174e2766e27089d$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $2174e2766e27089d$export$882461b6382ed46c; }, function (v) { return $2174e2766e27089d$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $2174e2766e27089d$export$466bfc07425424d5; }, function (v) { return $2174e2766e27089d$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $2174e2766e27089d$export$cd75ccfd720a3cd4; }, function (v) { return $2174e2766e27089d$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $2174e2766e27089d$export$fa8d919ba61d84db; }, function (v) { return $2174e2766e27089d$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $2174e2766e27089d$export$757ceba2d55c277e; }, function (v) { return $2174e2766e27089d$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $2174e2766e27089d$export$b3890eb0ae9dca99; }, function (v) { return $2174e2766e27089d$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $2174e2766e27089d$export$502457920280e6be; }, function (v) { return $2174e2766e27089d$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $2174e2766e27089d$export$c78a37762a8d58e1; }, function (v) { return $2174e2766e27089d$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $2174e2766e27089d$export$dc54d992c10e8a18; }, function (v) { return $2174e2766e27089d$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $2174e2766e27089d$export$83d89fbfd8236492; }, function (v) { return $2174e2766e27089d$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $2174e2766e27089d$export$ae55be85d98224ed;
var $2174e2766e27089d$export$d39a5bbd09211389;
var $2174e2766e27089d$export$882461b6382ed46c;
var $2174e2766e27089d$export$466bfc07425424d5;
var $2174e2766e27089d$export$cd75ccfd720a3cd4;
var $2174e2766e27089d$export$fa8d919ba61d84db;
var $2174e2766e27089d$export$757ceba2d55c277e;
var $2174e2766e27089d$export$b3890eb0ae9dca99;
var $2174e2766e27089d$export$502457920280e6be;
var $2174e2766e27089d$export$c78a37762a8d58e1;
var $2174e2766e27089d$export$dc54d992c10e8a18;
var $2174e2766e27089d$export$83d89fbfd8236492;
"use strict";

var $P551f = parcelRequire("P551f");

var $8sPnc = parcelRequire("8sPnc");
function $2174e2766e27089d$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $2174e2766e27089d$var$da = new Set, $2174e2766e27089d$var$ea = {};
function $2174e2766e27089d$var$fa(a, b) {
    $2174e2766e27089d$var$ha(a, b);
    $2174e2766e27089d$var$ha(a + "Capture", b);
}
function $2174e2766e27089d$var$ha(a, b) {
    $2174e2766e27089d$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$2174e2766e27089d$var$da.add(b[a]);
}
var $2174e2766e27089d$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $2174e2766e27089d$var$ja = Object.prototype.hasOwnProperty, $2174e2766e27089d$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $2174e2766e27089d$var$la = {}, $2174e2766e27089d$var$ma = {};
function $2174e2766e27089d$var$oa(a) {
    if ($2174e2766e27089d$var$ja.call($2174e2766e27089d$var$ma, a)) return !0;
    if ($2174e2766e27089d$var$ja.call($2174e2766e27089d$var$la, a)) return !1;
    if ($2174e2766e27089d$var$ka.test(a)) return $2174e2766e27089d$var$ma[a] = !0;
    $2174e2766e27089d$var$la[a] = !0;
    return !1;
}
function $2174e2766e27089d$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $2174e2766e27089d$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $2174e2766e27089d$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $2174e2766e27089d$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $2174e2766e27089d$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $2174e2766e27089d$var$z[a] = new $2174e2766e27089d$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $2174e2766e27089d$var$z[b] = new $2174e2766e27089d$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $2174e2766e27089d$var$z[a] = new $2174e2766e27089d$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $2174e2766e27089d$var$z[a] = new $2174e2766e27089d$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $2174e2766e27089d$var$z[a] = new $2174e2766e27089d$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $2174e2766e27089d$var$z[a] = new $2174e2766e27089d$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $2174e2766e27089d$var$z[a] = new $2174e2766e27089d$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $2174e2766e27089d$var$z[a] = new $2174e2766e27089d$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $2174e2766e27089d$var$z[a] = new $2174e2766e27089d$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $2174e2766e27089d$var$ra = /[\-:]([a-z])/g;
function $2174e2766e27089d$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($2174e2766e27089d$var$ra, $2174e2766e27089d$var$sa);
    $2174e2766e27089d$var$z[b] = new $2174e2766e27089d$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($2174e2766e27089d$var$ra, $2174e2766e27089d$var$sa);
    $2174e2766e27089d$var$z[b] = new $2174e2766e27089d$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($2174e2766e27089d$var$ra, $2174e2766e27089d$var$sa);
    $2174e2766e27089d$var$z[b] = new $2174e2766e27089d$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $2174e2766e27089d$var$z[a] = new $2174e2766e27089d$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$2174e2766e27089d$var$z.xlinkHref = new $2174e2766e27089d$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $2174e2766e27089d$var$z[a] = new $2174e2766e27089d$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $2174e2766e27089d$var$ta(a, b, c, d) {
    var e = $2174e2766e27089d$var$z.hasOwnProperty(b) ? $2174e2766e27089d$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $2174e2766e27089d$var$qa(b, c, e, d) && (c = null), d || null === e ? $2174e2766e27089d$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $2174e2766e27089d$var$ua = $P551f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $2174e2766e27089d$var$va = Symbol.for("react.element"), $2174e2766e27089d$var$wa = Symbol.for("react.portal"), $2174e2766e27089d$var$ya = Symbol.for("react.fragment"), $2174e2766e27089d$var$za = Symbol.for("react.strict_mode"), $2174e2766e27089d$var$Aa = Symbol.for("react.profiler"), $2174e2766e27089d$var$Ba = Symbol.for("react.provider"), $2174e2766e27089d$var$Ca = Symbol.for("react.context"), $2174e2766e27089d$var$Da = Symbol.for("react.forward_ref"), $2174e2766e27089d$var$Ea = Symbol.for("react.suspense"), $2174e2766e27089d$var$Fa = Symbol.for("react.suspense_list"), $2174e2766e27089d$var$Ga = Symbol.for("react.memo"), $2174e2766e27089d$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $2174e2766e27089d$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $2174e2766e27089d$var$Ja = Symbol.iterator;
function $2174e2766e27089d$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $2174e2766e27089d$var$Ja && a[$2174e2766e27089d$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $2174e2766e27089d$var$A = Object.assign, $2174e2766e27089d$var$La;
function $2174e2766e27089d$var$Ma(a) {
    if (void 0 === $2174e2766e27089d$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $2174e2766e27089d$var$La = b && b[1] || "";
    }
    return "\n" + $2174e2766e27089d$var$La + a;
}
var $2174e2766e27089d$var$Na = !1;
function $2174e2766e27089d$var$Oa(a, b) {
    if (!a || $2174e2766e27089d$var$Na) return "";
    $2174e2766e27089d$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $2174e2766e27089d$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $2174e2766e27089d$var$Ma(a) : "";
}
function $2174e2766e27089d$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $2174e2766e27089d$var$Ma(a.type);
        case 16:
            return $2174e2766e27089d$var$Ma("Lazy");
        case 13:
            return $2174e2766e27089d$var$Ma("Suspense");
        case 19:
            return $2174e2766e27089d$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $2174e2766e27089d$var$Oa(a.type, !1), a;
        case 11:
            return a = $2174e2766e27089d$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $2174e2766e27089d$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $2174e2766e27089d$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $2174e2766e27089d$var$ya:
            return "Fragment";
        case $2174e2766e27089d$var$wa:
            return "Portal";
        case $2174e2766e27089d$var$Aa:
            return "Profiler";
        case $2174e2766e27089d$var$za:
            return "StrictMode";
        case $2174e2766e27089d$var$Ea:
            return "Suspense";
        case $2174e2766e27089d$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $2174e2766e27089d$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $2174e2766e27089d$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $2174e2766e27089d$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $2174e2766e27089d$var$Ga:
            return b = a.displayName || null, null !== b ? b : $2174e2766e27089d$var$Qa(a.type) || "Memo";
        case $2174e2766e27089d$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $2174e2766e27089d$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $2174e2766e27089d$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $2174e2766e27089d$var$Qa(b);
        case 8:
            return b === $2174e2766e27089d$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $2174e2766e27089d$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $2174e2766e27089d$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $2174e2766e27089d$var$Ua(a) {
    var b = $2174e2766e27089d$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $2174e2766e27089d$var$Va(a) {
    a._valueTracker || (a._valueTracker = $2174e2766e27089d$var$Ua(a));
}
function $2174e2766e27089d$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $2174e2766e27089d$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $2174e2766e27089d$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $2174e2766e27089d$var$Ya(a, b) {
    var c = b.checked;
    return $2174e2766e27089d$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $2174e2766e27089d$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $2174e2766e27089d$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $2174e2766e27089d$var$ab(a, b) {
    b = b.checked;
    null != b && $2174e2766e27089d$var$ta(a, "checked", b, !1);
}
function $2174e2766e27089d$var$bb(a, b) {
    $2174e2766e27089d$var$ab(a, b);
    var c = $2174e2766e27089d$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $2174e2766e27089d$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $2174e2766e27089d$var$cb(a, b.type, $2174e2766e27089d$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $2174e2766e27089d$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $2174e2766e27089d$var$cb(a, b, c) {
    if ("number" !== b || $2174e2766e27089d$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $2174e2766e27089d$var$eb = Array.isArray;
function $2174e2766e27089d$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $2174e2766e27089d$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $2174e2766e27089d$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($2174e2766e27089d$var$p(91));
    return $2174e2766e27089d$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $2174e2766e27089d$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($2174e2766e27089d$var$p(92));
            if ($2174e2766e27089d$var$eb(c)) {
                if (1 < c.length) throw Error($2174e2766e27089d$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $2174e2766e27089d$var$Sa(c)
    };
}
function $2174e2766e27089d$var$ib(a, b) {
    var c = $2174e2766e27089d$var$Sa(b.value), d = $2174e2766e27089d$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $2174e2766e27089d$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $2174e2766e27089d$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $2174e2766e27089d$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $2174e2766e27089d$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $2174e2766e27089d$var$mb, $2174e2766e27089d$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $2174e2766e27089d$var$mb = $2174e2766e27089d$var$mb || document.createElement("div");
        $2174e2766e27089d$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $2174e2766e27089d$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $2174e2766e27089d$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $2174e2766e27089d$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $2174e2766e27089d$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($2174e2766e27089d$var$pb).forEach(function(a) {
    $2174e2766e27089d$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $2174e2766e27089d$var$pb[b] = $2174e2766e27089d$var$pb[a];
    });
});
function $2174e2766e27089d$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $2174e2766e27089d$var$pb.hasOwnProperty(a) && $2174e2766e27089d$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $2174e2766e27089d$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $2174e2766e27089d$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $2174e2766e27089d$var$tb = $2174e2766e27089d$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $2174e2766e27089d$var$ub(a, b) {
    if (b) {
        if ($2174e2766e27089d$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($2174e2766e27089d$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($2174e2766e27089d$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($2174e2766e27089d$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($2174e2766e27089d$var$p(62));
    }
}
function $2174e2766e27089d$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $2174e2766e27089d$var$wb = null;
function $2174e2766e27089d$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $2174e2766e27089d$var$yb = null, $2174e2766e27089d$var$zb = null, $2174e2766e27089d$var$Ab = null;
function $2174e2766e27089d$var$Bb(a) {
    if (a = $2174e2766e27089d$var$Cb(a)) {
        if ("function" !== typeof $2174e2766e27089d$var$yb) throw Error($2174e2766e27089d$var$p(280));
        var b = a.stateNode;
        b && (b = $2174e2766e27089d$var$Db(b), $2174e2766e27089d$var$yb(a.stateNode, a.type, b));
    }
}
function $2174e2766e27089d$var$Eb(a) {
    $2174e2766e27089d$var$zb ? $2174e2766e27089d$var$Ab ? $2174e2766e27089d$var$Ab.push(a) : $2174e2766e27089d$var$Ab = [
        a
    ] : $2174e2766e27089d$var$zb = a;
}
function $2174e2766e27089d$var$Fb() {
    if ($2174e2766e27089d$var$zb) {
        var a = $2174e2766e27089d$var$zb, b = $2174e2766e27089d$var$Ab;
        $2174e2766e27089d$var$Ab = $2174e2766e27089d$var$zb = null;
        $2174e2766e27089d$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$2174e2766e27089d$var$Bb(b[a]);
    }
}
function $2174e2766e27089d$var$Gb(a, b) {
    return a(b);
}
function $2174e2766e27089d$var$Hb() {}
var $2174e2766e27089d$var$Ib = !1;
function $2174e2766e27089d$var$Jb(a, b, c) {
    if ($2174e2766e27089d$var$Ib) return a(b, c);
    $2174e2766e27089d$var$Ib = !0;
    try {
        return $2174e2766e27089d$var$Gb(a, b, c);
    } finally{
        if ($2174e2766e27089d$var$Ib = !1, null !== $2174e2766e27089d$var$zb || null !== $2174e2766e27089d$var$Ab) $2174e2766e27089d$var$Hb(), $2174e2766e27089d$var$Fb();
    }
}
function $2174e2766e27089d$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $2174e2766e27089d$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($2174e2766e27089d$var$p(231, b, typeof c));
    return c;
}
var $2174e2766e27089d$var$Lb = !1;
if ($2174e2766e27089d$var$ia) try {
    var $2174e2766e27089d$var$Mb = {};
    Object.defineProperty($2174e2766e27089d$var$Mb, "passive", {
        get: function() {
            $2174e2766e27089d$var$Lb = !0;
        }
    });
    window.addEventListener("test", $2174e2766e27089d$var$Mb, $2174e2766e27089d$var$Mb);
    window.removeEventListener("test", $2174e2766e27089d$var$Mb, $2174e2766e27089d$var$Mb);
} catch (a) {
    $2174e2766e27089d$var$Lb = !1;
}
function $2174e2766e27089d$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $2174e2766e27089d$var$Ob = !1, $2174e2766e27089d$var$Pb = null, $2174e2766e27089d$var$Qb = !1, $2174e2766e27089d$var$Rb = null, $2174e2766e27089d$var$Sb = {
    onError: function(a) {
        $2174e2766e27089d$var$Ob = !0;
        $2174e2766e27089d$var$Pb = a;
    }
};
function $2174e2766e27089d$var$Tb(a, b, c, d, e, f, g, h, k) {
    $2174e2766e27089d$var$Ob = !1;
    $2174e2766e27089d$var$Pb = null;
    $2174e2766e27089d$var$Nb.apply($2174e2766e27089d$var$Sb, arguments);
}
function $2174e2766e27089d$var$Ub(a, b, c, d, e, f, g, h, k) {
    $2174e2766e27089d$var$Tb.apply(this, arguments);
    if ($2174e2766e27089d$var$Ob) {
        if ($2174e2766e27089d$var$Ob) {
            var l = $2174e2766e27089d$var$Pb;
            $2174e2766e27089d$var$Ob = !1;
            $2174e2766e27089d$var$Pb = null;
        } else throw Error($2174e2766e27089d$var$p(198));
        $2174e2766e27089d$var$Qb || ($2174e2766e27089d$var$Qb = !0, $2174e2766e27089d$var$Rb = l);
    }
}
function $2174e2766e27089d$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $2174e2766e27089d$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $2174e2766e27089d$var$Xb(a) {
    if ($2174e2766e27089d$var$Vb(a) !== a) throw Error($2174e2766e27089d$var$p(188));
}
function $2174e2766e27089d$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $2174e2766e27089d$var$Vb(a);
        if (null === b) throw Error($2174e2766e27089d$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $2174e2766e27089d$var$Xb(e), a;
                if (f === d) return $2174e2766e27089d$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($2174e2766e27089d$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($2174e2766e27089d$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($2174e2766e27089d$var$p(190));
    }
    if (3 !== c.tag) throw Error($2174e2766e27089d$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $2174e2766e27089d$var$Zb(a) {
    a = $2174e2766e27089d$var$Yb(a);
    return null !== a ? $2174e2766e27089d$var$$b(a) : null;
}
function $2174e2766e27089d$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $2174e2766e27089d$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $2174e2766e27089d$var$ac = $8sPnc.unstable_scheduleCallback, $2174e2766e27089d$var$bc = $8sPnc.unstable_cancelCallback, $2174e2766e27089d$var$cc = $8sPnc.unstable_shouldYield, $2174e2766e27089d$var$dc = $8sPnc.unstable_requestPaint, $2174e2766e27089d$var$B = $8sPnc.unstable_now, $2174e2766e27089d$var$ec = $8sPnc.unstable_getCurrentPriorityLevel, $2174e2766e27089d$var$fc = $8sPnc.unstable_ImmediatePriority, $2174e2766e27089d$var$gc = $8sPnc.unstable_UserBlockingPriority, $2174e2766e27089d$var$hc = $8sPnc.unstable_NormalPriority, $2174e2766e27089d$var$ic = $8sPnc.unstable_LowPriority, $2174e2766e27089d$var$jc = $8sPnc.unstable_IdlePriority, $2174e2766e27089d$var$kc = null, $2174e2766e27089d$var$lc = null;
function $2174e2766e27089d$var$mc(a) {
    if ($2174e2766e27089d$var$lc && "function" === typeof $2174e2766e27089d$var$lc.onCommitFiberRoot) try {
        $2174e2766e27089d$var$lc.onCommitFiberRoot($2174e2766e27089d$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $2174e2766e27089d$var$oc = Math.clz32 ? Math.clz32 : $2174e2766e27089d$var$nc, $2174e2766e27089d$var$pc = Math.log, $2174e2766e27089d$var$qc = Math.LN2;
function $2174e2766e27089d$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($2174e2766e27089d$var$pc(a) / $2174e2766e27089d$var$qc | 0) | 0;
}
var $2174e2766e27089d$var$rc = 64, $2174e2766e27089d$var$sc = 4194304;
function $2174e2766e27089d$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $2174e2766e27089d$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $2174e2766e27089d$var$tc(h) : (f &= g, 0 !== f && (d = $2174e2766e27089d$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $2174e2766e27089d$var$tc(g) : 0 !== f && (d = $2174e2766e27089d$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $2174e2766e27089d$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $2174e2766e27089d$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $2174e2766e27089d$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $2174e2766e27089d$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $2174e2766e27089d$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $2174e2766e27089d$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $2174e2766e27089d$var$yc() {
    var a = $2174e2766e27089d$var$rc;
    $2174e2766e27089d$var$rc <<= 1;
    0 === ($2174e2766e27089d$var$rc & 4194240) && ($2174e2766e27089d$var$rc = 64);
    return a;
}
function $2174e2766e27089d$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $2174e2766e27089d$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $2174e2766e27089d$var$oc(b);
    a[b] = c;
}
function $2174e2766e27089d$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $2174e2766e27089d$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $2174e2766e27089d$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $2174e2766e27089d$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $2174e2766e27089d$var$C = 0;
function $2174e2766e27089d$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $2174e2766e27089d$var$Ec, $2174e2766e27089d$var$Fc, $2174e2766e27089d$var$Gc, $2174e2766e27089d$var$Hc, $2174e2766e27089d$var$Ic, $2174e2766e27089d$var$Jc = !1, $2174e2766e27089d$var$Kc = [], $2174e2766e27089d$var$Lc = null, $2174e2766e27089d$var$Mc = null, $2174e2766e27089d$var$Nc = null, $2174e2766e27089d$var$Oc = new Map, $2174e2766e27089d$var$Pc = new Map, $2174e2766e27089d$var$Qc = [], $2174e2766e27089d$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $2174e2766e27089d$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $2174e2766e27089d$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $2174e2766e27089d$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $2174e2766e27089d$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $2174e2766e27089d$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $2174e2766e27089d$var$Pc.delete(b.pointerId);
    }
}
function $2174e2766e27089d$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $2174e2766e27089d$var$Cb(b), null !== b && $2174e2766e27089d$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $2174e2766e27089d$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $2174e2766e27089d$var$Lc = $2174e2766e27089d$var$Tc($2174e2766e27089d$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $2174e2766e27089d$var$Mc = $2174e2766e27089d$var$Tc($2174e2766e27089d$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $2174e2766e27089d$var$Nc = $2174e2766e27089d$var$Tc($2174e2766e27089d$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $2174e2766e27089d$var$Oc.set(f, $2174e2766e27089d$var$Tc($2174e2766e27089d$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $2174e2766e27089d$var$Pc.set(f, $2174e2766e27089d$var$Tc($2174e2766e27089d$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $2174e2766e27089d$var$Vc(a) {
    var b = $2174e2766e27089d$var$Wc(a.target);
    if (null !== b) {
        var c = $2174e2766e27089d$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $2174e2766e27089d$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $2174e2766e27089d$var$Ic(a.priority, function() {
                        $2174e2766e27089d$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $2174e2766e27089d$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $2174e2766e27089d$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $2174e2766e27089d$var$wb = d;
            c.target.dispatchEvent(d);
            $2174e2766e27089d$var$wb = null;
        } else return b = $2174e2766e27089d$var$Cb(c), null !== b && $2174e2766e27089d$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $2174e2766e27089d$var$Zc(a, b, c) {
    $2174e2766e27089d$var$Xc(a) && c.delete(b);
}
function $2174e2766e27089d$var$$c() {
    $2174e2766e27089d$var$Jc = !1;
    null !== $2174e2766e27089d$var$Lc && $2174e2766e27089d$var$Xc($2174e2766e27089d$var$Lc) && ($2174e2766e27089d$var$Lc = null);
    null !== $2174e2766e27089d$var$Mc && $2174e2766e27089d$var$Xc($2174e2766e27089d$var$Mc) && ($2174e2766e27089d$var$Mc = null);
    null !== $2174e2766e27089d$var$Nc && $2174e2766e27089d$var$Xc($2174e2766e27089d$var$Nc) && ($2174e2766e27089d$var$Nc = null);
    $2174e2766e27089d$var$Oc.forEach($2174e2766e27089d$var$Zc);
    $2174e2766e27089d$var$Pc.forEach($2174e2766e27089d$var$Zc);
}
function $2174e2766e27089d$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $2174e2766e27089d$var$Jc || ($2174e2766e27089d$var$Jc = !0, $8sPnc.unstable_scheduleCallback($8sPnc.unstable_NormalPriority, $2174e2766e27089d$var$$c)));
}
function $2174e2766e27089d$var$bd(a) {
    function b(b) {
        return $2174e2766e27089d$var$ad(b, a);
    }
    if (0 < $2174e2766e27089d$var$Kc.length) {
        $2174e2766e27089d$var$ad($2174e2766e27089d$var$Kc[0], a);
        for(var c = 1; c < $2174e2766e27089d$var$Kc.length; c++){
            var d = $2174e2766e27089d$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $2174e2766e27089d$var$Lc && $2174e2766e27089d$var$ad($2174e2766e27089d$var$Lc, a);
    null !== $2174e2766e27089d$var$Mc && $2174e2766e27089d$var$ad($2174e2766e27089d$var$Mc, a);
    null !== $2174e2766e27089d$var$Nc && $2174e2766e27089d$var$ad($2174e2766e27089d$var$Nc, a);
    $2174e2766e27089d$var$Oc.forEach(b);
    $2174e2766e27089d$var$Pc.forEach(b);
    for(c = 0; c < $2174e2766e27089d$var$Qc.length; c++)d = $2174e2766e27089d$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $2174e2766e27089d$var$Qc.length && (c = $2174e2766e27089d$var$Qc[0], null === c.blockedOn);)$2174e2766e27089d$var$Vc(c), null === c.blockedOn && $2174e2766e27089d$var$Qc.shift();
}
var $2174e2766e27089d$var$cd = $2174e2766e27089d$var$ua.ReactCurrentBatchConfig, $2174e2766e27089d$var$dd = !0;
function $2174e2766e27089d$var$ed(a, b, c, d) {
    var e = $2174e2766e27089d$var$C, f = $2174e2766e27089d$var$cd.transition;
    $2174e2766e27089d$var$cd.transition = null;
    try {
        $2174e2766e27089d$var$C = 1, $2174e2766e27089d$var$fd(a, b, c, d);
    } finally{
        $2174e2766e27089d$var$C = e, $2174e2766e27089d$var$cd.transition = f;
    }
}
function $2174e2766e27089d$var$gd(a, b, c, d) {
    var e = $2174e2766e27089d$var$C, f = $2174e2766e27089d$var$cd.transition;
    $2174e2766e27089d$var$cd.transition = null;
    try {
        $2174e2766e27089d$var$C = 4, $2174e2766e27089d$var$fd(a, b, c, d);
    } finally{
        $2174e2766e27089d$var$C = e, $2174e2766e27089d$var$cd.transition = f;
    }
}
function $2174e2766e27089d$var$fd(a, b, c, d) {
    if ($2174e2766e27089d$var$dd) {
        var e = $2174e2766e27089d$var$Yc(a, b, c, d);
        if (null === e) $2174e2766e27089d$var$hd(a, b, d, $2174e2766e27089d$var$id, c), $2174e2766e27089d$var$Sc(a, d);
        else if ($2174e2766e27089d$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($2174e2766e27089d$var$Sc(a, d), b & 4 && -1 < $2174e2766e27089d$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $2174e2766e27089d$var$Cb(e);
                null !== f && $2174e2766e27089d$var$Ec(f);
                f = $2174e2766e27089d$var$Yc(a, b, c, d);
                null === f && $2174e2766e27089d$var$hd(a, b, d, $2174e2766e27089d$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $2174e2766e27089d$var$hd(a, b, d, null, c);
    }
}
var $2174e2766e27089d$var$id = null;
function $2174e2766e27089d$var$Yc(a, b, c, d) {
    $2174e2766e27089d$var$id = null;
    a = $2174e2766e27089d$var$xb(d);
    a = $2174e2766e27089d$var$Wc(a);
    if (null !== a) {
        if (b = $2174e2766e27089d$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $2174e2766e27089d$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $2174e2766e27089d$var$id = a;
    return null;
}
function $2174e2766e27089d$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($2174e2766e27089d$var$ec()){
                case $2174e2766e27089d$var$fc:
                    return 1;
                case $2174e2766e27089d$var$gc:
                    return 4;
                case $2174e2766e27089d$var$hc:
                case $2174e2766e27089d$var$ic:
                    return 16;
                case $2174e2766e27089d$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $2174e2766e27089d$var$kd = null, $2174e2766e27089d$var$ld = null, $2174e2766e27089d$var$md = null;
function $2174e2766e27089d$var$nd() {
    if ($2174e2766e27089d$var$md) return $2174e2766e27089d$var$md;
    var a, b = $2174e2766e27089d$var$ld, c = b.length, d, e = "value" in $2174e2766e27089d$var$kd ? $2174e2766e27089d$var$kd.value : $2174e2766e27089d$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $2174e2766e27089d$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $2174e2766e27089d$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $2174e2766e27089d$var$pd() {
    return !0;
}
function $2174e2766e27089d$var$qd() {
    return !1;
}
function $2174e2766e27089d$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $2174e2766e27089d$var$pd : $2174e2766e27089d$var$qd;
        this.isPropagationStopped = $2174e2766e27089d$var$qd;
        return this;
    }
    $2174e2766e27089d$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $2174e2766e27089d$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $2174e2766e27089d$var$pd);
        },
        persist: function() {},
        isPersistent: $2174e2766e27089d$var$pd
    });
    return b;
}
var $2174e2766e27089d$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $2174e2766e27089d$var$td = $2174e2766e27089d$var$rd($2174e2766e27089d$var$sd), $2174e2766e27089d$var$ud = $2174e2766e27089d$var$A({}, $2174e2766e27089d$var$sd, {
    view: 0,
    detail: 0
}), $2174e2766e27089d$var$vd = $2174e2766e27089d$var$rd($2174e2766e27089d$var$ud), $2174e2766e27089d$var$wd, $2174e2766e27089d$var$xd, $2174e2766e27089d$var$yd, $2174e2766e27089d$var$Ad = $2174e2766e27089d$var$A({}, $2174e2766e27089d$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $2174e2766e27089d$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $2174e2766e27089d$var$yd && ($2174e2766e27089d$var$yd && "mousemove" === a.type ? ($2174e2766e27089d$var$wd = a.screenX - $2174e2766e27089d$var$yd.screenX, $2174e2766e27089d$var$xd = a.screenY - $2174e2766e27089d$var$yd.screenY) : $2174e2766e27089d$var$xd = $2174e2766e27089d$var$wd = 0, $2174e2766e27089d$var$yd = a);
        return $2174e2766e27089d$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $2174e2766e27089d$var$xd;
    }
}), $2174e2766e27089d$var$Bd = $2174e2766e27089d$var$rd($2174e2766e27089d$var$Ad), $2174e2766e27089d$var$Cd = $2174e2766e27089d$var$A({}, $2174e2766e27089d$var$Ad, {
    dataTransfer: 0
}), $2174e2766e27089d$var$Dd = $2174e2766e27089d$var$rd($2174e2766e27089d$var$Cd), $2174e2766e27089d$var$Ed = $2174e2766e27089d$var$A({}, $2174e2766e27089d$var$ud, {
    relatedTarget: 0
}), $2174e2766e27089d$var$Fd = $2174e2766e27089d$var$rd($2174e2766e27089d$var$Ed), $2174e2766e27089d$var$Gd = $2174e2766e27089d$var$A({}, $2174e2766e27089d$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $2174e2766e27089d$var$Hd = $2174e2766e27089d$var$rd($2174e2766e27089d$var$Gd), $2174e2766e27089d$var$Id = $2174e2766e27089d$var$A({}, $2174e2766e27089d$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $2174e2766e27089d$var$Jd = $2174e2766e27089d$var$rd($2174e2766e27089d$var$Id), $2174e2766e27089d$var$Kd = $2174e2766e27089d$var$A({}, $2174e2766e27089d$var$sd, {
    data: 0
}), $2174e2766e27089d$var$Ld = $2174e2766e27089d$var$rd($2174e2766e27089d$var$Kd), $2174e2766e27089d$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $2174e2766e27089d$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $2174e2766e27089d$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $2174e2766e27089d$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $2174e2766e27089d$var$Od[a]) ? !!b[a] : !1;
}
function $2174e2766e27089d$var$zd() {
    return $2174e2766e27089d$var$Pd;
}
var $2174e2766e27089d$var$Qd = $2174e2766e27089d$var$A({}, $2174e2766e27089d$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $2174e2766e27089d$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $2174e2766e27089d$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $2174e2766e27089d$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $2174e2766e27089d$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $2174e2766e27089d$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $2174e2766e27089d$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $2174e2766e27089d$var$Rd = $2174e2766e27089d$var$rd($2174e2766e27089d$var$Qd), $2174e2766e27089d$var$Sd = $2174e2766e27089d$var$A({}, $2174e2766e27089d$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $2174e2766e27089d$var$Td = $2174e2766e27089d$var$rd($2174e2766e27089d$var$Sd), $2174e2766e27089d$var$Ud = $2174e2766e27089d$var$A({}, $2174e2766e27089d$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $2174e2766e27089d$var$zd
}), $2174e2766e27089d$var$Vd = $2174e2766e27089d$var$rd($2174e2766e27089d$var$Ud), $2174e2766e27089d$var$Wd = $2174e2766e27089d$var$A({}, $2174e2766e27089d$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $2174e2766e27089d$var$Xd = $2174e2766e27089d$var$rd($2174e2766e27089d$var$Wd), $2174e2766e27089d$var$Yd = $2174e2766e27089d$var$A({}, $2174e2766e27089d$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $2174e2766e27089d$var$Zd = $2174e2766e27089d$var$rd($2174e2766e27089d$var$Yd), $2174e2766e27089d$var$$d = [
    9,
    13,
    27,
    32
], $2174e2766e27089d$var$ae = $2174e2766e27089d$var$ia && "CompositionEvent" in window, $2174e2766e27089d$var$be = null;
$2174e2766e27089d$var$ia && "documentMode" in document && ($2174e2766e27089d$var$be = document.documentMode);
var $2174e2766e27089d$var$ce = $2174e2766e27089d$var$ia && "TextEvent" in window && !$2174e2766e27089d$var$be, $2174e2766e27089d$var$de = $2174e2766e27089d$var$ia && (!$2174e2766e27089d$var$ae || $2174e2766e27089d$var$be && 8 < $2174e2766e27089d$var$be && 11 >= $2174e2766e27089d$var$be), $2174e2766e27089d$var$ee = String.fromCharCode(32), $2174e2766e27089d$var$fe = !1;
function $2174e2766e27089d$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $2174e2766e27089d$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $2174e2766e27089d$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $2174e2766e27089d$var$ie = !1;
function $2174e2766e27089d$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $2174e2766e27089d$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $2174e2766e27089d$var$fe = !0;
            return $2174e2766e27089d$var$ee;
        case "textInput":
            return a = b.data, a === $2174e2766e27089d$var$ee && $2174e2766e27089d$var$fe ? null : a;
        default:
            return null;
    }
}
function $2174e2766e27089d$var$ke(a, b) {
    if ($2174e2766e27089d$var$ie) return "compositionend" === a || !$2174e2766e27089d$var$ae && $2174e2766e27089d$var$ge(a, b) ? (a = $2174e2766e27089d$var$nd(), $2174e2766e27089d$var$md = $2174e2766e27089d$var$ld = $2174e2766e27089d$var$kd = null, $2174e2766e27089d$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $2174e2766e27089d$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $2174e2766e27089d$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $2174e2766e27089d$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$2174e2766e27089d$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $2174e2766e27089d$var$ne(a, b, c, d) {
    $2174e2766e27089d$var$Eb(d);
    b = $2174e2766e27089d$var$oe(b, "onChange");
    0 < b.length && (c = new $2174e2766e27089d$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $2174e2766e27089d$var$pe = null, $2174e2766e27089d$var$qe = null;
function $2174e2766e27089d$var$re(a) {
    $2174e2766e27089d$var$se(a, 0);
}
function $2174e2766e27089d$var$te(a) {
    var b = $2174e2766e27089d$var$ue(a);
    if ($2174e2766e27089d$var$Wa(b)) return a;
}
function $2174e2766e27089d$var$ve(a, b) {
    if ("change" === a) return b;
}
var $2174e2766e27089d$var$we = !1;
if ($2174e2766e27089d$var$ia) {
    var $2174e2766e27089d$var$xe;
    if ($2174e2766e27089d$var$ia) {
        var $2174e2766e27089d$var$ye = "oninput" in document;
        if (!$2174e2766e27089d$var$ye) {
            var $2174e2766e27089d$var$ze = document.createElement("div");
            $2174e2766e27089d$var$ze.setAttribute("oninput", "return;");
            $2174e2766e27089d$var$ye = "function" === typeof $2174e2766e27089d$var$ze.oninput;
        }
        $2174e2766e27089d$var$xe = $2174e2766e27089d$var$ye;
    } else $2174e2766e27089d$var$xe = !1;
    $2174e2766e27089d$var$we = $2174e2766e27089d$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $2174e2766e27089d$var$Ae() {
    $2174e2766e27089d$var$pe && ($2174e2766e27089d$var$pe.detachEvent("onpropertychange", $2174e2766e27089d$var$Be), $2174e2766e27089d$var$qe = $2174e2766e27089d$var$pe = null);
}
function $2174e2766e27089d$var$Be(a) {
    if ("value" === a.propertyName && $2174e2766e27089d$var$te($2174e2766e27089d$var$qe)) {
        var b = [];
        $2174e2766e27089d$var$ne(b, $2174e2766e27089d$var$qe, a, $2174e2766e27089d$var$xb(a));
        $2174e2766e27089d$var$Jb($2174e2766e27089d$var$re, b);
    }
}
function $2174e2766e27089d$var$Ce(a, b, c) {
    "focusin" === a ? ($2174e2766e27089d$var$Ae(), $2174e2766e27089d$var$pe = b, $2174e2766e27089d$var$qe = c, $2174e2766e27089d$var$pe.attachEvent("onpropertychange", $2174e2766e27089d$var$Be)) : "focusout" === a && $2174e2766e27089d$var$Ae();
}
function $2174e2766e27089d$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $2174e2766e27089d$var$te($2174e2766e27089d$var$qe);
}
function $2174e2766e27089d$var$Ee(a, b) {
    if ("click" === a) return $2174e2766e27089d$var$te(b);
}
function $2174e2766e27089d$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $2174e2766e27089d$var$te(b);
}
function $2174e2766e27089d$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $2174e2766e27089d$var$He = "function" === typeof Object.is ? Object.is : $2174e2766e27089d$var$Ge;
function $2174e2766e27089d$var$Ie(a, b) {
    if ($2174e2766e27089d$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$2174e2766e27089d$var$ja.call(b, e) || !$2174e2766e27089d$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $2174e2766e27089d$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $2174e2766e27089d$var$Ke(a, b) {
    var c = $2174e2766e27089d$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $2174e2766e27089d$var$Je(c);
    }
}
function $2174e2766e27089d$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $2174e2766e27089d$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $2174e2766e27089d$var$Me() {
    for(var a = window, b = $2174e2766e27089d$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $2174e2766e27089d$var$Xa(a.document);
    }
    return b;
}
function $2174e2766e27089d$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $2174e2766e27089d$var$Oe(a) {
    var b = $2174e2766e27089d$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $2174e2766e27089d$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $2174e2766e27089d$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $2174e2766e27089d$var$Ke(c, f);
                var g = $2174e2766e27089d$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $2174e2766e27089d$var$Pe = $2174e2766e27089d$var$ia && "documentMode" in document && 11 >= document.documentMode, $2174e2766e27089d$var$Qe = null, $2174e2766e27089d$var$Re = null, $2174e2766e27089d$var$Se = null, $2174e2766e27089d$var$Te = !1;
function $2174e2766e27089d$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $2174e2766e27089d$var$Te || null == $2174e2766e27089d$var$Qe || $2174e2766e27089d$var$Qe !== $2174e2766e27089d$var$Xa(d) || (d = $2174e2766e27089d$var$Qe, "selectionStart" in d && $2174e2766e27089d$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $2174e2766e27089d$var$Se && $2174e2766e27089d$var$Ie($2174e2766e27089d$var$Se, d) || ($2174e2766e27089d$var$Se = d, d = $2174e2766e27089d$var$oe($2174e2766e27089d$var$Re, "onSelect"), 0 < d.length && (b = new $2174e2766e27089d$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $2174e2766e27089d$var$Qe)));
}
function $2174e2766e27089d$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $2174e2766e27089d$var$We = {
    animationend: $2174e2766e27089d$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $2174e2766e27089d$var$Ve("Animation", "AnimationIteration"),
    animationstart: $2174e2766e27089d$var$Ve("Animation", "AnimationStart"),
    transitionend: $2174e2766e27089d$var$Ve("Transition", "TransitionEnd")
}, $2174e2766e27089d$var$Xe = {}, $2174e2766e27089d$var$Ye = {};
$2174e2766e27089d$var$ia && ($2174e2766e27089d$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $2174e2766e27089d$var$We.animationend.animation, delete $2174e2766e27089d$var$We.animationiteration.animation, delete $2174e2766e27089d$var$We.animationstart.animation), "TransitionEvent" in window || delete $2174e2766e27089d$var$We.transitionend.transition);
function $2174e2766e27089d$var$Ze(a) {
    if ($2174e2766e27089d$var$Xe[a]) return $2174e2766e27089d$var$Xe[a];
    if (!$2174e2766e27089d$var$We[a]) return a;
    var b = $2174e2766e27089d$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $2174e2766e27089d$var$Ye) return $2174e2766e27089d$var$Xe[a] = b[c];
    return a;
}
var $2174e2766e27089d$var$$e = $2174e2766e27089d$var$Ze("animationend"), $2174e2766e27089d$var$af = $2174e2766e27089d$var$Ze("animationiteration"), $2174e2766e27089d$var$bf = $2174e2766e27089d$var$Ze("animationstart"), $2174e2766e27089d$var$cf = $2174e2766e27089d$var$Ze("transitionend"), $2174e2766e27089d$var$df = new Map, $2174e2766e27089d$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $2174e2766e27089d$var$ff(a, b) {
    $2174e2766e27089d$var$df.set(a, b);
    $2174e2766e27089d$var$fa(b, [
        a
    ]);
}
for(var $2174e2766e27089d$var$gf = 0; $2174e2766e27089d$var$gf < $2174e2766e27089d$var$ef.length; $2174e2766e27089d$var$gf++){
    var $2174e2766e27089d$var$hf = $2174e2766e27089d$var$ef[$2174e2766e27089d$var$gf], $2174e2766e27089d$var$jf = $2174e2766e27089d$var$hf.toLowerCase(), $2174e2766e27089d$var$kf = $2174e2766e27089d$var$hf[0].toUpperCase() + $2174e2766e27089d$var$hf.slice(1);
    $2174e2766e27089d$var$ff($2174e2766e27089d$var$jf, "on" + $2174e2766e27089d$var$kf);
}
$2174e2766e27089d$var$ff($2174e2766e27089d$var$$e, "onAnimationEnd");
$2174e2766e27089d$var$ff($2174e2766e27089d$var$af, "onAnimationIteration");
$2174e2766e27089d$var$ff($2174e2766e27089d$var$bf, "onAnimationStart");
$2174e2766e27089d$var$ff("dblclick", "onDoubleClick");
$2174e2766e27089d$var$ff("focusin", "onFocus");
$2174e2766e27089d$var$ff("focusout", "onBlur");
$2174e2766e27089d$var$ff($2174e2766e27089d$var$cf, "onTransitionEnd");
$2174e2766e27089d$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$2174e2766e27089d$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$2174e2766e27089d$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$2174e2766e27089d$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$2174e2766e27089d$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$2174e2766e27089d$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$2174e2766e27089d$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$2174e2766e27089d$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$2174e2766e27089d$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$2174e2766e27089d$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $2174e2766e27089d$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $2174e2766e27089d$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($2174e2766e27089d$var$lf));
function $2174e2766e27089d$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $2174e2766e27089d$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $2174e2766e27089d$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $2174e2766e27089d$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $2174e2766e27089d$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($2174e2766e27089d$var$Qb) throw a = $2174e2766e27089d$var$Rb, $2174e2766e27089d$var$Qb = !1, $2174e2766e27089d$var$Rb = null, a;
}
function $2174e2766e27089d$var$D(a, b) {
    var c = b[$2174e2766e27089d$var$of];
    void 0 === c && (c = b[$2174e2766e27089d$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($2174e2766e27089d$var$pf(b, a, 2, !1), c.add(d));
}
function $2174e2766e27089d$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $2174e2766e27089d$var$pf(c, a, d, b);
}
var $2174e2766e27089d$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $2174e2766e27089d$var$sf(a) {
    if (!a[$2174e2766e27089d$var$rf]) {
        a[$2174e2766e27089d$var$rf] = !0;
        $2174e2766e27089d$var$da.forEach(function(b) {
            "selectionchange" !== b && ($2174e2766e27089d$var$mf.has(b) || $2174e2766e27089d$var$qf(b, !1, a), $2174e2766e27089d$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$2174e2766e27089d$var$rf] || (b[$2174e2766e27089d$var$rf] = !0, $2174e2766e27089d$var$qf("selectionchange", !1, b));
    }
}
function $2174e2766e27089d$var$pf(a, b, c, d) {
    switch($2174e2766e27089d$var$jd(b)){
        case 1:
            var e = $2174e2766e27089d$var$ed;
            break;
        case 4:
            e = $2174e2766e27089d$var$gd;
            break;
        default:
            e = $2174e2766e27089d$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$2174e2766e27089d$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $2174e2766e27089d$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $2174e2766e27089d$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $2174e2766e27089d$var$Jb(function() {
        var d = f, e = $2174e2766e27089d$var$xb(c), g = [];
        a: {
            var h = $2174e2766e27089d$var$df.get(a);
            if (void 0 !== h) {
                var k = $2174e2766e27089d$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $2174e2766e27089d$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $2174e2766e27089d$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $2174e2766e27089d$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $2174e2766e27089d$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $2174e2766e27089d$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $2174e2766e27089d$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $2174e2766e27089d$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $2174e2766e27089d$var$Vd;
                        break;
                    case $2174e2766e27089d$var$$e:
                    case $2174e2766e27089d$var$af:
                    case $2174e2766e27089d$var$bf:
                        k = $2174e2766e27089d$var$Hd;
                        break;
                    case $2174e2766e27089d$var$cf:
                        k = $2174e2766e27089d$var$Xd;
                        break;
                    case "scroll":
                        k = $2174e2766e27089d$var$vd;
                        break;
                    case "wheel":
                        k = $2174e2766e27089d$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $2174e2766e27089d$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $2174e2766e27089d$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $2174e2766e27089d$var$Kb(w, x), null != F && t.push($2174e2766e27089d$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $2174e2766e27089d$var$wb && (n = c.relatedTarget || c.fromElement) && ($2174e2766e27089d$var$Wc(n) || n[$2174e2766e27089d$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $2174e2766e27089d$var$Wc(n) : null, null !== n && (J = $2174e2766e27089d$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $2174e2766e27089d$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $2174e2766e27089d$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $2174e2766e27089d$var$ue(k);
                        u = null == n ? h : $2174e2766e27089d$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $2174e2766e27089d$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $2174e2766e27089d$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $2174e2766e27089d$var$vf(F))u++;
                            for(; 0 < w - u;)t = $2174e2766e27089d$var$vf(t), w--;
                            for(; 0 < u - w;)x = $2174e2766e27089d$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $2174e2766e27089d$var$vf(t);
                                x = $2174e2766e27089d$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $2174e2766e27089d$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $2174e2766e27089d$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $2174e2766e27089d$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $2174e2766e27089d$var$ve;
                else if ($2174e2766e27089d$var$me(h)) {
                    if ($2174e2766e27089d$var$we) na = $2174e2766e27089d$var$Fe;
                    else {
                        na = $2174e2766e27089d$var$De;
                        var xa = $2174e2766e27089d$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $2174e2766e27089d$var$Ee);
                if (na && (na = na(a, d))) {
                    $2174e2766e27089d$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $2174e2766e27089d$var$cb(h, "number", h.value);
            }
            xa = d ? $2174e2766e27089d$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($2174e2766e27089d$var$me(xa) || "true" === xa.contentEditable) $2174e2766e27089d$var$Qe = xa, $2174e2766e27089d$var$Re = d, $2174e2766e27089d$var$Se = null;
                    break;
                case "focusout":
                    $2174e2766e27089d$var$Se = $2174e2766e27089d$var$Re = $2174e2766e27089d$var$Qe = null;
                    break;
                case "mousedown":
                    $2174e2766e27089d$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $2174e2766e27089d$var$Te = !1;
                    $2174e2766e27089d$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($2174e2766e27089d$var$Pe) break;
                case "keydown":
                case "keyup":
                    $2174e2766e27089d$var$Ue(g, c, e);
            }
            var $a;
            if ($2174e2766e27089d$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $2174e2766e27089d$var$ie ? $2174e2766e27089d$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($2174e2766e27089d$var$de && "ko" !== c.locale && ($2174e2766e27089d$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $2174e2766e27089d$var$ie && ($a = $2174e2766e27089d$var$nd()) : ($2174e2766e27089d$var$kd = e, $2174e2766e27089d$var$ld = "value" in $2174e2766e27089d$var$kd ? $2174e2766e27089d$var$kd.value : $2174e2766e27089d$var$kd.textContent, $2174e2766e27089d$var$ie = !0)), xa = $2174e2766e27089d$var$oe(d, ba), 0 < xa.length && (ba = new $2174e2766e27089d$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $2174e2766e27089d$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $2174e2766e27089d$var$ce ? $2174e2766e27089d$var$je(a, c) : $2174e2766e27089d$var$ke(a, c)) d = $2174e2766e27089d$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $2174e2766e27089d$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $2174e2766e27089d$var$se(g, b);
    });
}
function $2174e2766e27089d$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $2174e2766e27089d$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $2174e2766e27089d$var$Kb(a, c), null != f && d.unshift($2174e2766e27089d$var$tf(a, f, e)), f = $2174e2766e27089d$var$Kb(a, b), null != f && d.push($2174e2766e27089d$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $2174e2766e27089d$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $2174e2766e27089d$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $2174e2766e27089d$var$Kb(c, f), null != k && g.unshift($2174e2766e27089d$var$tf(c, k, h))) : e || (k = $2174e2766e27089d$var$Kb(c, f), null != k && g.push($2174e2766e27089d$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $2174e2766e27089d$var$xf = /\r\n?/g, $2174e2766e27089d$var$yf = /\u0000|\uFFFD/g;
function $2174e2766e27089d$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($2174e2766e27089d$var$xf, "\n").replace($2174e2766e27089d$var$yf, "");
}
function $2174e2766e27089d$var$Af(a, b, c) {
    b = $2174e2766e27089d$var$zf(b);
    if ($2174e2766e27089d$var$zf(a) !== b && c) throw Error($2174e2766e27089d$var$p(425));
}
function $2174e2766e27089d$var$Bf() {}
var $2174e2766e27089d$var$Cf = null, $2174e2766e27089d$var$Df = null;
function $2174e2766e27089d$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $2174e2766e27089d$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $2174e2766e27089d$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $2174e2766e27089d$var$Hf = "function" === typeof Promise ? Promise : void 0, $2174e2766e27089d$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $2174e2766e27089d$var$Hf ? function(a) {
    return $2174e2766e27089d$var$Hf.resolve(null).then(a).catch($2174e2766e27089d$var$If);
} : $2174e2766e27089d$var$Ff;
function $2174e2766e27089d$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $2174e2766e27089d$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $2174e2766e27089d$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $2174e2766e27089d$var$bd(b);
}
function $2174e2766e27089d$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $2174e2766e27089d$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $2174e2766e27089d$var$Nf = Math.random().toString(36).slice(2), $2174e2766e27089d$var$Of = "__reactFiber$" + $2174e2766e27089d$var$Nf, $2174e2766e27089d$var$Pf = "__reactProps$" + $2174e2766e27089d$var$Nf, $2174e2766e27089d$var$uf = "__reactContainer$" + $2174e2766e27089d$var$Nf, $2174e2766e27089d$var$of = "__reactEvents$" + $2174e2766e27089d$var$Nf, $2174e2766e27089d$var$Qf = "__reactListeners$" + $2174e2766e27089d$var$Nf, $2174e2766e27089d$var$Rf = "__reactHandles$" + $2174e2766e27089d$var$Nf;
function $2174e2766e27089d$var$Wc(a) {
    var b = a[$2174e2766e27089d$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$2174e2766e27089d$var$uf] || c[$2174e2766e27089d$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $2174e2766e27089d$var$Mf(a); null !== a;){
                if (c = a[$2174e2766e27089d$var$Of]) return c;
                a = $2174e2766e27089d$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $2174e2766e27089d$var$Cb(a) {
    a = a[$2174e2766e27089d$var$Of] || a[$2174e2766e27089d$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $2174e2766e27089d$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($2174e2766e27089d$var$p(33));
}
function $2174e2766e27089d$var$Db(a) {
    return a[$2174e2766e27089d$var$Pf] || null;
}
var $2174e2766e27089d$var$Sf = [], $2174e2766e27089d$var$Tf = -1;
function $2174e2766e27089d$var$Uf(a) {
    return {
        current: a
    };
}
function $2174e2766e27089d$var$E(a) {
    0 > $2174e2766e27089d$var$Tf || (a.current = $2174e2766e27089d$var$Sf[$2174e2766e27089d$var$Tf], $2174e2766e27089d$var$Sf[$2174e2766e27089d$var$Tf] = null, $2174e2766e27089d$var$Tf--);
}
function $2174e2766e27089d$var$G(a, b) {
    $2174e2766e27089d$var$Tf++;
    $2174e2766e27089d$var$Sf[$2174e2766e27089d$var$Tf] = a.current;
    a.current = b;
}
var $2174e2766e27089d$var$Vf = {}, $2174e2766e27089d$var$H = $2174e2766e27089d$var$Uf($2174e2766e27089d$var$Vf), $2174e2766e27089d$var$Wf = $2174e2766e27089d$var$Uf(!1), $2174e2766e27089d$var$Xf = $2174e2766e27089d$var$Vf;
function $2174e2766e27089d$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $2174e2766e27089d$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $2174e2766e27089d$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $2174e2766e27089d$var$$f() {
    $2174e2766e27089d$var$E($2174e2766e27089d$var$Wf);
    $2174e2766e27089d$var$E($2174e2766e27089d$var$H);
}
function $2174e2766e27089d$var$ag(a, b, c) {
    if ($2174e2766e27089d$var$H.current !== $2174e2766e27089d$var$Vf) throw Error($2174e2766e27089d$var$p(168));
    $2174e2766e27089d$var$G($2174e2766e27089d$var$H, b);
    $2174e2766e27089d$var$G($2174e2766e27089d$var$Wf, c);
}
function $2174e2766e27089d$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($2174e2766e27089d$var$p(108, $2174e2766e27089d$var$Ra(a) || "Unknown", e));
    return $2174e2766e27089d$var$A({}, c, d);
}
function $2174e2766e27089d$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $2174e2766e27089d$var$Vf;
    $2174e2766e27089d$var$Xf = $2174e2766e27089d$var$H.current;
    $2174e2766e27089d$var$G($2174e2766e27089d$var$H, a);
    $2174e2766e27089d$var$G($2174e2766e27089d$var$Wf, $2174e2766e27089d$var$Wf.current);
    return !0;
}
function $2174e2766e27089d$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($2174e2766e27089d$var$p(169));
    c ? (a = $2174e2766e27089d$var$bg(a, b, $2174e2766e27089d$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $2174e2766e27089d$var$E($2174e2766e27089d$var$Wf), $2174e2766e27089d$var$E($2174e2766e27089d$var$H), $2174e2766e27089d$var$G($2174e2766e27089d$var$H, a)) : $2174e2766e27089d$var$E($2174e2766e27089d$var$Wf);
    $2174e2766e27089d$var$G($2174e2766e27089d$var$Wf, c);
}
var $2174e2766e27089d$var$eg = null, $2174e2766e27089d$var$fg = !1, $2174e2766e27089d$var$gg = !1;
function $2174e2766e27089d$var$hg(a) {
    null === $2174e2766e27089d$var$eg ? $2174e2766e27089d$var$eg = [
        a
    ] : $2174e2766e27089d$var$eg.push(a);
}
function $2174e2766e27089d$var$ig(a) {
    $2174e2766e27089d$var$fg = !0;
    $2174e2766e27089d$var$hg(a);
}
function $2174e2766e27089d$var$jg() {
    if (!$2174e2766e27089d$var$gg && null !== $2174e2766e27089d$var$eg) {
        $2174e2766e27089d$var$gg = !0;
        var a = 0, b = $2174e2766e27089d$var$C;
        try {
            var c = $2174e2766e27089d$var$eg;
            for($2174e2766e27089d$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $2174e2766e27089d$var$eg = null;
            $2174e2766e27089d$var$fg = !1;
        } catch (e) {
            throw null !== $2174e2766e27089d$var$eg && ($2174e2766e27089d$var$eg = $2174e2766e27089d$var$eg.slice(a + 1)), $2174e2766e27089d$var$ac($2174e2766e27089d$var$fc, $2174e2766e27089d$var$jg), e;
        } finally{
            $2174e2766e27089d$var$C = b, $2174e2766e27089d$var$gg = !1;
        }
    }
    return null;
}
var $2174e2766e27089d$var$kg = [], $2174e2766e27089d$var$lg = 0, $2174e2766e27089d$var$mg = null, $2174e2766e27089d$var$ng = 0, $2174e2766e27089d$var$og = [], $2174e2766e27089d$var$pg = 0, $2174e2766e27089d$var$qg = null, $2174e2766e27089d$var$rg = 1, $2174e2766e27089d$var$sg = "";
function $2174e2766e27089d$var$tg(a, b) {
    $2174e2766e27089d$var$kg[$2174e2766e27089d$var$lg++] = $2174e2766e27089d$var$ng;
    $2174e2766e27089d$var$kg[$2174e2766e27089d$var$lg++] = $2174e2766e27089d$var$mg;
    $2174e2766e27089d$var$mg = a;
    $2174e2766e27089d$var$ng = b;
}
function $2174e2766e27089d$var$ug(a, b, c) {
    $2174e2766e27089d$var$og[$2174e2766e27089d$var$pg++] = $2174e2766e27089d$var$rg;
    $2174e2766e27089d$var$og[$2174e2766e27089d$var$pg++] = $2174e2766e27089d$var$sg;
    $2174e2766e27089d$var$og[$2174e2766e27089d$var$pg++] = $2174e2766e27089d$var$qg;
    $2174e2766e27089d$var$qg = a;
    var d = $2174e2766e27089d$var$rg;
    a = $2174e2766e27089d$var$sg;
    var e = 32 - $2174e2766e27089d$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $2174e2766e27089d$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $2174e2766e27089d$var$rg = 1 << 32 - $2174e2766e27089d$var$oc(b) + e | c << e | d;
        $2174e2766e27089d$var$sg = f + a;
    } else $2174e2766e27089d$var$rg = 1 << f | c << e | d, $2174e2766e27089d$var$sg = a;
}
function $2174e2766e27089d$var$vg(a) {
    null !== a.return && ($2174e2766e27089d$var$tg(a, 1), $2174e2766e27089d$var$ug(a, 1, 0));
}
function $2174e2766e27089d$var$wg(a) {
    for(; a === $2174e2766e27089d$var$mg;)$2174e2766e27089d$var$mg = $2174e2766e27089d$var$kg[--$2174e2766e27089d$var$lg], $2174e2766e27089d$var$kg[$2174e2766e27089d$var$lg] = null, $2174e2766e27089d$var$ng = $2174e2766e27089d$var$kg[--$2174e2766e27089d$var$lg], $2174e2766e27089d$var$kg[$2174e2766e27089d$var$lg] = null;
    for(; a === $2174e2766e27089d$var$qg;)$2174e2766e27089d$var$qg = $2174e2766e27089d$var$og[--$2174e2766e27089d$var$pg], $2174e2766e27089d$var$og[$2174e2766e27089d$var$pg] = null, $2174e2766e27089d$var$sg = $2174e2766e27089d$var$og[--$2174e2766e27089d$var$pg], $2174e2766e27089d$var$og[$2174e2766e27089d$var$pg] = null, $2174e2766e27089d$var$rg = $2174e2766e27089d$var$og[--$2174e2766e27089d$var$pg], $2174e2766e27089d$var$og[$2174e2766e27089d$var$pg] = null;
}
var $2174e2766e27089d$var$xg = null, $2174e2766e27089d$var$yg = null, $2174e2766e27089d$var$I = !1, $2174e2766e27089d$var$zg = null;
function $2174e2766e27089d$var$Ag(a, b) {
    var c = $2174e2766e27089d$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $2174e2766e27089d$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $2174e2766e27089d$var$xg = a, $2174e2766e27089d$var$yg = $2174e2766e27089d$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $2174e2766e27089d$var$xg = a, $2174e2766e27089d$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $2174e2766e27089d$var$qg ? {
                id: $2174e2766e27089d$var$rg,
                overflow: $2174e2766e27089d$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $2174e2766e27089d$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $2174e2766e27089d$var$xg = a, $2174e2766e27089d$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $2174e2766e27089d$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $2174e2766e27089d$var$Eg(a) {
    if ($2174e2766e27089d$var$I) {
        var b = $2174e2766e27089d$var$yg;
        if (b) {
            var c = b;
            if (!$2174e2766e27089d$var$Cg(a, b)) {
                if ($2174e2766e27089d$var$Dg(a)) throw Error($2174e2766e27089d$var$p(418));
                b = $2174e2766e27089d$var$Lf(c.nextSibling);
                var d = $2174e2766e27089d$var$xg;
                b && $2174e2766e27089d$var$Cg(a, b) ? $2174e2766e27089d$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $2174e2766e27089d$var$I = !1, $2174e2766e27089d$var$xg = a);
            }
        } else {
            if ($2174e2766e27089d$var$Dg(a)) throw Error($2174e2766e27089d$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $2174e2766e27089d$var$I = !1;
            $2174e2766e27089d$var$xg = a;
        }
    }
}
function $2174e2766e27089d$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $2174e2766e27089d$var$xg = a;
}
function $2174e2766e27089d$var$Gg(a) {
    if (a !== $2174e2766e27089d$var$xg) return !1;
    if (!$2174e2766e27089d$var$I) return $2174e2766e27089d$var$Fg(a), $2174e2766e27089d$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$2174e2766e27089d$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $2174e2766e27089d$var$yg)) {
        if ($2174e2766e27089d$var$Dg(a)) throw $2174e2766e27089d$var$Hg(), Error($2174e2766e27089d$var$p(418));
        for(; b;)$2174e2766e27089d$var$Ag(a, b), b = $2174e2766e27089d$var$Lf(b.nextSibling);
    }
    $2174e2766e27089d$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($2174e2766e27089d$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $2174e2766e27089d$var$yg = $2174e2766e27089d$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $2174e2766e27089d$var$yg = null;
        }
    } else $2174e2766e27089d$var$yg = $2174e2766e27089d$var$xg ? $2174e2766e27089d$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $2174e2766e27089d$var$Hg() {
    for(var a = $2174e2766e27089d$var$yg; a;)a = $2174e2766e27089d$var$Lf(a.nextSibling);
}
function $2174e2766e27089d$var$Ig() {
    $2174e2766e27089d$var$yg = $2174e2766e27089d$var$xg = null;
    $2174e2766e27089d$var$I = !1;
}
function $2174e2766e27089d$var$Jg(a) {
    null === $2174e2766e27089d$var$zg ? $2174e2766e27089d$var$zg = [
        a
    ] : $2174e2766e27089d$var$zg.push(a);
}
var $2174e2766e27089d$var$Kg = $2174e2766e27089d$var$ua.ReactCurrentBatchConfig;
function $2174e2766e27089d$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $2174e2766e27089d$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $2174e2766e27089d$var$Mg = $2174e2766e27089d$var$Uf(null), $2174e2766e27089d$var$Ng = null, $2174e2766e27089d$var$Og = null, $2174e2766e27089d$var$Pg = null;
function $2174e2766e27089d$var$Qg() {
    $2174e2766e27089d$var$Pg = $2174e2766e27089d$var$Og = $2174e2766e27089d$var$Ng = null;
}
function $2174e2766e27089d$var$Rg(a) {
    var b = $2174e2766e27089d$var$Mg.current;
    $2174e2766e27089d$var$E($2174e2766e27089d$var$Mg);
    a._currentValue = b;
}
function $2174e2766e27089d$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $2174e2766e27089d$var$Tg(a, b) {
    $2174e2766e27089d$var$Ng = a;
    $2174e2766e27089d$var$Pg = $2174e2766e27089d$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($2174e2766e27089d$var$Ug = !0), a.firstContext = null);
}
function $2174e2766e27089d$var$Vg(a) {
    var b = a._currentValue;
    if ($2174e2766e27089d$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $2174e2766e27089d$var$Og) {
            if (null === $2174e2766e27089d$var$Ng) throw Error($2174e2766e27089d$var$p(308));
            $2174e2766e27089d$var$Og = a;
            $2174e2766e27089d$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $2174e2766e27089d$var$Og = $2174e2766e27089d$var$Og.next = a;
    }
    return b;
}
var $2174e2766e27089d$var$Wg = null;
function $2174e2766e27089d$var$Xg(a) {
    null === $2174e2766e27089d$var$Wg ? $2174e2766e27089d$var$Wg = [
        a
    ] : $2174e2766e27089d$var$Wg.push(a);
}
function $2174e2766e27089d$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $2174e2766e27089d$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $2174e2766e27089d$var$Zg(a, d);
}
function $2174e2766e27089d$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $2174e2766e27089d$var$$g = !1;
function $2174e2766e27089d$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $2174e2766e27089d$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $2174e2766e27089d$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $2174e2766e27089d$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($2174e2766e27089d$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $2174e2766e27089d$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $2174e2766e27089d$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $2174e2766e27089d$var$Zg(a, c);
}
function $2174e2766e27089d$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $2174e2766e27089d$var$Cc(a, c);
    }
}
function $2174e2766e27089d$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $2174e2766e27089d$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $2174e2766e27089d$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $2174e2766e27089d$var$A({}, q, r);
                            break a;
                        case 2:
                            $2174e2766e27089d$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $2174e2766e27089d$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $2174e2766e27089d$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($2174e2766e27089d$var$p(191, e));
            e.call(d);
        }
    }
}
var $2174e2766e27089d$var$jh = (new $P551f.Component).refs;
function $2174e2766e27089d$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $2174e2766e27089d$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $2174e2766e27089d$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $2174e2766e27089d$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $2174e2766e27089d$var$L(), e = $2174e2766e27089d$var$lh(a), f = $2174e2766e27089d$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $2174e2766e27089d$var$dh(a, f, e);
        null !== b && ($2174e2766e27089d$var$mh(b, a, e, d), $2174e2766e27089d$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $2174e2766e27089d$var$L(), e = $2174e2766e27089d$var$lh(a), f = $2174e2766e27089d$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $2174e2766e27089d$var$dh(a, f, e);
        null !== b && ($2174e2766e27089d$var$mh(b, a, e, d), $2174e2766e27089d$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $2174e2766e27089d$var$L(), d = $2174e2766e27089d$var$lh(a), e = $2174e2766e27089d$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $2174e2766e27089d$var$dh(a, e, d);
        null !== b && ($2174e2766e27089d$var$mh(b, a, d, c), $2174e2766e27089d$var$eh(b, a, d));
    }
};
function $2174e2766e27089d$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$2174e2766e27089d$var$Ie(c, d) || !$2174e2766e27089d$var$Ie(e, f) : !0;
}
function $2174e2766e27089d$var$ph(a, b, c) {
    var d = !1, e = $2174e2766e27089d$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $2174e2766e27089d$var$Vg(f) : (e = $2174e2766e27089d$var$Zf(b) ? $2174e2766e27089d$var$Xf : $2174e2766e27089d$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $2174e2766e27089d$var$Yf(a, e) : $2174e2766e27089d$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $2174e2766e27089d$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $2174e2766e27089d$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $2174e2766e27089d$var$nh.enqueueReplaceState(b, b.state, null);
}
function $2174e2766e27089d$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $2174e2766e27089d$var$jh;
    $2174e2766e27089d$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $2174e2766e27089d$var$Vg(f) : (f = $2174e2766e27089d$var$Zf(b) ? $2174e2766e27089d$var$Xf : $2174e2766e27089d$var$H.current, e.context = $2174e2766e27089d$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($2174e2766e27089d$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $2174e2766e27089d$var$nh.enqueueReplaceState(e, e.state, null), $2174e2766e27089d$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $2174e2766e27089d$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($2174e2766e27089d$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($2174e2766e27089d$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $2174e2766e27089d$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($2174e2766e27089d$var$p(284));
        if (!c._owner) throw Error($2174e2766e27089d$var$p(290, a));
    }
    return a;
}
function $2174e2766e27089d$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($2174e2766e27089d$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $2174e2766e27089d$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $2174e2766e27089d$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $2174e2766e27089d$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $2174e2766e27089d$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $2174e2766e27089d$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $2174e2766e27089d$var$Ha && $2174e2766e27089d$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $2174e2766e27089d$var$sh(a, b, c), d.return = a, d;
        d = $2174e2766e27089d$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $2174e2766e27089d$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $2174e2766e27089d$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $2174e2766e27089d$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $2174e2766e27089d$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $2174e2766e27089d$var$va:
                    return c = $2174e2766e27089d$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $2174e2766e27089d$var$sh(a, null, b), c.return = a, c;
                case $2174e2766e27089d$var$wa:
                    return b = $2174e2766e27089d$var$zh(b, a.mode, c), b.return = a, b;
                case $2174e2766e27089d$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($2174e2766e27089d$var$eb(b) || $2174e2766e27089d$var$Ka(b)) return b = $2174e2766e27089d$var$Ah(b, a.mode, c, null), b.return = a, b;
            $2174e2766e27089d$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $2174e2766e27089d$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $2174e2766e27089d$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $2174e2766e27089d$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($2174e2766e27089d$var$eb(c) || $2174e2766e27089d$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $2174e2766e27089d$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $2174e2766e27089d$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $2174e2766e27089d$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $2174e2766e27089d$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($2174e2766e27089d$var$eb(d) || $2174e2766e27089d$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $2174e2766e27089d$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $2174e2766e27089d$var$I && $2174e2766e27089d$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $2174e2766e27089d$var$I && $2174e2766e27089d$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $2174e2766e27089d$var$I && $2174e2766e27089d$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $2174e2766e27089d$var$Ka(h);
        if ("function" !== typeof l) throw Error($2174e2766e27089d$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($2174e2766e27089d$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $2174e2766e27089d$var$I && $2174e2766e27089d$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $2174e2766e27089d$var$I && $2174e2766e27089d$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $2174e2766e27089d$var$I && $2174e2766e27089d$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $2174e2766e27089d$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $2174e2766e27089d$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $2174e2766e27089d$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $2174e2766e27089d$var$Ha && $2174e2766e27089d$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $2174e2766e27089d$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $2174e2766e27089d$var$ya ? (d = $2174e2766e27089d$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $2174e2766e27089d$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $2174e2766e27089d$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $2174e2766e27089d$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $2174e2766e27089d$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $2174e2766e27089d$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($2174e2766e27089d$var$eb(f)) return n(a, d, f, h);
            if ($2174e2766e27089d$var$Ka(f)) return t(a, d, f, h);
            $2174e2766e27089d$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $2174e2766e27089d$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $2174e2766e27089d$var$Bh = $2174e2766e27089d$var$vh(!0), $2174e2766e27089d$var$Ch = $2174e2766e27089d$var$vh(!1), $2174e2766e27089d$var$Dh = {}, $2174e2766e27089d$var$Eh = $2174e2766e27089d$var$Uf($2174e2766e27089d$var$Dh), $2174e2766e27089d$var$Fh = $2174e2766e27089d$var$Uf($2174e2766e27089d$var$Dh), $2174e2766e27089d$var$Gh = $2174e2766e27089d$var$Uf($2174e2766e27089d$var$Dh);
function $2174e2766e27089d$var$Hh(a) {
    if (a === $2174e2766e27089d$var$Dh) throw Error($2174e2766e27089d$var$p(174));
    return a;
}
function $2174e2766e27089d$var$Ih(a, b) {
    $2174e2766e27089d$var$G($2174e2766e27089d$var$Gh, b);
    $2174e2766e27089d$var$G($2174e2766e27089d$var$Fh, a);
    $2174e2766e27089d$var$G($2174e2766e27089d$var$Eh, $2174e2766e27089d$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $2174e2766e27089d$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $2174e2766e27089d$var$lb(b, a);
    }
    $2174e2766e27089d$var$E($2174e2766e27089d$var$Eh);
    $2174e2766e27089d$var$G($2174e2766e27089d$var$Eh, b);
}
function $2174e2766e27089d$var$Jh() {
    $2174e2766e27089d$var$E($2174e2766e27089d$var$Eh);
    $2174e2766e27089d$var$E($2174e2766e27089d$var$Fh);
    $2174e2766e27089d$var$E($2174e2766e27089d$var$Gh);
}
function $2174e2766e27089d$var$Kh(a) {
    $2174e2766e27089d$var$Hh($2174e2766e27089d$var$Gh.current);
    var b = $2174e2766e27089d$var$Hh($2174e2766e27089d$var$Eh.current);
    var c = $2174e2766e27089d$var$lb(b, a.type);
    b !== c && ($2174e2766e27089d$var$G($2174e2766e27089d$var$Fh, a), $2174e2766e27089d$var$G($2174e2766e27089d$var$Eh, c));
}
function $2174e2766e27089d$var$Lh(a) {
    $2174e2766e27089d$var$Fh.current === a && ($2174e2766e27089d$var$E($2174e2766e27089d$var$Eh), $2174e2766e27089d$var$E($2174e2766e27089d$var$Fh));
}
var $2174e2766e27089d$var$M = $2174e2766e27089d$var$Uf(0);
function $2174e2766e27089d$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $2174e2766e27089d$var$Nh = [];
function $2174e2766e27089d$var$Oh() {
    for(var a = 0; a < $2174e2766e27089d$var$Nh.length; a++)$2174e2766e27089d$var$Nh[a]._workInProgressVersionPrimary = null;
    $2174e2766e27089d$var$Nh.length = 0;
}
var $2174e2766e27089d$var$Ph = $2174e2766e27089d$var$ua.ReactCurrentDispatcher, $2174e2766e27089d$var$Qh = $2174e2766e27089d$var$ua.ReactCurrentBatchConfig, $2174e2766e27089d$var$Rh = 0, $2174e2766e27089d$var$N = null, $2174e2766e27089d$var$O = null, $2174e2766e27089d$var$P = null, $2174e2766e27089d$var$Sh = !1, $2174e2766e27089d$var$Th = !1, $2174e2766e27089d$var$Uh = 0, $2174e2766e27089d$var$Vh = 0;
function $2174e2766e27089d$var$Q() {
    throw Error($2174e2766e27089d$var$p(321));
}
function $2174e2766e27089d$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$2174e2766e27089d$var$He(a[c], b[c])) return !1;
    return !0;
}
function $2174e2766e27089d$var$Xh(a, b, c, d, e, f) {
    $2174e2766e27089d$var$Rh = f;
    $2174e2766e27089d$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $2174e2766e27089d$var$Ph.current = null === a || null === a.memoizedState ? $2174e2766e27089d$var$Yh : $2174e2766e27089d$var$Zh;
    a = c(d, e);
    if ($2174e2766e27089d$var$Th) {
        f = 0;
        do {
            $2174e2766e27089d$var$Th = !1;
            $2174e2766e27089d$var$Uh = 0;
            if (25 <= f) throw Error($2174e2766e27089d$var$p(301));
            f += 1;
            $2174e2766e27089d$var$P = $2174e2766e27089d$var$O = null;
            b.updateQueue = null;
            $2174e2766e27089d$var$Ph.current = $2174e2766e27089d$var$$h;
            a = c(d, e);
        }while ($2174e2766e27089d$var$Th);
    }
    $2174e2766e27089d$var$Ph.current = $2174e2766e27089d$var$ai;
    b = null !== $2174e2766e27089d$var$O && null !== $2174e2766e27089d$var$O.next;
    $2174e2766e27089d$var$Rh = 0;
    $2174e2766e27089d$var$P = $2174e2766e27089d$var$O = $2174e2766e27089d$var$N = null;
    $2174e2766e27089d$var$Sh = !1;
    if (b) throw Error($2174e2766e27089d$var$p(300));
    return a;
}
function $2174e2766e27089d$var$bi() {
    var a = 0 !== $2174e2766e27089d$var$Uh;
    $2174e2766e27089d$var$Uh = 0;
    return a;
}
function $2174e2766e27089d$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $2174e2766e27089d$var$P ? $2174e2766e27089d$var$N.memoizedState = $2174e2766e27089d$var$P = a : $2174e2766e27089d$var$P = $2174e2766e27089d$var$P.next = a;
    return $2174e2766e27089d$var$P;
}
function $2174e2766e27089d$var$di() {
    if (null === $2174e2766e27089d$var$O) {
        var a = $2174e2766e27089d$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $2174e2766e27089d$var$O.next;
    var b = null === $2174e2766e27089d$var$P ? $2174e2766e27089d$var$N.memoizedState : $2174e2766e27089d$var$P.next;
    if (null !== b) $2174e2766e27089d$var$P = b, $2174e2766e27089d$var$O = a;
    else {
        if (null === a) throw Error($2174e2766e27089d$var$p(310));
        $2174e2766e27089d$var$O = a;
        a = {
            memoizedState: $2174e2766e27089d$var$O.memoizedState,
            baseState: $2174e2766e27089d$var$O.baseState,
            baseQueue: $2174e2766e27089d$var$O.baseQueue,
            queue: $2174e2766e27089d$var$O.queue,
            next: null
        };
        null === $2174e2766e27089d$var$P ? $2174e2766e27089d$var$N.memoizedState = $2174e2766e27089d$var$P = a : $2174e2766e27089d$var$P = $2174e2766e27089d$var$P.next = a;
    }
    return $2174e2766e27089d$var$P;
}
function $2174e2766e27089d$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $2174e2766e27089d$var$fi(a) {
    var b = $2174e2766e27089d$var$di(), c = b.queue;
    if (null === c) throw Error($2174e2766e27089d$var$p(311));
    c.lastRenderedReducer = a;
    var d = $2174e2766e27089d$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($2174e2766e27089d$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $2174e2766e27089d$var$N.lanes |= m;
                $2174e2766e27089d$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $2174e2766e27089d$var$He(d, b.memoizedState) || ($2174e2766e27089d$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $2174e2766e27089d$var$N.lanes |= f, $2174e2766e27089d$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $2174e2766e27089d$var$gi(a) {
    var b = $2174e2766e27089d$var$di(), c = b.queue;
    if (null === c) throw Error($2174e2766e27089d$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $2174e2766e27089d$var$He(f, b.memoizedState) || ($2174e2766e27089d$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $2174e2766e27089d$var$hi() {}
function $2174e2766e27089d$var$ii(a, b) {
    var c = $2174e2766e27089d$var$N, d = $2174e2766e27089d$var$di(), e = b(), f = !$2174e2766e27089d$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $2174e2766e27089d$var$Ug = !0);
    d = d.queue;
    $2174e2766e27089d$var$ji($2174e2766e27089d$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $2174e2766e27089d$var$P && $2174e2766e27089d$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $2174e2766e27089d$var$li(9, $2174e2766e27089d$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $2174e2766e27089d$var$R) throw Error($2174e2766e27089d$var$p(349));
        0 !== ($2174e2766e27089d$var$Rh & 30) || $2174e2766e27089d$var$ni(c, b, e);
    }
    return e;
}
function $2174e2766e27089d$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $2174e2766e27089d$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $2174e2766e27089d$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $2174e2766e27089d$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $2174e2766e27089d$var$oi(b) && $2174e2766e27089d$var$pi(a);
}
function $2174e2766e27089d$var$ki(a, b, c) {
    return c(function() {
        $2174e2766e27089d$var$oi(b) && $2174e2766e27089d$var$pi(a);
    });
}
function $2174e2766e27089d$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$2174e2766e27089d$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $2174e2766e27089d$var$pi(a) {
    var b = $2174e2766e27089d$var$Zg(a, 1);
    null !== b && $2174e2766e27089d$var$mh(b, a, 1, -1);
}
function $2174e2766e27089d$var$qi(a) {
    var b = $2174e2766e27089d$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $2174e2766e27089d$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $2174e2766e27089d$var$ri.bind(null, $2174e2766e27089d$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $2174e2766e27089d$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $2174e2766e27089d$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $2174e2766e27089d$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $2174e2766e27089d$var$si() {
    return $2174e2766e27089d$var$di().memoizedState;
}
function $2174e2766e27089d$var$ti(a, b, c, d) {
    var e = $2174e2766e27089d$var$ci();
    $2174e2766e27089d$var$N.flags |= a;
    e.memoizedState = $2174e2766e27089d$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $2174e2766e27089d$var$ui(a, b, c, d) {
    var e = $2174e2766e27089d$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $2174e2766e27089d$var$O) {
        var g = $2174e2766e27089d$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $2174e2766e27089d$var$Wh(d, g.deps)) {
            e.memoizedState = $2174e2766e27089d$var$li(b, c, f, d);
            return;
        }
    }
    $2174e2766e27089d$var$N.flags |= a;
    e.memoizedState = $2174e2766e27089d$var$li(1 | b, c, f, d);
}
function $2174e2766e27089d$var$vi(a, b) {
    return $2174e2766e27089d$var$ti(8390656, 8, a, b);
}
function $2174e2766e27089d$var$ji(a, b) {
    return $2174e2766e27089d$var$ui(2048, 8, a, b);
}
function $2174e2766e27089d$var$wi(a, b) {
    return $2174e2766e27089d$var$ui(4, 2, a, b);
}
function $2174e2766e27089d$var$xi(a, b) {
    return $2174e2766e27089d$var$ui(4, 4, a, b);
}
function $2174e2766e27089d$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $2174e2766e27089d$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $2174e2766e27089d$var$ui(4, 4, $2174e2766e27089d$var$yi.bind(null, b, a), c);
}
function $2174e2766e27089d$var$Ai() {}
function $2174e2766e27089d$var$Bi(a, b) {
    var c = $2174e2766e27089d$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $2174e2766e27089d$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $2174e2766e27089d$var$Ci(a, b) {
    var c = $2174e2766e27089d$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $2174e2766e27089d$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $2174e2766e27089d$var$Di(a, b, c) {
    if (0 === ($2174e2766e27089d$var$Rh & 21)) return a.baseState && (a.baseState = !1, $2174e2766e27089d$var$Ug = !0), a.memoizedState = c;
    $2174e2766e27089d$var$He(c, b) || (c = $2174e2766e27089d$var$yc(), $2174e2766e27089d$var$N.lanes |= c, $2174e2766e27089d$var$hh |= c, a.baseState = !0);
    return b;
}
function $2174e2766e27089d$var$Ei(a, b) {
    var c = $2174e2766e27089d$var$C;
    $2174e2766e27089d$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $2174e2766e27089d$var$Qh.transition;
    $2174e2766e27089d$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $2174e2766e27089d$var$C = c, $2174e2766e27089d$var$Qh.transition = d;
    }
}
function $2174e2766e27089d$var$Fi() {
    return $2174e2766e27089d$var$di().memoizedState;
}
function $2174e2766e27089d$var$Gi(a, b, c) {
    var d = $2174e2766e27089d$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($2174e2766e27089d$var$Hi(a)) $2174e2766e27089d$var$Ii(b, c);
    else if (c = $2174e2766e27089d$var$Yg(a, b, c, d), null !== c) {
        var e = $2174e2766e27089d$var$L();
        $2174e2766e27089d$var$mh(c, a, d, e);
        $2174e2766e27089d$var$Ji(c, b, d);
    }
}
function $2174e2766e27089d$var$ri(a, b, c) {
    var d = $2174e2766e27089d$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($2174e2766e27089d$var$Hi(a)) $2174e2766e27089d$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($2174e2766e27089d$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $2174e2766e27089d$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $2174e2766e27089d$var$Yg(a, b, e, d);
        null !== c && (e = $2174e2766e27089d$var$L(), $2174e2766e27089d$var$mh(c, a, d, e), $2174e2766e27089d$var$Ji(c, b, d));
    }
}
function $2174e2766e27089d$var$Hi(a) {
    var b = a.alternate;
    return a === $2174e2766e27089d$var$N || null !== b && b === $2174e2766e27089d$var$N;
}
function $2174e2766e27089d$var$Ii(a, b) {
    $2174e2766e27089d$var$Th = $2174e2766e27089d$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $2174e2766e27089d$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $2174e2766e27089d$var$Cc(a, c);
    }
}
var $2174e2766e27089d$var$ai = {
    readContext: $2174e2766e27089d$var$Vg,
    useCallback: $2174e2766e27089d$var$Q,
    useContext: $2174e2766e27089d$var$Q,
    useEffect: $2174e2766e27089d$var$Q,
    useImperativeHandle: $2174e2766e27089d$var$Q,
    useInsertionEffect: $2174e2766e27089d$var$Q,
    useLayoutEffect: $2174e2766e27089d$var$Q,
    useMemo: $2174e2766e27089d$var$Q,
    useReducer: $2174e2766e27089d$var$Q,
    useRef: $2174e2766e27089d$var$Q,
    useState: $2174e2766e27089d$var$Q,
    useDebugValue: $2174e2766e27089d$var$Q,
    useDeferredValue: $2174e2766e27089d$var$Q,
    useTransition: $2174e2766e27089d$var$Q,
    useMutableSource: $2174e2766e27089d$var$Q,
    useSyncExternalStore: $2174e2766e27089d$var$Q,
    useId: $2174e2766e27089d$var$Q,
    unstable_isNewReconciler: !1
}, $2174e2766e27089d$var$Yh = {
    readContext: $2174e2766e27089d$var$Vg,
    useCallback: function(a, b) {
        $2174e2766e27089d$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $2174e2766e27089d$var$Vg,
    useEffect: $2174e2766e27089d$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $2174e2766e27089d$var$ti(4194308, 4, $2174e2766e27089d$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $2174e2766e27089d$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $2174e2766e27089d$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $2174e2766e27089d$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $2174e2766e27089d$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $2174e2766e27089d$var$Gi.bind(null, $2174e2766e27089d$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $2174e2766e27089d$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $2174e2766e27089d$var$qi,
    useDebugValue: $2174e2766e27089d$var$Ai,
    useDeferredValue: function(a) {
        return $2174e2766e27089d$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $2174e2766e27089d$var$qi(!1), b = a[0];
        a = $2174e2766e27089d$var$Ei.bind(null, a[1]);
        $2174e2766e27089d$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $2174e2766e27089d$var$N, e = $2174e2766e27089d$var$ci();
        if ($2174e2766e27089d$var$I) {
            if (void 0 === c) throw Error($2174e2766e27089d$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $2174e2766e27089d$var$R) throw Error($2174e2766e27089d$var$p(349));
            0 !== ($2174e2766e27089d$var$Rh & 30) || $2174e2766e27089d$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $2174e2766e27089d$var$vi($2174e2766e27089d$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $2174e2766e27089d$var$li(9, $2174e2766e27089d$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $2174e2766e27089d$var$ci(), b = $2174e2766e27089d$var$R.identifierPrefix;
        if ($2174e2766e27089d$var$I) {
            var c = $2174e2766e27089d$var$sg;
            var d = $2174e2766e27089d$var$rg;
            c = (d & ~(1 << 32 - $2174e2766e27089d$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $2174e2766e27089d$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $2174e2766e27089d$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $2174e2766e27089d$var$Zh = {
    readContext: $2174e2766e27089d$var$Vg,
    useCallback: $2174e2766e27089d$var$Bi,
    useContext: $2174e2766e27089d$var$Vg,
    useEffect: $2174e2766e27089d$var$ji,
    useImperativeHandle: $2174e2766e27089d$var$zi,
    useInsertionEffect: $2174e2766e27089d$var$wi,
    useLayoutEffect: $2174e2766e27089d$var$xi,
    useMemo: $2174e2766e27089d$var$Ci,
    useReducer: $2174e2766e27089d$var$fi,
    useRef: $2174e2766e27089d$var$si,
    useState: function() {
        return $2174e2766e27089d$var$fi($2174e2766e27089d$var$ei);
    },
    useDebugValue: $2174e2766e27089d$var$Ai,
    useDeferredValue: function(a) {
        var b = $2174e2766e27089d$var$di();
        return $2174e2766e27089d$var$Di(b, $2174e2766e27089d$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $2174e2766e27089d$var$fi($2174e2766e27089d$var$ei)[0], b = $2174e2766e27089d$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $2174e2766e27089d$var$hi,
    useSyncExternalStore: $2174e2766e27089d$var$ii,
    useId: $2174e2766e27089d$var$Fi,
    unstable_isNewReconciler: !1
}, $2174e2766e27089d$var$$h = {
    readContext: $2174e2766e27089d$var$Vg,
    useCallback: $2174e2766e27089d$var$Bi,
    useContext: $2174e2766e27089d$var$Vg,
    useEffect: $2174e2766e27089d$var$ji,
    useImperativeHandle: $2174e2766e27089d$var$zi,
    useInsertionEffect: $2174e2766e27089d$var$wi,
    useLayoutEffect: $2174e2766e27089d$var$xi,
    useMemo: $2174e2766e27089d$var$Ci,
    useReducer: $2174e2766e27089d$var$gi,
    useRef: $2174e2766e27089d$var$si,
    useState: function() {
        return $2174e2766e27089d$var$gi($2174e2766e27089d$var$ei);
    },
    useDebugValue: $2174e2766e27089d$var$Ai,
    useDeferredValue: function(a) {
        var b = $2174e2766e27089d$var$di();
        return null === $2174e2766e27089d$var$O ? b.memoizedState = a : $2174e2766e27089d$var$Di(b, $2174e2766e27089d$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $2174e2766e27089d$var$gi($2174e2766e27089d$var$ei)[0], b = $2174e2766e27089d$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $2174e2766e27089d$var$hi,
    useSyncExternalStore: $2174e2766e27089d$var$ii,
    useId: $2174e2766e27089d$var$Fi,
    unstable_isNewReconciler: !1
};
function $2174e2766e27089d$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $2174e2766e27089d$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $2174e2766e27089d$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $2174e2766e27089d$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $2174e2766e27089d$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $2174e2766e27089d$var$Oi(a, b, c) {
    c = $2174e2766e27089d$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $2174e2766e27089d$var$Pi || ($2174e2766e27089d$var$Pi = !0, $2174e2766e27089d$var$Qi = d);
        $2174e2766e27089d$var$Mi(a, b);
    };
    return c;
}
function $2174e2766e27089d$var$Ri(a, b, c) {
    c = $2174e2766e27089d$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $2174e2766e27089d$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $2174e2766e27089d$var$Mi(a, b);
        "function" !== typeof d && (null === $2174e2766e27089d$var$Si ? $2174e2766e27089d$var$Si = new Set([
            this
        ]) : $2174e2766e27089d$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $2174e2766e27089d$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $2174e2766e27089d$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $2174e2766e27089d$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $2174e2766e27089d$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $2174e2766e27089d$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $2174e2766e27089d$var$ch(-1, 1), b.tag = 2, $2174e2766e27089d$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $2174e2766e27089d$var$Xi = $2174e2766e27089d$var$ua.ReactCurrentOwner, $2174e2766e27089d$var$Ug = !1;
function $2174e2766e27089d$var$Yi(a, b, c, d) {
    b.child = null === a ? $2174e2766e27089d$var$Ch(b, null, c, d) : $2174e2766e27089d$var$Bh(b, a.child, c, d);
}
function $2174e2766e27089d$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $2174e2766e27089d$var$Tg(b, e);
    d = $2174e2766e27089d$var$Xh(a, b, c, d, f, e);
    c = $2174e2766e27089d$var$bi();
    if (null !== a && !$2174e2766e27089d$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $2174e2766e27089d$var$$i(a, b, e);
    $2174e2766e27089d$var$I && c && $2174e2766e27089d$var$vg(b);
    b.flags |= 1;
    $2174e2766e27089d$var$Yi(a, b, d, e);
    return b.child;
}
function $2174e2766e27089d$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$2174e2766e27089d$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $2174e2766e27089d$var$cj(a, b, f, d, e);
        a = $2174e2766e27089d$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $2174e2766e27089d$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $2174e2766e27089d$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $2174e2766e27089d$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $2174e2766e27089d$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($2174e2766e27089d$var$Ie(f, d) && a.ref === b.ref) {
            if ($2174e2766e27089d$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($2174e2766e27089d$var$Ug = !0);
            else return b.lanes = a.lanes, $2174e2766e27089d$var$$i(a, b, e);
        }
    }
    return $2174e2766e27089d$var$dj(a, b, c, d, e);
}
function $2174e2766e27089d$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $2174e2766e27089d$var$G($2174e2766e27089d$var$fj, $2174e2766e27089d$var$gj), $2174e2766e27089d$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $2174e2766e27089d$var$G($2174e2766e27089d$var$fj, $2174e2766e27089d$var$gj), $2174e2766e27089d$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $2174e2766e27089d$var$G($2174e2766e27089d$var$fj, $2174e2766e27089d$var$gj);
            $2174e2766e27089d$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $2174e2766e27089d$var$G($2174e2766e27089d$var$fj, $2174e2766e27089d$var$gj), $2174e2766e27089d$var$gj |= d;
    $2174e2766e27089d$var$Yi(a, b, e, c);
    return b.child;
}
function $2174e2766e27089d$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $2174e2766e27089d$var$dj(a, b, c, d, e) {
    var f = $2174e2766e27089d$var$Zf(c) ? $2174e2766e27089d$var$Xf : $2174e2766e27089d$var$H.current;
    f = $2174e2766e27089d$var$Yf(b, f);
    $2174e2766e27089d$var$Tg(b, e);
    c = $2174e2766e27089d$var$Xh(a, b, c, d, f, e);
    d = $2174e2766e27089d$var$bi();
    if (null !== a && !$2174e2766e27089d$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $2174e2766e27089d$var$$i(a, b, e);
    $2174e2766e27089d$var$I && d && $2174e2766e27089d$var$vg(b);
    b.flags |= 1;
    $2174e2766e27089d$var$Yi(a, b, c, e);
    return b.child;
}
function $2174e2766e27089d$var$ij(a, b, c, d, e) {
    if ($2174e2766e27089d$var$Zf(c)) {
        var f = !0;
        $2174e2766e27089d$var$cg(b);
    } else f = !1;
    $2174e2766e27089d$var$Tg(b, e);
    if (null === b.stateNode) $2174e2766e27089d$var$jj(a, b), $2174e2766e27089d$var$ph(b, c, d), $2174e2766e27089d$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $2174e2766e27089d$var$Vg(l) : (l = $2174e2766e27089d$var$Zf(c) ? $2174e2766e27089d$var$Xf : $2174e2766e27089d$var$H.current, l = $2174e2766e27089d$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $2174e2766e27089d$var$qh(b, g, d, l);
        $2174e2766e27089d$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $2174e2766e27089d$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $2174e2766e27089d$var$Wf.current || $2174e2766e27089d$var$$g ? ("function" === typeof m && ($2174e2766e27089d$var$kh(b, c, m, d), k = b.memoizedState), (h = $2174e2766e27089d$var$$g || $2174e2766e27089d$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $2174e2766e27089d$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $2174e2766e27089d$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $2174e2766e27089d$var$Vg(k) : (k = $2174e2766e27089d$var$Zf(c) ? $2174e2766e27089d$var$Xf : $2174e2766e27089d$var$H.current, k = $2174e2766e27089d$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $2174e2766e27089d$var$qh(b, g, d, k);
        $2174e2766e27089d$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $2174e2766e27089d$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $2174e2766e27089d$var$Wf.current || $2174e2766e27089d$var$$g ? ("function" === typeof y && ($2174e2766e27089d$var$kh(b, c, y, d), n = b.memoizedState), (l = $2174e2766e27089d$var$$g || $2174e2766e27089d$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $2174e2766e27089d$var$kj(a, b, c, d, f, e);
}
function $2174e2766e27089d$var$kj(a, b, c, d, e, f) {
    $2174e2766e27089d$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $2174e2766e27089d$var$dg(b, c, !1), $2174e2766e27089d$var$$i(a, b, f);
    d = b.stateNode;
    $2174e2766e27089d$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $2174e2766e27089d$var$Bh(b, a.child, null, f), b.child = $2174e2766e27089d$var$Bh(b, null, h, f)) : $2174e2766e27089d$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $2174e2766e27089d$var$dg(b, c, !0);
    return b.child;
}
function $2174e2766e27089d$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $2174e2766e27089d$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $2174e2766e27089d$var$ag(a, b.context, !1);
    $2174e2766e27089d$var$Ih(a, b.containerInfo);
}
function $2174e2766e27089d$var$mj(a, b, c, d, e) {
    $2174e2766e27089d$var$Ig();
    $2174e2766e27089d$var$Jg(e);
    b.flags |= 256;
    $2174e2766e27089d$var$Yi(a, b, c, d);
    return b.child;
}
var $2174e2766e27089d$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $2174e2766e27089d$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $2174e2766e27089d$var$pj(a, b, c) {
    var d = b.pendingProps, e = $2174e2766e27089d$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $2174e2766e27089d$var$G($2174e2766e27089d$var$M, e & 1);
    if (null === a) {
        $2174e2766e27089d$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $2174e2766e27089d$var$qj(g, d, 0, null), a = $2174e2766e27089d$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $2174e2766e27089d$var$oj(c), b.memoizedState = $2174e2766e27089d$var$nj, a) : $2174e2766e27089d$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $2174e2766e27089d$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $2174e2766e27089d$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $2174e2766e27089d$var$wh(h, f) : (f = $2174e2766e27089d$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $2174e2766e27089d$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $2174e2766e27089d$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $2174e2766e27089d$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $2174e2766e27089d$var$rj(a, b) {
    b = $2174e2766e27089d$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $2174e2766e27089d$var$tj(a, b, c, d) {
    null !== d && $2174e2766e27089d$var$Jg(d);
    $2174e2766e27089d$var$Bh(b, a.child, null, c);
    a = $2174e2766e27089d$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $2174e2766e27089d$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $2174e2766e27089d$var$Li(Error($2174e2766e27089d$var$p(422))), $2174e2766e27089d$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $2174e2766e27089d$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $2174e2766e27089d$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $2174e2766e27089d$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $2174e2766e27089d$var$oj(g);
        b.memoizedState = $2174e2766e27089d$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $2174e2766e27089d$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($2174e2766e27089d$var$p(419));
        d = $2174e2766e27089d$var$Li(f, d, void 0);
        return $2174e2766e27089d$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($2174e2766e27089d$var$Ug || h) {
        d = $2174e2766e27089d$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $2174e2766e27089d$var$Zg(a, e), $2174e2766e27089d$var$mh(d, a, e, -1));
        }
        $2174e2766e27089d$var$uj();
        d = $2174e2766e27089d$var$Li(Error($2174e2766e27089d$var$p(421)));
        return $2174e2766e27089d$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $2174e2766e27089d$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $2174e2766e27089d$var$yg = $2174e2766e27089d$var$Lf(e.nextSibling);
    $2174e2766e27089d$var$xg = b;
    $2174e2766e27089d$var$I = !0;
    $2174e2766e27089d$var$zg = null;
    null !== a && ($2174e2766e27089d$var$og[$2174e2766e27089d$var$pg++] = $2174e2766e27089d$var$rg, $2174e2766e27089d$var$og[$2174e2766e27089d$var$pg++] = $2174e2766e27089d$var$sg, $2174e2766e27089d$var$og[$2174e2766e27089d$var$pg++] = $2174e2766e27089d$var$qg, $2174e2766e27089d$var$rg = a.id, $2174e2766e27089d$var$sg = a.overflow, $2174e2766e27089d$var$qg = b);
    b = $2174e2766e27089d$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $2174e2766e27089d$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $2174e2766e27089d$var$Sg(a.return, b, c);
}
function $2174e2766e27089d$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $2174e2766e27089d$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $2174e2766e27089d$var$Yi(a, b, d.children, c);
    d = $2174e2766e27089d$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $2174e2766e27089d$var$wj(a, c, b);
            else if (19 === a.tag) $2174e2766e27089d$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $2174e2766e27089d$var$G($2174e2766e27089d$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $2174e2766e27089d$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $2174e2766e27089d$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $2174e2766e27089d$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $2174e2766e27089d$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $2174e2766e27089d$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $2174e2766e27089d$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $2174e2766e27089d$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $2174e2766e27089d$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($2174e2766e27089d$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $2174e2766e27089d$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $2174e2766e27089d$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $2174e2766e27089d$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $2174e2766e27089d$var$lj(b);
            $2174e2766e27089d$var$Ig();
            break;
        case 5:
            $2174e2766e27089d$var$Kh(b);
            break;
        case 1:
            $2174e2766e27089d$var$Zf(b.type) && $2174e2766e27089d$var$cg(b);
            break;
        case 4:
            $2174e2766e27089d$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $2174e2766e27089d$var$G($2174e2766e27089d$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $2174e2766e27089d$var$G($2174e2766e27089d$var$M, $2174e2766e27089d$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $2174e2766e27089d$var$pj(a, b, c);
                $2174e2766e27089d$var$G($2174e2766e27089d$var$M, $2174e2766e27089d$var$M.current & 1);
                a = $2174e2766e27089d$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $2174e2766e27089d$var$G($2174e2766e27089d$var$M, $2174e2766e27089d$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $2174e2766e27089d$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $2174e2766e27089d$var$G($2174e2766e27089d$var$M, $2174e2766e27089d$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $2174e2766e27089d$var$ej(a, b, c);
    }
    return $2174e2766e27089d$var$$i(a, b, c);
}
var $2174e2766e27089d$var$Aj, $2174e2766e27089d$var$Bj, $2174e2766e27089d$var$Cj, $2174e2766e27089d$var$Dj;
$2174e2766e27089d$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$2174e2766e27089d$var$Bj = function() {};
$2174e2766e27089d$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $2174e2766e27089d$var$Hh($2174e2766e27089d$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $2174e2766e27089d$var$Ya(a, e);
                d = $2174e2766e27089d$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $2174e2766e27089d$var$A({}, e, {
                    value: void 0
                });
                d = $2174e2766e27089d$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $2174e2766e27089d$var$gb(a, e);
                d = $2174e2766e27089d$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $2174e2766e27089d$var$Bf);
        }
        $2174e2766e27089d$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($2174e2766e27089d$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($2174e2766e27089d$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $2174e2766e27089d$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$2174e2766e27089d$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $2174e2766e27089d$var$Ej(a, b) {
    if (!$2174e2766e27089d$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $2174e2766e27089d$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $2174e2766e27089d$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $2174e2766e27089d$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $2174e2766e27089d$var$S(b), null;
        case 1:
            return $2174e2766e27089d$var$Zf(b.type) && $2174e2766e27089d$var$$f(), $2174e2766e27089d$var$S(b), null;
        case 3:
            d = b.stateNode;
            $2174e2766e27089d$var$Jh();
            $2174e2766e27089d$var$E($2174e2766e27089d$var$Wf);
            $2174e2766e27089d$var$E($2174e2766e27089d$var$H);
            $2174e2766e27089d$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $2174e2766e27089d$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $2174e2766e27089d$var$zg && ($2174e2766e27089d$var$Gj($2174e2766e27089d$var$zg), $2174e2766e27089d$var$zg = null));
            $2174e2766e27089d$var$Bj(a, b);
            $2174e2766e27089d$var$S(b);
            return null;
        case 5:
            $2174e2766e27089d$var$Lh(b);
            var e = $2174e2766e27089d$var$Hh($2174e2766e27089d$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $2174e2766e27089d$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($2174e2766e27089d$var$p(166));
                    $2174e2766e27089d$var$S(b);
                    return null;
                }
                a = $2174e2766e27089d$var$Hh($2174e2766e27089d$var$Eh.current);
                if ($2174e2766e27089d$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$2174e2766e27089d$var$Of] = b;
                    d[$2174e2766e27089d$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $2174e2766e27089d$var$D("cancel", d);
                            $2174e2766e27089d$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $2174e2766e27089d$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $2174e2766e27089d$var$lf.length; e++)$2174e2766e27089d$var$D($2174e2766e27089d$var$lf[e], d);
                            break;
                        case "source":
                            $2174e2766e27089d$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $2174e2766e27089d$var$D("error", d);
                            $2174e2766e27089d$var$D("load", d);
                            break;
                        case "details":
                            $2174e2766e27089d$var$D("toggle", d);
                            break;
                        case "input":
                            $2174e2766e27089d$var$Za(d, f);
                            $2174e2766e27089d$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $2174e2766e27089d$var$D("invalid", d);
                            break;
                        case "textarea":
                            $2174e2766e27089d$var$hb(d, f), $2174e2766e27089d$var$D("invalid", d);
                    }
                    $2174e2766e27089d$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $2174e2766e27089d$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $2174e2766e27089d$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $2174e2766e27089d$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $2174e2766e27089d$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $2174e2766e27089d$var$Va(d);
                            $2174e2766e27089d$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $2174e2766e27089d$var$Va(d);
                            $2174e2766e27089d$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $2174e2766e27089d$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $2174e2766e27089d$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$2174e2766e27089d$var$Of] = b;
                    a[$2174e2766e27089d$var$Pf] = d;
                    $2174e2766e27089d$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $2174e2766e27089d$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $2174e2766e27089d$var$D("cancel", a);
                                $2174e2766e27089d$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $2174e2766e27089d$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $2174e2766e27089d$var$lf.length; e++)$2174e2766e27089d$var$D($2174e2766e27089d$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $2174e2766e27089d$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $2174e2766e27089d$var$D("error", a);
                                $2174e2766e27089d$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $2174e2766e27089d$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $2174e2766e27089d$var$Za(a, d);
                                e = $2174e2766e27089d$var$Ya(a, d);
                                $2174e2766e27089d$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $2174e2766e27089d$var$A({}, d, {
                                    value: void 0
                                });
                                $2174e2766e27089d$var$D("invalid", a);
                                break;
                            case "textarea":
                                $2174e2766e27089d$var$hb(a, d);
                                e = $2174e2766e27089d$var$gb(a, d);
                                $2174e2766e27089d$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $2174e2766e27089d$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $2174e2766e27089d$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $2174e2766e27089d$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $2174e2766e27089d$var$ob(a, k) : "number" === typeof k && $2174e2766e27089d$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($2174e2766e27089d$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $2174e2766e27089d$var$D("scroll", a) : null != k && $2174e2766e27089d$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $2174e2766e27089d$var$Va(a);
                                $2174e2766e27089d$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $2174e2766e27089d$var$Va(a);
                                $2174e2766e27089d$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $2174e2766e27089d$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $2174e2766e27089d$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $2174e2766e27089d$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $2174e2766e27089d$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $2174e2766e27089d$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $2174e2766e27089d$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($2174e2766e27089d$var$p(166));
                c = $2174e2766e27089d$var$Hh($2174e2766e27089d$var$Gh.current);
                $2174e2766e27089d$var$Hh($2174e2766e27089d$var$Eh.current);
                if ($2174e2766e27089d$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$2174e2766e27089d$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $2174e2766e27089d$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $2174e2766e27089d$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $2174e2766e27089d$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$2174e2766e27089d$var$Of] = b, b.stateNode = d;
            }
            $2174e2766e27089d$var$S(b);
            return null;
        case 13:
            $2174e2766e27089d$var$E($2174e2766e27089d$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($2174e2766e27089d$var$I && null !== $2174e2766e27089d$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $2174e2766e27089d$var$Hg(), $2174e2766e27089d$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $2174e2766e27089d$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($2174e2766e27089d$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($2174e2766e27089d$var$p(317));
                        f[$2174e2766e27089d$var$Of] = b;
                    } else $2174e2766e27089d$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $2174e2766e27089d$var$S(b);
                    f = !1;
                } else null !== $2174e2766e27089d$var$zg && ($2174e2766e27089d$var$Gj($2174e2766e27089d$var$zg), $2174e2766e27089d$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($2174e2766e27089d$var$M.current & 1) ? 0 === $2174e2766e27089d$var$T && ($2174e2766e27089d$var$T = 3) : $2174e2766e27089d$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $2174e2766e27089d$var$S(b);
            return null;
        case 4:
            return $2174e2766e27089d$var$Jh(), $2174e2766e27089d$var$Bj(a, b), null === a && $2174e2766e27089d$var$sf(b.stateNode.containerInfo), $2174e2766e27089d$var$S(b), null;
        case 10:
            return $2174e2766e27089d$var$Rg(b.type._context), $2174e2766e27089d$var$S(b), null;
        case 17:
            return $2174e2766e27089d$var$Zf(b.type) && $2174e2766e27089d$var$$f(), $2174e2766e27089d$var$S(b), null;
        case 19:
            $2174e2766e27089d$var$E($2174e2766e27089d$var$M);
            f = b.memoizedState;
            if (null === f) return $2174e2766e27089d$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $2174e2766e27089d$var$Ej(f, !1);
                else {
                    if (0 !== $2174e2766e27089d$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $2174e2766e27089d$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $2174e2766e27089d$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $2174e2766e27089d$var$G($2174e2766e27089d$var$M, $2174e2766e27089d$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $2174e2766e27089d$var$B() > $2174e2766e27089d$var$Hj && (b.flags |= 128, d = !0, $2174e2766e27089d$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $2174e2766e27089d$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $2174e2766e27089d$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$2174e2766e27089d$var$I) return $2174e2766e27089d$var$S(b), null;
                    } else 2 * $2174e2766e27089d$var$B() - f.renderingStartTime > $2174e2766e27089d$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $2174e2766e27089d$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $2174e2766e27089d$var$B(), b.sibling = null, c = $2174e2766e27089d$var$M.current, $2174e2766e27089d$var$G($2174e2766e27089d$var$M, d ? c & 1 | 2 : c & 1), b;
            $2174e2766e27089d$var$S(b);
            return null;
        case 22:
        case 23:
            return $2174e2766e27089d$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($2174e2766e27089d$var$gj & 1073741824) && ($2174e2766e27089d$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $2174e2766e27089d$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($2174e2766e27089d$var$p(156, b.tag));
}
function $2174e2766e27089d$var$Jj(a, b) {
    $2174e2766e27089d$var$wg(b);
    switch(b.tag){
        case 1:
            return $2174e2766e27089d$var$Zf(b.type) && $2174e2766e27089d$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $2174e2766e27089d$var$Jh(), $2174e2766e27089d$var$E($2174e2766e27089d$var$Wf), $2174e2766e27089d$var$E($2174e2766e27089d$var$H), $2174e2766e27089d$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $2174e2766e27089d$var$Lh(b), null;
        case 13:
            $2174e2766e27089d$var$E($2174e2766e27089d$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($2174e2766e27089d$var$p(340));
                $2174e2766e27089d$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $2174e2766e27089d$var$E($2174e2766e27089d$var$M), null;
        case 4:
            return $2174e2766e27089d$var$Jh(), null;
        case 10:
            return $2174e2766e27089d$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $2174e2766e27089d$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $2174e2766e27089d$var$Kj = !1, $2174e2766e27089d$var$U = !1, $2174e2766e27089d$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $2174e2766e27089d$var$V = null;
function $2174e2766e27089d$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $2174e2766e27089d$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $2174e2766e27089d$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $2174e2766e27089d$var$W(a, b, d);
    }
}
var $2174e2766e27089d$var$Oj = !1;
function $2174e2766e27089d$var$Pj(a, b) {
    $2174e2766e27089d$var$Cf = $2174e2766e27089d$var$dd;
    a = $2174e2766e27089d$var$Me();
    if ($2174e2766e27089d$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $2174e2766e27089d$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $2174e2766e27089d$var$dd = !1;
    for($2174e2766e27089d$var$V = b; null !== $2174e2766e27089d$var$V;)if (b = $2174e2766e27089d$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $2174e2766e27089d$var$V = a;
    else for(; null !== $2174e2766e27089d$var$V;){
        b = $2174e2766e27089d$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $2174e2766e27089d$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($2174e2766e27089d$var$p(163));
            }
        } catch (F) {
            $2174e2766e27089d$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $2174e2766e27089d$var$V = a;
            break;
        }
        $2174e2766e27089d$var$V = b.return;
    }
    n = $2174e2766e27089d$var$Oj;
    $2174e2766e27089d$var$Oj = !1;
    return n;
}
function $2174e2766e27089d$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $2174e2766e27089d$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $2174e2766e27089d$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $2174e2766e27089d$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $2174e2766e27089d$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $2174e2766e27089d$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$2174e2766e27089d$var$Of], delete b[$2174e2766e27089d$var$Pf], delete b[$2174e2766e27089d$var$of], delete b[$2174e2766e27089d$var$Qf], delete b[$2174e2766e27089d$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $2174e2766e27089d$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $2174e2766e27089d$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $2174e2766e27089d$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $2174e2766e27089d$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $2174e2766e27089d$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($2174e2766e27089d$var$Wj(a, b, c), a = a.sibling; null !== a;)$2174e2766e27089d$var$Wj(a, b, c), a = a.sibling;
}
function $2174e2766e27089d$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($2174e2766e27089d$var$Xj(a, b, c), a = a.sibling; null !== a;)$2174e2766e27089d$var$Xj(a, b, c), a = a.sibling;
}
var $2174e2766e27089d$var$X = null, $2174e2766e27089d$var$Yj = !1;
function $2174e2766e27089d$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$2174e2766e27089d$var$ak(a, b, c), c = c.sibling;
}
function $2174e2766e27089d$var$ak(a, b, c) {
    if ($2174e2766e27089d$var$lc && "function" === typeof $2174e2766e27089d$var$lc.onCommitFiberUnmount) try {
        $2174e2766e27089d$var$lc.onCommitFiberUnmount($2174e2766e27089d$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $2174e2766e27089d$var$U || $2174e2766e27089d$var$Mj(c, b);
        case 6:
            var d = $2174e2766e27089d$var$X, e = $2174e2766e27089d$var$Yj;
            $2174e2766e27089d$var$X = null;
            $2174e2766e27089d$var$Zj(a, b, c);
            $2174e2766e27089d$var$X = d;
            $2174e2766e27089d$var$Yj = e;
            null !== $2174e2766e27089d$var$X && ($2174e2766e27089d$var$Yj ? (a = $2174e2766e27089d$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $2174e2766e27089d$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $2174e2766e27089d$var$X && ($2174e2766e27089d$var$Yj ? (a = $2174e2766e27089d$var$X, c = c.stateNode, 8 === a.nodeType ? $2174e2766e27089d$var$Kf(a.parentNode, c) : 1 === a.nodeType && $2174e2766e27089d$var$Kf(a, c), $2174e2766e27089d$var$bd(a)) : $2174e2766e27089d$var$Kf($2174e2766e27089d$var$X, c.stateNode));
            break;
        case 4:
            d = $2174e2766e27089d$var$X;
            e = $2174e2766e27089d$var$Yj;
            $2174e2766e27089d$var$X = c.stateNode.containerInfo;
            $2174e2766e27089d$var$Yj = !0;
            $2174e2766e27089d$var$Zj(a, b, c);
            $2174e2766e27089d$var$X = d;
            $2174e2766e27089d$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$2174e2766e27089d$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $2174e2766e27089d$var$Nj(c, b, g) : 0 !== (f & 4) && $2174e2766e27089d$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $2174e2766e27089d$var$Zj(a, b, c);
            break;
        case 1:
            if (!$2174e2766e27089d$var$U && ($2174e2766e27089d$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $2174e2766e27089d$var$W(c, b, h);
            }
            $2174e2766e27089d$var$Zj(a, b, c);
            break;
        case 21:
            $2174e2766e27089d$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($2174e2766e27089d$var$U = (d = $2174e2766e27089d$var$U) || null !== c.memoizedState, $2174e2766e27089d$var$Zj(a, b, c), $2174e2766e27089d$var$U = d) : $2174e2766e27089d$var$Zj(a, b, c);
            break;
        default:
            $2174e2766e27089d$var$Zj(a, b, c);
    }
}
function $2174e2766e27089d$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $2174e2766e27089d$var$Lj);
        b.forEach(function(b) {
            var d = $2174e2766e27089d$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $2174e2766e27089d$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $2174e2766e27089d$var$X = h.stateNode;
                        $2174e2766e27089d$var$Yj = !1;
                        break a;
                    case 3:
                        $2174e2766e27089d$var$X = h.stateNode.containerInfo;
                        $2174e2766e27089d$var$Yj = !0;
                        break a;
                    case 4:
                        $2174e2766e27089d$var$X = h.stateNode.containerInfo;
                        $2174e2766e27089d$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $2174e2766e27089d$var$X) throw Error($2174e2766e27089d$var$p(160));
            $2174e2766e27089d$var$ak(f, g, e);
            $2174e2766e27089d$var$X = null;
            $2174e2766e27089d$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $2174e2766e27089d$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$2174e2766e27089d$var$ek(b, a), b = b.sibling;
}
function $2174e2766e27089d$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $2174e2766e27089d$var$dk(b, a);
            $2174e2766e27089d$var$fk(a);
            if (d & 4) {
                try {
                    $2174e2766e27089d$var$Qj(3, a, a.return), $2174e2766e27089d$var$Rj(3, a);
                } catch (t) {
                    $2174e2766e27089d$var$W(a, a.return, t);
                }
                try {
                    $2174e2766e27089d$var$Qj(5, a, a.return);
                } catch (t) {
                    $2174e2766e27089d$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $2174e2766e27089d$var$dk(b, a);
            $2174e2766e27089d$var$fk(a);
            d & 512 && null !== c && $2174e2766e27089d$var$Mj(c, c.return);
            break;
        case 5:
            $2174e2766e27089d$var$dk(b, a);
            $2174e2766e27089d$var$fk(a);
            d & 512 && null !== c && $2174e2766e27089d$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $2174e2766e27089d$var$ob(e, "");
                } catch (t) {
                    $2174e2766e27089d$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $2174e2766e27089d$var$ab(e, f);
                    $2174e2766e27089d$var$vb(h, g);
                    var l = $2174e2766e27089d$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $2174e2766e27089d$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $2174e2766e27089d$var$nb(e, q) : "children" === m ? $2174e2766e27089d$var$ob(e, q) : $2174e2766e27089d$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $2174e2766e27089d$var$bb(e, f);
                            break;
                        case "textarea":
                            $2174e2766e27089d$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $2174e2766e27089d$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $2174e2766e27089d$var$fb(e, !!f.multiple, f.defaultValue, !0) : $2174e2766e27089d$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$2174e2766e27089d$var$Pf] = f;
                } catch (t) {
                    $2174e2766e27089d$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $2174e2766e27089d$var$dk(b, a);
            $2174e2766e27089d$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($2174e2766e27089d$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $2174e2766e27089d$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $2174e2766e27089d$var$dk(b, a);
            $2174e2766e27089d$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $2174e2766e27089d$var$bd(b.containerInfo);
            } catch (t) {
                $2174e2766e27089d$var$W(a, a.return, t);
            }
            break;
        case 4:
            $2174e2766e27089d$var$dk(b, a);
            $2174e2766e27089d$var$fk(a);
            break;
        case 13:
            $2174e2766e27089d$var$dk(b, a);
            $2174e2766e27089d$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($2174e2766e27089d$var$gk = $2174e2766e27089d$var$B()));
            d & 4 && $2174e2766e27089d$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($2174e2766e27089d$var$U = (l = $2174e2766e27089d$var$U) || m, $2174e2766e27089d$var$dk(b, a), $2174e2766e27089d$var$U = l) : $2174e2766e27089d$var$dk(b, a);
            $2174e2766e27089d$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($2174e2766e27089d$var$V = a, m = a.child; null !== m;){
                    for(q = $2174e2766e27089d$var$V = m; null !== $2174e2766e27089d$var$V;){
                        r = $2174e2766e27089d$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $2174e2766e27089d$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $2174e2766e27089d$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $2174e2766e27089d$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $2174e2766e27089d$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $2174e2766e27089d$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $2174e2766e27089d$var$V = y) : $2174e2766e27089d$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $2174e2766e27089d$var$rb("display", g));
                            } catch (t) {
                                $2174e2766e27089d$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $2174e2766e27089d$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $2174e2766e27089d$var$dk(b, a);
            $2174e2766e27089d$var$fk(a);
            d & 4 && $2174e2766e27089d$var$bk(a);
            break;
        case 21:
            break;
        default:
            $2174e2766e27089d$var$dk(b, a), $2174e2766e27089d$var$fk(a);
    }
}
function $2174e2766e27089d$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($2174e2766e27089d$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($2174e2766e27089d$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($2174e2766e27089d$var$ob(e, ""), d.flags &= -33);
                    var f = $2174e2766e27089d$var$Vj(a);
                    $2174e2766e27089d$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $2174e2766e27089d$var$Vj(a);
                    $2174e2766e27089d$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($2174e2766e27089d$var$p(161));
            }
        } catch (k) {
            $2174e2766e27089d$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $2174e2766e27089d$var$ik(a, b, c) {
    $2174e2766e27089d$var$V = a;
    $2174e2766e27089d$var$jk(a, b, c);
}
function $2174e2766e27089d$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $2174e2766e27089d$var$V;){
        var e = $2174e2766e27089d$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $2174e2766e27089d$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $2174e2766e27089d$var$U;
                h = $2174e2766e27089d$var$Kj;
                var l = $2174e2766e27089d$var$U;
                $2174e2766e27089d$var$Kj = g;
                if (($2174e2766e27089d$var$U = k) && !l) for($2174e2766e27089d$var$V = e; null !== $2174e2766e27089d$var$V;)g = $2174e2766e27089d$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $2174e2766e27089d$var$kk(e) : null !== k ? (k.return = g, $2174e2766e27089d$var$V = k) : $2174e2766e27089d$var$kk(e);
                for(; null !== f;)$2174e2766e27089d$var$V = f, $2174e2766e27089d$var$jk(f, b, c), f = f.sibling;
                $2174e2766e27089d$var$V = e;
                $2174e2766e27089d$var$Kj = h;
                $2174e2766e27089d$var$U = l;
            }
            $2174e2766e27089d$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $2174e2766e27089d$var$V = f) : $2174e2766e27089d$var$lk(a, b, c);
    }
}
function $2174e2766e27089d$var$lk(a) {
    for(; null !== $2174e2766e27089d$var$V;){
        var b = $2174e2766e27089d$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $2174e2766e27089d$var$U || $2174e2766e27089d$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$2174e2766e27089d$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $2174e2766e27089d$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $2174e2766e27089d$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $2174e2766e27089d$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $2174e2766e27089d$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($2174e2766e27089d$var$p(163));
                }
                $2174e2766e27089d$var$U || b.flags & 512 && $2174e2766e27089d$var$Sj(b);
            } catch (r) {
                $2174e2766e27089d$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $2174e2766e27089d$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $2174e2766e27089d$var$V = c;
            break;
        }
        $2174e2766e27089d$var$V = b.return;
    }
}
function $2174e2766e27089d$var$hk(a) {
    for(; null !== $2174e2766e27089d$var$V;){
        var b = $2174e2766e27089d$var$V;
        if (b === a) {
            $2174e2766e27089d$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $2174e2766e27089d$var$V = c;
            break;
        }
        $2174e2766e27089d$var$V = b.return;
    }
}
function $2174e2766e27089d$var$kk(a) {
    for(; null !== $2174e2766e27089d$var$V;){
        var b = $2174e2766e27089d$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $2174e2766e27089d$var$Rj(4, b);
                    } catch (k) {
                        $2174e2766e27089d$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $2174e2766e27089d$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $2174e2766e27089d$var$Sj(b);
                    } catch (k) {
                        $2174e2766e27089d$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $2174e2766e27089d$var$Sj(b);
                    } catch (k) {
                        $2174e2766e27089d$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $2174e2766e27089d$var$W(b, b.return, k);
        }
        if (b === a) {
            $2174e2766e27089d$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $2174e2766e27089d$var$V = h;
            break;
        }
        $2174e2766e27089d$var$V = b.return;
    }
}
var $2174e2766e27089d$var$mk = Math.ceil, $2174e2766e27089d$var$nk = $2174e2766e27089d$var$ua.ReactCurrentDispatcher, $2174e2766e27089d$var$ok = $2174e2766e27089d$var$ua.ReactCurrentOwner, $2174e2766e27089d$var$pk = $2174e2766e27089d$var$ua.ReactCurrentBatchConfig, $2174e2766e27089d$var$K = 0, $2174e2766e27089d$var$R = null, $2174e2766e27089d$var$Y = null, $2174e2766e27089d$var$Z = 0, $2174e2766e27089d$var$gj = 0, $2174e2766e27089d$var$fj = $2174e2766e27089d$var$Uf(0), $2174e2766e27089d$var$T = 0, $2174e2766e27089d$var$qk = null, $2174e2766e27089d$var$hh = 0, $2174e2766e27089d$var$rk = 0, $2174e2766e27089d$var$sk = 0, $2174e2766e27089d$var$tk = null, $2174e2766e27089d$var$uk = null, $2174e2766e27089d$var$gk = 0, $2174e2766e27089d$var$Hj = Infinity, $2174e2766e27089d$var$vk = null, $2174e2766e27089d$var$Pi = !1, $2174e2766e27089d$var$Qi = null, $2174e2766e27089d$var$Si = null, $2174e2766e27089d$var$wk = !1, $2174e2766e27089d$var$xk = null, $2174e2766e27089d$var$yk = 0, $2174e2766e27089d$var$zk = 0, $2174e2766e27089d$var$Ak = null, $2174e2766e27089d$var$Bk = -1, $2174e2766e27089d$var$Ck = 0;
function $2174e2766e27089d$var$L() {
    return 0 !== ($2174e2766e27089d$var$K & 6) ? $2174e2766e27089d$var$B() : -1 !== $2174e2766e27089d$var$Bk ? $2174e2766e27089d$var$Bk : $2174e2766e27089d$var$Bk = $2174e2766e27089d$var$B();
}
function $2174e2766e27089d$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($2174e2766e27089d$var$K & 2) && 0 !== $2174e2766e27089d$var$Z) return $2174e2766e27089d$var$Z & -$2174e2766e27089d$var$Z;
    if (null !== $2174e2766e27089d$var$Kg.transition) return 0 === $2174e2766e27089d$var$Ck && ($2174e2766e27089d$var$Ck = $2174e2766e27089d$var$yc()), $2174e2766e27089d$var$Ck;
    a = $2174e2766e27089d$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $2174e2766e27089d$var$jd(a.type);
    return a;
}
function $2174e2766e27089d$var$mh(a, b, c, d) {
    if (50 < $2174e2766e27089d$var$zk) throw $2174e2766e27089d$var$zk = 0, $2174e2766e27089d$var$Ak = null, Error($2174e2766e27089d$var$p(185));
    $2174e2766e27089d$var$Ac(a, c, d);
    if (0 === ($2174e2766e27089d$var$K & 2) || a !== $2174e2766e27089d$var$R) a === $2174e2766e27089d$var$R && (0 === ($2174e2766e27089d$var$K & 2) && ($2174e2766e27089d$var$rk |= c), 4 === $2174e2766e27089d$var$T && $2174e2766e27089d$var$Dk(a, $2174e2766e27089d$var$Z)), $2174e2766e27089d$var$Ek(a, d), 1 === c && 0 === $2174e2766e27089d$var$K && 0 === (b.mode & 1) && ($2174e2766e27089d$var$Hj = $2174e2766e27089d$var$B() + 500, $2174e2766e27089d$var$fg && $2174e2766e27089d$var$jg());
}
function $2174e2766e27089d$var$Ek(a, b) {
    var c = a.callbackNode;
    $2174e2766e27089d$var$wc(a, b);
    var d = $2174e2766e27089d$var$uc(a, a === $2174e2766e27089d$var$R ? $2174e2766e27089d$var$Z : 0);
    if (0 === d) null !== c && $2174e2766e27089d$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $2174e2766e27089d$var$bc(c);
        if (1 === b) 0 === a.tag ? $2174e2766e27089d$var$ig($2174e2766e27089d$var$Fk.bind(null, a)) : $2174e2766e27089d$var$hg($2174e2766e27089d$var$Fk.bind(null, a)), $2174e2766e27089d$var$Jf(function() {
            0 === ($2174e2766e27089d$var$K & 6) && $2174e2766e27089d$var$jg();
        }), c = null;
        else {
            switch($2174e2766e27089d$var$Dc(d)){
                case 1:
                    c = $2174e2766e27089d$var$fc;
                    break;
                case 4:
                    c = $2174e2766e27089d$var$gc;
                    break;
                case 16:
                    c = $2174e2766e27089d$var$hc;
                    break;
                case 536870912:
                    c = $2174e2766e27089d$var$jc;
                    break;
                default:
                    c = $2174e2766e27089d$var$hc;
            }
            c = $2174e2766e27089d$var$Gk(c, $2174e2766e27089d$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $2174e2766e27089d$var$Hk(a, b) {
    $2174e2766e27089d$var$Bk = -1;
    $2174e2766e27089d$var$Ck = 0;
    if (0 !== ($2174e2766e27089d$var$K & 6)) throw Error($2174e2766e27089d$var$p(327));
    var c = a.callbackNode;
    if ($2174e2766e27089d$var$Ik() && a.callbackNode !== c) return null;
    var d = $2174e2766e27089d$var$uc(a, a === $2174e2766e27089d$var$R ? $2174e2766e27089d$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $2174e2766e27089d$var$Jk(a, d);
    else {
        b = d;
        var e = $2174e2766e27089d$var$K;
        $2174e2766e27089d$var$K |= 2;
        var f = $2174e2766e27089d$var$Kk();
        if ($2174e2766e27089d$var$R !== a || $2174e2766e27089d$var$Z !== b) $2174e2766e27089d$var$vk = null, $2174e2766e27089d$var$Hj = $2174e2766e27089d$var$B() + 500, $2174e2766e27089d$var$Lk(a, b);
        for(;;)try {
            $2174e2766e27089d$var$Mk();
            break;
        } catch (h) {
            $2174e2766e27089d$var$Nk(a, h);
        }
        $2174e2766e27089d$var$Qg();
        $2174e2766e27089d$var$nk.current = f;
        $2174e2766e27089d$var$K = e;
        null !== $2174e2766e27089d$var$Y ? b = 0 : ($2174e2766e27089d$var$R = null, $2174e2766e27089d$var$Z = 0, b = $2174e2766e27089d$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $2174e2766e27089d$var$xc(a), 0 !== e && (d = e, b = $2174e2766e27089d$var$Ok(a, e)));
        if (1 === b) throw c = $2174e2766e27089d$var$qk, $2174e2766e27089d$var$Lk(a, 0), $2174e2766e27089d$var$Dk(a, d), $2174e2766e27089d$var$Ek(a, $2174e2766e27089d$var$B()), c;
        if (6 === b) $2174e2766e27089d$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$2174e2766e27089d$var$Pk(e) && (b = $2174e2766e27089d$var$Jk(a, d), 2 === b && (f = $2174e2766e27089d$var$xc(a), 0 !== f && (d = f, b = $2174e2766e27089d$var$Ok(a, f))), 1 === b)) throw c = $2174e2766e27089d$var$qk, $2174e2766e27089d$var$Lk(a, 0), $2174e2766e27089d$var$Dk(a, d), $2174e2766e27089d$var$Ek(a, $2174e2766e27089d$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($2174e2766e27089d$var$p(345));
                case 2:
                    $2174e2766e27089d$var$Qk(a, $2174e2766e27089d$var$uk, $2174e2766e27089d$var$vk);
                    break;
                case 3:
                    $2174e2766e27089d$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $2174e2766e27089d$var$gk + 500 - $2174e2766e27089d$var$B(), 10 < b)) {
                        if (0 !== $2174e2766e27089d$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $2174e2766e27089d$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $2174e2766e27089d$var$Ff($2174e2766e27089d$var$Qk.bind(null, a, $2174e2766e27089d$var$uk, $2174e2766e27089d$var$vk), b);
                        break;
                    }
                    $2174e2766e27089d$var$Qk(a, $2174e2766e27089d$var$uk, $2174e2766e27089d$var$vk);
                    break;
                case 4:
                    $2174e2766e27089d$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $2174e2766e27089d$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $2174e2766e27089d$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $2174e2766e27089d$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $2174e2766e27089d$var$Ff($2174e2766e27089d$var$Qk.bind(null, a, $2174e2766e27089d$var$uk, $2174e2766e27089d$var$vk), d);
                        break;
                    }
                    $2174e2766e27089d$var$Qk(a, $2174e2766e27089d$var$uk, $2174e2766e27089d$var$vk);
                    break;
                case 5:
                    $2174e2766e27089d$var$Qk(a, $2174e2766e27089d$var$uk, $2174e2766e27089d$var$vk);
                    break;
                default:
                    throw Error($2174e2766e27089d$var$p(329));
            }
        }
    }
    $2174e2766e27089d$var$Ek(a, $2174e2766e27089d$var$B());
    return a.callbackNode === c ? $2174e2766e27089d$var$Hk.bind(null, a) : null;
}
function $2174e2766e27089d$var$Ok(a, b) {
    var c = $2174e2766e27089d$var$tk;
    a.current.memoizedState.isDehydrated && ($2174e2766e27089d$var$Lk(a, b).flags |= 256);
    a = $2174e2766e27089d$var$Jk(a, b);
    2 !== a && (b = $2174e2766e27089d$var$uk, $2174e2766e27089d$var$uk = c, null !== b && $2174e2766e27089d$var$Gj(b));
    return a;
}
function $2174e2766e27089d$var$Gj(a) {
    null === $2174e2766e27089d$var$uk ? $2174e2766e27089d$var$uk = a : $2174e2766e27089d$var$uk.push.apply($2174e2766e27089d$var$uk, a);
}
function $2174e2766e27089d$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$2174e2766e27089d$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $2174e2766e27089d$var$Dk(a, b) {
    b &= ~$2174e2766e27089d$var$sk;
    b &= ~$2174e2766e27089d$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $2174e2766e27089d$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $2174e2766e27089d$var$Fk(a) {
    if (0 !== ($2174e2766e27089d$var$K & 6)) throw Error($2174e2766e27089d$var$p(327));
    $2174e2766e27089d$var$Ik();
    var b = $2174e2766e27089d$var$uc(a, 0);
    if (0 === (b & 1)) return $2174e2766e27089d$var$Ek(a, $2174e2766e27089d$var$B()), null;
    var c = $2174e2766e27089d$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $2174e2766e27089d$var$xc(a);
        0 !== d && (b = d, c = $2174e2766e27089d$var$Ok(a, d));
    }
    if (1 === c) throw c = $2174e2766e27089d$var$qk, $2174e2766e27089d$var$Lk(a, 0), $2174e2766e27089d$var$Dk(a, b), $2174e2766e27089d$var$Ek(a, $2174e2766e27089d$var$B()), c;
    if (6 === c) throw Error($2174e2766e27089d$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $2174e2766e27089d$var$Qk(a, $2174e2766e27089d$var$uk, $2174e2766e27089d$var$vk);
    $2174e2766e27089d$var$Ek(a, $2174e2766e27089d$var$B());
    return null;
}
function $2174e2766e27089d$var$Rk(a, b) {
    var c = $2174e2766e27089d$var$K;
    $2174e2766e27089d$var$K |= 1;
    try {
        return a(b);
    } finally{
        $2174e2766e27089d$var$K = c, 0 === $2174e2766e27089d$var$K && ($2174e2766e27089d$var$Hj = $2174e2766e27089d$var$B() + 500, $2174e2766e27089d$var$fg && $2174e2766e27089d$var$jg());
    }
}
function $2174e2766e27089d$var$Sk(a) {
    null !== $2174e2766e27089d$var$xk && 0 === $2174e2766e27089d$var$xk.tag && 0 === ($2174e2766e27089d$var$K & 6) && $2174e2766e27089d$var$Ik();
    var b = $2174e2766e27089d$var$K;
    $2174e2766e27089d$var$K |= 1;
    var c = $2174e2766e27089d$var$pk.transition, d = $2174e2766e27089d$var$C;
    try {
        if ($2174e2766e27089d$var$pk.transition = null, $2174e2766e27089d$var$C = 1, a) return a();
    } finally{
        $2174e2766e27089d$var$C = d, $2174e2766e27089d$var$pk.transition = c, $2174e2766e27089d$var$K = b, 0 === ($2174e2766e27089d$var$K & 6) && $2174e2766e27089d$var$jg();
    }
}
function $2174e2766e27089d$var$Ij() {
    $2174e2766e27089d$var$gj = $2174e2766e27089d$var$fj.current;
    $2174e2766e27089d$var$E($2174e2766e27089d$var$fj);
}
function $2174e2766e27089d$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $2174e2766e27089d$var$Gf(c));
    if (null !== $2174e2766e27089d$var$Y) for(c = $2174e2766e27089d$var$Y.return; null !== c;){
        var d = c;
        $2174e2766e27089d$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $2174e2766e27089d$var$$f();
                break;
            case 3:
                $2174e2766e27089d$var$Jh();
                $2174e2766e27089d$var$E($2174e2766e27089d$var$Wf);
                $2174e2766e27089d$var$E($2174e2766e27089d$var$H);
                $2174e2766e27089d$var$Oh();
                break;
            case 5:
                $2174e2766e27089d$var$Lh(d);
                break;
            case 4:
                $2174e2766e27089d$var$Jh();
                break;
            case 13:
                $2174e2766e27089d$var$E($2174e2766e27089d$var$M);
                break;
            case 19:
                $2174e2766e27089d$var$E($2174e2766e27089d$var$M);
                break;
            case 10:
                $2174e2766e27089d$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $2174e2766e27089d$var$Ij();
        }
        c = c.return;
    }
    $2174e2766e27089d$var$R = a;
    $2174e2766e27089d$var$Y = a = $2174e2766e27089d$var$wh(a.current, null);
    $2174e2766e27089d$var$Z = $2174e2766e27089d$var$gj = b;
    $2174e2766e27089d$var$T = 0;
    $2174e2766e27089d$var$qk = null;
    $2174e2766e27089d$var$sk = $2174e2766e27089d$var$rk = $2174e2766e27089d$var$hh = 0;
    $2174e2766e27089d$var$uk = $2174e2766e27089d$var$tk = null;
    if (null !== $2174e2766e27089d$var$Wg) {
        for(b = 0; b < $2174e2766e27089d$var$Wg.length; b++)if (c = $2174e2766e27089d$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $2174e2766e27089d$var$Wg = null;
    }
    return a;
}
function $2174e2766e27089d$var$Nk(a, b) {
    do {
        var c = $2174e2766e27089d$var$Y;
        try {
            $2174e2766e27089d$var$Qg();
            $2174e2766e27089d$var$Ph.current = $2174e2766e27089d$var$ai;
            if ($2174e2766e27089d$var$Sh) {
                for(var d = $2174e2766e27089d$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $2174e2766e27089d$var$Sh = !1;
            }
            $2174e2766e27089d$var$Rh = 0;
            $2174e2766e27089d$var$P = $2174e2766e27089d$var$O = $2174e2766e27089d$var$N = null;
            $2174e2766e27089d$var$Th = !1;
            $2174e2766e27089d$var$Uh = 0;
            $2174e2766e27089d$var$ok.current = null;
            if (null === c || null === c.return) {
                $2174e2766e27089d$var$T = 1;
                $2174e2766e27089d$var$qk = b;
                $2174e2766e27089d$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $2174e2766e27089d$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $2174e2766e27089d$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $2174e2766e27089d$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $2174e2766e27089d$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $2174e2766e27089d$var$Ti(f, l, b);
                            $2174e2766e27089d$var$uj();
                            break a;
                        }
                        k = Error($2174e2766e27089d$var$p(426));
                    }
                } else if ($2174e2766e27089d$var$I && h.mode & 1) {
                    var J = $2174e2766e27089d$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $2174e2766e27089d$var$Wi(J, g, h, f, b);
                        $2174e2766e27089d$var$Jg($2174e2766e27089d$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $2174e2766e27089d$var$Ki(k, h);
                4 !== $2174e2766e27089d$var$T && ($2174e2766e27089d$var$T = 2);
                null === $2174e2766e27089d$var$tk ? $2174e2766e27089d$var$tk = [
                    f
                ] : $2174e2766e27089d$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $2174e2766e27089d$var$Oi(f, k, b);
                            $2174e2766e27089d$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $2174e2766e27089d$var$Si || !$2174e2766e27089d$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $2174e2766e27089d$var$Ri(f, h, b);
                                $2174e2766e27089d$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $2174e2766e27089d$var$Tk(c);
        } catch (na) {
            b = na;
            $2174e2766e27089d$var$Y === c && null !== c && ($2174e2766e27089d$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $2174e2766e27089d$var$Kk() {
    var a = $2174e2766e27089d$var$nk.current;
    $2174e2766e27089d$var$nk.current = $2174e2766e27089d$var$ai;
    return null === a ? $2174e2766e27089d$var$ai : a;
}
function $2174e2766e27089d$var$uj() {
    if (0 === $2174e2766e27089d$var$T || 3 === $2174e2766e27089d$var$T || 2 === $2174e2766e27089d$var$T) $2174e2766e27089d$var$T = 4;
    null === $2174e2766e27089d$var$R || 0 === ($2174e2766e27089d$var$hh & 268435455) && 0 === ($2174e2766e27089d$var$rk & 268435455) || $2174e2766e27089d$var$Dk($2174e2766e27089d$var$R, $2174e2766e27089d$var$Z);
}
function $2174e2766e27089d$var$Jk(a, b) {
    var c = $2174e2766e27089d$var$K;
    $2174e2766e27089d$var$K |= 2;
    var d = $2174e2766e27089d$var$Kk();
    if ($2174e2766e27089d$var$R !== a || $2174e2766e27089d$var$Z !== b) $2174e2766e27089d$var$vk = null, $2174e2766e27089d$var$Lk(a, b);
    for(;;)try {
        $2174e2766e27089d$var$Uk();
        break;
    } catch (e) {
        $2174e2766e27089d$var$Nk(a, e);
    }
    $2174e2766e27089d$var$Qg();
    $2174e2766e27089d$var$K = c;
    $2174e2766e27089d$var$nk.current = d;
    if (null !== $2174e2766e27089d$var$Y) throw Error($2174e2766e27089d$var$p(261));
    $2174e2766e27089d$var$R = null;
    $2174e2766e27089d$var$Z = 0;
    return $2174e2766e27089d$var$T;
}
function $2174e2766e27089d$var$Uk() {
    for(; null !== $2174e2766e27089d$var$Y;)$2174e2766e27089d$var$Vk($2174e2766e27089d$var$Y);
}
function $2174e2766e27089d$var$Mk() {
    for(; null !== $2174e2766e27089d$var$Y && !$2174e2766e27089d$var$cc();)$2174e2766e27089d$var$Vk($2174e2766e27089d$var$Y);
}
function $2174e2766e27089d$var$Vk(a) {
    var b = $2174e2766e27089d$var$Wk(a.alternate, a, $2174e2766e27089d$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $2174e2766e27089d$var$Tk(a) : $2174e2766e27089d$var$Y = b;
    $2174e2766e27089d$var$ok.current = null;
}
function $2174e2766e27089d$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $2174e2766e27089d$var$Fj(c, b, $2174e2766e27089d$var$gj), null !== c) {
                $2174e2766e27089d$var$Y = c;
                return;
            }
        } else {
            c = $2174e2766e27089d$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $2174e2766e27089d$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $2174e2766e27089d$var$T = 6;
                $2174e2766e27089d$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $2174e2766e27089d$var$Y = b;
            return;
        }
        $2174e2766e27089d$var$Y = b = a;
    }while (null !== b);
    0 === $2174e2766e27089d$var$T && ($2174e2766e27089d$var$T = 5);
}
function $2174e2766e27089d$var$Qk(a, b, c) {
    var d = $2174e2766e27089d$var$C, e = $2174e2766e27089d$var$pk.transition;
    try {
        $2174e2766e27089d$var$pk.transition = null, $2174e2766e27089d$var$C = 1, $2174e2766e27089d$var$Xk(a, b, c, d);
    } finally{
        $2174e2766e27089d$var$pk.transition = e, $2174e2766e27089d$var$C = d;
    }
    return null;
}
function $2174e2766e27089d$var$Xk(a, b, c, d) {
    do $2174e2766e27089d$var$Ik();
    while (null !== $2174e2766e27089d$var$xk);
    if (0 !== ($2174e2766e27089d$var$K & 6)) throw Error($2174e2766e27089d$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($2174e2766e27089d$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $2174e2766e27089d$var$Bc(a, f);
    a === $2174e2766e27089d$var$R && ($2174e2766e27089d$var$Y = $2174e2766e27089d$var$R = null, $2174e2766e27089d$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $2174e2766e27089d$var$wk || ($2174e2766e27089d$var$wk = !0, $2174e2766e27089d$var$Gk($2174e2766e27089d$var$hc, function() {
        $2174e2766e27089d$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $2174e2766e27089d$var$pk.transition;
        $2174e2766e27089d$var$pk.transition = null;
        var g = $2174e2766e27089d$var$C;
        $2174e2766e27089d$var$C = 1;
        var h = $2174e2766e27089d$var$K;
        $2174e2766e27089d$var$K |= 4;
        $2174e2766e27089d$var$ok.current = null;
        $2174e2766e27089d$var$Pj(a, c);
        $2174e2766e27089d$var$ek(c, a);
        $2174e2766e27089d$var$Oe($2174e2766e27089d$var$Df);
        $2174e2766e27089d$var$dd = !!$2174e2766e27089d$var$Cf;
        $2174e2766e27089d$var$Df = $2174e2766e27089d$var$Cf = null;
        a.current = c;
        $2174e2766e27089d$var$ik(c, a, e);
        $2174e2766e27089d$var$dc();
        $2174e2766e27089d$var$K = h;
        $2174e2766e27089d$var$C = g;
        $2174e2766e27089d$var$pk.transition = f;
    } else a.current = c;
    $2174e2766e27089d$var$wk && ($2174e2766e27089d$var$wk = !1, $2174e2766e27089d$var$xk = a, $2174e2766e27089d$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($2174e2766e27089d$var$Si = null);
    $2174e2766e27089d$var$mc(c.stateNode, d);
    $2174e2766e27089d$var$Ek(a, $2174e2766e27089d$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($2174e2766e27089d$var$Pi) throw $2174e2766e27089d$var$Pi = !1, a = $2174e2766e27089d$var$Qi, $2174e2766e27089d$var$Qi = null, a;
    0 !== ($2174e2766e27089d$var$yk & 1) && 0 !== a.tag && $2174e2766e27089d$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $2174e2766e27089d$var$Ak ? $2174e2766e27089d$var$zk++ : ($2174e2766e27089d$var$zk = 0, $2174e2766e27089d$var$Ak = a) : $2174e2766e27089d$var$zk = 0;
    $2174e2766e27089d$var$jg();
    return null;
}
function $2174e2766e27089d$var$Ik() {
    if (null !== $2174e2766e27089d$var$xk) {
        var a = $2174e2766e27089d$var$Dc($2174e2766e27089d$var$yk), b = $2174e2766e27089d$var$pk.transition, c = $2174e2766e27089d$var$C;
        try {
            $2174e2766e27089d$var$pk.transition = null;
            $2174e2766e27089d$var$C = 16 > a ? 16 : a;
            if (null === $2174e2766e27089d$var$xk) var d = !1;
            else {
                a = $2174e2766e27089d$var$xk;
                $2174e2766e27089d$var$xk = null;
                $2174e2766e27089d$var$yk = 0;
                if (0 !== ($2174e2766e27089d$var$K & 6)) throw Error($2174e2766e27089d$var$p(331));
                var e = $2174e2766e27089d$var$K;
                $2174e2766e27089d$var$K |= 4;
                for($2174e2766e27089d$var$V = a.current; null !== $2174e2766e27089d$var$V;){
                    var f = $2174e2766e27089d$var$V, g = f.child;
                    if (0 !== ($2174e2766e27089d$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($2174e2766e27089d$var$V = l; null !== $2174e2766e27089d$var$V;){
                                    var m = $2174e2766e27089d$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $2174e2766e27089d$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $2174e2766e27089d$var$V = q;
                                    else for(; null !== $2174e2766e27089d$var$V;){
                                        m = $2174e2766e27089d$var$V;
                                        var r = m.sibling, y = m.return;
                                        $2174e2766e27089d$var$Tj(m);
                                        if (m === l) {
                                            $2174e2766e27089d$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $2174e2766e27089d$var$V = r;
                                            break;
                                        }
                                        $2174e2766e27089d$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $2174e2766e27089d$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $2174e2766e27089d$var$V = g;
                    else b: for(; null !== $2174e2766e27089d$var$V;){
                        f = $2174e2766e27089d$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $2174e2766e27089d$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $2174e2766e27089d$var$V = x;
                            break b;
                        }
                        $2174e2766e27089d$var$V = f.return;
                    }
                }
                var w = a.current;
                for($2174e2766e27089d$var$V = w; null !== $2174e2766e27089d$var$V;){
                    g = $2174e2766e27089d$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $2174e2766e27089d$var$V = u;
                    else b: for(g = w; null !== $2174e2766e27089d$var$V;){
                        h = $2174e2766e27089d$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $2174e2766e27089d$var$Rj(9, h);
                            }
                        } catch (na) {
                            $2174e2766e27089d$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $2174e2766e27089d$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $2174e2766e27089d$var$V = F;
                            break b;
                        }
                        $2174e2766e27089d$var$V = h.return;
                    }
                }
                $2174e2766e27089d$var$K = e;
                $2174e2766e27089d$var$jg();
                if ($2174e2766e27089d$var$lc && "function" === typeof $2174e2766e27089d$var$lc.onPostCommitFiberRoot) try {
                    $2174e2766e27089d$var$lc.onPostCommitFiberRoot($2174e2766e27089d$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $2174e2766e27089d$var$C = c, $2174e2766e27089d$var$pk.transition = b;
        }
    }
    return !1;
}
function $2174e2766e27089d$var$Yk(a, b, c) {
    b = $2174e2766e27089d$var$Ki(c, b);
    b = $2174e2766e27089d$var$Oi(a, b, 1);
    a = $2174e2766e27089d$var$dh(a, b, 1);
    b = $2174e2766e27089d$var$L();
    null !== a && ($2174e2766e27089d$var$Ac(a, 1, b), $2174e2766e27089d$var$Ek(a, b));
}
function $2174e2766e27089d$var$W(a, b, c) {
    if (3 === a.tag) $2174e2766e27089d$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $2174e2766e27089d$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $2174e2766e27089d$var$Si || !$2174e2766e27089d$var$Si.has(d))) {
                a = $2174e2766e27089d$var$Ki(c, a);
                a = $2174e2766e27089d$var$Ri(b, a, 1);
                b = $2174e2766e27089d$var$dh(b, a, 1);
                a = $2174e2766e27089d$var$L();
                null !== b && ($2174e2766e27089d$var$Ac(b, 1, a), $2174e2766e27089d$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $2174e2766e27089d$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $2174e2766e27089d$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $2174e2766e27089d$var$R === a && ($2174e2766e27089d$var$Z & c) === c && (4 === $2174e2766e27089d$var$T || 3 === $2174e2766e27089d$var$T && ($2174e2766e27089d$var$Z & 130023424) === $2174e2766e27089d$var$Z && 500 > $2174e2766e27089d$var$B() - $2174e2766e27089d$var$gk ? $2174e2766e27089d$var$Lk(a, 0) : $2174e2766e27089d$var$sk |= c);
    $2174e2766e27089d$var$Ek(a, b);
}
function $2174e2766e27089d$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $2174e2766e27089d$var$sc, $2174e2766e27089d$var$sc <<= 1, 0 === ($2174e2766e27089d$var$sc & 130023424) && ($2174e2766e27089d$var$sc = 4194304)));
    var c = $2174e2766e27089d$var$L();
    a = $2174e2766e27089d$var$Zg(a, b);
    null !== a && ($2174e2766e27089d$var$Ac(a, b, c), $2174e2766e27089d$var$Ek(a, c));
}
function $2174e2766e27089d$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $2174e2766e27089d$var$Zk(a, c);
}
function $2174e2766e27089d$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($2174e2766e27089d$var$p(314));
    }
    null !== d && d.delete(b);
    $2174e2766e27089d$var$Zk(a, c);
}
var $2174e2766e27089d$var$Wk;
$2174e2766e27089d$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $2174e2766e27089d$var$Wf.current) $2174e2766e27089d$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $2174e2766e27089d$var$Ug = !1, $2174e2766e27089d$var$zj(a, b, c);
            $2174e2766e27089d$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $2174e2766e27089d$var$Ug = !1, $2174e2766e27089d$var$I && 0 !== (b.flags & 1048576) && $2174e2766e27089d$var$ug(b, $2174e2766e27089d$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $2174e2766e27089d$var$jj(a, b);
            a = b.pendingProps;
            var e = $2174e2766e27089d$var$Yf(b, $2174e2766e27089d$var$H.current);
            $2174e2766e27089d$var$Tg(b, c);
            e = $2174e2766e27089d$var$Xh(null, b, d, a, e, c);
            var f = $2174e2766e27089d$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $2174e2766e27089d$var$Zf(d) ? (f = !0, $2174e2766e27089d$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $2174e2766e27089d$var$ah(b), e.updater = $2174e2766e27089d$var$nh, b.stateNode = e, e._reactInternals = b, $2174e2766e27089d$var$rh(b, d, a, c), b = $2174e2766e27089d$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $2174e2766e27089d$var$I && f && $2174e2766e27089d$var$vg(b), $2174e2766e27089d$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $2174e2766e27089d$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $2174e2766e27089d$var$$k(d);
                a = $2174e2766e27089d$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $2174e2766e27089d$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $2174e2766e27089d$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $2174e2766e27089d$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $2174e2766e27089d$var$aj(null, b, d, $2174e2766e27089d$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($2174e2766e27089d$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $2174e2766e27089d$var$Lg(d, e), $2174e2766e27089d$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $2174e2766e27089d$var$Lg(d, e), $2174e2766e27089d$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $2174e2766e27089d$var$lj(b);
                if (null === a) throw Error($2174e2766e27089d$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $2174e2766e27089d$var$bh(a, b);
                $2174e2766e27089d$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $2174e2766e27089d$var$Ki(Error($2174e2766e27089d$var$p(423)), b);
                        b = $2174e2766e27089d$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $2174e2766e27089d$var$Ki(Error($2174e2766e27089d$var$p(424)), b);
                        b = $2174e2766e27089d$var$mj(a, b, d, c, e);
                        break a;
                    } else for($2174e2766e27089d$var$yg = $2174e2766e27089d$var$Lf(b.stateNode.containerInfo.firstChild), $2174e2766e27089d$var$xg = b, $2174e2766e27089d$var$I = !0, $2174e2766e27089d$var$zg = null, c = $2174e2766e27089d$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $2174e2766e27089d$var$Ig();
                    if (d === e) {
                        b = $2174e2766e27089d$var$$i(a, b, c);
                        break a;
                    }
                    $2174e2766e27089d$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $2174e2766e27089d$var$Kh(b), null === a && $2174e2766e27089d$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $2174e2766e27089d$var$Ef(d, e) ? g = null : null !== f && $2174e2766e27089d$var$Ef(d, f) && (b.flags |= 32), $2174e2766e27089d$var$hj(a, b), $2174e2766e27089d$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $2174e2766e27089d$var$Eg(b), null;
        case 13:
            return $2174e2766e27089d$var$pj(a, b, c);
        case 4:
            return $2174e2766e27089d$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $2174e2766e27089d$var$Bh(b, null, d, c) : $2174e2766e27089d$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $2174e2766e27089d$var$Lg(d, e), $2174e2766e27089d$var$Zi(a, b, d, e, c);
        case 7:
            return $2174e2766e27089d$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $2174e2766e27089d$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $2174e2766e27089d$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $2174e2766e27089d$var$G($2174e2766e27089d$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($2174e2766e27089d$var$He(f.value, g)) {
                        if (f.children === e.children && !$2174e2766e27089d$var$Wf.current) {
                            b = $2174e2766e27089d$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $2174e2766e27089d$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $2174e2766e27089d$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($2174e2766e27089d$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $2174e2766e27089d$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $2174e2766e27089d$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $2174e2766e27089d$var$Tg(b, c), e = $2174e2766e27089d$var$Vg(e), d = d(e), b.flags |= 1, $2174e2766e27089d$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $2174e2766e27089d$var$Lg(d, b.pendingProps), e = $2174e2766e27089d$var$Lg(d.type, e), $2174e2766e27089d$var$aj(a, b, d, e, c);
        case 15:
            return $2174e2766e27089d$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $2174e2766e27089d$var$Lg(d, e), $2174e2766e27089d$var$jj(a, b), b.tag = 1, $2174e2766e27089d$var$Zf(d) ? (a = !0, $2174e2766e27089d$var$cg(b)) : a = !1, $2174e2766e27089d$var$Tg(b, c), $2174e2766e27089d$var$ph(b, d, e), $2174e2766e27089d$var$rh(b, d, e, c), $2174e2766e27089d$var$kj(null, b, d, !0, a, c);
        case 19:
            return $2174e2766e27089d$var$yj(a, b, c);
        case 22:
            return $2174e2766e27089d$var$ej(a, b, c);
    }
    throw Error($2174e2766e27089d$var$p(156, b.tag));
};
function $2174e2766e27089d$var$Gk(a, b) {
    return $2174e2766e27089d$var$ac(a, b);
}
function $2174e2766e27089d$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $2174e2766e27089d$var$Bg(a, b, c, d) {
    return new $2174e2766e27089d$var$al(a, b, c, d);
}
function $2174e2766e27089d$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $2174e2766e27089d$var$$k(a) {
    if ("function" === typeof a) return $2174e2766e27089d$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $2174e2766e27089d$var$Da) return 11;
        if (a === $2174e2766e27089d$var$Ga) return 14;
    }
    return 2;
}
function $2174e2766e27089d$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $2174e2766e27089d$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $2174e2766e27089d$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $2174e2766e27089d$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $2174e2766e27089d$var$ya:
            return $2174e2766e27089d$var$Ah(c.children, e, f, b);
        case $2174e2766e27089d$var$za:
            g = 8;
            e |= 8;
            break;
        case $2174e2766e27089d$var$Aa:
            return a = $2174e2766e27089d$var$Bg(12, c, b, e | 2), a.elementType = $2174e2766e27089d$var$Aa, a.lanes = f, a;
        case $2174e2766e27089d$var$Ea:
            return a = $2174e2766e27089d$var$Bg(13, c, b, e), a.elementType = $2174e2766e27089d$var$Ea, a.lanes = f, a;
        case $2174e2766e27089d$var$Fa:
            return a = $2174e2766e27089d$var$Bg(19, c, b, e), a.elementType = $2174e2766e27089d$var$Fa, a.lanes = f, a;
        case $2174e2766e27089d$var$Ia:
            return $2174e2766e27089d$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $2174e2766e27089d$var$Ba:
                    g = 10;
                    break a;
                case $2174e2766e27089d$var$Ca:
                    g = 9;
                    break a;
                case $2174e2766e27089d$var$Da:
                    g = 11;
                    break a;
                case $2174e2766e27089d$var$Ga:
                    g = 14;
                    break a;
                case $2174e2766e27089d$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($2174e2766e27089d$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $2174e2766e27089d$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $2174e2766e27089d$var$Ah(a, b, c, d) {
    a = $2174e2766e27089d$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $2174e2766e27089d$var$qj(a, b, c, d) {
    a = $2174e2766e27089d$var$Bg(22, a, d, b);
    a.elementType = $2174e2766e27089d$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $2174e2766e27089d$var$xh(a, b, c) {
    a = $2174e2766e27089d$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $2174e2766e27089d$var$zh(a, b, c) {
    b = $2174e2766e27089d$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $2174e2766e27089d$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $2174e2766e27089d$var$zc(0);
    this.expirationTimes = $2174e2766e27089d$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $2174e2766e27089d$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $2174e2766e27089d$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $2174e2766e27089d$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $2174e2766e27089d$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $2174e2766e27089d$var$ah(f);
    return a;
}
function $2174e2766e27089d$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $2174e2766e27089d$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $2174e2766e27089d$var$el(a) {
    if (!a) return $2174e2766e27089d$var$Vf;
    a = a._reactInternals;
    a: {
        if ($2174e2766e27089d$var$Vb(a) !== a || 1 !== a.tag) throw Error($2174e2766e27089d$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($2174e2766e27089d$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($2174e2766e27089d$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($2174e2766e27089d$var$Zf(c)) return $2174e2766e27089d$var$bg(a, c, b);
    }
    return b;
}
function $2174e2766e27089d$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $2174e2766e27089d$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $2174e2766e27089d$var$el(null);
    c = a.current;
    d = $2174e2766e27089d$var$L();
    e = $2174e2766e27089d$var$lh(c);
    f = $2174e2766e27089d$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $2174e2766e27089d$var$dh(c, f, e);
    a.current.lanes = e;
    $2174e2766e27089d$var$Ac(a, e, d);
    $2174e2766e27089d$var$Ek(a, d);
    return a;
}
function $2174e2766e27089d$var$gl(a, b, c, d) {
    var e = b.current, f = $2174e2766e27089d$var$L(), g = $2174e2766e27089d$var$lh(e);
    c = $2174e2766e27089d$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $2174e2766e27089d$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $2174e2766e27089d$var$dh(e, b, g);
    null !== a && ($2174e2766e27089d$var$mh(a, e, g, f), $2174e2766e27089d$var$eh(a, e, g));
    return g;
}
function $2174e2766e27089d$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $2174e2766e27089d$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $2174e2766e27089d$var$jl(a, b) {
    $2174e2766e27089d$var$il(a, b);
    (a = a.alternate) && $2174e2766e27089d$var$il(a, b);
}
function $2174e2766e27089d$var$kl() {
    return null;
}
var $2174e2766e27089d$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $2174e2766e27089d$var$ml(a) {
    this._internalRoot = a;
}
$2174e2766e27089d$var$nl.prototype.render = $2174e2766e27089d$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($2174e2766e27089d$var$p(409));
    $2174e2766e27089d$var$gl(a, b, null, null);
};
$2174e2766e27089d$var$nl.prototype.unmount = $2174e2766e27089d$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $2174e2766e27089d$var$Sk(function() {
            $2174e2766e27089d$var$gl(null, a, null, null);
        });
        b[$2174e2766e27089d$var$uf] = null;
    }
};
function $2174e2766e27089d$var$nl(a) {
    this._internalRoot = a;
}
$2174e2766e27089d$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $2174e2766e27089d$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $2174e2766e27089d$var$Qc.length && 0 !== b && b < $2174e2766e27089d$var$Qc[c].priority; c++);
        $2174e2766e27089d$var$Qc.splice(c, 0, a);
        0 === c && $2174e2766e27089d$var$Vc(a);
    }
};
function $2174e2766e27089d$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $2174e2766e27089d$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $2174e2766e27089d$var$ql() {}
function $2174e2766e27089d$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $2174e2766e27089d$var$hl(g);
                f.call(a);
            };
        }
        var g = $2174e2766e27089d$var$fl(b, d, a, 0, null, !1, !1, "", $2174e2766e27089d$var$ql);
        a._reactRootContainer = g;
        a[$2174e2766e27089d$var$uf] = g.current;
        $2174e2766e27089d$var$sf(8 === a.nodeType ? a.parentNode : a);
        $2174e2766e27089d$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $2174e2766e27089d$var$hl(k);
            h.call(a);
        };
    }
    var k = $2174e2766e27089d$var$cl(a, 0, !1, null, null, !1, !1, "", $2174e2766e27089d$var$ql);
    a._reactRootContainer = k;
    a[$2174e2766e27089d$var$uf] = k.current;
    $2174e2766e27089d$var$sf(8 === a.nodeType ? a.parentNode : a);
    $2174e2766e27089d$var$Sk(function() {
        $2174e2766e27089d$var$gl(b, k, c, d);
    });
    return k;
}
function $2174e2766e27089d$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $2174e2766e27089d$var$hl(g);
                h.call(a);
            };
        }
        $2174e2766e27089d$var$gl(b, g, a, e);
    } else g = $2174e2766e27089d$var$rl(c, b, a, e, d);
    return $2174e2766e27089d$var$hl(g);
}
$2174e2766e27089d$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $2174e2766e27089d$var$tc(b.pendingLanes);
                0 !== c && ($2174e2766e27089d$var$Cc(b, c | 1), $2174e2766e27089d$var$Ek(b, $2174e2766e27089d$var$B()), 0 === ($2174e2766e27089d$var$K & 6) && ($2174e2766e27089d$var$Hj = $2174e2766e27089d$var$B() + 500, $2174e2766e27089d$var$jg()));
            }
            break;
        case 13:
            $2174e2766e27089d$var$Sk(function() {
                var b = $2174e2766e27089d$var$Zg(a, 1);
                if (null !== b) {
                    var c = $2174e2766e27089d$var$L();
                    $2174e2766e27089d$var$mh(b, a, 1, c);
                }
            }), $2174e2766e27089d$var$jl(a, 1);
    }
};
$2174e2766e27089d$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $2174e2766e27089d$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $2174e2766e27089d$var$L();
            $2174e2766e27089d$var$mh(b, a, 134217728, c);
        }
        $2174e2766e27089d$var$jl(a, 134217728);
    }
};
$2174e2766e27089d$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $2174e2766e27089d$var$lh(a), c = $2174e2766e27089d$var$Zg(a, b);
        if (null !== c) {
            var d = $2174e2766e27089d$var$L();
            $2174e2766e27089d$var$mh(c, a, b, d);
        }
        $2174e2766e27089d$var$jl(a, b);
    }
};
$2174e2766e27089d$var$Hc = function() {
    return $2174e2766e27089d$var$C;
};
$2174e2766e27089d$var$Ic = function(a, b) {
    var c = $2174e2766e27089d$var$C;
    try {
        return $2174e2766e27089d$var$C = a, b();
    } finally{
        $2174e2766e27089d$var$C = c;
    }
};
$2174e2766e27089d$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $2174e2766e27089d$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $2174e2766e27089d$var$Db(d);
                        if (!e) throw Error($2174e2766e27089d$var$p(90));
                        $2174e2766e27089d$var$Wa(d);
                        $2174e2766e27089d$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $2174e2766e27089d$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $2174e2766e27089d$var$fb(a, !!c.multiple, b, !1);
    }
};
$2174e2766e27089d$var$Gb = $2174e2766e27089d$var$Rk;
$2174e2766e27089d$var$Hb = $2174e2766e27089d$var$Sk;
var $2174e2766e27089d$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $2174e2766e27089d$var$Cb,
        $2174e2766e27089d$var$ue,
        $2174e2766e27089d$var$Db,
        $2174e2766e27089d$var$Eb,
        $2174e2766e27089d$var$Fb,
        $2174e2766e27089d$var$Rk
    ]
}, $2174e2766e27089d$var$ul = {
    findFiberByHostInstance: $2174e2766e27089d$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $2174e2766e27089d$var$vl = {
    bundleType: $2174e2766e27089d$var$ul.bundleType,
    version: $2174e2766e27089d$var$ul.version,
    rendererPackageName: $2174e2766e27089d$var$ul.rendererPackageName,
    rendererConfig: $2174e2766e27089d$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $2174e2766e27089d$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $2174e2766e27089d$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $2174e2766e27089d$var$ul.findFiberByHostInstance || $2174e2766e27089d$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $2174e2766e27089d$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$2174e2766e27089d$var$wl.isDisabled && $2174e2766e27089d$var$wl.supportsFiber) try {
        $2174e2766e27089d$var$kc = $2174e2766e27089d$var$wl.inject($2174e2766e27089d$var$vl), $2174e2766e27089d$var$lc = $2174e2766e27089d$var$wl;
    } catch (a) {}
}
$2174e2766e27089d$export$ae55be85d98224ed = $2174e2766e27089d$var$tl;
$2174e2766e27089d$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$2174e2766e27089d$var$ol(b)) throw Error($2174e2766e27089d$var$p(200));
    return $2174e2766e27089d$var$dl(a, b, null, c);
};
$2174e2766e27089d$export$882461b6382ed46c = function(a, b) {
    if (!$2174e2766e27089d$var$ol(a)) throw Error($2174e2766e27089d$var$p(299));
    var c = !1, d = "", e = $2174e2766e27089d$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $2174e2766e27089d$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$2174e2766e27089d$var$uf] = b.current;
    $2174e2766e27089d$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $2174e2766e27089d$var$ml(b);
};
$2174e2766e27089d$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($2174e2766e27089d$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($2174e2766e27089d$var$p(268, a));
    }
    a = $2174e2766e27089d$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$2174e2766e27089d$export$cd75ccfd720a3cd4 = function(a) {
    return $2174e2766e27089d$var$Sk(a);
};
$2174e2766e27089d$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$2174e2766e27089d$var$pl(b)) throw Error($2174e2766e27089d$var$p(200));
    return $2174e2766e27089d$var$sl(null, a, b, !0, c);
};
$2174e2766e27089d$export$757ceba2d55c277e = function(a, b, c) {
    if (!$2174e2766e27089d$var$ol(a)) throw Error($2174e2766e27089d$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $2174e2766e27089d$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $2174e2766e27089d$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$2174e2766e27089d$var$uf] = b.current;
    $2174e2766e27089d$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $2174e2766e27089d$var$nl(b);
};
$2174e2766e27089d$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$2174e2766e27089d$var$pl(b)) throw Error($2174e2766e27089d$var$p(200));
    return $2174e2766e27089d$var$sl(null, a, b, !1, c);
};
$2174e2766e27089d$export$502457920280e6be = function(a) {
    if (!$2174e2766e27089d$var$pl(a)) throw Error($2174e2766e27089d$var$p(40));
    return a._reactRootContainer ? ($2174e2766e27089d$var$Sk(function() {
        $2174e2766e27089d$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$2174e2766e27089d$var$uf] = null;
        });
    }), !0) : !1;
};
$2174e2766e27089d$export$c78a37762a8d58e1 = $2174e2766e27089d$var$Rk;
$2174e2766e27089d$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$2174e2766e27089d$var$pl(c)) throw Error($2174e2766e27089d$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($2174e2766e27089d$var$p(38));
    return $2174e2766e27089d$var$sl(a, b, c, !1, d);
};
$2174e2766e27089d$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRequire.register("8sPnc", function(module, exports) {
"use strict";

module.exports = (parcelRequire("eaMUF"));

});
parcelRequire.register("eaMUF", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $a517f0f0f87cd78c$export$c4744153514ff05d; }, function (v) { return $a517f0f0f87cd78c$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $a517f0f0f87cd78c$export$3e506c1ccc9cc1a7; }, function (v) { return $a517f0f0f87cd78c$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $a517f0f0f87cd78c$export$e26fe2ed2fa76875; }, function (v) { return $a517f0f0f87cd78c$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $a517f0f0f87cd78c$export$502329bbf4b505b1; }, function (v) { return $a517f0f0f87cd78c$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $a517f0f0f87cd78c$export$6e3807111c4874c4; }, function (v) { return $a517f0f0f87cd78c$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $a517f0f0f87cd78c$export$c27134553091fb3a; }, function (v) { return $a517f0f0f87cd78c$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $a517f0f0f87cd78c$export$33ee1acdc04fd2a2; }, function (v) { return $a517f0f0f87cd78c$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $a517f0f0f87cd78c$export$b00a404bbd5edef2; }, function (v) { return $a517f0f0f87cd78c$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $a517f0f0f87cd78c$export$8352ce38b91d0c62; }, function (v) { return $a517f0f0f87cd78c$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $a517f0f0f87cd78c$export$d66a1c1c77bd778b; }, function (v) { return $a517f0f0f87cd78c$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $a517f0f0f87cd78c$export$d3dfb8e4810cb555; }, function (v) { return $a517f0f0f87cd78c$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $a517f0f0f87cd78c$export$839f9183b0465a69; }, function (v) { return $a517f0f0f87cd78c$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $a517f0f0f87cd78c$export$72fdf0e06517287b; }, function (v) { return $a517f0f0f87cd78c$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $a517f0f0f87cd78c$export$4b844e58a3e414b4; }, function (v) { return $a517f0f0f87cd78c$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $a517f0f0f87cd78c$export$816d2913ae6b83b1; }, function (v) { return $a517f0f0f87cd78c$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $a517f0f0f87cd78c$export$61bcfe829111a1d0; }, function (v) { return $a517f0f0f87cd78c$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $a517f0f0f87cd78c$export$7ee8c9beb337bc3f; }, function (v) { return $a517f0f0f87cd78c$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $a517f0f0f87cd78c$export$b5836b71941fa3ed; }, function (v) { return $a517f0f0f87cd78c$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $a517f0f0f87cd78c$export$cf845f2c119da08a; }, function (v) { return $a517f0f0f87cd78c$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a517f0f0f87cd78c$export$c4744153514ff05d;
var $a517f0f0f87cd78c$export$3e506c1ccc9cc1a7;
var $a517f0f0f87cd78c$export$e26fe2ed2fa76875;
var $a517f0f0f87cd78c$export$502329bbf4b505b1;
var $a517f0f0f87cd78c$export$6e3807111c4874c4;
var $a517f0f0f87cd78c$export$c27134553091fb3a;
var $a517f0f0f87cd78c$export$33ee1acdc04fd2a2;
var $a517f0f0f87cd78c$export$b00a404bbd5edef2;
var $a517f0f0f87cd78c$export$8352ce38b91d0c62;
var $a517f0f0f87cd78c$export$d66a1c1c77bd778b;
var $a517f0f0f87cd78c$export$d3dfb8e4810cb555;
var $a517f0f0f87cd78c$export$839f9183b0465a69;
var $a517f0f0f87cd78c$export$72fdf0e06517287b;
var $a517f0f0f87cd78c$export$4b844e58a3e414b4;
var $a517f0f0f87cd78c$export$816d2913ae6b83b1;
var $a517f0f0f87cd78c$export$61bcfe829111a1d0;
var $a517f0f0f87cd78c$export$7ee8c9beb337bc3f;
var $a517f0f0f87cd78c$export$b5836b71941fa3ed;
var $a517f0f0f87cd78c$export$cf845f2c119da08a;
"use strict";
function $a517f0f0f87cd78c$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $a517f0f0f87cd78c$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $a517f0f0f87cd78c$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $a517f0f0f87cd78c$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $a517f0f0f87cd78c$var$g(C, c)) n < e && 0 > $a517f0f0f87cd78c$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $a517f0f0f87cd78c$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $a517f0f0f87cd78c$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $a517f0f0f87cd78c$var$l = performance;
    $a517f0f0f87cd78c$export$c4744153514ff05d = function() {
        return $a517f0f0f87cd78c$var$l.now();
    };
} else {
    var $a517f0f0f87cd78c$var$p = Date, $a517f0f0f87cd78c$var$q = $a517f0f0f87cd78c$var$p.now();
    $a517f0f0f87cd78c$export$c4744153514ff05d = function() {
        return $a517f0f0f87cd78c$var$p.now() - $a517f0f0f87cd78c$var$q;
    };
}
var $a517f0f0f87cd78c$var$r = [], $a517f0f0f87cd78c$var$t = [], $a517f0f0f87cd78c$var$u = 1, $a517f0f0f87cd78c$var$v = null, $a517f0f0f87cd78c$var$y = 3, $a517f0f0f87cd78c$var$z = !1, $a517f0f0f87cd78c$var$A = !1, $a517f0f0f87cd78c$var$B = !1, $a517f0f0f87cd78c$var$D = "function" === typeof setTimeout ? setTimeout : null, $a517f0f0f87cd78c$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $a517f0f0f87cd78c$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $a517f0f0f87cd78c$var$G(a) {
    for(var b = $a517f0f0f87cd78c$var$h($a517f0f0f87cd78c$var$t); null !== b;){
        if (null === b.callback) $a517f0f0f87cd78c$var$k($a517f0f0f87cd78c$var$t);
        else if (b.startTime <= a) $a517f0f0f87cd78c$var$k($a517f0f0f87cd78c$var$t), b.sortIndex = b.expirationTime, $a517f0f0f87cd78c$var$f($a517f0f0f87cd78c$var$r, b);
        else break;
        b = $a517f0f0f87cd78c$var$h($a517f0f0f87cd78c$var$t);
    }
}
function $a517f0f0f87cd78c$var$H(a) {
    $a517f0f0f87cd78c$var$B = !1;
    $a517f0f0f87cd78c$var$G(a);
    if (!$a517f0f0f87cd78c$var$A) {
        if (null !== $a517f0f0f87cd78c$var$h($a517f0f0f87cd78c$var$r)) $a517f0f0f87cd78c$var$A = !0, $a517f0f0f87cd78c$var$I($a517f0f0f87cd78c$var$J);
        else {
            var b = $a517f0f0f87cd78c$var$h($a517f0f0f87cd78c$var$t);
            null !== b && $a517f0f0f87cd78c$var$K($a517f0f0f87cd78c$var$H, b.startTime - a);
        }
    }
}
function $a517f0f0f87cd78c$var$J(a, b) {
    $a517f0f0f87cd78c$var$A = !1;
    $a517f0f0f87cd78c$var$B && ($a517f0f0f87cd78c$var$B = !1, $a517f0f0f87cd78c$var$E($a517f0f0f87cd78c$var$L), $a517f0f0f87cd78c$var$L = -1);
    $a517f0f0f87cd78c$var$z = !0;
    var c = $a517f0f0f87cd78c$var$y;
    try {
        $a517f0f0f87cd78c$var$G(b);
        for($a517f0f0f87cd78c$var$v = $a517f0f0f87cd78c$var$h($a517f0f0f87cd78c$var$r); null !== $a517f0f0f87cd78c$var$v && (!($a517f0f0f87cd78c$var$v.expirationTime > b) || a && !$a517f0f0f87cd78c$var$M());){
            var d = $a517f0f0f87cd78c$var$v.callback;
            if ("function" === typeof d) {
                $a517f0f0f87cd78c$var$v.callback = null;
                $a517f0f0f87cd78c$var$y = $a517f0f0f87cd78c$var$v.priorityLevel;
                var e = d($a517f0f0f87cd78c$var$v.expirationTime <= b);
                b = $a517f0f0f87cd78c$export$c4744153514ff05d();
                "function" === typeof e ? $a517f0f0f87cd78c$var$v.callback = e : $a517f0f0f87cd78c$var$v === $a517f0f0f87cd78c$var$h($a517f0f0f87cd78c$var$r) && $a517f0f0f87cd78c$var$k($a517f0f0f87cd78c$var$r);
                $a517f0f0f87cd78c$var$G(b);
            } else $a517f0f0f87cd78c$var$k($a517f0f0f87cd78c$var$r);
            $a517f0f0f87cd78c$var$v = $a517f0f0f87cd78c$var$h($a517f0f0f87cd78c$var$r);
        }
        if (null !== $a517f0f0f87cd78c$var$v) var w = !0;
        else {
            var m = $a517f0f0f87cd78c$var$h($a517f0f0f87cd78c$var$t);
            null !== m && $a517f0f0f87cd78c$var$K($a517f0f0f87cd78c$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $a517f0f0f87cd78c$var$v = null, $a517f0f0f87cd78c$var$y = c, $a517f0f0f87cd78c$var$z = !1;
    }
}
var $a517f0f0f87cd78c$var$N = !1, $a517f0f0f87cd78c$var$O = null, $a517f0f0f87cd78c$var$L = -1, $a517f0f0f87cd78c$var$P = 5, $a517f0f0f87cd78c$var$Q = -1;
function $a517f0f0f87cd78c$var$M() {
    return $a517f0f0f87cd78c$export$c4744153514ff05d() - $a517f0f0f87cd78c$var$Q < $a517f0f0f87cd78c$var$P ? !1 : !0;
}
function $a517f0f0f87cd78c$var$R() {
    if (null !== $a517f0f0f87cd78c$var$O) {
        var a = $a517f0f0f87cd78c$export$c4744153514ff05d();
        $a517f0f0f87cd78c$var$Q = a;
        var b = !0;
        try {
            b = $a517f0f0f87cd78c$var$O(!0, a);
        } finally{
            b ? $a517f0f0f87cd78c$var$S() : ($a517f0f0f87cd78c$var$N = !1, $a517f0f0f87cd78c$var$O = null);
        }
    } else $a517f0f0f87cd78c$var$N = !1;
}
var $a517f0f0f87cd78c$var$S;
if ("function" === typeof $a517f0f0f87cd78c$var$F) $a517f0f0f87cd78c$var$S = function() {
    $a517f0f0f87cd78c$var$F($a517f0f0f87cd78c$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $a517f0f0f87cd78c$var$T = new MessageChannel, $a517f0f0f87cd78c$var$U = $a517f0f0f87cd78c$var$T.port2;
    $a517f0f0f87cd78c$var$T.port1.onmessage = $a517f0f0f87cd78c$var$R;
    $a517f0f0f87cd78c$var$S = function() {
        $a517f0f0f87cd78c$var$U.postMessage(null);
    };
} else $a517f0f0f87cd78c$var$S = function() {
    $a517f0f0f87cd78c$var$D($a517f0f0f87cd78c$var$R, 0);
};
function $a517f0f0f87cd78c$var$I(a) {
    $a517f0f0f87cd78c$var$O = a;
    $a517f0f0f87cd78c$var$N || ($a517f0f0f87cd78c$var$N = !0, $a517f0f0f87cd78c$var$S());
}
function $a517f0f0f87cd78c$var$K(a, b) {
    $a517f0f0f87cd78c$var$L = $a517f0f0f87cd78c$var$D(function() {
        a($a517f0f0f87cd78c$export$c4744153514ff05d());
    }, b);
}
$a517f0f0f87cd78c$export$3e506c1ccc9cc1a7 = 5;
$a517f0f0f87cd78c$export$e26fe2ed2fa76875 = 1;
$a517f0f0f87cd78c$export$502329bbf4b505b1 = 4;
$a517f0f0f87cd78c$export$6e3807111c4874c4 = 3;
$a517f0f0f87cd78c$export$c27134553091fb3a = null;
$a517f0f0f87cd78c$export$33ee1acdc04fd2a2 = 2;
$a517f0f0f87cd78c$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$a517f0f0f87cd78c$export$8352ce38b91d0c62 = function() {
    $a517f0f0f87cd78c$var$A || $a517f0f0f87cd78c$var$z || ($a517f0f0f87cd78c$var$A = !0, $a517f0f0f87cd78c$var$I($a517f0f0f87cd78c$var$J));
};
$a517f0f0f87cd78c$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $a517f0f0f87cd78c$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$a517f0f0f87cd78c$export$d3dfb8e4810cb555 = function() {
    return $a517f0f0f87cd78c$var$y;
};
$a517f0f0f87cd78c$export$839f9183b0465a69 = function() {
    return $a517f0f0f87cd78c$var$h($a517f0f0f87cd78c$var$r);
};
$a517f0f0f87cd78c$export$72fdf0e06517287b = function(a) {
    switch($a517f0f0f87cd78c$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $a517f0f0f87cd78c$var$y;
    }
    var c = $a517f0f0f87cd78c$var$y;
    $a517f0f0f87cd78c$var$y = b;
    try {
        return a();
    } finally{
        $a517f0f0f87cd78c$var$y = c;
    }
};
$a517f0f0f87cd78c$export$4b844e58a3e414b4 = function() {};
$a517f0f0f87cd78c$export$816d2913ae6b83b1 = function() {};
$a517f0f0f87cd78c$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $a517f0f0f87cd78c$var$y;
    $a517f0f0f87cd78c$var$y = a;
    try {
        return b();
    } finally{
        $a517f0f0f87cd78c$var$y = c;
    }
};
$a517f0f0f87cd78c$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $a517f0f0f87cd78c$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $a517f0f0f87cd78c$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $a517f0f0f87cd78c$var$f($a517f0f0f87cd78c$var$t, a), null === $a517f0f0f87cd78c$var$h($a517f0f0f87cd78c$var$r) && a === $a517f0f0f87cd78c$var$h($a517f0f0f87cd78c$var$t) && ($a517f0f0f87cd78c$var$B ? ($a517f0f0f87cd78c$var$E($a517f0f0f87cd78c$var$L), $a517f0f0f87cd78c$var$L = -1) : $a517f0f0f87cd78c$var$B = !0, $a517f0f0f87cd78c$var$K($a517f0f0f87cd78c$var$H, c - d))) : (a.sortIndex = e, $a517f0f0f87cd78c$var$f($a517f0f0f87cd78c$var$r, a), $a517f0f0f87cd78c$var$A || $a517f0f0f87cd78c$var$z || ($a517f0f0f87cd78c$var$A = !0, $a517f0f0f87cd78c$var$I($a517f0f0f87cd78c$var$J)));
    return a;
};
$a517f0f0f87cd78c$export$b5836b71941fa3ed = $a517f0f0f87cd78c$var$M;
$a517f0f0f87cd78c$export$cf845f2c119da08a = function(a) {
    var b = $a517f0f0f87cd78c$var$y;
    return function() {
        var c = $a517f0f0f87cd78c$var$y;
        $a517f0f0f87cd78c$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $a517f0f0f87cd78c$var$y = c;
        }
    };
};

});



parcelRequire.register("k0dmy", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $gmFzF = parcelRequire("gmFzF");
function $e8fe2c4fcd4fc60e$var$emptyFunction() {}
function $e8fe2c4fcd4fc60e$var$emptyFunctionWithReset() {}
$e8fe2c4fcd4fc60e$var$emptyFunctionWithReset.resetWarningCache = $e8fe2c4fcd4fc60e$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $gmFzF) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $e8fe2c4fcd4fc60e$var$emptyFunctionWithReset,
        resetWarningCache: $e8fe2c4fcd4fc60e$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRequire.register("gmFzF", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $be9ef32f74f6c8fe$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $be9ef32f74f6c8fe$var$ReactPropTypesSecret;

});


parcelRequire.register("gcEbT", function(module, exports) {
// shim for using process in browser
var $bcbcf16780bc9d1b$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $bcbcf16780bc9d1b$var$cachedSetTimeout;
var $bcbcf16780bc9d1b$var$cachedClearTimeout;
function $bcbcf16780bc9d1b$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $bcbcf16780bc9d1b$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $bcbcf16780bc9d1b$var$cachedSetTimeout = setTimeout;
        else $bcbcf16780bc9d1b$var$cachedSetTimeout = $bcbcf16780bc9d1b$var$defaultSetTimout;
    } catch (e) {
        $bcbcf16780bc9d1b$var$cachedSetTimeout = $bcbcf16780bc9d1b$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $bcbcf16780bc9d1b$var$cachedClearTimeout = clearTimeout;
        else $bcbcf16780bc9d1b$var$cachedClearTimeout = $bcbcf16780bc9d1b$var$defaultClearTimeout;
    } catch (e) {
        $bcbcf16780bc9d1b$var$cachedClearTimeout = $bcbcf16780bc9d1b$var$defaultClearTimeout;
    }
})();
function $bcbcf16780bc9d1b$var$runTimeout(fun) {
    if ($bcbcf16780bc9d1b$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($bcbcf16780bc9d1b$var$cachedSetTimeout === $bcbcf16780bc9d1b$var$defaultSetTimout || !$bcbcf16780bc9d1b$var$cachedSetTimeout) && setTimeout) {
        $bcbcf16780bc9d1b$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $bcbcf16780bc9d1b$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $bcbcf16780bc9d1b$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $bcbcf16780bc9d1b$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $bcbcf16780bc9d1b$var$runClearTimeout(marker) {
    if ($bcbcf16780bc9d1b$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($bcbcf16780bc9d1b$var$cachedClearTimeout === $bcbcf16780bc9d1b$var$defaultClearTimeout || !$bcbcf16780bc9d1b$var$cachedClearTimeout) && clearTimeout) {
        $bcbcf16780bc9d1b$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $bcbcf16780bc9d1b$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $bcbcf16780bc9d1b$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $bcbcf16780bc9d1b$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $bcbcf16780bc9d1b$var$queue = [];
var $bcbcf16780bc9d1b$var$draining = false;
var $bcbcf16780bc9d1b$var$currentQueue;
var $bcbcf16780bc9d1b$var$queueIndex = -1;
function $bcbcf16780bc9d1b$var$cleanUpNextTick() {
    if (!$bcbcf16780bc9d1b$var$draining || !$bcbcf16780bc9d1b$var$currentQueue) return;
    $bcbcf16780bc9d1b$var$draining = false;
    if ($bcbcf16780bc9d1b$var$currentQueue.length) $bcbcf16780bc9d1b$var$queue = $bcbcf16780bc9d1b$var$currentQueue.concat($bcbcf16780bc9d1b$var$queue);
    else $bcbcf16780bc9d1b$var$queueIndex = -1;
    if ($bcbcf16780bc9d1b$var$queue.length) $bcbcf16780bc9d1b$var$drainQueue();
}
function $bcbcf16780bc9d1b$var$drainQueue() {
    if ($bcbcf16780bc9d1b$var$draining) return;
    var timeout = $bcbcf16780bc9d1b$var$runTimeout($bcbcf16780bc9d1b$var$cleanUpNextTick);
    $bcbcf16780bc9d1b$var$draining = true;
    var len = $bcbcf16780bc9d1b$var$queue.length;
    while(len){
        $bcbcf16780bc9d1b$var$currentQueue = $bcbcf16780bc9d1b$var$queue;
        $bcbcf16780bc9d1b$var$queue = [];
        while(++$bcbcf16780bc9d1b$var$queueIndex < len)if ($bcbcf16780bc9d1b$var$currentQueue) $bcbcf16780bc9d1b$var$currentQueue[$bcbcf16780bc9d1b$var$queueIndex].run();
        $bcbcf16780bc9d1b$var$queueIndex = -1;
        len = $bcbcf16780bc9d1b$var$queue.length;
    }
    $bcbcf16780bc9d1b$var$currentQueue = null;
    $bcbcf16780bc9d1b$var$draining = false;
    $bcbcf16780bc9d1b$var$runClearTimeout(timeout);
}
$bcbcf16780bc9d1b$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $bcbcf16780bc9d1b$var$queue.push(new $bcbcf16780bc9d1b$var$Item(fun, args));
    if ($bcbcf16780bc9d1b$var$queue.length === 1 && !$bcbcf16780bc9d1b$var$draining) $bcbcf16780bc9d1b$var$runTimeout($bcbcf16780bc9d1b$var$drainQueue);
};
// v8 likes predictible objects
function $bcbcf16780bc9d1b$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$bcbcf16780bc9d1b$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$bcbcf16780bc9d1b$var$process.title = "browser";
$bcbcf16780bc9d1b$var$process.browser = true;
$bcbcf16780bc9d1b$var$process.env = {};
$bcbcf16780bc9d1b$var$process.argv = [];
$bcbcf16780bc9d1b$var$process.version = ""; // empty string to avoid regexp issues
$bcbcf16780bc9d1b$var$process.versions = {};
function $bcbcf16780bc9d1b$var$noop() {}
$bcbcf16780bc9d1b$var$process.on = $bcbcf16780bc9d1b$var$noop;
$bcbcf16780bc9d1b$var$process.addListener = $bcbcf16780bc9d1b$var$noop;
$bcbcf16780bc9d1b$var$process.once = $bcbcf16780bc9d1b$var$noop;
$bcbcf16780bc9d1b$var$process.off = $bcbcf16780bc9d1b$var$noop;
$bcbcf16780bc9d1b$var$process.removeListener = $bcbcf16780bc9d1b$var$noop;
$bcbcf16780bc9d1b$var$process.removeAllListeners = $bcbcf16780bc9d1b$var$noop;
$bcbcf16780bc9d1b$var$process.emit = $bcbcf16780bc9d1b$var$noop;
$bcbcf16780bc9d1b$var$process.prependListener = $bcbcf16780bc9d1b$var$noop;
$bcbcf16780bc9d1b$var$process.prependOnceListener = $bcbcf16780bc9d1b$var$noop;
$bcbcf16780bc9d1b$var$process.listeners = function(name) {
    return [];
};
$bcbcf16780bc9d1b$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$bcbcf16780bc9d1b$var$process.cwd = function() {
    return "/";
};
$bcbcf16780bc9d1b$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$bcbcf16780bc9d1b$var$process.umask = function() {
    return 0;
};

});

parcelRequire.register("gMdMh", function(module, exports) {









module.exports = Promise.all([
    (parcelRequire("ckCc1"))((parcelRequire("dvCpl")).getBundleURL("fCzRa") + (parcelRequire("e26He")).resolve("3Oer8")),
    (parcelRequire("ckCc1"))((parcelRequire("dvCpl")).getBundleURL("fCzRa") + (parcelRequire("e26He")).resolve("ajnOe")),
    (parcelRequire("ckCc1"))((parcelRequire("dvCpl")).getBundleURL("fCzRa") + (parcelRequire("e26He")).resolve("kJ8xJ"))
]).then(()=>parcelRequire("goUex"));

});
parcelRequire.register("ckCc1", function(module, exports) {
"use strict";

var $gFpNk = parcelRequire("gFpNk");
module.exports = $gFpNk(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Add a global function to handle when the script loads.
        var globalName = "i".concat(("" + Math.random()).slice(2));
        $parcel$global[globalName] = function(m) {
            resolve(m);
            cleanup();
        };
        // Remove script on load or error
        var cleanup = function() {
            delete $parcel$global[globalName];
            script.onerror = null;
            script.remove();
        };
        // Append an inline script tag into the document head
        var script = document.createElement("script");
        script.async = true;
        script.type = "module";
        script.charset = "utf-8";
        script.textContent = "import * as m from '".concat(bundle, "'; ").concat(globalName, "(m);");
        script.onerror = function(e) {
            reject(e);
            cleanup();
        };
        document.head.appendChild(script);
    });
});

});
parcelRequire.register("gFpNk", function(module, exports) {
"use strict";
var $c2247bf44e388667$var$cachedBundles = {};
var $c2247bf44e388667$var$cachedPreloads = {};
var $c2247bf44e388667$var$cachedPrefetches = {};
function $c2247bf44e388667$var$getCache(type) {
    switch(type){
        case "preload":
            return $c2247bf44e388667$var$cachedPreloads;
        case "prefetch":
            return $c2247bf44e388667$var$cachedPrefetches;
        default:
            return $c2247bf44e388667$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $c2247bf44e388667$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});


parcelRequire.register("dvCpl", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $9d5bf69315763ed0$export$bdfd709ae4826697; }, function (v) { return $9d5bf69315763ed0$export$bdfd709ae4826697 = v; });
var $9d5bf69315763ed0$export$bdfd709ae4826697;
var $9d5bf69315763ed0$export$c9e73fbda7da57b6;
var $9d5bf69315763ed0$export$5a759dc7a1cfb72a;
"use strict";
var $9d5bf69315763ed0$var$bundleURL = {};
function $9d5bf69315763ed0$var$getBundleURLCached(id) {
    var value = $9d5bf69315763ed0$var$bundleURL[id];
    if (!value) {
        value = $9d5bf69315763ed0$var$getBundleURL();
        $9d5bf69315763ed0$var$bundleURL[id] = value;
    }
    return value;
}
function $9d5bf69315763ed0$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $9d5bf69315763ed0$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $9d5bf69315763ed0$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $9d5bf69315763ed0$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$9d5bf69315763ed0$export$bdfd709ae4826697 = $9d5bf69315763ed0$var$getBundleURLCached;
$9d5bf69315763ed0$export$c9e73fbda7da57b6 = $9d5bf69315763ed0$var$getBaseURL;
$9d5bf69315763ed0$export$5a759dc7a1cfb72a = $9d5bf69315763ed0$var$getOrigin;

});


parcelRequire.register("2kTrc", function(module, exports) {












module.exports = Promise.all([
    (parcelRequire("ckCc1"))((parcelRequire("dvCpl")).getBundleURL("fCzRa") + (parcelRequire("e26He")).resolve("bTmLH")),
    (parcelRequire("ckCc1"))((parcelRequire("dvCpl")).getBundleURL("fCzRa") + (parcelRequire("e26He")).resolve("3Oer8")),
    (parcelRequire("ckCc1"))((parcelRequire("dvCpl")).getBundleURL("fCzRa") + (parcelRequire("e26He")).resolve("ajnOe")),
    (parcelRequire("ckCc1"))((parcelRequire("dvCpl")).getBundleURL("fCzRa") + (parcelRequire("e26He")).resolve("dixqs"))
]).then(()=>parcelRequire("aJWPm"));

});

parcelRequire.register("epiMQ", function(module, exports) {









module.exports = Promise.all([
    (parcelRequire("ckCc1"))((parcelRequire("dvCpl")).getBundleURL("fCzRa") + (parcelRequire("e26He")).resolve("bTmLH")),
    (parcelRequire("ckCc1"))((parcelRequire("dvCpl")).getBundleURL("fCzRa") + (parcelRequire("e26He")).resolve("ajnOe")),
    (parcelRequire("ckCc1"))((parcelRequire("dvCpl")).getBundleURL("fCzRa") + (parcelRequire("e26He")).resolve("k8uo8"))
]).then(()=>parcelRequire("5jzu6"));

});

parcelRequire.register("e8aIO", function(module, exports) {
/* UAParser.js v1.0.2
   Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
   MIT License */ (function(window1, undefined) {
    "use strict";
    var LIBVERSION = "1.0.2", EMPTY = "", UNKNOWN = "?", FUNC_TYPE = "function", UNDEF_TYPE = "undefined", OBJ_TYPE = "object", STR_TYPE = "string", MAJOR = "major", MODEL = "model", NAME = "name", TYPE = "type", VENDOR = "vendor", VERSION = "version", ARCHITECTURE = "architecture", CONSOLE = "console", MOBILE = "mobile", TABLET = "tablet", SMARTTV = "smarttv", WEARABLE = "wearable", EMBEDDED = "embedded", UA_MAX_LENGTH = 255;
    var AMAZON = "Amazon", APPLE = "Apple", ASUS = "ASUS", BLACKBERRY = "BlackBerry", BROWSER = "Browser", CHROME = "Chrome", EDGE = "Edge", FIREFOX = "Firefox", GOOGLE = "Google", HUAWEI = "Huawei", LG = "LG", MICROSOFT = "Microsoft", MOTOROLA = "Motorola", OPERA = "Opera", SAMSUNG = "Samsung", SONY = "Sony", XIAOMI = "Xiaomi", ZEBRA = "Zebra", FACEBOOK = "Facebook";
    var extend = function(regexes, extensions) {
        var mergedRegexes = {};
        for(var i in regexes)if (extensions[i] && extensions[i].length % 2 === 0) mergedRegexes[i] = extensions[i].concat(regexes[i]);
        else mergedRegexes[i] = regexes[i];
        return mergedRegexes;
    }, enumerize = function(arr) {
        var enums = {};
        for(var i = 0; i < arr.length; i++)enums[arr[i].toUpperCase()] = arr[i];
        return enums;
    }, has = function(str1, str2) {
        return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
    }, lowerize = function(str) {
        return str.toLowerCase();
    }, majorize = function(version) {
        return typeof version === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split(".")[0] : undefined;
    }, trim = function(str, len) {
        if (typeof str === STR_TYPE) {
            str = str.replace(/^\s\s*/, EMPTY).replace(/\s\s*$/, EMPTY);
            return typeof len === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
        }
    };
    var rgxMapper = function(ua, arrays) {
        var i = 0, j, k, p, q, matches, match;
        while(i < arrays.length && !matches){
            var regex = arrays[i], props = arrays[i + 1];
            j = k = 0;
            while(j < regex.length && !matches){
                matches = regex[j++].exec(ua);
                if (!!matches) for(p = 0; p < props.length; p++){
                    match = matches[++k];
                    q = props[p];
                    if (typeof q === OBJ_TYPE && q.length > 0) {
                        if (q.length === 2) {
                            if (typeof q[1] == FUNC_TYPE) this[q[0]] = q[1].call(this, match);
                            else this[q[0]] = q[1];
                        } else if (q.length === 3) {
                            if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                            else this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                        } else if (q.length === 4) this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                    } else this[q] = match ? match : undefined;
                }
            }
            i += 2;
        }
    }, strMapper = function(str, map) {
        for(var i in map){
            if (typeof map[i] === OBJ_TYPE && map[i].length > 0) for(var j = 0; j < map[i].length; j++){
                if (has(map[i][j], str)) return i === UNKNOWN ? undefined : i;
            }
            else if (has(map[i], str)) return i === UNKNOWN ? undefined : i;
        }
        return str;
    };
    var oldSafariMap = {
        "1.0": "/8",
        1.2: "/1",
        1.3: "/3",
        "2.0": "/412",
        "2.0.2": "/416",
        "2.0.3": "/417",
        "2.0.4": "/419",
        "?": "/"
    }, windowsVersionMap = {
        ME: "4.90",
        "NT 3.11": "NT3.51",
        "NT 4.0": "NT4.0",
        2e3: "NT 5.0",
        XP: [
            "NT 5.1",
            "NT 5.2"
        ],
        Vista: "NT 6.0",
        7: "NT 6.1",
        8: "NT 6.2",
        8.1: "NT 6.3",
        10: [
            "NT 6.4",
            "NT 10.0"
        ],
        RT: "ARM"
    };
    var regexes = {
        browser: [
            [
                /\b(?:crmo|crios)\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Chrome"
                ]
            ],
            [
                /edg(?:e|ios|a)?\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Edge"
                ]
            ],
            [
                /(opera mini)\/([-\w\.]+)/i,
                /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
                /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /opios[\/ ]+([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Mini"
                ]
            ],
            [
                /\bopr\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA
                ]
            ],
            [
                /(kindle)\/([\w\.]+)/i,
                /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,
                /(avant |iemobile|slim)(?:browser)?[\/ ]?([\w\.]*)/i,
                /(ba?idubrowser)[\/ ]?([\w\.]+)/i,
                /(?:ms|\()(ie) ([\w\.]+)/i,
                /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale|qqbrowserlite|qq)\/([-\w\.]+)/i,
                /(weibo)__([\d\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "UC" + BROWSER
                ]
            ],
            [
                /\bqbcore\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "WeChat(Win) Desktop"
                ]
            ],
            [
                /micromessenger\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "WeChat"
                ]
            ],
            [
                /konqueror\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Konqueror"
                ]
            ],
            [
                /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "IE"
                ]
            ],
            [
                /yabrowser\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Yandex"
                ]
            ],
            [
                /(avast|avg)\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1 Secure " + BROWSER
                ],
                VERSION
            ],
            [
                /\bfocus\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " Focus"
                ]
            ],
            [
                /\bopt\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Touch"
                ]
            ],
            [
                /coc_coc\w+\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Coc Coc"
                ]
            ],
            [
                /dolfin\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Dolphin"
                ]
            ],
            [
                /coast\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Coast"
                ]
            ],
            [
                /miuibrowser\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "MIUI " + BROWSER
                ]
            ],
            [
                /fxios\/([-\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX
                ]
            ],
            [
                /\bqihu|(qi?ho?o?|360)browser/i
            ],
            [
                [
                    NAME,
                    "360 " + BROWSER
                ]
            ],
            [
                /(oculus|samsung|sailfish)browser\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1 " + BROWSER
                ],
                VERSION
            ],
            [
                /(comodo_dragon)\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /_/g,
                    " "
                ],
                VERSION
            ],
            [
                /(electron)\/([\w\.]+) safari/i,
                /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
                /m?(qqbrowser|baiduboxapp|2345Explorer)[\/ ]?([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(metasr)[\/ ]?([\w\.]+)/i,
                /(lbbrowser)/i
            ],
            [
                NAME
            ],
            [
                /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i
            ],
            [
                [
                    NAME,
                    FACEBOOK
                ],
                VERSION
            ],
            [
                /safari (line)\/([\w\.]+)/i,
                /\b(line)\/([\w\.]+)\/iab/i,
                /(chromium|instagram)[\/ ]([-\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\bgsa\/([\w\.]+) .*safari\//i
            ],
            [
                VERSION,
                [
                    NAME,
                    "GSA"
                ]
            ],
            [
                /headlesschrome(?:\/([\w\.]+)| )/i
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + " Headless"
                ]
            ],
            [
                / wv\).+(chrome)\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    CHROME + " WebView"
                ],
                VERSION
            ],
            [
                /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Android " + BROWSER
                ]
            ],
            [
                /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /version\/([\w\.]+) .*mobile\/\w+ (safari)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Mobile Safari"
                ]
            ],
            [
                /version\/([\w\.]+) .*(mobile ?safari|safari)/i
            ],
            [
                VERSION,
                NAME
            ],
            [
                /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    oldSafariMap
                ]
            ],
            [
                /(webkit|khtml)\/([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(navigator|netscape\d?)\/([-\w\.]+)/i
            ],
            [
                [
                    NAME,
                    "Netscape"
                ],
                VERSION
            ],
            [
                /mobile vr; rv:([\w\.]+)\).+firefox/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " Reality"
                ]
            ],
            [
                /ekiohf.+(flow)\/([\w\.]+)/i,
                /(swiftfox)/i,
                /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
                /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
                /(firefox)\/([\w\.]+)/i,
                /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
                /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
                /(links) \(([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ]
        ],
        cpu: [
            [
                /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i
            ],
            [
                [
                    ARCHITECTURE,
                    "amd64"
                ]
            ],
            [
                /(ia32(?=;))/i
            ],
            [
                [
                    ARCHITECTURE,
                    lowerize
                ]
            ],
            [
                /((?:i[346]|x)86)[;\)]/i
            ],
            [
                [
                    ARCHITECTURE,
                    "ia32"
                ]
            ],
            [
                /\b(aarch64|arm(v?8e?l?|_?64))\b/i
            ],
            [
                [
                    ARCHITECTURE,
                    "arm64"
                ]
            ],
            [
                /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i
            ],
            [
                [
                    ARCHITECTURE,
                    "armhf"
                ]
            ],
            [
                /windows (ce|mobile); ppc;/i
            ],
            [
                [
                    ARCHITECTURE,
                    "arm"
                ]
            ],
            [
                /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i
            ],
            [
                [
                    ARCHITECTURE,
                    /ower/,
                    EMPTY,
                    lowerize
                ]
            ],
            [
                /(sun4\w)[;\)]/i
            ],
            [
                [
                    ARCHITECTURE,
                    "sparc"
                ]
            ],
            [
                /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
            ],
            [
                [
                    ARCHITECTURE,
                    lowerize
                ]
            ]
        ],
        device: [
            [
                /\b(sch-i[89]0\d|shw-m380s|sm-[pt]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:s[cgp]h|gt|sm)-\w+|galaxy nexus)/i,
                /samsung[- ]([-\w]+)/i,
                /sec-(sgh\w+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\((ip(?:hone|od)[\w ]*);/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\((ipad);[-\w\),; ]+apple/i,
                /applecoremedia\/[\w\.]+ \((ipad)/i,
                /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(?:huawei|honor)([-\w ]+)[;\)]/i,
                /\b(nexus 6p|\w{2,4}-[atu]?[ln][01259x][012359][an]?)\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(poco[\w ]+)(?: bui|\))/i,
                /\b; (\w+) build\/hm\1/i,
                /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
                /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
                /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /; (\w+) bui.+ oppo/i,
                /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "OPPO"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /vivo (\w+)(?: bui|\))/i,
                /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Vivo"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(rmx[12]\d{3})(?: bui|;|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Realme"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
                /\bmot(?:orola)?[- ](\w*)/i,
                /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(mz60\d|xoom[2 ]{0,2}) build\//i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
                /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
                /\blg-?([\d\w]+) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(ideatab[-\w ]+)/i,
                /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Lenovo"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(?:maemo|nokia).*(n900|lumia \d+)/i,
                /nokia[-_ ]?([-\w\.]*)/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    "Nokia"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(pixel c)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+ ([c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /sony tablet [ps]/i,
                /\b(?:sony)?sgp\w+(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    "Xperia Tablet"
                ],
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                / (kb2005|in20[12]5|be20[12][59])\b/i,
                /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "OnePlus"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(alexa)webm/i,
                /(kf[a-z]{2}wi)( bui|\))/i,
                /(kf[a-z]+)( bui|\)).+silk\//i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i
            ],
            [
                [
                    MODEL,
                    /(.+)/g,
                    "Fire Phone $1"
                ],
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(playbook);[-\w\),; ]+(rim)/i
            ],
            [
                MODEL,
                VENDOR,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:bb[a-f]|st[hv])100-\d)/i,
                /\(bb10; (\w+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    BLACKBERRY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(nexus 9)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "HTC"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
                /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
                /(alcatel|geeksphone|nexian|panasonic|sony)[-_ ]?([-\w]*)/i
            ],
            [
                VENDOR,
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Acer"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (m[1-5] note) bui/i,
                /\bmz-([-\w]{2,})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Meizu"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Sharp"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[-_ ]?([-\w]*)/i,
                /(hp) ([\w ]+\w)/i,
                /(asus)-?(\w+)/i,
                /(microsoft); (lumia[\w ]+)/i,
                /(lenovo)[-_ ]?([-\w]+)/i,
                /(jolla)/i,
                /(oppo) ?([\w ]+) bui/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(archos) (gamepad2?)/i,
                /(hp).+(touchpad(?!.+tablet)|tablet)/i,
                /(kindle)\/([\w\.]+)/i,
                /(nook)[\w ]+build\/(\w+)/i,
                /(dell) (strea[kpr\d ]*[\dko])/i,
                /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
                /(trinity)[- ]*(t\d{3}) bui/i,
                /(gigaset)[- ]+(q\w{1,9}) bui/i,
                /(vodafone) ([\w ]+)(?:\)| bui)/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(surface duo)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid [\d\.]+; (fp\du?)(?: b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Fairphone"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(u304aa)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "AT&T"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\bsie-(\w*)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Siemens"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(rct\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "RCA"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(venue[\d ]{2,7}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Dell"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(q(?:mv|ta)\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Verizon"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Barnes & Noble"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(tm\d{3}\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "NuVision"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(k88) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "ZTE"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(nx\d{3}j) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "ZTE"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(gen\d{3}) b.+49h/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Swiss"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(zur\d{3}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Swiss"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((zeki)?tb.*\b) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Zeki"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b([yr]\d{2}) b/i,
                /\b(dragon[- ]+touch |dt)(\w{5}) b/i
            ],
            [
                [
                    VENDOR,
                    "Dragon Touch"
                ],
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(ns-?\w{0,9}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Insignia"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((nxa|next)-?\w{0,9}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "NextBook"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i
            ],
            [
                [
                    VENDOR,
                    "Voice"
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(lvtel\-)?(v1[12]) b/i
            ],
            [
                [
                    VENDOR,
                    "LvTel"
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(ph-1) /i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Essential"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(v(100md|700na|7011|917g).*\b) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Envizen"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(trio[-\w\. ]+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "MachSpeed"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\btu_(1491) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Rotor"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(shield[\w ]+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Nvidia"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(sprint) (\w+)/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kin\.[onetw]{3})/i
            ],
            [
                [
                    MODEL,
                    /\./g,
                    " "
                ],
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(ouya)/i,
                /(nintendo) ([wids3utch]+)/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /droid.+; (shield) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Nvidia"
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /(playstation [345portablevi]+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /\b(xbox(?: one)?(?!; xbox))[\); ]/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /smart-tv.+(samsung)/i
            ],
            [
                VENDOR,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /hbbtv.+maple;(\d+)/i
            ],
            [
                [
                    MODEL,
                    /^/,
                    "SmartTV"
                ],
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i
            ],
            [
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(apple) ?tv/i
            ],
            [
                VENDOR,
                [
                    MODEL,
                    APPLE + " TV"
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /crkey/i
            ],
            [
                [
                    MODEL,
                    CHROME + "cast"
                ],
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /droid.+aft(\w)( bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\(dtv[\);].+(aquos)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Sharp"
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
                /hbbtv\/\d+\.\d+\.\d+ +\([\w ]*; *(\w[^;]*);([^;]*)/i
            ],
            [
                [
                    VENDOR,
                    trim
                ],
                [
                    MODEL,
                    trim
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i
            ],
            [
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /((pebble))app/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (glass) \d/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (wt63?0{2,3})\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(quest( 2)?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    FACEBOOK
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i
            ],
            [
                VENDOR,
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /droid .+?; ([^;]+?)(?: bui|\) applew).+? mobile safari/i
            ],
            [
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i
            ],
            [
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i
            ],
            [
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(phone|mobile(?:[;\/]| safari)|pda(?=.+windows ce))/i
            ],
            [
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(android[-\w\. ]{0,9});.+buil/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Generic"
                ]
            ]
        ],
        engine: [
            [
                /windows.+ edge\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    EDGE + "HTML"
                ]
            ],
            [
                /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Blink"
                ]
            ],
            [
                /(presto)\/([\w\.]+)/i,
                /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,
                /ekioh(flow)\/([\w\.]+)/i,
                /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
                /(icab)[\/ ]([23]\.[\d\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /rv\:([\w\.]{1,9})\b.+(gecko)/i
            ],
            [
                VERSION,
                NAME
            ]
        ],
        os: [
            [
                /microsoft (windows) (vista|xp)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(windows) nt 6\.2; (arm)/i,
                /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i,
                /(windows)[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ]
            ],
            [
                /(win(?=3|9|n)|win 9x )([nt\d\.]+)/i
            ],
            [
                [
                    NAME,
                    "Windows"
                ],
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ]
            ],
            [
                /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,
                /cfnetwork\/.+darwin/i
            ],
            [
                [
                    VERSION,
                    /_/g,
                    "."
                ],
                [
                    NAME,
                    "iOS"
                ]
            ],
            [
                /(mac os x) ?([\w\. ]*)/i,
                /(macintosh|mac_powerpc\b)(?!.+haiku)/i
            ],
            [
                [
                    NAME,
                    "Mac OS"
                ],
                [
                    VERSION,
                    /_/g,
                    "."
                ]
            ],
            [
                /droid ([\w\.]+)\b.+(android[- ]x86)/i
            ],
            [
                VERSION,
                NAME
            ],
            [
                /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
                /(blackberry)\w*\/([\w\.]*)/i,
                /(tizen|kaios)[\/ ]([\w\.]+)/i,
                /\((series40);/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\(bb(10);/i
            ],
            [
                VERSION,
                [
                    NAME,
                    BLACKBERRY
                ]
            ],
            [
                /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Symbian"
                ]
            ],
            [
                /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " OS"
                ]
            ],
            [
                /web0s;.+rt(tv)/i,
                /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "webOS"
                ]
            ],
            [
                /crkey\/([\d\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + "cast"
                ]
            ],
            [
                /(cros) [\w]+ ([\w\.]+\w)/i
            ],
            [
                [
                    NAME,
                    "Chromium OS"
                ],
                VERSION
            ],
            [
                /(nintendo|playstation) ([wids345portablevuch]+)/i,
                /(xbox); +xbox ([^\);]+)/i,
                /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
                /(mint)[\/\(\) ]?(\w*)/i,
                /(mageia|vectorlinux)[; ]/i,
                /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
                /(hurd|linux) ?([\w\.]*)/i,
                /(gnu) ?([\w\.]*)/i,
                /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
                /(haiku) (\w+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(sunos) ?([\w\.\d]*)/i
            ],
            [
                [
                    NAME,
                    "Solaris"
                ],
                VERSION
            ],
            [
                /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
                /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
                /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux)/i,
                /(unix) ?([\w\.]*)/i
            ],
            [
                NAME,
                VERSION
            ]
        ]
    };
    var UAParser = function(ua, extensions) {
        if (typeof ua === OBJ_TYPE) {
            extensions = ua;
            ua = undefined;
        }
        if (!(this instanceof UAParser)) return new UAParser(ua, extensions).getResult();
        var _ua = ua || (typeof window1 !== UNDEF_TYPE && window1.navigator && window1.navigator.userAgent ? window1.navigator.userAgent : EMPTY);
        var _rgxmap = extensions ? extend(regexes, extensions) : regexes;
        this.getBrowser = function() {
            var _browser = {};
            _browser[NAME] = undefined;
            _browser[VERSION] = undefined;
            rgxMapper.call(_browser, _ua, _rgxmap.browser);
            _browser.major = majorize(_browser.version);
            return _browser;
        };
        this.getCPU = function() {
            var _cpu = {};
            _cpu[ARCHITECTURE] = undefined;
            rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
            return _cpu;
        };
        this.getDevice = function() {
            var _device = {};
            _device[VENDOR] = undefined;
            _device[MODEL] = undefined;
            _device[TYPE] = undefined;
            rgxMapper.call(_device, _ua, _rgxmap.device);
            return _device;
        };
        this.getEngine = function() {
            var _engine = {};
            _engine[NAME] = undefined;
            _engine[VERSION] = undefined;
            rgxMapper.call(_engine, _ua, _rgxmap.engine);
            return _engine;
        };
        this.getOS = function() {
            var _os = {};
            _os[NAME] = undefined;
            _os[VERSION] = undefined;
            rgxMapper.call(_os, _ua, _rgxmap.os);
            return _os;
        };
        this.getResult = function() {
            return {
                ua: this.getUA(),
                browser: this.getBrowser(),
                engine: this.getEngine(),
                os: this.getOS(),
                device: this.getDevice(),
                cpu: this.getCPU()
            };
        };
        this.getUA = function() {
            return _ua;
        };
        this.setUA = function(ua) {
            _ua = typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH ? trim(ua, UA_MAX_LENGTH) : ua;
            return this;
        };
        this.setUA(_ua);
        return this;
    };
    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER = enumerize([
        NAME,
        VERSION,
        MAJOR
    ]);
    UAParser.CPU = enumerize([
        ARCHITECTURE
    ]);
    UAParser.DEVICE = enumerize([
        MODEL,
        VENDOR,
        TYPE,
        CONSOLE,
        MOBILE,
        SMARTTV,
        TABLET,
        WEARABLE,
        EMBEDDED
    ]);
    UAParser.ENGINE = UAParser.OS = enumerize([
        NAME,
        VERSION
    ]);
    if ("object" !== UNDEF_TYPE) {
        if ("object" !== UNDEF_TYPE && module.exports) exports = module.exports = UAParser;
        exports.UAParser = UAParser;
    } else {
        if (typeof define === FUNC_TYPE && define.amd) define(function() {
            return UAParser;
        });
        else if (typeof window1 !== UNDEF_TYPE) window1.UAParser = UAParser;
    }
    var $ = typeof window1 !== UNDEF_TYPE && (window1.jQuery || window1.Zepto);
    if ($ && !$.ua) {
        var parser = new UAParser;
        $.ua = parser.getResult();
        $.ua.get = function() {
            return parser.getUA();
        };
        $.ua.set = function(ua) {
            parser.setUA(ua);
            var result = parser.getResult();
            for(var prop in result)$.ua[prop] = result[prop];
        };
    }
})(typeof window === "object" ? window : this);

});

/* eslint-disable-next-line import/no-unassigned-import */ // `Symbol.prototype.description` getter
// https://tc39.es/ecma262/#sec-symbol.prototype.description
"use strict";
var $ef48c8e0540d6569$exports = {};
"use strict";
var $212fa519f4bef41a$exports = {};
"use strict";
var $212fa519f4bef41a$var$check = function(it) {
    return it && it.Math === Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
$212fa519f4bef41a$exports = // eslint-disable-next-line es/no-global-this -- safe
$212fa519f4bef41a$var$check(typeof globalThis == "object" && globalThis) || $212fa519f4bef41a$var$check(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
$212fa519f4bef41a$var$check(typeof self == "object" && self) || $212fa519f4bef41a$var$check(typeof $parcel$global == "object" && $parcel$global) || $212fa519f4bef41a$var$check(typeof $212fa519f4bef41a$exports == "object" && $212fa519f4bef41a$exports) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function("return this")();


// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var $3cd2e4c9005c1909$export$2d1720544b23b823;
"use strict";
var $16b43a02da62cc11$exports = {};
"use strict";
var $217c917c4f59b359$exports = {};
"use strict";
$217c917c4f59b359$exports = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};


// Detect IE8's incomplete defineProperty implementation
$16b43a02da62cc11$exports = !$217c917c4f59b359$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] !== 7;
});


var $2f17e9746e5fde89$exports = {};
"use strict";
var $4da6c0a05b2e762d$exports = {};
"use strict";

$4da6c0a05b2e762d$exports = !$217c917c4f59b359$exports(function() {
    // eslint-disable-next-line es/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != "function" || test.hasOwnProperty("prototype");
});


var $2f17e9746e5fde89$var$call = Function.prototype.call;
$2f17e9746e5fde89$exports = $4da6c0a05b2e762d$exports ? $2f17e9746e5fde89$var$call.bind($2f17e9746e5fde89$var$call) : function() {
    return $2f17e9746e5fde89$var$call.apply($2f17e9746e5fde89$var$call, arguments);
};


// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var $f6b684d67cc87fbe$export$2d1720544b23b823;
"use strict";
var $f6b684d67cc87fbe$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $f6b684d67cc87fbe$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $f6b684d67cc87fbe$var$NASHORN_BUG = $f6b684d67cc87fbe$var$getOwnPropertyDescriptor && !$f6b684d67cc87fbe$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
$f6b684d67cc87fbe$export$2d1720544b23b823 = $f6b684d67cc87fbe$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $f6b684d67cc87fbe$var$getOwnPropertyDescriptor(this, V);
    return !!descriptor && descriptor.enumerable;
} : $f6b684d67cc87fbe$var$$propertyIsEnumerable;


var $819ae5875a6bb120$exports = {};
"use strict";
$819ae5875a6bb120$exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};


var $1a94a489a7afc329$exports = {};
"use strict";
var $8086cf521fa8b34c$exports = {};
"use strict";
var $c201050ed73b14ba$exports = {};
"use strict";

var $c201050ed73b14ba$var$FunctionPrototype = Function.prototype;
var $c201050ed73b14ba$var$call = $c201050ed73b14ba$var$FunctionPrototype.call;
var $c201050ed73b14ba$var$uncurryThisWithBind = $4da6c0a05b2e762d$exports && $c201050ed73b14ba$var$FunctionPrototype.bind.bind($c201050ed73b14ba$var$call, $c201050ed73b14ba$var$call);
$c201050ed73b14ba$exports = $4da6c0a05b2e762d$exports ? $c201050ed73b14ba$var$uncurryThisWithBind : function(fn) {
    return function() {
        return $c201050ed73b14ba$var$call.apply(fn, arguments);
    };
};



var $7f55bdfec0ad037d$exports = {};
"use strict";

var $7f55bdfec0ad037d$var$toString = $c201050ed73b14ba$exports({}.toString);
var $7f55bdfec0ad037d$var$stringSlice = $c201050ed73b14ba$exports("".slice);
$7f55bdfec0ad037d$exports = function(it) {
    return $7f55bdfec0ad037d$var$stringSlice($7f55bdfec0ad037d$var$toString(it), 8, -1);
};


var $8086cf521fa8b34c$var$$Object = Object;
var $8086cf521fa8b34c$var$split = $c201050ed73b14ba$exports("".split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
$8086cf521fa8b34c$exports = $217c917c4f59b359$exports(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$8086cf521fa8b34c$var$$Object("z").propertyIsEnumerable(0);
}) ? function(it) {
    return $7f55bdfec0ad037d$exports(it) === "String" ? $8086cf521fa8b34c$var$split(it, "") : $8086cf521fa8b34c$var$$Object(it);
} : $8086cf521fa8b34c$var$$Object;


var $07418f2e69c51fa2$exports = {};
"use strict";
var $e64dc79af48a1328$exports = {};
"use strict";
// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
$e64dc79af48a1328$exports = function(it) {
    return it === null || it === undefined;
};


var $07418f2e69c51fa2$var$$TypeError = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
$07418f2e69c51fa2$exports = function(it) {
    if ($e64dc79af48a1328$exports(it)) throw new $07418f2e69c51fa2$var$$TypeError("Can't call method on " + it);
    return it;
};


$1a94a489a7afc329$exports = function(it) {
    return $8086cf521fa8b34c$exports($07418f2e69c51fa2$exports(it));
};


var $4dbc0d7468e7eb76$exports = {};
"use strict";
var $1cf67f83396a1488$exports = {};
"use strict";

var $06f10e9b9cb1418c$exports = {};
"use strict";
var $73d1a34d94fa4c35$exports = {};
"use strict";
var $bc8af0d3478e71c6$exports = {};
"use strict";
var $bc8af0d3478e71c6$var$documentAll = typeof document == "object" && document.all;
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var $bc8af0d3478e71c6$var$IS_HTMLDDA = typeof $bc8af0d3478e71c6$var$documentAll == "undefined" && $bc8af0d3478e71c6$var$documentAll !== undefined;
$bc8af0d3478e71c6$exports = {
    all: $bc8af0d3478e71c6$var$documentAll,
    IS_HTMLDDA: $bc8af0d3478e71c6$var$IS_HTMLDDA
};


var $73d1a34d94fa4c35$var$documentAll = $bc8af0d3478e71c6$exports.all;
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
$73d1a34d94fa4c35$exports = $bc8af0d3478e71c6$exports.IS_HTMLDDA ? function(argument) {
    return typeof argument == "function" || argument === $73d1a34d94fa4c35$var$documentAll;
} : function(argument) {
    return typeof argument == "function";
};



var $06f10e9b9cb1418c$var$documentAll = $bc8af0d3478e71c6$exports.all;
$06f10e9b9cb1418c$exports = $bc8af0d3478e71c6$exports.IS_HTMLDDA ? function(it) {
    return typeof it == "object" ? it !== null : $73d1a34d94fa4c35$exports(it) || it === $06f10e9b9cb1418c$var$documentAll;
} : function(it) {
    return typeof it == "object" ? it !== null : $73d1a34d94fa4c35$exports(it);
};


var $81db9cf3baf84d30$exports = {};
"use strict";
var $3e824c856d81a8e3$exports = {};
"use strict";


var $3e824c856d81a8e3$var$aFunction = function(argument) {
    return $73d1a34d94fa4c35$exports(argument) ? argument : undefined;
};
$3e824c856d81a8e3$exports = function(namespace, method) {
    return arguments.length < 2 ? $3e824c856d81a8e3$var$aFunction($212fa519f4bef41a$exports[namespace]) : $212fa519f4bef41a$exports[namespace] && $212fa519f4bef41a$exports[namespace][method];
};



var $dba85d7bd7ffe0d7$exports = {};
"use strict";

$dba85d7bd7ffe0d7$exports = $c201050ed73b14ba$exports({}.isPrototypeOf);


var $edee44790dc08709$exports = {};
"use strict";
var $13a8cd52720b8bb7$exports = {};
"use strict";
var $aed210e8b55f96e7$exports = {};
"use strict";

var $10e5337eedcfb10c$exports = {};
"use strict";
$10e5337eedcfb10c$exports = typeof navigator != "undefined" && String(navigator.userAgent) || "";


var $aed210e8b55f96e7$var$process = $212fa519f4bef41a$exports.process;
var $aed210e8b55f96e7$var$Deno = $212fa519f4bef41a$exports.Deno;
var $aed210e8b55f96e7$var$versions = $aed210e8b55f96e7$var$process && $aed210e8b55f96e7$var$process.versions || $aed210e8b55f96e7$var$Deno && $aed210e8b55f96e7$var$Deno.version;
var $aed210e8b55f96e7$var$v8 = $aed210e8b55f96e7$var$versions && $aed210e8b55f96e7$var$versions.v8;
var $aed210e8b55f96e7$var$match, $aed210e8b55f96e7$var$version;
if ($aed210e8b55f96e7$var$v8) {
    $aed210e8b55f96e7$var$match = $aed210e8b55f96e7$var$v8.split(".");
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    $aed210e8b55f96e7$var$version = $aed210e8b55f96e7$var$match[0] > 0 && $aed210e8b55f96e7$var$match[0] < 4 ? 1 : +($aed210e8b55f96e7$var$match[0] + $aed210e8b55f96e7$var$match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!$aed210e8b55f96e7$var$version && $10e5337eedcfb10c$exports) {
    $aed210e8b55f96e7$var$match = $10e5337eedcfb10c$exports.match(/Edge\/(\d+)/);
    if (!$aed210e8b55f96e7$var$match || $aed210e8b55f96e7$var$match[1] >= 74) {
        $aed210e8b55f96e7$var$match = $10e5337eedcfb10c$exports.match(/Chrome\/(\d+)/);
        if ($aed210e8b55f96e7$var$match) $aed210e8b55f96e7$var$version = +$aed210e8b55f96e7$var$match[1];
    }
}
$aed210e8b55f96e7$exports = $aed210e8b55f96e7$var$version;




var $13a8cd52720b8bb7$var$$String = $212fa519f4bef41a$exports.String;
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
$13a8cd52720b8bb7$exports = !!Object.getOwnPropertySymbols && !$217c917c4f59b359$exports(function() {
    var symbol = Symbol("symbol detection");
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
    // of course, fail.
    return !$13a8cd52720b8bb7$var$$String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $aed210e8b55f96e7$exports && $aed210e8b55f96e7$exports < 41;
});


$edee44790dc08709$exports = $13a8cd52720b8bb7$exports && !Symbol.sham && typeof Symbol.iterator == "symbol";


var $81db9cf3baf84d30$var$$Object = Object;
$81db9cf3baf84d30$exports = $edee44790dc08709$exports ? function(it) {
    return typeof it == "symbol";
} : function(it) {
    var $Symbol = $3e824c856d81a8e3$exports("Symbol");
    return $73d1a34d94fa4c35$exports($Symbol) && $dba85d7bd7ffe0d7$exports($Symbol.prototype, $81db9cf3baf84d30$var$$Object(it));
};


var $a1d58592526cda62$exports = {};
"use strict";
var $6df447ad4be37421$exports = {};
"use strict";

var $bb66d003fc13d318$exports = {};
"use strict";
var $bb66d003fc13d318$var$$String = String;
$bb66d003fc13d318$exports = function(argument) {
    try {
        return $bb66d003fc13d318$var$$String(argument);
    } catch (error) {
        return "Object";
    }
};


var $6df447ad4be37421$var$$TypeError = TypeError;
// `Assert: IsCallable(argument) is true`
$6df447ad4be37421$exports = function(argument) {
    if ($73d1a34d94fa4c35$exports(argument)) return argument;
    throw new $6df447ad4be37421$var$$TypeError($bb66d003fc13d318$exports(argument) + " is not a function");
};



// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
$a1d58592526cda62$exports = function(V, P) {
    var func = V[P];
    return $e64dc79af48a1328$exports(func) ? undefined : $6df447ad4be37421$exports(func);
};


var $8b0aecfa24fa1949$exports = {};
"use strict";



var $8b0aecfa24fa1949$var$$TypeError = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
$8b0aecfa24fa1949$exports = function(input, pref) {
    var fn, val;
    if (pref === "string" && $73d1a34d94fa4c35$exports(fn = input.toString) && !$06f10e9b9cb1418c$exports(val = $2f17e9746e5fde89$exports(fn, input))) return val;
    if ($73d1a34d94fa4c35$exports(fn = input.valueOf) && !$06f10e9b9cb1418c$exports(val = $2f17e9746e5fde89$exports(fn, input))) return val;
    if (pref !== "string" && $73d1a34d94fa4c35$exports(fn = input.toString) && !$06f10e9b9cb1418c$exports(val = $2f17e9746e5fde89$exports(fn, input))) return val;
    throw new $8b0aecfa24fa1949$var$$TypeError("Can't convert object to primitive value");
};


var $bbf4e852bf6421ea$exports = {};
"use strict";

var $32a869ed71ece4be$exports = {};
"use strict";
var $036c29a074575bd6$exports = {};
"use strict";
$036c29a074575bd6$exports = false;


var $edea88028f2ac210$exports = {};
"use strict";

var $2e7a1c6196ae4181$exports = {};
"use strict";

// eslint-disable-next-line es/no-object-defineproperty -- safe
var $2e7a1c6196ae4181$var$defineProperty = Object.defineProperty;
$2e7a1c6196ae4181$exports = function(key, value) {
    try {
        $2e7a1c6196ae4181$var$defineProperty($212fa519f4bef41a$exports, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        $212fa519f4bef41a$exports[key] = value;
    }
    return value;
};


var $edea88028f2ac210$var$SHARED = "__core-js_shared__";
var $edea88028f2ac210$var$store = $212fa519f4bef41a$exports[$edea88028f2ac210$var$SHARED] || $2e7a1c6196ae4181$exports($edea88028f2ac210$var$SHARED, {});
$edea88028f2ac210$exports = $edea88028f2ac210$var$store;


($32a869ed71ece4be$exports = function(key, value) {
    return $edea88028f2ac210$exports[key] || ($edea88028f2ac210$exports[key] = value !== undefined ? value : {});
})("versions", []).push({
    version: "3.34.0",
    mode: $036c29a074575bd6$exports ? "pure" : "global",
    copyright: "\xa9 2014-2023 Denis Pushkarev (zloirock.ru)",
    license: "https://github.com/zloirock/core-js/blob/v3.34.0/LICENSE",
    source: "https://github.com/zloirock/core-js"
});


var $1ad0c60d8de14c83$exports = {};
"use strict";

var $361c03d23168e423$exports = {};
"use strict";

var $361c03d23168e423$var$$Object = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
$361c03d23168e423$exports = function(argument) {
    return $361c03d23168e423$var$$Object($07418f2e69c51fa2$exports(argument));
};


var $1ad0c60d8de14c83$var$hasOwnProperty = $c201050ed73b14ba$exports({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
$1ad0c60d8de14c83$exports = Object.hasOwn || function hasOwn(it, key) {
    return $1ad0c60d8de14c83$var$hasOwnProperty($361c03d23168e423$exports(it), key);
};


var $280519a5ebb3eef0$exports = {};
"use strict";

var $280519a5ebb3eef0$var$id = 0;
var $280519a5ebb3eef0$var$postfix = Math.random();
var $280519a5ebb3eef0$var$toString = $c201050ed73b14ba$exports(1.0.toString);
$280519a5ebb3eef0$exports = function(key) {
    return "Symbol(" + (key === undefined ? "" : key) + ")_" + $280519a5ebb3eef0$var$toString(++$280519a5ebb3eef0$var$id + $280519a5ebb3eef0$var$postfix, 36);
};




var $bbf4e852bf6421ea$var$Symbol = $212fa519f4bef41a$exports.Symbol;
var $bbf4e852bf6421ea$var$WellKnownSymbolsStore = $32a869ed71ece4be$exports("wks");
var $bbf4e852bf6421ea$var$createWellKnownSymbol = $edee44790dc08709$exports ? $bbf4e852bf6421ea$var$Symbol["for"] || $bbf4e852bf6421ea$var$Symbol : $bbf4e852bf6421ea$var$Symbol && $bbf4e852bf6421ea$var$Symbol.withoutSetter || $280519a5ebb3eef0$exports;
$bbf4e852bf6421ea$exports = function(name) {
    if (!$1ad0c60d8de14c83$exports($bbf4e852bf6421ea$var$WellKnownSymbolsStore, name)) $bbf4e852bf6421ea$var$WellKnownSymbolsStore[name] = $13a8cd52720b8bb7$exports && $1ad0c60d8de14c83$exports($bbf4e852bf6421ea$var$Symbol, name) ? $bbf4e852bf6421ea$var$Symbol[name] : $bbf4e852bf6421ea$var$createWellKnownSymbol("Symbol." + name);
    return $bbf4e852bf6421ea$var$WellKnownSymbolsStore[name];
};


var $1cf67f83396a1488$var$$TypeError = TypeError;
var $1cf67f83396a1488$var$TO_PRIMITIVE = $bbf4e852bf6421ea$exports("toPrimitive");
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
$1cf67f83396a1488$exports = function(input, pref) {
    if (!$06f10e9b9cb1418c$exports(input) || $81db9cf3baf84d30$exports(input)) return input;
    var exoticToPrim = $a1d58592526cda62$exports(input, $1cf67f83396a1488$var$TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = "default";
        result = $2f17e9746e5fde89$exports(exoticToPrim, input, pref);
        if (!$06f10e9b9cb1418c$exports(result) || $81db9cf3baf84d30$exports(result)) return result;
        throw new $1cf67f83396a1488$var$$TypeError("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = "number";
    return $8b0aecfa24fa1949$exports(input, pref);
};



// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
$4dbc0d7468e7eb76$exports = function(argument) {
    var key = $1cf67f83396a1488$exports(argument, "string");
    return $81db9cf3baf84d30$exports(key) ? key : key + "";
};



var $c4e7e7941e2a9829$exports = {};
"use strict";


var $5b8a2493ea30b53c$exports = {};
"use strict";


var $5b8a2493ea30b53c$var$document = $212fa519f4bef41a$exports.document;
// typeof document.createElement is 'object' in old IE
var $5b8a2493ea30b53c$var$EXISTS = $06f10e9b9cb1418c$exports($5b8a2493ea30b53c$var$document) && $06f10e9b9cb1418c$exports($5b8a2493ea30b53c$var$document.createElement);
$5b8a2493ea30b53c$exports = function(it) {
    return $5b8a2493ea30b53c$var$EXISTS ? $5b8a2493ea30b53c$var$document.createElement(it) : {};
};


// Thanks to IE8 for its funny defineProperty
$c4e7e7941e2a9829$exports = !$16b43a02da62cc11$exports && !$217c917c4f59b359$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty($5b8a2493ea30b53c$exports("div"), "a", {
        get: function() {
            return 7;
        }
    }).a !== 7;
});


// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $3cd2e4c9005c1909$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
$3cd2e4c9005c1909$export$2d1720544b23b823 = $16b43a02da62cc11$exports ? $3cd2e4c9005c1909$var$$getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = $1a94a489a7afc329$exports(O);
    P = $4dbc0d7468e7eb76$exports(P);
    if ($c4e7e7941e2a9829$exports) try {
        return $3cd2e4c9005c1909$var$$getOwnPropertyDescriptor(O, P);
    } catch (error) {}
    if ($1ad0c60d8de14c83$exports(O, P)) return $819ae5875a6bb120$exports(!$2f17e9746e5fde89$exports($f6b684d67cc87fbe$export$2d1720544b23b823, O, P), O[P]);
};


var $ef48c8e0540d6569$require$getOwnPropertyDescriptor = $3cd2e4c9005c1909$export$2d1720544b23b823;
var $cbffb6e18a252dcf$exports = {};
"use strict";

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var $0163cc0a742cd3ad$export$2d1720544b23b823;
"use strict";


var $4b254bfc883d2a2e$exports = {};
"use strict";


// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
$4b254bfc883d2a2e$exports = $16b43a02da62cc11$exports && $217c917c4f59b359$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, "prototype", {
        value: 42,
        writable: false
    }).prototype !== 42;
});


var $affc609f2393bdba$exports = {};
"use strict";

var $affc609f2393bdba$var$$String = String;
var $affc609f2393bdba$var$$TypeError = TypeError;
// `Assert: Type(argument) is Object`
$affc609f2393bdba$exports = function(argument) {
    if ($06f10e9b9cb1418c$exports(argument)) return argument;
    throw new $affc609f2393bdba$var$$TypeError($affc609f2393bdba$var$$String(argument) + " is not an object");
};



var $0163cc0a742cd3ad$var$$TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $0163cc0a742cd3ad$var$$defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $0163cc0a742cd3ad$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $0163cc0a742cd3ad$var$ENUMERABLE = "enumerable";
var $0163cc0a742cd3ad$var$CONFIGURABLE = "configurable";
var $0163cc0a742cd3ad$var$WRITABLE = "writable";
$0163cc0a742cd3ad$export$2d1720544b23b823 = $16b43a02da62cc11$exports ? $4b254bfc883d2a2e$exports ? function defineProperty(O, P, Attributes) {
    $affc609f2393bdba$exports(O);
    P = $4dbc0d7468e7eb76$exports(P);
    $affc609f2393bdba$exports(Attributes);
    if (typeof O === "function" && P === "prototype" && "value" in Attributes && $0163cc0a742cd3ad$var$WRITABLE in Attributes && !Attributes[$0163cc0a742cd3ad$var$WRITABLE]) {
        var current = $0163cc0a742cd3ad$var$$getOwnPropertyDescriptor(O, P);
        if (current && current[$0163cc0a742cd3ad$var$WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: $0163cc0a742cd3ad$var$CONFIGURABLE in Attributes ? Attributes[$0163cc0a742cd3ad$var$CONFIGURABLE] : current[$0163cc0a742cd3ad$var$CONFIGURABLE],
                enumerable: $0163cc0a742cd3ad$var$ENUMERABLE in Attributes ? Attributes[$0163cc0a742cd3ad$var$ENUMERABLE] : current[$0163cc0a742cd3ad$var$ENUMERABLE],
                writable: false
            };
        }
    }
    return $0163cc0a742cd3ad$var$$defineProperty(O, P, Attributes);
} : $0163cc0a742cd3ad$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $affc609f2393bdba$exports(O);
    P = $4dbc0d7468e7eb76$exports(P);
    $affc609f2393bdba$exports(Attributes);
    if ($c4e7e7941e2a9829$exports) try {
        return $0163cc0a742cd3ad$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ("get" in Attributes || "set" in Attributes) throw new $0163cc0a742cd3ad$var$$TypeError("Accessors not supported");
    if ("value" in Attributes) O[P] = Attributes.value;
    return O;
};



$cbffb6e18a252dcf$exports = $16b43a02da62cc11$exports ? function(object, key, value) {
    return $0163cc0a742cd3ad$export$2d1720544b23b823(object, key, $819ae5875a6bb120$exports(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};


var $5cabf6b3204ed174$exports = {};
"use strict";


var $bb0a70fb6b8037e2$exports = {};
"use strict";





var $b6b3da709b860269$exports = {};
"use strict";


var $b6b3da709b860269$var$FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $b6b3da709b860269$var$getDescriptor = $16b43a02da62cc11$exports && Object.getOwnPropertyDescriptor;
var $b6b3da709b860269$var$EXISTS = $1ad0c60d8de14c83$exports($b6b3da709b860269$var$FunctionPrototype, "name");
// additional protection from minified / mangled / dropped function names
var $b6b3da709b860269$var$PROPER = $b6b3da709b860269$var$EXISTS && (function something() {}).name === "something";
var $b6b3da709b860269$var$CONFIGURABLE = $b6b3da709b860269$var$EXISTS && (!$16b43a02da62cc11$exports || $16b43a02da62cc11$exports && $b6b3da709b860269$var$getDescriptor($b6b3da709b860269$var$FunctionPrototype, "name").configurable);
$b6b3da709b860269$exports = {
    EXISTS: $b6b3da709b860269$var$EXISTS,
    PROPER: $b6b3da709b860269$var$PROPER,
    CONFIGURABLE: $b6b3da709b860269$var$CONFIGURABLE
};


var $bb0a70fb6b8037e2$require$CONFIGURABLE_FUNCTION_NAME = $b6b3da709b860269$exports.CONFIGURABLE;
var $d96e0a7b2ae7b4d6$exports = {};
"use strict";



var $d96e0a7b2ae7b4d6$var$functionToString = $c201050ed73b14ba$exports(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!$73d1a34d94fa4c35$exports($edea88028f2ac210$exports.inspectSource)) $edea88028f2ac210$exports.inspectSource = function(it) {
    return $d96e0a7b2ae7b4d6$var$functionToString(it);
};
$d96e0a7b2ae7b4d6$exports = $edea88028f2ac210$exports.inspectSource;


var $954a2ea894ec1c9c$exports = {};
"use strict";
var $1b936cf6730f1f56$exports = {};
"use strict";


var $1b936cf6730f1f56$var$WeakMap = $212fa519f4bef41a$exports.WeakMap;
$1b936cf6730f1f56$exports = $73d1a34d94fa4c35$exports($1b936cf6730f1f56$var$WeakMap) && /native code/.test(String($1b936cf6730f1f56$var$WeakMap));







var $923aeb444d932325$exports = {};
"use strict";


var $923aeb444d932325$var$keys = $32a869ed71ece4be$exports("keys");
$923aeb444d932325$exports = function(key) {
    return $923aeb444d932325$var$keys[key] || ($923aeb444d932325$var$keys[key] = $280519a5ebb3eef0$exports(key));
};


var $b993c2c9b79c8bdc$exports = {};
"use strict";
$b993c2c9b79c8bdc$exports = {};


var $954a2ea894ec1c9c$var$OBJECT_ALREADY_INITIALIZED = "Object already initialized";
var $954a2ea894ec1c9c$var$TypeError = $212fa519f4bef41a$exports.TypeError;
var $954a2ea894ec1c9c$var$WeakMap = $212fa519f4bef41a$exports.WeakMap;
var $954a2ea894ec1c9c$var$set, $954a2ea894ec1c9c$var$get, $954a2ea894ec1c9c$var$has;
var $954a2ea894ec1c9c$var$enforce = function(it) {
    return $954a2ea894ec1c9c$var$has(it) ? $954a2ea894ec1c9c$var$get(it) : $954a2ea894ec1c9c$var$set(it, {});
};
var $954a2ea894ec1c9c$var$getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!$06f10e9b9cb1418c$exports(it) || (state = $954a2ea894ec1c9c$var$get(it)).type !== TYPE) throw new $954a2ea894ec1c9c$var$TypeError("Incompatible receiver, " + TYPE + " required");
        return state;
    };
};
if ($1b936cf6730f1f56$exports || $edea88028f2ac210$exports.state) {
    var $954a2ea894ec1c9c$var$store = $edea88028f2ac210$exports.state || ($edea88028f2ac210$exports.state = new $954a2ea894ec1c9c$var$WeakMap());
    /* eslint-disable no-self-assign -- prototype methods protection */ $954a2ea894ec1c9c$var$store.get = $954a2ea894ec1c9c$var$store.get;
    $954a2ea894ec1c9c$var$store.has = $954a2ea894ec1c9c$var$store.has;
    $954a2ea894ec1c9c$var$store.set = $954a2ea894ec1c9c$var$store.set;
    /* eslint-enable no-self-assign -- prototype methods protection */ $954a2ea894ec1c9c$var$set = function(it, metadata) {
        if ($954a2ea894ec1c9c$var$store.has(it)) throw new $954a2ea894ec1c9c$var$TypeError($954a2ea894ec1c9c$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $954a2ea894ec1c9c$var$store.set(it, metadata);
        return metadata;
    };
    $954a2ea894ec1c9c$var$get = function(it) {
        return $954a2ea894ec1c9c$var$store.get(it) || {};
    };
    $954a2ea894ec1c9c$var$has = function(it) {
        return $954a2ea894ec1c9c$var$store.has(it);
    };
} else {
    var $954a2ea894ec1c9c$var$STATE = $923aeb444d932325$exports("state");
    $b993c2c9b79c8bdc$exports[$954a2ea894ec1c9c$var$STATE] = true;
    $954a2ea894ec1c9c$var$set = function(it, metadata) {
        if ($1ad0c60d8de14c83$exports(it, $954a2ea894ec1c9c$var$STATE)) throw new $954a2ea894ec1c9c$var$TypeError($954a2ea894ec1c9c$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $cbffb6e18a252dcf$exports(it, $954a2ea894ec1c9c$var$STATE, metadata);
        return metadata;
    };
    $954a2ea894ec1c9c$var$get = function(it) {
        return $1ad0c60d8de14c83$exports(it, $954a2ea894ec1c9c$var$STATE) ? it[$954a2ea894ec1c9c$var$STATE] : {};
    };
    $954a2ea894ec1c9c$var$has = function(it) {
        return $1ad0c60d8de14c83$exports(it, $954a2ea894ec1c9c$var$STATE);
    };
}
$954a2ea894ec1c9c$exports = {
    set: $954a2ea894ec1c9c$var$set,
    get: $954a2ea894ec1c9c$var$get,
    has: $954a2ea894ec1c9c$var$has,
    enforce: $954a2ea894ec1c9c$var$enforce,
    getterFor: $954a2ea894ec1c9c$var$getterFor
};


var $bb0a70fb6b8037e2$var$enforceInternalState = $954a2ea894ec1c9c$exports.enforce;
var $bb0a70fb6b8037e2$var$getInternalState = $954a2ea894ec1c9c$exports.get;
var $bb0a70fb6b8037e2$var$$String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $bb0a70fb6b8037e2$var$defineProperty = Object.defineProperty;
var $bb0a70fb6b8037e2$var$stringSlice = $c201050ed73b14ba$exports("".slice);
var $bb0a70fb6b8037e2$var$replace = $c201050ed73b14ba$exports("".replace);
var $bb0a70fb6b8037e2$var$join = $c201050ed73b14ba$exports([].join);
var $bb0a70fb6b8037e2$var$CONFIGURABLE_LENGTH = $16b43a02da62cc11$exports && !$217c917c4f59b359$exports(function() {
    return $bb0a70fb6b8037e2$var$defineProperty(function() {}, "length", {
        value: 8
    }).length !== 8;
});
var $bb0a70fb6b8037e2$var$TEMPLATE = String(String).split("String");
var $bb0a70fb6b8037e2$var$makeBuiltIn = $bb0a70fb6b8037e2$exports = function(value, name, options) {
    if ($bb0a70fb6b8037e2$var$stringSlice($bb0a70fb6b8037e2$var$$String(name), 0, 7) === "Symbol(") name = "[" + $bb0a70fb6b8037e2$var$replace($bb0a70fb6b8037e2$var$$String(name), /^Symbol\(([^)]*)\)/, "$1") + "]";
    if (options && options.getter) name = "get " + name;
    if (options && options.setter) name = "set " + name;
    if (!$1ad0c60d8de14c83$exports(value, "name") || $bb0a70fb6b8037e2$require$CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
        if ($16b43a02da62cc11$exports) $bb0a70fb6b8037e2$var$defineProperty(value, "name", {
            value: name,
            configurable: true
        });
        else value.name = name;
    }
    if ($bb0a70fb6b8037e2$var$CONFIGURABLE_LENGTH && options && $1ad0c60d8de14c83$exports(options, "arity") && value.length !== options.arity) $bb0a70fb6b8037e2$var$defineProperty(value, "length", {
        value: options.arity
    });
    try {
        if (options && $1ad0c60d8de14c83$exports(options, "constructor") && options.constructor) {
            if ($16b43a02da62cc11$exports) $bb0a70fb6b8037e2$var$defineProperty(value, "prototype", {
                writable: false
            });
        } else if (value.prototype) value.prototype = undefined;
    } catch (error) {}
    var state = $bb0a70fb6b8037e2$var$enforceInternalState(value);
    if (!$1ad0c60d8de14c83$exports(state, "source")) state.source = $bb0a70fb6b8037e2$var$join($bb0a70fb6b8037e2$var$TEMPLATE, typeof name == "string" ? name : "");
    return value;
};
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = $bb0a70fb6b8037e2$var$makeBuiltIn(function toString() {
    return $73d1a34d94fa4c35$exports(this) && $bb0a70fb6b8037e2$var$getInternalState(this).source || $d96e0a7b2ae7b4d6$exports(this);
}, "toString");



$5cabf6b3204ed174$exports = function(O, key, value, options) {
    if (!options) options = {};
    var simple = options.enumerable;
    var name = options.name !== undefined ? options.name : key;
    if ($73d1a34d94fa4c35$exports(value)) $bb0a70fb6b8037e2$exports(value, name, options);
    if (options.global) {
        if (simple) O[key] = value;
        else $2e7a1c6196ae4181$exports(key, value);
    } else {
        try {
            if (!options.unsafe) delete O[key];
            else if (O[key]) simple = true;
        } catch (error) {}
        if (simple) O[key] = value;
        else $0163cc0a742cd3ad$export$2d1720544b23b823(O, key, {
            value: value,
            enumerable: false,
            configurable: !options.nonConfigurable,
            writable: !options.nonWritable
        });
    }
    return O;
};



var $3e579e5e62b22d47$exports = {};
"use strict";

var $64b3906f2399e484$exports = {};
"use strict";


// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
var $f54839ff0ad1f1b7$export$2d1720544b23b823;
"use strict";
var $0e5b20725775546f$exports = {};
"use strict";



var $e93c8db5f87bfe6d$exports = {};
"use strict";

var $7510e5f178952714$exports = {};
"use strict";
var $8d76b52b36a52486$exports = {};
"use strict";
var $4a26ea1a48711e4b$exports = {};
"use strict";
var $4a26ea1a48711e4b$var$ceil = Math.ceil;
var $4a26ea1a48711e4b$var$floor = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
$4a26ea1a48711e4b$exports = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? $4a26ea1a48711e4b$var$floor : $4a26ea1a48711e4b$var$ceil)(n);
};


// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
$8d76b52b36a52486$exports = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : $4a26ea1a48711e4b$exports(number);
};


var $7510e5f178952714$var$max = Math.max;
var $7510e5f178952714$var$min = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
$7510e5f178952714$exports = function(index, length) {
    var integer = $8d76b52b36a52486$exports(index);
    return integer < 0 ? $7510e5f178952714$var$max(integer + length, 0) : $7510e5f178952714$var$min(integer, length);
};


var $3f18e45666a111c8$exports = {};
"use strict";
var $a46f106a02f96447$exports = {};
"use strict";

var $a46f106a02f96447$var$min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
$a46f106a02f96447$exports = function(argument) {
    return argument > 0 ? $a46f106a02f96447$var$min($8d76b52b36a52486$exports(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
$3f18e45666a111c8$exports = function(obj) {
    return $a46f106a02f96447$exports(obj.length);
};


// `Array.prototype.{ indexOf, includes }` methods implementation
var $e93c8db5f87bfe6d$var$createMethod = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $1a94a489a7afc329$exports($this);
        var length = $3f18e45666a111c8$exports(O);
        var index = $7510e5f178952714$exports(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el !== el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value !== value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
$e93c8db5f87bfe6d$exports = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $e93c8db5f87bfe6d$var$createMethod(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $e93c8db5f87bfe6d$var$createMethod(false)
};


var $0e5b20725775546f$require$indexOf = $e93c8db5f87bfe6d$exports.indexOf;

var $0e5b20725775546f$var$push = $c201050ed73b14ba$exports([].push);
$0e5b20725775546f$exports = function(object, names) {
    var O = $1a94a489a7afc329$exports(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$1ad0c60d8de14c83$exports($b993c2c9b79c8bdc$exports, key) && $1ad0c60d8de14c83$exports(O, key) && $0e5b20725775546f$var$push(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($1ad0c60d8de14c83$exports(O, key = names[i++])) ~$0e5b20725775546f$require$indexOf(result, key) || $0e5b20725775546f$var$push(result, key);
    return result;
};


var $31fbe93812db4cd8$exports = {};
"use strict";
// IE8- don't enum bug keys
$31fbe93812db4cd8$exports = [
    "constructor",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
];


var $f54839ff0ad1f1b7$var$hiddenKeys = $31fbe93812db4cd8$exports.concat("length", "prototype");
$f54839ff0ad1f1b7$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $0e5b20725775546f$exports(O, $f54839ff0ad1f1b7$var$hiddenKeys);
};


// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
var $bb2b38985ad7e191$export$2d1720544b23b823;
"use strict";
$bb2b38985ad7e191$export$2d1720544b23b823 = Object.getOwnPropertySymbols;



var $64b3906f2399e484$var$concat = $c201050ed73b14ba$exports([].concat);
// all object keys, includes non-enumerable and symbols
$64b3906f2399e484$exports = $3e824c856d81a8e3$exports("Reflect", "ownKeys") || function ownKeys(it) {
    var keys = $f54839ff0ad1f1b7$export$2d1720544b23b823($affc609f2393bdba$exports(it));
    var getOwnPropertySymbols = $bb2b38985ad7e191$export$2d1720544b23b823;
    return getOwnPropertySymbols ? $64b3906f2399e484$var$concat(keys, getOwnPropertySymbols(it)) : keys;
};




$3e579e5e62b22d47$exports = function(target, source, exceptions) {
    var keys = $64b3906f2399e484$exports(source);
    var defineProperty = $0163cc0a742cd3ad$export$2d1720544b23b823;
    var getOwnPropertyDescriptor = $3cd2e4c9005c1909$export$2d1720544b23b823;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$1ad0c60d8de14c83$exports(target, key) && !(exceptions && $1ad0c60d8de14c83$exports(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};


var $e48b32723d42f00b$exports = {};
"use strict";


var $e48b32723d42f00b$var$replacement = /#|\.prototype\./;
var $e48b32723d42f00b$var$isForced = function(feature, detection) {
    var value = $e48b32723d42f00b$var$data[$e48b32723d42f00b$var$normalize(feature)];
    return value === $e48b32723d42f00b$var$POLYFILL ? true : value === $e48b32723d42f00b$var$NATIVE ? false : $73d1a34d94fa4c35$exports(detection) ? $217c917c4f59b359$exports(detection) : !!detection;
};
var $e48b32723d42f00b$var$normalize = $e48b32723d42f00b$var$isForced.normalize = function(string) {
    return String(string).replace($e48b32723d42f00b$var$replacement, ".").toLowerCase();
};
var $e48b32723d42f00b$var$data = $e48b32723d42f00b$var$isForced.data = {};
var $e48b32723d42f00b$var$NATIVE = $e48b32723d42f00b$var$isForced.NATIVE = "N";
var $e48b32723d42f00b$var$POLYFILL = $e48b32723d42f00b$var$isForced.POLYFILL = "P";
$e48b32723d42f00b$exports = $e48b32723d42f00b$var$isForced;


/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ $ef48c8e0540d6569$exports = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = $212fa519f4bef41a$exports;
    else if (STATIC) target = $212fa519f4bef41a$exports[TARGET] || $2e7a1c6196ae4181$exports(TARGET, {});
    else target = ($212fa519f4bef41a$exports[TARGET] || {}).prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.dontCallGetSet) {
            descriptor = $ef48c8e0540d6569$require$getOwnPropertyDescriptor(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = $e48b32723d42f00b$exports(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if (typeof sourceProperty == typeof targetProperty) continue;
            $3e579e5e62b22d47$exports(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) $cbffb6e18a252dcf$exports(sourceProperty, "sham", true);
        $5cabf6b3204ed174$exports(target, key, sourceProperty, options);
    }
};








var $5eca6f9e01902ab4$exports = {};
"use strict";
var $7d156d7c862bc268$exports = {};
"use strict";
var $9c619e8002f331af$exports = {};
"use strict";

var $9c619e8002f331af$var$TO_STRING_TAG = $bbf4e852bf6421ea$exports("toStringTag");
var $9c619e8002f331af$var$test = {};
$9c619e8002f331af$var$test[$9c619e8002f331af$var$TO_STRING_TAG] = "z";
$9c619e8002f331af$exports = String($9c619e8002f331af$var$test) === "[object z]";





var $7d156d7c862bc268$var$TO_STRING_TAG = $bbf4e852bf6421ea$exports("toStringTag");
var $7d156d7c862bc268$var$$Object = Object;
// ES3 wrong here
var $7d156d7c862bc268$var$CORRECT_ARGUMENTS = $7f55bdfec0ad037d$exports(function() {
    return arguments;
}()) === "Arguments";
// fallback for IE11 Script Access Denied error
var $7d156d7c862bc268$var$tryGet = function(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
$7d156d7c862bc268$exports = $9c619e8002f331af$exports ? $7f55bdfec0ad037d$exports : function(it) {
    var O, tag, result;
    return it === undefined ? "Undefined" : it === null ? "Null" : typeof (tag = $7d156d7c862bc268$var$tryGet(O = $7d156d7c862bc268$var$$Object(it), $7d156d7c862bc268$var$TO_STRING_TAG)) == "string" ? tag : $7d156d7c862bc268$var$CORRECT_ARGUMENTS ? $7f55bdfec0ad037d$exports(O) : (result = $7f55bdfec0ad037d$exports(O)) === "Object" && $73d1a34d94fa4c35$exports(O.callee) ? "Arguments" : result;
};


var $5eca6f9e01902ab4$var$$String = String;
$5eca6f9e01902ab4$exports = function(argument) {
    if ($7d156d7c862bc268$exports(argument) === "Symbol") throw new TypeError("Cannot convert a Symbol value to a string");
    return $5eca6f9e01902ab4$var$$String(argument);
};


var $4dba431ca752b815$exports = {};
"use strict";


$4dba431ca752b815$exports = function(target, name, descriptor) {
    if (descriptor.get) $bb0a70fb6b8037e2$exports(descriptor.get, name, {
        getter: true
    });
    if (descriptor.set) $bb0a70fb6b8037e2$exports(descriptor.set, name, {
        setter: true
    });
    return $0163cc0a742cd3ad$export$2d1720544b23b823(target, name, descriptor);
};



var $85e057b4caccfc2b$var$NativeSymbol = $212fa519f4bef41a$exports.Symbol;
var $85e057b4caccfc2b$var$SymbolPrototype = $85e057b4caccfc2b$var$NativeSymbol && $85e057b4caccfc2b$var$NativeSymbol.prototype;
if ($16b43a02da62cc11$exports && $73d1a34d94fa4c35$exports($85e057b4caccfc2b$var$NativeSymbol) && (!("description" in $85e057b4caccfc2b$var$SymbolPrototype) || // Safari 12 bug
$85e057b4caccfc2b$var$NativeSymbol().description !== undefined)) {
    var $85e057b4caccfc2b$var$EmptyStringDescriptionStore = {};
    // wrap Symbol constructor for correct work with undefined description
    var $85e057b4caccfc2b$var$SymbolWrapper = function Symbol() {
        var description = arguments.length < 1 || arguments[0] === undefined ? undefined : $5eca6f9e01902ab4$exports(arguments[0]);
        var result = $dba85d7bd7ffe0d7$exports($85e057b4caccfc2b$var$SymbolPrototype, this) ? new $85e057b4caccfc2b$var$NativeSymbol(description) : description === undefined ? $85e057b4caccfc2b$var$NativeSymbol() : $85e057b4caccfc2b$var$NativeSymbol(description);
        if (description === "") $85e057b4caccfc2b$var$EmptyStringDescriptionStore[result] = true;
        return result;
    };
    $3e579e5e62b22d47$exports($85e057b4caccfc2b$var$SymbolWrapper, $85e057b4caccfc2b$var$NativeSymbol);
    $85e057b4caccfc2b$var$SymbolWrapper.prototype = $85e057b4caccfc2b$var$SymbolPrototype;
    $85e057b4caccfc2b$var$SymbolPrototype.constructor = $85e057b4caccfc2b$var$SymbolWrapper;
    var $85e057b4caccfc2b$var$NATIVE_SYMBOL = String($85e057b4caccfc2b$var$NativeSymbol("description detection")) === "Symbol(description detection)";
    var $85e057b4caccfc2b$var$thisSymbolValue = $c201050ed73b14ba$exports($85e057b4caccfc2b$var$SymbolPrototype.valueOf);
    var $85e057b4caccfc2b$var$symbolDescriptiveString = $c201050ed73b14ba$exports($85e057b4caccfc2b$var$SymbolPrototype.toString);
    var $85e057b4caccfc2b$var$regexp = /^Symbol\((.*)\)[^)]+$/;
    var $85e057b4caccfc2b$var$replace = $c201050ed73b14ba$exports("".replace);
    var $85e057b4caccfc2b$var$stringSlice = $c201050ed73b14ba$exports("".slice);
    $4dba431ca752b815$exports($85e057b4caccfc2b$var$SymbolPrototype, "description", {
        configurable: true,
        get: function description() {
            var symbol = $85e057b4caccfc2b$var$thisSymbolValue(this);
            if ($1ad0c60d8de14c83$exports($85e057b4caccfc2b$var$EmptyStringDescriptionStore, symbol)) return "";
            var string = $85e057b4caccfc2b$var$symbolDescriptiveString(symbol);
            var desc = $85e057b4caccfc2b$var$NATIVE_SYMBOL ? $85e057b4caccfc2b$var$stringSlice(string, 7, -1) : $85e057b4caccfc2b$var$replace(string, $85e057b4caccfc2b$var$regexp, "$1");
            return desc === "" ? undefined : desc;
        }
    });
    $ef48c8e0540d6569$exports({
        global: true,
        constructor: true,
        forced: true
    }, {
        Symbol: $85e057b4caccfc2b$var$SymbolWrapper
    });
}


"use strict";
var $83de97535578578d$exports = {};
"use strict";
var $327350c306bb60e2$exports = {};
"use strict";

$327350c306bb60e2$exports = $212fa519f4bef41a$exports;



var $18afa6e0c6c29677$export$2d1720544b23b823;
"use strict";

$18afa6e0c6c29677$export$2d1720544b23b823 = $bbf4e852bf6421ea$exports;



var $83de97535578578d$require$defineProperty = $0163cc0a742cd3ad$export$2d1720544b23b823;
$83de97535578578d$exports = function(NAME) {
    var Symbol = $327350c306bb60e2$exports.Symbol || ($327350c306bb60e2$exports.Symbol = {});
    if (!$1ad0c60d8de14c83$exports(Symbol, NAME)) $83de97535578578d$require$defineProperty(Symbol, NAME, {
        value: $18afa6e0c6c29677$export$2d1720544b23b823(NAME)
    });
};


// `Symbol.asyncIterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.asynciterator
$83de97535578578d$exports("asyncIterator");


"use strict";

// `Symbol.match` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.match
$83de97535578578d$exports("match");


"use strict";

// `Symbol.replace` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.replace
$83de97535578578d$exports("replace");


"use strict";

// `Symbol.search` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.search
$83de97535578578d$exports("search");


"use strict";

// `Symbol.split` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.split
$83de97535578578d$exports("split");


"use strict";

var $583a8d6fc5e45201$exports = {};
"use strict";
var $f5ba607f4800b671$exports = {};
"use strict";

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
$f5ba607f4800b671$exports = Array.isArray || function isArray(argument) {
    return $7f55bdfec0ad037d$exports(argument) === "Array";
};



var $56d0daeb4987f8b0$exports = {};
"use strict";
var $56d0daeb4987f8b0$var$$TypeError = TypeError;
var $56d0daeb4987f8b0$var$MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991
$56d0daeb4987f8b0$exports = function(it) {
    if (it > $56d0daeb4987f8b0$var$MAX_SAFE_INTEGER) throw $56d0daeb4987f8b0$var$$TypeError("Maximum allowed index exceeded");
    return it;
};


var $2db6a9f70c481925$exports = {};
"use strict";
var $46453aed9e51860f$exports = {};
"use strict";


$46453aed9e51860f$exports = function(fn) {
    // Nashorn bug:
    //   https://github.com/zloirock/core-js/issues/1128
    //   https://github.com/zloirock/core-js/issues/1130
    if ($7f55bdfec0ad037d$exports(fn) === "Function") return $c201050ed73b14ba$exports(fn);
};




var $2db6a9f70c481925$var$bind = $46453aed9e51860f$exports($46453aed9e51860f$exports.bind);
// optional / simple context binding
$2db6a9f70c481925$exports = function(fn, that) {
    $6df447ad4be37421$exports(fn);
    return that === undefined ? fn : $4da6c0a05b2e762d$exports ? $2db6a9f70c481925$var$bind(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};


// `FlattenIntoArray` abstract operation
// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var $583a8d6fc5e45201$var$flattenIntoArray = function(target, original, source, sourceLen, start, depth, mapper, thisArg) {
    var targetIndex = start;
    var sourceIndex = 0;
    var mapFn = mapper ? $2db6a9f70c481925$exports(mapper, thisArg) : false;
    var element, elementLen;
    while(sourceIndex < sourceLen){
        if (sourceIndex in source) {
            element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];
            if (depth > 0 && $f5ba607f4800b671$exports(element)) {
                elementLen = $3f18e45666a111c8$exports(element);
                targetIndex = $583a8d6fc5e45201$var$flattenIntoArray(target, original, element, elementLen, targetIndex, depth - 1) - 1;
            } else {
                $56d0daeb4987f8b0$exports(targetIndex + 1);
                target[targetIndex] = element;
            }
            targetIndex++;
        }
        sourceIndex++;
    }
    return targetIndex;
};
$583a8d6fc5e45201$exports = $583a8d6fc5e45201$var$flattenIntoArray;





var $5bb6f939df74d76a$exports = {};
"use strict";
var $7c4023b24e61f2cc$exports = {};
"use strict";

var $f9bc962f91baa4bd$exports = {};
"use strict";






var $f9bc962f91baa4bd$var$noop = function() {};
var $f9bc962f91baa4bd$var$empty = [];
var $f9bc962f91baa4bd$var$construct = $3e824c856d81a8e3$exports("Reflect", "construct");
var $f9bc962f91baa4bd$var$constructorRegExp = /^\s*(?:class|function)\b/;
var $f9bc962f91baa4bd$var$exec = $c201050ed73b14ba$exports($f9bc962f91baa4bd$var$constructorRegExp.exec);
var $f9bc962f91baa4bd$var$INCORRECT_TO_STRING = !$f9bc962f91baa4bd$var$constructorRegExp.test($f9bc962f91baa4bd$var$noop);
var $f9bc962f91baa4bd$var$isConstructorModern = function isConstructor(argument) {
    if (!$73d1a34d94fa4c35$exports(argument)) return false;
    try {
        $f9bc962f91baa4bd$var$construct($f9bc962f91baa4bd$var$noop, $f9bc962f91baa4bd$var$empty, argument);
        return true;
    } catch (error) {
        return false;
    }
};
var $f9bc962f91baa4bd$var$isConstructorLegacy = function isConstructor(argument) {
    if (!$73d1a34d94fa4c35$exports(argument)) return false;
    switch($7d156d7c862bc268$exports(argument)){
        case "AsyncFunction":
        case "GeneratorFunction":
        case "AsyncGeneratorFunction":
            return false;
    }
    try {
        // we can't check .prototype since constructors produced by .bind haven't it
        // `Function#toString` throws on some built-it function in some legacy engines
        // (for example, `DOMQuad` and similar in FF41-)
        return $f9bc962f91baa4bd$var$INCORRECT_TO_STRING || !!$f9bc962f91baa4bd$var$exec($f9bc962f91baa4bd$var$constructorRegExp, $d96e0a7b2ae7b4d6$exports(argument));
    } catch (error) {
        return true;
    }
};
$f9bc962f91baa4bd$var$isConstructorLegacy.sham = true;
// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
$f9bc962f91baa4bd$exports = !$f9bc962f91baa4bd$var$construct || $217c917c4f59b359$exports(function() {
    var called;
    return $f9bc962f91baa4bd$var$isConstructorModern($f9bc962f91baa4bd$var$isConstructorModern.call) || !$f9bc962f91baa4bd$var$isConstructorModern(Object) || !$f9bc962f91baa4bd$var$isConstructorModern(function() {
        called = true;
    }) || called;
}) ? $f9bc962f91baa4bd$var$isConstructorLegacy : $f9bc962f91baa4bd$var$isConstructorModern;




var $7c4023b24e61f2cc$var$SPECIES = $bbf4e852bf6421ea$exports("species");
var $7c4023b24e61f2cc$var$$Array = Array;
// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
$7c4023b24e61f2cc$exports = function(originalArray) {
    var C;
    if ($f5ba607f4800b671$exports(originalArray)) {
        C = originalArray.constructor;
        // cross-realm fallback
        if ($f9bc962f91baa4bd$exports(C) && (C === $7c4023b24e61f2cc$var$$Array || $f5ba607f4800b671$exports(C.prototype))) C = undefined;
        else if ($06f10e9b9cb1418c$exports(C)) {
            C = C[$7c4023b24e61f2cc$var$SPECIES];
            if (C === null) C = undefined;
        }
    }
    return C === undefined ? $7c4023b24e61f2cc$var$$Array : C;
};


// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
$5bb6f939df74d76a$exports = function(originalArray, length) {
    return new ($7c4023b24e61f2cc$exports(originalArray))(length === 0 ? 0 : length);
};


// `Array.prototype.flat` method
// https://tc39.es/ecma262/#sec-array.prototype.flat
$ef48c8e0540d6569$exports({
    target: "Array",
    proto: true
}, {
    flat: function flat() {
        var depthArg = arguments.length ? arguments[0] : undefined;
        var O = $361c03d23168e423$exports(this);
        var sourceLen = $3f18e45666a111c8$exports(O);
        var A = $5bb6f939df74d76a$exports(O, 0);
        A.length = $583a8d6fc5e45201$exports(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : $8d76b52b36a52486$exports(depthArg));
        return A;
    }
});


"use strict";






// `Array.prototype.flatMap` method
// https://tc39.es/ecma262/#sec-array.prototype.flatmap
$ef48c8e0540d6569$exports({
    target: "Array",
    proto: true
}, {
    flatMap: function flatMap(callbackfn /* , thisArg */ ) {
        var O = $361c03d23168e423$exports(this);
        var sourceLen = $3f18e45666a111c8$exports(O);
        var A;
        $6df447ad4be37421$exports(callbackfn);
        A = $5bb6f939df74d76a$exports(O, 0);
        A.length = $583a8d6fc5e45201$exports(A, O, O, sourceLen, 0, 1, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        return A;
    }
});


"use strict";


var $426c3ec4a53d17a6$require$$includes = $e93c8db5f87bfe6d$exports.includes;

var $68464d161ed9088f$exports = {};
"use strict";

var $a98baaf21fc755e7$exports = {};
"use strict";

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
var $75692f7e20e6a0e4$export$2d1720544b23b823;
"use strict";





var $f5ab74bf375b4ea8$exports = {};
"use strict";


// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
$f5ab74bf375b4ea8$exports = Object.keys || function keys(O) {
    return $0e5b20725775546f$exports(O, $31fbe93812db4cd8$exports);
};


$75692f7e20e6a0e4$export$2d1720544b23b823 = $16b43a02da62cc11$exports && !$4b254bfc883d2a2e$exports ? Object.defineProperties : function defineProperties(O, Properties) {
    $affc609f2393bdba$exports(O);
    var props = $1a94a489a7afc329$exports(Properties);
    var keys = $f5ab74bf375b4ea8$exports(Properties);
    var length = keys.length;
    var index = 0;
    var key;
    while(length > index)$0163cc0a742cd3ad$export$2d1720544b23b823(O, key = keys[index++], props[key]);
    return O;
};




var $74eb1bae1f2deb49$exports = {};
"use strict";

$74eb1bae1f2deb49$exports = $3e824c856d81a8e3$exports("document", "documentElement");




var $a98baaf21fc755e7$var$GT = ">";
var $a98baaf21fc755e7$var$LT = "<";
var $a98baaf21fc755e7$var$PROTOTYPE = "prototype";
var $a98baaf21fc755e7$var$SCRIPT = "script";
var $a98baaf21fc755e7$var$IE_PROTO = $923aeb444d932325$exports("IE_PROTO");
var $a98baaf21fc755e7$var$EmptyConstructor = function() {};
var $a98baaf21fc755e7$var$scriptTag = function(content) {
    return $a98baaf21fc755e7$var$LT + $a98baaf21fc755e7$var$SCRIPT + $a98baaf21fc755e7$var$GT + content + $a98baaf21fc755e7$var$LT + "/" + $a98baaf21fc755e7$var$SCRIPT + $a98baaf21fc755e7$var$GT;
};
// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var $a98baaf21fc755e7$var$NullProtoObjectViaActiveX = function(activeXDocument) {
    activeXDocument.write($a98baaf21fc755e7$var$scriptTag(""));
    activeXDocument.close();
    var temp = activeXDocument.parentWindow.Object;
    activeXDocument = null; // avoid memory leak
    return temp;
};
// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $a98baaf21fc755e7$var$NullProtoObjectViaIFrame = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = $5b8a2493ea30b53c$exports("iframe");
    var JS = "java" + $a98baaf21fc755e7$var$SCRIPT + ":";
    var iframeDocument;
    iframe.style.display = "none";
    $74eb1bae1f2deb49$exports.appendChild(iframe);
    // https://github.com/zloirock/core-js/issues/475
    iframe.src = String(JS);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write($a98baaf21fc755e7$var$scriptTag("document.F=Object"));
    iframeDocument.close();
    return iframeDocument.F;
};
// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var $a98baaf21fc755e7$var$activeXDocument;
var $a98baaf21fc755e7$var$NullProtoObject = function() {
    try {
        $a98baaf21fc755e7$var$activeXDocument = new ActiveXObject("htmlfile");
    } catch (error) {}
    $a98baaf21fc755e7$var$NullProtoObject = typeof document != "undefined" ? document.domain && $a98baaf21fc755e7$var$activeXDocument ? $a98baaf21fc755e7$var$NullProtoObjectViaActiveX($a98baaf21fc755e7$var$activeXDocument) // old IE
     : $a98baaf21fc755e7$var$NullProtoObjectViaIFrame() : $a98baaf21fc755e7$var$NullProtoObjectViaActiveX($a98baaf21fc755e7$var$activeXDocument); // WSH
    var length = $31fbe93812db4cd8$exports.length;
    while(length--)delete $a98baaf21fc755e7$var$NullProtoObject[$a98baaf21fc755e7$var$PROTOTYPE][$31fbe93812db4cd8$exports[length]];
    return $a98baaf21fc755e7$var$NullProtoObject();
};
$b993c2c9b79c8bdc$exports[$a98baaf21fc755e7$var$IE_PROTO] = true;
// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
$a98baaf21fc755e7$exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $a98baaf21fc755e7$var$EmptyConstructor[$a98baaf21fc755e7$var$PROTOTYPE] = $affc609f2393bdba$exports(O);
        result = new $a98baaf21fc755e7$var$EmptyConstructor();
        $a98baaf21fc755e7$var$EmptyConstructor[$a98baaf21fc755e7$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$a98baaf21fc755e7$var$IE_PROTO] = O;
    } else result = $a98baaf21fc755e7$var$NullProtoObject();
    return Properties === undefined ? result : $75692f7e20e6a0e4$export$2d1720544b23b823(result, Properties);
};



var $68464d161ed9088f$require$defineProperty = $0163cc0a742cd3ad$export$2d1720544b23b823;
var $68464d161ed9088f$var$UNSCOPABLES = $bbf4e852bf6421ea$exports("unscopables");
var $68464d161ed9088f$var$ArrayPrototype = Array.prototype;
// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if ($68464d161ed9088f$var$ArrayPrototype[$68464d161ed9088f$var$UNSCOPABLES] === undefined) $68464d161ed9088f$require$defineProperty($68464d161ed9088f$var$ArrayPrototype, $68464d161ed9088f$var$UNSCOPABLES, {
    configurable: true,
    value: $a98baaf21fc755e7$exports(null)
});
// add a key to Array.prototype[@@unscopables]
$68464d161ed9088f$exports = function(key) {
    $68464d161ed9088f$var$ArrayPrototype[$68464d161ed9088f$var$UNSCOPABLES][key] = true;
};


// FF99+ bug
var $426c3ec4a53d17a6$var$BROKEN_ON_SPARSE = $217c917c4f59b359$exports(function() {
    // eslint-disable-next-line es/no-array-prototype-includes -- detection
    return !Array(1).includes();
});
// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$ef48c8e0540d6569$exports({
    target: "Array",
    proto: true,
    forced: $426c3ec4a53d17a6$var$BROKEN_ON_SPARSE
}, {
    includes: function includes(el /* , fromIndex = 0 */ ) {
        return $426c3ec4a53d17a6$require$$includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
    }
});
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$68464d161ed9088f$exports("includes");


var $ce79d5292b96d6e1$exports = {};
"use strict";


var $2d9742e698a8c85c$exports = {};
"use strict";
$2d9742e698a8c85c$exports = {};




var $ce79d5292b96d6e1$require$defineProperty = $0163cc0a742cd3ad$export$2d1720544b23b823;
var $c94c3df4a788abf5$exports = {};
"use strict";





var $8159770b7a97268e$exports = {};
"use strict";
var $d632d30036e49f43$exports = {};
"use strict";




var $e5c52a606c67a805$exports = {};
"use strict";




var $0c221e5255e905d5$exports = {};
"use strict";

$0c221e5255e905d5$exports = !$217c917c4f59b359$exports(function() {
    function F() {}
    F.prototype.constructor = null;
    // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
    return Object.getPrototypeOf(new F()) !== F.prototype;
});


var $e5c52a606c67a805$var$IE_PROTO = $923aeb444d932325$exports("IE_PROTO");
var $e5c52a606c67a805$var$$Object = Object;
var $e5c52a606c67a805$var$ObjectPrototype = $e5c52a606c67a805$var$$Object.prototype;
// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
$e5c52a606c67a805$exports = $0c221e5255e905d5$exports ? $e5c52a606c67a805$var$$Object.getPrototypeOf : function(O) {
    var object = $361c03d23168e423$exports(O);
    if ($1ad0c60d8de14c83$exports(object, $e5c52a606c67a805$var$IE_PROTO)) return object[$e5c52a606c67a805$var$IE_PROTO];
    var constructor = object.constructor;
    if ($73d1a34d94fa4c35$exports(constructor) && object instanceof constructor) return constructor.prototype;
    return object instanceof $e5c52a606c67a805$var$$Object ? $e5c52a606c67a805$var$ObjectPrototype : null;
};





var $d632d30036e49f43$var$ITERATOR = $bbf4e852bf6421ea$exports("iterator");
var $d632d30036e49f43$var$BUGGY_SAFARI_ITERATORS = false;
// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var $d632d30036e49f43$var$IteratorPrototype, $d632d30036e49f43$var$PrototypeOfArrayIteratorPrototype, $d632d30036e49f43$var$arrayIterator;
/* eslint-disable es/no-array-prototype-keys -- safe */ if ([].keys) {
    $d632d30036e49f43$var$arrayIterator = [].keys();
    // Safari 8 has buggy iterators w/o `next`
    if (!("next" in $d632d30036e49f43$var$arrayIterator)) $d632d30036e49f43$var$BUGGY_SAFARI_ITERATORS = true;
    else {
        $d632d30036e49f43$var$PrototypeOfArrayIteratorPrototype = $e5c52a606c67a805$exports($e5c52a606c67a805$exports($d632d30036e49f43$var$arrayIterator));
        if ($d632d30036e49f43$var$PrototypeOfArrayIteratorPrototype !== Object.prototype) $d632d30036e49f43$var$IteratorPrototype = $d632d30036e49f43$var$PrototypeOfArrayIteratorPrototype;
    }
}
var $d632d30036e49f43$var$NEW_ITERATOR_PROTOTYPE = !$06f10e9b9cb1418c$exports($d632d30036e49f43$var$IteratorPrototype) || $217c917c4f59b359$exports(function() {
    var test = {};
    // FF44- legacy iterators case
    return $d632d30036e49f43$var$IteratorPrototype[$d632d30036e49f43$var$ITERATOR].call(test) !== test;
});
if ($d632d30036e49f43$var$NEW_ITERATOR_PROTOTYPE) $d632d30036e49f43$var$IteratorPrototype = {};
else if ($036c29a074575bd6$exports) $d632d30036e49f43$var$IteratorPrototype = $a98baaf21fc755e7$exports($d632d30036e49f43$var$IteratorPrototype);
// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!$73d1a34d94fa4c35$exports($d632d30036e49f43$var$IteratorPrototype[$d632d30036e49f43$var$ITERATOR])) $5cabf6b3204ed174$exports($d632d30036e49f43$var$IteratorPrototype, $d632d30036e49f43$var$ITERATOR, function() {
    return this;
});
$d632d30036e49f43$exports = {
    IteratorPrototype: $d632d30036e49f43$var$IteratorPrototype,
    BUGGY_SAFARI_ITERATORS: $d632d30036e49f43$var$BUGGY_SAFARI_ITERATORS
};


var $8159770b7a97268e$require$IteratorPrototype = $d632d30036e49f43$exports.IteratorPrototype;


var $036072e21338276e$exports = {};
"use strict";

var $036072e21338276e$require$defineProperty = $0163cc0a742cd3ad$export$2d1720544b23b823;


var $036072e21338276e$var$TO_STRING_TAG = $bbf4e852bf6421ea$exports("toStringTag");
$036072e21338276e$exports = function(target, TAG, STATIC) {
    if (target && !STATIC) target = target.prototype;
    if (target && !$1ad0c60d8de14c83$exports(target, $036072e21338276e$var$TO_STRING_TAG)) $036072e21338276e$require$defineProperty(target, $036072e21338276e$var$TO_STRING_TAG, {
        configurable: true,
        value: TAG
    });
};



var $8159770b7a97268e$var$returnThis = function() {
    return this;
};
$8159770b7a97268e$exports = function(IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
    var TO_STRING_TAG = NAME + " Iterator";
    IteratorConstructor.prototype = $a98baaf21fc755e7$exports($8159770b7a97268e$require$IteratorPrototype, {
        next: $819ae5875a6bb120$exports(+!ENUMERABLE_NEXT, next)
    });
    $036072e21338276e$exports(IteratorConstructor, TO_STRING_TAG, false, true);
    $2d9742e698a8c85c$exports[TO_STRING_TAG] = $8159770b7a97268e$var$returnThis;
    return IteratorConstructor;
};



var $160170ca8ccc9a75$exports = {};
"use strict";
var $28d294ca34143056$exports = {};
"use strict";


$28d294ca34143056$exports = function(object, key, method) {
    try {
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        return $c201050ed73b14ba$exports($6df447ad4be37421$exports(Object.getOwnPropertyDescriptor(object, key)[method]));
    } catch (error) {}
};



var $1227acb60ff4058a$exports = {};
"use strict";

var $1227acb60ff4058a$var$$String = String;
var $1227acb60ff4058a$var$$TypeError = TypeError;
$1227acb60ff4058a$exports = function(argument) {
    if (typeof argument == "object" || $73d1a34d94fa4c35$exports(argument)) return argument;
    throw new $1227acb60ff4058a$var$$TypeError("Can't set " + $1227acb60ff4058a$var$$String(argument) + " as a prototype");
};


// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
$160170ca8ccc9a75$exports = Object.setPrototypeOf || ("__proto__" in {} ? function() {
    var CORRECT_SETTER = false;
    var test = {};
    var setter;
    try {
        setter = $28d294ca34143056$exports(Object.prototype, "__proto__", "set");
        setter(test, []);
        CORRECT_SETTER = test instanceof Array;
    } catch (error) {}
    return function setPrototypeOf(O, proto) {
        $affc609f2393bdba$exports(O);
        $1227acb60ff4058a$exports(proto);
        if (CORRECT_SETTER) setter(O, proto);
        else O.__proto__ = proto;
        return O;
    };
}() : undefined);








var $c94c3df4a788abf5$var$PROPER_FUNCTION_NAME = $b6b3da709b860269$exports.PROPER;
var $c94c3df4a788abf5$var$CONFIGURABLE_FUNCTION_NAME = $b6b3da709b860269$exports.CONFIGURABLE;
var $c94c3df4a788abf5$var$IteratorPrototype = $d632d30036e49f43$exports.IteratorPrototype;
var $c94c3df4a788abf5$var$BUGGY_SAFARI_ITERATORS = $d632d30036e49f43$exports.BUGGY_SAFARI_ITERATORS;
var $c94c3df4a788abf5$var$ITERATOR = $bbf4e852bf6421ea$exports("iterator");
var $c94c3df4a788abf5$var$KEYS = "keys";
var $c94c3df4a788abf5$var$VALUES = "values";
var $c94c3df4a788abf5$var$ENTRIES = "entries";
var $c94c3df4a788abf5$var$returnThis = function() {
    return this;
};
$c94c3df4a788abf5$exports = function(Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
    $8159770b7a97268e$exports(IteratorConstructor, NAME, next);
    var getIterationMethod = function(KIND) {
        if (KIND === DEFAULT && defaultIterator) return defaultIterator;
        if (!$c94c3df4a788abf5$var$BUGGY_SAFARI_ITERATORS && KIND && KIND in IterablePrototype) return IterablePrototype[KIND];
        switch(KIND){
            case $c94c3df4a788abf5$var$KEYS:
                return function keys() {
                    return new IteratorConstructor(this, KIND);
                };
            case $c94c3df4a788abf5$var$VALUES:
                return function values() {
                    return new IteratorConstructor(this, KIND);
                };
            case $c94c3df4a788abf5$var$ENTRIES:
                return function entries() {
                    return new IteratorConstructor(this, KIND);
                };
        }
        return function() {
            return new IteratorConstructor(this);
        };
    };
    var TO_STRING_TAG = NAME + " Iterator";
    var INCORRECT_VALUES_NAME = false;
    var IterablePrototype = Iterable.prototype;
    var nativeIterator = IterablePrototype[$c94c3df4a788abf5$var$ITERATOR] || IterablePrototype["@@iterator"] || DEFAULT && IterablePrototype[DEFAULT];
    var defaultIterator = !$c94c3df4a788abf5$var$BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
    var anyNativeIterator = NAME === "Array" ? IterablePrototype.entries || nativeIterator : nativeIterator;
    var CurrentIteratorPrototype, methods, KEY;
    // fix native
    if (anyNativeIterator) {
        CurrentIteratorPrototype = $e5c52a606c67a805$exports(anyNativeIterator.call(new Iterable()));
        if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
            if (!$036c29a074575bd6$exports && $e5c52a606c67a805$exports(CurrentIteratorPrototype) !== $c94c3df4a788abf5$var$IteratorPrototype) {
                if ($160170ca8ccc9a75$exports) $160170ca8ccc9a75$exports(CurrentIteratorPrototype, $c94c3df4a788abf5$var$IteratorPrototype);
                else if (!$73d1a34d94fa4c35$exports(CurrentIteratorPrototype[$c94c3df4a788abf5$var$ITERATOR])) $5cabf6b3204ed174$exports(CurrentIteratorPrototype, $c94c3df4a788abf5$var$ITERATOR, $c94c3df4a788abf5$var$returnThis);
            }
            // Set @@toStringTag to native iterators
            $036072e21338276e$exports(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
            if ($036c29a074575bd6$exports) $2d9742e698a8c85c$exports[TO_STRING_TAG] = $c94c3df4a788abf5$var$returnThis;
        }
    }
    // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
    if ($c94c3df4a788abf5$var$PROPER_FUNCTION_NAME && DEFAULT === $c94c3df4a788abf5$var$VALUES && nativeIterator && nativeIterator.name !== $c94c3df4a788abf5$var$VALUES) {
        if (!$036c29a074575bd6$exports && $c94c3df4a788abf5$var$CONFIGURABLE_FUNCTION_NAME) $cbffb6e18a252dcf$exports(IterablePrototype, "name", $c94c3df4a788abf5$var$VALUES);
        else {
            INCORRECT_VALUES_NAME = true;
            defaultIterator = function values() {
                return $2f17e9746e5fde89$exports(nativeIterator, this);
            };
        }
    }
    // export additional methods
    if (DEFAULT) {
        methods = {
            values: getIterationMethod($c94c3df4a788abf5$var$VALUES),
            keys: IS_SET ? defaultIterator : getIterationMethod($c94c3df4a788abf5$var$KEYS),
            entries: getIterationMethod($c94c3df4a788abf5$var$ENTRIES)
        };
        if (FORCED) {
            for(KEY in methods)if ($c94c3df4a788abf5$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) $5cabf6b3204ed174$exports(IterablePrototype, KEY, methods[KEY]);
        } else $ef48c8e0540d6569$exports({
            target: NAME,
            proto: true,
            forced: $c94c3df4a788abf5$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
        }, methods);
    }
    // define iterator
    if ((!$036c29a074575bd6$exports || FORCED) && IterablePrototype[$c94c3df4a788abf5$var$ITERATOR] !== defaultIterator) $5cabf6b3204ed174$exports(IterablePrototype, $c94c3df4a788abf5$var$ITERATOR, defaultIterator, {
        name: DEFAULT
    });
    $2d9742e698a8c85c$exports[NAME] = defaultIterator;
    return methods;
};


var $783af5147689a0b0$exports = {};
"use strict";
// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
$783af5147689a0b0$exports = function(value, done) {
    return {
        value: value,
        done: done
    };
};




var $ce79d5292b96d6e1$var$ARRAY_ITERATOR = "Array Iterator";
var $ce79d5292b96d6e1$var$setInternalState = $954a2ea894ec1c9c$exports.set;
var $ce79d5292b96d6e1$var$getInternalState = $954a2ea894ec1c9c$exports.getterFor($ce79d5292b96d6e1$var$ARRAY_ITERATOR);
// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
$ce79d5292b96d6e1$exports = $c94c3df4a788abf5$exports(Array, "Array", function(iterated, kind) {
    $ce79d5292b96d6e1$var$setInternalState(this, {
        type: $ce79d5292b96d6e1$var$ARRAY_ITERATOR,
        target: $1a94a489a7afc329$exports(iterated),
        index: 0,
        kind: kind // kind
    });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function() {
    var state = $ce79d5292b96d6e1$var$getInternalState(this);
    var target = state.target;
    var index = state.index++;
    if (!target || index >= target.length) {
        state.target = undefined;
        return $783af5147689a0b0$exports(undefined, true);
    }
    switch(state.kind){
        case "keys":
            return $783af5147689a0b0$exports(index, false);
        case "values":
            return $783af5147689a0b0$exports(target[index], false);
    }
    return $783af5147689a0b0$exports([
        index,
        target[index]
    ], false);
}, "values");
// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var $ce79d5292b96d6e1$var$values = $2d9742e698a8c85c$exports.Arguments = $2d9742e698a8c85c$exports.Array;
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$68464d161ed9088f$exports("keys");
$68464d161ed9088f$exports("values");
$68464d161ed9088f$exports("entries");
// V8 ~ Chrome 45- bug
if (!$036c29a074575bd6$exports && $16b43a02da62cc11$exports && $ce79d5292b96d6e1$var$values.name !== "values") try {
    $ce79d5292b96d6e1$require$defineProperty($ce79d5292b96d6e1$var$values, "name", {
        value: "values"
    });
} catch (error) {}


"use strict";

var $86fd8e1d58933552$exports = {};
"use strict";




var $86fd8e1d58933552$var$$TypeError = TypeError;
// `Array.prototype.{ reduce, reduceRight }` methods implementation
var $86fd8e1d58933552$var$createMethod = function(IS_RIGHT) {
    return function(that, callbackfn, argumentsLength, memo) {
        var O = $361c03d23168e423$exports(that);
        var self = $8086cf521fa8b34c$exports(O);
        var length = $3f18e45666a111c8$exports(O);
        $6df447ad4be37421$exports(callbackfn);
        var index = IS_RIGHT ? length - 1 : 0;
        var i = IS_RIGHT ? -1 : 1;
        if (argumentsLength < 2) while(true){
            if (index in self) {
                memo = self[index];
                index += i;
                break;
            }
            index += i;
            if (IS_RIGHT ? index < 0 : length <= index) throw new $86fd8e1d58933552$var$$TypeError("Reduce of empty array with no initial value");
        }
        for(; IS_RIGHT ? index >= 0 : length > index; index += i)if (index in self) memo = callbackfn(memo, self[index], index, O);
        return memo;
    };
};
$86fd8e1d58933552$exports = {
    // `Array.prototype.reduce` method
    // https://tc39.es/ecma262/#sec-array.prototype.reduce
    left: $86fd8e1d58933552$var$createMethod(false),
    // `Array.prototype.reduceRight` method
    // https://tc39.es/ecma262/#sec-array.prototype.reduceright
    right: $86fd8e1d58933552$var$createMethod(true)
};


var $6a0029b54d009c29$require$$reduce = $86fd8e1d58933552$exports.left;
var $b2e804c92ff95b56$exports = {};
"use strict";

$b2e804c92ff95b56$exports = function(METHOD_NAME, argument) {
    var method = [][METHOD_NAME];
    return !!method && $217c917c4f59b359$exports(function() {
        // eslint-disable-next-line no-useless-call -- required for testing
        method.call(null, argument || function() {
            return 1;
        }, 1);
    });
};



var $9002d9a40e113f56$exports = {};
"use strict";


$9002d9a40e113f56$exports = $7f55bdfec0ad037d$exports($212fa519f4bef41a$exports.process) === "process";


// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var $6a0029b54d009c29$var$CHROME_BUG = !$9002d9a40e113f56$exports && $aed210e8b55f96e7$exports > 79 && $aed210e8b55f96e7$exports < 83;
var $6a0029b54d009c29$var$FORCED = $6a0029b54d009c29$var$CHROME_BUG || !$b2e804c92ff95b56$exports("reduce");
// `Array.prototype.reduce` method
// https://tc39.es/ecma262/#sec-array.prototype.reduce
$ef48c8e0540d6569$exports({
    target: "Array",
    proto: true,
    forced: $6a0029b54d009c29$var$FORCED
}, {
    reduce: function reduce(callbackfn /* , initialValue */ ) {
        var length = arguments.length;
        return $6a0029b54d009c29$require$$reduce(this, callbackfn, length, length > 1 ? arguments[1] : undefined);
    }
});


"use strict";


var $c1fa998b544c568a$require$$reduceRight = $86fd8e1d58933552$exports.right;



// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var $c1fa998b544c568a$var$CHROME_BUG = !$9002d9a40e113f56$exports && $aed210e8b55f96e7$exports > 79 && $aed210e8b55f96e7$exports < 83;
var $c1fa998b544c568a$var$FORCED = $c1fa998b544c568a$var$CHROME_BUG || !$b2e804c92ff95b56$exports("reduceRight");
// `Array.prototype.reduceRight` method
// https://tc39.es/ecma262/#sec-array.prototype.reduceright
$ef48c8e0540d6569$exports({
    target: "Array",
    proto: true,
    forced: $c1fa998b544c568a$var$FORCED
}, {
    reduceRight: function reduceRight(callbackfn /* , initialValue */ ) {
        return $c1fa998b544c568a$require$$reduceRight(this, callbackfn, arguments.length, arguments.length > 1 ? arguments[1] : undefined);
    }
});


"use strict";



var $a377e3dba5f41256$var$nativeReverse = $c201050ed73b14ba$exports([].reverse);
var $a377e3dba5f41256$var$test = [
    1,
    2
];
// `Array.prototype.reverse` method
// https://tc39.es/ecma262/#sec-array.prototype.reverse
// fix for Safari 12.0 bug
// https://bugs.webkit.org/show_bug.cgi?id=188794
$ef48c8e0540d6569$exports({
    target: "Array",
    proto: true,
    forced: String($a377e3dba5f41256$var$test) === String($a377e3dba5f41256$var$test.reverse())
}, {
    reverse: function reverse() {
        // eslint-disable-next-line no-self-assign -- dirty hack
        if ($f5ba607f4800b671$exports(this)) this.length = this.length;
        return $a377e3dba5f41256$var$nativeReverse(this);
    }
});


"use strict";





var $e45ba363c163ca46$exports = {};
"use strict";

var $e45ba363c163ca46$var$$TypeError = TypeError;
$e45ba363c163ca46$exports = function(O, P) {
    if (!delete O[P]) throw new $e45ba363c163ca46$var$$TypeError("Cannot delete property " + $bb66d003fc13d318$exports(P) + " of " + $bb66d003fc13d318$exports(O));
};




var $555a1841cf570867$exports = {};
"use strict";
var $9b893bf7d545a0e5$exports = {};
"use strict";


var $ec6a13a4c4f7948e$exports = {};
"use strict";



$ec6a13a4c4f7948e$exports = function(object, key, value) {
    var propertyKey = $4dbc0d7468e7eb76$exports(key);
    if (propertyKey in object) $0163cc0a742cd3ad$export$2d1720544b23b823(object, propertyKey, $819ae5875a6bb120$exports(0, value));
    else object[propertyKey] = value;
};


var $9b893bf7d545a0e5$var$$Array = Array;
var $9b893bf7d545a0e5$var$max = Math.max;
$9b893bf7d545a0e5$exports = function(O, start, end) {
    var length = $3f18e45666a111c8$exports(O);
    var k = $7510e5f178952714$exports(start, length);
    var fin = $7510e5f178952714$exports(end === undefined ? length : end, length);
    var result = $9b893bf7d545a0e5$var$$Array($9b893bf7d545a0e5$var$max(fin - k, 0));
    var n = 0;
    for(; k < fin; k++, n++)$ec6a13a4c4f7948e$exports(result, n, O[k]);
    result.length = n;
    return result;
};


var $555a1841cf570867$var$floor = Math.floor;
var $555a1841cf570867$var$mergeSort = function(array, comparefn) {
    var length = array.length;
    var middle = $555a1841cf570867$var$floor(length / 2);
    return length < 8 ? $555a1841cf570867$var$insertionSort(array, comparefn) : $555a1841cf570867$var$merge(array, $555a1841cf570867$var$mergeSort($9b893bf7d545a0e5$exports(array, 0, middle), comparefn), $555a1841cf570867$var$mergeSort($9b893bf7d545a0e5$exports(array, middle), comparefn), comparefn);
};
var $555a1841cf570867$var$insertionSort = function(array, comparefn) {
    var length = array.length;
    var i = 1;
    var element, j;
    while(i < length){
        j = i;
        element = array[i];
        while(j && comparefn(array[j - 1], element) > 0)array[j] = array[--j];
        if (j !== i++) array[j] = element;
    }
    return array;
};
var $555a1841cf570867$var$merge = function(array, left, right, comparefn) {
    var llength = left.length;
    var rlength = right.length;
    var lindex = 0;
    var rindex = 0;
    while(lindex < llength || rindex < rlength)array[lindex + rindex] = lindex < llength && rindex < rlength ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++] : lindex < llength ? left[lindex++] : right[rindex++];
    return array;
};
$555a1841cf570867$exports = $555a1841cf570867$var$mergeSort;



var $b1db8f4e724762d6$exports = {};
"use strict";

var $b1db8f4e724762d6$var$firefox = $10e5337eedcfb10c$exports.match(/firefox\/(\d+)/i);
$b1db8f4e724762d6$exports = !!$b1db8f4e724762d6$var$firefox && +$b1db8f4e724762d6$var$firefox[1];


var $909597d02685e5ba$exports = {};
"use strict";

$909597d02685e5ba$exports = /MSIE|Trident/.test($10e5337eedcfb10c$exports);



var $c2d1f4653f16d67a$exports = {};
"use strict";

var $c2d1f4653f16d67a$var$webkit = $10e5337eedcfb10c$exports.match(/AppleWebKit\/(\d+)\./);
$c2d1f4653f16d67a$exports = !!$c2d1f4653f16d67a$var$webkit && +$c2d1f4653f16d67a$var$webkit[1];


var $9cab2406f4b44903$var$test = [];
var $9cab2406f4b44903$var$nativeSort = $c201050ed73b14ba$exports($9cab2406f4b44903$var$test.sort);
var $9cab2406f4b44903$var$push = $c201050ed73b14ba$exports($9cab2406f4b44903$var$test.push);
// IE8-
var $9cab2406f4b44903$var$FAILS_ON_UNDEFINED = $217c917c4f59b359$exports(function() {
    $9cab2406f4b44903$var$test.sort(undefined);
});
// V8 bug
var $9cab2406f4b44903$var$FAILS_ON_NULL = $217c917c4f59b359$exports(function() {
    $9cab2406f4b44903$var$test.sort(null);
});
// Old WebKit
var $9cab2406f4b44903$var$STRICT_METHOD = $b2e804c92ff95b56$exports("sort");
var $9cab2406f4b44903$var$STABLE_SORT = !$217c917c4f59b359$exports(function() {
    // feature detection can be too slow, so check engines versions
    if ($aed210e8b55f96e7$exports) return $aed210e8b55f96e7$exports < 70;
    if ($b1db8f4e724762d6$exports && $b1db8f4e724762d6$exports > 3) return;
    if ($909597d02685e5ba$exports) return true;
    if ($c2d1f4653f16d67a$exports) return $c2d1f4653f16d67a$exports < 603;
    var result = "";
    var code, chr, value, index;
    // generate an array with more 512 elements (Chakra and old V8 fails only in this case)
    for(code = 65; code < 76; code++){
        chr = String.fromCharCode(code);
        switch(code){
            case 66:
            case 69:
            case 70:
            case 72:
                value = 3;
                break;
            case 68:
            case 71:
                value = 4;
                break;
            default:
                value = 2;
        }
        for(index = 0; index < 47; index++)$9cab2406f4b44903$var$test.push({
            k: chr + index,
            v: value
        });
    }
    $9cab2406f4b44903$var$test.sort(function(a, b) {
        return b.v - a.v;
    });
    for(index = 0; index < $9cab2406f4b44903$var$test.length; index++){
        chr = $9cab2406f4b44903$var$test[index].k.charAt(0);
        if (result.charAt(result.length - 1) !== chr) result += chr;
    }
    return result !== "DGBEFHACIJK";
});
var $9cab2406f4b44903$var$FORCED = $9cab2406f4b44903$var$FAILS_ON_UNDEFINED || !$9cab2406f4b44903$var$FAILS_ON_NULL || !$9cab2406f4b44903$var$STRICT_METHOD || !$9cab2406f4b44903$var$STABLE_SORT;
var $9cab2406f4b44903$var$getSortCompare = function(comparefn) {
    return function(x, y) {
        if (y === undefined) return -1;
        if (x === undefined) return 1;
        if (comparefn !== undefined) return +comparefn(x, y) || 0;
        return $5eca6f9e01902ab4$exports(x) > $5eca6f9e01902ab4$exports(y) ? 1 : -1;
    };
};
// `Array.prototype.sort` method
// https://tc39.es/ecma262/#sec-array.prototype.sort
$ef48c8e0540d6569$exports({
    target: "Array",
    proto: true,
    forced: $9cab2406f4b44903$var$FORCED
}, {
    sort: function sort(comparefn) {
        if (comparefn !== undefined) $6df447ad4be37421$exports(comparefn);
        var array = $361c03d23168e423$exports(this);
        if ($9cab2406f4b44903$var$STABLE_SORT) return comparefn === undefined ? $9cab2406f4b44903$var$nativeSort(array) : $9cab2406f4b44903$var$nativeSort(array, comparefn);
        var items = [];
        var arrayLength = $3f18e45666a111c8$exports(array);
        var itemsLength, index;
        for(index = 0; index < arrayLength; index++)if (index in array) $9cab2406f4b44903$var$push(items, array[index]);
        $555a1841cf570867$exports(items, $9cab2406f4b44903$var$getSortCompare(comparefn));
        itemsLength = $3f18e45666a111c8$exports(items);
        index = 0;
        while(index < itemsLength)array[index] = items[index++];
        while(index < arrayLength)$e45ba363c163ca46$exports(array, index++);
        return array;
    }
});


"use strict";

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$68464d161ed9088f$exports("flat");


"use strict";

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$68464d161ed9088f$exports("flatMap");


"use strict";


var $637fa5c72614f7f2$exports = {};
"use strict";



var $de0cc3fb914c1bf0$exports = {};
"use strict";
// eslint-disable-next-line es/no-typed-arrays -- safe
$de0cc3fb914c1bf0$exports = typeof ArrayBuffer != "undefined" && typeof DataView != "undefined";





var $ab8ebf21191217ba$exports = {};
"use strict";

$ab8ebf21191217ba$exports = function(target, src, options) {
    for(var key in src)$5cabf6b3204ed174$exports(target, key, src[key], options);
    return target;
};



var $efe207f3fce362b0$exports = {};
"use strict";

var $efe207f3fce362b0$var$$TypeError = TypeError;
$efe207f3fce362b0$exports = function(it, Prototype) {
    if ($dba85d7bd7ffe0d7$exports(Prototype, it)) return it;
    throw new $efe207f3fce362b0$var$$TypeError("Incorrect invocation");
};




var $25a90ed7517c0a6c$exports = {};
"use strict";


var $25a90ed7517c0a6c$var$$RangeError = RangeError;
// `ToIndex` abstract operation
// https://tc39.es/ecma262/#sec-toindex
$25a90ed7517c0a6c$exports = function(it) {
    if (it === undefined) return 0;
    var number = $8d76b52b36a52486$exports(it);
    var length = $a46f106a02f96447$exports(number);
    if (number !== length) throw new $25a90ed7517c0a6c$var$$RangeError("Wrong length or index");
    return length;
};


var $ce856037611fd3a2$exports = {};
"use strict";
var $17a30417390303d2$exports = {};
"use strict";
var $b6c2f161c16ef539$exports = {};
"use strict";
// `Math.sign` method implementation
// https://tc39.es/ecma262/#sec-math.sign
// eslint-disable-next-line es/no-math-sign -- safe
$b6c2f161c16ef539$exports = Math.sign || function sign(x) {
    var n = +x;
    // eslint-disable-next-line no-self-compare -- NaN check
    return n === 0 || n !== n ? n : n < 0 ? -1 : 1;
};


var $17a30417390303d2$var$abs = Math.abs;
var $17a30417390303d2$var$EPSILON = 2.220446049250313e-16; // Number.EPSILON
var $17a30417390303d2$var$INVERSE_EPSILON = 1 / $17a30417390303d2$var$EPSILON;
var $17a30417390303d2$var$roundTiesToEven = function(n) {
    return n + $17a30417390303d2$var$INVERSE_EPSILON - $17a30417390303d2$var$INVERSE_EPSILON;
};
$17a30417390303d2$exports = function(x, FLOAT_EPSILON, FLOAT_MAX_VALUE, FLOAT_MIN_VALUE) {
    var n = +x;
    var absolute = $17a30417390303d2$var$abs(n);
    var s = $b6c2f161c16ef539$exports(n);
    if (absolute < FLOAT_MIN_VALUE) return s * $17a30417390303d2$var$roundTiesToEven(absolute / FLOAT_MIN_VALUE / FLOAT_EPSILON) * FLOAT_MIN_VALUE * FLOAT_EPSILON;
    var a = (1 + FLOAT_EPSILON / $17a30417390303d2$var$EPSILON) * absolute;
    var result = a - (a - absolute);
    // eslint-disable-next-line no-self-compare -- NaN check
    if (result > FLOAT_MAX_VALUE || result !== result) return s * Infinity;
    return s * result;
};


var $ce856037611fd3a2$var$FLOAT32_EPSILON = 1.1920928955078125e-7; // 2 ** -23;
var $ce856037611fd3a2$var$FLOAT32_MAX_VALUE = 3.4028234663852886e+38; // 2 ** 128 - 2 ** 104
var $ce856037611fd3a2$var$FLOAT32_MIN_VALUE = 1.1754943508222875e-38; // 2 ** -126;
// `Math.fround` method implementation
// https://tc39.es/ecma262/#sec-math.fround
// eslint-disable-next-line es/no-math-fround -- safe
$ce856037611fd3a2$exports = Math.fround || function fround(x) {
    return $17a30417390303d2$exports(x, $ce856037611fd3a2$var$FLOAT32_EPSILON, $ce856037611fd3a2$var$FLOAT32_MAX_VALUE, $ce856037611fd3a2$var$FLOAT32_MIN_VALUE);
};


var $270f761a1675666e$exports = {};
"use strict";
// IEEE754 conversions based on https://github.com/feross/ieee754
var $270f761a1675666e$var$$Array = Array;
var $270f761a1675666e$var$abs = Math.abs;
var $270f761a1675666e$var$pow = Math.pow;
var $270f761a1675666e$var$floor = Math.floor;
var $270f761a1675666e$var$log = Math.log;
var $270f761a1675666e$var$LN2 = Math.LN2;
var $270f761a1675666e$var$pack = function(number, mantissaLength, bytes) {
    var buffer = $270f761a1675666e$var$$Array(bytes);
    var exponentLength = bytes * 8 - mantissaLength - 1;
    var eMax = (1 << exponentLength) - 1;
    var eBias = eMax >> 1;
    var rt = mantissaLength === 23 ? $270f761a1675666e$var$pow(2, -24) - $270f761a1675666e$var$pow(2, -77) : 0;
    var sign = number < 0 || number === 0 && 1 / number < 0 ? 1 : 0;
    var index = 0;
    var exponent, mantissa, c;
    number = $270f761a1675666e$var$abs(number);
    // eslint-disable-next-line no-self-compare -- NaN check
    if (number !== number || number === Infinity) {
        // eslint-disable-next-line no-self-compare -- NaN check
        mantissa = number !== number ? 1 : 0;
        exponent = eMax;
    } else {
        exponent = $270f761a1675666e$var$floor($270f761a1675666e$var$log(number) / $270f761a1675666e$var$LN2);
        c = $270f761a1675666e$var$pow(2, -exponent);
        if (number * c < 1) {
            exponent--;
            c *= 2;
        }
        if (exponent + eBias >= 1) number += rt / c;
        else number += rt * $270f761a1675666e$var$pow(2, 1 - eBias);
        if (number * c >= 2) {
            exponent++;
            c /= 2;
        }
        if (exponent + eBias >= eMax) {
            mantissa = 0;
            exponent = eMax;
        } else if (exponent + eBias >= 1) {
            mantissa = (number * c - 1) * $270f761a1675666e$var$pow(2, mantissaLength);
            exponent += eBias;
        } else {
            mantissa = number * $270f761a1675666e$var$pow(2, eBias - 1) * $270f761a1675666e$var$pow(2, mantissaLength);
            exponent = 0;
        }
    }
    while(mantissaLength >= 8){
        buffer[index++] = mantissa & 255;
        mantissa /= 256;
        mantissaLength -= 8;
    }
    exponent = exponent << mantissaLength | mantissa;
    exponentLength += mantissaLength;
    while(exponentLength > 0){
        buffer[index++] = exponent & 255;
        exponent /= 256;
        exponentLength -= 8;
    }
    buffer[--index] |= sign * 128;
    return buffer;
};
var $270f761a1675666e$var$unpack = function(buffer, mantissaLength) {
    var bytes = buffer.length;
    var exponentLength = bytes * 8 - mantissaLength - 1;
    var eMax = (1 << exponentLength) - 1;
    var eBias = eMax >> 1;
    var nBits = exponentLength - 7;
    var index = bytes - 1;
    var sign = buffer[index--];
    var exponent = sign & 127;
    var mantissa;
    sign >>= 7;
    while(nBits > 0){
        exponent = exponent * 256 + buffer[index--];
        nBits -= 8;
    }
    mantissa = exponent & (1 << -nBits) - 1;
    exponent >>= -nBits;
    nBits += mantissaLength;
    while(nBits > 0){
        mantissa = mantissa * 256 + buffer[index--];
        nBits -= 8;
    }
    if (exponent === 0) exponent = 1 - eBias;
    else if (exponent === eMax) return mantissa ? NaN : sign ? -Infinity : Infinity;
    else {
        mantissa += $270f761a1675666e$var$pow(2, mantissaLength);
        exponent -= eBias;
    }
    return (sign ? -1 : 1) * mantissa * $270f761a1675666e$var$pow(2, exponent - mantissaLength);
};
$270f761a1675666e$exports = {
    pack: $270f761a1675666e$var$pack,
    unpack: $270f761a1675666e$var$unpack
};





var $637fa5c72614f7f2$require$getOwnPropertyNames = $f54839ff0ad1f1b7$export$2d1720544b23b823;
var $cbfc2d3fd1b7fe5d$exports = {};
"use strict";



// `Array.prototype.fill` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.fill
$cbfc2d3fd1b7fe5d$exports = function fill(value /* , start = 0, end = @length */ ) {
    var O = $361c03d23168e423$exports(this);
    var length = $3f18e45666a111c8$exports(O);
    var argumentsLength = arguments.length;
    var index = $7510e5f178952714$exports(argumentsLength > 1 ? arguments[1] : undefined, length);
    var end = argumentsLength > 2 ? arguments[2] : undefined;
    var endPos = end === undefined ? length : $7510e5f178952714$exports(end, length);
    while(endPos > index)O[index++] = value;
    return O;
};





var $637fa5c72614f7f2$var$PROPER_FUNCTION_NAME = $b6b3da709b860269$exports.PROPER;
var $637fa5c72614f7f2$var$CONFIGURABLE_FUNCTION_NAME = $b6b3da709b860269$exports.CONFIGURABLE;
var $637fa5c72614f7f2$var$ARRAY_BUFFER = "ArrayBuffer";
var $637fa5c72614f7f2$var$DATA_VIEW = "DataView";
var $637fa5c72614f7f2$var$PROTOTYPE = "prototype";
var $637fa5c72614f7f2$var$WRONG_LENGTH = "Wrong length";
var $637fa5c72614f7f2$var$WRONG_INDEX = "Wrong index";
var $637fa5c72614f7f2$var$getInternalArrayBufferState = $954a2ea894ec1c9c$exports.getterFor($637fa5c72614f7f2$var$ARRAY_BUFFER);
var $637fa5c72614f7f2$var$getInternalDataViewState = $954a2ea894ec1c9c$exports.getterFor($637fa5c72614f7f2$var$DATA_VIEW);
var $637fa5c72614f7f2$var$setInternalState = $954a2ea894ec1c9c$exports.set;
var $637fa5c72614f7f2$var$NativeArrayBuffer = $212fa519f4bef41a$exports[$637fa5c72614f7f2$var$ARRAY_BUFFER];
var $637fa5c72614f7f2$var$$ArrayBuffer = $637fa5c72614f7f2$var$NativeArrayBuffer;
var $637fa5c72614f7f2$var$ArrayBufferPrototype = $637fa5c72614f7f2$var$$ArrayBuffer && $637fa5c72614f7f2$var$$ArrayBuffer[$637fa5c72614f7f2$var$PROTOTYPE];
var $637fa5c72614f7f2$var$$DataView = $212fa519f4bef41a$exports[$637fa5c72614f7f2$var$DATA_VIEW];
var $637fa5c72614f7f2$var$DataViewPrototype = $637fa5c72614f7f2$var$$DataView && $637fa5c72614f7f2$var$$DataView[$637fa5c72614f7f2$var$PROTOTYPE];
var $637fa5c72614f7f2$var$ObjectPrototype = Object.prototype;
var $637fa5c72614f7f2$var$Array = $212fa519f4bef41a$exports.Array;
var $637fa5c72614f7f2$var$RangeError = $212fa519f4bef41a$exports.RangeError;
var $637fa5c72614f7f2$var$fill = $c201050ed73b14ba$exports($cbfc2d3fd1b7fe5d$exports);
var $637fa5c72614f7f2$var$reverse = $c201050ed73b14ba$exports([].reverse);
var $637fa5c72614f7f2$var$packIEEE754 = $270f761a1675666e$exports.pack;
var $637fa5c72614f7f2$var$unpackIEEE754 = $270f761a1675666e$exports.unpack;
var $637fa5c72614f7f2$var$packInt8 = function(number) {
    return [
        number & 0xFF
    ];
};
var $637fa5c72614f7f2$var$packInt16 = function(number) {
    return [
        number & 0xFF,
        number >> 8 & 0xFF
    ];
};
var $637fa5c72614f7f2$var$packInt32 = function(number) {
    return [
        number & 0xFF,
        number >> 8 & 0xFF,
        number >> 16 & 0xFF,
        number >> 24 & 0xFF
    ];
};
var $637fa5c72614f7f2$var$unpackInt32 = function(buffer) {
    return buffer[3] << 24 | buffer[2] << 16 | buffer[1] << 8 | buffer[0];
};
var $637fa5c72614f7f2$var$packFloat32 = function(number) {
    return $637fa5c72614f7f2$var$packIEEE754($ce856037611fd3a2$exports(number), 23, 4);
};
var $637fa5c72614f7f2$var$packFloat64 = function(number) {
    return $637fa5c72614f7f2$var$packIEEE754(number, 52, 8);
};
var $637fa5c72614f7f2$var$addGetter = function(Constructor, key, getInternalState) {
    $4dba431ca752b815$exports(Constructor[$637fa5c72614f7f2$var$PROTOTYPE], key, {
        configurable: true,
        get: function() {
            return getInternalState(this)[key];
        }
    });
};
var $637fa5c72614f7f2$var$get = function(view, count, index, isLittleEndian) {
    var store = $637fa5c72614f7f2$var$getInternalDataViewState(view);
    var intIndex = $25a90ed7517c0a6c$exports(index);
    var boolIsLittleEndian = !!isLittleEndian;
    if (intIndex + count > store.byteLength) throw new $637fa5c72614f7f2$var$RangeError($637fa5c72614f7f2$var$WRONG_INDEX);
    var bytes = store.bytes;
    var start = intIndex + store.byteOffset;
    var pack = $9b893bf7d545a0e5$exports(bytes, start, start + count);
    return boolIsLittleEndian ? pack : $637fa5c72614f7f2$var$reverse(pack);
};
var $637fa5c72614f7f2$var$set = function(view, count, index, conversion, value, isLittleEndian) {
    var store = $637fa5c72614f7f2$var$getInternalDataViewState(view);
    var intIndex = $25a90ed7517c0a6c$exports(index);
    var pack = conversion(+value);
    var boolIsLittleEndian = !!isLittleEndian;
    if (intIndex + count > store.byteLength) throw new $637fa5c72614f7f2$var$RangeError($637fa5c72614f7f2$var$WRONG_INDEX);
    var bytes = store.bytes;
    var start = intIndex + store.byteOffset;
    for(var i = 0; i < count; i++)bytes[start + i] = pack[boolIsLittleEndian ? i : count - i - 1];
};
if (!$de0cc3fb914c1bf0$exports) {
    $637fa5c72614f7f2$var$$ArrayBuffer = function ArrayBuffer(length) {
        $efe207f3fce362b0$exports(this, $637fa5c72614f7f2$var$ArrayBufferPrototype);
        var byteLength = $25a90ed7517c0a6c$exports(length);
        $637fa5c72614f7f2$var$setInternalState(this, {
            type: $637fa5c72614f7f2$var$ARRAY_BUFFER,
            bytes: $637fa5c72614f7f2$var$fill($637fa5c72614f7f2$var$Array(byteLength), 0),
            byteLength: byteLength
        });
        if (!$16b43a02da62cc11$exports) {
            this.byteLength = byteLength;
            this.detached = false;
        }
    };
    $637fa5c72614f7f2$var$ArrayBufferPrototype = $637fa5c72614f7f2$var$$ArrayBuffer[$637fa5c72614f7f2$var$PROTOTYPE];
    $637fa5c72614f7f2$var$$DataView = function DataView(buffer, byteOffset, byteLength) {
        $efe207f3fce362b0$exports(this, $637fa5c72614f7f2$var$DataViewPrototype);
        $efe207f3fce362b0$exports(buffer, $637fa5c72614f7f2$var$ArrayBufferPrototype);
        var bufferState = $637fa5c72614f7f2$var$getInternalArrayBufferState(buffer);
        var bufferLength = bufferState.byteLength;
        var offset = $8d76b52b36a52486$exports(byteOffset);
        if (offset < 0 || offset > bufferLength) throw new $637fa5c72614f7f2$var$RangeError("Wrong offset");
        byteLength = byteLength === undefined ? bufferLength - offset : $a46f106a02f96447$exports(byteLength);
        if (offset + byteLength > bufferLength) throw new $637fa5c72614f7f2$var$RangeError($637fa5c72614f7f2$var$WRONG_LENGTH);
        $637fa5c72614f7f2$var$setInternalState(this, {
            type: $637fa5c72614f7f2$var$DATA_VIEW,
            buffer: buffer,
            byteLength: byteLength,
            byteOffset: offset,
            bytes: bufferState.bytes
        });
        if (!$16b43a02da62cc11$exports) {
            this.buffer = buffer;
            this.byteLength = byteLength;
            this.byteOffset = offset;
        }
    };
    $637fa5c72614f7f2$var$DataViewPrototype = $637fa5c72614f7f2$var$$DataView[$637fa5c72614f7f2$var$PROTOTYPE];
    if ($16b43a02da62cc11$exports) {
        $637fa5c72614f7f2$var$addGetter($637fa5c72614f7f2$var$$ArrayBuffer, "byteLength", $637fa5c72614f7f2$var$getInternalArrayBufferState);
        $637fa5c72614f7f2$var$addGetter($637fa5c72614f7f2$var$$DataView, "buffer", $637fa5c72614f7f2$var$getInternalDataViewState);
        $637fa5c72614f7f2$var$addGetter($637fa5c72614f7f2$var$$DataView, "byteLength", $637fa5c72614f7f2$var$getInternalDataViewState);
        $637fa5c72614f7f2$var$addGetter($637fa5c72614f7f2$var$$DataView, "byteOffset", $637fa5c72614f7f2$var$getInternalDataViewState);
    }
    $ab8ebf21191217ba$exports($637fa5c72614f7f2$var$DataViewPrototype, {
        getInt8: function getInt8(byteOffset) {
            return $637fa5c72614f7f2$var$get(this, 1, byteOffset)[0] << 24 >> 24;
        },
        getUint8: function getUint8(byteOffset) {
            return $637fa5c72614f7f2$var$get(this, 1, byteOffset)[0];
        },
        getInt16: function getInt16(byteOffset /* , littleEndian */ ) {
            var bytes = $637fa5c72614f7f2$var$get(this, 2, byteOffset, arguments.length > 1 ? arguments[1] : false);
            return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
        },
        getUint16: function getUint16(byteOffset /* , littleEndian */ ) {
            var bytes = $637fa5c72614f7f2$var$get(this, 2, byteOffset, arguments.length > 1 ? arguments[1] : false);
            return bytes[1] << 8 | bytes[0];
        },
        getInt32: function getInt32(byteOffset /* , littleEndian */ ) {
            return $637fa5c72614f7f2$var$unpackInt32($637fa5c72614f7f2$var$get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : false));
        },
        getUint32: function getUint32(byteOffset /* , littleEndian */ ) {
            return $637fa5c72614f7f2$var$unpackInt32($637fa5c72614f7f2$var$get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : false)) >>> 0;
        },
        getFloat32: function getFloat32(byteOffset /* , littleEndian */ ) {
            return $637fa5c72614f7f2$var$unpackIEEE754($637fa5c72614f7f2$var$get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : false), 23);
        },
        getFloat64: function getFloat64(byteOffset /* , littleEndian */ ) {
            return $637fa5c72614f7f2$var$unpackIEEE754($637fa5c72614f7f2$var$get(this, 8, byteOffset, arguments.length > 1 ? arguments[1] : false), 52);
        },
        setInt8: function setInt8(byteOffset, value) {
            $637fa5c72614f7f2$var$set(this, 1, byteOffset, $637fa5c72614f7f2$var$packInt8, value);
        },
        setUint8: function setUint8(byteOffset, value) {
            $637fa5c72614f7f2$var$set(this, 1, byteOffset, $637fa5c72614f7f2$var$packInt8, value);
        },
        setInt16: function setInt16(byteOffset, value /* , littleEndian */ ) {
            $637fa5c72614f7f2$var$set(this, 2, byteOffset, $637fa5c72614f7f2$var$packInt16, value, arguments.length > 2 ? arguments[2] : false);
        },
        setUint16: function setUint16(byteOffset, value /* , littleEndian */ ) {
            $637fa5c72614f7f2$var$set(this, 2, byteOffset, $637fa5c72614f7f2$var$packInt16, value, arguments.length > 2 ? arguments[2] : false);
        },
        setInt32: function setInt32(byteOffset, value /* , littleEndian */ ) {
            $637fa5c72614f7f2$var$set(this, 4, byteOffset, $637fa5c72614f7f2$var$packInt32, value, arguments.length > 2 ? arguments[2] : false);
        },
        setUint32: function setUint32(byteOffset, value /* , littleEndian */ ) {
            $637fa5c72614f7f2$var$set(this, 4, byteOffset, $637fa5c72614f7f2$var$packInt32, value, arguments.length > 2 ? arguments[2] : false);
        },
        setFloat32: function setFloat32(byteOffset, value /* , littleEndian */ ) {
            $637fa5c72614f7f2$var$set(this, 4, byteOffset, $637fa5c72614f7f2$var$packFloat32, value, arguments.length > 2 ? arguments[2] : false);
        },
        setFloat64: function setFloat64(byteOffset, value /* , littleEndian */ ) {
            $637fa5c72614f7f2$var$set(this, 8, byteOffset, $637fa5c72614f7f2$var$packFloat64, value, arguments.length > 2 ? arguments[2] : false);
        }
    });
} else {
    var $637fa5c72614f7f2$var$INCORRECT_ARRAY_BUFFER_NAME = $637fa5c72614f7f2$var$PROPER_FUNCTION_NAME && $637fa5c72614f7f2$var$NativeArrayBuffer.name !== $637fa5c72614f7f2$var$ARRAY_BUFFER;
    /* eslint-disable no-new -- required for testing */ if (!$217c917c4f59b359$exports(function() {
        $637fa5c72614f7f2$var$NativeArrayBuffer(1);
    }) || !$217c917c4f59b359$exports(function() {
        new $637fa5c72614f7f2$var$NativeArrayBuffer(-1);
    }) || $217c917c4f59b359$exports(function() {
        new $637fa5c72614f7f2$var$NativeArrayBuffer();
        new $637fa5c72614f7f2$var$NativeArrayBuffer(1.5);
        new $637fa5c72614f7f2$var$NativeArrayBuffer(NaN);
        return $637fa5c72614f7f2$var$NativeArrayBuffer.length !== 1 || $637fa5c72614f7f2$var$INCORRECT_ARRAY_BUFFER_NAME && !$637fa5c72614f7f2$var$CONFIGURABLE_FUNCTION_NAME;
    })) {
        /* eslint-enable no-new -- required for testing */ $637fa5c72614f7f2$var$$ArrayBuffer = function ArrayBuffer(length) {
            $efe207f3fce362b0$exports(this, $637fa5c72614f7f2$var$ArrayBufferPrototype);
            return new $637fa5c72614f7f2$var$NativeArrayBuffer($25a90ed7517c0a6c$exports(length));
        };
        $637fa5c72614f7f2$var$$ArrayBuffer[$637fa5c72614f7f2$var$PROTOTYPE] = $637fa5c72614f7f2$var$ArrayBufferPrototype;
        for(var $637fa5c72614f7f2$var$keys = $637fa5c72614f7f2$require$getOwnPropertyNames($637fa5c72614f7f2$var$NativeArrayBuffer), $637fa5c72614f7f2$var$j = 0, $637fa5c72614f7f2$var$key; $637fa5c72614f7f2$var$keys.length > $637fa5c72614f7f2$var$j;)if (!(($637fa5c72614f7f2$var$key = $637fa5c72614f7f2$var$keys[$637fa5c72614f7f2$var$j++]) in $637fa5c72614f7f2$var$$ArrayBuffer)) $cbffb6e18a252dcf$exports($637fa5c72614f7f2$var$$ArrayBuffer, $637fa5c72614f7f2$var$key, $637fa5c72614f7f2$var$NativeArrayBuffer[$637fa5c72614f7f2$var$key]);
        $637fa5c72614f7f2$var$ArrayBufferPrototype.constructor = $637fa5c72614f7f2$var$$ArrayBuffer;
    } else if ($637fa5c72614f7f2$var$INCORRECT_ARRAY_BUFFER_NAME && $637fa5c72614f7f2$var$CONFIGURABLE_FUNCTION_NAME) $cbffb6e18a252dcf$exports($637fa5c72614f7f2$var$NativeArrayBuffer, "name", $637fa5c72614f7f2$var$ARRAY_BUFFER);
    // WebKit bug - the same parent prototype for typed arrays and data view
    if ($160170ca8ccc9a75$exports && $e5c52a606c67a805$exports($637fa5c72614f7f2$var$DataViewPrototype) !== $637fa5c72614f7f2$var$ObjectPrototype) $160170ca8ccc9a75$exports($637fa5c72614f7f2$var$DataViewPrototype, $637fa5c72614f7f2$var$ObjectPrototype);
    // iOS Safari 7.x bug
    var $637fa5c72614f7f2$var$testView = new $637fa5c72614f7f2$var$$DataView(new $637fa5c72614f7f2$var$$ArrayBuffer(2));
    var $637fa5c72614f7f2$var$$setInt8 = $c201050ed73b14ba$exports($637fa5c72614f7f2$var$DataViewPrototype.setInt8);
    $637fa5c72614f7f2$var$testView.setInt8(0, 2147483648);
    $637fa5c72614f7f2$var$testView.setInt8(1, 2147483649);
    if ($637fa5c72614f7f2$var$testView.getInt8(0) || !$637fa5c72614f7f2$var$testView.getInt8(1)) $ab8ebf21191217ba$exports($637fa5c72614f7f2$var$DataViewPrototype, {
        setInt8: function setInt8(byteOffset, value) {
            $637fa5c72614f7f2$var$$setInt8(this, byteOffset, value << 24 >> 24);
        },
        setUint8: function setUint8(byteOffset, value) {
            $637fa5c72614f7f2$var$$setInt8(this, byteOffset, value << 24 >> 24);
        }
    }, {
        unsafe: true
    });
}
$036072e21338276e$exports($637fa5c72614f7f2$var$$ArrayBuffer, $637fa5c72614f7f2$var$ARRAY_BUFFER);
$036072e21338276e$exports($637fa5c72614f7f2$var$$DataView, $637fa5c72614f7f2$var$DATA_VIEW);
$637fa5c72614f7f2$exports = {
    ArrayBuffer: $637fa5c72614f7f2$var$$ArrayBuffer,
    DataView: $637fa5c72614f7f2$var$$DataView
};


var $a85873e11645746b$exports = {};
"use strict";




var $a85873e11645746b$var$SPECIES = $bbf4e852bf6421ea$exports("species");
$a85873e11645746b$exports = function(CONSTRUCTOR_NAME) {
    var Constructor = $3e824c856d81a8e3$exports(CONSTRUCTOR_NAME);
    if ($16b43a02da62cc11$exports && Constructor && !Constructor[$a85873e11645746b$var$SPECIES]) $4dba431ca752b815$exports(Constructor, $a85873e11645746b$var$SPECIES, {
        configurable: true,
        get: function() {
            return this;
        }
    });
};


var $410773496dac31b2$var$ARRAY_BUFFER = "ArrayBuffer";
var $410773496dac31b2$var$ArrayBuffer = $637fa5c72614f7f2$exports[$410773496dac31b2$var$ARRAY_BUFFER];
var $410773496dac31b2$var$NativeArrayBuffer = $212fa519f4bef41a$exports[$410773496dac31b2$var$ARRAY_BUFFER];
// `ArrayBuffer` constructor
// https://tc39.es/ecma262/#sec-arraybuffer-constructor
$ef48c8e0540d6569$exports({
    global: true,
    constructor: true,
    forced: $410773496dac31b2$var$NativeArrayBuffer !== $410773496dac31b2$var$ArrayBuffer
}, {
    ArrayBuffer: $410773496dac31b2$var$ArrayBuffer
});
$a85873e11645746b$exports($410773496dac31b2$var$ARRAY_BUFFER);


"use strict";







var $21e66763122ffa99$exports = {};
"use strict";

var $8762ecaa63628bbc$exports = {};
"use strict";


var $8762ecaa63628bbc$var$$TypeError = TypeError;
// `Assert: IsConstructor(argument) is true`
$8762ecaa63628bbc$exports = function(argument) {
    if ($f9bc962f91baa4bd$exports(argument)) return argument;
    throw new $8762ecaa63628bbc$var$$TypeError($bb66d003fc13d318$exports(argument) + " is not a constructor");
};




var $21e66763122ffa99$var$SPECIES = $bbf4e852bf6421ea$exports("species");
// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
$21e66763122ffa99$exports = function(O, defaultConstructor) {
    var C = $affc609f2393bdba$exports(O).constructor;
    var S;
    return C === undefined || $e64dc79af48a1328$exports(S = $affc609f2393bdba$exports(C)[$21e66763122ffa99$var$SPECIES]) ? defaultConstructor : $8762ecaa63628bbc$exports(S);
};


var $4d3666df7af26315$var$ArrayBuffer = $637fa5c72614f7f2$exports.ArrayBuffer;
var $4d3666df7af26315$var$DataView = $637fa5c72614f7f2$exports.DataView;
var $4d3666df7af26315$var$DataViewPrototype = $4d3666df7af26315$var$DataView.prototype;
var $4d3666df7af26315$var$nativeArrayBufferSlice = $46453aed9e51860f$exports($4d3666df7af26315$var$ArrayBuffer.prototype.slice);
var $4d3666df7af26315$var$getUint8 = $46453aed9e51860f$exports($4d3666df7af26315$var$DataViewPrototype.getUint8);
var $4d3666df7af26315$var$setUint8 = $46453aed9e51860f$exports($4d3666df7af26315$var$DataViewPrototype.setUint8);
var $4d3666df7af26315$var$INCORRECT_SLICE = $217c917c4f59b359$exports(function() {
    return !new $4d3666df7af26315$var$ArrayBuffer(2).slice(1, undefined).byteLength;
});
// `ArrayBuffer.prototype.slice` method
// https://tc39.es/ecma262/#sec-arraybuffer.prototype.slice
$ef48c8e0540d6569$exports({
    target: "ArrayBuffer",
    proto: true,
    unsafe: true,
    forced: $4d3666df7af26315$var$INCORRECT_SLICE
}, {
    slice: function slice(start, end) {
        if ($4d3666df7af26315$var$nativeArrayBufferSlice && end === undefined) return $4d3666df7af26315$var$nativeArrayBufferSlice($affc609f2393bdba$exports(this), start); // FF fix
        var length = $affc609f2393bdba$exports(this).byteLength;
        var first = $7510e5f178952714$exports(start, length);
        var fin = $7510e5f178952714$exports(end === undefined ? length : end, length);
        var result = new ($21e66763122ffa99$exports(this, $4d3666df7af26315$var$ArrayBuffer))($a46f106a02f96447$exports(fin - first));
        var viewSource = new $4d3666df7af26315$var$DataView(this);
        var viewTarget = new $4d3666df7af26315$var$DataView(result);
        var index = 0;
        while(first < fin)$4d3666df7af26315$var$setUint8(viewTarget, index++, $4d3666df7af26315$var$getUint8(viewSource, first++));
        return result;
    }
});


"use strict";

// eslint-disable-next-line es/no-math-hypot -- required for testing
var $7f796f08852e93af$var$$hypot = Math.hypot;
var $7f796f08852e93af$var$abs = Math.abs;
var $7f796f08852e93af$var$sqrt = Math.sqrt;
// Chrome 77 bug
// https://bugs.chromium.org/p/v8/issues/detail?id=9546
var $7f796f08852e93af$var$FORCED = !!$7f796f08852e93af$var$$hypot && $7f796f08852e93af$var$$hypot(Infinity, NaN) !== Infinity;
// `Math.hypot` method
// https://tc39.es/ecma262/#sec-math.hypot
$ef48c8e0540d6569$exports({
    target: "Math",
    stat: true,
    arity: 2,
    forced: $7f796f08852e93af$var$FORCED
}, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    hypot: function hypot(value1, value2) {
        var sum = 0;
        var i = 0;
        var aLen = arguments.length;
        var larg = 0;
        var arg, div;
        while(i < aLen){
            arg = $7f796f08852e93af$var$abs(arguments[i++]);
            if (larg < arg) {
                div = larg / arg;
                sum = sum * div * div + 1;
                larg = arg;
            } else if (arg > 0) {
                div = arg / larg;
                sum += div * div;
            } else sum += arg;
        }
        return larg === Infinity ? Infinity : larg * $7f796f08852e93af$var$sqrt(sum);
    }
});


"use strict";

var $72899ef6a0136bb1$exports = {};
"use strict";




var $95bd89ea43e67dd3$exports = {};
"use strict";



var $09e23748e3ca5e72$exports = {};
"use strict";
// a string of all valid unicode whitespaces
$09e23748e3ca5e72$exports = "	\n\v\f\r \xa0              　\u2028\u2029\uFEFF";


var $95bd89ea43e67dd3$var$replace = $c201050ed73b14ba$exports("".replace);
var $95bd89ea43e67dd3$var$ltrim = RegExp("^[" + $09e23748e3ca5e72$exports + "]+");
var $95bd89ea43e67dd3$var$rtrim = RegExp("(^|[^" + $09e23748e3ca5e72$exports + "])[" + $09e23748e3ca5e72$exports + "]+$");
// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var $95bd89ea43e67dd3$var$createMethod = function(TYPE) {
    return function($this) {
        var string = $5eca6f9e01902ab4$exports($07418f2e69c51fa2$exports($this));
        if (TYPE & 1) string = $95bd89ea43e67dd3$var$replace(string, $95bd89ea43e67dd3$var$ltrim, "");
        if (TYPE & 2) string = $95bd89ea43e67dd3$var$replace(string, $95bd89ea43e67dd3$var$rtrim, "$1");
        return string;
    };
};
$95bd89ea43e67dd3$exports = {
    // `String.prototype.{ trimLeft, trimStart }` methods
    // https://tc39.es/ecma262/#sec-string.prototype.trimstart
    start: $95bd89ea43e67dd3$var$createMethod(1),
    // `String.prototype.{ trimRight, trimEnd }` methods
    // https://tc39.es/ecma262/#sec-string.prototype.trimend
    end: $95bd89ea43e67dd3$var$createMethod(2),
    // `String.prototype.trim` method
    // https://tc39.es/ecma262/#sec-string.prototype.trim
    trim: $95bd89ea43e67dd3$var$createMethod(3)
};


var $72899ef6a0136bb1$require$trim = $95bd89ea43e67dd3$exports.trim;

var $72899ef6a0136bb1$var$charAt = $c201050ed73b14ba$exports("".charAt);
var $72899ef6a0136bb1$var$$parseFloat = $212fa519f4bef41a$exports.parseFloat;
var $72899ef6a0136bb1$var$Symbol = $212fa519f4bef41a$exports.Symbol;
var $72899ef6a0136bb1$var$ITERATOR = $72899ef6a0136bb1$var$Symbol && $72899ef6a0136bb1$var$Symbol.iterator;
var $72899ef6a0136bb1$var$FORCED = 1 / $72899ef6a0136bb1$var$$parseFloat($09e23748e3ca5e72$exports + "-0") !== -Infinity || $72899ef6a0136bb1$var$ITERATOR && !$217c917c4f59b359$exports(function() {
    $72899ef6a0136bb1$var$$parseFloat(Object($72899ef6a0136bb1$var$ITERATOR));
});
// `parseFloat` method
// https://tc39.es/ecma262/#sec-parsefloat-string
$72899ef6a0136bb1$exports = $72899ef6a0136bb1$var$FORCED ? function parseFloat(string) {
    var trimmedString = $72899ef6a0136bb1$require$trim($5eca6f9e01902ab4$exports(string));
    var result = $72899ef6a0136bb1$var$$parseFloat(trimmedString);
    return result === 0 && $72899ef6a0136bb1$var$charAt(trimmedString, 0) === "-" ? -0 : result;
} : $72899ef6a0136bb1$var$$parseFloat;


// `Number.parseFloat` method
// https://tc39.es/ecma262/#sec-number.parseFloat
// eslint-disable-next-line es/no-number-parsefloat -- required for testing
$ef48c8e0540d6569$exports({
    target: "Number",
    stat: true,
    forced: Number.parseFloat !== $72899ef6a0136bb1$exports
}, {
    parseFloat: $72899ef6a0136bb1$exports
});


"use strict";

var $8214a8d506814724$exports = {};
"use strict";





var $8214a8d506814724$require$trim = $95bd89ea43e67dd3$exports.trim;

var $8214a8d506814724$var$$parseInt = $212fa519f4bef41a$exports.parseInt;
var $8214a8d506814724$var$Symbol = $212fa519f4bef41a$exports.Symbol;
var $8214a8d506814724$var$ITERATOR = $8214a8d506814724$var$Symbol && $8214a8d506814724$var$Symbol.iterator;
var $8214a8d506814724$var$hex = /^[+-]?0x/i;
var $8214a8d506814724$var$exec = $c201050ed73b14ba$exports($8214a8d506814724$var$hex.exec);
var $8214a8d506814724$var$FORCED = $8214a8d506814724$var$$parseInt($09e23748e3ca5e72$exports + "08") !== 8 || $8214a8d506814724$var$$parseInt($09e23748e3ca5e72$exports + "0x16") !== 22 || $8214a8d506814724$var$ITERATOR && !$217c917c4f59b359$exports(function() {
    $8214a8d506814724$var$$parseInt(Object($8214a8d506814724$var$ITERATOR));
});
// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
$8214a8d506814724$exports = $8214a8d506814724$var$FORCED ? function parseInt(string, radix) {
    var S = $8214a8d506814724$require$trim($5eca6f9e01902ab4$exports(string));
    return $8214a8d506814724$var$$parseInt(S, radix >>> 0 || ($8214a8d506814724$var$exec($8214a8d506814724$var$hex, S) ? 16 : 10));
} : $8214a8d506814724$var$$parseInt;


// `Number.parseInt` method
// https://tc39.es/ecma262/#sec-number.parseint
// eslint-disable-next-line es/no-number-parseint -- required for testing
$ef48c8e0540d6569$exports({
    target: "Number",
    stat: true,
    forced: Number.parseInt !== $8214a8d506814724$exports
}, {
    parseInt: $8214a8d506814724$exports
});


"use strict";



var $0953585e18aa294e$exports = {};
"use strict";

// `thisNumberValue` abstract operation
// https://tc39.es/ecma262/#sec-thisnumbervalue
$0953585e18aa294e$exports = $c201050ed73b14ba$exports(1.0.valueOf);


var $13b3209d388f3bc3$exports = {};
"use strict";



var $13b3209d388f3bc3$var$$RangeError = RangeError;
// `String.prototype.repeat` method implementation
// https://tc39.es/ecma262/#sec-string.prototype.repeat
$13b3209d388f3bc3$exports = function repeat(count) {
    var str = $5eca6f9e01902ab4$exports($07418f2e69c51fa2$exports(this));
    var result = "";
    var n = $8d76b52b36a52486$exports(count);
    if (n < 0 || n === Infinity) throw new $13b3209d388f3bc3$var$$RangeError("Wrong number of repetitions");
    for(; n > 0; (n >>>= 1) && (str += str))if (n & 1) result += str;
    return result;
};



var $a84bbeff2049395a$var$$RangeError = RangeError;
var $a84bbeff2049395a$var$$String = String;
var $a84bbeff2049395a$var$floor = Math.floor;
var $a84bbeff2049395a$var$repeat = $c201050ed73b14ba$exports($13b3209d388f3bc3$exports);
var $a84bbeff2049395a$var$stringSlice = $c201050ed73b14ba$exports("".slice);
var $a84bbeff2049395a$var$nativeToFixed = $c201050ed73b14ba$exports(1.0.toFixed);
var $a84bbeff2049395a$var$pow = function(x, n, acc) {
    return n === 0 ? acc : n % 2 === 1 ? $a84bbeff2049395a$var$pow(x, n - 1, acc * x) : $a84bbeff2049395a$var$pow(x * x, n / 2, acc);
};
var $a84bbeff2049395a$var$log = function(x) {
    var n = 0;
    var x2 = x;
    while(x2 >= 4096){
        n += 12;
        x2 /= 4096;
    }
    while(x2 >= 2){
        n += 1;
        x2 /= 2;
    }
    return n;
};
var $a84bbeff2049395a$var$multiply = function(data, n, c) {
    var index = -1;
    var c2 = c;
    while(++index < 6){
        c2 += n * data[index];
        data[index] = c2 % 1e7;
        c2 = $a84bbeff2049395a$var$floor(c2 / 1e7);
    }
};
var $a84bbeff2049395a$var$divide = function(data, n) {
    var index = 6;
    var c = 0;
    while(--index >= 0){
        c += data[index];
        data[index] = $a84bbeff2049395a$var$floor(c / n);
        c = c % n * 1e7;
    }
};
var $a84bbeff2049395a$var$dataToString = function(data) {
    var index = 6;
    var s = "";
    while(--index >= 0)if (s !== "" || index === 0 || data[index] !== 0) {
        var t = $a84bbeff2049395a$var$$String(data[index]);
        s = s === "" ? t : s + $a84bbeff2049395a$var$repeat("0", 7 - t.length) + t;
    }
    return s;
};
var $a84bbeff2049395a$var$FORCED = $217c917c4f59b359$exports(function() {
    return $a84bbeff2049395a$var$nativeToFixed(0.00008, 3) !== "0.000" || $a84bbeff2049395a$var$nativeToFixed(0.9, 0) !== "1" || $a84bbeff2049395a$var$nativeToFixed(1.255, 2) !== "1.25" || $a84bbeff2049395a$var$nativeToFixed(1000000000000000128.0, 0) !== "1000000000000000128";
}) || !$217c917c4f59b359$exports(function() {
    // V8 ~ Android 4.3-
    $a84bbeff2049395a$var$nativeToFixed({});
});
// `Number.prototype.toFixed` method
// https://tc39.es/ecma262/#sec-number.prototype.tofixed
$ef48c8e0540d6569$exports({
    target: "Number",
    proto: true,
    forced: $a84bbeff2049395a$var$FORCED
}, {
    toFixed: function toFixed(fractionDigits) {
        var number = $0953585e18aa294e$exports(this);
        var fractDigits = $8d76b52b36a52486$exports(fractionDigits);
        var data = [
            0,
            0,
            0,
            0,
            0,
            0
        ];
        var sign = "";
        var result = "0";
        var e, z, j, k;
        // TODO: ES2018 increased the maximum number of fraction digits to 100, need to improve the implementation
        if (fractDigits < 0 || fractDigits > 20) throw new $a84bbeff2049395a$var$$RangeError("Incorrect fraction digits");
        // eslint-disable-next-line no-self-compare -- NaN check
        if (number !== number) return "NaN";
        if (number <= -1000000000000000000000 || number >= 1e21) return $a84bbeff2049395a$var$$String(number);
        if (number < 0) {
            sign = "-";
            number = -number;
        }
        if (number > 1e-21) {
            e = $a84bbeff2049395a$var$log(number * $a84bbeff2049395a$var$pow(2, 69, 1)) - 69;
            z = e < 0 ? number * $a84bbeff2049395a$var$pow(2, -e, 1) : number / $a84bbeff2049395a$var$pow(2, e, 1);
            z *= 0x10000000000000;
            e = 52 - e;
            if (e > 0) {
                $a84bbeff2049395a$var$multiply(data, 0, z);
                j = fractDigits;
                while(j >= 7){
                    $a84bbeff2049395a$var$multiply(data, 1e7, 0);
                    j -= 7;
                }
                $a84bbeff2049395a$var$multiply(data, $a84bbeff2049395a$var$pow(10, j, 1), 0);
                j = e - 1;
                while(j >= 23){
                    $a84bbeff2049395a$var$divide(data, 8388608);
                    j -= 23;
                }
                $a84bbeff2049395a$var$divide(data, 1 << j);
                $a84bbeff2049395a$var$multiply(data, 1, 1);
                $a84bbeff2049395a$var$divide(data, 2);
                result = $a84bbeff2049395a$var$dataToString(data);
            } else {
                $a84bbeff2049395a$var$multiply(data, 0, z);
                $a84bbeff2049395a$var$multiply(data, 1 << -e, 0);
                result = $a84bbeff2049395a$var$dataToString(data) + $a84bbeff2049395a$var$repeat("0", fractDigits);
            }
        }
        if (fractDigits > 0) {
            k = result.length;
            result = sign + (k <= fractDigits ? "0." + $a84bbeff2049395a$var$repeat("0", fractDigits - k) + result : $a84bbeff2049395a$var$stringSlice(result, 0, k - fractDigits) + "." + $a84bbeff2049395a$var$stringSlice(result, k - fractDigits));
        } else result = sign + result;
        return result;
    }
});


"use strict";

var $c1606cd5236ce179$exports = {};
"use strict";









// eslint-disable-next-line es/no-object-assign -- safe
var $c1606cd5236ce179$var$$assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var $c1606cd5236ce179$var$defineProperty = Object.defineProperty;
var $c1606cd5236ce179$var$concat = $c201050ed73b14ba$exports([].concat);
// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
$c1606cd5236ce179$exports = !$c1606cd5236ce179$var$$assign || $217c917c4f59b359$exports(function() {
    // should have correct order of operations (Edge bug)
    if ($16b43a02da62cc11$exports && $c1606cd5236ce179$var$$assign({
        b: 1
    }, $c1606cd5236ce179$var$$assign($c1606cd5236ce179$var$defineProperty({}, "a", {
        enumerable: true,
        get: function() {
            $c1606cd5236ce179$var$defineProperty(this, "b", {
                value: 3,
                enumerable: false
            });
        }
    }), {
        b: 2
    })).b !== 1) return true;
    // should work with symbols and should have deterministic property order (V8 bug)
    var A = {};
    var B = {};
    // eslint-disable-next-line es/no-symbol -- safe
    var symbol = Symbol("assign detection");
    var alphabet = "abcdefghijklmnopqrst";
    A[symbol] = 7;
    alphabet.split("").forEach(function(chr) {
        B[chr] = chr;
    });
    return $c1606cd5236ce179$var$$assign({}, A)[symbol] !== 7 || $f5ab74bf375b4ea8$exports($c1606cd5236ce179$var$$assign({}, B)).join("") !== alphabet;
}) ? function assign(target, source) {
    var T = $361c03d23168e423$exports(target);
    var argumentsLength = arguments.length;
    var index = 1;
    var getOwnPropertySymbols = $bb2b38985ad7e191$export$2d1720544b23b823;
    var propertyIsEnumerable = $f6b684d67cc87fbe$export$2d1720544b23b823;
    while(argumentsLength > index){
        var S = $8086cf521fa8b34c$exports(arguments[index++]);
        var keys = getOwnPropertySymbols ? $c1606cd5236ce179$var$concat($f5ab74bf375b4ea8$exports(S), getOwnPropertySymbols(S)) : $f5ab74bf375b4ea8$exports(S);
        var length = keys.length;
        var j = 0;
        var key;
        while(length > j){
            key = keys[j++];
            if (!$16b43a02da62cc11$exports || $2f17e9746e5fde89$exports(propertyIsEnumerable, S, key)) T[key] = S[key];
        }
    }
    return T;
} : $c1606cd5236ce179$var$$assign;


// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$ef48c8e0540d6569$exports({
    target: "Object",
    stat: true,
    arity: 2,
    forced: Object.assign !== $c1606cd5236ce179$exports
}, {
    assign: $c1606cd5236ce179$exports
});


"use strict";


var $f69bc7a4ef624d83$exports = {};
"use strict";




// Forced replacement object prototype accessors methods
$f69bc7a4ef624d83$exports = $036c29a074575bd6$exports || !$217c917c4f59b359$exports(function() {
    // This feature detection crashes old WebKit
    // https://github.com/zloirock/core-js/issues/232
    if ($c2d1f4653f16d67a$exports && $c2d1f4653f16d67a$exports < 535) return;
    var key = Math.random();
    // In FF throws only define methods
    // eslint-disable-next-line no-undef, no-useless-call, es/no-legacy-object-prototype-accessor-methods -- required for testing
    __defineSetter__.call(null, key, function() {});
    delete $212fa519f4bef41a$exports[key];
});





// `Object.prototype.__defineGetter__` method
// https://tc39.es/ecma262/#sec-object.prototype.__defineGetter__
if ($16b43a02da62cc11$exports) $ef48c8e0540d6569$exports({
    target: "Object",
    proto: true,
    forced: $f69bc7a4ef624d83$exports
}, {
    __defineGetter__: function __defineGetter__(P, getter) {
        $0163cc0a742cd3ad$export$2d1720544b23b823($361c03d23168e423$exports(this), P, {
            get: $6df447ad4be37421$exports(getter),
            enumerable: true,
            configurable: true
        });
    }
});


"use strict";






// `Object.prototype.__defineSetter__` method
// https://tc39.es/ecma262/#sec-object.prototype.__defineSetter__
if ($16b43a02da62cc11$exports) $ef48c8e0540d6569$exports({
    target: "Object",
    proto: true,
    forced: $f69bc7a4ef624d83$exports
}, {
    __defineSetter__: function __defineSetter__(P, setter) {
        $0163cc0a742cd3ad$export$2d1720544b23b823($361c03d23168e423$exports(this), P, {
            set: $6df447ad4be37421$exports(setter),
            enumerable: true,
            configurable: true
        });
    }
});


"use strict";

var $1067bad61af3a5d4$exports = {};
"use strict";




var $0c7638bc83d11df5$exports = {};
"use strict";


var $0c7638bc83d11df5$var$ITERATOR = $bbf4e852bf6421ea$exports("iterator");
var $0c7638bc83d11df5$var$ArrayPrototype = Array.prototype;
// check on default Array iterator
$0c7638bc83d11df5$exports = function(it) {
    return it !== undefined && ($2d9742e698a8c85c$exports.Array === it || $0c7638bc83d11df5$var$ArrayPrototype[$0c7638bc83d11df5$var$ITERATOR] === it);
};




var $89f16bd42f655d35$exports = {};
"use strict";




var $11873dac339e5ad0$exports = {};
"use strict";





var $11873dac339e5ad0$var$ITERATOR = $bbf4e852bf6421ea$exports("iterator");
$11873dac339e5ad0$exports = function(it) {
    if (!$e64dc79af48a1328$exports(it)) return $a1d58592526cda62$exports(it, $11873dac339e5ad0$var$ITERATOR) || $a1d58592526cda62$exports(it, "@@iterator") || $2d9742e698a8c85c$exports[$7d156d7c862bc268$exports(it)];
};


var $89f16bd42f655d35$var$$TypeError = TypeError;
$89f16bd42f655d35$exports = function(argument, usingIterator) {
    var iteratorMethod = arguments.length < 2 ? $11873dac339e5ad0$exports(argument) : usingIterator;
    if ($6df447ad4be37421$exports(iteratorMethod)) return $affc609f2393bdba$exports($2f17e9746e5fde89$exports(iteratorMethod, argument));
    throw new $89f16bd42f655d35$var$$TypeError($bb66d003fc13d318$exports(argument) + " is not iterable");
};



var $5433b3170981ac13$exports = {};
"use strict";



$5433b3170981ac13$exports = function(iterator, kind, value) {
    var innerResult, innerError;
    $affc609f2393bdba$exports(iterator);
    try {
        innerResult = $a1d58592526cda62$exports(iterator, "return");
        if (!innerResult) {
            if (kind === "throw") throw value;
            return value;
        }
        innerResult = $2f17e9746e5fde89$exports(innerResult, iterator);
    } catch (error) {
        innerError = true;
        innerResult = error;
    }
    if (kind === "throw") throw value;
    if (innerError) throw innerResult;
    $affc609f2393bdba$exports(innerResult);
    return value;
};


var $1067bad61af3a5d4$var$$TypeError = TypeError;
var $1067bad61af3a5d4$var$Result = function(stopped, result) {
    this.stopped = stopped;
    this.result = result;
};
var $1067bad61af3a5d4$var$ResultPrototype = $1067bad61af3a5d4$var$Result.prototype;
$1067bad61af3a5d4$exports = function(iterable, unboundFunction, options) {
    var that = options && options.that;
    var AS_ENTRIES = !!(options && options.AS_ENTRIES);
    var IS_RECORD = !!(options && options.IS_RECORD);
    var IS_ITERATOR = !!(options && options.IS_ITERATOR);
    var INTERRUPTED = !!(options && options.INTERRUPTED);
    var fn = $2db6a9f70c481925$exports(unboundFunction, that);
    var iterator, iterFn, index, length, result, next, step;
    var stop = function(condition) {
        if (iterator) $5433b3170981ac13$exports(iterator, "normal", condition);
        return new $1067bad61af3a5d4$var$Result(true, condition);
    };
    var callFn = function(value) {
        if (AS_ENTRIES) {
            $affc609f2393bdba$exports(value);
            return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
        }
        return INTERRUPTED ? fn(value, stop) : fn(value);
    };
    if (IS_RECORD) iterator = iterable.iterator;
    else if (IS_ITERATOR) iterator = iterable;
    else {
        iterFn = $11873dac339e5ad0$exports(iterable);
        if (!iterFn) throw new $1067bad61af3a5d4$var$$TypeError($bb66d003fc13d318$exports(iterable) + " is not iterable");
        // optimisation for array iterators
        if ($0c7638bc83d11df5$exports(iterFn)) {
            for(index = 0, length = $3f18e45666a111c8$exports(iterable); length > index; index++){
                result = callFn(iterable[index]);
                if (result && $dba85d7bd7ffe0d7$exports($1067bad61af3a5d4$var$ResultPrototype, result)) return result;
            }
            return new $1067bad61af3a5d4$var$Result(false);
        }
        iterator = $89f16bd42f655d35$exports(iterable, iterFn);
    }
    next = IS_RECORD ? iterable.next : iterator.next;
    while(!(step = $2f17e9746e5fde89$exports(next, iterator)).done){
        try {
            result = callFn(step.value);
        } catch (error) {
            $5433b3170981ac13$exports(iterator, "throw", error);
        }
        if (typeof result == "object" && result && $dba85d7bd7ffe0d7$exports($1067bad61af3a5d4$var$ResultPrototype, result)) return result;
    }
    return new $1067bad61af3a5d4$var$Result(false);
};



// `Object.fromEntries` method
// https://github.com/tc39/proposal-object-from-entries
$ef48c8e0540d6569$exports({
    target: "Object",
    stat: true
}, {
    fromEntries: function fromEntries(iterable) {
        var obj = {};
        $1067bad61af3a5d4$exports(iterable, function(k, v) {
            $ec6a13a4c4f7948e$exports(obj, k, v);
        }, {
            AS_ENTRIES: true
        });
        return obj;
    }
});


"use strict";







var $7141cbbd7da86e28$require$getOwnPropertyDescriptor = $3cd2e4c9005c1909$export$2d1720544b23b823;
// `Object.prototype.__lookupGetter__` method
// https://tc39.es/ecma262/#sec-object.prototype.__lookupGetter__
if ($16b43a02da62cc11$exports) $ef48c8e0540d6569$exports({
    target: "Object",
    proto: true,
    forced: $f69bc7a4ef624d83$exports
}, {
    __lookupGetter__: function __lookupGetter__(P) {
        var O = $361c03d23168e423$exports(this);
        var key = $4dbc0d7468e7eb76$exports(P);
        var desc;
        do {
            if (desc = $7141cbbd7da86e28$require$getOwnPropertyDescriptor(O, key)) return desc.get;
        }while (O = $e5c52a606c67a805$exports(O));
    }
});


"use strict";







var $6a9e10c3e9da1bca$require$getOwnPropertyDescriptor = $3cd2e4c9005c1909$export$2d1720544b23b823;
// `Object.prototype.__lookupSetter__` method
// https://tc39.es/ecma262/#sec-object.prototype.__lookupSetter__
if ($16b43a02da62cc11$exports) $ef48c8e0540d6569$exports({
    target: "Object",
    proto: true,
    forced: $f69bc7a4ef624d83$exports
}, {
    __lookupSetter__: function __lookupSetter__(P) {
        var O = $361c03d23168e423$exports(this);
        var key = $4dbc0d7468e7eb76$exports(P);
        var desc;
        do {
            if (desc = $6a9e10c3e9da1bca$require$getOwnPropertyDescriptor(O, key)) return desc.set;
        }while (O = $e5c52a606c67a805$exports(O));
    }
});


"use strict";


// `parseFloat` method
// https://tc39.es/ecma262/#sec-parsefloat-string
$ef48c8e0540d6569$exports({
    global: true,
    forced: parseFloat !== $72899ef6a0136bb1$exports
}, {
    parseFloat: $72899ef6a0136bb1$exports
});


"use strict";


// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
$ef48c8e0540d6569$exports({
    global: true,
    forced: parseInt !== $8214a8d506814724$exports
}, {
    parseInt: $8214a8d506814724$exports
});


"use strict";
"use strict";














var $660f9a894434a192$exports = {};
"use strict";

var $9cb3247174ca8cfd$exports = {};
"use strict";

var $9cb3247174ca8cfd$var$FunctionPrototype = Function.prototype;
var $9cb3247174ca8cfd$var$apply = $9cb3247174ca8cfd$var$FunctionPrototype.apply;
var $9cb3247174ca8cfd$var$call = $9cb3247174ca8cfd$var$FunctionPrototype.call;
// eslint-disable-next-line es/no-reflect -- safe
$9cb3247174ca8cfd$exports = typeof Reflect == "object" && Reflect.apply || ($4da6c0a05b2e762d$exports ? $9cb3247174ca8cfd$var$call.bind($9cb3247174ca8cfd$var$apply) : function() {
    return $9cb3247174ca8cfd$var$call.apply($9cb3247174ca8cfd$var$apply, arguments);
});







var $a1fdbc3bb6749f54$exports = {};
"use strict";

$a1fdbc3bb6749f54$exports = $c201050ed73b14ba$exports([].slice);



var $44813c6cb2f7b76c$exports = {};
"use strict";
var $44813c6cb2f7b76c$var$$TypeError = TypeError;
$44813c6cb2f7b76c$exports = function(passed, required) {
    if (passed < required) throw new $44813c6cb2f7b76c$var$$TypeError("Not enough arguments");
    return passed;
};


var $f48a3c05065936d0$exports = {};
"use strict";

// eslint-disable-next-line redos/no-vulnerable -- safe
$f48a3c05065936d0$exports = /(?:ipad|iphone|ipod).*applewebkit/i.test($10e5337eedcfb10c$exports);



var $660f9a894434a192$var$set = $212fa519f4bef41a$exports.setImmediate;
var $660f9a894434a192$var$clear = $212fa519f4bef41a$exports.clearImmediate;
var $660f9a894434a192$var$process = $212fa519f4bef41a$exports.process;
var $660f9a894434a192$var$Dispatch = $212fa519f4bef41a$exports.Dispatch;
var $660f9a894434a192$var$Function = $212fa519f4bef41a$exports.Function;
var $660f9a894434a192$var$MessageChannel = $212fa519f4bef41a$exports.MessageChannel;
var $660f9a894434a192$var$String = $212fa519f4bef41a$exports.String;
var $660f9a894434a192$var$counter = 0;
var $660f9a894434a192$var$queue = {};
var $660f9a894434a192$var$ONREADYSTATECHANGE = "onreadystatechange";
var $660f9a894434a192$var$$location, $660f9a894434a192$var$defer, $660f9a894434a192$var$channel, $660f9a894434a192$var$port;
$217c917c4f59b359$exports(function() {
    // Deno throws a ReferenceError on `location` access without `--location` flag
    $660f9a894434a192$var$$location = $212fa519f4bef41a$exports.location;
});
var $660f9a894434a192$var$run = function(id) {
    if ($1ad0c60d8de14c83$exports($660f9a894434a192$var$queue, id)) {
        var fn = $660f9a894434a192$var$queue[id];
        delete $660f9a894434a192$var$queue[id];
        fn();
    }
};
var $660f9a894434a192$var$runner = function(id) {
    return function() {
        $660f9a894434a192$var$run(id);
    };
};
var $660f9a894434a192$var$eventListener = function(event) {
    $660f9a894434a192$var$run(event.data);
};
var $660f9a894434a192$var$globalPostMessageDefer = function(id) {
    // old engines have not location.origin
    $212fa519f4bef41a$exports.postMessage($660f9a894434a192$var$String(id), $660f9a894434a192$var$$location.protocol + "//" + $660f9a894434a192$var$$location.host);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!$660f9a894434a192$var$set || !$660f9a894434a192$var$clear) {
    $660f9a894434a192$var$set = function setImmediate(handler) {
        $44813c6cb2f7b76c$exports(arguments.length, 1);
        var fn = $73d1a34d94fa4c35$exports(handler) ? handler : $660f9a894434a192$var$Function(handler);
        var args = $a1fdbc3bb6749f54$exports(arguments, 1);
        $660f9a894434a192$var$queue[++$660f9a894434a192$var$counter] = function() {
            $9cb3247174ca8cfd$exports(fn, undefined, args);
        };
        $660f9a894434a192$var$defer($660f9a894434a192$var$counter);
        return $660f9a894434a192$var$counter;
    };
    $660f9a894434a192$var$clear = function clearImmediate(id) {
        delete $660f9a894434a192$var$queue[id];
    };
    // Node.js 0.8-
    if ($9002d9a40e113f56$exports) $660f9a894434a192$var$defer = function(id) {
        $660f9a894434a192$var$process.nextTick($660f9a894434a192$var$runner(id));
    };
    else if ($660f9a894434a192$var$Dispatch && $660f9a894434a192$var$Dispatch.now) $660f9a894434a192$var$defer = function(id) {
        $660f9a894434a192$var$Dispatch.now($660f9a894434a192$var$runner(id));
    };
    else if ($660f9a894434a192$var$MessageChannel && !$f48a3c05065936d0$exports) {
        $660f9a894434a192$var$channel = new $660f9a894434a192$var$MessageChannel();
        $660f9a894434a192$var$port = $660f9a894434a192$var$channel.port2;
        $660f9a894434a192$var$channel.port1.onmessage = $660f9a894434a192$var$eventListener;
        $660f9a894434a192$var$defer = $2db6a9f70c481925$exports($660f9a894434a192$var$port.postMessage, $660f9a894434a192$var$port);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    } else if ($212fa519f4bef41a$exports.addEventListener && $73d1a34d94fa4c35$exports($212fa519f4bef41a$exports.postMessage) && !$212fa519f4bef41a$exports.importScripts && $660f9a894434a192$var$$location && $660f9a894434a192$var$$location.protocol !== "file:" && !$217c917c4f59b359$exports($660f9a894434a192$var$globalPostMessageDefer)) {
        $660f9a894434a192$var$defer = $660f9a894434a192$var$globalPostMessageDefer;
        $212fa519f4bef41a$exports.addEventListener("message", $660f9a894434a192$var$eventListener, false);
    // IE8-
    } else if ($660f9a894434a192$var$ONREADYSTATECHANGE in $5b8a2493ea30b53c$exports("script")) $660f9a894434a192$var$defer = function(id) {
        $74eb1bae1f2deb49$exports.appendChild($5b8a2493ea30b53c$exports("script"))[$660f9a894434a192$var$ONREADYSTATECHANGE] = function() {
            $74eb1bae1f2deb49$exports.removeChild(this);
            $660f9a894434a192$var$run(id);
        };
    };
    else $660f9a894434a192$var$defer = function(id) {
        setTimeout($660f9a894434a192$var$runner(id), 0);
    };
}
$660f9a894434a192$exports = {
    set: $660f9a894434a192$var$set,
    clear: $660f9a894434a192$var$clear
};


var $316ec5507754a97f$require$task = $660f9a894434a192$exports.set;
var $4174e122d6b4eb8a$exports = {};
"use strict";



var $4174e122d6b4eb8a$require$getOwnPropertyDescriptor = $3cd2e4c9005c1909$export$2d1720544b23b823;

var $4174e122d6b4eb8a$require$macrotask = $660f9a894434a192$exports.set;
var $5700926495c5b4b1$exports = {};
"use strict";
var $5700926495c5b4b1$var$Queue = function() {
    this.head = null;
    this.tail = null;
};
$5700926495c5b4b1$var$Queue.prototype = {
    add: function(item) {
        var entry = {
            item: item,
            next: null
        };
        var tail = this.tail;
        if (tail) tail.next = entry;
        else this.head = entry;
        this.tail = entry;
    },
    get: function() {
        var entry = this.head;
        if (entry) {
            var next = this.head = entry.next;
            if (next === null) this.tail = null;
            return entry.item;
        }
    }
};
$5700926495c5b4b1$exports = $5700926495c5b4b1$var$Queue;



var $55c79e7bdb6952c7$exports = {};
"use strict";

$55c79e7bdb6952c7$exports = /ipad|iphone|ipod/i.test($10e5337eedcfb10c$exports) && typeof Pebble != "undefined";


var $927acdb32ff9d31c$exports = {};
"use strict";

$927acdb32ff9d31c$exports = /web0s(?!.*chrome)/i.test($10e5337eedcfb10c$exports);



var $4174e122d6b4eb8a$var$MutationObserver = $212fa519f4bef41a$exports.MutationObserver || $212fa519f4bef41a$exports.WebKitMutationObserver;
var $4174e122d6b4eb8a$var$document = $212fa519f4bef41a$exports.document;
var $4174e122d6b4eb8a$var$process = $212fa519f4bef41a$exports.process;
var $4174e122d6b4eb8a$var$Promise = $212fa519f4bef41a$exports.Promise;
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var $4174e122d6b4eb8a$var$queueMicrotaskDescriptor = $4174e122d6b4eb8a$require$getOwnPropertyDescriptor($212fa519f4bef41a$exports, "queueMicrotask");
var $4174e122d6b4eb8a$var$microtask = $4174e122d6b4eb8a$var$queueMicrotaskDescriptor && $4174e122d6b4eb8a$var$queueMicrotaskDescriptor.value;
var $4174e122d6b4eb8a$var$notify, $4174e122d6b4eb8a$var$toggle, $4174e122d6b4eb8a$var$node, $4174e122d6b4eb8a$var$promise, $4174e122d6b4eb8a$var$then;
// modern engines have queueMicrotask method
if (!$4174e122d6b4eb8a$var$microtask) {
    var $4174e122d6b4eb8a$var$queue = new $5700926495c5b4b1$exports();
    var $4174e122d6b4eb8a$var$flush = function() {
        var parent, fn;
        if ($9002d9a40e113f56$exports && (parent = $4174e122d6b4eb8a$var$process.domain)) parent.exit();
        while(fn = $4174e122d6b4eb8a$var$queue.get())try {
            fn();
        } catch (error) {
            if ($4174e122d6b4eb8a$var$queue.head) $4174e122d6b4eb8a$var$notify();
            throw error;
        }
        if (parent) parent.enter();
    };
    // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
    // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
    if (!$f48a3c05065936d0$exports && !$9002d9a40e113f56$exports && !$927acdb32ff9d31c$exports && $4174e122d6b4eb8a$var$MutationObserver && $4174e122d6b4eb8a$var$document) {
        $4174e122d6b4eb8a$var$toggle = true;
        $4174e122d6b4eb8a$var$node = $4174e122d6b4eb8a$var$document.createTextNode("");
        new $4174e122d6b4eb8a$var$MutationObserver($4174e122d6b4eb8a$var$flush).observe($4174e122d6b4eb8a$var$node, {
            characterData: true
        });
        $4174e122d6b4eb8a$var$notify = function() {
            $4174e122d6b4eb8a$var$node.data = $4174e122d6b4eb8a$var$toggle = !$4174e122d6b4eb8a$var$toggle;
        };
    // environments with maybe non-completely correct, but existent Promise
    } else if (!$55c79e7bdb6952c7$exports && $4174e122d6b4eb8a$var$Promise && $4174e122d6b4eb8a$var$Promise.resolve) {
        // Promise.resolve without an argument throws an error in LG WebOS 2
        $4174e122d6b4eb8a$var$promise = $4174e122d6b4eb8a$var$Promise.resolve(undefined);
        // workaround of WebKit ~ iOS Safari 10.1 bug
        $4174e122d6b4eb8a$var$promise.constructor = $4174e122d6b4eb8a$var$Promise;
        $4174e122d6b4eb8a$var$then = $2db6a9f70c481925$exports($4174e122d6b4eb8a$var$promise.then, $4174e122d6b4eb8a$var$promise);
        $4174e122d6b4eb8a$var$notify = function() {
            $4174e122d6b4eb8a$var$then($4174e122d6b4eb8a$var$flush);
        };
    // Node.js without promises
    } else if ($9002d9a40e113f56$exports) $4174e122d6b4eb8a$var$notify = function() {
        $4174e122d6b4eb8a$var$process.nextTick($4174e122d6b4eb8a$var$flush);
    };
    else {
        // `webpack` dev server bug on IE global methods - use bind(fn, global)
        $4174e122d6b4eb8a$require$macrotask = $2db6a9f70c481925$exports($4174e122d6b4eb8a$require$macrotask, $212fa519f4bef41a$exports);
        $4174e122d6b4eb8a$var$notify = function() {
            $4174e122d6b4eb8a$require$macrotask($4174e122d6b4eb8a$var$flush);
        };
    }
    $4174e122d6b4eb8a$var$microtask = function(fn) {
        if (!$4174e122d6b4eb8a$var$queue.head) $4174e122d6b4eb8a$var$notify();
        $4174e122d6b4eb8a$var$queue.add(fn);
    };
}
$4174e122d6b4eb8a$exports = $4174e122d6b4eb8a$var$microtask;


var $a52341f32563d18b$exports = {};
"use strict";
$a52341f32563d18b$exports = function(a, b) {
    try {
        // eslint-disable-next-line no-console -- safe
        arguments.length === 1 ? console.error(a) : console.error(a, b);
    } catch (error) {}
};


var $f8c91a7dd342833c$exports = {};
"use strict";
$f8c91a7dd342833c$exports = function(exec) {
    try {
        return {
            error: false,
            value: exec()
        };
    } catch (error) {
        return {
            error: true,
            value: error
        };
    }
};




var $bdc6200b8cf20395$exports = {};
"use strict";

$bdc6200b8cf20395$exports = $212fa519f4bef41a$exports.Promise;


var $0096134d912183c2$exports = {};
"use strict";






var $38d1d0a4deddb257$exports = {};
"use strict";
var $1bb63513cb801ac0$exports = {};
"use strict";
/* global Deno -- Deno case */ $1bb63513cb801ac0$exports = typeof Deno == "object" && Deno && typeof Deno.version == "object";



$38d1d0a4deddb257$exports = !$1bb63513cb801ac0$exports && !$9002d9a40e113f56$exports && typeof window == "object" && typeof document == "object";





var $0096134d912183c2$var$NativePromisePrototype = $bdc6200b8cf20395$exports && $bdc6200b8cf20395$exports.prototype;
var $0096134d912183c2$var$SPECIES = $bbf4e852bf6421ea$exports("species");
var $0096134d912183c2$var$SUBCLASSING = false;
var $0096134d912183c2$var$NATIVE_PROMISE_REJECTION_EVENT = $73d1a34d94fa4c35$exports($212fa519f4bef41a$exports.PromiseRejectionEvent);
var $0096134d912183c2$var$FORCED_PROMISE_CONSTRUCTOR = $e48b32723d42f00b$exports("Promise", function() {
    var PROMISE_CONSTRUCTOR_SOURCE = $d96e0a7b2ae7b4d6$exports($bdc6200b8cf20395$exports);
    var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String($bdc6200b8cf20395$exports);
    // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
    // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
    // We can't detect it synchronously, so just check versions
    if (!GLOBAL_CORE_JS_PROMISE && $aed210e8b55f96e7$exports === 66) return true;
    // We need Promise#{ catch, finally } in the pure version for preventing prototype pollution
    if ($036c29a074575bd6$exports && !($0096134d912183c2$var$NativePromisePrototype["catch"] && $0096134d912183c2$var$NativePromisePrototype["finally"])) return true;
    // We can't use @@species feature detection in V8 since it causes
    // deoptimization and performance degradation
    // https://github.com/zloirock/core-js/issues/679
    if (!$aed210e8b55f96e7$exports || $aed210e8b55f96e7$exports < 51 || !/native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) {
        // Detect correctness of subclassing with @@species support
        var promise = new $bdc6200b8cf20395$exports(function(resolve) {
            resolve(1);
        });
        var FakePromise = function(exec) {
            exec(function() {}, function() {});
        };
        var constructor = promise.constructor = {};
        constructor[$0096134d912183c2$var$SPECIES] = FakePromise;
        $0096134d912183c2$var$SUBCLASSING = promise.then(function() {}) instanceof FakePromise;
        if (!$0096134d912183c2$var$SUBCLASSING) return true;
    // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    }
    return !GLOBAL_CORE_JS_PROMISE && ($38d1d0a4deddb257$exports || $1bb63513cb801ac0$exports) && !$0096134d912183c2$var$NATIVE_PROMISE_REJECTION_EVENT;
});
$0096134d912183c2$exports = {
    CONSTRUCTOR: $0096134d912183c2$var$FORCED_PROMISE_CONSTRUCTOR,
    REJECTION_EVENT: $0096134d912183c2$var$NATIVE_PROMISE_REJECTION_EVENT,
    SUBCLASSING: $0096134d912183c2$var$SUBCLASSING
};


// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
var $c335377c5f9c8743$export$2d1720544b23b823;
"use strict";

var $c335377c5f9c8743$var$$TypeError = TypeError;
var $c335377c5f9c8743$var$PromiseCapability = function(C) {
    var resolve, reject;
    this.promise = new C(function($$resolve, $$reject) {
        if (resolve !== undefined || reject !== undefined) throw new $c335377c5f9c8743$var$$TypeError("Bad Promise constructor");
        resolve = $$resolve;
        reject = $$reject;
    });
    this.resolve = $6df447ad4be37421$exports(resolve);
    this.reject = $6df447ad4be37421$exports(reject);
};
$c335377c5f9c8743$export$2d1720544b23b823 = function(C) {
    return new $c335377c5f9c8743$var$PromiseCapability(C);
};


var $316ec5507754a97f$var$PROMISE = "Promise";
var $316ec5507754a97f$var$FORCED_PROMISE_CONSTRUCTOR = $0096134d912183c2$exports.CONSTRUCTOR;
var $316ec5507754a97f$var$NATIVE_PROMISE_REJECTION_EVENT = $0096134d912183c2$exports.REJECTION_EVENT;
var $316ec5507754a97f$var$NATIVE_PROMISE_SUBCLASSING = $0096134d912183c2$exports.SUBCLASSING;
var $316ec5507754a97f$var$getInternalPromiseState = $954a2ea894ec1c9c$exports.getterFor($316ec5507754a97f$var$PROMISE);
var $316ec5507754a97f$var$setInternalState = $954a2ea894ec1c9c$exports.set;
var $316ec5507754a97f$var$NativePromisePrototype = $bdc6200b8cf20395$exports && $bdc6200b8cf20395$exports.prototype;
var $316ec5507754a97f$var$PromiseConstructor = $bdc6200b8cf20395$exports;
var $316ec5507754a97f$var$PromisePrototype = $316ec5507754a97f$var$NativePromisePrototype;
var $316ec5507754a97f$var$TypeError = $212fa519f4bef41a$exports.TypeError;
var $316ec5507754a97f$var$document = $212fa519f4bef41a$exports.document;
var $316ec5507754a97f$var$process = $212fa519f4bef41a$exports.process;
var $316ec5507754a97f$var$newPromiseCapability = $c335377c5f9c8743$export$2d1720544b23b823;
var $316ec5507754a97f$var$newGenericPromiseCapability = $316ec5507754a97f$var$newPromiseCapability;
var $316ec5507754a97f$var$DISPATCH_EVENT = !!($316ec5507754a97f$var$document && $316ec5507754a97f$var$document.createEvent && $212fa519f4bef41a$exports.dispatchEvent);
var $316ec5507754a97f$var$UNHANDLED_REJECTION = "unhandledrejection";
var $316ec5507754a97f$var$REJECTION_HANDLED = "rejectionhandled";
var $316ec5507754a97f$var$PENDING = 0;
var $316ec5507754a97f$var$FULFILLED = 1;
var $316ec5507754a97f$var$REJECTED = 2;
var $316ec5507754a97f$var$HANDLED = 1;
var $316ec5507754a97f$var$UNHANDLED = 2;
var $316ec5507754a97f$var$Internal, $316ec5507754a97f$var$OwnPromiseCapability, $316ec5507754a97f$var$PromiseWrapper, $316ec5507754a97f$var$nativeThen;
// helpers
var $316ec5507754a97f$var$isThenable = function(it) {
    var then;
    return $06f10e9b9cb1418c$exports(it) && $73d1a34d94fa4c35$exports(then = it.then) ? then : false;
};
var $316ec5507754a97f$var$callReaction = function(reaction, state) {
    var value = state.value;
    var ok = state.state === $316ec5507754a97f$var$FULFILLED;
    var handler = ok ? reaction.ok : reaction.fail;
    var resolve = reaction.resolve;
    var reject = reaction.reject;
    var domain = reaction.domain;
    var result, then, exited;
    try {
        if (handler) {
            if (!ok) {
                if (state.rejection === $316ec5507754a97f$var$UNHANDLED) $316ec5507754a97f$var$onHandleUnhandled(state);
                state.rejection = $316ec5507754a97f$var$HANDLED;
            }
            if (handler === true) result = value;
            else {
                if (domain) domain.enter();
                result = handler(value); // can throw
                if (domain) {
                    domain.exit();
                    exited = true;
                }
            }
            if (result === reaction.promise) reject(new $316ec5507754a97f$var$TypeError("Promise-chain cycle"));
            else if (then = $316ec5507754a97f$var$isThenable(result)) $2f17e9746e5fde89$exports(then, result, resolve, reject);
            else resolve(result);
        } else reject(value);
    } catch (error) {
        if (domain && !exited) domain.exit();
        reject(error);
    }
};
var $316ec5507754a97f$var$notify = function(state, isReject) {
    if (state.notified) return;
    state.notified = true;
    $4174e122d6b4eb8a$exports(function() {
        var reactions = state.reactions;
        var reaction;
        while(reaction = reactions.get())$316ec5507754a97f$var$callReaction(reaction, state);
        state.notified = false;
        if (isReject && !state.rejection) $316ec5507754a97f$var$onUnhandled(state);
    });
};
var $316ec5507754a97f$var$dispatchEvent = function(name, promise, reason) {
    var event, handler;
    if ($316ec5507754a97f$var$DISPATCH_EVENT) {
        event = $316ec5507754a97f$var$document.createEvent("Event");
        event.promise = promise;
        event.reason = reason;
        event.initEvent(name, false, true);
        $212fa519f4bef41a$exports.dispatchEvent(event);
    } else event = {
        promise: promise,
        reason: reason
    };
    if (!$316ec5507754a97f$var$NATIVE_PROMISE_REJECTION_EVENT && (handler = $212fa519f4bef41a$exports["on" + name])) handler(event);
    else if (name === $316ec5507754a97f$var$UNHANDLED_REJECTION) $a52341f32563d18b$exports("Unhandled promise rejection", reason);
};
var $316ec5507754a97f$var$onUnhandled = function(state) {
    $2f17e9746e5fde89$exports($316ec5507754a97f$require$task, $212fa519f4bef41a$exports, function() {
        var promise = state.facade;
        var value = state.value;
        var IS_UNHANDLED = $316ec5507754a97f$var$isUnhandled(state);
        var result;
        if (IS_UNHANDLED) {
            result = $f8c91a7dd342833c$exports(function() {
                if ($9002d9a40e113f56$exports) $316ec5507754a97f$var$process.emit("unhandledRejection", value, promise);
                else $316ec5507754a97f$var$dispatchEvent($316ec5507754a97f$var$UNHANDLED_REJECTION, promise, value);
            });
            // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
            state.rejection = $9002d9a40e113f56$exports || $316ec5507754a97f$var$isUnhandled(state) ? $316ec5507754a97f$var$UNHANDLED : $316ec5507754a97f$var$HANDLED;
            if (result.error) throw result.value;
        }
    });
};
var $316ec5507754a97f$var$isUnhandled = function(state) {
    return state.rejection !== $316ec5507754a97f$var$HANDLED && !state.parent;
};
var $316ec5507754a97f$var$onHandleUnhandled = function(state) {
    $2f17e9746e5fde89$exports($316ec5507754a97f$require$task, $212fa519f4bef41a$exports, function() {
        var promise = state.facade;
        if ($9002d9a40e113f56$exports) $316ec5507754a97f$var$process.emit("rejectionHandled", promise);
        else $316ec5507754a97f$var$dispatchEvent($316ec5507754a97f$var$REJECTION_HANDLED, promise, state.value);
    });
};
var $316ec5507754a97f$var$bind = function(fn, state, unwrap) {
    return function(value) {
        fn(state, value, unwrap);
    };
};
var $316ec5507754a97f$var$internalReject = function(state, value, unwrap) {
    if (state.done) return;
    state.done = true;
    if (unwrap) state = unwrap;
    state.value = value;
    state.state = $316ec5507754a97f$var$REJECTED;
    $316ec5507754a97f$var$notify(state, true);
};
var $316ec5507754a97f$var$internalResolve = function(state, value, unwrap) {
    if (state.done) return;
    state.done = true;
    if (unwrap) state = unwrap;
    try {
        if (state.facade === value) throw new $316ec5507754a97f$var$TypeError("Promise can't be resolved itself");
        var then = $316ec5507754a97f$var$isThenable(value);
        if (then) $4174e122d6b4eb8a$exports(function() {
            var wrapper = {
                done: false
            };
            try {
                $2f17e9746e5fde89$exports(then, value, $316ec5507754a97f$var$bind($316ec5507754a97f$var$internalResolve, wrapper, state), $316ec5507754a97f$var$bind($316ec5507754a97f$var$internalReject, wrapper, state));
            } catch (error) {
                $316ec5507754a97f$var$internalReject(wrapper, error, state);
            }
        });
        else {
            state.value = value;
            state.state = $316ec5507754a97f$var$FULFILLED;
            $316ec5507754a97f$var$notify(state, false);
        }
    } catch (error) {
        $316ec5507754a97f$var$internalReject({
            done: false
        }, error, state);
    }
};
// constructor polyfill
if ($316ec5507754a97f$var$FORCED_PROMISE_CONSTRUCTOR) {
    // 25.4.3.1 Promise(executor)
    $316ec5507754a97f$var$PromiseConstructor = function Promise(executor) {
        $efe207f3fce362b0$exports(this, $316ec5507754a97f$var$PromisePrototype);
        $6df447ad4be37421$exports(executor);
        $2f17e9746e5fde89$exports($316ec5507754a97f$var$Internal, this);
        var state = $316ec5507754a97f$var$getInternalPromiseState(this);
        try {
            executor($316ec5507754a97f$var$bind($316ec5507754a97f$var$internalResolve, state), $316ec5507754a97f$var$bind($316ec5507754a97f$var$internalReject, state));
        } catch (error) {
            $316ec5507754a97f$var$internalReject(state, error);
        }
    };
    $316ec5507754a97f$var$PromisePrototype = $316ec5507754a97f$var$PromiseConstructor.prototype;
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    $316ec5507754a97f$var$Internal = function Promise(executor) {
        $316ec5507754a97f$var$setInternalState(this, {
            type: $316ec5507754a97f$var$PROMISE,
            done: false,
            notified: false,
            parent: false,
            reactions: new $5700926495c5b4b1$exports(),
            rejection: false,
            state: $316ec5507754a97f$var$PENDING,
            value: undefined
        });
    };
    // `Promise.prototype.then` method
    // https://tc39.es/ecma262/#sec-promise.prototype.then
    $316ec5507754a97f$var$Internal.prototype = $5cabf6b3204ed174$exports($316ec5507754a97f$var$PromisePrototype, "then", function then(onFulfilled, onRejected) {
        var state = $316ec5507754a97f$var$getInternalPromiseState(this);
        var reaction = $316ec5507754a97f$var$newPromiseCapability($21e66763122ffa99$exports(this, $316ec5507754a97f$var$PromiseConstructor));
        state.parent = true;
        reaction.ok = $73d1a34d94fa4c35$exports(onFulfilled) ? onFulfilled : true;
        reaction.fail = $73d1a34d94fa4c35$exports(onRejected) && onRejected;
        reaction.domain = $9002d9a40e113f56$exports ? $316ec5507754a97f$var$process.domain : undefined;
        if (state.state === $316ec5507754a97f$var$PENDING) state.reactions.add(reaction);
        else $4174e122d6b4eb8a$exports(function() {
            $316ec5507754a97f$var$callReaction(reaction, state);
        });
        return reaction.promise;
    });
    $316ec5507754a97f$var$OwnPromiseCapability = function() {
        var promise = new $316ec5507754a97f$var$Internal();
        var state = $316ec5507754a97f$var$getInternalPromiseState(promise);
        this.promise = promise;
        this.resolve = $316ec5507754a97f$var$bind($316ec5507754a97f$var$internalResolve, state);
        this.reject = $316ec5507754a97f$var$bind($316ec5507754a97f$var$internalReject, state);
    };
    $c335377c5f9c8743$export$2d1720544b23b823 = $316ec5507754a97f$var$newPromiseCapability = function(C) {
        return C === $316ec5507754a97f$var$PromiseConstructor || C === $316ec5507754a97f$var$PromiseWrapper ? new $316ec5507754a97f$var$OwnPromiseCapability(C) : $316ec5507754a97f$var$newGenericPromiseCapability(C);
    };
    if (!$036c29a074575bd6$exports && $73d1a34d94fa4c35$exports($bdc6200b8cf20395$exports) && $316ec5507754a97f$var$NativePromisePrototype !== Object.prototype) {
        $316ec5507754a97f$var$nativeThen = $316ec5507754a97f$var$NativePromisePrototype.then;
        if (!$316ec5507754a97f$var$NATIVE_PROMISE_SUBCLASSING) // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
        $5cabf6b3204ed174$exports($316ec5507754a97f$var$NativePromisePrototype, "then", function then(onFulfilled, onRejected) {
            var that = this;
            return new $316ec5507754a97f$var$PromiseConstructor(function(resolve, reject) {
                $2f17e9746e5fde89$exports($316ec5507754a97f$var$nativeThen, that, resolve, reject);
            }).then(onFulfilled, onRejected);
        // https://github.com/zloirock/core-js/issues/640
        }, {
            unsafe: true
        });
        // make `.constructor === Promise` work for native promise-based APIs
        try {
            delete $316ec5507754a97f$var$NativePromisePrototype.constructor;
        } catch (error) {}
        // make `instanceof Promise` work for native promise-based APIs
        if ($160170ca8ccc9a75$exports) $160170ca8ccc9a75$exports($316ec5507754a97f$var$NativePromisePrototype, $316ec5507754a97f$var$PromisePrototype);
    }
}
$ef48c8e0540d6569$exports({
    global: true,
    constructor: true,
    wrap: true,
    forced: $316ec5507754a97f$var$FORCED_PROMISE_CONSTRUCTOR
}, {
    Promise: $316ec5507754a97f$var$PromiseConstructor
});
$036072e21338276e$exports($316ec5507754a97f$var$PromiseConstructor, $316ec5507754a97f$var$PROMISE, false, true);
$a85873e11645746b$exports($316ec5507754a97f$var$PROMISE);


"use strict";






var $6fe32dc7efdbe6ad$exports = {};
"use strict";

var $cbc4990623e012f7$exports = {};
"use strict";

var $cbc4990623e012f7$var$ITERATOR = $bbf4e852bf6421ea$exports("iterator");
var $cbc4990623e012f7$var$SAFE_CLOSING = false;
try {
    var $cbc4990623e012f7$var$called = 0;
    var $cbc4990623e012f7$var$iteratorWithReturn = {
        next: function() {
            return {
                done: !!$cbc4990623e012f7$var$called++
            };
        },
        "return": function() {
            $cbc4990623e012f7$var$SAFE_CLOSING = true;
        }
    };
    $cbc4990623e012f7$var$iteratorWithReturn[$cbc4990623e012f7$var$ITERATOR] = function() {
        return this;
    };
    // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
    Array.from($cbc4990623e012f7$var$iteratorWithReturn, function() {
        throw 2;
    });
} catch (error) {}
$cbc4990623e012f7$exports = function(exec, SKIP_CLOSING) {
    try {
        if (!SKIP_CLOSING && !$cbc4990623e012f7$var$SAFE_CLOSING) return false;
    } catch (error) {
        return false;
    } // workaround of old WebKit + `eval` bug
    var ITERATION_SUPPORT = false;
    try {
        var object = {};
        object[$cbc4990623e012f7$var$ITERATOR] = function() {
            return {
                next: function() {
                    return {
                        done: ITERATION_SUPPORT = true
                    };
                }
            };
        };
        exec(object);
    } catch (error) {}
    return ITERATION_SUPPORT;
};



var $6fe32dc7efdbe6ad$require$FORCED_PROMISE_CONSTRUCTOR = $0096134d912183c2$exports.CONSTRUCTOR;
$6fe32dc7efdbe6ad$exports = $6fe32dc7efdbe6ad$require$FORCED_PROMISE_CONSTRUCTOR || !$cbc4990623e012f7$exports(function(iterable) {
    $bdc6200b8cf20395$exports.all(iterable).then(undefined, function() {});
});


// `Promise.all` method
// https://tc39.es/ecma262/#sec-promise.all
$ef48c8e0540d6569$exports({
    target: "Promise",
    stat: true,
    forced: $6fe32dc7efdbe6ad$exports
}, {
    all: function all(iterable) {
        var C = this;
        var capability = $c335377c5f9c8743$export$2d1720544b23b823(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = $f8c91a7dd342833c$exports(function() {
            var $promiseResolve = $6df447ad4be37421$exports(C.resolve);
            var values = [];
            var counter = 0;
            var remaining = 1;
            $1067bad61af3a5d4$exports(iterable, function(promise) {
                var index = counter++;
                var alreadyCalled = false;
                remaining++;
                $2f17e9746e5fde89$exports($promiseResolve, C, promise).then(function(value) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[index] = value;
                    --remaining || resolve(values);
                }, reject);
            });
            --remaining || resolve(values);
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});


"use strict";



var $61768118d10b5cdc$require$FORCED_PROMISE_CONSTRUCTOR = $0096134d912183c2$exports.CONSTRUCTOR;




var $61768118d10b5cdc$var$NativePromisePrototype = $bdc6200b8cf20395$exports && $bdc6200b8cf20395$exports.prototype;
// `Promise.prototype.catch` method
// https://tc39.es/ecma262/#sec-promise.prototype.catch
$ef48c8e0540d6569$exports({
    target: "Promise",
    proto: true,
    forced: $61768118d10b5cdc$require$FORCED_PROMISE_CONSTRUCTOR,
    real: true
}, {
    "catch": function(onRejected) {
        return this.then(undefined, onRejected);
    }
});
// makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
if (!$036c29a074575bd6$exports && $73d1a34d94fa4c35$exports($bdc6200b8cf20395$exports)) {
    var $61768118d10b5cdc$var$method = $3e824c856d81a8e3$exports("Promise").prototype["catch"];
    if ($61768118d10b5cdc$var$NativePromisePrototype["catch"] !== $61768118d10b5cdc$var$method) $5cabf6b3204ed174$exports($61768118d10b5cdc$var$NativePromisePrototype, "catch", $61768118d10b5cdc$var$method, {
        unsafe: true
    });
}


"use strict";







// `Promise.race` method
// https://tc39.es/ecma262/#sec-promise.race
$ef48c8e0540d6569$exports({
    target: "Promise",
    stat: true,
    forced: $6fe32dc7efdbe6ad$exports
}, {
    race: function race(iterable) {
        var C = this;
        var capability = $c335377c5f9c8743$export$2d1720544b23b823(C);
        var reject = capability.reject;
        var result = $f8c91a7dd342833c$exports(function() {
            var $promiseResolve = $6df447ad4be37421$exports(C.resolve);
            $1067bad61af3a5d4$exports(iterable, function(promise) {
                $2f17e9746e5fde89$exports($promiseResolve, C, promise).then(capability.resolve, reject);
            });
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});


"use strict";




var $348014e9aa299cf7$require$FORCED_PROMISE_CONSTRUCTOR = $0096134d912183c2$exports.CONSTRUCTOR;
// `Promise.reject` method
// https://tc39.es/ecma262/#sec-promise.reject
$ef48c8e0540d6569$exports({
    target: "Promise",
    stat: true,
    forced: $348014e9aa299cf7$require$FORCED_PROMISE_CONSTRUCTOR
}, {
    reject: function reject(r) {
        var capability = $c335377c5f9c8743$export$2d1720544b23b823(this);
        $2f17e9746e5fde89$exports(capability.reject, undefined, r);
        return capability.promise;
    }
});


"use strict";





var $76f5be95c29b7e6a$require$FORCED_PROMISE_CONSTRUCTOR = $0096134d912183c2$exports.CONSTRUCTOR;
var $0babb1db87ca6f59$exports = {};
"use strict";



$0babb1db87ca6f59$exports = function(C, x) {
    $affc609f2393bdba$exports(C);
    if ($06f10e9b9cb1418c$exports(x) && x.constructor === C) return x;
    var promiseCapability = $c335377c5f9c8743$export$2d1720544b23b823(C);
    var resolve = promiseCapability.resolve;
    resolve(x);
    return promiseCapability.promise;
};


var $76f5be95c29b7e6a$var$PromiseConstructorWrapper = $3e824c856d81a8e3$exports("Promise");
var $76f5be95c29b7e6a$var$CHECK_WRAPPER = $036c29a074575bd6$exports && !$76f5be95c29b7e6a$require$FORCED_PROMISE_CONSTRUCTOR;
// `Promise.resolve` method
// https://tc39.es/ecma262/#sec-promise.resolve
$ef48c8e0540d6569$exports({
    target: "Promise",
    stat: true,
    forced: $036c29a074575bd6$exports || $76f5be95c29b7e6a$require$FORCED_PROMISE_CONSTRUCTOR
}, {
    resolve: function resolve(x) {
        return $0babb1db87ca6f59$exports($76f5be95c29b7e6a$var$CHECK_WRAPPER && this === $76f5be95c29b7e6a$var$PromiseConstructorWrapper ? $bdc6200b8cf20395$exports : this, x);
    }
});




"use strict";









var $a40e1d7b0610de78$var$NativePromisePrototype = $bdc6200b8cf20395$exports && $bdc6200b8cf20395$exports.prototype;
// Safari bug https://bugs.webkit.org/show_bug.cgi?id=200829
var $a40e1d7b0610de78$var$NON_GENERIC = !!$bdc6200b8cf20395$exports && $217c917c4f59b359$exports(function() {
    // eslint-disable-next-line unicorn/no-thenable -- required for testing
    $a40e1d7b0610de78$var$NativePromisePrototype["finally"].call({
        then: function() {}
    }, function() {});
});
// `Promise.prototype.finally` method
// https://tc39.es/ecma262/#sec-promise.prototype.finally
$ef48c8e0540d6569$exports({
    target: "Promise",
    proto: true,
    real: true,
    forced: $a40e1d7b0610de78$var$NON_GENERIC
}, {
    "finally": function(onFinally) {
        var C = $21e66763122ffa99$exports(this, $3e824c856d81a8e3$exports("Promise"));
        var isFunction = $73d1a34d94fa4c35$exports(onFinally);
        return this.then(isFunction ? function(x) {
            return $0babb1db87ca6f59$exports(C, onFinally()).then(function() {
                return x;
            });
        } : onFinally, isFunction ? function(e) {
            return $0babb1db87ca6f59$exports(C, onFinally()).then(function() {
                throw e;
            });
        } : onFinally);
    }
});
// makes sure that native promise-based APIs `Promise#finally` properly works with patched `Promise#then`
if (!$036c29a074575bd6$exports && $73d1a34d94fa4c35$exports($bdc6200b8cf20395$exports)) {
    var $a40e1d7b0610de78$var$method = $3e824c856d81a8e3$exports("Promise").prototype["finally"];
    if ($a40e1d7b0610de78$var$NativePromisePrototype["finally"] !== $a40e1d7b0610de78$var$method) $5cabf6b3204ed174$exports($a40e1d7b0610de78$var$NativePromisePrototype, "finally", $a40e1d7b0610de78$var$method, {
        unsafe: true
    });
}


"use strict";




var $d30ba9414507376d$exports = {};
"use strict";

$d30ba9414507376d$exports = function(descriptor) {
    return descriptor !== undefined && ($1ad0c60d8de14c83$exports(descriptor, "value") || $1ad0c60d8de14c83$exports(descriptor, "writable"));
};







// `Reflect.set` method
// https://tc39.es/ecma262/#sec-reflect.set
function $94e5756af5d407ab$var$set(target, propertyKey, V /* , receiver */ ) {
    var receiver = arguments.length < 4 ? target : arguments[3];
    var ownDescriptor = $3cd2e4c9005c1909$export$2d1720544b23b823($affc609f2393bdba$exports(target), propertyKey);
    var existingDescriptor, prototype, setter;
    if (!ownDescriptor) {
        if ($06f10e9b9cb1418c$exports(prototype = $e5c52a606c67a805$exports(target))) return $94e5756af5d407ab$var$set(prototype, propertyKey, V, receiver);
        ownDescriptor = $819ae5875a6bb120$exports(0);
    }
    if ($d30ba9414507376d$exports(ownDescriptor)) {
        if (ownDescriptor.writable === false || !$06f10e9b9cb1418c$exports(receiver)) return false;
        if (existingDescriptor = $3cd2e4c9005c1909$export$2d1720544b23b823(receiver, propertyKey)) {
            if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
            existingDescriptor.value = V;
            $0163cc0a742cd3ad$export$2d1720544b23b823(receiver, propertyKey, existingDescriptor);
        } else $0163cc0a742cd3ad$export$2d1720544b23b823(receiver, propertyKey, $819ae5875a6bb120$exports(0, V));
    } else {
        setter = ownDescriptor.set;
        if (setter === undefined) return false;
        $2f17e9746e5fde89$exports(setter, receiver, V);
    }
    return true;
}
// MS Edge 17-18 Reflect.set allows setting the property to object
// with non-writable property on the prototype
var $94e5756af5d407ab$var$MS_EDGE_BUG = $217c917c4f59b359$exports(function() {
    var Constructor = function() {};
    var object = $0163cc0a742cd3ad$export$2d1720544b23b823(new Constructor(), "a", {
        configurable: true
    });
    // eslint-disable-next-line es/no-reflect -- required for testing
    return Reflect.set(Constructor.prototype, "a", 1, object) !== false;
});
$ef48c8e0540d6569$exports({
    target: "Reflect",
    stat: true,
    forced: $94e5756af5d407ab$var$MS_EDGE_BUG
}, {
    set: $94e5756af5d407ab$var$set
});


"use strict";




var $9b01bf25cd1d3ee2$exports = {};
"use strict";



// makes subclassing work correct for wrapped built-ins
$9b01bf25cd1d3ee2$exports = function($this, dummy, Wrapper) {
    var NewTarget, NewTargetPrototype;
    if (// it can work only with native `setPrototypeOf`
    $160170ca8ccc9a75$exports && // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    $73d1a34d94fa4c35$exports(NewTarget = dummy.constructor) && NewTarget !== Wrapper && $06f10e9b9cb1418c$exports(NewTargetPrototype = NewTarget.prototype) && NewTargetPrototype !== Wrapper.prototype) $160170ca8ccc9a75$exports($this, NewTargetPrototype);
    return $this;
};





var $11373e333da66eda$require$getOwnPropertyNames = $f54839ff0ad1f1b7$export$2d1720544b23b823;

var $a7cca8ee8e2a9d0b$exports = {};
"use strict";



var $a7cca8ee8e2a9d0b$var$MATCH = $bbf4e852bf6421ea$exports("match");
// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
$a7cca8ee8e2a9d0b$exports = function(it) {
    var isRegExp;
    return $06f10e9b9cb1418c$exports(it) && ((isRegExp = it[$a7cca8ee8e2a9d0b$var$MATCH]) !== undefined ? !!isRegExp : $7f55bdfec0ad037d$exports(it) === "RegExp");
};



var $6a132a17783f32fb$exports = {};
"use strict";



var $402d9bf0f823b3d2$exports = {};
"use strict";

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
$402d9bf0f823b3d2$exports = function() {
    var that = $affc609f2393bdba$exports(this);
    var result = "";
    if (that.hasIndices) result += "d";
    if (that.global) result += "g";
    if (that.ignoreCase) result += "i";
    if (that.multiline) result += "m";
    if (that.dotAll) result += "s";
    if (that.unicode) result += "u";
    if (that.unicodeSets) result += "v";
    if (that.sticky) result += "y";
    return result;
};


var $6a132a17783f32fb$var$RegExpPrototype = RegExp.prototype;
$6a132a17783f32fb$exports = function(R) {
    var flags = R.flags;
    return flags === undefined && !("flags" in $6a132a17783f32fb$var$RegExpPrototype) && !$1ad0c60d8de14c83$exports(R, "flags") && $dba85d7bd7ffe0d7$exports($6a132a17783f32fb$var$RegExpPrototype, R) ? $2f17e9746e5fde89$exports($402d9bf0f823b3d2$exports, R) : flags;
};


var $b675eceb5466c0d8$exports = {};
"use strict";


// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $b675eceb5466c0d8$var$$RegExp = $212fa519f4bef41a$exports.RegExp;
var $b675eceb5466c0d8$var$UNSUPPORTED_Y = $217c917c4f59b359$exports(function() {
    var re = $b675eceb5466c0d8$var$$RegExp("a", "y");
    re.lastIndex = 2;
    return re.exec("abcd") !== null;
});
// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var $b675eceb5466c0d8$var$MISSED_STICKY = $b675eceb5466c0d8$var$UNSUPPORTED_Y || $217c917c4f59b359$exports(function() {
    return !$b675eceb5466c0d8$var$$RegExp("a", "y").sticky;
});
var $b675eceb5466c0d8$var$BROKEN_CARET = $b675eceb5466c0d8$var$UNSUPPORTED_Y || $217c917c4f59b359$exports(function() {
    // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
    var re = $b675eceb5466c0d8$var$$RegExp("^r", "gy");
    re.lastIndex = 2;
    return re.exec("str") !== null;
});
$b675eceb5466c0d8$exports = {
    BROKEN_CARET: $b675eceb5466c0d8$var$BROKEN_CARET,
    MISSED_STICKY: $b675eceb5466c0d8$var$MISSED_STICKY,
    UNSUPPORTED_Y: $b675eceb5466c0d8$var$UNSUPPORTED_Y
};


var $7836d1851f92e35f$exports = {};
"use strict";

var $7836d1851f92e35f$require$defineProperty = $0163cc0a742cd3ad$export$2d1720544b23b823;
$7836d1851f92e35f$exports = function(Target, Source, key) {
    key in Target || $7836d1851f92e35f$require$defineProperty(Target, key, {
        configurable: true,
        get: function() {
            return Source[key];
        },
        set: function(it) {
            Source[key] = it;
        }
    });
};






var $11373e333da66eda$require$enforceInternalState = $954a2ea894ec1c9c$exports.enforce;


var $ead09c4c112c3e77$exports = {};
"use strict";


// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $ead09c4c112c3e77$var$$RegExp = $212fa519f4bef41a$exports.RegExp;
$ead09c4c112c3e77$exports = $217c917c4f59b359$exports(function() {
    var re = $ead09c4c112c3e77$var$$RegExp(".", "s");
    return !(re.dotAll && re.test("\n") && re.flags === "s");
});


var $2dbbe1b36067f22d$exports = {};
"use strict";


// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $2dbbe1b36067f22d$var$$RegExp = $212fa519f4bef41a$exports.RegExp;
$2dbbe1b36067f22d$exports = $217c917c4f59b359$exports(function() {
    var re = $2dbbe1b36067f22d$var$$RegExp("(?<a>b)", "g");
    return re.exec("b").groups.a !== "b" || "b".replace(re, "$<a>c") !== "bc";
});


var $11373e333da66eda$var$MATCH = $bbf4e852bf6421ea$exports("match");
var $11373e333da66eda$var$NativeRegExp = $212fa519f4bef41a$exports.RegExp;
var $11373e333da66eda$var$RegExpPrototype = $11373e333da66eda$var$NativeRegExp.prototype;
var $11373e333da66eda$var$SyntaxError = $212fa519f4bef41a$exports.SyntaxError;
var $11373e333da66eda$var$exec = $c201050ed73b14ba$exports($11373e333da66eda$var$RegExpPrototype.exec);
var $11373e333da66eda$var$charAt = $c201050ed73b14ba$exports("".charAt);
var $11373e333da66eda$var$replace = $c201050ed73b14ba$exports("".replace);
var $11373e333da66eda$var$stringIndexOf = $c201050ed73b14ba$exports("".indexOf);
var $11373e333da66eda$var$stringSlice = $c201050ed73b14ba$exports("".slice);
// TODO: Use only proper RegExpIdentifierName
var $11373e333da66eda$var$IS_NCG = /^\?<[^\s\d!#%&*+<=>@^][^\s!#%&*+<=>@^]*>/;
var $11373e333da66eda$var$re1 = /a/g;
var $11373e333da66eda$var$re2 = /a/g;
// "new" should create a new object, old webkit bug
var $11373e333da66eda$var$CORRECT_NEW = new $11373e333da66eda$var$NativeRegExp($11373e333da66eda$var$re1) !== $11373e333da66eda$var$re1;
var $11373e333da66eda$var$MISSED_STICKY = $b675eceb5466c0d8$exports.MISSED_STICKY;
var $11373e333da66eda$var$UNSUPPORTED_Y = $b675eceb5466c0d8$exports.UNSUPPORTED_Y;
var $11373e333da66eda$var$BASE_FORCED = $16b43a02da62cc11$exports && (!$11373e333da66eda$var$CORRECT_NEW || $11373e333da66eda$var$MISSED_STICKY || $ead09c4c112c3e77$exports || $2dbbe1b36067f22d$exports || $217c917c4f59b359$exports(function() {
    $11373e333da66eda$var$re2[$11373e333da66eda$var$MATCH] = false;
    // RegExp constructor can alter flags and IsRegExp works correct with @@match
    return $11373e333da66eda$var$NativeRegExp($11373e333da66eda$var$re1) !== $11373e333da66eda$var$re1 || $11373e333da66eda$var$NativeRegExp($11373e333da66eda$var$re2) === $11373e333da66eda$var$re2 || String($11373e333da66eda$var$NativeRegExp($11373e333da66eda$var$re1, "i")) !== "/a/i";
}));
var $11373e333da66eda$var$handleDotAll = function(string) {
    var length = string.length;
    var index = 0;
    var result = "";
    var brackets = false;
    var chr;
    for(; index <= length; index++){
        chr = $11373e333da66eda$var$charAt(string, index);
        if (chr === "\\") {
            result += chr + $11373e333da66eda$var$charAt(string, ++index);
            continue;
        }
        if (!brackets && chr === ".") result += "[\\s\\S]";
        else {
            if (chr === "[") brackets = true;
            else if (chr === "]") brackets = false;
            result += chr;
        }
    }
    return result;
};
var $11373e333da66eda$var$handleNCG = function(string) {
    var length = string.length;
    var index = 0;
    var result = "";
    var named = [];
    var names = $a98baaf21fc755e7$exports(null);
    var brackets = false;
    var ncg = false;
    var groupid = 0;
    var groupname = "";
    var chr;
    for(; index <= length; index++){
        chr = $11373e333da66eda$var$charAt(string, index);
        if (chr === "\\") chr += $11373e333da66eda$var$charAt(string, ++index);
        else if (chr === "]") brackets = false;
        else if (!brackets) switch(true){
            case chr === "[":
                brackets = true;
                break;
            case chr === "(":
                if ($11373e333da66eda$var$exec($11373e333da66eda$var$IS_NCG, $11373e333da66eda$var$stringSlice(string, index + 1))) {
                    index += 2;
                    ncg = true;
                }
                result += chr;
                groupid++;
                continue;
            case chr === ">" && ncg:
                if (groupname === "" || $1ad0c60d8de14c83$exports(names, groupname)) throw new $11373e333da66eda$var$SyntaxError("Invalid capture group name");
                names[groupname] = true;
                named[named.length] = [
                    groupname,
                    groupid
                ];
                ncg = false;
                groupname = "";
                continue;
        }
        if (ncg) groupname += chr;
        else result += chr;
    }
    return [
        result,
        named
    ];
};
// `RegExp` constructor
// https://tc39.es/ecma262/#sec-regexp-constructor
if ($e48b32723d42f00b$exports("RegExp", $11373e333da66eda$var$BASE_FORCED)) {
    var $11373e333da66eda$var$RegExpWrapper = function RegExp(pattern, flags) {
        var thisIsRegExp = $dba85d7bd7ffe0d7$exports($11373e333da66eda$var$RegExpPrototype, this);
        var patternIsRegExp = $a7cca8ee8e2a9d0b$exports(pattern);
        var flagsAreUndefined = flags === undefined;
        var groups = [];
        var rawPattern = pattern;
        var rawFlags, dotAll, sticky, handled, result, state;
        if (!thisIsRegExp && patternIsRegExp && flagsAreUndefined && pattern.constructor === $11373e333da66eda$var$RegExpWrapper) return pattern;
        if (patternIsRegExp || $dba85d7bd7ffe0d7$exports($11373e333da66eda$var$RegExpPrototype, pattern)) {
            pattern = pattern.source;
            if (flagsAreUndefined) flags = $6a132a17783f32fb$exports(rawPattern);
        }
        pattern = pattern === undefined ? "" : $5eca6f9e01902ab4$exports(pattern);
        flags = flags === undefined ? "" : $5eca6f9e01902ab4$exports(flags);
        rawPattern = pattern;
        if ($ead09c4c112c3e77$exports && "dotAll" in $11373e333da66eda$var$re1) {
            dotAll = !!flags && $11373e333da66eda$var$stringIndexOf(flags, "s") > -1;
            if (dotAll) flags = $11373e333da66eda$var$replace(flags, /s/g, "");
        }
        rawFlags = flags;
        if ($11373e333da66eda$var$MISSED_STICKY && "sticky" in $11373e333da66eda$var$re1) {
            sticky = !!flags && $11373e333da66eda$var$stringIndexOf(flags, "y") > -1;
            if (sticky && $11373e333da66eda$var$UNSUPPORTED_Y) flags = $11373e333da66eda$var$replace(flags, /y/g, "");
        }
        if ($2dbbe1b36067f22d$exports) {
            handled = $11373e333da66eda$var$handleNCG(pattern);
            pattern = handled[0];
            groups = handled[1];
        }
        result = $9b01bf25cd1d3ee2$exports($11373e333da66eda$var$NativeRegExp(pattern, flags), thisIsRegExp ? this : $11373e333da66eda$var$RegExpPrototype, $11373e333da66eda$var$RegExpWrapper);
        if (dotAll || sticky || groups.length) {
            state = $11373e333da66eda$require$enforceInternalState(result);
            if (dotAll) {
                state.dotAll = true;
                state.raw = $11373e333da66eda$var$RegExpWrapper($11373e333da66eda$var$handleDotAll(pattern), rawFlags);
            }
            if (sticky) state.sticky = true;
            if (groups.length) state.groups = groups;
        }
        if (pattern !== rawPattern) try {
            // fails in old engines, but we have no alternatives for unsupported regex syntax
            $cbffb6e18a252dcf$exports(result, "source", rawPattern === "" ? "(?:)" : rawPattern);
        } catch (error) {}
        return result;
    };
    for(var $11373e333da66eda$var$keys = $11373e333da66eda$require$getOwnPropertyNames($11373e333da66eda$var$NativeRegExp), $11373e333da66eda$var$index = 0; $11373e333da66eda$var$keys.length > $11373e333da66eda$var$index;)$7836d1851f92e35f$exports($11373e333da66eda$var$RegExpWrapper, $11373e333da66eda$var$NativeRegExp, $11373e333da66eda$var$keys[$11373e333da66eda$var$index++]);
    $11373e333da66eda$var$RegExpPrototype.constructor = $11373e333da66eda$var$RegExpWrapper;
    $11373e333da66eda$var$RegExpWrapper.prototype = $11373e333da66eda$var$RegExpPrototype;
    $5cabf6b3204ed174$exports($212fa519f4bef41a$exports, "RegExp", $11373e333da66eda$var$RegExpWrapper, {
        constructor: true
    });
}
// https://tc39.es/ecma262/#sec-get-regexp-@@species
$a85873e11645746b$exports("RegExp");


"use strict";

var $b0a5bb0c23d675f3$exports = {};
"use strict";








var $b0a5bb0c23d675f3$require$getInternalState = $954a2ea894ec1c9c$exports.get;


var $b0a5bb0c23d675f3$var$nativeReplace = $32a869ed71ece4be$exports("native-string-replace", String.prototype.replace);
var $b0a5bb0c23d675f3$var$nativeExec = RegExp.prototype.exec;
var $b0a5bb0c23d675f3$var$patchedExec = $b0a5bb0c23d675f3$var$nativeExec;
var $b0a5bb0c23d675f3$var$charAt = $c201050ed73b14ba$exports("".charAt);
var $b0a5bb0c23d675f3$var$indexOf = $c201050ed73b14ba$exports("".indexOf);
var $b0a5bb0c23d675f3$var$replace = $c201050ed73b14ba$exports("".replace);
var $b0a5bb0c23d675f3$var$stringSlice = $c201050ed73b14ba$exports("".slice);
var $b0a5bb0c23d675f3$var$UPDATES_LAST_INDEX_WRONG = function() {
    var re1 = /a/;
    var re2 = /b*/g;
    $2f17e9746e5fde89$exports($b0a5bb0c23d675f3$var$nativeExec, re1, "a");
    $2f17e9746e5fde89$exports($b0a5bb0c23d675f3$var$nativeExec, re2, "a");
    return re1.lastIndex !== 0 || re2.lastIndex !== 0;
}();
var $b0a5bb0c23d675f3$var$UNSUPPORTED_Y = $b675eceb5466c0d8$exports.BROKEN_CARET;
// nonparticipating capturing group, copied from es5-shim's String#split patch.
var $b0a5bb0c23d675f3$var$NPCG_INCLUDED = /()??/.exec("")[1] !== undefined;
var $b0a5bb0c23d675f3$var$PATCH = $b0a5bb0c23d675f3$var$UPDATES_LAST_INDEX_WRONG || $b0a5bb0c23d675f3$var$NPCG_INCLUDED || $b0a5bb0c23d675f3$var$UNSUPPORTED_Y || $ead09c4c112c3e77$exports || $2dbbe1b36067f22d$exports;
if ($b0a5bb0c23d675f3$var$PATCH) $b0a5bb0c23d675f3$var$patchedExec = function exec(string) {
    var re = this;
    var state = $b0a5bb0c23d675f3$require$getInternalState(re);
    var str = $5eca6f9e01902ab4$exports(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;
    if (raw) {
        raw.lastIndex = re.lastIndex;
        result = $2f17e9746e5fde89$exports($b0a5bb0c23d675f3$var$patchedExec, raw, str);
        re.lastIndex = raw.lastIndex;
        return result;
    }
    var groups = state.groups;
    var sticky = $b0a5bb0c23d675f3$var$UNSUPPORTED_Y && re.sticky;
    var flags = $2f17e9746e5fde89$exports($402d9bf0f823b3d2$exports, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;
    if (sticky) {
        flags = $b0a5bb0c23d675f3$var$replace(flags, "y", "");
        if ($b0a5bb0c23d675f3$var$indexOf(flags, "g") === -1) flags += "g";
        strCopy = $b0a5bb0c23d675f3$var$stringSlice(str, re.lastIndex);
        // Support anchored sticky behavior.
        if (re.lastIndex > 0 && (!re.multiline || re.multiline && $b0a5bb0c23d675f3$var$charAt(str, re.lastIndex - 1) !== "\n")) {
            source = "(?: " + source + ")";
            strCopy = " " + strCopy;
            charsAdded++;
        }
        // ^(? + rx + ) is needed, in combination with some str slicing, to
        // simulate the 'y' flag.
        reCopy = new RegExp("^(?:" + source + ")", flags);
    }
    if ($b0a5bb0c23d675f3$var$NPCG_INCLUDED) reCopy = new RegExp("^" + source + "$(?!\\s)", flags);
    if ($b0a5bb0c23d675f3$var$UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;
    match = $2f17e9746e5fde89$exports($b0a5bb0c23d675f3$var$nativeExec, sticky ? reCopy : re, strCopy);
    if (sticky) {
        if (match) {
            match.input = $b0a5bb0c23d675f3$var$stringSlice(match.input, charsAdded);
            match[0] = $b0a5bb0c23d675f3$var$stringSlice(match[0], charsAdded);
            match.index = re.lastIndex;
            re.lastIndex += match[0].length;
        } else re.lastIndex = 0;
    } else if ($b0a5bb0c23d675f3$var$UPDATES_LAST_INDEX_WRONG && match) re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    if ($b0a5bb0c23d675f3$var$NPCG_INCLUDED && match && match.length > 1) // Fix browsers whose `exec` methods don't consistently return `undefined`
    // for NPCG, like IE8. NOTE: This doesn't work for /(.?)?/
    $2f17e9746e5fde89$exports($b0a5bb0c23d675f3$var$nativeReplace, match[0], reCopy, function() {
        for(i = 1; i < arguments.length - 2; i++)if (arguments[i] === undefined) match[i] = undefined;
    });
    if (match && groups) {
        match.groups = object = $a98baaf21fc755e7$exports(null);
        for(i = 0; i < groups.length; i++){
            group = groups[i];
            object[group[0]] = match[group[1]];
        }
    }
    return match;
};
$b0a5bb0c23d675f3$exports = $b0a5bb0c23d675f3$var$patchedExec;


// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$ef48c8e0540d6569$exports({
    target: "RegExp",
    proto: true,
    forced: /./.exec !== $b0a5bb0c23d675f3$exports
}, {
    exec: $b0a5bb0c23d675f3$exports
});


"use strict";





// babel-minify and Closure Compiler transpiles RegExp('.', 'd') -> /./d and it causes SyntaxError
var $c0963e2cc6178831$var$RegExp = $212fa519f4bef41a$exports.RegExp;
var $c0963e2cc6178831$var$RegExpPrototype = $c0963e2cc6178831$var$RegExp.prototype;
var $c0963e2cc6178831$var$FORCED = $16b43a02da62cc11$exports && $217c917c4f59b359$exports(function() {
    var INDICES_SUPPORT = true;
    try {
        $c0963e2cc6178831$var$RegExp(".", "d");
    } catch (error) {
        INDICES_SUPPORT = false;
    }
    var O = {};
    // modern V8 bug
    var calls = "";
    var expected = INDICES_SUPPORT ? "dgimsy" : "gimsy";
    var addGetter = function(key, chr) {
        // eslint-disable-next-line es/no-object-defineproperty -- safe
        Object.defineProperty(O, key, {
            get: function() {
                calls += chr;
                return true;
            }
        });
    };
    var pairs = {
        dotAll: "s",
        global: "g",
        ignoreCase: "i",
        multiline: "m",
        sticky: "y"
    };
    if (INDICES_SUPPORT) pairs.hasIndices = "d";
    for(var key in pairs)addGetter(key, pairs[key]);
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    var result = Object.getOwnPropertyDescriptor($c0963e2cc6178831$var$RegExpPrototype, "flags").get.call(O);
    return result !== expected || calls !== expected;
});
// `RegExp.prototype.flags` getter
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
if ($c0963e2cc6178831$var$FORCED) $4dba431ca752b815$exports($c0963e2cc6178831$var$RegExpPrototype, "flags", {
    configurable: true,
    get: $402d9bf0f823b3d2$exports
});


"use strict";

var $934388012037e530$require$PROPER_FUNCTION_NAME = $b6b3da709b860269$exports.PROPER;





var $934388012037e530$var$TO_STRING = "toString";
var $934388012037e530$var$RegExpPrototype = RegExp.prototype;
var $934388012037e530$var$nativeToString = $934388012037e530$var$RegExpPrototype[$934388012037e530$var$TO_STRING];
var $934388012037e530$var$NOT_GENERIC = $217c917c4f59b359$exports(function() {
    return $934388012037e530$var$nativeToString.call({
        source: "a",
        flags: "b"
    }) !== "/a/b";
});
// FF44- RegExp#toString has a wrong name
var $934388012037e530$var$INCORRECT_NAME = $934388012037e530$require$PROPER_FUNCTION_NAME && $934388012037e530$var$nativeToString.name !== $934388012037e530$var$TO_STRING;
// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if ($934388012037e530$var$NOT_GENERIC || $934388012037e530$var$INCORRECT_NAME) $5cabf6b3204ed174$exports(RegExp.prototype, $934388012037e530$var$TO_STRING, function toString() {
    var R = $affc609f2393bdba$exports(this);
    var pattern = $5eca6f9e01902ab4$exports(R.source);
    var flags = $5eca6f9e01902ab4$exports($6a132a17783f32fb$exports(R));
    return "/" + pattern + "/" + flags;
}, {
    unsafe: true
});


"use strict";



var $5022aa2f37d6960e$require$getOwnPropertyDescriptor = $3cd2e4c9005c1909$export$2d1720544b23b823;


var $d12cfa566f68495d$exports = {};
"use strict";

var $d12cfa566f68495d$var$$TypeError = TypeError;
$d12cfa566f68495d$exports = function(it) {
    if ($a7cca8ee8e2a9d0b$exports(it)) throw new $d12cfa566f68495d$var$$TypeError("The method doesn't accept regular expressions");
    return it;
};



var $f921fb1e8743d8d7$exports = {};
"use strict";

var $f921fb1e8743d8d7$var$MATCH = $bbf4e852bf6421ea$exports("match");
$f921fb1e8743d8d7$exports = function(METHOD_NAME) {
    var regexp = /./;
    try {
        "/./"[METHOD_NAME](regexp);
    } catch (error1) {
        try {
            regexp[$f921fb1e8743d8d7$var$MATCH] = false;
            return "/./"[METHOD_NAME](regexp);
        } catch (error2) {}
    }
    return false;
};



// eslint-disable-next-line es/no-string-prototype-endswith -- safe
var $5022aa2f37d6960e$var$nativeEndsWith = $46453aed9e51860f$exports("".endsWith);
var $5022aa2f37d6960e$var$slice = $46453aed9e51860f$exports("".slice);
var $5022aa2f37d6960e$var$min = Math.min;
var $5022aa2f37d6960e$var$CORRECT_IS_REGEXP_LOGIC = $f921fb1e8743d8d7$exports("endsWith");
// https://github.com/zloirock/core-js/pull/702
var $5022aa2f37d6960e$var$MDN_POLYFILL_BUG = !$036c29a074575bd6$exports && !$5022aa2f37d6960e$var$CORRECT_IS_REGEXP_LOGIC && !!function() {
    var descriptor = $5022aa2f37d6960e$require$getOwnPropertyDescriptor(String.prototype, "endsWith");
    return descriptor && !descriptor.writable;
}();
// `String.prototype.endsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.endswith
$ef48c8e0540d6569$exports({
    target: "String",
    proto: true,
    forced: !$5022aa2f37d6960e$var$MDN_POLYFILL_BUG && !$5022aa2f37d6960e$var$CORRECT_IS_REGEXP_LOGIC
}, {
    endsWith: function endsWith(searchString /* , endPosition = @length */ ) {
        var that = $5eca6f9e01902ab4$exports($07418f2e69c51fa2$exports(this));
        $d12cfa566f68495d$exports(searchString);
        var endPosition = arguments.length > 1 ? arguments[1] : undefined;
        var len = that.length;
        var end = endPosition === undefined ? len : $5022aa2f37d6960e$var$min($a46f106a02f96447$exports(endPosition), len);
        var search = $5eca6f9e01902ab4$exports(searchString);
        return $5022aa2f37d6960e$var$nativeEndsWith ? $5022aa2f37d6960e$var$nativeEndsWith(that, search, end) : $5022aa2f37d6960e$var$slice(that, end - search.length, end) === search;
    }
});


"use strict";






var $8896ff31a948b8ca$var$stringIndexOf = $c201050ed73b14ba$exports("".indexOf);
// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$ef48c8e0540d6569$exports({
    target: "String",
    proto: true,
    forced: !$f921fb1e8743d8d7$exports("includes")
}, {
    includes: function includes(searchString /* , position = 0 */ ) {
        return !!~$8896ff31a948b8ca$var$stringIndexOf($5eca6f9e01902ab4$exports($07418f2e69c51fa2$exports(this)), $5eca6f9e01902ab4$exports($d12cfa566f68495d$exports(searchString)), arguments.length > 1 ? arguments[1] : undefined);
    }
});


"use strict";

var $63968fb4db63af3d$exports = {};
"use strict";







var $63968fb4db63af3d$var$SPECIES = $bbf4e852bf6421ea$exports("species");
var $63968fb4db63af3d$var$RegExpPrototype = RegExp.prototype;
$63968fb4db63af3d$exports = function(KEY, exec, FORCED, SHAM) {
    var SYMBOL = $bbf4e852bf6421ea$exports(KEY);
    var DELEGATES_TO_SYMBOL = !$217c917c4f59b359$exports(function() {
        // String methods call symbol-named RegEp methods
        var O = {};
        O[SYMBOL] = function() {
            return 7;
        };
        return ""[KEY](O) !== 7;
    });
    var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !$217c917c4f59b359$exports(function() {
        // Symbol-named RegExp methods call .exec
        var execCalled = false;
        var re = /a/;
        if (KEY === "split") {
            // We can't use real regex here since it causes deoptimization
            // and serious performance degradation in V8
            // https://github.com/zloirock/core-js/issues/306
            re = {};
            // RegExp[@@split] doesn't call the regex's exec method, but first creates
            // a new one. We need to return the patched regex when creating the new one.
            re.constructor = {};
            re.constructor[$63968fb4db63af3d$var$SPECIES] = function() {
                return re;
            };
            re.flags = "";
            re[SYMBOL] = /./[SYMBOL];
        }
        re.exec = function() {
            execCalled = true;
            return null;
        };
        re[SYMBOL]("");
        return !execCalled;
    });
    if (!DELEGATES_TO_SYMBOL || !DELEGATES_TO_EXEC || FORCED) {
        var uncurriedNativeRegExpMethod = $46453aed9e51860f$exports(/./[SYMBOL]);
        var methods = exec(SYMBOL, ""[KEY], function(nativeMethod, regexp, str, arg2, forceStringMethod) {
            var uncurriedNativeMethod = $46453aed9e51860f$exports(nativeMethod);
            var $exec = regexp.exec;
            if ($exec === $b0a5bb0c23d675f3$exports || $exec === $63968fb4db63af3d$var$RegExpPrototype.exec) {
                if (DELEGATES_TO_SYMBOL && !forceStringMethod) // The native String method already delegates to @@method (this
                // polyfilled function), leasing to infinite recursion.
                // We avoid it by directly calling the native @@method method.
                return {
                    done: true,
                    value: uncurriedNativeRegExpMethod(regexp, str, arg2)
                };
                return {
                    done: true,
                    value: uncurriedNativeMethod(str, regexp, arg2)
                };
            }
            return {
                done: false
            };
        });
        $5cabf6b3204ed174$exports(String.prototype, KEY, methods[0]);
        $5cabf6b3204ed174$exports($63968fb4db63af3d$var$RegExpPrototype, SYMBOL, methods[1]);
    }
    if (SHAM) $cbffb6e18a252dcf$exports($63968fb4db63af3d$var$RegExpPrototype[SYMBOL], "sham", true);
};








var $9c81ffbb19bd14cc$exports = {};
"use strict";
var $f270186c84f50a15$exports = {};
"use strict";




var $f270186c84f50a15$var$charAt = $c201050ed73b14ba$exports("".charAt);
var $f270186c84f50a15$var$charCodeAt = $c201050ed73b14ba$exports("".charCodeAt);
var $f270186c84f50a15$var$stringSlice = $c201050ed73b14ba$exports("".slice);
var $f270186c84f50a15$var$createMethod = function(CONVERT_TO_STRING) {
    return function($this, pos) {
        var S = $5eca6f9e01902ab4$exports($07418f2e69c51fa2$exports($this));
        var position = $8d76b52b36a52486$exports(pos);
        var size = S.length;
        var first, second;
        if (position < 0 || position >= size) return CONVERT_TO_STRING ? "" : undefined;
        first = $f270186c84f50a15$var$charCodeAt(S, position);
        return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = $f270186c84f50a15$var$charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? $f270186c84f50a15$var$charAt(S, position) : first : CONVERT_TO_STRING ? $f270186c84f50a15$var$stringSlice(S, position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
    };
};
$f270186c84f50a15$exports = {
    // `String.prototype.codePointAt` method
    // https://tc39.es/ecma262/#sec-string.prototype.codepointat
    codeAt: $f270186c84f50a15$var$createMethod(false),
    // `String.prototype.at` method
    // https://github.com/mathiasbynens/String.prototype.at
    charAt: $f270186c84f50a15$var$createMethod(true)
};


var $9c81ffbb19bd14cc$require$charAt = $f270186c84f50a15$exports.charAt;
// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
$9c81ffbb19bd14cc$exports = function(S, index, unicode) {
    return index + (unicode ? $9c81ffbb19bd14cc$require$charAt(S, index).length : 1);
};


var $e91e9894e8974d75$exports = {};
"use strict";





var $e91e9894e8974d75$var$$TypeError = TypeError;
// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
$e91e9894e8974d75$exports = function(R, S) {
    var exec = R.exec;
    if ($73d1a34d94fa4c35$exports(exec)) {
        var result = $2f17e9746e5fde89$exports(exec, R, S);
        if (result !== null) $affc609f2393bdba$exports(result);
        return result;
    }
    if ($7f55bdfec0ad037d$exports(R) === "RegExp") return $2f17e9746e5fde89$exports($b0a5bb0c23d675f3$exports, R, S);
    throw new $e91e9894e8974d75$var$$TypeError("RegExp#exec called on incompatible receiver");
};


// @@match logic
$63968fb4db63af3d$exports("match", function(MATCH, nativeMatch, maybeCallNative) {
    return [
        // `String.prototype.match` method
        // https://tc39.es/ecma262/#sec-string.prototype.match
        function match(regexp) {
            var O = $07418f2e69c51fa2$exports(this);
            var matcher = $e64dc79af48a1328$exports(regexp) ? undefined : $a1d58592526cda62$exports(regexp, MATCH);
            return matcher ? $2f17e9746e5fde89$exports(matcher, regexp, O) : new RegExp(regexp)[MATCH]($5eca6f9e01902ab4$exports(O));
        },
        // `RegExp.prototype[@@match]` method
        // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
        function(string) {
            var rx = $affc609f2393bdba$exports(this);
            var S = $5eca6f9e01902ab4$exports(string);
            var res = maybeCallNative(nativeMatch, rx, S);
            if (res.done) return res.value;
            if (!rx.global) return $e91e9894e8974d75$exports(rx, S);
            var fullUnicode = rx.unicode;
            rx.lastIndex = 0;
            var A = [];
            var n = 0;
            var result;
            while((result = $e91e9894e8974d75$exports(rx, S)) !== null){
                var matchStr = $5eca6f9e01902ab4$exports(result[0]);
                A[n] = matchStr;
                if (matchStr === "") rx.lastIndex = $9c81ffbb19bd14cc$exports(S, $a46f106a02f96447$exports(rx.lastIndex), fullUnicode);
                n++;
            }
            return n === 0 ? null : A;
        }
    ];
});


"use strict";














var $b736369b2a89d587$exports = {};
"use strict";


var $b736369b2a89d587$var$floor = Math.floor;
var $b736369b2a89d587$var$charAt = $c201050ed73b14ba$exports("".charAt);
var $b736369b2a89d587$var$replace = $c201050ed73b14ba$exports("".replace);
var $b736369b2a89d587$var$stringSlice = $c201050ed73b14ba$exports("".slice);
// eslint-disable-next-line redos/no-vulnerable -- safe
var $b736369b2a89d587$var$SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var $b736369b2a89d587$var$SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;
// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
$b736369b2a89d587$exports = function(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = $b736369b2a89d587$var$SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
        namedCaptures = $361c03d23168e423$exports(namedCaptures);
        symbols = $b736369b2a89d587$var$SUBSTITUTION_SYMBOLS;
    }
    return $b736369b2a89d587$var$replace(replacement, symbols, function(match, ch) {
        var capture;
        switch($b736369b2a89d587$var$charAt(ch, 0)){
            case "$":
                return "$";
            case "&":
                return matched;
            case "`":
                return $b736369b2a89d587$var$stringSlice(str, 0, position);
            case "'":
                return $b736369b2a89d587$var$stringSlice(str, tailPos);
            case "<":
                capture = namedCaptures[$b736369b2a89d587$var$stringSlice(ch, 1, -1)];
                break;
            default:
                var n = +ch;
                if (n === 0) return match;
                if (n > m) {
                    var f = $b736369b2a89d587$var$floor(n / 10);
                    if (f === 0) return match;
                    if (f <= m) return captures[f - 1] === undefined ? $b736369b2a89d587$var$charAt(ch, 1) : captures[f - 1] + $b736369b2a89d587$var$charAt(ch, 1);
                    return match;
                }
                capture = captures[n - 1];
        }
        return capture === undefined ? "" : capture;
    });
};




var $772b7dfa67eb3c54$var$REPLACE = $bbf4e852bf6421ea$exports("replace");
var $772b7dfa67eb3c54$var$max = Math.max;
var $772b7dfa67eb3c54$var$min = Math.min;
var $772b7dfa67eb3c54$var$concat = $c201050ed73b14ba$exports([].concat);
var $772b7dfa67eb3c54$var$push = $c201050ed73b14ba$exports([].push);
var $772b7dfa67eb3c54$var$stringIndexOf = $c201050ed73b14ba$exports("".indexOf);
var $772b7dfa67eb3c54$var$stringSlice = $c201050ed73b14ba$exports("".slice);
var $772b7dfa67eb3c54$var$maybeToString = function(it) {
    return it === undefined ? it : String(it);
};
// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var $772b7dfa67eb3c54$var$REPLACE_KEEPS_$0 = function() {
    // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
    return "a".replace(/./, "$0") === "$0";
}();
// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var $772b7dfa67eb3c54$var$REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = function() {
    if (/./[$772b7dfa67eb3c54$var$REPLACE]) return /./[$772b7dfa67eb3c54$var$REPLACE]("a", "$0") === "";
    return false;
}();
var $772b7dfa67eb3c54$var$REPLACE_SUPPORTS_NAMED_GROUPS = !$217c917c4f59b359$exports(function() {
    var re = /./;
    re.exec = function() {
        var result = [];
        result.groups = {
            a: "7"
        };
        return result;
    };
    // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
    return "".replace(re, "$<a>") !== "7";
});
// @@replace logic
$63968fb4db63af3d$exports("replace", function(_, nativeReplace, maybeCallNative) {
    var UNSAFE_SUBSTITUTE = $772b7dfa67eb3c54$var$REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? "$" : "$0";
    return [
        // `String.prototype.replace` method
        // https://tc39.es/ecma262/#sec-string.prototype.replace
        function replace(searchValue, replaceValue) {
            var O = $07418f2e69c51fa2$exports(this);
            var replacer = $e64dc79af48a1328$exports(searchValue) ? undefined : $a1d58592526cda62$exports(searchValue, $772b7dfa67eb3c54$var$REPLACE);
            return replacer ? $2f17e9746e5fde89$exports(replacer, searchValue, O, replaceValue) : $2f17e9746e5fde89$exports(nativeReplace, $5eca6f9e01902ab4$exports(O), searchValue, replaceValue);
        },
        // `RegExp.prototype[@@replace]` method
        // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
        function(string, replaceValue) {
            var rx = $affc609f2393bdba$exports(this);
            var S = $5eca6f9e01902ab4$exports(string);
            if (typeof replaceValue == "string" && $772b7dfa67eb3c54$var$stringIndexOf(replaceValue, UNSAFE_SUBSTITUTE) === -1 && $772b7dfa67eb3c54$var$stringIndexOf(replaceValue, "$<") === -1) {
                var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
                if (res.done) return res.value;
            }
            var functionalReplace = $73d1a34d94fa4c35$exports(replaceValue);
            if (!functionalReplace) replaceValue = $5eca6f9e01902ab4$exports(replaceValue);
            var global = rx.global;
            var fullUnicode;
            if (global) {
                fullUnicode = rx.unicode;
                rx.lastIndex = 0;
            }
            var results = [];
            var result;
            while(true){
                result = $e91e9894e8974d75$exports(rx, S);
                if (result === null) break;
                $772b7dfa67eb3c54$var$push(results, result);
                if (!global) break;
                var matchStr = $5eca6f9e01902ab4$exports(result[0]);
                if (matchStr === "") rx.lastIndex = $9c81ffbb19bd14cc$exports(S, $a46f106a02f96447$exports(rx.lastIndex), fullUnicode);
            }
            var accumulatedResult = "";
            var nextSourcePosition = 0;
            for(var i = 0; i < results.length; i++){
                result = results[i];
                var matched = $5eca6f9e01902ab4$exports(result[0]);
                var position = $772b7dfa67eb3c54$var$max($772b7dfa67eb3c54$var$min($8d76b52b36a52486$exports(result.index), S.length), 0);
                var captures = [];
                var replacement;
                // NOTE: This is equivalent to
                //   captures = result.slice(1).map(maybeToString)
                // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
                // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
                // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
                for(var j = 1; j < result.length; j++)$772b7dfa67eb3c54$var$push(captures, $772b7dfa67eb3c54$var$maybeToString(result[j]));
                var namedCaptures = result.groups;
                if (functionalReplace) {
                    var replacerArgs = $772b7dfa67eb3c54$var$concat([
                        matched
                    ], captures, position, S);
                    if (namedCaptures !== undefined) $772b7dfa67eb3c54$var$push(replacerArgs, namedCaptures);
                    replacement = $5eca6f9e01902ab4$exports($9cb3247174ca8cfd$exports(replaceValue, undefined, replacerArgs));
                } else replacement = $b736369b2a89d587$exports(matched, S, position, captures, namedCaptures, replaceValue);
                if (position >= nextSourcePosition) {
                    accumulatedResult += $772b7dfa67eb3c54$var$stringSlice(S, nextSourcePosition, position) + replacement;
                    nextSourcePosition = position + matched.length;
                }
            }
            return accumulatedResult + $772b7dfa67eb3c54$var$stringSlice(S, nextSourcePosition);
        }
    ];
}, !$772b7dfa67eb3c54$var$REPLACE_SUPPORTS_NAMED_GROUPS || !$772b7dfa67eb3c54$var$REPLACE_KEEPS_$0 || $772b7dfa67eb3c54$var$REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);


"use strict";





var $1048f84ff794bc96$exports = {};
"use strict";
// `SameValue` abstract operation
// https://tc39.es/ecma262/#sec-samevalue
// eslint-disable-next-line es/no-object-is -- safe
$1048f84ff794bc96$exports = Object.is || function is(x, y) {
    // eslint-disable-next-line no-self-compare -- NaN check
    return x === y ? x !== 0 || 1 / x === 1 / y : x !== x && y !== y;
};





// @@search logic
$63968fb4db63af3d$exports("search", function(SEARCH, nativeSearch, maybeCallNative) {
    return [
        // `String.prototype.search` method
        // https://tc39.es/ecma262/#sec-string.prototype.search
        function search(regexp) {
            var O = $07418f2e69c51fa2$exports(this);
            var searcher = $e64dc79af48a1328$exports(regexp) ? undefined : $a1d58592526cda62$exports(regexp, SEARCH);
            return searcher ? $2f17e9746e5fde89$exports(searcher, regexp, O) : new RegExp(regexp)[SEARCH]($5eca6f9e01902ab4$exports(O));
        },
        // `RegExp.prototype[@@search]` method
        // https://tc39.es/ecma262/#sec-regexp.prototype-@@search
        function(string) {
            var rx = $affc609f2393bdba$exports(this);
            var S = $5eca6f9e01902ab4$exports(string);
            var res = maybeCallNative(nativeSearch, rx, S);
            if (res.done) return res.value;
            var previousLastIndex = rx.lastIndex;
            if (!$1048f84ff794bc96$exports(previousLastIndex, 0)) rx.lastIndex = 0;
            var result = $e91e9894e8974d75$exports(rx, S);
            if (!$1048f84ff794bc96$exports(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
            return result === null ? -1 : result.index;
        }
    ];
});


"use strict";


















var $3651b685457f801a$var$UNSUPPORTED_Y = $b675eceb5466c0d8$exports.UNSUPPORTED_Y;
var $3651b685457f801a$var$MAX_UINT32 = 0xFFFFFFFF;
var $3651b685457f801a$var$min = Math.min;
var $3651b685457f801a$var$$push = [].push;
var $3651b685457f801a$var$exec = $c201050ed73b14ba$exports(/./.exec);
var $3651b685457f801a$var$push = $c201050ed73b14ba$exports($3651b685457f801a$var$$push);
var $3651b685457f801a$var$stringSlice = $c201050ed73b14ba$exports("".slice);
// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var $3651b685457f801a$var$SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !$217c917c4f59b359$exports(function() {
    // eslint-disable-next-line regexp/no-empty-group -- required for testing
    var re = /(?:)/;
    var originalExec = re.exec;
    re.exec = function() {
        return originalExec.apply(this, arguments);
    };
    var result = "ab".split(re);
    return result.length !== 2 || result[0] !== "a" || result[1] !== "b";
});
// @@split logic
$63968fb4db63af3d$exports("split", function(SPLIT, nativeSplit, maybeCallNative) {
    var internalSplit;
    if ("abbc".split(/(b)*/)[1] === "c" || // eslint-disable-next-line regexp/no-empty-group -- required for testing
    "test".split(/(?:)/, -1).length !== 4 || "ab".split(/(?:ab)*/).length !== 2 || ".".split(/(.?)(.?)/).length !== 4 || // eslint-disable-next-line regexp/no-empty-capturing-group, regexp/no-empty-group -- required for testing
    ".".split(/()()/).length > 1 || "".split(/.?/).length) // based on es5-shim implementation, need to rework it
    internalSplit = function(separator, limit) {
        var string = $5eca6f9e01902ab4$exports($07418f2e69c51fa2$exports(this));
        var lim = limit === undefined ? $3651b685457f801a$var$MAX_UINT32 : limit >>> 0;
        if (lim === 0) return [];
        if (separator === undefined) return [
            string
        ];
        // If `separator` is not a regex, use native split
        if (!$a7cca8ee8e2a9d0b$exports(separator)) return $2f17e9746e5fde89$exports(nativeSplit, string, separator, lim);
        var output = [];
        var flags = (separator.ignoreCase ? "i" : "") + (separator.multiline ? "m" : "") + (separator.unicode ? "u" : "") + (separator.sticky ? "y" : "");
        var lastLastIndex = 0;
        // Make `global` and avoid `lastIndex` issues by working with a copy
        var separatorCopy = new RegExp(separator.source, flags + "g");
        var match, lastIndex, lastLength;
        while(match = $2f17e9746e5fde89$exports($b0a5bb0c23d675f3$exports, separatorCopy, string)){
            lastIndex = separatorCopy.lastIndex;
            if (lastIndex > lastLastIndex) {
                $3651b685457f801a$var$push(output, $3651b685457f801a$var$stringSlice(string, lastLastIndex, match.index));
                if (match.length > 1 && match.index < string.length) $9cb3247174ca8cfd$exports($3651b685457f801a$var$$push, output, $9b893bf7d545a0e5$exports(match, 1));
                lastLength = match[0].length;
                lastLastIndex = lastIndex;
                if (output.length >= lim) break;
            }
            if (separatorCopy.lastIndex === match.index) separatorCopy.lastIndex++; // Avoid an infinite loop
        }
        if (lastLastIndex === string.length) {
            if (lastLength || !$3651b685457f801a$var$exec(separatorCopy, "")) $3651b685457f801a$var$push(output, "");
        } else $3651b685457f801a$var$push(output, $3651b685457f801a$var$stringSlice(string, lastLastIndex));
        return output.length > lim ? $9b893bf7d545a0e5$exports(output, 0, lim) : output;
    };
    else if ("0".split(undefined, 0).length) internalSplit = function(separator, limit) {
        return separator === undefined && limit === 0 ? [] : $2f17e9746e5fde89$exports(nativeSplit, this, separator, limit);
    };
    else internalSplit = nativeSplit;
    return [
        // `String.prototype.split` method
        // https://tc39.es/ecma262/#sec-string.prototype.split
        function split(separator, limit) {
            var O = $07418f2e69c51fa2$exports(this);
            var splitter = $e64dc79af48a1328$exports(separator) ? undefined : $a1d58592526cda62$exports(separator, SPLIT);
            return splitter ? $2f17e9746e5fde89$exports(splitter, separator, O, limit) : $2f17e9746e5fde89$exports(internalSplit, $5eca6f9e01902ab4$exports(O), separator, limit);
        },
        // `RegExp.prototype[@@split]` method
        // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
        //
        // NOTE: This cannot be properly polyfilled in engines that don't support
        // the 'y' flag.
        function(string, limit) {
            var rx = $affc609f2393bdba$exports(this);
            var S = $5eca6f9e01902ab4$exports(string);
            var res = maybeCallNative(internalSplit, rx, S, limit, internalSplit !== nativeSplit);
            if (res.done) return res.value;
            var C = $21e66763122ffa99$exports(rx, RegExp);
            var unicodeMatching = rx.unicode;
            var flags = (rx.ignoreCase ? "i" : "") + (rx.multiline ? "m" : "") + (rx.unicode ? "u" : "") + ($3651b685457f801a$var$UNSUPPORTED_Y ? "g" : "y");
            // ^(? + rx + ) is needed, in combination with some S slicing, to
            // simulate the 'y' flag.
            var splitter = new C($3651b685457f801a$var$UNSUPPORTED_Y ? "^(?:" + rx.source + ")" : rx, flags);
            var lim = limit === undefined ? $3651b685457f801a$var$MAX_UINT32 : limit >>> 0;
            if (lim === 0) return [];
            if (S.length === 0) return $e91e9894e8974d75$exports(splitter, S) === null ? [
                S
            ] : [];
            var p = 0;
            var q = 0;
            var A = [];
            while(q < S.length){
                splitter.lastIndex = $3651b685457f801a$var$UNSUPPORTED_Y ? 0 : q;
                var z = $e91e9894e8974d75$exports(splitter, $3651b685457f801a$var$UNSUPPORTED_Y ? $3651b685457f801a$var$stringSlice(S, q) : S);
                var e;
                if (z === null || (e = $3651b685457f801a$var$min($a46f106a02f96447$exports(splitter.lastIndex + ($3651b685457f801a$var$UNSUPPORTED_Y ? q : 0)), S.length)) === p) q = $9c81ffbb19bd14cc$exports(S, q, unicodeMatching);
                else {
                    $3651b685457f801a$var$push(A, $3651b685457f801a$var$stringSlice(S, p, q));
                    if (A.length === lim) return A;
                    for(var i = 1; i <= z.length - 1; i++){
                        $3651b685457f801a$var$push(A, z[i]);
                        if (A.length === lim) return A;
                    }
                    q = p = e;
                }
            }
            $3651b685457f801a$var$push(A, $3651b685457f801a$var$stringSlice(S, p));
            return A;
        }
    ];
}, !$3651b685457f801a$var$SPLIT_WORKS_WITH_OVERWRITTEN_EXEC, $3651b685457f801a$var$UNSUPPORTED_Y);


"use strict";



var $3d6b1fa8be7fe16d$require$getOwnPropertyDescriptor = $3cd2e4c9005c1909$export$2d1720544b23b823;






// eslint-disable-next-line es/no-string-prototype-startswith -- safe
var $3d6b1fa8be7fe16d$var$nativeStartsWith = $46453aed9e51860f$exports("".startsWith);
var $3d6b1fa8be7fe16d$var$stringSlice = $46453aed9e51860f$exports("".slice);
var $3d6b1fa8be7fe16d$var$min = Math.min;
var $3d6b1fa8be7fe16d$var$CORRECT_IS_REGEXP_LOGIC = $f921fb1e8743d8d7$exports("startsWith");
// https://github.com/zloirock/core-js/pull/702
var $3d6b1fa8be7fe16d$var$MDN_POLYFILL_BUG = !$036c29a074575bd6$exports && !$3d6b1fa8be7fe16d$var$CORRECT_IS_REGEXP_LOGIC && !!function() {
    var descriptor = $3d6b1fa8be7fe16d$require$getOwnPropertyDescriptor(String.prototype, "startsWith");
    return descriptor && !descriptor.writable;
}();
// `String.prototype.startsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.startswith
$ef48c8e0540d6569$exports({
    target: "String",
    proto: true,
    forced: !$3d6b1fa8be7fe16d$var$MDN_POLYFILL_BUG && !$3d6b1fa8be7fe16d$var$CORRECT_IS_REGEXP_LOGIC
}, {
    startsWith: function startsWith(searchString /* , position = 0 */ ) {
        var that = $5eca6f9e01902ab4$exports($07418f2e69c51fa2$exports(this));
        $d12cfa566f68495d$exports(searchString);
        var index = $a46f106a02f96447$exports($3d6b1fa8be7fe16d$var$min(arguments.length > 1 ? arguments[1] : undefined, that.length));
        var search = $5eca6f9e01902ab4$exports(searchString);
        return $3d6b1fa8be7fe16d$var$nativeStartsWith ? $3d6b1fa8be7fe16d$var$nativeStartsWith(that, search, index) : $3d6b1fa8be7fe16d$var$stringSlice(that, index, index + search.length) === search;
    }
});


"use strict";


var $5f42bbb672232368$require$$trim = $95bd89ea43e67dd3$exports.trim;
var $68d1db6770c33c6e$exports = {};
"use strict";

var $68d1db6770c33c6e$require$PROPER_FUNCTION_NAME = $b6b3da709b860269$exports.PROPER;


var $68d1db6770c33c6e$var$non = "​\x85᠎";
// check that a method works with the correct list
// of whitespaces and has a correct name
$68d1db6770c33c6e$exports = function(METHOD_NAME) {
    return $217c917c4f59b359$exports(function() {
        return !!$09e23748e3ca5e72$exports[METHOD_NAME]() || $68d1db6770c33c6e$var$non[METHOD_NAME]() !== $68d1db6770c33c6e$var$non || $68d1db6770c33c6e$require$PROPER_FUNCTION_NAME && $09e23748e3ca5e72$exports[METHOD_NAME].name !== METHOD_NAME;
    });
};


// `String.prototype.trim` method
// https://tc39.es/ecma262/#sec-string.prototype.trim
$ef48c8e0540d6569$exports({
    target: "String",
    proto: true,
    forced: $68d1db6770c33c6e$exports("trim")
}, {
    trim: function trim() {
        return $5f42bbb672232368$require$$trim(this);
    }
});


"use strict";
"use strict";

var $31a9937e84768567$exports = {};
"use strict";

var $31a9937e84768567$require$$trimEnd = $95bd89ea43e67dd3$exports.end;

// `String.prototype.{ trimEnd, trimRight }` method
// https://tc39.es/ecma262/#sec-string.prototype.trimend
// https://tc39.es/ecma262/#String.prototype.trimright
$31a9937e84768567$exports = $68d1db6770c33c6e$exports("trimEnd") ? function trimEnd() {
    return $31a9937e84768567$require$$trimEnd(this);
// eslint-disable-next-line es/no-string-prototype-trimstart-trimend -- safe
} : "".trimEnd;


// `String.prototype.trimRight` method
// https://tc39.es/ecma262/#sec-string.prototype.trimend
// eslint-disable-next-line es/no-string-prototype-trimleft-trimright -- safe
$ef48c8e0540d6569$exports({
    target: "String",
    proto: true,
    name: "trimEnd",
    forced: "".trimRight !== $31a9937e84768567$exports
}, {
    trimRight: $31a9937e84768567$exports
});




// `String.prototype.trimEnd` method
// https://tc39.es/ecma262/#sec-string.prototype.trimend
// eslint-disable-next-line es/no-string-prototype-trimstart-trimend -- safe
$ef48c8e0540d6569$exports({
    target: "String",
    proto: true,
    name: "trimEnd",
    forced: "".trimEnd !== $31a9937e84768567$exports
}, {
    trimEnd: $31a9937e84768567$exports
});


"use strict";
"use strict";

var $690d2a10482c40e0$exports = {};
"use strict";

var $690d2a10482c40e0$require$$trimStart = $95bd89ea43e67dd3$exports.start;

// `String.prototype.{ trimStart, trimLeft }` method
// https://tc39.es/ecma262/#sec-string.prototype.trimstart
// https://tc39.es/ecma262/#String.prototype.trimleft
$690d2a10482c40e0$exports = $68d1db6770c33c6e$exports("trimStart") ? function trimStart() {
    return $690d2a10482c40e0$require$$trimStart(this);
// eslint-disable-next-line es/no-string-prototype-trimstart-trimend -- safe
} : "".trimStart;


// `String.prototype.trimLeft` method
// https://tc39.es/ecma262/#sec-string.prototype.trimleft
// eslint-disable-next-line es/no-string-prototype-trimleft-trimright -- safe
$ef48c8e0540d6569$exports({
    target: "String",
    proto: true,
    name: "trimStart",
    forced: "".trimLeft !== $690d2a10482c40e0$exports
}, {
    trimLeft: $690d2a10482c40e0$exports
});




// `String.prototype.trimStart` method
// https://tc39.es/ecma262/#sec-string.prototype.trimstart
// eslint-disable-next-line es/no-string-prototype-trimstart-trimend -- safe
$ef48c8e0540d6569$exports({
    target: "String",
    proto: true,
    name: "trimStart",
    forced: "".trimStart !== $690d2a10482c40e0$exports
}, {
    trimStart: $690d2a10482c40e0$exports
});


"use strict";
var $e2daa496cfaf241d$exports = {};
"use strict";




var $2142cb90e3dc39b5$exports = {};
"use strict";



var $22c60d3b8256dfa1$exports = {};
"use strict";

















var $22c60d3b8256dfa1$var$enforceInternalState = $954a2ea894ec1c9c$exports.enforce;
var $22c60d3b8256dfa1$var$getInternalState = $954a2ea894ec1c9c$exports.get;
var $22c60d3b8256dfa1$var$Int8Array = $212fa519f4bef41a$exports.Int8Array;
var $22c60d3b8256dfa1$var$Int8ArrayPrototype = $22c60d3b8256dfa1$var$Int8Array && $22c60d3b8256dfa1$var$Int8Array.prototype;
var $22c60d3b8256dfa1$var$Uint8ClampedArray = $212fa519f4bef41a$exports.Uint8ClampedArray;
var $22c60d3b8256dfa1$var$Uint8ClampedArrayPrototype = $22c60d3b8256dfa1$var$Uint8ClampedArray && $22c60d3b8256dfa1$var$Uint8ClampedArray.prototype;
var $22c60d3b8256dfa1$var$TypedArray = $22c60d3b8256dfa1$var$Int8Array && $e5c52a606c67a805$exports($22c60d3b8256dfa1$var$Int8Array);
var $22c60d3b8256dfa1$var$TypedArrayPrototype = $22c60d3b8256dfa1$var$Int8ArrayPrototype && $e5c52a606c67a805$exports($22c60d3b8256dfa1$var$Int8ArrayPrototype);
var $22c60d3b8256dfa1$var$ObjectPrototype = Object.prototype;
var $22c60d3b8256dfa1$var$TypeError = $212fa519f4bef41a$exports.TypeError;
var $22c60d3b8256dfa1$var$TO_STRING_TAG = $bbf4e852bf6421ea$exports("toStringTag");
var $22c60d3b8256dfa1$var$TYPED_ARRAY_TAG = $280519a5ebb3eef0$exports("TYPED_ARRAY_TAG");
var $22c60d3b8256dfa1$var$TYPED_ARRAY_CONSTRUCTOR = "TypedArrayConstructor";
// Fixing native typed arrays in Opera Presto crashes the browser, see #595
var $22c60d3b8256dfa1$var$NATIVE_ARRAY_BUFFER_VIEWS = $de0cc3fb914c1bf0$exports && !!$160170ca8ccc9a75$exports && $7d156d7c862bc268$exports($212fa519f4bef41a$exports.opera) !== "Opera";
var $22c60d3b8256dfa1$var$TYPED_ARRAY_TAG_REQUIRED = false;
var $22c60d3b8256dfa1$var$NAME, $22c60d3b8256dfa1$var$Constructor, $22c60d3b8256dfa1$var$Prototype;
var $22c60d3b8256dfa1$var$TypedArrayConstructorsList = {
    Int8Array: 1,
    Uint8Array: 1,
    Uint8ClampedArray: 1,
    Int16Array: 2,
    Uint16Array: 2,
    Int32Array: 4,
    Uint32Array: 4,
    Float32Array: 4,
    Float64Array: 8
};
var $22c60d3b8256dfa1$var$BigIntArrayConstructorsList = {
    BigInt64Array: 8,
    BigUint64Array: 8
};
var $22c60d3b8256dfa1$var$isView = function isView(it) {
    if (!$06f10e9b9cb1418c$exports(it)) return false;
    var klass = $7d156d7c862bc268$exports(it);
    return klass === "DataView" || $1ad0c60d8de14c83$exports($22c60d3b8256dfa1$var$TypedArrayConstructorsList, klass) || $1ad0c60d8de14c83$exports($22c60d3b8256dfa1$var$BigIntArrayConstructorsList, klass);
};
var $22c60d3b8256dfa1$var$getTypedArrayConstructor = function(it) {
    var proto = $e5c52a606c67a805$exports(it);
    if (!$06f10e9b9cb1418c$exports(proto)) return;
    var state = $22c60d3b8256dfa1$var$getInternalState(proto);
    return state && $1ad0c60d8de14c83$exports(state, $22c60d3b8256dfa1$var$TYPED_ARRAY_CONSTRUCTOR) ? state[$22c60d3b8256dfa1$var$TYPED_ARRAY_CONSTRUCTOR] : $22c60d3b8256dfa1$var$getTypedArrayConstructor(proto);
};
var $22c60d3b8256dfa1$var$isTypedArray = function(it) {
    if (!$06f10e9b9cb1418c$exports(it)) return false;
    var klass = $7d156d7c862bc268$exports(it);
    return $1ad0c60d8de14c83$exports($22c60d3b8256dfa1$var$TypedArrayConstructorsList, klass) || $1ad0c60d8de14c83$exports($22c60d3b8256dfa1$var$BigIntArrayConstructorsList, klass);
};
var $22c60d3b8256dfa1$var$aTypedArray = function(it) {
    if ($22c60d3b8256dfa1$var$isTypedArray(it)) return it;
    throw new $22c60d3b8256dfa1$var$TypeError("Target is not a typed array");
};
var $22c60d3b8256dfa1$var$aTypedArrayConstructor = function(C) {
    if ($73d1a34d94fa4c35$exports(C) && (!$160170ca8ccc9a75$exports || $dba85d7bd7ffe0d7$exports($22c60d3b8256dfa1$var$TypedArray, C))) return C;
    throw new $22c60d3b8256dfa1$var$TypeError($bb66d003fc13d318$exports(C) + " is not a typed array constructor");
};
var $22c60d3b8256dfa1$var$exportTypedArrayMethod = function(KEY, property, forced, options) {
    if (!$16b43a02da62cc11$exports) return;
    if (forced) for(var ARRAY in $22c60d3b8256dfa1$var$TypedArrayConstructorsList){
        var TypedArrayConstructor = $212fa519f4bef41a$exports[ARRAY];
        if (TypedArrayConstructor && $1ad0c60d8de14c83$exports(TypedArrayConstructor.prototype, KEY)) try {
            delete TypedArrayConstructor.prototype[KEY];
        } catch (error) {
            // old WebKit bug - some methods are non-configurable
            try {
                TypedArrayConstructor.prototype[KEY] = property;
            } catch (error2) {}
        }
    }
    if (!$22c60d3b8256dfa1$var$TypedArrayPrototype[KEY] || forced) $5cabf6b3204ed174$exports($22c60d3b8256dfa1$var$TypedArrayPrototype, KEY, forced ? property : $22c60d3b8256dfa1$var$NATIVE_ARRAY_BUFFER_VIEWS && $22c60d3b8256dfa1$var$Int8ArrayPrototype[KEY] || property, options);
};
var $22c60d3b8256dfa1$var$exportTypedArrayStaticMethod = function(KEY, property, forced) {
    var ARRAY, TypedArrayConstructor;
    if (!$16b43a02da62cc11$exports) return;
    if ($160170ca8ccc9a75$exports) {
        if (forced) for(ARRAY in $22c60d3b8256dfa1$var$TypedArrayConstructorsList){
            TypedArrayConstructor = $212fa519f4bef41a$exports[ARRAY];
            if (TypedArrayConstructor && $1ad0c60d8de14c83$exports(TypedArrayConstructor, KEY)) try {
                delete TypedArrayConstructor[KEY];
            } catch (error) {}
        }
        if (!$22c60d3b8256dfa1$var$TypedArray[KEY] || forced) // V8 ~ Chrome 49-50 `%TypedArray%` methods are non-writable non-configurable
        try {
            return $5cabf6b3204ed174$exports($22c60d3b8256dfa1$var$TypedArray, KEY, forced ? property : $22c60d3b8256dfa1$var$NATIVE_ARRAY_BUFFER_VIEWS && $22c60d3b8256dfa1$var$TypedArray[KEY] || property);
        } catch (error) {}
        else return;
    }
    for(ARRAY in $22c60d3b8256dfa1$var$TypedArrayConstructorsList){
        TypedArrayConstructor = $212fa519f4bef41a$exports[ARRAY];
        if (TypedArrayConstructor && (!TypedArrayConstructor[KEY] || forced)) $5cabf6b3204ed174$exports(TypedArrayConstructor, KEY, property);
    }
};
for($22c60d3b8256dfa1$var$NAME in $22c60d3b8256dfa1$var$TypedArrayConstructorsList){
    $22c60d3b8256dfa1$var$Constructor = $212fa519f4bef41a$exports[$22c60d3b8256dfa1$var$NAME];
    $22c60d3b8256dfa1$var$Prototype = $22c60d3b8256dfa1$var$Constructor && $22c60d3b8256dfa1$var$Constructor.prototype;
    if ($22c60d3b8256dfa1$var$Prototype) $22c60d3b8256dfa1$var$enforceInternalState($22c60d3b8256dfa1$var$Prototype)[$22c60d3b8256dfa1$var$TYPED_ARRAY_CONSTRUCTOR] = $22c60d3b8256dfa1$var$Constructor;
    else $22c60d3b8256dfa1$var$NATIVE_ARRAY_BUFFER_VIEWS = false;
}
for($22c60d3b8256dfa1$var$NAME in $22c60d3b8256dfa1$var$BigIntArrayConstructorsList){
    $22c60d3b8256dfa1$var$Constructor = $212fa519f4bef41a$exports[$22c60d3b8256dfa1$var$NAME];
    $22c60d3b8256dfa1$var$Prototype = $22c60d3b8256dfa1$var$Constructor && $22c60d3b8256dfa1$var$Constructor.prototype;
    if ($22c60d3b8256dfa1$var$Prototype) $22c60d3b8256dfa1$var$enforceInternalState($22c60d3b8256dfa1$var$Prototype)[$22c60d3b8256dfa1$var$TYPED_ARRAY_CONSTRUCTOR] = $22c60d3b8256dfa1$var$Constructor;
}
// WebKit bug - typed arrays constructors prototype is Object.prototype
if (!$22c60d3b8256dfa1$var$NATIVE_ARRAY_BUFFER_VIEWS || !$73d1a34d94fa4c35$exports($22c60d3b8256dfa1$var$TypedArray) || $22c60d3b8256dfa1$var$TypedArray === Function.prototype) {
    // eslint-disable-next-line no-shadow -- safe
    $22c60d3b8256dfa1$var$TypedArray = function TypedArray() {
        throw new $22c60d3b8256dfa1$var$TypeError("Incorrect invocation");
    };
    if ($22c60d3b8256dfa1$var$NATIVE_ARRAY_BUFFER_VIEWS) {
        for($22c60d3b8256dfa1$var$NAME in $22c60d3b8256dfa1$var$TypedArrayConstructorsList)if ($212fa519f4bef41a$exports[$22c60d3b8256dfa1$var$NAME]) $160170ca8ccc9a75$exports($212fa519f4bef41a$exports[$22c60d3b8256dfa1$var$NAME], $22c60d3b8256dfa1$var$TypedArray);
    }
}
if (!$22c60d3b8256dfa1$var$NATIVE_ARRAY_BUFFER_VIEWS || !$22c60d3b8256dfa1$var$TypedArrayPrototype || $22c60d3b8256dfa1$var$TypedArrayPrototype === $22c60d3b8256dfa1$var$ObjectPrototype) {
    $22c60d3b8256dfa1$var$TypedArrayPrototype = $22c60d3b8256dfa1$var$TypedArray.prototype;
    if ($22c60d3b8256dfa1$var$NATIVE_ARRAY_BUFFER_VIEWS) {
        for($22c60d3b8256dfa1$var$NAME in $22c60d3b8256dfa1$var$TypedArrayConstructorsList)if ($212fa519f4bef41a$exports[$22c60d3b8256dfa1$var$NAME]) $160170ca8ccc9a75$exports($212fa519f4bef41a$exports[$22c60d3b8256dfa1$var$NAME].prototype, $22c60d3b8256dfa1$var$TypedArrayPrototype);
    }
}
// WebKit bug - one more object in Uint8ClampedArray prototype chain
if ($22c60d3b8256dfa1$var$NATIVE_ARRAY_BUFFER_VIEWS && $e5c52a606c67a805$exports($22c60d3b8256dfa1$var$Uint8ClampedArrayPrototype) !== $22c60d3b8256dfa1$var$TypedArrayPrototype) $160170ca8ccc9a75$exports($22c60d3b8256dfa1$var$Uint8ClampedArrayPrototype, $22c60d3b8256dfa1$var$TypedArrayPrototype);
if ($16b43a02da62cc11$exports && !$1ad0c60d8de14c83$exports($22c60d3b8256dfa1$var$TypedArrayPrototype, $22c60d3b8256dfa1$var$TO_STRING_TAG)) {
    $22c60d3b8256dfa1$var$TYPED_ARRAY_TAG_REQUIRED = true;
    $4dba431ca752b815$exports($22c60d3b8256dfa1$var$TypedArrayPrototype, $22c60d3b8256dfa1$var$TO_STRING_TAG, {
        configurable: true,
        get: function() {
            return $06f10e9b9cb1418c$exports(this) ? this[$22c60d3b8256dfa1$var$TYPED_ARRAY_TAG] : undefined;
        }
    });
    for($22c60d3b8256dfa1$var$NAME in $22c60d3b8256dfa1$var$TypedArrayConstructorsList)if ($212fa519f4bef41a$exports[$22c60d3b8256dfa1$var$NAME]) $cbffb6e18a252dcf$exports($212fa519f4bef41a$exports[$22c60d3b8256dfa1$var$NAME], $22c60d3b8256dfa1$var$TYPED_ARRAY_TAG, $22c60d3b8256dfa1$var$NAME);
}
$22c60d3b8256dfa1$exports = {
    NATIVE_ARRAY_BUFFER_VIEWS: $22c60d3b8256dfa1$var$NATIVE_ARRAY_BUFFER_VIEWS,
    TYPED_ARRAY_TAG: $22c60d3b8256dfa1$var$TYPED_ARRAY_TAG_REQUIRED && $22c60d3b8256dfa1$var$TYPED_ARRAY_TAG,
    aTypedArray: $22c60d3b8256dfa1$var$aTypedArray,
    aTypedArrayConstructor: $22c60d3b8256dfa1$var$aTypedArrayConstructor,
    exportTypedArrayMethod: $22c60d3b8256dfa1$var$exportTypedArrayMethod,
    exportTypedArrayStaticMethod: $22c60d3b8256dfa1$var$exportTypedArrayStaticMethod,
    getTypedArrayConstructor: $22c60d3b8256dfa1$var$getTypedArrayConstructor,
    isView: $22c60d3b8256dfa1$var$isView,
    isTypedArray: $22c60d3b8256dfa1$var$isTypedArray,
    TypedArray: $22c60d3b8256dfa1$var$TypedArray,
    TypedArrayPrototype: $22c60d3b8256dfa1$var$TypedArrayPrototype
};


var $2142cb90e3dc39b5$require$NATIVE_ARRAY_BUFFER_VIEWS = $22c60d3b8256dfa1$exports.NATIVE_ARRAY_BUFFER_VIEWS;
var $2142cb90e3dc39b5$var$ArrayBuffer = $212fa519f4bef41a$exports.ArrayBuffer;
var $2142cb90e3dc39b5$var$Int8Array = $212fa519f4bef41a$exports.Int8Array;
$2142cb90e3dc39b5$exports = !$2142cb90e3dc39b5$require$NATIVE_ARRAY_BUFFER_VIEWS || !$217c917c4f59b359$exports(function() {
    $2142cb90e3dc39b5$var$Int8Array(1);
}) || !$217c917c4f59b359$exports(function() {
    new $2142cb90e3dc39b5$var$Int8Array(-1);
}) || !$cbc4990623e012f7$exports(function(iterable) {
    new $2142cb90e3dc39b5$var$Int8Array();
    new $2142cb90e3dc39b5$var$Int8Array(null);
    new $2142cb90e3dc39b5$var$Int8Array(1.5);
    new $2142cb90e3dc39b5$var$Int8Array(iterable);
}, true) || $217c917c4f59b359$exports(function() {
    // Safari (11+) bug - a reason why even Safari 13 should load a typed array polyfill
    return new $2142cb90e3dc39b5$var$Int8Array(new $2142cb90e3dc39b5$var$ArrayBuffer(2), 1, undefined).length !== 1;
});







var $7eafeb60861f3832$exports = {};
"use strict";

var $7eafeb60861f3832$var$floor = Math.floor;
// `IsIntegralNumber` abstract operation
// https://tc39.es/ecma262/#sec-isintegralnumber
// eslint-disable-next-line es/no-number-isinteger -- safe
$7eafeb60861f3832$exports = Number.isInteger || function isInteger(it) {
    return !$06f10e9b9cb1418c$exports(it) && isFinite(it) && $7eafeb60861f3832$var$floor(it) === it;
};




var $79302c583135fece$exports = {};
"use strict";
var $88f4dbb2aba2fc36$exports = {};
"use strict";

var $88f4dbb2aba2fc36$var$$RangeError = RangeError;
$88f4dbb2aba2fc36$exports = function(it) {
    var result = $8d76b52b36a52486$exports(it);
    if (result < 0) throw new $88f4dbb2aba2fc36$var$$RangeError("The argument can't be less than 0");
    return result;
};


var $79302c583135fece$var$$RangeError = RangeError;
$79302c583135fece$exports = function(it, BYTES) {
    var offset = $88f4dbb2aba2fc36$exports(it);
    if (offset % BYTES) throw new $79302c583135fece$var$$RangeError("Wrong offset");
    return offset;
};


var $984069833450f3d6$exports = {};
"use strict";
var $984069833450f3d6$var$round = Math.round;
$984069833450f3d6$exports = function(it) {
    var value = $984069833450f3d6$var$round(it);
    return value < 0 ? 0 : value > 0xFF ? 0xFF : value & 0xFF;
};











var $e2daa496cfaf241d$require$getOwnPropertyNames = $f54839ff0ad1f1b7$export$2d1720544b23b823;
var $a6436190d159aa8e$exports = {};
"use strict";








var $d686b5a8639563c0$exports = {};
"use strict";

$d686b5a8639563c0$exports = function(it) {
    var klass = $7d156d7c862bc268$exports(it);
    return klass === "BigInt64Array" || klass === "BigUint64Array";
};



var $a6436190d159aa8e$require$aTypedArrayConstructor = $22c60d3b8256dfa1$exports.aTypedArrayConstructor;
var $e8194761fbcb527e$exports = {};
"use strict";

var $e8194761fbcb527e$var$$TypeError = TypeError;
// `ToBigInt` abstract operation
// https://tc39.es/ecma262/#sec-tobigint
$e8194761fbcb527e$exports = function(argument) {
    var prim = $1cf67f83396a1488$exports(argument, "number");
    if (typeof prim == "number") throw new $e8194761fbcb527e$var$$TypeError("Can't convert number to bigint");
    // eslint-disable-next-line es/no-bigint -- safe
    return BigInt(prim);
};


$a6436190d159aa8e$exports = function from(source /* , mapfn, thisArg */ ) {
    var C = $8762ecaa63628bbc$exports(this);
    var O = $361c03d23168e423$exports(source);
    var argumentsLength = arguments.length;
    var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iteratorMethod = $11873dac339e5ad0$exports(O);
    var i, length, result, thisIsBigIntArray, value, step, iterator, next;
    if (iteratorMethod && !$0c7638bc83d11df5$exports(iteratorMethod)) {
        iterator = $89f16bd42f655d35$exports(O, iteratorMethod);
        next = iterator.next;
        O = [];
        while(!(step = $2f17e9746e5fde89$exports(next, iterator)).done)O.push(step.value);
    }
    if (mapping && argumentsLength > 2) mapfn = $2db6a9f70c481925$exports(mapfn, arguments[2]);
    length = $3f18e45666a111c8$exports(O);
    result = new ($a6436190d159aa8e$require$aTypedArrayConstructor(C))(length);
    thisIsBigIntArray = $d686b5a8639563c0$exports(result);
    for(i = 0; length > i; i++){
        value = mapping ? mapfn(O[i], i) : O[i];
        // FF30- typed arrays doesn't properly convert objects to typed array values
        result[i] = thisIsBigIntArray ? $e8194761fbcb527e$exports(value) : +value;
    }
    return result;
};


var $14e96181fe6e0035$exports = {};
"use strict";






var $14e96181fe6e0035$var$push = $c201050ed73b14ba$exports([].push);
// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var $14e96181fe6e0035$var$createMethod = function(TYPE) {
    var IS_MAP = TYPE === 1;
    var IS_FILTER = TYPE === 2;
    var IS_SOME = TYPE === 3;
    var IS_EVERY = TYPE === 4;
    var IS_FIND_INDEX = TYPE === 6;
    var IS_FILTER_REJECT = TYPE === 7;
    var NO_HOLES = TYPE === 5 || IS_FIND_INDEX;
    return function($this, callbackfn, that, specificCreate) {
        var O = $361c03d23168e423$exports($this);
        var self = $8086cf521fa8b34c$exports(O);
        var length = $3f18e45666a111c8$exports(self);
        var boundFunction = $2db6a9f70c481925$exports(callbackfn, that);
        var index = 0;
        var create = specificCreate || $5bb6f939df74d76a$exports;
        var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
        var value, result;
        for(; length > index; index++)if (NO_HOLES || index in self) {
            value = self[index];
            result = boundFunction(value, index, O);
            if (TYPE) {
                if (IS_MAP) target[index] = result; // map
                else if (result) switch(TYPE){
                    case 3:
                        return true; // some
                    case 5:
                        return value; // find
                    case 6:
                        return index; // findIndex
                    case 2:
                        $14e96181fe6e0035$var$push(target, value); // filter
                }
                else switch(TYPE){
                    case 4:
                        return false; // every
                    case 7:
                        $14e96181fe6e0035$var$push(target, value); // filterReject
                }
            }
        }
        return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
    };
};
$14e96181fe6e0035$exports = {
    // `Array.prototype.forEach` method
    // https://tc39.es/ecma262/#sec-array.prototype.foreach
    forEach: $14e96181fe6e0035$var$createMethod(0),
    // `Array.prototype.map` method
    // https://tc39.es/ecma262/#sec-array.prototype.map
    map: $14e96181fe6e0035$var$createMethod(1),
    // `Array.prototype.filter` method
    // https://tc39.es/ecma262/#sec-array.prototype.filter
    filter: $14e96181fe6e0035$var$createMethod(2),
    // `Array.prototype.some` method
    // https://tc39.es/ecma262/#sec-array.prototype.some
    some: $14e96181fe6e0035$var$createMethod(3),
    // `Array.prototype.every` method
    // https://tc39.es/ecma262/#sec-array.prototype.every
    every: $14e96181fe6e0035$var$createMethod(4),
    // `Array.prototype.find` method
    // https://tc39.es/ecma262/#sec-array.prototype.find
    find: $14e96181fe6e0035$var$createMethod(5),
    // `Array.prototype.findIndex` method
    // https://tc39.es/ecma262/#sec-array.prototype.findIndex
    findIndex: $14e96181fe6e0035$var$createMethod(6),
    // `Array.prototype.filterReject` method
    // https://github.com/tc39/proposal-array-filtering
    filterReject: $14e96181fe6e0035$var$createMethod(7)
};


var $e2daa496cfaf241d$require$forEach = $14e96181fe6e0035$exports.forEach;






var $e2daa496cfaf241d$var$getInternalState = $954a2ea894ec1c9c$exports.get;
var $e2daa496cfaf241d$var$setInternalState = $954a2ea894ec1c9c$exports.set;
var $e2daa496cfaf241d$var$enforceInternalState = $954a2ea894ec1c9c$exports.enforce;
var $e2daa496cfaf241d$var$nativeDefineProperty = $0163cc0a742cd3ad$export$2d1720544b23b823;
var $e2daa496cfaf241d$var$nativeGetOwnPropertyDescriptor = $3cd2e4c9005c1909$export$2d1720544b23b823;
var $e2daa496cfaf241d$var$RangeError = $212fa519f4bef41a$exports.RangeError;
var $e2daa496cfaf241d$var$ArrayBuffer = $637fa5c72614f7f2$exports.ArrayBuffer;
var $e2daa496cfaf241d$var$ArrayBufferPrototype = $e2daa496cfaf241d$var$ArrayBuffer.prototype;
var $e2daa496cfaf241d$var$DataView = $637fa5c72614f7f2$exports.DataView;
var $e2daa496cfaf241d$var$NATIVE_ARRAY_BUFFER_VIEWS = $22c60d3b8256dfa1$exports.NATIVE_ARRAY_BUFFER_VIEWS;
var $e2daa496cfaf241d$var$TYPED_ARRAY_TAG = $22c60d3b8256dfa1$exports.TYPED_ARRAY_TAG;
var $e2daa496cfaf241d$var$TypedArray = $22c60d3b8256dfa1$exports.TypedArray;
var $e2daa496cfaf241d$var$TypedArrayPrototype = $22c60d3b8256dfa1$exports.TypedArrayPrototype;
var $e2daa496cfaf241d$var$aTypedArrayConstructor = $22c60d3b8256dfa1$exports.aTypedArrayConstructor;
var $e2daa496cfaf241d$var$isTypedArray = $22c60d3b8256dfa1$exports.isTypedArray;
var $e2daa496cfaf241d$var$BYTES_PER_ELEMENT = "BYTES_PER_ELEMENT";
var $e2daa496cfaf241d$var$WRONG_LENGTH = "Wrong length";
var $e2daa496cfaf241d$var$fromList = function(C, list) {
    $e2daa496cfaf241d$var$aTypedArrayConstructor(C);
    var index = 0;
    var length = list.length;
    var result = new C(length);
    while(length > index)result[index] = list[index++];
    return result;
};
var $e2daa496cfaf241d$var$addGetter = function(it, key) {
    $4dba431ca752b815$exports(it, key, {
        configurable: true,
        get: function() {
            return $e2daa496cfaf241d$var$getInternalState(this)[key];
        }
    });
};
var $e2daa496cfaf241d$var$isArrayBuffer = function(it) {
    var klass;
    return $dba85d7bd7ffe0d7$exports($e2daa496cfaf241d$var$ArrayBufferPrototype, it) || (klass = $7d156d7c862bc268$exports(it)) === "ArrayBuffer" || klass === "SharedArrayBuffer";
};
var $e2daa496cfaf241d$var$isTypedArrayIndex = function(target, key) {
    return $e2daa496cfaf241d$var$isTypedArray(target) && !$81db9cf3baf84d30$exports(key) && key in target && $7eafeb60861f3832$exports(+key) && key >= 0;
};
var $e2daa496cfaf241d$var$wrappedGetOwnPropertyDescriptor = function getOwnPropertyDescriptor(target, key) {
    key = $4dbc0d7468e7eb76$exports(key);
    return $e2daa496cfaf241d$var$isTypedArrayIndex(target, key) ? $819ae5875a6bb120$exports(2, target[key]) : $e2daa496cfaf241d$var$nativeGetOwnPropertyDescriptor(target, key);
};
var $e2daa496cfaf241d$var$wrappedDefineProperty = function defineProperty(target, key, descriptor) {
    key = $4dbc0d7468e7eb76$exports(key);
    if ($e2daa496cfaf241d$var$isTypedArrayIndex(target, key) && $06f10e9b9cb1418c$exports(descriptor) && $1ad0c60d8de14c83$exports(descriptor, "value") && !$1ad0c60d8de14c83$exports(descriptor, "get") && !$1ad0c60d8de14c83$exports(descriptor, "set") && !descriptor.configurable && (!$1ad0c60d8de14c83$exports(descriptor, "writable") || descriptor.writable) && (!$1ad0c60d8de14c83$exports(descriptor, "enumerable") || descriptor.enumerable)) {
        target[key] = descriptor.value;
        return target;
    }
    return $e2daa496cfaf241d$var$nativeDefineProperty(target, key, descriptor);
};
if ($16b43a02da62cc11$exports) {
    if (!$e2daa496cfaf241d$var$NATIVE_ARRAY_BUFFER_VIEWS) {
        $3cd2e4c9005c1909$export$2d1720544b23b823 = $e2daa496cfaf241d$var$wrappedGetOwnPropertyDescriptor;
        $0163cc0a742cd3ad$export$2d1720544b23b823 = $e2daa496cfaf241d$var$wrappedDefineProperty;
        $e2daa496cfaf241d$var$addGetter($e2daa496cfaf241d$var$TypedArrayPrototype, "buffer");
        $e2daa496cfaf241d$var$addGetter($e2daa496cfaf241d$var$TypedArrayPrototype, "byteOffset");
        $e2daa496cfaf241d$var$addGetter($e2daa496cfaf241d$var$TypedArrayPrototype, "byteLength");
        $e2daa496cfaf241d$var$addGetter($e2daa496cfaf241d$var$TypedArrayPrototype, "length");
    }
    $ef48c8e0540d6569$exports({
        target: "Object",
        stat: true,
        forced: !$e2daa496cfaf241d$var$NATIVE_ARRAY_BUFFER_VIEWS
    }, {
        getOwnPropertyDescriptor: $e2daa496cfaf241d$var$wrappedGetOwnPropertyDescriptor,
        defineProperty: $e2daa496cfaf241d$var$wrappedDefineProperty
    });
    $e2daa496cfaf241d$exports = function(TYPE, wrapper, CLAMPED) {
        var BYTES = TYPE.match(/\d+/)[0] / 8;
        var CONSTRUCTOR_NAME = TYPE + (CLAMPED ? "Clamped" : "") + "Array";
        var GETTER = "get" + TYPE;
        var SETTER = "set" + TYPE;
        var NativeTypedArrayConstructor = $212fa519f4bef41a$exports[CONSTRUCTOR_NAME];
        var TypedArrayConstructor = NativeTypedArrayConstructor;
        var TypedArrayConstructorPrototype = TypedArrayConstructor && TypedArrayConstructor.prototype;
        var exported = {};
        var getter = function(that, index) {
            var data = $e2daa496cfaf241d$var$getInternalState(that);
            return data.view[GETTER](index * BYTES + data.byteOffset, true);
        };
        var setter = function(that, index, value) {
            var data = $e2daa496cfaf241d$var$getInternalState(that);
            data.view[SETTER](index * BYTES + data.byteOffset, CLAMPED ? $984069833450f3d6$exports(value) : value, true);
        };
        var addElement = function(that, index) {
            $e2daa496cfaf241d$var$nativeDefineProperty(that, index, {
                get: function() {
                    return getter(this, index);
                },
                set: function(value) {
                    return setter(this, index, value);
                },
                enumerable: true
            });
        };
        if (!$e2daa496cfaf241d$var$NATIVE_ARRAY_BUFFER_VIEWS) {
            TypedArrayConstructor = wrapper(function(that, data, offset, $length) {
                $efe207f3fce362b0$exports(that, TypedArrayConstructorPrototype);
                var index = 0;
                var byteOffset = 0;
                var buffer, byteLength, length;
                if (!$06f10e9b9cb1418c$exports(data)) {
                    length = $25a90ed7517c0a6c$exports(data);
                    byteLength = length * BYTES;
                    buffer = new $e2daa496cfaf241d$var$ArrayBuffer(byteLength);
                } else if ($e2daa496cfaf241d$var$isArrayBuffer(data)) {
                    buffer = data;
                    byteOffset = $79302c583135fece$exports(offset, BYTES);
                    var $len = data.byteLength;
                    if ($length === undefined) {
                        if ($len % BYTES) throw new $e2daa496cfaf241d$var$RangeError($e2daa496cfaf241d$var$WRONG_LENGTH);
                        byteLength = $len - byteOffset;
                        if (byteLength < 0) throw new $e2daa496cfaf241d$var$RangeError($e2daa496cfaf241d$var$WRONG_LENGTH);
                    } else {
                        byteLength = $a46f106a02f96447$exports($length) * BYTES;
                        if (byteLength + byteOffset > $len) throw new $e2daa496cfaf241d$var$RangeError($e2daa496cfaf241d$var$WRONG_LENGTH);
                    }
                    length = byteLength / BYTES;
                } else if ($e2daa496cfaf241d$var$isTypedArray(data)) return $e2daa496cfaf241d$var$fromList(TypedArrayConstructor, data);
                else return $2f17e9746e5fde89$exports($a6436190d159aa8e$exports, TypedArrayConstructor, data);
                $e2daa496cfaf241d$var$setInternalState(that, {
                    buffer: buffer,
                    byteOffset: byteOffset,
                    byteLength: byteLength,
                    length: length,
                    view: new $e2daa496cfaf241d$var$DataView(buffer)
                });
                while(index < length)addElement(that, index++);
            });
            if ($160170ca8ccc9a75$exports) $160170ca8ccc9a75$exports(TypedArrayConstructor, $e2daa496cfaf241d$var$TypedArray);
            TypedArrayConstructorPrototype = TypedArrayConstructor.prototype = $a98baaf21fc755e7$exports($e2daa496cfaf241d$var$TypedArrayPrototype);
        } else if ($2142cb90e3dc39b5$exports) {
            TypedArrayConstructor = wrapper(function(dummy, data, typedArrayOffset, $length) {
                $efe207f3fce362b0$exports(dummy, TypedArrayConstructorPrototype);
                return $9b01bf25cd1d3ee2$exports(function() {
                    if (!$06f10e9b9cb1418c$exports(data)) return new NativeTypedArrayConstructor($25a90ed7517c0a6c$exports(data));
                    if ($e2daa496cfaf241d$var$isArrayBuffer(data)) return $length !== undefined ? new NativeTypedArrayConstructor(data, $79302c583135fece$exports(typedArrayOffset, BYTES), $length) : typedArrayOffset !== undefined ? new NativeTypedArrayConstructor(data, $79302c583135fece$exports(typedArrayOffset, BYTES)) : new NativeTypedArrayConstructor(data);
                    if ($e2daa496cfaf241d$var$isTypedArray(data)) return $e2daa496cfaf241d$var$fromList(TypedArrayConstructor, data);
                    return $2f17e9746e5fde89$exports($a6436190d159aa8e$exports, TypedArrayConstructor, data);
                }(), dummy, TypedArrayConstructor);
            });
            if ($160170ca8ccc9a75$exports) $160170ca8ccc9a75$exports(TypedArrayConstructor, $e2daa496cfaf241d$var$TypedArray);
            $e2daa496cfaf241d$require$forEach($e2daa496cfaf241d$require$getOwnPropertyNames(NativeTypedArrayConstructor), function(key) {
                if (!(key in TypedArrayConstructor)) $cbffb6e18a252dcf$exports(TypedArrayConstructor, key, NativeTypedArrayConstructor[key]);
            });
            TypedArrayConstructor.prototype = TypedArrayConstructorPrototype;
        }
        if (TypedArrayConstructorPrototype.constructor !== TypedArrayConstructor) $cbffb6e18a252dcf$exports(TypedArrayConstructorPrototype, "constructor", TypedArrayConstructor);
        $e2daa496cfaf241d$var$enforceInternalState(TypedArrayConstructorPrototype).TypedArrayConstructor = TypedArrayConstructor;
        if ($e2daa496cfaf241d$var$TYPED_ARRAY_TAG) $cbffb6e18a252dcf$exports(TypedArrayConstructorPrototype, $e2daa496cfaf241d$var$TYPED_ARRAY_TAG, CONSTRUCTOR_NAME);
        var FORCED = TypedArrayConstructor !== NativeTypedArrayConstructor;
        exported[CONSTRUCTOR_NAME] = TypedArrayConstructor;
        $ef48c8e0540d6569$exports({
            global: true,
            constructor: true,
            forced: FORCED,
            sham: !$e2daa496cfaf241d$var$NATIVE_ARRAY_BUFFER_VIEWS
        }, exported);
        if (!($e2daa496cfaf241d$var$BYTES_PER_ELEMENT in TypedArrayConstructor)) $cbffb6e18a252dcf$exports(TypedArrayConstructor, $e2daa496cfaf241d$var$BYTES_PER_ELEMENT, BYTES);
        if (!($e2daa496cfaf241d$var$BYTES_PER_ELEMENT in TypedArrayConstructorPrototype)) $cbffb6e18a252dcf$exports(TypedArrayConstructorPrototype, $e2daa496cfaf241d$var$BYTES_PER_ELEMENT, BYTES);
        $a85873e11645746b$exports(CONSTRUCTOR_NAME);
    };
} else $e2daa496cfaf241d$exports = function() {};


// `Float32Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
$e2daa496cfaf241d$exports("Float32", function(init) {
    return function Float32Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});


"use strict";

// `Float64Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
$e2daa496cfaf241d$exports("Float64", function(init) {
    return function Float64Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});


"use strict";

// `Int8Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
$e2daa496cfaf241d$exports("Int8", function(init) {
    return function Int8Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});


"use strict";

// `Int16Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
$e2daa496cfaf241d$exports("Int16", function(init) {
    return function Int16Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});


"use strict";

// `Int32Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
$e2daa496cfaf241d$exports("Int32", function(init) {
    return function Int32Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});


"use strict";

// `Uint8Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
$e2daa496cfaf241d$exports("Uint8", function(init) {
    return function Uint8Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});


"use strict";

// `Uint8ClampedArray` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
$e2daa496cfaf241d$exports("Uint8", function(init) {
    return function Uint8ClampedArray(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
}, true);


"use strict";

// `Uint16Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
$e2daa496cfaf241d$exports("Uint16", function(init) {
    return function Uint16Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});


"use strict";

// `Uint32Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
$e2daa496cfaf241d$exports("Uint32", function(init) {
    return function Uint32Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});


"use strict";







var $4b93aa5b14d4f699$var$aTypedArray = $22c60d3b8256dfa1$exports.aTypedArray;
var $4b93aa5b14d4f699$var$exportTypedArrayMethod = $22c60d3b8256dfa1$exports.exportTypedArrayMethod;
var $4b93aa5b14d4f699$var$slice = $c201050ed73b14ba$exports("".slice);
// V8 ~ Chrome < 59, Safari < 14.1, FF < 55, Edge <=18
var $4b93aa5b14d4f699$var$CONVERSION_BUG = $217c917c4f59b359$exports(function() {
    var count = 0;
    // eslint-disable-next-line es/no-typed-arrays -- safe
    new Int8Array(2).fill({
        valueOf: function() {
            return count++;
        }
    });
    return count !== 1;
});
// `%TypedArray%.prototype.fill` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.fill
$4b93aa5b14d4f699$var$exportTypedArrayMethod("fill", function fill(value /* , start, end */ ) {
    var length = arguments.length;
    $4b93aa5b14d4f699$var$aTypedArray(this);
    var actualValue = $4b93aa5b14d4f699$var$slice($7d156d7c862bc268$exports(this), 0, 3) === "Big" ? $e8194761fbcb527e$exports(value) : +value;
    return $2f17e9746e5fde89$exports($cbfc2d3fd1b7fe5d$exports, this, actualValue, length > 1 ? arguments[1] : undefined, length > 2 ? arguments[2] : undefined);
}, $4b93aa5b14d4f699$var$CONVERSION_BUG);


"use strict";


var $7adce7fe53d73595$require$exportTypedArrayStaticMethod = $22c60d3b8256dfa1$exports.exportTypedArrayStaticMethod;

// `%TypedArray%.from` method
// https://tc39.es/ecma262/#sec-%typedarray%.from
$7adce7fe53d73595$require$exportTypedArrayStaticMethod("from", $a6436190d159aa8e$exports, $2142cb90e3dc39b5$exports);


"use strict";


var $891f9d7dc0d9b4b6$var$aTypedArrayConstructor = $22c60d3b8256dfa1$exports.aTypedArrayConstructor;
var $891f9d7dc0d9b4b6$var$exportTypedArrayStaticMethod = $22c60d3b8256dfa1$exports.exportTypedArrayStaticMethod;
// `%TypedArray%.of` method
// https://tc39.es/ecma262/#sec-%typedarray%.of
$891f9d7dc0d9b4b6$var$exportTypedArrayStaticMethod("of", function of() {
    var index = 0;
    var length = arguments.length;
    var result = new ($891f9d7dc0d9b4b6$var$aTypedArrayConstructor(this))(length);
    while(length > index)result[index] = arguments[index++];
    return result;
}, $2142cb90e3dc39b5$exports);


"use strict";







var $f4d97e7f8ca2745b$var$RangeError = $212fa519f4bef41a$exports.RangeError;
var $f4d97e7f8ca2745b$var$Int8Array = $212fa519f4bef41a$exports.Int8Array;
var $f4d97e7f8ca2745b$var$Int8ArrayPrototype = $f4d97e7f8ca2745b$var$Int8Array && $f4d97e7f8ca2745b$var$Int8Array.prototype;
var $f4d97e7f8ca2745b$var$$set = $f4d97e7f8ca2745b$var$Int8ArrayPrototype && $f4d97e7f8ca2745b$var$Int8ArrayPrototype.set;
var $f4d97e7f8ca2745b$var$aTypedArray = $22c60d3b8256dfa1$exports.aTypedArray;
var $f4d97e7f8ca2745b$var$exportTypedArrayMethod = $22c60d3b8256dfa1$exports.exportTypedArrayMethod;
var $f4d97e7f8ca2745b$var$WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS = !$217c917c4f59b359$exports(function() {
    // eslint-disable-next-line es/no-typed-arrays -- required for testing
    var array = new Uint8ClampedArray(2);
    $2f17e9746e5fde89$exports($f4d97e7f8ca2745b$var$$set, array, {
        length: 1,
        0: 3
    }, 1);
    return array[1] !== 3;
});
// https://bugs.chromium.org/p/v8/issues/detail?id=11294 and other
var $f4d97e7f8ca2745b$var$TO_OBJECT_BUG = $f4d97e7f8ca2745b$var$WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS && $22c60d3b8256dfa1$exports.NATIVE_ARRAY_BUFFER_VIEWS && $217c917c4f59b359$exports(function() {
    var array = new $f4d97e7f8ca2745b$var$Int8Array(2);
    array.set(1);
    array.set("2", 1);
    return array[0] !== 0 || array[1] !== 2;
});
// `%TypedArray%.prototype.set` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.set
$f4d97e7f8ca2745b$var$exportTypedArrayMethod("set", function set(arrayLike /* , offset */ ) {
    $f4d97e7f8ca2745b$var$aTypedArray(this);
    var offset = $79302c583135fece$exports(arguments.length > 1 ? arguments[1] : undefined, 1);
    var src = $361c03d23168e423$exports(arrayLike);
    if ($f4d97e7f8ca2745b$var$WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS) return $2f17e9746e5fde89$exports($f4d97e7f8ca2745b$var$$set, this, src, offset);
    var length = this.length;
    var len = $3f18e45666a111c8$exports(src);
    var index = 0;
    if (len + offset > length) throw new $f4d97e7f8ca2745b$var$RangeError("Wrong length");
    while(index < len)this[offset + index] = src[index++];
}, !$f4d97e7f8ca2745b$var$WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS || $f4d97e7f8ca2745b$var$TO_OBJECT_BUG);


"use strict";










var $29ef1c9d05e4c067$var$aTypedArray = $22c60d3b8256dfa1$exports.aTypedArray;
var $29ef1c9d05e4c067$var$exportTypedArrayMethod = $22c60d3b8256dfa1$exports.exportTypedArrayMethod;
var $29ef1c9d05e4c067$var$Uint16Array = $212fa519f4bef41a$exports.Uint16Array;
var $29ef1c9d05e4c067$var$nativeSort = $29ef1c9d05e4c067$var$Uint16Array && $46453aed9e51860f$exports($29ef1c9d05e4c067$var$Uint16Array.prototype.sort);
// WebKit
var $29ef1c9d05e4c067$var$ACCEPT_INCORRECT_ARGUMENTS = !!$29ef1c9d05e4c067$var$nativeSort && !($217c917c4f59b359$exports(function() {
    $29ef1c9d05e4c067$var$nativeSort(new $29ef1c9d05e4c067$var$Uint16Array(2), null);
}) && $217c917c4f59b359$exports(function() {
    $29ef1c9d05e4c067$var$nativeSort(new $29ef1c9d05e4c067$var$Uint16Array(2), {});
}));
var $29ef1c9d05e4c067$var$STABLE_SORT = !!$29ef1c9d05e4c067$var$nativeSort && !$217c917c4f59b359$exports(function() {
    // feature detection can be too slow, so check engines versions
    if ($aed210e8b55f96e7$exports) return $aed210e8b55f96e7$exports < 74;
    if ($b1db8f4e724762d6$exports) return $b1db8f4e724762d6$exports < 67;
    if ($909597d02685e5ba$exports) return true;
    if ($c2d1f4653f16d67a$exports) return $c2d1f4653f16d67a$exports < 602;
    var array = new $29ef1c9d05e4c067$var$Uint16Array(516);
    var expected = Array(516);
    var index, mod;
    for(index = 0; index < 516; index++){
        mod = index % 4;
        array[index] = 515 - index;
        expected[index] = index - 2 * mod + 3;
    }
    $29ef1c9d05e4c067$var$nativeSort(array, function(a, b) {
        return (a / 4 | 0) - (b / 4 | 0);
    });
    for(index = 0; index < 516; index++){
        if (array[index] !== expected[index]) return true;
    }
});
var $29ef1c9d05e4c067$var$getSortCompare = function(comparefn) {
    return function(x, y) {
        if (comparefn !== undefined) return +comparefn(x, y) || 0;
        // eslint-disable-next-line no-self-compare -- NaN check
        if (y !== y) return -1;
        // eslint-disable-next-line no-self-compare -- NaN check
        if (x !== x) return 1;
        if (x === 0 && y === 0) return 1 / x > 0 && 1 / y < 0 ? 1 : -1;
        return x > y;
    };
};
// `%TypedArray%.prototype.sort` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.sort
$29ef1c9d05e4c067$var$exportTypedArrayMethod("sort", function sort(comparefn) {
    if (comparefn !== undefined) $6df447ad4be37421$exports(comparefn);
    if ($29ef1c9d05e4c067$var$STABLE_SORT) return $29ef1c9d05e4c067$var$nativeSort(this, comparefn);
    return $555a1841cf570867$exports($29ef1c9d05e4c067$var$aTypedArray(this), $29ef1c9d05e4c067$var$getSortCompare(comparefn));
}, !$29ef1c9d05e4c067$var$STABLE_SORT || $29ef1c9d05e4c067$var$ACCEPT_INCORRECT_ARGUMENTS);


"use strict";





var $ee70129579e40959$var$Int8Array = $212fa519f4bef41a$exports.Int8Array;
var $ee70129579e40959$var$aTypedArray = $22c60d3b8256dfa1$exports.aTypedArray;
var $ee70129579e40959$var$exportTypedArrayMethod = $22c60d3b8256dfa1$exports.exportTypedArrayMethod;
var $ee70129579e40959$var$$toLocaleString = [].toLocaleString;
// iOS Safari 6.x fails here
var $ee70129579e40959$var$TO_LOCALE_STRING_BUG = !!$ee70129579e40959$var$Int8Array && $217c917c4f59b359$exports(function() {
    $ee70129579e40959$var$$toLocaleString.call(new $ee70129579e40959$var$Int8Array(1));
});
var $ee70129579e40959$var$FORCED = $217c917c4f59b359$exports(function() {
    return [
        1,
        2
    ].toLocaleString() !== new $ee70129579e40959$var$Int8Array([
        1,
        2
    ]).toLocaleString();
}) || !$217c917c4f59b359$exports(function() {
    $ee70129579e40959$var$Int8Array.prototype.toLocaleString.call([
        1,
        2
    ]);
});
// `%TypedArray%.prototype.toLocaleString` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.tolocalestring
$ee70129579e40959$var$exportTypedArrayMethod("toLocaleString", function toLocaleString() {
    return $9cb3247174ca8cfd$exports($ee70129579e40959$var$$toLocaleString, $ee70129579e40959$var$TO_LOCALE_STRING_BUG ? $a1fdbc3bb6749f54$exports($ee70129579e40959$var$aTypedArray(this)) : $ee70129579e40959$var$aTypedArray(this), $a1fdbc3bb6749f54$exports(arguments));
}, $ee70129579e40959$var$FORCED);


"use strict";
"use strict";
var $dc7f2cab36298732$exports = {};
"use strict";

$dc7f2cab36298732$exports = !$217c917c4f59b359$exports(function() {
    // eslint-disable-next-line es/no-object-isextensible, es/no-object-preventextensions -- required for testing
    return Object.isExtensible(Object.preventExtensions({}));
});





var $6b2ce68c49545b2f$exports = {};
"use strict";






var $6b2ce68c49545b2f$require$defineProperty = $0163cc0a742cd3ad$export$2d1720544b23b823;

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var $3b0872e15d2693c4$export$2d1720544b23b823;
"use strict";



var $3b0872e15d2693c4$require$$getOwnPropertyNames = $f54839ff0ad1f1b7$export$2d1720544b23b823;

var $3b0872e15d2693c4$var$windowNames = typeof window == "object" && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
var $3b0872e15d2693c4$var$getWindowNames = function(it) {
    try {
        return $3b0872e15d2693c4$require$$getOwnPropertyNames(it);
    } catch (error) {
        return $9b893bf7d545a0e5$exports($3b0872e15d2693c4$var$windowNames);
    }
};
$3b0872e15d2693c4$export$2d1720544b23b823 = function getOwnPropertyNames(it) {
    return $3b0872e15d2693c4$var$windowNames && $7f55bdfec0ad037d$exports(it) === "Window" ? $3b0872e15d2693c4$var$getWindowNames(it) : $3b0872e15d2693c4$require$$getOwnPropertyNames($1a94a489a7afc329$exports(it));
};


var $78f306c14c90b75a$exports = {};
"use strict";



var $3df46d39e35af50d$exports = {};
"use strict";

$3df46d39e35af50d$exports = $217c917c4f59b359$exports(function() {
    if (typeof ArrayBuffer == "function") {
        var buffer = new ArrayBuffer(8);
        // eslint-disable-next-line es/no-object-isextensible, es/no-object-defineproperty -- safe
        if (Object.isExtensible(buffer)) Object.defineProperty(buffer, "a", {
            value: 8
        });
    }
});


// eslint-disable-next-line es/no-object-isextensible -- safe
var $78f306c14c90b75a$var$$isExtensible = Object.isExtensible;
var $78f306c14c90b75a$var$FAILS_ON_PRIMITIVES = $217c917c4f59b359$exports(function() {
    $78f306c14c90b75a$var$$isExtensible(1);
});
// `Object.isExtensible` method
// https://tc39.es/ecma262/#sec-object.isextensible
$78f306c14c90b75a$exports = $78f306c14c90b75a$var$FAILS_ON_PRIMITIVES || $3df46d39e35af50d$exports ? function isExtensible(it) {
    if (!$06f10e9b9cb1418c$exports(it)) return false;
    if ($3df46d39e35af50d$exports && $7f55bdfec0ad037d$exports(it) === "ArrayBuffer") return false;
    return $78f306c14c90b75a$var$$isExtensible ? $78f306c14c90b75a$var$$isExtensible(it) : true;
} : $78f306c14c90b75a$var$$isExtensible;




var $6b2ce68c49545b2f$var$REQUIRED = false;
var $6b2ce68c49545b2f$var$METADATA = $280519a5ebb3eef0$exports("meta");
var $6b2ce68c49545b2f$var$id = 0;
var $6b2ce68c49545b2f$var$setMetadata = function(it) {
    $6b2ce68c49545b2f$require$defineProperty(it, $6b2ce68c49545b2f$var$METADATA, {
        value: {
            objectID: "O" + $6b2ce68c49545b2f$var$id++,
            weakData: {} // weak collections IDs
        }
    });
};
var $6b2ce68c49545b2f$var$fastKey = function(it, create) {
    // return a primitive with prefix
    if (!$06f10e9b9cb1418c$exports(it)) return typeof it == "symbol" ? it : (typeof it == "string" ? "S" : "P") + it;
    if (!$1ad0c60d8de14c83$exports(it, $6b2ce68c49545b2f$var$METADATA)) {
        // can't set metadata to uncaught frozen object
        if (!$78f306c14c90b75a$exports(it)) return "F";
        // not necessary to add metadata
        if (!create) return "E";
        // add missing metadata
        $6b2ce68c49545b2f$var$setMetadata(it);
    // return object ID
    }
    return it[$6b2ce68c49545b2f$var$METADATA].objectID;
};
var $6b2ce68c49545b2f$var$getWeakData = function(it, create) {
    if (!$1ad0c60d8de14c83$exports(it, $6b2ce68c49545b2f$var$METADATA)) {
        // can't set metadata to uncaught frozen object
        if (!$78f306c14c90b75a$exports(it)) return true;
        // not necessary to add metadata
        if (!create) return false;
        // add missing metadata
        $6b2ce68c49545b2f$var$setMetadata(it);
    // return the store of weak collections IDs
    }
    return it[$6b2ce68c49545b2f$var$METADATA].weakData;
};
// add metadata on freeze-family methods calling
var $6b2ce68c49545b2f$var$onFreeze = function(it) {
    if ($dc7f2cab36298732$exports && $6b2ce68c49545b2f$var$REQUIRED && $78f306c14c90b75a$exports(it) && !$1ad0c60d8de14c83$exports(it, $6b2ce68c49545b2f$var$METADATA)) $6b2ce68c49545b2f$var$setMetadata(it);
    return it;
};
var $6b2ce68c49545b2f$var$enable = function() {
    $6b2ce68c49545b2f$var$meta.enable = function() {};
    $6b2ce68c49545b2f$var$REQUIRED = true;
    var getOwnPropertyNames = $f54839ff0ad1f1b7$export$2d1720544b23b823;
    var splice = $c201050ed73b14ba$exports([].splice);
    var test = {};
    test[$6b2ce68c49545b2f$var$METADATA] = 1;
    // prevent exposing of metadata key
    if (getOwnPropertyNames(test).length) {
        $f54839ff0ad1f1b7$export$2d1720544b23b823 = function(it) {
            var result = getOwnPropertyNames(it);
            for(var i = 0, length = result.length; i < length; i++)if (result[i] === $6b2ce68c49545b2f$var$METADATA) {
                splice(result, i, 1);
                break;
            }
            return result;
        };
        $ef48c8e0540d6569$exports({
            target: "Object",
            stat: true,
            forced: true
        }, {
            getOwnPropertyNames: $3b0872e15d2693c4$export$2d1720544b23b823
        });
    }
};
var $6b2ce68c49545b2f$var$meta = $6b2ce68c49545b2f$exports = {
    enable: $6b2ce68c49545b2f$var$enable,
    fastKey: $6b2ce68c49545b2f$var$fastKey,
    getWeakData: $6b2ce68c49545b2f$var$getWeakData,
    onFreeze: $6b2ce68c49545b2f$var$onFreeze
};
$b993c2c9b79c8bdc$exports[$6b2ce68c49545b2f$var$METADATA] = true;


var $0a2bbea6f51588ae$exports = {};
"use strict";















$0a2bbea6f51588ae$exports = function(CONSTRUCTOR_NAME, wrapper, common) {
    var IS_MAP = CONSTRUCTOR_NAME.indexOf("Map") !== -1;
    var IS_WEAK = CONSTRUCTOR_NAME.indexOf("Weak") !== -1;
    var ADDER = IS_MAP ? "set" : "add";
    var NativeConstructor = $212fa519f4bef41a$exports[CONSTRUCTOR_NAME];
    var NativePrototype = NativeConstructor && NativeConstructor.prototype;
    var Constructor = NativeConstructor;
    var exported = {};
    var fixMethod = function(KEY) {
        var uncurriedNativeMethod = $c201050ed73b14ba$exports(NativePrototype[KEY]);
        $5cabf6b3204ed174$exports(NativePrototype, KEY, KEY === "add" ? function add(value) {
            uncurriedNativeMethod(this, value === 0 ? 0 : value);
            return this;
        } : KEY === "delete" ? function(key) {
            return IS_WEAK && !$06f10e9b9cb1418c$exports(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
        } : KEY === "get" ? function get(key) {
            return IS_WEAK && !$06f10e9b9cb1418c$exports(key) ? undefined : uncurriedNativeMethod(this, key === 0 ? 0 : key);
        } : KEY === "has" ? function has(key) {
            return IS_WEAK && !$06f10e9b9cb1418c$exports(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
        } : function set(key, value) {
            uncurriedNativeMethod(this, key === 0 ? 0 : key, value);
            return this;
        });
    };
    var REPLACE = $e48b32723d42f00b$exports(CONSTRUCTOR_NAME, !$73d1a34d94fa4c35$exports(NativeConstructor) || !(IS_WEAK || NativePrototype.forEach && !$217c917c4f59b359$exports(function() {
        new NativeConstructor().entries().next();
    })));
    if (REPLACE) {
        // create collection constructor
        Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
        $6b2ce68c49545b2f$exports.enable();
    } else if ($e48b32723d42f00b$exports(CONSTRUCTOR_NAME, true)) {
        var instance = new Constructor();
        // early implementations not supports chaining
        var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) !== instance;
        // V8 ~ Chromium 40- weak-collections throws on primitives, but should return false
        var THROWS_ON_PRIMITIVES = $217c917c4f59b359$exports(function() {
            instance.has(1);
        });
        // most early implementations doesn't supports iterables, most modern - not close it correctly
        // eslint-disable-next-line no-new -- required for testing
        var ACCEPT_ITERABLES = $cbc4990623e012f7$exports(function(iterable) {
            new NativeConstructor(iterable);
        });
        // for early implementations -0 and +0 not the same
        var BUGGY_ZERO = !IS_WEAK && $217c917c4f59b359$exports(function() {
            // V8 ~ Chromium 42- fails only with 5+ elements
            var $instance = new NativeConstructor();
            var index = 5;
            while(index--)$instance[ADDER](index, index);
            return !$instance.has(-0);
        });
        if (!ACCEPT_ITERABLES) {
            Constructor = wrapper(function(dummy, iterable) {
                $efe207f3fce362b0$exports(dummy, NativePrototype);
                var that = $9b01bf25cd1d3ee2$exports(new NativeConstructor(), dummy, Constructor);
                if (!$e64dc79af48a1328$exports(iterable)) $1067bad61af3a5d4$exports(iterable, that[ADDER], {
                    that: that,
                    AS_ENTRIES: IS_MAP
                });
                return that;
            });
            Constructor.prototype = NativePrototype;
            NativePrototype.constructor = Constructor;
        }
        if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
            fixMethod("delete");
            fixMethod("has");
            IS_MAP && fixMethod("get");
        }
        if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
        // weak collections should not contains .clear method
        if (IS_WEAK && NativePrototype.clear) delete NativePrototype.clear;
    }
    exported[CONSTRUCTOR_NAME] = Constructor;
    $ef48c8e0540d6569$exports({
        global: true,
        constructor: true,
        forced: Constructor !== NativeConstructor
    }, exported);
    $036072e21338276e$exports(Constructor, CONSTRUCTOR_NAME);
    if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);
    return Constructor;
};


var $8a9d896a49f9907d$exports = {};
"use strict";



var $8a9d896a49f9907d$require$getWeakData = $6b2ce68c49545b2f$exports.getWeakData;








var $8a9d896a49f9907d$var$setInternalState = $954a2ea894ec1c9c$exports.set;
var $8a9d896a49f9907d$var$internalStateGetterFor = $954a2ea894ec1c9c$exports.getterFor;
var $8a9d896a49f9907d$var$find = $14e96181fe6e0035$exports.find;
var $8a9d896a49f9907d$var$findIndex = $14e96181fe6e0035$exports.findIndex;
var $8a9d896a49f9907d$var$splice = $c201050ed73b14ba$exports([].splice);
var $8a9d896a49f9907d$var$id = 0;
// fallback for uncaught frozen keys
var $8a9d896a49f9907d$var$uncaughtFrozenStore = function(state) {
    return state.frozen || (state.frozen = new $8a9d896a49f9907d$var$UncaughtFrozenStore());
};
var $8a9d896a49f9907d$var$UncaughtFrozenStore = function() {
    this.entries = [];
};
var $8a9d896a49f9907d$var$findUncaughtFrozen = function(store, key) {
    return $8a9d896a49f9907d$var$find(store.entries, function(it) {
        return it[0] === key;
    });
};
$8a9d896a49f9907d$var$UncaughtFrozenStore.prototype = {
    get: function(key) {
        var entry = $8a9d896a49f9907d$var$findUncaughtFrozen(this, key);
        if (entry) return entry[1];
    },
    has: function(key) {
        return !!$8a9d896a49f9907d$var$findUncaughtFrozen(this, key);
    },
    set: function(key, value) {
        var entry = $8a9d896a49f9907d$var$findUncaughtFrozen(this, key);
        if (entry) entry[1] = value;
        else this.entries.push([
            key,
            value
        ]);
    },
    "delete": function(key) {
        var index = $8a9d896a49f9907d$var$findIndex(this.entries, function(it) {
            return it[0] === key;
        });
        if (~index) $8a9d896a49f9907d$var$splice(this.entries, index, 1);
        return !!~index;
    }
};
$8a9d896a49f9907d$exports = {
    getConstructor: function(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
        var Constructor = wrapper(function(that, iterable) {
            $efe207f3fce362b0$exports(that, Prototype);
            $8a9d896a49f9907d$var$setInternalState(that, {
                type: CONSTRUCTOR_NAME,
                id: $8a9d896a49f9907d$var$id++,
                frozen: undefined
            });
            if (!$e64dc79af48a1328$exports(iterable)) $1067bad61af3a5d4$exports(iterable, that[ADDER], {
                that: that,
                AS_ENTRIES: IS_MAP
            });
        });
        var Prototype = Constructor.prototype;
        var getInternalState = $8a9d896a49f9907d$var$internalStateGetterFor(CONSTRUCTOR_NAME);
        var define = function(that, key, value) {
            var state = getInternalState(that);
            var data = $8a9d896a49f9907d$require$getWeakData($affc609f2393bdba$exports(key), true);
            if (data === true) $8a9d896a49f9907d$var$uncaughtFrozenStore(state).set(key, value);
            else data[state.id] = value;
            return that;
        };
        $ab8ebf21191217ba$exports(Prototype, {
            // `{ WeakMap, WeakSet }.prototype.delete(key)` methods
            // https://tc39.es/ecma262/#sec-weakmap.prototype.delete
            // https://tc39.es/ecma262/#sec-weakset.prototype.delete
            "delete": function(key) {
                var state = getInternalState(this);
                if (!$06f10e9b9cb1418c$exports(key)) return false;
                var data = $8a9d896a49f9907d$require$getWeakData(key);
                if (data === true) return $8a9d896a49f9907d$var$uncaughtFrozenStore(state)["delete"](key);
                return data && $1ad0c60d8de14c83$exports(data, state.id) && delete data[state.id];
            },
            // `{ WeakMap, WeakSet }.prototype.has(key)` methods
            // https://tc39.es/ecma262/#sec-weakmap.prototype.has
            // https://tc39.es/ecma262/#sec-weakset.prototype.has
            has: function has(key) {
                var state = getInternalState(this);
                if (!$06f10e9b9cb1418c$exports(key)) return false;
                var data = $8a9d896a49f9907d$require$getWeakData(key);
                if (data === true) return $8a9d896a49f9907d$var$uncaughtFrozenStore(state).has(key);
                return data && $1ad0c60d8de14c83$exports(data, state.id);
            }
        });
        $ab8ebf21191217ba$exports(Prototype, IS_MAP ? {
            // `WeakMap.prototype.get(key)` method
            // https://tc39.es/ecma262/#sec-weakmap.prototype.get
            get: function get(key) {
                var state = getInternalState(this);
                if ($06f10e9b9cb1418c$exports(key)) {
                    var data = $8a9d896a49f9907d$require$getWeakData(key);
                    if (data === true) return $8a9d896a49f9907d$var$uncaughtFrozenStore(state).get(key);
                    return data ? data[state.id] : undefined;
                }
            },
            // `WeakMap.prototype.set(key, value)` method
            // https://tc39.es/ecma262/#sec-weakmap.prototype.set
            set: function set(key, value) {
                return define(this, key, value);
            }
        } : {
            // `WeakSet.prototype.add(value)` method
            // https://tc39.es/ecma262/#sec-weakset.prototype.add
            add: function add(value) {
                return define(this, value, true);
            }
        });
        return Constructor;
    }
};




var $d104ca4029008e8a$require$enforceInternalState = $954a2ea894ec1c9c$exports.enforce;


var $d104ca4029008e8a$var$$Object = Object;
// eslint-disable-next-line es/no-array-isarray -- safe
var $d104ca4029008e8a$var$isArray = Array.isArray;
// eslint-disable-next-line es/no-object-isextensible -- safe
var $d104ca4029008e8a$var$isExtensible = $d104ca4029008e8a$var$$Object.isExtensible;
// eslint-disable-next-line es/no-object-isfrozen -- safe
var $d104ca4029008e8a$var$isFrozen = $d104ca4029008e8a$var$$Object.isFrozen;
// eslint-disable-next-line es/no-object-issealed -- safe
var $d104ca4029008e8a$var$isSealed = $d104ca4029008e8a$var$$Object.isSealed;
// eslint-disable-next-line es/no-object-freeze -- safe
var $d104ca4029008e8a$var$freeze = $d104ca4029008e8a$var$$Object.freeze;
// eslint-disable-next-line es/no-object-seal -- safe
var $d104ca4029008e8a$var$seal = $d104ca4029008e8a$var$$Object.seal;
var $d104ca4029008e8a$var$FROZEN = {};
var $d104ca4029008e8a$var$SEALED = {};
var $d104ca4029008e8a$var$IS_IE11 = !$212fa519f4bef41a$exports.ActiveXObject && "ActiveXObject" in $212fa519f4bef41a$exports;
var $d104ca4029008e8a$var$InternalWeakMap;
var $d104ca4029008e8a$var$wrapper = function(init) {
    return function WeakMap() {
        return init(this, arguments.length ? arguments[0] : undefined);
    };
};
// `WeakMap` constructor
// https://tc39.es/ecma262/#sec-weakmap-constructor
var $d104ca4029008e8a$var$$WeakMap = $0a2bbea6f51588ae$exports("WeakMap", $d104ca4029008e8a$var$wrapper, $8a9d896a49f9907d$exports);
var $d104ca4029008e8a$var$WeakMapPrototype = $d104ca4029008e8a$var$$WeakMap.prototype;
var $d104ca4029008e8a$var$nativeSet = $c201050ed73b14ba$exports($d104ca4029008e8a$var$WeakMapPrototype.set);
// Chakra Edge bug: adding frozen arrays to WeakMap unfreeze them
var $d104ca4029008e8a$var$hasMSEdgeFreezingBug = function() {
    return $dc7f2cab36298732$exports && $217c917c4f59b359$exports(function() {
        var frozenArray = $d104ca4029008e8a$var$freeze([]);
        $d104ca4029008e8a$var$nativeSet(new $d104ca4029008e8a$var$$WeakMap(), frozenArray, 1);
        return !$d104ca4029008e8a$var$isFrozen(frozenArray);
    });
};
// IE11 WeakMap frozen keys fix
// We can't use feature detection because it crash some old IE builds
// https://github.com/zloirock/core-js/issues/485
if ($1b936cf6730f1f56$exports) {
    if ($d104ca4029008e8a$var$IS_IE11) {
        $d104ca4029008e8a$var$InternalWeakMap = $8a9d896a49f9907d$exports.getConstructor($d104ca4029008e8a$var$wrapper, "WeakMap", true);
        $6b2ce68c49545b2f$exports.enable();
        var $d104ca4029008e8a$var$nativeDelete = $c201050ed73b14ba$exports($d104ca4029008e8a$var$WeakMapPrototype["delete"]);
        var $d104ca4029008e8a$var$nativeHas = $c201050ed73b14ba$exports($d104ca4029008e8a$var$WeakMapPrototype.has);
        var $d104ca4029008e8a$var$nativeGet = $c201050ed73b14ba$exports($d104ca4029008e8a$var$WeakMapPrototype.get);
        $ab8ebf21191217ba$exports($d104ca4029008e8a$var$WeakMapPrototype, {
            "delete": function(key) {
                if ($06f10e9b9cb1418c$exports(key) && !$d104ca4029008e8a$var$isExtensible(key)) {
                    var state = $d104ca4029008e8a$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $d104ca4029008e8a$var$InternalWeakMap();
                    return $d104ca4029008e8a$var$nativeDelete(this, key) || state.frozen["delete"](key);
                }
                return $d104ca4029008e8a$var$nativeDelete(this, key);
            },
            has: function has(key) {
                if ($06f10e9b9cb1418c$exports(key) && !$d104ca4029008e8a$var$isExtensible(key)) {
                    var state = $d104ca4029008e8a$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $d104ca4029008e8a$var$InternalWeakMap();
                    return $d104ca4029008e8a$var$nativeHas(this, key) || state.frozen.has(key);
                }
                return $d104ca4029008e8a$var$nativeHas(this, key);
            },
            get: function get(key) {
                if ($06f10e9b9cb1418c$exports(key) && !$d104ca4029008e8a$var$isExtensible(key)) {
                    var state = $d104ca4029008e8a$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $d104ca4029008e8a$var$InternalWeakMap();
                    return $d104ca4029008e8a$var$nativeHas(this, key) ? $d104ca4029008e8a$var$nativeGet(this, key) : state.frozen.get(key);
                }
                return $d104ca4029008e8a$var$nativeGet(this, key);
            },
            set: function set(key, value) {
                if ($06f10e9b9cb1418c$exports(key) && !$d104ca4029008e8a$var$isExtensible(key)) {
                    var state = $d104ca4029008e8a$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $d104ca4029008e8a$var$InternalWeakMap();
                    $d104ca4029008e8a$var$nativeHas(this, key) ? $d104ca4029008e8a$var$nativeSet(this, key, value) : state.frozen.set(key, value);
                } else $d104ca4029008e8a$var$nativeSet(this, key, value);
                return this;
            }
        });
    // Chakra Edge frozen keys fix
    } else if ($d104ca4029008e8a$var$hasMSEdgeFreezingBug()) $ab8ebf21191217ba$exports($d104ca4029008e8a$var$WeakMapPrototype, {
        set: function set(key, value) {
            var arrayIntegrityLevel;
            if ($d104ca4029008e8a$var$isArray(key)) {
                if ($d104ca4029008e8a$var$isFrozen(key)) arrayIntegrityLevel = $d104ca4029008e8a$var$FROZEN;
                else if ($d104ca4029008e8a$var$isSealed(key)) arrayIntegrityLevel = $d104ca4029008e8a$var$SEALED;
            }
            $d104ca4029008e8a$var$nativeSet(this, key, value);
            if (arrayIntegrityLevel === $d104ca4029008e8a$var$FROZEN) $d104ca4029008e8a$var$freeze(key);
            if (arrayIntegrityLevel === $d104ca4029008e8a$var$SEALED) $d104ca4029008e8a$var$seal(key);
            return this;
        }
    });
}




"use strict";
"use strict";
"use strict";








var $7a709cff0e2c0102$exports = {};
"use strict";


// `InstallErrorCause` abstract operation
// https://tc39.es/proposal-error-cause/#sec-errorobjects-install-error-cause
$7a709cff0e2c0102$exports = function(O, options) {
    if ($06f10e9b9cb1418c$exports(options) && "cause" in options) $cbffb6e18a252dcf$exports(O, "cause", options.cause);
};


var $52f9ed7c809cfd71$exports = {};
"use strict";

var $9eca551c50d91c94$exports = {};
"use strict";

var $9eca551c50d91c94$var$$Error = Error;
var $9eca551c50d91c94$var$replace = $c201050ed73b14ba$exports("".replace);
var $9eca551c50d91c94$var$TEST = function(arg) {
    return String(new $9eca551c50d91c94$var$$Error(arg).stack);
}("zxcasd");
// eslint-disable-next-line redos/no-vulnerable -- safe
var $9eca551c50d91c94$var$V8_OR_CHAKRA_STACK_ENTRY = /\n\s*at [^:]*:[^\n]*/;
var $9eca551c50d91c94$var$IS_V8_OR_CHAKRA_STACK = $9eca551c50d91c94$var$V8_OR_CHAKRA_STACK_ENTRY.test($9eca551c50d91c94$var$TEST);
$9eca551c50d91c94$exports = function(stack, dropEntries) {
    if ($9eca551c50d91c94$var$IS_V8_OR_CHAKRA_STACK && typeof stack == "string" && !$9eca551c50d91c94$var$$Error.prepareStackTrace) while(dropEntries--)stack = $9eca551c50d91c94$var$replace(stack, $9eca551c50d91c94$var$V8_OR_CHAKRA_STACK_ENTRY, "");
    return stack;
};


var $2c4a6aef86056f4e$exports = {};
"use strict";


$2c4a6aef86056f4e$exports = !$217c917c4f59b359$exports(function() {
    var error = new Error("a");
    if (!("stack" in error)) return true;
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty(error, "stack", $819ae5875a6bb120$exports(1, 7));
    return error.stack !== 7;
});


// non-standard V8
var $52f9ed7c809cfd71$var$captureStackTrace = Error.captureStackTrace;
$52f9ed7c809cfd71$exports = function(error, C, stack, dropEntries) {
    if ($2c4a6aef86056f4e$exports) {
        if ($52f9ed7c809cfd71$var$captureStackTrace) $52f9ed7c809cfd71$var$captureStackTrace(error, C);
        else $cbffb6e18a252dcf$exports(error, "stack", $9eca551c50d91c94$exports(stack, dropEntries));
    }
};



var $b03182cc4dcee196$exports = {};
"use strict";

$b03182cc4dcee196$exports = function(argument, $default) {
    return argument === undefined ? arguments.length < 2 ? "" : $default : $5eca6f9e01902ab4$exports(argument);
};



var $7d4aabce627e616e$var$TO_STRING_TAG = $bbf4e852bf6421ea$exports("toStringTag");
var $7d4aabce627e616e$var$$Error = Error;
var $7d4aabce627e616e$var$push = [].push;
var $7d4aabce627e616e$var$$AggregateError = function AggregateError(errors, message /* , options */ ) {
    var isInstance = $dba85d7bd7ffe0d7$exports($7d4aabce627e616e$var$AggregateErrorPrototype, this);
    var that;
    if ($160170ca8ccc9a75$exports) that = $160170ca8ccc9a75$exports(new $7d4aabce627e616e$var$$Error(), isInstance ? $e5c52a606c67a805$exports(this) : $7d4aabce627e616e$var$AggregateErrorPrototype);
    else {
        that = isInstance ? this : $a98baaf21fc755e7$exports($7d4aabce627e616e$var$AggregateErrorPrototype);
        $cbffb6e18a252dcf$exports(that, $7d4aabce627e616e$var$TO_STRING_TAG, "Error");
    }
    if (message !== undefined) $cbffb6e18a252dcf$exports(that, "message", $b03182cc4dcee196$exports(message));
    $52f9ed7c809cfd71$exports(that, $7d4aabce627e616e$var$$AggregateError, that.stack, 1);
    if (arguments.length > 2) $7a709cff0e2c0102$exports(that, arguments[2]);
    var errorsArray = [];
    $1067bad61af3a5d4$exports(errors, $7d4aabce627e616e$var$push, {
        that: errorsArray
    });
    $cbffb6e18a252dcf$exports(that, "errors", errorsArray);
    return that;
};
if ($160170ca8ccc9a75$exports) $160170ca8ccc9a75$exports($7d4aabce627e616e$var$$AggregateError, $7d4aabce627e616e$var$$Error);
else $3e579e5e62b22d47$exports($7d4aabce627e616e$var$$AggregateError, $7d4aabce627e616e$var$$Error, {
    name: true
});
var $7d4aabce627e616e$var$AggregateErrorPrototype = $7d4aabce627e616e$var$$AggregateError.prototype = $a98baaf21fc755e7$exports($7d4aabce627e616e$var$$Error.prototype, {
    constructor: $819ae5875a6bb120$exports(1, $7d4aabce627e616e$var$$AggregateError),
    message: $819ae5875a6bb120$exports(1, ""),
    name: $819ae5875a6bb120$exports(1, "AggregateError")
});
// `AggregateError` constructor
// https://tc39.es/ecma262/#sec-aggregate-error-constructor
$ef48c8e0540d6569$exports({
    global: true,
    constructor: true,
    arity: 2
}, {
    AggregateError: $7d4aabce627e616e$var$$AggregateError
});






"use strict";
"use strict";


// `globalThis` object
// https://tc39.es/ecma262/#sec-globalthis
$ef48c8e0540d6569$exports({
    global: true,
    forced: $212fa519f4bef41a$exports.globalThis !== $212fa519f4bef41a$exports
}, {
    globalThis: $212fa519f4bef41a$exports
});




"use strict";
"use strict";







// `Promise.allSettled` method
// https://tc39.es/ecma262/#sec-promise.allsettled
$ef48c8e0540d6569$exports({
    target: "Promise",
    stat: true,
    forced: $6fe32dc7efdbe6ad$exports
}, {
    allSettled: function allSettled(iterable) {
        var C = this;
        var capability = $c335377c5f9c8743$export$2d1720544b23b823(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = $f8c91a7dd342833c$exports(function() {
            var promiseResolve = $6df447ad4be37421$exports(C.resolve);
            var values = [];
            var counter = 0;
            var remaining = 1;
            $1067bad61af3a5d4$exports(iterable, function(promise) {
                var index = counter++;
                var alreadyCalled = false;
                remaining++;
                $2f17e9746e5fde89$exports(promiseResolve, C, promise).then(function(value) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[index] = {
                        status: "fulfilled",
                        value: value
                    };
                    --remaining || resolve(values);
                }, function(error) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[index] = {
                        status: "rejected",
                        reason: error
                    };
                    --remaining || resolve(values);
                });
            });
            --remaining || resolve(values);
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});




"use strict";
"use strict";








var $04cd0dc1fa777eb2$var$PROMISE_ANY_ERROR = "No one promise resolved";
// `Promise.any` method
// https://tc39.es/ecma262/#sec-promise.any
$ef48c8e0540d6569$exports({
    target: "Promise",
    stat: true,
    forced: $6fe32dc7efdbe6ad$exports
}, {
    any: function any(iterable) {
        var C = this;
        var AggregateError = $3e824c856d81a8e3$exports("AggregateError");
        var capability = $c335377c5f9c8743$export$2d1720544b23b823(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = $f8c91a7dd342833c$exports(function() {
            var promiseResolve = $6df447ad4be37421$exports(C.resolve);
            var errors = [];
            var counter = 0;
            var remaining = 1;
            var alreadyResolved = false;
            $1067bad61af3a5d4$exports(iterable, function(promise) {
                var index = counter++;
                var alreadyRejected = false;
                remaining++;
                $2f17e9746e5fde89$exports(promiseResolve, C, promise).then(function(value) {
                    if (alreadyRejected || alreadyResolved) return;
                    alreadyResolved = true;
                    resolve(value);
                }, function(error) {
                    if (alreadyRejected || alreadyResolved) return;
                    alreadyRejected = true;
                    errors[index] = error;
                    --remaining || reject(new AggregateError(errors, $04cd0dc1fa777eb2$var$PROMISE_ANY_ERROR));
                });
            });
            --remaining || reject(new AggregateError(errors, $04cd0dc1fa777eb2$var$PROMISE_ANY_ERROR));
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});




"use strict";
"use strict";






















var $520458fbc6ea9559$var$MATCH_ALL = $bbf4e852bf6421ea$exports("matchAll");
var $520458fbc6ea9559$var$REGEXP_STRING = "RegExp String";
var $520458fbc6ea9559$var$REGEXP_STRING_ITERATOR = $520458fbc6ea9559$var$REGEXP_STRING + " Iterator";
var $520458fbc6ea9559$var$setInternalState = $954a2ea894ec1c9c$exports.set;
var $520458fbc6ea9559$var$getInternalState = $954a2ea894ec1c9c$exports.getterFor($520458fbc6ea9559$var$REGEXP_STRING_ITERATOR);
var $520458fbc6ea9559$var$RegExpPrototype = RegExp.prototype;
var $520458fbc6ea9559$var$$TypeError = TypeError;
var $520458fbc6ea9559$var$stringIndexOf = $46453aed9e51860f$exports("".indexOf);
var $520458fbc6ea9559$var$nativeMatchAll = $46453aed9e51860f$exports("".matchAll);
var $520458fbc6ea9559$var$WORKS_WITH_NON_GLOBAL_REGEX = !!$520458fbc6ea9559$var$nativeMatchAll && !$217c917c4f59b359$exports(function() {
    $520458fbc6ea9559$var$nativeMatchAll("a", /./);
});
var $520458fbc6ea9559$var$$RegExpStringIterator = $8159770b7a97268e$exports(function RegExpStringIterator(regexp, string, $global, fullUnicode) {
    $520458fbc6ea9559$var$setInternalState(this, {
        type: $520458fbc6ea9559$var$REGEXP_STRING_ITERATOR,
        regexp: regexp,
        string: string,
        global: $global,
        unicode: fullUnicode,
        done: false
    });
}, $520458fbc6ea9559$var$REGEXP_STRING, function next() {
    var state = $520458fbc6ea9559$var$getInternalState(this);
    if (state.done) return $783af5147689a0b0$exports(undefined, true);
    var R = state.regexp;
    var S = state.string;
    var match = $e91e9894e8974d75$exports(R, S);
    if (match === null) {
        state.done = true;
        return $783af5147689a0b0$exports(undefined, true);
    }
    if (state.global) {
        if ($5eca6f9e01902ab4$exports(match[0]) === "") R.lastIndex = $9c81ffbb19bd14cc$exports(S, $a46f106a02f96447$exports(R.lastIndex), state.unicode);
        return $783af5147689a0b0$exports(match, false);
    }
    state.done = true;
    return $783af5147689a0b0$exports(match, false);
});
var $520458fbc6ea9559$var$$matchAll = function(string) {
    var R = $affc609f2393bdba$exports(this);
    var S = $5eca6f9e01902ab4$exports(string);
    var C = $21e66763122ffa99$exports(R, RegExp);
    var flags = $5eca6f9e01902ab4$exports($6a132a17783f32fb$exports(R));
    var matcher, $global, fullUnicode;
    matcher = new C(C === RegExp ? R.source : R, flags);
    $global = !!~$520458fbc6ea9559$var$stringIndexOf(flags, "g");
    fullUnicode = !!~$520458fbc6ea9559$var$stringIndexOf(flags, "u");
    matcher.lastIndex = $a46f106a02f96447$exports(R.lastIndex);
    return new $520458fbc6ea9559$var$$RegExpStringIterator(matcher, S, $global, fullUnicode);
};
// `String.prototype.matchAll` method
// https://tc39.es/ecma262/#sec-string.prototype.matchall
$ef48c8e0540d6569$exports({
    target: "String",
    proto: true,
    forced: $520458fbc6ea9559$var$WORKS_WITH_NON_GLOBAL_REGEX
}, {
    matchAll: function matchAll(regexp) {
        var O = $07418f2e69c51fa2$exports(this);
        var flags, S, matcher, rx;
        if (!$e64dc79af48a1328$exports(regexp)) {
            if ($a7cca8ee8e2a9d0b$exports(regexp)) {
                flags = $5eca6f9e01902ab4$exports($07418f2e69c51fa2$exports($6a132a17783f32fb$exports(regexp)));
                if (!~$520458fbc6ea9559$var$stringIndexOf(flags, "g")) throw new $520458fbc6ea9559$var$$TypeError("`.matchAll` does not allow non-global regexes");
            }
            if ($520458fbc6ea9559$var$WORKS_WITH_NON_GLOBAL_REGEX) return $520458fbc6ea9559$var$nativeMatchAll(O, regexp);
            matcher = $a1d58592526cda62$exports(regexp, $520458fbc6ea9559$var$MATCH_ALL);
            if (matcher === undefined && $036c29a074575bd6$exports && $7f55bdfec0ad037d$exports(regexp) === "RegExp") matcher = $520458fbc6ea9559$var$$matchAll;
            if (matcher) return $2f17e9746e5fde89$exports(matcher, regexp, O);
        } else if ($520458fbc6ea9559$var$WORKS_WITH_NON_GLOBAL_REGEX) return $520458fbc6ea9559$var$nativeMatchAll(O, regexp);
        S = $5eca6f9e01902ab4$exports(O);
        rx = new RegExp(regexp, "g");
        return $036c29a074575bd6$exports ? $2f17e9746e5fde89$exports($520458fbc6ea9559$var$$matchAll, rx, S) : rx[$520458fbc6ea9559$var$MATCH_ALL](S);
    }
});
$036c29a074575bd6$exports || $520458fbc6ea9559$var$MATCH_ALL in $520458fbc6ea9559$var$RegExpPrototype || $5cabf6b3204ed174$exports($520458fbc6ea9559$var$RegExpPrototype, $520458fbc6ea9559$var$MATCH_ALL, $520458fbc6ea9559$var$$matchAll);




"use strict";
"use strict";













var $94be2385fe5ccc7a$var$REPLACE = $bbf4e852bf6421ea$exports("replace");
var $94be2385fe5ccc7a$var$$TypeError = TypeError;
var $94be2385fe5ccc7a$var$indexOf = $c201050ed73b14ba$exports("".indexOf);
var $94be2385fe5ccc7a$var$replace = $c201050ed73b14ba$exports("".replace);
var $94be2385fe5ccc7a$var$stringSlice = $c201050ed73b14ba$exports("".slice);
var $94be2385fe5ccc7a$var$max = Math.max;
var $94be2385fe5ccc7a$var$stringIndexOf = function(string, searchValue, fromIndex) {
    if (fromIndex > string.length) return -1;
    if (searchValue === "") return fromIndex;
    return $94be2385fe5ccc7a$var$indexOf(string, searchValue, fromIndex);
};
// `String.prototype.replaceAll` method
// https://tc39.es/ecma262/#sec-string.prototype.replaceall
$ef48c8e0540d6569$exports({
    target: "String",
    proto: true
}, {
    replaceAll: function replaceAll(searchValue, replaceValue) {
        var O = $07418f2e69c51fa2$exports(this);
        var IS_REG_EXP, flags, replacer, string, searchString, functionalReplace, searchLength, advanceBy, replacement;
        var position = 0;
        var endOfLastMatch = 0;
        var result = "";
        if (!$e64dc79af48a1328$exports(searchValue)) {
            IS_REG_EXP = $a7cca8ee8e2a9d0b$exports(searchValue);
            if (IS_REG_EXP) {
                flags = $5eca6f9e01902ab4$exports($07418f2e69c51fa2$exports($6a132a17783f32fb$exports(searchValue)));
                if (!~$94be2385fe5ccc7a$var$indexOf(flags, "g")) throw new $94be2385fe5ccc7a$var$$TypeError("`.replaceAll` does not allow non-global regexes");
            }
            replacer = $a1d58592526cda62$exports(searchValue, $94be2385fe5ccc7a$var$REPLACE);
            if (replacer) return $2f17e9746e5fde89$exports(replacer, searchValue, O, replaceValue);
            else if ($036c29a074575bd6$exports && IS_REG_EXP) return $94be2385fe5ccc7a$var$replace($5eca6f9e01902ab4$exports(O), searchValue, replaceValue);
        }
        string = $5eca6f9e01902ab4$exports(O);
        searchString = $5eca6f9e01902ab4$exports(searchValue);
        functionalReplace = $73d1a34d94fa4c35$exports(replaceValue);
        if (!functionalReplace) replaceValue = $5eca6f9e01902ab4$exports(replaceValue);
        searchLength = searchString.length;
        advanceBy = $94be2385fe5ccc7a$var$max(1, searchLength);
        position = $94be2385fe5ccc7a$var$stringIndexOf(string, searchString, 0);
        while(position !== -1){
            replacement = functionalReplace ? $5eca6f9e01902ab4$exports(replaceValue(searchString, position, string)) : $b736369b2a89d587$exports(searchString, string, position, [], undefined, replaceValue);
            result += $94be2385fe5ccc7a$var$stringSlice(string, endOfLastMatch, position) + replacement;
            endOfLastMatch = position + searchLength;
            position = $94be2385fe5ccc7a$var$stringIndexOf(string, searchString, position + advanceBy);
        }
        if (endOfLastMatch < string.length) result += $94be2385fe5ccc7a$var$stringSlice(string, endOfLastMatch);
        return result;
    }
});




"use strict";



var $fc5bda78ce285ae0$require$defineProperty = $0163cc0a742cd3ad$export$2d1720544b23b823;

var $fc5bda78ce285ae0$require$getOwnPropertyDescriptor = $3cd2e4c9005c1909$export$2d1720544b23b823;
var $fc5bda78ce285ae0$var$Symbol = $212fa519f4bef41a$exports.Symbol;
// `Symbol.dispose` well-known symbol
// https://github.com/tc39/proposal-explicit-resource-management
$83de97535578578d$exports("dispose");
if ($fc5bda78ce285ae0$var$Symbol) {
    var $fc5bda78ce285ae0$var$descriptor = $fc5bda78ce285ae0$require$getOwnPropertyDescriptor($fc5bda78ce285ae0$var$Symbol, "dispose");
    // workaround of NodeJS 20.4 bug
    // https://github.com/nodejs/node/issues/48699
    // and incorrect descriptor from some transpilers and userland helpers
    if ($fc5bda78ce285ae0$var$descriptor.enumerable && $fc5bda78ce285ae0$var$descriptor.configurable && $fc5bda78ce285ae0$var$descriptor.writable) $fc5bda78ce285ae0$require$defineProperty($fc5bda78ce285ae0$var$Symbol, "dispose", {
        value: $fc5bda78ce285ae0$var$descriptor.value,
        enumerable: false,
        configurable: false,
        writable: false
    });
}


"use strict";

var $f261fad59894a58f$exports = {};
"use strict";
// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
$f261fad59894a58f$exports = {
    CSSRuleList: 0,
    CSSStyleDeclaration: 0,
    CSSValueList: 0,
    ClientRectList: 0,
    DOMRectList: 0,
    DOMStringList: 0,
    DOMTokenList: 1,
    DataTransferItemList: 0,
    FileList: 0,
    HTMLAllCollection: 0,
    HTMLCollection: 0,
    HTMLFormElement: 0,
    HTMLSelectElement: 0,
    MediaList: 0,
    MimeTypeArray: 0,
    NamedNodeMap: 0,
    NodeList: 1,
    PaintRequestList: 0,
    Plugin: 0,
    PluginArray: 0,
    SVGLengthList: 0,
    SVGNumberList: 0,
    SVGPathSegList: 0,
    SVGPointList: 0,
    SVGStringList: 0,
    SVGTransformList: 0,
    SourceBufferList: 0,
    StyleSheetList: 0,
    TextTrackCueList: 0,
    TextTrackList: 0,
    TouchList: 0
};


var $e629879f6f8b631e$exports = {};
"use strict";

var $e629879f6f8b631e$var$classList = $5b8a2493ea30b53c$exports("span").classList;
var $e629879f6f8b631e$var$DOMTokenListPrototype = $e629879f6f8b631e$var$classList && $e629879f6f8b631e$var$classList.constructor && $e629879f6f8b631e$var$classList.constructor.prototype;
$e629879f6f8b631e$exports = $e629879f6f8b631e$var$DOMTokenListPrototype === Object.prototype ? undefined : $e629879f6f8b631e$var$DOMTokenListPrototype;






var $c30f983a680eb0a6$var$ITERATOR = $bbf4e852bf6421ea$exports("iterator");
var $c30f983a680eb0a6$var$ArrayValues = $ce79d5292b96d6e1$exports.values;
var $c30f983a680eb0a6$var$handlePrototype = function(CollectionPrototype, COLLECTION_NAME) {
    if (CollectionPrototype) {
        // some Chrome versions have non-configurable methods on DOMTokenList
        if (CollectionPrototype[$c30f983a680eb0a6$var$ITERATOR] !== $c30f983a680eb0a6$var$ArrayValues) try {
            $cbffb6e18a252dcf$exports(CollectionPrototype, $c30f983a680eb0a6$var$ITERATOR, $c30f983a680eb0a6$var$ArrayValues);
        } catch (error) {
            CollectionPrototype[$c30f983a680eb0a6$var$ITERATOR] = $c30f983a680eb0a6$var$ArrayValues;
        }
        $036072e21338276e$exports(CollectionPrototype, COLLECTION_NAME, true);
        if ($f261fad59894a58f$exports[COLLECTION_NAME]) for(var METHOD_NAME in $ce79d5292b96d6e1$exports){
            // some Chrome versions have non-configurable methods on DOMTokenList
            if (CollectionPrototype[METHOD_NAME] !== $ce79d5292b96d6e1$exports[METHOD_NAME]) try {
                $cbffb6e18a252dcf$exports(CollectionPrototype, METHOD_NAME, $ce79d5292b96d6e1$exports[METHOD_NAME]);
            } catch (error) {
                CollectionPrototype[METHOD_NAME] = $ce79d5292b96d6e1$exports[METHOD_NAME];
            }
        }
    }
};
for(var $c30f983a680eb0a6$var$COLLECTION_NAME in $f261fad59894a58f$exports)$c30f983a680eb0a6$var$handlePrototype($212fa519f4bef41a$exports[$c30f983a680eb0a6$var$COLLECTION_NAME] && $212fa519f4bef41a$exports[$c30f983a680eb0a6$var$COLLECTION_NAME].prototype, $c30f983a680eb0a6$var$COLLECTION_NAME);
$c30f983a680eb0a6$var$handlePrototype($e629879f6f8b631e$exports, "DOMTokenList");


"use strict";
"use strict";



var $0e5b06bc91576124$require$clearImmediate = $660f9a894434a192$exports.clear;
// `clearImmediate` method
// http://w3c.github.io/setImmediate/#si-clearImmediate
$ef48c8e0540d6569$exports({
    global: true,
    bind: true,
    enumerable: true,
    forced: $212fa519f4bef41a$exports.clearImmediate !== $0e5b06bc91576124$require$clearImmediate
}, {
    clearImmediate: $0e5b06bc91576124$require$clearImmediate
});


"use strict";



var $d240dc305eba2d25$require$setTask = $660f9a894434a192$exports.set;
var $d683bc11625481d7$exports = {};
"use strict";



var $180a67b79bfa3572$exports = {};
"use strict";
/* global Bun -- Bun case */ $180a67b79bfa3572$exports = typeof Bun == "function" && Bun && typeof Bun.version == "string";





var $d683bc11625481d7$var$Function = $212fa519f4bef41a$exports.Function;
// dirty IE9- and Bun 0.3.0- checks
var $d683bc11625481d7$var$WRAP = /MSIE .\./.test($10e5337eedcfb10c$exports) || $180a67b79bfa3572$exports && function() {
    var version = $212fa519f4bef41a$exports.Bun.version.split(".");
    return version.length < 3 || version[0] === "0" && (version[1] < 3 || version[1] === "3" && version[2] === "0");
}();
// IE9- / Bun 0.3.0- setTimeout / setInterval / setImmediate additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#timers
// https://github.com/oven-sh/bun/issues/1633
$d683bc11625481d7$exports = function(scheduler, hasTimeArg) {
    var firstParamIndex = hasTimeArg ? 2 : 1;
    return $d683bc11625481d7$var$WRAP ? function(handler, timeout /* , ...arguments */ ) {
        var boundArgs = $44813c6cb2f7b76c$exports(arguments.length, 1) > firstParamIndex;
        var fn = $73d1a34d94fa4c35$exports(handler) ? handler : $d683bc11625481d7$var$Function(handler);
        var params = boundArgs ? $a1fdbc3bb6749f54$exports(arguments, firstParamIndex) : [];
        var callback = boundArgs ? function() {
            $9cb3247174ca8cfd$exports(fn, this, params);
        } : fn;
        return hasTimeArg ? scheduler(callback, timeout) : scheduler(callback);
    } : scheduler;
};


// https://github.com/oven-sh/bun/issues/1633
var $d240dc305eba2d25$var$setImmediate = $212fa519f4bef41a$exports.setImmediate ? $d683bc11625481d7$exports($d240dc305eba2d25$require$setTask, false) : $d240dc305eba2d25$require$setTask;
// `setImmediate` method
// http://w3c.github.io/setImmediate/#si-setImmediate
$ef48c8e0540d6569$exports({
    global: true,
    bind: true,
    enumerable: true,
    forced: $212fa519f4bef41a$exports.setImmediate !== $d240dc305eba2d25$var$setImmediate
}, {
    setImmediate: $d240dc305eba2d25$var$setImmediate
});




"use strict";






var $479acebb23a4a2e3$var$process = $212fa519f4bef41a$exports.process;
// `queueMicrotask` method
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-queuemicrotask
$ef48c8e0540d6569$exports({
    global: true,
    enumerable: true,
    dontCallGetSet: true
}, {
    queueMicrotask: function queueMicrotask(fn) {
        $44813c6cb2f7b76c$exports(arguments.length, 1);
        $6df447ad4be37421$exports(fn);
        var domain = $9002d9a40e113f56$exports && $479acebb23a4a2e3$var$process.domain;
        $4174e122d6b4eb8a$exports(domain ? domain.bind(fn) : fn);
    }
});


"use strict";
"use strict";
"use strict";

var $50de05d0a5173455$require$charAt = $f270186c84f50a15$exports.charAt;




var $50de05d0a5173455$var$STRING_ITERATOR = "String Iterator";
var $50de05d0a5173455$var$setInternalState = $954a2ea894ec1c9c$exports.set;
var $50de05d0a5173455$var$getInternalState = $954a2ea894ec1c9c$exports.getterFor($50de05d0a5173455$var$STRING_ITERATOR);
// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
$c94c3df4a788abf5$exports(String, "String", function(iterated) {
    $50de05d0a5173455$var$setInternalState(this, {
        type: $50de05d0a5173455$var$STRING_ITERATOR,
        string: $5eca6f9e01902ab4$exports(iterated),
        index: 0
    });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
    var state = $50de05d0a5173455$var$getInternalState(this);
    var string = state.string;
    var index = state.index;
    var point;
    if (index >= string.length) return $783af5147689a0b0$exports(undefined, true);
    point = $50de05d0a5173455$require$charAt(string, index);
    state.index += point.length;
    return $783af5147689a0b0$exports(point, false);
});




var $470e62d1132fcedf$exports = {};
"use strict";




var $470e62d1132fcedf$var$ITERATOR = $bbf4e852bf6421ea$exports("iterator");
$470e62d1132fcedf$exports = !$217c917c4f59b359$exports(function() {
    // eslint-disable-next-line unicorn/relative-url-style -- required for testing
    var url = new URL("b?a=1&b=2&c=3", "http://a");
    var params = url.searchParams;
    var params2 = new URLSearchParams("a=1&a=2&b=3");
    var result = "";
    url.pathname = "c%20d";
    params.forEach(function(value, key) {
        params["delete"]("b");
        result += key + value;
    });
    params2["delete"]("a", 2);
    // `undefined` case is a Chromium 117 bug
    // https://bugs.chromium.org/p/v8/issues/detail?id=14222
    params2["delete"]("b", undefined);
    return $036c29a074575bd6$exports && (!url.toJSON || !params2.has("a", 1) || params2.has("a", 2) || !params2.has("a", undefined) || params2.has("b")) || !params.size && ($036c29a074575bd6$exports || !$16b43a02da62cc11$exports) || !params.sort || url.href !== "http://a/c%20d?a=1&c=3" || params.get("c") !== "3" || String(new URLSearchParams("?a=1")) !== "a=1" || !params[$470e62d1132fcedf$var$ITERATOR] || new URL("https://a@b").username !== "a" || new URLSearchParams(new URLSearchParams("a=b")).get("a") !== "b" || new URL("http://тест").host !== "xn--e1aybc" || new URL("http://a#б").hash !== "#%D0%B1" || result !== "a1c3" || new URL("http://x", undefined).host !== "x";
});










var $448935b1ecdf1016$exports = {};
"use strict";



var $c55517fda3f18763$exports = {};
"use strict";


// call something on iterator step with safe closing on error
$c55517fda3f18763$exports = function(iterator, fn, value, ENTRIES) {
    try {
        return ENTRIES ? fn($affc609f2393bdba$exports(value)[0], value[1]) : fn(value);
    } catch (error) {
        $5433b3170981ac13$exports(iterator, "throw", error);
    }
};








var $448935b1ecdf1016$var$$Array = Array;
// `Array.from` method implementation
// https://tc39.es/ecma262/#sec-array.from
$448935b1ecdf1016$exports = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */ ) {
    var O = $361c03d23168e423$exports(arrayLike);
    var IS_CONSTRUCTOR = $f9bc962f91baa4bd$exports(this);
    var argumentsLength = arguments.length;
    var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    if (mapping) mapfn = $2db6a9f70c481925$exports(mapfn, argumentsLength > 2 ? arguments[2] : undefined);
    var iteratorMethod = $11873dac339e5ad0$exports(O);
    var index = 0;
    var length, result, step, iterator, next, value;
    // if the target is not iterable or it's an array with the default iterator - use a simple case
    if (iteratorMethod && !(this === $448935b1ecdf1016$var$$Array && $0c7638bc83d11df5$exports(iteratorMethod))) {
        iterator = $89f16bd42f655d35$exports(O, iteratorMethod);
        next = iterator.next;
        result = IS_CONSTRUCTOR ? new this() : [];
        for(; !(step = $2f17e9746e5fde89$exports(next, iterator)).done; index++){
            value = mapping ? $c55517fda3f18763$exports(iterator, mapfn, [
                step.value,
                index
            ], true) : step.value;
            $ec6a13a4c4f7948e$exports(result, index, value);
        }
    } else {
        length = $3f18e45666a111c8$exports(O);
        result = IS_CONSTRUCTOR ? new this(length) : $448935b1ecdf1016$var$$Array(length);
        for(; length > index; index++){
            value = mapping ? mapfn(O[index], index) : O[index];
            $ec6a13a4c4f7948e$exports(result, index, value);
        }
    }
    result.length = index;
    return result;
};




var $64709efe73953b38$require$codeAt = $f270186c84f50a15$exports.codeAt;
var $155c186061e8fe42$exports = {};
"use strict";

var $155c186061e8fe42$var$maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
var $155c186061e8fe42$var$base = 36;
var $155c186061e8fe42$var$tMin = 1;
var $155c186061e8fe42$var$tMax = 26;
var $155c186061e8fe42$var$skew = 38;
var $155c186061e8fe42$var$damp = 700;
var $155c186061e8fe42$var$initialBias = 72;
var $155c186061e8fe42$var$initialN = 128; // 0x80
var $155c186061e8fe42$var$delimiter = "-"; // '\x2D'
var $155c186061e8fe42$var$regexNonASCII = /[^\0-\u007E]/; // non-ASCII chars
var $155c186061e8fe42$var$regexSeparators = /[.\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
var $155c186061e8fe42$var$OVERFLOW_ERROR = "Overflow: input needs wider integers to process";
var $155c186061e8fe42$var$baseMinusTMin = $155c186061e8fe42$var$base - $155c186061e8fe42$var$tMin;
var $155c186061e8fe42$var$$RangeError = RangeError;
var $155c186061e8fe42$var$exec = $c201050ed73b14ba$exports($155c186061e8fe42$var$regexSeparators.exec);
var $155c186061e8fe42$var$floor = Math.floor;
var $155c186061e8fe42$var$fromCharCode = String.fromCharCode;
var $155c186061e8fe42$var$charCodeAt = $c201050ed73b14ba$exports("".charCodeAt);
var $155c186061e8fe42$var$join = $c201050ed73b14ba$exports([].join);
var $155c186061e8fe42$var$push = $c201050ed73b14ba$exports([].push);
var $155c186061e8fe42$var$replace = $c201050ed73b14ba$exports("".replace);
var $155c186061e8fe42$var$split = $c201050ed73b14ba$exports("".split);
var $155c186061e8fe42$var$toLowerCase = $c201050ed73b14ba$exports("".toLowerCase);
/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 */ var $155c186061e8fe42$var$ucs2decode = function(string) {
    var output = [];
    var counter = 0;
    var length = string.length;
    while(counter < length){
        var value = $155c186061e8fe42$var$charCodeAt(string, counter++);
        if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
            // It's a high surrogate, and there is a next character.
            var extra = $155c186061e8fe42$var$charCodeAt(string, counter++);
            if ((extra & 0xFC00) === 0xDC00) $155c186061e8fe42$var$push(output, ((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
            else {
                // It's an unmatched surrogate; only append this code unit, in case the
                // next code unit is the high surrogate of a surrogate pair.
                $155c186061e8fe42$var$push(output, value);
                counter--;
            }
        } else $155c186061e8fe42$var$push(output, value);
    }
    return output;
};
/**
 * Converts a digit/integer into a basic code point.
 */ var $155c186061e8fe42$var$digitToBasic = function(digit) {
    //  0..25 map to ASCII a..z or A..Z
    // 26..35 map to ASCII 0..9
    return digit + 22 + 75 * (digit < 26);
};
/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 */ var $155c186061e8fe42$var$adapt = function(delta, numPoints, firstTime) {
    var k = 0;
    delta = firstTime ? $155c186061e8fe42$var$floor(delta / $155c186061e8fe42$var$damp) : delta >> 1;
    delta += $155c186061e8fe42$var$floor(delta / numPoints);
    while(delta > $155c186061e8fe42$var$baseMinusTMin * $155c186061e8fe42$var$tMax >> 1){
        delta = $155c186061e8fe42$var$floor(delta / $155c186061e8fe42$var$baseMinusTMin);
        k += $155c186061e8fe42$var$base;
    }
    return $155c186061e8fe42$var$floor(k + ($155c186061e8fe42$var$baseMinusTMin + 1) * delta / (delta + $155c186061e8fe42$var$skew));
};
/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 */ var $155c186061e8fe42$var$encode = function(input) {
    var output = [];
    // Convert the input in UCS-2 to an array of Unicode code points.
    input = $155c186061e8fe42$var$ucs2decode(input);
    // Cache the length.
    var inputLength = input.length;
    // Initialize the state.
    var n = $155c186061e8fe42$var$initialN;
    var delta = 0;
    var bias = $155c186061e8fe42$var$initialBias;
    var i, currentValue;
    // Handle the basic code points.
    for(i = 0; i < input.length; i++){
        currentValue = input[i];
        if (currentValue < 0x80) $155c186061e8fe42$var$push(output, $155c186061e8fe42$var$fromCharCode(currentValue));
    }
    var basicLength = output.length; // number of basic code points.
    var handledCPCount = basicLength; // number of code points that have been handled;
    // Finish the basic string with a delimiter unless it's empty.
    if (basicLength) $155c186061e8fe42$var$push(output, $155c186061e8fe42$var$delimiter);
    // Main encoding loop:
    while(handledCPCount < inputLength){
        // All non-basic code points < n have been handled already. Find the next larger one:
        var m = $155c186061e8fe42$var$maxInt;
        for(i = 0; i < input.length; i++){
            currentValue = input[i];
            if (currentValue >= n && currentValue < m) m = currentValue;
        }
        // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>, but guard against overflow.
        var handledCPCountPlusOne = handledCPCount + 1;
        if (m - n > $155c186061e8fe42$var$floor(($155c186061e8fe42$var$maxInt - delta) / handledCPCountPlusOne)) throw new $155c186061e8fe42$var$$RangeError($155c186061e8fe42$var$OVERFLOW_ERROR);
        delta += (m - n) * handledCPCountPlusOne;
        n = m;
        for(i = 0; i < input.length; i++){
            currentValue = input[i];
            if (currentValue < n && ++delta > $155c186061e8fe42$var$maxInt) throw new $155c186061e8fe42$var$$RangeError($155c186061e8fe42$var$OVERFLOW_ERROR);
            if (currentValue === n) {
                // Represent delta as a generalized variable-length integer.
                var q = delta;
                var k = $155c186061e8fe42$var$base;
                while(true){
                    var t = k <= bias ? $155c186061e8fe42$var$tMin : k >= bias + $155c186061e8fe42$var$tMax ? $155c186061e8fe42$var$tMax : k - bias;
                    if (q < t) break;
                    var qMinusT = q - t;
                    var baseMinusT = $155c186061e8fe42$var$base - t;
                    $155c186061e8fe42$var$push(output, $155c186061e8fe42$var$fromCharCode($155c186061e8fe42$var$digitToBasic(t + qMinusT % baseMinusT)));
                    q = $155c186061e8fe42$var$floor(qMinusT / baseMinusT);
                    k += $155c186061e8fe42$var$base;
                }
                $155c186061e8fe42$var$push(output, $155c186061e8fe42$var$fromCharCode($155c186061e8fe42$var$digitToBasic(q)));
                bias = $155c186061e8fe42$var$adapt(delta, handledCPCountPlusOne, handledCPCount === basicLength);
                delta = 0;
                handledCPCount++;
            }
        }
        delta++;
        n++;
    }
    return $155c186061e8fe42$var$join(output, "");
};
$155c186061e8fe42$exports = function(input) {
    var encoded = [];
    var labels = $155c186061e8fe42$var$split($155c186061e8fe42$var$replace($155c186061e8fe42$var$toLowerCase(input), $155c186061e8fe42$var$regexSeparators, "."), ".");
    var i, label;
    for(i = 0; i < labels.length; i++){
        label = labels[i];
        $155c186061e8fe42$var$push(encoded, $155c186061e8fe42$var$exec($155c186061e8fe42$var$regexNonASCII, label) ? "xn--" + $155c186061e8fe42$var$encode(label) : label);
    }
    return $155c186061e8fe42$var$join(encoded, ".");
};





var $3e2b964881188d3c$exports = {};
"use strict";





























var $3e2b964881188d3c$var$ITERATOR = $bbf4e852bf6421ea$exports("iterator");
var $3e2b964881188d3c$var$URL_SEARCH_PARAMS = "URLSearchParams";
var $3e2b964881188d3c$var$URL_SEARCH_PARAMS_ITERATOR = $3e2b964881188d3c$var$URL_SEARCH_PARAMS + "Iterator";
var $3e2b964881188d3c$var$setInternalState = $954a2ea894ec1c9c$exports.set;
var $3e2b964881188d3c$var$getInternalParamsState = $954a2ea894ec1c9c$exports.getterFor($3e2b964881188d3c$var$URL_SEARCH_PARAMS);
var $3e2b964881188d3c$var$getInternalIteratorState = $954a2ea894ec1c9c$exports.getterFor($3e2b964881188d3c$var$URL_SEARCH_PARAMS_ITERATOR);
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $3e2b964881188d3c$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Avoid NodeJS experimental warning
var $3e2b964881188d3c$var$safeGetBuiltIn = function(name) {
    if (!$16b43a02da62cc11$exports) return $212fa519f4bef41a$exports[name];
    var descriptor = $3e2b964881188d3c$var$getOwnPropertyDescriptor($212fa519f4bef41a$exports, name);
    return descriptor && descriptor.value;
};
var $3e2b964881188d3c$var$nativeFetch = $3e2b964881188d3c$var$safeGetBuiltIn("fetch");
var $3e2b964881188d3c$var$NativeRequest = $3e2b964881188d3c$var$safeGetBuiltIn("Request");
var $3e2b964881188d3c$var$Headers = $3e2b964881188d3c$var$safeGetBuiltIn("Headers");
var $3e2b964881188d3c$var$RequestPrototype = $3e2b964881188d3c$var$NativeRequest && $3e2b964881188d3c$var$NativeRequest.prototype;
var $3e2b964881188d3c$var$HeadersPrototype = $3e2b964881188d3c$var$Headers && $3e2b964881188d3c$var$Headers.prototype;
var $3e2b964881188d3c$var$RegExp = $212fa519f4bef41a$exports.RegExp;
var $3e2b964881188d3c$var$TypeError = $212fa519f4bef41a$exports.TypeError;
var $3e2b964881188d3c$var$decodeURIComponent = $212fa519f4bef41a$exports.decodeURIComponent;
var $3e2b964881188d3c$var$encodeURIComponent = $212fa519f4bef41a$exports.encodeURIComponent;
var $3e2b964881188d3c$var$charAt = $c201050ed73b14ba$exports("".charAt);
var $3e2b964881188d3c$var$join = $c201050ed73b14ba$exports([].join);
var $3e2b964881188d3c$var$push = $c201050ed73b14ba$exports([].push);
var $3e2b964881188d3c$var$replace = $c201050ed73b14ba$exports("".replace);
var $3e2b964881188d3c$var$shift = $c201050ed73b14ba$exports([].shift);
var $3e2b964881188d3c$var$splice = $c201050ed73b14ba$exports([].splice);
var $3e2b964881188d3c$var$split = $c201050ed73b14ba$exports("".split);
var $3e2b964881188d3c$var$stringSlice = $c201050ed73b14ba$exports("".slice);
var $3e2b964881188d3c$var$plus = /\+/g;
var $3e2b964881188d3c$var$sequences = Array(4);
var $3e2b964881188d3c$var$percentSequence = function(bytes) {
    return $3e2b964881188d3c$var$sequences[bytes - 1] || ($3e2b964881188d3c$var$sequences[bytes - 1] = $3e2b964881188d3c$var$RegExp("((?:%[\\da-f]{2}){" + bytes + "})", "gi"));
};
var $3e2b964881188d3c$var$percentDecode = function(sequence) {
    try {
        return $3e2b964881188d3c$var$decodeURIComponent(sequence);
    } catch (error) {
        return sequence;
    }
};
var $3e2b964881188d3c$var$deserialize = function(it) {
    var result = $3e2b964881188d3c$var$replace(it, $3e2b964881188d3c$var$plus, " ");
    var bytes = 4;
    try {
        return $3e2b964881188d3c$var$decodeURIComponent(result);
    } catch (error) {
        while(bytes)result = $3e2b964881188d3c$var$replace(result, $3e2b964881188d3c$var$percentSequence(bytes--), $3e2b964881188d3c$var$percentDecode);
        return result;
    }
};
var $3e2b964881188d3c$var$find = /[!'()~]|%20/g;
var $3e2b964881188d3c$var$replacements = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+"
};
var $3e2b964881188d3c$var$replacer = function(match) {
    return $3e2b964881188d3c$var$replacements[match];
};
var $3e2b964881188d3c$var$serialize = function(it) {
    return $3e2b964881188d3c$var$replace($3e2b964881188d3c$var$encodeURIComponent(it), $3e2b964881188d3c$var$find, $3e2b964881188d3c$var$replacer);
};
var $3e2b964881188d3c$var$URLSearchParamsIterator = $8159770b7a97268e$exports(function Iterator(params, kind) {
    $3e2b964881188d3c$var$setInternalState(this, {
        type: $3e2b964881188d3c$var$URL_SEARCH_PARAMS_ITERATOR,
        target: $3e2b964881188d3c$var$getInternalParamsState(params).entries,
        index: 0,
        kind: kind
    });
}, $3e2b964881188d3c$var$URL_SEARCH_PARAMS, function next() {
    var state = $3e2b964881188d3c$var$getInternalIteratorState(this);
    var target = state.target;
    var index = state.index++;
    if (!target || index >= target.length) {
        state.target = undefined;
        return $783af5147689a0b0$exports(undefined, true);
    }
    var entry = target[index];
    switch(state.kind){
        case "keys":
            return $783af5147689a0b0$exports(entry.key, false);
        case "values":
            return $783af5147689a0b0$exports(entry.value, false);
    }
    return $783af5147689a0b0$exports([
        entry.key,
        entry.value
    ], false);
}, true);
var $3e2b964881188d3c$var$URLSearchParamsState = function(init) {
    this.entries = [];
    this.url = null;
    if (init !== undefined) {
        if ($06f10e9b9cb1418c$exports(init)) this.parseObject(init);
        else this.parseQuery(typeof init == "string" ? $3e2b964881188d3c$var$charAt(init, 0) === "?" ? $3e2b964881188d3c$var$stringSlice(init, 1) : init : $5eca6f9e01902ab4$exports(init));
    }
};
$3e2b964881188d3c$var$URLSearchParamsState.prototype = {
    type: $3e2b964881188d3c$var$URL_SEARCH_PARAMS,
    bindURL: function(url) {
        this.url = url;
        this.update();
    },
    parseObject: function(object) {
        var entries = this.entries;
        var iteratorMethod = $11873dac339e5ad0$exports(object);
        var iterator, next, step, entryIterator, entryNext, first, second;
        if (iteratorMethod) {
            iterator = $89f16bd42f655d35$exports(object, iteratorMethod);
            next = iterator.next;
            while(!(step = $2f17e9746e5fde89$exports(next, iterator)).done){
                entryIterator = $89f16bd42f655d35$exports($affc609f2393bdba$exports(step.value));
                entryNext = entryIterator.next;
                if ((first = $2f17e9746e5fde89$exports(entryNext, entryIterator)).done || (second = $2f17e9746e5fde89$exports(entryNext, entryIterator)).done || !$2f17e9746e5fde89$exports(entryNext, entryIterator).done) throw new $3e2b964881188d3c$var$TypeError("Expected sequence with length 2");
                $3e2b964881188d3c$var$push(entries, {
                    key: $5eca6f9e01902ab4$exports(first.value),
                    value: $5eca6f9e01902ab4$exports(second.value)
                });
            }
        } else for(var key in object)if ($1ad0c60d8de14c83$exports(object, key)) $3e2b964881188d3c$var$push(entries, {
            key: key,
            value: $5eca6f9e01902ab4$exports(object[key])
        });
    },
    parseQuery: function(query) {
        if (query) {
            var entries = this.entries;
            var attributes = $3e2b964881188d3c$var$split(query, "&");
            var index = 0;
            var attribute, entry;
            while(index < attributes.length){
                attribute = attributes[index++];
                if (attribute.length) {
                    entry = $3e2b964881188d3c$var$split(attribute, "=");
                    $3e2b964881188d3c$var$push(entries, {
                        key: $3e2b964881188d3c$var$deserialize($3e2b964881188d3c$var$shift(entry)),
                        value: $3e2b964881188d3c$var$deserialize($3e2b964881188d3c$var$join(entry, "="))
                    });
                }
            }
        }
    },
    serialize: function() {
        var entries = this.entries;
        var result = [];
        var index = 0;
        var entry;
        while(index < entries.length){
            entry = entries[index++];
            $3e2b964881188d3c$var$push(result, $3e2b964881188d3c$var$serialize(entry.key) + "=" + $3e2b964881188d3c$var$serialize(entry.value));
        }
        return $3e2b964881188d3c$var$join(result, "&");
    },
    update: function() {
        this.entries.length = 0;
        this.parseQuery(this.url.query);
    },
    updateURL: function() {
        if (this.url) this.url.update();
    }
};
// `URLSearchParams` constructor
// https://url.spec.whatwg.org/#interface-urlsearchparams
var $3e2b964881188d3c$var$URLSearchParamsConstructor = function URLSearchParams() {
    $efe207f3fce362b0$exports(this, $3e2b964881188d3c$var$URLSearchParamsPrototype);
    var init = arguments.length > 0 ? arguments[0] : undefined;
    var state = $3e2b964881188d3c$var$setInternalState(this, new $3e2b964881188d3c$var$URLSearchParamsState(init));
    if (!$16b43a02da62cc11$exports) this.size = state.entries.length;
};
var $3e2b964881188d3c$var$URLSearchParamsPrototype = $3e2b964881188d3c$var$URLSearchParamsConstructor.prototype;
$ab8ebf21191217ba$exports($3e2b964881188d3c$var$URLSearchParamsPrototype, {
    // `URLSearchParams.prototype.append` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-append
    append: function append(name, value) {
        var state = $3e2b964881188d3c$var$getInternalParamsState(this);
        $44813c6cb2f7b76c$exports(arguments.length, 2);
        $3e2b964881188d3c$var$push(state.entries, {
            key: $5eca6f9e01902ab4$exports(name),
            value: $5eca6f9e01902ab4$exports(value)
        });
        if (!$16b43a02da62cc11$exports) this.length++;
        state.updateURL();
    },
    // `URLSearchParams.prototype.delete` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-delete
    "delete": function(name /* , value */ ) {
        var state = $3e2b964881188d3c$var$getInternalParamsState(this);
        var length = $44813c6cb2f7b76c$exports(arguments.length, 1);
        var entries = state.entries;
        var key = $5eca6f9e01902ab4$exports(name);
        var $value = length < 2 ? undefined : arguments[1];
        var value = $value === undefined ? $value : $5eca6f9e01902ab4$exports($value);
        var index = 0;
        while(index < entries.length){
            var entry = entries[index];
            if (entry.key === key && (value === undefined || entry.value === value)) {
                $3e2b964881188d3c$var$splice(entries, index, 1);
                if (value !== undefined) break;
            } else index++;
        }
        if (!$16b43a02da62cc11$exports) this.size = entries.length;
        state.updateURL();
    },
    // `URLSearchParams.prototype.get` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-get
    get: function get(name) {
        var entries = $3e2b964881188d3c$var$getInternalParamsState(this).entries;
        $44813c6cb2f7b76c$exports(arguments.length, 1);
        var key = $5eca6f9e01902ab4$exports(name);
        var index = 0;
        for(; index < entries.length; index++){
            if (entries[index].key === key) return entries[index].value;
        }
        return null;
    },
    // `URLSearchParams.prototype.getAll` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-getall
    getAll: function getAll(name) {
        var entries = $3e2b964881188d3c$var$getInternalParamsState(this).entries;
        $44813c6cb2f7b76c$exports(arguments.length, 1);
        var key = $5eca6f9e01902ab4$exports(name);
        var result = [];
        var index = 0;
        for(; index < entries.length; index++)if (entries[index].key === key) $3e2b964881188d3c$var$push(result, entries[index].value);
        return result;
    },
    // `URLSearchParams.prototype.has` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-has
    has: function has(name /* , value */ ) {
        var entries = $3e2b964881188d3c$var$getInternalParamsState(this).entries;
        var length = $44813c6cb2f7b76c$exports(arguments.length, 1);
        var key = $5eca6f9e01902ab4$exports(name);
        var $value = length < 2 ? undefined : arguments[1];
        var value = $value === undefined ? $value : $5eca6f9e01902ab4$exports($value);
        var index = 0;
        while(index < entries.length){
            var entry = entries[index++];
            if (entry.key === key && (value === undefined || entry.value === value)) return true;
        }
        return false;
    },
    // `URLSearchParams.prototype.set` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-set
    set: function set(name, value) {
        var state = $3e2b964881188d3c$var$getInternalParamsState(this);
        $44813c6cb2f7b76c$exports(arguments.length, 1);
        var entries = state.entries;
        var found = false;
        var key = $5eca6f9e01902ab4$exports(name);
        var val = $5eca6f9e01902ab4$exports(value);
        var index = 0;
        var entry;
        for(; index < entries.length; index++){
            entry = entries[index];
            if (entry.key === key) {
                if (found) $3e2b964881188d3c$var$splice(entries, index--, 1);
                else {
                    found = true;
                    entry.value = val;
                }
            }
        }
        if (!found) $3e2b964881188d3c$var$push(entries, {
            key: key,
            value: val
        });
        if (!$16b43a02da62cc11$exports) this.size = entries.length;
        state.updateURL();
    },
    // `URLSearchParams.prototype.sort` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-sort
    sort: function sort() {
        var state = $3e2b964881188d3c$var$getInternalParamsState(this);
        $555a1841cf570867$exports(state.entries, function(a, b) {
            return a.key > b.key ? 1 : -1;
        });
        state.updateURL();
    },
    // `URLSearchParams.prototype.forEach` method
    forEach: function forEach(callback /* , thisArg */ ) {
        var entries = $3e2b964881188d3c$var$getInternalParamsState(this).entries;
        var boundFunction = $2db6a9f70c481925$exports(callback, arguments.length > 1 ? arguments[1] : undefined);
        var index = 0;
        var entry;
        while(index < entries.length){
            entry = entries[index++];
            boundFunction(entry.value, entry.key, this);
        }
    },
    // `URLSearchParams.prototype.keys` method
    keys: function keys() {
        return new $3e2b964881188d3c$var$URLSearchParamsIterator(this, "keys");
    },
    // `URLSearchParams.prototype.values` method
    values: function values() {
        return new $3e2b964881188d3c$var$URLSearchParamsIterator(this, "values");
    },
    // `URLSearchParams.prototype.entries` method
    entries: function entries() {
        return new $3e2b964881188d3c$var$URLSearchParamsIterator(this, "entries");
    }
}, {
    enumerable: true
});
// `URLSearchParams.prototype[@@iterator]` method
$5cabf6b3204ed174$exports($3e2b964881188d3c$var$URLSearchParamsPrototype, $3e2b964881188d3c$var$ITERATOR, $3e2b964881188d3c$var$URLSearchParamsPrototype.entries, {
    name: "entries"
});
// `URLSearchParams.prototype.toString` method
// https://url.spec.whatwg.org/#urlsearchparams-stringification-behavior
$5cabf6b3204ed174$exports($3e2b964881188d3c$var$URLSearchParamsPrototype, "toString", function toString() {
    return $3e2b964881188d3c$var$getInternalParamsState(this).serialize();
}, {
    enumerable: true
});
// `URLSearchParams.prototype.size` getter
// https://github.com/whatwg/url/pull/734
if ($16b43a02da62cc11$exports) $4dba431ca752b815$exports($3e2b964881188d3c$var$URLSearchParamsPrototype, "size", {
    get: function size() {
        return $3e2b964881188d3c$var$getInternalParamsState(this).entries.length;
    },
    configurable: true,
    enumerable: true
});
$036072e21338276e$exports($3e2b964881188d3c$var$URLSearchParamsConstructor, $3e2b964881188d3c$var$URL_SEARCH_PARAMS);
$ef48c8e0540d6569$exports({
    global: true,
    constructor: true,
    forced: !$470e62d1132fcedf$exports
}, {
    URLSearchParams: $3e2b964881188d3c$var$URLSearchParamsConstructor
});
// Wrap `fetch` and `Request` for correct work with polyfilled `URLSearchParams`
if (!$470e62d1132fcedf$exports && $73d1a34d94fa4c35$exports($3e2b964881188d3c$var$Headers)) {
    var $3e2b964881188d3c$var$headersHas = $c201050ed73b14ba$exports($3e2b964881188d3c$var$HeadersPrototype.has);
    var $3e2b964881188d3c$var$headersSet = $c201050ed73b14ba$exports($3e2b964881188d3c$var$HeadersPrototype.set);
    var $3e2b964881188d3c$var$wrapRequestOptions = function(init) {
        if ($06f10e9b9cb1418c$exports(init)) {
            var body = init.body;
            var headers;
            if ($7d156d7c862bc268$exports(body) === $3e2b964881188d3c$var$URL_SEARCH_PARAMS) {
                headers = init.headers ? new $3e2b964881188d3c$var$Headers(init.headers) : new $3e2b964881188d3c$var$Headers();
                if (!$3e2b964881188d3c$var$headersHas(headers, "content-type")) $3e2b964881188d3c$var$headersSet(headers, "content-type", "application/x-www-form-urlencoded;charset=UTF-8");
                return $a98baaf21fc755e7$exports(init, {
                    body: $819ae5875a6bb120$exports(0, $5eca6f9e01902ab4$exports(body)),
                    headers: $819ae5875a6bb120$exports(0, headers)
                });
            }
        }
        return init;
    };
    if ($73d1a34d94fa4c35$exports($3e2b964881188d3c$var$nativeFetch)) $ef48c8e0540d6569$exports({
        global: true,
        enumerable: true,
        dontCallGetSet: true,
        forced: true
    }, {
        fetch: function fetch(input /* , init */ ) {
            return $3e2b964881188d3c$var$nativeFetch(input, arguments.length > 1 ? $3e2b964881188d3c$var$wrapRequestOptions(arguments[1]) : {});
        }
    });
    if ($73d1a34d94fa4c35$exports($3e2b964881188d3c$var$NativeRequest)) {
        var $3e2b964881188d3c$var$RequestConstructor = function Request(input /* , init */ ) {
            $efe207f3fce362b0$exports(this, $3e2b964881188d3c$var$RequestPrototype);
            return new $3e2b964881188d3c$var$NativeRequest(input, arguments.length > 1 ? $3e2b964881188d3c$var$wrapRequestOptions(arguments[1]) : {});
        };
        $3e2b964881188d3c$var$RequestPrototype.constructor = $3e2b964881188d3c$var$RequestConstructor;
        $3e2b964881188d3c$var$RequestConstructor.prototype = $3e2b964881188d3c$var$RequestPrototype;
        $ef48c8e0540d6569$exports({
            global: true,
            constructor: true,
            dontCallGetSet: true,
            forced: true
        }, {
            Request: $3e2b964881188d3c$var$RequestConstructor
        });
    }
}
$3e2b964881188d3c$exports = {
    URLSearchParams: $3e2b964881188d3c$var$URLSearchParamsConstructor,
    getState: $3e2b964881188d3c$var$getInternalParamsState
};



var $64709efe73953b38$var$setInternalState = $954a2ea894ec1c9c$exports.set;
var $64709efe73953b38$var$getInternalURLState = $954a2ea894ec1c9c$exports.getterFor("URL");
var $64709efe73953b38$var$URLSearchParams = $3e2b964881188d3c$exports.URLSearchParams;
var $64709efe73953b38$var$getInternalSearchParamsState = $3e2b964881188d3c$exports.getState;
var $64709efe73953b38$var$NativeURL = $212fa519f4bef41a$exports.URL;
var $64709efe73953b38$var$TypeError = $212fa519f4bef41a$exports.TypeError;
var $64709efe73953b38$var$parseInt = $212fa519f4bef41a$exports.parseInt;
var $64709efe73953b38$var$floor = Math.floor;
var $64709efe73953b38$var$pow = Math.pow;
var $64709efe73953b38$var$charAt = $c201050ed73b14ba$exports("".charAt);
var $64709efe73953b38$var$exec = $c201050ed73b14ba$exports(/./.exec);
var $64709efe73953b38$var$join = $c201050ed73b14ba$exports([].join);
var $64709efe73953b38$var$numberToString = $c201050ed73b14ba$exports(1.0.toString);
var $64709efe73953b38$var$pop = $c201050ed73b14ba$exports([].pop);
var $64709efe73953b38$var$push = $c201050ed73b14ba$exports([].push);
var $64709efe73953b38$var$replace = $c201050ed73b14ba$exports("".replace);
var $64709efe73953b38$var$shift = $c201050ed73b14ba$exports([].shift);
var $64709efe73953b38$var$split = $c201050ed73b14ba$exports("".split);
var $64709efe73953b38$var$stringSlice = $c201050ed73b14ba$exports("".slice);
var $64709efe73953b38$var$toLowerCase = $c201050ed73b14ba$exports("".toLowerCase);
var $64709efe73953b38$var$unshift = $c201050ed73b14ba$exports([].unshift);
var $64709efe73953b38$var$INVALID_AUTHORITY = "Invalid authority";
var $64709efe73953b38$var$INVALID_SCHEME = "Invalid scheme";
var $64709efe73953b38$var$INVALID_HOST = "Invalid host";
var $64709efe73953b38$var$INVALID_PORT = "Invalid port";
var $64709efe73953b38$var$ALPHA = /[a-z]/i;
// eslint-disable-next-line regexp/no-obscure-range -- safe
var $64709efe73953b38$var$ALPHANUMERIC = /[\d+-.a-z]/i;
var $64709efe73953b38$var$DIGIT = /\d/;
var $64709efe73953b38$var$HEX_START = /^0x/i;
var $64709efe73953b38$var$OCT = /^[0-7]+$/;
var $64709efe73953b38$var$DEC = /^\d+$/;
var $64709efe73953b38$var$HEX = /^[\da-f]+$/i;
/* eslint-disable regexp/no-control-character -- safe */ var $64709efe73953b38$var$FORBIDDEN_HOST_CODE_POINT = /[\0\t\n\r #%/:<>?@[\\\]^|]/;
var $64709efe73953b38$var$FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT = /[\0\t\n\r #/:<>?@[\\\]^|]/;
var $64709efe73953b38$var$LEADING_C0_CONTROL_OR_SPACE = /^[\u0000-\u0020]+/;
var $64709efe73953b38$var$TRAILING_C0_CONTROL_OR_SPACE = /(^|[^\u0000-\u0020])[\u0000-\u0020]+$/;
var $64709efe73953b38$var$TAB_AND_NEW_LINE = /[\t\n\r]/g;
/* eslint-enable regexp/no-control-character -- safe */ var $64709efe73953b38$var$EOF;
// https://url.spec.whatwg.org/#ipv4-number-parser
var $64709efe73953b38$var$parseIPv4 = function(input) {
    var parts = $64709efe73953b38$var$split(input, ".");
    var partsLength, numbers, index, part, radix, number, ipv4;
    if (parts.length && parts[parts.length - 1] === "") parts.length--;
    partsLength = parts.length;
    if (partsLength > 4) return input;
    numbers = [];
    for(index = 0; index < partsLength; index++){
        part = parts[index];
        if (part === "") return input;
        radix = 10;
        if (part.length > 1 && $64709efe73953b38$var$charAt(part, 0) === "0") {
            radix = $64709efe73953b38$var$exec($64709efe73953b38$var$HEX_START, part) ? 16 : 8;
            part = $64709efe73953b38$var$stringSlice(part, radix === 8 ? 1 : 2);
        }
        if (part === "") number = 0;
        else {
            if (!$64709efe73953b38$var$exec(radix === 10 ? $64709efe73953b38$var$DEC : radix === 8 ? $64709efe73953b38$var$OCT : $64709efe73953b38$var$HEX, part)) return input;
            number = $64709efe73953b38$var$parseInt(part, radix);
        }
        $64709efe73953b38$var$push(numbers, number);
    }
    for(index = 0; index < partsLength; index++){
        number = numbers[index];
        if (index === partsLength - 1) {
            if (number >= $64709efe73953b38$var$pow(256, 5 - partsLength)) return null;
        } else if (number > 255) return null;
    }
    ipv4 = $64709efe73953b38$var$pop(numbers);
    for(index = 0; index < numbers.length; index++)ipv4 += numbers[index] * $64709efe73953b38$var$pow(256, 3 - index);
    return ipv4;
};
// https://url.spec.whatwg.org/#concept-ipv6-parser
// eslint-disable-next-line max-statements -- TODO
var $64709efe73953b38$var$parseIPv6 = function(input) {
    var address = [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ];
    var pieceIndex = 0;
    var compress = null;
    var pointer = 0;
    var value, length, numbersSeen, ipv4Piece, number, swaps, swap;
    var chr = function() {
        return $64709efe73953b38$var$charAt(input, pointer);
    };
    if (chr() === ":") {
        if ($64709efe73953b38$var$charAt(input, 1) !== ":") return;
        pointer += 2;
        pieceIndex++;
        compress = pieceIndex;
    }
    while(chr()){
        if (pieceIndex === 8) return;
        if (chr() === ":") {
            if (compress !== null) return;
            pointer++;
            pieceIndex++;
            compress = pieceIndex;
            continue;
        }
        value = length = 0;
        while(length < 4 && $64709efe73953b38$var$exec($64709efe73953b38$var$HEX, chr())){
            value = value * 16 + $64709efe73953b38$var$parseInt(chr(), 16);
            pointer++;
            length++;
        }
        if (chr() === ".") {
            if (length === 0) return;
            pointer -= length;
            if (pieceIndex > 6) return;
            numbersSeen = 0;
            while(chr()){
                ipv4Piece = null;
                if (numbersSeen > 0) {
                    if (chr() === "." && numbersSeen < 4) pointer++;
                    else return;
                }
                if (!$64709efe73953b38$var$exec($64709efe73953b38$var$DIGIT, chr())) return;
                while($64709efe73953b38$var$exec($64709efe73953b38$var$DIGIT, chr())){
                    number = $64709efe73953b38$var$parseInt(chr(), 10);
                    if (ipv4Piece === null) ipv4Piece = number;
                    else if (ipv4Piece === 0) return;
                    else ipv4Piece = ipv4Piece * 10 + number;
                    if (ipv4Piece > 255) return;
                    pointer++;
                }
                address[pieceIndex] = address[pieceIndex] * 256 + ipv4Piece;
                numbersSeen++;
                if (numbersSeen === 2 || numbersSeen === 4) pieceIndex++;
            }
            if (numbersSeen !== 4) return;
            break;
        } else if (chr() === ":") {
            pointer++;
            if (!chr()) return;
        } else if (chr()) return;
        address[pieceIndex++] = value;
    }
    if (compress !== null) {
        swaps = pieceIndex - compress;
        pieceIndex = 7;
        while(pieceIndex !== 0 && swaps > 0){
            swap = address[pieceIndex];
            address[pieceIndex--] = address[compress + swaps - 1];
            address[compress + --swaps] = swap;
        }
    } else if (pieceIndex !== 8) return;
    return address;
};
var $64709efe73953b38$var$findLongestZeroSequence = function(ipv6) {
    var maxIndex = null;
    var maxLength = 1;
    var currStart = null;
    var currLength = 0;
    var index = 0;
    for(; index < 8; index++)if (ipv6[index] !== 0) {
        if (currLength > maxLength) {
            maxIndex = currStart;
            maxLength = currLength;
        }
        currStart = null;
        currLength = 0;
    } else {
        if (currStart === null) currStart = index;
        ++currLength;
    }
    if (currLength > maxLength) {
        maxIndex = currStart;
        maxLength = currLength;
    }
    return maxIndex;
};
// https://url.spec.whatwg.org/#host-serializing
var $64709efe73953b38$var$serializeHost = function(host) {
    var result, index, compress, ignore0;
    // ipv4
    if (typeof host == "number") {
        result = [];
        for(index = 0; index < 4; index++){
            $64709efe73953b38$var$unshift(result, host % 256);
            host = $64709efe73953b38$var$floor(host / 256);
        }
        return $64709efe73953b38$var$join(result, ".");
    // ipv6
    } else if (typeof host == "object") {
        result = "";
        compress = $64709efe73953b38$var$findLongestZeroSequence(host);
        for(index = 0; index < 8; index++){
            if (ignore0 && host[index] === 0) continue;
            if (ignore0) ignore0 = false;
            if (compress === index) {
                result += index ? ":" : "::";
                ignore0 = true;
            } else {
                result += $64709efe73953b38$var$numberToString(host[index], 16);
                if (index < 7) result += ":";
            }
        }
        return "[" + result + "]";
    }
    return host;
};
var $64709efe73953b38$var$C0ControlPercentEncodeSet = {};
var $64709efe73953b38$var$fragmentPercentEncodeSet = $c1606cd5236ce179$exports({}, $64709efe73953b38$var$C0ControlPercentEncodeSet, {
    " ": 1,
    '"': 1,
    "<": 1,
    ">": 1,
    "`": 1
});
var $64709efe73953b38$var$pathPercentEncodeSet = $c1606cd5236ce179$exports({}, $64709efe73953b38$var$fragmentPercentEncodeSet, {
    "#": 1,
    "?": 1,
    "{": 1,
    "}": 1
});
var $64709efe73953b38$var$userinfoPercentEncodeSet = $c1606cd5236ce179$exports({}, $64709efe73953b38$var$pathPercentEncodeSet, {
    "/": 1,
    ":": 1,
    ";": 1,
    "=": 1,
    "@": 1,
    "[": 1,
    "\\": 1,
    "]": 1,
    "^": 1,
    "|": 1
});
var $64709efe73953b38$var$percentEncode = function(chr, set) {
    var code = $64709efe73953b38$require$codeAt(chr, 0);
    return code > 0x20 && code < 0x7F && !$1ad0c60d8de14c83$exports(set, chr) ? chr : encodeURIComponent(chr);
};
// https://url.spec.whatwg.org/#special-scheme
var $64709efe73953b38$var$specialSchemes = {
    ftp: 21,
    file: null,
    http: 80,
    https: 443,
    ws: 80,
    wss: 443
};
// https://url.spec.whatwg.org/#windows-drive-letter
var $64709efe73953b38$var$isWindowsDriveLetter = function(string, normalized) {
    var second;
    return string.length === 2 && $64709efe73953b38$var$exec($64709efe73953b38$var$ALPHA, $64709efe73953b38$var$charAt(string, 0)) && ((second = $64709efe73953b38$var$charAt(string, 1)) === ":" || !normalized && second === "|");
};
// https://url.spec.whatwg.org/#start-with-a-windows-drive-letter
var $64709efe73953b38$var$startsWithWindowsDriveLetter = function(string) {
    var third;
    return string.length > 1 && $64709efe73953b38$var$isWindowsDriveLetter($64709efe73953b38$var$stringSlice(string, 0, 2)) && (string.length === 2 || (third = $64709efe73953b38$var$charAt(string, 2)) === "/" || third === "\\" || third === "?" || third === "#");
};
// https://url.spec.whatwg.org/#single-dot-path-segment
var $64709efe73953b38$var$isSingleDot = function(segment) {
    return segment === "." || $64709efe73953b38$var$toLowerCase(segment) === "%2e";
};
// https://url.spec.whatwg.org/#double-dot-path-segment
var $64709efe73953b38$var$isDoubleDot = function(segment) {
    segment = $64709efe73953b38$var$toLowerCase(segment);
    return segment === ".." || segment === "%2e." || segment === ".%2e" || segment === "%2e%2e";
};
// States:
var $64709efe73953b38$var$SCHEME_START = {};
var $64709efe73953b38$var$SCHEME = {};
var $64709efe73953b38$var$NO_SCHEME = {};
var $64709efe73953b38$var$SPECIAL_RELATIVE_OR_AUTHORITY = {};
var $64709efe73953b38$var$PATH_OR_AUTHORITY = {};
var $64709efe73953b38$var$RELATIVE = {};
var $64709efe73953b38$var$RELATIVE_SLASH = {};
var $64709efe73953b38$var$SPECIAL_AUTHORITY_SLASHES = {};
var $64709efe73953b38$var$SPECIAL_AUTHORITY_IGNORE_SLASHES = {};
var $64709efe73953b38$var$AUTHORITY = {};
var $64709efe73953b38$var$HOST = {};
var $64709efe73953b38$var$HOSTNAME = {};
var $64709efe73953b38$var$PORT = {};
var $64709efe73953b38$var$FILE = {};
var $64709efe73953b38$var$FILE_SLASH = {};
var $64709efe73953b38$var$FILE_HOST = {};
var $64709efe73953b38$var$PATH_START = {};
var $64709efe73953b38$var$PATH = {};
var $64709efe73953b38$var$CANNOT_BE_A_BASE_URL_PATH = {};
var $64709efe73953b38$var$QUERY = {};
var $64709efe73953b38$var$FRAGMENT = {};
var $64709efe73953b38$var$URLState = function(url, isBase, base) {
    var urlString = $5eca6f9e01902ab4$exports(url);
    var baseState, failure, searchParams;
    if (isBase) {
        failure = this.parse(urlString);
        if (failure) throw new $64709efe73953b38$var$TypeError(failure);
        this.searchParams = null;
    } else {
        if (base !== undefined) baseState = new $64709efe73953b38$var$URLState(base, true);
        failure = this.parse(urlString, null, baseState);
        if (failure) throw new $64709efe73953b38$var$TypeError(failure);
        searchParams = $64709efe73953b38$var$getInternalSearchParamsState(new $64709efe73953b38$var$URLSearchParams());
        searchParams.bindURL(this);
        this.searchParams = searchParams;
    }
};
$64709efe73953b38$var$URLState.prototype = {
    type: "URL",
    // https://url.spec.whatwg.org/#url-parsing
    // eslint-disable-next-line max-statements -- TODO
    parse: function(input, stateOverride, base) {
        var url = this;
        var state = stateOverride || $64709efe73953b38$var$SCHEME_START;
        var pointer = 0;
        var buffer = "";
        var seenAt = false;
        var seenBracket = false;
        var seenPasswordToken = false;
        var codePoints, chr, bufferCodePoints, failure;
        input = $5eca6f9e01902ab4$exports(input);
        if (!stateOverride) {
            url.scheme = "";
            url.username = "";
            url.password = "";
            url.host = null;
            url.port = null;
            url.path = [];
            url.query = null;
            url.fragment = null;
            url.cannotBeABaseURL = false;
            input = $64709efe73953b38$var$replace(input, $64709efe73953b38$var$LEADING_C0_CONTROL_OR_SPACE, "");
            input = $64709efe73953b38$var$replace(input, $64709efe73953b38$var$TRAILING_C0_CONTROL_OR_SPACE, "$1");
        }
        input = $64709efe73953b38$var$replace(input, $64709efe73953b38$var$TAB_AND_NEW_LINE, "");
        codePoints = $448935b1ecdf1016$exports(input);
        while(pointer <= codePoints.length){
            chr = codePoints[pointer];
            switch(state){
                case $64709efe73953b38$var$SCHEME_START:
                    if (chr && $64709efe73953b38$var$exec($64709efe73953b38$var$ALPHA, chr)) {
                        buffer += $64709efe73953b38$var$toLowerCase(chr);
                        state = $64709efe73953b38$var$SCHEME;
                    } else if (!stateOverride) {
                        state = $64709efe73953b38$var$NO_SCHEME;
                        continue;
                    } else return $64709efe73953b38$var$INVALID_SCHEME;
                    break;
                case $64709efe73953b38$var$SCHEME:
                    if (chr && ($64709efe73953b38$var$exec($64709efe73953b38$var$ALPHANUMERIC, chr) || chr === "+" || chr === "-" || chr === ".")) buffer += $64709efe73953b38$var$toLowerCase(chr);
                    else if (chr === ":") {
                        if (stateOverride && (url.isSpecial() !== $1ad0c60d8de14c83$exports($64709efe73953b38$var$specialSchemes, buffer) || buffer === "file" && (url.includesCredentials() || url.port !== null) || url.scheme === "file" && !url.host)) return;
                        url.scheme = buffer;
                        if (stateOverride) {
                            if (url.isSpecial() && $64709efe73953b38$var$specialSchemes[url.scheme] === url.port) url.port = null;
                            return;
                        }
                        buffer = "";
                        if (url.scheme === "file") state = $64709efe73953b38$var$FILE;
                        else if (url.isSpecial() && base && base.scheme === url.scheme) state = $64709efe73953b38$var$SPECIAL_RELATIVE_OR_AUTHORITY;
                        else if (url.isSpecial()) state = $64709efe73953b38$var$SPECIAL_AUTHORITY_SLASHES;
                        else if (codePoints[pointer + 1] === "/") {
                            state = $64709efe73953b38$var$PATH_OR_AUTHORITY;
                            pointer++;
                        } else {
                            url.cannotBeABaseURL = true;
                            $64709efe73953b38$var$push(url.path, "");
                            state = $64709efe73953b38$var$CANNOT_BE_A_BASE_URL_PATH;
                        }
                    } else if (!stateOverride) {
                        buffer = "";
                        state = $64709efe73953b38$var$NO_SCHEME;
                        pointer = 0;
                        continue;
                    } else return $64709efe73953b38$var$INVALID_SCHEME;
                    break;
                case $64709efe73953b38$var$NO_SCHEME:
                    if (!base || base.cannotBeABaseURL && chr !== "#") return $64709efe73953b38$var$INVALID_SCHEME;
                    if (base.cannotBeABaseURL && chr === "#") {
                        url.scheme = base.scheme;
                        url.path = $9b893bf7d545a0e5$exports(base.path);
                        url.query = base.query;
                        url.fragment = "";
                        url.cannotBeABaseURL = true;
                        state = $64709efe73953b38$var$FRAGMENT;
                        break;
                    }
                    state = base.scheme === "file" ? $64709efe73953b38$var$FILE : $64709efe73953b38$var$RELATIVE;
                    continue;
                case $64709efe73953b38$var$SPECIAL_RELATIVE_OR_AUTHORITY:
                    if (chr === "/" && codePoints[pointer + 1] === "/") {
                        state = $64709efe73953b38$var$SPECIAL_AUTHORITY_IGNORE_SLASHES;
                        pointer++;
                    } else {
                        state = $64709efe73953b38$var$RELATIVE;
                        continue;
                    }
                    break;
                case $64709efe73953b38$var$PATH_OR_AUTHORITY:
                    if (chr === "/") {
                        state = $64709efe73953b38$var$AUTHORITY;
                        break;
                    } else {
                        state = $64709efe73953b38$var$PATH;
                        continue;
                    }
                case $64709efe73953b38$var$RELATIVE:
                    url.scheme = base.scheme;
                    if (chr === $64709efe73953b38$var$EOF) {
                        url.username = base.username;
                        url.password = base.password;
                        url.host = base.host;
                        url.port = base.port;
                        url.path = $9b893bf7d545a0e5$exports(base.path);
                        url.query = base.query;
                    } else if (chr === "/" || chr === "\\" && url.isSpecial()) state = $64709efe73953b38$var$RELATIVE_SLASH;
                    else if (chr === "?") {
                        url.username = base.username;
                        url.password = base.password;
                        url.host = base.host;
                        url.port = base.port;
                        url.path = $9b893bf7d545a0e5$exports(base.path);
                        url.query = "";
                        state = $64709efe73953b38$var$QUERY;
                    } else if (chr === "#") {
                        url.username = base.username;
                        url.password = base.password;
                        url.host = base.host;
                        url.port = base.port;
                        url.path = $9b893bf7d545a0e5$exports(base.path);
                        url.query = base.query;
                        url.fragment = "";
                        state = $64709efe73953b38$var$FRAGMENT;
                    } else {
                        url.username = base.username;
                        url.password = base.password;
                        url.host = base.host;
                        url.port = base.port;
                        url.path = $9b893bf7d545a0e5$exports(base.path);
                        url.path.length--;
                        state = $64709efe73953b38$var$PATH;
                        continue;
                    }
                    break;
                case $64709efe73953b38$var$RELATIVE_SLASH:
                    if (url.isSpecial() && (chr === "/" || chr === "\\")) state = $64709efe73953b38$var$SPECIAL_AUTHORITY_IGNORE_SLASHES;
                    else if (chr === "/") state = $64709efe73953b38$var$AUTHORITY;
                    else {
                        url.username = base.username;
                        url.password = base.password;
                        url.host = base.host;
                        url.port = base.port;
                        state = $64709efe73953b38$var$PATH;
                        continue;
                    }
                    break;
                case $64709efe73953b38$var$SPECIAL_AUTHORITY_SLASHES:
                    state = $64709efe73953b38$var$SPECIAL_AUTHORITY_IGNORE_SLASHES;
                    if (chr !== "/" || $64709efe73953b38$var$charAt(buffer, pointer + 1) !== "/") continue;
                    pointer++;
                    break;
                case $64709efe73953b38$var$SPECIAL_AUTHORITY_IGNORE_SLASHES:
                    if (chr !== "/" && chr !== "\\") {
                        state = $64709efe73953b38$var$AUTHORITY;
                        continue;
                    }
                    break;
                case $64709efe73953b38$var$AUTHORITY:
                    if (chr === "@") {
                        if (seenAt) buffer = "%40" + buffer;
                        seenAt = true;
                        bufferCodePoints = $448935b1ecdf1016$exports(buffer);
                        for(var i = 0; i < bufferCodePoints.length; i++){
                            var codePoint = bufferCodePoints[i];
                            if (codePoint === ":" && !seenPasswordToken) {
                                seenPasswordToken = true;
                                continue;
                            }
                            var encodedCodePoints = $64709efe73953b38$var$percentEncode(codePoint, $64709efe73953b38$var$userinfoPercentEncodeSet);
                            if (seenPasswordToken) url.password += encodedCodePoints;
                            else url.username += encodedCodePoints;
                        }
                        buffer = "";
                    } else if (chr === $64709efe73953b38$var$EOF || chr === "/" || chr === "?" || chr === "#" || chr === "\\" && url.isSpecial()) {
                        if (seenAt && buffer === "") return $64709efe73953b38$var$INVALID_AUTHORITY;
                        pointer -= $448935b1ecdf1016$exports(buffer).length + 1;
                        buffer = "";
                        state = $64709efe73953b38$var$HOST;
                    } else buffer += chr;
                    break;
                case $64709efe73953b38$var$HOST:
                case $64709efe73953b38$var$HOSTNAME:
                    if (stateOverride && url.scheme === "file") {
                        state = $64709efe73953b38$var$FILE_HOST;
                        continue;
                    } else if (chr === ":" && !seenBracket) {
                        if (buffer === "") return $64709efe73953b38$var$INVALID_HOST;
                        failure = url.parseHost(buffer);
                        if (failure) return failure;
                        buffer = "";
                        state = $64709efe73953b38$var$PORT;
                        if (stateOverride === $64709efe73953b38$var$HOSTNAME) return;
                    } else if (chr === $64709efe73953b38$var$EOF || chr === "/" || chr === "?" || chr === "#" || chr === "\\" && url.isSpecial()) {
                        if (url.isSpecial() && buffer === "") return $64709efe73953b38$var$INVALID_HOST;
                        if (stateOverride && buffer === "" && (url.includesCredentials() || url.port !== null)) return;
                        failure = url.parseHost(buffer);
                        if (failure) return failure;
                        buffer = "";
                        state = $64709efe73953b38$var$PATH_START;
                        if (stateOverride) return;
                        continue;
                    } else {
                        if (chr === "[") seenBracket = true;
                        else if (chr === "]") seenBracket = false;
                        buffer += chr;
                    }
                    break;
                case $64709efe73953b38$var$PORT:
                    if ($64709efe73953b38$var$exec($64709efe73953b38$var$DIGIT, chr)) buffer += chr;
                    else if (chr === $64709efe73953b38$var$EOF || chr === "/" || chr === "?" || chr === "#" || chr === "\\" && url.isSpecial() || stateOverride) {
                        if (buffer !== "") {
                            var port = $64709efe73953b38$var$parseInt(buffer, 10);
                            if (port > 0xFFFF) return $64709efe73953b38$var$INVALID_PORT;
                            url.port = url.isSpecial() && port === $64709efe73953b38$var$specialSchemes[url.scheme] ? null : port;
                            buffer = "";
                        }
                        if (stateOverride) return;
                        state = $64709efe73953b38$var$PATH_START;
                        continue;
                    } else return $64709efe73953b38$var$INVALID_PORT;
                    break;
                case $64709efe73953b38$var$FILE:
                    url.scheme = "file";
                    if (chr === "/" || chr === "\\") state = $64709efe73953b38$var$FILE_SLASH;
                    else if (base && base.scheme === "file") switch(chr){
                        case $64709efe73953b38$var$EOF:
                            url.host = base.host;
                            url.path = $9b893bf7d545a0e5$exports(base.path);
                            url.query = base.query;
                            break;
                        case "?":
                            url.host = base.host;
                            url.path = $9b893bf7d545a0e5$exports(base.path);
                            url.query = "";
                            state = $64709efe73953b38$var$QUERY;
                            break;
                        case "#":
                            url.host = base.host;
                            url.path = $9b893bf7d545a0e5$exports(base.path);
                            url.query = base.query;
                            url.fragment = "";
                            state = $64709efe73953b38$var$FRAGMENT;
                            break;
                        default:
                            if (!$64709efe73953b38$var$startsWithWindowsDriveLetter($64709efe73953b38$var$join($9b893bf7d545a0e5$exports(codePoints, pointer), ""))) {
                                url.host = base.host;
                                url.path = $9b893bf7d545a0e5$exports(base.path);
                                url.shortenPath();
                            }
                            state = $64709efe73953b38$var$PATH;
                            continue;
                    }
                    else {
                        state = $64709efe73953b38$var$PATH;
                        continue;
                    }
                    break;
                case $64709efe73953b38$var$FILE_SLASH:
                    if (chr === "/" || chr === "\\") {
                        state = $64709efe73953b38$var$FILE_HOST;
                        break;
                    }
                    if (base && base.scheme === "file" && !$64709efe73953b38$var$startsWithWindowsDriveLetter($64709efe73953b38$var$join($9b893bf7d545a0e5$exports(codePoints, pointer), ""))) {
                        if ($64709efe73953b38$var$isWindowsDriveLetter(base.path[0], true)) $64709efe73953b38$var$push(url.path, base.path[0]);
                        else url.host = base.host;
                    }
                    state = $64709efe73953b38$var$PATH;
                    continue;
                case $64709efe73953b38$var$FILE_HOST:
                    if (chr === $64709efe73953b38$var$EOF || chr === "/" || chr === "\\" || chr === "?" || chr === "#") {
                        if (!stateOverride && $64709efe73953b38$var$isWindowsDriveLetter(buffer)) state = $64709efe73953b38$var$PATH;
                        else if (buffer === "") {
                            url.host = "";
                            if (stateOverride) return;
                            state = $64709efe73953b38$var$PATH_START;
                        } else {
                            failure = url.parseHost(buffer);
                            if (failure) return failure;
                            if (url.host === "localhost") url.host = "";
                            if (stateOverride) return;
                            buffer = "";
                            state = $64709efe73953b38$var$PATH_START;
                        }
                        continue;
                    } else buffer += chr;
                    break;
                case $64709efe73953b38$var$PATH_START:
                    if (url.isSpecial()) {
                        state = $64709efe73953b38$var$PATH;
                        if (chr !== "/" && chr !== "\\") continue;
                    } else if (!stateOverride && chr === "?") {
                        url.query = "";
                        state = $64709efe73953b38$var$QUERY;
                    } else if (!stateOverride && chr === "#") {
                        url.fragment = "";
                        state = $64709efe73953b38$var$FRAGMENT;
                    } else if (chr !== $64709efe73953b38$var$EOF) {
                        state = $64709efe73953b38$var$PATH;
                        if (chr !== "/") continue;
                    }
                    break;
                case $64709efe73953b38$var$PATH:
                    if (chr === $64709efe73953b38$var$EOF || chr === "/" || chr === "\\" && url.isSpecial() || !stateOverride && (chr === "?" || chr === "#")) {
                        if ($64709efe73953b38$var$isDoubleDot(buffer)) {
                            url.shortenPath();
                            if (chr !== "/" && !(chr === "\\" && url.isSpecial())) $64709efe73953b38$var$push(url.path, "");
                        } else if ($64709efe73953b38$var$isSingleDot(buffer)) {
                            if (chr !== "/" && !(chr === "\\" && url.isSpecial())) $64709efe73953b38$var$push(url.path, "");
                        } else {
                            if (url.scheme === "file" && !url.path.length && $64709efe73953b38$var$isWindowsDriveLetter(buffer)) {
                                if (url.host) url.host = "";
                                buffer = $64709efe73953b38$var$charAt(buffer, 0) + ":"; // normalize windows drive letter
                            }
                            $64709efe73953b38$var$push(url.path, buffer);
                        }
                        buffer = "";
                        if (url.scheme === "file" && (chr === $64709efe73953b38$var$EOF || chr === "?" || chr === "#")) while(url.path.length > 1 && url.path[0] === "")$64709efe73953b38$var$shift(url.path);
                        if (chr === "?") {
                            url.query = "";
                            state = $64709efe73953b38$var$QUERY;
                        } else if (chr === "#") {
                            url.fragment = "";
                            state = $64709efe73953b38$var$FRAGMENT;
                        }
                    } else buffer += $64709efe73953b38$var$percentEncode(chr, $64709efe73953b38$var$pathPercentEncodeSet);
                    break;
                case $64709efe73953b38$var$CANNOT_BE_A_BASE_URL_PATH:
                    if (chr === "?") {
                        url.query = "";
                        state = $64709efe73953b38$var$QUERY;
                    } else if (chr === "#") {
                        url.fragment = "";
                        state = $64709efe73953b38$var$FRAGMENT;
                    } else if (chr !== $64709efe73953b38$var$EOF) url.path[0] += $64709efe73953b38$var$percentEncode(chr, $64709efe73953b38$var$C0ControlPercentEncodeSet);
                    break;
                case $64709efe73953b38$var$QUERY:
                    if (!stateOverride && chr === "#") {
                        url.fragment = "";
                        state = $64709efe73953b38$var$FRAGMENT;
                    } else if (chr !== $64709efe73953b38$var$EOF) {
                        if (chr === "'" && url.isSpecial()) url.query += "%27";
                        else if (chr === "#") url.query += "%23";
                        else url.query += $64709efe73953b38$var$percentEncode(chr, $64709efe73953b38$var$C0ControlPercentEncodeSet);
                    }
                    break;
                case $64709efe73953b38$var$FRAGMENT:
                    if (chr !== $64709efe73953b38$var$EOF) url.fragment += $64709efe73953b38$var$percentEncode(chr, $64709efe73953b38$var$fragmentPercentEncodeSet);
                    break;
            }
            pointer++;
        }
    },
    // https://url.spec.whatwg.org/#host-parsing
    parseHost: function(input) {
        var result, codePoints, index;
        if ($64709efe73953b38$var$charAt(input, 0) === "[") {
            if ($64709efe73953b38$var$charAt(input, input.length - 1) !== "]") return $64709efe73953b38$var$INVALID_HOST;
            result = $64709efe73953b38$var$parseIPv6($64709efe73953b38$var$stringSlice(input, 1, -1));
            if (!result) return $64709efe73953b38$var$INVALID_HOST;
            this.host = result;
        // opaque host
        } else if (!this.isSpecial()) {
            if ($64709efe73953b38$var$exec($64709efe73953b38$var$FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT, input)) return $64709efe73953b38$var$INVALID_HOST;
            result = "";
            codePoints = $448935b1ecdf1016$exports(input);
            for(index = 0; index < codePoints.length; index++)result += $64709efe73953b38$var$percentEncode(codePoints[index], $64709efe73953b38$var$C0ControlPercentEncodeSet);
            this.host = result;
        } else {
            input = $155c186061e8fe42$exports(input);
            if ($64709efe73953b38$var$exec($64709efe73953b38$var$FORBIDDEN_HOST_CODE_POINT, input)) return $64709efe73953b38$var$INVALID_HOST;
            result = $64709efe73953b38$var$parseIPv4(input);
            if (result === null) return $64709efe73953b38$var$INVALID_HOST;
            this.host = result;
        }
    },
    // https://url.spec.whatwg.org/#cannot-have-a-username-password-port
    cannotHaveUsernamePasswordPort: function() {
        return !this.host || this.cannotBeABaseURL || this.scheme === "file";
    },
    // https://url.spec.whatwg.org/#include-credentials
    includesCredentials: function() {
        return this.username !== "" || this.password !== "";
    },
    // https://url.spec.whatwg.org/#is-special
    isSpecial: function() {
        return $1ad0c60d8de14c83$exports($64709efe73953b38$var$specialSchemes, this.scheme);
    },
    // https://url.spec.whatwg.org/#shorten-a-urls-path
    shortenPath: function() {
        var path = this.path;
        var pathSize = path.length;
        if (pathSize && (this.scheme !== "file" || pathSize !== 1 || !$64709efe73953b38$var$isWindowsDriveLetter(path[0], true))) path.length--;
    },
    // https://url.spec.whatwg.org/#concept-url-serializer
    serialize: function() {
        var url = this;
        var scheme = url.scheme;
        var username = url.username;
        var password = url.password;
        var host = url.host;
        var port = url.port;
        var path = url.path;
        var query = url.query;
        var fragment = url.fragment;
        var output = scheme + ":";
        if (host !== null) {
            output += "//";
            if (url.includesCredentials()) output += username + (password ? ":" + password : "") + "@";
            output += $64709efe73953b38$var$serializeHost(host);
            if (port !== null) output += ":" + port;
        } else if (scheme === "file") output += "//";
        output += url.cannotBeABaseURL ? path[0] : path.length ? "/" + $64709efe73953b38$var$join(path, "/") : "";
        if (query !== null) output += "?" + query;
        if (fragment !== null) output += "#" + fragment;
        return output;
    },
    // https://url.spec.whatwg.org/#dom-url-href
    setHref: function(href) {
        var failure = this.parse(href);
        if (failure) throw new $64709efe73953b38$var$TypeError(failure);
        this.searchParams.update();
    },
    // https://url.spec.whatwg.org/#dom-url-origin
    getOrigin: function() {
        var scheme = this.scheme;
        var port = this.port;
        if (scheme === "blob") try {
            return new $64709efe73953b38$var$URLConstructor(scheme.path[0]).origin;
        } catch (error) {
            return "null";
        }
        if (scheme === "file" || !this.isSpecial()) return "null";
        return scheme + "://" + $64709efe73953b38$var$serializeHost(this.host) + (port !== null ? ":" + port : "");
    },
    // https://url.spec.whatwg.org/#dom-url-protocol
    getProtocol: function() {
        return this.scheme + ":";
    },
    setProtocol: function(protocol) {
        this.parse($5eca6f9e01902ab4$exports(protocol) + ":", $64709efe73953b38$var$SCHEME_START);
    },
    // https://url.spec.whatwg.org/#dom-url-username
    getUsername: function() {
        return this.username;
    },
    setUsername: function(username) {
        var codePoints = $448935b1ecdf1016$exports($5eca6f9e01902ab4$exports(username));
        if (this.cannotHaveUsernamePasswordPort()) return;
        this.username = "";
        for(var i = 0; i < codePoints.length; i++)this.username += $64709efe73953b38$var$percentEncode(codePoints[i], $64709efe73953b38$var$userinfoPercentEncodeSet);
    },
    // https://url.spec.whatwg.org/#dom-url-password
    getPassword: function() {
        return this.password;
    },
    setPassword: function(password) {
        var codePoints = $448935b1ecdf1016$exports($5eca6f9e01902ab4$exports(password));
        if (this.cannotHaveUsernamePasswordPort()) return;
        this.password = "";
        for(var i = 0; i < codePoints.length; i++)this.password += $64709efe73953b38$var$percentEncode(codePoints[i], $64709efe73953b38$var$userinfoPercentEncodeSet);
    },
    // https://url.spec.whatwg.org/#dom-url-host
    getHost: function() {
        var host = this.host;
        var port = this.port;
        return host === null ? "" : port === null ? $64709efe73953b38$var$serializeHost(host) : $64709efe73953b38$var$serializeHost(host) + ":" + port;
    },
    setHost: function(host) {
        if (this.cannotBeABaseURL) return;
        this.parse(host, $64709efe73953b38$var$HOST);
    },
    // https://url.spec.whatwg.org/#dom-url-hostname
    getHostname: function() {
        var host = this.host;
        return host === null ? "" : $64709efe73953b38$var$serializeHost(host);
    },
    setHostname: function(hostname) {
        if (this.cannotBeABaseURL) return;
        this.parse(hostname, $64709efe73953b38$var$HOSTNAME);
    },
    // https://url.spec.whatwg.org/#dom-url-port
    getPort: function() {
        var port = this.port;
        return port === null ? "" : $5eca6f9e01902ab4$exports(port);
    },
    setPort: function(port) {
        if (this.cannotHaveUsernamePasswordPort()) return;
        port = $5eca6f9e01902ab4$exports(port);
        if (port === "") this.port = null;
        else this.parse(port, $64709efe73953b38$var$PORT);
    },
    // https://url.spec.whatwg.org/#dom-url-pathname
    getPathname: function() {
        var path = this.path;
        return this.cannotBeABaseURL ? path[0] : path.length ? "/" + $64709efe73953b38$var$join(path, "/") : "";
    },
    setPathname: function(pathname) {
        if (this.cannotBeABaseURL) return;
        this.path = [];
        this.parse(pathname, $64709efe73953b38$var$PATH_START);
    },
    // https://url.spec.whatwg.org/#dom-url-search
    getSearch: function() {
        var query = this.query;
        return query ? "?" + query : "";
    },
    setSearch: function(search) {
        search = $5eca6f9e01902ab4$exports(search);
        if (search === "") this.query = null;
        else {
            if ($64709efe73953b38$var$charAt(search, 0) === "?") search = $64709efe73953b38$var$stringSlice(search, 1);
            this.query = "";
            this.parse(search, $64709efe73953b38$var$QUERY);
        }
        this.searchParams.update();
    },
    // https://url.spec.whatwg.org/#dom-url-searchparams
    getSearchParams: function() {
        return this.searchParams.facade;
    },
    // https://url.spec.whatwg.org/#dom-url-hash
    getHash: function() {
        var fragment = this.fragment;
        return fragment ? "#" + fragment : "";
    },
    setHash: function(hash) {
        hash = $5eca6f9e01902ab4$exports(hash);
        if (hash === "") {
            this.fragment = null;
            return;
        }
        if ($64709efe73953b38$var$charAt(hash, 0) === "#") hash = $64709efe73953b38$var$stringSlice(hash, 1);
        this.fragment = "";
        this.parse(hash, $64709efe73953b38$var$FRAGMENT);
    },
    update: function() {
        this.query = this.searchParams.serialize() || null;
    }
};
// `URL` constructor
// https://url.spec.whatwg.org/#url-class
var $64709efe73953b38$var$URLConstructor = function URL(url /* , base */ ) {
    var that = $efe207f3fce362b0$exports(this, $64709efe73953b38$var$URLPrototype);
    var base = $44813c6cb2f7b76c$exports(arguments.length, 1) > 1 ? arguments[1] : undefined;
    var state = $64709efe73953b38$var$setInternalState(that, new $64709efe73953b38$var$URLState(url, false, base));
    if (!$16b43a02da62cc11$exports) {
        that.href = state.serialize();
        that.origin = state.getOrigin();
        that.protocol = state.getProtocol();
        that.username = state.getUsername();
        that.password = state.getPassword();
        that.host = state.getHost();
        that.hostname = state.getHostname();
        that.port = state.getPort();
        that.pathname = state.getPathname();
        that.search = state.getSearch();
        that.searchParams = state.getSearchParams();
        that.hash = state.getHash();
    }
};
var $64709efe73953b38$var$URLPrototype = $64709efe73953b38$var$URLConstructor.prototype;
var $64709efe73953b38$var$accessorDescriptor = function(getter, setter) {
    return {
        get: function() {
            return $64709efe73953b38$var$getInternalURLState(this)[getter]();
        },
        set: setter && function(value) {
            return $64709efe73953b38$var$getInternalURLState(this)[setter](value);
        },
        configurable: true,
        enumerable: true
    };
};
if ($16b43a02da62cc11$exports) {
    // `URL.prototype.href` accessors pair
    // https://url.spec.whatwg.org/#dom-url-href
    $4dba431ca752b815$exports($64709efe73953b38$var$URLPrototype, "href", $64709efe73953b38$var$accessorDescriptor("serialize", "setHref"));
    // `URL.prototype.origin` getter
    // https://url.spec.whatwg.org/#dom-url-origin
    $4dba431ca752b815$exports($64709efe73953b38$var$URLPrototype, "origin", $64709efe73953b38$var$accessorDescriptor("getOrigin"));
    // `URL.prototype.protocol` accessors pair
    // https://url.spec.whatwg.org/#dom-url-protocol
    $4dba431ca752b815$exports($64709efe73953b38$var$URLPrototype, "protocol", $64709efe73953b38$var$accessorDescriptor("getProtocol", "setProtocol"));
    // `URL.prototype.username` accessors pair
    // https://url.spec.whatwg.org/#dom-url-username
    $4dba431ca752b815$exports($64709efe73953b38$var$URLPrototype, "username", $64709efe73953b38$var$accessorDescriptor("getUsername", "setUsername"));
    // `URL.prototype.password` accessors pair
    // https://url.spec.whatwg.org/#dom-url-password
    $4dba431ca752b815$exports($64709efe73953b38$var$URLPrototype, "password", $64709efe73953b38$var$accessorDescriptor("getPassword", "setPassword"));
    // `URL.prototype.host` accessors pair
    // https://url.spec.whatwg.org/#dom-url-host
    $4dba431ca752b815$exports($64709efe73953b38$var$URLPrototype, "host", $64709efe73953b38$var$accessorDescriptor("getHost", "setHost"));
    // `URL.prototype.hostname` accessors pair
    // https://url.spec.whatwg.org/#dom-url-hostname
    $4dba431ca752b815$exports($64709efe73953b38$var$URLPrototype, "hostname", $64709efe73953b38$var$accessorDescriptor("getHostname", "setHostname"));
    // `URL.prototype.port` accessors pair
    // https://url.spec.whatwg.org/#dom-url-port
    $4dba431ca752b815$exports($64709efe73953b38$var$URLPrototype, "port", $64709efe73953b38$var$accessorDescriptor("getPort", "setPort"));
    // `URL.prototype.pathname` accessors pair
    // https://url.spec.whatwg.org/#dom-url-pathname
    $4dba431ca752b815$exports($64709efe73953b38$var$URLPrototype, "pathname", $64709efe73953b38$var$accessorDescriptor("getPathname", "setPathname"));
    // `URL.prototype.search` accessors pair
    // https://url.spec.whatwg.org/#dom-url-search
    $4dba431ca752b815$exports($64709efe73953b38$var$URLPrototype, "search", $64709efe73953b38$var$accessorDescriptor("getSearch", "setSearch"));
    // `URL.prototype.searchParams` getter
    // https://url.spec.whatwg.org/#dom-url-searchparams
    $4dba431ca752b815$exports($64709efe73953b38$var$URLPrototype, "searchParams", $64709efe73953b38$var$accessorDescriptor("getSearchParams"));
    // `URL.prototype.hash` accessors pair
    // https://url.spec.whatwg.org/#dom-url-hash
    $4dba431ca752b815$exports($64709efe73953b38$var$URLPrototype, "hash", $64709efe73953b38$var$accessorDescriptor("getHash", "setHash"));
}
// `URL.prototype.toJSON` method
// https://url.spec.whatwg.org/#dom-url-tojson
$5cabf6b3204ed174$exports($64709efe73953b38$var$URLPrototype, "toJSON", function toJSON() {
    return $64709efe73953b38$var$getInternalURLState(this).serialize();
}, {
    enumerable: true
});
// `URL.prototype.toString` method
// https://url.spec.whatwg.org/#URL-stringification-behavior
$5cabf6b3204ed174$exports($64709efe73953b38$var$URLPrototype, "toString", function toString() {
    return $64709efe73953b38$var$getInternalURLState(this).serialize();
}, {
    enumerable: true
});
if ($64709efe73953b38$var$NativeURL) {
    var $64709efe73953b38$var$nativeCreateObjectURL = $64709efe73953b38$var$NativeURL.createObjectURL;
    var $64709efe73953b38$var$nativeRevokeObjectURL = $64709efe73953b38$var$NativeURL.revokeObjectURL;
    // `URL.createObjectURL` method
    // https://developer.mozilla.org/en-US/docs/Web/API/URL/createObjectURL
    if ($64709efe73953b38$var$nativeCreateObjectURL) $5cabf6b3204ed174$exports($64709efe73953b38$var$URLConstructor, "createObjectURL", $2db6a9f70c481925$exports($64709efe73953b38$var$nativeCreateObjectURL, $64709efe73953b38$var$NativeURL));
    // `URL.revokeObjectURL` method
    // https://developer.mozilla.org/en-US/docs/Web/API/URL/revokeObjectURL
    if ($64709efe73953b38$var$nativeRevokeObjectURL) $5cabf6b3204ed174$exports($64709efe73953b38$var$URLConstructor, "revokeObjectURL", $2db6a9f70c481925$exports($64709efe73953b38$var$nativeRevokeObjectURL, $64709efe73953b38$var$NativeURL));
}
$036072e21338276e$exports($64709efe73953b38$var$URLConstructor, "URL");
$ef48c8e0540d6569$exports({
    global: true,
    constructor: true,
    forced: !$470e62d1132fcedf$exports,
    sham: !$16b43a02da62cc11$exports
}, {
    URL: $64709efe73953b38$var$URLConstructor
});




"use strict";


// `URL.prototype.toJSON` method
// https://url.spec.whatwg.org/#dom-url-tojson
$ef48c8e0540d6569$exports({
    target: "URL",
    proto: true,
    enumerable: true
}, {
    toJSON: function toJSON() {
        return $2f17e9746e5fde89$exports(URL.prototype.toString, this);
    }
});


"use strict";



var $b1404a408b0d045c$exports = {};
"use strict";

$b1404a408b0d045c$exports = (parcelRequire("4XZfq"));


var $1f7064be4a077270$export$882461b6382ed46c;
var $1f7064be4a077270$export$757ceba2d55c277e;
"use strict";
var $dcf5062905338935$exports = {};
"use strict";
function $dcf5062905338935$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($dcf5062905338935$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$dcf5062905338935$var$checkDCE();

$dcf5062905338935$exports = (parcelRequire("2S5uy"));


var $1f7064be4a077270$var$i;
$1f7064be4a077270$export$882461b6382ed46c = $dcf5062905338935$exports.createRoot;
$1f7064be4a077270$export$757ceba2d55c277e = $dcf5062905338935$exports.hydrateRoot;


var $e479b6ac5364ae16$exports = {};
"use strict";
Object.defineProperty($e479b6ac5364ae16$exports, "__esModule", {
    value: true
});
var $eb08b1491a0a5198$exports = {};
"use strict";
Object.defineProperty($eb08b1491a0a5198$exports, "__esModule", {
    value: true
});
$eb08b1491a0a5198$exports.bodyOpenClassName = $eb08b1491a0a5198$exports.portalClassName = undefined;
var $eb08b1491a0a5198$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $eb08b1491a0a5198$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $P551f = parcelRequire("P551f");
var $eb08b1491a0a5198$var$_react2 = $eb08b1491a0a5198$var$_interopRequireDefault($P551f);

var $eb08b1491a0a5198$var$_reactDom2 = $eb08b1491a0a5198$var$_interopRequireDefault($dcf5062905338935$exports);
var $bd6ef712189d85ad$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bd6ef712189d85ad$var$ReactIs, $bd6ef712189d85ad$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$bd6ef712189d85ad$exports = (parcelRequire("k0dmy"))();


var $eb08b1491a0a5198$var$_propTypes2 = $eb08b1491a0a5198$var$_interopRequireDefault($bd6ef712189d85ad$exports);
var $c97ebba6a2cb77a6$exports = {};
"use strict";
Object.defineProperty($c97ebba6a2cb77a6$exports, "__esModule", {
    value: true
});
var $c97ebba6a2cb77a6$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $c97ebba6a2cb77a6$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $c97ebba6a2cb77a6$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $P551f = parcelRequire("P551f");

var $c97ebba6a2cb77a6$var$_propTypes2 = $c97ebba6a2cb77a6$var$_interopRequireDefault($bd6ef712189d85ad$exports);
var $abb6ecf5147db09b$exports = {};
"use strict";
Object.defineProperty($abb6ecf5147db09b$exports, "__esModule", {
    value: true
});
$abb6ecf5147db09b$exports.resetState = $abb6ecf5147db09b$var$resetState;
$abb6ecf5147db09b$exports.log = $abb6ecf5147db09b$var$log;
$abb6ecf5147db09b$exports.handleBlur = $abb6ecf5147db09b$var$handleBlur;
$abb6ecf5147db09b$exports.handleFocus = $abb6ecf5147db09b$var$handleFocus;
$abb6ecf5147db09b$exports.markForFocusLater = $abb6ecf5147db09b$var$markForFocusLater;
$abb6ecf5147db09b$exports.returnFocus = $abb6ecf5147db09b$var$returnFocus;
$abb6ecf5147db09b$exports.popWithoutFocus = $abb6ecf5147db09b$var$popWithoutFocus;
$abb6ecf5147db09b$exports.setupScopedFocus = $abb6ecf5147db09b$var$setupScopedFocus;
$abb6ecf5147db09b$exports.teardownScopedFocus = $abb6ecf5147db09b$var$teardownScopedFocus;
var $f90aa509d041c224$exports = {};
"use strict";
Object.defineProperty($f90aa509d041c224$exports, "__esModule", {
    value: true
});
$f90aa509d041c224$exports.default = $f90aa509d041c224$var$findTabbableDescendants;
/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */ var $f90aa509d041c224$var$tabbableNode = /input|select|textarea|button|object|iframe/;
function $f90aa509d041c224$var$hidesContents(element) {
    var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;
    // If the node is empty, this is good enough
    if (zeroSize && !element.innerHTML) return true;
    try {
        // Otherwise we need to check some styles
        var style = window.getComputedStyle(element);
        return zeroSize ? style.getPropertyValue("overflow") !== "visible" || // if 'overflow: visible' set, check if there is actually any overflow
        element.scrollWidth <= 0 && element.scrollHeight <= 0 : style.getPropertyValue("display") == "none";
    } catch (exception) {
        // eslint-disable-next-line no-console
        console.warn("Failed to inspect element style");
        return false;
    }
}
function $f90aa509d041c224$var$visible(element) {
    var parentElement = element;
    var rootNode = element.getRootNode && element.getRootNode();
    while(parentElement){
        if (parentElement === document.body) break;
        // if we are not hidden yet, skip to checking outside the Web Component
        if (rootNode && parentElement === rootNode) parentElement = rootNode.host.parentNode;
        if ($f90aa509d041c224$var$hidesContents(parentElement)) return false;
        parentElement = parentElement.parentNode;
    }
    return true;
}
function $f90aa509d041c224$var$focusable(element, isTabIndexNotNaN) {
    var nodeName = element.nodeName.toLowerCase();
    var res = $f90aa509d041c224$var$tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
    return res && $f90aa509d041c224$var$visible(element);
}
function $f90aa509d041c224$var$tabbable(element) {
    var tabIndex = element.getAttribute("tabindex");
    if (tabIndex === null) tabIndex = undefined;
    var isTabIndexNaN = isNaN(tabIndex);
    return (isTabIndexNaN || tabIndex >= 0) && $f90aa509d041c224$var$focusable(element, !isTabIndexNaN);
}
function $f90aa509d041c224$var$findTabbableDescendants(element) {
    var descendants = [].slice.call(element.querySelectorAll("*"), 0).reduce(function(finished, el) {
        return finished.concat(!el.shadowRoot ? [
            el
        ] : $f90aa509d041c224$var$findTabbableDescendants(el.shadowRoot));
    }, []);
    return descendants.filter($f90aa509d041c224$var$tabbable);
}
$f90aa509d041c224$exports = $f90aa509d041c224$exports["default"];


var $abb6ecf5147db09b$var$_tabbable2 = $abb6ecf5147db09b$var$_interopRequireDefault($f90aa509d041c224$exports);
function $abb6ecf5147db09b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $abb6ecf5147db09b$var$focusLaterElements = [];
var $abb6ecf5147db09b$var$modalElement = null;
var $abb6ecf5147db09b$var$needToFocus = false;
/* eslint-disable no-console */ /* istanbul ignore next */ function $abb6ecf5147db09b$var$resetState() {
    $abb6ecf5147db09b$var$focusLaterElements = [];
}
/* istanbul ignore next */ function $abb6ecf5147db09b$var$log() {}
/* eslint-enable no-console */ function $abb6ecf5147db09b$var$handleBlur() {
    $abb6ecf5147db09b$var$needToFocus = true;
}
function $abb6ecf5147db09b$var$handleFocus() {
    if ($abb6ecf5147db09b$var$needToFocus) {
        $abb6ecf5147db09b$var$needToFocus = false;
        if (!$abb6ecf5147db09b$var$modalElement) return;
        // need to see how jQuery shims document.on('focusin') so we don't need the
        // setTimeout, firefox doesn't support focusin, if it did, we could focus
        // the element outside of a setTimeout. Side-effect of this implementation
        // is that the document.body gets focus, and then we focus our element right
        // after, seems fine.
        setTimeout(function() {
            if ($abb6ecf5147db09b$var$modalElement.contains(document.activeElement)) return;
            var el = (0, $abb6ecf5147db09b$var$_tabbable2.default)($abb6ecf5147db09b$var$modalElement)[0] || $abb6ecf5147db09b$var$modalElement;
            el.focus();
        }, 0);
    }
}
function $abb6ecf5147db09b$var$markForFocusLater() {
    $abb6ecf5147db09b$var$focusLaterElements.push(document.activeElement);
}
/* eslint-disable no-console */ function $abb6ecf5147db09b$var$returnFocus() {
    var preventScroll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var toFocus = null;
    try {
        if ($abb6ecf5147db09b$var$focusLaterElements.length !== 0) {
            toFocus = $abb6ecf5147db09b$var$focusLaterElements.pop();
            toFocus.focus({
                preventScroll: preventScroll
            });
        }
        return;
    } catch (e) {
        console.warn([
            "You tried to return focus to",
            toFocus,
            "but it is not in the DOM anymore"
        ].join(" "));
    }
}
/* eslint-enable no-console */ function $abb6ecf5147db09b$var$popWithoutFocus() {
    $abb6ecf5147db09b$var$focusLaterElements.length > 0 && $abb6ecf5147db09b$var$focusLaterElements.pop();
}
function $abb6ecf5147db09b$var$setupScopedFocus(element) {
    $abb6ecf5147db09b$var$modalElement = element;
    if (window.addEventListener) {
        window.addEventListener("blur", $abb6ecf5147db09b$var$handleBlur, false);
        document.addEventListener("focus", $abb6ecf5147db09b$var$handleFocus, true);
    } else {
        window.attachEvent("onBlur", $abb6ecf5147db09b$var$handleBlur);
        document.attachEvent("onFocus", $abb6ecf5147db09b$var$handleFocus);
    }
}
function $abb6ecf5147db09b$var$teardownScopedFocus() {
    $abb6ecf5147db09b$var$modalElement = null;
    if (window.addEventListener) {
        window.removeEventListener("blur", $abb6ecf5147db09b$var$handleBlur);
        document.removeEventListener("focus", $abb6ecf5147db09b$var$handleFocus);
    } else {
        window.detachEvent("onBlur", $abb6ecf5147db09b$var$handleBlur);
        document.detachEvent("onFocus", $abb6ecf5147db09b$var$handleFocus);
    }
}


var $c97ebba6a2cb77a6$var$focusManager = $c97ebba6a2cb77a6$var$_interopRequireWildcard($abb6ecf5147db09b$exports);
var $6683774b5f787e42$exports = {};
"use strict";
Object.defineProperty($6683774b5f787e42$exports, "__esModule", {
    value: true
});
$6683774b5f787e42$exports.default = $6683774b5f787e42$var$scopeTab;

var $6683774b5f787e42$var$_tabbable2 = $6683774b5f787e42$var$_interopRequireDefault($f90aa509d041c224$exports);
function $6683774b5f787e42$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $6683774b5f787e42$var$getActiveElement() {
    var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
    return el.activeElement.shadowRoot ? $6683774b5f787e42$var$getActiveElement(el.activeElement.shadowRoot) : el.activeElement;
}
function $6683774b5f787e42$var$scopeTab(node, event) {
    var tabbable = (0, $6683774b5f787e42$var$_tabbable2.default)(node);
    if (!tabbable.length) {
        // Do nothing, since there are no elements that can receive focus.
        event.preventDefault();
        return;
    }
    var target = void 0;
    var shiftKey = event.shiftKey;
    var head = tabbable[0];
    var tail = tabbable[tabbable.length - 1];
    var activeElement = $6683774b5f787e42$var$getActiveElement();
    // proceed with default browser behavior on tab.
    // Focus on last element on shift + tab.
    if (node === activeElement) {
        if (!shiftKey) return;
        target = tail;
    }
    if (tail === activeElement && !shiftKey) target = head;
    if (head === activeElement && shiftKey) target = tail;
    if (target) {
        event.preventDefault();
        target.focus();
        return;
    }
    // Safari radio issue.
    //
    // Safari does not move the focus to the radio button,
    // so we need to force it to really walk through all elements.
    //
    // This is very error prone, since we are trying to guess
    // if it is a safari browser from the first occurence between
    // chrome or safari.
    //
    // The chrome user agent contains the first ocurrence
    // as the 'chrome/version' and later the 'safari/version'.
    var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
    var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;
    // If we are not in safari desktop, let the browser control
    // the focus
    if (!isSafariDesktop) return;
    var x = tabbable.indexOf(activeElement);
    if (x > -1) x += shiftKey ? -1 : 1;
    target = tabbable[x];
    // If the tabbable element does not exist,
    // focus head/tail based on shiftKey
    if (typeof target === "undefined") {
        event.preventDefault();
        target = shiftKey ? tail : head;
        target.focus();
        return;
    }
    event.preventDefault();
    target.focus();
}
$6683774b5f787e42$exports = $6683774b5f787e42$exports["default"];


var $c97ebba6a2cb77a6$var$_scopeTab2 = $c97ebba6a2cb77a6$var$_interopRequireDefault($6683774b5f787e42$exports);
var $d0cf2f2728d28592$exports = {};
"use strict";
Object.defineProperty($d0cf2f2728d28592$exports, "__esModule", {
    value: true
});
$d0cf2f2728d28592$exports.resetState = $d0cf2f2728d28592$var$resetState;
$d0cf2f2728d28592$exports.log = $d0cf2f2728d28592$var$log;
$d0cf2f2728d28592$exports.assertNodeList = $d0cf2f2728d28592$var$assertNodeList;
$d0cf2f2728d28592$exports.setElement = $d0cf2f2728d28592$var$setElement;
$d0cf2f2728d28592$exports.validateElement = $d0cf2f2728d28592$var$validateElement;
$d0cf2f2728d28592$exports.hide = $d0cf2f2728d28592$var$hide;
$d0cf2f2728d28592$exports.show = $d0cf2f2728d28592$var$show;
$d0cf2f2728d28592$exports.documentNotReadyOrSSRTesting = $d0cf2f2728d28592$var$documentNotReadyOrSSRTesting;
var $6ff32d0b5f02da8a$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $6ff32d0b5f02da8a$var$__DEV__ = false;
var $6ff32d0b5f02da8a$var$warning = function() {};
if ($6ff32d0b5f02da8a$var$__DEV__) {
    var $6ff32d0b5f02da8a$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = "Warning: " + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== "undefined") console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $6ff32d0b5f02da8a$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $6ff32d0b5f02da8a$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
$6ff32d0b5f02da8a$exports = $6ff32d0b5f02da8a$var$warning;


var $d0cf2f2728d28592$var$_warning2 = $d0cf2f2728d28592$var$_interopRequireDefault($6ff32d0b5f02da8a$exports);
var $468a7cc76bb195cf$exports = {};
"use strict";
Object.defineProperty($468a7cc76bb195cf$exports, "__esModule", {
    value: true
});
$468a7cc76bb195cf$exports.canUseDOM = $468a7cc76bb195cf$exports.SafeNodeList = $468a7cc76bb195cf$exports.SafeHTMLCollection = undefined;
var $f6c892e7fdf2a0fa$exports = {};
/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/ /* global define */ (function() {
    "use strict";
    var canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
    var ExecutionEnvironment = {
        canUseDOM: canUseDOM,
        canUseWorkers: typeof Worker !== "undefined",
        canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
        canUseViewport: canUseDOM && !!window.screen
    };
    if (typeof define === "function" && typeof define.amd === "object" && define.amd) define(function() {
        return ExecutionEnvironment;
    });
    else if (0, $f6c892e7fdf2a0fa$exports) $f6c892e7fdf2a0fa$exports = ExecutionEnvironment;
    else window.ExecutionEnvironment = ExecutionEnvironment;
})();


var $468a7cc76bb195cf$var$_exenv2 = $468a7cc76bb195cf$var$_interopRequireDefault($f6c892e7fdf2a0fa$exports);
function $468a7cc76bb195cf$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $468a7cc76bb195cf$var$EE = $468a7cc76bb195cf$var$_exenv2.default;
var $468a7cc76bb195cf$var$SafeHTMLElement = $468a7cc76bb195cf$var$EE.canUseDOM ? window.HTMLElement : {};
var $468a7cc76bb195cf$var$SafeHTMLCollection = $468a7cc76bb195cf$exports.SafeHTMLCollection = $468a7cc76bb195cf$var$EE.canUseDOM ? window.HTMLCollection : {};
var $468a7cc76bb195cf$var$SafeNodeList = $468a7cc76bb195cf$exports.SafeNodeList = $468a7cc76bb195cf$var$EE.canUseDOM ? window.NodeList : {};
var $468a7cc76bb195cf$var$canUseDOM = $468a7cc76bb195cf$exports.canUseDOM = $468a7cc76bb195cf$var$EE.canUseDOM;
$468a7cc76bb195cf$exports.default = $468a7cc76bb195cf$var$SafeHTMLElement;


function $d0cf2f2728d28592$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $d0cf2f2728d28592$var$globalElement = null;
/* eslint-disable no-console */ /* istanbul ignore next */ function $d0cf2f2728d28592$var$resetState() {
    if ($d0cf2f2728d28592$var$globalElement) {
        if ($d0cf2f2728d28592$var$globalElement.removeAttribute) $d0cf2f2728d28592$var$globalElement.removeAttribute("aria-hidden");
        else if ($d0cf2f2728d28592$var$globalElement.length != null) $d0cf2f2728d28592$var$globalElement.forEach(function(element) {
            return element.removeAttribute("aria-hidden");
        });
        else document.querySelectorAll($d0cf2f2728d28592$var$globalElement).forEach(function(element) {
            return element.removeAttribute("aria-hidden");
        });
    }
    $d0cf2f2728d28592$var$globalElement = null;
}
/* istanbul ignore next */ function $d0cf2f2728d28592$var$log() {
    var check;
}
/* eslint-enable no-console */ function $d0cf2f2728d28592$var$assertNodeList(nodeList, selector) {
    if (!nodeList || !nodeList.length) throw new Error("react-modal: No elements were found for selector " + selector + ".");
}
function $d0cf2f2728d28592$var$setElement(element) {
    var useElement = element;
    if (typeof useElement === "string" && $468a7cc76bb195cf$exports.canUseDOM) {
        var el = document.querySelectorAll(useElement);
        $d0cf2f2728d28592$var$assertNodeList(el, useElement);
        useElement = el;
    }
    $d0cf2f2728d28592$var$globalElement = useElement || $d0cf2f2728d28592$var$globalElement;
    return $d0cf2f2728d28592$var$globalElement;
}
function $d0cf2f2728d28592$var$validateElement(appElement) {
    var el = appElement || $d0cf2f2728d28592$var$globalElement;
    if (el) return Array.isArray(el) || el instanceof HTMLCollection || el instanceof NodeList ? el : [
        el
    ];
    else {
        (0, $d0cf2f2728d28592$var$_warning2.default)(false, [
            "react-modal: App element is not defined.",
            "Please use `Modal.setAppElement(el)` or set `appElement={el}`.",
            "This is needed so screen readers don't see main content",
            "when modal is opened. It is not recommended, but you can opt-out",
            "by setting `ariaHideApp={false}`."
        ].join(" "));
        return [];
    }
}
function $d0cf2f2728d28592$var$hide(appElement) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;
    try {
        for(var _iterator = $d0cf2f2728d28592$var$validateElement(appElement)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var el = _step.value;
            el.setAttribute("aria-hidden", "true");
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return) _iterator.return();
        } finally{
            if (_didIteratorError) throw _iteratorError;
        }
    }
}
function $d0cf2f2728d28592$var$show(appElement) {
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;
    try {
        for(var _iterator2 = $d0cf2f2728d28592$var$validateElement(appElement)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
            var el = _step2.value;
            el.removeAttribute("aria-hidden");
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) _iterator2.return();
        } finally{
            if (_didIteratorError2) throw _iteratorError2;
        }
    }
}
function $d0cf2f2728d28592$var$documentNotReadyOrSSRTesting() {
    $d0cf2f2728d28592$var$globalElement = null;
}


var $c97ebba6a2cb77a6$var$ariaAppHider = $c97ebba6a2cb77a6$var$_interopRequireWildcard($d0cf2f2728d28592$exports);
var $e0bc4d9f5e4062c1$exports = {};
"use strict";
Object.defineProperty($e0bc4d9f5e4062c1$exports, "__esModule", {
    value: true
});
$e0bc4d9f5e4062c1$exports.resetState = $e0bc4d9f5e4062c1$var$resetState;
$e0bc4d9f5e4062c1$exports.log = $e0bc4d9f5e4062c1$var$log;
var $e0bc4d9f5e4062c1$var$htmlClassList = {};
var $e0bc4d9f5e4062c1$var$docBodyClassList = {};
/* eslint-disable no-console */ /* istanbul ignore next */ function $e0bc4d9f5e4062c1$var$removeClass(at, cls) {
    at.classList.remove(cls);
}
/* istanbul ignore next */ function $e0bc4d9f5e4062c1$var$resetState() {
    var htmlElement = document.getElementsByTagName("html")[0];
    for(var cls in $e0bc4d9f5e4062c1$var$htmlClassList)$e0bc4d9f5e4062c1$var$removeClass(htmlElement, $e0bc4d9f5e4062c1$var$htmlClassList[cls]);
    var body = document.body;
    for(var _cls in $e0bc4d9f5e4062c1$var$docBodyClassList)$e0bc4d9f5e4062c1$var$removeClass(body, $e0bc4d9f5e4062c1$var$docBodyClassList[_cls]);
    $e0bc4d9f5e4062c1$var$htmlClassList = {};
    $e0bc4d9f5e4062c1$var$docBodyClassList = {};
}
/* istanbul ignore next */ function $e0bc4d9f5e4062c1$var$log() {
    var classes, buffer, x, _x;
}
/* eslint-enable no-console */ /**
 * Track the number of reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */ var $e0bc4d9f5e4062c1$var$incrementReference = function incrementReference(poll, className) {
    if (!poll[className]) poll[className] = 0;
    poll[className] += 1;
    return className;
};
/**
 * Drop the reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */ var $e0bc4d9f5e4062c1$var$decrementReference = function decrementReference(poll, className) {
    if (poll[className]) poll[className] -= 1;
    return className;
};
/**
 * Track a class and add to the given class list.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be tracked.
 */ var $e0bc4d9f5e4062c1$var$trackClass = function trackClass(classListRef, poll, classes) {
    classes.forEach(function(className) {
        $e0bc4d9f5e4062c1$var$incrementReference(poll, className);
        classListRef.add(className);
    });
};
/**
 * Untrack a class and remove from the given class list if the reference
 * reaches 0.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be untracked.
 */ var $e0bc4d9f5e4062c1$var$untrackClass = function untrackClass(classListRef, poll, classes) {
    classes.forEach(function(className) {
        $e0bc4d9f5e4062c1$var$decrementReference(poll, className);
        poll[className] === 0 && classListRef.remove(className);
    });
};
/**
 * Public inferface to add classes to the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */ var $e0bc4d9f5e4062c1$var$add = $e0bc4d9f5e4062c1$exports.add = function add(element, classString) {
    return $e0bc4d9f5e4062c1$var$trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? $e0bc4d9f5e4062c1$var$htmlClassList : $e0bc4d9f5e4062c1$var$docBodyClassList, classString.split(" "));
};
/**
 * Public inferface to remove classes from the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */ var $e0bc4d9f5e4062c1$var$remove = $e0bc4d9f5e4062c1$exports.remove = function remove(element, classString) {
    return $e0bc4d9f5e4062c1$var$untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? $e0bc4d9f5e4062c1$var$htmlClassList : $e0bc4d9f5e4062c1$var$docBodyClassList, classString.split(" "));
};


var $c97ebba6a2cb77a6$var$classList = $c97ebba6a2cb77a6$var$_interopRequireWildcard($e0bc4d9f5e4062c1$exports);

var $c97ebba6a2cb77a6$var$_safeHTMLElement2 = $c97ebba6a2cb77a6$var$_interopRequireDefault($468a7cc76bb195cf$exports);
var $bcdfc7561146644d$exports = {};
"use strict";
Object.defineProperty($bcdfc7561146644d$exports, "__esModule", {
    value: true
});
$bcdfc7561146644d$exports.log = $bcdfc7561146644d$var$log;
$bcdfc7561146644d$exports.resetState = $bcdfc7561146644d$var$resetState;
function $bcdfc7561146644d$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
// Tracks portals that are open and emits events to subscribers
var $bcdfc7561146644d$var$PortalOpenInstances = function PortalOpenInstances() {
    var _this = this;
    $bcdfc7561146644d$var$_classCallCheck(this, PortalOpenInstances);
    this.register = function(openInstance) {
        if (_this.openInstances.indexOf(openInstance) !== -1) return;
        _this.openInstances.push(openInstance);
        _this.emit("register");
    };
    this.deregister = function(openInstance) {
        var index = _this.openInstances.indexOf(openInstance);
        if (index === -1) return;
        _this.openInstances.splice(index, 1);
        _this.emit("deregister");
    };
    this.subscribe = function(callback) {
        _this.subscribers.push(callback);
    };
    this.emit = function(eventType) {
        _this.subscribers.forEach(function(subscriber) {
            return subscriber(eventType, // shallow copy to avoid accidental mutation
            _this.openInstances.slice());
        });
    };
    this.openInstances = [];
    this.subscribers = [];
};
var $bcdfc7561146644d$var$portalOpenInstances = new $bcdfc7561146644d$var$PortalOpenInstances();
/* eslint-disable no-console */ /* istanbul ignore next */ function $bcdfc7561146644d$var$log() {
    console.log("portalOpenInstances ----------");
    console.log($bcdfc7561146644d$var$portalOpenInstances.openInstances.length);
    $bcdfc7561146644d$var$portalOpenInstances.openInstances.forEach(function(p) {
        return console.log(p);
    });
    console.log("end portalOpenInstances ----------");
}
/* istanbul ignore next */ function $bcdfc7561146644d$var$resetState() {
    $bcdfc7561146644d$var$portalOpenInstances = new $bcdfc7561146644d$var$PortalOpenInstances();
}
/* eslint-enable no-console */ $bcdfc7561146644d$exports.default = $bcdfc7561146644d$var$portalOpenInstances;


var $c97ebba6a2cb77a6$var$_portalOpenInstances2 = $c97ebba6a2cb77a6$var$_interopRequireDefault($bcdfc7561146644d$exports);
var $fd3d5a94e0d2819b$exports = {};
"use strict";
Object.defineProperty($fd3d5a94e0d2819b$exports, "__esModule", {
    value: true
});
$fd3d5a94e0d2819b$exports.resetState = $fd3d5a94e0d2819b$var$resetState;
$fd3d5a94e0d2819b$exports.log = $fd3d5a94e0d2819b$var$log;

var $fd3d5a94e0d2819b$var$_portalOpenInstances2 = $fd3d5a94e0d2819b$var$_interopRequireDefault($bcdfc7561146644d$exports);
function $fd3d5a94e0d2819b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// Body focus trap see Issue #742
var $fd3d5a94e0d2819b$var$before = void 0, $fd3d5a94e0d2819b$var$after = void 0, $fd3d5a94e0d2819b$var$instances = [];
/* eslint-disable no-console */ /* istanbul ignore next */ function $fd3d5a94e0d2819b$var$resetState() {
    var _arr = [
        $fd3d5a94e0d2819b$var$before,
        $fd3d5a94e0d2819b$var$after
    ];
    for(var _i = 0; _i < _arr.length; _i++){
        var item = _arr[_i];
        if (!item) continue;
        item.parentNode && item.parentNode.removeChild(item);
    }
    $fd3d5a94e0d2819b$var$before = $fd3d5a94e0d2819b$var$after = null;
    $fd3d5a94e0d2819b$var$instances = [];
}
/* istanbul ignore next */ function $fd3d5a94e0d2819b$var$log() {
    console.log("bodyTrap ----------");
    console.log($fd3d5a94e0d2819b$var$instances.length);
    var _arr2 = [
        $fd3d5a94e0d2819b$var$before,
        $fd3d5a94e0d2819b$var$after
    ];
    for(var _i2 = 0; _i2 < _arr2.length; _i2++){
        var item = _arr2[_i2];
        var check = item || {};
        console.log(check.nodeName, check.className, check.id);
    }
    console.log("edn bodyTrap ----------");
}
/* eslint-enable no-console */ function $fd3d5a94e0d2819b$var$focusContent() {
    if ($fd3d5a94e0d2819b$var$instances.length === 0) return;
    $fd3d5a94e0d2819b$var$instances[$fd3d5a94e0d2819b$var$instances.length - 1].focusContent();
}
function $fd3d5a94e0d2819b$var$bodyTrap(eventType, openInstances) {
    if (!$fd3d5a94e0d2819b$var$before && !$fd3d5a94e0d2819b$var$after) {
        $fd3d5a94e0d2819b$var$before = document.createElement("div");
        $fd3d5a94e0d2819b$var$before.setAttribute("data-react-modal-body-trap", "");
        $fd3d5a94e0d2819b$var$before.style.position = "absolute";
        $fd3d5a94e0d2819b$var$before.style.opacity = "0";
        $fd3d5a94e0d2819b$var$before.setAttribute("tabindex", "0");
        $fd3d5a94e0d2819b$var$before.addEventListener("focus", $fd3d5a94e0d2819b$var$focusContent);
        $fd3d5a94e0d2819b$var$after = $fd3d5a94e0d2819b$var$before.cloneNode();
        $fd3d5a94e0d2819b$var$after.addEventListener("focus", $fd3d5a94e0d2819b$var$focusContent);
    }
    $fd3d5a94e0d2819b$var$instances = openInstances;
    if ($fd3d5a94e0d2819b$var$instances.length > 0) {
        // Add focus trap
        if (document.body.firstChild !== $fd3d5a94e0d2819b$var$before) document.body.insertBefore($fd3d5a94e0d2819b$var$before, document.body.firstChild);
        if (document.body.lastChild !== $fd3d5a94e0d2819b$var$after) document.body.appendChild($fd3d5a94e0d2819b$var$after);
    } else {
        // Remove focus trap
        if ($fd3d5a94e0d2819b$var$before.parentElement) $fd3d5a94e0d2819b$var$before.parentElement.removeChild($fd3d5a94e0d2819b$var$before);
        if ($fd3d5a94e0d2819b$var$after.parentElement) $fd3d5a94e0d2819b$var$after.parentElement.removeChild($fd3d5a94e0d2819b$var$after);
    }
}
$fd3d5a94e0d2819b$var$_portalOpenInstances2.default.subscribe($fd3d5a94e0d2819b$var$bodyTrap);


function $c97ebba6a2cb77a6$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $c97ebba6a2cb77a6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c97ebba6a2cb77a6$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c97ebba6a2cb77a6$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $c97ebba6a2cb77a6$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
// so that our CSS is statically analyzable
var $c97ebba6a2cb77a6$var$CLASS_NAMES = {
    overlay: "ReactModal__Overlay",
    content: "ReactModal__Content"
};
var $c97ebba6a2cb77a6$var$TAB_KEY = 9;
var $c97ebba6a2cb77a6$var$ESC_KEY = 27;
var $c97ebba6a2cb77a6$var$ariaHiddenInstances = 0;
var $c97ebba6a2cb77a6$var$ModalPortal = function(_Component) {
    $c97ebba6a2cb77a6$var$_inherits(ModalPortal, _Component);
    function ModalPortal(props) {
        $c97ebba6a2cb77a6$var$_classCallCheck(this, ModalPortal);
        var _this = $c97ebba6a2cb77a6$var$_possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));
        _this.setOverlayRef = function(overlay) {
            _this.overlay = overlay;
            _this.props.overlayRef && _this.props.overlayRef(overlay);
        };
        _this.setContentRef = function(content) {
            _this.content = content;
            _this.props.contentRef && _this.props.contentRef(content);
        };
        _this.afterClose = function() {
            var _this$props = _this.props, appElement = _this$props.appElement, ariaHideApp = _this$props.ariaHideApp, htmlOpenClassName = _this$props.htmlOpenClassName, bodyOpenClassName = _this$props.bodyOpenClassName;
            // Remove classes.
            bodyOpenClassName && $c97ebba6a2cb77a6$var$classList.remove(document.body, bodyOpenClassName);
            htmlOpenClassName && $c97ebba6a2cb77a6$var$classList.remove(document.getElementsByTagName("html")[0], htmlOpenClassName);
            // Reset aria-hidden attribute if all modals have been removed
            if (ariaHideApp && $c97ebba6a2cb77a6$var$ariaHiddenInstances > 0) {
                $c97ebba6a2cb77a6$var$ariaHiddenInstances -= 1;
                if ($c97ebba6a2cb77a6$var$ariaHiddenInstances === 0) $c97ebba6a2cb77a6$var$ariaAppHider.show(appElement);
            }
            if (_this.props.shouldFocusAfterRender) {
                if (_this.props.shouldReturnFocusAfterClose) {
                    $c97ebba6a2cb77a6$var$focusManager.returnFocus(_this.props.preventScroll);
                    $c97ebba6a2cb77a6$var$focusManager.teardownScopedFocus();
                } else $c97ebba6a2cb77a6$var$focusManager.popWithoutFocus();
            }
            if (_this.props.onAfterClose) _this.props.onAfterClose();
            $c97ebba6a2cb77a6$var$_portalOpenInstances2.default.deregister(_this);
        };
        _this.open = function() {
            _this.beforeOpen();
            if (_this.state.afterOpen && _this.state.beforeClose) {
                clearTimeout(_this.closeTimer);
                _this.setState({
                    beforeClose: false
                });
            } else {
                if (_this.props.shouldFocusAfterRender) {
                    $c97ebba6a2cb77a6$var$focusManager.setupScopedFocus(_this.node);
                    $c97ebba6a2cb77a6$var$focusManager.markForFocusLater();
                }
                _this.setState({
                    isOpen: true
                }, function() {
                    _this.openAnimationFrame = requestAnimationFrame(function() {
                        _this.setState({
                            afterOpen: true
                        });
                        if (_this.props.isOpen && _this.props.onAfterOpen) _this.props.onAfterOpen({
                            overlayEl: _this.overlay,
                            contentEl: _this.content
                        });
                    });
                });
            }
        };
        _this.close = function() {
            if (_this.props.closeTimeoutMS > 0) _this.closeWithTimeout();
            else _this.closeWithoutTimeout();
        };
        _this.focusContent = function() {
            return _this.content && !_this.contentHasFocus() && _this.content.focus({
                preventScroll: true
            });
        };
        _this.closeWithTimeout = function() {
            var closesAt = Date.now() + _this.props.closeTimeoutMS;
            _this.setState({
                beforeClose: true,
                closesAt: closesAt
            }, function() {
                _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
            });
        };
        _this.closeWithoutTimeout = function() {
            _this.setState({
                beforeClose: false,
                isOpen: false,
                afterOpen: false,
                closesAt: null
            }, _this.afterClose);
        };
        _this.handleKeyDown = function(event) {
            if (event.keyCode === $c97ebba6a2cb77a6$var$TAB_KEY) (0, $c97ebba6a2cb77a6$var$_scopeTab2.default)(_this.content, event);
            if (_this.props.shouldCloseOnEsc && event.keyCode === $c97ebba6a2cb77a6$var$ESC_KEY) {
                event.stopPropagation();
                _this.requestClose(event);
            }
        };
        _this.handleOverlayOnClick = function(event) {
            if (_this.shouldClose === null) _this.shouldClose = true;
            if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
                if (_this.ownerHandlesClose()) _this.requestClose(event);
                else _this.focusContent();
            }
            _this.shouldClose = null;
        };
        _this.handleContentOnMouseUp = function() {
            _this.shouldClose = false;
        };
        _this.handleOverlayOnMouseDown = function(event) {
            if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) event.preventDefault();
        };
        _this.handleContentOnClick = function() {
            _this.shouldClose = false;
        };
        _this.handleContentOnMouseDown = function() {
            _this.shouldClose = false;
        };
        _this.requestClose = function(event) {
            return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
        };
        _this.ownerHandlesClose = function() {
            return _this.props.onRequestClose;
        };
        _this.shouldBeClosed = function() {
            return !_this.state.isOpen && !_this.state.beforeClose;
        };
        _this.contentHasFocus = function() {
            return document.activeElement === _this.content || _this.content.contains(document.activeElement);
        };
        _this.buildClassName = function(which, additional) {
            var classNames = (typeof additional === "undefined" ? "undefined" : $c97ebba6a2cb77a6$var$_typeof(additional)) === "object" ? additional : {
                base: $c97ebba6a2cb77a6$var$CLASS_NAMES[which],
                afterOpen: $c97ebba6a2cb77a6$var$CLASS_NAMES[which] + "--after-open",
                beforeClose: $c97ebba6a2cb77a6$var$CLASS_NAMES[which] + "--before-close"
            };
            var className = classNames.base;
            if (_this.state.afterOpen) className = className + " " + classNames.afterOpen;
            if (_this.state.beforeClose) className = className + " " + classNames.beforeClose;
            return typeof additional === "string" && additional ? className + " " + additional : className;
        };
        _this.attributesFromObject = function(prefix, items) {
            return Object.keys(items).reduce(function(acc, name) {
                acc[prefix + "-" + name] = items[name];
                return acc;
            }, {});
        };
        _this.state = {
            afterOpen: false,
            beforeClose: false
        };
        _this.shouldClose = null;
        _this.moveFromContentToOverlay = null;
        return _this;
    }
    $c97ebba6a2cb77a6$var$_createClass(ModalPortal, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (this.props.isOpen) this.open();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                if (this.props.isOpen && !prevProps.isOpen) this.open();
                else if (!this.props.isOpen && prevProps.isOpen) this.close();
                // Focus only needs to be set once when the modal is being opened
                if (this.props.shouldFocusAfterRender && this.state.isOpen && !prevState.isOpen) this.focusContent();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.state.isOpen) this.afterClose();
                clearTimeout(this.closeTimer);
                cancelAnimationFrame(this.openAnimationFrame);
            }
        },
        {
            key: "beforeOpen",
            value: function beforeOpen() {
                var _props = this.props, appElement = _props.appElement, ariaHideApp = _props.ariaHideApp, htmlOpenClassName = _props.htmlOpenClassName, bodyOpenClassName = _props.bodyOpenClassName;
                // Add classes.
                bodyOpenClassName && $c97ebba6a2cb77a6$var$classList.add(document.body, bodyOpenClassName);
                htmlOpenClassName && $c97ebba6a2cb77a6$var$classList.add(document.getElementsByTagName("html")[0], htmlOpenClassName);
                if (ariaHideApp) {
                    $c97ebba6a2cb77a6$var$ariaHiddenInstances += 1;
                    $c97ebba6a2cb77a6$var$ariaAppHider.hide(appElement);
                }
                $c97ebba6a2cb77a6$var$_portalOpenInstances2.default.register(this);
            }
        },
        {
            key: "render",
            value: function render() {
                var _props2 = this.props, id = _props2.id, className = _props2.className, overlayClassName = _props2.overlayClassName, defaultStyles = _props2.defaultStyles, children = _props2.children;
                var contentStyles = className ? {} : defaultStyles.content;
                var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;
                if (this.shouldBeClosed()) return null;
                var overlayProps = {
                    ref: this.setOverlayRef,
                    className: this.buildClassName("overlay", overlayClassName),
                    style: $c97ebba6a2cb77a6$var$_extends({}, overlayStyles, this.props.style.overlay),
                    onClick: this.handleOverlayOnClick,
                    onMouseDown: this.handleOverlayOnMouseDown
                };
                var contentProps = $c97ebba6a2cb77a6$var$_extends({
                    id: id,
                    ref: this.setContentRef,
                    style: $c97ebba6a2cb77a6$var$_extends({}, contentStyles, this.props.style.content),
                    className: this.buildClassName("content", className),
                    tabIndex: "-1",
                    onKeyDown: this.handleKeyDown,
                    onMouseDown: this.handleContentOnMouseDown,
                    onMouseUp: this.handleContentOnMouseUp,
                    onClick: this.handleContentOnClick,
                    role: this.props.role,
                    "aria-label": this.props.contentLabel
                }, this.attributesFromObject("aria", $c97ebba6a2cb77a6$var$_extends({
                    modal: true
                }, this.props.aria)), this.attributesFromObject("data", this.props.data || {}), {
                    "data-testid": this.props.testId
                });
                var contentElement = this.props.contentElement(contentProps, children);
                return this.props.overlayElement(overlayProps, contentElement);
            }
        }
    ]);
    return ModalPortal;
}($P551f.Component);
$c97ebba6a2cb77a6$var$ModalPortal.defaultProps = {
    style: {
        overlay: {},
        content: {}
    },
    defaultStyles: {}
};
$c97ebba6a2cb77a6$var$ModalPortal.propTypes = {
    isOpen: $c97ebba6a2cb77a6$var$_propTypes2.default.bool.isRequired,
    defaultStyles: $c97ebba6a2cb77a6$var$_propTypes2.default.shape({
        content: $c97ebba6a2cb77a6$var$_propTypes2.default.object,
        overlay: $c97ebba6a2cb77a6$var$_propTypes2.default.object
    }),
    style: $c97ebba6a2cb77a6$var$_propTypes2.default.shape({
        content: $c97ebba6a2cb77a6$var$_propTypes2.default.object,
        overlay: $c97ebba6a2cb77a6$var$_propTypes2.default.object
    }),
    className: $c97ebba6a2cb77a6$var$_propTypes2.default.oneOfType([
        $c97ebba6a2cb77a6$var$_propTypes2.default.string,
        $c97ebba6a2cb77a6$var$_propTypes2.default.object
    ]),
    overlayClassName: $c97ebba6a2cb77a6$var$_propTypes2.default.oneOfType([
        $c97ebba6a2cb77a6$var$_propTypes2.default.string,
        $c97ebba6a2cb77a6$var$_propTypes2.default.object
    ]),
    bodyOpenClassName: $c97ebba6a2cb77a6$var$_propTypes2.default.string,
    htmlOpenClassName: $c97ebba6a2cb77a6$var$_propTypes2.default.string,
    ariaHideApp: $c97ebba6a2cb77a6$var$_propTypes2.default.bool,
    appElement: $c97ebba6a2cb77a6$var$_propTypes2.default.oneOfType([
        $c97ebba6a2cb77a6$var$_propTypes2.default.instanceOf($c97ebba6a2cb77a6$var$_safeHTMLElement2.default),
        $c97ebba6a2cb77a6$var$_propTypes2.default.instanceOf($468a7cc76bb195cf$exports.SafeHTMLCollection),
        $c97ebba6a2cb77a6$var$_propTypes2.default.instanceOf($468a7cc76bb195cf$exports.SafeNodeList),
        $c97ebba6a2cb77a6$var$_propTypes2.default.arrayOf($c97ebba6a2cb77a6$var$_propTypes2.default.instanceOf($c97ebba6a2cb77a6$var$_safeHTMLElement2.default))
    ]),
    onAfterOpen: $c97ebba6a2cb77a6$var$_propTypes2.default.func,
    onAfterClose: $c97ebba6a2cb77a6$var$_propTypes2.default.func,
    onRequestClose: $c97ebba6a2cb77a6$var$_propTypes2.default.func,
    closeTimeoutMS: $c97ebba6a2cb77a6$var$_propTypes2.default.number,
    shouldFocusAfterRender: $c97ebba6a2cb77a6$var$_propTypes2.default.bool,
    shouldCloseOnOverlayClick: $c97ebba6a2cb77a6$var$_propTypes2.default.bool,
    shouldReturnFocusAfterClose: $c97ebba6a2cb77a6$var$_propTypes2.default.bool,
    preventScroll: $c97ebba6a2cb77a6$var$_propTypes2.default.bool,
    role: $c97ebba6a2cb77a6$var$_propTypes2.default.string,
    contentLabel: $c97ebba6a2cb77a6$var$_propTypes2.default.string,
    aria: $c97ebba6a2cb77a6$var$_propTypes2.default.object,
    data: $c97ebba6a2cb77a6$var$_propTypes2.default.object,
    children: $c97ebba6a2cb77a6$var$_propTypes2.default.node,
    shouldCloseOnEsc: $c97ebba6a2cb77a6$var$_propTypes2.default.bool,
    overlayRef: $c97ebba6a2cb77a6$var$_propTypes2.default.func,
    contentRef: $c97ebba6a2cb77a6$var$_propTypes2.default.func,
    id: $c97ebba6a2cb77a6$var$_propTypes2.default.string,
    overlayElement: $c97ebba6a2cb77a6$var$_propTypes2.default.func,
    contentElement: $c97ebba6a2cb77a6$var$_propTypes2.default.func,
    testId: $c97ebba6a2cb77a6$var$_propTypes2.default.string
};
$c97ebba6a2cb77a6$exports.default = $c97ebba6a2cb77a6$var$ModalPortal;
$c97ebba6a2cb77a6$exports = $c97ebba6a2cb77a6$exports["default"];


var $eb08b1491a0a5198$var$_ModalPortal2 = $eb08b1491a0a5198$var$_interopRequireDefault($c97ebba6a2cb77a6$exports);

var $eb08b1491a0a5198$var$ariaAppHider = $eb08b1491a0a5198$var$_interopRequireWildcard($d0cf2f2728d28592$exports);

var $eb08b1491a0a5198$var$_safeHTMLElement2 = $eb08b1491a0a5198$var$_interopRequireDefault($468a7cc76bb195cf$exports);
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $862552385241927e$var$componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function $862552385241927e$var$componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function $862552385241927e$var$componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
$862552385241927e$var$componentWillMount.__suppressDeprecationWarning = true;
$862552385241927e$var$componentWillReceiveProps.__suppressDeprecationWarning = true;
$862552385241927e$var$componentWillUpdate.__suppressDeprecationWarning = true;
function $862552385241927e$export$cea1c58a6db52bca(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error("Can only polyfill class components");
    if (typeof Component.getDerivedStateFromProps !== "function" && typeof prototype.getSnapshotBeforeUpdate !== "function") return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === "function") foundWillMountName = "componentWillMount";
    else if (typeof prototype.UNSAFE_componentWillMount === "function") foundWillMountName = "UNSAFE_componentWillMount";
    if (typeof prototype.componentWillReceiveProps === "function") foundWillReceivePropsName = "componentWillReceiveProps";
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === "function") foundWillReceivePropsName = "UNSAFE_componentWillReceiveProps";
    if (typeof prototype.componentWillUpdate === "function") foundWillUpdateName = "componentWillUpdate";
    else if (typeof prototype.UNSAFE_componentWillUpdate === "function") foundWillUpdateName = "UNSAFE_componentWillUpdate";
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
        throw Error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n" + componentName + " uses " + newApiName + " but also contains the following legacy lifecycles:" + (foundWillMountName !== null ? "\n  " + foundWillMountName : "") + (foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : "") + (foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : "") + "\n\nThe above lifecycles should be removed. Learn more about this warning here:\n" + "https://fb.me/react-async-component-lifecycle-hooks");
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === "function") {
        prototype.componentWillMount = $862552385241927e$var$componentWillMount;
        prototype.componentWillReceiveProps = $862552385241927e$var$componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === "function") {
        if (typeof prototype.componentDidUpdate !== "function") throw new Error("Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype");
        prototype.componentWillUpdate = $862552385241927e$var$componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}


function $eb08b1491a0a5198$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $eb08b1491a0a5198$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $eb08b1491a0a5198$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $eb08b1491a0a5198$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $eb08b1491a0a5198$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $eb08b1491a0a5198$var$portalClassName = $eb08b1491a0a5198$exports.portalClassName = "ReactModalPortal";
var $eb08b1491a0a5198$var$bodyOpenClassName = $eb08b1491a0a5198$exports.bodyOpenClassName = "ReactModal__Body--open";
var $eb08b1491a0a5198$var$isReact16 = $468a7cc76bb195cf$exports.canUseDOM && $eb08b1491a0a5198$var$_reactDom2.default.createPortal !== undefined;
var $eb08b1491a0a5198$var$createHTMLElement = function createHTMLElement(name) {
    return document.createElement(name);
};
var $eb08b1491a0a5198$var$getCreatePortal = function getCreatePortal() {
    return $eb08b1491a0a5198$var$isReact16 ? $eb08b1491a0a5198$var$_reactDom2.default.createPortal : $eb08b1491a0a5198$var$_reactDom2.default.unstable_renderSubtreeIntoContainer;
};
function $eb08b1491a0a5198$var$getParentElement(parentSelector) {
    return parentSelector();
}
var $eb08b1491a0a5198$var$Modal = function(_Component) {
    $eb08b1491a0a5198$var$_inherits(Modal, _Component);
    function Modal() {
        var _ref;
        var _temp, _this, _ret;
        $eb08b1491a0a5198$var$_classCallCheck(this, Modal);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $eb08b1491a0a5198$var$_possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.removePortal = function() {
            !$eb08b1491a0a5198$var$isReact16 && $eb08b1491a0a5198$var$_reactDom2.default.unmountComponentAtNode(_this.node);
            var parent = $eb08b1491a0a5198$var$getParentElement(_this.props.parentSelector);
            if (parent && parent.contains(_this.node)) parent.removeChild(_this.node);
            else // eslint-disable-next-line no-console
            console.warn('React-Modal: "parentSelector" prop did not returned any DOM element. Make sure that the parent element is unmounted to avoid any memory leaks.');
        }, _this.portalRef = function(ref) {
            _this.portal = ref;
        }, _this.renderPortal = function(props) {
            var createPortal = $eb08b1491a0a5198$var$getCreatePortal();
            var portal = createPortal(_this, $eb08b1491a0a5198$var$_react2.default.createElement($eb08b1491a0a5198$var$_ModalPortal2.default, $eb08b1491a0a5198$var$_extends({
                defaultStyles: Modal.defaultStyles
            }, props)), _this.node);
            _this.portalRef(portal);
        }, _temp), $eb08b1491a0a5198$var$_possibleConstructorReturn(_this, _ret);
    }
    $eb08b1491a0a5198$var$_createClass(Modal, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (!$468a7cc76bb195cf$exports.canUseDOM) return;
                if (!$eb08b1491a0a5198$var$isReact16) this.node = $eb08b1491a0a5198$var$createHTMLElement("div");
                this.node.className = this.props.portalClassName;
                var parent = $eb08b1491a0a5198$var$getParentElement(this.props.parentSelector);
                parent.appendChild(this.node);
                !$eb08b1491a0a5198$var$isReact16 && this.renderPortal(this.props);
            }
        },
        {
            key: "getSnapshotBeforeUpdate",
            value: function getSnapshotBeforeUpdate(prevProps) {
                var prevParent = $eb08b1491a0a5198$var$getParentElement(prevProps.parentSelector);
                var nextParent = $eb08b1491a0a5198$var$getParentElement(this.props.parentSelector);
                return {
                    prevParent: prevParent,
                    nextParent: nextParent
                };
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, _, snapshot) {
                if (!$468a7cc76bb195cf$exports.canUseDOM) return;
                var _props = this.props, isOpen = _props.isOpen, portalClassName = _props.portalClassName;
                if (prevProps.portalClassName !== portalClassName) this.node.className = portalClassName;
                var prevParent = snapshot.prevParent, nextParent = snapshot.nextParent;
                if (nextParent !== prevParent) {
                    prevParent.removeChild(this.node);
                    nextParent.appendChild(this.node);
                }
                // Stop unnecessary renders if modal is remaining closed
                if (!prevProps.isOpen && !isOpen) return;
                !$eb08b1491a0a5198$var$isReact16 && this.renderPortal(this.props);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (!$468a7cc76bb195cf$exports.canUseDOM || !this.node || !this.portal) return;
                var state = this.portal.state;
                var now = Date.now();
                var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);
                if (closesAt) {
                    if (!state.beforeClose) this.portal.closeWithTimeout();
                    setTimeout(this.removePortal, closesAt - now);
                } else this.removePortal();
            }
        },
        {
            key: "render",
            value: function render() {
                if (!$468a7cc76bb195cf$exports.canUseDOM || !$eb08b1491a0a5198$var$isReact16) return null;
                if (!this.node && $eb08b1491a0a5198$var$isReact16) this.node = $eb08b1491a0a5198$var$createHTMLElement("div");
                var createPortal = $eb08b1491a0a5198$var$getCreatePortal();
                return createPortal($eb08b1491a0a5198$var$_react2.default.createElement($eb08b1491a0a5198$var$_ModalPortal2.default, $eb08b1491a0a5198$var$_extends({
                    ref: this.portalRef,
                    defaultStyles: Modal.defaultStyles
                }, this.props)), this.node);
            }
        }
    ], [
        {
            key: "setAppElement",
            value: function setAppElement(element) {
                $eb08b1491a0a5198$var$ariaAppHider.setElement(element);
            }
        }
    ]);
    return Modal;
}($P551f.Component);
$eb08b1491a0a5198$var$Modal.propTypes = {
    isOpen: $eb08b1491a0a5198$var$_propTypes2.default.bool.isRequired,
    style: $eb08b1491a0a5198$var$_propTypes2.default.shape({
        content: $eb08b1491a0a5198$var$_propTypes2.default.object,
        overlay: $eb08b1491a0a5198$var$_propTypes2.default.object
    }),
    portalClassName: $eb08b1491a0a5198$var$_propTypes2.default.string,
    bodyOpenClassName: $eb08b1491a0a5198$var$_propTypes2.default.string,
    htmlOpenClassName: $eb08b1491a0a5198$var$_propTypes2.default.string,
    className: $eb08b1491a0a5198$var$_propTypes2.default.oneOfType([
        $eb08b1491a0a5198$var$_propTypes2.default.string,
        $eb08b1491a0a5198$var$_propTypes2.default.shape({
            base: $eb08b1491a0a5198$var$_propTypes2.default.string.isRequired,
            afterOpen: $eb08b1491a0a5198$var$_propTypes2.default.string.isRequired,
            beforeClose: $eb08b1491a0a5198$var$_propTypes2.default.string.isRequired
        })
    ]),
    overlayClassName: $eb08b1491a0a5198$var$_propTypes2.default.oneOfType([
        $eb08b1491a0a5198$var$_propTypes2.default.string,
        $eb08b1491a0a5198$var$_propTypes2.default.shape({
            base: $eb08b1491a0a5198$var$_propTypes2.default.string.isRequired,
            afterOpen: $eb08b1491a0a5198$var$_propTypes2.default.string.isRequired,
            beforeClose: $eb08b1491a0a5198$var$_propTypes2.default.string.isRequired
        })
    ]),
    appElement: $eb08b1491a0a5198$var$_propTypes2.default.oneOfType([
        $eb08b1491a0a5198$var$_propTypes2.default.instanceOf($eb08b1491a0a5198$var$_safeHTMLElement2.default),
        $eb08b1491a0a5198$var$_propTypes2.default.instanceOf($468a7cc76bb195cf$exports.SafeHTMLCollection),
        $eb08b1491a0a5198$var$_propTypes2.default.instanceOf($468a7cc76bb195cf$exports.SafeNodeList),
        $eb08b1491a0a5198$var$_propTypes2.default.arrayOf($eb08b1491a0a5198$var$_propTypes2.default.instanceOf($eb08b1491a0a5198$var$_safeHTMLElement2.default))
    ]),
    onAfterOpen: $eb08b1491a0a5198$var$_propTypes2.default.func,
    onRequestClose: $eb08b1491a0a5198$var$_propTypes2.default.func,
    closeTimeoutMS: $eb08b1491a0a5198$var$_propTypes2.default.number,
    ariaHideApp: $eb08b1491a0a5198$var$_propTypes2.default.bool,
    shouldFocusAfterRender: $eb08b1491a0a5198$var$_propTypes2.default.bool,
    shouldCloseOnOverlayClick: $eb08b1491a0a5198$var$_propTypes2.default.bool,
    shouldReturnFocusAfterClose: $eb08b1491a0a5198$var$_propTypes2.default.bool,
    preventScroll: $eb08b1491a0a5198$var$_propTypes2.default.bool,
    parentSelector: $eb08b1491a0a5198$var$_propTypes2.default.func,
    aria: $eb08b1491a0a5198$var$_propTypes2.default.object,
    data: $eb08b1491a0a5198$var$_propTypes2.default.object,
    role: $eb08b1491a0a5198$var$_propTypes2.default.string,
    contentLabel: $eb08b1491a0a5198$var$_propTypes2.default.string,
    shouldCloseOnEsc: $eb08b1491a0a5198$var$_propTypes2.default.bool,
    overlayRef: $eb08b1491a0a5198$var$_propTypes2.default.func,
    contentRef: $eb08b1491a0a5198$var$_propTypes2.default.func,
    id: $eb08b1491a0a5198$var$_propTypes2.default.string,
    overlayElement: $eb08b1491a0a5198$var$_propTypes2.default.func,
    contentElement: $eb08b1491a0a5198$var$_propTypes2.default.func
};
$eb08b1491a0a5198$var$Modal.defaultProps = {
    isOpen: false,
    portalClassName: $eb08b1491a0a5198$var$portalClassName,
    bodyOpenClassName: $eb08b1491a0a5198$var$bodyOpenClassName,
    role: "dialog",
    ariaHideApp: true,
    closeTimeoutMS: 0,
    shouldFocusAfterRender: true,
    shouldCloseOnEsc: true,
    shouldCloseOnOverlayClick: true,
    shouldReturnFocusAfterClose: true,
    preventScroll: false,
    parentSelector: function parentSelector() {
        return document.body;
    },
    overlayElement: function overlayElement(props, contentEl) {
        return $eb08b1491a0a5198$var$_react2.default.createElement("div", props, contentEl);
    },
    contentElement: function contentElement(props, children) {
        return $eb08b1491a0a5198$var$_react2.default.createElement("div", props, children);
    }
};
$eb08b1491a0a5198$var$Modal.defaultStyles = {
    overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(255, 255, 255, 0.75)"
    },
    content: {
        position: "absolute",
        top: "40px",
        left: "40px",
        right: "40px",
        bottom: "40px",
        border: "1px solid #ccc",
        background: "#fff",
        overflow: "auto",
        WebkitOverflowScrolling: "touch",
        borderRadius: "4px",
        outline: "none",
        padding: "20px"
    }
};
(0, $862552385241927e$export$cea1c58a6db52bca)($eb08b1491a0a5198$var$Modal);
$eb08b1491a0a5198$exports.default = $eb08b1491a0a5198$var$Modal;


var $e479b6ac5364ae16$var$_Modal2 = $e479b6ac5364ae16$var$_interopRequireDefault($eb08b1491a0a5198$exports);
function $e479b6ac5364ae16$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$e479b6ac5364ae16$exports.default = $e479b6ac5364ae16$var$_Modal2.default;
$e479b6ac5364ae16$exports = $e479b6ac5364ae16$exports["default"];



const $d3a343049ebb557e$export$670d48958e84d448 = (value)=>{
    if (value) return Array.isArray(value) ? value : [
        value
    ];
    return [];
};
// Disable FP rules here to use the performant approach while keep the function itself "FP"
/* eslint-disable @silverhand/fp/no-let, @silverhand/fp/no-mutation */ const $d3a343049ebb557e$export$76d90c956114f2c2 = (times, initial, iterate)=>{
    let result = initial;
    while(times--)result = iterate(result);
    return result;
};
/* eslint-enable @silverhand/fp/no-let, @silverhand/fp/no-mutation */ const $d3a343049ebb557e$export$6b75200e58bc97d0 = (array)=>[
        ...new Set(array)
    ];


// https://github.com/facebook/jest/issues/7547
const $4f95a9cf034a847d$export$a7a9523472993e97 = (value, error)=>{
    if (!value) // https://github.com/typescript-eslint/typescript-eslint/issues/3814
    // eslint-disable-next-line @typescript-eslint/no-throw-literal
    throw error;
};


// eslint-disable-next-line id-length
const $f9ef0789ef4e87f0$var$compareFunction = (a, b)=>{
    if (typeof a === "string" && typeof b === "string") return a.localeCompare(b);
    if (typeof a === "number" && typeof b === "number") return a - b;
    if (typeof a === "boolean" && typeof b === "boolean") return Number(a) - Number(b);
    throw new Error("Unsupported compare type");
};
const $f9ef0789ef4e87f0$export$12dc7a11e2f7584e = (array1, array2)=>{
    if (array1.length !== array2.length) return false;
    const sortedA = array1.slice().sort($f9ef0789ef4e87f0$var$compareFunction);
    const sortedB = array2.slice().sort($f9ef0789ef4e87f0$var$compareFunction);
    return sortedA.every((value, index)=>value === sortedB[index]);
};
// eslint-disable-next-line unicorn/prefer-native-coercion-functions
const $f9ef0789ef4e87f0$export$ccb441c9c5feb3fc = (value)=>Boolean(value);
const $f9ef0789ef4e87f0$export$b29ea735dcfba3c1 = (value)=>value !== null && value !== undefined;
const $f9ef0789ef4e87f0$export$a4f4bb6b1453fff5 = (data, property)=>Object.prototype.hasOwnProperty.call(data, property);
const $f9ef0789ef4e87f0$export$fb789885f1f64dd7 = (string)=>Boolean(/[\u3400-\u4DBF\u4E00-\u9FFF\uF900-\uFAFF]/.test(string));
/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */ // eslint-disable-next-line @typescript-eslint/ban-types -- this is a utility function
const $f9ef0789ef4e87f0$var$isObject = (object)=>Object.prototype.toString.call(object) === "[object Object]";
/** Returns true if an object was created by the `Object` constructor, or `Object.create(null)`. */ function $f9ef0789ef4e87f0$export$53b83ca8eaab0383(object) {
    if (!$f9ef0789ef4e87f0$var$isObject(object)) return false;
    // If has modified constructor
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (object.constructor === undefined) return true;
    // If has modified prototype
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, prefer-destructuring
    const prototype = object.constructor.prototype;
    if (!$f9ef0789ef4e87f0$var$isObject(prototype)) return false;
    // If constructor does not have an Object-specific method
    if (!$f9ef0789ef4e87f0$export$a4f4bb6b1453fff5(prototype, "isPrototypeOf")) return false;
    // Most likely a plain Object
    return true;
}



const $dd763c2393b0d659$export$133fc36489ac9add = (exp)=>(0, $f9ef0789ef4e87f0$export$ccb441c9c5feb3fc)(exp) ? exp : null;
/**
 * Conditional return the expression result when it's not {@link Falsy};
 * otherwise return `undefined`.
 *
 * @example
 * ```ts
 * conditional(1 && '2') // '2'
 * conditional(false && '1') // undefined
 * ```
 */ const $dd763c2393b0d659$export$c327da55a124987a = (exp)=>(0, $f9ef0789ef4e87f0$export$ccb441c9c5feb3fc)(exp) ? exp : undefined;
/** Alias for {@link conditional}. */ const $dd763c2393b0d659$export$7ffafceb12143143 = $dd763c2393b0d659$export$c327da55a124987a;
/**
 * Conditional return the stringified expression result (using `String`) when it's not {@link Falsy};
 * otherwise return an empty string.
 *
 * @example
 * ```ts
 * conditionalString(1 && 2) // '2'
 * conditionalString(false && '1') // ''
 * ```
 */ const $dd763c2393b0d659$export$78aa88a01782ee9d = (exp)=>(0, $f9ef0789ef4e87f0$export$ccb441c9c5feb3fc)(exp) ? String(exp) : "";
/** Alias for {@link conditionalString}. */ const $dd763c2393b0d659$export$723fe479c809eebc = $dd763c2393b0d659$export$78aa88a01782ee9d;
/**
 * Conditional concat multiple expression results into a array by filtering all {@link Falsy} results
 * and flatten 1 level deep if the expression result is an array.
 *
 * @example
 * ```ts
 * conditionalArray(1, [2, 3]) // [1, 2, 3]
 * ```
 */ const $dd763c2393b0d659$export$c96eff0e57d59a5e = (...exps)=>exps.filter((value)=>(0, $f9ef0789ef4e87f0$export$ccb441c9c5feb3fc)(value)).flat();
/** Alias for {@link conditionalArray}. */ const $dd763c2393b0d659$export$68c43792fed28aa6 = $dd763c2393b0d659$export$c96eff0e57d59a5e;
/**
 * Return a new object with all {@link Falsy} values removed.
 * This function only performs a shallow removal, i.e. it does not remove
 * {@link Falsy} values nested in objects.
 *
 * @example
 * ```ts
 * conditionalObject({
 *   foo: 'foo',
 *   bar: undefined,
 *   baz: false,
 * }) // { foo: 'foo' }
 * ```
 */ const $dd763c2393b0d659$export$6d93be478c042166 = (object)=>// eslint-disable-next-line no-restricted-syntax
    Object.fromEntries(Object.entries(object).filter(([, value])=>(0, $f9ef0789ef4e87f0$export$ccb441c9c5feb3fc)(value)));
/** Alias for {@link conditionalObject}. */ const $dd763c2393b0d659$export$48ab0026c89e64fa = $dd763c2393b0d659$export$6d93be478c042166;




var $gcEbT = parcelRequire("gcEbT");
var $d65330a9eb654f38$var$_process_env_key;
// Browsers don't have `process`
// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
const $d65330a9eb654f38$export$4bd44a2aa29d3d6e = (key, fallback = "")=>{
    return ($d65330a9eb654f38$var$_process_env_key = $gcEbT === null || $gcEbT === void 0 ? void 0 : $gcEbT.env[key]) !== null && $d65330a9eb654f38$var$_process_env_key !== void 0 ? $d65330a9eb654f38$var$_process_env_key : fallback;
};
const $d65330a9eb654f38$export$912b126b3b8a9cf1 = (envKey, fallback = [])=>{
    const rawValue = $d65330a9eb654f38$export$4bd44a2aa29d3d6e(envKey);
    if (!rawValue) return fallback;
    return rawValue.split(",").map((value)=>value.trim()).filter(Boolean);
};
const $d65330a9eb654f38$export$9f11f28d727ba39d = (key)=>{
    // Browsers don't have `process`
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    const value = $gcEbT === null || $gcEbT === void 0 ? void 0 : $gcEbT.env[key];
    (0, $4f95a9cf034a847d$export$a7a9523472993e97)(value, new Error(`env variable ${key} not found`));
    return value;
};
const $d65330a9eb654f38$export$8ee0fc9ee280b4ee = ()=>typeof window === "undefined";


// Intended
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $96962764729a993e$export$8793edee2d425525 = ()=>{};
const $96962764729a993e$export$4369c812aac99591 = (value)=>value !== null && (typeof value === "object" || typeof value === "function") && "then" in value && typeof value.then === "function";
// eslint-disable-next-line @typescript-eslint/promise-function-async
const $96962764729a993e$export$2cb2cb98cc670b59 = (exec, onError)=>{
    const handleError = (error)=>{
        if (onError instanceof Error) throw onError;
        return onError(error);
    };
    try {
        const unwrapped = typeof exec === "function" ? exec() : exec;
        // eslint-disable-next-line promise/prefer-await-to-then
        return $96962764729a993e$export$4369c812aac99591(unwrapped) ? unwrapped.catch(handleError) : unwrapped;
    } catch (error) {
        return handleError(error);
    }
};
// eslint-disable-next-line @typescript-eslint/promise-function-async
const $96962764729a993e$export$a3a27526e073307 = (exec, onError)=>{
    try {
        const unwrapped = typeof exec === "function" ? exec() : exec;
        return $96962764729a993e$export$4369c812aac99591(unwrapped) ? unwrapped.catch((error)=>{
            onError === null || onError === void 0 ? void 0 : onError(error);
        }) : unwrapped;
    } catch (error) {
        onError === null || onError === void 0 ? void 0 : onError(error);
    }
};


const $61982e026cccac2f$export$357523c63a2253b9 = (object, ...keys)=>{
    // eslint-disable-next-line no-restricted-syntax
    return Object.fromEntries(keys.map((key)=>[
            key,
            object[key]
        ]));
};
const $61982e026cccac2f$export$42fd73f889ee4d63 = (...keys)=>(state)=>$61982e026cccac2f$export$357523c63a2253b9(state, ...keys);


function $7ebb618db3110393$export$1294308be85b4eca(string) {
    if (typeof string !== "string") throw new TypeError("Expected a string");
    return string.toLowerCase().replaceAll(/(?:^|\s|-)\S/g, (value)=>value.toUpperCase()).replaceAll("-", " ");
}
/**
 * RFC 4648 section 5: base64url (URL- and filename-safe standard)
 * @link https://datatracker.ietf.org/doc/html/rfc4648#section-5
 */ const $7ebb618db3110393$var$replaceNonUrlSafeCharacters = (base64String)=>base64String.replaceAll("+", "-").replaceAll("/", "_").replaceAll(/=+$/g, "");
const $7ebb618db3110393$var$restoreNonUrlSafeCharacters = (base64String)=>base64String.replaceAll("-", "+").replaceAll("_", "/");
const $7ebb618db3110393$export$cf6f352aaefa956f = {
    isSafe: (input)=>/^[\w-]*$/.test(input),
    encode: (rawString)=>{
        const encodedString = btoa(unescape(encodeURIComponent(rawString)));
        return $7ebb618db3110393$var$replaceNonUrlSafeCharacters(encodedString);
    },
    decode: (encodedString)=>{
        const nonUrlSafeEncodedString = $7ebb618db3110393$var$restoreNonUrlSafeCharacters(encodedString);
        return decodeURIComponent(escape(atob(nonUrlSafeEncodedString)));
    },
    replaceNonUrlSafeCharacters: $7ebb618db3110393$var$replaceNonUrlSafeCharacters,
    restoreNonUrlSafeCharacters: $7ebb618db3110393$var$restoreNonUrlSafeCharacters
};
const $7ebb618db3110393$export$7a668e70ea2210d9 = (value)=>// eslint-disable-next-line no-implicit-coercion
    !!value && [
        "1",
        "true",
        "y",
        "yes",
        "yep",
        "yeah"
    ].includes(value.toLowerCase());



const $72ce7ff777c988e5$export$3988ae62b71be9a3 = (object, keySerial)=>{
    if (object === null || typeof object !== "object") throw new TypeError("Non-object received in `get()`.");
    let result = object;
    for (const key of keySerial.split("."))// @ts-expect-error for performance
    result = result[key];
    return result;
};
const $72ce7ff777c988e5$export$fedb900c0ea4e699 = (...args)=>(0, $96962764729a993e$export$a3a27526e073307)(()=>$72ce7ff777c988e5$export$3988ae62b71be9a3(...args));
/** Same to `get()` but with the strict type definition only to enable IntelliSense. */ const $72ce7ff777c988e5$export$bf7199a9ebcb84a9 = (object, keySerial)=>$72ce7ff777c988e5$export$3988ae62b71be9a3(object, keySerial);


/** Join multiple path segments. This function exists since there's no native implementation in browser. */ const $b39dafdc671b0b08$export$b891921babc70093 = (...segments)=>{
    const result = [];
    for (const segment of segments.join("/").split("/")){
        if (!segment || segment === ".") continue;
        if ([
            ...segment
        ].every((char)=>char === ".")) {
            // eslint-disable-next-line @silverhand/fp/no-mutating-methods
            result.pop();
            continue;
        }
        // eslint-disable-next-line @silverhand/fp/no-mutating-methods
        result.push(segment);
    }
    return "/" + result.join("/");
};
/** Append path segments to the base URL. */ const $b39dafdc671b0b08$export$c3cef1c0537c0eb2 = (baseUrl, ...pathnames)=>new URL($b39dafdc671b0b08$export$b891921babc70093(baseUrl.pathname, ...pathnames), baseUrl);


// eslint-disable-next-line @typescript-eslint/ban-types
const $ead635d18ff5c4e4$export$a6cdc56e425d0d0a = (object)=>object !== null && typeof object === "object";
const $ead635d18ff5c4e4$export$dd89c3a817f05bc7 = (object, key)=>$ead635d18ff5c4e4$export$a6cdc56e425d0d0a(object) && key in object;
/**
 * Remove all keys with `undefined` values from an object. This function only
 * performs a shallow removal, i.e. it does not remove `undefined` values nested
 * in objects.
 *
 * @param object The object to remove `undefined` keys from.
 * @returns A new object with all `undefined` keys removed.
 */ // eslint-disable-next-line @typescript-eslint/ban-types -- this is a utility function
const $ead635d18ff5c4e4$export$8e7457d724841712 = (object)=>// eslint-disable-next-line no-restricted-syntax
    Object.fromEntries(Object.entries(object).filter(([, value])=>value !== undefined));


/* eslint-disable @silverhand/fp/no-let, @silverhand/fp/no-mutation */ function $36460ddb153be61a$export$d2de3aaeafa91619(function_) {
    let called = false;
    let result;
    return function(...args) {
        if (!called) {
            called = true;
            result = function_.apply(this, args);
        }
        return result;
    };
}







class $9f8487c441af1312$export$538b9cc6200b0efa {
    get instance() {
        return this.appInsights;
    }
    get trackPageView() {
        var _this_appInsights;
        return (_this_appInsights = this.appInsights) === null || _this_appInsights === void 0 ? void 0 : _this_appInsights.trackPageView.bind(this.appInsights);
    }
    async setup(cloudRole, config) {
        var _ref, _this_appInsights;
        const connectionStringFromConfig = typeof config === "string" ? config : config === null || config === void 0 ? void 0 : config.connectionString;
        // The string needs to be normalized since it may contain '"'
        const connectionString = (_ref = connectionStringFromConfig !== null && connectionStringFromConfig !== void 0 ? connectionStringFromConfig : "") === null || _ref === void 0 ? void 0 : _ref.replace(/^"?(.*)"?$/g, "$1");
        if (!connectionString) return false;
        if (((_this_appInsights = this.appInsights) === null || _this_appInsights === void 0 ? void 0 : _this_appInsights.config.connectionString) === connectionString) return true;
        try {
            // Lazy load ApplicationInsights modules
            const { ReactPlugin: ReactPlugin, withAITracking: withAITracking } = await (parcelRequire("gMdMh"));
            const { ApplicationInsights: ApplicationInsights } = await (parcelRequire("2kTrc"));
            var _conditional;
            // Conditionally load ClickAnalytics plugin
            const configObject = (_conditional = (0, $dd763c2393b0d659$export$c327da55a124987a)(typeof config === "object" && config)) !== null && _conditional !== void 0 ? _conditional : {};
            const { cookieDomain: cookieDomain, clickPlugin: clickPlugin } = configObject;
            const initClickAnalyticsPlugin = async ()=>{
                const { ClickAnalyticsPlugin: ClickAnalyticsPlugin } = await (parcelRequire("epiMQ"));
                return new ClickAnalyticsPlugin();
            };
            // Assign React props
            // https://github.com/microsoft/applicationinsights-react-js#readme
            this.withAITracking = withAITracking;
            this.reactPlugin = new ReactPlugin();
            // Assign ClickAnalytics prop
            this.clickAnalyticsPlugin = (0, $dd763c2393b0d659$export$c327da55a124987a)(clickPlugin && await initClickAnalyticsPlugin());
            // Init ApplicationInsights instance
            this.appInsights = new ApplicationInsights({
                config: {
                    cookieDomain: cookieDomain,
                    connectionString: connectionString,
                    enableAutoRouteTracking: false,
                    extensions: (0, $dd763c2393b0d659$export$c96eff0e57d59a5e)(this.reactPlugin, this.clickAnalyticsPlugin),
                    extensionConfig: (0, $dd763c2393b0d659$export$c327da55a124987a)(this.clickAnalyticsPlugin && {
                        [this.clickAnalyticsPlugin.identifier]: clickPlugin
                    })
                }
            });
            // Extract UTM parameters
            const searchParams = [
                ...new URLSearchParams(window.location.search).entries()
            ];
            this.utmParameters = Object.fromEntries(searchParams.filter(([key])=>key.startsWith("utm_")));
            this.appInsights.addTelemetryInitializer((item)=>{
                var _item_tags;
                // @see https://github.com/microsoft/ApplicationInsights-JS#example-setting-cloud-role-name
                // @see https://github.com/microsoft/ApplicationInsights-node.js/blob/a573e40fc66981c6a3106bdc5b783d1d94f64231/Schema/PublicSchema/ContextTagKeys.bond#L83
                /* eslint-disable @silverhand/fp/no-mutation */ item.tags = [
                    ...(_item_tags = item.tags) !== null && _item_tags !== void 0 ? _item_tags : [],
                    {
                        "ai.cloud.role": cloudRole
                    }
                ];
            /* eslint-enable @silverhand/fp/no-mutation */ });
            this.appInsights.loadAppInsights();
        } catch (error) {
            console.error("Unable to init ApplicationInsights:");
            console.error(error);
            return false;
        }
        return true;
    }
    withAppInsights(Component) {
        if (!this.reactPlugin || !this.withAITracking) return Component;
        return this.withAITracking(this.reactPlugin, Component, undefined, "appInsightsWrapper");
    }
    constructor(){
        /**
         * URL search parameters that start with `utm_`. It is an empty object until you call `.setup()`,
         * which will read the URL search string and store parameters in this property.
         */ this.utmParameters = {};
    }
}
const $9f8487c441af1312$export$97a4640d2ef590c2 = new $9f8487c441af1312$export$538b9cc6200b0efa();
const $9f8487c441af1312$export$e0392879325cfa36 = $9f8487c441af1312$export$97a4640d2ef590c2.withAppInsights.bind($9f8487c441af1312$export$97a4640d2ef590c2);




var $P551f = parcelRequire("P551f");

const $cb4ffea6932908cb$var$notImplemented = ()=>{
    throw new Error("Not implemented");
};
const $cb4ffea6932908cb$export$c17a2d427d600cd = /*#__PURE__*/ (0, $P551f.createContext)({
    needsSetup: true,
    isSetupFinished: false,
    setup: $cb4ffea6932908cb$var$notImplemented,
    appInsights: $9f8487c441af1312$export$97a4640d2ef590c2
});
const $cb4ffea6932908cb$export$41d5ed2e6aeb716a = ({ children: children })=>{
    const [setupStatus, setSetupStatus] = (0, $P551f.useState)("none");
    const setup = (0, $P551f.useCallback)(async (...args)=>{
        if (setupStatus !== "none") return;
        setSetupStatus("loading");
        const result = await (0, $9f8487c441af1312$export$97a4640d2ef590c2).setup(...args);
        if (result) {
            console.debug("Initialized ApplicationInsights");
            setSetupStatus("initialized");
        } else setSetupStatus("failed");
    }, [
        setupStatus
    ]);
    const context = (0, $P551f.useMemo)(()=>({
            needsSetup: setupStatus === "none",
            isSetupFinished: setupStatus === "initialized" || setupStatus === "failed",
            setup: setup,
            appInsights: $9f8487c441af1312$export$97a4640d2ef590c2
        }), [
        setup,
        setupStatus
    ]);
    return (0, $b1404a408b0d045c$exports.jsx)($cb4ffea6932908cb$export$c17a2d427d600cd.Provider, {
        value: context,
        children: children
    });
};


/**
 * **CAUTION:** This function takes the last two parts of the hostname which may cause issues for
 * some second-level domains, e.g. `.co.uk`.
 */ const $0b705a71be9c4364$export$6006c55f71b07ab6 = ()=>window.location.hostname.split(".").slice(-2).join(".");


function $7e98d45d0a7eb14e$export$1e71eb4bef00f6b0(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $0de5391da8318002$export$581ff339ea0ba762(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $7e98d45d0a7eb14e$export$1e71eb4bef00f6b0)(target, key, source[key]);
        });
    }
    return target;
}


function $71caa11c260adb2e$export$7a4a7e38737aceb4(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


function $451b529b5830e8ac$export$69fdd232f62cde60(source, excluded) {
    if (source == null) return {};
    var target = (0, $71caa11c260adb2e$export$7a4a7e38737aceb4)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}




var $P551f = parcelRequire("P551f");


const $b463edcd3feef6e8$var$AppInsights = ({ cloudRole: cloudRole })=>{
    const { needsSetup: needsSetup, setup: setup } = (0, $P551f.useContext)((0, $cb4ffea6932908cb$export$c17a2d427d600cd));
    (0, $P551f.useEffect)(()=>{
        const run = async ()=>{
            await setup(cloudRole, {
                cookieDomain: (0, $0b705a71be9c4364$export$6006c55f71b07ab6)()
            });
        };
        if (needsSetup) run();
    }, [
        cloudRole,
        needsSetup,
        setup
    ]);
    return null;
};
/**
 * **CAUTION:** Make sure to put this component inside `<LogtoProvider />` or any other
 * context providers that are render-sensitive, since we are lazy loading ApplicationInsights SDKs
 * for better user experience.
 *
 * This component will trigger a render after the ApplicationInsights SDK is loaded which may
 * cause issues for some context providers. For example, `useHandleSignInCallback` will be
 * called twice if you use this component to wrap a `<LogtoProvider />`.
 */ const $b463edcd3feef6e8$var$AppInsightsBoundary = (_param)=>{
    var { children: children } = _param, rest = (0, $451b529b5830e8ac$export$69fdd232f62cde60)(_param, [
        "children"
    ]);
    return (0, $b1404a408b0d045c$exports.jsxs)((0, $cb4ffea6932908cb$export$41d5ed2e6aeb716a), {
        children: [
            (0, $b1404a408b0d045c$exports.jsx)($b463edcd3feef6e8$var$AppInsights, (0, $0de5391da8318002$export$581ff339ea0ba762)({}, rest)),
            children
        ]
    });
};
var $b463edcd3feef6e8$export$2e2bcd8739ae039 = $b463edcd3feef6e8$var$AppInsightsBoundary;





var $P551f = parcelRequire("P551f");
/** The app (either frontend or backend) for a bunch of events. */ 
var $11c380c82e275a01$export$16fa2f45be04daa8;
(function(Component) {
    /** Logto core service. */ Component["Core"] = "core";
    /** Logto Console. */ Component["Console"] = "console";
    /** Logto blog. */ Component["Blog"] = "blog";
    /** Logto official website. */ Component["Website"] = "website";
})($11c380c82e275a01$export$16fa2f45be04daa8 || ($11c380c82e275a01$export$16fa2f45be04daa8 = {}));
var $11c380c82e275a01$export$b8cbc268a2e6b94;
(function(GeneralEvent) {
    /** A user visited the current app, it should be recorded once per session. */ GeneralEvent["Visit"] = "visit";
})($11c380c82e275a01$export$b8cbc268a2e6b94 || ($11c380c82e275a01$export$b8cbc268a2e6b94 = {}));
var $11c380c82e275a01$export$989616d0f60dd871;
(function(CoreEvent) {
    /** An existing user signed in via an interaction. */ CoreEvent["SignIn"] = "sign_in";
    /** A new user has created in an interaction. */ CoreEvent["Register"] = "register";
})($11c380c82e275a01$export$989616d0f60dd871 || ($11c380c82e275a01$export$989616d0f60dd871 = {}));
var $11c380c82e275a01$export$25b0c984d112f523;
(function(ConsoleEvent) {
    /** A user started the onboarding process. */ ConsoleEvent["Onboard"] = "onboard";
})($11c380c82e275a01$export$25b0c984d112f523 || ($11c380c82e275a01$export$25b0c984d112f523 = {}));
var $11c380c82e275a01$export$3a08a98571ac8e3e;
(function(BlogEvent) {
    /** A user viewed a blog post. */ BlogEvent["ViewPost"] = "view_post";
})($11c380c82e275a01$export$3a08a98571ac8e3e || ($11c380c82e275a01$export$3a08a98571ac8e3e = {}));
const $11c380c82e275a01$export$70fb2d88ab3fc3a6 = Object.freeze({
    [$11c380c82e275a01$export$16fa2f45be04daa8.Core]: $11c380c82e275a01$export$989616d0f60dd871,
    [$11c380c82e275a01$export$16fa2f45be04daa8.Console]: (0, $0de5391da8318002$export$581ff339ea0ba762)({}, $11c380c82e275a01$export$25b0c984d112f523, $11c380c82e275a01$export$b8cbc268a2e6b94),
    [$11c380c82e275a01$export$16fa2f45be04daa8.Blog]: (0, $0de5391da8318002$export$581ff339ea0ba762)({}, $11c380c82e275a01$export$3a08a98571ac8e3e, $11c380c82e275a01$export$b8cbc268a2e6b94),
    [$11c380c82e275a01$export$16fa2f45be04daa8.Website]: $11c380c82e275a01$export$b8cbc268a2e6b94
});
function $11c380c82e275a01$export$a13decb7c9026980(component, event, data) {
    return [
        component,
        event,
        data
    ].filter(Boolean).join("/");
}



const $5af77ecb66078c82$var$storageKeyPrefix = "logto:insights:";
/** Track an event after AppInsights SDK is setup, but only once during the current session.  */ const $5af77ecb66078c82$var$TrackOnce = ({ component: component, event: event, customProperties: customProperties })=>{
    const { isSetupFinished: isSetupFinished, appInsights: appInsights } = (0, $P551f.useContext)((0, $cb4ffea6932908cb$export$c17a2d427d600cd));
    (0, $P551f.useEffect)(()=>{
        const eventName = (0, $11c380c82e275a01$export$a13decb7c9026980)(component, event);
        const storageKey = `${$5af77ecb66078c82$var$storageKeyPrefix}${eventName}`;
        const tracked = (0, $7ebb618db3110393$export$7a668e70ea2210d9)(sessionStorage.getItem(storageKey));
        if (isSetupFinished && !tracked) {
            var _appInsights_instance;
            (_appInsights_instance = appInsights.instance) === null || _appInsights_instance === void 0 ? void 0 : _appInsights_instance.trackEvent({
                name: (0, $11c380c82e275a01$export$a13decb7c9026980)(component, event)
            }, (0, $0de5391da8318002$export$581ff339ea0ba762)({}, appInsights.utmParameters, customProperties));
            sessionStorage.setItem(storageKey, "1");
        }
    }, [
        appInsights.instance,
        appInsights.utmParameters,
        component,
        customProperties,
        event,
        isSetupFinished
    ]);
    return null;
};
var $5af77ecb66078c82$export$2e2bcd8739ae039 = $5af77ecb66078c82$var$TrackOnce;







function $6c438fc4da5900c8$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $6c438fc4da5900c8$export$4fa2f4023c9cbda5(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $6c438fc4da5900c8$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}


var $db5e9db6ef1a480f$export$7debb50ef11d5e0b;
(function(util) {
    util.assertEqual = (val)=>val;
    function assertIs(_arg) {}
    util.assertIs = assertIs;
    function assertNever(_x) {
        throw new Error();
    }
    util.assertNever = assertNever;
    util.arrayToEnum = (items)=>{
        const obj = {};
        for (const item of items)obj[item] = item;
        return obj;
    };
    util.getValidEnumValues = (obj)=>{
        const validKeys = util.objectKeys(obj).filter((k)=>typeof obj[obj[k]] !== "number");
        const filtered = {};
        for (const k of validKeys)filtered[k] = obj[k];
        return util.objectValues(filtered);
    };
    util.objectValues = (obj)=>{
        return util.objectKeys(obj).map(function(e) {
            return obj[e];
        });
    };
    util.objectKeys = typeof Object.keys === "function" // eslint-disable-line ban/ban
     ? (obj)=>Object.keys(obj) // eslint-disable-line ban/ban
     : (object)=>{
        const keys = [];
        for(const key in object)if (Object.prototype.hasOwnProperty.call(object, key)) keys.push(key);
        return keys;
    };
    util.find = (arr, checker)=>{
        for (const item of arr){
            if (checker(item)) return item;
        }
        return undefined;
    };
    util.isInteger = typeof Number.isInteger === "function" ? (val)=>Number.isInteger(val) // eslint-disable-line ban/ban
     : (val)=>typeof val === "number" && isFinite(val) && Math.floor(val) === val;
    function joinValues(array, separator = " | ") {
        return array.map((val)=>typeof val === "string" ? `'${val}'` : val).join(separator);
    }
    util.joinValues = joinValues;
    util.jsonStringifyReplacer = (_, value)=>{
        if (typeof value === "bigint") return value.toString();
        return value;
    };
})($db5e9db6ef1a480f$export$7debb50ef11d5e0b || ($db5e9db6ef1a480f$export$7debb50ef11d5e0b = {}));
var $db5e9db6ef1a480f$export$4aa2142c225fd5c7;
(function(objectUtil) {
    objectUtil.mergeShapes = (first, second)=>{
        return (0, $0de5391da8318002$export$581ff339ea0ba762)({}, first, second);
    };
})($db5e9db6ef1a480f$export$4aa2142c225fd5c7 || ($db5e9db6ef1a480f$export$4aa2142c225fd5c7 = {}));
const $db5e9db6ef1a480f$export$5716da67bfaa244d = $db5e9db6ef1a480f$export$7debb50ef11d5e0b.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set"
]);
const $db5e9db6ef1a480f$export$3e9057828ebd5c7a = (data)=>{
    const t = typeof data;
    switch(t){
        case "undefined":
            return $db5e9db6ef1a480f$export$5716da67bfaa244d.undefined;
        case "string":
            return $db5e9db6ef1a480f$export$5716da67bfaa244d.string;
        case "number":
            return isNaN(data) ? $db5e9db6ef1a480f$export$5716da67bfaa244d.nan : $db5e9db6ef1a480f$export$5716da67bfaa244d.number;
        case "boolean":
            return $db5e9db6ef1a480f$export$5716da67bfaa244d.boolean;
        case "function":
            return $db5e9db6ef1a480f$export$5716da67bfaa244d.function;
        case "bigint":
            return $db5e9db6ef1a480f$export$5716da67bfaa244d.bigint;
        case "symbol":
            return $db5e9db6ef1a480f$export$5716da67bfaa244d.symbol;
        case "object":
            if (Array.isArray(data)) return $db5e9db6ef1a480f$export$5716da67bfaa244d.array;
            if (data === null) return $db5e9db6ef1a480f$export$5716da67bfaa244d.null;
            if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") return $db5e9db6ef1a480f$export$5716da67bfaa244d.promise;
            if (typeof Map !== "undefined" && data instanceof Map) return $db5e9db6ef1a480f$export$5716da67bfaa244d.map;
            if (typeof Set !== "undefined" && data instanceof Set) return $db5e9db6ef1a480f$export$5716da67bfaa244d.set;
            if (typeof Date !== "undefined" && data instanceof Date) return $db5e9db6ef1a480f$export$5716da67bfaa244d.date;
            return $db5e9db6ef1a480f$export$5716da67bfaa244d.object;
        default:
            return $db5e9db6ef1a480f$export$5716da67bfaa244d.unknown;
    }
};
const $db5e9db6ef1a480f$export$5ba560653e4a1035 = $db5e9db6ef1a480f$export$7debb50ef11d5e0b.arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite"
]);
const $db5e9db6ef1a480f$export$913eddeaf297cfea = (obj)=>{
    const json = JSON.stringify(obj, null, 2);
    return json.replace(/"([^"]+)":/g, "$1:");
};
class $db5e9db6ef1a480f$export$f98dac4b251ab333 extends Error {
    get errors() {
        return this.issues;
    }
    format(_mapper) {
        const mapper = _mapper || function(issue) {
            return issue.message;
        };
        const fieldErrors = {
            _errors: []
        };
        const processError = (error)=>{
            for (const issue of error.issues){
                if (issue.code === "invalid_union") issue.unionErrors.map(processError);
                else if (issue.code === "invalid_return_type") processError(issue.returnTypeError);
                else if (issue.code === "invalid_arguments") processError(issue.argumentsError);
                else if (issue.path.length === 0) fieldErrors._errors.push(mapper(issue));
                else {
                    let curr = fieldErrors;
                    let i = 0;
                    while(i < issue.path.length){
                        const el = issue.path[i];
                        const terminal = i === issue.path.length - 1;
                        if (!terminal) curr[el] = curr[el] || {
                            _errors: []
                        };
                        else {
                            curr[el] = curr[el] || {
                                _errors: []
                            };
                            curr[el]._errors.push(mapper(issue));
                        }
                        curr = curr[el];
                        i++;
                    }
                }
            }
        };
        processError(this);
        return fieldErrors;
    }
    toString() {
        return this.message;
    }
    get message() {
        return JSON.stringify(this.issues, $db5e9db6ef1a480f$export$7debb50ef11d5e0b.jsonStringifyReplacer, 2);
    }
    get isEmpty() {
        return this.issues.length === 0;
    }
    flatten(mapper = (issue)=>issue.message) {
        const fieldErrors = {};
        const formErrors = [];
        for (const sub of this.issues)if (sub.path.length > 0) {
            fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
            fieldErrors[sub.path[0]].push(mapper(sub));
        } else formErrors.push(mapper(sub));
        return {
            formErrors: formErrors,
            fieldErrors: fieldErrors
        };
    }
    get formErrors() {
        return this.flatten();
    }
    constructor(issues){
        super();
        this.issues = [];
        this.addIssue = (sub)=>{
            this.issues = [
                ...this.issues,
                sub
            ];
        };
        this.addIssues = (subs = [])=>{
            this.issues = [
                ...this.issues,
                ...subs
            ];
        };
        const actualProto = new.target.prototype;
        if (Object.setPrototypeOf) // eslint-disable-next-line ban/ban
        Object.setPrototypeOf(this, actualProto);
        else this.__proto__ = actualProto;
        this.name = "ZodError";
        this.issues = issues;
    }
}
$db5e9db6ef1a480f$export$f98dac4b251ab333.create = (issues)=>{
    const error = new $db5e9db6ef1a480f$export$f98dac4b251ab333(issues);
    return error;
};
const $db5e9db6ef1a480f$export$341b0b6e0a6f5099 = (issue, _ctx)=>{
    let message;
    switch(issue.code){
        case $db5e9db6ef1a480f$export$5ba560653e4a1035.invalid_type:
            if (issue.received === $db5e9db6ef1a480f$export$5716da67bfaa244d.undefined) message = "Required";
            else message = `Expected ${issue.expected}, received ${issue.received}`;
            break;
        case $db5e9db6ef1a480f$export$5ba560653e4a1035.invalid_literal:
            message = `Invalid literal value, expected ${JSON.stringify(issue.expected, $db5e9db6ef1a480f$export$7debb50ef11d5e0b.jsonStringifyReplacer)}`;
            break;
        case $db5e9db6ef1a480f$export$5ba560653e4a1035.unrecognized_keys:
            message = `Unrecognized key(s) in object: ${$db5e9db6ef1a480f$export$7debb50ef11d5e0b.joinValues(issue.keys, ", ")}`;
            break;
        case $db5e9db6ef1a480f$export$5ba560653e4a1035.invalid_union:
            message = `Invalid input`;
            break;
        case $db5e9db6ef1a480f$export$5ba560653e4a1035.invalid_union_discriminator:
            message = `Invalid discriminator value. Expected ${$db5e9db6ef1a480f$export$7debb50ef11d5e0b.joinValues(issue.options)}`;
            break;
        case $db5e9db6ef1a480f$export$5ba560653e4a1035.invalid_enum_value:
            message = `Invalid enum value. Expected ${$db5e9db6ef1a480f$export$7debb50ef11d5e0b.joinValues(issue.options)}, received '${issue.received}'`;
            break;
        case $db5e9db6ef1a480f$export$5ba560653e4a1035.invalid_arguments:
            message = `Invalid function arguments`;
            break;
        case $db5e9db6ef1a480f$export$5ba560653e4a1035.invalid_return_type:
            message = `Invalid function return type`;
            break;
        case $db5e9db6ef1a480f$export$5ba560653e4a1035.invalid_date:
            message = `Invalid date`;
            break;
        case $db5e9db6ef1a480f$export$5ba560653e4a1035.invalid_string:
            if (typeof issue.validation === "object") {
                if ("includes" in issue.validation) {
                    message = `Invalid input: must include "${issue.validation.includes}"`;
                    if (typeof issue.validation.position === "number") message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
                } else if ("startsWith" in issue.validation) message = `Invalid input: must start with "${issue.validation.startsWith}"`;
                else if ("endsWith" in issue.validation) message = `Invalid input: must end with "${issue.validation.endsWith}"`;
                else $db5e9db6ef1a480f$export$7debb50ef11d5e0b.assertNever(issue.validation);
            } else if (issue.validation !== "regex") message = `Invalid ${issue.validation}`;
            else message = "Invalid";
            break;
        case $db5e9db6ef1a480f$export$5ba560653e4a1035.too_small:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${new Date(Number(issue.minimum))}`;
            else message = "Invalid input";
            break;
        case $db5e9db6ef1a480f$export$5ba560653e4a1035.too_big:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "bigint") message = `BigInt must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly` : issue.inclusive ? `smaller than or equal to` : `smaller than`} ${new Date(Number(issue.maximum))}`;
            else message = "Invalid input";
            break;
        case $db5e9db6ef1a480f$export$5ba560653e4a1035.custom:
            message = `Invalid input`;
            break;
        case $db5e9db6ef1a480f$export$5ba560653e4a1035.invalid_intersection_types:
            message = `Intersection results could not be merged`;
            break;
        case $db5e9db6ef1a480f$export$5ba560653e4a1035.not_multiple_of:
            message = `Number must be a multiple of ${issue.multipleOf}`;
            break;
        case $db5e9db6ef1a480f$export$5ba560653e4a1035.not_finite:
            message = "Number must be finite";
            break;
        default:
            message = _ctx.defaultError;
            $db5e9db6ef1a480f$export$7debb50ef11d5e0b.assertNever(issue);
    }
    return {
        message: message
    };
};
let $db5e9db6ef1a480f$var$overrideErrorMap = $db5e9db6ef1a480f$export$341b0b6e0a6f5099;
function $db5e9db6ef1a480f$export$1097a8289cfd22d7(map) {
    $db5e9db6ef1a480f$var$overrideErrorMap = map;
}
function $db5e9db6ef1a480f$export$32f27c719778d4c4() {
    return $db5e9db6ef1a480f$var$overrideErrorMap;
}
const $db5e9db6ef1a480f$export$244a85fde9c419ed = (params)=>{
    const { data: data, path: path, errorMaps: errorMaps, issueData: issueData } = params;
    const fullPath = [
        ...path,
        ...issueData.path || []
    ];
    const fullIssue = (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, issueData), {
        path: fullPath
    });
    let errorMessage = "";
    const maps = errorMaps.filter((m)=>!!m).slice().reverse();
    for (const map of maps)errorMessage = map(fullIssue, {
        data: data,
        defaultError: errorMessage
    }).message;
    return (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, issueData), {
        path: fullPath,
        message: issueData.message || errorMessage
    });
};
const $db5e9db6ef1a480f$export$1526d2e05f74572 = [];
function $db5e9db6ef1a480f$export$db7caee60e5d514d(ctx, issueData) {
    const issue = $db5e9db6ef1a480f$export$244a85fde9c419ed({
        issueData: issueData,
        data: ctx.data,
        path: ctx.path,
        errorMaps: [
            ctx.common.contextualErrorMap,
            ctx.schemaErrorMap,
            $db5e9db6ef1a480f$export$32f27c719778d4c4(),
            $db5e9db6ef1a480f$export$341b0b6e0a6f5099
        ].filter((x)=>!!x)
    });
    ctx.common.issues.push(issue);
}
class $db5e9db6ef1a480f$export$5b20a5c3d05c1f6f {
    dirty() {
        if (this.value === "valid") this.value = "dirty";
    }
    abort() {
        if (this.value !== "aborted") this.value = "aborted";
    }
    static mergeArray(status, results) {
        const arrayValue = [];
        for (const s of results){
            if (s.status === "aborted") return $db5e9db6ef1a480f$export$9a105a556e65c2c0;
            if (s.status === "dirty") status.dirty();
            arrayValue.push(s.value);
        }
        return {
            status: status.value,
            value: arrayValue
        };
    }
    static async mergeObjectAsync(status, pairs) {
        const syncPairs = [];
        for (const pair of pairs)syncPairs.push({
            key: await pair.key,
            value: await pair.value
        });
        return $db5e9db6ef1a480f$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
    }
    static mergeObjectSync(status, pairs) {
        const finalObject = {};
        for (const pair of pairs){
            const { key: key, value: value } = pair;
            if (key.status === "aborted") return $db5e9db6ef1a480f$export$9a105a556e65c2c0;
            if (value.status === "aborted") return $db5e9db6ef1a480f$export$9a105a556e65c2c0;
            if (key.status === "dirty") status.dirty();
            if (value.status === "dirty") status.dirty();
            if (key.value !== "__proto__" && (typeof value.value !== "undefined" || pair.alwaysSet)) finalObject[key.value] = value.value;
        }
        return {
            status: status.value,
            value: finalObject
        };
    }
    constructor(){
        this.value = "valid";
    }
}
const $db5e9db6ef1a480f$export$9a105a556e65c2c0 = Object.freeze({
    status: "aborted"
});
const $db5e9db6ef1a480f$export$325a211da9693fcf = (value)=>({
        status: "dirty",
        value: value
    });
const $db5e9db6ef1a480f$export$c6813a8d51f77eaf = (value)=>({
        status: "valid",
        value: value
    });
const $db5e9db6ef1a480f$export$afa861e3c5730743 = (x)=>x.status === "aborted";
const $db5e9db6ef1a480f$export$910b6cdd390341b3 = (x)=>x.status === "dirty";
const $db5e9db6ef1a480f$export$1ea939691cdc45b8 = (x)=>x.status === "valid";
const $db5e9db6ef1a480f$export$aefee5ebe1dcfd9e = (x)=>typeof Promise !== "undefined" && x instanceof Promise;
var $db5e9db6ef1a480f$var$errorUtil;
(function(errorUtil) {
    errorUtil.errToObj = (message)=>typeof message === "string" ? {
            message: message
        } : message || {};
    errorUtil.toString = (message)=>typeof message === "string" ? message : message === null || message === void 0 ? void 0 : message.message;
})($db5e9db6ef1a480f$var$errorUtil || ($db5e9db6ef1a480f$var$errorUtil = {}));
class $db5e9db6ef1a480f$var$ParseInputLazyPath {
    get path() {
        if (!this._cachedPath.length) {
            if (this._key instanceof Array) this._cachedPath.push(...this._path, ...this._key);
            else this._cachedPath.push(...this._path, this._key);
        }
        return this._cachedPath;
    }
    constructor(parent, value, path, key){
        this._cachedPath = [];
        this.parent = parent;
        this.data = value;
        this._path = path;
        this._key = key;
    }
}
const $db5e9db6ef1a480f$var$handleResult = (ctx, result)=>{
    if ($db5e9db6ef1a480f$export$1ea939691cdc45b8(result)) return {
        success: true,
        data: result.value
    };
    else {
        if (!ctx.common.issues.length) throw new Error("Validation failed but no issues detected.");
        return {
            success: false,
            get error () {
                if (this._error) return this._error;
                const error = new $db5e9db6ef1a480f$export$f98dac4b251ab333(ctx.common.issues);
                this._error = error;
                return this._error;
            }
        };
    }
};
function $db5e9db6ef1a480f$var$processCreateParams(params) {
    if (!params) return {};
    const { errorMap: errorMap, invalid_type_error: invalid_type_error, required_error: required_error, description: description } = params;
    if (errorMap && (invalid_type_error || required_error)) throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
    if (errorMap) return {
        errorMap: errorMap,
        description: description
    };
    const customMap = (iss, ctx)=>{
        if (iss.code !== "invalid_type") return {
            message: ctx.defaultError
        };
        if (typeof ctx.data === "undefined") return {
            message: required_error !== null && required_error !== void 0 ? required_error : ctx.defaultError
        };
        return {
            message: invalid_type_error !== null && invalid_type_error !== void 0 ? invalid_type_error : ctx.defaultError
        };
    };
    return {
        errorMap: customMap,
        description: description
    };
}
class $db5e9db6ef1a480f$export$19342e026b58ebb7 {
    get description() {
        return this._def.description;
    }
    _getType(input) {
        return $db5e9db6ef1a480f$export$3e9057828ebd5c7a(input.data);
    }
    _getOrReturnCtx(input, ctx) {
        return ctx || {
            common: input.parent.common,
            data: input.data,
            parsedType: $db5e9db6ef1a480f$export$3e9057828ebd5c7a(input.data),
            schemaErrorMap: this._def.errorMap,
            path: input.path,
            parent: input.parent
        };
    }
    _processInputParams(input) {
        return {
            status: new $db5e9db6ef1a480f$export$5b20a5c3d05c1f6f(),
            ctx: {
                common: input.parent.common,
                data: input.data,
                parsedType: $db5e9db6ef1a480f$export$3e9057828ebd5c7a(input.data),
                schemaErrorMap: this._def.errorMap,
                path: input.path,
                parent: input.parent
            }
        };
    }
    _parseSync(input) {
        const result = this._parse(input);
        if ($db5e9db6ef1a480f$export$aefee5ebe1dcfd9e(result)) throw new Error("Synchronous parse encountered promise.");
        return result;
    }
    _parseAsync(input) {
        const result = this._parse(input);
        return Promise.resolve(result);
    }
    parse(data, params) {
        const result = this.safeParse(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    safeParse(data, params) {
        var _a;
        const ctx = {
            common: {
                issues: [],
                async: (_a = params === null || params === void 0 ? void 0 : params.async) !== null && _a !== void 0 ? _a : false,
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $db5e9db6ef1a480f$export$3e9057828ebd5c7a(data)
        };
        const result = this._parseSync({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        return $db5e9db6ef1a480f$var$handleResult(ctx, result);
    }
    async parseAsync(data, params) {
        const result = await this.safeParseAsync(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    async safeParseAsync(data, params) {
        const ctx = {
            common: {
                issues: [],
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
                async: true
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $db5e9db6ef1a480f$export$3e9057828ebd5c7a(data)
        };
        const maybeAsyncResult = this._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        const result = await ($db5e9db6ef1a480f$export$aefee5ebe1dcfd9e(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult));
        return $db5e9db6ef1a480f$var$handleResult(ctx, result);
    }
    refine(check, message) {
        const getIssueProperties = (val)=>{
            if (typeof message === "string" || typeof message === "undefined") return {
                message: message
            };
            else if (typeof message === "function") return message(val);
            else return message;
        };
        return this._refinement((val, ctx)=>{
            const result = check(val);
            const setError = ()=>ctx.addIssue((0, $0de5391da8318002$export$581ff339ea0ba762)({
                    code: $db5e9db6ef1a480f$export$5ba560653e4a1035.custom
                }, getIssueProperties(val)));
            if (typeof Promise !== "undefined" && result instanceof Promise) return result.then((data)=>{
                if (!data) {
                    setError();
                    return false;
                } else return true;
            });
            if (!result) {
                setError();
                return false;
            } else return true;
        });
    }
    refinement(check, refinementData) {
        return this._refinement((val, ctx)=>{
            if (!check(val)) {
                ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
                return false;
            } else return true;
        });
    }
    _refinement(refinement) {
        return new $db5e9db6ef1a480f$export$a60af00cc0ce2582({
            schema: this,
            typeName: $db5e9db6ef1a480f$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "refinement",
                refinement: refinement
            }
        });
    }
    superRefine(refinement) {
        return this._refinement(refinement);
    }
    optional() {
        return $db5e9db6ef1a480f$export$aa56fec1e9d629b8.create(this, this._def);
    }
    nullable() {
        return $db5e9db6ef1a480f$export$aaac0b8b429cef5.create(this, this._def);
    }
    nullish() {
        return this.nullable().optional();
    }
    array() {
        return $db5e9db6ef1a480f$export$7acfc3e64785411.create(this, this._def);
    }
    promise() {
        return $db5e9db6ef1a480f$export$3f196b0127d6e50a.create(this, this._def);
    }
    or(option) {
        return $db5e9db6ef1a480f$export$a8b236cb5070a311.create([
            this,
            option
        ], this._def);
    }
    and(incoming) {
        return $db5e9db6ef1a480f$export$c02deaf0bb5203d4.create(this, incoming, this._def);
    }
    transform(transform) {
        return new $db5e9db6ef1a480f$export$a60af00cc0ce2582((0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, $db5e9db6ef1a480f$var$processCreateParams(this._def)), {
            schema: this,
            typeName: $db5e9db6ef1a480f$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "transform",
                transform: transform
            }
        }));
    }
    default(def) {
        const defaultValueFunc = typeof def === "function" ? def : ()=>def;
        return new $db5e9db6ef1a480f$export$bb19b37874861e7e((0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, $db5e9db6ef1a480f$var$processCreateParams(this._def)), {
            innerType: this,
            defaultValue: defaultValueFunc,
            typeName: $db5e9db6ef1a480f$export$558106ce543bd011.ZodDefault
        }));
    }
    brand() {
        return new $db5e9db6ef1a480f$export$66b0c798a395271f((0, $0de5391da8318002$export$581ff339ea0ba762)({
            typeName: $db5e9db6ef1a480f$export$558106ce543bd011.ZodBranded,
            type: this
        }, $db5e9db6ef1a480f$var$processCreateParams(this._def)));
    }
    catch(def) {
        const catchValueFunc = typeof def === "function" ? def : ()=>def;
        return new $db5e9db6ef1a480f$export$75a44ec6249ac76b((0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, $db5e9db6ef1a480f$var$processCreateParams(this._def)), {
            innerType: this,
            catchValue: catchValueFunc,
            typeName: $db5e9db6ef1a480f$export$558106ce543bd011.ZodCatch
        }));
    }
    describe(description) {
        const This = this.constructor;
        return new This((0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, this._def), {
            description: description
        }));
    }
    pipe(target) {
        return $db5e9db6ef1a480f$export$a3c3ef8a0e95c6da.create(this, target);
    }
    readonly() {
        return $db5e9db6ef1a480f$export$5d1f7ef05c4e493a.create(this);
    }
    isOptional() {
        return this.safeParse(undefined).success;
    }
    isNullable() {
        return this.safeParse(null).success;
    }
    constructor(def){
        /** Alias of safeParseAsync */ this.spa = this.safeParseAsync;
        this._def = def;
        this.parse = this.parse.bind(this);
        this.safeParse = this.safeParse.bind(this);
        this.parseAsync = this.parseAsync.bind(this);
        this.safeParseAsync = this.safeParseAsync.bind(this);
        this.spa = this.spa.bind(this);
        this.refine = this.refine.bind(this);
        this.refinement = this.refinement.bind(this);
        this.superRefine = this.superRefine.bind(this);
        this.optional = this.optional.bind(this);
        this.nullable = this.nullable.bind(this);
        this.nullish = this.nullish.bind(this);
        this.array = this.array.bind(this);
        this.promise = this.promise.bind(this);
        this.or = this.or.bind(this);
        this.and = this.and.bind(this);
        this.transform = this.transform.bind(this);
        this.brand = this.brand.bind(this);
        this.default = this.default.bind(this);
        this.catch = this.catch.bind(this);
        this.describe = this.describe.bind(this);
        this.pipe = this.pipe.bind(this);
        this.readonly = this.readonly.bind(this);
        this.isNullable = this.isNullable.bind(this);
        this.isOptional = this.isOptional.bind(this);
    }
}
const $db5e9db6ef1a480f$var$cuidRegex = /^c[^\s-]{8,}$/i;
const $db5e9db6ef1a480f$var$cuid2Regex = /^[a-z][a-z0-9]*$/;
const $db5e9db6ef1a480f$var$ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/;
// const uuidRegex =
//   /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i;
const $db5e9db6ef1a480f$var$uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
// from https://stackoverflow.com/a/46181/1550155
// old version: too slow, didn't support unicode
// const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
//old email regex
// const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((?!-)([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{1,})[^-<>()[\].,;:\s@"]$/i;
// eslint-disable-next-line
// const emailRegex =
//   /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/;
// const emailRegex =
//   /^[a-zA-Z0-9\.\!\#\$\%\&\'\*\+\/\=\?\^\_\`\{\|\}\~\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// const emailRegex =
//   /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
const $db5e9db6ef1a480f$var$emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_+-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
// const emailRegex =
//   /^[a-z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9\-]+)*$/i;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
const $db5e9db6ef1a480f$var$_emojiRegex = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
let $db5e9db6ef1a480f$var$emojiRegex;
const $db5e9db6ef1a480f$var$ipv4Regex = /^(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))$/;
const $db5e9db6ef1a480f$var$ipv6Regex = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
// Adapted from https://stackoverflow.com/a/3143231
const $db5e9db6ef1a480f$var$datetimeRegex = (args)=>{
    if (args.precision) {
        if (args.offset) return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${args.precision}}(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
        else return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${args.precision}}Z$`);
    } else if (args.precision === 0) {
        if (args.offset) return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
        else return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}Z$`);
    } else {
        if (args.offset) return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
        else return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?Z$`);
    }
};
function $db5e9db6ef1a480f$var$isValidIP(ip, version) {
    if ((version === "v4" || !version) && $db5e9db6ef1a480f$var$ipv4Regex.test(ip)) return true;
    if ((version === "v6" || !version) && $db5e9db6ef1a480f$var$ipv6Regex.test(ip)) return true;
    return false;
}
class $db5e9db6ef1a480f$export$1230eb29b8d3b502 extends $db5e9db6ef1a480f$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = String(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $db5e9db6ef1a480f$export$5716da67bfaa244d.string) {
            const ctx = this._getOrReturnCtx(input);
            $db5e9db6ef1a480f$export$db7caee60e5d514d(ctx, {
                code: $db5e9db6ef1a480f$export$5ba560653e4a1035.invalid_type,
                expected: $db5e9db6ef1a480f$export$5716da67bfaa244d.string,
                received: ctx.parsedType
            });
            return $db5e9db6ef1a480f$export$9a105a556e65c2c0;
        }
        const status = new $db5e9db6ef1a480f$export$5b20a5c3d05c1f6f();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.length < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $db5e9db6ef1a480f$export$db7caee60e5d514d(ctx, {
                        code: $db5e9db6ef1a480f$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.length > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $db5e9db6ef1a480f$export$db7caee60e5d514d(ctx, {
                        code: $db5e9db6ef1a480f$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "length") {
                const tooBig = input.data.length > check.value;
                const tooSmall = input.data.length < check.value;
                if (tooBig || tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    if (tooBig) $db5e9db6ef1a480f$export$db7caee60e5d514d(ctx, {
                        code: $db5e9db6ef1a480f$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    else if (tooSmall) $db5e9db6ef1a480f$export$db7caee60e5d514d(ctx, {
                        code: $db5e9db6ef1a480f$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "email") {
                if (!$db5e9db6ef1a480f$var$emailRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $db5e9db6ef1a480f$export$db7caee60e5d514d(ctx, {
                        validation: "email",
                        code: $db5e9db6ef1a480f$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "emoji") {
                if (!$db5e9db6ef1a480f$var$emojiRegex) $db5e9db6ef1a480f$var$emojiRegex = new RegExp($db5e9db6ef1a480f$var$_emojiRegex, "u");
                if (!$db5e9db6ef1a480f$var$emojiRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $db5e9db6ef1a480f$export$db7caee60e5d514d(ctx, {
                        validation: "emoji",
                        code: $db5e9db6ef1a480f$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "uuid") {
                if (!$db5e9db6ef1a480f$var$uuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $db5e9db6ef1a480f$export$db7caee60e5d514d(ctx, {
                        validation: "uuid",
                        code: $db5e9db6ef1a480f$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid") {
                if (!$db5e9db6ef1a480f$var$cuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $db5e9db6ef1a480f$export$db7caee60e5d514d(ctx, {
                        validation: "cuid",
                        code: $db5e9db6ef1a480f$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid2") {
                if (!$db5e9db6ef1a480f$var$cuid2Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $db5e9db6ef1a480f$export$db7caee60e5d514d(ctx, {
                        validation: "cuid2",
                        code: $db5e9db6ef1a480f$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ulid") {
                if (!$db5e9db6ef1a480f$var$ulidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $db5e9db6ef1a480f$export$db7caee60e5d514d(ctx, {
                        validation: "ulid",
                        code: $db5e9db6ef1a480f$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "url") try {
                new URL(input.data);
            } catch (_a) {
                ctx = this._getOrReturnCtx(input, ctx);
                $db5e9db6ef1a480f$export$db7caee60e5d514d(ctx, {
                    validation: "url",
                    code: $db5e9db6ef1a480f$export$5ba560653e4a1035.invalid_string,
                    message: check.message
                });
                status.dirty();
            }
            else if (check.kind === "regex") {
                check.regex.lastIndex = 0;
                const testResult = check.regex.test(input.data);
                if (!testResult) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $db5e9db6ef1a480f$export$db7caee60e5d514d(ctx, {
                        validation: "regex",
                        code: $db5e9db6ef1a480f$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "trim") input.data = input.data.trim();
            else if (check.kind === "includes") {
                if (!input.data.includes(check.value, check.position)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $db5e9db6ef1a480f$export$db7caee60e5d514d(ctx, {
                        code: $db5e9db6ef1a480f$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            includes: check.value,
                            position: check.position
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "toLowerCase") input.data = input.data.toLowerCase();
            else if (check.kind === "toUpperCase") input.data = input.data.toUpperCase();
            else if (check.kind === "startsWith") {
                if (!input.data.startsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $db5e9db6ef1a480f$export$db7caee60e5d514d(ctx, {
                        code: $db5e9db6ef1a480f$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            startsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "endsWith") {
                if (!input.data.endsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $db5e9db6ef1a480f$export$db7caee60e5d514d(ctx, {
                        code: $db5e9db6ef1a480f$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            endsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "datetime") {
                const regex = $db5e9db6ef1a480f$var$datetimeRegex(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $db5e9db6ef1a480f$export$db7caee60e5d514d(ctx, {
                        code: $db5e9db6ef1a480f$export$5ba560653e4a1035.invalid_string,
                        validation: "datetime",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ip") {
                if (!$db5e9db6ef1a480f$var$isValidIP(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $db5e9db6ef1a480f$export$db7caee60e5d514d(ctx, {
                        validation: "ip",
                        code: $db5e9db6ef1a480f$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $db5e9db6ef1a480f$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _regex(regex, validation, message) {
        return this.refinement((data)=>regex.test(data), (0, $0de5391da8318002$export$581ff339ea0ba762)({
            validation: validation,
            code: $db5e9db6ef1a480f$export$5ba560653e4a1035.invalid_string
        }, $db5e9db6ef1a480f$var$errorUtil.errToObj(message)));
    }
    _addCheck(check) {
        return new $db5e9db6ef1a480f$export$1230eb29b8d3b502((0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, this._def), {
            checks: [
                ...this._def.checks,
                check
            ]
        }));
    }
    email(message) {
        return this._addCheck((0, $0de5391da8318002$export$581ff339ea0ba762)({
            kind: "email"
        }, $db5e9db6ef1a480f$var$errorUtil.errToObj(message)));
    }
    url(message) {
        return this._addCheck((0, $0de5391da8318002$export$581ff339ea0ba762)({
            kind: "url"
        }, $db5e9db6ef1a480f$var$errorUtil.errToObj(message)));
    }
    emoji(message) {
        return this._addCheck((0, $0de5391da8318002$export$581ff339ea0ba762)({
            kind: "emoji"
        }, $db5e9db6ef1a480f$var$errorUtil.errToObj(message)));
    }
    uuid(message) {
        return this._addCheck((0, $0de5391da8318002$export$581ff339ea0ba762)({
            kind: "uuid"
        }, $db5e9db6ef1a480f$var$errorUtil.errToObj(message)));
    }
    cuid(message) {
        return this._addCheck((0, $0de5391da8318002$export$581ff339ea0ba762)({
            kind: "cuid"
        }, $db5e9db6ef1a480f$var$errorUtil.errToObj(message)));
    }
    cuid2(message) {
        return this._addCheck((0, $0de5391da8318002$export$581ff339ea0ba762)({
            kind: "cuid2"
        }, $db5e9db6ef1a480f$var$errorUtil.errToObj(message)));
    }
    ulid(message) {
        return this._addCheck((0, $0de5391da8318002$export$581ff339ea0ba762)({
            kind: "ulid"
        }, $db5e9db6ef1a480f$var$errorUtil.errToObj(message)));
    }
    ip(options) {
        return this._addCheck((0, $0de5391da8318002$export$581ff339ea0ba762)({
            kind: "ip"
        }, $db5e9db6ef1a480f$var$errorUtil.errToObj(options)));
    }
    datetime(options) {
        var _a;
        if (typeof options === "string") return this._addCheck({
            kind: "datetime",
            precision: null,
            offset: false,
            message: options
        });
        return this._addCheck((0, $0de5391da8318002$export$581ff339ea0ba762)({
            kind: "datetime",
            precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
            offset: (_a = options === null || options === void 0 ? void 0 : options.offset) !== null && _a !== void 0 ? _a : false
        }, $db5e9db6ef1a480f$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)));
    }
    regex(regex, message) {
        return this._addCheck((0, $0de5391da8318002$export$581ff339ea0ba762)({
            kind: "regex",
            regex: regex
        }, $db5e9db6ef1a480f$var$errorUtil.errToObj(message)));
    }
    includes(value, options) {
        return this._addCheck((0, $0de5391da8318002$export$581ff339ea0ba762)({
            kind: "includes",
            value: value,
            position: options === null || options === void 0 ? void 0 : options.position
        }, $db5e9db6ef1a480f$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)));
    }
    startsWith(value, message) {
        return this._addCheck((0, $0de5391da8318002$export$581ff339ea0ba762)({
            kind: "startsWith",
            value: value
        }, $db5e9db6ef1a480f$var$errorUtil.errToObj(message)));
    }
    endsWith(value, message) {
        return this._addCheck((0, $0de5391da8318002$export$581ff339ea0ba762)({
            kind: "endsWith",
            value: value
        }, $db5e9db6ef1a480f$var$errorUtil.errToObj(message)));
    }
    min(minLength, message) {
        return this._addCheck((0, $0de5391da8318002$export$581ff339ea0ba762)({
            kind: "min",
            value: minLength
        }, $db5e9db6ef1a480f$var$errorUtil.errToObj(message)));
    }
    max(maxLength, message) {
        return this._addCheck((0, $0de5391da8318002$export$581ff339ea0ba762)({
            kind: "max",
            value: maxLength
        }, $db5e9db6ef1a480f$var$errorUtil.errToObj(message)));
    }
    length(len, message) {
        return this._addCheck((0, $0de5391da8318002$export$581ff339ea0ba762)({
            kind: "length",
            value: len
        }, $db5e9db6ef1a480f$var$errorUtil.errToObj(message)));
    }
    /**
     * @deprecated Use z.string().min(1) instead.
     * @see {@link ZodString.min}
     */ nonempty(message) {
        return this.min(1, $db5e9db6ef1a480f$var$errorUtil.errToObj(message));
    }
    trim() {
        return new $db5e9db6ef1a480f$export$1230eb29b8d3b502((0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, this._def), {
            checks: [
                ...this._def.checks,
                {
                    kind: "trim"
                }
            ]
        }));
    }
    toLowerCase() {
        return new $db5e9db6ef1a480f$export$1230eb29b8d3b502((0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, this._def), {
            checks: [
                ...this._def.checks,
                {
                    kind: "toLowerCase"
                }
            ]
        }));
    }
    toUpperCase() {
        return new $db5e9db6ef1a480f$export$1230eb29b8d3b502((0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, this._def), {
            checks: [
                ...this._def.checks,
                {
                    kind: "toUpperCase"
                }
            ]
        }));
    }
    get isDatetime() {
        return !!this._def.checks.find((ch)=>ch.kind === "datetime");
    }
    get isEmail() {
        return !!this._def.checks.find((ch)=>ch.kind === "email");
    }
    get isURL() {
        return !!this._def.checks.find((ch)=>ch.kind === "url");
    }
    get isEmoji() {
        return !!this._def.checks.find((ch)=>ch.kind === "emoji");
    }
    get isUUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "uuid");
    }
    get isCUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid");
    }
    get isCUID2() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid2");
    }
    get isULID() {
        return !!this._def.checks.find((ch)=>ch.kind === "ulid");
    }
    get isIP() {
        return !!this._def.checks.find((ch)=>ch.kind === "ip");
    }
    get minLength() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxLength() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$db5e9db6ef1a480f$export$1230eb29b8d3b502.create = (params)=>{
    var _a;
    return new $db5e9db6ef1a480f$export$1230eb29b8d3b502((0, $0de5391da8318002$export$581ff339ea0ba762)({
        checks: [],
        typeName: $db5e9db6ef1a480f$export$558106ce543bd011.ZodString,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false
    }, $db5e9db6ef1a480f$var$processCreateParams(params)));
};
// https://stackoverflow.com/questions/3966484/why-does-modulus-operator-return-fractional-number-in-javascript/31711034#31711034
function $db5e9db6ef1a480f$var$floatSafeRemainder(val, step) {
    const valDecCount = (val.toString().split(".")[1] || "").length;
    const stepDecCount = (step.toString().split(".")[1] || "").length;
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    const valInt = parseInt(val.toFixed(decCount).replace(".", ""));
    const stepInt = parseInt(step.toFixed(decCount).replace(".", ""));
    return valInt % stepInt / Math.pow(10, decCount);
}
class $db5e9db6ef1a480f$export$5b070a55c0c43e09 extends $db5e9db6ef1a480f$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = Number(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $db5e9db6ef1a480f$export$5716da67bfaa244d.number) {
            const ctx = this._getOrReturnCtx(input);
            $db5e9db6ef1a480f$export$db7caee60e5d514d(ctx, {
                code: $db5e9db6ef1a480f$export$5ba560653e4a1035.invalid_type,
                expected: $db5e9db6ef1a480f$export$5716da67bfaa244d.number,
                received: ctx.parsedType
            });
            return $db5e9db6ef1a480f$export$9a105a556e65c2c0;
        }
        let ctx = undefined;
        const status = new $db5e9db6ef1a480f$export$5b20a5c3d05c1f6f();
        for (const check of this._def.checks){
            if (check.kind === "int") {
                if (!$db5e9db6ef1a480f$export$7debb50ef11d5e0b.isInteger(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $db5e9db6ef1a480f$export$db7caee60e5d514d(ctx, {
                        code: $db5e9db6ef1a480f$export$5ba560653e4a1035.invalid_type,
                        expected: "integer",
                        received: "float",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $db5e9db6ef1a480f$export$db7caee60e5d514d(ctx, {
                        code: $db5e9db6ef1a480f$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $db5e9db6ef1a480f$export$db7caee60e5d514d(ctx, {
                        code: $db5e9db6ef1a480f$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if ($db5e9db6ef1a480f$var$floatSafeRemainder(input.data, check.value) !== 0) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $db5e9db6ef1a480f$export$db7caee60e5d514d(ctx, {
                        code: $db5e9db6ef1a480f$export$5ba560653e4a1035.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "finite") {
                if (!Number.isFinite(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $db5e9db6ef1a480f$export$db7caee60e5d514d(ctx, {
                        code: $db5e9db6ef1a480f$export$5ba560653e4a1035.not_finite,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $db5e9db6ef1a480f$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, $db5e9db6ef1a480f$var$errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, $db5e9db6ef1a480f$var$errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, $db5e9db6ef1a480f$var$errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, $db5e9db6ef1a480f$var$errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $db5e9db6ef1a480f$export$5b070a55c0c43e09((0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, this._def), {
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: $db5e9db6ef1a480f$var$errorUtil.toString(message)
                }
            ]
        }));
    }
    _addCheck(check) {
        return new $db5e9db6ef1a480f$export$5b070a55c0c43e09((0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, this._def), {
            checks: [
                ...this._def.checks,
                check
            ]
        }));
    }
    int(message) {
        return this._addCheck({
            kind: "int",
            message: $db5e9db6ef1a480f$var$errorUtil.toString(message)
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: false,
            message: $db5e9db6ef1a480f$var$errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: false,
            message: $db5e9db6ef1a480f$var$errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: true,
            message: $db5e9db6ef1a480f$var$errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: true,
            message: $db5e9db6ef1a480f$var$errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: $db5e9db6ef1a480f$var$errorUtil.toString(message)
        });
    }
    finite(message) {
        return this._addCheck({
            kind: "finite",
            message: $db5e9db6ef1a480f$var$errorUtil.toString(message)
        });
    }
    safe(message) {
        return this._addCheck({
            kind: "min",
            inclusive: true,
            value: Number.MIN_SAFE_INTEGER,
            message: $db5e9db6ef1a480f$var$errorUtil.toString(message)
        })._addCheck({
            kind: "max",
            inclusive: true,
            value: Number.MAX_SAFE_INTEGER,
            message: $db5e9db6ef1a480f$var$errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
    get isInt() {
        return !!this._def.checks.find((ch)=>ch.kind === "int" || ch.kind === "multipleOf" && $db5e9db6ef1a480f$export$7debb50ef11d5e0b.isInteger(ch.value));
    }
    get isFinite() {
        let max = null, min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") return true;
            else if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            } else if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return Number.isFinite(min) && Number.isFinite(max);
    }
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
        this.step = this.multipleOf;
    }
}
$db5e9db6ef1a480f$export$5b070a55c0c43e09.create = (params)=>{
    return new $db5e9db6ef1a480f$export$5b070a55c0c43e09((0, $0de5391da8318002$export$581ff339ea0ba762)({
        checks: [],
        typeName: $db5e9db6ef1a480f$export$558106ce543bd011.ZodNumber,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false
    }, $db5e9db6ef1a480f$var$processCreateParams(params)));
};
class $db5e9db6ef1a480f$export$67d741fd70ff98f4 extends $db5e9db6ef1a480f$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = BigInt(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $db5e9db6ef1a480f$export$5716da67bfaa244d.bigint) {
            const ctx = this._getOrReturnCtx(input);
            $db5e9db6ef1a480f$export$db7caee60e5d514d(ctx, {
                code: $db5e9db6ef1a480f$export$5ba560653e4a1035.invalid_type,
                expected: $db5e9db6ef1a480f$export$5716da67bfaa244d.bigint,
                received: ctx.parsedType
            });
            return $db5e9db6ef1a480f$export$9a105a556e65c2c0;
        }
        let ctx = undefined;
        const status = new $db5e9db6ef1a480f$export$5b20a5c3d05c1f6f();
        for (const check of this._def.checks){
            if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $db5e9db6ef1a480f$export$db7caee60e5d514d(ctx, {
                        code: $db5e9db6ef1a480f$export$5ba560653e4a1035.too_small,
                        type: "bigint",
                        minimum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $db5e9db6ef1a480f$export$db7caee60e5d514d(ctx, {
                        code: $db5e9db6ef1a480f$export$5ba560653e4a1035.too_big,
                        type: "bigint",
                        maximum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if (input.data % check.value !== BigInt(0)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $db5e9db6ef1a480f$export$db7caee60e5d514d(ctx, {
                        code: $db5e9db6ef1a480f$export$5ba560653e4a1035.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $db5e9db6ef1a480f$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, $db5e9db6ef1a480f$var$errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, $db5e9db6ef1a480f$var$errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, $db5e9db6ef1a480f$var$errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, $db5e9db6ef1a480f$var$errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $db5e9db6ef1a480f$export$67d741fd70ff98f4((0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, this._def), {
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: $db5e9db6ef1a480f$var$errorUtil.toString(message)
                }
            ]
        }));
    }
    _addCheck(check) {
        return new $db5e9db6ef1a480f$export$67d741fd70ff98f4((0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, this._def), {
            checks: [
                ...this._def.checks,
                check
            ]
        }));
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: false,
            message: $db5e9db6ef1a480f$var$errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: false,
            message: $db5e9db6ef1a480f$var$errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: true,
            message: $db5e9db6ef1a480f$var$errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: true,
            message: $db5e9db6ef1a480f$var$errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: $db5e9db6ef1a480f$var$errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
    }
}
$db5e9db6ef1a480f$export$67d741fd70ff98f4.create = (params)=>{
    var _a;
    return new $db5e9db6ef1a480f$export$67d741fd70ff98f4((0, $0de5391da8318002$export$581ff339ea0ba762)({
        checks: [],
        typeName: $db5e9db6ef1a480f$export$558106ce543bd011.ZodBigInt,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false
    }, $db5e9db6ef1a480f$var$processCreateParams(params)));
};
class $db5e9db6ef1a480f$export$723d146f80596191 extends $db5e9db6ef1a480f$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = Boolean(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $db5e9db6ef1a480f$export$5716da67bfaa244d.boolean) {
            const ctx = this._getOrReturnCtx(input);
            $db5e9db6ef1a480f$export$db7caee60e5d514d(ctx, {
                code: $db5e9db6ef1a480f$export$5ba560653e4a1035.invalid_type,
                expected: $db5e9db6ef1a480f$export$5716da67bfaa244d.boolean,
                received: ctx.parsedType
            });
            return $db5e9db6ef1a480f$export$9a105a556e65c2c0;
        }
        return $db5e9db6ef1a480f$export$c6813a8d51f77eaf(input.data);
    }
}
$db5e9db6ef1a480f$export$723d146f80596191.create = (params)=>{
    return new $db5e9db6ef1a480f$export$723d146f80596191((0, $0de5391da8318002$export$581ff339ea0ba762)({
        typeName: $db5e9db6ef1a480f$export$558106ce543bd011.ZodBoolean,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false
    }, $db5e9db6ef1a480f$var$processCreateParams(params)));
};
class $db5e9db6ef1a480f$export$e974be33bdc55521 extends $db5e9db6ef1a480f$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = new Date(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $db5e9db6ef1a480f$export$5716da67bfaa244d.date) {
            const ctx = this._getOrReturnCtx(input);
            $db5e9db6ef1a480f$export$db7caee60e5d514d(ctx, {
                code: $db5e9db6ef1a480f$export$5ba560653e4a1035.invalid_type,
                expected: $db5e9db6ef1a480f$export$5716da67bfaa244d.date,
                received: ctx.parsedType
            });
            return $db5e9db6ef1a480f$export$9a105a556e65c2c0;
        }
        if (isNaN(input.data.getTime())) {
            const ctx = this._getOrReturnCtx(input);
            $db5e9db6ef1a480f$export$db7caee60e5d514d(ctx, {
                code: $db5e9db6ef1a480f$export$5ba560653e4a1035.invalid_date
            });
            return $db5e9db6ef1a480f$export$9a105a556e65c2c0;
        }
        const status = new $db5e9db6ef1a480f$export$5b20a5c3d05c1f6f();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.getTime() < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $db5e9db6ef1a480f$export$db7caee60e5d514d(ctx, {
                        code: $db5e9db6ef1a480f$export$5ba560653e4a1035.too_small,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        minimum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.getTime() > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $db5e9db6ef1a480f$export$db7caee60e5d514d(ctx, {
                        code: $db5e9db6ef1a480f$export$5ba560653e4a1035.too_big,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        maximum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else $db5e9db6ef1a480f$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: new Date(input.data.getTime())
        };
    }
    _addCheck(check) {
        return new $db5e9db6ef1a480f$export$e974be33bdc55521((0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, this._def), {
            checks: [
                ...this._def.checks,
                check
            ]
        }));
    }
    min(minDate, message) {
        return this._addCheck({
            kind: "min",
            value: minDate.getTime(),
            message: $db5e9db6ef1a480f$var$errorUtil.toString(message)
        });
    }
    max(maxDate, message) {
        return this._addCheck({
            kind: "max",
            value: maxDate.getTime(),
            message: $db5e9db6ef1a480f$var$errorUtil.toString(message)
        });
    }
    get minDate() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min != null ? new Date(min) : null;
    }
    get maxDate() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max != null ? new Date(max) : null;
    }
}
$db5e9db6ef1a480f$export$e974be33bdc55521.create = (params)=>{
    return new $db5e9db6ef1a480f$export$e974be33bdc55521((0, $0de5391da8318002$export$581ff339ea0ba762)({
        checks: [],
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        typeName: $db5e9db6ef1a480f$export$558106ce543bd011.ZodDate
    }, $db5e9db6ef1a480f$var$processCreateParams(params)));
};
class $db5e9db6ef1a480f$export$bcc3b40f6b638044 extends $db5e9db6ef1a480f$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $db5e9db6ef1a480f$export$5716da67bfaa244d.symbol) {
            const ctx = this._getOrReturnCtx(input);
            $db5e9db6ef1a480f$export$db7caee60e5d514d(ctx, {
                code: $db5e9db6ef1a480f$export$5ba560653e4a1035.invalid_type,
                expected: $db5e9db6ef1a480f$export$5716da67bfaa244d.symbol,
                received: ctx.parsedType
            });
            return $db5e9db6ef1a480f$export$9a105a556e65c2c0;
        }
        return $db5e9db6ef1a480f$export$c6813a8d51f77eaf(input.data);
    }
}
$db5e9db6ef1a480f$export$bcc3b40f6b638044.create = (params)=>{
    return new $db5e9db6ef1a480f$export$bcc3b40f6b638044((0, $0de5391da8318002$export$581ff339ea0ba762)({
        typeName: $db5e9db6ef1a480f$export$558106ce543bd011.ZodSymbol
    }, $db5e9db6ef1a480f$var$processCreateParams(params)));
};
class $db5e9db6ef1a480f$export$4e780e961c30340d extends $db5e9db6ef1a480f$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $db5e9db6ef1a480f$export$5716da67bfaa244d.undefined) {
            const ctx = this._getOrReturnCtx(input);
            $db5e9db6ef1a480f$export$db7caee60e5d514d(ctx, {
                code: $db5e9db6ef1a480f$export$5ba560653e4a1035.invalid_type,
                expected: $db5e9db6ef1a480f$export$5716da67bfaa244d.undefined,
                received: ctx.parsedType
            });
            return $db5e9db6ef1a480f$export$9a105a556e65c2c0;
        }
        return $db5e9db6ef1a480f$export$c6813a8d51f77eaf(input.data);
    }
}
$db5e9db6ef1a480f$export$4e780e961c30340d.create = (params)=>{
    return new $db5e9db6ef1a480f$export$4e780e961c30340d((0, $0de5391da8318002$export$581ff339ea0ba762)({
        typeName: $db5e9db6ef1a480f$export$558106ce543bd011.ZodUndefined
    }, $db5e9db6ef1a480f$var$processCreateParams(params)));
};
class $db5e9db6ef1a480f$export$a96281f914484f2d extends $db5e9db6ef1a480f$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $db5e9db6ef1a480f$export$5716da67bfaa244d.null) {
            const ctx = this._getOrReturnCtx(input);
            $db5e9db6ef1a480f$export$db7caee60e5d514d(ctx, {
                code: $db5e9db6ef1a480f$export$5ba560653e4a1035.invalid_type,
                expected: $db5e9db6ef1a480f$export$5716da67bfaa244d.null,
                received: ctx.parsedType
            });
            return $db5e9db6ef1a480f$export$9a105a556e65c2c0;
        }
        return $db5e9db6ef1a480f$export$c6813a8d51f77eaf(input.data);
    }
}
$db5e9db6ef1a480f$export$a96281f914484f2d.create = (params)=>{
    return new $db5e9db6ef1a480f$export$a96281f914484f2d((0, $0de5391da8318002$export$581ff339ea0ba762)({
        typeName: $db5e9db6ef1a480f$export$558106ce543bd011.ZodNull
    }, $db5e9db6ef1a480f$var$processCreateParams(params)));
};
class $db5e9db6ef1a480f$export$b9d1edb536b4e4eb extends $db5e9db6ef1a480f$export$19342e026b58ebb7 {
    _parse(input) {
        return $db5e9db6ef1a480f$export$c6813a8d51f77eaf(input.data);
    }
    constructor(){
        super(...arguments);
        // to prevent instances of other classes from extending ZodAny. this causes issues with catchall in ZodObject.
        this._any = true;
    }
}
$db5e9db6ef1a480f$export$b9d1edb536b4e4eb.create = (params)=>{
    return new $db5e9db6ef1a480f$export$b9d1edb536b4e4eb((0, $0de5391da8318002$export$581ff339ea0ba762)({
        typeName: $db5e9db6ef1a480f$export$558106ce543bd011.ZodAny
    }, $db5e9db6ef1a480f$var$processCreateParams(params)));
};
class $db5e9db6ef1a480f$export$ef3b1bb1630977ae extends $db5e9db6ef1a480f$export$19342e026b58ebb7 {
    _parse(input) {
        return $db5e9db6ef1a480f$export$c6813a8d51f77eaf(input.data);
    }
    constructor(){
        super(...arguments);
        // required
        this._unknown = true;
    }
}
$db5e9db6ef1a480f$export$ef3b1bb1630977ae.create = (params)=>{
    return new $db5e9db6ef1a480f$export$ef3b1bb1630977ae((0, $0de5391da8318002$export$581ff339ea0ba762)({
        typeName: $db5e9db6ef1a480f$export$558106ce543bd011.ZodUnknown
    }, $db5e9db6ef1a480f$var$processCreateParams(params)));
};
class $db5e9db6ef1a480f$export$1e576a20c3ce9fb5 extends $db5e9db6ef1a480f$export$19342e026b58ebb7 {
    _parse(input) {
        const ctx = this._getOrReturnCtx(input);
        $db5e9db6ef1a480f$export$db7caee60e5d514d(ctx, {
            code: $db5e9db6ef1a480f$export$5ba560653e4a1035.invalid_type,
            expected: $db5e9db6ef1a480f$export$5716da67bfaa244d.never,
            received: ctx.parsedType
        });
        return $db5e9db6ef1a480f$export$9a105a556e65c2c0;
    }
}
$db5e9db6ef1a480f$export$1e576a20c3ce9fb5.create = (params)=>{
    return new $db5e9db6ef1a480f$export$1e576a20c3ce9fb5((0, $0de5391da8318002$export$581ff339ea0ba762)({
        typeName: $db5e9db6ef1a480f$export$558106ce543bd011.ZodNever
    }, $db5e9db6ef1a480f$var$processCreateParams(params)));
};
class $db5e9db6ef1a480f$export$7d39f5df85f21031 extends $db5e9db6ef1a480f$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $db5e9db6ef1a480f$export$5716da67bfaa244d.undefined) {
            const ctx = this._getOrReturnCtx(input);
            $db5e9db6ef1a480f$export$db7caee60e5d514d(ctx, {
                code: $db5e9db6ef1a480f$export$5ba560653e4a1035.invalid_type,
                expected: $db5e9db6ef1a480f$export$5716da67bfaa244d.void,
                received: ctx.parsedType
            });
            return $db5e9db6ef1a480f$export$9a105a556e65c2c0;
        }
        return $db5e9db6ef1a480f$export$c6813a8d51f77eaf(input.data);
    }
}
$db5e9db6ef1a480f$export$7d39f5df85f21031.create = (params)=>{
    return new $db5e9db6ef1a480f$export$7d39f5df85f21031((0, $0de5391da8318002$export$581ff339ea0ba762)({
        typeName: $db5e9db6ef1a480f$export$558106ce543bd011.ZodVoid
    }, $db5e9db6ef1a480f$var$processCreateParams(params)));
};
class $db5e9db6ef1a480f$export$7acfc3e64785411 extends $db5e9db6ef1a480f$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx, status: status } = this._processInputParams(input);
        const def = this._def;
        if (ctx.parsedType !== $db5e9db6ef1a480f$export$5716da67bfaa244d.array) {
            $db5e9db6ef1a480f$export$db7caee60e5d514d(ctx, {
                code: $db5e9db6ef1a480f$export$5ba560653e4a1035.invalid_type,
                expected: $db5e9db6ef1a480f$export$5716da67bfaa244d.array,
                received: ctx.parsedType
            });
            return $db5e9db6ef1a480f$export$9a105a556e65c2c0;
        }
        if (def.exactLength !== null) {
            const tooBig = ctx.data.length > def.exactLength.value;
            const tooSmall = ctx.data.length < def.exactLength.value;
            if (tooBig || tooSmall) {
                $db5e9db6ef1a480f$export$db7caee60e5d514d(ctx, {
                    code: tooBig ? $db5e9db6ef1a480f$export$5ba560653e4a1035.too_big : $db5e9db6ef1a480f$export$5ba560653e4a1035.too_small,
                    minimum: tooSmall ? def.exactLength.value : undefined,
                    maximum: tooBig ? def.exactLength.value : undefined,
                    type: "array",
                    inclusive: true,
                    exact: true,
                    message: def.exactLength.message
                });
                status.dirty();
            }
        }
        if (def.minLength !== null) {
            if (ctx.data.length < def.minLength.value) {
                $db5e9db6ef1a480f$export$db7caee60e5d514d(ctx, {
                    code: $db5e9db6ef1a480f$export$5ba560653e4a1035.too_small,
                    minimum: def.minLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.minLength.message
                });
                status.dirty();
            }
        }
        if (def.maxLength !== null) {
            if (ctx.data.length > def.maxLength.value) {
                $db5e9db6ef1a480f$export$db7caee60e5d514d(ctx, {
                    code: $db5e9db6ef1a480f$export$5ba560653e4a1035.too_big,
                    maximum: def.maxLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.maxLength.message
                });
                status.dirty();
            }
        }
        if (ctx.common.async) return Promise.all([
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseAsync(new $db5e9db6ef1a480f$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        })).then((result)=>{
            return $db5e9db6ef1a480f$export$5b20a5c3d05c1f6f.mergeArray(status, result);
        });
        const result = [
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseSync(new $db5e9db6ef1a480f$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        });
        return $db5e9db6ef1a480f$export$5b20a5c3d05c1f6f.mergeArray(status, result);
    }
    get element() {
        return this._def.type;
    }
    min(minLength, message) {
        return new $db5e9db6ef1a480f$export$7acfc3e64785411((0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, this._def), {
            minLength: {
                value: minLength,
                message: $db5e9db6ef1a480f$var$errorUtil.toString(message)
            }
        }));
    }
    max(maxLength, message) {
        return new $db5e9db6ef1a480f$export$7acfc3e64785411((0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, this._def), {
            maxLength: {
                value: maxLength,
                message: $db5e9db6ef1a480f$var$errorUtil.toString(message)
            }
        }));
    }
    length(len, message) {
        return new $db5e9db6ef1a480f$export$7acfc3e64785411((0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, this._def), {
            exactLength: {
                value: len,
                message: $db5e9db6ef1a480f$var$errorUtil.toString(message)
            }
        }));
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$db5e9db6ef1a480f$export$7acfc3e64785411.create = (schema, params)=>{
    return new $db5e9db6ef1a480f$export$7acfc3e64785411((0, $0de5391da8318002$export$581ff339ea0ba762)({
        type: schema,
        minLength: null,
        maxLength: null,
        exactLength: null,
        typeName: $db5e9db6ef1a480f$export$558106ce543bd011.ZodArray
    }, $db5e9db6ef1a480f$var$processCreateParams(params)));
};
function $db5e9db6ef1a480f$var$deepPartialify(schema) {
    if (schema instanceof $db5e9db6ef1a480f$export$736315c5b55efbad) {
        const newShape = {};
        for(const key in schema.shape){
            const fieldSchema = schema.shape[key];
            newShape[key] = $db5e9db6ef1a480f$export$aa56fec1e9d629b8.create($db5e9db6ef1a480f$var$deepPartialify(fieldSchema));
        }
        return new $db5e9db6ef1a480f$export$736315c5b55efbad((0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, schema._def), {
            shape: ()=>newShape
        }));
    } else if (schema instanceof $db5e9db6ef1a480f$export$7acfc3e64785411) return new $db5e9db6ef1a480f$export$7acfc3e64785411((0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, schema._def), {
        type: $db5e9db6ef1a480f$var$deepPartialify(schema.element)
    }));
    else if (schema instanceof $db5e9db6ef1a480f$export$aa56fec1e9d629b8) return $db5e9db6ef1a480f$export$aa56fec1e9d629b8.create($db5e9db6ef1a480f$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $db5e9db6ef1a480f$export$aaac0b8b429cef5) return $db5e9db6ef1a480f$export$aaac0b8b429cef5.create($db5e9db6ef1a480f$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $db5e9db6ef1a480f$export$e2a18bb771d8e6a3) return $db5e9db6ef1a480f$export$e2a18bb771d8e6a3.create(schema.items.map((item)=>$db5e9db6ef1a480f$var$deepPartialify(item)));
    else return schema;
}
class $db5e9db6ef1a480f$export$736315c5b55efbad extends $db5e9db6ef1a480f$export$19342e026b58ebb7 {
    _getCached() {
        if (this._cached !== null) return this._cached;
        const shape = this._def.shape();
        const keys = $db5e9db6ef1a480f$export$7debb50ef11d5e0b.objectKeys(shape);
        return this._cached = {
            shape: shape,
            keys: keys
        };
    }
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $db5e9db6ef1a480f$export$5716da67bfaa244d.object) {
            const ctx = this._getOrReturnCtx(input);
            $db5e9db6ef1a480f$export$db7caee60e5d514d(ctx, {
                code: $db5e9db6ef1a480f$export$5ba560653e4a1035.invalid_type,
                expected: $db5e9db6ef1a480f$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $db5e9db6ef1a480f$export$9a105a556e65c2c0;
        }
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const { shape: shape, keys: shapeKeys } = this._getCached();
        const extraKeys = [];
        if (!(this._def.catchall instanceof $db5e9db6ef1a480f$export$1e576a20c3ce9fb5 && this._def.unknownKeys === "strip")) {
            for(const key in ctx.data)if (!shapeKeys.includes(key)) extraKeys.push(key);
        }
        const pairs = [];
        for (const key of shapeKeys){
            const keyValidator = shape[key];
            const value = ctx.data[key];
            pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: keyValidator._parse(new $db5e9db6ef1a480f$var$ParseInputLazyPath(ctx, value, ctx.path, key)),
                alwaysSet: key in ctx.data
            });
        }
        if (this._def.catchall instanceof $db5e9db6ef1a480f$export$1e576a20c3ce9fb5) {
            const unknownKeys = this._def.unknownKeys;
            if (unknownKeys === "passthrough") for (const key of extraKeys)pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: {
                    status: "valid",
                    value: ctx.data[key]
                }
            });
            else if (unknownKeys === "strict") {
                if (extraKeys.length > 0) {
                    $db5e9db6ef1a480f$export$db7caee60e5d514d(ctx, {
                        code: $db5e9db6ef1a480f$export$5ba560653e4a1035.unrecognized_keys,
                        keys: extraKeys
                    });
                    status.dirty();
                }
            } else if (unknownKeys === "strip") ;
            else throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
        } else {
            // run catchall validation
            const catchall = this._def.catchall;
            for (const key of extraKeys){
                const value = ctx.data[key];
                pairs.push({
                    key: {
                        status: "valid",
                        value: key
                    },
                    value: catchall._parse(new $db5e9db6ef1a480f$var$ParseInputLazyPath(ctx, value, ctx.path, key) //, ctx.child(key), value, getParsedType(value)
                    ),
                    alwaysSet: key in ctx.data
                });
            }
        }
        if (ctx.common.async) return Promise.resolve().then(async ()=>{
            const syncPairs = [];
            for (const pair of pairs){
                const key = await pair.key;
                syncPairs.push({
                    key: key,
                    value: await pair.value,
                    alwaysSet: pair.alwaysSet
                });
            }
            return syncPairs;
        }).then((syncPairs)=>{
            return $db5e9db6ef1a480f$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
        });
        else return $db5e9db6ef1a480f$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
    }
    get shape() {
        return this._def.shape();
    }
    strict(message) {
        $db5e9db6ef1a480f$var$errorUtil.errToObj;
        return new $db5e9db6ef1a480f$export$736315c5b55efbad((0, $0de5391da8318002$export$581ff339ea0ba762)((0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, this._def), {
            unknownKeys: "strict"
        }), message !== undefined ? {
            errorMap: (issue, ctx)=>{
                var _a, _b, _c, _d;
                const defaultError = (_c = (_b = (_a = this._def).errorMap) === null || _b === void 0 ? void 0 : _b.call(_a, issue, ctx).message) !== null && _c !== void 0 ? _c : ctx.defaultError;
                if (issue.code === "unrecognized_keys") return {
                    message: (_d = $db5e9db6ef1a480f$var$errorUtil.errToObj(message).message) !== null && _d !== void 0 ? _d : defaultError
                };
                return {
                    message: defaultError
                };
            }
        } : {}));
    }
    strip() {
        return new $db5e9db6ef1a480f$export$736315c5b55efbad((0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, this._def), {
            unknownKeys: "strip"
        }));
    }
    passthrough() {
        return new $db5e9db6ef1a480f$export$736315c5b55efbad((0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, this._def), {
            unknownKeys: "passthrough"
        }));
    }
    // const AugmentFactory =
    //   <Def extends ZodObjectDef>(def: Def) =>
    //   <Augmentation extends ZodRawShape>(
    //     augmentation: Augmentation
    //   ): ZodObject<
    //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
    //     Def["unknownKeys"],
    //     Def["catchall"]
    //   > => {
    //     return new ZodObject({
    //       ...def,
    //       shape: () => ({
    //         ...def.shape(),
    //         ...augmentation,
    //       }),
    //     }) as any;
    //   };
    extend(augmentation) {
        return new $db5e9db6ef1a480f$export$736315c5b55efbad((0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, this._def), {
            shape: ()=>(0, $0de5391da8318002$export$581ff339ea0ba762)({}, this._def.shape(), augmentation)
        }));
    }
    /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */ merge(merging) {
        const merged = new $db5e9db6ef1a480f$export$736315c5b55efbad({
            unknownKeys: merging._def.unknownKeys,
            catchall: merging._def.catchall,
            shape: ()=>(0, $0de5391da8318002$export$581ff339ea0ba762)({}, this._def.shape(), merging._def.shape()),
            typeName: $db5e9db6ef1a480f$export$558106ce543bd011.ZodObject
        });
        return merged;
    }
    // merge<
    //   Incoming extends AnyZodObject,
    //   Augmentation extends Incoming["shape"],
    //   NewOutput extends {
    //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
    //       ? Augmentation[k]["_output"]
    //       : k extends keyof Output
    //       ? Output[k]
    //       : never;
    //   },
    //   NewInput extends {
    //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
    //       ? Augmentation[k]["_input"]
    //       : k extends keyof Input
    //       ? Input[k]
    //       : never;
    //   }
    // >(
    //   merging: Incoming
    // ): ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"],
    //   NewOutput,
    //   NewInput
    // > {
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    setKey(key, schema) {
        return this.augment({
            [key]: schema
        });
    }
    // merge<Incoming extends AnyZodObject>(
    //   merging: Incoming
    // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
    // ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"]
    // > {
    //   // const mergedShape = objectUtil.mergeShapes(
    //   //   this._def.shape(),
    //   //   merging._def.shape()
    //   // );
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    catchall(index) {
        return new $db5e9db6ef1a480f$export$736315c5b55efbad((0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, this._def), {
            catchall: index
        }));
    }
    pick(mask) {
        const shape = {};
        $db5e9db6ef1a480f$export$7debb50ef11d5e0b.objectKeys(mask).forEach((key)=>{
            if (mask[key] && this.shape[key]) shape[key] = this.shape[key];
        });
        return new $db5e9db6ef1a480f$export$736315c5b55efbad((0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, this._def), {
            shape: ()=>shape
        }));
    }
    omit(mask) {
        const shape = {};
        $db5e9db6ef1a480f$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            if (!mask[key]) shape[key] = this.shape[key];
        });
        return new $db5e9db6ef1a480f$export$736315c5b55efbad((0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, this._def), {
            shape: ()=>shape
        }));
    }
    /**
     * @deprecated
     */ deepPartial() {
        return $db5e9db6ef1a480f$var$deepPartialify(this);
    }
    partial(mask) {
        const newShape = {};
        $db5e9db6ef1a480f$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            const fieldSchema = this.shape[key];
            if (mask && !mask[key]) newShape[key] = fieldSchema;
            else newShape[key] = fieldSchema.optional();
        });
        return new $db5e9db6ef1a480f$export$736315c5b55efbad((0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, this._def), {
            shape: ()=>newShape
        }));
    }
    required(mask) {
        const newShape = {};
        $db5e9db6ef1a480f$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            if (mask && !mask[key]) newShape[key] = this.shape[key];
            else {
                const fieldSchema = this.shape[key];
                let newField = fieldSchema;
                while(newField instanceof $db5e9db6ef1a480f$export$aa56fec1e9d629b8)newField = newField._def.innerType;
                newShape[key] = newField;
            }
        });
        return new $db5e9db6ef1a480f$export$736315c5b55efbad((0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, this._def), {
            shape: ()=>newShape
        }));
    }
    keyof() {
        return $db5e9db6ef1a480f$var$createZodEnum($db5e9db6ef1a480f$export$7debb50ef11d5e0b.objectKeys(this.shape));
    }
    constructor(){
        super(...arguments);
        this._cached = null;
        /**
         * @deprecated In most cases, this is no longer needed - unknown properties are now silently stripped.
         * If you want to pass through unknown properties, use `.passthrough()` instead.
         */ this.nonstrict = this.passthrough;
        // extend<
        //   Augmentation extends ZodRawShape,
        //   NewOutput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
        //       ? Augmentation[k]["_output"]
        //       : k extends keyof Output
        //       ? Output[k]
        //       : never;
        //   }>,
        //   NewInput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
        //       ? Augmentation[k]["_input"]
        //       : k extends keyof Input
        //       ? Input[k]
        //       : never;
        //   }>
        // >(
        //   augmentation: Augmentation
        // ): ZodObject<
        //   extendShape<T, Augmentation>,
        //   UnknownKeys,
        //   Catchall,
        //   NewOutput,
        //   NewInput
        // > {
        //   return new ZodObject({
        //     ...this._def,
        //     shape: () => ({
        //       ...this._def.shape(),
        //       ...augmentation,
        //     }),
        //   }) as any;
        // }
        /**
         * @deprecated Use `.extend` instead
         *  */ this.augment = this.extend;
    }
}
$db5e9db6ef1a480f$export$736315c5b55efbad.create = (shape, params)=>{
    return new $db5e9db6ef1a480f$export$736315c5b55efbad((0, $0de5391da8318002$export$581ff339ea0ba762)({
        shape: ()=>shape,
        unknownKeys: "strip",
        catchall: $db5e9db6ef1a480f$export$1e576a20c3ce9fb5.create(),
        typeName: $db5e9db6ef1a480f$export$558106ce543bd011.ZodObject
    }, $db5e9db6ef1a480f$var$processCreateParams(params)));
};
$db5e9db6ef1a480f$export$736315c5b55efbad.strictCreate = (shape, params)=>{
    return new $db5e9db6ef1a480f$export$736315c5b55efbad((0, $0de5391da8318002$export$581ff339ea0ba762)({
        shape: ()=>shape,
        unknownKeys: "strict",
        catchall: $db5e9db6ef1a480f$export$1e576a20c3ce9fb5.create(),
        typeName: $db5e9db6ef1a480f$export$558106ce543bd011.ZodObject
    }, $db5e9db6ef1a480f$var$processCreateParams(params)));
};
$db5e9db6ef1a480f$export$736315c5b55efbad.lazycreate = (shape, params)=>{
    return new $db5e9db6ef1a480f$export$736315c5b55efbad((0, $0de5391da8318002$export$581ff339ea0ba762)({
        shape: shape,
        unknownKeys: "strip",
        catchall: $db5e9db6ef1a480f$export$1e576a20c3ce9fb5.create(),
        typeName: $db5e9db6ef1a480f$export$558106ce543bd011.ZodObject
    }, $db5e9db6ef1a480f$var$processCreateParams(params)));
};
class $db5e9db6ef1a480f$export$a8b236cb5070a311 extends $db5e9db6ef1a480f$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const options = this._def.options;
        function handleResults(results) {
            // return first issue-free validation if it exists
            for (const result of results){
                if (result.result.status === "valid") return result.result;
            }
            for (const result of results)if (result.result.status === "dirty") {
                // add issues from dirty option
                ctx.common.issues.push(...result.ctx.common.issues);
                return result.result;
            }
            // return invalid
            const unionErrors = results.map((result)=>new $db5e9db6ef1a480f$export$f98dac4b251ab333(result.ctx.common.issues));
            $db5e9db6ef1a480f$export$db7caee60e5d514d(ctx, {
                code: $db5e9db6ef1a480f$export$5ba560653e4a1035.invalid_union,
                unionErrors: unionErrors
            });
            return $db5e9db6ef1a480f$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return Promise.all(options.map(async (option)=>{
            const childCtx = (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, ctx), {
                common: (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, ctx.common), {
                    issues: []
                }),
                parent: null
            });
            return {
                result: await option._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                }),
                ctx: childCtx
            };
        })).then(handleResults);
        else {
            let dirty = undefined;
            const issues = [];
            for (const option of options){
                const childCtx = (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, ctx), {
                    common: (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, ctx.common), {
                        issues: []
                    }),
                    parent: null
                });
                const result = option._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                });
                if (result.status === "valid") return result;
                else if (result.status === "dirty" && !dirty) dirty = {
                    result: result,
                    ctx: childCtx
                };
                if (childCtx.common.issues.length) issues.push(childCtx.common.issues);
            }
            if (dirty) {
                ctx.common.issues.push(...dirty.ctx.common.issues);
                return dirty.result;
            }
            const unionErrors = issues.map((issues)=>new $db5e9db6ef1a480f$export$f98dac4b251ab333(issues));
            $db5e9db6ef1a480f$export$db7caee60e5d514d(ctx, {
                code: $db5e9db6ef1a480f$export$5ba560653e4a1035.invalid_union,
                unionErrors: unionErrors
            });
            return $db5e9db6ef1a480f$export$9a105a556e65c2c0;
        }
    }
    get options() {
        return this._def.options;
    }
}
$db5e9db6ef1a480f$export$a8b236cb5070a311.create = (types, params)=>{
    return new $db5e9db6ef1a480f$export$a8b236cb5070a311((0, $0de5391da8318002$export$581ff339ea0ba762)({
        options: types,
        typeName: $db5e9db6ef1a480f$export$558106ce543bd011.ZodUnion
    }, $db5e9db6ef1a480f$var$processCreateParams(params)));
};
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//////////                                 //////////
//////////      ZodDiscriminatedUnion      //////////
//////////                                 //////////
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
const $db5e9db6ef1a480f$var$getDiscriminator = (type)=>{
    if (type instanceof $db5e9db6ef1a480f$export$378d0cfce37406e6) return $db5e9db6ef1a480f$var$getDiscriminator(type.schema);
    else if (type instanceof $db5e9db6ef1a480f$export$a60af00cc0ce2582) return $db5e9db6ef1a480f$var$getDiscriminator(type.innerType());
    else if (type instanceof $db5e9db6ef1a480f$export$7e44096782a165d3) return [
        type.value
    ];
    else if (type instanceof $db5e9db6ef1a480f$export$d325d1f0e1c20179) return type.options;
    else if (type instanceof $db5e9db6ef1a480f$export$370b2e8d6d6f5c56) // eslint-disable-next-line ban/ban
    return Object.keys(type.enum);
    else if (type instanceof $db5e9db6ef1a480f$export$bb19b37874861e7e) return $db5e9db6ef1a480f$var$getDiscriminator(type._def.innerType);
    else if (type instanceof $db5e9db6ef1a480f$export$4e780e961c30340d) return [
        undefined
    ];
    else if (type instanceof $db5e9db6ef1a480f$export$a96281f914484f2d) return [
        null
    ];
    else return null;
};
class $db5e9db6ef1a480f$export$5ef2424805ac76a3 extends $db5e9db6ef1a480f$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $db5e9db6ef1a480f$export$5716da67bfaa244d.object) {
            $db5e9db6ef1a480f$export$db7caee60e5d514d(ctx, {
                code: $db5e9db6ef1a480f$export$5ba560653e4a1035.invalid_type,
                expected: $db5e9db6ef1a480f$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $db5e9db6ef1a480f$export$9a105a556e65c2c0;
        }
        const discriminator = this.discriminator;
        const discriminatorValue = ctx.data[discriminator];
        const option = this.optionsMap.get(discriminatorValue);
        if (!option) {
            $db5e9db6ef1a480f$export$db7caee60e5d514d(ctx, {
                code: $db5e9db6ef1a480f$export$5ba560653e4a1035.invalid_union_discriminator,
                options: Array.from(this.optionsMap.keys()),
                path: [
                    discriminator
                ]
            });
            return $db5e9db6ef1a480f$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return option._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
        else return option._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
    get discriminator() {
        return this._def.discriminator;
    }
    get options() {
        return this._def.options;
    }
    get optionsMap() {
        return this._def.optionsMap;
    }
    /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */ static create(discriminator, options, params) {
        // Get all the valid discriminator values
        const optionsMap = new Map();
        // try {
        for (const type of options){
            const discriminatorValues = $db5e9db6ef1a480f$var$getDiscriminator(type.shape[discriminator]);
            if (!discriminatorValues) throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
            for (const value of discriminatorValues){
                if (optionsMap.has(value)) throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
                optionsMap.set(value, type);
            }
        }
        return new $db5e9db6ef1a480f$export$5ef2424805ac76a3((0, $0de5391da8318002$export$581ff339ea0ba762)({
            typeName: $db5e9db6ef1a480f$export$558106ce543bd011.ZodDiscriminatedUnion,
            discriminator: discriminator,
            options: options,
            optionsMap: optionsMap
        }, $db5e9db6ef1a480f$var$processCreateParams(params)));
    }
}
function $db5e9db6ef1a480f$var$mergeValues(a, b) {
    const aType = $db5e9db6ef1a480f$export$3e9057828ebd5c7a(a);
    const bType = $db5e9db6ef1a480f$export$3e9057828ebd5c7a(b);
    if (a === b) return {
        valid: true,
        data: a
    };
    else if (aType === $db5e9db6ef1a480f$export$5716da67bfaa244d.object && bType === $db5e9db6ef1a480f$export$5716da67bfaa244d.object) {
        const bKeys = $db5e9db6ef1a480f$export$7debb50ef11d5e0b.objectKeys(b);
        const sharedKeys = $db5e9db6ef1a480f$export$7debb50ef11d5e0b.objectKeys(a).filter((key)=>bKeys.indexOf(key) !== -1);
        const newObj = (0, $0de5391da8318002$export$581ff339ea0ba762)({}, a, b);
        for (const key of sharedKeys){
            const sharedValue = $db5e9db6ef1a480f$var$mergeValues(a[key], b[key]);
            if (!sharedValue.valid) return {
                valid: false
            };
            newObj[key] = sharedValue.data;
        }
        return {
            valid: true,
            data: newObj
        };
    } else if (aType === $db5e9db6ef1a480f$export$5716da67bfaa244d.array && bType === $db5e9db6ef1a480f$export$5716da67bfaa244d.array) {
        if (a.length !== b.length) return {
            valid: false
        };
        const newArray = [];
        for(let index = 0; index < a.length; index++){
            const itemA = a[index];
            const itemB = b[index];
            const sharedValue = $db5e9db6ef1a480f$var$mergeValues(itemA, itemB);
            if (!sharedValue.valid) return {
                valid: false
            };
            newArray.push(sharedValue.data);
        }
        return {
            valid: true,
            data: newArray
        };
    } else if (aType === $db5e9db6ef1a480f$export$5716da67bfaa244d.date && bType === $db5e9db6ef1a480f$export$5716da67bfaa244d.date && +a === +b) return {
        valid: true,
        data: a
    };
    else return {
        valid: false
    };
}
class $db5e9db6ef1a480f$export$c02deaf0bb5203d4 extends $db5e9db6ef1a480f$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const handleParsed = (parsedLeft, parsedRight)=>{
            if ($db5e9db6ef1a480f$export$afa861e3c5730743(parsedLeft) || $db5e9db6ef1a480f$export$afa861e3c5730743(parsedRight)) return $db5e9db6ef1a480f$export$9a105a556e65c2c0;
            const merged = $db5e9db6ef1a480f$var$mergeValues(parsedLeft.value, parsedRight.value);
            if (!merged.valid) {
                $db5e9db6ef1a480f$export$db7caee60e5d514d(ctx, {
                    code: $db5e9db6ef1a480f$export$5ba560653e4a1035.invalid_intersection_types
                });
                return $db5e9db6ef1a480f$export$9a105a556e65c2c0;
            }
            if ($db5e9db6ef1a480f$export$910b6cdd390341b3(parsedLeft) || $db5e9db6ef1a480f$export$910b6cdd390341b3(parsedRight)) status.dirty();
            return {
                status: status.value,
                value: merged.data
            };
        };
        if (ctx.common.async) return Promise.all([
            this._def.left._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }),
            this._def.right._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            })
        ]).then(([left, right])=>handleParsed(left, right));
        else return handleParsed(this._def.left._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }), this._def.right._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }));
    }
}
$db5e9db6ef1a480f$export$c02deaf0bb5203d4.create = (left, right, params)=>{
    return new $db5e9db6ef1a480f$export$c02deaf0bb5203d4((0, $0de5391da8318002$export$581ff339ea0ba762)({
        left: left,
        right: right,
        typeName: $db5e9db6ef1a480f$export$558106ce543bd011.ZodIntersection
    }, $db5e9db6ef1a480f$var$processCreateParams(params)));
};
class $db5e9db6ef1a480f$export$e2a18bb771d8e6a3 extends $db5e9db6ef1a480f$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $db5e9db6ef1a480f$export$5716da67bfaa244d.array) {
            $db5e9db6ef1a480f$export$db7caee60e5d514d(ctx, {
                code: $db5e9db6ef1a480f$export$5ba560653e4a1035.invalid_type,
                expected: $db5e9db6ef1a480f$export$5716da67bfaa244d.array,
                received: ctx.parsedType
            });
            return $db5e9db6ef1a480f$export$9a105a556e65c2c0;
        }
        if (ctx.data.length < this._def.items.length) {
            $db5e9db6ef1a480f$export$db7caee60e5d514d(ctx, {
                code: $db5e9db6ef1a480f$export$5ba560653e4a1035.too_small,
                minimum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            return $db5e9db6ef1a480f$export$9a105a556e65c2c0;
        }
        const rest = this._def.rest;
        if (!rest && ctx.data.length > this._def.items.length) {
            $db5e9db6ef1a480f$export$db7caee60e5d514d(ctx, {
                code: $db5e9db6ef1a480f$export$5ba560653e4a1035.too_big,
                maximum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            status.dirty();
        }
        const items = [
            ...ctx.data
        ].map((item, itemIndex)=>{
            const schema = this._def.items[itemIndex] || this._def.rest;
            if (!schema) return null;
            return schema._parse(new $db5e9db6ef1a480f$var$ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
        }).filter((x)=>!!x); // filter nulls
        if (ctx.common.async) return Promise.all(items).then((results)=>{
            return $db5e9db6ef1a480f$export$5b20a5c3d05c1f6f.mergeArray(status, results);
        });
        else return $db5e9db6ef1a480f$export$5b20a5c3d05c1f6f.mergeArray(status, items);
    }
    get items() {
        return this._def.items;
    }
    rest(rest) {
        return new $db5e9db6ef1a480f$export$e2a18bb771d8e6a3((0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, this._def), {
            rest: rest
        }));
    }
}
$db5e9db6ef1a480f$export$e2a18bb771d8e6a3.create = (schemas, params)=>{
    if (!Array.isArray(schemas)) throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    return new $db5e9db6ef1a480f$export$e2a18bb771d8e6a3((0, $0de5391da8318002$export$581ff339ea0ba762)({
        items: schemas,
        typeName: $db5e9db6ef1a480f$export$558106ce543bd011.ZodTuple,
        rest: null
    }, $db5e9db6ef1a480f$var$processCreateParams(params)));
};
class $db5e9db6ef1a480f$export$a2acc09968cb4b7f extends $db5e9db6ef1a480f$export$19342e026b58ebb7 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $db5e9db6ef1a480f$export$5716da67bfaa244d.object) {
            $db5e9db6ef1a480f$export$db7caee60e5d514d(ctx, {
                code: $db5e9db6ef1a480f$export$5ba560653e4a1035.invalid_type,
                expected: $db5e9db6ef1a480f$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $db5e9db6ef1a480f$export$9a105a556e65c2c0;
        }
        const pairs = [];
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        for(const key in ctx.data)pairs.push({
            key: keyType._parse(new $db5e9db6ef1a480f$var$ParseInputLazyPath(ctx, key, ctx.path, key)),
            value: valueType._parse(new $db5e9db6ef1a480f$var$ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key))
        });
        if (ctx.common.async) return $db5e9db6ef1a480f$export$5b20a5c3d05c1f6f.mergeObjectAsync(status, pairs);
        else return $db5e9db6ef1a480f$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
    }
    get element() {
        return this._def.valueType;
    }
    static create(first, second, third) {
        if (second instanceof $db5e9db6ef1a480f$export$19342e026b58ebb7) return new $db5e9db6ef1a480f$export$a2acc09968cb4b7f((0, $0de5391da8318002$export$581ff339ea0ba762)({
            keyType: first,
            valueType: second,
            typeName: $db5e9db6ef1a480f$export$558106ce543bd011.ZodRecord
        }, $db5e9db6ef1a480f$var$processCreateParams(third)));
        return new $db5e9db6ef1a480f$export$a2acc09968cb4b7f((0, $0de5391da8318002$export$581ff339ea0ba762)({
            keyType: $db5e9db6ef1a480f$export$1230eb29b8d3b502.create(),
            valueType: first,
            typeName: $db5e9db6ef1a480f$export$558106ce543bd011.ZodRecord
        }, $db5e9db6ef1a480f$var$processCreateParams(second)));
    }
}
class $db5e9db6ef1a480f$export$163b6a2b712d9542 extends $db5e9db6ef1a480f$export$19342e026b58ebb7 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $db5e9db6ef1a480f$export$5716da67bfaa244d.map) {
            $db5e9db6ef1a480f$export$db7caee60e5d514d(ctx, {
                code: $db5e9db6ef1a480f$export$5ba560653e4a1035.invalid_type,
                expected: $db5e9db6ef1a480f$export$5716da67bfaa244d.map,
                received: ctx.parsedType
            });
            return $db5e9db6ef1a480f$export$9a105a556e65c2c0;
        }
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        const pairs = [
            ...ctx.data.entries()
        ].map(([key, value], index)=>{
            return {
                key: keyType._parse(new $db5e9db6ef1a480f$var$ParseInputLazyPath(ctx, key, ctx.path, [
                    index,
                    "key"
                ])),
                value: valueType._parse(new $db5e9db6ef1a480f$var$ParseInputLazyPath(ctx, value, ctx.path, [
                    index,
                    "value"
                ]))
            };
        });
        if (ctx.common.async) {
            const finalMap = new Map();
            return Promise.resolve().then(async ()=>{
                for (const pair of pairs){
                    const key = await pair.key;
                    const value = await pair.value;
                    if (key.status === "aborted" || value.status === "aborted") return $db5e9db6ef1a480f$export$9a105a556e65c2c0;
                    if (key.status === "dirty" || value.status === "dirty") status.dirty();
                    finalMap.set(key.value, value.value);
                }
                return {
                    status: status.value,
                    value: finalMap
                };
            });
        } else {
            const finalMap = new Map();
            for (const pair of pairs){
                const key = pair.key;
                const value = pair.value;
                if (key.status === "aborted" || value.status === "aborted") return $db5e9db6ef1a480f$export$9a105a556e65c2c0;
                if (key.status === "dirty" || value.status === "dirty") status.dirty();
                finalMap.set(key.value, value.value);
            }
            return {
                status: status.value,
                value: finalMap
            };
        }
    }
}
$db5e9db6ef1a480f$export$163b6a2b712d9542.create = (keyType, valueType, params)=>{
    return new $db5e9db6ef1a480f$export$163b6a2b712d9542((0, $0de5391da8318002$export$581ff339ea0ba762)({
        valueType: valueType,
        keyType: keyType,
        typeName: $db5e9db6ef1a480f$export$558106ce543bd011.ZodMap
    }, $db5e9db6ef1a480f$var$processCreateParams(params)));
};
class $db5e9db6ef1a480f$export$977057706f816712 extends $db5e9db6ef1a480f$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $db5e9db6ef1a480f$export$5716da67bfaa244d.set) {
            $db5e9db6ef1a480f$export$db7caee60e5d514d(ctx, {
                code: $db5e9db6ef1a480f$export$5ba560653e4a1035.invalid_type,
                expected: $db5e9db6ef1a480f$export$5716da67bfaa244d.set,
                received: ctx.parsedType
            });
            return $db5e9db6ef1a480f$export$9a105a556e65c2c0;
        }
        const def = this._def;
        if (def.minSize !== null) {
            if (ctx.data.size < def.minSize.value) {
                $db5e9db6ef1a480f$export$db7caee60e5d514d(ctx, {
                    code: $db5e9db6ef1a480f$export$5ba560653e4a1035.too_small,
                    minimum: def.minSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.minSize.message
                });
                status.dirty();
            }
        }
        if (def.maxSize !== null) {
            if (ctx.data.size > def.maxSize.value) {
                $db5e9db6ef1a480f$export$db7caee60e5d514d(ctx, {
                    code: $db5e9db6ef1a480f$export$5ba560653e4a1035.too_big,
                    maximum: def.maxSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.maxSize.message
                });
                status.dirty();
            }
        }
        const valueType = this._def.valueType;
        function finalizeSet(elements) {
            const parsedSet = new Set();
            for (const element of elements){
                if (element.status === "aborted") return $db5e9db6ef1a480f$export$9a105a556e65c2c0;
                if (element.status === "dirty") status.dirty();
                parsedSet.add(element.value);
            }
            return {
                status: status.value,
                value: parsedSet
            };
        }
        const elements = [
            ...ctx.data.values()
        ].map((item, i)=>valueType._parse(new $db5e9db6ef1a480f$var$ParseInputLazyPath(ctx, item, ctx.path, i)));
        if (ctx.common.async) return Promise.all(elements).then((elements)=>finalizeSet(elements));
        else return finalizeSet(elements);
    }
    min(minSize, message) {
        return new $db5e9db6ef1a480f$export$977057706f816712((0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, this._def), {
            minSize: {
                value: minSize,
                message: $db5e9db6ef1a480f$var$errorUtil.toString(message)
            }
        }));
    }
    max(maxSize, message) {
        return new $db5e9db6ef1a480f$export$977057706f816712((0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, this._def), {
            maxSize: {
                value: maxSize,
                message: $db5e9db6ef1a480f$var$errorUtil.toString(message)
            }
        }));
    }
    size(size, message) {
        return this.min(size, message).max(size, message);
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$db5e9db6ef1a480f$export$977057706f816712.create = (valueType, params)=>{
    return new $db5e9db6ef1a480f$export$977057706f816712((0, $0de5391da8318002$export$581ff339ea0ba762)({
        valueType: valueType,
        minSize: null,
        maxSize: null,
        typeName: $db5e9db6ef1a480f$export$558106ce543bd011.ZodSet
    }, $db5e9db6ef1a480f$var$processCreateParams(params)));
};
class $db5e9db6ef1a480f$export$d4602ba55673f53c extends $db5e9db6ef1a480f$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $db5e9db6ef1a480f$export$5716da67bfaa244d.function) {
            $db5e9db6ef1a480f$export$db7caee60e5d514d(ctx, {
                code: $db5e9db6ef1a480f$export$5ba560653e4a1035.invalid_type,
                expected: $db5e9db6ef1a480f$export$5716da67bfaa244d.function,
                received: ctx.parsedType
            });
            return $db5e9db6ef1a480f$export$9a105a556e65c2c0;
        }
        function makeArgsIssue(args, error) {
            return $db5e9db6ef1a480f$export$244a85fde9c419ed({
                data: args,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    $db5e9db6ef1a480f$export$32f27c719778d4c4(),
                    $db5e9db6ef1a480f$export$341b0b6e0a6f5099
                ].filter((x)=>!!x),
                issueData: {
                    code: $db5e9db6ef1a480f$export$5ba560653e4a1035.invalid_arguments,
                    argumentsError: error
                }
            });
        }
        function makeReturnsIssue(returns, error) {
            return $db5e9db6ef1a480f$export$244a85fde9c419ed({
                data: returns,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    $db5e9db6ef1a480f$export$32f27c719778d4c4(),
                    $db5e9db6ef1a480f$export$341b0b6e0a6f5099
                ].filter((x)=>!!x),
                issueData: {
                    code: $db5e9db6ef1a480f$export$5ba560653e4a1035.invalid_return_type,
                    returnTypeError: error
                }
            });
        }
        const params = {
            errorMap: ctx.common.contextualErrorMap
        };
        const fn = ctx.data;
        if (this._def.returns instanceof $db5e9db6ef1a480f$export$3f196b0127d6e50a) {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return $db5e9db6ef1a480f$export$c6813a8d51f77eaf(async function(...args) {
                const error = new $db5e9db6ef1a480f$export$f98dac4b251ab333([]);
                const parsedArgs = await me._def.args.parseAsync(args, params).catch((e)=>{
                    error.addIssue(makeArgsIssue(args, e));
                    throw error;
                });
                const result = await Reflect.apply(fn, this, parsedArgs);
                const parsedReturns = await me._def.returns._def.type.parseAsync(result, params).catch((e)=>{
                    error.addIssue(makeReturnsIssue(result, e));
                    throw error;
                });
                return parsedReturns;
            });
        } else {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return $db5e9db6ef1a480f$export$c6813a8d51f77eaf(function(...args) {
                const parsedArgs = me._def.args.safeParse(args, params);
                if (!parsedArgs.success) throw new $db5e9db6ef1a480f$export$f98dac4b251ab333([
                    makeArgsIssue(args, parsedArgs.error)
                ]);
                const result = Reflect.apply(fn, this, parsedArgs.data);
                const parsedReturns = me._def.returns.safeParse(result, params);
                if (!parsedReturns.success) throw new $db5e9db6ef1a480f$export$f98dac4b251ab333([
                    makeReturnsIssue(result, parsedReturns.error)
                ]);
                return parsedReturns.data;
            });
        }
    }
    parameters() {
        return this._def.args;
    }
    returnType() {
        return this._def.returns;
    }
    args(...items) {
        return new $db5e9db6ef1a480f$export$d4602ba55673f53c((0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, this._def), {
            args: $db5e9db6ef1a480f$export$e2a18bb771d8e6a3.create(items).rest($db5e9db6ef1a480f$export$ef3b1bb1630977ae.create())
        }));
    }
    returns(returnType) {
        return new $db5e9db6ef1a480f$export$d4602ba55673f53c((0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, this._def), {
            returns: returnType
        }));
    }
    implement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    strictImplement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    static create(args, returns, params) {
        return new $db5e9db6ef1a480f$export$d4602ba55673f53c((0, $0de5391da8318002$export$581ff339ea0ba762)({
            args: args ? args : $db5e9db6ef1a480f$export$e2a18bb771d8e6a3.create([]).rest($db5e9db6ef1a480f$export$ef3b1bb1630977ae.create()),
            returns: returns || $db5e9db6ef1a480f$export$ef3b1bb1630977ae.create(),
            typeName: $db5e9db6ef1a480f$export$558106ce543bd011.ZodFunction
        }, $db5e9db6ef1a480f$var$processCreateParams(params)));
    }
    constructor(){
        super(...arguments);
        this.validate = this.implement;
    }
}
class $db5e9db6ef1a480f$export$378d0cfce37406e6 extends $db5e9db6ef1a480f$export$19342e026b58ebb7 {
    get schema() {
        return this._def.getter();
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const lazySchema = this._def.getter();
        return lazySchema._parse({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
}
$db5e9db6ef1a480f$export$378d0cfce37406e6.create = (getter, params)=>{
    return new $db5e9db6ef1a480f$export$378d0cfce37406e6((0, $0de5391da8318002$export$581ff339ea0ba762)({
        getter: getter,
        typeName: $db5e9db6ef1a480f$export$558106ce543bd011.ZodLazy
    }, $db5e9db6ef1a480f$var$processCreateParams(params)));
};
class $db5e9db6ef1a480f$export$7e44096782a165d3 extends $db5e9db6ef1a480f$export$19342e026b58ebb7 {
    _parse(input) {
        if (input.data !== this._def.value) {
            const ctx = this._getOrReturnCtx(input);
            $db5e9db6ef1a480f$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $db5e9db6ef1a480f$export$5ba560653e4a1035.invalid_literal,
                expected: this._def.value
            });
            return $db5e9db6ef1a480f$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
    get value() {
        return this._def.value;
    }
}
$db5e9db6ef1a480f$export$7e44096782a165d3.create = (value, params)=>{
    return new $db5e9db6ef1a480f$export$7e44096782a165d3((0, $0de5391da8318002$export$581ff339ea0ba762)({
        value: value,
        typeName: $db5e9db6ef1a480f$export$558106ce543bd011.ZodLiteral
    }, $db5e9db6ef1a480f$var$processCreateParams(params)));
};
function $db5e9db6ef1a480f$var$createZodEnum(values, params) {
    return new $db5e9db6ef1a480f$export$d325d1f0e1c20179((0, $0de5391da8318002$export$581ff339ea0ba762)({
        values: values,
        typeName: $db5e9db6ef1a480f$export$558106ce543bd011.ZodEnum
    }, $db5e9db6ef1a480f$var$processCreateParams(params)));
}
class $db5e9db6ef1a480f$export$d325d1f0e1c20179 extends $db5e9db6ef1a480f$export$19342e026b58ebb7 {
    _parse(input) {
        if (typeof input.data !== "string") {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            $db5e9db6ef1a480f$export$db7caee60e5d514d(ctx, {
                expected: $db5e9db6ef1a480f$export$7debb50ef11d5e0b.joinValues(expectedValues),
                received: ctx.parsedType,
                code: $db5e9db6ef1a480f$export$5ba560653e4a1035.invalid_type
            });
            return $db5e9db6ef1a480f$export$9a105a556e65c2c0;
        }
        if (this._def.values.indexOf(input.data) === -1) {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            $db5e9db6ef1a480f$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $db5e9db6ef1a480f$export$5ba560653e4a1035.invalid_enum_value,
                options: expectedValues
            });
            return $db5e9db6ef1a480f$export$9a105a556e65c2c0;
        }
        return $db5e9db6ef1a480f$export$c6813a8d51f77eaf(input.data);
    }
    get options() {
        return this._def.values;
    }
    get enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Values() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    extract(values) {
        return $db5e9db6ef1a480f$export$d325d1f0e1c20179.create(values);
    }
    exclude(values) {
        return $db5e9db6ef1a480f$export$d325d1f0e1c20179.create(this.options.filter((opt)=>!values.includes(opt)));
    }
}
$db5e9db6ef1a480f$export$d325d1f0e1c20179.create = $db5e9db6ef1a480f$var$createZodEnum;
class $db5e9db6ef1a480f$export$370b2e8d6d6f5c56 extends $db5e9db6ef1a480f$export$19342e026b58ebb7 {
    _parse(input) {
        const nativeEnumValues = $db5e9db6ef1a480f$export$7debb50ef11d5e0b.getValidEnumValues(this._def.values);
        const ctx = this._getOrReturnCtx(input);
        if (ctx.parsedType !== $db5e9db6ef1a480f$export$5716da67bfaa244d.string && ctx.parsedType !== $db5e9db6ef1a480f$export$5716da67bfaa244d.number) {
            const expectedValues = $db5e9db6ef1a480f$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
            $db5e9db6ef1a480f$export$db7caee60e5d514d(ctx, {
                expected: $db5e9db6ef1a480f$export$7debb50ef11d5e0b.joinValues(expectedValues),
                received: ctx.parsedType,
                code: $db5e9db6ef1a480f$export$5ba560653e4a1035.invalid_type
            });
            return $db5e9db6ef1a480f$export$9a105a556e65c2c0;
        }
        if (nativeEnumValues.indexOf(input.data) === -1) {
            const expectedValues = $db5e9db6ef1a480f$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
            $db5e9db6ef1a480f$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $db5e9db6ef1a480f$export$5ba560653e4a1035.invalid_enum_value,
                options: expectedValues
            });
            return $db5e9db6ef1a480f$export$9a105a556e65c2c0;
        }
        return $db5e9db6ef1a480f$export$c6813a8d51f77eaf(input.data);
    }
    get enum() {
        return this._def.values;
    }
}
$db5e9db6ef1a480f$export$370b2e8d6d6f5c56.create = (values, params)=>{
    return new $db5e9db6ef1a480f$export$370b2e8d6d6f5c56((0, $0de5391da8318002$export$581ff339ea0ba762)({
        values: values,
        typeName: $db5e9db6ef1a480f$export$558106ce543bd011.ZodNativeEnum
    }, $db5e9db6ef1a480f$var$processCreateParams(params)));
};
class $db5e9db6ef1a480f$export$3f196b0127d6e50a extends $db5e9db6ef1a480f$export$19342e026b58ebb7 {
    unwrap() {
        return this._def.type;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $db5e9db6ef1a480f$export$5716da67bfaa244d.promise && ctx.common.async === false) {
            $db5e9db6ef1a480f$export$db7caee60e5d514d(ctx, {
                code: $db5e9db6ef1a480f$export$5ba560653e4a1035.invalid_type,
                expected: $db5e9db6ef1a480f$export$5716da67bfaa244d.promise,
                received: ctx.parsedType
            });
            return $db5e9db6ef1a480f$export$9a105a556e65c2c0;
        }
        const promisified = ctx.parsedType === $db5e9db6ef1a480f$export$5716da67bfaa244d.promise ? ctx.data : Promise.resolve(ctx.data);
        return $db5e9db6ef1a480f$export$c6813a8d51f77eaf(promisified.then((data)=>{
            return this._def.type.parseAsync(data, {
                path: ctx.path,
                errorMap: ctx.common.contextualErrorMap
            });
        }));
    }
}
$db5e9db6ef1a480f$export$3f196b0127d6e50a.create = (schema, params)=>{
    return new $db5e9db6ef1a480f$export$3f196b0127d6e50a((0, $0de5391da8318002$export$581ff339ea0ba762)({
        type: schema,
        typeName: $db5e9db6ef1a480f$export$558106ce543bd011.ZodPromise
    }, $db5e9db6ef1a480f$var$processCreateParams(params)));
};
class $db5e9db6ef1a480f$export$a60af00cc0ce2582 extends $db5e9db6ef1a480f$export$19342e026b58ebb7 {
    innerType() {
        return this._def.schema;
    }
    sourceType() {
        return this._def.schema._def.typeName === $db5e9db6ef1a480f$export$558106ce543bd011.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const effect = this._def.effect || null;
        const checkCtx = {
            addIssue: (arg)=>{
                $db5e9db6ef1a480f$export$db7caee60e5d514d(ctx, arg);
                if (arg.fatal) status.abort();
                else status.dirty();
            },
            get path () {
                return ctx.path;
            }
        };
        checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
        if (effect.type === "preprocess") {
            const processed = effect.transform(ctx.data, checkCtx);
            if (ctx.common.issues.length) return {
                status: "dirty",
                value: ctx.data
            };
            if (ctx.common.async) return Promise.resolve(processed).then((processed)=>{
                return this._def.schema._parseAsync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
            });
            else return this._def.schema._parseSync({
                data: processed,
                path: ctx.path,
                parent: ctx
            });
        }
        if (effect.type === "refinement") {
            const executeRefinement = (acc)=>{
                const result = effect.refinement(acc, checkCtx);
                if (ctx.common.async) return Promise.resolve(result);
                if (result instanceof Promise) throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
                return acc;
            };
            if (ctx.common.async === false) {
                const inner = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inner.status === "aborted") return $db5e9db6ef1a480f$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                // return value is ignored
                executeRefinement(inner.value);
                return {
                    status: status.value,
                    value: inner.value
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((inner)=>{
                if (inner.status === "aborted") return $db5e9db6ef1a480f$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                return executeRefinement(inner.value).then(()=>{
                    return {
                        status: status.value,
                        value: inner.value
                    };
                });
            });
        }
        if (effect.type === "transform") {
            if (ctx.common.async === false) {
                const base = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (!$db5e9db6ef1a480f$export$1ea939691cdc45b8(base)) return base;
                const result = effect.transform(base.value, checkCtx);
                if (result instanceof Promise) throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
                return {
                    status: status.value,
                    value: result
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((base)=>{
                if (!$db5e9db6ef1a480f$export$1ea939691cdc45b8(base)) return base;
                return Promise.resolve(effect.transform(base.value, checkCtx)).then((result)=>({
                        status: status.value,
                        value: result
                    }));
            });
        }
        $db5e9db6ef1a480f$export$7debb50ef11d5e0b.assertNever(effect);
    }
}
$db5e9db6ef1a480f$export$a60af00cc0ce2582.create = (schema, effect, params)=>{
    return new $db5e9db6ef1a480f$export$a60af00cc0ce2582((0, $0de5391da8318002$export$581ff339ea0ba762)({
        schema: schema,
        typeName: $db5e9db6ef1a480f$export$558106ce543bd011.ZodEffects,
        effect: effect
    }, $db5e9db6ef1a480f$var$processCreateParams(params)));
};
$db5e9db6ef1a480f$export$a60af00cc0ce2582.createWithPreprocess = (preprocess, schema, params)=>{
    return new $db5e9db6ef1a480f$export$a60af00cc0ce2582((0, $0de5391da8318002$export$581ff339ea0ba762)({
        schema: schema,
        effect: {
            type: "preprocess",
            transform: preprocess
        },
        typeName: $db5e9db6ef1a480f$export$558106ce543bd011.ZodEffects
    }, $db5e9db6ef1a480f$var$processCreateParams(params)));
};
class $db5e9db6ef1a480f$export$aa56fec1e9d629b8 extends $db5e9db6ef1a480f$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === $db5e9db6ef1a480f$export$5716da67bfaa244d.undefined) return $db5e9db6ef1a480f$export$c6813a8d51f77eaf(undefined);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$db5e9db6ef1a480f$export$aa56fec1e9d629b8.create = (type, params)=>{
    return new $db5e9db6ef1a480f$export$aa56fec1e9d629b8((0, $0de5391da8318002$export$581ff339ea0ba762)({
        innerType: type,
        typeName: $db5e9db6ef1a480f$export$558106ce543bd011.ZodOptional
    }, $db5e9db6ef1a480f$var$processCreateParams(params)));
};
class $db5e9db6ef1a480f$export$aaac0b8b429cef5 extends $db5e9db6ef1a480f$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === $db5e9db6ef1a480f$export$5716da67bfaa244d.null) return $db5e9db6ef1a480f$export$c6813a8d51f77eaf(null);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$db5e9db6ef1a480f$export$aaac0b8b429cef5.create = (type, params)=>{
    return new $db5e9db6ef1a480f$export$aaac0b8b429cef5((0, $0de5391da8318002$export$581ff339ea0ba762)({
        innerType: type,
        typeName: $db5e9db6ef1a480f$export$558106ce543bd011.ZodNullable
    }, $db5e9db6ef1a480f$var$processCreateParams(params)));
};
class $db5e9db6ef1a480f$export$bb19b37874861e7e extends $db5e9db6ef1a480f$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        let data = ctx.data;
        if (ctx.parsedType === $db5e9db6ef1a480f$export$5716da67bfaa244d.undefined) data = this._def.defaultValue();
        return this._def.innerType._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    removeDefault() {
        return this._def.innerType;
    }
}
$db5e9db6ef1a480f$export$bb19b37874861e7e.create = (type, params)=>{
    return new $db5e9db6ef1a480f$export$bb19b37874861e7e((0, $0de5391da8318002$export$581ff339ea0ba762)({
        innerType: type,
        typeName: $db5e9db6ef1a480f$export$558106ce543bd011.ZodDefault,
        defaultValue: typeof params.default === "function" ? params.default : ()=>params.default
    }, $db5e9db6ef1a480f$var$processCreateParams(params)));
};
class $db5e9db6ef1a480f$export$75a44ec6249ac76b extends $db5e9db6ef1a480f$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        // newCtx is used to not collect issues from inner types in ctx
        const newCtx = (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, ctx), {
            common: (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, ctx.common), {
                issues: []
            })
        });
        const result = this._def.innerType._parse({
            data: newCtx.data,
            path: newCtx.path,
            parent: (0, $0de5391da8318002$export$581ff339ea0ba762)({}, newCtx)
        });
        if ($db5e9db6ef1a480f$export$aefee5ebe1dcfd9e(result)) return result.then((result)=>{
            return {
                status: "valid",
                value: result.status === "valid" ? result.value : this._def.catchValue({
                    get error () {
                        return new $db5e9db6ef1a480f$export$f98dac4b251ab333(newCtx.common.issues);
                    },
                    input: newCtx.data
                })
            };
        });
        else return {
            status: "valid",
            value: result.status === "valid" ? result.value : this._def.catchValue({
                get error () {
                    return new $db5e9db6ef1a480f$export$f98dac4b251ab333(newCtx.common.issues);
                },
                input: newCtx.data
            })
        };
    }
    removeCatch() {
        return this._def.innerType;
    }
}
$db5e9db6ef1a480f$export$75a44ec6249ac76b.create = (type, params)=>{
    return new $db5e9db6ef1a480f$export$75a44ec6249ac76b((0, $0de5391da8318002$export$581ff339ea0ba762)({
        innerType: type,
        typeName: $db5e9db6ef1a480f$export$558106ce543bd011.ZodCatch,
        catchValue: typeof params.catch === "function" ? params.catch : ()=>params.catch
    }, $db5e9db6ef1a480f$var$processCreateParams(params)));
};
class $db5e9db6ef1a480f$export$26ccfa0145e8511f extends $db5e9db6ef1a480f$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $db5e9db6ef1a480f$export$5716da67bfaa244d.nan) {
            const ctx = this._getOrReturnCtx(input);
            $db5e9db6ef1a480f$export$db7caee60e5d514d(ctx, {
                code: $db5e9db6ef1a480f$export$5ba560653e4a1035.invalid_type,
                expected: $db5e9db6ef1a480f$export$5716da67bfaa244d.nan,
                received: ctx.parsedType
            });
            return $db5e9db6ef1a480f$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
}
$db5e9db6ef1a480f$export$26ccfa0145e8511f.create = (params)=>{
    return new $db5e9db6ef1a480f$export$26ccfa0145e8511f((0, $0de5391da8318002$export$581ff339ea0ba762)({
        typeName: $db5e9db6ef1a480f$export$558106ce543bd011.ZodNaN
    }, $db5e9db6ef1a480f$var$processCreateParams(params)));
};
const $db5e9db6ef1a480f$export$cf2deea74cde46b4 = Symbol("zod_brand");
class $db5e9db6ef1a480f$export$66b0c798a395271f extends $db5e9db6ef1a480f$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const data = ctx.data;
        return this._def.type._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    unwrap() {
        return this._def.type;
    }
}
class $db5e9db6ef1a480f$export$a3c3ef8a0e95c6da extends $db5e9db6ef1a480f$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.common.async) {
            const handleAsync = async ()=>{
                const inResult = await this._def.in._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inResult.status === "aborted") return $db5e9db6ef1a480f$export$9a105a556e65c2c0;
                if (inResult.status === "dirty") {
                    status.dirty();
                    return $db5e9db6ef1a480f$export$325a211da9693fcf(inResult.value);
                } else return this._def.out._parseAsync({
                    data: inResult.value,
                    path: ctx.path,
                    parent: ctx
                });
            };
            return handleAsync();
        } else {
            const inResult = this._def.in._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            });
            if (inResult.status === "aborted") return $db5e9db6ef1a480f$export$9a105a556e65c2c0;
            if (inResult.status === "dirty") {
                status.dirty();
                return {
                    status: "dirty",
                    value: inResult.value
                };
            } else return this._def.out._parseSync({
                data: inResult.value,
                path: ctx.path,
                parent: ctx
            });
        }
    }
    static create(a, b) {
        return new $db5e9db6ef1a480f$export$a3c3ef8a0e95c6da({
            in: a,
            out: b,
            typeName: $db5e9db6ef1a480f$export$558106ce543bd011.ZodPipeline
        });
    }
}
class $db5e9db6ef1a480f$export$5d1f7ef05c4e493a extends $db5e9db6ef1a480f$export$19342e026b58ebb7 {
    _parse(input) {
        const result = this._def.innerType._parse(input);
        if ($db5e9db6ef1a480f$export$1ea939691cdc45b8(result)) result.value = Object.freeze(result.value);
        return result;
    }
}
$db5e9db6ef1a480f$export$5d1f7ef05c4e493a.create = (type, params)=>{
    return new $db5e9db6ef1a480f$export$5d1f7ef05c4e493a((0, $0de5391da8318002$export$581ff339ea0ba762)({
        innerType: type,
        typeName: $db5e9db6ef1a480f$export$558106ce543bd011.ZodReadonly
    }, $db5e9db6ef1a480f$var$processCreateParams(params)));
};
const $db5e9db6ef1a480f$export$4c00f665f0d4b443 = (check, params = {}, /**
 * @deprecated
 *
 * Pass `fatal` into the params object instead:
 *
 * ```ts
 * z.string().custom((val) => val.length > 5, { fatal: false })
 * ```
 *
 */ fatal)=>{
    if (check) return $db5e9db6ef1a480f$export$b9d1edb536b4e4eb.create().superRefine((data, ctx)=>{
        var _a, _b;
        if (!check(data)) {
            const p = typeof params === "function" ? params(data) : typeof params === "string" ? {
                message: params
            } : params;
            const _fatal = (_b = (_a = p.fatal) !== null && _a !== void 0 ? _a : fatal) !== null && _b !== void 0 ? _b : true;
            const p2 = typeof p === "string" ? {
                message: p
            } : p;
            ctx.addIssue((0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({
                code: "custom"
            }, p2), {
                fatal: _fatal
            }));
        }
    });
    return $db5e9db6ef1a480f$export$b9d1edb536b4e4eb.create();
};
const $db5e9db6ef1a480f$export$1ee8ee30835eab8b = {
    object: $db5e9db6ef1a480f$export$736315c5b55efbad.lazycreate
};
var $db5e9db6ef1a480f$export$558106ce543bd011;
(function(ZodFirstPartyTypeKind) {
    ZodFirstPartyTypeKind["ZodString"] = "ZodString";
    ZodFirstPartyTypeKind["ZodNumber"] = "ZodNumber";
    ZodFirstPartyTypeKind["ZodNaN"] = "ZodNaN";
    ZodFirstPartyTypeKind["ZodBigInt"] = "ZodBigInt";
    ZodFirstPartyTypeKind["ZodBoolean"] = "ZodBoolean";
    ZodFirstPartyTypeKind["ZodDate"] = "ZodDate";
    ZodFirstPartyTypeKind["ZodSymbol"] = "ZodSymbol";
    ZodFirstPartyTypeKind["ZodUndefined"] = "ZodUndefined";
    ZodFirstPartyTypeKind["ZodNull"] = "ZodNull";
    ZodFirstPartyTypeKind["ZodAny"] = "ZodAny";
    ZodFirstPartyTypeKind["ZodUnknown"] = "ZodUnknown";
    ZodFirstPartyTypeKind["ZodNever"] = "ZodNever";
    ZodFirstPartyTypeKind["ZodVoid"] = "ZodVoid";
    ZodFirstPartyTypeKind["ZodArray"] = "ZodArray";
    ZodFirstPartyTypeKind["ZodObject"] = "ZodObject";
    ZodFirstPartyTypeKind["ZodUnion"] = "ZodUnion";
    ZodFirstPartyTypeKind["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
    ZodFirstPartyTypeKind["ZodIntersection"] = "ZodIntersection";
    ZodFirstPartyTypeKind["ZodTuple"] = "ZodTuple";
    ZodFirstPartyTypeKind["ZodRecord"] = "ZodRecord";
    ZodFirstPartyTypeKind["ZodMap"] = "ZodMap";
    ZodFirstPartyTypeKind["ZodSet"] = "ZodSet";
    ZodFirstPartyTypeKind["ZodFunction"] = "ZodFunction";
    ZodFirstPartyTypeKind["ZodLazy"] = "ZodLazy";
    ZodFirstPartyTypeKind["ZodLiteral"] = "ZodLiteral";
    ZodFirstPartyTypeKind["ZodEnum"] = "ZodEnum";
    ZodFirstPartyTypeKind["ZodEffects"] = "ZodEffects";
    ZodFirstPartyTypeKind["ZodNativeEnum"] = "ZodNativeEnum";
    ZodFirstPartyTypeKind["ZodOptional"] = "ZodOptional";
    ZodFirstPartyTypeKind["ZodNullable"] = "ZodNullable";
    ZodFirstPartyTypeKind["ZodDefault"] = "ZodDefault";
    ZodFirstPartyTypeKind["ZodCatch"] = "ZodCatch";
    ZodFirstPartyTypeKind["ZodPromise"] = "ZodPromise";
    ZodFirstPartyTypeKind["ZodBranded"] = "ZodBranded";
    ZodFirstPartyTypeKind["ZodPipeline"] = "ZodPipeline";
    ZodFirstPartyTypeKind["ZodReadonly"] = "ZodReadonly";
})($db5e9db6ef1a480f$export$558106ce543bd011 || ($db5e9db6ef1a480f$export$558106ce543bd011 = {}));
const $db5e9db6ef1a480f$export$3d916e7c22dbd8b5 = (// const instanceOfType = <T extends new (...args: any[]) => any>(
cls, params = {
    message: `Input not instance of ${cls.name}`
})=>$db5e9db6ef1a480f$export$4c00f665f0d4b443((data)=>data instanceof cls, params);
const $db5e9db6ef1a480f$export$22b082955e083ec3 = $db5e9db6ef1a480f$export$1230eb29b8d3b502.create;
const $db5e9db6ef1a480f$export$98e628dec113755e = $db5e9db6ef1a480f$export$5b070a55c0c43e09.create;
const $db5e9db6ef1a480f$export$9e06de0973666692 = $db5e9db6ef1a480f$export$26ccfa0145e8511f.create;
const $db5e9db6ef1a480f$export$a0f65b52274bcc00 = $db5e9db6ef1a480f$export$67d741fd70ff98f4.create;
const $db5e9db6ef1a480f$export$4a21f16c33752377 = $db5e9db6ef1a480f$export$723d146f80596191.create;
const $db5e9db6ef1a480f$export$324d90190a8b822a = $db5e9db6ef1a480f$export$e974be33bdc55521.create;
const $db5e9db6ef1a480f$export$8f701197936bc2a6 = $db5e9db6ef1a480f$export$bcc3b40f6b638044.create;
const $db5e9db6ef1a480f$export$1db45310990710a5 = $db5e9db6ef1a480f$export$4e780e961c30340d.create;
const $db5e9db6ef1a480f$export$7b1b591b262c240 = $db5e9db6ef1a480f$export$a96281f914484f2d.create;
const $db5e9db6ef1a480f$export$4154a199d7d90455 = $db5e9db6ef1a480f$export$b9d1edb536b4e4eb.create;
const $db5e9db6ef1a480f$export$19282c40b967aec6 = $db5e9db6ef1a480f$export$ef3b1bb1630977ae.create;
const $db5e9db6ef1a480f$export$b3e22bcfd64c1022 = $db5e9db6ef1a480f$export$1e576a20c3ce9fb5.create;
const $db5e9db6ef1a480f$export$490e536ee7389aeb = $db5e9db6ef1a480f$export$7d39f5df85f21031.create;
const $db5e9db6ef1a480f$export$2f23118c22fb2630 = $db5e9db6ef1a480f$export$7acfc3e64785411.create;
const $db5e9db6ef1a480f$export$be5493f9613cbbe = $db5e9db6ef1a480f$export$736315c5b55efbad.create;
const $db5e9db6ef1a480f$export$8fb0df5f40d0b477 = $db5e9db6ef1a480f$export$736315c5b55efbad.strictCreate;
const $db5e9db6ef1a480f$export$971dd5b0dfd021b6 = $db5e9db6ef1a480f$export$a8b236cb5070a311.create;
const $db5e9db6ef1a480f$export$4b888e40c4ee26dd = $db5e9db6ef1a480f$export$5ef2424805ac76a3.create;
const $db5e9db6ef1a480f$export$bc86dfbf7795668c = $db5e9db6ef1a480f$export$c02deaf0bb5203d4.create;
const $db5e9db6ef1a480f$export$65e3907585753458 = $db5e9db6ef1a480f$export$e2a18bb771d8e6a3.create;
const $db5e9db6ef1a480f$export$e5185e241753e543 = $db5e9db6ef1a480f$export$a2acc09968cb4b7f.create;
const $db5e9db6ef1a480f$export$871de8747c9eaa88 = $db5e9db6ef1a480f$export$163b6a2b712d9542.create;
const $db5e9db6ef1a480f$export$adaa4cf7ef1b65be = $db5e9db6ef1a480f$export$977057706f816712.create;
const $db5e9db6ef1a480f$export$44e51c8aac7c2deb = $db5e9db6ef1a480f$export$d4602ba55673f53c.create;
const $db5e9db6ef1a480f$export$488013bae63b21da = $db5e9db6ef1a480f$export$378d0cfce37406e6.create;
const $db5e9db6ef1a480f$export$c8ec6e1ec9fefcb0 = $db5e9db6ef1a480f$export$7e44096782a165d3.create;
const $db5e9db6ef1a480f$export$78a99c8d44d72635 = $db5e9db6ef1a480f$export$d325d1f0e1c20179.create;
const $db5e9db6ef1a480f$export$6fe7eca19ebe5199 = $db5e9db6ef1a480f$export$370b2e8d6d6f5c56.create;
const $db5e9db6ef1a480f$export$c957ef27a0ebfd4 = $db5e9db6ef1a480f$export$3f196b0127d6e50a.create;
const $db5e9db6ef1a480f$export$dc573d8a6576cdb3 = $db5e9db6ef1a480f$export$a60af00cc0ce2582.create;
const $db5e9db6ef1a480f$export$516e28dec6a4b6d4 = $db5e9db6ef1a480f$export$aa56fec1e9d629b8.create;
const $db5e9db6ef1a480f$export$133fc36489ac9add = $db5e9db6ef1a480f$export$aaac0b8b429cef5.create;
const $db5e9db6ef1a480f$export$fc37fe19dfda43ee = $db5e9db6ef1a480f$export$a60af00cc0ce2582.createWithPreprocess;
const $db5e9db6ef1a480f$export$43f28b24e1eb8181 = $db5e9db6ef1a480f$export$a3c3ef8a0e95c6da.create;
const $db5e9db6ef1a480f$export$3b3d07727c5b702c = ()=>$db5e9db6ef1a480f$export$22b082955e083ec3().optional();
const $db5e9db6ef1a480f$export$eb150471a61fced6 = ()=>$db5e9db6ef1a480f$export$98e628dec113755e().optional();
const $db5e9db6ef1a480f$export$269251733cdcbbf1 = ()=>$db5e9db6ef1a480f$export$4a21f16c33752377().optional();
const $db5e9db6ef1a480f$export$8c14e57e778d3873 = {
    string: (arg)=>$db5e9db6ef1a480f$export$1230eb29b8d3b502.create((0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, arg), {
            coerce: true
        })),
    number: (arg)=>$db5e9db6ef1a480f$export$5b070a55c0c43e09.create((0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, arg), {
            coerce: true
        })),
    boolean: (arg)=>$db5e9db6ef1a480f$export$723d146f80596191.create((0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, arg), {
            coerce: true
        })),
    bigint: (arg)=>$db5e9db6ef1a480f$export$67d741fd70ff98f4.create((0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, arg), {
            coerce: true
        })),
    date: (arg)=>$db5e9db6ef1a480f$export$e974be33bdc55521.create((0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, arg), {
            coerce: true
        }))
};
const $db5e9db6ef1a480f$export$96c94437c95d7862 = $db5e9db6ef1a480f$export$9a105a556e65c2c0;
var $db5e9db6ef1a480f$export$2e2bcd8739ae039 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    defaultErrorMap: $db5e9db6ef1a480f$export$341b0b6e0a6f5099,
    setErrorMap: $db5e9db6ef1a480f$export$1097a8289cfd22d7,
    getErrorMap: $db5e9db6ef1a480f$export$32f27c719778d4c4,
    makeIssue: $db5e9db6ef1a480f$export$244a85fde9c419ed,
    EMPTY_PATH: $db5e9db6ef1a480f$export$1526d2e05f74572,
    addIssueToContext: $db5e9db6ef1a480f$export$db7caee60e5d514d,
    ParseStatus: $db5e9db6ef1a480f$export$5b20a5c3d05c1f6f,
    INVALID: $db5e9db6ef1a480f$export$9a105a556e65c2c0,
    DIRTY: $db5e9db6ef1a480f$export$325a211da9693fcf,
    OK: $db5e9db6ef1a480f$export$c6813a8d51f77eaf,
    isAborted: $db5e9db6ef1a480f$export$afa861e3c5730743,
    isDirty: $db5e9db6ef1a480f$export$910b6cdd390341b3,
    isValid: $db5e9db6ef1a480f$export$1ea939691cdc45b8,
    isAsync: $db5e9db6ef1a480f$export$aefee5ebe1dcfd9e,
    get util () {
        return $db5e9db6ef1a480f$export$7debb50ef11d5e0b;
    },
    get objectUtil () {
        return $db5e9db6ef1a480f$export$4aa2142c225fd5c7;
    },
    ZodParsedType: $db5e9db6ef1a480f$export$5716da67bfaa244d,
    getParsedType: $db5e9db6ef1a480f$export$3e9057828ebd5c7a,
    ZodType: $db5e9db6ef1a480f$export$19342e026b58ebb7,
    ZodString: $db5e9db6ef1a480f$export$1230eb29b8d3b502,
    ZodNumber: $db5e9db6ef1a480f$export$5b070a55c0c43e09,
    ZodBigInt: $db5e9db6ef1a480f$export$67d741fd70ff98f4,
    ZodBoolean: $db5e9db6ef1a480f$export$723d146f80596191,
    ZodDate: $db5e9db6ef1a480f$export$e974be33bdc55521,
    ZodSymbol: $db5e9db6ef1a480f$export$bcc3b40f6b638044,
    ZodUndefined: $db5e9db6ef1a480f$export$4e780e961c30340d,
    ZodNull: $db5e9db6ef1a480f$export$a96281f914484f2d,
    ZodAny: $db5e9db6ef1a480f$export$b9d1edb536b4e4eb,
    ZodUnknown: $db5e9db6ef1a480f$export$ef3b1bb1630977ae,
    ZodNever: $db5e9db6ef1a480f$export$1e576a20c3ce9fb5,
    ZodVoid: $db5e9db6ef1a480f$export$7d39f5df85f21031,
    ZodArray: $db5e9db6ef1a480f$export$7acfc3e64785411,
    ZodObject: $db5e9db6ef1a480f$export$736315c5b55efbad,
    ZodUnion: $db5e9db6ef1a480f$export$a8b236cb5070a311,
    ZodDiscriminatedUnion: $db5e9db6ef1a480f$export$5ef2424805ac76a3,
    ZodIntersection: $db5e9db6ef1a480f$export$c02deaf0bb5203d4,
    ZodTuple: $db5e9db6ef1a480f$export$e2a18bb771d8e6a3,
    ZodRecord: $db5e9db6ef1a480f$export$a2acc09968cb4b7f,
    ZodMap: $db5e9db6ef1a480f$export$163b6a2b712d9542,
    ZodSet: $db5e9db6ef1a480f$export$977057706f816712,
    ZodFunction: $db5e9db6ef1a480f$export$d4602ba55673f53c,
    ZodLazy: $db5e9db6ef1a480f$export$378d0cfce37406e6,
    ZodLiteral: $db5e9db6ef1a480f$export$7e44096782a165d3,
    ZodEnum: $db5e9db6ef1a480f$export$d325d1f0e1c20179,
    ZodNativeEnum: $db5e9db6ef1a480f$export$370b2e8d6d6f5c56,
    ZodPromise: $db5e9db6ef1a480f$export$3f196b0127d6e50a,
    ZodEffects: $db5e9db6ef1a480f$export$a60af00cc0ce2582,
    ZodTransformer: $db5e9db6ef1a480f$export$a60af00cc0ce2582,
    ZodOptional: $db5e9db6ef1a480f$export$aa56fec1e9d629b8,
    ZodNullable: $db5e9db6ef1a480f$export$aaac0b8b429cef5,
    ZodDefault: $db5e9db6ef1a480f$export$bb19b37874861e7e,
    ZodCatch: $db5e9db6ef1a480f$export$75a44ec6249ac76b,
    ZodNaN: $db5e9db6ef1a480f$export$26ccfa0145e8511f,
    BRAND: $db5e9db6ef1a480f$export$cf2deea74cde46b4,
    ZodBranded: $db5e9db6ef1a480f$export$66b0c798a395271f,
    ZodPipeline: $db5e9db6ef1a480f$export$a3c3ef8a0e95c6da,
    ZodReadonly: $db5e9db6ef1a480f$export$5d1f7ef05c4e493a,
    custom: $db5e9db6ef1a480f$export$4c00f665f0d4b443,
    Schema: $db5e9db6ef1a480f$export$19342e026b58ebb7,
    ZodSchema: $db5e9db6ef1a480f$export$19342e026b58ebb7,
    late: $db5e9db6ef1a480f$export$1ee8ee30835eab8b,
    get ZodFirstPartyTypeKind () {
        return $db5e9db6ef1a480f$export$558106ce543bd011;
    },
    coerce: $db5e9db6ef1a480f$export$8c14e57e778d3873,
    any: $db5e9db6ef1a480f$export$4154a199d7d90455,
    array: $db5e9db6ef1a480f$export$2f23118c22fb2630,
    bigint: $db5e9db6ef1a480f$export$a0f65b52274bcc00,
    boolean: $db5e9db6ef1a480f$export$4a21f16c33752377,
    date: $db5e9db6ef1a480f$export$324d90190a8b822a,
    discriminatedUnion: $db5e9db6ef1a480f$export$4b888e40c4ee26dd,
    effect: $db5e9db6ef1a480f$export$dc573d8a6576cdb3,
    "enum": $db5e9db6ef1a480f$export$78a99c8d44d72635,
    "function": $db5e9db6ef1a480f$export$44e51c8aac7c2deb,
    "instanceof": $db5e9db6ef1a480f$export$3d916e7c22dbd8b5,
    intersection: $db5e9db6ef1a480f$export$bc86dfbf7795668c,
    lazy: $db5e9db6ef1a480f$export$488013bae63b21da,
    literal: $db5e9db6ef1a480f$export$c8ec6e1ec9fefcb0,
    map: $db5e9db6ef1a480f$export$871de8747c9eaa88,
    nan: $db5e9db6ef1a480f$export$9e06de0973666692,
    nativeEnum: $db5e9db6ef1a480f$export$6fe7eca19ebe5199,
    never: $db5e9db6ef1a480f$export$b3e22bcfd64c1022,
    "null": $db5e9db6ef1a480f$export$7b1b591b262c240,
    nullable: $db5e9db6ef1a480f$export$133fc36489ac9add,
    number: $db5e9db6ef1a480f$export$98e628dec113755e,
    object: $db5e9db6ef1a480f$export$be5493f9613cbbe,
    oboolean: $db5e9db6ef1a480f$export$269251733cdcbbf1,
    onumber: $db5e9db6ef1a480f$export$eb150471a61fced6,
    optional: $db5e9db6ef1a480f$export$516e28dec6a4b6d4,
    ostring: $db5e9db6ef1a480f$export$3b3d07727c5b702c,
    pipeline: $db5e9db6ef1a480f$export$43f28b24e1eb8181,
    preprocess: $db5e9db6ef1a480f$export$fc37fe19dfda43ee,
    promise: $db5e9db6ef1a480f$export$c957ef27a0ebfd4,
    record: $db5e9db6ef1a480f$export$e5185e241753e543,
    set: $db5e9db6ef1a480f$export$adaa4cf7ef1b65be,
    strictObject: $db5e9db6ef1a480f$export$8fb0df5f40d0b477,
    string: $db5e9db6ef1a480f$export$22b082955e083ec3,
    symbol: $db5e9db6ef1a480f$export$8f701197936bc2a6,
    transformer: $db5e9db6ef1a480f$export$dc573d8a6576cdb3,
    tuple: $db5e9db6ef1a480f$export$65e3907585753458,
    "undefined": $db5e9db6ef1a480f$export$1db45310990710a5,
    union: $db5e9db6ef1a480f$export$971dd5b0dfd021b6,
    unknown: $db5e9db6ef1a480f$export$19282c40b967aec6,
    "void": $db5e9db6ef1a480f$export$490e536ee7389aeb,
    NEVER: $db5e9db6ef1a480f$export$96c94437c95d7862,
    ZodIssueCode: $db5e9db6ef1a480f$export$5ba560653e4a1035,
    quotelessJson: $db5e9db6ef1a480f$export$913eddeaf297cfea,
    ZodError: $db5e9db6ef1a480f$export$f98dac4b251ab333
});


const $a86cc69a84585305$export$48c1db756576ae1 = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    name: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
    type: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
    value: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string()
});
const $a86cc69a84585305$export$ab6045338fa7d71b = $a86cc69a84585305$export$48c1db756576ae1.array();
const $a86cc69a84585305$export$10762083065a1f71 = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    id: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
    status: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
    ssl: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
        status: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
        validation_errors: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
            message: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string()
        }).array().optional()
    }),
    verification_errors: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().array().optional()
});
var $a86cc69a84585305$export$4bfadd7b59276a6c;
(function(DomainStatus) {
    DomainStatus["PendingVerification"] = "PendingVerification";
    DomainStatus["PendingSsl"] = "PendingSsl";
    DomainStatus["Active"] = "Active";
    DomainStatus["Error"] = "Error";
})($a86cc69a84585305$export$4bfadd7b59276a6c || ($a86cc69a84585305$export$4bfadd7b59276a6c = {}));
const $a86cc69a84585305$export$fda7fbe88a5ffb61 = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).nativeEnum($a86cc69a84585305$export$4bfadd7b59276a6c);



var $19a1785de7c32ff4$export$9b32daede159ad68;
(function(HookEvent) {
    HookEvent["PostRegister"] = "PostRegister";
    HookEvent["PostSignIn"] = "PostSignIn";
    HookEvent["PostResetPassword"] = "PostResetPassword";
})($19a1785de7c32ff4$export$9b32daede159ad68 || ($19a1785de7c32ff4$export$9b32daede159ad68 = {}));
const $19a1785de7c32ff4$export$2d2b15eb4f8d4fc9 = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).nativeEnum($19a1785de7c32ff4$export$9b32daede159ad68);
const $19a1785de7c32ff4$export$56e77a150fce61b = $19a1785de7c32ff4$export$2d2b15eb4f8d4fc9.array();
const $19a1785de7c32ff4$export$924993b6fcd8d738 = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    /** We don't need `type` since v1 only has web hook */ // type: 'web';
    /** Method fixed to `POST` */ url: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
    /** Additional headers that attach to the request */ headers: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).record((0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string()).optional(),
    /**
     * @deprecated
     * Retry times when hook response status >= 500.
     * Now the retry times is fixed to 3.
     * Keep for backward compatibility.
     */ retries: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).number().gte(0).lte(3).optional()
});


var $65db2c8fcb86b5e5$exports = {};
var $df074e7d5dcd8624$exports = {};
/* MIT license */ var $e6076e8972ca3446$exports = {};
"use strict";
$e6076e8972ca3446$exports = {
    "aliceblue": [
        240,
        248,
        255
    ],
    "antiquewhite": [
        250,
        235,
        215
    ],
    "aqua": [
        0,
        255,
        255
    ],
    "aquamarine": [
        127,
        255,
        212
    ],
    "azure": [
        240,
        255,
        255
    ],
    "beige": [
        245,
        245,
        220
    ],
    "bisque": [
        255,
        228,
        196
    ],
    "black": [
        0,
        0,
        0
    ],
    "blanchedalmond": [
        255,
        235,
        205
    ],
    "blue": [
        0,
        0,
        255
    ],
    "blueviolet": [
        138,
        43,
        226
    ],
    "brown": [
        165,
        42,
        42
    ],
    "burlywood": [
        222,
        184,
        135
    ],
    "cadetblue": [
        95,
        158,
        160
    ],
    "chartreuse": [
        127,
        255,
        0
    ],
    "chocolate": [
        210,
        105,
        30
    ],
    "coral": [
        255,
        127,
        80
    ],
    "cornflowerblue": [
        100,
        149,
        237
    ],
    "cornsilk": [
        255,
        248,
        220
    ],
    "crimson": [
        220,
        20,
        60
    ],
    "cyan": [
        0,
        255,
        255
    ],
    "darkblue": [
        0,
        0,
        139
    ],
    "darkcyan": [
        0,
        139,
        139
    ],
    "darkgoldenrod": [
        184,
        134,
        11
    ],
    "darkgray": [
        169,
        169,
        169
    ],
    "darkgreen": [
        0,
        100,
        0
    ],
    "darkgrey": [
        169,
        169,
        169
    ],
    "darkkhaki": [
        189,
        183,
        107
    ],
    "darkmagenta": [
        139,
        0,
        139
    ],
    "darkolivegreen": [
        85,
        107,
        47
    ],
    "darkorange": [
        255,
        140,
        0
    ],
    "darkorchid": [
        153,
        50,
        204
    ],
    "darkred": [
        139,
        0,
        0
    ],
    "darksalmon": [
        233,
        150,
        122
    ],
    "darkseagreen": [
        143,
        188,
        143
    ],
    "darkslateblue": [
        72,
        61,
        139
    ],
    "darkslategray": [
        47,
        79,
        79
    ],
    "darkslategrey": [
        47,
        79,
        79
    ],
    "darkturquoise": [
        0,
        206,
        209
    ],
    "darkviolet": [
        148,
        0,
        211
    ],
    "deeppink": [
        255,
        20,
        147
    ],
    "deepskyblue": [
        0,
        191,
        255
    ],
    "dimgray": [
        105,
        105,
        105
    ],
    "dimgrey": [
        105,
        105,
        105
    ],
    "dodgerblue": [
        30,
        144,
        255
    ],
    "firebrick": [
        178,
        34,
        34
    ],
    "floralwhite": [
        255,
        250,
        240
    ],
    "forestgreen": [
        34,
        139,
        34
    ],
    "fuchsia": [
        255,
        0,
        255
    ],
    "gainsboro": [
        220,
        220,
        220
    ],
    "ghostwhite": [
        248,
        248,
        255
    ],
    "gold": [
        255,
        215,
        0
    ],
    "goldenrod": [
        218,
        165,
        32
    ],
    "gray": [
        128,
        128,
        128
    ],
    "green": [
        0,
        128,
        0
    ],
    "greenyellow": [
        173,
        255,
        47
    ],
    "grey": [
        128,
        128,
        128
    ],
    "honeydew": [
        240,
        255,
        240
    ],
    "hotpink": [
        255,
        105,
        180
    ],
    "indianred": [
        205,
        92,
        92
    ],
    "indigo": [
        75,
        0,
        130
    ],
    "ivory": [
        255,
        255,
        240
    ],
    "khaki": [
        240,
        230,
        140
    ],
    "lavender": [
        230,
        230,
        250
    ],
    "lavenderblush": [
        255,
        240,
        245
    ],
    "lawngreen": [
        124,
        252,
        0
    ],
    "lemonchiffon": [
        255,
        250,
        205
    ],
    "lightblue": [
        173,
        216,
        230
    ],
    "lightcoral": [
        240,
        128,
        128
    ],
    "lightcyan": [
        224,
        255,
        255
    ],
    "lightgoldenrodyellow": [
        250,
        250,
        210
    ],
    "lightgray": [
        211,
        211,
        211
    ],
    "lightgreen": [
        144,
        238,
        144
    ],
    "lightgrey": [
        211,
        211,
        211
    ],
    "lightpink": [
        255,
        182,
        193
    ],
    "lightsalmon": [
        255,
        160,
        122
    ],
    "lightseagreen": [
        32,
        178,
        170
    ],
    "lightskyblue": [
        135,
        206,
        250
    ],
    "lightslategray": [
        119,
        136,
        153
    ],
    "lightslategrey": [
        119,
        136,
        153
    ],
    "lightsteelblue": [
        176,
        196,
        222
    ],
    "lightyellow": [
        255,
        255,
        224
    ],
    "lime": [
        0,
        255,
        0
    ],
    "limegreen": [
        50,
        205,
        50
    ],
    "linen": [
        250,
        240,
        230
    ],
    "magenta": [
        255,
        0,
        255
    ],
    "maroon": [
        128,
        0,
        0
    ],
    "mediumaquamarine": [
        102,
        205,
        170
    ],
    "mediumblue": [
        0,
        0,
        205
    ],
    "mediumorchid": [
        186,
        85,
        211
    ],
    "mediumpurple": [
        147,
        112,
        219
    ],
    "mediumseagreen": [
        60,
        179,
        113
    ],
    "mediumslateblue": [
        123,
        104,
        238
    ],
    "mediumspringgreen": [
        0,
        250,
        154
    ],
    "mediumturquoise": [
        72,
        209,
        204
    ],
    "mediumvioletred": [
        199,
        21,
        133
    ],
    "midnightblue": [
        25,
        25,
        112
    ],
    "mintcream": [
        245,
        255,
        250
    ],
    "mistyrose": [
        255,
        228,
        225
    ],
    "moccasin": [
        255,
        228,
        181
    ],
    "navajowhite": [
        255,
        222,
        173
    ],
    "navy": [
        0,
        0,
        128
    ],
    "oldlace": [
        253,
        245,
        230
    ],
    "olive": [
        128,
        128,
        0
    ],
    "olivedrab": [
        107,
        142,
        35
    ],
    "orange": [
        255,
        165,
        0
    ],
    "orangered": [
        255,
        69,
        0
    ],
    "orchid": [
        218,
        112,
        214
    ],
    "palegoldenrod": [
        238,
        232,
        170
    ],
    "palegreen": [
        152,
        251,
        152
    ],
    "paleturquoise": [
        175,
        238,
        238
    ],
    "palevioletred": [
        219,
        112,
        147
    ],
    "papayawhip": [
        255,
        239,
        213
    ],
    "peachpuff": [
        255,
        218,
        185
    ],
    "peru": [
        205,
        133,
        63
    ],
    "pink": [
        255,
        192,
        203
    ],
    "plum": [
        221,
        160,
        221
    ],
    "powderblue": [
        176,
        224,
        230
    ],
    "purple": [
        128,
        0,
        128
    ],
    "rebeccapurple": [
        102,
        51,
        153
    ],
    "red": [
        255,
        0,
        0
    ],
    "rosybrown": [
        188,
        143,
        143
    ],
    "royalblue": [
        65,
        105,
        225
    ],
    "saddlebrown": [
        139,
        69,
        19
    ],
    "salmon": [
        250,
        128,
        114
    ],
    "sandybrown": [
        244,
        164,
        96
    ],
    "seagreen": [
        46,
        139,
        87
    ],
    "seashell": [
        255,
        245,
        238
    ],
    "sienna": [
        160,
        82,
        45
    ],
    "silver": [
        192,
        192,
        192
    ],
    "skyblue": [
        135,
        206,
        235
    ],
    "slateblue": [
        106,
        90,
        205
    ],
    "slategray": [
        112,
        128,
        144
    ],
    "slategrey": [
        112,
        128,
        144
    ],
    "snow": [
        255,
        250,
        250
    ],
    "springgreen": [
        0,
        255,
        127
    ],
    "steelblue": [
        70,
        130,
        180
    ],
    "tan": [
        210,
        180,
        140
    ],
    "teal": [
        0,
        128,
        128
    ],
    "thistle": [
        216,
        191,
        216
    ],
    "tomato": [
        255,
        99,
        71
    ],
    "turquoise": [
        64,
        224,
        208
    ],
    "violet": [
        238,
        130,
        238
    ],
    "wheat": [
        245,
        222,
        179
    ],
    "white": [
        255,
        255,
        255
    ],
    "whitesmoke": [
        245,
        245,
        245
    ],
    "yellow": [
        255,
        255,
        0
    ],
    "yellowgreen": [
        154,
        205,
        50
    ]
};


var $0a8391ea7e6bc196$exports = {};
"use strict";
var $e7f5a680d34ffd50$exports = {};
$e7f5a680d34ffd50$exports = function isArrayish(obj) {
    if (!obj || typeof obj === "string") return false;
    return obj instanceof Array || Array.isArray(obj) || obj.length >= 0 && (obj.splice instanceof Function || Object.getOwnPropertyDescriptor(obj, obj.length - 1) && obj.constructor.name !== "String");
};


var $0a8391ea7e6bc196$var$concat = Array.prototype.concat;
var $0a8391ea7e6bc196$var$slice = Array.prototype.slice;
var $0a8391ea7e6bc196$var$swizzle = $0a8391ea7e6bc196$exports = function swizzle(args) {
    var results = [];
    for(var i = 0, len = args.length; i < len; i++){
        var arg = args[i];
        if ($e7f5a680d34ffd50$exports(arg)) // http://jsperf.com/javascript-array-concat-vs-push/98
        results = $0a8391ea7e6bc196$var$concat.call(results, $0a8391ea7e6bc196$var$slice.call(arg));
        else results.push(arg);
    }
    return results;
};
$0a8391ea7e6bc196$var$swizzle.wrap = function(fn) {
    return function() {
        return fn($0a8391ea7e6bc196$var$swizzle(arguments));
    };
};


var $df074e7d5dcd8624$var$hasOwnProperty = Object.hasOwnProperty;
var $df074e7d5dcd8624$var$reverseNames = Object.create(null);
// create a list of reverse color names
for(var $df074e7d5dcd8624$var$name in $e6076e8972ca3446$exports)if ($df074e7d5dcd8624$var$hasOwnProperty.call($e6076e8972ca3446$exports, $df074e7d5dcd8624$var$name)) $df074e7d5dcd8624$var$reverseNames[$e6076e8972ca3446$exports[$df074e7d5dcd8624$var$name]] = $df074e7d5dcd8624$var$name;
var $df074e7d5dcd8624$var$cs = $df074e7d5dcd8624$exports = {
    to: {},
    get: {}
};
$df074e7d5dcd8624$var$cs.get = function(string) {
    var prefix = string.substring(0, 3).toLowerCase();
    var val;
    var model;
    switch(prefix){
        case "hsl":
            val = $df074e7d5dcd8624$var$cs.get.hsl(string);
            model = "hsl";
            break;
        case "hwb":
            val = $df074e7d5dcd8624$var$cs.get.hwb(string);
            model = "hwb";
            break;
        default:
            val = $df074e7d5dcd8624$var$cs.get.rgb(string);
            model = "rgb";
            break;
    }
    if (!val) return null;
    return {
        model: model,
        value: val
    };
};
$df074e7d5dcd8624$var$cs.get.rgb = function(string) {
    if (!string) return null;
    var abbr = /^#([a-f0-9]{3,4})$/i;
    var hex = /^#([a-f0-9]{6})([a-f0-9]{2})?$/i;
    var rgba = /^rgba?\(\s*([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/;
    var per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/;
    var keyword = /^(\w+)$/;
    var rgb = [
        0,
        0,
        0,
        1
    ];
    var match;
    var i;
    var hexAlpha;
    if (match = string.match(hex)) {
        hexAlpha = match[2];
        match = match[1];
        for(i = 0; i < 3; i++){
            // https://jsperf.com/slice-vs-substr-vs-substring-methods-long-string/19
            var i2 = i * 2;
            rgb[i] = parseInt(match.slice(i2, i2 + 2), 16);
        }
        if (hexAlpha) rgb[3] = parseInt(hexAlpha, 16) / 255;
    } else if (match = string.match(abbr)) {
        match = match[1];
        hexAlpha = match[3];
        for(i = 0; i < 3; i++)rgb[i] = parseInt(match[i] + match[i], 16);
        if (hexAlpha) rgb[3] = parseInt(hexAlpha + hexAlpha, 16) / 255;
    } else if (match = string.match(rgba)) {
        for(i = 0; i < 3; i++)rgb[i] = parseInt(match[i + 1], 0);
        if (match[4]) {
            if (match[5]) rgb[3] = parseFloat(match[4]) * 0.01;
            else rgb[3] = parseFloat(match[4]);
        }
    } else if (match = string.match(per)) {
        for(i = 0; i < 3; i++)rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
        if (match[4]) {
            if (match[5]) rgb[3] = parseFloat(match[4]) * 0.01;
            else rgb[3] = parseFloat(match[4]);
        }
    } else if (match = string.match(keyword)) {
        if (match[1] === "transparent") return [
            0,
            0,
            0,
            0
        ];
        if (!$df074e7d5dcd8624$var$hasOwnProperty.call($e6076e8972ca3446$exports, match[1])) return null;
        rgb = $e6076e8972ca3446$exports[match[1]];
        rgb[3] = 1;
        return rgb;
    } else return null;
    for(i = 0; i < 3; i++)rgb[i] = $df074e7d5dcd8624$var$clamp(rgb[i], 0, 255);
    rgb[3] = $df074e7d5dcd8624$var$clamp(rgb[3], 0, 1);
    return rgb;
};
$df074e7d5dcd8624$var$cs.get.hsl = function(string) {
    if (!string) return null;
    var hsl = /^hsla?\(\s*([+-]?(?:\d{0,3}\.)?\d+)(?:deg)?\s*,?\s*([+-]?[\d\.]+)%\s*,?\s*([+-]?[\d\.]+)%\s*(?:[,|\/]\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/;
    var match = string.match(hsl);
    if (match) {
        var alpha = parseFloat(match[4]);
        var h = (parseFloat(match[1]) % 360 + 360) % 360;
        var s = $df074e7d5dcd8624$var$clamp(parseFloat(match[2]), 0, 100);
        var l = $df074e7d5dcd8624$var$clamp(parseFloat(match[3]), 0, 100);
        var a = $df074e7d5dcd8624$var$clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
        return [
            h,
            s,
            l,
            a
        ];
    }
    return null;
};
$df074e7d5dcd8624$var$cs.get.hwb = function(string) {
    if (!string) return null;
    var hwb = /^hwb\(\s*([+-]?\d{0,3}(?:\.\d+)?)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/;
    var match = string.match(hwb);
    if (match) {
        var alpha = parseFloat(match[4]);
        var h = (parseFloat(match[1]) % 360 + 360) % 360;
        var w = $df074e7d5dcd8624$var$clamp(parseFloat(match[2]), 0, 100);
        var b = $df074e7d5dcd8624$var$clamp(parseFloat(match[3]), 0, 100);
        var a = $df074e7d5dcd8624$var$clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
        return [
            h,
            w,
            b,
            a
        ];
    }
    return null;
};
$df074e7d5dcd8624$var$cs.to.hex = function() {
    var rgba = $0a8391ea7e6bc196$exports(arguments);
    return "#" + $df074e7d5dcd8624$var$hexDouble(rgba[0]) + $df074e7d5dcd8624$var$hexDouble(rgba[1]) + $df074e7d5dcd8624$var$hexDouble(rgba[2]) + (rgba[3] < 1 ? $df074e7d5dcd8624$var$hexDouble(Math.round(rgba[3] * 255)) : "");
};
$df074e7d5dcd8624$var$cs.to.rgb = function() {
    var rgba = $0a8391ea7e6bc196$exports(arguments);
    return rgba.length < 4 || rgba[3] === 1 ? "rgb(" + Math.round(rgba[0]) + ", " + Math.round(rgba[1]) + ", " + Math.round(rgba[2]) + ")" : "rgba(" + Math.round(rgba[0]) + ", " + Math.round(rgba[1]) + ", " + Math.round(rgba[2]) + ", " + rgba[3] + ")";
};
$df074e7d5dcd8624$var$cs.to.rgb.percent = function() {
    var rgba = $0a8391ea7e6bc196$exports(arguments);
    var r = Math.round(rgba[0] / 255 * 100);
    var g = Math.round(rgba[1] / 255 * 100);
    var b = Math.round(rgba[2] / 255 * 100);
    return rgba.length < 4 || rgba[3] === 1 ? "rgb(" + r + "%, " + g + "%, " + b + "%)" : "rgba(" + r + "%, " + g + "%, " + b + "%, " + rgba[3] + ")";
};
$df074e7d5dcd8624$var$cs.to.hsl = function() {
    var hsla = $0a8391ea7e6bc196$exports(arguments);
    return hsla.length < 4 || hsla[3] === 1 ? "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)" : "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, " + hsla[3] + ")";
};
// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
// (hwb have alpha optional & 1 is default value)
$df074e7d5dcd8624$var$cs.to.hwb = function() {
    var hwba = $0a8391ea7e6bc196$exports(arguments);
    var a = "";
    if (hwba.length >= 4 && hwba[3] !== 1) a = ", " + hwba[3];
    return "hwb(" + hwba[0] + ", " + hwba[1] + "%, " + hwba[2] + "%" + a + ")";
};
$df074e7d5dcd8624$var$cs.to.keyword = function(rgb) {
    return $df074e7d5dcd8624$var$reverseNames[rgb.slice(0, 3)];
};
// helpers
function $df074e7d5dcd8624$var$clamp(num, min, max) {
    return Math.min(Math.max(min, num), max);
}
function $df074e7d5dcd8624$var$hexDouble(num) {
    var str = Math.round(num).toString(16).toUpperCase();
    return str.length < 2 ? "0" + str : str;
}


var $cf08bf5b3435e787$exports = {};
var $1be8f4d3208fdae3$exports = {};
/* MIT license */ /* eslint-disable no-mixed-operators */ 
// NOTE: conversions should only return primitive values (i.e. arrays, or
//       values that give correct `typeof` results).
//       do not use box values types (i.e. Number(), String(), etc.)
const $1be8f4d3208fdae3$var$reverseKeywords = {};
for (const key of Object.keys($e6076e8972ca3446$exports))$1be8f4d3208fdae3$var$reverseKeywords[$e6076e8972ca3446$exports[key]] = key;
const $1be8f4d3208fdae3$var$convert = {
    rgb: {
        channels: 3,
        labels: "rgb"
    },
    hsl: {
        channels: 3,
        labels: "hsl"
    },
    hsv: {
        channels: 3,
        labels: "hsv"
    },
    hwb: {
        channels: 3,
        labels: "hwb"
    },
    cmyk: {
        channels: 4,
        labels: "cmyk"
    },
    xyz: {
        channels: 3,
        labels: "xyz"
    },
    lab: {
        channels: 3,
        labels: "lab"
    },
    lch: {
        channels: 3,
        labels: "lch"
    },
    hex: {
        channels: 1,
        labels: [
            "hex"
        ]
    },
    keyword: {
        channels: 1,
        labels: [
            "keyword"
        ]
    },
    ansi16: {
        channels: 1,
        labels: [
            "ansi16"
        ]
    },
    ansi256: {
        channels: 1,
        labels: [
            "ansi256"
        ]
    },
    hcg: {
        channels: 3,
        labels: [
            "h",
            "c",
            "g"
        ]
    },
    apple: {
        channels: 3,
        labels: [
            "r16",
            "g16",
            "b16"
        ]
    },
    gray: {
        channels: 1,
        labels: [
            "gray"
        ]
    }
};
$1be8f4d3208fdae3$exports = $1be8f4d3208fdae3$var$convert;
// Hide .channels and .labels properties
for (const model of Object.keys($1be8f4d3208fdae3$var$convert)){
    if (!("channels" in $1be8f4d3208fdae3$var$convert[model])) throw new Error("missing channels property: " + model);
    if (!("labels" in $1be8f4d3208fdae3$var$convert[model])) throw new Error("missing channel labels property: " + model);
    if ($1be8f4d3208fdae3$var$convert[model].labels.length !== $1be8f4d3208fdae3$var$convert[model].channels) throw new Error("channel and label counts mismatch: " + model);
    const { channels: channels, labels: labels } = $1be8f4d3208fdae3$var$convert[model];
    delete $1be8f4d3208fdae3$var$convert[model].channels;
    delete $1be8f4d3208fdae3$var$convert[model].labels;
    Object.defineProperty($1be8f4d3208fdae3$var$convert[model], "channels", {
        value: channels
    });
    Object.defineProperty($1be8f4d3208fdae3$var$convert[model], "labels", {
        value: labels
    });
}
$1be8f4d3208fdae3$var$convert.rgb.hsl = function(rgb) {
    const r = rgb[0] / 255;
    const g = rgb[1] / 255;
    const b = rgb[2] / 255;
    const min = Math.min(r, g, b);
    const max = Math.max(r, g, b);
    const delta = max - min;
    let h;
    let s;
    if (max === min) h = 0;
    else if (r === max) h = (g - b) / delta;
    else if (g === max) h = 2 + (b - r) / delta;
    else if (b === max) h = 4 + (r - g) / delta;
    h = Math.min(h * 60, 360);
    if (h < 0) h += 360;
    const l = (min + max) / 2;
    if (max === min) s = 0;
    else if (l <= 0.5) s = delta / (max + min);
    else s = delta / (2 - max - min);
    return [
        h,
        s * 100,
        l * 100
    ];
};
$1be8f4d3208fdae3$var$convert.rgb.hsv = function(rgb) {
    let rdif;
    let gdif;
    let bdif;
    let h;
    let s;
    const r = rgb[0] / 255;
    const g = rgb[1] / 255;
    const b = rgb[2] / 255;
    const v = Math.max(r, g, b);
    const diff = v - Math.min(r, g, b);
    const diffc = function(c) {
        return (v - c) / 6 / diff + 0.5;
    };
    if (diff === 0) {
        h = 0;
        s = 0;
    } else {
        s = diff / v;
        rdif = diffc(r);
        gdif = diffc(g);
        bdif = diffc(b);
        if (r === v) h = bdif - gdif;
        else if (g === v) h = 1 / 3 + rdif - bdif;
        else if (b === v) h = 2 / 3 + gdif - rdif;
        if (h < 0) h += 1;
        else if (h > 1) h -= 1;
    }
    return [
        h * 360,
        s * 100,
        v * 100
    ];
};
$1be8f4d3208fdae3$var$convert.rgb.hwb = function(rgb) {
    const r = rgb[0];
    const g = rgb[1];
    let b = rgb[2];
    const h = $1be8f4d3208fdae3$var$convert.rgb.hsl(rgb)[0];
    const w = 1 / 255 * Math.min(r, Math.min(g, b));
    b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));
    return [
        h,
        w * 100,
        b * 100
    ];
};
$1be8f4d3208fdae3$var$convert.rgb.cmyk = function(rgb) {
    const r = rgb[0] / 255;
    const g = rgb[1] / 255;
    const b = rgb[2] / 255;
    const k = Math.min(1 - r, 1 - g, 1 - b);
    const c = (1 - r - k) / (1 - k) || 0;
    const m = (1 - g - k) / (1 - k) || 0;
    const y = (1 - b - k) / (1 - k) || 0;
    return [
        c * 100,
        m * 100,
        y * 100,
        k * 100
    ];
};
function $1be8f4d3208fdae3$var$comparativeDistance(x, y) {
    /*
		See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
	*/ return (x[0] - y[0]) ** 2 + (x[1] - y[1]) ** 2 + (x[2] - y[2]) ** 2;
}
$1be8f4d3208fdae3$var$convert.rgb.keyword = function(rgb) {
    const reversed = $1be8f4d3208fdae3$var$reverseKeywords[rgb];
    if (reversed) return reversed;
    let currentClosestDistance = Infinity;
    let currentClosestKeyword;
    for (const keyword of Object.keys($e6076e8972ca3446$exports)){
        const value = $e6076e8972ca3446$exports[keyword];
        // Compute comparative distance
        const distance = $1be8f4d3208fdae3$var$comparativeDistance(rgb, value);
        // Check if its less, if so set as closest
        if (distance < currentClosestDistance) {
            currentClosestDistance = distance;
            currentClosestKeyword = keyword;
        }
    }
    return currentClosestKeyword;
};
$1be8f4d3208fdae3$var$convert.keyword.rgb = function(keyword) {
    return $e6076e8972ca3446$exports[keyword];
};
$1be8f4d3208fdae3$var$convert.rgb.xyz = function(rgb) {
    let r = rgb[0] / 255;
    let g = rgb[1] / 255;
    let b = rgb[2] / 255;
    // Assume sRGB
    r = r > 0.04045 ? ((r + 0.055) / 1.055) ** 2.4 : r / 12.92;
    g = g > 0.04045 ? ((g + 0.055) / 1.055) ** 2.4 : g / 12.92;
    b = b > 0.04045 ? ((b + 0.055) / 1.055) ** 2.4 : b / 12.92;
    const x = r * 0.4124 + g * 0.3576 + b * 0.1805;
    const y = r * 0.2126 + g * 0.7152 + b * 0.0722;
    const z = r * 0.0193 + g * 0.1192 + b * 0.9505;
    return [
        x * 100,
        y * 100,
        z * 100
    ];
};
$1be8f4d3208fdae3$var$convert.rgb.lab = function(rgb) {
    const xyz = $1be8f4d3208fdae3$var$convert.rgb.xyz(rgb);
    let x = xyz[0];
    let y = xyz[1];
    let z = xyz[2];
    x /= 95.047;
    y /= 100;
    z /= 108.883;
    x = x > 0.008856 ? x ** (1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? y ** (1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? z ** (1 / 3) : 7.787 * z + 16 / 116;
    const l = 116 * y - 16;
    const a = 500 * (x - y);
    const b = 200 * (y - z);
    return [
        l,
        a,
        b
    ];
};
$1be8f4d3208fdae3$var$convert.hsl.rgb = function(hsl) {
    const h = hsl[0] / 360;
    const s = hsl[1] / 100;
    const l = hsl[2] / 100;
    let t2;
    let t3;
    let val;
    if (s === 0) {
        val = l * 255;
        return [
            val,
            val,
            val
        ];
    }
    if (l < 0.5) t2 = l * (1 + s);
    else t2 = l + s - l * s;
    const t1 = 2 * l - t2;
    const rgb = [
        0,
        0,
        0
    ];
    for(let i = 0; i < 3; i++){
        t3 = h + 1 / 3 * -(i - 1);
        if (t3 < 0) t3++;
        if (t3 > 1) t3--;
        if (6 * t3 < 1) val = t1 + (t2 - t1) * 6 * t3;
        else if (2 * t3 < 1) val = t2;
        else if (3 * t3 < 2) val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
        else val = t1;
        rgb[i] = val * 255;
    }
    return rgb;
};
$1be8f4d3208fdae3$var$convert.hsl.hsv = function(hsl) {
    const h = hsl[0];
    let s = hsl[1] / 100;
    let l = hsl[2] / 100;
    let smin = s;
    const lmin = Math.max(l, 0.01);
    l *= 2;
    s *= l <= 1 ? l : 2 - l;
    smin *= lmin <= 1 ? lmin : 2 - lmin;
    const v = (l + s) / 2;
    const sv = l === 0 ? 2 * smin / (lmin + smin) : 2 * s / (l + s);
    return [
        h,
        sv * 100,
        v * 100
    ];
};
$1be8f4d3208fdae3$var$convert.hsv.rgb = function(hsv) {
    const h = hsv[0] / 60;
    const s = hsv[1] / 100;
    let v = hsv[2] / 100;
    const hi = Math.floor(h) % 6;
    const f = h - Math.floor(h);
    const p = 255 * v * (1 - s);
    const q = 255 * v * (1 - s * f);
    const t = 255 * v * (1 - s * (1 - f));
    v *= 255;
    switch(hi){
        case 0:
            return [
                v,
                t,
                p
            ];
        case 1:
            return [
                q,
                v,
                p
            ];
        case 2:
            return [
                p,
                v,
                t
            ];
        case 3:
            return [
                p,
                q,
                v
            ];
        case 4:
            return [
                t,
                p,
                v
            ];
        case 5:
            return [
                v,
                p,
                q
            ];
    }
};
$1be8f4d3208fdae3$var$convert.hsv.hsl = function(hsv) {
    const h = hsv[0];
    const s = hsv[1] / 100;
    const v = hsv[2] / 100;
    const vmin = Math.max(v, 0.01);
    let sl;
    let l;
    l = (2 - s) * v;
    const lmin = (2 - s) * vmin;
    sl = s * vmin;
    sl /= lmin <= 1 ? lmin : 2 - lmin;
    sl = sl || 0;
    l /= 2;
    return [
        h,
        sl * 100,
        l * 100
    ];
};
// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
$1be8f4d3208fdae3$var$convert.hwb.rgb = function(hwb) {
    const h = hwb[0] / 360;
    let wh = hwb[1] / 100;
    let bl = hwb[2] / 100;
    const ratio = wh + bl;
    let f;
    // Wh + bl cant be > 1
    if (ratio > 1) {
        wh /= ratio;
        bl /= ratio;
    }
    const i = Math.floor(6 * h);
    const v = 1 - bl;
    f = 6 * h - i;
    if ((i & 0x01) !== 0) f = 1 - f;
    const n = wh + f * (v - wh); // Linear interpolation
    let r;
    let g;
    let b;
    /* eslint-disable max-statements-per-line,no-multi-spaces */ switch(i){
        default:
        case 6:
        case 0:
            r = v;
            g = n;
            b = wh;
            break;
        case 1:
            r = n;
            g = v;
            b = wh;
            break;
        case 2:
            r = wh;
            g = v;
            b = n;
            break;
        case 3:
            r = wh;
            g = n;
            b = v;
            break;
        case 4:
            r = n;
            g = wh;
            b = v;
            break;
        case 5:
            r = v;
            g = wh;
            b = n;
            break;
    }
    /* eslint-enable max-statements-per-line,no-multi-spaces */ return [
        r * 255,
        g * 255,
        b * 255
    ];
};
$1be8f4d3208fdae3$var$convert.cmyk.rgb = function(cmyk) {
    const c = cmyk[0] / 100;
    const m = cmyk[1] / 100;
    const y = cmyk[2] / 100;
    const k = cmyk[3] / 100;
    const r = 1 - Math.min(1, c * (1 - k) + k);
    const g = 1 - Math.min(1, m * (1 - k) + k);
    const b = 1 - Math.min(1, y * (1 - k) + k);
    return [
        r * 255,
        g * 255,
        b * 255
    ];
};
$1be8f4d3208fdae3$var$convert.xyz.rgb = function(xyz) {
    const x = xyz[0] / 100;
    const y = xyz[1] / 100;
    const z = xyz[2] / 100;
    let r;
    let g;
    let b;
    r = x * 3.2406 + y * -1.5372 + z * -0.4986;
    g = x * -0.9689 + y * 1.8758 + z * 0.0415;
    b = x * 0.0557 + y * -0.204 + z * 1.0570;
    // Assume sRGB
    r = r > 0.0031308 ? 1.055 * r ** (1.0 / 2.4) - 0.055 : r * 12.92;
    g = g > 0.0031308 ? 1.055 * g ** (1.0 / 2.4) - 0.055 : g * 12.92;
    b = b > 0.0031308 ? 1.055 * b ** (1.0 / 2.4) - 0.055 : b * 12.92;
    r = Math.min(Math.max(0, r), 1);
    g = Math.min(Math.max(0, g), 1);
    b = Math.min(Math.max(0, b), 1);
    return [
        r * 255,
        g * 255,
        b * 255
    ];
};
$1be8f4d3208fdae3$var$convert.xyz.lab = function(xyz) {
    let x = xyz[0];
    let y = xyz[1];
    let z = xyz[2];
    x /= 95.047;
    y /= 100;
    z /= 108.883;
    x = x > 0.008856 ? x ** (1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? y ** (1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? z ** (1 / 3) : 7.787 * z + 16 / 116;
    const l = 116 * y - 16;
    const a = 500 * (x - y);
    const b = 200 * (y - z);
    return [
        l,
        a,
        b
    ];
};
$1be8f4d3208fdae3$var$convert.lab.xyz = function(lab) {
    const l = lab[0];
    const a = lab[1];
    const b = lab[2];
    let x;
    let y;
    let z;
    y = (l + 16) / 116;
    x = a / 500 + y;
    z = y - b / 200;
    const y2 = y ** 3;
    const x2 = x ** 3;
    const z2 = z ** 3;
    y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
    x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
    z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;
    x *= 95.047;
    y *= 100;
    z *= 108.883;
    return [
        x,
        y,
        z
    ];
};
$1be8f4d3208fdae3$var$convert.lab.lch = function(lab) {
    const l = lab[0];
    const a = lab[1];
    const b = lab[2];
    let h;
    const hr = Math.atan2(b, a);
    h = hr * 360 / 2 / Math.PI;
    if (h < 0) h += 360;
    const c = Math.sqrt(a * a + b * b);
    return [
        l,
        c,
        h
    ];
};
$1be8f4d3208fdae3$var$convert.lch.lab = function(lch) {
    const l = lch[0];
    const c = lch[1];
    const h = lch[2];
    const hr = h / 360 * 2 * Math.PI;
    const a = c * Math.cos(hr);
    const b = c * Math.sin(hr);
    return [
        l,
        a,
        b
    ];
};
$1be8f4d3208fdae3$var$convert.rgb.ansi16 = function(args, saturation = null) {
    const [r, g, b] = args;
    let value = saturation === null ? $1be8f4d3208fdae3$var$convert.rgb.hsv(args)[2] : saturation; // Hsv -> ansi16 optimization
    value = Math.round(value / 50);
    if (value === 0) return 30;
    let ansi = 30 + (Math.round(b / 255) << 2 | Math.round(g / 255) << 1 | Math.round(r / 255));
    if (value === 2) ansi += 60;
    return ansi;
};
$1be8f4d3208fdae3$var$convert.hsv.ansi16 = function(args) {
    // Optimization here; we already know the value and don't need to get
    // it converted for us.
    return $1be8f4d3208fdae3$var$convert.rgb.ansi16($1be8f4d3208fdae3$var$convert.hsv.rgb(args), args[2]);
};
$1be8f4d3208fdae3$var$convert.rgb.ansi256 = function(args) {
    const r = args[0];
    const g = args[1];
    const b = args[2];
    // We use the extended greyscale palette here, with the exception of
    // black and white. normal palette only has 4 greyscale shades.
    if (r === g && g === b) {
        if (r < 8) return 16;
        if (r > 248) return 231;
        return Math.round((r - 8) / 247 * 24) + 232;
    }
    const ansi = 16 + 36 * Math.round(r / 255 * 5) + 6 * Math.round(g / 255 * 5) + Math.round(b / 255 * 5);
    return ansi;
};
$1be8f4d3208fdae3$var$convert.ansi16.rgb = function(args) {
    let color = args % 10;
    // Handle greyscale
    if (color === 0 || color === 7) {
        if (args > 50) color += 3.5;
        color = color / 10.5 * 255;
        return [
            color,
            color,
            color
        ];
    }
    const mult = (~~(args > 50) + 1) * 0.5;
    const r = (color & 1) * mult * 255;
    const g = (color >> 1 & 1) * mult * 255;
    const b = (color >> 2 & 1) * mult * 255;
    return [
        r,
        g,
        b
    ];
};
$1be8f4d3208fdae3$var$convert.ansi256.rgb = function(args) {
    // Handle greyscale
    if (args >= 232) {
        const c = (args - 232) * 10 + 8;
        return [
            c,
            c,
            c
        ];
    }
    args -= 16;
    let rem;
    const r = Math.floor(args / 36) / 5 * 255;
    const g = Math.floor((rem = args % 36) / 6) / 5 * 255;
    const b = rem % 6 / 5 * 255;
    return [
        r,
        g,
        b
    ];
};
$1be8f4d3208fdae3$var$convert.rgb.hex = function(args) {
    const integer = ((Math.round(args[0]) & 0xFF) << 16) + ((Math.round(args[1]) & 0xFF) << 8) + (Math.round(args[2]) & 0xFF);
    const string = integer.toString(16).toUpperCase();
    return "000000".substring(string.length) + string;
};
$1be8f4d3208fdae3$var$convert.hex.rgb = function(args) {
    const match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
    if (!match) return [
        0,
        0,
        0
    ];
    let colorString = match[0];
    if (match[0].length === 3) colorString = colorString.split("").map((char)=>{
        return char + char;
    }).join("");
    const integer = parseInt(colorString, 16);
    const r = integer >> 16 & 0xFF;
    const g = integer >> 8 & 0xFF;
    const b = integer & 0xFF;
    return [
        r,
        g,
        b
    ];
};
$1be8f4d3208fdae3$var$convert.rgb.hcg = function(rgb) {
    const r = rgb[0] / 255;
    const g = rgb[1] / 255;
    const b = rgb[2] / 255;
    const max = Math.max(Math.max(r, g), b);
    const min = Math.min(Math.min(r, g), b);
    const chroma = max - min;
    let grayscale;
    let hue;
    if (chroma < 1) grayscale = min / (1 - chroma);
    else grayscale = 0;
    if (chroma <= 0) hue = 0;
    else if (max === r) hue = (g - b) / chroma % 6;
    else if (max === g) hue = 2 + (b - r) / chroma;
    else hue = 4 + (r - g) / chroma;
    hue /= 6;
    hue %= 1;
    return [
        hue * 360,
        chroma * 100,
        grayscale * 100
    ];
};
$1be8f4d3208fdae3$var$convert.hsl.hcg = function(hsl) {
    const s = hsl[1] / 100;
    const l = hsl[2] / 100;
    const c = l < 0.5 ? 2.0 * s * l : 2.0 * s * (1.0 - l);
    let f = 0;
    if (c < 1.0) f = (l - 0.5 * c) / (1.0 - c);
    return [
        hsl[0],
        c * 100,
        f * 100
    ];
};
$1be8f4d3208fdae3$var$convert.hsv.hcg = function(hsv) {
    const s = hsv[1] / 100;
    const v = hsv[2] / 100;
    const c = s * v;
    let f = 0;
    if (c < 1.0) f = (v - c) / (1 - c);
    return [
        hsv[0],
        c * 100,
        f * 100
    ];
};
$1be8f4d3208fdae3$var$convert.hcg.rgb = function(hcg) {
    const h = hcg[0] / 360;
    const c = hcg[1] / 100;
    const g = hcg[2] / 100;
    if (c === 0.0) return [
        g * 255,
        g * 255,
        g * 255
    ];
    const pure = [
        0,
        0,
        0
    ];
    const hi = h % 1 * 6;
    const v = hi % 1;
    const w = 1 - v;
    let mg = 0;
    /* eslint-disable max-statements-per-line */ switch(Math.floor(hi)){
        case 0:
            pure[0] = 1;
            pure[1] = v;
            pure[2] = 0;
            break;
        case 1:
            pure[0] = w;
            pure[1] = 1;
            pure[2] = 0;
            break;
        case 2:
            pure[0] = 0;
            pure[1] = 1;
            pure[2] = v;
            break;
        case 3:
            pure[0] = 0;
            pure[1] = w;
            pure[2] = 1;
            break;
        case 4:
            pure[0] = v;
            pure[1] = 0;
            pure[2] = 1;
            break;
        default:
            pure[0] = 1;
            pure[1] = 0;
            pure[2] = w;
    }
    /* eslint-enable max-statements-per-line */ mg = (1.0 - c) * g;
    return [
        (c * pure[0] + mg) * 255,
        (c * pure[1] + mg) * 255,
        (c * pure[2] + mg) * 255
    ];
};
$1be8f4d3208fdae3$var$convert.hcg.hsv = function(hcg) {
    const c = hcg[1] / 100;
    const g = hcg[2] / 100;
    const v = c + g * (1.0 - c);
    let f = 0;
    if (v > 0.0) f = c / v;
    return [
        hcg[0],
        f * 100,
        v * 100
    ];
};
$1be8f4d3208fdae3$var$convert.hcg.hsl = function(hcg) {
    const c = hcg[1] / 100;
    const g = hcg[2] / 100;
    const l = g * (1.0 - c) + 0.5 * c;
    let s = 0;
    if (l > 0.0 && l < 0.5) s = c / (2 * l);
    else if (l >= 0.5 && l < 1.0) s = c / (2 * (1 - l));
    return [
        hcg[0],
        s * 100,
        l * 100
    ];
};
$1be8f4d3208fdae3$var$convert.hcg.hwb = function(hcg) {
    const c = hcg[1] / 100;
    const g = hcg[2] / 100;
    const v = c + g * (1.0 - c);
    return [
        hcg[0],
        (v - c) * 100,
        (1 - v) * 100
    ];
};
$1be8f4d3208fdae3$var$convert.hwb.hcg = function(hwb) {
    const w = hwb[1] / 100;
    const b = hwb[2] / 100;
    const v = 1 - b;
    const c = v - w;
    let g = 0;
    if (c < 1) g = (v - c) / (1 - c);
    return [
        hwb[0],
        c * 100,
        g * 100
    ];
};
$1be8f4d3208fdae3$var$convert.apple.rgb = function(apple) {
    return [
        apple[0] / 65535 * 255,
        apple[1] / 65535 * 255,
        apple[2] / 65535 * 255
    ];
};
$1be8f4d3208fdae3$var$convert.rgb.apple = function(rgb) {
    return [
        rgb[0] / 255 * 65535,
        rgb[1] / 255 * 65535,
        rgb[2] / 255 * 65535
    ];
};
$1be8f4d3208fdae3$var$convert.gray.rgb = function(args) {
    return [
        args[0] / 100 * 255,
        args[0] / 100 * 255,
        args[0] / 100 * 255
    ];
};
$1be8f4d3208fdae3$var$convert.gray.hsl = function(args) {
    return [
        0,
        0,
        args[0]
    ];
};
$1be8f4d3208fdae3$var$convert.gray.hsv = $1be8f4d3208fdae3$var$convert.gray.hsl;
$1be8f4d3208fdae3$var$convert.gray.hwb = function(gray) {
    return [
        0,
        100,
        gray[0]
    ];
};
$1be8f4d3208fdae3$var$convert.gray.cmyk = function(gray) {
    return [
        0,
        0,
        0,
        gray[0]
    ];
};
$1be8f4d3208fdae3$var$convert.gray.lab = function(gray) {
    return [
        gray[0],
        0,
        0
    ];
};
$1be8f4d3208fdae3$var$convert.gray.hex = function(gray) {
    const val = Math.round(gray[0] / 100 * 255) & 0xFF;
    const integer = (val << 16) + (val << 8) + val;
    const string = integer.toString(16).toUpperCase();
    return "000000".substring(string.length) + string;
};
$1be8f4d3208fdae3$var$convert.rgb.gray = function(rgb) {
    const val = (rgb[0] + rgb[1] + rgb[2]) / 3;
    return [
        val / 255 * 100
    ];
};


var $4cbc30590332cd6b$exports = {};

/*
	This function routes a model to all other models.

	all functions that are routed have a property `.conversion` attached
	to the returned synthetic function. This property is an array
	of strings, each with the steps in between the 'from' and 'to'
	color models (inclusive).

	conversions that are not possible simply are not included.
*/ function $4cbc30590332cd6b$var$buildGraph() {
    const graph = {};
    // https://jsperf.com/object-keys-vs-for-in-with-closure/3
    const models = Object.keys($1be8f4d3208fdae3$exports);
    for(let len = models.length, i = 0; i < len; i++)graph[models[i]] = {
        // http://jsperf.com/1-vs-infinity
        // micro-opt, but this is simple.
        distance: -1,
        parent: null
    };
    return graph;
}
// https://en.wikipedia.org/wiki/Breadth-first_search
function $4cbc30590332cd6b$var$deriveBFS(fromModel) {
    const graph = $4cbc30590332cd6b$var$buildGraph();
    const queue = [
        fromModel
    ]; // Unshift -> queue -> pop
    graph[fromModel].distance = 0;
    while(queue.length){
        const current = queue.pop();
        const adjacents = Object.keys($1be8f4d3208fdae3$exports[current]);
        for(let len = adjacents.length, i = 0; i < len; i++){
            const adjacent = adjacents[i];
            const node = graph[adjacent];
            if (node.distance === -1) {
                node.distance = graph[current].distance + 1;
                node.parent = current;
                queue.unshift(adjacent);
            }
        }
    }
    return graph;
}
function $4cbc30590332cd6b$var$link(from, to) {
    return function(args) {
        return to(from(args));
    };
}
function $4cbc30590332cd6b$var$wrapConversion(toModel, graph) {
    const path = [
        graph[toModel].parent,
        toModel
    ];
    let fn = $1be8f4d3208fdae3$exports[graph[toModel].parent][toModel];
    let cur = graph[toModel].parent;
    while(graph[cur].parent){
        path.unshift(graph[cur].parent);
        fn = $4cbc30590332cd6b$var$link($1be8f4d3208fdae3$exports[graph[cur].parent][cur], fn);
        cur = graph[cur].parent;
    }
    fn.conversion = path;
    return fn;
}
$4cbc30590332cd6b$exports = function(fromModel) {
    const graph = $4cbc30590332cd6b$var$deriveBFS(fromModel);
    const conversion = {};
    const models = Object.keys(graph);
    for(let len = models.length, i = 0; i < len; i++){
        const toModel = models[i];
        const node = graph[toModel];
        if (node.parent === null) continue;
        conversion[toModel] = $4cbc30590332cd6b$var$wrapConversion(toModel, graph);
    }
    return conversion;
};


const $cf08bf5b3435e787$var$convert = {};
const $cf08bf5b3435e787$var$models = Object.keys($1be8f4d3208fdae3$exports);
function $cf08bf5b3435e787$var$wrapRaw(fn) {
    const wrappedFn = function(...args) {
        const arg0 = args[0];
        if (arg0 === undefined || arg0 === null) return arg0;
        if (arg0.length > 1) args = arg0;
        return fn(args);
    };
    // Preserve .conversion property if there is one
    if ("conversion" in fn) wrappedFn.conversion = fn.conversion;
    return wrappedFn;
}
function $cf08bf5b3435e787$var$wrapRounded(fn) {
    const wrappedFn = function(...args) {
        const arg0 = args[0];
        if (arg0 === undefined || arg0 === null) return arg0;
        if (arg0.length > 1) args = arg0;
        const result = fn(args);
        // We're assuming the result is an array here.
        // see notice in conversions.js; don't use box types
        // in conversion functions.
        if (typeof result === "object") for(let len = result.length, i = 0; i < len; i++)result[i] = Math.round(result[i]);
        return result;
    };
    // Preserve .conversion property if there is one
    if ("conversion" in fn) wrappedFn.conversion = fn.conversion;
    return wrappedFn;
}
$cf08bf5b3435e787$var$models.forEach((fromModel)=>{
    $cf08bf5b3435e787$var$convert[fromModel] = {};
    Object.defineProperty($cf08bf5b3435e787$var$convert[fromModel], "channels", {
        value: $1be8f4d3208fdae3$exports[fromModel].channels
    });
    Object.defineProperty($cf08bf5b3435e787$var$convert[fromModel], "labels", {
        value: $1be8f4d3208fdae3$exports[fromModel].labels
    });
    const routes = $4cbc30590332cd6b$exports(fromModel);
    const routeModels = Object.keys(routes);
    routeModels.forEach((toModel)=>{
        const fn = routes[toModel];
        $cf08bf5b3435e787$var$convert[fromModel][toModel] = $cf08bf5b3435e787$var$wrapRounded(fn);
        $cf08bf5b3435e787$var$convert[fromModel][toModel].raw = $cf08bf5b3435e787$var$wrapRaw(fn);
    });
});
$cf08bf5b3435e787$exports = $cf08bf5b3435e787$var$convert;


const $65db2c8fcb86b5e5$var$skippedModels = [
    // To be honest, I don't really feel like keyword belongs in color convert, but eh.
    "keyword",
    // Gray conflicts with some method names, and has its own method defined.
    "gray",
    // Shouldn't really be in color-convert either...
    "hex"
];
const $65db2c8fcb86b5e5$var$hashedModelKeys = {};
for (const model of Object.keys($cf08bf5b3435e787$exports))$65db2c8fcb86b5e5$var$hashedModelKeys[[
    ...$cf08bf5b3435e787$exports[model].labels
].sort().join("")] = model;
const $65db2c8fcb86b5e5$var$limiters = {};
function $65db2c8fcb86b5e5$var$Color(object, model) {
    if (!(this instanceof $65db2c8fcb86b5e5$var$Color)) return new $65db2c8fcb86b5e5$var$Color(object, model);
    if (model && model in $65db2c8fcb86b5e5$var$skippedModels) model = null;
    if (model && !(model in $cf08bf5b3435e787$exports)) throw new Error("Unknown model: " + model);
    let i;
    let channels;
    if (object == null) {
        this.model = "rgb";
        this.color = [
            0,
            0,
            0
        ];
        this.valpha = 1;
    } else if (object instanceof $65db2c8fcb86b5e5$var$Color) {
        this.model = object.model;
        this.color = [
            ...object.color
        ];
        this.valpha = object.valpha;
    } else if (typeof object === "string") {
        const result = $df074e7d5dcd8624$exports.get(object);
        if (result === null) throw new Error("Unable to parse color from string: " + object);
        this.model = result.model;
        channels = $cf08bf5b3435e787$exports[this.model].channels;
        this.color = result.value.slice(0, channels);
        this.valpha = typeof result.value[channels] === "number" ? result.value[channels] : 1;
    } else if (object.length > 0) {
        this.model = model || "rgb";
        channels = $cf08bf5b3435e787$exports[this.model].channels;
        const newArray = Array.prototype.slice.call(object, 0, channels);
        this.color = $65db2c8fcb86b5e5$var$zeroArray(newArray, channels);
        this.valpha = typeof object[channels] === "number" ? object[channels] : 1;
    } else if (typeof object === "number") {
        // This is always RGB - can be converted later on.
        this.model = "rgb";
        this.color = [
            object >> 16 & 0xFF,
            object >> 8 & 0xFF,
            object & 0xFF
        ];
        this.valpha = 1;
    } else {
        this.valpha = 1;
        const keys = Object.keys(object);
        if ("alpha" in object) {
            keys.splice(keys.indexOf("alpha"), 1);
            this.valpha = typeof object.alpha === "number" ? object.alpha : 0;
        }
        const hashedKeys = keys.sort().join("");
        if (!(hashedKeys in $65db2c8fcb86b5e5$var$hashedModelKeys)) throw new Error("Unable to parse color from object: " + JSON.stringify(object));
        this.model = $65db2c8fcb86b5e5$var$hashedModelKeys[hashedKeys];
        const { labels: labels } = $cf08bf5b3435e787$exports[this.model];
        const color = [];
        for(i = 0; i < labels.length; i++)color.push(object[labels[i]]);
        this.color = $65db2c8fcb86b5e5$var$zeroArray(color);
    }
    // Perform limitations (clamping, etc.)
    if ($65db2c8fcb86b5e5$var$limiters[this.model]) {
        channels = $cf08bf5b3435e787$exports[this.model].channels;
        for(i = 0; i < channels; i++){
            const limit = $65db2c8fcb86b5e5$var$limiters[this.model][i];
            if (limit) this.color[i] = limit(this.color[i]);
        }
    }
    this.valpha = Math.max(0, Math.min(1, this.valpha));
    if (Object.freeze) Object.freeze(this);
}
$65db2c8fcb86b5e5$var$Color.prototype = {
    toString () {
        return this.string();
    },
    toJSON () {
        return this[this.model]();
    },
    string (places) {
        let self = this.model in $df074e7d5dcd8624$exports.to ? this : this.rgb();
        self = self.round(typeof places === "number" ? places : 1);
        const args = self.valpha === 1 ? self.color : [
            ...self.color,
            this.valpha
        ];
        return $df074e7d5dcd8624$exports.to[self.model](args);
    },
    percentString (places) {
        const self = this.rgb().round(typeof places === "number" ? places : 1);
        const args = self.valpha === 1 ? self.color : [
            ...self.color,
            this.valpha
        ];
        return $df074e7d5dcd8624$exports.to.rgb.percent(args);
    },
    array () {
        return this.valpha === 1 ? [
            ...this.color
        ] : [
            ...this.color,
            this.valpha
        ];
    },
    object () {
        const result = {};
        const { channels: channels } = $cf08bf5b3435e787$exports[this.model];
        const { labels: labels } = $cf08bf5b3435e787$exports[this.model];
        for(let i = 0; i < channels; i++)result[labels[i]] = this.color[i];
        if (this.valpha !== 1) result.alpha = this.valpha;
        return result;
    },
    unitArray () {
        const rgb = this.rgb().color;
        rgb[0] /= 255;
        rgb[1] /= 255;
        rgb[2] /= 255;
        if (this.valpha !== 1) rgb.push(this.valpha);
        return rgb;
    },
    unitObject () {
        const rgb = this.rgb().object();
        rgb.r /= 255;
        rgb.g /= 255;
        rgb.b /= 255;
        if (this.valpha !== 1) rgb.alpha = this.valpha;
        return rgb;
    },
    round (places) {
        places = Math.max(places || 0, 0);
        return new $65db2c8fcb86b5e5$var$Color([
            ...this.color.map($65db2c8fcb86b5e5$var$roundToPlace(places)),
            this.valpha
        ], this.model);
    },
    alpha (value) {
        if (value !== undefined) return new $65db2c8fcb86b5e5$var$Color([
            ...this.color,
            Math.max(0, Math.min(1, value))
        ], this.model);
        return this.valpha;
    },
    // Rgb
    red: $65db2c8fcb86b5e5$var$getset("rgb", 0, $65db2c8fcb86b5e5$var$maxfn(255)),
    green: $65db2c8fcb86b5e5$var$getset("rgb", 1, $65db2c8fcb86b5e5$var$maxfn(255)),
    blue: $65db2c8fcb86b5e5$var$getset("rgb", 2, $65db2c8fcb86b5e5$var$maxfn(255)),
    hue: $65db2c8fcb86b5e5$var$getset([
        "hsl",
        "hsv",
        "hsl",
        "hwb",
        "hcg"
    ], 0, (value)=>(value % 360 + 360) % 360),
    saturationl: $65db2c8fcb86b5e5$var$getset("hsl", 1, $65db2c8fcb86b5e5$var$maxfn(100)),
    lightness: $65db2c8fcb86b5e5$var$getset("hsl", 2, $65db2c8fcb86b5e5$var$maxfn(100)),
    saturationv: $65db2c8fcb86b5e5$var$getset("hsv", 1, $65db2c8fcb86b5e5$var$maxfn(100)),
    value: $65db2c8fcb86b5e5$var$getset("hsv", 2, $65db2c8fcb86b5e5$var$maxfn(100)),
    chroma: $65db2c8fcb86b5e5$var$getset("hcg", 1, $65db2c8fcb86b5e5$var$maxfn(100)),
    gray: $65db2c8fcb86b5e5$var$getset("hcg", 2, $65db2c8fcb86b5e5$var$maxfn(100)),
    white: $65db2c8fcb86b5e5$var$getset("hwb", 1, $65db2c8fcb86b5e5$var$maxfn(100)),
    wblack: $65db2c8fcb86b5e5$var$getset("hwb", 2, $65db2c8fcb86b5e5$var$maxfn(100)),
    cyan: $65db2c8fcb86b5e5$var$getset("cmyk", 0, $65db2c8fcb86b5e5$var$maxfn(100)),
    magenta: $65db2c8fcb86b5e5$var$getset("cmyk", 1, $65db2c8fcb86b5e5$var$maxfn(100)),
    yellow: $65db2c8fcb86b5e5$var$getset("cmyk", 2, $65db2c8fcb86b5e5$var$maxfn(100)),
    black: $65db2c8fcb86b5e5$var$getset("cmyk", 3, $65db2c8fcb86b5e5$var$maxfn(100)),
    x: $65db2c8fcb86b5e5$var$getset("xyz", 0, $65db2c8fcb86b5e5$var$maxfn(95.047)),
    y: $65db2c8fcb86b5e5$var$getset("xyz", 1, $65db2c8fcb86b5e5$var$maxfn(100)),
    z: $65db2c8fcb86b5e5$var$getset("xyz", 2, $65db2c8fcb86b5e5$var$maxfn(108.833)),
    l: $65db2c8fcb86b5e5$var$getset("lab", 0, $65db2c8fcb86b5e5$var$maxfn(100)),
    a: $65db2c8fcb86b5e5$var$getset("lab", 1),
    b: $65db2c8fcb86b5e5$var$getset("lab", 2),
    keyword (value) {
        if (value !== undefined) return new $65db2c8fcb86b5e5$var$Color(value);
        return $cf08bf5b3435e787$exports[this.model].keyword(this.color);
    },
    hex (value) {
        if (value !== undefined) return new $65db2c8fcb86b5e5$var$Color(value);
        return $df074e7d5dcd8624$exports.to.hex(this.rgb().round().color);
    },
    hexa (value) {
        if (value !== undefined) return new $65db2c8fcb86b5e5$var$Color(value);
        const rgbArray = this.rgb().round().color;
        let alphaHex = Math.round(this.valpha * 255).toString(16).toUpperCase();
        if (alphaHex.length === 1) alphaHex = "0" + alphaHex;
        return $df074e7d5dcd8624$exports.to.hex(rgbArray) + alphaHex;
    },
    rgbNumber () {
        const rgb = this.rgb().color;
        return (rgb[0] & 0xFF) << 16 | (rgb[1] & 0xFF) << 8 | rgb[2] & 0xFF;
    },
    luminosity () {
        // http://www.w3.org/TR/WCAG20/#relativeluminancedef
        const rgb = this.rgb().color;
        const lum = [];
        for (const [i, element] of rgb.entries()){
            const chan = element / 255;
            lum[i] = chan <= 0.04045 ? chan / 12.92 : ((chan + 0.055) / 1.055) ** 2.4;
        }
        return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
    },
    contrast (color2) {
        // http://www.w3.org/TR/WCAG20/#contrast-ratiodef
        const lum1 = this.luminosity();
        const lum2 = color2.luminosity();
        if (lum1 > lum2) return (lum1 + 0.05) / (lum2 + 0.05);
        return (lum2 + 0.05) / (lum1 + 0.05);
    },
    level (color2) {
        // https://www.w3.org/TR/WCAG/#contrast-enhanced
        const contrastRatio = this.contrast(color2);
        if (contrastRatio >= 7) return "AAA";
        return contrastRatio >= 4.5 ? "AA" : "";
    },
    isDark () {
        // YIQ equation from http://24ways.org/2010/calculating-color-contrast
        const rgb = this.rgb().color;
        const yiq = (rgb[0] * 2126 + rgb[1] * 7152 + rgb[2] * 722) / 10000;
        return yiq < 128;
    },
    isLight () {
        return !this.isDark();
    },
    negate () {
        const rgb = this.rgb();
        for(let i = 0; i < 3; i++)rgb.color[i] = 255 - rgb.color[i];
        return rgb;
    },
    lighten (ratio) {
        const hsl = this.hsl();
        hsl.color[2] += hsl.color[2] * ratio;
        return hsl;
    },
    darken (ratio) {
        const hsl = this.hsl();
        hsl.color[2] -= hsl.color[2] * ratio;
        return hsl;
    },
    saturate (ratio) {
        const hsl = this.hsl();
        hsl.color[1] += hsl.color[1] * ratio;
        return hsl;
    },
    desaturate (ratio) {
        const hsl = this.hsl();
        hsl.color[1] -= hsl.color[1] * ratio;
        return hsl;
    },
    whiten (ratio) {
        const hwb = this.hwb();
        hwb.color[1] += hwb.color[1] * ratio;
        return hwb;
    },
    blacken (ratio) {
        const hwb = this.hwb();
        hwb.color[2] += hwb.color[2] * ratio;
        return hwb;
    },
    grayscale () {
        // http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
        const rgb = this.rgb().color;
        const value = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
        return $65db2c8fcb86b5e5$var$Color.rgb(value, value, value);
    },
    fade (ratio) {
        return this.alpha(this.valpha - this.valpha * ratio);
    },
    opaquer (ratio) {
        return this.alpha(this.valpha + this.valpha * ratio);
    },
    rotate (degrees) {
        const hsl = this.hsl();
        let hue = hsl.color[0];
        hue = (hue + degrees) % 360;
        hue = hue < 0 ? 360 + hue : hue;
        hsl.color[0] = hue;
        return hsl;
    },
    mix (mixinColor, weight) {
        // Ported from sass implementation in C
        // https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
        if (!mixinColor || !mixinColor.rgb) throw new Error('Argument to "mix" was not a Color instance, but rather an instance of ' + typeof mixinColor);
        const color1 = mixinColor.rgb();
        const color2 = this.rgb();
        const p = weight === undefined ? 0.5 : weight;
        const w = 2 * p - 1;
        const a = color1.alpha() - color2.alpha();
        const w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2;
        const w2 = 1 - w1;
        return $65db2c8fcb86b5e5$var$Color.rgb(w1 * color1.red() + w2 * color2.red(), w1 * color1.green() + w2 * color2.green(), w1 * color1.blue() + w2 * color2.blue(), color1.alpha() * p + color2.alpha() * (1 - p));
    }
};
// Model conversion methods and static constructors
for (const model of Object.keys($cf08bf5b3435e787$exports)){
    if ($65db2c8fcb86b5e5$var$skippedModels.includes(model)) continue;
    const { channels: channels } = $cf08bf5b3435e787$exports[model];
    // Conversion methods
    $65db2c8fcb86b5e5$var$Color.prototype[model] = function(...args) {
        if (this.model === model) return new $65db2c8fcb86b5e5$var$Color(this);
        if (args.length > 0) return new $65db2c8fcb86b5e5$var$Color(args, model);
        return new $65db2c8fcb86b5e5$var$Color([
            ...$65db2c8fcb86b5e5$var$assertArray($cf08bf5b3435e787$exports[this.model][model].raw(this.color)),
            this.valpha
        ], model);
    };
    // 'static' construction methods
    $65db2c8fcb86b5e5$var$Color[model] = function(...args) {
        let color = args[0];
        if (typeof color === "number") color = $65db2c8fcb86b5e5$var$zeroArray(args, channels);
        return new $65db2c8fcb86b5e5$var$Color(color, model);
    };
}
function $65db2c8fcb86b5e5$var$roundTo(number, places) {
    return Number(number.toFixed(places));
}
function $65db2c8fcb86b5e5$var$roundToPlace(places) {
    return function(number) {
        return $65db2c8fcb86b5e5$var$roundTo(number, places);
    };
}
function $65db2c8fcb86b5e5$var$getset(model, channel, modifier) {
    model = Array.isArray(model) ? model : [
        model
    ];
    for (const m of model)($65db2c8fcb86b5e5$var$limiters[m] || ($65db2c8fcb86b5e5$var$limiters[m] = []))[channel] = modifier;
    model = model[0];
    return function(value) {
        let result;
        if (value !== undefined) {
            if (modifier) value = modifier(value);
            result = this[model]();
            result.color[channel] = value;
            return result;
        }
        result = this[model]().color[channel];
        if (modifier) result = modifier(result);
        return result;
    };
}
function $65db2c8fcb86b5e5$var$maxfn(max) {
    return function(v) {
        return Math.max(0, Math.min(max, v));
    };
}
function $65db2c8fcb86b5e5$var$assertArray(value) {
    return Array.isArray(value) ? value : [
        value
    ];
}
function $65db2c8fcb86b5e5$var$zeroArray(array, length) {
    for(let i = 0; i < length; i++)if (typeof array[i] !== "number") array[i] = 0;
    return array;
}
$65db2c8fcb86b5e5$exports = $65db2c8fcb86b5e5$var$Color;


const $e54dff7b369bf34e$export$2b47dd798c93e22f = (baseColor, delta)=>{
    const hslArray = baseColor.hsl().round().array();
    var _hslArray_, _hslArray_1, _hslArray_2;
    return (0, (/*@__PURE__*/$parcel$interopDefault($65db2c8fcb86b5e5$exports)))([
        (_hslArray_ = hslArray[0]) !== null && _hslArray_ !== void 0 ? _hslArray_ : 0,
        (_hslArray_1 = hslArray[1]) !== null && _hslArray_1 !== void 0 ? _hslArray_1 : 0,
        ((_hslArray_2 = hslArray[2]) !== null && _hslArray_2 !== void 0 ? _hslArray_2 : 0) + delta
    ], "hsl");
};
const $e54dff7b369bf34e$export$13a5971b241f058c = (baseColor, delta)=>{
    const hslArray = baseColor.hsl().round().array();
    var _hslArray_, _hslArray_1, _hslArray_2;
    return (0, (/*@__PURE__*/$parcel$interopDefault($65db2c8fcb86b5e5$exports)))([
        (_hslArray_ = hslArray[0]) !== null && _hslArray_ !== void 0 ? _hslArray_ : 0,
        (_hslArray_1 = hslArray[1]) !== null && _hslArray_1 !== void 0 ? _hslArray_1 : 0,
        ((_hslArray_2 = hslArray[2]) !== null && _hslArray_2 !== void 0 ? _hslArray_2 : 0) - delta
    ], "hsl");
};
const $e54dff7b369bf34e$export$2feb0cd4df065982 = (lightColor)=>$e54dff7b369bf34e$export$2b47dd798c93e22f((0, (/*@__PURE__*/$parcel$interopDefault($65db2c8fcb86b5e5$exports)))(lightColor), 10).hex();


const $fe6d828cdd2e59e4$export$6561ab227a8e4a2 = (regEx)=>{
    try {
        return Boolean(regEx && new RegExp(regEx));
    } catch (e) {
        return false;
    }
};


const $ca8ea17c0d092285$export$bdb23a0789f9885e = /^\S+@\S+\.\S+$/;
const $ca8ea17c0d092285$export$205be3a4a78028e = /^\d+$/;
const $ca8ea17c0d092285$export$3b90d915073188c = /^\+?[\d-( )]+$/;
const $ca8ea17c0d092285$export$221be9ce6b96eec3 = /^[A-Z_a-z]\w*$/;
const $ca8ea17c0d092285$export$faa873956c7a1484 = /^https?:$/;
const $ca8ea17c0d092285$export$cda568c01bd42f00 = /^[a-z][\d+_a-z-]*(\.[\d+_a-z-]+)+:$/;
const $ca8ea17c0d092285$export$ad64c5d64b2f359b = /^#[\da-f]{3}([\da-f]{3})?$/i;
const $ca8ea17c0d092285$export$2586bfd81a855904 = /^\d{4}(-\d{2}){2}/;
const $ca8ea17c0d092285$export$14b44af55c20c1e5 = /^\S+$/;
const $ca8ea17c0d092285$export$d9e81dda45f84c36 = /^[\dA-Za-z](?:[\dA-Za-z-]*[\dA-Za-z])?(?:\.[\dA-Za-z](?:[\dA-Za-z-]*[\dA-Za-z])?){2,}$/;


const $33c59d0a69c5841e$export$eabdc444ee87166e = (url, type)=>{
    try {
        const { protocol: protocol } = new URL(url);
        const protocolRegEx = type === "mobile" ? (0, $ca8ea17c0d092285$export$cda568c01bd42f00) : (0, $ca8ea17c0d092285$export$faa873956c7a1484);
        return protocolRegEx.test(protocol);
    } catch (e) {
        return false;
    }
};
const $33c59d0a69c5841e$export$6ac9a0b3ab4a632f = (url)=>{
    try {
        return new URL(url).origin === url;
    } catch (e) {
        return false;
    }
};
const $33c59d0a69c5841e$export$bef94a5618bf18bf = (url)=>{
    try {
        return Boolean(url && new URL(url));
    } catch (e) {
        return false;
    }
};
const $33c59d0a69c5841e$export$ec8a6426516240fc = (url)=>{
    const parsedUrl = new URL(url);
    return [
        "localhost",
        "127.0.0.1",
        "::1"
    ].includes(parsedUrl.hostname);
};





/** Scopes that reserved by Logto, which will be added to the auth request automatically. */ var $7e115e7b30c7027b$export$1d2e82cebfd4b08;
(function(ReservedScope) {
    ReservedScope["OpenId"] = "openid";
    ReservedScope["OfflineAccess"] = "offline_access";
})($7e115e7b30c7027b$export$1d2e82cebfd4b08 || ($7e115e7b30c7027b$export$1d2e82cebfd4b08 = {}));
var $7e115e7b30c7027b$export$36ba08a8e14b2df6;
(function(ReservedResource) {
    /**
     * The resource for organization template per RFC 0001.
     *
     * @see {@link https://github.com/logto-io/rfcs | RFC 0001} for more details.
     */ ReservedResource["Organization"] = "urn:logto:resource:organizations";
})($7e115e7b30c7027b$export$36ba08a8e14b2df6 || ($7e115e7b30c7027b$export$36ba08a8e14b2df6 = {}));
var $7e115e7b30c7027b$export$4b02c5b431f6eb78;
(function(UserScope) {
    /**
     * Scope for basic user info.
     *
     * See {@link idTokenClaims} for mapped claims in ID Token and {@link userinfoClaims} for additional claims in Userinfo Endpoint.
     */ UserScope["Profile"] = "profile";
    /**
     * Scope for user email address.
     *
     * See {@link idTokenClaims} for mapped claims in ID Token and {@link userinfoClaims} for additional claims in Userinfo Endpoint.
     */ UserScope["Email"] = "email";
    /**
     * Scope for user phone number.
     *
     * See {@link idTokenClaims} for mapped claims in ID Token and {@link userinfoClaims} for additional claims in Userinfo Endpoint.
     */ UserScope["Phone"] = "phone";
    /**
     * Scope for user address.
     *
     * See {@link idTokenClaims} for mapped claims in ID Token and {@link userinfoClaims} for additional claims in Userinfo Endpoint.
     */ UserScope["Address"] = "address";
    /**
     * Scope for user's custom data.
     *
     * See {@link idTokenClaims} for mapped claims in ID Token and {@link userinfoClaims} for additional claims in Userinfo Endpoint.
     */ UserScope["CustomData"] = "custom_data";
    /**
     * Scope for user's social identity details.
     *
     * See {@link idTokenClaims} for mapped claims in ID Token and {@link userinfoClaims} for additional claims in Userinfo Endpoint.
     */ UserScope["Identities"] = "identities";
    /**
     * Scope for user's roles.
     *
     * See {@link idTokenClaims} for mapped claims in ID Token and {@link userinfoClaims} for additional claims in Userinfo Endpoint.
     */ UserScope["Roles"] = "roles";
    /**
     * Scope for user's organization IDs and perform organization token grant per [RFC 0001](https://github.com/logto-io/rfcs).
     *
     * See {@link idTokenClaims} for mapped claims in ID Token and {@link userinfoClaims} for additional claims in Userinfo Endpoint.
     */ UserScope["Organizations"] = "urn:logto:scope:organizations";
    /**
     * Scope for user's organization roles per [RFC 0001](https://github.com/logto-io/rfcs).
     *
     * See {@link idTokenClaims} for mapped claims in ID Token and {@link userinfoClaims} for additional claims in Userinfo Endpoint.
     */ UserScope["OrganizationRoles"] = "urn:logto:scope:organization_roles";
})($7e115e7b30c7027b$export$4b02c5b431f6eb78 || ($7e115e7b30c7027b$export$4b02c5b431f6eb78 = {}));
const $7e115e7b30c7027b$export$f57bb8dda2a18319 = Object.freeze({
    [$7e115e7b30c7027b$export$4b02c5b431f6eb78.Profile]: [
        // Standard claims
        "name",
        "family_name",
        "given_name",
        "middle_name",
        "nickname",
        "preferred_username",
        "profile",
        "picture",
        "website",
        "gender",
        "birthdate",
        "zoneinfo",
        "locale",
        "updated_at",
        // Custom claims
        "username",
        "created_at"
    ],
    [$7e115e7b30c7027b$export$4b02c5b431f6eb78.Email]: [
        "email",
        "email_verified"
    ],
    [$7e115e7b30c7027b$export$4b02c5b431f6eb78.Phone]: [
        "phone_number",
        "phone_number_verified"
    ],
    [$7e115e7b30c7027b$export$4b02c5b431f6eb78.Address]: [
        "address"
    ],
    [$7e115e7b30c7027b$export$4b02c5b431f6eb78.Roles]: [
        "roles"
    ],
    [$7e115e7b30c7027b$export$4b02c5b431f6eb78.Organizations]: [
        "organizations"
    ],
    [$7e115e7b30c7027b$export$4b02c5b431f6eb78.OrganizationRoles]: [
        "organization_roles"
    ],
    [$7e115e7b30c7027b$export$4b02c5b431f6eb78.CustomData]: [],
    [$7e115e7b30c7027b$export$4b02c5b431f6eb78.Identities]: []
});
const $7e115e7b30c7027b$export$c11d5a3385aa71dd = Object.freeze({
    [$7e115e7b30c7027b$export$4b02c5b431f6eb78.Profile]: [],
    [$7e115e7b30c7027b$export$4b02c5b431f6eb78.Email]: [],
    [$7e115e7b30c7027b$export$4b02c5b431f6eb78.Phone]: [],
    [$7e115e7b30c7027b$export$4b02c5b431f6eb78.Address]: [],
    [$7e115e7b30c7027b$export$4b02c5b431f6eb78.Roles]: [],
    [$7e115e7b30c7027b$export$4b02c5b431f6eb78.Organizations]: [
        "organization_data"
    ],
    [$7e115e7b30c7027b$export$4b02c5b431f6eb78.OrganizationRoles]: [],
    [$7e115e7b30c7027b$export$4b02c5b431f6eb78.CustomData]: [
        "custom_data"
    ],
    [$7e115e7b30c7027b$export$4b02c5b431f6eb78.Identities]: [
        "identities"
    ]
});
const $7e115e7b30c7027b$export$6c46daeabb0176f9 = Object.freeze(// Hard to infer type directly, use `as` for a workaround.
// eslint-disable-next-line no-restricted-syntax
Object.fromEntries(Object.values($7e115e7b30c7027b$export$4b02c5b431f6eb78).map((current)=>[
        current,
        [
            ...$7e115e7b30c7027b$export$f57bb8dda2a18319[current],
            ...$7e115e7b30c7027b$export$c11d5a3385aa71dd[current]
        ]
    ])));
const $7e115e7b30c7027b$export$fc38cc6da79faa5c = "urn:logto:organization:";
const $7e115e7b30c7027b$export$22667c0b6b2d7fac = (organizationId)=>`${$7e115e7b30c7027b$export$fc38cc6da79faa5c}${organizationId}`;
const $7e115e7b30c7027b$export$a237ae1b02e4e718 = (urn)=>{
    if (!urn.startsWith($7e115e7b30c7027b$export$fc38cc6da79faa5c)) throw new TypeError("Invalid organization URN.");
    return urn.slice($7e115e7b30c7027b$export$fc38cc6da79faa5c.length);
};


/*
  We does not export `sql.ts` here since it requires slonik which is not universal.
  It will be exported separately in `/src/index.ts`.
*/ 



const $7dc45467e5c89375$export$dd89c3a817f05bc7 = (object, key)=>object !== null && typeof object === "object" && key in object;


/**
 * A cache that expires entries after a given time-to-live (TTL). It uses a
 * `Map` in memory to store the entries.
 */ function $da9718fd2e09c92f$export$ccedaf978f62b9dd(receiver, privateSet, fn) {
    if (!privateSet.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return fn;
}


function $81a6d1d52ff9237c$export$6b10452b5ac97eba(obj, privateCollection) {
    if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}


function $11542ea1772162d4$export$1002c20f28174dbf(obj, privateSet) {
    (0, $81a6d1d52ff9237c$export$6b10452b5ac97eba)(obj, privateSet);
    privateSet.add(obj);
}


var $781d37ec18f60bdc$var$_purge = /*#__PURE__*/ new WeakSet();
class $781d37ec18f60bdc$export$4421a7403324ea68 {
    /**
     * Sets a value in the cache.
     * @param key The key to set.
     * @param value The value to set.
     * @param ttl The TTL for the entry in milliseconds. Defaults to the default
     * TTL.
     * @throws If the value is `undefined`.
     */ set(key, value, ttl = this.ttl) {
        if (value === undefined) throw new TypeError("Value cannot be undefined");
        this.expiration.set(key, Date.now() + ttl);
        this.data.set(key, value);
    }
    /**
     * Gets a value from the cache.
     * @param key The key to get.
     * @returns The value or `undefined` if the entry has expired or does not
     * exist.
     */ get(key) {
        (0, $da9718fd2e09c92f$export$ccedaf978f62b9dd)(this, $781d37ec18f60bdc$var$_purge, $781d37ec18f60bdc$var$purge).call(this, key);
        return this.data.get(key);
    }
    /**
     * Checks if a key exists in the cache.
     * @param key The key to check.
     * @returns `true` if the key exists and has not expired, `false` otherwise.
     */ has(key) {
        (0, $da9718fd2e09c92f$export$ccedaf978f62b9dd)(this, $781d37ec18f60bdc$var$_purge, $781d37ec18f60bdc$var$purge).call(this, key);
        return this.data.has(key);
    }
    /**
     * Deletes a key and its value from the cache. If the key does not exist, this
     * method does nothing.
     * @param key The key to delete.
     * @returns `true` if the key existed and was deleted, `false` otherwise.
     */ delete(key) {
        this.expiration.delete(key);
        return this.data.delete(key);
    }
    /**
     * Clears the cache. All entries will be deleted.
     */ clear() {
        this.expiration.clear();
        this.data.clear();
    }
    /**
     * @param ttl The default TTL for entries in milliseconds. Defaults to
     * `Number.POSITIVE_INFINITY`.
     */ constructor(ttl = Number.POSITIVE_INFINITY){
        (0, $11542ea1772162d4$export$1002c20f28174dbf)(this, $781d37ec18f60bdc$var$_purge);
        this.ttl = ttl;
        this.data = new Map();
        this.expiration = new Map();
    }
}
function $781d37ec18f60bdc$var$purge(key) {
    const expiration = this.expiration.get(key);
    if (expiration !== undefined && expiration < Date.now()) this.delete(key);
}



let $479960eff283084f$export$4385e60b38654f68 = (bytes)=>crypto.getRandomValues(new Uint8Array(bytes));
let $479960eff283084f$export$a5cee9e955a615e5 = (alphabet, defaultSize, getRandom)=>{
    let mask = (2 << Math.log(alphabet.length - 1) / Math.LN2) - 1;
    let step = -~(1.6 * mask * defaultSize / alphabet.length);
    return (size = defaultSize)=>{
        let id = "";
        while(true){
            let bytes = getRandom(step);
            let j = step;
            while(j--){
                id += alphabet[bytes[j] & mask] || "";
                if (id.length === size) return id;
            }
        }
    };
};
let $479960eff283084f$export$62e99e5c9f473d7f = (alphabet, size = 21)=>$479960eff283084f$export$a5cee9e955a615e5(alphabet, size, $479960eff283084f$export$4385e60b38654f68);
let $479960eff283084f$export$ac4959f4f1338dfc = (size = 21)=>crypto.getRandomValues(new Uint8Array(size)).reduce((id, byte)=>{
        byte &= 63;
        if (byte < 36) id += byte.toString(36);
        else if (byte < 62) id += (byte - 26).toString(36).toUpperCase();
        else if (byte > 62) id += "-";
        else id += "_";
        return id;
    }, "");


const $89790267634015cc$var$lowercaseAlphabet = "0123456789abcdefghijklmnopqrstuvwxyz";
const $89790267634015cc$var$alphabet = `${$89790267634015cc$var$lowercaseAlphabet}ABCDEFGHIJKLMNOPQRSTUVWXYZ`;
const $89790267634015cc$var$buildIdGenerator = (size, includingUppercase = true)=>(0, $479960eff283084f$export$62e99e5c9f473d7f)(includingUppercase ? $89790267634015cc$var$alphabet : $89790267634015cc$var$lowercaseAlphabet, size);
const $89790267634015cc$export$7e648d54e633633e = $89790267634015cc$var$buildIdGenerator(21, false);
const $89790267634015cc$export$8702116b552d3dba = $89790267634015cc$var$buildIdGenerator(12, false);
const $89790267634015cc$export$877b6275f1b9e856 = $89790267634015cc$var$buildIdGenerator(32);



// Importing from a ".js" file is a workaround for Node.js "ES Modules"
// importing system which is even uncapable of importing "*.json" files.
// This file is a workaround for a bug in web browsers' "native"
// ES6 importing system which is uncapable of importing "*.json" files.
// https://github.com/catamphetamine/libphonenumber-js/issues/239
var $051d22eb5cab544f$export$2e2bcd8739ae039 = {
    "version": 4,
    "country_calling_codes": {
        "1": [
            "US",
            "AG",
            "AI",
            "AS",
            "BB",
            "BM",
            "BS",
            "CA",
            "DM",
            "DO",
            "GD",
            "GU",
            "JM",
            "KN",
            "KY",
            "LC",
            "MP",
            "MS",
            "PR",
            "SX",
            "TC",
            "TT",
            "VC",
            "VG",
            "VI"
        ],
        "7": [
            "RU",
            "KZ"
        ],
        "20": [
            "EG"
        ],
        "27": [
            "ZA"
        ],
        "30": [
            "GR"
        ],
        "31": [
            "NL"
        ],
        "32": [
            "BE"
        ],
        "33": [
            "FR"
        ],
        "34": [
            "ES"
        ],
        "36": [
            "HU"
        ],
        "39": [
            "IT",
            "VA"
        ],
        "40": [
            "RO"
        ],
        "41": [
            "CH"
        ],
        "43": [
            "AT"
        ],
        "44": [
            "GB",
            "GG",
            "IM",
            "JE"
        ],
        "45": [
            "DK"
        ],
        "46": [
            "SE"
        ],
        "47": [
            "NO",
            "SJ"
        ],
        "48": [
            "PL"
        ],
        "49": [
            "DE"
        ],
        "51": [
            "PE"
        ],
        "52": [
            "MX"
        ],
        "53": [
            "CU"
        ],
        "54": [
            "AR"
        ],
        "55": [
            "BR"
        ],
        "56": [
            "CL"
        ],
        "57": [
            "CO"
        ],
        "58": [
            "VE"
        ],
        "60": [
            "MY"
        ],
        "61": [
            "AU",
            "CC",
            "CX"
        ],
        "62": [
            "ID"
        ],
        "63": [
            "PH"
        ],
        "64": [
            "NZ"
        ],
        "65": [
            "SG"
        ],
        "66": [
            "TH"
        ],
        "81": [
            "JP"
        ],
        "82": [
            "KR"
        ],
        "84": [
            "VN"
        ],
        "86": [
            "CN"
        ],
        "90": [
            "TR"
        ],
        "91": [
            "IN"
        ],
        "92": [
            "PK"
        ],
        "93": [
            "AF"
        ],
        "94": [
            "LK"
        ],
        "95": [
            "MM"
        ],
        "98": [
            "IR"
        ],
        "211": [
            "SS"
        ],
        "212": [
            "MA",
            "EH"
        ],
        "213": [
            "DZ"
        ],
        "216": [
            "TN"
        ],
        "218": [
            "LY"
        ],
        "220": [
            "GM"
        ],
        "221": [
            "SN"
        ],
        "222": [
            "MR"
        ],
        "223": [
            "ML"
        ],
        "224": [
            "GN"
        ],
        "225": [
            "CI"
        ],
        "226": [
            "BF"
        ],
        "227": [
            "NE"
        ],
        "228": [
            "TG"
        ],
        "229": [
            "BJ"
        ],
        "230": [
            "MU"
        ],
        "231": [
            "LR"
        ],
        "232": [
            "SL"
        ],
        "233": [
            "GH"
        ],
        "234": [
            "NG"
        ],
        "235": [
            "TD"
        ],
        "236": [
            "CF"
        ],
        "237": [
            "CM"
        ],
        "238": [
            "CV"
        ],
        "239": [
            "ST"
        ],
        "240": [
            "GQ"
        ],
        "241": [
            "GA"
        ],
        "242": [
            "CG"
        ],
        "243": [
            "CD"
        ],
        "244": [
            "AO"
        ],
        "245": [
            "GW"
        ],
        "246": [
            "IO"
        ],
        "247": [
            "AC"
        ],
        "248": [
            "SC"
        ],
        "249": [
            "SD"
        ],
        "250": [
            "RW"
        ],
        "251": [
            "ET"
        ],
        "252": [
            "SO"
        ],
        "253": [
            "DJ"
        ],
        "254": [
            "KE"
        ],
        "255": [
            "TZ"
        ],
        "256": [
            "UG"
        ],
        "257": [
            "BI"
        ],
        "258": [
            "MZ"
        ],
        "260": [
            "ZM"
        ],
        "261": [
            "MG"
        ],
        "262": [
            "RE",
            "YT"
        ],
        "263": [
            "ZW"
        ],
        "264": [
            "NA"
        ],
        "265": [
            "MW"
        ],
        "266": [
            "LS"
        ],
        "267": [
            "BW"
        ],
        "268": [
            "SZ"
        ],
        "269": [
            "KM"
        ],
        "290": [
            "SH",
            "TA"
        ],
        "291": [
            "ER"
        ],
        "297": [
            "AW"
        ],
        "298": [
            "FO"
        ],
        "299": [
            "GL"
        ],
        "350": [
            "GI"
        ],
        "351": [
            "PT"
        ],
        "352": [
            "LU"
        ],
        "353": [
            "IE"
        ],
        "354": [
            "IS"
        ],
        "355": [
            "AL"
        ],
        "356": [
            "MT"
        ],
        "357": [
            "CY"
        ],
        "358": [
            "FI",
            "AX"
        ],
        "359": [
            "BG"
        ],
        "370": [
            "LT"
        ],
        "371": [
            "LV"
        ],
        "372": [
            "EE"
        ],
        "373": [
            "MD"
        ],
        "374": [
            "AM"
        ],
        "375": [
            "BY"
        ],
        "376": [
            "AD"
        ],
        "377": [
            "MC"
        ],
        "378": [
            "SM"
        ],
        "380": [
            "UA"
        ],
        "381": [
            "RS"
        ],
        "382": [
            "ME"
        ],
        "383": [
            "XK"
        ],
        "385": [
            "HR"
        ],
        "386": [
            "SI"
        ],
        "387": [
            "BA"
        ],
        "389": [
            "MK"
        ],
        "420": [
            "CZ"
        ],
        "421": [
            "SK"
        ],
        "423": [
            "LI"
        ],
        "500": [
            "FK"
        ],
        "501": [
            "BZ"
        ],
        "502": [
            "GT"
        ],
        "503": [
            "SV"
        ],
        "504": [
            "HN"
        ],
        "505": [
            "NI"
        ],
        "506": [
            "CR"
        ],
        "507": [
            "PA"
        ],
        "508": [
            "PM"
        ],
        "509": [
            "HT"
        ],
        "590": [
            "GP",
            "BL",
            "MF"
        ],
        "591": [
            "BO"
        ],
        "592": [
            "GY"
        ],
        "593": [
            "EC"
        ],
        "594": [
            "GF"
        ],
        "595": [
            "PY"
        ],
        "596": [
            "MQ"
        ],
        "597": [
            "SR"
        ],
        "598": [
            "UY"
        ],
        "599": [
            "CW",
            "BQ"
        ],
        "670": [
            "TL"
        ],
        "672": [
            "NF"
        ],
        "673": [
            "BN"
        ],
        "674": [
            "NR"
        ],
        "675": [
            "PG"
        ],
        "676": [
            "TO"
        ],
        "677": [
            "SB"
        ],
        "678": [
            "VU"
        ],
        "679": [
            "FJ"
        ],
        "680": [
            "PW"
        ],
        "681": [
            "WF"
        ],
        "682": [
            "CK"
        ],
        "683": [
            "NU"
        ],
        "685": [
            "WS"
        ],
        "686": [
            "KI"
        ],
        "687": [
            "NC"
        ],
        "688": [
            "TV"
        ],
        "689": [
            "PF"
        ],
        "690": [
            "TK"
        ],
        "691": [
            "FM"
        ],
        "692": [
            "MH"
        ],
        "850": [
            "KP"
        ],
        "852": [
            "HK"
        ],
        "853": [
            "MO"
        ],
        "855": [
            "KH"
        ],
        "856": [
            "LA"
        ],
        "880": [
            "BD"
        ],
        "886": [
            "TW"
        ],
        "960": [
            "MV"
        ],
        "961": [
            "LB"
        ],
        "962": [
            "JO"
        ],
        "963": [
            "SY"
        ],
        "964": [
            "IQ"
        ],
        "965": [
            "KW"
        ],
        "966": [
            "SA"
        ],
        "967": [
            "YE"
        ],
        "968": [
            "OM"
        ],
        "970": [
            "PS"
        ],
        "971": [
            "AE"
        ],
        "972": [
            "IL"
        ],
        "973": [
            "BH"
        ],
        "974": [
            "QA"
        ],
        "975": [
            "BT"
        ],
        "976": [
            "MN"
        ],
        "977": [
            "NP"
        ],
        "992": [
            "TJ"
        ],
        "993": [
            "TM"
        ],
        "994": [
            "AZ"
        ],
        "995": [
            "GE"
        ],
        "996": [
            "KG"
        ],
        "998": [
            "UZ"
        ]
    },
    "countries": {
        "AC": [
            "247",
            "00",
            "(?:[01589]\\d|[46])\\d{4}",
            [
                5,
                6
            ]
        ],
        "AD": [
            "376",
            "00",
            "(?:1|6\\d)\\d{7}|[135-9]\\d{5}",
            [
                6,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "[135-9]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ]
        ],
        "AE": [
            "971",
            "00",
            "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{2,9})",
                    "$1 $2",
                    [
                        "60|8"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[236]|[479][2-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[479]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AF": [
            "93",
            "00",
            "[2-7]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AG": [
            "1",
            "011",
            "(?:268|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([457]\\d{6})$|1",
            "268$1",
            0,
            "268"
        ],
        "AI": [
            "1",
            "011",
            "(?:264|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2457]\\d{6})$|1",
            "264$1",
            0,
            "264"
        ],
        "AL": [
            "355",
            "00",
            "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3,4})",
                    "$1 $2",
                    [
                        "80|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "4[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2358][2-5]|4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[23578]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AM": [
            "374",
            "00",
            "(?:[1-489]\\d|55|60|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]0"
                    ],
                    "0 $1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "2|3[12]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "1|47"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[3-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AO": [
            "244",
            "00",
            "[29]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[29]"
                    ]
                ]
            ]
        ],
        "AR": [
            "54",
            "00",
            "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}",
            [
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{2})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])",
                        "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)",
                        "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                        "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "1"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[68]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[23]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d)(\\d{4})(\\d{2})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "9(?:2[2-469]|3[3-578])",
                        "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))",
                        "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)",
                        "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                        "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ],
                [
                    "(\\d)(\\d{2})(\\d{4})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "91"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1-$2-$3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "9"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ]
            ],
            "0",
            0,
            "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?",
            "9$1"
        ],
        "AS": [
            "1",
            "011",
            "(?:[58]\\d\\d|684|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([267]\\d{6})$|1",
            "684$1",
            0,
            "684"
        ],
        "AT": [
            "43",
            "00",
            "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d)(\\d{3,12})",
                    "$1 $2",
                    [
                        "1(?:11|[2-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})",
                    "$1 $2",
                    [
                        "517"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,5})",
                    "$1 $2",
                    [
                        "5[079]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,10})",
                    "$1 $2",
                    [
                        "(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,9})",
                    "$1 $2",
                    [
                        "[2-467]|5[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4,7})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AU": [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1 $2",
                    [
                        "16"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "16"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "14|4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2378]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1(?:30|[89])"
                    ]
                ]
            ],
            "0",
            0,
            "(183[12])|0",
            0,
            0,
            0,
            [
                [
                    "(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|3(?:[0-3589]\\d|4[0-578]|6[1-9]|7[0-35-9])|7(?:[013-57-9]\\d|2[0-8]))\\d{3}|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4]))|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}",
                    [
                        9
                    ]
                ],
                [
                    "4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-26-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "180(?:0\\d{3}|2)\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "190[0-26]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                [
                    "163\\d{2,6}",
                    [
                        5,
                        6,
                        7,
                        8,
                        9
                    ]
                ],
                [
                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                    [
                        9
                    ]
                ],
                [
                    "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                    [
                        6,
                        8,
                        10,
                        12
                    ]
                ]
            ],
            "0011"
        ],
        "AW": [
            "297",
            "00",
            "(?:[25-79]\\d\\d|800)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[25-9]"
                    ]
                ]
            ]
        ],
        "AX": [
            "358",
            "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
            "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            "18",
            0,
            "00"
        ],
        "AZ": [
            "994",
            "00",
            "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[28]|2|365|46",
                        "1[28]|2|365[45]|46",
                        "1[28]|2|365(?:4|5[02])|46"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[13-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BA": [
            "387",
            "00",
            "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6[1-3]|[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2-$3",
                    [
                        "[3-5]|6[56]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BB": [
            "1",
            "011",
            "(?:246|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "246$1",
            0,
            "246"
        ],
        "BD": [
            "880",
            "00",
            "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1-$2",
                    [
                        "31[5-8]|[459]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1-$2",
                    [
                        "3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,6})",
                    "$1-$2",
                    [
                        "[13-9]|22"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{7,8})",
                    "$1-$2",
                    [
                        "2"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BE": [
            "32",
            "00",
            "4\\d{8}|[1-9]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:80|9)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[239]|4[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[15-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "4"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BF": [
            "226",
            "00",
            "[025-7]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[025-7]"
                    ]
                ]
            ]
        ],
        "BG": [
            "359",
            "00",
            "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}",
            [
                6,
                7,
                8,
                9,
                12
            ],
            [
                [
                    "(\\d)(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "43[1-6]|70[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:70|8)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "43[1-7]|7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[48]|9[08]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BH": [
            "973",
            "00",
            "[136-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[13679]|8[02-4679]"
                    ]
                ]
            ]
        ],
        "BI": [
            "257",
            "00",
            "(?:[267]\\d|31)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2367]"
                    ]
                ]
            ]
        ],
        "BJ": [
            "229",
            "00",
            "[24-689]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24-689]"
                    ]
                ]
            ]
        ],
        "BL": [
            "590",
            "00",
            "590\\d{6}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"
                ],
                [
                    "69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:395|76[018])\\d|475[0-5])\\d{4}"
                ]
            ]
        ],
        "BM": [
            "1",
            "011",
            "(?:441|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "441$1",
            0,
            "441"
        ],
        "BN": [
            "673",
            "00",
            "[2-578]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-578]"
                    ]
                ]
            ]
        ],
        "BO": [
            "591",
            "00(?:1\\d)?",
            "(?:[2-467]\\d\\d|8001)\\d{5}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "[23]|4[46]"
                    ]
                ],
                [
                    "(\\d{8})",
                    "$1",
                    [
                        "[67]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            "0",
            0,
            "0(1\\d)?"
        ],
        "BQ": [
            "599",
            "00",
            "(?:[34]1|7\\d)\\d{5}",
            [
                7
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "[347]"
        ],
        "BR": [
            "55",
            "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)",
            "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}",
            [
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "300|4(?:0[02]|37)",
                        "4(?:02|37)0|[34]00"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "(?:[358]|90)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{2})(\\d{5})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[16][1-9]|[2-57-9]"
                    ],
                    "($1)"
                ]
            ],
            "0",
            0,
            "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?",
            "$2"
        ],
        "BS": [
            "1",
            "011",
            "(?:242|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([3-8]\\d{6})$|1",
            "242$1",
            0,
            "242"
        ],
        "BT": [
            "975",
            "00",
            "[17]\\d{7}|[2-8]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-68]|7[246]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[67]|7"
                    ]
                ]
            ]
        ],
        "BW": [
            "267",
            "00",
            "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "90"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[24-6]|3[15-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[37]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "BY": [
            "375",
            "810",
            "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "8 $1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "800"
                    ],
                    "8 $1"
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{3})",
                    "$1 $2-$3",
                    [
                        "1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])",
                        "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "1(?:[56]|7[467])|2[1-3]"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[1-4]"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "8 $1"
                ]
            ],
            "8",
            0,
            "0|80?",
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "BZ": [
            "501",
            "00",
            "(?:0800\\d|[2-8])\\d{6}",
            [
                7,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[2-8]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})(\\d{3})",
                    "$1-$2-$3-$4",
                    [
                        "0"
                    ]
                ]
            ]
        ],
        "CA": [
            "1",
            "011",
            "(?:[2-8]\\d|90)\\d{8}|3\\d{6}",
            [
                7,
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "",
                    [
                        10
                    ]
                ],
                [
                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "900[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[125-9]|33|44|66|77|88)|622)[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                [
                    "310\\d{4}",
                    [
                        7
                    ]
                ],
                0,
                [
                    "600[2-9]\\d{6}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "CC": [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",
            [
                6,
                7,
                8,
                9,
                10,
                12
            ],
            0,
            "0",
            0,
            "([59]\\d{7})$|0",
            "8$1",
            0,
            0,
            [
                [
                    "8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}",
                    [
                        9
                    ]
                ],
                [
                    "4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-26-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "180(?:0\\d{3}|2)\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "190[0-26]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                0,
                [
                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                    [
                        9
                    ]
                ],
                [
                    "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                    [
                        6,
                        8,
                        10,
                        12
                    ]
                ]
            ],
            "0011"
        ],
        "CD": [
            "243",
            "00",
            "[189]\\d{8}|[1-68]\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "[1-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "CF": [
            "236",
            "00",
            "(?:[27]\\d{3}|8776)\\d{4}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[278]"
                    ]
                ]
            ]
        ],
        "CG": [
            "242",
            "00",
            "222\\d{6}|(?:0\\d|80)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[02]"
                    ]
                ]
            ]
        ],
        "CH": [
            "41",
            "00",
            "8\\d{11}|[2-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8[047]|90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-79]|81"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "CI": [
            "225",
            "00",
            "[02]\\d{9}",
            [
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d)(\\d{5})",
                    "$1 $2 $3 $4",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ]
            ]
        ],
        "CK": [
            "682",
            "00",
            "[2-578]\\d{4}",
            [
                5
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "[2-578]"
                    ]
                ]
            ]
        ],
        "CL": [
            "56",
            "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0",
            "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}",
            [
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "219",
                        "2196"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "44"
                    ]
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[1-36]"
                    ],
                    "($1)"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9[2-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "60|8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "60"
                    ]
                ]
            ]
        ],
        "CM": [
            "237",
            "00",
            "[26]\\d{8}|88\\d{6,7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "88"
                    ]
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "[26]|88"
                    ]
                ]
            ]
        ],
        "CN": [
            "86",
            "00|1(?:[12]\\d|79)\\d\\d00",
            "1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5,6})",
                    "$1 $2",
                    [
                        "(?:10|2[0-57-9])[19]",
                        "(?:10|2[0-57-9])(?:10|9[56])",
                        "10(?:10|9[56])|2[0-57-9](?:100|9[56])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]",
                        "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]",
                        "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])",
                        "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "(?:4|80)0"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "10|2(?:[02-57-9]|1[1-9])",
                        "10|2(?:[02-57-9]|1[1-9])",
                        "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{7,8})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-578]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1[3-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "[12]"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0",
            0,
            "(1(?:[12]\\d|79)\\d\\d)|0",
            0,
            0,
            0,
            0,
            "00"
        ],
        "CO": [
            "57",
            "00(?:4(?:[14]4|56)|[579])",
            "(?:60\\d\\d|9101)\\d{6}|(?:1\\d|3)\\d{9}",
            [
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "6"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "3[0-357]|91"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{7})",
                    "$1-$2-$3",
                    [
                        "1"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ]
            ],
            "0",
            0,
            "0([3579]|4(?:[14]4|56))?"
        ],
        "CR": [
            "506",
            "00",
            "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-7]|8[3-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[89]"
                    ]
                ]
            ],
            0,
            0,
            "(19(?:0[0-2468]|1[09]|20|66|77|99))"
        ],
        "CU": [
            "53",
            "119",
            "[27]\\d{6,7}|[34]\\d{5,7}|63\\d{6}|(?:5|8\\d\\d)\\d{7}",
            [
                6,
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1 $2",
                    [
                        "2[1-4]|[34]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{6,7})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "[56]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "CV": [
            "238",
            "0",
            "(?:[2-59]\\d\\d|800)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[2-589]"
                    ]
                ]
            ]
        ],
        "CW": [
            "599",
            "00",
            "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[3467]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9[4-8]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            "[69]"
        ],
        "CX": [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",
            [
                6,
                7,
                8,
                9,
                10,
                12
            ],
            0,
            "0",
            0,
            "([59]\\d{7})$|0",
            "8$1",
            0,
            0,
            [
                [
                    "8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}",
                    [
                        9
                    ]
                ],
                [
                    "4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-26-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "180(?:0\\d{3}|2)\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "190[0-26]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                0,
                [
                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                    [
                        9
                    ]
                ],
                [
                    "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                    [
                        6,
                        8,
                        10,
                        12
                    ]
                ]
            ],
            "0011"
        ],
        "CY": [
            "357",
            "00",
            "(?:[279]\\d|[58]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[257-9]"
                    ]
                ]
            ]
        ],
        "CZ": [
            "420",
            "00",
            "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-8]|9[015-7]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "96"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ]
            ]
        ],
        "DE": [
            "49",
            "00",
            "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15
            ],
            [
                [
                    "(\\d{2})(\\d{3,13})",
                    "$1 $2",
                    [
                        "3[02]|40|[68]9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,12})",
                    "$1 $2",
                    [
                        "2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1",
                        "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{2,11})",
                    "$1 $2",
                    [
                        "[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]",
                        "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "138"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{2,10})",
                    "$1 $2",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,11})",
                    "$1 $2",
                    [
                        "181"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{4,10})",
                    "$1 $2 $3",
                    [
                        "1(?:3|80)|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7,8})",
                    "$1 $2",
                    [
                        "1[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7,12})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{6})",
                    "$1 $2",
                    [
                        "185",
                        "1850",
                        "18500"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{7})",
                    "$1 $2",
                    [
                        "18[68]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{6})",
                    "$1 $2",
                    [
                        "15[0568]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{7})",
                    "$1 $2",
                    [
                        "15[1279]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{8})",
                    "$1 $2",
                    [
                        "18"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{7,8})",
                    "$1 $2 $3",
                    [
                        "1(?:6[023]|7)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{7})",
                    "$1 $2 $3",
                    [
                        "15[279]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{8})",
                    "$1 $2 $3",
                    [
                        "15"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "DJ": [
            "253",
            "00",
            "(?:2\\d|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[27]"
                    ]
                ]
            ]
        ],
        "DK": [
            "45",
            "00",
            "[2-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "DM": [
            "1",
            "011",
            "(?:[58]\\d\\d|767|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-7]\\d{6})$|1",
            "767$1",
            0,
            "767"
        ],
        "DO": [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "8001|8[024]9"
        ],
        "DZ": [
            "213",
            "00",
            "(?:[1-4]|[5-79]\\d|80)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-8]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "EC": [
            "593",
            "00",
            "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}",
            [
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[2-7]"
                    ],
                    "(0$1)",
                    0,
                    "$1-$2-$3"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "EE": [
            "372",
            "00",
            "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88",
                        "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3,4})",
                    "$1 $2",
                    [
                        "[45]|8(?:00|[1-49])",
                        "[45]|8(?:00[1-9]|[1-49])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "EG": [
            "20",
            "00",
            "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{7,8})",
                    "$1 $2",
                    [
                        "[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6,7})",
                    "$1 $2",
                    [
                        "1[35]|[4-6]|8[2468]|9[235-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{8})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "EH": [
            "212",
            "00",
            "[5-8]\\d{8}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            "528[89]"
        ],
        "ER": [
            "291",
            "00",
            "[178]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[178]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ES": [
            "34",
            "00",
            "[5-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]00"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-9]"
                    ]
                ]
            ]
        ],
        "ET": [
            "251",
            "00",
            "(?:11|[2-579]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-579]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "FI": [
            "358",
            "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
            "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d)(\\d{4,9})",
                    "$1 $2",
                    [
                        "[2568][1-8]|3(?:0[1-9]|[1-9])|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1 $2",
                    [
                        "[12]00|[368]|70[07-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4,8})",
                    "$1 $2",
                    [
                        "[1245]|7[135]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6,10})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            "1[03-79]|[2-9]",
            0,
            "00"
        ],
        "FJ": [
            "679",
            "0(?:0|52)",
            "45\\d{5}|(?:0800\\d|[235-9])\\d{6}",
            [
                7,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[235-9]|45"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "FK": [
            "500",
            "00",
            "[2-7]\\d{4}",
            [
                5
            ]
        ],
        "FM": [
            "691",
            "00",
            "(?:[39]\\d\\d|820)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[389]"
                    ]
                ]
            ]
        ],
        "FO": [
            "298",
            "00",
            "[2-9]\\d{5}",
            [
                6
            ],
            [
                [
                    "(\\d{6})",
                    "$1",
                    [
                        "[2-9]"
                    ]
                ]
            ],
            0,
            0,
            "(10(?:01|[12]0|88))"
        ],
        "FR": [
            "33",
            "00",
            "[1-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0 $1"
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "[1-79]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GA": [
            "241",
            "00",
            "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "11|[67]"
                    ],
                    "0$1"
                ]
            ],
            0,
            0,
            "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})",
            "$1"
        ],
        "GB": [
            "44",
            "00",
            "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}",
            [
                7,
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "800",
                        "8001",
                        "80011",
                        "800111",
                        "8001111"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "845",
                        "8454",
                        "84546",
                        "845464"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{4,5})",
                    "$1 $2",
                    [
                        "1(?:38|5[23]|69|76|94)",
                        "1(?:(?:38|69)7|5(?:24|39)|768|946)",
                        "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5,6})",
                    "$1 $2",
                    [
                        "1(?:[2-69][02-9]|[78])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[25]|7(?:0|6[02-9])",
                        "[25]|7(?:0|6(?:[03-9]|2[356]))"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1389]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0235])|4(?:[0-5]\\d\\d|69[7-9]|70[0-79])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-2]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}",
                    [
                        9,
                        10
                    ]
                ],
                [
                    "7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "80[08]\\d{7}|800\\d{6}|8001111"
                ],
                [
                    "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "70\\d{8}",
                    [
                        10
                    ]
                ],
                0,
                [
                    "(?:3[0347]|55)\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "56\\d{8}",
                    [
                        10
                    ]
                ]
            ],
            0,
            " x"
        ],
        "GD": [
            "1",
            "011",
            "(?:473|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "473$1",
            0,
            "473"
        ],
        "GE": [
            "995",
            "00",
            "(?:[3-57]\\d\\d|800)\\d{6}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "32"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[57]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[348]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GF": [
            "594",
            "00",
            "[56]94\\d{6}|(?:80|9\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[56]|9[47]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GG": [
            "44",
            "00",
            "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?",
            [
                7,
                9,
                10
            ],
            0,
            "0",
            0,
            "([25-9]\\d{5})$|0",
            "1481$1",
            0,
            0,
            [
                [
                    "1481[25-9]\\d{5}",
                    [
                        10
                    ]
                ],
                [
                    "7(?:(?:781|839)\\d|911[17])\\d{5}",
                    [
                        10
                    ]
                ],
                [
                    "80[08]\\d{7}|800\\d{6}|8001111"
                ],
                [
                    "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "70\\d{8}",
                    [
                        10
                    ]
                ],
                0,
                [
                    "(?:3[0347]|55)\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "56\\d{8}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "GH": [
            "233",
            "00",
            "(?:[235]\\d{3}|800)\\d{5}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[235]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GI": [
            "350",
            "00",
            "(?:[25]\\d|60)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ]
            ]
        ],
        "GL": [
            "299",
            "00",
            "(?:19|[2-689]\\d|70)\\d{4}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "19|[2-9]"
                    ]
                ]
            ]
        ],
        "GM": [
            "220",
            "00",
            "[2-9]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "GN": [
            "224",
            "00",
            "722\\d{6}|(?:3|6\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "3"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[67]"
                    ]
                ]
            ]
        ],
        "GP": [
            "590",
            "00",
            "590\\d{6}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[569]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"
                ],
                [
                    "69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:395|76[018])\\d|475[0-5])\\d{4}"
                ]
            ]
        ],
        "GQ": [
            "240",
            "00",
            "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[235]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[89]"
                    ]
                ]
            ]
        ],
        "GR": [
            "30",
            "00",
            "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}",
            [
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "21|7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2689]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "GT": [
            "502",
            "00",
            "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}",
            [
                8,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-8]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ]
        ],
        "GU": [
            "1",
            "011",
            "(?:[58]\\d\\d|671|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "671$1",
            0,
            "671"
        ],
        "GW": [
            "245",
            "00",
            "[49]\\d{8}|4\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "40"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ]
                ]
            ]
        ],
        "GY": [
            "592",
            "001",
            "(?:[2-8]\\d{3}|9008)\\d{3}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "HK": [
            "852",
            "00(?:30|5[09]|[126-9]?)",
            "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}",
            [
                5,
                6,
                7,
                8,
                9,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{2,5})",
                    "$1 $2",
                    [
                        "900",
                        "9003"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "HN": [
            "504",
            "00",
            "8\\d{10}|[237-9]\\d{7}",
            [
                8,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "[237-9]"
                    ]
                ]
            ]
        ],
        "HR": [
            "385",
            "00",
            "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "6[01]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-5]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "HT": [
            "509",
            "00",
            "(?:[2-489]\\d|55)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-589]"
                    ]
                ]
            ]
        ],
        "HU": [
            "36",
            "00",
            "[235-7]\\d{8}|[1-9]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "(06 $1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"
                    ],
                    "(06 $1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ],
                    "06 $1"
                ]
            ],
            "06"
        ],
        "ID": [
            "62",
            "00[89]",
            "(?:(?:00[1-9]|8\\d)\\d{4}|[1-36])\\d{6}|00\\d{10}|[1-9]\\d{8,10}|[2-9]\\d{7}",
            [
                7,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "15"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5,9})",
                    "$1 $2",
                    [
                        "2[124]|[36]1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5,7})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,8})",
                    "$1 $2",
                    [
                        "[2-79]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "8[1-35-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6,8})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "804"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "80"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1-$2-$3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IE": [
            "353",
            "00",
            "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "2[24-9]|47|58|6[237-9]|9[35-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[45]0"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2569]|4[1-69]|7[14]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "81"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "4"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IL": [
            "972",
            "0(?:0|1[2-9])",
            "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{4})(\\d{3})",
                    "$1-$2",
                    [
                        "125"
                    ]
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{2})",
                    "$1-$2-$3",
                    [
                        "121"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[2-489]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[57]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "12"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1-$2",
                    [
                        "159"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{3})",
                    "$1-$2-$3-$4",
                    [
                        "1[7-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})",
                    "$1-$2 $3-$4",
                    [
                        "15"
                    ]
                ]
            ],
            "0"
        ],
        "IM": [
            "44",
            "00",
            "1624\\d{6}|(?:[3578]\\d|90)\\d{8}",
            [
                10
            ],
            0,
            "0",
            0,
            "([25-8]\\d{5})$|0",
            "1624$1",
            0,
            "74576|(?:16|7[56])24"
        ],
        "IN": [
            "91",
            "00",
            "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}",
            [
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d{8})",
                    "$1",
                    [
                        "5(?:0|2[23]|3[03]|[67]1|88)",
                        "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)",
                        "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{4})(\\d{4,5})",
                    "$1 $2",
                    [
                        "180",
                        "1800"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "140"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "11|2[02]|33|4[04]|79[1-7]|80[2-46]",
                        "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])",
                        "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]",
                        "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]",
                        "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807",
                        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]",
                        "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "[6-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{2,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1(?:6|8[06])",
                        "1(?:6|8[06]0)"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "18"
                    ],
                    0,
                    1
                ]
            ],
            "0"
        ],
        "IO": [
            "246",
            "00",
            "3\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "3"
                    ]
                ]
            ]
        ],
        "IQ": [
            "964",
            "00",
            "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IR": [
            "98",
            "00",
            "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}",
            [
                4,
                5,
                6,
                7,
                10
            ],
            [
                [
                    "(\\d{4,5})",
                    "$1",
                    [
                        "96"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4,5})",
                    "$1 $2",
                    [
                        "(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-8]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IS": [
            "354",
            "00|1(?:0(?:01|[12]0)|100)",
            "(?:38\\d|[4-9])\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[4-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "3"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "IT": [
            "39",
            "00",
            "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1 $2",
                    [
                        "0[26]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,6})",
                    "$1 $2",
                    [
                        "0[13-57-9][0159]|8(?:03|4[17]|9[2-5])",
                        "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"
                    ]
                ],
                [
                    "(\\d{4})(\\d{2,6})",
                    "$1 $2",
                    [
                        "0(?:[13-579][2-46-8]|8[236-8])"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "894"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0[26]|5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "1(?:44|[679])|[378]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0[13-57-9][0159]|14"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "0[26]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "3"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}"
                ],
                [
                    "3[1-9]\\d{8}|3[2-9]\\d{7}",
                    [
                        9,
                        10
                    ]
                ],
                [
                    "80(?:0\\d{3}|3)\\d{3}",
                    [
                        6,
                        9
                    ]
                ],
                [
                    "(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}",
                    [
                        6,
                        8,
                        9,
                        10
                    ]
                ],
                [
                    "1(?:78\\d|99)\\d{6}",
                    [
                        9,
                        10
                    ]
                ],
                0,
                0,
                0,
                [
                    "55\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "84(?:[08]\\d{3}|[17])\\d{3}",
                    [
                        6,
                        9
                    ]
                ]
            ]
        ],
        "JE": [
            "44",
            "00",
            "1534\\d{6}|(?:[3578]\\d|90)\\d{8}",
            [
                10
            ],
            0,
            "0",
            0,
            "([0-24-8]\\d{5})$|0",
            "1534$1",
            0,
            0,
            [
                [
                    "1534[0-24-8]\\d{5}"
                ],
                [
                    "7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97[7-9]))\\d{5}"
                ],
                [
                    "80(?:07(?:35|81)|8901)\\d{4}"
                ],
                [
                    "(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"
                ],
                [
                    "701511\\d{4}"
                ],
                0,
                [
                    "(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"
                ],
                [
                    "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"
                ],
                [
                    "56\\d{8}"
                ]
            ]
        ],
        "JM": [
            "1",
            "011",
            "(?:[58]\\d\\d|658|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "658|876"
        ],
        "JO": [
            "962",
            "00",
            "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2356]|87"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "JP": [
            "81",
            "010",
            "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}",
            [
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15,
                16,
                17
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "(?:12|57|99)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d)(\\d{4})",
                    "$1-$2-$3",
                    [
                        "1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])",
                        "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]",
                        "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "60"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[36]|4(?:2[09]|7[01])",
                        "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])",
                        "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]",
                        "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[14]|[289][2-9]|5[3-9]|7[2-4679]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[257-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "(000[259]\\d{6})$|(?:(?:003768)0?)|0",
            "$1"
        ],
        "KE": [
            "254",
            "000",
            "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5,7})",
                    "$1 $2",
                    [
                        "[24-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[17]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "KG": [
            "996",
            "00",
            "8\\d{9}|[235-9]\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "3(?:1[346]|[24-79])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[235-79]|88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d)(\\d{2,3})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "KH": [
            "855",
            "00[14-9]",
            "1\\d{9}|[1-9]\\d{7,8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "KI": [
            "686",
            "00",
            "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}",
            [
                5,
                8
            ],
            0,
            "0"
        ],
        "KM": [
            "269",
            "00",
            "[3478]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[3478]"
                    ]
                ]
            ]
        ],
        "KN": [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-7]\\d{6})$|1",
            "869$1",
            0,
            "869"
        ],
        "KP": [
            "850",
            "00|99",
            "85\\d{6}|(?:19\\d|[2-7])\\d{7}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "KR": [
            "82",
            "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))",
            "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}",
            [
                5,
                6,
                8,
                9,
                10,
                11,
                12,
                13,
                14
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1-$2",
                    [
                        "(?:3[1-3]|[46][1-4]|5[1-5])1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "60|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[1346]|5[1-5]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[57]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "0(8(?:[1-46-8]|5\\d\\d))?"
        ],
        "KW": [
            "965",
            "00",
            "18\\d{5}|(?:[2569]\\d|41)\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{4})(\\d{3,4})",
                    "$1 $2",
                    [
                        "[169]|2(?:[235]|4[1-35-9])|52"
                    ]
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[245]"
                    ]
                ]
            ]
        ],
        "KY": [
            "1",
            "011",
            "(?:345|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "345$1",
            0,
            "345"
        ],
        "KZ": [
            "7",
            "810",
            "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}",
            [
                10,
                14
            ],
            0,
            "8",
            0,
            0,
            0,
            0,
            "33|7",
            0,
            "8~10"
        ],
        "LA": [
            "856",
            "00",
            "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2[13]|3[14]|[4-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "30[013-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[23]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "LB": [
            "961",
            "00",
            "[27-9]\\d{7}|[13-9]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[27-9]"
                    ]
                ]
            ],
            "0"
        ],
        "LC": [
            "1",
            "011",
            "(?:[58]\\d\\d|758|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-8]\\d{6})$|1",
            "758$1",
            0,
            "758"
        ],
        "LI": [
            "423",
            "00",
            "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[2379]|8(?:0[09]|7)",
                        "[2379]|8(?:0(?:02|9)|7)"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "69"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ],
            "0",
            0,
            "(1001)|0"
        ],
        "LK": [
            "94",
            "00",
            "[1-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[1-689]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "LR": [
            "231",
            "00",
            "(?:[25]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[4-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[23578]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "LS": [
            "266",
            "00",
            "(?:[256]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2568]"
                    ]
                ]
            ]
        ],
        "LT": [
            "370",
            "00",
            "(?:[3469]\\d|52|[78]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "52[0-7]"
                    ],
                    "(8-$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "8 $1",
                    1
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "37|4(?:[15]|6[1-8])"
                    ],
                    "(8-$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[3-6]"
                    ],
                    "(8-$1)",
                    1
                ]
            ],
            "8",
            0,
            "[08]"
        ],
        "LU": [
            "352",
            "00",
            "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "20[2-689]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
                    "$1 $2 $3 $4",
                    [
                        "2(?:[0367]|4[3-8])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "80[01]|90[015]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "20"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "2(?:[0367]|4[3-8])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})",
                    "$1 $2 $3 $4",
                    [
                        "[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"
                    ]
                ]
            ],
            0,
            0,
            "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"
        ],
        "LV": [
            "371",
            "00",
            "(?:[268]\\d|90)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[269]|8[01]"
                    ]
                ]
            ]
        ],
        "LY": [
            "218",
            "00",
            "[2-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{7})",
                    "$1-$2",
                    [
                        "[2-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MA": [
            "212",
            "00",
            "[5-8]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "5[45]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1-$2",
                    [
                        "5(?:2[2-489]|3[5-9]|9)|8(?:0[89]|92)",
                        "5(?:2(?:[2-49]|8[235-9])|3[5-9]|9)|8(?:0[89]|92)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1-$2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1-$2",
                    [
                        "[5-7]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"
                ],
                [
                    "(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-2]|5[01]|8[0-3]))\\d{6}"
                ],
                [
                    "80[0-7]\\d{6}"
                ],
                [
                    "89\\d{7}"
                ],
                0,
                0,
                0,
                0,
                [
                    "(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"
                ]
            ]
        ],
        "MC": [
            "377",
            "00",
            "(?:[3489]|6\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[389]"
                    ]
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MD": [
            "373",
            "00",
            "(?:[235-7]\\d|[89]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "22|3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[25-7]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ME": [
            "382",
            "00",
            "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MF": [
            "590",
            "00",
            "590\\d{6}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"
                ],
                [
                    "69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:395|76[018])\\d|475[0-5])\\d{4}"
                ]
            ]
        ],
        "MG": [
            "261",
            "00",
            "[23]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[23]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "([24-9]\\d{6})$|0",
            "20$1"
        ],
        "MH": [
            "692",
            "011",
            "329\\d{4}|(?:[256]\\d|45)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[2-6]"
                    ]
                ]
            ],
            "1"
        ],
        "MK": [
            "389",
            "00",
            "[2-578]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2|34[47]|4(?:[37]7|5[47]|64)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[347]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[58]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ML": [
            "223",
            "00",
            "[24-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24-9]"
                    ]
                ]
            ]
        ],
        "MM": [
            "95",
            "00",
            "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "16|2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[12]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[4-7]|8[1-35]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4,6})",
                    "$1 $2 $3",
                    [
                        "9(?:2[0-4]|[35-9]|4[137-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "92"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{5})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MN": [
            "976",
            "001",
            "[12]\\d{7,9}|[5-9]\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[12]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[5-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[12]2[1-3]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[12](?:27|3[2-8]|4[2-68]|5[1-4689])",
                        "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{4,5})",
                    "$1 $2",
                    [
                        "[12]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MO": [
            "853",
            "00",
            "0800\\d{3}|(?:28|[68]\\d)\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{4})(\\d{3})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[268]"
                    ]
                ]
            ]
        ],
        "MP": [
            "1",
            "011",
            "[58]\\d{9}|(?:67|90)0\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "670$1",
            0,
            "670"
        ],
        "MQ": [
            "596",
            "00",
            "596\\d{6}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[569]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MR": [
            "222",
            "00",
            "(?:[2-4]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-48]"
                    ]
                ]
            ]
        ],
        "MS": [
            "1",
            "011",
            "(?:[58]\\d\\d|664|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([34]\\d{6})$|1",
            "664$1",
            0,
            "664"
        ],
        "MT": [
            "356",
            "00",
            "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2357-9]"
                    ]
                ]
            ]
        ],
        "MU": [
            "230",
            "0(?:0|[24-7]0|3[03])",
            "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-46]|8[013]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[57]"
                    ]
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "8"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "020"
        ],
        "MV": [
            "960",
            "0(?:0|19)",
            "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}",
            [
                7,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[34679]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "MW": [
            "265",
            "00",
            "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1[2-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[137-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MX": [
            "52",
            "0[09]",
            "1(?:(?:[27]2|44|87|99)[1-9]|65[0-689])\\d{7}|(?:1(?:[01]\\d|2[13-9]|[35][1-9]|4[0-35-9]|6[0-46-9]|7[013-9]|8[1-69]|9[1-8])|[2-9]\\d)\\d{8}",
            [
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "33|5[56]|81"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d)(\\d{2})(\\d{4})(\\d{4})",
                    "$2 $3 $4",
                    [
                        "1(?:33|5[56]|81)"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{4})",
                    "$2 $3 $4",
                    [
                        "1"
                    ],
                    0,
                    1
                ]
            ],
            "01",
            0,
            "0(?:[12]|4[45])|1",
            0,
            0,
            0,
            0,
            "00"
        ],
        "MY": [
            "60",
            "00",
            "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "[4-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1-$2 $3",
                    [
                        "1(?:[02469]|[378][1-9]|53)|8",
                        "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{4})",
                    "$1-$2-$3-$4",
                    [
                        "1(?:[367]|80)"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "15"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MZ": [
            "258",
            "00",
            "(?:2|8\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2|8[2-79]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "NA": [
            "264",
            "00",
            "[68]\\d{7,8}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "87"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "NC": [
            "687",
            "00",
            "(?:050|[2-57-9]\\d\\d)\\d{3}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1.$2.$3",
                    [
                        "[02-57-9]"
                    ]
                ]
            ]
        ],
        "NE": [
            "227",
            "00",
            "[027-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "08"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[089]|2[013]|7[047]"
                    ]
                ]
            ]
        ],
        "NF": [
            "672",
            "00",
            "[13]\\d{5}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "1[0-3]"
                    ]
                ],
                [
                    "(\\d)(\\d{5})",
                    "$1 $2",
                    [
                        "[13]"
                    ]
                ]
            ],
            0,
            0,
            "([0-258]\\d{4})$",
            "3$1"
        ],
        "NG": [
            "234",
            "009",
            "(?:[124-7]|9\\d{3})\\d{6}|[1-9]\\d{7}|[78]\\d{9,13}",
            [
                7,
                8,
                10,
                11,
                12,
                13,
                14
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "78"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[12]|9(?:0[3-9]|[1-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[3-7]|8[2-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})(\\d{5,6})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "NI": [
            "505",
            "00",
            "(?:1800|[25-8]\\d{3})\\d{4}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[125-8]"
                    ]
                ]
            ]
        ],
        "NL": [
            "31",
            "00",
            "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4,7})",
                    "$1 $2",
                    [
                        "[89]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "66"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{8})",
                    "$1 $2",
                    [
                        "6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-578]|91"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "NO": [
            "47",
            "00",
            "(?:0|[2-9]\\d{3})\\d{4}",
            [
                5,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-79]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            "[02-689]|7[0-8]"
        ],
        "NP": [
            "977",
            "00",
            "(?:1\\d|9)\\d{9}|[1-9]\\d{7}",
            [
                8,
                10,
                11
            ],
            [
                [
                    "(\\d)(\\d{7})",
                    "$1-$2",
                    [
                        "1[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1-$2",
                    [
                        "1[01]|[2-8]|9(?:[1-59]|[67][2-6])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1-$2",
                    [
                        "9"
                    ]
                ]
            ],
            "0"
        ],
        "NR": [
            "674",
            "00",
            "(?:444|(?:55|8\\d)\\d|666)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[4-68]"
                    ]
                ]
            ]
        ],
        "NU": [
            "683",
            "00",
            "(?:[4-7]|888\\d)\\d{3}",
            [
                4,
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "NZ": [
            "64",
            "0(?:0|161)",
            "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3,8})",
                    "$1 $2",
                    [
                        "8[1-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "50[036-8]|8|90",
                        "50(?:[0367]|88)|8|90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "24|[346]|7[2-57-9]|9[2-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2(?:10|74)|[589]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1|2[028]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,5})",
                    "$1 $2 $3",
                    [
                        "2(?:[169]|7[0-35-9])|7"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "OM": [
            "968",
            "00",
            "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4,6})",
                    "$1 $2",
                    [
                        "[58]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[179]"
                    ]
                ]
            ]
        ],
        "PA": [
            "507",
            "00",
            "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}",
            [
                7,
                8,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[1-57-9]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "[68]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "PE": [
            "51",
            "00|19(?:1[124]|77|90)00",
            "(?:[14-8]|9\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[4-8]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00",
            " Anexo "
        ],
        "PF": [
            "689",
            "00",
            "4\\d{5}(?:\\d{2})?|8\\d{7,8}",
            [
                6,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "44"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "4|8[7-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "PG": [
            "675",
            "00|140[1-3]",
            "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "18|[2-69]|85"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[78]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "PH": [
            "63",
            "00",
            "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}",
            [
                6,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d)(\\d{5})",
                    "$1 $2",
                    [
                        "2"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{4})(\\d{4,6})",
                    "$1 $2",
                    [
                        "3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2",
                        "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "346|4(?:27|9[35])|883",
                        "3469|4(?:279|9(?:30|56))|8834"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-7]|8[2-8]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "PK": [
            "92",
            "00",
            "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}",
            [
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{2,7})",
                    "$1 $2 $3",
                    [
                        "[89]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6,7})",
                    "$1 $2",
                    [
                        "2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])",
                        "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{7,8})",
                    "$1 $2",
                    [
                        "(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "58"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[24-9]"
                    ],
                    "(0$1)"
                ]
            ],
            "0"
        ],
        "PL": [
            "48",
            "00",
            "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{5})",
                    "$1",
                    [
                        "19"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "11|20|64"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1",
                        "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "64"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[2-8]|[2-7]|8[1-79]|9[145]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "PM": [
            "508",
            "00",
            "[45]\\d{5}|(?:708|80\\d)\\d{6}",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[45]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "PR": [
            "1",
            "011",
            "(?:[589]\\d\\d|787)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "787|939"
        ],
        "PS": [
            "970",
            "00",
            "[2489]2\\d{6}|(?:1\\d|5)\\d{8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2489]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "PT": [
            "351",
            "00",
            "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[12]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "16|[236-9]"
                    ]
                ]
            ]
        ],
        "PW": [
            "680",
            "01[12]",
            "(?:[24-8]\\d\\d|345|900)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "PY": [
            "595",
            "00",
            "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3,6})",
                    "$1 $2",
                    [
                        "[2-9]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{4,5})",
                    "$1 $2",
                    [
                        "2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "87"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "9(?:[5-79]|8[1-6])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ]
                ]
            ],
            "0"
        ],
        "QA": [
            "974",
            "00",
            "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}",
            [
                7,
                8,
                9,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "2[16]|8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[3-7]"
                    ]
                ]
            ]
        ],
        "RE": [
            "262",
            "00",
            "(?:26|[689]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2689]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}"
                ],
                [
                    "69(?:2\\d\\d|3(?:[06][0-6]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))\\d{4}"
                ],
                [
                    "80\\d{7}"
                ],
                [
                    "89[1-37-9]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                [
                    "9(?:399[0-3]|479[0-5]|76(?:2[27]|3[0-37]))\\d{4}"
                ],
                [
                    "8(?:1[019]|2[0156]|84|90)\\d{6}"
                ]
            ]
        ],
        "RO": [
            "40",
            "00",
            "(?:[2378]\\d|62|90)\\d{7}|[23]\\d{5}",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "2[3-6]",
                        "2[3-6]\\d9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "219|31"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[23]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[236-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            " int "
        ],
        "RS": [
            "381",
            "00",
            "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}",
            [
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3,9})",
                    "$1 $2",
                    [
                        "(?:2[389]|39)0|[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5,10})",
                    "$1 $2",
                    [
                        "[1-36]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "RU": [
            "7",
            "810",
            "8\\d{13}|[347-9]\\d{9}",
            [
                10,
                14
            ],
            [
                [
                    "(\\d{4})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "7(?:1[0-8]|2[1-9])",
                        "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))",
                        "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{5})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "7(?:1[0-68]|2[1-9])",
                        "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))",
                        "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[349]|8(?:[02-7]|1[1-8])"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "8 ($1)"
                ]
            ],
            "8",
            0,
            0,
            0,
            0,
            "3[04-689]|[489]",
            0,
            "8~10"
        ],
        "RW": [
            "250",
            "00",
            "(?:06|[27]\\d\\d|[89]00)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "SA": [
            "966",
            "00",
            "92\\d{7}|(?:[15]|8\\d)\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "81"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            "0"
        ],
        "SB": [
            "677",
            "0[01]",
            "(?:[1-6]|[7-9]\\d\\d)\\d{4}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "7|8[4-9]|9(?:[1-8]|9[0-8])"
                    ]
                ]
            ]
        ],
        "SC": [
            "248",
            "010|0[0-2]",
            "800\\d{4}|(?:[249]\\d|64)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[246]|9[57]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "SD": [
            "249",
            "00",
            "[19]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[19]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "SE": [
            "46",
            "00",
            "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2,3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "20"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "9(?:00|39|44|9)"
                    ],
                    "0$1",
                    0,
                    "$1 $2"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "[12][136]|3[356]|4[0246]|6[03]|90[1-9]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d)(\\d{2,3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{3})",
                    "$1-$2 $3",
                    [
                        "9(?:00|39|44)"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "10|7"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{3})",
                    "$1-$2 $3 $4",
                    [
                        "9"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4 $5",
                    [
                        "[26]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4 $5"
                ]
            ],
            "0"
        ],
        "SG": [
            "65",
            "0[0-3]\\d",
            "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}",
            [
                8,
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[369]|8(?:0[1-8]|[1-9])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ]
        ],
        "SH": [
            "290",
            "00",
            "(?:[256]\\d|8)\\d{3}",
            [
                4,
                5
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "[256]"
        ],
        "SI": [
            "386",
            "00|10(?:22|66|88|99)",
            "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}",
            [
                5,
                6,
                7,
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3,6})",
                    "$1 $2",
                    [
                        "8[09]|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "59|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[37][01]|4[0139]|51|6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[1-57]"
                    ],
                    "(0$1)"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "SJ": [
            "47",
            "00",
            "0\\d{4}|(?:[489]\\d|79)\\d{6}",
            [
                5,
                8
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "79"
        ],
        "SK": [
            "421",
            "00",
            "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}",
            [
                6,
                7,
                9
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "21"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[3-5][1-8]1",
                        "[3-5][1-8]1[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                    "$1/$2 $3 $4",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[689]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1/$2 $3 $4",
                    [
                        "[3-5]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "SL": [
            "232",
            "00",
            "(?:[237-9]\\d|66)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[236-9]"
                    ],
                    "(0$1)"
                ]
            ],
            "0"
        ],
        "SM": [
            "378",
            "00",
            "(?:0549|[5-7]\\d)\\d{6}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-7]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ]
            ],
            0,
            0,
            "([89]\\d{5})$",
            "0549$1"
        ],
        "SN": [
            "221",
            "00",
            "(?:[378]\\d|93)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[379]"
                    ]
                ]
            ]
        ],
        "SO": [
            "252",
            "00",
            "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "8[125]"
                    ]
                ],
                [
                    "(\\d{6})",
                    "$1",
                    [
                        "[134]"
                    ]
                ],
                [
                    "(\\d)(\\d{6})",
                    "$1 $2",
                    [
                        "[15]|2[0-79]|3[0-46-8]|4[0-7]"
                    ]
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "(?:2|90)4|[67]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[348]|64|79|90"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5,7})",
                    "$1 $2",
                    [
                        "1|28|6[0-35-9]|77|9[2-9]"
                    ]
                ]
            ],
            "0"
        ],
        "SR": [
            "597",
            "00",
            "(?:[2-5]|68|[78]\\d)\\d{5}",
            [
                6,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1-$2-$3",
                    [
                        "56"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})",
                    "$1-$2",
                    [
                        "[2-5]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[6-8]"
                    ]
                ]
            ]
        ],
        "SS": [
            "211",
            "00",
            "[19]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[19]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ST": [
            "239",
            "00",
            "(?:22|9\\d)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[29]"
                    ]
                ]
            ]
        ],
        "SV": [
            "503",
            "00",
            "[267]\\d{7}|[89]00\\d{4}(?:\\d{4})?",
            [
                7,
                8,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[89]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[267]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ]
                ]
            ]
        ],
        "SX": [
            "1",
            "011",
            "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "(5\\d{6})$|1",
            "721$1",
            0,
            "721"
        ],
        "SY": [
            "963",
            "00",
            "[1-39]\\d{8}|[1-5]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-5]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0"
        ],
        "SZ": [
            "268",
            "00",
            "0800\\d{4}|(?:[237]\\d|900)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[0237]"
                    ]
                ],
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ]
            ]
        ],
        "TA": [
            "290",
            "00",
            "8\\d{3}",
            [
                4
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "8"
        ],
        "TC": [
            "1",
            "011",
            "(?:[58]\\d\\d|649|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-479]\\d{6})$|1",
            "649$1",
            0,
            "649"
        ],
        "TD": [
            "235",
            "00|16",
            "(?:22|[69]\\d|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2679]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "TG": [
            "228",
            "00",
            "[279]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[279]"
                    ]
                ]
            ]
        ],
        "TH": [
            "66",
            "00[1-9]",
            "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}",
            [
                8,
                9,
                10,
                13
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[13-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "TJ": [
            "992",
            "810",
            "[0-57-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{6})(\\d)(\\d{2})",
                    "$1 $2 $3",
                    [
                        "331",
                        "3317"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "44[02-479]|[34]7"
                    ]
                ],
                [
                    "(\\d{4})(\\d)(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3[1-5]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[0-57-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "TK": [
            "690",
            "00",
            "[2-47]\\d{3,6}",
            [
                4,
                5,
                6,
                7
            ]
        ],
        "TL": [
            "670",
            "00",
            "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-489]|70"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ]
        ],
        "TM": [
            "993",
            "810",
            "[1-6]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "12"
                    ],
                    "(8 $1)"
                ],
                [
                    "(\\d{3})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[1-5]"
                    ],
                    "(8 $1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "6"
                    ],
                    "8 $1"
                ]
            ],
            "8",
            0,
            0,
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "TN": [
            "216",
            "00",
            "[2-57-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-57-9]"
                    ]
                ]
            ]
        ],
        "TO": [
            "676",
            "00",
            "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1-$2",
                    [
                        "[2-4]|50|6[09]|7[0-24-69]|8[05]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[5-9]"
                    ]
                ]
            ]
        ],
        "TR": [
            "90",
            "00",
            "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}",
            [
                7,
                10,
                12,
                13
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "512|8[01589]|90"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "5(?:[0-59]|61)",
                        "5(?:[0-59]|61[06])",
                        "5(?:[0-59]|61[06]1)"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24][1-8]|3[1-9]"
                    ],
                    "(0$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{6,7})",
                    "$1 $2 $3",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0"
        ],
        "TT": [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-46-8]\\d{6})$|1",
            "868$1",
            0,
            "868"
        ],
        "TV": [
            "688",
            "00",
            "(?:2|7\\d\\d|90)\\d{4}",
            [
                5,
                6,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "90"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ]
        ],
        "TW": [
            "886",
            "0(?:0[25-79]|19)",
            "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}",
            [
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d)(\\d{4})",
                    "$1 $2 $3",
                    [
                        "202"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[258]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]",
                        "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "#"
        ],
        "TZ": [
            "255",
            "00[056]",
            "(?:[25-8]\\d|41|90)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[24]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[67]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "UA": [
            "380",
            "00",
            "[89]\\d{9}|[3-9]\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]",
                        "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])",
                        "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-7]|89|9[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "0~0"
        ],
        "UG": [
            "256",
            "00[057]",
            "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "202",
                        "2024"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[27-9]|4(?:6[45]|[7-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "[34]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "US": [
            "1",
            "011",
            "[2-9]\\d{9}|3\\d{6}",
            [
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "310"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "($1) $2-$3",
                    [
                        "[2-9]"
                    ],
                    0,
                    1,
                    "$1-$2-$3"
                ]
            ],
            "1",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:5056(?:[0-35-9]\\d|4[468])|73020\\d)\\d{4}|(?:4722|505[2-57-9]|983[289])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[013569]|3[0-24679]|4[167]|5[0-2]|6[0149]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"
                ],
                [
                    ""
                ],
                [
                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"
                ],
                [
                    "900[2-9]\\d{6}"
                ],
                [
                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"
                ]
            ]
        ],
        "UY": [
            "598",
            "0(?:0|1[3-9]\\d)",
            "0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}",
            [
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d{3})(\\d{3,4})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[49]0|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[124]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00",
            " int. "
        ],
        "UZ": [
            "998",
            "810",
            "(?:20|33|[5-79]\\d|88)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[235-9]"
                    ],
                    "8 $1"
                ]
            ],
            "8",
            0,
            0,
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "VA": [
            "39",
            "00",
            "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "06698"
        ],
        "VC": [
            "1",
            "011",
            "(?:[58]\\d\\d|784|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-7]\\d{6})$|1",
            "784$1",
            0,
            "784"
        ],
        "VE": [
            "58",
            "00",
            "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}",
            [
                10
            ],
            [
                [
                    "(\\d{3})(\\d{7})",
                    "$1-$2",
                    [
                        "[24-689]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "VG": [
            "1",
            "011",
            "(?:284|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-578]\\d{6})$|1",
            "284$1",
            0,
            "284"
        ],
        "VI": [
            "1",
            "011",
            "[58]\\d{9}|(?:34|90)0\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "340$1",
            0,
            "340"
        ],
        "VN": [
            "84",
            "00",
            "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{4,6})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "6"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[357-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[48]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0"
        ],
        "VU": [
            "678",
            "00",
            "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[57-9]"
                    ]
                ]
            ]
        ],
        "WF": [
            "681",
            "00",
            "(?:40|72)\\d{4}|8\\d{5}(?:\\d{3})?",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[478]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "WS": [
            "685",
            "0",
            "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}",
            [
                5,
                6,
                7,
                10
            ],
            [
                [
                    "(\\d{5})",
                    "$1",
                    [
                        "[2-5]|6[1-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1 $2",
                    [
                        "[68]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ]
        ],
        "XK": [
            "383",
            "00",
            "[23]\\d{7,8}|(?:4\\d\\d|[89]00)\\d{5}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[23]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "YE": [
            "967",
            "00",
            "(?:1|7\\d)\\d{7}|[1-7]\\d{6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-6]|7(?:[24-6]|8[0-7])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "YT": [
            "262",
            "00",
            "(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "269(?:0[0-467]|5[0-4]|6\\d|[78]0)\\d{4}"
                ],
                [
                    "639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])\\d{4}"
                ],
                [
                    "80\\d{7}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:39|47)8[01]|769\\d)\\d{4}"
                ]
            ]
        ],
        "ZA": [
            "27",
            "00",
            "[1-79]\\d{8}|8\\d{4,9}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1 $2",
                    [
                        "8[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "8[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "860"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ZM": [
            "260",
            "00",
            "800\\d{6}|(?:21|63|[79]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[28]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "[79]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ZW": [
            "263",
            "00",
            "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{3,5})",
                    "$1 $2",
                    [
                        "2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2",
                        "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)",
                        "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,5})",
                    "$1 $2",
                    [
                        "1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "29[013-9]|39|54"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,5})",
                    "$1 $2",
                    [
                        "(?:25|54)8",
                        "258|5483"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ]
    },
    "nonGeographic": {
        "800": [
            "800",
            0,
            "(?:00|[1-9]\\d)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "\\d"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                [
                    "(?:00|[1-9]\\d)\\d{6}"
                ]
            ]
        ],
        "808": [
            "808",
            0,
            "[1-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[1-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "[1-9]\\d{7}"
                ]
            ]
        ],
        "870": [
            "870",
            0,
            "7\\d{11}|[35-7]\\d{8}",
            [
                9,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[35-7]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"
                ]
            ]
        ],
        "878": [
            "878",
            0,
            "10\\d{10}",
            [
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "10\\d{10}"
                ]
            ]
        ],
        "881": [
            "881",
            0,
            "6\\d{9}|[0-36-9]\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[0-37-9]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{5,6})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "6\\d{9}|[0-36-9]\\d{8}"
                ]
            ]
        ],
        "882": [
            "882",
            0,
            "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "16|342"
                    ]
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "49"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1[36]|9"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "3[23]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "16"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "10|23|3(?:[15]|4[57])|4|51"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "34"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4,5})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[1-35]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}",
                    [
                        7,
                        8,
                        9,
                        10,
                        12
                    ]
                ],
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"
                ]
            ]
        ],
        "883": [
            "883",
            0,
            "(?:[1-4]\\d|51)\\d{6,10}",
            [
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{2,8})",
                    "$1 $2 $3",
                    [
                        "[14]|2[24-689]|3[02-689]|51[24-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "510"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "21"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "51[13]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[235]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"
                ]
            ]
        ],
        "888": [
            "888",
            0,
            "\\d{11}",
            [
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1 $2 $3"
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "\\d{11}"
                ]
            ]
        ],
        "979": [
            "979",
            0,
            "[1359]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1359]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                [
                    "[1359]\\d{8}"
                ]
            ]
        ]
    }
};


function $58067136b6929952$export$2e2bcd8739ae039(func, _arguments) {
    var args = Array.prototype.slice.call(_arguments);
    args.push((0, $051d22eb5cab544f$export$2e2bcd8739ae039));
    return func.apply(this, args);
}


// This is a port of Google Android `libphonenumber`'s
// `phonenumberutil.js` of December 31th, 2018.
//
// https://github.com/googlei18n/libphonenumber/commits/master/javascript/i18n/phonenumbers/phonenumberutil.js
// The minimum length of the national significant number.
var $37eb819a63618324$export$cd8355bcbe13154 = 2; // The ITU says the maximum length should be 15,
var $37eb819a63618324$export$85ddd8c9b243679b = 17; // The maximum length of the country calling code.
var $37eb819a63618324$export$514717690676fb4a = 3; // Digits accepted in phone numbers
var $37eb819a63618324$export$852d1d4a47329634 = "0-9０-９٠-٩۰-۹"; // `DASHES` will be right after the opening square bracket of the "character class"
var $37eb819a63618324$var$DASHES = "-‐-―−ー－";
var $37eb819a63618324$var$SLASHES = "／/";
var $37eb819a63618324$var$DOTS = "．.";
var $37eb819a63618324$export$20542845033f576e = " \xa0\xad​⁠　";
var $37eb819a63618324$var$BRACKETS = "()（）［］\\[\\]"; // export const OPENING_BRACKETS = '(\uFF08\uFF3B\\\['
var $37eb819a63618324$var$TILDES = "~⁓∼～"; // Regular expression of acceptable punctuation found in phone numbers. This
var $37eb819a63618324$export$7f01587e28f9194 = "".concat($37eb819a63618324$var$DASHES).concat($37eb819a63618324$var$SLASHES).concat($37eb819a63618324$var$DOTS).concat($37eb819a63618324$export$20542845033f576e).concat($37eb819a63618324$var$BRACKETS).concat($37eb819a63618324$var$TILDES);
var $37eb819a63618324$export$207c99ccf3902df8 = "+＋"; // const LEADING_PLUS_CHARS_PATTERN = new RegExp('^[' + PLUS_CHARS + ']+')


function $f05781b554dcd2cc$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $f05781b554dcd2cc$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $f05781b554dcd2cc$var$_typeof(obj);
}
function $f05781b554dcd2cc$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $f05781b554dcd2cc$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $f05781b554dcd2cc$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $f05781b554dcd2cc$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $f05781b554dcd2cc$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $f05781b554dcd2cc$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $f05781b554dcd2cc$var$_setPrototypeOf(subClass, superClass);
}
function $f05781b554dcd2cc$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $f05781b554dcd2cc$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $f05781b554dcd2cc$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $f05781b554dcd2cc$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $f05781b554dcd2cc$var$_possibleConstructorReturn(this, result);
    };
}
function $f05781b554dcd2cc$var$_possibleConstructorReturn(self, call) {
    if (call && ($f05781b554dcd2cc$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $f05781b554dcd2cc$var$_assertThisInitialized(self);
}
function $f05781b554dcd2cc$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $f05781b554dcd2cc$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $f05781b554dcd2cc$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$f05781b554dcd2cc$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $f05781b554dcd2cc$var$_construct(Class, arguments, $f05781b554dcd2cc$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $f05781b554dcd2cc$var$_setPrototypeOf(Wrapper, Class);
    };
    return $f05781b554dcd2cc$var$_wrapNativeSuper(Class);
}
function $f05781b554dcd2cc$var$_construct(Parent, args, Class) {
    if ($f05781b554dcd2cc$var$_isNativeReflectConstruct()) $f05781b554dcd2cc$var$_construct = Reflect.construct;
    else $f05781b554dcd2cc$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $f05781b554dcd2cc$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $f05781b554dcd2cc$var$_construct.apply(null, arguments);
}
function $f05781b554dcd2cc$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $f05781b554dcd2cc$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $f05781b554dcd2cc$var$_setPrototypeOf(o, p) {
    $f05781b554dcd2cc$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $f05781b554dcd2cc$var$_setPrototypeOf(o, p);
}
function $f05781b554dcd2cc$var$_getPrototypeOf(o) {
    $f05781b554dcd2cc$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $f05781b554dcd2cc$var$_getPrototypeOf(o);
}
// https://stackoverflow.com/a/46971044/970769
// "Breaking changes in Typescript 2.1"
// "Extending built-ins like Error, Array, and Map may no longer work."
// "As a recommendation, you can manually adjust the prototype immediately after any super(...) calls."
// https://github.com/Microsoft/TypeScript-wiki/blob/main/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
var $f05781b554dcd2cc$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Error) {
    $f05781b554dcd2cc$var$_inherits(ParseError, _Error);
    var _super = $f05781b554dcd2cc$var$_createSuper(ParseError);
    function ParseError(code) {
        var _this;
        $f05781b554dcd2cc$var$_classCallCheck(this, ParseError);
        _this = _super.call(this, code); // Set the prototype explicitly.
        // Any subclass of FooError will have to manually set the prototype as well.
        Object.setPrototypeOf($f05781b554dcd2cc$var$_assertThisInitialized(_this), ParseError.prototype);
        _this.name = _this.constructor.name;
        return _this;
    }
    return $f05781b554dcd2cc$var$_createClass(ParseError);
}(/*#__PURE__*/ $f05781b554dcd2cc$var$_wrapNativeSuper(Error));


// Copy-pasted from:
// https://github.com/substack/semver-compare/blob/master/index.js
//
// Inlining this function because some users reported issues with
// importing from `semver-compare` in a browser with ES6 "native" modules.
//
// Fixes `semver-compare` not being able to compare versions with alpha/beta/etc "tags".
// https://github.com/catamphetamine/libphonenumber-js/issues/381
function $152a7a96295748c5$export$2e2bcd8739ae039(a, b) {
    a = a.split("-");
    b = b.split("-");
    var pa = a[0].split(".");
    var pb = b[0].split(".");
    for(var i = 0; i < 3; i++){
        var na = Number(pa[i]);
        var nb = Number(pb[i]);
        if (na > nb) return 1;
        if (nb > na) return -1;
        if (!isNaN(na) && isNaN(nb)) return 1;
        if (isNaN(na) && !isNaN(nb)) return -1;
    }
    if (a[1] && b[1]) return a[1] > b[1] ? 1 : a[1] < b[1] ? -1 : 0;
    return !a[1] && b[1] ? 1 : a[1] && !b[1] ? -1 : 0;
}


var $d814e6c2374b27a6$var$objectConstructor = {}.constructor;
function $d814e6c2374b27a6$export$2e2bcd8739ae039(object) {
    return object !== undefined && object !== null && object.constructor === $d814e6c2374b27a6$var$objectConstructor;
}


function $3542b2b23489a694$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $3542b2b23489a694$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $3542b2b23489a694$var$_typeof(obj);
}
function $3542b2b23489a694$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $3542b2b23489a694$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $3542b2b23489a694$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $3542b2b23489a694$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $3542b2b23489a694$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
// "country_phone_code_to_countries" to "country_calling_codes".
var $3542b2b23489a694$var$V2 = "1.0.18"; // Added "idd_prefix" and "default_idd_prefix".
var $3542b2b23489a694$var$V3 = "1.2.0"; // Moved `001` country code to "nonGeographic" section of metadata.
var $3542b2b23489a694$var$V4 = "1.7.35";
var $3542b2b23489a694$var$DEFAULT_EXT_PREFIX = " ext. ";
var $3542b2b23489a694$var$CALLING_CODE_REG_EXP = /^\d+$/;
/**
 * See: https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md
 */ var $3542b2b23489a694$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Metadata(metadata) {
        $3542b2b23489a694$var$_classCallCheck(this, Metadata);
        $3542b2b23489a694$export$a0b100d4662a8795(metadata);
        this.metadata = metadata;
        $3542b2b23489a694$var$setVersion.call(this, metadata);
    }
    $3542b2b23489a694$var$_createClass(Metadata, [
        {
            key: "getCountries",
            value: function getCountries() {
                return Object.keys(this.metadata.countries).filter(function(_) {
                    return _ !== "001";
                });
            }
        },
        {
            key: "getCountryMetadata",
            value: function getCountryMetadata(countryCode) {
                return this.metadata.countries[countryCode];
            }
        },
        {
            key: "nonGeographic",
            value: function nonGeographic() {
                if (this.v1 || this.v2 || this.v3) return; // `nonGeographical` was a typo.
                // It's present in metadata generated from `1.7.35` to `1.7.37`.
                // The test case could be found by searching for "nonGeographical".
                return this.metadata.nonGeographic || this.metadata.nonGeographical;
            }
        },
        {
            key: "hasCountry",
            value: function hasCountry(country) {
                return this.getCountryMetadata(country) !== undefined;
            }
        },
        {
            key: "hasCallingCode",
            value: function hasCallingCode(callingCode) {
                if (this.getCountryCodesForCallingCode(callingCode)) return true;
                if (this.nonGeographic()) {
                    if (this.nonGeographic()[callingCode]) return true;
                } else {
                    // A hacky workaround for old custom metadata (generated before V4).
                    var countryCodes = this.countryCallingCodes()[callingCode];
                    if (countryCodes && countryCodes.length === 1 && countryCodes[0] === "001") return true;
                }
            }
        },
        {
            key: "isNonGeographicCallingCode",
            value: function isNonGeographicCallingCode(callingCode) {
                if (this.nonGeographic()) return this.nonGeographic()[callingCode] ? true : false;
                else return this.getCountryCodesForCallingCode(callingCode) ? false : true;
            } // Deprecated.
        },
        {
            key: "country",
            value: function country(countryCode) {
                return this.selectNumberingPlan(countryCode);
            }
        },
        {
            key: "selectNumberingPlan",
            value: function selectNumberingPlan(countryCode, callingCode) {
                // Supports just passing `callingCode` as the first argument.
                if (countryCode && $3542b2b23489a694$var$CALLING_CODE_REG_EXP.test(countryCode)) {
                    callingCode = countryCode;
                    countryCode = null;
                }
                if (countryCode && countryCode !== "001") {
                    if (!this.hasCountry(countryCode)) throw new Error("Unknown country: ".concat(countryCode));
                    this.numberingPlan = new $3542b2b23489a694$var$NumberingPlan(this.getCountryMetadata(countryCode), this);
                } else if (callingCode) {
                    if (!this.hasCallingCode(callingCode)) throw new Error("Unknown calling code: ".concat(callingCode));
                    this.numberingPlan = new $3542b2b23489a694$var$NumberingPlan(this.getNumberingPlanMetadata(callingCode), this);
                } else this.numberingPlan = undefined;
                return this;
            }
        },
        {
            key: "getCountryCodesForCallingCode",
            value: function getCountryCodesForCallingCode(callingCode) {
                var countryCodes = this.countryCallingCodes()[callingCode];
                if (countryCodes) {
                    // Metadata before V4 included "non-geographic entity" calling codes
                    // inside `country_calling_codes` (for example, `"881":["001"]`).
                    // Now the semantics of `country_calling_codes` has changed:
                    // it's specifically for "countries" now.
                    // Older versions of custom metadata will simply skip parsing
                    // "non-geographic entity" phone numbers with new versions
                    // of this library: it's not considered a bug,
                    // because such numbers are extremely rare,
                    // and developers extremely rarely use custom metadata.
                    if (countryCodes.length === 1 && countryCodes[0].length === 3) return;
                    return countryCodes;
                }
            }
        },
        {
            key: "getCountryCodeForCallingCode",
            value: function getCountryCodeForCallingCode(callingCode) {
                var countryCodes = this.getCountryCodesForCallingCode(callingCode);
                if (countryCodes) return countryCodes[0];
            }
        },
        {
            key: "getNumberingPlanMetadata",
            value: function getNumberingPlanMetadata(callingCode) {
                var countryCode = this.getCountryCodeForCallingCode(callingCode);
                if (countryCode) return this.getCountryMetadata(countryCode);
                if (this.nonGeographic()) {
                    var metadata = this.nonGeographic()[callingCode];
                    if (metadata) return metadata;
                } else {
                    // A hacky workaround for old custom metadata (generated before V4).
                    // In that metadata, there was no concept of "non-geographic" metadata
                    // so metadata for `001` country code was stored along with other countries.
                    // The test case can be found by searching for:
                    // "should work around `nonGeographic` metadata not existing".
                    var countryCodes = this.countryCallingCodes()[callingCode];
                    if (countryCodes && countryCodes.length === 1 && countryCodes[0] === "001") return this.metadata.countries["001"];
                }
            } // Deprecated.
        },
        {
            key: "countryCallingCode",
            value: function countryCallingCode() {
                return this.numberingPlan.callingCode();
            } // Deprecated.
        },
        {
            key: "IDDPrefix",
            value: function IDDPrefix() {
                return this.numberingPlan.IDDPrefix();
            } // Deprecated.
        },
        {
            key: "defaultIDDPrefix",
            value: function defaultIDDPrefix() {
                return this.numberingPlan.defaultIDDPrefix();
            } // Deprecated.
        },
        {
            key: "nationalNumberPattern",
            value: function nationalNumberPattern() {
                return this.numberingPlan.nationalNumberPattern();
            } // Deprecated.
        },
        {
            key: "possibleLengths",
            value: function possibleLengths() {
                return this.numberingPlan.possibleLengths();
            } // Deprecated.
        },
        {
            key: "formats",
            value: function formats() {
                return this.numberingPlan.formats();
            } // Deprecated.
        },
        {
            key: "nationalPrefixForParsing",
            value: function nationalPrefixForParsing() {
                return this.numberingPlan.nationalPrefixForParsing();
            } // Deprecated.
        },
        {
            key: "nationalPrefixTransformRule",
            value: function nationalPrefixTransformRule() {
                return this.numberingPlan.nationalPrefixTransformRule();
            } // Deprecated.
        },
        {
            key: "leadingDigits",
            value: function leadingDigits() {
                return this.numberingPlan.leadingDigits();
            } // Deprecated.
        },
        {
            key: "hasTypes",
            value: function hasTypes() {
                return this.numberingPlan.hasTypes();
            } // Deprecated.
        },
        {
            key: "type",
            value: function type(_type) {
                return this.numberingPlan.type(_type);
            } // Deprecated.
        },
        {
            key: "ext",
            value: function ext() {
                return this.numberingPlan.ext();
            }
        },
        {
            key: "countryCallingCodes",
            value: function countryCallingCodes() {
                if (this.v1) return this.metadata.country_phone_code_to_countries;
                return this.metadata.country_calling_codes;
            } // Deprecated.
        },
        {
            key: "chooseCountryByCountryCallingCode",
            value: function chooseCountryByCountryCallingCode(callingCode) {
                return this.selectNumberingPlan(callingCode);
            }
        },
        {
            key: "hasSelectedNumberingPlan",
            value: function hasSelectedNumberingPlan() {
                return this.numberingPlan !== undefined;
            }
        }
    ]);
    return Metadata;
}();
var $3542b2b23489a694$var$NumberingPlan = /*#__PURE__*/ function() {
    function NumberingPlan(metadata, globalMetadataObject) {
        $3542b2b23489a694$var$_classCallCheck(this, NumberingPlan);
        this.globalMetadataObject = globalMetadataObject;
        this.metadata = metadata;
        $3542b2b23489a694$var$setVersion.call(this, globalMetadataObject.metadata);
    }
    $3542b2b23489a694$var$_createClass(NumberingPlan, [
        {
            key: "callingCode",
            value: function callingCode() {
                return this.metadata[0];
            } // Formatting information for regions which share
        },
        {
            key: "getDefaultCountryMetadataForRegion",
            value: function getDefaultCountryMetadataForRegion() {
                return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
            } // Is always present.
        },
        {
            key: "IDDPrefix",
            value: function IDDPrefix() {
                if (this.v1 || this.v2) return;
                return this.metadata[1];
            } // Is only present when a country supports multiple IDD prefixes.
        },
        {
            key: "defaultIDDPrefix",
            value: function defaultIDDPrefix() {
                if (this.v1 || this.v2) return;
                return this.metadata[12];
            }
        },
        {
            key: "nationalNumberPattern",
            value: function nationalNumberPattern() {
                if (this.v1 || this.v2) return this.metadata[1];
                return this.metadata[2];
            } // "possible length" data is always present in Google's metadata.
        },
        {
            key: "possibleLengths",
            value: function possibleLengths() {
                if (this.v1) return;
                return this.metadata[this.v2 ? 2 : 3];
            }
        },
        {
            key: "_getFormats",
            value: function _getFormats(metadata) {
                return metadata[this.v1 ? 2 : this.v2 ? 3 : 4];
            } // For countries of the same region (e.g. NANPA)
        },
        {
            key: "formats",
            value: function formats() {
                var _this = this;
                var formats = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
                return formats.map(function(_) {
                    return new $3542b2b23489a694$var$Format(_, _this);
                });
            }
        },
        {
            key: "nationalPrefix",
            value: function nationalPrefix() {
                return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
            }
        },
        {
            key: "_getNationalPrefixFormattingRule",
            value: function _getNationalPrefixFormattingRule(metadata) {
                return metadata[this.v1 ? 4 : this.v2 ? 5 : 6];
            } // For countries of the same region (e.g. NANPA)
        },
        {
            key: "nationalPrefixFormattingRule",
            value: function nationalPrefixFormattingRule() {
                return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
            }
        },
        {
            key: "_nationalPrefixForParsing",
            value: function _nationalPrefixForParsing() {
                return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
            }
        },
        {
            key: "nationalPrefixForParsing",
            value: function nationalPrefixForParsing() {
                // If `national_prefix_for_parsing` is not set explicitly,
                // then infer it from `national_prefix` (if any)
                return this._nationalPrefixForParsing() || this.nationalPrefix();
            }
        },
        {
            key: "nationalPrefixTransformRule",
            value: function nationalPrefixTransformRule() {
                return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
            }
        },
        {
            key: "_getNationalPrefixIsOptionalWhenFormatting",
            value: function _getNationalPrefixIsOptionalWhenFormatting() {
                return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
            } // For countries of the same region (e.g. NANPA)
        },
        {
            key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
            value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
                return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
            }
        },
        {
            key: "leadingDigits",
            value: function leadingDigits() {
                return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
            }
        },
        {
            key: "types",
            value: function types() {
                return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
            }
        },
        {
            key: "hasTypes",
            value: function hasTypes() {
                // Versions 1.2.0 - 1.2.4: can be `[]`.
                /* istanbul ignore next */ if (this.types() && this.types().length === 0) return false;
                 // Versions <= 1.2.4: can be `undefined`.
                // Version >= 1.2.5: can be `0`.
                return !!this.types();
            }
        },
        {
            key: "type",
            value: function type(_type2) {
                if (this.hasTypes() && $3542b2b23489a694$var$getType(this.types(), _type2)) return new $3542b2b23489a694$var$Type($3542b2b23489a694$var$getType(this.types(), _type2), this);
            }
        },
        {
            key: "ext",
            value: function ext() {
                if (this.v1 || this.v2) return $3542b2b23489a694$var$DEFAULT_EXT_PREFIX;
                return this.metadata[13] || $3542b2b23489a694$var$DEFAULT_EXT_PREFIX;
            }
        }
    ]);
    return NumberingPlan;
}();
var $3542b2b23489a694$var$Format = /*#__PURE__*/ function() {
    function Format(format, metadata) {
        $3542b2b23489a694$var$_classCallCheck(this, Format);
        this._format = format;
        this.metadata = metadata;
    }
    $3542b2b23489a694$var$_createClass(Format, [
        {
            key: "pattern",
            value: function pattern() {
                return this._format[0];
            }
        },
        {
            key: "format",
            value: function format() {
                return this._format[1];
            }
        },
        {
            key: "leadingDigitsPatterns",
            value: function leadingDigitsPatterns() {
                return this._format[2] || [];
            }
        },
        {
            key: "nationalPrefixFormattingRule",
            value: function nationalPrefixFormattingRule() {
                return this._format[3] || this.metadata.nationalPrefixFormattingRule();
            }
        },
        {
            key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
            value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
                return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
            }
        },
        {
            key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
            value: function nationalPrefixIsMandatoryWhenFormattingInNationalFormat() {
                // National prefix is omitted if there's no national prefix formatting rule
                // set for this country, or when the national prefix formatting rule
                // contains no national prefix itself, or when this rule is set but
                // national prefix is optional for this phone number format
                // (and it is not enforced explicitly)
                return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
            } // Checks whether national prefix formatting rule contains national prefix.
        },
        {
            key: "usesNationalPrefix",
            value: function usesNationalPrefix() {
                return this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
                !$3542b2b23489a694$var$FIRST_GROUP_ONLY_PREFIX_PATTERN.test(this.nationalPrefixFormattingRule()) // In compressed metadata, `this.nationalPrefixFormattingRule()` is `0`
                 ? true : false;
            }
        },
        {
            key: "internationalFormat",
            value: function internationalFormat() {
                return this._format[5] || this.format();
            }
        }
    ]);
    return Format;
}();
/**
 * A pattern that is used to determine if the national prefix formatting rule
 * has the first group only, i.e., does not start with the national prefix.
 * Note that the pattern explicitly allows for unbalanced parentheses.
 */ var $3542b2b23489a694$var$FIRST_GROUP_ONLY_PREFIX_PATTERN = /^\(?\$1\)?$/;
var $3542b2b23489a694$var$Type = /*#__PURE__*/ function() {
    function Type(type, metadata) {
        $3542b2b23489a694$var$_classCallCheck(this, Type);
        this.type = type;
        this.metadata = metadata;
    }
    $3542b2b23489a694$var$_createClass(Type, [
        {
            key: "pattern",
            value: function pattern() {
                if (this.metadata.v1) return this.type;
                return this.type[0];
            }
        },
        {
            key: "possibleLengths",
            value: function possibleLengths() {
                if (this.metadata.v1) return;
                return this.type[1] || this.metadata.possibleLengths();
            }
        }
    ]);
    return Type;
}();
function $3542b2b23489a694$var$getType(types, type) {
    switch(type){
        case "FIXED_LINE":
            return types[0];
        case "MOBILE":
            return types[1];
        case "TOLL_FREE":
            return types[2];
        case "PREMIUM_RATE":
            return types[3];
        case "PERSONAL_NUMBER":
            return types[4];
        case "VOICEMAIL":
            return types[5];
        case "UAN":
            return types[6];
        case "PAGER":
            return types[7];
        case "VOIP":
            return types[8];
        case "SHARED_COST":
            return types[9];
    }
}
function $3542b2b23489a694$export$a0b100d4662a8795(metadata) {
    if (!metadata) throw new Error("[libphonenumber-js] `metadata` argument not passed. Check your arguments.");
     // `country_phone_code_to_countries` was renamed to
    // `country_calling_codes` in `1.0.18`.
    if (!(0, $d814e6c2374b27a6$export$2e2bcd8739ae039)(metadata) || !(0, $d814e6c2374b27a6$export$2e2bcd8739ae039)(metadata.countries)) throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat((0, $d814e6c2374b27a6$export$2e2bcd8739ae039)(metadata) ? "an object of shape: { " + Object.keys(metadata).join(", ") + " }" : "a " + $3542b2b23489a694$var$typeOf(metadata) + ": " + metadata, "."));
} // Babel transforms `typeof` into some "branches"
// so istanbul will show this as "branch not covered".
/* istanbul ignore next */ var $3542b2b23489a694$var$typeOf = function typeOf(_) {
    return $3542b2b23489a694$var$_typeof(_);
};
function $3542b2b23489a694$export$9b48c965eafc2cf6(country, metadata) {
    metadata = new $3542b2b23489a694$export$2e2bcd8739ae039(metadata);
    if (metadata.hasCountry(country)) return metadata.country(country).ext();
    return $3542b2b23489a694$var$DEFAULT_EXT_PREFIX;
}
function $3542b2b23489a694$export$32876ca2f1919cf0(country, metadata) {
    metadata = new $3542b2b23489a694$export$2e2bcd8739ae039(metadata);
    if (metadata.hasCountry(country)) return metadata.country(country).countryCallingCode();
    throw new Error("Unknown country: ".concat(country));
}
function $3542b2b23489a694$export$bd9e113b8b17202a(country, metadata) {
    // metadata = new Metadata(metadata)
    // return metadata.hasCountry(country)
    return metadata.countries.hasOwnProperty(country);
}
function $3542b2b23489a694$var$setVersion(metadata) {
    var version = metadata.version;
    if (typeof version === "number") {
        this.v1 = version === 1;
        this.v2 = version === 2;
        this.v3 = version === 3;
        this.v4 = version === 4;
    } else {
        if (!version) this.v1 = true;
        else if ((0, $152a7a96295748c5$export$2e2bcd8739ae039)(version, $3542b2b23489a694$var$V3) === -1) this.v2 = true;
        else if ((0, $152a7a96295748c5$export$2e2bcd8739ae039)(version, $3542b2b23489a694$var$V4) === -1) this.v3 = true;
        else this.v4 = true;
    }
} // const ISO_COUNTRY_CODE = /^[A-Z]{2}$/
 // function isCountryCode(countryCode) {
 // 	return ISO_COUNTRY_CODE.test(countryCodeOrCountryCallingCode)
 // }




var $7c474898e679f6b3$var$RFC3966_EXTN_PREFIX = ";ext=";
/**
 * Helper method for constructing regular expressions for parsing. Creates
 * an expression that captures up to max_length digits.
 * @return {string} RegEx pattern to capture extension digits.
 */ var $7c474898e679f6b3$var$getExtensionDigitsPattern = function getExtensionDigitsPattern(maxLength) {
    return "([".concat((0, $37eb819a63618324$export$852d1d4a47329634), "]{1,").concat(maxLength, "})");
};
function $7c474898e679f6b3$export$2e2bcd8739ae039(purpose) {
    // We cap the maximum length of an extension based on the ambiguity of the way
    // the extension is prefixed. As per ITU, the officially allowed length for
    // extensions is actually 40, but we don't support this since we haven't seen real
    // examples and this introduces many false interpretations as the extension labels
    // are not standardized.
    /** @type {string} */ var extLimitAfterExplicitLabel = "20";
    /** @type {string} */ var extLimitAfterLikelyLabel = "15";
    /** @type {string} */ var extLimitAfterAmbiguousChar = "9";
    /** @type {string} */ var extLimitWhenNotSure = "6";
    /** @type {string} */ var possibleSeparatorsBetweenNumberAndExtLabel = "[ \xa0\\t,]*"; // Optional full stop (.) or colon, followed by zero or more spaces/tabs/commas.
    /** @type {string} */ var possibleCharsAfterExtLabel = "[:\\.．]?[ \xa0\\t,-]*";
    /** @type {string} */ var optionalExtnSuffix = "#?"; // Here the extension is called out in more explicit way, i.e mentioning it obvious
    // patterns like "ext.".
    /** @type {string} */ var explicitExtLabels = "(?:e?xt(?:ensi(?:ó?|\xf3))?n?|ｅ?ｘｔｎ?|доб|anexo)"; // One-character symbols that can be used to indicate an extension, and less
    // commonly used or more ambiguous extension labels.
    /** @type {string} */ var ambiguousExtLabels = "(?:[xｘ#＃~～]|int|ｉｎｔ)"; // When extension is not separated clearly.
    /** @type {string} */ var ambiguousSeparator = "[- ]+"; // This is the same as possibleSeparatorsBetweenNumberAndExtLabel, but not matching
    // comma as extension label may have it.
    /** @type {string} */ var possibleSeparatorsNumberExtLabelNoComma = "[ \xa0\\t]*"; // ",," is commonly used for auto dialling the extension when connected. First
    // comma is matched through possibleSeparatorsBetweenNumberAndExtLabel, so we do
    // not repeat it here. Semi-colon works in Iphone and Android also to pop up a
    // button with the extension number following.
    /** @type {string} */ var autoDiallingAndExtLabelsFound = "(?:,{2}|;)";
    /** @type {string} */ var rfcExtn = $7c474898e679f6b3$var$RFC3966_EXTN_PREFIX + $7c474898e679f6b3$var$getExtensionDigitsPattern(extLimitAfterExplicitLabel);
    /** @type {string} */ var explicitExtn = possibleSeparatorsBetweenNumberAndExtLabel + explicitExtLabels + possibleCharsAfterExtLabel + $7c474898e679f6b3$var$getExtensionDigitsPattern(extLimitAfterExplicitLabel) + optionalExtnSuffix;
    /** @type {string} */ var ambiguousExtn = possibleSeparatorsBetweenNumberAndExtLabel + ambiguousExtLabels + possibleCharsAfterExtLabel + $7c474898e679f6b3$var$getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix;
    /** @type {string} */ var americanStyleExtnWithSuffix = ambiguousSeparator + $7c474898e679f6b3$var$getExtensionDigitsPattern(extLimitWhenNotSure) + "#";
    /** @type {string} */ var autoDiallingExtn = possibleSeparatorsNumberExtLabelNoComma + autoDiallingAndExtLabelsFound + possibleCharsAfterExtLabel + $7c474898e679f6b3$var$getExtensionDigitsPattern(extLimitAfterLikelyLabel) + optionalExtnSuffix;
    /** @type {string} */ var onlyCommasExtn = possibleSeparatorsNumberExtLabelNoComma + "(?:,)+" + possibleCharsAfterExtLabel + $7c474898e679f6b3$var$getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix; // The first regular expression covers RFC 3966 format, where the extension is added
    // using ";ext=". The second more generic where extension is mentioned with explicit
    // labels like "ext:". In both the above cases we allow more numbers in extension than
    // any other extension labels. The third one captures when single character extension
    // labels or less commonly used labels are used. In such cases we capture fewer
    // extension digits in order to reduce the chance of falsely interpreting two
    // numbers beside each other as a number + extension. The fourth one covers the
    // special case of American numbers where the extension is written with a hash
    // at the end, such as "- 503#". The fifth one is exclusively for extension
    // autodialling formats which are used when dialling and in this case we accept longer
    // extensions. The last one is more liberal on the number of commas that acts as
    // extension labels, so we have a strict cap on the number of digits in such extensions.
    return rfcExtn + "|" + explicitExtn + "|" + ambiguousExtn + "|" + americanStyleExtnWithSuffix + "|" + autoDiallingExtn + "|" + onlyCommasExtn;
}


//  Checks we have at least three leading digits, and only valid punctuation,
//  alpha characters and digits in the phone number. Does not include extension
//  data. The symbol 'x' is allowed here as valid punctuation since it is often
//  used as a placeholder for carrier codes, for example in Brazilian phone
//  numbers. We also allow multiple '+' characters at the start.
//
//  Corresponds to the following:
//  [digits]{minLengthNsn}|
//  plus_sign*
//  (([punctuation]|[star])*[digits]){3,}([punctuation]|[star]|[digits]|[alpha])*
//
//  The first reg-ex is to allow short numbers (two digits long) to be parsed if
//  they are entered as "15" etc, but only if there is no punctuation in them.
//  The second expression restricts the number of digits to three or more, but
//  then allows them to be in international form, and to have alpha-characters
//  and punctuation. We split up the two reg-exes here and combine them when
//  creating the reg-ex VALID_PHONE_NUMBER_PATTERN itself so we can prefix it
//  with ^ and append $ to each branch.
//
//  "Note VALID_PUNCTUATION starts with a -,
//   so must be the first in the range" (c) Google devs.
//  (wtf did they mean by saying that; probably nothing)
//
var $c76e1434e0d3cfc5$var$MIN_LENGTH_PHONE_NUMBER_PATTERN = "[" + (0, $37eb819a63618324$export$852d1d4a47329634) + "]{" + (0, $37eb819a63618324$export$cd8355bcbe13154) + "}"; //
var $c76e1434e0d3cfc5$export$a77dd7471651eee = "[" + (0, $37eb819a63618324$export$207c99ccf3902df8) + "]{0,1}" + "(?:" + "[" + (0, $37eb819a63618324$export$7f01587e28f9194) + "]*" + "[" + (0, $37eb819a63618324$export$852d1d4a47329634) + "]" + "){3,}" + "[" + (0, $37eb819a63618324$export$7f01587e28f9194) + (0, $37eb819a63618324$export$852d1d4a47329634) + "]*"; // This regular expression isn't present in Google's `libphonenumber`
// and is only used to determine whether the phone number being input
// is too short for it to even consider it a "valid" number.
// This is just a way to differentiate between a really invalid phone
// number like "abcde" and a valid phone number that a user has just
// started inputting, like "+1" or "1": both these cases would be
// considered `NOT_A_NUMBER` by Google's `libphonenumber`, but this
// library can provide a more detailed error message — whether it's
// really "not a number", or is it just a start of a valid phone number.
var $c76e1434e0d3cfc5$var$VALID_PHONE_NUMBER_START_REG_EXP = new RegExp("^[" + (0, $37eb819a63618324$export$207c99ccf3902df8) + "]{0,1}" + "(?:" + "[" + (0, $37eb819a63618324$export$7f01587e28f9194) + "]*" + "[" + (0, $37eb819a63618324$export$852d1d4a47329634) + "]" + "){1,2}" + "$", "i");
var $c76e1434e0d3cfc5$export$a2d12a04749c087d = $c76e1434e0d3cfc5$export$a77dd7471651eee + // Phone number extensions
"(?:" + (0, $7c474898e679f6b3$export$2e2bcd8739ae039)() + ")?"; // The combined regular expression for valid phone numbers:
//
var $c76e1434e0d3cfc5$var$VALID_PHONE_NUMBER_PATTERN = new RegExp("^" + $c76e1434e0d3cfc5$var$MIN_LENGTH_PHONE_NUMBER_PATTERN + "$" + "|" + // Or a longer fully parsed phone number (min 3 characters)
"^" + $c76e1434e0d3cfc5$export$a2d12a04749c087d + "$", "i"); // Checks to see if the string of characters could possibly be a phone number at
function $c76e1434e0d3cfc5$export$2e2bcd8739ae039(number) {
    return number.length >= (0, $37eb819a63618324$export$cd8355bcbe13154) && $c76e1434e0d3cfc5$var$VALID_PHONE_NUMBER_PATTERN.test(number);
} // This is just a way to differentiate between a really invalid phone
function $c76e1434e0d3cfc5$export$4c3f76c95c05197c(number) {
    return $c76e1434e0d3cfc5$var$VALID_PHONE_NUMBER_START_REG_EXP.test(number);
}



// 1 or more valid digits, for use when parsing.
var $36eb7721bd8daaf6$var$EXTN_PATTERN = new RegExp("(?:" + (0, $7c474898e679f6b3$export$2e2bcd8739ae039)() + ")$", "i"); // Strips any extension (as in, the part of the number dialled after the call is
function $36eb7721bd8daaf6$export$2e2bcd8739ae039(number) {
    var start = number.search($36eb7721bd8daaf6$var$EXTN_PATTERN);
    if (start < 0) return {};
     // If we find a potential extension, and the number preceding this is a viable
    // number, we assume it is an extension.
    var numberWithoutExtension = number.slice(0, start);
    var matches = number.match($36eb7721bd8daaf6$var$EXTN_PATTERN);
    var i = 1;
    while(i < matches.length){
        if (matches[i]) return {
            number: numberWithoutExtension,
            ext: matches[i]
        };
        i++;
    }
}


function $f9f424f8cba181aa$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $f9f424f8cba181aa$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $f9f424f8cba181aa$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $f9f424f8cba181aa$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $f9f424f8cba181aa$var$_arrayLikeToArray(o, minLen);
}
function $f9f424f8cba181aa$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $f9f424f8cba181aa$export$2848f3d68c08fe69 = {
    "0": "0",
    "1": "1",
    "2": "2",
    "3": "3",
    "4": "4",
    "5": "5",
    "6": "6",
    "7": "7",
    "8": "8",
    "9": "9",
    "０": "0",
    // Fullwidth digit 0
    "１": "1",
    // Fullwidth digit 1
    "２": "2",
    // Fullwidth digit 2
    "３": "3",
    // Fullwidth digit 3
    "４": "4",
    // Fullwidth digit 4
    "５": "5",
    // Fullwidth digit 5
    "６": "6",
    // Fullwidth digit 6
    "７": "7",
    // Fullwidth digit 7
    "８": "8",
    // Fullwidth digit 8
    "９": "9",
    // Fullwidth digit 9
    "٠": "0",
    // Arabic-indic digit 0
    "١": "1",
    // Arabic-indic digit 1
    "٢": "2",
    // Arabic-indic digit 2
    "٣": "3",
    // Arabic-indic digit 3
    "٤": "4",
    // Arabic-indic digit 4
    "٥": "5",
    // Arabic-indic digit 5
    "٦": "6",
    // Arabic-indic digit 6
    "٧": "7",
    // Arabic-indic digit 7
    "٨": "8",
    // Arabic-indic digit 8
    "٩": "9",
    // Arabic-indic digit 9
    "۰": "0",
    // Eastern-Arabic digit 0
    "۱": "1",
    // Eastern-Arabic digit 1
    "۲": "2",
    // Eastern-Arabic digit 2
    "۳": "3",
    // Eastern-Arabic digit 3
    "۴": "4",
    // Eastern-Arabic digit 4
    "۵": "5",
    // Eastern-Arabic digit 5
    "۶": "6",
    // Eastern-Arabic digit 6
    "۷": "7",
    // Eastern-Arabic digit 7
    "۸": "8",
    // Eastern-Arabic digit 8
    "۹": "9" // Eastern-Arabic digit 9
};
function $f9f424f8cba181aa$export$1d16fddea1437169(character) {
    return $f9f424f8cba181aa$export$2848f3d68c08fe69[character];
}
function $f9f424f8cba181aa$export$2e2bcd8739ae039(string) {
    var result = ""; // Using `.split('')` here instead of normal `for ... of`
    // because the importing application doesn't neccessarily include an ES6 polyfill.
    // The `.split('')` approach discards "exotic" UTF-8 characters
    // (the ones consisting of four bytes) but digits
    // (including non-European ones) don't fall into that range
    // so such "exotic" characters would be discarded anyway.
    for(var _iterator = $f9f424f8cba181aa$var$_createForOfIteratorHelperLoose(string.split("")), _step; !(_step = _iterator()).done;){
        var character = _step.value;
        var digit = $f9f424f8cba181aa$export$1d16fddea1437169(character);
        if (digit) result += digit;
    }
    return result;
}


function $a92c8bfd77016633$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $a92c8bfd77016633$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a92c8bfd77016633$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $a92c8bfd77016633$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $a92c8bfd77016633$var$_arrayLikeToArray(o, minLen);
}
function $a92c8bfd77016633$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $a92c8bfd77016633$export$2e2bcd8739ae039(string) {
    var result = ""; // Using `.split('')` here instead of normal `for ... of`
    // because the importing application doesn't neccessarily include an ES6 polyfill.
    // The `.split('')` approach discards "exotic" UTF-8 characters
    // (the ones consisting of four bytes) but digits
    // (including non-European ones) don't fall into that range
    // so such "exotic" characters would be discarded anyway.
    for(var _iterator = $a92c8bfd77016633$var$_createForOfIteratorHelperLoose(string.split("")), _step; !(_step = _iterator()).done;){
        var character = _step.value;
        result += $a92c8bfd77016633$export$13d8790d7fb84c28(character, result) || "";
    }
    return result;
}
function $a92c8bfd77016633$export$13d8790d7fb84c28(character, prevParsedCharacters) {
    // Only allow a leading `+`.
    if (character === "+") {
        // If this `+` is not the first parsed character
        // then discard it.
        if (prevParsedCharacters) return;
        return "+";
    } // Allow digits.
    return (0, $f9f424f8cba181aa$export$1d16fddea1437169)(character);
}




function $289151226ff86c04$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $289151226ff86c04$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $289151226ff86c04$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $289151226ff86c04$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $289151226ff86c04$var$_arrayLikeToArray(o, minLen);
}
function $289151226ff86c04$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $289151226ff86c04$export$2e2bcd8739ae039(a, b) {
    var merged = a.slice();
    for(var _iterator = $289151226ff86c04$var$_createForOfIteratorHelperLoose(b), _step; !(_step = _iterator()).done;){
        var element = _step.value;
        if (a.indexOf(element) < 0) merged.push(element);
    }
    return merged.sort(function(a, b) {
        return a - b;
    }); // ES6 version, requires Set polyfill.
// let merged = new Set(a)
// for (const element of b) {
// 	merged.add(i)
// }
// return Array.from(merged).sort((a, b) => a - b)
}


function $e49ad59848e09d3c$export$2e2bcd8739ae039(nationalNumber, metadata) {
    return $e49ad59848e09d3c$export$69333f603c7d5931(nationalNumber, undefined, metadata);
} // Checks whether a number is possible for the country based on its length.
function $e49ad59848e09d3c$export$69333f603c7d5931(nationalNumber, type, metadata) {
    var type_info = metadata.type(type); // There should always be "<possiblePengths/>" set for every type element.
    // This is declared in the XML schema.
    // For size efficiency, where a sub-description (e.g. fixed-line)
    // has the same "<possiblePengths/>" as the "general description", this is missing,
    // so we fall back to the "general description". Where no numbers of the type
    // exist at all, there is one possible length (-1) which is guaranteed
    // not to match the length of any real phone number.
    var possible_lengths = type_info && type_info.possibleLengths() || metadata.possibleLengths(); // let local_lengths    = type_info && type.possibleLengthsLocal() || metadata.possibleLengthsLocal()
    // Metadata before version `1.0.18` didn't contain `possible_lengths`.
    if (!possible_lengths) return "IS_POSSIBLE";
    if (type === "FIXED_LINE_OR_MOBILE") {
        // No such country in metadata.
        /* istanbul ignore next */ if (!metadata.type("FIXED_LINE")) // The rare case has been encountered where no fixedLine data is available
        // (true for some non-geographic entities), so we just check mobile.
        return $e49ad59848e09d3c$export$69333f603c7d5931(nationalNumber, "MOBILE", metadata);
        var mobile_type = metadata.type("MOBILE");
        if (mobile_type) // Merge the mobile data in if there was any. "Concat" creates a new
        // array, it doesn't edit possible_lengths in place, so we don't need a copy.
        // Note that when adding the possible lengths from mobile, we have
        // to again check they aren't empty since if they are this indicates
        // they are the same as the general desc and should be obtained from there.
        possible_lengths = (0, $289151226ff86c04$export$2e2bcd8739ae039)(possible_lengths, mobile_type.possibleLengths()); // The current list is sorted; we need to merge in the new list and
    } else if (type && !type_info) return "INVALID_LENGTH";
    var actual_length = nationalNumber.length; // In `libphonenumber-js` all "local-only" formats are dropped for simplicity.
    // // This is safe because there is never an overlap beween the possible lengths
    // // and the local-only lengths; this is checked at build time.
    // if (local_lengths && local_lengths.indexOf(nationalNumber.length) >= 0)
    // {
    // 	return 'IS_POSSIBLE_LOCAL_ONLY'
    // }
    var minimum_length = possible_lengths[0];
    if (minimum_length === actual_length) return "IS_POSSIBLE";
    if (minimum_length > actual_length) return "TOO_SHORT";
    if (possible_lengths[possible_lengths.length - 1] < actual_length) return "TOO_LONG";
     // We skip the first element since we've already checked it.
    return possible_lengths.indexOf(actual_length, 1) >= 0 ? "IS_POSSIBLE" : "INVALID_LENGTH";
}


function $284b24a180d5a5a9$export$2e2bcd8739ae039(input, options, metadata) {
    /* istanbul ignore if */ if (options === undefined) options = {};
    metadata = new (0, $3542b2b23489a694$export$2e2bcd8739ae039)(metadata);
    if (options.v2) {
        if (!input.countryCallingCode) throw new Error("Invalid phone number object passed");
        metadata.selectNumberingPlan(input.countryCallingCode);
    } else {
        if (!input.phone) return false;
        if (input.country) {
            if (!metadata.hasCountry(input.country)) throw new Error("Unknown country: ".concat(input.country));
            metadata.country(input.country);
        } else {
            if (!input.countryCallingCode) throw new Error("Invalid phone number object passed");
            metadata.selectNumberingPlan(input.countryCallingCode);
        }
    } // Old metadata (< 1.0.18) had no "possible length" data.
    if (metadata.possibleLengths()) return $284b24a180d5a5a9$export$4f8890cedf1e0497(input.phone || input.nationalNumber, metadata);
    else {
        // There was a bug between `1.7.35` and `1.7.37` where "possible_lengths"
        // were missing for "non-geographical" numbering plans.
        // Just assume the number is possible in such cases:
        // it's unlikely that anyone generated their custom metadata
        // in that short period of time (one day).
        // This code can be removed in some future major version update.
        if (input.countryCallingCode && metadata.isNonGeographicCallingCode(input.countryCallingCode)) // "Non-geographic entities" did't have `possibleLengths`
        // due to a bug in metadata generation process.
        return true;
        else throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
    }
}
function $284b24a180d5a5a9$export$4f8890cedf1e0497(nationalNumber, metadata) {
    //, isInternational) {
    switch((0, $e49ad59848e09d3c$export$2e2bcd8739ae039)(nationalNumber, metadata)){
        case "IS_POSSIBLE":
            return true;
        // This library ignores "local-only" phone numbers (for simplicity).
        // See the readme for more info on what are "local-only" phone numbers.
        // case 'IS_POSSIBLE_LOCAL_ONLY':
        // 	return !isInternational
        default:
            return false;
    }
}





/**
 * Checks whether the entire input sequence can be matched
 * against the regular expression.
 * @return {boolean}
 */ function $7c3045a0d74e1110$export$2e2bcd8739ae039(text, regular_expression) {
    // If assigning the `''` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    text = text || "";
    return new RegExp("^(?:" + regular_expression + ")$").test(text);
}




function $94c0652204baced1$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $94c0652204baced1$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $94c0652204baced1$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $94c0652204baced1$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $94c0652204baced1$var$_arrayLikeToArray(o, minLen);
}
function $94c0652204baced1$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $94c0652204baced1$var$NON_FIXED_LINE_PHONE_TYPES = [
    "MOBILE",
    "PREMIUM_RATE",
    "TOLL_FREE",
    "SHARED_COST",
    "VOIP",
    "PERSONAL_NUMBER",
    "PAGER",
    "UAN",
    "VOICEMAIL"
]; // Finds out national phone number type (fixed line, mobile, etc)
function $94c0652204baced1$export$2e2bcd8739ae039(input, options, metadata) {
    // If assigning the `{}` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    options = options || {}; // When `parse()` returns an empty object — `{}` —
    // that means that the phone number is malformed,
    // so it can't possibly be valid.
    if (!input.country && !input.countryCallingCode) return;
    metadata = new (0, $3542b2b23489a694$export$2e2bcd8739ae039)(metadata);
    metadata.selectNumberingPlan(input.country, input.countryCallingCode);
    var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // The following is copy-pasted from the original function:
    // https://github.com/googlei18n/libphonenumber/blob/3ea547d4fbaa2d0b67588904dfa5d3f2557c27ff/javascript/i18n/phonenumbers/phonenumberutil.js#L2835
    // Is this national number even valid for this country
    if (!(0, $7c3045a0d74e1110$export$2e2bcd8739ae039)(nationalNumber, metadata.nationalNumberPattern())) return;
     // Is it fixed line number
    if ($94c0652204baced1$export$7bd37b39ade0214d(nationalNumber, "FIXED_LINE", metadata)) {
        // Because duplicate regular expressions are removed
        // to reduce metadata size, if "mobile" pattern is ""
        // then it means it was removed due to being a duplicate of the fixed-line pattern.
        //
        if (metadata.type("MOBILE") && metadata.type("MOBILE").pattern() === "") return "FIXED_LINE_OR_MOBILE";
         // `MOBILE` type pattern isn't included if it matched `FIXED_LINE` one.
        // For example, for "US" country.
        // Old metadata (< `1.0.18`) had a specific "types" data structure
        // that happened to be `undefined` for `MOBILE` in that case.
        // Newer metadata (>= `1.0.18`) has another data structure that is
        // not `undefined` for `MOBILE` in that case (it's just an empty array).
        // So this `if` is just for backwards compatibility with old metadata.
        if (!metadata.type("MOBILE")) return "FIXED_LINE_OR_MOBILE";
         // Check if the number happens to qualify as both fixed line and mobile.
        // (no such country in the minimal metadata set)
        /* istanbul ignore if */ if ($94c0652204baced1$export$7bd37b39ade0214d(nationalNumber, "MOBILE", metadata)) return "FIXED_LINE_OR_MOBILE";
        return "FIXED_LINE";
    }
    for(var _iterator = $94c0652204baced1$var$_createForOfIteratorHelperLoose($94c0652204baced1$var$NON_FIXED_LINE_PHONE_TYPES), _step; !(_step = _iterator()).done;){
        var type = _step.value;
        if ($94c0652204baced1$export$7bd37b39ade0214d(nationalNumber, type, metadata)) return type;
    }
}
function $94c0652204baced1$export$7bd37b39ade0214d(nationalNumber, type, metadata) {
    type = metadata.type(type);
    if (!type || !type.pattern()) return false;
     // Check if any possible number lengths are present;
    // if so, we use them to avoid checking
    // the validation pattern if they don't match.
    // If they are absent, this means they match
    // the general description, which we have
    // already checked before a specific number type.
    if (type.possibleLengths() && type.possibleLengths().indexOf(nationalNumber.length) < 0) return false;
    return (0, $7c3045a0d74e1110$export$2e2bcd8739ae039)(nationalNumber, type.pattern());
}


function $ea12283a895980cd$export$2e2bcd8739ae039(input, options, metadata) {
    // If assigning the `{}` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    options = options || {};
    metadata = new (0, $3542b2b23489a694$export$2e2bcd8739ae039)(metadata);
    /**
   * Checks if a phone number is "possible" (basically just checks its length).
   *
   * @param  {object|PhoneNumber} input — If `options.v2: true` flag is passed, the `input` should be a `PhoneNumber` instance. Otherwise, it should be an object of shape `{ phone: '...', country: '...' }`.
   * @param  {object} [options]
   * @param  {object} metadata
   * @return {string}
   */ metadata.selectNumberingPlan(input.country, input.countryCallingCode); // By default, countries only have type regexps when it's required for
    // distinguishing different countries having the same `countryCallingCode`.
    if (metadata.hasTypes()) return (0, $94c0652204baced1$export$2e2bcd8739ae039)(input, options, metadata.metadata) !== undefined;
     // If there are no type regexps for this country in metadata then use
    // `nationalNumberPattern` as a "better than nothing" replacement.
    var nationalNumber = options.v2 ? input.nationalNumber : input.phone;
    return (0, $7c3045a0d74e1110$export$2e2bcd8739ae039)(nationalNumber, metadata.nationalNumberPattern());
}




function $0db3166fd8db4acd$export$2e2bcd8739ae039(callingCode, nationalNumber, metadata) {
    var _metadata = new (0, $3542b2b23489a694$export$2e2bcd8739ae039)(metadata);
    var possibleCountries = _metadata.getCountryCodesForCallingCode(callingCode);
    if (!possibleCountries) return [];
    return possibleCountries.filter(function(country) {
        return $0db3166fd8db4acd$var$couldNationalNumberBelongToCountry(nationalNumber, country, metadata);
    });
}
function $0db3166fd8db4acd$var$couldNationalNumberBelongToCountry(nationalNumber, country, metadata) {
    var _metadata = new (0, $3542b2b23489a694$export$2e2bcd8739ae039)(metadata);
    _metadata.selectNumberingPlan(country);
    if (_metadata.numberingPlan.possibleLengths().indexOf(nationalNumber.length) >= 0) return true;
    return false;
}




function $1720b1fd8ce450b5$export$2e2bcd8739ae039(formattedNumber) {
    return formattedNumber.replace(new RegExp("[".concat((0, $37eb819a63618324$export$7f01587e28f9194), "]+"), "g"), " ").trim();
}


var $16c99871ebcb9fc4$export$4f32ad1c51a7a6be = /(\$\d)/;
function $16c99871ebcb9fc4$export$2e2bcd8739ae039(number, format, _ref) {
    var useInternationalFormat = _ref.useInternationalFormat, withNationalPrefix = _ref.withNationalPrefix, carrierCode = _ref.carrierCode, metadata = _ref.metadata;
    var formattedNumber = number.replace(new RegExp(format.pattern()), useInternationalFormat ? format.internationalFormat() : // because that one is only used when formatting phone numbers
    // for dialing from a mobile phone, and this is not a dialing library.
    // carrierCode && format.domesticCarrierCodeFormattingRule()
    // 	// First, replace the $CC in the formatting rule with the desired carrier code.
    // 	// Then, replace the $FG in the formatting rule with the first group
    // 	// and the carrier code combined in the appropriate way.
    // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
    // 	: (
    // 		withNationalPrefix && format.nationalPrefixFormattingRule()
    // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
    // 			: format.format()
    // 	)
    withNationalPrefix && format.nationalPrefixFormattingRule() ? format.format().replace($16c99871ebcb9fc4$export$4f32ad1c51a7a6be, format.nationalPrefixFormattingRule()) : format.format());
    if (useInternationalFormat) return (0, $1720b1fd8ce450b5$export$2e2bcd8739ae039)(formattedNumber);
    return formattedNumber;
}




/**
 * Pattern that makes it easy to distinguish whether a region has a single
 * international dialing prefix or not. If a region has a single international
 * prefix (e.g. 011 in USA), it will be represented as a string that contains
 * a sequence of ASCII digits, and possibly a tilde, which signals waiting for
 * the tone. If there are multiple available international prefixes in a
 * region, they will be represented as a regex string that always contains one
 * or more characters that are not ASCII digits or a tilde.
 */ var $b518028795ca8c69$var$SINGLE_IDD_PREFIX_REG_EXP = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/; // For regions that have multiple IDD prefixes
function $b518028795ca8c69$export$2e2bcd8739ae039(country, callingCode, metadata) {
    var countryMetadata = new (0, $3542b2b23489a694$export$2e2bcd8739ae039)(metadata);
    countryMetadata.selectNumberingPlan(country, callingCode);
    if (countryMetadata.defaultIDDPrefix()) return countryMetadata.defaultIDDPrefix();
    if ($b518028795ca8c69$var$SINGLE_IDD_PREFIX_REG_EXP.test(countryMetadata.IDDPrefix())) return countryMetadata.IDDPrefix();
}



function $c7573b0f9785bc2a$var$_slicedToArray(arr, i) {
    return $c7573b0f9785bc2a$var$_arrayWithHoles(arr) || $c7573b0f9785bc2a$var$_iterableToArrayLimit(arr, i) || $c7573b0f9785bc2a$var$_unsupportedIterableToArray(arr, i) || $c7573b0f9785bc2a$var$_nonIterableRest();
}
function $c7573b0f9785bc2a$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c7573b0f9785bc2a$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $c7573b0f9785bc2a$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $c7573b0f9785bc2a$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $c7573b0f9785bc2a$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c7573b0f9785bc2a$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $c7573b0f9785bc2a$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $c7573b0f9785bc2a$var$_arrayLikeToArray(o, minLen);
}
function $c7573b0f9785bc2a$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $c7573b0f9785bc2a$export$26fe644d7d92bb13(text) {
    var number;
    var ext; // Replace "tel:" with "tel=" for parsing convenience.
    text = text.replace(/^tel:/, "tel=");
    for(var _iterator = $c7573b0f9785bc2a$var$_createForOfIteratorHelperLoose(text.split(";")), _step; !(_step = _iterator()).done;){
        var part = _step.value;
        var _part$split = part.split("="), _part$split2 = $c7573b0f9785bc2a$var$_slicedToArray(_part$split, 2), name = _part$split2[0], value = _part$split2[1];
        switch(name){
            case "tel":
                number = value;
                break;
            case "ext":
                ext = value;
                break;
            case "phone-context":
                // Only "country contexts" are supported.
                // "Domain contexts" are ignored.
                if (value[0] === "+") number = value + number;
                break;
        }
    } // If the phone number is not viable, then abort.
    if (!(0, $c76e1434e0d3cfc5$export$2e2bcd8739ae039)(number)) return {};
    var result = {
        number: number
    };
    if (ext) result.ext = ext;
    return result;
}
function $c7573b0f9785bc2a$export$d4f2d2bc1159d115(_ref) {
    var number = _ref.number, ext = _ref.ext;
    if (!number) return "";
    if (number[0] !== "+") throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');
    return "tel:".concat(number).concat(ext ? ";ext=" + ext : "");
}


function $5d4a6d2f4c8f5b3f$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $5d4a6d2f4c8f5b3f$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $5d4a6d2f4c8f5b3f$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $5d4a6d2f4c8f5b3f$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $5d4a6d2f4c8f5b3f$var$_arrayLikeToArray(o, minLen);
}
function $5d4a6d2f4c8f5b3f$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $5d4a6d2f4c8f5b3f$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $5d4a6d2f4c8f5b3f$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $5d4a6d2f4c8f5b3f$var$ownKeys(Object(source), !0).forEach(function(key) {
            $5d4a6d2f4c8f5b3f$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $5d4a6d2f4c8f5b3f$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $5d4a6d2f4c8f5b3f$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $5d4a6d2f4c8f5b3f$var$DEFAULT_OPTIONS = {
    formatExtension: function formatExtension(formattedNumber, extension, metadata) {
        return "".concat(formattedNumber).concat(metadata.ext()).concat(extension);
    }
};
function $5d4a6d2f4c8f5b3f$export$2e2bcd8739ae039(input, format, options, metadata) {
    // Apply default options.
    if (options) options = $5d4a6d2f4c8f5b3f$var$_objectSpread($5d4a6d2f4c8f5b3f$var$_objectSpread({}, $5d4a6d2f4c8f5b3f$var$DEFAULT_OPTIONS), options);
    else options = $5d4a6d2f4c8f5b3f$var$DEFAULT_OPTIONS;
    metadata = new (0, $3542b2b23489a694$export$2e2bcd8739ae039)(metadata);
    if (input.country && input.country !== "001") {
        // Validate `input.country`.
        if (!metadata.hasCountry(input.country)) throw new Error("Unknown country: ".concat(input.country));
        metadata.country(input.country);
    } else if (input.countryCallingCode) metadata.selectNumberingPlan(input.countryCallingCode);
    else return input.phone || "";
    var countryCallingCode = metadata.countryCallingCode();
    var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // This variable should have been declared inside `case`s
    // but Babel has a bug and it says "duplicate variable declaration".
    var number;
    switch(format){
        case "NATIONAL":
            // Legacy argument support.
            // (`{ country: ..., phone: '' }`)
            if (!nationalNumber) return "";
            number = $5d4a6d2f4c8f5b3f$var$formatNationalNumber(nationalNumber, input.carrierCode, "NATIONAL", metadata, options);
            return $5d4a6d2f4c8f5b3f$var$addExtension(number, input.ext, metadata, options.formatExtension);
        case "INTERNATIONAL":
            // Legacy argument support.
            // (`{ country: ..., phone: '' }`)
            if (!nationalNumber) return "+".concat(countryCallingCode);
            number = $5d4a6d2f4c8f5b3f$var$formatNationalNumber(nationalNumber, null, "INTERNATIONAL", metadata, options);
            number = "+".concat(countryCallingCode, " ").concat(number);
            return $5d4a6d2f4c8f5b3f$var$addExtension(number, input.ext, metadata, options.formatExtension);
        case "E.164":
            // `E.164` doesn't define "phone number extensions".
            return "+".concat(countryCallingCode).concat(nationalNumber);
        case "RFC3966":
            return (0, $c7573b0f9785bc2a$export$d4f2d2bc1159d115)({
                number: "+".concat(countryCallingCode).concat(nationalNumber),
                ext: input.ext
            });
        // For reference, here's Google's IDD formatter:
        // https://github.com/google/libphonenumber/blob/32719cf74e68796788d1ca45abc85dcdc63ba5b9/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L1546
        // Not saying that this IDD formatter replicates it 1:1, but it seems to work.
        // Who would even need to format phone numbers in IDD format anyway?
        case "IDD":
            if (!options.fromCountry) return; // throw new Error('`fromCountry` option not passed for IDD-prefixed formatting.')
            var formattedNumber = $5d4a6d2f4c8f5b3f$var$formatIDD(nationalNumber, input.carrierCode, countryCallingCode, options.fromCountry, metadata);
            return $5d4a6d2f4c8f5b3f$var$addExtension(formattedNumber, input.ext, metadata, options.formatExtension);
        default:
            throw new Error('Unknown "format" argument passed to "formatNumber()": "'.concat(format, '"'));
    }
}
function $5d4a6d2f4c8f5b3f$var$formatNationalNumber(number, carrierCode, formatAs, metadata, options) {
    var format = $5d4a6d2f4c8f5b3f$export$a4ff939d1245121e(metadata.formats(), number);
    if (!format) return number;
    return (0, $16c99871ebcb9fc4$export$2e2bcd8739ae039)(number, format, {
        useInternationalFormat: formatAs === "INTERNATIONAL",
        withNationalPrefix: format.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && options && options.nationalPrefix === false ? false : true,
        carrierCode: carrierCode,
        metadata: metadata
    });
}
function $5d4a6d2f4c8f5b3f$export$a4ff939d1245121e(availableFormats, nationalNnumber) {
    for(var _iterator = $5d4a6d2f4c8f5b3f$var$_createForOfIteratorHelperLoose(availableFormats), _step; !(_step = _iterator()).done;){
        var format = _step.value;
        // Validate leading digits.
        // The test case for "else path" could be found by searching for
        // "format.leadingDigitsPatterns().length === 0".
        if (format.leadingDigitsPatterns().length > 0) {
            // The last leading_digits_pattern is used here, as it is the most detailed
            var lastLeadingDigitsPattern = format.leadingDigitsPatterns()[format.leadingDigitsPatterns().length - 1]; // If leading digits don't match then move on to the next phone number format
            if (nationalNnumber.search(lastLeadingDigitsPattern) !== 0) continue;
        } // Check that the national number matches the phone number format regular expression
        if ((0, $7c3045a0d74e1110$export$2e2bcd8739ae039)(nationalNnumber, format.pattern())) return format;
    }
}
function $5d4a6d2f4c8f5b3f$var$addExtension(formattedNumber, ext, metadata, formatExtension) {
    return ext ? formatExtension(formattedNumber, ext, metadata) : formattedNumber;
}
function $5d4a6d2f4c8f5b3f$var$formatIDD(nationalNumber, carrierCode, countryCallingCode, fromCountry, metadata) {
    var fromCountryCallingCode = (0, $3542b2b23489a694$export$32876ca2f1919cf0)(fromCountry, metadata.metadata); // When calling within the same country calling code.
    if (fromCountryCallingCode === countryCallingCode) {
        var formattedNumber = $5d4a6d2f4c8f5b3f$var$formatNationalNumber(nationalNumber, carrierCode, "NATIONAL", metadata); // For NANPA regions, return the national format for these regions
        // but prefix it with the country calling code.
        if (countryCallingCode === "1") return countryCallingCode + " " + formattedNumber;
         // If regions share a country calling code, the country calling code need
        // not be dialled. This also applies when dialling within a region, so this
        // if clause covers both these cases. Technically this is the case for
        // dialling from La Reunion to other overseas departments of France (French
        // Guiana, Martinique, Guadeloupe), but not vice versa - so we don't cover
        // this edge case for now and for those cases return the version including
        // country calling code. Details here:
        // http://www.petitfute.com/voyage/225-info-pratiques-reunion
        //
        return formattedNumber;
    }
    var iddPrefix = (0, $b518028795ca8c69$export$2e2bcd8739ae039)(fromCountry, undefined, metadata.metadata);
    if (iddPrefix) return "".concat(iddPrefix, " ").concat(countryCallingCode, " ").concat($5d4a6d2f4c8f5b3f$var$formatNationalNumber(nationalNumber, null, "INTERNATIONAL", metadata));
}


function $686291360e3beccf$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $686291360e3beccf$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $686291360e3beccf$var$ownKeys(Object(source), !0).forEach(function(key) {
            $686291360e3beccf$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $686291360e3beccf$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $686291360e3beccf$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $686291360e3beccf$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $686291360e3beccf$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $686291360e3beccf$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $686291360e3beccf$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $686291360e3beccf$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
var $686291360e3beccf$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
var $686291360e3beccf$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * @param  {string} countryOrCountryCallingCode
   * @param  {string} nationalNumber
   * @param  {object} metadata — Metadata JSON
   * @return {PhoneNumber}
   */ function PhoneNumber(countryOrCountryCallingCode, nationalNumber, metadata) {
        $686291360e3beccf$var$_classCallCheck(this, PhoneNumber);
        if (!countryOrCountryCallingCode) throw new TypeError("`country` or `countryCallingCode` not passed");
        if (!nationalNumber) throw new TypeError("`nationalNumber` not passed");
        if (!metadata) throw new TypeError("`metadata` not passed");
        var _getCountryAndCountry = $686291360e3beccf$var$getCountryAndCountryCallingCode(countryOrCountryCallingCode, metadata), country = _getCountryAndCountry.country, countryCallingCode = _getCountryAndCountry.countryCallingCode;
        this.country = country;
        this.countryCallingCode = countryCallingCode;
        this.nationalNumber = nationalNumber;
        this.number = "+" + this.countryCallingCode + this.nationalNumber; // Exclude `metadata` property output from `PhoneNumber.toString()`
        // so that it doesn't clutter the console output of Node.js.
        // Previously, when Node.js did `console.log(new PhoneNumber(...))`,
        // it would output the whole internal structure of the `metadata` object.
        this.getMetadata = function() {
            return metadata;
        };
    }
    $686291360e3beccf$var$_createClass(PhoneNumber, [
        {
            key: "setExt",
            value: function setExt(ext) {
                this.ext = ext;
            }
        },
        {
            key: "getPossibleCountries",
            value: function getPossibleCountries() {
                if (this.country) return [
                    this.country
                ];
                return (0, $0db3166fd8db4acd$export$2e2bcd8739ae039)(this.countryCallingCode, this.nationalNumber, this.getMetadata());
            }
        },
        {
            key: "isPossible",
            value: function isPossible() {
                return (0, $284b24a180d5a5a9$export$2e2bcd8739ae039)(this, {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "isValid",
            value: function isValid() {
                return (0, $ea12283a895980cd$export$2e2bcd8739ae039)(this, {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "isNonGeographic",
            value: function isNonGeographic() {
                var metadata = new (0, $3542b2b23489a694$export$2e2bcd8739ae039)(this.getMetadata());
                return metadata.isNonGeographicCallingCode(this.countryCallingCode);
            }
        },
        {
            key: "isEqual",
            value: function isEqual(phoneNumber) {
                return this.number === phoneNumber.number && this.ext === phoneNumber.ext;
            } // This function was originally meant to be an equivalent for `validatePhoneNumberLength()`,
        },
        {
            key: "getType",
            value: function getType() {
                return (0, $94c0652204baced1$export$2e2bcd8739ae039)(this, {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "format",
            value: function format(_format, options) {
                return (0, $5d4a6d2f4c8f5b3f$export$2e2bcd8739ae039)(this, _format, options ? $686291360e3beccf$var$_objectSpread($686291360e3beccf$var$_objectSpread({}, options), {}, {
                    v2: true
                }) : {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "formatNational",
            value: function formatNational(options) {
                return this.format("NATIONAL", options);
            }
        },
        {
            key: "formatInternational",
            value: function formatInternational(options) {
                return this.format("INTERNATIONAL", options);
            }
        },
        {
            key: "getURI",
            value: function getURI(options) {
                return this.format("RFC3966", options);
            }
        }
    ]);
    return PhoneNumber;
}();
var $686291360e3beccf$var$isCountryCode = function isCountryCode(value) {
    return /^[A-Z]{2}$/.test(value);
};
function $686291360e3beccf$var$getCountryAndCountryCallingCode(countryOrCountryCallingCode, metadataJson) {
    var country;
    var countryCallingCode;
    var metadata = new (0, $3542b2b23489a694$export$2e2bcd8739ae039)(metadataJson); // If country code is passed then derive `countryCallingCode` from it.
    // Also store the country code as `.country`.
    if ($686291360e3beccf$var$isCountryCode(countryOrCountryCallingCode)) {
        country = countryOrCountryCallingCode;
        metadata.selectNumberingPlan(country);
        countryCallingCode = metadata.countryCallingCode();
    } else {
        countryCallingCode = countryOrCountryCallingCode;
        /* istanbul ignore if */ if ($686291360e3beccf$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
            if (metadata.isNonGeographicCallingCode(countryCallingCode)) country = "001";
        }
    }
    return {
        country: country,
        countryCallingCode: countryCallingCode
    };
}





var $00f9418aa89d453f$var$CAPTURING_DIGIT_PATTERN = new RegExp("([" + (0, $37eb819a63618324$export$852d1d4a47329634) + "])");
function $00f9418aa89d453f$export$2e2bcd8739ae039(number, country, callingCode, metadata) {
    if (!country) return;
     // Check if the number is IDD-prefixed.
    var countryMetadata = new (0, $3542b2b23489a694$export$2e2bcd8739ae039)(metadata);
    countryMetadata.selectNumberingPlan(country, callingCode);
    var IDDPrefixPattern = new RegExp(countryMetadata.IDDPrefix());
    if (number.search(IDDPrefixPattern) !== 0) return;
     // Strip IDD prefix.
    number = number.slice(number.match(IDDPrefixPattern)[0].length); // If there're any digits after an IDD prefix,
    // then those digits are a country calling code.
    // Since no country code starts with a `0`,
    // the code below validates that the next digit (if present) is not `0`.
    var matchedGroups = number.match($00f9418aa89d453f$var$CAPTURING_DIGIT_PATTERN);
    if (matchedGroups && matchedGroups[1] != null && matchedGroups[1].length > 0) {
        if (matchedGroups[1] === "0") return;
    }
    return number;
}




/**
 * Strips any national prefix (such as 0, 1) present in a
 * (possibly incomplete) number provided.
 * "Carrier codes" are only used  in Colombia and Brazil,
 * and only when dialing within those countries from a mobile phone to a fixed line number.
 * Sometimes it won't actually strip national prefix
 * and will instead prepend some digits to the `number`:
 * for example, when number `2345678` is passed with `VI` country selected,
 * it will return `{ number: "3402345678" }`, because `340` area code is prepended.
 * @param {string} number — National number digits.
 * @param {object} metadata — Metadata with country selected.
 * @return {object} `{ nationalNumber: string, nationalPrefix: string? carrierCode: string? }`. Even if a national prefix was extracted, it's not necessarily present in the returned object, so don't rely on its presence in the returned object in order to find out whether a national prefix has been extracted or not.
 */ function $8cdb55b07ba59ef7$export$2e2bcd8739ae039(number, metadata) {
    if (number && metadata.numberingPlan.nationalPrefixForParsing()) {
        // See METADATA.md for the description of
        // `national_prefix_for_parsing` and `national_prefix_transform_rule`.
        // Attempt to parse the first digits as a national prefix.
        var prefixPattern = new RegExp("^(?:" + metadata.numberingPlan.nationalPrefixForParsing() + ")");
        var prefixMatch = prefixPattern.exec(number);
        if (prefixMatch) {
            var nationalNumber;
            var carrierCode; // https://gitlab.com/catamphetamine/libphonenumber-js/-/blob/master/METADATA.md#national_prefix_for_parsing--national_prefix_transform_rule
            // If a `national_prefix_for_parsing` has any "capturing groups"
            // then it means that the national (significant) number is equal to
            // those "capturing groups" transformed via `national_prefix_transform_rule`,
            // and nothing could be said about the actual national prefix:
            // what is it and was it even there.
            // If a `national_prefix_for_parsing` doesn't have any "capturing groups",
            // then everything it matches is a national prefix.
            // To determine whether `national_prefix_for_parsing` matched any
            // "capturing groups", the value of the result of calling `.exec()`
            // is looked at, and if it has non-undefined values where there're
            // "capturing groups" in the regular expression, then it means
            // that "capturing groups" have been matched.
            // It's not possible to tell whether there'll be any "capturing gropus"
            // before the matching process, because a `national_prefix_for_parsing`
            // could exhibit both behaviors.
            var capturedGroupsCount = prefixMatch.length - 1;
            var hasCapturedGroups = capturedGroupsCount > 0 && prefixMatch[capturedGroupsCount];
            if (metadata.nationalPrefixTransformRule() && hasCapturedGroups) {
                nationalNumber = number.replace(prefixPattern, metadata.nationalPrefixTransformRule()); // If there's more than one captured group,
                // then carrier code is the second one.
                if (capturedGroupsCount > 1) carrierCode = prefixMatch[1];
            } else {
                // `prefixBeforeNationalNumber` is the whole substring matched by
                // the `national_prefix_for_parsing` regular expression.
                // There seem to be no guarantees that it's just a national prefix.
                // For example, if there's a carrier code, it's gonna be a
                // part of `prefixBeforeNationalNumber` too.
                var prefixBeforeNationalNumber = prefixMatch[0];
                nationalNumber = number.slice(prefixBeforeNationalNumber.length); // If there's at least one captured group,
                // then carrier code is the first one.
                if (hasCapturedGroups) carrierCode = prefixMatch[1];
            } // Tries to guess whether a national prefix was present in the input.
            // This is not something copy-pasted from Google's library:
            // they don't seem to have an equivalent for that.
            // So this isn't an "officially approved" way of doing something like that.
            // But since there seems no other existing method, this library uses it.
            var nationalPrefix;
            if (hasCapturedGroups) {
                var possiblePositionOfTheFirstCapturedGroup = number.indexOf(prefixMatch[1]);
                var possibleNationalPrefix = number.slice(0, possiblePositionOfTheFirstCapturedGroup); // Example: an Argentinian (AR) phone number `0111523456789`.
                // `prefixMatch[0]` is `01115`, and `$1` is `11`,
                // and the rest of the phone number is `23456789`.
                // The national number is transformed via `9$1` to `91123456789`.
                // National prefix `0` is detected being present at the start.
                // if (possibleNationalPrefix.indexOf(metadata.numberingPlan.nationalPrefix()) === 0) {
                if (possibleNationalPrefix === metadata.numberingPlan.nationalPrefix()) nationalPrefix = metadata.numberingPlan.nationalPrefix();
            } else nationalPrefix = prefixMatch[0];
            return {
                nationalNumber: nationalNumber,
                nationalPrefix: nationalPrefix,
                carrierCode: carrierCode
            };
        }
    }
    return {
        nationalNumber: number
    };
}




function $3040a9e625083371$export$2e2bcd8739ae039(number, metadata) {
    // Parsing national prefixes and carrier codes
    // is only required for local phone numbers
    // but some people don't understand that
    // and sometimes write international phone numbers
    // with national prefixes (or maybe even carrier codes).
    // http://ucken.blogspot.ru/2016/03/trunk-prefixes-in-skype4b.html
    // Google's original library forgives such mistakes
    // and so does this library, because it has been requested:
    // https://github.com/catamphetamine/libphonenumber-js/issues/127
    var _extractNationalNumbe = (0, $8cdb55b07ba59ef7$export$2e2bcd8739ae039)(number, metadata), carrierCode = _extractNationalNumbe.carrierCode, nationalNumber = _extractNationalNumbe.nationalNumber;
    if (nationalNumber !== number) {
        if (!$3040a9e625083371$var$shouldHaveExtractedNationalPrefix(number, nationalNumber, metadata)) // Don't strip the national prefix.
        return {
            nationalNumber: number
        };
         // Check the national (significant) number length after extracting national prefix and carrier code.
        // Legacy generated metadata (before `1.0.18`) didn't support the "possible lengths" feature.
        if (metadata.possibleLengths()) {
            // The number remaining after stripping the national prefix and carrier code
            // should be long enough to have a possible length for the country.
            // Otherwise, don't strip the national prefix and carrier code,
            // since the original number could be a valid number.
            // This check has been copy-pasted "as is" from Google's original library:
            // https://github.com/google/libphonenumber/blob/876268eb1ad6cdc1b7b5bef17fc5e43052702d57/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L3236-L3250
            // It doesn't check for the "possibility" of the original `number`.
            // I guess it's fine not checking that one. It works as is anyway.
            if (!$3040a9e625083371$var$isPossibleIncompleteNationalNumber(nationalNumber, metadata)) // Don't strip the national prefix.
            return {
                nationalNumber: number
            };
        }
    }
    return {
        nationalNumber: nationalNumber,
        carrierCode: carrierCode
    };
} // In some countries, the same digit could be a national prefix
// or a leading digit of a valid phone number.
// For example, in Russia, national prefix is `8`,
// and also `800 555 35 35` is a valid number
// in which `8` is not a national prefix, but the first digit
// of a national (significant) number.
// Same's with Belarus:
// `82004910060` is a valid national (significant) number,
// but `2004910060` is not.
// To support such cases (to prevent the code from always stripping
// national prefix), a condition is imposed: a national prefix
// is not extracted when the original number is "viable" and the
// resultant number is not, a "viable" national number being the one
// that matches `national_number_pattern`.
function $3040a9e625083371$var$shouldHaveExtractedNationalPrefix(nationalNumberBefore, nationalNumberAfter, metadata) {
    // The equivalent in Google's code is:
    // https://github.com/google/libphonenumber/blob/e326fa1fc4283bb05eb35cb3c15c18f98a31af33/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L2969-L3004
    if ((0, $7c3045a0d74e1110$export$2e2bcd8739ae039)(nationalNumberBefore, metadata.nationalNumberPattern()) && !(0, $7c3045a0d74e1110$export$2e2bcd8739ae039)(nationalNumberAfter, metadata.nationalNumberPattern())) return false;
     // This "is possible" national number (length) check has been commented out
    // because it's superceded by the (effectively) same check done in the
    // `extractNationalNumber()` function after it calls `shouldHaveExtractedNationalPrefix()`.
    // In other words, why run the same check twice if it could only be run once.
    // // Check the national (significant) number length after extracting national prefix and carrier code.
    // // Fixes a minor "weird behavior" bug: https://gitlab.com/catamphetamine/libphonenumber-js/-/issues/57
    // // (Legacy generated metadata (before `1.0.18`) didn't support the "possible lengths" feature).
    // if (metadata.possibleLengths()) {
    // 	if (isPossibleIncompleteNationalNumber(nationalNumberBefore, metadata) &&
    // 		!isPossibleIncompleteNationalNumber(nationalNumberAfter, metadata)) {
    // 		return false
    // 	}
    // }
    return true;
}
function $3040a9e625083371$var$isPossibleIncompleteNationalNumber(nationalNumber, metadata) {
    switch((0, $e49ad59848e09d3c$export$2e2bcd8739ae039)(nationalNumber, metadata)){
        case "TOO_SHORT":
        case "INVALID_LENGTH":
            // This library ignores "local-only" phone numbers (for simplicity).
            // See the readme for more info on what are "local-only" phone numbers.
            // case 'IS_POSSIBLE_LOCAL_ONLY':
            return false;
        default:
            return true;
    }
}




function $df4aa846077e668c$export$2e2bcd8739ae039(number, country, callingCode, metadata) {
    var countryCallingCode = country ? (0, $3542b2b23489a694$export$32876ca2f1919cf0)(country, metadata) : callingCode;
    if (number.indexOf(countryCallingCode) === 0) {
        metadata = new (0, $3542b2b23489a694$export$2e2bcd8739ae039)(metadata);
        metadata.selectNumberingPlan(country, callingCode);
        var possibleShorterNumber = number.slice(countryCallingCode.length);
        var _extractNationalNumbe = (0, $3040a9e625083371$export$2e2bcd8739ae039)(possibleShorterNumber, metadata), possibleShorterNationalNumber = _extractNationalNumbe.nationalNumber;
        var _extractNationalNumbe2 = (0, $3040a9e625083371$export$2e2bcd8739ae039)(number, metadata), nationalNumber = _extractNationalNumbe2.nationalNumber; // If the number was not valid before but is valid now,
        // or if it was too long before, we consider the number
        // with the country calling code stripped to be a better result
        // and keep that instead.
        // For example, in Germany (+49), `49` is a valid area code,
        // so if a number starts with `49`, it could be both a valid
        // national German number or an international number without
        // a leading `+`.
        if (!(0, $7c3045a0d74e1110$export$2e2bcd8739ae039)(nationalNumber, metadata.nationalNumberPattern()) && (0, $7c3045a0d74e1110$export$2e2bcd8739ae039)(possibleShorterNationalNumber, metadata.nationalNumberPattern()) || (0, $e49ad59848e09d3c$export$2e2bcd8739ae039)(nationalNumber, metadata) === "TOO_LONG") return {
            countryCallingCode: countryCallingCode,
            number: possibleShorterNumber
        };
    }
    return {
        number: number
    };
}




function $82234a27313b6bed$export$2e2bcd8739ae039(number, country, callingCode, metadata) {
    if (!number) return {};
    var isNumberWithIddPrefix; // If this is not an international phone number,
    // then either extract an "IDD" prefix, or extract a
    // country calling code from a number by autocorrecting it
    // by prepending a leading `+` in cases when it starts
    // with the country calling code.
    // https://wikitravel.org/en/International_dialling_prefix
    // https://github.com/catamphetamine/libphonenumber-js/issues/376
    if (number[0] !== "+") {
        // Convert an "out-of-country" dialing phone number
        // to a proper international phone number.
        var numberWithoutIDD = (0, $00f9418aa89d453f$export$2e2bcd8739ae039)(number, country, callingCode, metadata); // If an IDD prefix was stripped then
        // convert the number to international one
        // for subsequent parsing.
        if (numberWithoutIDD && numberWithoutIDD !== number) {
            isNumberWithIddPrefix = true;
            number = "+" + numberWithoutIDD;
        } else {
            // Check to see if the number starts with the country calling code
            // for the default country. If so, we remove the country calling code,
            // and do some checks on the validity of the number before and after.
            // https://github.com/catamphetamine/libphonenumber-js/issues/376
            if (country || callingCode) {
                var _extractCountryCallin = (0, $df4aa846077e668c$export$2e2bcd8739ae039)(number, country, callingCode, metadata), countryCallingCode = _extractCountryCallin.countryCallingCode, shorterNumber = _extractCountryCallin.number;
                if (countryCallingCode) return {
                    countryCallingCodeSource: "FROM_NUMBER_WITHOUT_PLUS_SIGN",
                    countryCallingCode: countryCallingCode,
                    number: shorterNumber
                };
            }
            return {
                // No need to set it to `UNSPECIFIED`. It can be just `undefined`.
                // countryCallingCodeSource: 'UNSPECIFIED',
                number: number
            };
        }
    } // Fast abortion: country codes do not begin with a '0'
    if (number[1] === "0") return {};
    metadata = new (0, $3542b2b23489a694$export$2e2bcd8739ae039)(metadata); // The thing with country phone codes
    // is that they are orthogonal to each other
    // i.e. there's no such country phone code A
    // for which country phone code B exists
    // where B starts with A.
    // Therefore, while scanning digits,
    // if a valid country code is found,
    // that means that it is the country code.
    //
    var i = 2;
    while(i - 1 <= (0, $37eb819a63618324$export$514717690676fb4a) && i <= number.length){
        var _countryCallingCode = number.slice(1, i);
        if (metadata.hasCallingCode(_countryCallingCode)) {
            metadata.selectNumberingPlan(_countryCallingCode);
            return {
                countryCallingCodeSource: isNumberWithIddPrefix ? "FROM_NUMBER_WITH_IDD" : "FROM_NUMBER_WITH_PLUS_SIGN",
                countryCallingCode: _countryCallingCode,
                number: number.slice(i)
            };
        }
        i++;
    }
    return {};
} // The possible values for the returned `countryCallingCodeSource` are:
 //
 // Copy-pasted from:
 // https://github.com/google/libphonenumber/blob/master/resources/phonenumber.proto
 //
 // // The source from which the country_code is derived. This is not set in the
 // // general parsing method, but in the method that parses and keeps raw_input.
 // // New fields could be added upon request.
 // enum CountryCodeSource {
 //  // Default value returned if this is not set, because the phone number was
 //  // created using parse, not parseAndKeepRawInput. hasCountryCodeSource will
 //  // return false if this is the case.
 //  UNSPECIFIED = 0;
 //
 //  // The country_code is derived based on a phone number with a leading "+",
 //  // e.g. the French number "+33 1 42 68 53 00".
 //  FROM_NUMBER_WITH_PLUS_SIGN = 1;
 //
 //  // The country_code is derived based on a phone number with a leading IDD,
 //  // e.g. the French number "011 33 1 42 68 53 00", as it is dialled from US.
 //  FROM_NUMBER_WITH_IDD = 5;
 //
 //  // The country_code is derived based on a phone number without a leading
 //  // "+", e.g. the French number "33 1 42 68 53 00" when defaultCountry is
 //  // supplied as France.
 //  FROM_NUMBER_WITHOUT_PLUS_SIGN = 10;
 //
 //  // The country_code is derived NOT based on the phone number itself, but
 //  // from the defaultCountry parameter provided in the parsing function by the
 //  // clients. This happens mostly for numbers written in the national format
 //  // (without country code). For example, this would be set when parsing the
 //  // French number "01 42 68 53 00", when defaultCountry is supplied as
 //  // France.
 //  FROM_DEFAULT_COUNTRY = 20;
 // }






function $cd68acbfb19db38d$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $cd68acbfb19db38d$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $cd68acbfb19db38d$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $cd68acbfb19db38d$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $cd68acbfb19db38d$var$_arrayLikeToArray(o, minLen);
}
function $cd68acbfb19db38d$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $cd68acbfb19db38d$export$2e2bcd8739ae039(nationalPhoneNumber, _ref) {
    var countries = _ref.countries, defaultCountry = _ref.defaultCountry, metadata = _ref.metadata;
    // Re-create `metadata` because it will be selecting a `country`.
    metadata = new (0, $3542b2b23489a694$export$2e2bcd8739ae039)(metadata);
    var matchingCountries = [];
    for(var _iterator = $cd68acbfb19db38d$var$_createForOfIteratorHelperLoose(countries), _step; !(_step = _iterator()).done;){
        var country = _step.value;
        metadata.country(country); // "Leading digits" patterns are only defined for about 20% of all countries.
        // By definition, matching "leading digits" is a sufficient but not a necessary
        // condition for a phone number to belong to a country.
        // The point of "leading digits" check is that it's the fastest one to get a match.
        // https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md#leading_digits
        // I'd suppose that "leading digits" patterns are mutually exclusive for different countries
        // because of the intended use of that feature.
        if (metadata.leadingDigits()) {
            if (nationalPhoneNumber && nationalPhoneNumber.search(metadata.leadingDigits()) === 0) return country;
        } else if ((0, $94c0652204baced1$export$2e2bcd8739ae039)({
            phone: nationalPhoneNumber,
            country: country
        }, undefined, metadata.metadata)) {
            // If the `defaultCountry` is among the `matchingCountries` then return it.
            if (defaultCountry) {
                if (country === defaultCountry) return country;
                matchingCountries.push(country);
            } else return country;
        }
    } // Return the first ("main") one of the `matchingCountries`.
    if (matchingCountries.length > 0) return matchingCountries[0];
}


var $2fc7641cd4ad89ee$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
function $2fc7641cd4ad89ee$export$2e2bcd8739ae039(callingCode, _ref) {
    var nationalPhoneNumber = _ref.nationalNumber, defaultCountry = _ref.defaultCountry, metadata = _ref.metadata;
    /* istanbul ignore if */ if ($2fc7641cd4ad89ee$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
        if (metadata.isNonGeographicCallingCode(callingCode)) return "001";
    }
    var possibleCountries = metadata.getCountryCodesForCallingCode(callingCode);
    if (!possibleCountries) return;
     // If there's just one country corresponding to the country code,
    // then just return it, without further phone number digits validation.
    if (possibleCountries.length === 1) return possibleCountries[0];
    return (0, $cd68acbfb19db38d$export$2e2bcd8739ae039)(nationalPhoneNumber, {
        countries: possibleCountries,
        defaultCountry: defaultCountry,
        metadata: metadata.metadata
    });
}


// When phone numbers are written in `RFC3966` format — `"tel:+12133734253"` —
// they can have their "calling code" part written separately in a `phone-context` parameter.
// Example: `"tel:12133734253;phone-context=+1"`.
// This function parses the full phone number from the local number and the `phone-context`
// when the `phone-context` contains a `+` sign.

var $64817669006155db$export$1ddc7eed78155f68 = "+";
var $64817669006155db$var$RFC3966_VISUAL_SEPARATOR_ = "[\\-\\.\\(\\)]?";
var $64817669006155db$var$RFC3966_PHONE_DIGIT_ = "([" + (0, $37eb819a63618324$export$852d1d4a47329634) + "]" + "|" + $64817669006155db$var$RFC3966_VISUAL_SEPARATOR_ + ")";
var $64817669006155db$var$RFC3966_GLOBAL_NUMBER_DIGITS_ = "^\\" + $64817669006155db$export$1ddc7eed78155f68 + $64817669006155db$var$RFC3966_PHONE_DIGIT_ + "*" + "[" + (0, $37eb819a63618324$export$852d1d4a47329634) + "]" + $64817669006155db$var$RFC3966_PHONE_DIGIT_ + "*" + "$";
/**
 * Regular expression of valid global-number-digits for the phone-context
 * parameter, following the syntax defined in RFC3966.
 */ var $64817669006155db$var$RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_ = new RegExp($64817669006155db$var$RFC3966_GLOBAL_NUMBER_DIGITS_, "g"); // In this port of Google's library, we don't accept alpha characters in phone numbers.
// const ALPHANUM_ = VALID_ALPHA_ + VALID_DIGITS
var $64817669006155db$var$ALPHANUM_ = (0, $37eb819a63618324$export$852d1d4a47329634);
var $64817669006155db$var$RFC3966_DOMAINLABEL_ = "[" + $64817669006155db$var$ALPHANUM_ + "]+((\\-)*[" + $64817669006155db$var$ALPHANUM_ + "])*";
var $64817669006155db$var$VALID_ALPHA_ = "a-zA-Z";
var $64817669006155db$var$RFC3966_TOPLABEL_ = "[" + $64817669006155db$var$VALID_ALPHA_ + "]+((\\-)*[" + $64817669006155db$var$ALPHANUM_ + "])*";
var $64817669006155db$var$RFC3966_DOMAINNAME_ = "^(" + $64817669006155db$var$RFC3966_DOMAINLABEL_ + "\\.)*" + $64817669006155db$var$RFC3966_TOPLABEL_ + "\\.?$";
/**
 * Regular expression of valid domainname for the phone-context parameter,
 * following the syntax defined in RFC3966.
 */ var $64817669006155db$var$RFC3966_DOMAINNAME_PATTERN_ = new RegExp($64817669006155db$var$RFC3966_DOMAINNAME_, "g");
var $64817669006155db$export$70d485ce3f6de783 = "tel:";
var $64817669006155db$export$f6d5879d582c3a27 = ";phone-context=";
var $64817669006155db$export$9e356e12edb00a81 = ";isub=";
function $64817669006155db$export$2e2bcd8739ae039(numberToExtractFrom) {
    var indexOfPhoneContext = numberToExtractFrom.indexOf($64817669006155db$export$f6d5879d582c3a27); // If no phone-context parameter is present
    if (indexOfPhoneContext < 0) return null;
    var phoneContextStart = indexOfPhoneContext + $64817669006155db$export$f6d5879d582c3a27.length; // If phone-context parameter is empty
    if (phoneContextStart >= numberToExtractFrom.length) return "";
    var phoneContextEnd = numberToExtractFrom.indexOf(";", phoneContextStart); // If phone-context is not the last parameter
    if (phoneContextEnd >= 0) return numberToExtractFrom.substring(phoneContextStart, phoneContextEnd);
    else return numberToExtractFrom.substring(phoneContextStart);
}
function $64817669006155db$export$474a4aa22ad6959a(phoneContext) {
    if (phoneContext === null) return true;
    if (phoneContext.length === 0) return false;
     // Does phone-context value match pattern of global-number-digits or domainname.
    return $64817669006155db$var$RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_.test(phoneContext) || $64817669006155db$var$RFC3966_DOMAINNAME_PATTERN_.test(phoneContext);
}



function $212d7fe71c3c24da$export$2e2bcd8739ae039(numberToParse, _ref) {
    var extractFormattedPhoneNumber = _ref.extractFormattedPhoneNumber;
    var phoneContext = (0, $64817669006155db$export$2e2bcd8739ae039)(numberToParse);
    if (!(0, $64817669006155db$export$474a4aa22ad6959a)(phoneContext)) throw new (0, $f05781b554dcd2cc$export$2e2bcd8739ae039)("NOT_A_NUMBER");
    var phoneNumberString;
    if (phoneContext === null) // Extract a possible number from the string passed in.
    // (this strips leading characters that could not be the start of a phone number)
    phoneNumberString = extractFormattedPhoneNumber(numberToParse) || "";
    else {
        phoneNumberString = ""; // If the phone context contains a phone number prefix, we need to capture
        // it, whereas domains will be ignored.
        if (phoneContext.charAt(0) === (0, $64817669006155db$export$1ddc7eed78155f68)) phoneNumberString += phoneContext;
         // Now append everything between the "tel:" prefix and the phone-context.
        // This should include the national number, an optional extension or
        // isdn-subaddress component. Note we also handle the case when "tel:" is
        // missing, as we have seen in some of the phone number inputs.
        // In that case, we append everything from the beginning.
        var indexOfRfc3966Prefix = numberToParse.indexOf((0, $64817669006155db$export$70d485ce3f6de783));
        var indexOfNationalNumber; // RFC 3966 "tel:" prefix is preset at this stage because
        // `isPhoneContextValid()` requires it to be present.
        /* istanbul ignore else */ if (indexOfRfc3966Prefix >= 0) indexOfNationalNumber = indexOfRfc3966Prefix + (0, $64817669006155db$export$70d485ce3f6de783).length;
        else indexOfNationalNumber = 0;
        var indexOfPhoneContext = numberToParse.indexOf((0, $64817669006155db$export$f6d5879d582c3a27));
        phoneNumberString += numberToParse.substring(indexOfNationalNumber, indexOfPhoneContext);
    } // Delete the isdn-subaddress and everything after it if it is present.
    // Note extension won't appear at the same time with isdn-subaddress
    // according to paragraph 5.3 of the RFC3966 spec.
    var indexOfIsdn = phoneNumberString.indexOf((0, $64817669006155db$export$9e356e12edb00a81));
    if (indexOfIsdn > 0) phoneNumberString = phoneNumberString.substring(0, indexOfIsdn);
     // If both phone context and isdn-subaddress are absent but other
    // parameters are present, the parameters are left in nationalNumber.
    // This is because we are concerned about deleting content from a potential
    // number string when there is no strong evidence that the number is
    // actually written in RFC3966.
    if (phoneNumberString !== "") return phoneNumberString;
}


// This prevents malicious input from consuming CPU.
var $99478b52c741e937$var$MAX_INPUT_STRING_LENGTH = 250; // This consists of the plus symbol, digits, and arabic-indic digits.
var $99478b52c741e937$var$PHONE_NUMBER_START_PATTERN = new RegExp("[" + (0, $37eb819a63618324$export$207c99ccf3902df8) + (0, $37eb819a63618324$export$852d1d4a47329634) + "]"); // Regular expression of trailing characters that we want to remove.
// A trailing `#` is sometimes used when writing phone numbers with extensions in US.
// Example: "+1 (645) 123 1234-910#" number has extension "910".
var $99478b52c741e937$var$AFTER_PHONE_NUMBER_END_PATTERN = new RegExp("[^" + (0, $37eb819a63618324$export$852d1d4a47329634) + "#" + "]+$");
var $99478b52c741e937$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false; // Examples:
function $99478b52c741e937$export$2e2bcd8739ae039(text, options, metadata) {
    // If assigning the `{}` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    options = options || {};
    metadata = new (0, $3542b2b23489a694$export$2e2bcd8739ae039)(metadata); // Validate `defaultCountry`.
    if (options.defaultCountry && !metadata.hasCountry(options.defaultCountry)) {
        if (options.v2) throw new (0, $f05781b554dcd2cc$export$2e2bcd8739ae039)("INVALID_COUNTRY");
        throw new Error("Unknown country: ".concat(options.defaultCountry));
    } // Parse the phone number.
    var _parseInput = $99478b52c741e937$var$parseInput(text, options.v2, options.extract), formattedPhoneNumber = _parseInput.number, ext = _parseInput.ext, error = _parseInput.error; // If the phone number is not viable then return nothing.
    if (!formattedPhoneNumber) {
        if (options.v2) {
            if (error === "TOO_SHORT") throw new (0, $f05781b554dcd2cc$export$2e2bcd8739ae039)("TOO_SHORT");
            throw new (0, $f05781b554dcd2cc$export$2e2bcd8739ae039)("NOT_A_NUMBER");
        }
        return {};
    }
    var _parsePhoneNumber = $99478b52c741e937$var$parsePhoneNumber(formattedPhoneNumber, options.defaultCountry, options.defaultCallingCode, metadata), country = _parsePhoneNumber.country, nationalNumber = _parsePhoneNumber.nationalNumber, countryCallingCode = _parsePhoneNumber.countryCallingCode, countryCallingCodeSource = _parsePhoneNumber.countryCallingCodeSource, carrierCode = _parsePhoneNumber.carrierCode;
    if (!metadata.hasSelectedNumberingPlan()) {
        if (options.v2) throw new (0, $f05781b554dcd2cc$export$2e2bcd8739ae039)("INVALID_COUNTRY");
        return {};
    } // Validate national (significant) number length.
    if (!nationalNumber || nationalNumber.length < (0, $37eb819a63618324$export$cd8355bcbe13154)) {
        // Won't throw here because the regexp already demands length > 1.
        /* istanbul ignore if */ if (options.v2) throw new (0, $f05781b554dcd2cc$export$2e2bcd8739ae039)("TOO_SHORT");
         // Google's demo just throws an error in this case.
        return {};
    } // Validate national (significant) number length.
    //
    // A sidenote:
    //
    // They say that sometimes national (significant) numbers
    // can be longer than `MAX_LENGTH_FOR_NSN` (e.g. in Germany).
    // https://github.com/googlei18n/libphonenumber/blob/7e1748645552da39c4e1ba731e47969d97bdb539/resources/phonenumber.proto#L36
    // Such numbers will just be discarded.
    //
    if (nationalNumber.length > (0, $37eb819a63618324$export$85ddd8c9b243679b)) {
        if (options.v2) throw new (0, $f05781b554dcd2cc$export$2e2bcd8739ae039)("TOO_LONG");
         // Google's demo just throws an error in this case.
        return {};
    }
    if (options.v2) {
        var phoneNumber = new (0, $686291360e3beccf$export$2e2bcd8739ae039)(countryCallingCode, nationalNumber, metadata.metadata);
        if (country) phoneNumber.country = country;
        if (carrierCode) phoneNumber.carrierCode = carrierCode;
        if (ext) phoneNumber.ext = ext;
        phoneNumber.__countryCallingCodeSource = countryCallingCodeSource;
        return phoneNumber;
    } // Check if national phone number pattern matches the number.
    // National number pattern is different for each country,
    // even for those ones which are part of the "NANPA" group.
    var valid = (options.extended ? metadata.hasSelectedNumberingPlan() : country) ? (0, $7c3045a0d74e1110$export$2e2bcd8739ae039)(nationalNumber, metadata.nationalNumberPattern()) : false;
    if (!options.extended) return valid ? $99478b52c741e937$var$result(country, nationalNumber, ext) : {};
     // isInternational: countryCallingCode !== undefined
    return {
        country: country,
        countryCallingCode: countryCallingCode,
        carrierCode: carrierCode,
        valid: valid,
        possible: valid ? true : options.extended === true && metadata.possibleLengths() && (0, $284b24a180d5a5a9$export$4f8890cedf1e0497)(nationalNumber, metadata) ? true : false,
        phone: nationalNumber,
        ext: ext
    };
}
/**
 * Extracts a formatted phone number from text.
 * Doesn't guarantee that the extracted phone number
 * is a valid phone number (for example, doesn't validate its length).
 * @param  {string} text
 * @param  {boolean} [extract] — If `false`, then will parse the entire `text` as a phone number.
 * @param  {boolean} [throwOnError] — By default, it won't throw if the text is too long.
 * @return {string}
 * @example
 * // Returns "(213) 373-4253".
 * extractFormattedPhoneNumber("Call (213) 373-4253 for assistance.")
 */ function $99478b52c741e937$var$_extractFormattedPhoneNumber(text, extract, throwOnError) {
    if (!text) return;
    if (text.length > $99478b52c741e937$var$MAX_INPUT_STRING_LENGTH) {
        if (throwOnError) throw new (0, $f05781b554dcd2cc$export$2e2bcd8739ae039)("TOO_LONG");
        return;
    }
    if (extract === false) return text;
     // Attempt to extract a possible number from the string passed in
    var startsAt = text.search($99478b52c741e937$var$PHONE_NUMBER_START_PATTERN);
    if (startsAt < 0) return;
    return text // Trim everything to the left of the phone number
    .slice(startsAt) // Remove trailing non-numerical characters
    .replace($99478b52c741e937$var$AFTER_PHONE_NUMBER_END_PATTERN, "");
}
/**
 * @param  {string} text - Input.
 * @param  {boolean} v2 - Legacy API functions don't pass `v2: true` flag.
 * @param  {boolean} [extract] - Whether to extract a phone number from `text`, or attempt to parse the entire text as a phone number.
 * @return {object} `{ ?number, ?ext }`.
 */ function $99478b52c741e937$var$parseInput(text, v2, extract) {
    // // Parse RFC 3966 phone number URI.
    // if (text && text.indexOf('tel:') === 0) {
    // 	return parseRFC3966(text)
    // }
    // let number = extractFormattedPhoneNumber(text, extract, v2)
    var number = (0, $212d7fe71c3c24da$export$2e2bcd8739ae039)(text, {
        extractFormattedPhoneNumber: function extractFormattedPhoneNumber(text) {
            return $99478b52c741e937$var$_extractFormattedPhoneNumber(text, extract, v2);
        }
    }); // If the phone number is not viable, then abort.
    if (!number) return {};
    if (!(0, $c76e1434e0d3cfc5$export$2e2bcd8739ae039)(number)) {
        if ((0, $c76e1434e0d3cfc5$export$4c3f76c95c05197c)(number)) return {
            error: "TOO_SHORT"
        };
        return {};
    } // Attempt to parse extension first, since it doesn't require region-specific
    // data and we want to have the non-normalised number here.
    var withExtensionStripped = (0, $36eb7721bd8daaf6$export$2e2bcd8739ae039)(number);
    if (withExtensionStripped.ext) return withExtensionStripped;
    return {
        number: number
    };
}
/**
 * Creates `parse()` result object.
 */ function $99478b52c741e937$var$result(country, nationalNumber, ext) {
    var result = {
        country: country,
        phone: nationalNumber
    };
    if (ext) result.ext = ext;
    return result;
}
/**
 * Parses a viable phone number.
 * @param {string} formattedPhoneNumber — Example: "(213) 373-4253".
 * @param {string} [defaultCountry]
 * @param {string} [defaultCallingCode]
 * @param {Metadata} metadata
 * @return {object} Returns `{ country: string?, countryCallingCode: string?, nationalNumber: string? }`.
 */ function $99478b52c741e937$var$parsePhoneNumber(formattedPhoneNumber, defaultCountry, defaultCallingCode, metadata) {
    // Extract calling code from phone number.
    var _extractCountryCallin = (0, $82234a27313b6bed$export$2e2bcd8739ae039)((0, $a92c8bfd77016633$export$2e2bcd8739ae039)(formattedPhoneNumber), defaultCountry, defaultCallingCode, metadata.metadata), countryCallingCodeSource = _extractCountryCallin.countryCallingCodeSource, countryCallingCode = _extractCountryCallin.countryCallingCode, number = _extractCountryCallin.number; // Choose a country by `countryCallingCode`.
    var country;
    if (countryCallingCode) metadata.selectNumberingPlan(countryCallingCode);
    else if (number && (defaultCountry || defaultCallingCode)) {
        metadata.selectNumberingPlan(defaultCountry, defaultCallingCode);
        if (defaultCountry) country = defaultCountry;
        else {
            /* istanbul ignore if */ if ($99478b52c741e937$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
                if (metadata.isNonGeographicCallingCode(defaultCallingCode)) country = "001";
            }
        }
        countryCallingCode = defaultCallingCode || (0, $3542b2b23489a694$export$32876ca2f1919cf0)(defaultCountry, metadata.metadata);
    } else return {};
    if (!number) return {
        countryCallingCodeSource: countryCallingCodeSource,
        countryCallingCode: countryCallingCode
    };
    var _extractNationalNumbe = (0, $3040a9e625083371$export$2e2bcd8739ae039)((0, $a92c8bfd77016633$export$2e2bcd8739ae039)(number), metadata), nationalNumber = _extractNationalNumbe.nationalNumber, carrierCode = _extractNationalNumbe.carrierCode; // Sometimes there are several countries
    // corresponding to the same country phone code
    // (e.g. NANPA countries all having `1` country phone code).
    // Therefore, to reliably determine the exact country,
    // national (significant) number should have been parsed first.
    //
    // When `metadata.json` is generated, all "ambiguous" country phone codes
    // get their countries populated with the full set of
    // "phone number type" regular expressions.
    //
    var exactCountry = (0, $2fc7641cd4ad89ee$export$2e2bcd8739ae039)(countryCallingCode, {
        nationalNumber: nationalNumber,
        defaultCountry: defaultCountry,
        metadata: metadata
    });
    if (exactCountry) {
        country = exactCountry;
        /* istanbul ignore if */ if (exactCountry === "001") ;
        else metadata.country(country);
    }
    return {
        country: country,
        countryCallingCode: countryCallingCode,
        countryCallingCodeSource: countryCallingCodeSource,
        nationalNumber: nationalNumber,
        carrierCode: carrierCode
    };
}


function $a674a010695c093f$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a674a010695c093f$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $a674a010695c093f$var$ownKeys(Object(source), !0).forEach(function(key) {
            $a674a010695c093f$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $a674a010695c093f$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $a674a010695c093f$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a674a010695c093f$export$2e2bcd8739ae039(text, options, metadata) {
    return (0, $99478b52c741e937$export$2e2bcd8739ae039)(text, $a674a010695c093f$var$_objectSpread($a674a010695c093f$var$_objectSpread({}, options), {}, {
        v2: true
    }), metadata);
}



function $d5516a9ef8573853$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d5516a9ef8573853$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $d5516a9ef8573853$var$ownKeys(Object(source), !0).forEach(function(key) {
            $d5516a9ef8573853$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $d5516a9ef8573853$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $d5516a9ef8573853$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $d5516a9ef8573853$var$_slicedToArray(arr, i) {
    return $d5516a9ef8573853$var$_arrayWithHoles(arr) || $d5516a9ef8573853$var$_iterableToArrayLimit(arr, i) || $d5516a9ef8573853$var$_unsupportedIterableToArray(arr, i) || $d5516a9ef8573853$var$_nonIterableRest();
}
function $d5516a9ef8573853$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $d5516a9ef8573853$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $d5516a9ef8573853$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $d5516a9ef8573853$var$_arrayLikeToArray(o, minLen);
}
function $d5516a9ef8573853$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $d5516a9ef8573853$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $d5516a9ef8573853$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $d5516a9ef8573853$export$2e2bcd8739ae039(args) {
    var _Array$prototype$slic = Array.prototype.slice.call(args), _Array$prototype$slic2 = $d5516a9ef8573853$var$_slicedToArray(_Array$prototype$slic, 4), arg_1 = _Array$prototype$slic2[0], arg_2 = _Array$prototype$slic2[1], arg_3 = _Array$prototype$slic2[2], arg_4 = _Array$prototype$slic2[3];
    var text;
    var options;
    var metadata; // If the phone number is passed as a string.
    // `parsePhoneNumber('88005553535', ...)`.
    if (typeof arg_1 === "string") text = arg_1;
    else throw new TypeError("A text for parsing must be a string."); // If "default country" argument is being passed then move it to `options`.
    // `parsePhoneNumber('88005553535', 'RU', [options], metadata)`.
    if (!arg_2 || typeof arg_2 === "string") {
        if (arg_4) {
            options = arg_3;
            metadata = arg_4;
        } else {
            options = undefined;
            metadata = arg_3;
        }
        if (arg_2) options = $d5516a9ef8573853$var$_objectSpread({
            defaultCountry: arg_2
        }, options);
    } else if ((0, $d814e6c2374b27a6$export$2e2bcd8739ae039)(arg_2)) {
        if (arg_3) {
            options = arg_2;
            metadata = arg_3;
        } else metadata = arg_2;
    } else throw new Error("Invalid second argument: ".concat(arg_2));
    return {
        text: text,
        options: options,
        metadata: metadata
    };
}


function $c832506221b95168$export$2e2bcd8739ae039() {
    var _normalizeArguments = (0, $d5516a9ef8573853$export$2e2bcd8739ae039)(arguments), text = _normalizeArguments.text, options = _normalizeArguments.options, metadata = _normalizeArguments.metadata;
    return (0, $a674a010695c093f$export$2e2bcd8739ae039)(text, options, metadata);
}


function $3d3f88f14db28728$export$176bb591929cc9a8() {
    return (0, $58067136b6929952$export$2e2bcd8739ae039)((0, $c832506221b95168$export$2e2bcd8739ae039), arguments);
}


const $13c4948701a0f05e$export$da44e4eaa54bc82e = (phone)=>{
    try {
        return (0, $3d3f88f14db28728$export$176bb591929cc9a8)(phone).number.slice(1);
    } catch (e) {
        console.error(`Invalid phone number: ${phone}`);
        return phone;
    }
};
const $13c4948701a0f05e$export$d79b62bd58081ca4 = (phone)=>{
    try {
        const phoneNumber = phone.startsWith("+") ? phone : `+${phone}`;
        return (0, $3d3f88f14db28728$export$176bb591929cc9a8)(phoneNumber).formatInternational();
    } catch (e) {
        console.error(`Invalid phone number: ${phone}`);
        return phone;
    }
};


const $c802d38300abe43f$export$b86884fca6ca2c21 = ({ name: name, username: username, primaryEmail: primaryEmail, primaryPhone: primaryPhone })=>{
    const formattedPhoneNumber = (0, $dd763c2393b0d659$export$c327da55a124987a)(primaryPhone && (0, $13c4948701a0f05e$export$d79b62bd58081ca4)(primaryPhone));
    var _ref, _ref1, _ref2;
    return (_ref2 = (_ref1 = (_ref = name !== null && name !== void 0 ? name : primaryEmail) !== null && _ref !== void 0 ? _ref : formattedPhoneNumber) !== null && _ref1 !== void 0 ? _ref1 : username) !== null && _ref2 !== void 0 ? _ref2 : undefined;
};



/**
 * Checks if the subdomain string is valid
 * @param subdomain subdomain string
 * @returns boolean indicating whether the subdomain is valid
 */ const $eeb097e4aafff1b8$export$7621d68d5c3b3a53 = (subdomain)=>/^([\da-z]([\da-z-]{0,61}[\da-z])?)$/.test(subdomain);






// Use lowercase letters for tenant IDs to improve compatibility
const $8a392054c7b92f52$var$generateTenantId = ()=>(0, $89790267634015cc$export$7e648d54e633633e)(6);
const $8a392054c7b92f52$export$ac26273771c70863 = (databaseName, tenantId = $8a392054c7b92f52$var$generateTenantId())=>{
    const parentRole = `logto_tenant_${databaseName}`;
    const role = `logto_tenant_${databaseName}_${tenantId}`;
    const password = (0, $89790267634015cc$export$7e648d54e633633e)(32);
    return {
        id: tenantId,
        parentRole: parentRole,
        role: role,
        password: password
    };
};




const $951146edf6ec24ed$export$fd24084cc418abf6 = Object.freeze({
    200: "OK",
    201: "Created",
    202: "Accepted",
    203: "Non-Authoritative Information",
    204: "No Content",
    205: "Reset Content",
    206: "Partial Content",
    300: "Multiple Choices",
    301: "Moved Permanently",
    302: "Found",
    303: "See Other",
    304: "Not Modified",
    305: "Use Proxy",
    306: "Unused",
    307: "Temporary Redirect",
    400: "Bad Request",
    401: "Unauthorized",
    402: "Payment Required",
    403: "Forbidden",
    404: "Not Found",
    405: "Method Not Allowed",
    406: "Not Acceptable",
    407: "Proxy Authentication Required",
    408: "Request Timeout",
    409: "Conflict",
    410: "Gone",
    411: "Length Required",
    412: "Precondition Required",
    413: "Request Entry Too Large",
    414: "Request-URI Too Long",
    415: "Unsupported Media Type",
    416: "Requested Range Not Satisfiable",
    417: "Expectation Failed",
    418: "I'm a teapot",
    422: "Unprocessable Content",
    429: "Too Many Requests",
    500: "Internal Server Error",
    501: "Not Implemented",
    502: "Bad Gateway",
    503: "Service Unavailable",
    504: "Gateway Timeout",
    505: "HTTP Version Not Supported"
});




const $f1330bf4da2f84ef$export$72f2527c55497f9e = ()=>(0, $7ebb618db3110393$export$7a668e70ea2210d9)(undefined);
const $f1330bf4da2f84ef$export$3411cedb68d31149 = ()=>{
    if (!$f1330bf4da2f84ef$export$72f2527c55497f9e()) throw new Error("This function should only be called in integration tests");
    return Object.freeze([
        "123456aA",
        "test_password"
    ]);
};


const $c16ce008c63b69bd$export$5fffa90e2e38377b = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    length: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
        min: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).number().int().min(1).default(8),
        max: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).number().int().min(1).default(256)
    }).default({}),
    characterTypes: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
        min: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).number().int().min(1).max(4).optional().default(1)
    }).default({}),
    rejects: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
        pwned: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).boolean().default(true),
        repetitionAndSequence: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).boolean().default(true),
        userInfo: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).boolean().default(true),
        words: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().array().default([])
    }).default({})
});
class $c16ce008c63b69bd$export$d2f225c121fa68bd {
    /** Get the length threshold for checking restricted phrases. */ static getRestrictedPhraseThreshold(password) {
        const { restrictedPhrasesTolerance: restrictedPhrasesTolerance } = $c16ce008c63b69bd$export$d2f225c121fa68bd;
        return Math.max(1, password.length - restrictedPhrasesTolerance);
    }
    /**
     * Check if a password meets all the policy requirements.
     *
     * @param password - Password to check.
     * @param userInfo - User information to check. Required if the policy
     * requires to reject passwords that include user information.
     * @returns An array of issues. If the password meets the policy, an empty array will be returned.
     * @throws TypeError - If the policy requires to reject passwords that include user information
     * but the user information is not provided.
     */ /* eslint-disable @silverhand/fp/no-let, @silverhand/fp/no-mutation, @silverhand/fp/no-mutating-methods */ async check(password, userInfo) {
        const issues = this.fastCheck(password);
        if (this.policy.rejects.pwned && await this.hasBeenPwned(password)) issues.push({
            code: "password_rejected.pwned"
        });
        // `hashArray[i]` indicates whether the `i`th character violates the restriction.
        // We'll gradually set the value to `1` if needed.
        // The algorithm time complexity should be O(n^2), but it's fast enough for a password.
        const hashArray = Array.from({
            length: password.length
        }).fill(0);
        const issueCodes = new Set();
        const { repetitionAndSequence: repetitionAndSequence, words: words, userInfo: rejectUserInfo } = this.policy.rejects;
        const rejectWords = words.length > 0;
        const fillHashArray = (startIndex, length, code)=>{
            if (length <= 0) return;
            for(let i = startIndex; i < startIndex + length; i += 1)hashArray[i] = 1;
            issueCodes.add(code);
        };
        for(let i = 0; i < password.length; i += 1){
            const sliced = password.slice(i);
            if (repetitionAndSequence) {
                fillHashArray(i, this.repetitionLength(sliced), "restricted.repetition");
                fillHashArray(i, this.sequenceLength(sliced), "restricted.sequence");
            }
            if (rejectWords) fillHashArray(i, this.wordLength(sliced), "restricted.words");
            if (rejectUserInfo) {
                if (!userInfo) throw new TypeError("User information data is required to check user information.");
                fillHashArray(i, this.userInfoLength(sliced, userInfo), "restricted.user_info");
            }
        }
        return hashArray.reduce((total, current)=>total + current, 0) > $c16ce008c63b69bd$export$d2f225c121fa68bd.getRestrictedPhraseThreshold(password) ? [
            ...issues,
            ...[
                ...issueCodes
            ].map((code)=>({
                    code: `password_rejected.${code}`
                }))
        ] : issues;
    }
    /* eslint-enable @silverhand/fp/no-let, @silverhand/fp/no-mutation, @silverhand/fp/no-mutating-methods */ /**
     * Perform a fast check to see if the password passes the basic requirements.
     * Only the length and character types will be checked.
     *
     * This method is used for frontend validation.
     *
     * @param password - Password to check.
     * @returns Whether the password passes the basic requirements.
     */ /* eslint-disable @silverhand/fp/no-mutating-methods */ fastCheck(password) {
        const issues = [];
        if (password.length < this.policy.length.min) issues.push({
            code: "password_rejected.too_short",
            interpolation: {
                min: this.policy.length.min
            }
        });
        else if (password.length > this.policy.length.max) issues.push({
            code: "password_rejected.too_long",
            interpolation: {
                max: this.policy.length.max
            }
        });
        const characterTypes = this.checkCharTypes(password);
        if (characterTypes === "unsupported") issues.push({
            code: "password_rejected.unsupported_characters"
        });
        else if (!characterTypes) issues.push({
            code: "password_rejected.character_types",
            interpolation: {
                min: this.policy.characterTypes.min
            }
        });
        return issues;
    }
    /* eslint-enable @silverhand/fp/no-mutating-methods */ /**
     * Check if the given password contains enough character types.
     *
     * @param password - Password to check.
     * @returns Whether the password contains enough character types; or `'unsupported'`
     * if the password contains unsupported characters.
     */ checkCharTypes(password) {
        const characterTypes = new Set();
        for (const char of password){
            if (char >= "a" && char <= "z") characterTypes.add("lowercase");
            else if (char >= "A" && char <= "Z") characterTypes.add("uppercase");
            else if (char >= "0" && char <= "9") characterTypes.add("digits");
            else if ($c16ce008c63b69bd$export$d2f225c121fa68bd.symbols.includes(char)) characterTypes.add("symbols");
            else return "unsupported";
        }
        return characterTypes.size >= this.policy.characterTypes.min;
    }
    /**
     * Check if the given password has been pwned.
     *
     * @param password - Password to check.
     * @returns Whether the password has been pwned.
     */ async hasBeenPwned(password) {
        if ((0, $f1330bf4da2f84ef$export$72f2527c55497f9e)()) return (0, $f1330bf4da2f84ef$export$3411cedb68d31149)().includes(password);
        const hash = await this.subtle.digest("SHA-1", new TextEncoder().encode(password));
        const hashHex = Array.from(new Uint8Array(hash)).map((binary)=>binary.toString(16).padStart(2, "0")).join("");
        const hashPrefix = hashHex.slice(0, 5);
        const hashSuffix = hashHex.slice(5);
        const response = await fetch(`https://api.pwnedpasswords.com/range/${hashPrefix}`);
        const text = await response.text();
        const hashes = text.split("\n");
        const found = hashes.some((hex)=>hex.toLowerCase().startsWith(hashSuffix));
        return found;
    }
    /**
     * Get the length of the repetition at the beginning of the given string.
     * For example, `repetitionLength('aaaaa')` will return `5`.
     *
     * If the length is less than {@link PasswordPolicyChecker.repetitionAndSequenceThreshold},
     * `0` will be returned.
     */ /* eslint-disable @silverhand/fp/no-let, @silverhand/fp/no-mutation */ repetitionLength(password) {
        const { repetitionAndSequenceThreshold: repetitionAndSequenceThreshold } = $c16ce008c63b69bd$export$d2f225c121fa68bd;
        const firstChar = password[0];
        let length = 0;
        if (firstChar === undefined) return 0;
        for (const char of password){
            if (char === firstChar) length += 1;
            else break;
        }
        return length >= repetitionAndSequenceThreshold ? length : 0;
    }
    /* eslint-enable @silverhand/fp/no-let, @silverhand/fp/no-mutation */ /**
     * Get the length of the user information at the beginning of the given string.
     * For example, `userInfoLength('silverhand', { username: 'silverhand' })` will return `10`.
     *
     * For multiple matches, the longest length will be returned.
     */ // eslint-disable-next-line complexity
    userInfoLength(password, userInfo) {
        const lowercased = password.toLowerCase();
        const { name: name, username: username, email: email, phoneNumber: phoneNumber } = userInfo;
        // eslint-disable-next-line @silverhand/fp/no-let
        let length = 0;
        const updateLength = (newLength)=>{
            if (newLength > length) // eslint-disable-next-line @silverhand/fp/no-mutation
            length = newLength;
        };
        if (name) {
            const joined = name.replaceAll(/\s+/g, "");
            // The original name should be the longest string, so we check it first.
            if (lowercased.startsWith(name.toLowerCase())) updateLength(name.length);
            else {
                if (lowercased.startsWith(joined.toLowerCase())) updateLength(joined.length);
                for (const word of name.split(" "))if (lowercased.startsWith(word.toLowerCase())) updateLength(word.length);
            }
        }
        if (username && lowercased.startsWith(username.toLowerCase())) updateLength(username.length);
        if (email) {
            const emailPrefix = email.split("@")[0];
            if (emailPrefix && lowercased.startsWith(emailPrefix.toLowerCase())) updateLength(emailPrefix.length);
        }
        if (phoneNumber && lowercased.startsWith(phoneNumber)) updateLength(phoneNumber.length);
        return length;
    }
    /**
     * Get the length of the word that matches the word list at the beginning of the given string.
     *
     * For multiple matches, the longest length will be returned.
     */ /* eslint-disable @silverhand/fp/no-let, @silverhand/fp/no-mutation */ wordLength(password) {
        const sliced = password.toLowerCase();
        let length = 0;
        for (const word of this.policy.rejects.words)if (sliced.startsWith(word.toLowerCase()) && word.length > length) length = word.length;
        return length;
    }
    /* eslint-enable @silverhand/fp/no-let, @silverhand/fp/no-mutation */ /**
     * Get the length of the sequence at the beginning of the given string.
     * For example, `sequenceLength('12345')` will return `5`.
     *
     * If the length is less than {@link PasswordPolicyChecker.repetitionAndSequenceThreshold},
     * `0` will be returned.
     */ /* eslint-disable @silverhand/fp/no-let, @silverhand/fp/no-mutation */ sequenceLength(password) {
        const { repetitionAndSequenceThreshold: repetitionAndSequenceThreshold } = $c16ce008c63b69bd$export$d2f225c121fa68bd;
        let value = "";
        let length = 0;
        for (const char of password){
            if (!value || this.isSequential(value + char)) {
                value += char;
                length += 1;
            } else break;
        }
        return length >= repetitionAndSequenceThreshold ? length : 0;
    }
    /* eslint-enable @silverhand/fp/no-let, @silverhand/fp/no-mutation */ /**
     * Check if the given string is sequential by iterating through the {@link PasswordPolicyChecker.sequence}.
     */ isSequential(value) {
        const { sequence: sequence } = $c16ce008c63b69bd$export$d2f225c121fa68bd;
        for (const seq of sequence){
            // eslint-disable-next-line @silverhand/fp/no-mutating-methods -- created a new array before mutating
            const reversedSeq = [
                ...seq
            ].reverse().join("");
            if ([
                seq,
                reversedSeq,
                seq.toUpperCase(),
                reversedSeq.toUpperCase()
            ].some((item)=>item.includes(value))) return true;
        }
        return false;
    }
    constructor(policy, /** The Web Crypto API to use. By default, the global `crypto.subtle` will be used. */ subtle = crypto.subtle){
        this.subtle = subtle;
        this.policy = $c16ce008c63b69bd$export$5fffa90e2e38377b.parse(policy);
    }
}
(()=>{
    $c16ce008c63b69bd$export$d2f225c121fa68bd.symbols = Object.freeze("!\"#$%&'()*+,-./:;<=>?@[\\]^_`{|}~ ");
})();
(()=>{
    $c16ce008c63b69bd$export$d2f225c121fa68bd.sequence = Object.freeze([
        "0123456789",
        "abcdefghijklmnopqrstuvwxyz",
        "qwertyuiop",
        "asdfghjkl",
        "zxcvbnm",
        "1qaz",
        "2wsx",
        "3edc",
        "4rfv",
        "5tgb",
        "6yhn",
        "7ujm",
        "8ik",
        "9ol"
    ]);
})();
(()=>{
    $c16ce008c63b69bd$export$d2f225c121fa68bd.repetitionAndSequenceThreshold = 3;
})();
(()=>{
    $c16ce008c63b69bd$export$d2f225c121fa68bd.restrictedPhrasesTolerance = 3;
})();





var $09f813c8a1ce8d76$export$a20c8b5ccf36e075;
(function(LogResult) {
    LogResult["Success"] = "Success";
    LogResult["Error"] = "Error";
})($09f813c8a1ce8d76$export$a20c8b5ccf36e075 || ($09f813c8a1ce8d76$export$a20c8b5ccf36e075 = {}));
const $09f813c8a1ce8d76$export$2938cb1ca9b4e331 = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    key: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
    result: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).nativeEnum($09f813c8a1ce8d76$export$a20c8b5ccf36e075),
    error: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).record((0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(), (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).unknown()).or((0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string()).optional(),
    ip: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().optional(),
    userAgent: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().optional(),
    userId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().optional(),
    applicationId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().optional(),
    sessionId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().optional()
}).catchall((0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).unknown());
const $09f813c8a1ce8d76$export$eee4f836f95656a7 = (0, $c16ce008c63b69bd$export$5fffa90e2e38377b).deepPartial();




const $b3914f7de7f01a2a$export$525df20e0fb1714c = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    userCode: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().optional(),
    uid: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().optional(),
    grantId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().optional()
})/**
     * Try to use `.passthrough()` if type has been fixed.
     * https://github.com/colinhacks/zod/issues/452
     */ .catchall((0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).unknown());
const $b3914f7de7f01a2a$export$2b5eeb3c40bff26b = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    redirectUris: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().refine((url)=>(0, $33c59d0a69c5841e$export$eabdc444ee87166e)(url, "web")).or((0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().refine((url)=>(0, $33c59d0a69c5841e$export$eabdc444ee87166e)(url, "mobile"))).array(),
    postLogoutRedirectUris: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().url().array(),
    logoUri: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().optional()
});
var $b3914f7de7f01a2a$export$35a50069c63f27cc;
(function(CustomClientMetadataKey) {
    CustomClientMetadataKey["CorsAllowedOrigins"] = "corsAllowedOrigins";
    CustomClientMetadataKey["IdTokenTtl"] = "idTokenTtl";
    /** @deprecated Use {@link RefreshTokenTtlInDays} instead. */ CustomClientMetadataKey["RefreshTokenTtl"] = "refreshTokenTtl";
    CustomClientMetadataKey["RefreshTokenTtlInDays"] = "refreshTokenTtlInDays";
    CustomClientMetadataKey["TenantId"] = "tenantId";
    /**
     * Enabling this configuration will allow Logto to always issue Refresh Tokens, regardless of whether `prompt=consent` is presented in the authentication request.
     *
     * It only works for web applications when the client allowed grant types includes `refresh_token`.
     *
     * This config is for the third-party integrations that do not strictly follow OpenID Connect standards due to some reasons (e.g. they only know OAuth, but requires a Refresh Token to be returned anyway).
     */ CustomClientMetadataKey["AlwaysIssueRefreshToken"] = "alwaysIssueRefreshToken";
    /**
     * When enabled (default), Logto will issue a new Refresh Token for token requests when 70% of the original Time to Live (TTL) has passed.
     *
     * It can be turned off for only traditional web apps for enhanced security.
     */ CustomClientMetadataKey["RotateRefreshToken"] = "rotateRefreshToken";
})($b3914f7de7f01a2a$export$35a50069c63f27cc || ($b3914f7de7f01a2a$export$35a50069c63f27cc = {}));
const $b3914f7de7f01a2a$export$44618fabe8266610 = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    [$b3914f7de7f01a2a$export$35a50069c63f27cc.CorsAllowedOrigins]: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).array().optional(),
    [$b3914f7de7f01a2a$export$35a50069c63f27cc.IdTokenTtl]: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).number().optional(),
    [$b3914f7de7f01a2a$export$35a50069c63f27cc.RefreshTokenTtl]: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).number().optional(),
    [$b3914f7de7f01a2a$export$35a50069c63f27cc.RefreshTokenTtlInDays]: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).number().int().min(1).max(90).optional(),
    [$b3914f7de7f01a2a$export$35a50069c63f27cc.TenantId]: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().optional(),
    [$b3914f7de7f01a2a$export$35a50069c63f27cc.AlwaysIssueRefreshToken]: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).boolean().optional(),
    [$b3914f7de7f01a2a$export$35a50069c63f27cc.RotateRefreshToken]: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).boolean().optional()
});



const $4b5ac82527c88c19$export$aea1b2a91583fcef = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).lazy(()=>(0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).record((0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().or($4b5ac82527c88c19$export$aea1b2a91583fcef)));



const $6bd3c4907d3be429$export$d0d68bb9ed2c643d = Object.freeze({
    "af-ZA": "Afrikaans",
    "am-ET": "አማርኛ",
    "ar-AR": "العربية",
    "as-IN": "অসমীয়া",
    "az-AZ": "Azərbaycan dili",
    "be-BY": "Беларуская",
    "bg-BG": "Български",
    "bn-IN": "বাংলা",
    "br-FR": "Brezhoneg",
    "bs-BA": "Bosanski",
    "ca-ES": "Catal\xe0",
    "cb-IQ": "کوردیی ناوەندی",
    "co-FR": "Corsu",
    "cs-CZ": "Čeština",
    "cx-PH": "Bisaya",
    "cy-GB": "Cymraeg",
    "da-DK": "Dansk",
    de: "Deutsch",
    "de-DE": "Deutsch (Deutschland)",
    "el-GR": "Ελληνικά",
    en: "English",
    "en-GB": "English (UK)",
    "en-US": "English (US)",
    "eo-EO": "Esperanto",
    es: "Espa\xf1ol",
    "es-ES": "Espa\xf1ol (Espa\xf1a)",
    "es-419": "Espa\xf1ol (Latinoam\xe9rica)",
    "et-EE": "Eesti",
    "eu-ES": "Euskara",
    "fa-IR": "فارسی",
    "ff-NG": "Fula",
    "fi-FI": "Suomi",
    "fo-FO": "F\xf8royskt",
    fr: "Fran\xe7ais",
    "fr-CA": "Fran\xe7ais (Canada)",
    "fr-FR": "Fran\xe7ais (France)",
    "fy-NL": "Frysk",
    "ga-IE": "Gaeilge",
    "gl-ES": "Galego",
    "gn-PY": "Guarani",
    "gu-IN": "ગુજરાતી",
    "ha-NG": "Hausa",
    "he-IL": "עברית",
    "hi-IN": "हिन्दी",
    "hr-HR": "Hrvatski",
    "ht-HT": "Krey\xf2l Ayisyen",
    "hu-HU": "Magyar",
    "hy-AM": "Հայերեն",
    "id-ID": "Bahasa Indonesia",
    "ik-US": "I\xf1upiatun",
    "is-IS": "\xcdslenska",
    it: "Italiano",
    "it-IT": "Italiano (Italia)",
    "iu-CA": "Inuktitut",
    ja: "日本語",
    "ja-JP": "日本語",
    "ja-KS": "日本語(関西)",
    "jv-ID": "Basa Jawa",
    "ka-GE": "ქართული",
    "kk-KZ": "Қазақша",
    "km-KH": "ភាសាខ្មែរ",
    "kn-IN": "ಕನ್ನಡ",
    ko: "한국어",
    "ko-KR": "한국어",
    "ku-TR": "Kurd\xee (Kurmanc\xee)",
    "ky-KG": "кыргызча",
    "lo-LA": "ພາສາລາວ",
    "lt-LT": "Lietuvių",
    "lv-LV": "Latviešu",
    "mg-MG": "Malagasy",
    "mk-MK": "Македонски",
    "ml-IN": "മലയാളം",
    "mn-MN": "Монгол",
    "mr-IN": "मराठी",
    "ms-MY": "Bahasa Melayu",
    "mt-MT": "Malti",
    "my-MM": "မြန်မာဘာသာ",
    "nb-NO": "Norsk (bokm\xe5l)",
    "ne-NP": "नेपाली",
    "nl-BE": "Vlaams",
    "nl-NL": "Nederlands",
    "nn-NO": "Norsk (nynorsk)",
    "or-IN": "ଓଡ଼ିଆ",
    "pa-IN": "ਪੰਜਾਬੀ",
    "pl-PL": "Polski",
    "ps-AF": "پښتو",
    pt: "portugu\xeas",
    "pt-BR": "Portugu\xeas (Brasil)",
    "pt-PT": "Portugu\xeas (Portugal)",
    "ro-RO": "Rom\xe2nă",
    ru: "Русский",
    "ru-RU": "Русский",
    "rw-RW": "Ikinyarwanda",
    "sc-IT": "Sardu",
    "si-LK": "සිංහල",
    "sk-SK": "Slovenčina",
    "sl-SI": "Slovenščina",
    "sn-ZW": "Shona",
    "sq-AL": "Shqip",
    "sr-RS": "Српски",
    "sv-SE": "Svenska",
    "sw-KE": "Kiswahili",
    "sy-SY": "ܣܘܪܝܝܐ",
    "sz-PL": "ślōnskŏ gŏdka",
    "ta-IN": "தமிழ்",
    "te-IN": "తెలుగు",
    "tg-TJ": "Тоҷикӣ",
    "th-TH": "ภาษาไทย",
    "tl-PH": "Filipino",
    tr: "T\xfcrk\xe7e",
    "tr-TR": "T\xfcrk\xe7e",
    "tt-RU": "Татарча",
    "tz-MA": "ⵜⴰⵎⴰⵣⵉⵖⵜ",
    "uk-UA": "Українська",
    "ur-PK": "اردو",
    "uz-UZ": "O'zbek",
    "vi-VN": "Tiếng Việt",
    zh: "中文",
    "zh-CN": "简体中文",
    "zh-HK": "繁體中文（香港）",
    "zh-MO": "繁體中文（澳門）",
    "zh-TW": "繁體中文（台灣）",
    "zz-TR": "Zaza"
});






const $c6adf4a17941b3cf$export$ab649249f0bfeb57 = (value)=>typeof value === "string" && value in (0, $6bd3c4907d3be429$export$d0d68bb9ed2c643d);
const $c6adf4a17941b3cf$export$2b8b19a59fcec1e6 = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).any().refine((value)=>$c6adf4a17941b3cf$export$ab649249f0bfeb57(value));
function $c6adf4a17941b3cf$export$bcd1dd1f397bba12(value) {
    return (0, $db5e9db6ef1a480f$export$4154a199d7d90455)().transform(()=>value);
}





const $c0e46a7ec45ea8f3$export$5c91807cab7a8dc1 = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    primaryColor: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().regex((0, $ca8ea17c0d092285$export$ad64c5d64b2f359b)),
    isDarkModeEnabled: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).boolean(),
    darkPrimaryColor: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().regex((0, $ca8ea17c0d092285$export$ad64c5d64b2f359b))
});
const $c0e46a7ec45ea8f3$export$c9d0acdc98ac45b = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    logoUrl: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().url().optional(),
    darkLogoUrl: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().url().optional(),
    favicon: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().url().optional()
});
const $c0e46a7ec45ea8f3$export$b8fe26243f8b3b37 = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    autoDetect: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).boolean(),
    fallbackLanguage: (0, $c6adf4a17941b3cf$export$2b8b19a59fcec1e6)
});
var $c0e46a7ec45ea8f3$export$f2322d76aef584c7;
(function(SignInIdentifier) {
    SignInIdentifier["Username"] = "username";
    SignInIdentifier["Email"] = "email";
    SignInIdentifier["Phone"] = "phone";
})($c0e46a7ec45ea8f3$export$f2322d76aef584c7 || ($c0e46a7ec45ea8f3$export$f2322d76aef584c7 = {}));
const $c0e46a7ec45ea8f3$export$fd48acc070c38d7b = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    identifiers: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).nativeEnum($c0e46a7ec45ea8f3$export$f2322d76aef584c7).array(),
    password: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).boolean(),
    verify: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).boolean()
});
const $c0e46a7ec45ea8f3$export$8665c7c0edac5e7a = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    methods: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
        identifier: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).nativeEnum($c0e46a7ec45ea8f3$export$f2322d76aef584c7),
        password: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).boolean(),
        verificationCode: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).boolean(),
        isPasswordPrimary: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).boolean()
    }).array()
});
const $c0e46a7ec45ea8f3$export$276d424b39387296 = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().array();
const $c0e46a7ec45ea8f3$export$7dfc08c51ef177a5 = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).record((0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string());
var $c0e46a7ec45ea8f3$export$c62e7669a75c5961;
(function(MfaFactor) {
    MfaFactor["TOTP"] = "Totp";
    MfaFactor["WebAuthn"] = "WebAuthn";
    MfaFactor["BackupCode"] = "BackupCode";
})($c0e46a7ec45ea8f3$export$c62e7669a75c5961 || ($c0e46a7ec45ea8f3$export$c62e7669a75c5961 = {}));
const $c0e46a7ec45ea8f3$export$10c80e60471dfbfa = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).nativeEnum($c0e46a7ec45ea8f3$export$c62e7669a75c5961).array();
var $c0e46a7ec45ea8f3$export$da22c5f01b0bc81;
(function(MfaPolicy) {
    MfaPolicy["UserControlled"] = "UserControlled";
    MfaPolicy["Mandatory"] = "Mandatory";
})($c0e46a7ec45ea8f3$export$da22c5f01b0bc81 || ($c0e46a7ec45ea8f3$export$da22c5f01b0bc81 = {}));
const $c0e46a7ec45ea8f3$export$74899fc35c1207c8 = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    factors: $c0e46a7ec45ea8f3$export$10c80e60471dfbfa,
    policy: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).nativeEnum($c0e46a7ec45ea8f3$export$da22c5f01b0bc81)
});



var $a0a70058bba8d47e$export$f6585a37d5516193;
(function(SentinelActivityTargetType) {
    SentinelActivityTargetType["User"] = "User";
    SentinelActivityTargetType["App"] = "App";
})($a0a70058bba8d47e$export$f6585a37d5516193 || ($a0a70058bba8d47e$export$f6585a37d5516193 = {}));
const $a0a70058bba8d47e$export$47228912e855c2e6 = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).nativeEnum($a0a70058bba8d47e$export$f6585a37d5516193);
var $a0a70058bba8d47e$export$e4c510688679a019;
(function(SentinelActivityAction) {
    /**
     * The subject tries to pass a verification by inputting a password.
     *
     * For example, a user (subject) who inputted a password (action) to authenticate themselves
     * (target).
     */ SentinelActivityAction["Password"] = "Password";
    /**
     * The subject tries to pass a verification by inputting a verification code.
     *
     * For example, a user (subject) who inputted a verification code (action) to authenticate
     * themselves (target).
     */ SentinelActivityAction["VerificationCode"] = "VerificationCode";
})($a0a70058bba8d47e$export$e4c510688679a019 || ($a0a70058bba8d47e$export$e4c510688679a019 = {}));
const $a0a70058bba8d47e$export$8cdcc536cbf8daf0 = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).nativeEnum($a0a70058bba8d47e$export$e4c510688679a019);
const $a0a70058bba8d47e$export$ef3e193200f88c05 = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).record((0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).unknown());






var $14c8279a521e4ddd$export$dc13b60e2521b1fc;
(function(ConnectorConfigFormItemType) {
    ConnectorConfigFormItemType["Text"] = "Text";
    ConnectorConfigFormItemType["Number"] = "Number";
    ConnectorConfigFormItemType["MultilineText"] = "MultilineText";
    ConnectorConfigFormItemType["Switch"] = "Switch";
    ConnectorConfigFormItemType["Select"] = "Select";
    ConnectorConfigFormItemType["Json"] = "Json";
})($14c8279a521e4ddd$export$dc13b60e2521b1fc || ($14c8279a521e4ddd$export$dc13b60e2521b1fc = {}));
const $14c8279a521e4ddd$var$baseConfigFormItem = {
    key: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
    label: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
    placeholder: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().optional(),
    required: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).boolean().optional(),
    defaultValue: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).unknown().optional(),
    showConditions: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).array((0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
        targetKey: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
        expectValue: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).unknown().optional()
    })).optional(),
    description: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().optional(),
    tooltip: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().optional(),
    isConfidential: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).boolean().optional()
};
const $14c8279a521e4ddd$export$ee34796348b9598a = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).discriminatedUnion("type", [
    (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object((0, $0de5391da8318002$export$581ff339ea0ba762)({
        type: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).literal($14c8279a521e4ddd$export$dc13b60e2521b1fc.Select),
        selectItems: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).array((0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
            value: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
            title: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string()
        }))
    }, $14c8279a521e4ddd$var$baseConfigFormItem)),
    (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object((0, $0de5391da8318002$export$581ff339ea0ba762)({
        type: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).enum([
            $14c8279a521e4ddd$export$dc13b60e2521b1fc.Text,
            $14c8279a521e4ddd$export$dc13b60e2521b1fc.Number,
            $14c8279a521e4ddd$export$dc13b60e2521b1fc.MultilineText,
            $14c8279a521e4ddd$export$dc13b60e2521b1fc.Switch,
            $14c8279a521e4ddd$export$dc13b60e2521b1fc.Json
        ])
    }, $14c8279a521e4ddd$var$baseConfigFormItem))
]);


var $8bf20f642f61a47e$export$2ecd4a627c6913d4;
(function(ConnectorErrorCodes) {
    ConnectorErrorCodes["General"] = "general";
    ConnectorErrorCodes["InvalidMetadata"] = "invalid_metadata";
    ConnectorErrorCodes["UnexpectedType"] = "unexpected_type";
    ConnectorErrorCodes["InvalidConfigGuard"] = "invalid_config_guard";
    ConnectorErrorCodes["InvalidRequestParameters"] = "invalid_request_parameters";
    ConnectorErrorCodes["InsufficientRequestParameters"] = "insufficient_request_parameters";
    ConnectorErrorCodes["InvalidConfig"] = "invalid_config";
    ConnectorErrorCodes["InvalidCertificate"] = "invalid_certificate";
    ConnectorErrorCodes["InvalidResponse"] = "invalid_response";
    /** The template is not found for the given type. */ ConnectorErrorCodes["TemplateNotFound"] = "template_not_found";
    /**
     * The template type is not supported by the connector.
     *
     * @deprecated Connector should be able to handle dynamic template type.
     */ ConnectorErrorCodes["TemplateNotSupported"] = "template_not_supported";
    ConnectorErrorCodes["RateLimitExceeded"] = "rate_limit_exceeded";
    ConnectorErrorCodes["NotImplemented"] = "not_implemented";
    ConnectorErrorCodes["SocialAuthCodeInvalid"] = "social_auth_code_invalid";
    ConnectorErrorCodes["SocialAccessTokenInvalid"] = "social_invalid_access_token";
    ConnectorErrorCodes["SocialIdTokenInvalid"] = "social_invalid_id_token";
    ConnectorErrorCodes["AuthorizationFailed"] = "authorization_failed";
})($8bf20f642f61a47e$export$2ecd4a627c6913d4 || ($8bf20f642f61a47e$export$2ecd4a627c6913d4 = {}));
class $8bf20f642f61a47e$export$1a6b62c5b97f19bd extends Error {
    constructor(code, data){
        const message = `ConnectorError: ${data ? JSON.stringify(data) : code}`;
        super(message);
        this.code = code;
        this.data = typeof data === "string" ? {
            message: data
        } : data;
    }
}





var $a5946dc029c62388$export$e2b8cfc001e78efb;
(function(ConnectorPlatform) {
    ConnectorPlatform["Native"] = "Native";
    ConnectorPlatform["Universal"] = "Universal";
    ConnectorPlatform["Web"] = "Web";
})($a5946dc029c62388$export$e2b8cfc001e78efb || ($a5946dc029c62388$export$e2b8cfc001e78efb = {}));
const $a5946dc029c62388$export$7241e9f50f26948a = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    en: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string()
}).and((0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).record((0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string())).refine((i18nObject)=>{
    const keys = Object.keys(i18nObject);
    if (!keys.includes("en")) return false;
    for (const value of keys){
        if (!(0, $c6adf4a17941b3cf$export$ab649249f0bfeb57)(value)) return false;
    }
    return true;
});
const $a5946dc029c62388$export$7d252e66ae683236 = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    // Social connector platform. TODO: @darcyYe considering remove the nullable and make all the social connector field optional
    platform: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).nativeEnum($a5946dc029c62388$export$e2b8cfc001e78efb).nullable(),
    // Indicates custom connector that follows standard protocol. Currently supported standard connectors are OIDC, OAuth2, and SAML2
    isStandard: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).boolean().optional()
});
const $a5946dc029c62388$export$f7d2da53d88c923c = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    // Unique connector factory id
    id: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
    /* Connector provider. Unique for each provider. Users can have only one social identity per provider
      For Social connectors, it's manually set on connector creation
      For SSO connectors, it's the same as the issuer
    */ target: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
    name: $a5946dc029c62388$export$7241e9f50f26948a,
    description: $a5946dc029c62388$export$7241e9f50f26948a,
    logo: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
    logoDark: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().nullable(),
    readme: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
    configTemplate: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().optional(),
    formItems: (0, $14c8279a521e4ddd$export$ee34796348b9598a).array().optional()
}).merge($a5946dc029c62388$export$7d252e66ae683236).catchall((0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).unknown());
const $a5946dc029c62388$export$155cba4e58565525 = $a5946dc029c62388$export$f7d2da53d88c923c.pick({
    target: true,
    name: true,
    logo: true,
    logoDark: true
}).partial();


var $77c1afb6aeb74e86$export$18dbf40ba8d1d9db;
(function(ConnectorType) {
    ConnectorType["Email"] = "Email";
    ConnectorType["Sms"] = "Sms";
    ConnectorType["Social"] = "Social";
})($77c1afb6aeb74e86$export$18dbf40ba8d1d9db || ($77c1afb6aeb74e86$export$18dbf40ba8d1d9db = {}));


// MARK: SMS + Email connector

var $44d0c2102b73fd43$export$849d15400f87ce3f;
(function(VerificationCodeType) {
    VerificationCodeType["SignIn"] = "SignIn";
    VerificationCodeType["Register"] = "Register";
    VerificationCodeType["ForgotPassword"] = "ForgotPassword";
    VerificationCodeType["Generic"] = "Generic";
    /** @deprecated Use `Generic` type template for sending test sms/email use case */ VerificationCodeType["Test"] = "Test";
})($44d0c2102b73fd43$export$849d15400f87ce3f || ($44d0c2102b73fd43$export$849d15400f87ce3f = {}));
const $44d0c2102b73fd43$export$61cf650ef6de814a = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).nativeEnum($44d0c2102b73fd43$export$849d15400f87ce3f);
var $44d0c2102b73fd43$export$fd0446c06165ed92;
(function(TemplateType) {
    /** The template for sending verification code when user is signing in. */ TemplateType["SignIn"] = "SignIn";
    /** The template for sending verification code when user is registering. */ TemplateType["Register"] = "Register";
    /** The template for sending verification code when user is resetting password. */ TemplateType["ForgotPassword"] = "ForgotPassword";
    /** The template for sending organization invitation. */ TemplateType["OrganizationInvitation"] = "OrganizationInvitation";
    /** The template for generic usage. */ TemplateType["Generic"] = "Generic";
})($44d0c2102b73fd43$export$fd0446c06165ed92 || ($44d0c2102b73fd43$export$fd0446c06165ed92 = {}));
const $44d0c2102b73fd43$export$28d17db1e2f10761 = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).nativeEnum($44d0c2102b73fd43$export$fd0446c06165ed92);
const $44d0c2102b73fd43$export$f9b3e019678b784e = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    code: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().optional(),
    link: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().optional()
}).and((0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).record((0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string()));
const $44d0c2102b73fd43$export$51e0082496d4c1ff = /(https?:\/\/)?(?:www\.)?[\w#%+.:=@~-]{1,256}\.[\d()A-Za-z]{1,6}\b[\w#%&()+./:=?@~-]*/;
const $44d0c2102b73fd43$export$21b1fc3b40375a1b = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    senderName: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().refine((address)=>!$44d0c2102b73fd43$export$51e0082496d4c1ff.test(address), "URL is not allowed in sender name."),
    companyInformation: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().refine((address)=>!$44d0c2102b73fd43$export$51e0082496d4c1ff.test(address), "URL is not allowed in company information."),
    appLogo: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().url()
}).partial();
const $44d0c2102b73fd43$export$d68193cee3e4f305 = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    to: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
    type: $44d0c2102b73fd43$export$28d17db1e2f10761.or($44d0c2102b73fd43$export$61cf650ef6de814a),
    payload: $44d0c2102b73fd43$export$f9b3e019678b784e
});



// Copied from https://github.com/colinhacks/zod#json-type
const $2b3ee26e56fddc99$var$literalSchema = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).union([
    (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
    (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).number(),
    (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).boolean(),
    (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).null()
]);
const $2b3ee26e56fddc99$export$80d8b5946da2a05e = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).lazy(()=>(0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).union([
        $2b3ee26e56fddc99$var$literalSchema,
        (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).array($2b3ee26e56fddc99$export$80d8b5946da2a05e),
        (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).record($2b3ee26e56fddc99$export$80d8b5946da2a05e)
    ]));
const $2b3ee26e56fddc99$export$4ac62c0537cd0db7 = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).record($2b3ee26e56fddc99$export$80d8b5946da2a05e);
const $2b3ee26e56fddc99$export$3788bacea3bf0dba = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    id: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
    email: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().optional(),
    phone: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().optional(),
    name: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().optional(),
    avatar: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().optional(),
    rawData: $2b3ee26e56fddc99$export$80d8b5946da2a05e.optional()
});
const $2b3ee26e56fddc99$export$d09576a05941985c = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    nonce: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
    redirectUri: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
    connectorId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
    connectorFactoryId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
    jti: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
    state: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string()
}).partial()// Accept arbitrary unspecified keys so developers who can not publish @logto/connector-kit can more flexibly utilize connector session.
.catchall((0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).unknown());


var $51009219fec611c3$export$5dbd9b9b0aba9316;
(function(DemoConnector) {
    DemoConnector["Sms"] = "logto-sms";
    DemoConnector["Social"] = "logto-social-demo";
})($51009219fec611c3$export$5dbd9b9b0aba9316 || ($51009219fec611c3$export$5dbd9b9b0aba9316 = {}));
const $51009219fec611c3$export$a1fe89342af5f2bc = Object.freeze([
    $51009219fec611c3$export$5dbd9b9b0aba9316.Sms,
    $51009219fec611c3$export$5dbd9b9b0aba9316.Social
]);
var $51009219fec611c3$export$59c1b079c431ef40;
(function(ServiceConnector) {
    ServiceConnector["Email"] = "logto-email";
})($51009219fec611c3$export$59c1b079c431ef40 || ($51009219fec611c3$export$59c1b079c431ef40 = {}));
const $51009219fec611c3$export$4a0935744d2041a0 = Object.freeze([
    $51009219fec611c3$export$59c1b079c431ef40.Email
]);


function $0f733299a7f3b7f4$export$127f9a442b42d18(config, guard) {
    const result = guard.safeParse(config);
    if (!result.success) throw new (0, $8bf20f642f61a47e$export$1a6b62c5b97f19bd)((0, $8bf20f642f61a47e$export$2ecd4a627c6913d4).InvalidConfig, result.error);
}
const $0f733299a7f3b7f4$export$18c43dcebf00e571 = (jsonString, errorCode = (0, $8bf20f642f61a47e$export$2ecd4a627c6913d4).InvalidResponse, errorPayload)=>{
    try {
        return (0, $2b3ee26e56fddc99$export$80d8b5946da2a05e).parse(JSON.parse(jsonString));
    } catch (e) {
        throw new (0, $8bf20f642f61a47e$export$1a6b62c5b97f19bd)(errorCode, errorPayload !== null && errorPayload !== void 0 ? errorPayload : jsonString);
    }
};
const $0f733299a7f3b7f4$export$7b9340ca5373286 = (...[jsonString, errorCode = (0, $8bf20f642f61a47e$export$2ecd4a627c6913d4).InvalidResponse, errorPayload])=>{
    try {
        return (0, $2b3ee26e56fddc99$export$4ac62c0537cd0db7).parse(JSON.parse(jsonString));
    } catch (e) {
        throw new (0, $8bf20f642f61a47e$export$1a6b62c5b97f19bd)(errorCode, errorPayload !== null && errorPayload !== void 0 ? errorPayload : jsonString);
    }
};
const $0f733299a7f3b7f4$export$4fe65911a1cf396d = "logto_mock_verification_code_record.txt";
const $0f733299a7f3b7f4$export$139964ce187c5e2 = Object.freeze({
    [(0, $77c1afb6aeb74e86$export$18dbf40ba8d1d9db).Sms]: "/tmp/logto_mock_sms_record.txt",
    [(0, $77c1afb6aeb74e86$export$18dbf40ba8d1d9db).Email]: "/tmp/logto_mock_email_record.txt"
});
const $0f733299a7f3b7f4$export$24f9fc31d5505892 = (template, payload)=>{
    var _payload_key;
    return Object.keys(payload).reduce((accumulator, key)=>accumulator.replaceAll(new RegExp(`{{\\s*${key}\\s*}}`, "g"), (_payload_key = payload[key]) !== null && _payload_key !== void 0 ? _payload_key : ""), template);
};




const $19b00b9869ef71ab$export$755522cf8b35e50 = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    familyName: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
    givenName: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
    middleName: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
    nickname: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
    preferredUsername: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
    profile: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
    website: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
    gender: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
    birthdate: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
    zoneinfo: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
    locale: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
    address: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
        formatted: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
        streetAddress: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
        locality: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
        region: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
        postalCode: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
        country: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string()
    }).partial()
}).partial();
const $19b00b9869ef71ab$export$572b146f6bc88040 = Object.freeze($19b00b9869ef71ab$export$755522cf8b35e50.keyof().options);
const $19b00b9869ef71ab$export$5b0e1cc5f5293c3b = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().array();
const $19b00b9869ef71ab$export$4d846b5d465d17a5 = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    userId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
    details: (0, $2b3ee26e56fddc99$export$4ac62c0537cd0db7).optional()
});
const $19b00b9869ef71ab$export$9240af6bda06dde7 = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).record($19b00b9869ef71ab$export$4d846b5d465d17a5);
const $19b00b9869ef71ab$export$45938720c8cd17da = {
    id: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
    createdAt: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
    lastUsedAt: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().optional()
};
const $19b00b9869ef71ab$export$247de21853358ba3 = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object((0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({
    type: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).literal((0, $c0e46a7ec45ea8f3$export$c62e7669a75c5961).TOTP)
}, $19b00b9869ef71ab$export$45938720c8cd17da), {
    key: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string()
}));
const $19b00b9869ef71ab$export$aa941865a0228ea6 = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).enum([
    "usb",
    "nfc",
    "ble",
    "internal",
    "cable",
    "hybrid",
    "smart-card"
]);
const $19b00b9869ef71ab$export$d887df993511916c = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object((0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({
    type: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).literal((0, $c0e46a7ec45ea8f3$export$c62e7669a75c5961).WebAuthn)
}, $19b00b9869ef71ab$export$45938720c8cd17da), {
    credentialId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
    publicKey: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
    transports: $19b00b9869ef71ab$export$aa941865a0228ea6.array().optional(),
    counter: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).number(),
    agent: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string()
}));
const $19b00b9869ef71ab$export$b31bbb972ba29c41 = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object((0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({
    type: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).literal((0, $c0e46a7ec45ea8f3$export$c62e7669a75c5961).BackupCode)
}, $19b00b9869ef71ab$export$45938720c8cd17da), {
    codes: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
        code: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
        usedAt: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().optional()
    }).array()
}));
const $19b00b9869ef71ab$export$e0149a7d7403659d = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).discriminatedUnion("type", [
    $19b00b9869ef71ab$export$247de21853358ba3,
    $19b00b9869ef71ab$export$d887df993511916c,
    $19b00b9869ef71ab$export$b31bbb972ba29c41
]);
const $19b00b9869ef71ab$export$cd58e15effbd05b2 = $19b00b9869ef71ab$export$e0149a7d7403659d.array();



const $03895a224211714c$export$d7a665f9067dd8f8 = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).array((0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string());
const $03895a224211714c$export$363bdce991737de = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    displayName: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().optional(),
    logo: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().optional(),
    darkLogo: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().optional()
});




const $f5920afcd50012a5$export$7cbc7e52a66572d6 = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    /* The domain name, e.g app.example.com */ domain: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
    /* The status of the domain in Cloudflare */ status: (0, $a86cc69a84585305$export$fda7fbe88a5ffb61),
    /* The error message if any */ errorMessage: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().nullable(),
    /* The DNS records of the domain */ dnsRecords: (0, $a86cc69a84585305$export$ab6045338fa7d71b),
    /* The remote Cloudflare data */ cloudflareData: (0, $a86cc69a84585305$export$10762083065a1f71).nullable()
});
const $f5920afcd50012a5$export$dea254f43799108e = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).array($f5920afcd50012a5$export$7cbc7e52a66572d6);
const $f5920afcd50012a5$export$f7af996b28fe8992 = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    /* The host of the site */ host: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
    /* The origin of the site */ origin: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
    /* Session duration in seconds */ sessionDuration: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).number(),
    pageRules: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).array((0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
        /* The path pattern (regex) to match */ path: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string()
    })),
    /* Custom domain */ customDomains: $f5920afcd50012a5$export$dea254f43799108e.optional()
});







// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
var $3ce2871eb3919730$export$d16f8fdf0c548b68;
(function(ApplicationType) {
    ApplicationType["Native"] = "Native";
    ApplicationType["SPA"] = "SPA";
    ApplicationType["Traditional"] = "Traditional";
    ApplicationType["MachineToMachine"] = "MachineToMachine";
    ApplicationType["Protected"] = "Protected";
})($3ce2871eb3919730$export$d16f8fdf0c548b68 || ($3ce2871eb3919730$export$d16f8fdf0c548b68 = {}));
var $3ce2871eb3919730$export$3ac4f2bb1c3a6ab6;
(function(OrganizationInvitationStatus) {
    OrganizationInvitationStatus["Pending"] = "Pending";
    OrganizationInvitationStatus["Accepted"] = "Accepted";
    OrganizationInvitationStatus["Expired"] = "Expired";
    OrganizationInvitationStatus["Revoked"] = "Revoked";
})($3ce2871eb3919730$export$3ac4f2bb1c3a6ab6 || ($3ce2871eb3919730$export$3ac4f2bb1c3a6ab6 = {}));
var $3ce2871eb3919730$export$e57c3ccf0ca02b45;
(function(RoleType) {
    RoleType["User"] = "User";
    RoleType["MachineToMachine"] = "MachineToMachine";
})($3ce2871eb3919730$export$e57c3ccf0ca02b45 || ($3ce2871eb3919730$export$e57c3ccf0ca02b45 = {}));
var $3ce2871eb3919730$export$dc6c7df092741a48;
(function(SentinelActionResult) {
    SentinelActionResult["Success"] = "Success";
    SentinelActionResult["Failed"] = "Failed";
})($3ce2871eb3919730$export$dc6c7df092741a48 || ($3ce2871eb3919730$export$dc6c7df092741a48 = {}));
var $3ce2871eb3919730$export$418d76209f25e60e;
(function(SentinelDecision) {
    SentinelDecision["Undecided"] = "Undecided";
    SentinelDecision["Allowed"] = "Allowed";
    SentinelDecision["Blocked"] = "Blocked";
    SentinelDecision["Challenge"] = "Challenge";
})($3ce2871eb3919730$export$418d76209f25e60e || ($3ce2871eb3919730$export$418d76209f25e60e = {}));
var $3ce2871eb3919730$export$f927bbb3d448dc2b;
(function(SignInMode) {
    SignInMode["SignIn"] = "SignIn";
    SignInMode["Register"] = "Register";
    SignInMode["SignInAndRegister"] = "SignInAndRegister";
})($3ce2871eb3919730$export$f927bbb3d448dc2b || ($3ce2871eb3919730$export$f927bbb3d448dc2b = {}));
var $3ce2871eb3919730$export$b3dbe23797267513;
(function(UsersPasswordEncryptionMethod) {
    UsersPasswordEncryptionMethod["Argon2i"] = "Argon2i";
    UsersPasswordEncryptionMethod["SHA1"] = "SHA1";
    UsersPasswordEncryptionMethod["SHA256"] = "SHA256";
    UsersPasswordEncryptionMethod["MD5"] = "MD5";
    UsersPasswordEncryptionMethod["Bcrypt"] = "Bcrypt";
})($3ce2871eb3919730$export$b3dbe23797267513 || ($3ce2871eb3919730$export$b3dbe23797267513 = {}));


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.


const $82c906177bd2d562$var$createGuard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    tenantId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21).optional(),
    applicationId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    branding: (0, $c0e46a7ec45ea8f3$export$c9d0acdc98ac45b).optional(),
    termsOfUseUrl: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(2048).nullable().optional(),
    privacyPolicyUrl: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(2048).nullable().optional(),
    displayName: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(256).nullable().optional()
});
const $82c906177bd2d562$var$guard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    tenantId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21),
    applicationId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    branding: (0, $c0e46a7ec45ea8f3$export$c9d0acdc98ac45b),
    termsOfUseUrl: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(2048).nullable(),
    privacyPolicyUrl: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(2048).nullable(),
    displayName: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(256).nullable()
});
const $82c906177bd2d562$export$b21e17c60fe7d89c = Object.freeze({
    table: "application_sign_in_experiences",
    tableSingular: "application_sign_in_experience",
    fields: {
        tenantId: "tenant_id",
        applicationId: "application_id",
        branding: "branding",
        termsOfUseUrl: "terms_of_use_url",
        privacyPolicyUrl: "privacy_policy_url",
        displayName: "display_name"
    },
    fieldKeys: [
        "tenantId",
        "applicationId",
        "branding",
        "termsOfUseUrl",
        "privacyPolicyUrl",
        "displayName"
    ],
    createGuard: $82c906177bd2d562$var$createGuard,
    guard: $82c906177bd2d562$var$guard,
    updateGuard: $82c906177bd2d562$var$guard.partial()
});


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

const $fc5533bb24b1d9c8$var$createGuard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    tenantId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21).optional(),
    applicationId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    organizationScopeId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21)
});
const $fc5533bb24b1d9c8$var$guard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    tenantId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21),
    applicationId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    organizationScopeId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21)
});
const $fc5533bb24b1d9c8$export$cc7d7eb8b2d4c88f = Object.freeze({
    table: "application_user_consent_organization_scopes",
    tableSingular: "application_user_consent_organization_scope",
    fields: {
        tenantId: "tenant_id",
        applicationId: "application_id",
        organizationScopeId: "organization_scope_id"
    },
    fieldKeys: [
        "tenantId",
        "applicationId",
        "organizationScopeId"
    ],
    createGuard: $fc5533bb24b1d9c8$var$createGuard,
    guard: $fc5533bb24b1d9c8$var$guard,
    updateGuard: $fc5533bb24b1d9c8$var$guard.partial()
});


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

const $f4b61f603addb116$var$createGuard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    tenantId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21).optional(),
    applicationId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    organizationId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    userId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21)
});
const $f4b61f603addb116$var$guard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    tenantId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21),
    applicationId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    organizationId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    userId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21)
});
const $f4b61f603addb116$export$1477f056ed289a93 = Object.freeze({
    table: "application_user_consent_organizations",
    tableSingular: "application_user_consent_organization",
    fields: {
        tenantId: "tenant_id",
        applicationId: "application_id",
        organizationId: "organization_id",
        userId: "user_id"
    },
    fieldKeys: [
        "tenantId",
        "applicationId",
        "organizationId",
        "userId"
    ],
    createGuard: $f4b61f603addb116$var$createGuard,
    guard: $f4b61f603addb116$var$guard,
    updateGuard: $f4b61f603addb116$var$guard.partial()
});


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

const $ca28fae764b76115$var$createGuard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    tenantId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21).optional(),
    applicationId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    scopeId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21)
});
const $ca28fae764b76115$var$guard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    tenantId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21),
    applicationId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    scopeId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21)
});
const $ca28fae764b76115$export$5961a9d1caf5eb5f = Object.freeze({
    table: "application_user_consent_resource_scopes",
    tableSingular: "application_user_consent_resource_scope",
    fields: {
        tenantId: "tenant_id",
        applicationId: "application_id",
        scopeId: "scope_id"
    },
    fieldKeys: [
        "tenantId",
        "applicationId",
        "scopeId"
    ],
    createGuard: $ca28fae764b76115$var$createGuard,
    guard: $ca28fae764b76115$var$guard,
    updateGuard: $ca28fae764b76115$var$guard.partial()
});


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

const $fcddafa7ab6fa07b$var$createGuard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    tenantId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21).optional(),
    applicationId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    userScope: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(64)
});
const $fcddafa7ab6fa07b$var$guard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    tenantId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21),
    applicationId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    userScope: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(64)
});
const $fcddafa7ab6fa07b$export$23c1519812ac7ae7 = Object.freeze({
    table: "application_user_consent_user_scopes",
    tableSingular: "application_user_consent_user_scope",
    fields: {
        tenantId: "tenant_id",
        applicationId: "application_id",
        userScope: "user_scope"
    },
    fieldKeys: [
        "tenantId",
        "applicationId",
        "userScope"
    ],
    createGuard: $fcddafa7ab6fa07b$var$createGuard,
    guard: $fcddafa7ab6fa07b$var$guard,
    updateGuard: $fcddafa7ab6fa07b$var$guard.partial()
});


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.



const $660b8d53428b2c71$var$createGuard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    tenantId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21).optional(),
    id: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    name: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(256),
    secret: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(64),
    description: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().nullable().optional(),
    type: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).nativeEnum((0, $3ce2871eb3919730$export$d16f8fdf0c548b68)),
    oidcClientMetadata: (0, $b3914f7de7f01a2a$export$2b5eeb3c40bff26b),
    customClientMetadata: (0, $b3914f7de7f01a2a$export$44618fabe8266610).optional(),
    protectedAppMetadata: (0, $f5920afcd50012a5$export$f7af996b28fe8992).nullable().optional(),
    isThirdParty: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).boolean().optional(),
    createdAt: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).number().optional()
});
const $660b8d53428b2c71$var$guard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    tenantId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21),
    id: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    name: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(256),
    secret: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(64),
    description: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().nullable(),
    type: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).nativeEnum((0, $3ce2871eb3919730$export$d16f8fdf0c548b68)),
    oidcClientMetadata: (0, $b3914f7de7f01a2a$export$2b5eeb3c40bff26b),
    customClientMetadata: (0, $b3914f7de7f01a2a$export$44618fabe8266610),
    protectedAppMetadata: (0, $f5920afcd50012a5$export$f7af996b28fe8992).nullable(),
    isThirdParty: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).boolean(),
    createdAt: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).number()
});
const $660b8d53428b2c71$export$73c91b53927e421e = Object.freeze({
    table: "applications",
    tableSingular: "application",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        name: "name",
        secret: "secret",
        description: "description",
        type: "type",
        oidcClientMetadata: "oidc_client_metadata",
        customClientMetadata: "custom_client_metadata",
        protectedAppMetadata: "protected_app_metadata",
        isThirdParty: "is_third_party",
        createdAt: "created_at"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "name",
        "secret",
        "description",
        "type",
        "oidcClientMetadata",
        "customClientMetadata",
        "protectedAppMetadata",
        "isThirdParty",
        "createdAt"
    ],
    createGuard: $660b8d53428b2c71$var$createGuard,
    guard: $660b8d53428b2c71$var$guard,
    updateGuard: $660b8d53428b2c71$var$guard.partial()
});


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

const $c1cf7463484a80ef$var$createGuard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    tenantId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21).optional(),
    id: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    applicationId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    roleId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21)
});
const $c1cf7463484a80ef$var$guard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    tenantId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21),
    id: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    applicationId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    roleId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21)
});
const $c1cf7463484a80ef$export$9e9228a1487950f9 = Object.freeze({
    table: "applications_roles",
    tableSingular: "applications_role",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        applicationId: "application_id",
        roleId: "role_id"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "applicationId",
        "roleId"
    ],
    createGuard: $c1cf7463484a80ef$var$createGuard,
    guard: $c1cf7463484a80ef$var$guard,
    updateGuard: $c1cf7463484a80ef$var$guard.partial()
});


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.


const $ffa3e4b1defdaac9$var$createGuard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    tenantId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21).optional(),
    id: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(128),
    syncProfile: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).boolean().optional(),
    connectorId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(128),
    config: (0, $2b3ee26e56fddc99$export$4ac62c0537cd0db7).optional(),
    metadata: (0, $a5946dc029c62388$export$155cba4e58565525).optional(),
    createdAt: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).number().optional()
});
const $ffa3e4b1defdaac9$var$guard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    tenantId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21),
    id: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(128),
    syncProfile: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).boolean(),
    connectorId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(128),
    config: (0, $2b3ee26e56fddc99$export$4ac62c0537cd0db7),
    metadata: (0, $a5946dc029c62388$export$155cba4e58565525),
    createdAt: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).number()
});
const $ffa3e4b1defdaac9$export$87ce1179d2402b5a = Object.freeze({
    table: "connectors",
    tableSingular: "connector",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        syncProfile: "sync_profile",
        connectorId: "connector_id",
        config: "config",
        metadata: "metadata",
        createdAt: "created_at"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "syncProfile",
        "connectorId",
        "config",
        "metadata",
        "createdAt"
    ],
    createGuard: $ffa3e4b1defdaac9$var$createGuard,
    guard: $ffa3e4b1defdaac9$var$guard,
    updateGuard: $ffa3e4b1defdaac9$var$guard.partial()
});


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.


const $44b08c8a926c1ca4$var$createGuard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    tenantId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21).optional(),
    id: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    languageTag: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(16),
    translation: (0, $4b5ac82527c88c19$export$aea1b2a91583fcef)
});
const $44b08c8a926c1ca4$var$guard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    tenantId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21),
    id: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    languageTag: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(16),
    translation: (0, $4b5ac82527c88c19$export$aea1b2a91583fcef)
});
const $44b08c8a926c1ca4$export$68f045a468761c0e = Object.freeze({
    table: "custom_phrases",
    tableSingular: "custom_phrase",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        languageTag: "language_tag",
        translation: "translation"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "languageTag",
        "translation"
    ],
    createGuard: $44b08c8a926c1ca4$var$createGuard,
    guard: $44b08c8a926c1ca4$var$guard,
    updateGuard: $44b08c8a926c1ca4$var$guard.partial()
});


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

const $8d9cb06afecb1ff5$var$createGuard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    id: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    tenantId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21).optional(),
    userId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    date: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).number().optional()
});
const $8d9cb06afecb1ff5$var$guard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    id: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    tenantId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21),
    userId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    date: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).number()
});
const $8d9cb06afecb1ff5$export$d153bb698683b0a7 = Object.freeze({
    table: "daily_active_users",
    tableSingular: "daily_active_user",
    fields: {
        id: "id",
        tenantId: "tenant_id",
        userId: "user_id",
        date: "date"
    },
    fieldKeys: [
        "id",
        "tenantId",
        "userId",
        "date"
    ],
    createGuard: $8d9cb06afecb1ff5$var$createGuard,
    guard: $8d9cb06afecb1ff5$var$guard,
    updateGuard: $8d9cb06afecb1ff5$var$guard.partial()
});


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

const $e9f131185e73e43d$var$createGuard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    id: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    tenantId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21).optional(),
    usage: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).number().optional(),
    date: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).number()
});
const $e9f131185e73e43d$var$guard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    id: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    tenantId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21),
    usage: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).number(),
    date: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).number()
});
const $e9f131185e73e43d$export$46dadcefc3469961 = Object.freeze({
    table: "daily_token_usage",
    tableSingular: "daily_token_usage",
    fields: {
        id: "id",
        tenantId: "tenant_id",
        usage: "usage",
        date: "date"
    },
    fieldKeys: [
        "id",
        "tenantId",
        "usage",
        "date"
    ],
    createGuard: $e9f131185e73e43d$var$createGuard,
    guard: $e9f131185e73e43d$var$guard,
    updateGuard: $e9f131185e73e43d$var$guard.partial()
});


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.


const $fa7b63c34b0d9b48$var$createGuard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    tenantId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21).optional(),
    id: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    domain: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(256),
    status: (0, $a86cc69a84585305$export$fda7fbe88a5ffb61).optional(),
    errorMessage: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(1024).nullable().optional(),
    dnsRecords: (0, $a86cc69a84585305$export$ab6045338fa7d71b).optional(),
    cloudflareData: (0, $a86cc69a84585305$export$10762083065a1f71).nullable().optional(),
    updatedAt: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).number().optional(),
    createdAt: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).number().optional()
});
const $fa7b63c34b0d9b48$var$guard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    tenantId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21),
    id: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    domain: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(256),
    status: (0, $a86cc69a84585305$export$fda7fbe88a5ffb61),
    errorMessage: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(1024).nullable(),
    dnsRecords: (0, $a86cc69a84585305$export$ab6045338fa7d71b),
    cloudflareData: (0, $a86cc69a84585305$export$10762083065a1f71).nullable(),
    updatedAt: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).number(),
    createdAt: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).number()
});
const $fa7b63c34b0d9b48$export$e3e9d7fdf7b67caa = Object.freeze({
    table: "domains",
    tableSingular: "domain",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        domain: "domain",
        status: "status",
        errorMessage: "error_message",
        dnsRecords: "dns_records",
        cloudflareData: "cloudflare_data",
        updatedAt: "updated_at",
        createdAt: "created_at"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "domain",
        "status",
        "errorMessage",
        "dnsRecords",
        "cloudflareData",
        "updatedAt",
        "createdAt"
    ],
    createGuard: $fa7b63c34b0d9b48$var$createGuard,
    guard: $fa7b63c34b0d9b48$var$guard,
    updateGuard: $fa7b63c34b0d9b48$var$guard.partial()
});


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.


const $c8148cbdca7daef6$var$createGuard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    tenantId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21).optional(),
    id: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    name: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(256).optional(),
    event: (0, $19a1785de7c32ff4$export$2d2b15eb4f8d4fc9).nullable().optional(),
    events: (0, $19a1785de7c32ff4$export$56e77a150fce61b).optional(),
    config: (0, $19a1785de7c32ff4$export$924993b6fcd8d738),
    signingKey: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(64).optional(),
    enabled: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).boolean().optional(),
    createdAt: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).number().optional()
});
const $c8148cbdca7daef6$var$guard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    tenantId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21),
    id: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    name: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(256),
    event: (0, $19a1785de7c32ff4$export$2d2b15eb4f8d4fc9).nullable(),
    events: (0, $19a1785de7c32ff4$export$56e77a150fce61b),
    config: (0, $19a1785de7c32ff4$export$924993b6fcd8d738),
    signingKey: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(64),
    enabled: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).boolean(),
    createdAt: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).number()
});
const $c8148cbdca7daef6$export$5fbefe39e79899a6 = Object.freeze({
    table: "hooks",
    tableSingular: "hook",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        name: "name",
        event: "event",
        events: "events",
        config: "config",
        signingKey: "signing_key",
        enabled: "enabled",
        createdAt: "created_at"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "name",
        "event",
        "events",
        "config",
        "signingKey",
        "enabled",
        "createdAt"
    ],
    createGuard: $c8148cbdca7daef6$var$createGuard,
    guard: $c8148cbdca7daef6$var$guard,
    updateGuard: $c8148cbdca7daef6$var$guard.partial()
});


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.


const $4adbf37aa30c90dd$var$createGuard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    tenantId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21).optional(),
    id: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    key: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(128),
    payload: (0, $09f813c8a1ce8d76$export$2938cb1ca9b4e331).optional(),
    createdAt: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).number().optional()
});
const $4adbf37aa30c90dd$var$guard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    tenantId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21),
    id: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    key: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(128),
    payload: (0, $09f813c8a1ce8d76$export$2938cb1ca9b4e331),
    createdAt: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).number()
});
const $4adbf37aa30c90dd$export$55c65d61db3da5ca = Object.freeze({
    table: "logs",
    tableSingular: "log",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        key: "key",
        payload: "payload",
        createdAt: "created_at"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "key",
        "payload",
        "createdAt"
    ],
    createGuard: $4adbf37aa30c90dd$var$createGuard,
    guard: $4adbf37aa30c90dd$var$guard,
    updateGuard: $4adbf37aa30c90dd$var$guard.partial()
});


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.


const $6977fd47717c3ef1$var$createGuard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    tenantId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21).optional(),
    key: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(256),
    value: (0, $2b3ee26e56fddc99$export$80d8b5946da2a05e).optional()
});
const $6977fd47717c3ef1$var$guard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    tenantId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21),
    key: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(256),
    value: (0, $2b3ee26e56fddc99$export$80d8b5946da2a05e)
});
const $6977fd47717c3ef1$export$d95c9c1f4b55e315 = Object.freeze({
    table: "logto_configs",
    tableSingular: "logto_config",
    fields: {
        tenantId: "tenant_id",
        key: "key",
        value: "value"
    },
    fieldKeys: [
        "tenantId",
        "key",
        "value"
    ],
    createGuard: $6977fd47717c3ef1$var$createGuard,
    guard: $6977fd47717c3ef1$var$guard,
    updateGuard: $6977fd47717c3ef1$var$guard.partial()
});


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.


const $e4f01bc3a6b854c0$var$createGuard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    tenantId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21).optional(),
    modelName: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(64),
    id: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(128),
    payload: (0, $b3914f7de7f01a2a$export$525df20e0fb1714c),
    expiresAt: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).number(),
    consumedAt: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).number().nullable().optional()
});
const $e4f01bc3a6b854c0$var$guard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    tenantId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21),
    modelName: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(64),
    id: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(128),
    payload: (0, $b3914f7de7f01a2a$export$525df20e0fb1714c),
    expiresAt: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).number(),
    consumedAt: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).number().nullable()
});
const $e4f01bc3a6b854c0$export$4825f32a2bacdbff = Object.freeze({
    table: "oidc_model_instances",
    tableSingular: "oidc_model_instance",
    fields: {
        tenantId: "tenant_id",
        modelName: "model_name",
        id: "id",
        payload: "payload",
        expiresAt: "expires_at",
        consumedAt: "consumed_at"
    },
    fieldKeys: [
        "tenantId",
        "modelName",
        "id",
        "payload",
        "expiresAt",
        "consumedAt"
    ],
    createGuard: $e4f01bc3a6b854c0$var$createGuard,
    guard: $e4f01bc3a6b854c0$var$guard,
    updateGuard: $e4f01bc3a6b854c0$var$guard.partial()
});


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

const $1eb325cb91b4a388$var$createGuard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    tenantId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21).optional(),
    organizationInvitationId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    organizationRoleId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21)
});
const $1eb325cb91b4a388$var$guard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    tenantId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21),
    organizationInvitationId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    organizationRoleId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21)
});
const $1eb325cb91b4a388$export$fc376a4cb789d28e = Object.freeze({
    table: "organization_invitation_role_relations",
    tableSingular: "organization_invitation_role_relation",
    fields: {
        tenantId: "tenant_id",
        organizationInvitationId: "organization_invitation_id",
        organizationRoleId: "organization_role_id"
    },
    fieldKeys: [
        "tenantId",
        "organizationInvitationId",
        "organizationRoleId"
    ],
    createGuard: $1eb325cb91b4a388$var$createGuard,
    guard: $1eb325cb91b4a388$var$guard,
    updateGuard: $1eb325cb91b4a388$var$guard.partial()
});


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.


const $07ccf7a7394ec01a$var$createGuard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    tenantId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21).optional(),
    id: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    inviterId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21).nullable().optional(),
    invitee: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(256),
    acceptedUserId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21).nullable().optional(),
    organizationId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    status: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).nativeEnum((0, $3ce2871eb3919730$export$3ac4f2bb1c3a6ab6)),
    createdAt: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).number().optional(),
    updatedAt: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).number().optional(),
    expiresAt: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).number()
});
const $07ccf7a7394ec01a$var$guard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    tenantId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21),
    id: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    inviterId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21).nullable(),
    invitee: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(256),
    acceptedUserId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21).nullable(),
    organizationId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    status: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).nativeEnum((0, $3ce2871eb3919730$export$3ac4f2bb1c3a6ab6)),
    createdAt: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).number(),
    updatedAt: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).number(),
    expiresAt: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).number()
});
const $07ccf7a7394ec01a$export$63fd293d5536b534 = Object.freeze({
    table: "organization_invitations",
    tableSingular: "organization_invitation",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        inviterId: "inviter_id",
        invitee: "invitee",
        acceptedUserId: "accepted_user_id",
        organizationId: "organization_id",
        status: "status",
        createdAt: "created_at",
        updatedAt: "updated_at",
        expiresAt: "expires_at"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "inviterId",
        "invitee",
        "acceptedUserId",
        "organizationId",
        "status",
        "createdAt",
        "updatedAt",
        "expiresAt"
    ],
    createGuard: $07ccf7a7394ec01a$var$createGuard,
    guard: $07ccf7a7394ec01a$var$guard,
    updateGuard: $07ccf7a7394ec01a$var$guard.partial()
});


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

const $c3b470c09d9ac4c4$var$createGuard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    tenantId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21).optional(),
    organizationRoleId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    scopeId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21)
});
const $c3b470c09d9ac4c4$var$guard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    tenantId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21),
    organizationRoleId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    scopeId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21)
});
const $c3b470c09d9ac4c4$export$7d2c2ca29d23087b = Object.freeze({
    table: "organization_role_resource_scope_relations",
    tableSingular: "organization_role_resource_scope_relation",
    fields: {
        tenantId: "tenant_id",
        organizationRoleId: "organization_role_id",
        scopeId: "scope_id"
    },
    fieldKeys: [
        "tenantId",
        "organizationRoleId",
        "scopeId"
    ],
    createGuard: $c3b470c09d9ac4c4$var$createGuard,
    guard: $c3b470c09d9ac4c4$var$guard,
    updateGuard: $c3b470c09d9ac4c4$var$guard.partial()
});


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

const $fc0f3b1f7bb20de0$var$createGuard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    tenantId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21).optional(),
    organizationRoleId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    organizationScopeId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21)
});
const $fc0f3b1f7bb20de0$var$guard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    tenantId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21),
    organizationRoleId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    organizationScopeId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21)
});
const $fc0f3b1f7bb20de0$export$3c85c8a4a8d43867 = Object.freeze({
    table: "organization_role_scope_relations",
    tableSingular: "organization_role_scope_relation",
    fields: {
        tenantId: "tenant_id",
        organizationRoleId: "organization_role_id",
        organizationScopeId: "organization_scope_id"
    },
    fieldKeys: [
        "tenantId",
        "organizationRoleId",
        "organizationScopeId"
    ],
    createGuard: $fc0f3b1f7bb20de0$var$createGuard,
    guard: $fc0f3b1f7bb20de0$var$guard,
    updateGuard: $fc0f3b1f7bb20de0$var$guard.partial()
});


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

const $3f4a44c0fa14331f$var$createGuard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    tenantId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21).optional(),
    organizationId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    organizationRoleId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    userId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21)
});
const $3f4a44c0fa14331f$var$guard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    tenantId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21),
    organizationId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    organizationRoleId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    userId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21)
});
const $3f4a44c0fa14331f$export$92d9ab4d1ade1798 = Object.freeze({
    table: "organization_role_user_relations",
    tableSingular: "organization_role_user_relation",
    fields: {
        tenantId: "tenant_id",
        organizationId: "organization_id",
        organizationRoleId: "organization_role_id",
        userId: "user_id"
    },
    fieldKeys: [
        "tenantId",
        "organizationId",
        "organizationRoleId",
        "userId"
    ],
    createGuard: $3f4a44c0fa14331f$var$createGuard,
    guard: $3f4a44c0fa14331f$var$guard,
    updateGuard: $3f4a44c0fa14331f$var$guard.partial()
});


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

const $bca86ec785494256$var$createGuard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    tenantId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21).optional(),
    id: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    name: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(128),
    description: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(256).nullable().optional()
});
const $bca86ec785494256$var$guard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    tenantId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21),
    id: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    name: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(128),
    description: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(256).nullable()
});
const $bca86ec785494256$export$29f120f254b547e7 = Object.freeze({
    table: "organization_roles",
    tableSingular: "organization_role",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        name: "name",
        description: "description"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "name",
        "description"
    ],
    createGuard: $bca86ec785494256$var$createGuard,
    guard: $bca86ec785494256$var$guard,
    updateGuard: $bca86ec785494256$var$guard.partial()
});


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

const $03b914be955f9f6f$var$createGuard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    tenantId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21).optional(),
    id: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    name: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(128),
    description: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(256).nullable().optional()
});
const $03b914be955f9f6f$var$guard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    tenantId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21),
    id: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    name: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(128),
    description: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(256).nullable()
});
const $03b914be955f9f6f$export$9d110f69f69dde7a = Object.freeze({
    table: "organization_scopes",
    tableSingular: "organization_scope",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        name: "name",
        description: "description"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "name",
        "description"
    ],
    createGuard: $03b914be955f9f6f$var$createGuard,
    guard: $03b914be955f9f6f$var$guard,
    updateGuard: $03b914be955f9f6f$var$guard.partial()
});


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

const $991fa834b0956819$var$createGuard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    tenantId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21).optional(),
    organizationId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    userId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21)
});
const $991fa834b0956819$var$guard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    tenantId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21),
    organizationId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    userId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21)
});
const $991fa834b0956819$export$cd9bcab5c5506817 = Object.freeze({
    table: "organization_user_relations",
    tableSingular: "organization_user_relation",
    fields: {
        tenantId: "tenant_id",
        organizationId: "organization_id",
        userId: "user_id"
    },
    fieldKeys: [
        "tenantId",
        "organizationId",
        "userId"
    ],
    createGuard: $991fa834b0956819$var$createGuard,
    guard: $991fa834b0956819$var$guard,
    updateGuard: $991fa834b0956819$var$guard.partial()
});


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

const $e8e2c4287d2de9f0$var$createGuard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    tenantId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21).optional(),
    id: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    name: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(128),
    description: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(256).nullable().optional(),
    createdAt: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).number().optional()
});
const $e8e2c4287d2de9f0$var$guard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    tenantId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21),
    id: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    name: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(128),
    description: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(256).nullable(),
    createdAt: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).number()
});
const $e8e2c4287d2de9f0$export$8cdb1b004e612f6c = Object.freeze({
    table: "organizations",
    tableSingular: "organization",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        name: "name",
        description: "description",
        createdAt: "created_at"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "name",
        "description",
        "createdAt"
    ],
    createGuard: $e8e2c4287d2de9f0$var$createGuard,
    guard: $e8e2c4287d2de9f0$var$guard,
    updateGuard: $e8e2c4287d2de9f0$var$guard.partial()
});


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

const $ca4fbc220d98a00e$var$createGuard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    tenantId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21).optional(),
    id: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    interactionJti: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(128).nullable().optional(),
    phone: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(32).nullable().optional(),
    email: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(128).nullable().optional(),
    type: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(32),
    code: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(6),
    consumed: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).boolean().optional(),
    tryCount: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).number().optional(),
    createdAt: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).number().optional()
});
const $ca4fbc220d98a00e$var$guard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    tenantId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21),
    id: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    interactionJti: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(128).nullable(),
    phone: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(32).nullable(),
    email: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(128).nullable(),
    type: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(32),
    code: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(6),
    consumed: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).boolean(),
    tryCount: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).number(),
    createdAt: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).number()
});
const $ca4fbc220d98a00e$export$9bbf548a87a223fc = Object.freeze({
    table: "passcodes",
    tableSingular: "passcode",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        interactionJti: "interaction_jti",
        phone: "phone",
        email: "email",
        type: "type",
        code: "code",
        consumed: "consumed",
        tryCount: "try_count",
        createdAt: "created_at"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "interactionJti",
        "phone",
        "email",
        "type",
        "code",
        "consumed",
        "tryCount",
        "createdAt"
    ],
    createGuard: $ca4fbc220d98a00e$var$createGuard,
    guard: $ca4fbc220d98a00e$var$guard,
    updateGuard: $ca4fbc220d98a00e$var$guard.partial()
});


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

const $01bd9aeaf1aa3e97$var$createGuard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    tenantId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21).optional(),
    id: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    name: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1),
    indicator: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1),
    isDefault: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).boolean().optional(),
    accessTokenTtl: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).number().optional()
});
const $01bd9aeaf1aa3e97$var$guard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    tenantId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21),
    id: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    name: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1),
    indicator: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1),
    isDefault: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).boolean(),
    accessTokenTtl: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).number()
});
const $01bd9aeaf1aa3e97$export$e9a269813a6315a4 = Object.freeze({
    table: "resources",
    tableSingular: "resource",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        name: "name",
        indicator: "indicator",
        isDefault: "is_default",
        accessTokenTtl: "access_token_ttl"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "name",
        "indicator",
        "isDefault",
        "accessTokenTtl"
    ],
    createGuard: $01bd9aeaf1aa3e97$var$createGuard,
    guard: $01bd9aeaf1aa3e97$var$guard,
    updateGuard: $01bd9aeaf1aa3e97$var$guard.partial()
});


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.


const $d9b7eddf9bcbdc1d$var$createGuard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    tenantId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21).optional(),
    id: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    name: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(128),
    description: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(128),
    type: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).nativeEnum((0, $3ce2871eb3919730$export$e57c3ccf0ca02b45)).optional()
});
const $d9b7eddf9bcbdc1d$var$guard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    tenantId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21),
    id: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    name: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(128),
    description: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(128),
    type: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).nativeEnum((0, $3ce2871eb3919730$export$e57c3ccf0ca02b45))
});
const $d9b7eddf9bcbdc1d$export$d1d9e451800db729 = Object.freeze({
    table: "roles",
    tableSingular: "role",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        name: "name",
        description: "description",
        type: "type"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "name",
        "description",
        "type"
    ],
    createGuard: $d9b7eddf9bcbdc1d$var$createGuard,
    guard: $d9b7eddf9bcbdc1d$var$guard,
    updateGuard: $d9b7eddf9bcbdc1d$var$guard.partial()
});


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

const $39001e46cd607a3d$var$createGuard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    tenantId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21).optional(),
    id: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    roleId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    scopeId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21)
});
const $39001e46cd607a3d$var$guard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    tenantId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21),
    id: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    roleId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    scopeId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21)
});
const $39001e46cd607a3d$export$a3e241bf0004129f = Object.freeze({
    table: "roles_scopes",
    tableSingular: "roles_scope",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        roleId: "role_id",
        scopeId: "scope_id"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "roleId",
        "scopeId"
    ],
    createGuard: $39001e46cd607a3d$var$createGuard,
    guard: $39001e46cd607a3d$var$guard,
    updateGuard: $39001e46cd607a3d$var$guard.partial()
});


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

const $f68f1c4dcc6a46f1$var$createGuard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    tenantId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21).optional(),
    id: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    resourceId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    name: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(256),
    description: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().nullable().optional(),
    createdAt: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).number().optional()
});
const $f68f1c4dcc6a46f1$var$guard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    tenantId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21),
    id: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    resourceId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    name: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(256),
    description: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().nullable(),
    createdAt: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).number()
});
const $f68f1c4dcc6a46f1$export$8546186883d6ff3e = Object.freeze({
    table: "scopes",
    tableSingular: "scope",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        resourceId: "resource_id",
        name: "name",
        description: "description",
        createdAt: "created_at"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "resourceId",
        "name",
        "description",
        "createdAt"
    ],
    createGuard: $f68f1c4dcc6a46f1$var$createGuard,
    guard: $f68f1c4dcc6a46f1$var$guard,
    updateGuard: $f68f1c4dcc6a46f1$var$guard.partial()
});


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.



const $cfb654c7545dc46a$var$createGuard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    tenantId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21).optional(),
    id: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    targetType: (0, $a0a70058bba8d47e$export$47228912e855c2e6),
    targetHash: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(64),
    action: (0, $a0a70058bba8d47e$export$8cdcc536cbf8daf0),
    actionResult: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).nativeEnum((0, $3ce2871eb3919730$export$dc6c7df092741a48)),
    payload: (0, $a0a70058bba8d47e$export$ef3e193200f88c05),
    decision: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).nativeEnum((0, $3ce2871eb3919730$export$418d76209f25e60e)),
    decisionExpiresAt: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).number().optional(),
    createdAt: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).number().optional()
});
const $cfb654c7545dc46a$var$guard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    tenantId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21),
    id: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    targetType: (0, $a0a70058bba8d47e$export$47228912e855c2e6),
    targetHash: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(64),
    action: (0, $a0a70058bba8d47e$export$8cdcc536cbf8daf0),
    actionResult: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).nativeEnum((0, $3ce2871eb3919730$export$dc6c7df092741a48)),
    payload: (0, $a0a70058bba8d47e$export$ef3e193200f88c05),
    decision: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).nativeEnum((0, $3ce2871eb3919730$export$418d76209f25e60e)),
    decisionExpiresAt: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).number(),
    createdAt: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).number()
});
const $cfb654c7545dc46a$export$ac14f56217b6b757 = Object.freeze({
    table: "sentinel_activities",
    tableSingular: "sentinel_activity",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        targetType: "target_type",
        targetHash: "target_hash",
        action: "action",
        actionResult: "action_result",
        payload: "payload",
        decision: "decision",
        decisionExpiresAt: "decision_expires_at",
        createdAt: "created_at"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "targetType",
        "targetHash",
        "action",
        "actionResult",
        "payload",
        "decision",
        "decisionExpiresAt",
        "createdAt"
    ],
    createGuard: $cfb654c7545dc46a$var$createGuard,
    guard: $cfb654c7545dc46a$var$guard,
    updateGuard: $cfb654c7545dc46a$var$guard.partial()
});


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.


const $33a5d90822e49b33$var$createGuard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    id: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    tenantId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21).optional(),
    type: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(64),
    payload: (0, $2b3ee26e56fddc99$export$4ac62c0537cd0db7).optional(),
    createdAt: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).number().optional()
});
const $33a5d90822e49b33$var$guard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    id: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    tenantId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21),
    type: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(64),
    payload: (0, $2b3ee26e56fddc99$export$4ac62c0537cd0db7),
    createdAt: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).number()
});
const $33a5d90822e49b33$export$22ef66d3c161d6a7 = Object.freeze({
    table: "service_logs",
    tableSingular: "service_log",
    fields: {
        id: "id",
        tenantId: "tenant_id",
        type: "type",
        payload: "payload",
        createdAt: "created_at"
    },
    fieldKeys: [
        "id",
        "tenantId",
        "type",
        "payload",
        "createdAt"
    ],
    createGuard: $33a5d90822e49b33$var$createGuard,
    guard: $33a5d90822e49b33$var$guard,
    updateGuard: $33a5d90822e49b33$var$guard.partial()
});


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.



const $91b8ab8dbb22f7c8$var$createGuard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    tenantId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21).optional(),
    id: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    color: (0, $c0e46a7ec45ea8f3$export$5c91807cab7a8dc1),
    branding: (0, $c0e46a7ec45ea8f3$export$c9d0acdc98ac45b),
    languageInfo: (0, $c0e46a7ec45ea8f3$export$b8fe26243f8b3b37),
    termsOfUseUrl: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(2048).nullable().optional(),
    privacyPolicyUrl: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(2048).nullable().optional(),
    signIn: (0, $c0e46a7ec45ea8f3$export$8665c7c0edac5e7a),
    signUp: (0, $c0e46a7ec45ea8f3$export$fd48acc070c38d7b),
    socialSignInConnectorTargets: (0, $c0e46a7ec45ea8f3$export$276d424b39387296).optional(),
    signInMode: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).nativeEnum((0, $3ce2871eb3919730$export$f927bbb3d448dc2b)).optional(),
    customCss: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().nullable().optional(),
    customContent: (0, $c0e46a7ec45ea8f3$export$7dfc08c51ef177a5).optional(),
    passwordPolicy: (0, $09f813c8a1ce8d76$export$eee4f836f95656a7).optional(),
    mfa: (0, $c0e46a7ec45ea8f3$export$74899fc35c1207c8).optional(),
    singleSignOnEnabled: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).boolean().optional()
});
const $91b8ab8dbb22f7c8$var$guard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    tenantId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21),
    id: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    color: (0, $c0e46a7ec45ea8f3$export$5c91807cab7a8dc1),
    branding: (0, $c0e46a7ec45ea8f3$export$c9d0acdc98ac45b),
    languageInfo: (0, $c0e46a7ec45ea8f3$export$b8fe26243f8b3b37),
    termsOfUseUrl: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(2048).nullable(),
    privacyPolicyUrl: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(2048).nullable(),
    signIn: (0, $c0e46a7ec45ea8f3$export$8665c7c0edac5e7a),
    signUp: (0, $c0e46a7ec45ea8f3$export$fd48acc070c38d7b),
    socialSignInConnectorTargets: (0, $c0e46a7ec45ea8f3$export$276d424b39387296),
    signInMode: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).nativeEnum((0, $3ce2871eb3919730$export$f927bbb3d448dc2b)),
    customCss: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().nullable(),
    customContent: (0, $c0e46a7ec45ea8f3$export$7dfc08c51ef177a5),
    passwordPolicy: (0, $09f813c8a1ce8d76$export$eee4f836f95656a7),
    mfa: (0, $c0e46a7ec45ea8f3$export$74899fc35c1207c8),
    singleSignOnEnabled: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).boolean()
});
const $91b8ab8dbb22f7c8$export$761297ae014f2673 = Object.freeze({
    table: "sign_in_experiences",
    tableSingular: "sign_in_experience",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        color: "color",
        branding: "branding",
        languageInfo: "language_info",
        termsOfUseUrl: "terms_of_use_url",
        privacyPolicyUrl: "privacy_policy_url",
        signIn: "sign_in",
        signUp: "sign_up",
        socialSignInConnectorTargets: "social_sign_in_connector_targets",
        signInMode: "sign_in_mode",
        customCss: "custom_css",
        customContent: "custom_content",
        passwordPolicy: "password_policy",
        mfa: "mfa",
        singleSignOnEnabled: "single_sign_on_enabled"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "color",
        "branding",
        "languageInfo",
        "termsOfUseUrl",
        "privacyPolicyUrl",
        "signIn",
        "signUp",
        "socialSignInConnectorTargets",
        "signInMode",
        "customCss",
        "customContent",
        "passwordPolicy",
        "mfa",
        "singleSignOnEnabled"
    ],
    createGuard: $91b8ab8dbb22f7c8$var$createGuard,
    guard: $91b8ab8dbb22f7c8$var$guard,
    updateGuard: $91b8ab8dbb22f7c8$var$guard.partial()
});


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.


const $c68255f4bccb5b1c$var$createGuard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    tenantId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21).optional(),
    id: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(128),
    providerName: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(128),
    connectorName: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(128),
    config: (0, $2b3ee26e56fddc99$export$4ac62c0537cd0db7).optional(),
    domains: (0, $03895a224211714c$export$d7a665f9067dd8f8).optional(),
    branding: (0, $03895a224211714c$export$363bdce991737de).optional(),
    syncProfile: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).boolean().optional(),
    createdAt: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).number().optional()
});
const $c68255f4bccb5b1c$var$guard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    tenantId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21),
    id: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(128),
    providerName: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(128),
    connectorName: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(128),
    config: (0, $2b3ee26e56fddc99$export$4ac62c0537cd0db7),
    domains: (0, $03895a224211714c$export$d7a665f9067dd8f8),
    branding: (0, $03895a224211714c$export$363bdce991737de),
    syncProfile: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).boolean(),
    createdAt: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).number()
});
const $c68255f4bccb5b1c$export$cb7d2ef46acb2840 = Object.freeze({
    table: "sso_connectors",
    tableSingular: "sso_connector",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        providerName: "provider_name",
        connectorName: "connector_name",
        config: "config",
        domains: "domains",
        branding: "branding",
        syncProfile: "sync_profile",
        createdAt: "created_at"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "providerName",
        "connectorName",
        "config",
        "domains",
        "branding",
        "syncProfile",
        "createdAt"
    ],
    createGuard: $c68255f4bccb5b1c$var$createGuard,
    guard: $c68255f4bccb5b1c$var$guard,
    updateGuard: $c68255f4bccb5b1c$var$guard.partial()
});


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.


const $bf6332fc75af64ea$var$createGuard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    key: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(256),
    value: (0, $2b3ee26e56fddc99$export$4ac62c0537cd0db7).optional()
});
const $bf6332fc75af64ea$var$guard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    key: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(256),
    value: (0, $2b3ee26e56fddc99$export$4ac62c0537cd0db7)
});
const $bf6332fc75af64ea$export$2b3c0ad5912d86e2 = Object.freeze({
    table: "systems",
    tableSingular: "system",
    fields: {
        key: "key",
        value: "value"
    },
    fieldKeys: [
        "key",
        "value"
    ],
    createGuard: $bf6332fc75af64ea$var$createGuard,
    guard: $bf6332fc75af64ea$var$guard,
    updateGuard: $bf6332fc75af64ea$var$guard.partial()
});


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.


const $c30499d1d6213ed2$var$createGuard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    tenantId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21).optional(),
    id: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    userId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(12),
    issuer: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(256),
    identityId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(128),
    detail: (0, $2b3ee26e56fddc99$export$4ac62c0537cd0db7).optional(),
    createdAt: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).number().optional(),
    ssoConnectorId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(128)
});
const $c30499d1d6213ed2$var$guard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    tenantId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21),
    id: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    userId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(12),
    issuer: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(256),
    identityId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(128),
    detail: (0, $2b3ee26e56fddc99$export$4ac62c0537cd0db7),
    createdAt: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).number(),
    ssoConnectorId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(128)
});
const $c30499d1d6213ed2$export$53f83427a403da1f = Object.freeze({
    table: "user_sso_identities",
    tableSingular: "user_sso_identity",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        userId: "user_id",
        issuer: "issuer",
        identityId: "identity_id",
        detail: "detail",
        createdAt: "created_at",
        ssoConnectorId: "sso_connector_id"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "userId",
        "issuer",
        "identityId",
        "detail",
        "createdAt",
        "ssoConnectorId"
    ],
    createGuard: $c30499d1d6213ed2$var$createGuard,
    guard: $c30499d1d6213ed2$var$guard,
    updateGuard: $c30499d1d6213ed2$var$guard.partial()
});


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.



const $ba3e0e5fc0c0c5f0$var$createGuard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    tenantId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21).optional(),
    id: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(12),
    username: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(128).nullable().optional(),
    primaryEmail: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(128).nullable().optional(),
    primaryPhone: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(128).nullable().optional(),
    passwordEncrypted: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(128).nullable().optional(),
    passwordEncryptionMethod: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).nativeEnum((0, $3ce2871eb3919730$export$b3dbe23797267513)).nullable().optional(),
    name: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(128).nullable().optional(),
    avatar: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(2048).nullable().optional(),
    profile: (0, $19b00b9869ef71ab$export$755522cf8b35e50).optional(),
    applicationId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21).nullable().optional(),
    identities: (0, $19b00b9869ef71ab$export$9240af6bda06dde7).optional(),
    customData: (0, $2b3ee26e56fddc99$export$4ac62c0537cd0db7).optional(),
    logtoConfig: (0, $2b3ee26e56fddc99$export$4ac62c0537cd0db7).optional(),
    mfaVerifications: (0, $19b00b9869ef71ab$export$cd58e15effbd05b2).optional(),
    isSuspended: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).boolean().optional(),
    lastSignInAt: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).number().nullable().optional(),
    createdAt: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).number().optional(),
    updatedAt: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).number().optional()
});
const $ba3e0e5fc0c0c5f0$var$guard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    tenantId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21),
    id: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(12),
    username: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(128).nullable(),
    primaryEmail: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(128).nullable(),
    primaryPhone: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(128).nullable(),
    passwordEncrypted: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(128).nullable(),
    passwordEncryptionMethod: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).nativeEnum((0, $3ce2871eb3919730$export$b3dbe23797267513)).nullable(),
    name: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(128).nullable(),
    avatar: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(2048).nullable(),
    profile: (0, $19b00b9869ef71ab$export$755522cf8b35e50),
    applicationId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21).nullable(),
    identities: (0, $19b00b9869ef71ab$export$9240af6bda06dde7),
    customData: (0, $2b3ee26e56fddc99$export$4ac62c0537cd0db7),
    logtoConfig: (0, $2b3ee26e56fddc99$export$4ac62c0537cd0db7),
    mfaVerifications: (0, $19b00b9869ef71ab$export$cd58e15effbd05b2),
    isSuspended: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).boolean(),
    lastSignInAt: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).number().nullable(),
    createdAt: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).number(),
    updatedAt: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).number()
});
const $ba3e0e5fc0c0c5f0$export$a69f017b19597ff5 = Object.freeze({
    table: "users",
    tableSingular: "user",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        username: "username",
        primaryEmail: "primary_email",
        primaryPhone: "primary_phone",
        passwordEncrypted: "password_encrypted",
        passwordEncryptionMethod: "password_encryption_method",
        name: "name",
        avatar: "avatar",
        profile: "profile",
        applicationId: "application_id",
        identities: "identities",
        customData: "custom_data",
        logtoConfig: "logto_config",
        mfaVerifications: "mfa_verifications",
        isSuspended: "is_suspended",
        lastSignInAt: "last_sign_in_at",
        createdAt: "created_at",
        updatedAt: "updated_at"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "username",
        "primaryEmail",
        "primaryPhone",
        "passwordEncrypted",
        "passwordEncryptionMethod",
        "name",
        "avatar",
        "profile",
        "applicationId",
        "identities",
        "customData",
        "logtoConfig",
        "mfaVerifications",
        "isSuspended",
        "lastSignInAt",
        "createdAt",
        "updatedAt"
    ],
    createGuard: $ba3e0e5fc0c0c5f0$var$createGuard,
    guard: $ba3e0e5fc0c0c5f0$var$guard,
    updateGuard: $ba3e0e5fc0c0c5f0$var$guard.partial()
});


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

const $81dad4443dc2cf93$var$createGuard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    tenantId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21).optional(),
    id: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    userId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    roleId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21)
});
const $81dad4443dc2cf93$var$guard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    tenantId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21),
    id: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    userId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    roleId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21)
});
const $81dad4443dc2cf93$export$a93a64b4653e6020 = Object.freeze({
    table: "users_roles",
    tableSingular: "users_role",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        userId: "user_id",
        roleId: "role_id"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "userId",
        "roleId"
    ],
    createGuard: $81dad4443dc2cf93$var$createGuard,
    guard: $81dad4443dc2cf93$var$guard,
    updateGuard: $81dad4443dc2cf93$var$guard.partial()
});


// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

const $04c57da96c4d6d87$var$createGuard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    tenantId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21).optional(),
    id: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    userId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    createdAt: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).number().optional()
});
const $04c57da96c4d6d87$var$guard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    tenantId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(21),
    id: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    userId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1).max(21),
    createdAt: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).number()
});
const $04c57da96c4d6d87$export$730f48ea7aa802b0 = Object.freeze({
    table: "verification_statuses",
    tableSingular: "verification_status",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        userId: "user_id",
        createdAt: "created_at"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "userId",
        "createdAt"
    ],
    createGuard: $04c57da96c4d6d87$var$createGuard,
    guard: $04c57da96c4d6d87$var$guard,
    updateGuard: $04c57da96c4d6d87$var$guard.partial()
});







const $8627ae2cb174568a$export$b52523f950bcfb2f = (0, $ffa3e4b1defdaac9$export$87ce1179d2402b5a).guard.pick({
    id: true,
    syncProfile: true,
    config: true,
    metadata: true,
    connectorId: true
}).merge((0, $a5946dc029c62388$export$f7d2da53d88c923c)).merge((0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    type: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).nativeEnum((0, $77c1afb6aeb74e86$export$18dbf40ba8d1d9db)),
    isDemo: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).boolean().optional(),
    extraInfo: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).record((0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).unknown()).optional(),
    usage: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).number().optional()
}));
const $8627ae2cb174568a$export$8169eaabc815830f = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    type: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).nativeEnum((0, $77c1afb6aeb74e86$export$18dbf40ba8d1d9db)),
    isDemo: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).boolean().optional()
}).merge((0, $a5946dc029c62388$export$f7d2da53d88c923c));


const $c721b32d81f05711$export$82e9f45cca5ba907 = "Interaction";
var $c721b32d81f05711$export$a455218a85c89869;
(function(Field) {
    Field["Event"] = "Event";
    Field["Identifier"] = "Identifier";
    Field["Profile"] = "Profile";
    Field["BindMfa"] = "BindMfa";
    Field["Mfa"] = "Mfa";
})($c721b32d81f05711$export$a455218a85c89869 || ($c721b32d81f05711$export$a455218a85c89869 = {}));
var $c721b32d81f05711$export$31bb55db0b3e4187;
(function(Method) {
    Method["Password"] = "Password";
    Method["VerificationCode"] = "VerificationCode";
    Method["Social"] = "Social";
    Method["SingleSignOn"] = "SingleSignOn";
})($c721b32d81f05711$export$31bb55db0b3e4187 || ($c721b32d81f05711$export$31bb55db0b3e4187 = {}));
var $c721b32d81f05711$export$e19cd5f9376f8cee;
(function(Action) {
    /** Create a new entity. (E.g. create an interaction, create a verification code) */ Action["Create"] = "Create";
    /** Update an existing entity. (E.g. change interaction type) */ Action["Update"] = "Update";
    /** Submit updated info to an entity, or submit to the system. (E.g. submit an interaction, submit a verification code to get verified) */ Action["Submit"] = "Submit";
    /** Delete a existing entity. (E.g delete profile ) */ Action["Delete"] = "Delete";
    /** Change an entity to the end state. (E.g. end an interaction) */ Action["End"] = "End";
})($c721b32d81f05711$export$e19cd5f9376f8cee || ($c721b32d81f05711$export$e19cd5f9376f8cee = {}));


/** The type of a token event. */ var $05a8d6e4484a76a1$export$92738401e1603719;
(function(Type) {
    Type["ExchangeTokenBy"] = "ExchangeTokenBy";
    Type["RevokeToken"] = "RevokeToken";
})($05a8d6e4484a76a1$export$92738401e1603719 || ($05a8d6e4484a76a1$export$92738401e1603719 = {}));
var $05a8d6e4484a76a1$export$f435f793048e7a0f;
(function(TokenType) {
    TokenType["AccessToken"] = "AccessToken";
    TokenType["RefreshToken"] = "RefreshToken";
    TokenType["IdToken"] = "IdToken";
    TokenType["AuthorizationCode"] = "AuthorizationCode";
    TokenType["DeviceCode"] = "DeviceCode";
    TokenType["BackchannelAuthenticationRequest"] = "BackchannelAuthenticationRequest";
})($05a8d6e4484a76a1$export$f435f793048e7a0f || ($05a8d6e4484a76a1$export$f435f793048e7a0f = {}));
var $05a8d6e4484a76a1$export$4a1942e414bbb622;
(function(ExchangeByType) {
    ExchangeByType["Unknown"] = "Unknown";
    ExchangeByType["AuthorizationCode"] = "AuthorizationCode";
    ExchangeByType["RefreshToken"] = "RefreshToken";
    ExchangeByType["ClientCredentials"] = "ClientCredentials";
})($05a8d6e4484a76a1$export$4a1942e414bbb622 || ($05a8d6e4484a76a1$export$4a1942e414bbb622 = {}));


/** The type of a hook event. */ var $7f2c94605f7d3c64$export$92738401e1603719;
(function(Type) {
    Type["TriggerHook"] = "TriggerHook";
})($7f2c94605f7d3c64$export$92738401e1603719 || ($7f2c94605f7d3c64$export$92738401e1603719 = {}));


const $5a1dd945731e12c0$export$82e9f45cca5ba907 = "JwtCustomizer";
var $5a1dd945731e12c0$export$92738401e1603719;
(function(Type) {
    Type["AccessToken"] = "AccessToken";
    Type["ClientCredentials"] = "ClientCredentials";
})($5a1dd945731e12c0$export$92738401e1603719 || ($5a1dd945731e12c0$export$92738401e1603719 = {}));


const $e5b6fb903ac1a9f3$export$603af3d01cbca1e0 = "Unknown";


var $846815c36185ef64$export$ce68f19b50b39c0b;
(function(GrantType) {
    GrantType["AuthorizationCode"] = "authorization_code";
    GrantType["RefreshToken"] = "refresh_token";
    GrantType["ClientCredentials"] = "client_credentials";
})($846815c36185ef64$export$ce68f19b50b39c0b || ($846815c36185ef64$export$ce68f19b50b39c0b = {}));





const $1528a40113a1815c$export$c917e1f6c2e1df9e = Object.freeze([
    "id",
    "username",
    "primaryEmail",
    "primaryPhone",
    "name",
    "avatar",
    "customData",
    "identities",
    "lastSignInAt",
    "createdAt",
    "updatedAt",
    "profile",
    "applicationId",
    "isSuspended"
]);
const $1528a40113a1815c$export$996c89999cd0d06b = (0, $ba3e0e5fc0c0c5f0$export$a69f017b19597ff5).guard.pick(// eslint-disable-next-line no-restricted-syntax
Object.fromEntries($1528a40113a1815c$export$c917e1f6c2e1df9e.map((field)=>[
        field,
        true
    ])));
const $1528a40113a1815c$export$78c9be0b3d74e4aa = $1528a40113a1815c$export$996c89999cd0d06b.extend({
    hasPassword: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).boolean().optional(),
    ssoIdentities: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).array((0, $c30499d1d6213ed2$export$53f83427a403da1f).guard).optional()
});
const $1528a40113a1815c$export$45a6ff4daa005563 = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    id: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
    createdAt: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
    type: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).nativeEnum((0, $c0e46a7ec45ea8f3$export$c62e7669a75c5961)),
    agent: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().optional(),
    remainCodes: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).number().optional()
}).array();
var $1528a40113a1815c$export$a17952fc1a8aded7;
(function(InternalRole) {
    /**
     * Internal admin role for Machine-to-Machine apps in Logto user tenants.
     *
     * It should NOT be assigned to any user.
     */ InternalRole["Admin"] = "#internal:admin";
})($1528a40113a1815c$export$a17952fc1a8aded7 || ($1528a40113a1815c$export$a17952fc1a8aded7 = {}));
var $1528a40113a1815c$export$cc68ab3265ed0467;
(function(AdminTenantRole) {
    /** Common user role in admin tenant. */ AdminTenantRole["User"] = "user";
    /** The role for machine to machine applications that represent a user tenant and send requests to Logto Cloud. */ AdminTenantRole["TenantApplication"] = "tenantApplication";
})($1528a40113a1815c$export$cc68ab3265ed0467 || ($1528a40113a1815c$export$cc68ab3265ed0467 = {}));
var $1528a40113a1815c$export$90d62586f282d378;
(function(PredefinedScope) {
    PredefinedScope["All"] = "all";
})($1528a40113a1815c$export$90d62586f282d378 || ($1528a40113a1815c$export$90d62586f282d378 = {}));
const $1528a40113a1815c$export$7ffb47057ef1f416 = (0, $ba3e0e5fc0c0c5f0$export$a69f017b19597ff5).guard.pick({
    id: true,
    avatar: true,
    name: true
});










const $98020b2c3e3e6ddb$export$3efa9f96d1ddc3f2 = (0, $f68f1c4dcc6a46f1$export$8546186883d6ff3e).guard.extend({
    resource: (0, $01bd9aeaf1aa3e97$export$e9a269813a6315a4).guard
});



/**
 * Manually implement zod guards of some node OIDC provider types.
 *
 * Please note that we defined `accessTokenPayloadGuard` and `clientCredentialsPayloadGuard` in this file, they are used to make the user-defined token
 * sample to be aligned with the real token payload given by the OIDC provider in a real use case.
 *
 * Only keep the least necessary fields in the guards to align with the raw token payload that can be used for `extraTokenClaims` method.
 */ 


const $00ce94c3e7e40731$var$baseTokenPayloadGuardObject = {
    jti: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
    aud: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).union([
        (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
        (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().array()
    ]),
    scope: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().optional(),
    clientId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().optional()
};
const $00ce94c3e7e40731$export$e75da9f812cdc25c = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object((0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, $00ce94c3e7e40731$var$baseTokenPayloadGuardObject), {
    accountId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
    expiresWithSession: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).boolean().optional(),
    grantId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
    gty: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
    sessionUid: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().optional(),
    sid: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().optional(),
    kind: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).literal("AccessToken")
})).strict();
const $00ce94c3e7e40731$export$702899eeb662faa6 = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object((0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, $00ce94c3e7e40731$var$baseTokenPayloadGuardObject), {
    kind: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).literal("ClientCredentials")
})).strict();


const $d7929d7bee228ecc$export$f3e66f6027afb6ea = (0, $1528a40113a1815c$export$996c89999cd0d06b).extend({
    ssoIdentities: (0, $c30499d1d6213ed2$export$53f83427a403da1f).guard.pick({
        issuer: true,
        identityId: true,
        detail: true
    }).array(),
    mfaVerificationFactors: (0, $c0e46a7ec45ea8f3$export$10c80e60471dfbfa),
    roles: (0, $d9b7eddf9bcbdc1d$export$d1d9e451800db729).guard.pick({
        id: true,
        name: true,
        description: true
    }).extend({
        scopes: (0, $98020b2c3e3e6ddb$export$3efa9f96d1ddc3f2).pick({
            id: true,
            name: true,
            description: true,
            resourceId: true,
            resource: true
        }).array()
    }).array(),
    organizations: (0, $e8e2c4287d2de9f0$export$8cdb1b004e612f6c).guard.pick({
        id: true,
        name: true,
        description: true
    }).array(),
    organizationRoles: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
        organizationId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
        roleId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
        roleName: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string()
    }).array()
});
const $d7929d7bee228ecc$export$35f2e5a17d1b65f1 = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    script: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
    environmentVariables: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).record((0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string()),
    contextSample: (0, $2b3ee26e56fddc99$export$4ac62c0537cd0db7)
}).partial();
const $d7929d7bee228ecc$export$91f53954808434ef = $d7929d7bee228ecc$export$35f2e5a17d1b65f1.extend({
    // Use partial token guard since users customization may not rely on all fields.
    tokenSample: (0, $00ce94c3e7e40731$export$e75da9f812cdc25c).partial().optional(),
    contextSample: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
        user: $d7929d7bee228ecc$export$f3e66f6027afb6ea.partial()
    }).optional()
}).strict();
const $d7929d7bee228ecc$export$7c0ea0dbf45c263b = $d7929d7bee228ecc$export$35f2e5a17d1b65f1.extend({
    // Use partial token guard since users customization may not rely on all fields.
    tokenSample: (0, $00ce94c3e7e40731$export$702899eeb662faa6).partial().optional()
}).strict();
var $d7929d7bee228ecc$export$2b5732891b015568;
(function(LogtoJwtTokenKeyType) {
    LogtoJwtTokenKeyType["AccessToken"] = "access-token";
    LogtoJwtTokenKeyType["ClientCredentials"] = "client-credentials";
})($d7929d7bee228ecc$export$2b5732891b015568 || ($d7929d7bee228ecc$export$2b5732891b015568 = {}));
const $d7929d7bee228ecc$export$862c888fb3aaa059 = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).discriminatedUnion("tokenType", [
    (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object((0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({
        tokenType: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).literal($d7929d7bee228ecc$export$2b5732891b015568.AccessToken)
    }, $d7929d7bee228ecc$export$91f53954808434ef.required({
        script: true
    }).pick({
        environmentVariables: true,
        script: true
    }).shape), {
        token: $d7929d7bee228ecc$export$91f53954808434ef.required().shape.tokenSample,
        context: $d7929d7bee228ecc$export$91f53954808434ef.required().shape.contextSample
    })),
    (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object((0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({
        tokenType: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).literal($d7929d7bee228ecc$export$2b5732891b015568.ClientCredentials)
    }, $d7929d7bee228ecc$export$7c0ea0dbf45c263b.required({
        script: true
    }).pick({
        environmentVariables: true,
        script: true
    }).shape), {
        token: $d7929d7bee228ecc$export$7c0ea0dbf45c263b.required().shape.tokenSample
    }))
]);
/**
 * This guard is for cloud API use (request body guard).
 * Since the cloud API will be use by both testing and production, should keep the fields as general as possible.
 * The response guard for the cloud API is `jsonObjectGuard` since it extends the `token` with extra claims.
 */ const $d7929d7bee228ecc$var$commonJwtCustomizerGuard = $d7929d7bee228ecc$export$35f2e5a17d1b65f1.pick({
    script: true,
    environmentVariables: true
}).required({
    script: true
}).extend({
    token: (0, $2b3ee26e56fddc99$export$4ac62c0537cd0db7)
});
const $d7929d7bee228ecc$export$7a76d1cb4609fd08 = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).discriminatedUnion("tokenType", [
    $d7929d7bee228ecc$var$commonJwtCustomizerGuard.extend({
        tokenType: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).literal($d7929d7bee228ecc$export$2b5732891b015568.AccessToken),
        context: (0, $2b3ee26e56fddc99$export$4ac62c0537cd0db7)
    }),
    $d7929d7bee228ecc$var$commonJwtCustomizerGuard.extend({
        tokenType: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).literal($d7929d7bee228ecc$export$2b5732891b015568.ClientCredentials)
    })
]);



var $81e1a824f031f67b$export$15b2d6ce08800aad;
(function(LogtoOidcConfigKeyType) {
    LogtoOidcConfigKeyType["PrivateKeys"] = "private-keys";
    LogtoOidcConfigKeyType["CookieKeys"] = "cookie-keys";
})($81e1a824f031f67b$export$15b2d6ce08800aad || ($81e1a824f031f67b$export$15b2d6ce08800aad = {}));
var $81e1a824f031f67b$export$30b1b445ccf496a4;
(function(LogtoOidcConfigKey) {
    LogtoOidcConfigKey["PrivateKeys"] = "oidc.privateKeys";
    LogtoOidcConfigKey["CookieKeys"] = "oidc.cookieKeys";
})($81e1a824f031f67b$export$30b1b445ccf496a4 || ($81e1a824f031f67b$export$30b1b445ccf496a4 = {}));
var $81e1a824f031f67b$export$e33814a1cc7d5e24;
(function(SupportedSigningKeyAlgorithm) {
    SupportedSigningKeyAlgorithm["RSA"] = "RSA";
    SupportedSigningKeyAlgorithm["EC"] = "EC";
})($81e1a824f031f67b$export$e33814a1cc7d5e24 || ($81e1a824f031f67b$export$e33814a1cc7d5e24 = {}));
const $81e1a824f031f67b$export$a1c94f11d0704ec5 = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    id: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
    value: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
    createdAt: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).number()
});
const $81e1a824f031f67b$export$f5f9e866e854b681 = Object.freeze({
    [$81e1a824f031f67b$export$30b1b445ccf496a4.PrivateKeys]: $81e1a824f031f67b$export$a1c94f11d0704ec5.array(),
    [$81e1a824f031f67b$export$30b1b445ccf496a4.CookieKeys]: $81e1a824f031f67b$export$a1c94f11d0704ec5.array()
});
var $81e1a824f031f67b$export$35597c7744ab3ee6;
(function(LogtoJwtTokenKey) {
    LogtoJwtTokenKey["AccessToken"] = "jwt.accessToken";
    LogtoJwtTokenKey["ClientCredentials"] = "jwt.clientCredentials";
})($81e1a824f031f67b$export$35597c7744ab3ee6 || ($81e1a824f031f67b$export$35597c7744ab3ee6 = {}));
const $81e1a824f031f67b$export$2bd93abaa47d773b = Object.freeze({
    [$81e1a824f031f67b$export$35597c7744ab3ee6.AccessToken]: (0, $d7929d7bee228ecc$export$91f53954808434ef),
    [$81e1a824f031f67b$export$35597c7744ab3ee6.ClientCredentials]: (0, $d7929d7bee228ecc$export$7c0ea0dbf45c263b)
});
const $81e1a824f031f67b$export$f10f3dc56ae796fc = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).discriminatedUnion("key", [
    (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
        key: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).literal($81e1a824f031f67b$export$35597c7744ab3ee6.AccessToken),
        value: (0, $d7929d7bee228ecc$export$91f53954808434ef)
    }),
    (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
        key: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).literal($81e1a824f031f67b$export$35597c7744ab3ee6.ClientCredentials),
        value: (0, $d7929d7bee228ecc$export$7c0ea0dbf45c263b)
    })
]);
const $81e1a824f031f67b$export$73b6ce9fa4b1d915 = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    signInExperienceCustomized: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).boolean(),
    organizationCreated: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).boolean(),
    developmentTenantMigrationNotification: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
        isPaidTenant: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).boolean(),
        /**
         * Tag is used to store the original tenant tag before dev tenant migration.
         * This field is only used for DB rollback and because the `TenantTag` may change, so we don't guard it as the `TenantTag` type.
         */ tag: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
        readAt: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).number().optional()
    }).optional(),
    checkedChargeNotification: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
        token: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).boolean().optional(),
        apiResource: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).boolean().optional(),
        machineToMachineApp: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).boolean().optional(),
        tenantMember: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).boolean().optional()
    }).optional()
});
const $81e1a824f031f67b$export$bf5ba14ccde3732d = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    appId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
    appSecret: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
    resource: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string()
});
var $81e1a824f031f67b$export$a249f1a8f5d6b725;
(function(LogtoTenantConfigKey) {
    LogtoTenantConfigKey["AdminConsole"] = "adminConsole";
    LogtoTenantConfigKey["CloudConnection"] = "cloudConnection";
    /** The URL to redirect when session not found in Sign-in Experience. */ LogtoTenantConfigKey["SessionNotFoundRedirectUrl"] = "sessionNotFoundRedirectUrl";
})($81e1a824f031f67b$export$a249f1a8f5d6b725 || ($81e1a824f031f67b$export$a249f1a8f5d6b725 = {}));
const $81e1a824f031f67b$export$aebdc60e0ed8c4a5 = Object.freeze({
    [$81e1a824f031f67b$export$a249f1a8f5d6b725.AdminConsole]: $81e1a824f031f67b$export$73b6ce9fa4b1d915,
    [$81e1a824f031f67b$export$a249f1a8f5d6b725.CloudConnection]: $81e1a824f031f67b$export$bf5ba14ccde3732d,
    [$81e1a824f031f67b$export$a249f1a8f5d6b725.SessionNotFoundRedirectUrl]: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
        url: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string()
    })
});
const $81e1a824f031f67b$export$581c47e529f15f7a = Object.freeze([
    ...Object.values($81e1a824f031f67b$export$30b1b445ccf496a4),
    ...Object.values($81e1a824f031f67b$export$35597c7744ab3ee6),
    ...Object.values($81e1a824f031f67b$export$a249f1a8f5d6b725)
]);
const $81e1a824f031f67b$export$7684a7ad17d11565 = Object.freeze((0, $0de5391da8318002$export$581ff339ea0ba762)({}, $81e1a824f031f67b$export$f5f9e866e854b681, $81e1a824f031f67b$export$2bd93abaa47d773b, $81e1a824f031f67b$export$aebdc60e0ed8c4a5));
const $81e1a824f031f67b$export$aeb5ffc4d17f8d05 = $81e1a824f031f67b$export$a1c94f11d0704ec5.omit({
    value: true
}).merge((0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    signingKeyAlgorithm: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).nativeEnum($81e1a824f031f67b$export$e33814a1cc7d5e24).optional()
}));







const $36aad917333cdc3c$var$emailIdentifierGuard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().regex((0, $ca8ea17c0d092285$export$bdb23a0789f9885e));
const $36aad917333cdc3c$var$phoneIdentifierGuard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().regex((0, $ca8ea17c0d092285$export$205be3a4a78028e));
const $36aad917333cdc3c$var$codeGuard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1);
const $36aad917333cdc3c$export$6d0d05bfd78fb80d = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).union([
    (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
        email: $36aad917333cdc3c$var$emailIdentifierGuard
    }),
    (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
        phone: $36aad917333cdc3c$var$phoneIdentifierGuard
    })
]);
const $36aad917333cdc3c$export$37e88450d6946bf5 = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    email: $36aad917333cdc3c$var$emailIdentifierGuard,
    verificationCode: $36aad917333cdc3c$var$codeGuard
});
const $36aad917333cdc3c$export$7934fcc6bad2c738 = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    phone: $36aad917333cdc3c$var$phoneIdentifierGuard,
    verificationCode: $36aad917333cdc3c$var$codeGuard
});
const $36aad917333cdc3c$export$40faae2aa67d03fa = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).union([
    $36aad917333cdc3c$export$37e88450d6946bf5,
    $36aad917333cdc3c$export$7934fcc6bad2c738
]);


const $e77cfc775e0ed7e6$export$6df2cc07ea6d94e4 = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    username: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1),
    password: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1)
});
const $e77cfc775e0ed7e6$export$fe8dab8622cea973 = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    email: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1),
    password: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1)
});
const $e77cfc775e0ed7e6$export$654a1e6496f28807 = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    phone: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1),
    password: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().min(1)
});
const $e77cfc775e0ed7e6$export$37cf496dfd2fc283 = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    connectorId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
    connectorData: (0, $2b3ee26e56fddc99$export$4ac62c0537cd0db7)
});
const $e77cfc775e0ed7e6$export$c45e1b6fde4cf46f = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    connectorId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
    email: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string()
});
const $e77cfc775e0ed7e6$export$368d623e521112fc = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    connectorId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
    phone: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string()
});
var $e77cfc775e0ed7e6$export$5b6496a0e009b82d;
(function(InteractionEvent) {
    InteractionEvent["SignIn"] = "SignIn";
    InteractionEvent["Register"] = "Register";
    InteractionEvent["ForgotPassword"] = "ForgotPassword";
})($e77cfc775e0ed7e6$export$5b6496a0e009b82d || ($e77cfc775e0ed7e6$export$5b6496a0e009b82d = {}));
const $e77cfc775e0ed7e6$export$bdffc825a5318abd = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).nativeEnum($e77cfc775e0ed7e6$export$5b6496a0e009b82d);
const $e77cfc775e0ed7e6$export$683a5ef9930735ce = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).union([
    $e77cfc775e0ed7e6$export$6df2cc07ea6d94e4,
    $e77cfc775e0ed7e6$export$fe8dab8622cea973,
    $e77cfc775e0ed7e6$export$654a1e6496f28807,
    (0, $36aad917333cdc3c$export$37e88450d6946bf5),
    (0, $36aad917333cdc3c$export$7934fcc6bad2c738),
    $e77cfc775e0ed7e6$export$37cf496dfd2fc283,
    $e77cfc775e0ed7e6$export$c45e1b6fde4cf46f,
    $e77cfc775e0ed7e6$export$368d623e521112fc
]);
const $e77cfc775e0ed7e6$export$5f4b9d03b6e579b = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    username: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().regex((0, $ca8ea17c0d092285$export$221be9ce6b96eec3)).optional(),
    email: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().regex((0, $ca8ea17c0d092285$export$bdb23a0789f9885e)).optional(),
    phone: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().regex((0, $ca8ea17c0d092285$export$205be3a4a78028e)).optional(),
    connectorId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().optional(),
    password: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().optional()
});
var $e77cfc775e0ed7e6$export$68a887ed3b61b98e;
(function(MissingProfile) {
    MissingProfile["username"] = "username";
    MissingProfile["email"] = "email";
    MissingProfile["phone"] = "phone";
    MissingProfile["password"] = "password";
    MissingProfile["emailOrPhone"] = "emailOrPhone";
})($e77cfc775e0ed7e6$export$68a887ed3b61b98e || ($e77cfc775e0ed7e6$export$68a887ed3b61b98e = {}));
const $e77cfc775e0ed7e6$export$3cf8b0ef3f34f283 = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    // Unlike identifier payload which has indicator like "email",
    // mfa payload must have an additional type field to indicate type
    type: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).literal((0, $c0e46a7ec45ea8f3$export$c62e7669a75c5961).TOTP),
    code: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string()
});
const $e77cfc775e0ed7e6$export$909f398f25e38a05 = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    type: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).literal((0, $c0e46a7ec45ea8f3$export$c62e7669a75c5961).WebAuthn),
    id: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
    rawId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
    /**
     * The response from WebAuthn API
     *
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/PublicKeyCredential}
     */ response: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
        clientDataJSON: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
        attestationObject: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
        authenticatorData: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().optional(),
        transports: (0, $19b00b9869ef71ab$export$aa941865a0228ea6).array().optional(),
        publicKeyAlgorithm: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).number().optional(),
        publicKey: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().optional()
    }),
    authenticatorAttachment: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).enum([
        "cross-platform",
        "platform"
    ]).optional(),
    clientExtensionResults: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
        appid: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).boolean().optional(),
        crepProps: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
            rk: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).boolean().optional()
        }).optional(),
        hmacCreateSecret: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).boolean().optional()
    })
});
const $e77cfc775e0ed7e6$export$f2b00820cf0758fd = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    type: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).literal((0, $c0e46a7ec45ea8f3$export$c62e7669a75c5961).BackupCode)
});
const $e77cfc775e0ed7e6$export$dd85cb6e2ec2273d = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).discriminatedUnion("type", [
    $e77cfc775e0ed7e6$export$3cf8b0ef3f34f283,
    $e77cfc775e0ed7e6$export$909f398f25e38a05,
    $e77cfc775e0ed7e6$export$f2b00820cf0758fd
]);
const $e77cfc775e0ed7e6$export$850eb029f701b547 = $e77cfc775e0ed7e6$export$3cf8b0ef3f34f283;
const $e77cfc775e0ed7e6$export$4cf08ba69fb7c5b0 = $e77cfc775e0ed7e6$export$909f398f25e38a05.omit({
    response: true
}).extend({
    response: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
        clientDataJSON: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
        authenticatorData: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
        signature: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
        userHandle: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().optional()
    })
});
const $e77cfc775e0ed7e6$export$975166347c3a7642 = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    type: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).literal((0, $c0e46a7ec45ea8f3$export$c62e7669a75c5961).BackupCode),
    code: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string()
});
const $e77cfc775e0ed7e6$export$4d6ec7236b10bd3 = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).discriminatedUnion("type", [
    $e77cfc775e0ed7e6$export$850eb029f701b547,
    $e77cfc775e0ed7e6$export$4cf08ba69fb7c5b0,
    $e77cfc775e0ed7e6$export$975166347c3a7642
]);
const $e77cfc775e0ed7e6$export$fc67cd5d235908c3 = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    type: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).literal((0, $c0e46a7ec45ea8f3$export$c62e7669a75c5961).TOTP),
    secret: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string()
});
const $e77cfc775e0ed7e6$export$5159fecc862158ed = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    type: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).literal((0, $c0e46a7ec45ea8f3$export$c62e7669a75c5961).WebAuthn),
    challenge: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string()
});
const $e77cfc775e0ed7e6$export$ea1eb8d3018f63a8 = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    type: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).literal((0, $c0e46a7ec45ea8f3$export$c62e7669a75c5961).BackupCode),
    codes: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).array((0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string())
});
const $e77cfc775e0ed7e6$export$ad9fd10992842c85 = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).discriminatedUnion("type", [
    $e77cfc775e0ed7e6$export$fc67cd5d235908c3,
    $e77cfc775e0ed7e6$export$5159fecc862158ed,
    $e77cfc775e0ed7e6$export$ea1eb8d3018f63a8
]);
const $e77cfc775e0ed7e6$export$4a8ba443157a60f8 = $e77cfc775e0ed7e6$export$fc67cd5d235908c3;
const $e77cfc775e0ed7e6$export$9c31fcc1c40b68d4 = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    type: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).literal((0, $c0e46a7ec45ea8f3$export$c62e7669a75c5961).WebAuthn),
    credentialId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
    publicKey: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
    transports: (0, $19b00b9869ef71ab$export$aa941865a0228ea6).array(),
    counter: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).number(),
    agent: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string()
});
const $e77cfc775e0ed7e6$export$d103a080e257fd4e = $e77cfc775e0ed7e6$export$ea1eb8d3018f63a8;
const $e77cfc775e0ed7e6$export$346032d688e2ee1d = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).discriminatedUnion("type", [
    $e77cfc775e0ed7e6$export$4a8ba443157a60f8,
    $e77cfc775e0ed7e6$export$9c31fcc1c40b68d4,
    $e77cfc775e0ed7e6$export$d103a080e257fd4e
]);
const $e77cfc775e0ed7e6$export$7d4f7ea03460ffc6 = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    type: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).nativeEnum((0, $c0e46a7ec45ea8f3$export$c62e7669a75c5961)),
    id: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string()
});


/** Mode for matching the given value(s) and database entries. */ var $bc497a887d118fdb$export$a51f1551b9b55e4d;
(function(SearchMatchMode) {
    /** Use `=` or in-array checking. */ SearchMatchMode["Exact"] = "exact";
    /** Use the keyword `LIKE`. See [Postgres docs](https://www.postgresql.org/docs/current/functions-matching.html#FUNCTIONS-LIKE). */ SearchMatchMode["Like"] = "like";
    /** Use the keyword `SIMILAR TO` for regular expression matching. See [Postgres docs](https://www.postgresql.org/docs/current/functions-matching.html#FUNCTIONS-SIMILARTO-REGEXP). */ SearchMatchMode["SimilarTo"] = "similar_to";
    /** Use the keyword `POSIX` for regular expression matching. See [Postgres docs](https://www.postgresql.org/docs/current/functions-matching.html#FUNCTIONS-POSIX-REGEXP). */ SearchMatchMode["Posix"] = "posix";
})($bc497a887d118fdb$export$a51f1551b9b55e4d || ($bc497a887d118fdb$export$a51f1551b9b55e4d = {}));
var $bc497a887d118fdb$export$6d217b707eba5852;
(function(SearchJointMode) {
    SearchJointMode["Or"] = "or";
    SearchJointMode["And"] = "and";
})($bc497a887d118fdb$export$6d217b707eba5852 || ($bc497a887d118fdb$export$6d217b707eba5852 = {}));











const $e45d05057b97a17e$export$71547dc50acd9a7c = (0, $660b8d53428b2c71$export$73c91b53927e421e).guard.pick({
    id: true,
    name: true,
    type: true
});
const $e45d05057b97a17e$export$590c2403cf18bb08 = (0, $660b8d53428b2c71$export$73c91b53927e421e).createGuard.omit({
    id: true,
    createdAt: true,
    secret: true,
    tenantId: true
}).partial().merge((0, $660b8d53428b2c71$export$73c91b53927e421e).createGuard.pick({
    name: true,
    type: true
}));
const $e45d05057b97a17e$export$f8933e674a6d3243 = $e45d05057b97a17e$export$590c2403cf18bb08.partial().omit({
    type: true,
    isThirdParty: true
});
const $e45d05057b97a17e$export$8f1fa196fa63bf04 = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    organizationScopes: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).array((0, $03b914be955f9f6f$export$9d110f69f69dde7a).guard.pick({
        id: true,
        name: true,
        description: true
    })),
    resourceScopes: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).array((0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
        resource: (0, $01bd9aeaf1aa3e97$export$e9a269813a6315a4).guard.pick({
            id: true,
            name: true,
            indicator: true
        }),
        scopes: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).array((0, $f68f1c4dcc6a46f1$export$8546186883d6ff3e).guard.pick({
            id: true,
            name: true,
            description: true
        }))
    })),
    userScopes: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).array((0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).nativeEnum((0, $7e115e7b30c7027b$export$4b02c5b431f6eb78)))
});
var $e45d05057b97a17e$export$9b2e974edaaa0e9c;
(function(ApplicationUserConsentScopeType) {
    ApplicationUserConsentScopeType["OrganizationScopes"] = "organization-scopes";
    ApplicationUserConsentScopeType["ResourceScopes"] = "resource-scopes";
    ApplicationUserConsentScopeType["UserScopes"] = "user-scopes";
})($e45d05057b97a17e$export$9b2e974edaaa0e9c || ($e45d05057b97a17e$export$9b2e974edaaa0e9c = {}));
const $e45d05057b97a17e$export$8629c19b82b57228 = (0, $82c906177bd2d562$export$b21e17c60fe7d89c).createGuard.omit({
    applicationId: true,
    tenantId: true,
    termsOfUseUrl: true,
    privacyPolicyUrl: true
})// Align with the sign-in-experience create guard.
.merge((0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    termsOfUseUrl: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(2048).url().optional().nullable().or((0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).literal("")),
    privacyPolicyUrl: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().max(2048).url().optional().nullable().or((0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).literal(""))
}));




var $d2c01c9769f17a4a$export$4857b48889187a39;
(function(AlterationStateKey) {
    AlterationStateKey["AlterationState"] = "alterationState";
})($d2c01c9769f17a4a$export$4857b48889187a39 || ($d2c01c9769f17a4a$export$4857b48889187a39 = {}));
const $d2c01c9769f17a4a$export$b648b84528d1cda3 = Object.freeze({
    [$d2c01c9769f17a4a$export$4857b48889187a39.AlterationState]: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
        timestamp: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).number(),
        updatedAt: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().optional()
    })
});
var $d2c01c9769f17a4a$export$465a18018f692373;
(function(StorageProvider) {
    StorageProvider["AzureStorage"] = "AzureStorage";
    StorageProvider["S3Storage"] = "S3Storage";
    StorageProvider["GoogleStorage"] = "GoogleStorage";
})($d2c01c9769f17a4a$export$465a18018f692373 || ($d2c01c9769f17a4a$export$465a18018f692373 = {}));
const $d2c01c9769f17a4a$var$basicConfig = {
    publicUrl: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().optional()
};
const $d2c01c9769f17a4a$export$6882da4bfe6c548e = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).discriminatedUnion("provider", [
    (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object((0, $0de5391da8318002$export$581ff339ea0ba762)({
        provider: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).literal($d2c01c9769f17a4a$export$465a18018f692373.AzureStorage),
        connectionString: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
        container: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string()
    }, $d2c01c9769f17a4a$var$basicConfig)),
    (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object((0, $0de5391da8318002$export$581ff339ea0ba762)({
        provider: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).literal($d2c01c9769f17a4a$export$465a18018f692373.S3Storage),
        endpoint: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().optional(),
        region: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().optional(),
        bucket: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
        accessKeyId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
        accessSecretKey: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string()
    }, $d2c01c9769f17a4a$var$basicConfig)),
    (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object((0, $0de5391da8318002$export$581ff339ea0ba762)({
        provider: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).literal($d2c01c9769f17a4a$export$465a18018f692373.GoogleStorage),
        projectId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
        keyFilename: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
        bucketName: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string()
    }, $d2c01c9769f17a4a$var$basicConfig))
]);
var $d2c01c9769f17a4a$export$589fea410707bd1e;
(function(StorageProviderKey) {
    StorageProviderKey["StorageProvider"] = "storageProvider";
})($d2c01c9769f17a4a$export$589fea410707bd1e || ($d2c01c9769f17a4a$export$589fea410707bd1e = {}));
const $d2c01c9769f17a4a$export$1755428192b369f4 = Object.freeze({
    [$d2c01c9769f17a4a$export$589fea410707bd1e.StorageProvider]: $d2c01c9769f17a4a$export$6882da4bfe6c548e
});
var $d2c01c9769f17a4a$export$c04e0db396d22ede;
(function(EmailServiceProvider) {
    EmailServiceProvider["SendGrid"] = "SendGrid";
})($d2c01c9769f17a4a$export$c04e0db396d22ede || ($d2c01c9769f17a4a$export$c04e0db396d22ede = {}));
const $d2c01c9769f17a4a$export$ae559586eab6a29d = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    provider: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).literal($d2c01c9769f17a4a$export$c04e0db396d22ede.SendGrid),
    apiKey: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
    templateId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
    fromName: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
    fromEmail: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string()
});
const $d2c01c9769f17a4a$export$eed90e6abe4b6331 = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).discriminatedUnion("provider", [
    $d2c01c9769f17a4a$export$ae559586eab6a29d
]);
var $d2c01c9769f17a4a$export$1b716a2fb233f165;
(function(EmailServiceProviderKey) {
    EmailServiceProviderKey["EmailServiceProvider"] = "emailServiceProvider";
})($d2c01c9769f17a4a$export$1b716a2fb233f165 || ($d2c01c9769f17a4a$export$1b716a2fb233f165 = {}));
const $d2c01c9769f17a4a$export$148ac52baf2fe1fe = Object.freeze({
    [$d2c01c9769f17a4a$export$1b716a2fb233f165.EmailServiceProvider]: $d2c01c9769f17a4a$export$eed90e6abe4b6331
});
var $d2c01c9769f17a4a$export$3f96ea771b870c9b;
(function(DemoSocialProvider) {
    DemoSocialProvider["Google"] = "google";
    DemoSocialProvider["GitHub"] = "github";
    DemoSocialProvider["Discord"] = "discord";
})($d2c01c9769f17a4a$export$3f96ea771b870c9b || ($d2c01c9769f17a4a$export$3f96ea771b870c9b = {}));
const $d2c01c9769f17a4a$export$b0cb774a6cdd5c2c = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    name: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
    logo: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
    logoDark: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
    provider: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).nativeEnum($d2c01c9769f17a4a$export$3f96ea771b870c9b),
    clientId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string()
}).array();
var $d2c01c9769f17a4a$export$2b6e95870946a21e;
(function(DemoSocialKey) {
    DemoSocialKey["DemoSocial"] = "demoSocial";
})($d2c01c9769f17a4a$export$2b6e95870946a21e || ($d2c01c9769f17a4a$export$2b6e95870946a21e = {}));
const $d2c01c9769f17a4a$export$ae90bacd174e78c0 = Object.freeze({
    [$d2c01c9769f17a4a$export$2b6e95870946a21e.DemoSocial]: $d2c01c9769f17a4a$export$b0cb774a6cdd5c2c
});
const $d2c01c9769f17a4a$export$4792a20f2d99e347 = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    zoneId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
    apiToken: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
    blockedDomains: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().array().optional()
});
const $d2c01c9769f17a4a$export$aa9834a14f8dda83 = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    /* Cloudflare Workers & Pages account ID */ accountIdentifier: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
    /* KV namespace ID */ namespaceIdentifier: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
    /* Key prefix for protected app config */ keyName: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
    /* The default domain (e.g protected.app) for the protected app */ domain: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
    apiToken: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string()
});
var $d2c01c9769f17a4a$export$24bf5ccdb699e65e;
(function(CloudflareKey) {
    CloudflareKey["HostnameProvider"] = "cloudflareHostnameProvider";
    CloudflareKey["ProtectedAppConfigProvider"] = "cloudflareProtectedAppConfigProvider";
    CloudflareKey["ProtectedAppHostnameProvider"] = "cloudflareProtectedAppHostnameProvider";
})($d2c01c9769f17a4a$export$24bf5ccdb699e65e || ($d2c01c9769f17a4a$export$24bf5ccdb699e65e = {}));
const $d2c01c9769f17a4a$export$7dae3b09179b4445 = Object.freeze({
    [$d2c01c9769f17a4a$export$24bf5ccdb699e65e.HostnameProvider]: $d2c01c9769f17a4a$export$4792a20f2d99e347,
    [$d2c01c9769f17a4a$export$24bf5ccdb699e65e.ProtectedAppConfigProvider]: $d2c01c9769f17a4a$export$aa9834a14f8dda83,
    [$d2c01c9769f17a4a$export$24bf5ccdb699e65e.ProtectedAppHostnameProvider]: $d2c01c9769f17a4a$export$4792a20f2d99e347
});
const $d2c01c9769f17a4a$export$20b0450fb73770e2 = Object.freeze([
    ...Object.values($d2c01c9769f17a4a$export$4857b48889187a39),
    ...Object.values($d2c01c9769f17a4a$export$589fea410707bd1e),
    ...Object.values($d2c01c9769f17a4a$export$2b6e95870946a21e),
    ...Object.values($d2c01c9769f17a4a$export$24bf5ccdb699e65e),
    ...Object.values($d2c01c9769f17a4a$export$1b716a2fb233f165)
]);
const $d2c01c9769f17a4a$export$b74a29afb5bd243f = Object.freeze((0, $0de5391da8318002$export$581ff339ea0ba762)({}, $d2c01c9769f17a4a$export$b648b84528d1cda3, $d2c01c9769f17a4a$export$1755428192b369f4, $d2c01c9769f17a4a$export$ae90bacd174e78c0, $d2c01c9769f17a4a$export$7dae3b09179b4445, $d2c01c9769f17a4a$export$148ac52baf2fe1fe));



const $2638a0914c8dab6b$export$8ef133238cd2874 = 8388608; // 8MB
const $2638a0914c8dab6b$export$e2adfe8ff5d50ee4 = [
    "image/jpeg",
    "image/png",
    "image/gif",
    "image/vnd.microsoft.icon",
    "image/x-icon",
    "image/svg+xml",
    "image/tiff",
    "image/webp",
    "image/bmp"
];
const $2638a0914c8dab6b$var$allowUploadMimeTypeGuard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).enum($2638a0914c8dab6b$export$e2adfe8ff5d50ee4);
const $2638a0914c8dab6b$export$2dd272e4b553b8ba = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    status: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).union([
        (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).literal("ready"),
        (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).literal("not_configured")
    ]),
    allowUploadMimeTypes: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).array($2638a0914c8dab6b$var$allowUploadMimeTypeGuard).optional(),
    maxUploadFileSize: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).number().optional()
});
const $2638a0914c8dab6b$export$aaf4674b6bfc26fb = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    url: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string()
});




const $e18243c342f84fa6$var$hookExecutionStatsGuard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    successCount: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).number(),
    requestCount: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).number()
});
const $e18243c342f84fa6$export$5c5f088aefddc59e = (0, $c8148cbdca7daef6$export$5fbefe39e79899a6).guard.extend({
    executionStats: $e18243c342f84fa6$var$hookExecutionStatsGuard
});
const $e18243c342f84fa6$export$4d1fa1bc05a05454 = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    responseStatus: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).number(),
    responseBody: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string()
});


var $fc5875935c42829a$export$2cad645b7df28dd5;
(function(ServiceLogType) {
    ServiceLogType["SendEmail"] = "sendEmail";
    ServiceLogType["SendSms"] = "sendSms";
    ServiceLogType["FetchCustomJwt"] = "fetchCustomJwt";
})($fc5875935c42829a$export$2cad645b7df28dd5 || ($fc5875935c42829a$export$2cad645b7df28dd5 = {}));


var $93d2089b0ece27e4$export$14faa19a0f3bbeb2;
(function(Theme) {
    Theme["Light"] = "light";
    Theme["Dark"] = "dark";
})($93d2089b0ece27e4$export$14faa19a0f3bbeb2 || ($93d2089b0ece27e4$export$14faa19a0f3bbeb2 = {}));



const $f045820dfe30a75b$export$3b9208034fe791c1 = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    appId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string()
}).partial();



const $353245056dd008ff$var$dashboardUsersDataGuard = (0, $db5e9db6ef1a480f$export$be5493f9613cbbe)({
    count: (0, $db5e9db6ef1a480f$export$98e628dec113755e)(),
    delta: (0, $db5e9db6ef1a480f$export$98e628dec113755e)()
});
const $353245056dd008ff$export$9d1c6ddb5817c52e = (0, $db5e9db6ef1a480f$export$be5493f9613cbbe)({
    today: $353245056dd008ff$var$dashboardUsersDataGuard,
    last7Days: $353245056dd008ff$var$dashboardUsersDataGuard
});
const $353245056dd008ff$export$fd0651ecbc2a1652 = (0, $db5e9db6ef1a480f$export$be5493f9613cbbe)({
    dauCurve: (0, $db5e9db6ef1a480f$export$2f23118c22fb2630)((0, $db5e9db6ef1a480f$export$be5493f9613cbbe)({
        date: (0, $db5e9db6ef1a480f$export$22b082955e083ec3)(),
        count: (0, $db5e9db6ef1a480f$export$98e628dec113755e)()
    })),
    dau: $353245056dd008ff$var$dashboardUsersDataGuard,
    wau: $353245056dd008ff$var$dashboardUsersDataGuard,
    mau: $353245056dd008ff$var$dashboardUsersDataGuard
});



const $74603a6b9a0f2220$export$81290fbb16f7e442 = Object.freeze([
    "id",
    "domain",
    "status",
    "errorMessage",
    "dnsRecords"
]);
const $74603a6b9a0f2220$export$8181686bf073ccc4 = (0, $fa7b63c34b0d9b48$export$e3e9d7fdf7b67caa).guard.pick({
    id: true,
    domain: true,
    status: true,
    errorMessage: true,
    dnsRecords: true
});


/**
 * The sentinel class interface.
 *
 * Sentinels are responsible for accepting activity reports and making decisions based on them.
 *
 * For example, for a user sign-in activity, the sentinel might decide to:
 *
 * - Accept since the user uses the same device and location as usual;
 * - Require a MFA code since the user uses a new device or location;
 * - Block the user since the user tried to sign-in too many times with an incorrect password.
 *
 * The implementation should be privacy-aware and not store any personal identifiable information.
 */ class $59de3e0facad049e$export$84d34c4405d4a2e8 {
}




const $10085c8ffbd8a996$export$2334438dedb2ca6f = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    rp: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
        name: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
        id: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().optional()
    }),
    user: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
        id: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
        name: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
        displayName: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string()
    }),
    challenge: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
    pubKeyCredParams: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).array((0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
        type: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).literal("public-key"),
        alg: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).number()
    })),
    timeout: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).number().optional(),
    excludeCredentials: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).array((0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
        type: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).literal("public-key"),
        id: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
        transports: (0, $19b00b9869ef71ab$export$aa941865a0228ea6).array().optional()
    })).optional(),
    authenticatorSelection: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
        authenticatorAttachment: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).enum([
            "platform",
            "cross-platform"
        ]).optional(),
        requireResidentKey: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).boolean().optional(),
        residentKey: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).enum([
            "discouraged",
            "preferred",
            "required"
        ]).optional(),
        userVerification: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).enum([
            "required",
            "preferred",
            "discouraged"
        ]).optional()
    }).optional(),
    attestation: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).enum([
        "none",
        "indirect",
        "direct",
        "enterprise"
    ]).optional(),
    extensions: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
        appid: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().optional(),
        credProps: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).boolean().optional(),
        hmacCreateSecret: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).boolean().optional()
    }).optional()
});
const $10085c8ffbd8a996$export$e849189769e7ddda = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    challenge: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
    timeout: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).number().optional(),
    rpId: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().optional(),
    allowCredentials: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).array((0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
        type: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).literal("public-key"),
        id: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
        transports: (0, $19b00b9869ef71ab$export$aa941865a0228ea6).array().optional()
    })).optional(),
    userVerification: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).enum([
        "required",
        "preferred",
        "discouraged"
    ]).optional(),
    extensions: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
        appid: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().optional(),
        credProps: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).boolean().optional(),
        hmacCreateSecret: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).boolean().optional()
    }).optional()
});





const $8f6788a4977e11bb$export$e71edf44a2bc5ed8 = (0, $bca86ec785494256$export$29f120f254b547e7).guard.extend({
    scopes: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
        id: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
        name: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string()
    }).array()
});
const $8f6788a4977e11bb$export$a8f6e59aae709371 = (0, $bca86ec785494256$export$29f120f254b547e7).guard.extend({
    scopes: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
        id: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
        name: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string()
    }).array(),
    resourceScopes: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
        id: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
        name: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
        resource: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
            id: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
            name: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string()
        })
    }).array()
});
const $8f6788a4977e11bb$var$organizationRoleEntityGuard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    id: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
    name: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string()
});
const $8f6788a4977e11bb$export$a1b68498f213370c = (0, $e8e2c4287d2de9f0$export$8cdb1b004e612f6c).guard.extend({
    organizationRoles: $8f6788a4977e11bb$var$organizationRoleEntityGuard.array()
});
const $8f6788a4977e11bb$export$6c095334bcf53b71 = (0, $1528a40113a1815c$export$996c89999cd0d06b).extend({
    organizationRoles: $8f6788a4977e11bb$var$organizationRoleEntityGuard.array()
});
const $8f6788a4977e11bb$export$c805c92fd00f1460 = (0, $07ccf7a7394ec01a$export$63fd293d5536b534).guard.extend({
    organizationRoles: $8f6788a4977e11bb$var$organizationRoleEntityGuard.array()
});




const $d3507142cbbbfa5d$export$7f91c1744e02ec3c = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    id: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
    connectorName: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
    logo: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
    darkLogo: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().optional()
});
var $d3507142cbbbfa5d$export$88b6bcc5c3531d29;
(function(SsoProviderName) {
    SsoProviderName["OIDC"] = "OIDC";
    SsoProviderName["SAML"] = "SAML";
    SsoProviderName["AZURE_AD"] = "AzureAD";
    SsoProviderName["GOOGLE_WORKSPACE"] = "GoogleWorkspace";
    SsoProviderName["OKTA"] = "Okta";
    SsoProviderName["AZURE_AD_OIDC"] = "AzureAdOidc";
})($d3507142cbbbfa5d$export$88b6bcc5c3531d29 || ($d3507142cbbbfa5d$export$88b6bcc5c3531d29 = {}));
var $d3507142cbbbfa5d$export$f37fcb7c8234a0f8;
(function(SsoProviderType) {
    SsoProviderType["OIDC"] = "oidc";
    SsoProviderType["SAML"] = "saml";
})($d3507142cbbbfa5d$export$f37fcb7c8234a0f8 || ($d3507142cbbbfa5d$export$f37fcb7c8234a0f8 = {}));
const $d3507142cbbbfa5d$export$92ee0fc3a3bf5566 = Object.freeze([
    "gmail.com",
    "yahoo.com",
    "hotmail.com",
    "outlook.com",
    "live.com",
    "icloud.com",
    "aol.com",
    "yandex.com",
    "mail.com",
    "protonmail.com",
    "yanex.com",
    "gmx.com",
    "mail.ru",
    "zoho.com",
    "qq.com",
    "163.com",
    "126.com",
    "sina.com",
    "sohu.com"
]);
const $d3507142cbbbfa5d$var$ssoConnectorProviderDetailGuard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    providerName: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).nativeEnum($d3507142cbbbfa5d$export$88b6bcc5c3531d29),
    providerType: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).nativeEnum($d3507142cbbbfa5d$export$f37fcb7c8234a0f8),
    logo: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
    logoDark: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
    description: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
    name: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string()
});
const $d3507142cbbbfa5d$export$daec852f2106e44c = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).array($d3507142cbbbfa5d$var$ssoConnectorProviderDetailGuard);
const $d3507142cbbbfa5d$export$a536522a091757cc = (0, $c68255f4bccb5b1c$export$cb7d2ef46acb2840).guard// Must be a supported SSO provider name. Overwrite the providerName string type to enum.
.extend({
    providerName: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).nativeEnum($d3507142cbbbfa5d$export$88b6bcc5c3531d29)
}).merge(// Static provider details
(0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    name: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
    providerType: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).nativeEnum($d3507142cbbbfa5d$export$f37fcb7c8234a0f8),
    providerLogo: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
    providerLogoDark: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string(),
    // SSO connection config parsed from the provider.
    // - OIDC: connection config fetched from the OIDC provider.
    // - SAML: connection config fetched from the metadata url or metadata file.
    providerConfig: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).record((0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).unknown()).optional()
}));


var $4afbb3f789032847$export$3baa67aafdc7045f;
(function(TenantTag) {
    /* Development tenants are free to use but are not meant to be used as production environment. */ TenantTag["Development"] = "development";
    /* A production tenant must have an associated subscription plan, even if it's a free plan. */ TenantTag["Production"] = "production";
})($4afbb3f789032847$export$3baa67aafdc7045f || ($4afbb3f789032847$export$3baa67aafdc7045f = {}));


/**
 * @fileoverview
 * Tenant organizations are organizations in the admin tenant that represent tenants. They are
 * created when a tenant is created, and are used to define the roles and scopes for the users in
 * the tenant.
 *
 * This module provides utilities to manage tenant organizations.
 */ const $92d54ab7737d6554$export$ccc9014151910116 = "default";
const $92d54ab7737d6554$export$87d9f170d46b6e1e = "admin";


const $efd516c7d33d567e$export$2469be9aaea94b3b = (tenantId)=>`t-${tenantId}`;
const $efd516c7d33d567e$export$e34151e8896fc4e0 = (organizationId)=>{
    if (!organizationId.startsWith("t-")) throw new Error(`Invalid admin tenant organization ID: ${organizationId}`);
    return organizationId.slice(2);
};
const $efd516c7d33d567e$export$2d8382267fbcadbe = (tenantId)=>Object.freeze({
        tenantId: (0, $92d54ab7737d6554$export$87d9f170d46b6e1e),
        id: $efd516c7d33d567e$export$2469be9aaea94b3b(tenantId),
        name: `Tenant ${tenantId}`
    });
var $efd516c7d33d567e$export$5bc5773220b3c720;
(function(TenantScope) {
    /** Read the tenant data. */ TenantScope["ReadData"] = "read:data";
    /** Write the tenant data, including creating and updating the tenant. */ TenantScope["WriteData"] = "write:data";
    /** Delete data of the tenant. */ TenantScope["DeleteData"] = "delete:data";
    /** Read members of the tenant. */ TenantScope["ReadMember"] = "read:member";
    /** Invite members to the tenant. */ TenantScope["InviteMember"] = "invite:member";
    /** Remove members from the tenant. */ TenantScope["RemoveMember"] = "remove:member";
    /** Update the role of a member in the tenant. */ TenantScope["UpdateMemberRole"] = "update:member:role";
    /** Manage the tenant settings, including name, billing, etc. */ TenantScope["ManageTenant"] = "manage:tenant";
})($efd516c7d33d567e$export$5bc5773220b3c720 || ($efd516c7d33d567e$export$5bc5773220b3c720 = {}));
const $efd516c7d33d567e$var$allTenantScopes = Object.freeze(Object.values($efd516c7d33d567e$export$5bc5773220b3c720));
const $efd516c7d33d567e$export$d33885dda1bb96a0 = (scope)=>Object.freeze({
        tenantId: (0, $92d54ab7737d6554$export$87d9f170d46b6e1e),
        id: scope.replaceAll(":", "-"),
        name: scope,
        description: $efd516c7d33d567e$var$tenantScopeDescriptions[scope]
    });
const $efd516c7d33d567e$var$tenantScopeDescriptions = Object.freeze({
    [$efd516c7d33d567e$export$5bc5773220b3c720.ReadData]: "Read the tenant data.",
    [$efd516c7d33d567e$export$5bc5773220b3c720.WriteData]: "Write the tenant data, including creating and updating the tenant.",
    [$efd516c7d33d567e$export$5bc5773220b3c720.DeleteData]: "Delete data of the tenant.",
    [$efd516c7d33d567e$export$5bc5773220b3c720.ReadMember]: "Read members of the tenant.",
    [$efd516c7d33d567e$export$5bc5773220b3c720.InviteMember]: "Invite members to the tenant.",
    [$efd516c7d33d567e$export$5bc5773220b3c720.RemoveMember]: "Remove members from the tenant.",
    [$efd516c7d33d567e$export$5bc5773220b3c720.UpdateMemberRole]: "Update the role of a member in the tenant.",
    [$efd516c7d33d567e$export$5bc5773220b3c720.ManageTenant]: "Manage the tenant settings, including name, billing, etc."
});
var $efd516c7d33d567e$export$af4151a4e98c49fa;
(function(TenantRole) {
    /** Admin of the tenant, who has all permissions. */ TenantRole["Admin"] = "admin";
    /** Collaborator of the tenant, who has permissions to operate the tenant data, but not the tenant settings. */ TenantRole["Collaborator"] = "collaborator";
})($efd516c7d33d567e$export$af4151a4e98c49fa || ($efd516c7d33d567e$export$af4151a4e98c49fa = {}));
const $efd516c7d33d567e$var$tenantRoleDescriptions = Object.freeze({
    [$efd516c7d33d567e$export$af4151a4e98c49fa.Admin]: "Admin of the tenant, who has all permissions.",
    [$efd516c7d33d567e$export$af4151a4e98c49fa.Collaborator]: "Collaborator of the tenant, who has permissions to operate the tenant data, but not the tenant settings."
});
const $efd516c7d33d567e$export$1775965c9a0d8dc9 = (role)=>Object.freeze({
        tenantId: (0, $92d54ab7737d6554$export$87d9f170d46b6e1e),
        id: role,
        name: role,
        description: $efd516c7d33d567e$var$tenantRoleDescriptions[role]
    });
const $efd516c7d33d567e$export$3f89b2d5d2b9eb42 = Object.freeze({
    [$efd516c7d33d567e$export$af4151a4e98c49fa.Admin]: $efd516c7d33d567e$var$allTenantScopes,
    [$efd516c7d33d567e$export$af4151a4e98c49fa.Collaborator]: [
        $efd516c7d33d567e$export$5bc5773220b3c720.ReadData,
        $efd516c7d33d567e$export$5bc5773220b3c720.WriteData,
        $efd516c7d33d567e$export$5bc5773220b3c720.DeleteData,
        $efd516c7d33d567e$export$5bc5773220b3c720.ReadMember
    ]
});


/**
 * @fileoverview
 * Mapi (Management API) proxy is an endpoint in Logto Cloud that proxies the requests to the
 * corresponding Management API. It has the following benefits:
 *
 * - When we migrate the tenant management from API resources to tenant organizations, we can
 *   migrate Console to use the mapi proxy endpoint by changing only the base URL.
 * - It decouples the access control of Cloud user collaboration from the machine-to-machine access
 *   control of the Management API.
 * - The mapi proxy endpoint shares the same domain with Logto Cloud, so it can be used in the
 *   browser without CORS.
 *
 * This module provides utilities to manage mapi proxy.
 */ 


const $e34b7e4fd12eb7be$export$a1252204700ae600 = (tenantId)=>Object.freeze({
        tenantId: (0, $92d54ab7737d6554$export$87d9f170d46b6e1e),
        id: `m-${tenantId}`,
        name: `machine:mapi:${tenantId}`,
        description: `Machine-to-machine role for accessing Management API of tenant '${tenantId}'.`,
        type: (0, $3ce2871eb3919730$export$e57c3ccf0ca02b45).MachineToMachine
    });
const $e34b7e4fd12eb7be$export$deaf541980006e1f = (tenantId)=>Object.freeze({
        tenantId: (0, $92d54ab7737d6554$export$87d9f170d46b6e1e),
        id: `m-${tenantId}`,
        secret: (0, $89790267634015cc$export$877b6275f1b9e856)(32),
        name: `Management API access for ${tenantId}`,
        description: `Machine-to-machine app for accessing Management API of tenant '${tenantId}'.`,
        type: (0, $3ce2871eb3919730$export$d16f8fdf0c548b68).MachineToMachine,
        oidcClientMetadata: {
            redirectUris: [],
            postLogoutRedirectUris: []
        }
    });




const $49d687e85fefe09a$export$d6a2d3784301e7e6 = (0, $ba3e0e5fc0c0c5f0$export$a69f017b19597ff5).guard.pick({
    id: true,
    name: true,
    avatar: true,
    username: true,
    primaryEmail: true,
    primaryPhone: true
});
const $49d687e85fefe09a$export$bd52a8a3b354bd5c = (0, $660b8d53428b2c71$export$73c91b53927e421e).guard.pick({
    id: true,
    name: true
});
const $49d687e85fefe09a$export$18c739dd80de9062 = (0, $82c906177bd2d562$export$b21e17c60fe7d89c).guard.pick({
    branding: true,
    displayName: true,
    privacyPolicyUrl: true,
    termsOfUseUrl: true
});
const $49d687e85fefe09a$export$9694f7ffb7c13fa0 = (0, $e8e2c4287d2de9f0$export$8cdb1b004e612f6c).guard.pick({
    id: true,
    name: true
});
const $49d687e85fefe09a$export$852b61cc27b5cdcd = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    // The original resource id has a maximum length of 21 restriction. We need to make it compatible with the logto reserved organization name.
    // use string here, as we do not care about the resource id length here.
    resource: (0, $01bd9aeaf1aa3e97$export$e9a269813a6315a4).guard.pick({
        name: true
    }).extend({
        id: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string()
    }),
    scopes: (0, $f68f1c4dcc6a46f1$export$8546186883d6ff3e).guard.pick({
        id: true,
        name: true,
        description: true
    }).array()
});
const $49d687e85fefe09a$export$c3e25094abccc08 = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    application: $49d687e85fefe09a$export$bd52a8a3b354bd5c.merge($49d687e85fefe09a$export$18c739dd80de9062.partial()),
    user: $49d687e85fefe09a$export$d6a2d3784301e7e6,
    organizations: $49d687e85fefe09a$export$9694f7ffb7c13fa0.array().optional(),
    missingOIDCScope: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().array().optional(),
    missingResourceScopes: $49d687e85fefe09a$export$852b61cc27b5cdcd.array().optional(),
    redirectUri: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string()
});



const $fef83af2264ada34$export$b68ca08271df260b = "onboarding";
var $fef83af2264ada34$export$b6032183171af19f;
(function(Project) {
    Project["Personal"] = "personal";
    Project["Company"] = "company";
})($fef83af2264ada34$export$b6032183171af19f || ($fef83af2264ada34$export$b6032183171af19f = {}));
/** @deprecated Open-source options was for cloud preview use, no longer needed. Use default `Cloud` value for placeholder. */ var $fef83af2264ada34$var$DeploymentType;
(function(DeploymentType) {
    DeploymentType["OpenSource"] = "open-source";
    DeploymentType["Cloud"] = "cloud";
})($fef83af2264ada34$var$DeploymentType || ($fef83af2264ada34$var$DeploymentType = {}));
var $fef83af2264ada34$export$f99233281efd08a0;
(function(Title) {
    Title["Developer"] = "developer";
    Title["TeamLead"] = "team-lead";
    Title["Ceo"] = "ceo";
    Title["Cto"] = "cto";
    Title["Product"] = "product";
    Title["Others"] = "others";
})($fef83af2264ada34$export$f99233281efd08a0 || ($fef83af2264ada34$export$f99233281efd08a0 = {}));
var $fef83af2264ada34$export$41cc48adf872ce3b;
(function(CompanySize) {
    CompanySize["Scale1"] = "1";
    CompanySize["Scale2"] = "2-49";
    CompanySize["Scale3"] = "50-199";
    CompanySize["Scale4"] = "200-999";
    CompanySize["Scale5"] = "1000+";
})($fef83af2264ada34$export$41cc48adf872ce3b || ($fef83af2264ada34$export$41cc48adf872ce3b = {}));
var $fef83af2264ada34$export$fe867595c4640fb1;
(function(Reason) {
    Reason["Passwordless"] = "passwordless";
    Reason["Efficiency"] = "efficiency";
    Reason["AccessControl"] = "access-control";
    Reason["MultiTenancy"] = "multi-tenancy";
    Reason["Enterprise"] = "enterprise";
    Reason["Others"] = "others";
})($fef83af2264ada34$export$fe867595c4640fb1 || ($fef83af2264ada34$export$fe867595c4640fb1 = {}));
var $fef83af2264ada34$export$208cd1682bd0e4b6;
(function(Stage) {
    Stage["NewProduct"] = "new-product";
    Stage["ExistingProduct"] = "existing-product";
    Stage["TargetEnterpriseReady"] = "target-enterprise-ready";
})($fef83af2264ada34$export$208cd1682bd0e4b6 || ($fef83af2264ada34$export$208cd1682bd0e4b6 = {}));
var $fef83af2264ada34$export$e03ccbddd0690b5c;
(function(AdditionalFeatures) {
    AdditionalFeatures["CustomizeUiAndFlow"] = "customize-ui-and-flow";
    AdditionalFeatures["Compliance"] = "compliance";
    AdditionalFeatures["ExportUserDataFromLogto"] = "export-user-data-from-logto";
    AdditionalFeatures["BudgetControl"] = "budget-control";
    AdditionalFeatures["BringOwnAuth"] = "bring-own-auth";
    AdditionalFeatures["Others"] = "others";
})($fef83af2264ada34$export$e03ccbddd0690b5c || ($fef83af2264ada34$export$e03ccbddd0690b5c = {}));
const $fef83af2264ada34$var$questionnaireGuard = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    project: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).nativeEnum($fef83af2264ada34$export$b6032183171af19f).optional(),
    /** @deprecated Open-source options was for cloud preview use, no longer needed. Use default `Cloud` value for placeholder. */ deploymentType: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).nativeEnum($fef83af2264ada34$var$DeploymentType).optional().default($fef83af2264ada34$var$DeploymentType.Cloud),
    /** @deprecated */ titles: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).array((0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).nativeEnum($fef83af2264ada34$export$f99233281efd08a0)).optional(),
    companyName: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string().optional(),
    /** @deprecated */ companySize: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).nativeEnum($fef83af2264ada34$export$41cc48adf872ce3b).optional(),
    /** @deprecated */ reasons: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).array((0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).nativeEnum($fef83af2264ada34$export$fe867595c4640fb1)).optional(),
    stage: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).nativeEnum($fef83af2264ada34$export$208cd1682bd0e4b6).optional(),
    additionalFeatures: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).array((0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).nativeEnum($fef83af2264ada34$export$e03ccbddd0690b5c)).optional()
});
const $fef83af2264ada34$export$a9c4e6d214c76225 = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    questionnaire: $fef83af2264ada34$var$questionnaireGuard.optional(),
    isOnboardingDone: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).boolean().optional()
});











const $87b8dc3d7e1487b6$export$1bb5e159b3d64354 = "admin-console";
const $87b8dc3d7e1487b6$export$92b495973538657d = "demo-app";
const $87b8dc3d7e1487b6$export$c3f41e16cf1f3ff0 = (tenantId)=>({
        tenantId: tenantId,
        id: $87b8dc3d7e1487b6$export$92b495973538657d,
        name: "Live Preview",
        secret: "N/A",
        description: "Preview for Sign-in Experience.",
        type: (0, $3ce2871eb3919730$export$d16f8fdf0c548b68).SPA,
        oidcClientMetadata: {
            redirectUris: [],
            postLogoutRedirectUris: []
        },
        customClientMetadata: {},
        protectedAppMetadata: null,
        isThirdParty: false,
        createdAt: 0
    });
const $87b8dc3d7e1487b6$export$e6ae95e19af732a3 = ()=>Object.freeze({
        tenantId: (0, $92d54ab7737d6554$export$87d9f170d46b6e1e),
        id: $87b8dc3d7e1487b6$export$1bb5e159b3d64354,
        name: "Admin Console",
        secret: (0, $89790267634015cc$export$877b6275f1b9e856)(),
        description: "Logto Admin Console.",
        type: (0, $3ce2871eb3919730$export$d16f8fdf0c548b68).SPA,
        oidcClientMetadata: {
            redirectUris: [],
            postLogoutRedirectUris: []
        }
    });
const $87b8dc3d7e1487b6$export$7480c3dfa7c833f3 = (tenantId)=>Object.freeze({
        tenantId: (0, $92d54ab7737d6554$export$87d9f170d46b6e1e),
        id: (0, $89790267634015cc$export$7e648d54e633633e)(),
        name: "Cloud Service",
        description: `Machine to machine application for tenant ${tenantId}`,
        secret: (0, $89790267634015cc$export$877b6275f1b9e856)(),
        type: (0, $3ce2871eb3919730$export$d16f8fdf0c548b68).MachineToMachine,
        oidcClientMetadata: {
            redirectUris: [],
            postLogoutRedirectUris: []
        },
        customClientMetadata: {
            tenantId: tenantId
        }
    });
const $87b8dc3d7e1487b6$export$2d5b05d2f01b280 = (applicationId, roleId)=>Object.freeze({
        id: (0, $89790267634015cc$export$7e648d54e633633e)(),
        tenantId: (0, $92d54ab7737d6554$export$87d9f170d46b6e1e),
        applicationId: applicationId,
        roleId: roleId
    });






const $7510fa4f3878fbaa$export$e3fa12c425ddba26 = "https://cloud.logto.io/api";
var $7510fa4f3878fbaa$export$fd6cfb345221c2ba;
(function(CloudScope) {
    /** The user can create a user tenant. */ CloudScope["CreateTenant"] = "create:tenant";
    /** The user can update or delete its own tenants. */ CloudScope["ManageTenantSelf"] = "manage:tenant:self";
    CloudScope["SendSms"] = "send:sms";
    CloudScope["SendEmail"] = "send:email";
    /**
     * The user can access external (independent from Logto instance) resource to run JWT payload customizer
     * scripts and fetch the parsed token payload.
     */ CloudScope["FetchCustomJwt"] = "fetch:custom:jwt";
    /** The user can see and manage affiliates, including create, update, and delete. */ CloudScope["ManageAffiliate"] = "manage:affiliate";
    /** The user can create new affiliates and logs. */ CloudScope["CreateAffiliate"] = "create:affiliate";
})($7510fa4f3878fbaa$export$fd6cfb345221c2ba || ($7510fa4f3878fbaa$export$fd6cfb345221c2ba = {}));
const $7510fa4f3878fbaa$export$3ae0ed740a70db11 = ()=>{
    const resourceId = (0, $89790267634015cc$export$7e648d54e633633e)();
    const buildScope = (name, description)=>({
            tenantId: (0, $92d54ab7737d6554$export$87d9f170d46b6e1e),
            id: (0, $89790267634015cc$export$7e648d54e633633e)(),
            name: name,
            description: description,
            resourceId: resourceId
        });
    return Object.freeze([
        {
            resource: {
                tenantId: (0, $92d54ab7737d6554$export$87d9f170d46b6e1e),
                id: resourceId,
                indicator: $7510fa4f3878fbaa$export$e3fa12c425ddba26,
                name: `Logto Cloud API`
            },
            scopes: [
                buildScope($7510fa4f3878fbaa$export$fd6cfb345221c2ba.CreateTenant, "Allow creating new tenants."),
                buildScope($7510fa4f3878fbaa$export$fd6cfb345221c2ba.ManageTenantSelf, "Allow managing tenant itself, including update and delete.")
            ],
            role: {
                tenantId: (0, $92d54ab7737d6554$export$87d9f170d46b6e1e),
                name: (0, $1528a40113a1815c$export$cc68ab3265ed0467).User
            }
        },
        buildScope($7510fa4f3878fbaa$export$fd6cfb345221c2ba.SendEmail, "Allow sending emails. This scope is only available to M2M application."),
        buildScope($7510fa4f3878fbaa$export$fd6cfb345221c2ba.SendSms, "Allow sending SMS. This scope is only available to M2M application."),
        buildScope($7510fa4f3878fbaa$export$fd6cfb345221c2ba.FetchCustomJwt, "Allow accessing external resource to execute JWT payload customizer script and fetch the parsed token payload."),
        buildScope($7510fa4f3878fbaa$export$fd6cfb345221c2ba.CreateAffiliate, "Allow creating new affiliates and logs."),
        buildScope($7510fa4f3878fbaa$export$fd6cfb345221c2ba.ManageAffiliate, "Allow managing affiliates, including create, update, and delete.")
    ]);
};
const $7510fa4f3878fbaa$export$233b871be9b6564f = ()=>({
        tenantId: (0, $92d54ab7737d6554$export$87d9f170d46b6e1e),
        id: (0, $89790267634015cc$export$7e648d54e633633e)(),
        name: (0, $1528a40113a1815c$export$cc68ab3265ed0467).TenantApplication,
        description: "The role for M2M applications that represent a user tenant and send requests to Logto Cloud.",
        type: (0, $3ce2871eb3919730$export$e57c3ccf0ca02b45).MachineToMachine
    });






// Consider remove the dependency of IDs
const $3939a111c4c4b5c7$var$defaultResourceId = "management-api";
const $3939a111c4c4b5c7$var$defaultScopeAllId = "management-api-all";
const $3939a111c4c4b5c7$export$711b817cd779af20 = Object.freeze({
    resource: {
        tenantId: (0, $92d54ab7737d6554$export$ccc9014151910116),
        /** @deprecated You should not rely on this constant. Change to something else. */ id: $3939a111c4c4b5c7$var$defaultResourceId,
        /**
         * The fixed resource indicator for Management APIs.
         *
         * Admin Console requires the access token of this resource to be functional.
         */ indicator: `https://${(0, $92d54ab7737d6554$export$ccc9014151910116)}.logto.app/api`,
        name: "Logto Management API"
    },
    scopes: [
        {
            tenantId: (0, $92d54ab7737d6554$export$ccc9014151910116),
            /** @deprecated You should not rely on this constant. Change to something else. */ id: $3939a111c4c4b5c7$var$defaultScopeAllId,
            name: (0, $1528a40113a1815c$export$90d62586f282d378).All,
            description: "Default scope for Management API, allows all permissions.",
            /** @deprecated You should not rely on this constant. Change to something else. */ resourceId: $3939a111c4c4b5c7$var$defaultResourceId
        }
    ],
    /**
     * An internal user role for Management API of the `default` tenant.
     * @deprecated This role will be removed soon.
     */ role: {
        tenantId: (0, $92d54ab7737d6554$export$ccc9014151910116),
        /** @deprecated You should not rely on this constant. Change to something else. */ id: "admin-role",
        name: (0, $1528a40113a1815c$export$a17952fc1a8aded7).Admin,
        description: `Internal admin role for Logto tenant ${(0, $92d54ab7737d6554$export$ccc9014151910116)}.`,
        type: (0, $3ce2871eb3919730$export$e57c3ccf0ca02b45).MachineToMachine
    }
});
function $3939a111c4c4b5c7$export$245dbc301cf93887(tenantId, path = "api") {
    return `https://${tenantId}.logto.app/${path}`;
}
const $3939a111c4c4b5c7$export$ba32cb0bde5eb6df = `${(0, $92d54ab7737d6554$export$ccc9014151910116)}:admin`;
const $3939a111c4c4b5c7$export$c7852ca43795084 = (tenantId)=>{
    const resourceId = (0, $89790267634015cc$export$7e648d54e633633e)();
    return Object.freeze({
        resource: {
            tenantId: tenantId,
            id: resourceId,
            indicator: $3939a111c4c4b5c7$export$245dbc301cf93887(tenantId),
            name: `Logto Management API`
        },
        scopes: [
            {
                tenantId: tenantId,
                id: (0, $89790267634015cc$export$7e648d54e633633e)(),
                name: (0, $1528a40113a1815c$export$90d62586f282d378).All,
                description: "Default scope for Management API, allows all permissions.",
                resourceId: resourceId
            }
        ],
        /** @deprecated This role will be removed soon. */ role: {
            tenantId: tenantId,
            id: (0, $89790267634015cc$export$7e648d54e633633e)(),
            name: (0, $1528a40113a1815c$export$a17952fc1a8aded7).Admin,
            description: `Internal admin role for Logto tenant ${(0, $92d54ab7737d6554$export$ccc9014151910116)}.`,
            type: (0, $3ce2871eb3919730$export$e57c3ccf0ca02b45).MachineToMachine
        }
    });
};
const $3939a111c4c4b5c7$export$305b333dcaea6e0e = (tenantId)=>{
    const resourceId = (0, $89790267634015cc$export$7e648d54e633633e)();
    return Object.freeze({
        resource: {
            tenantId: (0, $92d54ab7737d6554$export$87d9f170d46b6e1e),
            id: resourceId,
            indicator: $3939a111c4c4b5c7$export$245dbc301cf93887(tenantId),
            name: `Logto Management API for tenant ${tenantId}`
        },
        scopes: [
            {
                tenantId: (0, $92d54ab7737d6554$export$87d9f170d46b6e1e),
                id: (0, $89790267634015cc$export$7e648d54e633633e)(),
                name: (0, $1528a40113a1815c$export$90d62586f282d378).All,
                description: "Default scope for Management API, allows all permissions.",
                resourceId: resourceId
            }
        ],
        /** The machine-to-machine role for the Management API proxy of the given tenant ID. */ role: (0, $e34b7e4fd12eb7be$export$a1252204700ae600)(tenantId)
    });
};
const $3939a111c4c4b5c7$export$3e34893e87727786 = ()=>{
    const resourceId = (0, $89790267634015cc$export$7e648d54e633633e)();
    return Object.freeze({
        resource: {
            tenantId: (0, $92d54ab7737d6554$export$87d9f170d46b6e1e),
            id: resourceId,
            indicator: $3939a111c4c4b5c7$export$245dbc301cf93887((0, $92d54ab7737d6554$export$87d9f170d46b6e1e), "me"),
            name: `Logto Me API`
        },
        scopes: [
            {
                tenantId: (0, $92d54ab7737d6554$export$87d9f170d46b6e1e),
                id: (0, $89790267634015cc$export$7e648d54e633633e)(),
                name: (0, $1528a40113a1815c$export$90d62586f282d378).All,
                description: "Default scope for Me API, allows all permissions.",
                resourceId: resourceId
            }
        ],
        role: {
            tenantId: (0, $92d54ab7737d6554$export$87d9f170d46b6e1e),
            id: (0, $89790267634015cc$export$7e648d54e633633e)(),
            name: (0, $1528a40113a1815c$export$cc68ab3265ed0467).User,
            description: "Default role for admin tenant.",
            type: (0, $3ce2871eb3919730$export$e57c3ccf0ca02b45).User
        }
    });
};




const $5e41f67c3a94b3bc$export$eac2ea73871449a = (forTenantId)=>Object.freeze({
        tenantId: forTenantId,
        key: (0, $81e1a824f031f67b$export$a249f1a8f5d6b725).AdminConsole,
        value: {
            signInExperienceCustomized: false,
            organizationCreated: false
        }
    });
const $5e41f67c3a94b3bc$export$fb8e6733ef2d5505 = (forTenantId, appId, appSecret)=>Object.freeze({
        tenantId: forTenantId,
        key: (0, $81e1a824f031f67b$export$a249f1a8f5d6b725).CloudConnection,
        value: {
            appId: appId,
            appSecret: appSecret,
            resource: (0, $7510fa4f3878fbaa$export$e3fa12c425ddba26)
        }
    });








const $83f3a19a2dfab0c3$var$defaultPrimaryColor = "#6139F6";
const $83f3a19a2dfab0c3$export$9aabb866d7e7cb45 = (forTenantId, isCloud)=>Object.freeze({
        tenantId: forTenantId,
        id: "default",
        color: {
            primaryColor: $83f3a19a2dfab0c3$var$defaultPrimaryColor,
            isDarkModeEnabled: false,
            darkPrimaryColor: (0, $e54dff7b369bf34e$export$2feb0cd4df065982)($83f3a19a2dfab0c3$var$defaultPrimaryColor)
        },
        branding: {
            logoUrl: isCloud ? undefined : "https://logto.io/logo.svg",
            darkLogoUrl: isCloud ? undefined : "https://logto.io/logo-dark.svg"
        },
        languageInfo: {
            autoDetect: true,
            fallbackLanguage: "en"
        },
        termsOfUseUrl: null,
        privacyPolicyUrl: null,
        signUp: {
            identifiers: [
                isCloud ? (0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Email : (0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Username
            ],
            password: true,
            verify: isCloud
        },
        signIn: {
            methods: [
                {
                    identifier: isCloud ? (0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Email : (0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Username,
                    password: true,
                    verificationCode: false,
                    isPasswordPrimary: true
                }
            ]
        },
        socialSignInConnectorTargets: [],
        signInMode: (0, $3ce2871eb3919730$export$f927bbb3d448dc2b).SignInAndRegister,
        customCss: null,
        customContent: {},
        passwordPolicy: {},
        mfa: {
            factors: [],
            policy: (0, $c0e46a7ec45ea8f3$export$da22c5f01b0bc81).UserControlled
        }
    });
const $83f3a19a2dfab0c3$export$7e36ef2bc7e2871f = $83f3a19a2dfab0c3$export$9aabb866d7e7cb45((0, $92d54ab7737d6554$export$ccc9014151910116), false);
const $83f3a19a2dfab0c3$export$e9fd471c1ae91561 = ()=>Object.freeze((0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, $83f3a19a2dfab0c3$export$7e36ef2bc7e2871f), {
        tenantId: (0, $92d54ab7737d6554$export$87d9f170d46b6e1e),
        color: (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, $83f3a19a2dfab0c3$export$7e36ef2bc7e2871f.color), {
            isDarkModeEnabled: true
        }),
        signInMode: (0, $3ce2871eb3919730$export$f927bbb3d448dc2b).Register,
        branding: {
            logoUrl: "https://logto.io/logo.svg",
            darkLogoUrl: "https://logto.io/logo-dark.svg"
        }
    }));





const $4310b4eb43b15310$export$58a828960e98f161 = "_logto";


/**
 * In OSS:
 *
 * - Only one single user tenant (`default`) is available.
 * - Admin tenant and Admin Console share one endpoint (`ADMIN_ENDPOINT`).
 *
 * There's no need to parse tenant ID from the first path segment in OSS, and the segment should be a fixed value.
 *
 * If we use `/default`, the URL will look ugly; thus we keep the old fashion `/console`.
 */ const $67bf121d151de464$export$c114d6e260d7e866 = "/console";



const $c672653ad6b2c5f4$export$41e1f3752bfbbffc = Object.freeze({
    oneMinute: 60,
    oneHour: 3600,
    oneDay: 86400
});


const $62aa16e1b23b00f9$export$69773729edd6695 = "tenant_id";
const $62aa16e1b23b00f9$export$2d48ae5b9b7ef84 = Object.freeze({
    idTokenTtl: (0, $c672653ad6b2c5f4$export$41e1f3752bfbbffc).oneHour,
    refreshTokenTtlInDays: 14,
    rotateRefreshToken: true
});
var $62aa16e1b23b00f9$export$d59e370a591c2f6e;
(function(ExtraParamsKey) {
    /**
     * @deprecated Use {@link FirstScreen} instead.
     * @see {@link InteractionMode} for the available values.
     */ ExtraParamsKey["InteractionMode"] = "interaction_mode";
    /**
     * The first screen to show for the user.
     *
     * @see {@link FirstScreen} for the available values.
     */ ExtraParamsKey["FirstScreen"] = "first_screen";
    /**
     * Directly sign in via the specified method. Note that the method must be properly configured
     * in Logto.
     *
     * @remark
     * The format of the value for this key is one of the following:
     *
     * - `social:<target>` (Use a social connector with the specified target, e.g. `social:google`)
     * - `sso:<connector-id>` (Use the specified SSO connector, e.g. `sso:123456`)
     */ ExtraParamsKey["DirectSignIn"] = "direct_sign_in";
})($62aa16e1b23b00f9$export$d59e370a591c2f6e || ($62aa16e1b23b00f9$export$d59e370a591c2f6e = {}));
var $62aa16e1b23b00f9$export$d184c05d3e025a16;
(function(InteractionMode) {
    InteractionMode["SignIn"] = "signIn";
    InteractionMode["SignUp"] = "signUp";
})($62aa16e1b23b00f9$export$d184c05d3e025a16 || ($62aa16e1b23b00f9$export$d184c05d3e025a16 = {}));
var $62aa16e1b23b00f9$export$fa38afa20f77931e;
(function(FirstScreen) {
    FirstScreen["SignIn"] = "signIn";
    FirstScreen["Register"] = "register";
})($62aa16e1b23b00f9$export$fa38afa20f77931e || ($62aa16e1b23b00f9$export$fa38afa20f77931e = {}));
const $62aa16e1b23b00f9$export$d4edee201590d836 = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).object({
    [$62aa16e1b23b00f9$export$d59e370a591c2f6e.InteractionMode]: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).nativeEnum($62aa16e1b23b00f9$export$d184c05d3e025a16),
    [$62aa16e1b23b00f9$export$d59e370a591c2f6e.FirstScreen]: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).nativeEnum($62aa16e1b23b00f9$export$fa38afa20f77931e),
    [$62aa16e1b23b00f9$export$d59e370a591c2f6e.DirectSignIn]: (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).string()
}).partial();



const $8f69e24ab73a99a6$export$33e784254961b75a = 10;


/**
 * Logto-provided predefined subscription plan IDs.
 *
 * In theory, the subscription plan ID will be a random string,
 * but Logto provides some predefined subscription plans and their IDs are reserved plan IDs.
 */ var $3088d8e3a2bf76d3$export$70d79c7c84af5a3e;
(function(ReservedPlanId) {
    ReservedPlanId["Free"] = "free";
    /**
     * @deprecated
     * In recent refactoring, the `hobby` plan is now treated as the `pro` plan.
     * Only use this plan ID to check if a plan is a `pro` plan or not.
     * This plan ID will be renamed to `pro` after legacy Stripe data is migrated by @darcyYe
     *
     * Todo @darcyYe:
     * - LOG-7846: Rename `hobby` to `pro` and `pro` to `legacy-pro`
     * - LOG-8339: Migrate legacy Stripe data
     */ ReservedPlanId["Hobby"] = "hobby";
    /**
     * @deprecated
     * Now this `pro` ID is not used anymore, we use `hobby` as the `pro` plan ID.
     * Only use this `pro` value when displaying the plan ID to the user.
     *
     * Todo @darcyYe see `Hobby` todo
     */ ReservedPlanId["Pro"] = "pro";
    ReservedPlanId["Development"] = "dev";
})($3088d8e3a2bf76d3$export$70d79c7c84af5a3e || ($3088d8e3a2bf76d3$export$70d79c7c84af5a3e = {}));


const $a0052762c6755033$var$routes = Object.freeze({
    signIn: "sign-in",
    register: "register",
    sso: "single-sign-on",
    consent: "consent"
});
const $a0052762c6755033$export$45794d16c9d83fe2 = Object.freeze({
    routes: $a0052762c6755033$var$routes
});




const $f154d7806239ccde$export$7ebc507e3327c47b = "#internal:";
const $f154d7806239ccde$export$9aaedfefea44825f = (roleName)=>roleName.startsWith($f154d7806239ccde$export$7ebc507e3327c47b);


const $b29bb3ea78314872$export$5ae1b4d89745ee61 = (indicator)=>/^https:\/\/[^.]+\.logto\.app\/api$/.test(indicator);



const $0268e31150996580$export$642cfcc4b084a733 = (domains)=>{
    const blackListSet = new Set((0, $d3507142cbbbfa5d$export$92ee0fc3a3bf5566));
    const validDomainSet = new Set();
    const duplicatedDomains = new Set();
    const forbiddenDomains = new Set();
    for (const domain of domains !== null && domains !== void 0 ? domains : []){
        if (blackListSet.has(domain)) forbiddenDomains.add(domain);
        if (validDomainSet.has(domain)) duplicatedDomains.add(domain);
        else validDomainSet.add(domain);
    }
    return {
        duplicatedDomains: duplicatedDomains,
        forbiddenDomains: forbiddenDomains
    };
};






/**
 * React Router DOM v6.10.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $P551f = parcelRequire("P551f");
/**
 * @remix-run/router v1.5.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $127365e5ae3fa679$var$_extends() {
    $127365e5ae3fa679$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $127365e5ae3fa679$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $127365e5ae3fa679$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($127365e5ae3fa679$export$e19cd5f9376f8cee || ($127365e5ae3fa679$export$e19cd5f9376f8cee = {}));
const $127365e5ae3fa679$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $127365e5ae3fa679$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $127365e5ae3fa679$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $127365e5ae3fa679$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $127365e5ae3fa679$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $127365e5ae3fa679$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $127365e5ae3fa679$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $127365e5ae3fa679$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $127365e5ae3fa679$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $127365e5ae3fa679$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $127365e5ae3fa679$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $127365e5ae3fa679$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $127365e5ae3fa679$export$fe53371bee54353d(to);
    }
    return $127365e5ae3fa679$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $127365e5ae3fa679$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $127365e5ae3fa679$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        return $127365e5ae3fa679$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $127365e5ae3fa679$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $127365e5ae3fa679$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $127365e5ae3fa679$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $127365e5ae3fa679$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $127365e5ae3fa679$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message); // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $127365e5ae3fa679$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $127365e5ae3fa679$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $127365e5ae3fa679$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $127365e5ae3fa679$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $127365e5ae3fa679$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $127365e5ae3fa679$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $127365e5ae3fa679$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $127365e5ae3fa679$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $127365e5ae3fa679$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $127365e5ae3fa679$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex(); // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($127365e5ae3fa679$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $127365e5ae3fa679$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $127365e5ae3fa679$export$e19cd5f9376f8cee.Push;
        let location = $127365e5ae3fa679$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $127365e5ae3fa679$var$getHistoryState(location, index);
        let url = history.createHref(location); // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $127365e5ae3fa679$export$e19cd5f9376f8cee.Replace;
        let location = $127365e5ae3fa679$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $127365e5ae3fa679$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $127365e5ae3fa679$export$fe53371bee54353d(to);
        $127365e5ae3fa679$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($127365e5ae3fa679$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($127365e5ae3fa679$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
} //#endregion
var $127365e5ae3fa679$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($127365e5ae3fa679$var$ResultType || ($127365e5ae3fa679$var$ResultType = {}));
const $127365e5ae3fa679$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $127365e5ae3fa679$var$isIndexRoute(route) {
    return route.index === true;
} // Walk the route tree generating unique IDs where necessary so we are working
// solely with AgnosticDataRouteObject's within the Router
function $127365e5ae3fa679$export$4a6d22b32134ea5d(routes, detectErrorBoundary, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $127365e5ae3fa679$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $127365e5ae3fa679$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($127365e5ae3fa679$var$isIndexRoute(route)) {
            let indexRoute = $127365e5ae3fa679$var$_extends({}, route, {
                hasErrorBoundary: detectErrorBoundary(route),
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $127365e5ae3fa679$var$_extends({}, route, {
                id: id,
                hasErrorBoundary: detectErrorBoundary(route),
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $127365e5ae3fa679$export$4a6d22b32134ea5d(route.children, detectErrorBoundary, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $127365e5ae3fa679$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $127365e5ae3fa679$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $127365e5ae3fa679$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $127365e5ae3fa679$var$flattenRoutes(routes);
    $127365e5ae3fa679$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $127365e5ae3fa679$var$matchRouteBranch(branches[i], // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    $127365e5ae3fa679$var$safelyDecodeURI(pathname));
    return matches;
}
function $127365e5ae3fa679$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $127365e5ae3fa679$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $127365e5ae3fa679$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta); // Add the children before adding this route to the array so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $127365e5ae3fa679$export$3e9cee6b33872309(// @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $127365e5ae3fa679$var$flattenRoutes(route.children, branches, routesMeta, path);
        } // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $127365e5ae3fa679$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $127365e5ae3fa679$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $127365e5ae3fa679$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments; // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?"); // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $127365e5ae3fa679$var$explodeOptionalSegments(rest.join("/"));
    let result = []; // All child paths with the prefix.  Do this for all children before the
    // optional version for all children so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explodes _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/"))); // Then if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
     // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $127365e5ae3fa679$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $127365e5ae3fa679$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $127365e5ae3fa679$var$paramRe = /^:\w+$/;
const $127365e5ae3fa679$var$dynamicSegmentValue = 3;
const $127365e5ae3fa679$var$indexRouteValue = 2;
const $127365e5ae3fa679$var$emptySegmentValue = 1;
const $127365e5ae3fa679$var$staticSegmentValue = 10;
const $127365e5ae3fa679$var$splatPenalty = -2;
const $127365e5ae3fa679$var$isSplat = (s)=>s === "*";
function $127365e5ae3fa679$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($127365e5ae3fa679$var$isSplat)) initialScore += $127365e5ae3fa679$var$splatPenalty;
    if (index) initialScore += $127365e5ae3fa679$var$indexRouteValue;
    return segments.filter((s)=>!$127365e5ae3fa679$var$isSplat(s)).reduce((score, segment)=>score + ($127365e5ae3fa679$var$paramRe.test(segment) ? $127365e5ae3fa679$var$dynamicSegmentValue : segment === "" ? $127365e5ae3fa679$var$emptySegmentValue : $127365e5ae3fa679$var$staticSegmentValue), initialScore);
}
function $127365e5ae3fa679$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // so they sort equally.
    0;
}
function $127365e5ae3fa679$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $127365e5ae3fa679$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $127365e5ae3fa679$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $127365e5ae3fa679$export$a5c6d149b50c1d86($127365e5ae3fa679$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $127365e5ae3fa679$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $127365e5ae3fa679$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $127365e5ae3fa679$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    } // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1; // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            const starParam = params[star]; // Apply the splat
            return starParam;
        }
        const keyMatch = segment.match(/^:(\w+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            if (optional === "?") return param == null ? "" : param;
            if (param == null) $127365e5ae3fa679$export$3e9cee6b33872309(false, 'Missing ":' + key + '" param');
            return param;
        } // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    }) // Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $127365e5ae3fa679$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, paramNames] = $127365e5ae3fa679$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = paramNames.reduce((memo, paramName, index)=>{
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        memo[paramName] = $127365e5ae3fa679$var$safelyDecodeURIComponent(captureGroups[index] || "", paramName);
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $127365e5ae3fa679$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $127365e5ae3fa679$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let paramNames = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^$?{}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:(\w+)/g, (_, paramName)=>{
        paramNames.push(paramName);
        return "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        paramNames.push("*");
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        paramNames
    ];
}
function $127365e5ae3fa679$var$safelyDecodeURI(value) {
    try {
        return decodeURI(value);
    } catch (error) {
        $127365e5ae3fa679$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
function $127365e5ae3fa679$var$safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        $127365e5ae3fa679$export$c0e02632e14916fd(false, 'The value for the URL param "' + paramName + '" will not be decoded because' + (' the string "' + value + '" is a malformed URL segment. This is probably') + (" due to a bad percent encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $127365e5ae3fa679$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
     // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $127365e5ae3fa679$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $127365e5ae3fa679$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $127365e5ae3fa679$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $127365e5ae3fa679$var$normalizeSearch(search),
        hash: $127365e5ae3fa679$var$normalizeHash(hash)
    };
}
function $127365e5ae3fa679$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $127365e5ae3fa679$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $127365e5ae3fa679$export$90ba53ce1c7fdff2(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
/**
 * @private
 */ function $127365e5ae3fa679$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $127365e5ae3fa679$export$8ccf933b0513f8d0(toArg);
    else {
        to = $127365e5ae3fa679$var$_extends({}, toArg);
        $127365e5ae3fa679$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $127365e5ae3fa679$var$getInvalidPathError("?", "pathname", "search", to));
        $127365e5ae3fa679$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $127365e5ae3fa679$var$getInvalidPathError("#", "pathname", "hash", to));
        $127365e5ae3fa679$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $127365e5ae3fa679$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from; // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (isPathRelative || toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/"); // Each leading .. segment means "go up one route" instead of "go up one
            // URL segment".  This is a key difference from how <a href> works and a
            // major reason we call this a "to" value instead of a "href".
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        } // If there are more ".." segments than parent routes, resolve relative to
        // the root / URL.
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $127365e5ae3fa679$export$b09f2ff0bbcb43c7(to, from); // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/"); // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $127365e5ae3fa679$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $127365e5ae3fa679$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $127365e5ae3fa679$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $127365e5ae3fa679$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $127365e5ae3fa679$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $127365e5ae3fa679$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $127365e5ae3fa679$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $127365e5ae3fa679$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $127365e5ae3fa679$export$42a99a7a4bc0e76a extends Error {
}
class $127365e5ae3fa679$export$61d759255b4eec65 {
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key); // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, null, data), (error)=>this.onSettle(promise, key, error)); // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $127365e5ae3fa679$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        if (error) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $127365e5ae3fa679$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: $127365e5ae3fa679$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $127365e5ae3fa679$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects"); // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $127365e5ae3fa679$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref)=>{
            let [key, value] = _ref;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
}
function $127365e5ae3fa679$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $127365e5ae3fa679$var$unwrapTrackedPromise(value) {
    if (!$127365e5ae3fa679$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $127365e5ae3fa679$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $127365e5ae3fa679$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $127365e5ae3fa679$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $127365e5ae3fa679$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 */ class $127365e5ae3fa679$export$acf1a680051f5031 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $127365e5ae3fa679$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $127365e5ae3fa679$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $127365e5ae3fa679$var$validMutationMethods = new Set($127365e5ae3fa679$var$validMutationMethodsArr);
const $127365e5ae3fa679$var$validRequestMethodsArr = [
    "get",
    ...$127365e5ae3fa679$var$validMutationMethodsArr
];
const $127365e5ae3fa679$var$validRequestMethods = new Set($127365e5ae3fa679$var$validRequestMethodsArr);
const $127365e5ae3fa679$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $127365e5ae3fa679$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $127365e5ae3fa679$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined
};
const $127365e5ae3fa679$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined
};
const $127365e5ae3fa679$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $127365e5ae3fa679$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $127365e5ae3fa679$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $127365e5ae3fa679$var$isServer = !$127365e5ae3fa679$var$isBrowser;
const $127365e5ae3fa679$var$defaultDetectErrorBoundary = (route)=>Boolean(route.hasErrorBoundary); //#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $127365e5ae3fa679$export$baddd0131ee8c05b(init) {
    $127365e5ae3fa679$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let detectErrorBoundary = init.detectErrorBoundary || $127365e5ae3fa679$var$defaultDetectErrorBoundary; // Routes keyed by ID
    let manifest = {}; // Routes in tree format for matching
    let dataRoutes = $127365e5ae3fa679$export$4a6d22b32134ea5d(init.routes, detectErrorBoundary, undefined, manifest);
    let inFlightDataRoutes; // Config driven behavior flags
    let future = $127365e5ae3fa679$var$_extends({
        v7_normalizeFormMethod: false
    }, init.future); // Cleanup function for history
    let unlistenHistory = null; // Externally-provided functions to call on all state changes
    let subscribers = new Set(); // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null; // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null; // Externally-provided function to get current scroll position
    let getScrollPosition = null; // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $127365e5ae3fa679$export$2708184779ceb39d(dataRoutes, init.history.location, init.basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $127365e5ae3fa679$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $127365e5ae3fa679$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized = // functions around still then we'll need to run them in initialize()
    !initialMatches.some((m)=>m.route.lazy) && (!initialMatches.some((m)=>m.route.loader) || init.hydrationData != null);
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $127365e5ae3fa679$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    }; // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $127365e5ae3fa679$export$e19cd5f9376f8cee.Pop; // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false; // AbortController for the active navigation
    let pendingNavigationController; // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false; // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidate()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false; // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = []; // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = []; // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map(); // Track loads based on the order in which they started
    let incrementingLoadId = 0; // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1; // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map(); // Fetchers that triggered redirect navigations from their actions
    let fetchRedirectIds = new Set(); // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map(); // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map(); // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map(); // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false; // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $127365e5ae3fa679$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1); // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        }); // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        deleteBlocker(blockerKey);
                        updateState({
                            blockers: new Map(router.state.blockers)
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        }); // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($127365e5ae3fa679$export$e19cd5f9376f8cee.Pop, state.location);
        return router;
    } // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    } // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    } // Update our state and notify the calling context of the change
    function updateState(newState) {
        state = $127365e5ae3fa679$var$_extends({}, state, newState);
        subscribers.forEach((subscriber)=>subscriber(state));
    } // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState) {
        var _location$state, _location$state2;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $127365e5ae3fa679$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
         // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $127365e5ae3fa679$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData; // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        for (let [key] of blockerFunctions)deleteBlocker(key);
         // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $127365e5ae3fa679$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        updateState($127365e5ae3fa679$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $127365e5ae3fa679$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: new Map(state.blockers)
        }));
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $127365e5ae3fa679$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $127365e5ae3fa679$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $127365e5ae3fa679$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
         // Reset stateful navigation vars
        pendingAction = $127365e5ae3fa679$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    } // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let { path: path, submission: submission, error: error } = $127365e5ae3fa679$var$normalizeNavigateOptions(to, future, opts);
        let currentLocation = state.location;
        let nextLocation = $127365e5ae3fa679$var$createLocation(state.location, path, opts && opts.state); // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $127365e5ae3fa679$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $127365e5ae3fa679$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $127365e5ae3fa679$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $127365e5ae3fa679$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $127365e5ae3fa679$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    }); // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    deleteBlocker(blockerKey);
                    updateState({
                        blockers: new Map(state.blockers)
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace
        });
    } // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        }); // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
         // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        } // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    } // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true; // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $127365e5ae3fa679$export$2708184779ceb39d(routesToUse, location, init.basename); // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $127365e5ae3fa679$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $127365e5ae3fa679$var$getShortCircuitMatches(routesToUse); // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            });
            return;
        } // Short circuit if it's only a hash change and not a mutation submission
        // For example, on /page#hash and submit a <Form method="post"> which will
        // default to a navigation to /page
        if ($127365e5ae3fa679$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $127365e5ae3fa679$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            });
            return;
        } // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $127365e5ae3fa679$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [$127365e5ae3fa679$var$findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission && $127365e5ae3fa679$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            let navigation = $127365e5ae3fa679$var$_extends({
                state: "loading",
                location: location
            }, opts.submission);
            loadingNavigation = navigation; // Create a GET request for the loaders
            request = new Request(request.url, {
                signal: request.signal
            });
        } // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, pendingActionData, pendingError);
        if (shortCircuited) return;
         // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $127365e5ae3fa679$var$_extends({
            matches: matches
        }, pendingActionData ? {
            actionData: pendingActionData
        } : {}, {
            loaderData: loaderData,
            errors: errors
        }));
    } // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        interruptActiveLoads(); // Put us in a submitting state
        let navigation = $127365e5ae3fa679$var$_extends({
            state: "submitting",
            location: location
        }, submission);
        updateState({
            navigation: navigation
        }); // Call our action and get the result
        let result;
        let actionMatch = $127365e5ae3fa679$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $127365e5ae3fa679$var$ResultType.error,
            error: $127365e5ae3fa679$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            result = await $127365e5ae3fa679$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, detectErrorBoundary, router.basename);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($127365e5ae3fa679$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else // If the user didn't explicity indicate replace behavior, replace if
            // we redirected to the exact same location we're currently at to avoid
            // double back-buttons
            replace = result.location === state.location.pathname + state.location.search;
            await startRedirectNavigation(state, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($127365e5ae3fa679$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $127365e5ae3fa679$var$findNearestBoundary(matches, actionMatch.route.id); // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $127365e5ae3fa679$export$e19cd5f9376f8cee.Push;
            return {
                // Send back an empty object we can use to clear out any prior actionData
                pendingActionData: {},
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if ($127365e5ae3fa679$var$isDeferredResult(result)) throw $127365e5ae3fa679$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    } // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation;
        if (!loadingNavigation) {
            let navigation = $127365e5ae3fa679$var$_extends({
                state: "loading",
                location: location,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined
            }, submission);
            loadingNavigation = navigation;
        } // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission ? submission || fetcherSubmission : loadingNavigation.formMethod && loadingNavigation.formAction && loadingNavigation.formData && loadingNavigation.formEncType ? {
            formMethod: loadingNavigation.formMethod,
            formAction: loadingNavigation.formAction,
            formData: loadingNavigation.formData,
            formEncType: loadingNavigation.formEncType
        } : undefined;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $127365e5ae3fa679$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, routesToUse, init.basename, pendingActionData, pendingError); // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId)); // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            completeNavigation(location, $127365e5ae3fa679$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingError || null
            }, pendingActionData ? {
                actionData: pendingActionData
            } : {}));
            return {
                shortCircuited: true
            };
        } // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        if (!isUninterruptedRevalidation) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = {
                    state: "loading",
                    data: fetcher && fetcher.data,
                    formMethod: undefined,
                    formAction: undefined,
                    formEncType: undefined,
                    formData: undefined,
                    " _hasFetcherDoneAnything ": true
                };
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData = pendingActionData || state.actionData;
            updateState($127365e5ae3fa679$var$_extends({
                navigation: loadingNavigation
            }, actionData ? Object.keys(actionData).length === 0 ? {
                actionData: null
            } : {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}));
        }
        pendingNavigationLoadId = ++incrementingLoadId;
        revalidatingFetchers.forEach((rf)=>fetchControllers.set(rf.key, pendingNavigationController));
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
         // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key)); // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $127365e5ae3fa679$var$findRedirect(results);
        if (redirect) {
            await startRedirectNavigation(state, redirect, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        } // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $127365e5ae3fa679$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds); // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        return $127365e5ae3fa679$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, didAbortFetchLoads || revalidatingFetchers.length > 0 ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getFetcher(key) {
        return state.fetchers.get(key) || $127365e5ae3fa679$export$52eace9c284d3585;
    } // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if ($127365e5ae3fa679$var$isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = $127365e5ae3fa679$export$2708184779ceb39d(routesToUse, href, init.basename);
        if (!matches) {
            setFetcherError(key, routeId, $127365e5ae3fa679$var$getInternalRouterError(404, {
                pathname: href
            }));
            return;
        }
        let { path: path, submission: submission } = $127365e5ae3fa679$var$normalizeNavigateOptions(href, future, opts, true);
        let match = $127365e5ae3fa679$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $127365e5ae3fa679$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, submission);
            return;
        } // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, submission);
    } // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $127365e5ae3fa679$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error);
            return;
        } // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        let fetcher = $127365e5ae3fa679$var$_extends({
            state: "submitting"
        }, submission, {
            data: existingFetcher && existingFetcher.data,
            " _hasFetcherDoneAnything ": true
        });
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }); // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $127365e5ae3fa679$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let actionResult = await $127365e5ae3fa679$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, detectErrorBoundary, router.basename);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by ou our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if ($127365e5ae3fa679$var$isRedirectResult(actionResult)) {
            fetchControllers.delete(key);
            fetchRedirectIds.add(key);
            let loadingFetcher = $127365e5ae3fa679$var$_extends({
                state: "loading"
            }, submission, {
                data: undefined,
                " _hasFetcherDoneAnything ": true
            });
            state.fetchers.set(key, loadingFetcher);
            updateState({
                fetchers: new Map(state.fetchers)
            });
            return startRedirectNavigation(state, actionResult, {
                submission: submission,
                isFetchActionRedirect: true
            });
        } // Process any non-redirect errors thrown
        if ($127365e5ae3fa679$var$isErrorResult(actionResult)) {
            setFetcherError(key, routeId, actionResult.error);
            return;
        }
        if ($127365e5ae3fa679$var$isDeferredResult(actionResult)) throw $127365e5ae3fa679$var$getInternalRouterError(400, {
            type: "defer-action"
        });
         // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $127365e5ae3fa679$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $127365e5ae3fa679$export$2708184779ceb39d(routesToUse, state.navigation.location, init.basename) : state.matches;
        $127365e5ae3fa679$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $127365e5ae3fa679$var$_extends({
            state: "loading",
            data: actionResult.data
        }, submission, {
            " _hasFetcherDoneAnything ": true
        });
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $127365e5ae3fa679$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, routesToUse, init.basename, {
            [match.route.id]: actionResult.data
        }, undefined // No need to send through errors since we short circuit above
        ); // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = {
                state: "loading",
                data: existingFetcher && existingFetcher.data,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined,
                " _hasFetcherDoneAnything ": true
            };
            state.fetchers.set(staleKey, revalidatingFetcher);
            fetchControllers.set(staleKey, abortController);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $127365e5ae3fa679$var$findRedirect(results);
        if (redirect) return startRedirectNavigation(state, redirect);
         // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $127365e5ae3fa679$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        let doneFetcher = {
            state: "idle",
            data: actionResult.data,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            " _hasFetcherDoneAnything ": true
        };
        state.fetchers.set(key, doneFetcher);
        let didAbortFetchLoads = abortStaleFetchLoads(loadId); // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $127365e5ae3fa679$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState($127365e5ae3fa679$var$_extends({
                errors: errors,
                loaderData: $127365e5ae3fa679$var$mergeLoaderData(state.loaderData, loaderData, matches, errors)
            }, didAbortFetchLoads ? {
                fetchers: new Map(state.fetchers)
            } : {}));
            isRevalidationRequired = false;
        }
    } // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, submission) {
        let existingFetcher = state.fetchers.get(key); // Put this fetcher into it's loading state
        let loadingFetcher = $127365e5ae3fa679$var$_extends({
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined
        }, submission, {
            data: existingFetcher && existingFetcher.data,
            " _hasFetcherDoneAnything ": true
        });
        state.fetchers.set(key, loadingFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }); // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $127365e5ae3fa679$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let result = await $127365e5ae3fa679$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, detectErrorBoundary, router.basename); // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($127365e5ae3fa679$var$isDeferredResult(result)) result = await $127365e5ae3fa679$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
         // We can delete this so long as we weren't aborted by ou our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
         // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($127365e5ae3fa679$var$isRedirectResult(result)) {
            await startRedirectNavigation(state, result);
            return;
        } // Process any non-redirect errors thrown
        if ($127365e5ae3fa679$var$isErrorResult(result)) {
            let boundaryMatch = $127365e5ae3fa679$var$findNearestBoundary(state.matches, routeId);
            state.fetchers.delete(key); // TODO: In remix, this would reset to IDLE_NAVIGATION if it was a catch -
            // do we need to behave any differently with our non-redirect errors?
            // What if it was a non-redirect Response?
            updateState({
                fetchers: new Map(state.fetchers),
                errors: {
                    [boundaryMatch.route.id]: result.error
                }
            });
            return;
        }
        $127365e5ae3fa679$export$3e9cee6b33872309(!$127365e5ae3fa679$var$isDeferredResult(result), "Unhandled fetcher deferred data"); // Put the fetcher back into an idle state
        let doneFetcher = {
            state: "idle",
            data: result.data,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            " _hasFetcherDoneAnything ": true
        };
        state.fetchers.set(key, doneFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(state, redirect, _temp) {
        var _window;
        let { submission: submission, replace: replace, isFetchActionRedirect: isFetchActionRedirect } = _temp === void 0 ? {} : _temp;
        if (redirect.revalidate) isRevalidationRequired = true;
        let redirectLocation = $127365e5ae3fa679$var$createLocation(state.location, redirect.location, $127365e5ae3fa679$var$_extends({
            _isRedirect: true
        }, isFetchActionRedirect ? {
            _isFetchActionRedirect: true
        } : {}));
        $127365e5ae3fa679$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation"); // Check if this an absolute external redirect that goes to a new origin
        if ($127365e5ae3fa679$var$ABSOLUTE_URL_REGEX.test(redirect.location) && $127365e5ae3fa679$var$isBrowser && typeof ((_window = window) == null ? void 0 : _window.location) !== "undefined") {
            let url = init.history.createURL(redirect.location);
            let isDifferentBasename = $127365e5ae3fa679$export$b69e3301ce081aa3(url.pathname, init.basename || "/") == null;
            if (window.location.origin !== url.origin || isDifferentBasename) {
                if (replace) window.location.replace(redirect.location);
                else window.location.assign(redirect.location);
                return;
            }
        } // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $127365e5ae3fa679$export$e19cd5f9376f8cee.Replace : $127365e5ae3fa679$export$e19cd5f9376f8cee.Push; // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, formData: formData } = state.navigation;
        if (!submission && formMethod && formAction && formData && formEncType) submission = {
            formMethod: formMethod,
            formAction: formAction,
            formEncType: formEncType,
            formData: formData
        };
         // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        if ($127365e5ae3fa679$var$redirectPreserveMethodStatusCodes.has(redirect.status) && submission && $127365e5ae3fa679$var$isMutationMethod(submission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $127365e5ae3fa679$var$_extends({}, submission, {
                formAction: redirect.location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else if (isFetchActionRedirect) // For a fetch action redirect, we kick off a new loading navigation
        // without the fetcher submission, but we send it along for shouldRevalidate
        await startNavigation(redirectHistoryAction, redirectLocation, {
            overrideNavigation: {
                state: "loading",
                location: redirectLocation,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined
            },
            fetcherSubmission: submission,
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else // Otherwise, we kick off a new loading navigation, preserving the
        // submission info for the duration of this navigation
        await startNavigation(redirectHistoryAction, redirectLocation, {
            overrideNavigation: {
                state: "loading",
                location: redirectLocation,
                formMethod: submission ? submission.formMethod : undefined,
                formAction: submission ? submission.formAction : undefined,
                formEncType: submission ? submission.formEncType : undefined,
                formData: submission ? submission.formData : undefined
            },
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$127365e5ae3fa679$var$callLoaderOrAction("loader", request, match, matches, manifest, detectErrorBoundary, router.basename)),
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match) return $127365e5ae3fa679$var$callLoaderOrAction("loader", $127365e5ae3fa679$var$createClientSideRequest(init.history, f.path, request.signal), f.match, f.matches, manifest, detectErrorBoundary, router.basename);
                else {
                    let error = {
                        type: $127365e5ae3fa679$var$ResultType.error,
                        error: $127365e5ae3fa679$var$getInternalRouterError(404, {
                            pathname: f.path
                        })
                    };
                    return error;
                }
            })
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            $127365e5ae3fa679$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, request.signal, false, state.loaderData),
            $127365e5ae3fa679$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, request.signal, true)
        ]);
        return {
            results: results,
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true; // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds()); // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function setFetcherError(key, routeId, error) {
        let boundaryMatch = $127365e5ae3fa679$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        });
    }
    function deleteFetcher(key) {
        if (fetchControllers.has(key)) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        state.fetchers.delete(key);
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $127365e5ae3fa679$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = {
                state: "idle",
                data: fetcher.data,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined,
                " _hasFetcherDoneAnything ": true
            };
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $127365e5ae3fa679$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
            }
        }
        markFetchersDone(doneKeys);
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $127365e5ae3fa679$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $127365e5ae3fa679$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    } // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $127365e5ae3fa679$export$386d57f03f0b2883; // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $127365e5ae3fa679$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        state.blockers.set(key, newBlocker);
        updateState({
            blockers: new Map(state.blockers)
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
         // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $127365e5ae3fa679$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
         // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    } // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || ((location)=>location.key); // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $127365e5ae3fa679$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollRestorationKey && getScrollPosition) {
            let userMatches = matches.map((m)=>$127365e5ae3fa679$var$createUseMatchesMatch(m, state.loaderData));
            let key = getScrollRestorationKey(location, userMatches) || location.key;
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollRestorationKey && getScrollPosition) {
            let userMatches = matches.map((m)=>$127365e5ae3fa679$var$createUseMatchesMatch(m, state.loaderData));
            let key = getScrollRestorationKey(location, userMatches) || location.key;
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        inFlightDataRoutes = newRoutes;
    }
    router = {
        get basename () {
            return init.basename;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcher,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
} //#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $127365e5ae3fa679$export$4d0306f8f6a4585b = Symbol("deferred");
function $127365e5ae3fa679$export$3336b097a6fbc59a(routes, opts) {
    $127365e5ae3fa679$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let detectErrorBoundary = (opts == null ? void 0 : opts.detectErrorBoundary) || $127365e5ae3fa679$var$defaultDetectErrorBoundary;
    let dataRoutes = $127365e5ae3fa679$export$4a6d22b32134ea5d(routes, detectErrorBoundary, undefined, manifest);
    let basename = (opts ? opts.basename : null) || "/";
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ async function query(request, _temp2) {
        let { requestContext: requestContext } = _temp2 === void 0 ? {} : _temp2;
        let url = new URL(request.url);
        let method = request.method;
        let location = $127365e5ae3fa679$var$createLocation("", $127365e5ae3fa679$export$fe53371bee54353d(url), null, "default");
        let matches = $127365e5ae3fa679$export$2708184779ceb39d(dataRoutes, location, basename); // SSR supports HEAD requests while SPA doesn't
        if (!$127365e5ae3fa679$var$isValidMethod(method) && method !== "HEAD") {
            let error = $127365e5ae3fa679$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $127365e5ae3fa679$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $127365e5ae3fa679$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $127365e5ae3fa679$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext);
        if ($127365e5ae3fa679$var$isResponse(result)) return result;
         // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $127365e5ae3fa679$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ async function queryRoute(request, _temp3) {
        let { routeId: routeId, requestContext: requestContext } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $127365e5ae3fa679$var$createLocation("", $127365e5ae3fa679$export$fe53371bee54353d(url), null, "default");
        let matches = $127365e5ae3fa679$export$2708184779ceb39d(dataRoutes, location, basename); // SSR supports HEAD requests while SPA doesn't
        if (!$127365e5ae3fa679$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $127365e5ae3fa679$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $127365e5ae3fa679$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $127365e5ae3fa679$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $127365e5ae3fa679$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $127365e5ae3fa679$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, match);
        if ($127365e5ae3fa679$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
         // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$127365e5ae3fa679$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, routeMatch) {
        $127365e5ae3fa679$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($127365e5ae3fa679$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $127365e5ae3fa679$var$getTargetMatch(matches, location), requestContext, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, routeMatch);
            return $127365e5ae3fa679$var$isResponse(result) ? result : $127365e5ae3fa679$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction, we throw
            // it to bail out and then return or throw here based on whether the user
            // returned or threw
            if ($127365e5ae3fa679$var$isQueryRouteResponse(e)) {
                if (e.type === $127365e5ae3fa679$var$ResultType.error && !$127365e5ae3fa679$var$isRedirectResponse(e.response)) throw e.response;
                return e.response;
            } // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($127365e5ae3fa679$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $127365e5ae3fa679$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $127365e5ae3fa679$var$ResultType.error,
                error: error
            };
        } else {
            result = await $127365e5ae3fa679$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, detectErrorBoundary, basename, true, isRouteRequest, requestContext);
            if (request.signal.aborted) {
                let method = isRouteRequest ? "queryRoute" : "query";
                throw new Error(method + "() call aborted");
            }
        }
        if ($127365e5ae3fa679$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if ($127365e5ae3fa679$var$isDeferredResult(result)) {
            let error = $127365e5ae3fa679$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $127365e5ae3fa679$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($127365e5ae3fa679$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        if ($127365e5ae3fa679$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $127365e5ae3fa679$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, requestContext, undefined, {
                [boundaryMatch.route.id]: result.error
            }); // action status codes take precedence over loader status codes
            return $127365e5ae3fa679$var$_extends({}, context, {
                statusCode: $127365e5ae3fa679$export$972111febbeef05b(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: $127365e5ae3fa679$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        } // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        let context = await loadRouteData(loaderRequest, matches, requestContext);
        return $127365e5ae3fa679$var$_extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: $127365e5ae3fa679$var$_extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        let isRouteRequest = routeMatch != null; // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $127365e5ae3fa679$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : $127365e5ae3fa679$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy); // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$127365e5ae3fa679$var$callLoaderOrAction("loader", request, match, matches, manifest, detectErrorBoundary, basename, true, isRouteRequest, requestContext))
        ]);
        if (request.signal.aborted) {
            let method = isRouteRequest ? "queryRoute" : "query";
            throw new Error(method + "() call aborted");
        } // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $127365e5ae3fa679$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds); // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $127365e5ae3fa679$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
} //#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $127365e5ae3fa679$export$fec11da027c70692(routes, context, error) {
    let newContext = $127365e5ae3fa679$var$_extends({}, context, {
        statusCode: 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $127365e5ae3fa679$var$isSubmissionNavigation(opts) {
    return opts != null && "formData" in opts;
} // Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $127365e5ae3fa679$var$normalizeNavigateOptions(to, future, opts, isFetcher) {
    if (isFetcher === void 0) isFetcher = false;
    let path = typeof to === "string" ? to : $127365e5ae3fa679$export$fe53371bee54353d(to); // Return location verbatim on non-submission navigations
    if (!opts || !$127365e5ae3fa679$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$127365e5ae3fa679$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $127365e5ae3fa679$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
     // Create a Submission on non-GET navigations
    let submission;
    if (opts.formData) {
        let formMethod = opts.formMethod || "get";
        submission = {
            formMethod: future.v7_normalizeFormMethod ? formMethod.toUpperCase() : formMethod.toLowerCase(),
            formAction: $127365e5ae3fa679$var$stripHashFromPath(path),
            formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
            formData: opts.formData
        };
        if ($127365e5ae3fa679$var$isMutationMethod(submission.formMethod)) return {
            path: path,
            submission: submission
        };
    } // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $127365e5ae3fa679$export$8ccf933b0513f8d0(path);
    let searchParams = $127365e5ae3fa679$var$convertFormDataToSearchParams(opts.formData); // Since fetcher GET submissions only run a single loader (as opposed to
    // navigation GET submissions which run all loaders), we need to preserve
    // any incoming ?index params
    if (isFetcher && parsedPath.search && $127365e5ae3fa679$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $127365e5ae3fa679$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
} // Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $127365e5ae3fa679$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $127365e5ae3fa679$var$getMatchesToLoad(history, state, matches, submission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, routesToUse, basename, pendingActionData, pendingError) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    let defaultShouldRevalidate = isRevalidationRequired || // Clicked the same link, resubmitted a GET form
    currentUrl.toString() === nextUrl.toString() || // Search params affect all loaders
    currentUrl.search !== nextUrl.search; // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = $127365e5ae3fa679$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        if (match.route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (match.route.loader == null) return false;
         // Always call the loader on new route instances and pending defer cancellations
        if ($127365e5ae3fa679$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
         // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $127365e5ae3fa679$var$shouldRevalidateLoader(match, $127365e5ae3fa679$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: defaultShouldRevalidate || $127365e5ae3fa679$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    }); // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate if fetcher won't be present in the subsequent render
        if (!matches.some((m)=>m.route.id === f.routeId)) return;
        let fetcherMatches = $127365e5ae3fa679$export$2708184779ceb39d(routesToUse, f.path, basename); // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData
        if (!fetcherMatches) {
            revalidatingFetchers.push($127365e5ae3fa679$var$_extends({
                key: key
            }, f, {
                matches: null,
                match: null
            }));
            return;
        }
        let fetcherMatch = $127365e5ae3fa679$var$getTargetMatch(fetcherMatches, f.path);
        if (cancelledFetcherLoads.includes(key)) {
            revalidatingFetchers.push($127365e5ae3fa679$var$_extends({
                key: key,
                matches: fetcherMatches,
                match: fetcherMatch
            }, f));
            return;
        } // Revalidating fetchers are decoupled from the route matches since they
        // hit a static href, so they _always_ check shouldRevalidate and the
        // default is strictly if a revalidation is explicitly required (action
        // submissions, useRevalidator, X-Remix-Revalidate).
        let shouldRevalidate = $127365e5ae3fa679$var$shouldRevalidateLoader(fetcherMatch, $127365e5ae3fa679$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: defaultShouldRevalidate
        }));
        if (shouldRevalidate) revalidatingFetchers.push($127365e5ae3fa679$var$_extends({
            key: key,
            matches: fetcherMatches,
            match: fetcherMatch
        }, f));
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $127365e5ae3fa679$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id; // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined; // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $127365e5ae3fa679$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"];
}
function $127365e5ae3fa679$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $127365e5ae3fa679$var$loadLazyRouteModule(route, detectErrorBoundary, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy(); // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $127365e5ae3fa679$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest"); // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $127365e5ae3fa679$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$127365e5ae3fa679$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    } // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to detectErrorBoundary
    Object.assign(routeToUpdate, routeUpdates); // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, {
        // To keep things framework agnostic, we use the provided
        // `detectErrorBoundary` function to set the `hasErrorBoundary` route
        // property since the logic will differ between frameworks.
        hasErrorBoundary: detectErrorBoundary($127365e5ae3fa679$var$_extends({}, routeToUpdate)),
        lazy: undefined
    });
}
async function $127365e5ae3fa679$var$callLoaderOrAction(type, request, match, matches, manifest, detectErrorBoundary, basename, isStaticRequest, isRouteRequest, requestContext) {
    if (basename === void 0) basename = "/";
    if (isStaticRequest === void 0) isStaticRequest = false;
    if (isRouteRequest === void 0) isRouteRequest = false;
    let resultType;
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        return Promise.race([
            handler({
                request: request,
                params: match.params,
                context: requestContext
            }),
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let values = await Promise.all([
                    runHandler(handler),
                    $127365e5ae3fa679$var$loadLazyRouteModule(match.route, detectErrorBoundary, manifest)
                ]);
                result = values[0];
            } else {
                // Load lazy route module, then run any returned handler
                await $127365e5ae3fa679$var$loadLazyRouteModule(match.route, detectErrorBoundary, manifest);
                handler = match.route[type];
                if (handler) // Handler still run even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") throw $127365e5ae3fa679$var$getInternalRouterError(405, {
                    method: request.method,
                    pathname: new URL(request.url).pathname,
                    routeId: match.route.id
                });
                else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $127365e5ae3fa679$var$ResultType.data,
                    data: undefined
                };
            }
        } else {
            $127365e5ae3fa679$export$3e9cee6b33872309(handler, "Could not find the " + type + ' to run on the "' + match.route.id + '" route');
            result = await runHandler(handler);
        }
        $127365e5ae3fa679$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        resultType = $127365e5ae3fa679$var$ResultType.error;
        result = e;
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    if ($127365e5ae3fa679$var$isResponse(result)) {
        let status = result.status; // Process redirects
        if ($127365e5ae3fa679$var$redirectStatusCodes.has(status)) {
            let location = result.headers.get("Location");
            $127365e5ae3fa679$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header"); // Support relative routing in internal redirects
            if (!$127365e5ae3fa679$var$ABSOLUTE_URL_REGEX.test(location)) {
                let activeMatches = matches.slice(0, matches.indexOf(match) + 1);
                let routePathnames = $127365e5ae3fa679$export$90ba53ce1c7fdff2(activeMatches).map((match)=>match.pathnameBase);
                let resolvedLocation = $127365e5ae3fa679$export$cae722b0cc860f13(location, routePathnames, new URL(request.url).pathname);
                $127365e5ae3fa679$export$3e9cee6b33872309($127365e5ae3fa679$export$fe53371bee54353d(resolvedLocation), "Unable to resolve redirect location: " + location); // Prepend the basename to the redirect location if we have one
                if (basename) {
                    let path = resolvedLocation.pathname;
                    resolvedLocation.pathname = path === "/" ? basename : $127365e5ae3fa679$export$86d9a7913e44197e([
                        basename,
                        path
                    ]);
                }
                location = $127365e5ae3fa679$export$fe53371bee54353d(resolvedLocation);
            } else if (!isStaticRequest) {
                // Strip off the protocol+origin for same-origin + same-basename absolute
                // redirects. If this is a static request, we can let it go back to the
                // browser as-is
                let currentUrl = new URL(request.url);
                let url = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                let isSameBasename = $127365e5ae3fa679$export$b69e3301ce081aa3(url.pathname, basename) != null;
                if (url.origin === currentUrl.origin && isSameBasename) location = url.pathname + url.search + url.hash;
            } // Don't process redirects in the router during static requests requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect.  We also update the Location header in place in this flow so
            // basename and relative routing is taken into account
            if (isStaticRequest) {
                result.headers.set("Location", location);
                throw result;
            }
            return {
                type: $127365e5ae3fa679$var$ResultType.redirect,
                status: status,
                location: location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null
            };
        } // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping.  We do this with the QueryRouteResponse wrapper
        // interface so we can know whether it was returned or thrown
        if (isRouteRequest) // eslint-disable-next-line no-throw-literal
        throw {
            type: resultType || $127365e5ae3fa679$var$ResultType.data,
            response: result
        };
        let data;
        let contentType = result.headers.get("Content-Type"); // Check between word boundaries instead of startsWith() due to the last
        // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
        if (contentType && /\bapplication\/json\b/.test(contentType)) data = await result.json();
        else data = await result.text();
        if (resultType === $127365e5ae3fa679$var$ResultType.error) return {
            type: resultType,
            error: new $127365e5ae3fa679$export$acf1a680051f5031(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: $127365e5ae3fa679$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === $127365e5ae3fa679$var$ResultType.error) return {
        type: resultType,
        error: result
    };
    if ($127365e5ae3fa679$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $127365e5ae3fa679$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $127365e5ae3fa679$var$ResultType.data,
        data: result
    };
} // Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $127365e5ae3fa679$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($127365e5ae3fa679$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $127365e5ae3fa679$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType, formData: formData } = submission; // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        init.body = formEncType === "application/x-www-form-urlencoded" ? $127365e5ae3fa679$var$convertFormDataToSearchParams(formData) : formData;
    } // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
    return new Request(url, init);
}
function $127365e5ae3fa679$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, value instanceof File ? value.name : value);
    return searchParams;
}
function $127365e5ae3fa679$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {}; // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $127365e5ae3fa679$export$3e9cee6b33872309(!$127365e5ae3fa679$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($127365e5ae3fa679$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = $127365e5ae3fa679$var$findNearestBoundary(matches, id);
            let error = result.error; // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {}; // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
             // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined; // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $127365e5ae3fa679$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($127365e5ae3fa679$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
             // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    }); // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $127365e5ae3fa679$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $127365e5ae3fa679$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds); // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match } = revalidatingFetchers[index];
        $127365e5ae3fa679$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index]; // Process fetcher non-redirect errors
        if ($127365e5ae3fa679$var$isErrorResult(result)) {
            let boundaryMatch = $127365e5ae3fa679$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $127365e5ae3fa679$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($127365e5ae3fa679$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $127365e5ae3fa679$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($127365e5ae3fa679$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $127365e5ae3fa679$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = {
                state: "idle",
                data: result.data,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined,
                " _hasFetcherDoneAnything ": true
            };
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $127365e5ae3fa679$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $127365e5ae3fa679$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
} // Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $127365e5ae3fa679$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $127365e5ae3fa679$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $127365e5ae3fa679$var$getInternalRouterError(status, _temp4) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp4 === void 0 ? {} : _temp4;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $127365e5ae3fa679$export$acf1a680051f5031(status || 500, statusText, new Error(errorMessage), true);
} // Find any returned redirect errors, starting from the lowest match
function $127365e5ae3fa679$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($127365e5ae3fa679$var$isRedirectResult(result)) return result;
    }
}
function $127365e5ae3fa679$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $127365e5ae3fa679$export$8ccf933b0513f8d0(path) : path;
    return $127365e5ae3fa679$export$fe53371bee54353d($127365e5ae3fa679$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $127365e5ae3fa679$var$isHashChangeOnly(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash !== b.hash;
}
function $127365e5ae3fa679$var$isDeferredResult(result) {
    return result.type === $127365e5ae3fa679$var$ResultType.deferred;
}
function $127365e5ae3fa679$var$isErrorResult(result) {
    return result.type === $127365e5ae3fa679$var$ResultType.error;
}
function $127365e5ae3fa679$var$isRedirectResult(result) {
    return (result && result.type) === $127365e5ae3fa679$var$ResultType.redirect;
}
function $127365e5ae3fa679$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $127365e5ae3fa679$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $127365e5ae3fa679$var$isRedirectResponse(result) {
    if (!$127365e5ae3fa679$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $127365e5ae3fa679$var$isQueryRouteResponse(obj) {
    return obj && $127365e5ae3fa679$var$isResponse(obj.response) && (obj.type === $127365e5ae3fa679$var$ResultType.data || $127365e5ae3fa679$var$ResultType.error);
}
function $127365e5ae3fa679$var$isValidMethod(method) {
    return $127365e5ae3fa679$var$validRequestMethods.has(method.toLowerCase());
}
function $127365e5ae3fa679$var$isMutationMethod(method) {
    return $127365e5ae3fa679$var$validMutationMethods.has(method.toLowerCase());
}
async function $127365e5ae3fa679$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signal, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index]; // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$127365e5ae3fa679$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($127365e5ae3fa679$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $127365e5ae3fa679$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
            if (result) results[index] = result || results[index];
        });
    }
}
async function $127365e5ae3fa679$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $127365e5ae3fa679$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $127365e5ae3fa679$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $127365e5ae3fa679$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $127365e5ae3fa679$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
} // Note: This should match the format exported by useMatches, so if you change
// this please also change that :)  Eventually we'll DRY this up
function $127365e5ae3fa679$var$createUseMatchesMatch(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $127365e5ae3fa679$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $127365e5ae3fa679$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $127365e5ae3fa679$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
     // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $127365e5ae3fa679$export$90ba53ce1c7fdff2(matches);
    return pathMatches[pathMatches.length - 1];
} //#endregion

/**
 * React Router v6.10.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 

var $P551f = parcelRequire("P551f");
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */ function $2ed817dc54ac40e6$var$isPolyfill(x, y) {
    return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y // eslint-disable-line no-self-compare
    ;
}
const $2ed817dc54ac40e6$var$is = typeof Object.is === "function" ? Object.is : $2ed817dc54ac40e6$var$isPolyfill; // Intentionally not using named imports because Rollup uses dynamic
// dispatch for CommonJS interop named imports.
const { useState: $2ed817dc54ac40e6$var$useState, useEffect: $2ed817dc54ac40e6$var$useEffect, useLayoutEffect: $2ed817dc54ac40e6$var$useLayoutEffect, useDebugValue: $2ed817dc54ac40e6$var$useDebugValue } = $P551f;
let $2ed817dc54ac40e6$var$didWarnOld18Alpha = false;
let $2ed817dc54ac40e6$var$didWarnUncachedGetSnapshot = false; // Disclaimer: This shim breaks many of the rules of React, and only works
// because of a very particular set of implementation details and assumptions
// -- change any one of them and it will break. The most important assumption
// is that updates are always synchronous, because concurrent rendering is
// only available in versions of React that also have a built-in
// useSyncExternalStore API. And we only use this shim when the built-in API
// does not exist.
//
// Do not assume that the clever hacks used by this hook also work in general.
// The point of this shim is to replace the need for hacks by other libraries.
function $2ed817dc54ac40e6$var$useSyncExternalStore$2(subscribe, getSnapshot, // React do not expose a way to check if we're hydrating. So users of the shim
// will need to track that themselves and return the correct value
// from `getSnapshot`.
getServerSnapshot) {
    // breaks the rules of React, and only works here because of specific
    // implementation details, most importantly that updates are
    // always synchronous.
    const value = getSnapshot();
    // re-render whenever the subscribed state changes by updating an some
    // arbitrary useState hook. Then, during render, we call getSnapshot to read
    // the current value.
    //
    // Because we don't actually use the state returned by the useState hook, we
    // can save a bit of memory by storing other stuff in that slot.
    //
    // To implement the early bailout, we need to track some things on a mutable
    // object. Usually, we would put that in a useRef hook, but we can stash it in
    // our useState hook instead.
    //
    // To force a re-render, we call forceUpdate({inst}). That works because the
    // new object always fails an equality check.
    const [{ inst: inst }, forceUpdate] = $2ed817dc54ac40e6$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }); // Track the latest getSnapshot function with a ref. This needs to be updated
    // in the layout phase so we can access it during the tearing check that
    // happens on subscribe.
    $2ed817dc54ac40e6$var$useLayoutEffect(()=>{
        inst.value = value;
        inst.getSnapshot = getSnapshot; // Whenever getSnapshot or subscribe changes, we need to check in the
        // commit phase if there was an interleaved mutation. In concurrent mode
        // this can happen all the time, but even in synchronous mode, an earlier
        // effect may have mutated the store.
        if ($2ed817dc54ac40e6$var$checkIfSnapshotChanged(inst)) // Force a re-render.
        forceUpdate({
            inst: inst
        });
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $2ed817dc54ac40e6$var$useEffect(()=>{
        // Check for changes right before subscribing. Subsequent changes will be
        // detected in the subscription handler.
        if ($2ed817dc54ac40e6$var$checkIfSnapshotChanged(inst)) // Force a re-render.
        forceUpdate({
            inst: inst
        });
        const handleStoreChange = ()=>{
            // TODO: Because there is no cross-renderer API for batching updates, it's
            // up to the consumer of this library to wrap their subscription event
            // with unstable_batchedUpdates. Should we try to detect when this isn't
            // the case and print a warning in development?
            // The store changed. Check if the snapshot changed since the last time we
            // read from the store.
            if ($2ed817dc54ac40e6$var$checkIfSnapshotChanged(inst)) // Force a re-render.
            forceUpdate({
                inst: inst
            });
        }; // Subscribe to the store and return a clean-up function.
        return subscribe(handleStoreChange); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        subscribe
    ]);
    $2ed817dc54ac40e6$var$useDebugValue(value);
    return value;
}
function $2ed817dc54ac40e6$var$checkIfSnapshotChanged(inst) {
    const latestGetSnapshot = inst.getSnapshot;
    const prevValue = inst.value;
    try {
        const nextValue = latestGetSnapshot();
        return !$2ed817dc54ac40e6$var$is(prevValue, nextValue);
    } catch (error) {
        return true;
    }
}
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @flow
 */ function $2ed817dc54ac40e6$var$useSyncExternalStore$1(subscribe, getSnapshot, getServerSnapshot) {
    // Note: The shim does not use getServerSnapshot, because pre-18 versions of
    // React do not expose a way to check if we're hydrating. So users of the shim
    // will need to track that themselves and return the correct value
    // from `getSnapshot`.
    return getSnapshot();
}
/**
 * Inlined into the react-router repo since use-sync-external-store does not
 * provide a UMD-compatible package, so we need this to be able to distribute
 * UMD react-router bundles
 */ const $2ed817dc54ac40e6$var$canUseDOM = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
const $2ed817dc54ac40e6$var$isServerEnvironment = !$2ed817dc54ac40e6$var$canUseDOM;
const $2ed817dc54ac40e6$var$shim = $2ed817dc54ac40e6$var$isServerEnvironment ? $2ed817dc54ac40e6$var$useSyncExternalStore$1 : $2ed817dc54ac40e6$var$useSyncExternalStore$2;
const $2ed817dc54ac40e6$var$useSyncExternalStore = "useSyncExternalStore" in $P551f ? ((module)=>module.useSyncExternalStore)($P551f) : $2ed817dc54ac40e6$var$shim;
const $2ed817dc54ac40e6$export$3add0d5dce533e2e = /*#__PURE__*/ $P551f.createContext(null);
const $2ed817dc54ac40e6$export$145dfa71566a64dc = /*#__PURE__*/ $P551f.createContext(null);
const $2ed817dc54ac40e6$var$AwaitContext = /*#__PURE__*/ $P551f.createContext(null);
const $2ed817dc54ac40e6$export$26749e8557646306 = /*#__PURE__*/ $P551f.createContext(null);
const $2ed817dc54ac40e6$export$c7914228fb69b0f5 = /*#__PURE__*/ $P551f.createContext(null);
const $2ed817dc54ac40e6$export$9072aa6dd1f93057 = /*#__PURE__*/ $P551f.createContext({
    outlet: null,
    matches: []
});
const $2ed817dc54ac40e6$var$RouteErrorContext = /*#__PURE__*/ $P551f.createContext(null);
function $2ed817dc54ac40e6$var$_extends() {
    $2ed817dc54ac40e6$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2ed817dc54ac40e6$var$_extends.apply(this, arguments);
}
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $2ed817dc54ac40e6$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$2ed817dc54ac40e6$export$9c954a9d03d32f4a() && (0, $127365e5ae3fa679$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $P551f.useContext($2ed817dc54ac40e6$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $2ed817dc54ac40e6$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname; // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $127365e5ae3fa679$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a <Router>.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $2ed817dc54ac40e6$export$9c954a9d03d32f4a() {
    return $P551f.useContext($2ed817dc54ac40e6$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $2ed817dc54ac40e6$export$45d76561a5302f2b() {
    !$2ed817dc54ac40e6$export$9c954a9d03d32f4a() && (0, $127365e5ae3fa679$export$3e9cee6b33872309)(false);
    return $P551f.useContext($2ed817dc54ac40e6$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $2ed817dc54ac40e6$export$1b3f31771c5d07c() {
    return $P551f.useContext($2ed817dc54ac40e6$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * <NavLink>.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $2ed817dc54ac40e6$export$6c330e8992e8a295(pattern) {
    !$2ed817dc54ac40e6$export$9c954a9d03d32f4a() && (0, $127365e5ae3fa679$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $2ed817dc54ac40e6$export$45d76561a5302f2b();
    return $P551f.useMemo(()=>(0, $127365e5ae3fa679$export$81336c211d5ff295)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ /**
 * Returns an imperative method for changing the location. Used by <Link>s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $2ed817dc54ac40e6$export$9770f232ac06a008() {
    !$2ed817dc54ac40e6$export$9c954a9d03d32f4a() && (0, $127365e5ae3fa679$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $P551f.useContext($2ed817dc54ac40e6$export$26749e8557646306);
    let { matches: matches } = $P551f.useContext($2ed817dc54ac40e6$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $2ed817dc54ac40e6$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $127365e5ae3fa679$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase));
    let activeRef = $P551f.useRef(false);
    $P551f.useEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $P551f.useCallback(function(to, options) {
        if (options === void 0) options = {};
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $127365e5ae3fa679$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path"); // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history.  If this is a root navigation, then we
        // navigate to the raw basename which allows the basename to have full
        // control over the presence of a trailing slash on root links
        if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $127365e5ae3fa679$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname
    ]);
    return navigate;
}
const $2ed817dc54ac40e6$var$OutletContext = /*#__PURE__*/ $P551f.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $2ed817dc54ac40e6$export$4138103a3ae699cc() {
    return $P551f.useContext($2ed817dc54ac40e6$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by <Outlet> to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $2ed817dc54ac40e6$export$a3be3530d8e40d0b(context) {
    let outlet = $P551f.useContext($2ed817dc54ac40e6$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $P551f.createElement($2ed817dc54ac40e6$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $2ed817dc54ac40e6$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $P551f.useContext($2ed817dc54ac40e6$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $2ed817dc54ac40e6$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { matches: matches } = $P551f.useContext($2ed817dc54ac40e6$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $2ed817dc54ac40e6$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $127365e5ae3fa679$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase));
    return $P551f.useMemo(()=>(0, $127365e5ae3fa679$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an <Outlet> to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $2ed817dc54ac40e6$export$5d3fca4a98652595(routes, locationArg) {
    !$2ed817dc54ac40e6$export$9c954a9d03d32f4a() && (0, $127365e5ae3fa679$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $P551f.useContext($2ed817dc54ac40e6$export$26749e8557646306);
    let dataRouterStateContext = $P551f.useContext($2ed817dc54ac40e6$export$145dfa71566a64dc);
    let { matches: parentMatches } = $P551f.useContext($2ed817dc54ac40e6$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $2ed817dc54ac40e6$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $127365e5ae3fa679$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $127365e5ae3fa679$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
    let matches = (0, $127365e5ae3fa679$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $2ed817dc54ac40e6$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $127365e5ae3fa679$export$86d9a7913e44197e)([
                parentPathnameBase,
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $127365e5ae3fa679$export$86d9a7913e44197e)([
                parentPathnameBase,
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterStateContext || undefined); // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $P551f.createElement($2ed817dc54ac40e6$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $2ed817dc54ac40e6$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $127365e5ae3fa679$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $2ed817dc54ac40e6$var$DefaultErrorComponent() {
    let error = $2ed817dc54ac40e6$export$ed527bf60f6e05f2();
    let message = (0, $127365e5ae3fa679$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $P551f.createElement($P551f.Fragment, null, /*#__PURE__*/ $P551f.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $P551f.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $P551f.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
class $2ed817dc54ac40e6$var$RenderErrorBoundary extends $P551f.Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location) return {
            error: props.error,
            location: props.location
        };
         // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error || state.error,
            location: state.location
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error ? /*#__PURE__*/ $P551f.createElement($2ed817dc54ac40e6$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $P551f.createElement($2ed817dc54ac40e6$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            error: props.error
        };
    }
}
function $2ed817dc54ac40e6$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $P551f.useContext($2ed817dc54ac40e6$export$3add0d5dce533e2e); // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $P551f.createElement($2ed817dc54ac40e6$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $2ed817dc54ac40e6$var$_renderMatches(matches, parentMatches, dataRouterState) {
    if (parentMatches === void 0) parentMatches = [];
    if (matches == null) {
        if (dataRouterState != null && dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches; // If we have data errors, trim matches to the highest error boundary
    let errors = dataRouterState == null ? void 0 : dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, $127365e5ae3fa679$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error = match.route.id ? errors == null ? void 0 : errors[match.route.id] : null; // Only data routers handle errors
        let errorElement = null;
        if (dataRouterState) {
            if (match.route.ErrorBoundary) errorElement = /*#__PURE__*/ $P551f.createElement(match.route.ErrorBoundary, null);
            else if (match.route.errorElement) errorElement = match.route.errorElement;
            else errorElement = /*#__PURE__*/ $P551f.createElement($2ed817dc54ac40e6$var$DefaultErrorComponent, null);
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children = outlet;
            if (error) children = errorElement;
            else if (match.route.Component) children = /*#__PURE__*/ $P551f.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            return /*#__PURE__*/ $P551f.createElement($2ed817dc54ac40e6$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches
                },
                children: children
            });
        }; // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $P551f.createElement($2ed817dc54ac40e6$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches
            }
        }) : getChildren();
    }, null);
}
var $2ed817dc54ac40e6$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
})($2ed817dc54ac40e6$var$DataRouterHook || ($2ed817dc54ac40e6$var$DataRouterHook = {}));
var $2ed817dc54ac40e6$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
})($2ed817dc54ac40e6$var$DataRouterStateHook || ($2ed817dc54ac40e6$var$DataRouterStateHook = {}));
function $2ed817dc54ac40e6$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $2ed817dc54ac40e6$var$useDataRouterContext(hookName) {
    let ctx = $P551f.useContext($2ed817dc54ac40e6$export$3add0d5dce533e2e);
    !ctx && (0, $127365e5ae3fa679$export$3e9cee6b33872309)(false);
    return ctx;
}
function $2ed817dc54ac40e6$var$useDataRouterState(hookName) {
    let state = $P551f.useContext($2ed817dc54ac40e6$export$145dfa71566a64dc);
    !state && (0, $127365e5ae3fa679$export$3e9cee6b33872309)(false);
    return state;
}
function $2ed817dc54ac40e6$var$useRouteContext(hookName) {
    let route = $P551f.useContext($2ed817dc54ac40e6$export$9072aa6dd1f93057);
    !route && (0, $127365e5ae3fa679$export$3e9cee6b33872309)(false);
    return route;
}
function $2ed817dc54ac40e6$var$useCurrentRouteId(hookName) {
    let route = $2ed817dc54ac40e6$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $127365e5ae3fa679$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $2ed817dc54ac40e6$export$d0fd4b7106de2769() {
    let state = $2ed817dc54ac40e6$var$useDataRouterState($2ed817dc54ac40e6$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $2ed817dc54ac40e6$export$600dc272ed516c15() {
    let dataRouterContext = $2ed817dc54ac40e6$var$useDataRouterContext($2ed817dc54ac40e6$var$DataRouterHook.UseRevalidator);
    let state = $2ed817dc54ac40e6$var$useDataRouterState($2ed817dc54ac40e6$var$DataRouterStateHook.UseRevalidator);
    return {
        revalidate: dataRouterContext.router.revalidate,
        state: state.revalidation
    };
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $2ed817dc54ac40e6$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $2ed817dc54ac40e6$var$useDataRouterState($2ed817dc54ac40e6$var$DataRouterStateHook.UseMatches);
    return $P551f.useMemo(()=>matches.map((match)=>{
            let { pathname: pathname, params: params } = match; // Note: This structure matches that created by createUseMatchesMatch
            // in the @remix-run/router , so if you change this please also change
            // that :)  Eventually we'll DRY this up
            return {
                id: match.route.id,
                pathname: pathname,
                params: params,
                data: loaderData[match.route.id],
                handle: match.route.handle
            };
        }), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $2ed817dc54ac40e6$export$1448a5050d252c4d() {
    let state = $2ed817dc54ac40e6$var$useDataRouterState($2ed817dc54ac40e6$var$DataRouterStateHook.UseLoaderData);
    let routeId = $2ed817dc54ac40e6$var$useCurrentRouteId($2ed817dc54ac40e6$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $2ed817dc54ac40e6$export$fd5d37484eab868d(routeId) {
    let state = $2ed817dc54ac40e6$var$useDataRouterState($2ed817dc54ac40e6$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $2ed817dc54ac40e6$export$fdc00f3f26066d5e() {
    let state = $2ed817dc54ac40e6$var$useDataRouterState($2ed817dc54ac40e6$var$DataRouterStateHook.UseActionData);
    let route = $P551f.useContext($2ed817dc54ac40e6$export$9072aa6dd1f93057);
    !route && (0, $127365e5ae3fa679$export$3e9cee6b33872309)(false);
    return Object.values((state == null ? void 0 : state.actionData) || {})[0];
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $2ed817dc54ac40e6$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $P551f.useContext($2ed817dc54ac40e6$var$RouteErrorContext);
    let state = $2ed817dc54ac40e6$var$useDataRouterState($2ed817dc54ac40e6$var$DataRouterStateHook.UseRouteError);
    let routeId = $2ed817dc54ac40e6$var$useCurrentRouteId($2ed817dc54ac40e6$var$DataRouterStateHook.UseRouteError); // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error) return error;
     // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor <Await /> value
 */ function $2ed817dc54ac40e6$export$78a72ddb39bdd145() {
    let value = $P551f.useContext($2ed817dc54ac40e6$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor <Await /> value
 */ function $2ed817dc54ac40e6$export$17f53340677d5831() {
    let value = $P551f.useContext($2ed817dc54ac40e6$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $2ed817dc54ac40e6$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $2ed817dc54ac40e6$export$2af03a1de5c0910(shouldBlock) {
    let { router: router } = $2ed817dc54ac40e6$var$useDataRouterContext($2ed817dc54ac40e6$var$DataRouterHook.UseBlocker);
    let state = $2ed817dc54ac40e6$var$useDataRouterState($2ed817dc54ac40e6$var$DataRouterStateHook.UseBlocker);
    let [blockerKey] = $P551f.useState(()=>String(++$2ed817dc54ac40e6$var$blockerId));
    let blockerFunction = $P551f.useCallback((args)=>{
        return typeof shouldBlock === "function" ? !!shouldBlock(args) : !!shouldBlock;
    }, [
        shouldBlock
    ]);
    let blocker = router.getBlocker(blockerKey, blockerFunction); // Cleanup on unmount
    $P551f.useEffect(()=>()=>router.deleteBlocker(blockerKey), [
        router,
        blockerKey
    ]); // Prefer the blocker from state since DataRouterContext is memoized so this
    // ensures we update on blocker state updates
    return state.blockers.get(blockerKey) || blocker;
}
const $2ed817dc54ac40e6$var$alreadyWarned = {};
function $2ed817dc54ac40e6$var$warningOnce(key, cond, message) {
    if (!cond && !$2ed817dc54ac40e6$var$alreadyWarned[key]) $2ed817dc54ac40e6$var$alreadyWarned[key] = true;
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $2ed817dc54ac40e6$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router } = _ref;
    let getState = $P551f.useCallback(()=>router.state, [
        router
    ]); // Sync router state to our component state to force re-renders
    let state = $2ed817dc54ac40e6$var$useSyncExternalStore(router.subscribe, getState, // but we pass our serialized hydration data into the router so state here
    // is already synced with what the server saw
    getState);
    let navigator = $P551f.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $P551f.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]); // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $P551f.createElement($P551f.Fragment, null, /*#__PURE__*/ $P551f.createElement($2ed817dc54ac40e6$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $P551f.createElement($2ed817dc54ac40e6$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $P551f.createElement($2ed817dc54ac40e6$export$55185c17a0fcbe46, {
        basename: router.basename,
        location: router.state.location,
        navigationType: router.state.historyAction,
        navigator: navigator
    }, router.state.initialized ? /*#__PURE__*/ $P551f.createElement($2ed817dc54ac40e6$export$3565eb3d00ca5a74, null) : fallbackElement))), null);
}
/**
 * A <Router> that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $2ed817dc54ac40e6$export$ae46f04cfaffe093(_ref2) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex } = _ref2;
    let historyRef = $P551f.useRef();
    if (historyRef.current == null) historyRef.current = (0, $127365e5ae3fa679$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setState] = $P551f.useState({
        action: history.action,
        location: history.location
    });
    $P551f.useLayoutEffect(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ $P551f.createElement($2ed817dc54ac40e6$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $2ed817dc54ac40e6$export$444b3ab0cb9aec40(_ref3) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref3;
    !$2ed817dc54ac40e6$export$9c954a9d03d32f4a() && (0, $127365e5ae3fa679$export$3e9cee6b33872309)(false);
    let dataRouterState = $P551f.useContext($2ed817dc54ac40e6$export$145dfa71566a64dc);
    let navigate = $2ed817dc54ac40e6$export$9770f232ac06a008();
    $P551f.useEffect(()=>{
        // Avoid kicking off multiple navigations if we're in the middle of a
        // data-router navigation, since components get re-rendered when we enter
        // a submitting/loading state
        if (dataRouterState && dataRouterState.navigation.state !== "idle") return;
        navigate(to, {
            replace: replace,
            state: state,
            relative: relative
        });
    });
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $2ed817dc54ac40e6$export$910ae8079b2c2852(props) {
    return $2ed817dc54ac40e6$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $2ed817dc54ac40e6$export$e7b0ac011bb776c6(_props) {
    (0, $127365e5ae3fa679$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a <Router> directly. Instead, you'll render a
 * router that is more specific to your environment such as a <BrowserRouter>
 * in web browsers or a <StaticRouter> for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $2ed817dc54ac40e6$export$55185c17a0fcbe46(_ref4) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $127365e5ae3fa679$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false } = _ref4;
    !!$2ed817dc54ac40e6$export$9c954a9d03d32f4a() && (0, $127365e5ae3fa679$export$3e9cee6b33872309)(false); // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $P551f.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp
        }), [
        basename,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $127365e5ae3fa679$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $P551f.useMemo(()=>{
        let trailingPathname = (0, $127365e5ae3fa679$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $P551f.createElement($2ed817dc54ac40e6$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $P551f.createElement($2ed817dc54ac40e6$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of <Route> elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $2ed817dc54ac40e6$export$3565eb3d00ca5a74(_ref5) {
    let { children: children, location: location } = _ref5;
    let dataRouterContext = $P551f.useContext($2ed817dc54ac40e6$export$3add0d5dce533e2e); // When in a DataRouterContext _without_ children, we use the router routes
    // directly.  If we have children, then we're in a descendant tree and we
    // need to use child routes.
    let routes = dataRouterContext && !children ? dataRouterContext.router.routes : $2ed817dc54ac40e6$export$16da398f5434bdec(children);
    return $2ed817dc54ac40e6$export$5d3fca4a98652595(routes, location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $2ed817dc54ac40e6$export$6ddabde395c8c576(_ref6) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref6;
    return /*#__PURE__*/ $P551f.createElement($2ed817dc54ac40e6$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $P551f.createElement($2ed817dc54ac40e6$var$ResolveAwait, null, children));
}
var $2ed817dc54ac40e6$var$AwaitRenderStatus;
(function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
})($2ed817dc54ac40e6$var$AwaitRenderStatus || ($2ed817dc54ac40e6$var$AwaitRenderStatus = {}));
const $2ed817dc54ac40e6$var$neverSettledPromise = new Promise(()=>{});
class $2ed817dc54ac40e6$var$AwaitErrorBoundary extends $P551f.Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $2ed817dc54ac40e6$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $2ed817dc54ac40e6$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $2ed817dc54ac40e6$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $2ed817dc54ac40e6$var$AwaitRenderStatus.error : promise._data !== undefined ? $2ed817dc54ac40e6$var$AwaitRenderStatus.success : $2ed817dc54ac40e6$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $2ed817dc54ac40e6$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $2ed817dc54ac40e6$var$AwaitRenderStatus.error && promise._error instanceof (0, $127365e5ae3fa679$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $2ed817dc54ac40e6$var$neverSettledPromise;
        if (status === $2ed817dc54ac40e6$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $2ed817dc54ac40e6$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $P551f.createElement($2ed817dc54ac40e6$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $2ed817dc54ac40e6$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $P551f.createElement($2ed817dc54ac40e6$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
         // Throw to the suspense boundary
        throw promise;
    }
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on <Await>
 */ function $2ed817dc54ac40e6$var$ResolveAwait(_ref7) {
    let { children: children } = _ref7;
    let data = $2ed817dc54ac40e6$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $P551f.createElement($P551f.Fragment, null, toRender);
} ///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $2ed817dc54ac40e6$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $P551f.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $P551f.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $P551f.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $2ed817dc54ac40e6$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $2ed817dc54ac40e6$export$e7b0ac011bb776c6) && (0, $127365e5ae3fa679$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $127365e5ae3fa679$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $2ed817dc54ac40e6$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $2ed817dc54ac40e6$export$daf73786167a7f72(matches) {
    return $2ed817dc54ac40e6$var$_renderMatches(matches);
}
function $2ed817dc54ac40e6$export$48907b48b599f040(route) {
    // there if you change this
    return Boolean(route.ErrorBoundary) || Boolean(route.errorElement);
}
function $2ed817dc54ac40e6$export$f30f7e456d254e83(routes, opts) {
    return (0, $127365e5ae3fa679$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: opts == null ? void 0 : opts.future,
        history: (0, $127365e5ae3fa679$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        detectErrorBoundary: $2ed817dc54ac40e6$export$48907b48b599f040
    }).initialize();
} ///////////////////////////////////////////////////////////////////////////////



function $efe29403354254eb$var$_extends() {
    $efe29403354254eb$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $efe29403354254eb$var$_extends.apply(this, arguments);
}
function $efe29403354254eb$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $efe29403354254eb$var$defaultMethod = "get";
const $efe29403354254eb$var$defaultEncType = "application/x-www-form-urlencoded";
function $efe29403354254eb$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $efe29403354254eb$var$isButtonElement(object) {
    return $efe29403354254eb$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $efe29403354254eb$var$isFormElement(object) {
    return $efe29403354254eb$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $efe29403354254eb$var$isInputElement(object) {
    return $efe29403354254eb$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $efe29403354254eb$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $efe29403354254eb$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$efe29403354254eb$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $efe29403354254eb$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $efe29403354254eb$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $efe29403354254eb$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) {
        for (let key of defaultSearchParams.keys())if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    }
    return searchParams;
}
function $efe29403354254eb$var$getFormSubmissionInfo(target, defaultAction, options) {
    let method;
    let action;
    let encType;
    let formData;
    if ($efe29403354254eb$var$isFormElement(target)) {
        let submissionTrigger = options.submissionTrigger;
        method = options.method || target.getAttribute("method") || $efe29403354254eb$var$defaultMethod;
        action = options.action || target.getAttribute("action") || defaultAction;
        encType = options.encType || target.getAttribute("enctype") || $efe29403354254eb$var$defaultEncType;
        formData = new FormData(target);
        if (submissionTrigger && submissionTrigger.name) formData.append(submissionTrigger.name, submissionTrigger.value);
    } else if ($efe29403354254eb$var$isButtonElement(target) || $efe29403354254eb$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
         // <button>/<input type="submit"> may override attributes of <form>
        method = options.method || target.getAttribute("formmethod") || form.getAttribute("method") || $efe29403354254eb$var$defaultMethod;
        action = options.action || target.getAttribute("formaction") || form.getAttribute("action") || defaultAction;
        encType = options.encType || target.getAttribute("formenctype") || form.getAttribute("enctype") || $efe29403354254eb$var$defaultEncType;
        formData = new FormData(form); // Include name + value from a <button>, appending in case the button name
        // matches an existing input name
        if (target.name) formData.append(target.name, target.value);
    } else if ($efe29403354254eb$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = options.method || $efe29403354254eb$var$defaultMethod;
        action = options.action || defaultAction;
        encType = options.encType || $efe29403354254eb$var$defaultEncType;
        if (target instanceof FormData) formData = target;
        else {
            formData = new FormData();
            if (target instanceof URLSearchParams) for (let [name, value] of target)formData.append(name, value);
            else if (target != null) for (let name of Object.keys(target))formData.append(name, target[name]);
        }
    }
    let { protocol: protocol, host: host } = window.location;
    let url = new URL(action, protocol + "//" + host);
    return {
        url: url,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData
    };
}
const $efe29403354254eb$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset"
], $efe29403354254eb$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "children"
], $efe29403354254eb$var$_excluded3 = [
    "reloadDocument",
    "replace",
    "method",
    "action",
    "onSubmit",
    "fetcherKey",
    "routeId",
    "relative",
    "preventScrollReset"
];
function $efe29403354254eb$export$1f3f55432a00e06d(routes, opts) {
    return (0, $127365e5ae3fa679$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: opts == null ? void 0 : opts.future,
        history: (0, $127365e5ae3fa679$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $efe29403354254eb$var$parseHydrationData(),
        routes: routes,
        detectErrorBoundary: (0, $2ed817dc54ac40e6$export$48907b48b599f040)
    }).initialize();
}
function $efe29403354254eb$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $127365e5ae3fa679$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: opts == null ? void 0 : opts.future,
        history: (0, $127365e5ae3fa679$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $efe29403354254eb$var$parseHydrationData(),
        routes: routes,
        detectErrorBoundary: (0, $2ed817dc54ac40e6$export$48907b48b599f040)
    }).initialize();
}
function $efe29403354254eb$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $efe29403354254eb$var$_extends({}, state, {
        errors: $efe29403354254eb$var$deserializeErrors(state.errors)
    });
    return state;
}
function $efe29403354254eb$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $127365e5ae3fa679$export$acf1a680051f5031)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            let error = new Error(val.message); // Wipe away the client-side stack trace.  Nothing to fill it in with
            // because we don't serialize SSR stack traces for security reasons
            error.stack = "";
            serialized[key] = error;
        } else serialized[key] = val;
    }
    return serialized;
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $efe29403354254eb$export$9ba4e89fdfa1fc54(_ref) {
    let { basename: basename, children: children, window: window1 } = _ref;
    let historyRef = $P551f.useRef();
    if (historyRef.current == null) historyRef.current = (0, $127365e5ae3fa679$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setState] = $P551f.useState({
        action: history.action,
        location: history.location
    });
    $P551f.useLayoutEffect(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ $P551f.createElement((0, $2ed817dc54ac40e6$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $efe29403354254eb$export$7221d69dcfc8e36b(_ref2) {
    let { basename: basename, children: children, window: window1 } = _ref2;
    let historyRef = $P551f.useRef();
    if (historyRef.current == null) historyRef.current = (0, $127365e5ae3fa679$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setState] = $P551f.useState({
        action: history.action,
        location: history.location
    });
    $P551f.useLayoutEffect(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ $P551f.createElement((0, $2ed817dc54ac40e6$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $efe29403354254eb$export$eefb0c834599897e(_ref3) {
    let { basename: basename, children: children, history: history } = _ref3;
    const [state, setState] = $P551f.useState({
        action: history.action,
        location: history.location
    });
    $P551f.useLayoutEffect(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ $P551f.createElement((0, $2ed817dc54ac40e6$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
const $efe29403354254eb$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $efe29403354254eb$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware <a>.
 */ const $efe29403354254eb$export$a6c7ac8248d6e38a = /*#__PURE__*/ $P551f.forwardRef(function LinkWithRef(_ref4, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset } = _ref4, rest = $efe29403354254eb$var$_objectWithoutPropertiesLoose(_ref4, $efe29403354254eb$var$_excluded);
    let { basename: basename } = $P551f.useContext((0, $2ed817dc54ac40e6$export$26749e8557646306)); // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $efe29403354254eb$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to; // Only check for external origins client-side
        if ($efe29403354254eb$var$isBrowser) {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $127365e5ae3fa679$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        }
    } // Rendered into <a href> for relative URLs
    let href = (0, $2ed817dc54ac40e6$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $efe29403354254eb$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $P551f.createElement("a", $efe29403354254eb$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ const $efe29403354254eb$export$b0d92dbee9b5b60d = /*#__PURE__*/ $P551f.forwardRef(function NavLinkWithRef(_ref5, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, children: children } = _ref5, rest = $efe29403354254eb$var$_objectWithoutPropertiesLoose(_ref5, $efe29403354254eb$var$_excluded2);
    let path = (0, $2ed817dc54ac40e6$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $2ed817dc54ac40e6$export$45d76561a5302f2b)();
    let routerState = $P551f.useContext((0, $2ed817dc54ac40e6$export$145dfa71566a64dc));
    let { navigator: navigator } = $P551f.useContext((0, $2ed817dc54ac40e6$export$26749e8557646306));
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(toPathname.length) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp({
        isActive: isActive,
        isPending: isPending
    });
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp({
        isActive: isActive,
        isPending: isPending
    }) : styleProp;
    return /*#__PURE__*/ $P551f.createElement($efe29403354254eb$export$a6c7ac8248d6e38a, $efe29403354254eb$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to
    }), typeof children === "function" ? children({
        isActive: isActive,
        isPending: isPending
    }) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $efe29403354254eb$export$a7fed597f4b8afd8 = /*#__PURE__*/ $P551f.forwardRef((props, ref)=>{
    return /*#__PURE__*/ $P551f.createElement($efe29403354254eb$var$FormImpl, $efe29403354254eb$var$_extends({}, props, {
        ref: ref
    }));
});
const $efe29403354254eb$var$FormImpl = /*#__PURE__*/ $P551f.forwardRef((_ref6, forwardedRef)=>{
    let { reloadDocument: reloadDocument, replace: replace, method: method = $efe29403354254eb$var$defaultMethod, action: action, onSubmit: onSubmit, fetcherKey: fetcherKey, routeId: routeId, relative: relative, preventScrollReset: preventScrollReset } = _ref6, props = $efe29403354254eb$var$_objectWithoutPropertiesLoose(_ref6, $efe29403354254eb$var$_excluded3);
    let submit = $efe29403354254eb$var$useSubmitImpl(fetcherKey, routeId);
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let formAction = $efe29403354254eb$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            method: submitMethod,
            replace: replace,
            relative: relative,
            preventScrollReset: preventScrollReset
        });
    };
    return /*#__PURE__*/ $P551f.createElement("form", $efe29403354254eb$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $efe29403354254eb$export$11aac1aab828f1fa(_ref7) {
    let { getKey: getKey, storageKey: storageKey } = _ref7;
    $efe29403354254eb$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $efe29403354254eb$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmitImpl"] = "useSubmitImpl";
    DataRouterHook["UseFetcher"] = "useFetcher";
})($efe29403354254eb$var$DataRouterHook || ($efe29403354254eb$var$DataRouterHook = {}));
var $efe29403354254eb$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($efe29403354254eb$var$DataRouterStateHook || ($efe29403354254eb$var$DataRouterStateHook = {}));
function $efe29403354254eb$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $efe29403354254eb$var$useDataRouterContext(hookName) {
    let ctx = $P551f.useContext((0, $2ed817dc54ac40e6$export$3add0d5dce533e2e));
    !ctx && (0, $127365e5ae3fa679$export$3e9cee6b33872309)(false);
    return ctx;
}
function $efe29403354254eb$var$useDataRouterState(hookName) {
    let state = $P551f.useContext((0, $2ed817dc54ac40e6$export$145dfa71566a64dc));
    !state && (0, $127365e5ae3fa679$export$3e9cee6b33872309)(false);
    return state;
}
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $efe29403354254eb$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $2ed817dc54ac40e6$export$9770f232ac06a008)();
    let location = (0, $2ed817dc54ac40e6$export$45d76561a5302f2b)();
    let path = (0, $2ed817dc54ac40e6$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $P551f.useCallback((event)=>{
        if ($efe29403354254eb$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault(); // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $127365e5ae3fa679$export$fe53371bee54353d)(location) === (0, $127365e5ae3fa679$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $efe29403354254eb$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $P551f.useRef($efe29403354254eb$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $P551f.useRef(false);
    let location = (0, $2ed817dc54ac40e6$export$45d76561a5302f2b)();
    let searchParams = $P551f.useMemo(()=>// Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $efe29403354254eb$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $2ed817dc54ac40e6$export$9770f232ac06a008)();
    let setSearchParams = $P551f.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $efe29403354254eb$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $efe29403354254eb$export$47c85c6e3a081d3() {
    return $efe29403354254eb$var$useSubmitImpl();
}
function $efe29403354254eb$var$useSubmitImpl(fetcherKey, routeId) {
    let { router: router } = $efe29403354254eb$var$useDataRouterContext($efe29403354254eb$var$DataRouterHook.UseSubmitImpl);
    let defaultAction = $efe29403354254eb$export$89a6bd6db0d97c56();
    return $P551f.useCallback(function(target, options) {
        if (options === void 0) options = {};
        if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
        let { method: method, encType: encType, formData: formData, url: url } = $efe29403354254eb$var$getFormSubmissionInfo(target, defaultAction, options);
        let href = url.pathname + url.search;
        let opts = {
            replace: options.replace,
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            formMethod: method,
            formEncType: encType
        };
        if (fetcherKey) {
            !(routeId != null) && (0, $127365e5ae3fa679$export$3e9cee6b33872309)(false);
            router.fetch(fetcherKey, routeId, href, opts);
        } else router.navigate(href, opts);
    }, [
        defaultAction,
        router,
        fetcherKey,
        routeId
    ]);
}
function $efe29403354254eb$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $P551f.useContext((0, $2ed817dc54ac40e6$export$26749e8557646306));
    let routeContext = $P551f.useContext((0, $2ed817dc54ac40e6$export$9072aa6dd1f93057));
    !routeContext && (0, $127365e5ae3fa679$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1); // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $efe29403354254eb$var$_extends({}, (0, $2ed817dc54ac40e6$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    })); // Previously we set the default action to ".". The problem with this is that
    // `useResolvedPath(".")` excludes search params and the hash of the resolved
    // URL. This is the intended behavior of when "." is specifically provided as
    // the form action, but inconsistent w/ browsers when the action is omitted.
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $2ed817dc54ac40e6$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to these directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        // or hash
        path.search = location.search;
        path.hash = location.hash; // When grabbing search params from the URL, remove the automatically
        // inserted ?index param so we match the useResolvedPath search behavior
        // which would not include ?index
        if (match.route.index) {
            let params = new URLSearchParams(path.search);
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
     // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $127365e5ae3fa679$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $127365e5ae3fa679$export$fe53371bee54353d)(path);
}
function $efe29403354254eb$var$createFetcherForm(fetcherKey, routeId) {
    let FetcherForm = /*#__PURE__*/ $P551f.forwardRef((props, ref)=>{
        return /*#__PURE__*/ $P551f.createElement($efe29403354254eb$var$FormImpl, $efe29403354254eb$var$_extends({}, props, {
            ref: ref,
            fetcherKey: fetcherKey,
            routeId: routeId
        }));
    });
    return FetcherForm;
}
let $efe29403354254eb$var$fetcherId = 0;
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $efe29403354254eb$export$5b0d2d9a9921565a() {
    var _route$matches;
    let { router: router } = $efe29403354254eb$var$useDataRouterContext($efe29403354254eb$var$DataRouterHook.UseFetcher);
    let route = $P551f.useContext((0, $2ed817dc54ac40e6$export$9072aa6dd1f93057));
    !route && (0, $127365e5ae3fa679$export$3e9cee6b33872309)(false);
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !(routeId != null) && (0, $127365e5ae3fa679$export$3e9cee6b33872309)(false);
    let [fetcherKey] = $P551f.useState(()=>String(++$efe29403354254eb$var$fetcherId));
    let [Form] = $P551f.useState(()=>{
        !routeId && (0, $127365e5ae3fa679$export$3e9cee6b33872309)(false);
        return $efe29403354254eb$var$createFetcherForm(fetcherKey, routeId);
    });
    let [load] = $P551f.useState(()=>(href)=>{
            !router && (0, $127365e5ae3fa679$export$3e9cee6b33872309)(false);
            !routeId && (0, $127365e5ae3fa679$export$3e9cee6b33872309)(false);
            router.fetch(fetcherKey, routeId, href);
        });
    let submit = $efe29403354254eb$var$useSubmitImpl(fetcherKey, routeId);
    let fetcher = router.getFetcher(fetcherKey);
    let fetcherWithComponents = $P551f.useMemo(()=>$efe29403354254eb$var$_extends({
            Form: Form,
            submit: submit,
            load: load
        }, fetcher), [
        fetcher,
        Form,
        submit,
        load
    ]);
    $P551f.useEffect(()=>{
        // Is this busted when the React team gets real weird and calls effects
        // twice on mount?  We really just need to garbage collect here when this
        // fetcher is no longer around.
        return ()=>{
            if (!router) {
                console.warn("No fetcher available to clean up from useFetcher()");
                return;
            }
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $efe29403354254eb$export$fa996778a3a31087() {
    let state = $efe29403354254eb$var$useDataRouterState($efe29403354254eb$var$DataRouterStateHook.UseFetchers);
    return [
        ...state.fetchers.values()
    ];
}
const $efe29403354254eb$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $efe29403354254eb$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $efe29403354254eb$export$25057cfe5591e3e9(_temp3) {
    let { getKey: getKey, storageKey: storageKey } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $efe29403354254eb$var$useDataRouterContext($efe29403354254eb$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $efe29403354254eb$var$useDataRouterState($efe29403354254eb$var$DataRouterStateHook.UseScrollRestoration);
    let location = (0, $2ed817dc54ac40e6$export$45d76561a5302f2b)();
    let matches = (0, $2ed817dc54ac40e6$export$2378eb7f5ff86053)();
    let navigation = (0, $2ed817dc54ac40e6$export$d0fd4b7106de2769)(); // Trigger manual scroll restoration while we're active
    $P551f.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []); // Save positions on pagehide
    $efe29403354254eb$var$usePageHide($P551f.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $efe29403354254eb$var$savedScrollPositions[key] = window.scrollY;
        }
        sessionStorage.setItem(storageKey || $efe29403354254eb$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($efe29403354254eb$var$savedScrollPositions));
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ])); // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $P551f.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $efe29403354254eb$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $efe29403354254eb$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {}
        }, [
            storageKey
        ]); // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $P551f.useLayoutEffect(()=>{
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($efe29403354254eb$var$savedScrollPositions, ()=>window.scrollY, getKey);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            getKey
        ]); // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $P551f.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
             // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            } // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(location.hash.slice(1));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            } // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
             // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $efe29403354254eb$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $P551f.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $efe29403354254eb$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $P551f.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $efe29403354254eb$export$39f4eb3dbd812741(_ref8) {
    let { when: when, message: message } = _ref8;
    let blocker = (0, $2ed817dc54ac40e6$export$2af03a1de5c0910)(when);
    $P551f.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
    $P551f.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
}



var $a6f0144cf2b2d456$exports = {};
/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = [];
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (!arg) continue;
            var argType = typeof arg;
            if (argType === "string" || argType === "number") classes.push(arg);
            else if (Array.isArray(arg)) {
                if (arg.length) {
                    var inner = classNames.apply(null, arg);
                    if (inner) classes.push(inner);
                }
            } else if (argType === "object") {
                if (arg.toString === Object.prototype.toString) {
                    for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
                } else classes.push(arg.toString());
            }
        }
        return classes.join(" ");
    }
    if (0, $a6f0144cf2b2d456$exports) {
        classNames.default = classNames;
        $a6f0144cf2b2d456$exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();






var $P551f = parcelRequire("P551f");



var $P551f = parcelRequire("P551f");
var $3152f4b5b57c36cc$exports = {};
"use strict";
Object.defineProperty($3152f4b5b57c36cc$exports, "__esModule", {
    value: true
});
function $3152f4b5b57c36cc$var$_interopDefault(ex) {
    return ex && typeof ex === "object" && "default" in ex ? ex["default"] : ex;
}

var $P551f = parcelRequire("P551f");
var $3152f4b5b57c36cc$var$React__default = $3152f4b5b57c36cc$var$_interopDefault($P551f);

var $e8aIO = parcelRequire("e8aIO");
var $3152f4b5b57c36cc$var$ClientUAInstance = new $e8aIO();
var $3152f4b5b57c36cc$var$browser = $3152f4b5b57c36cc$var$ClientUAInstance.getBrowser();
var $3152f4b5b57c36cc$var$cpu = $3152f4b5b57c36cc$var$ClientUAInstance.getCPU();
var $3152f4b5b57c36cc$var$device = $3152f4b5b57c36cc$var$ClientUAInstance.getDevice();
var $3152f4b5b57c36cc$var$engine = $3152f4b5b57c36cc$var$ClientUAInstance.getEngine();
var $3152f4b5b57c36cc$var$os = $3152f4b5b57c36cc$var$ClientUAInstance.getOS();
var $3152f4b5b57c36cc$var$ua = $3152f4b5b57c36cc$var$ClientUAInstance.getUA();
var $3152f4b5b57c36cc$var$setUa = function setUa(userAgentString) {
    return $3152f4b5b57c36cc$var$ClientUAInstance.setUA(userAgentString);
};
var $3152f4b5b57c36cc$var$parseUserAgent = function parseUserAgent(userAgent) {
    if (!userAgent) {
        console.error("No userAgent string was provided");
        return;
    }
    var UserAgentInstance = new $e8aIO(userAgent);
    return {
        UA: UserAgentInstance,
        browser: UserAgentInstance.getBrowser(),
        cpu: UserAgentInstance.getCPU(),
        device: UserAgentInstance.getDevice(),
        engine: UserAgentInstance.getEngine(),
        os: UserAgentInstance.getOS(),
        ua: UserAgentInstance.getUA(),
        setUserAgent: function setUserAgent(userAgentString) {
            return UserAgentInstance.setUA(userAgentString);
        }
    };
};
var $3152f4b5b57c36cc$var$UAHelper = /*#__PURE__*/ Object.freeze({
    ClientUAInstance: $3152f4b5b57c36cc$var$ClientUAInstance,
    browser: $3152f4b5b57c36cc$var$browser,
    cpu: $3152f4b5b57c36cc$var$cpu,
    device: $3152f4b5b57c36cc$var$device,
    engine: $3152f4b5b57c36cc$var$engine,
    os: $3152f4b5b57c36cc$var$os,
    ua: $3152f4b5b57c36cc$var$ua,
    setUa: $3152f4b5b57c36cc$var$setUa,
    parseUserAgent: $3152f4b5b57c36cc$var$parseUserAgent
});
function $3152f4b5b57c36cc$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $3152f4b5b57c36cc$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $3152f4b5b57c36cc$var$ownKeys(Object(source), true).forEach(function(key) {
            $3152f4b5b57c36cc$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $3152f4b5b57c36cc$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $3152f4b5b57c36cc$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $3152f4b5b57c36cc$var$_typeof = function(obj) {
        return typeof obj;
    };
    else $3152f4b5b57c36cc$var$_typeof = function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $3152f4b5b57c36cc$var$_typeof(obj);
}
function $3152f4b5b57c36cc$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $3152f4b5b57c36cc$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $3152f4b5b57c36cc$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $3152f4b5b57c36cc$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $3152f4b5b57c36cc$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $3152f4b5b57c36cc$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3152f4b5b57c36cc$var$_extends() {
    $3152f4b5b57c36cc$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3152f4b5b57c36cc$var$_extends.apply(this, arguments);
}
function $3152f4b5b57c36cc$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $3152f4b5b57c36cc$var$_setPrototypeOf(subClass, superClass);
}
function $3152f4b5b57c36cc$var$_getPrototypeOf(o) {
    $3152f4b5b57c36cc$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $3152f4b5b57c36cc$var$_getPrototypeOf(o);
}
function $3152f4b5b57c36cc$var$_setPrototypeOf(o, p) {
    $3152f4b5b57c36cc$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $3152f4b5b57c36cc$var$_setPrototypeOf(o, p);
}
function $3152f4b5b57c36cc$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $3152f4b5b57c36cc$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $3152f4b5b57c36cc$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $3152f4b5b57c36cc$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $3152f4b5b57c36cc$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $3152f4b5b57c36cc$var$_assertThisInitialized(self);
}
function $3152f4b5b57c36cc$var$_slicedToArray(arr, i) {
    return $3152f4b5b57c36cc$var$_arrayWithHoles(arr) || $3152f4b5b57c36cc$var$_iterableToArrayLimit(arr, i) || $3152f4b5b57c36cc$var$_unsupportedIterableToArray(arr, i) || $3152f4b5b57c36cc$var$_nonIterableRest();
}
function $3152f4b5b57c36cc$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $3152f4b5b57c36cc$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $3152f4b5b57c36cc$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $3152f4b5b57c36cc$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $3152f4b5b57c36cc$var$_arrayLikeToArray(o, minLen);
}
function $3152f4b5b57c36cc$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $3152f4b5b57c36cc$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var $3152f4b5b57c36cc$var$DeviceTypes = {
    Mobile: "mobile",
    Tablet: "tablet",
    SmartTv: "smarttv",
    Console: "console",
    Wearable: "wearable",
    Embedded: "embedded",
    Browser: undefined
};
var $3152f4b5b57c36cc$var$BrowserTypes = {
    Chrome: "Chrome",
    Firefox: "Firefox",
    Opera: "Opera",
    Yandex: "Yandex",
    Safari: "Safari",
    InternetExplorer: "Internet Explorer",
    Edge: "Edge",
    Chromium: "Chromium",
    Ie: "IE",
    MobileSafari: "Mobile Safari",
    EdgeChromium: "Edge Chromium",
    MIUI: "MIUI Browser",
    SamsungBrowser: "Samsung Browser"
};
var $3152f4b5b57c36cc$var$OsTypes = {
    IOS: "iOS",
    Android: "Android",
    WindowsPhone: "Windows Phone",
    Windows: "Windows",
    MAC_OS: "Mac OS"
};
var $3152f4b5b57c36cc$var$InitialDeviceTypes = {
    isMobile: false,
    isTablet: false,
    isBrowser: false,
    isSmartTV: false,
    isConsole: false,
    isWearable: false
};
var $3152f4b5b57c36cc$var$checkDeviceType = function checkDeviceType(type) {
    switch(type){
        case $3152f4b5b57c36cc$var$DeviceTypes.Mobile:
            return {
                isMobile: true
            };
        case $3152f4b5b57c36cc$var$DeviceTypes.Tablet:
            return {
                isTablet: true
            };
        case $3152f4b5b57c36cc$var$DeviceTypes.SmartTv:
            return {
                isSmartTV: true
            };
        case $3152f4b5b57c36cc$var$DeviceTypes.Console:
            return {
                isConsole: true
            };
        case $3152f4b5b57c36cc$var$DeviceTypes.Wearable:
            return {
                isWearable: true
            };
        case $3152f4b5b57c36cc$var$DeviceTypes.Browser:
            return {
                isBrowser: true
            };
        case $3152f4b5b57c36cc$var$DeviceTypes.Embedded:
            return {
                isEmbedded: true
            };
        default:
            return $3152f4b5b57c36cc$var$InitialDeviceTypes;
    }
};
var $3152f4b5b57c36cc$var$setUserAgent = function setUserAgent(userAgent) {
    return $3152f4b5b57c36cc$var$setUa(userAgent);
};
var $3152f4b5b57c36cc$var$setDefaults = function setDefaults(p) {
    var d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "none";
    return p ? p : d;
};
var $3152f4b5b57c36cc$var$getNavigatorInstance = function getNavigatorInstance() {
    if (typeof window !== "undefined") {
        if (window.navigator || navigator) return window.navigator || navigator;
    }
    return false;
};
var $3152f4b5b57c36cc$var$isIOS13Check = function isIOS13Check(type) {
    var nav = $3152f4b5b57c36cc$var$getNavigatorInstance();
    return nav && nav.platform && (nav.platform.indexOf(type) !== -1 || nav.platform === "MacIntel" && nav.maxTouchPoints > 1 && !window.MSStream);
};
var $3152f4b5b57c36cc$var$browserPayload = function browserPayload(isBrowser, browser, engine, os, ua) {
    return {
        isBrowser: isBrowser,
        browserMajorVersion: $3152f4b5b57c36cc$var$setDefaults(browser.major),
        browserFullVersion: $3152f4b5b57c36cc$var$setDefaults(browser.version),
        browserName: $3152f4b5b57c36cc$var$setDefaults(browser.name),
        engineName: $3152f4b5b57c36cc$var$setDefaults(engine.name),
        engineVersion: $3152f4b5b57c36cc$var$setDefaults(engine.version),
        osName: $3152f4b5b57c36cc$var$setDefaults(os.name),
        osVersion: $3152f4b5b57c36cc$var$setDefaults(os.version),
        userAgent: $3152f4b5b57c36cc$var$setDefaults(ua)
    };
};
var $3152f4b5b57c36cc$var$mobilePayload = function mobilePayload(type, device, os, ua) {
    return $3152f4b5b57c36cc$var$_objectSpread2({}, type, {
        vendor: $3152f4b5b57c36cc$var$setDefaults(device.vendor),
        model: $3152f4b5b57c36cc$var$setDefaults(device.model),
        os: $3152f4b5b57c36cc$var$setDefaults(os.name),
        osVersion: $3152f4b5b57c36cc$var$setDefaults(os.version),
        ua: $3152f4b5b57c36cc$var$setDefaults(ua)
    });
};
var $3152f4b5b57c36cc$var$smartTvPayload = function smartTvPayload(isSmartTV, engine, os, ua) {
    return {
        isSmartTV: isSmartTV,
        engineName: $3152f4b5b57c36cc$var$setDefaults(engine.name),
        engineVersion: $3152f4b5b57c36cc$var$setDefaults(engine.version),
        osName: $3152f4b5b57c36cc$var$setDefaults(os.name),
        osVersion: $3152f4b5b57c36cc$var$setDefaults(os.version),
        userAgent: $3152f4b5b57c36cc$var$setDefaults(ua)
    };
};
var $3152f4b5b57c36cc$var$consolePayload = function consolePayload(isConsole, engine, os, ua) {
    return {
        isConsole: isConsole,
        engineName: $3152f4b5b57c36cc$var$setDefaults(engine.name),
        engineVersion: $3152f4b5b57c36cc$var$setDefaults(engine.version),
        osName: $3152f4b5b57c36cc$var$setDefaults(os.name),
        osVersion: $3152f4b5b57c36cc$var$setDefaults(os.version),
        userAgent: $3152f4b5b57c36cc$var$setDefaults(ua)
    };
};
var $3152f4b5b57c36cc$var$wearablePayload = function wearablePayload(isWearable, engine, os, ua) {
    return {
        isWearable: isWearable,
        engineName: $3152f4b5b57c36cc$var$setDefaults(engine.name),
        engineVersion: $3152f4b5b57c36cc$var$setDefaults(engine.version),
        osName: $3152f4b5b57c36cc$var$setDefaults(os.name),
        osVersion: $3152f4b5b57c36cc$var$setDefaults(os.version),
        userAgent: $3152f4b5b57c36cc$var$setDefaults(ua)
    };
};
var $3152f4b5b57c36cc$var$embeddedPayload = function embeddedPayload(isEmbedded, device, engine, os, ua) {
    return {
        isEmbedded: isEmbedded,
        vendor: $3152f4b5b57c36cc$var$setDefaults(device.vendor),
        model: $3152f4b5b57c36cc$var$setDefaults(device.model),
        engineName: $3152f4b5b57c36cc$var$setDefaults(engine.name),
        engineVersion: $3152f4b5b57c36cc$var$setDefaults(engine.version),
        osName: $3152f4b5b57c36cc$var$setDefaults(os.name),
        osVersion: $3152f4b5b57c36cc$var$setDefaults(os.version),
        userAgent: $3152f4b5b57c36cc$var$setDefaults(ua)
    };
};
function $3152f4b5b57c36cc$var$deviceDetect(userAgent) {
    var _ref = userAgent ? $3152f4b5b57c36cc$var$parseUserAgent(userAgent) : $3152f4b5b57c36cc$var$UAHelper, device = _ref.device, browser = _ref.browser, engine = _ref.engine, os = _ref.os, ua = _ref.ua;
    var type = $3152f4b5b57c36cc$var$checkDeviceType(device.type);
    var isBrowser = type.isBrowser, isMobile = type.isMobile, isTablet = type.isTablet, isSmartTV = type.isSmartTV, isConsole = type.isConsole, isWearable = type.isWearable, isEmbedded = type.isEmbedded;
    if (isBrowser) return $3152f4b5b57c36cc$var$browserPayload(isBrowser, browser, engine, os, ua);
    if (isSmartTV) return $3152f4b5b57c36cc$var$smartTvPayload(isSmartTV, engine, os, ua);
    if (isConsole) return $3152f4b5b57c36cc$var$consolePayload(isConsole, engine, os, ua);
    if (isMobile) return $3152f4b5b57c36cc$var$mobilePayload(type, device, os, ua);
    if (isTablet) return $3152f4b5b57c36cc$var$mobilePayload(type, device, os, ua);
    if (isWearable) return $3152f4b5b57c36cc$var$wearablePayload(isWearable, engine, os, ua);
    if (isEmbedded) return $3152f4b5b57c36cc$var$embeddedPayload(isEmbedded, device, engine, os, ua);
}
var $3152f4b5b57c36cc$var$isMobileType = function isMobileType(_ref) {
    var type = _ref.type;
    return type === $3152f4b5b57c36cc$var$DeviceTypes.Mobile;
};
var $3152f4b5b57c36cc$var$isTabletType = function isTabletType(_ref2) {
    var type = _ref2.type;
    return type === $3152f4b5b57c36cc$var$DeviceTypes.Tablet;
};
var $3152f4b5b57c36cc$var$isMobileAndTabletType = function isMobileAndTabletType(_ref3) {
    var type = _ref3.type;
    return type === $3152f4b5b57c36cc$var$DeviceTypes.Mobile || type === $3152f4b5b57c36cc$var$DeviceTypes.Tablet;
};
var $3152f4b5b57c36cc$var$isSmartTVType = function isSmartTVType(_ref4) {
    var type = _ref4.type;
    return type === $3152f4b5b57c36cc$var$DeviceTypes.SmartTv;
};
var $3152f4b5b57c36cc$var$isBrowserType = function isBrowserType(_ref5) {
    var type = _ref5.type;
    return type === $3152f4b5b57c36cc$var$DeviceTypes.Browser;
};
var $3152f4b5b57c36cc$var$isWearableType = function isWearableType(_ref6) {
    var type = _ref6.type;
    return type === $3152f4b5b57c36cc$var$DeviceTypes.Wearable;
};
var $3152f4b5b57c36cc$var$isConsoleType = function isConsoleType(_ref7) {
    var type = _ref7.type;
    return type === $3152f4b5b57c36cc$var$DeviceTypes.Console;
};
var $3152f4b5b57c36cc$var$isEmbeddedType = function isEmbeddedType(_ref8) {
    var type = _ref8.type;
    return type === $3152f4b5b57c36cc$var$DeviceTypes.Embedded;
};
var $3152f4b5b57c36cc$var$getMobileVendor = function getMobileVendor(_ref9) {
    var vendor = _ref9.vendor;
    return $3152f4b5b57c36cc$var$setDefaults(vendor);
};
var $3152f4b5b57c36cc$var$getMobileModel = function getMobileModel(_ref10) {
    var model = _ref10.model;
    return $3152f4b5b57c36cc$var$setDefaults(model);
};
var $3152f4b5b57c36cc$var$getDeviceType = function getDeviceType(_ref11) {
    var type = _ref11.type;
    return $3152f4b5b57c36cc$var$setDefaults(type, "browser");
}; // os types
var $3152f4b5b57c36cc$var$isAndroidType = function isAndroidType(_ref12) {
    var name = _ref12.name;
    return name === $3152f4b5b57c36cc$var$OsTypes.Android;
};
var $3152f4b5b57c36cc$var$isWindowsType = function isWindowsType(_ref13) {
    var name = _ref13.name;
    return name === $3152f4b5b57c36cc$var$OsTypes.Windows;
};
var $3152f4b5b57c36cc$var$isMacOsType = function isMacOsType(_ref14) {
    var name = _ref14.name;
    return name === $3152f4b5b57c36cc$var$OsTypes.MAC_OS;
};
var $3152f4b5b57c36cc$var$isWinPhoneType = function isWinPhoneType(_ref15) {
    var name = _ref15.name;
    return name === $3152f4b5b57c36cc$var$OsTypes.WindowsPhone;
};
var $3152f4b5b57c36cc$var$isIOSType = function isIOSType(_ref16) {
    var name = _ref16.name;
    return name === $3152f4b5b57c36cc$var$OsTypes.IOS;
};
var $3152f4b5b57c36cc$var$getOsVersion = function getOsVersion(_ref17) {
    var version = _ref17.version;
    return $3152f4b5b57c36cc$var$setDefaults(version);
};
var $3152f4b5b57c36cc$var$getOsName = function getOsName(_ref18) {
    var name = _ref18.name;
    return $3152f4b5b57c36cc$var$setDefaults(name);
}; // browser types
var $3152f4b5b57c36cc$var$isChromeType = function isChromeType(_ref19) {
    var name = _ref19.name;
    return name === $3152f4b5b57c36cc$var$BrowserTypes.Chrome;
};
var $3152f4b5b57c36cc$var$isFirefoxType = function isFirefoxType(_ref20) {
    var name = _ref20.name;
    return name === $3152f4b5b57c36cc$var$BrowserTypes.Firefox;
};
var $3152f4b5b57c36cc$var$isChromiumType = function isChromiumType(_ref21) {
    var name = _ref21.name;
    return name === $3152f4b5b57c36cc$var$BrowserTypes.Chromium;
};
var $3152f4b5b57c36cc$var$isEdgeType = function isEdgeType(_ref22) {
    var name = _ref22.name;
    return name === $3152f4b5b57c36cc$var$BrowserTypes.Edge;
};
var $3152f4b5b57c36cc$var$isYandexType = function isYandexType(_ref23) {
    var name = _ref23.name;
    return name === $3152f4b5b57c36cc$var$BrowserTypes.Yandex;
};
var $3152f4b5b57c36cc$var$isSafariType = function isSafariType(_ref24) {
    var name = _ref24.name;
    return name === $3152f4b5b57c36cc$var$BrowserTypes.Safari || name === $3152f4b5b57c36cc$var$BrowserTypes.MobileSafari;
};
var $3152f4b5b57c36cc$var$isMobileSafariType = function isMobileSafariType(_ref25) {
    var name = _ref25.name;
    return name === $3152f4b5b57c36cc$var$BrowserTypes.MobileSafari;
};
var $3152f4b5b57c36cc$var$isOperaType = function isOperaType(_ref26) {
    var name = _ref26.name;
    return name === $3152f4b5b57c36cc$var$BrowserTypes.Opera;
};
var $3152f4b5b57c36cc$var$isIEType = function isIEType(_ref27) {
    var name = _ref27.name;
    return name === $3152f4b5b57c36cc$var$BrowserTypes.InternetExplorer || name === $3152f4b5b57c36cc$var$BrowserTypes.Ie;
};
var $3152f4b5b57c36cc$var$isMIUIType = function isMIUIType(_ref28) {
    var name = _ref28.name;
    return name === $3152f4b5b57c36cc$var$BrowserTypes.MIUI;
};
var $3152f4b5b57c36cc$var$isSamsungBrowserType = function isSamsungBrowserType(_ref29) {
    var name = _ref29.name;
    return name === $3152f4b5b57c36cc$var$BrowserTypes.SamsungBrowser;
};
var $3152f4b5b57c36cc$var$getBrowserFullVersion = function getBrowserFullVersion(_ref30) {
    var version = _ref30.version;
    return $3152f4b5b57c36cc$var$setDefaults(version);
};
var $3152f4b5b57c36cc$var$getBrowserVersion = function getBrowserVersion(_ref31) {
    var major = _ref31.major;
    return $3152f4b5b57c36cc$var$setDefaults(major);
};
var $3152f4b5b57c36cc$var$getBrowserName = function getBrowserName(_ref32) {
    var name = _ref32.name;
    return $3152f4b5b57c36cc$var$setDefaults(name);
}; // engine types
var $3152f4b5b57c36cc$var$getEngineName = function getEngineName(_ref33) {
    var name = _ref33.name;
    return $3152f4b5b57c36cc$var$setDefaults(name);
};
var $3152f4b5b57c36cc$var$getEngineVersion = function getEngineVersion(_ref34) {
    var version = _ref34.version;
    return $3152f4b5b57c36cc$var$setDefaults(version);
};
var $3152f4b5b57c36cc$var$isElectronType = function isElectronType() {
    var nav = $3152f4b5b57c36cc$var$getNavigatorInstance();
    var ua = nav && nav.userAgent && nav.userAgent.toLowerCase();
    return typeof ua === "string" ? /electron/.test(ua) : false;
};
var $3152f4b5b57c36cc$var$isEdgeChromiumType = function isEdgeChromiumType(ua) {
    return typeof ua === "string" && ua.indexOf("Edg/") !== -1;
};
var $3152f4b5b57c36cc$var$getIOS13 = function getIOS13() {
    var nav = $3152f4b5b57c36cc$var$getNavigatorInstance();
    return nav && (/iPad|iPhone|iPod/.test(nav.platform) || nav.platform === "MacIntel" && nav.maxTouchPoints > 1) && !window.MSStream;
};
var $3152f4b5b57c36cc$var$getIPad13 = function getIPad13() {
    return $3152f4b5b57c36cc$var$isIOS13Check("iPad");
};
var $3152f4b5b57c36cc$var$getIphone13 = function getIphone13() {
    return $3152f4b5b57c36cc$var$isIOS13Check("iPhone");
};
var $3152f4b5b57c36cc$var$getIPod13 = function getIPod13() {
    return $3152f4b5b57c36cc$var$isIOS13Check("iPod");
};
var $3152f4b5b57c36cc$var$getUseragent = function getUseragent(userAg) {
    return $3152f4b5b57c36cc$var$setDefaults(userAg);
};
function $3152f4b5b57c36cc$var$buildSelectorsObject(options) {
    var _ref = options ? options : $3152f4b5b57c36cc$var$UAHelper, device = _ref.device, browser = _ref.browser, os = _ref.os, engine = _ref.engine, ua = _ref.ua;
    return {
        isSmartTV: $3152f4b5b57c36cc$var$isSmartTVType(device),
        isConsole: $3152f4b5b57c36cc$var$isConsoleType(device),
        isWearable: $3152f4b5b57c36cc$var$isWearableType(device),
        isEmbedded: $3152f4b5b57c36cc$var$isEmbeddedType(device),
        isMobileSafari: $3152f4b5b57c36cc$var$isMobileSafariType(browser) || $3152f4b5b57c36cc$var$getIPad13(),
        isChromium: $3152f4b5b57c36cc$var$isChromiumType(browser),
        isMobile: $3152f4b5b57c36cc$var$isMobileAndTabletType(device) || $3152f4b5b57c36cc$var$getIPad13(),
        isMobileOnly: $3152f4b5b57c36cc$var$isMobileType(device),
        isTablet: $3152f4b5b57c36cc$var$isTabletType(device) || $3152f4b5b57c36cc$var$getIPad13(),
        isBrowser: $3152f4b5b57c36cc$var$isBrowserType(device),
        isDesktop: $3152f4b5b57c36cc$var$isBrowserType(device),
        isAndroid: $3152f4b5b57c36cc$var$isAndroidType(os),
        isWinPhone: $3152f4b5b57c36cc$var$isWinPhoneType(os),
        isIOS: $3152f4b5b57c36cc$var$isIOSType(os) || $3152f4b5b57c36cc$var$getIPad13(),
        isChrome: $3152f4b5b57c36cc$var$isChromeType(browser),
        isFirefox: $3152f4b5b57c36cc$var$isFirefoxType(browser),
        isSafari: $3152f4b5b57c36cc$var$isSafariType(browser),
        isOpera: $3152f4b5b57c36cc$var$isOperaType(browser),
        isIE: $3152f4b5b57c36cc$var$isIEType(browser),
        osVersion: $3152f4b5b57c36cc$var$getOsVersion(os),
        osName: $3152f4b5b57c36cc$var$getOsName(os),
        fullBrowserVersion: $3152f4b5b57c36cc$var$getBrowserFullVersion(browser),
        browserVersion: $3152f4b5b57c36cc$var$getBrowserVersion(browser),
        browserName: $3152f4b5b57c36cc$var$getBrowserName(browser),
        mobileVendor: $3152f4b5b57c36cc$var$getMobileVendor(device),
        mobileModel: $3152f4b5b57c36cc$var$getMobileModel(device),
        engineName: $3152f4b5b57c36cc$var$getEngineName(engine),
        engineVersion: $3152f4b5b57c36cc$var$getEngineVersion(engine),
        getUA: $3152f4b5b57c36cc$var$getUseragent(ua),
        isEdge: $3152f4b5b57c36cc$var$isEdgeType(browser) || $3152f4b5b57c36cc$var$isEdgeChromiumType(ua),
        isYandex: $3152f4b5b57c36cc$var$isYandexType(browser),
        deviceType: $3152f4b5b57c36cc$var$getDeviceType(device),
        isIOS13: $3152f4b5b57c36cc$var$getIOS13(),
        isIPad13: $3152f4b5b57c36cc$var$getIPad13(),
        isIPhone13: $3152f4b5b57c36cc$var$getIphone13(),
        isIPod13: $3152f4b5b57c36cc$var$getIPod13(),
        isElectron: $3152f4b5b57c36cc$var$isElectronType(),
        isEdgeChromium: $3152f4b5b57c36cc$var$isEdgeChromiumType(ua),
        isLegacyEdge: $3152f4b5b57c36cc$var$isEdgeType(browser) && !$3152f4b5b57c36cc$var$isEdgeChromiumType(ua),
        isWindows: $3152f4b5b57c36cc$var$isWindowsType(os),
        isMacOs: $3152f4b5b57c36cc$var$isMacOsType(os),
        isMIUI: $3152f4b5b57c36cc$var$isMIUIType(browser),
        isSamsungBrowser: $3152f4b5b57c36cc$var$isSamsungBrowserType(browser)
    };
}
var $3152f4b5b57c36cc$var$isSmartTV = $3152f4b5b57c36cc$var$isSmartTVType($3152f4b5b57c36cc$var$device);
var $3152f4b5b57c36cc$var$isConsole = $3152f4b5b57c36cc$var$isConsoleType($3152f4b5b57c36cc$var$device);
var $3152f4b5b57c36cc$var$isWearable = $3152f4b5b57c36cc$var$isWearableType($3152f4b5b57c36cc$var$device);
var $3152f4b5b57c36cc$var$isEmbedded = $3152f4b5b57c36cc$var$isEmbeddedType($3152f4b5b57c36cc$var$device);
var $3152f4b5b57c36cc$var$isMobileSafari = $3152f4b5b57c36cc$var$isMobileSafariType($3152f4b5b57c36cc$var$browser) || $3152f4b5b57c36cc$var$getIPad13();
var $3152f4b5b57c36cc$var$isChromium = $3152f4b5b57c36cc$var$isChromiumType($3152f4b5b57c36cc$var$browser);
var $3152f4b5b57c36cc$var$isMobile = $3152f4b5b57c36cc$var$isMobileAndTabletType($3152f4b5b57c36cc$var$device) || $3152f4b5b57c36cc$var$getIPad13();
var $3152f4b5b57c36cc$var$isMobileOnly = $3152f4b5b57c36cc$var$isMobileType($3152f4b5b57c36cc$var$device);
var $3152f4b5b57c36cc$var$isTablet = $3152f4b5b57c36cc$var$isTabletType($3152f4b5b57c36cc$var$device) || $3152f4b5b57c36cc$var$getIPad13();
var $3152f4b5b57c36cc$var$isBrowser = $3152f4b5b57c36cc$var$isBrowserType($3152f4b5b57c36cc$var$device);
var $3152f4b5b57c36cc$var$isDesktop = $3152f4b5b57c36cc$var$isBrowserType($3152f4b5b57c36cc$var$device);
var $3152f4b5b57c36cc$var$isAndroid = $3152f4b5b57c36cc$var$isAndroidType($3152f4b5b57c36cc$var$os);
var $3152f4b5b57c36cc$var$isWinPhone = $3152f4b5b57c36cc$var$isWinPhoneType($3152f4b5b57c36cc$var$os);
var $3152f4b5b57c36cc$var$isIOS = $3152f4b5b57c36cc$var$isIOSType($3152f4b5b57c36cc$var$os) || $3152f4b5b57c36cc$var$getIPad13();
var $3152f4b5b57c36cc$var$isChrome = $3152f4b5b57c36cc$var$isChromeType($3152f4b5b57c36cc$var$browser);
var $3152f4b5b57c36cc$var$isFirefox = $3152f4b5b57c36cc$var$isFirefoxType($3152f4b5b57c36cc$var$browser);
var $3152f4b5b57c36cc$var$isSafari = $3152f4b5b57c36cc$var$isSafariType($3152f4b5b57c36cc$var$browser);
var $3152f4b5b57c36cc$var$isOpera = $3152f4b5b57c36cc$var$isOperaType($3152f4b5b57c36cc$var$browser);
var $3152f4b5b57c36cc$var$isIE = $3152f4b5b57c36cc$var$isIEType($3152f4b5b57c36cc$var$browser);
var $3152f4b5b57c36cc$var$osVersion = $3152f4b5b57c36cc$var$getOsVersion($3152f4b5b57c36cc$var$os);
var $3152f4b5b57c36cc$var$osName = $3152f4b5b57c36cc$var$getOsName($3152f4b5b57c36cc$var$os);
var $3152f4b5b57c36cc$var$fullBrowserVersion = $3152f4b5b57c36cc$var$getBrowserFullVersion($3152f4b5b57c36cc$var$browser);
var $3152f4b5b57c36cc$var$browserVersion = $3152f4b5b57c36cc$var$getBrowserVersion($3152f4b5b57c36cc$var$browser);
var $3152f4b5b57c36cc$var$browserName = $3152f4b5b57c36cc$var$getBrowserName($3152f4b5b57c36cc$var$browser);
var $3152f4b5b57c36cc$var$mobileVendor = $3152f4b5b57c36cc$var$getMobileVendor($3152f4b5b57c36cc$var$device);
var $3152f4b5b57c36cc$var$mobileModel = $3152f4b5b57c36cc$var$getMobileModel($3152f4b5b57c36cc$var$device);
var $3152f4b5b57c36cc$var$engineName = $3152f4b5b57c36cc$var$getEngineName($3152f4b5b57c36cc$var$engine);
var $3152f4b5b57c36cc$var$engineVersion = $3152f4b5b57c36cc$var$getEngineVersion($3152f4b5b57c36cc$var$engine);
var $3152f4b5b57c36cc$var$getUA = $3152f4b5b57c36cc$var$getUseragent($3152f4b5b57c36cc$var$ua);
var $3152f4b5b57c36cc$var$isEdge = $3152f4b5b57c36cc$var$isEdgeType($3152f4b5b57c36cc$var$browser) || $3152f4b5b57c36cc$var$isEdgeChromiumType($3152f4b5b57c36cc$var$ua);
var $3152f4b5b57c36cc$var$isYandex = $3152f4b5b57c36cc$var$isYandexType($3152f4b5b57c36cc$var$browser);
var $3152f4b5b57c36cc$var$deviceType = $3152f4b5b57c36cc$var$getDeviceType($3152f4b5b57c36cc$var$device);
var $3152f4b5b57c36cc$var$isIOS13 = $3152f4b5b57c36cc$var$getIOS13();
var $3152f4b5b57c36cc$var$isIPad13 = $3152f4b5b57c36cc$var$getIPad13();
var $3152f4b5b57c36cc$var$isIPhone13 = $3152f4b5b57c36cc$var$getIphone13();
var $3152f4b5b57c36cc$var$isIPod13 = $3152f4b5b57c36cc$var$getIPod13();
var $3152f4b5b57c36cc$var$isElectron = $3152f4b5b57c36cc$var$isElectronType();
var $3152f4b5b57c36cc$var$isEdgeChromium = $3152f4b5b57c36cc$var$isEdgeChromiumType($3152f4b5b57c36cc$var$ua);
var $3152f4b5b57c36cc$var$isLegacyEdge = $3152f4b5b57c36cc$var$isEdgeType($3152f4b5b57c36cc$var$browser) && !$3152f4b5b57c36cc$var$isEdgeChromiumType($3152f4b5b57c36cc$var$ua);
var $3152f4b5b57c36cc$var$isWindows = $3152f4b5b57c36cc$var$isWindowsType($3152f4b5b57c36cc$var$os);
var $3152f4b5b57c36cc$var$isMacOs = $3152f4b5b57c36cc$var$isMacOsType($3152f4b5b57c36cc$var$os);
var $3152f4b5b57c36cc$var$isMIUI = $3152f4b5b57c36cc$var$isMIUIType($3152f4b5b57c36cc$var$browser);
var $3152f4b5b57c36cc$var$isSamsungBrowser = $3152f4b5b57c36cc$var$isSamsungBrowserType($3152f4b5b57c36cc$var$browser);
var $3152f4b5b57c36cc$var$getSelectorsByUserAgent = function getSelectorsByUserAgent(userAgent) {
    if (!userAgent || typeof userAgent !== "string") {
        console.error("No valid user agent string was provided");
        return;
    }
    var _UAHelper$parseUserAg = $3152f4b5b57c36cc$var$parseUserAgent(userAgent), device = _UAHelper$parseUserAg.device, browser = _UAHelper$parseUserAg.browser, os = _UAHelper$parseUserAg.os, engine = _UAHelper$parseUserAg.engine, ua = _UAHelper$parseUserAg.ua;
    return $3152f4b5b57c36cc$var$buildSelectorsObject({
        device: device,
        browser: browser,
        os: os,
        engine: engine,
        ua: ua
    });
};
var $3152f4b5b57c36cc$var$AndroidView = function AndroidView(_ref) {
    var renderWithFragment = _ref.renderWithFragment, children = _ref.children, props = $3152f4b5b57c36cc$var$_objectWithoutProperties(_ref, [
        "renderWithFragment",
        "children"
    ]);
    return $3152f4b5b57c36cc$var$isAndroid ? renderWithFragment ? $3152f4b5b57c36cc$var$React__default.createElement($P551f.Fragment, null, children) : $3152f4b5b57c36cc$var$React__default.createElement("div", props, children) : null;
};
var $3152f4b5b57c36cc$var$BrowserView = function BrowserView(_ref2) {
    var renderWithFragment = _ref2.renderWithFragment, children = _ref2.children, props = $3152f4b5b57c36cc$var$_objectWithoutProperties(_ref2, [
        "renderWithFragment",
        "children"
    ]);
    return $3152f4b5b57c36cc$var$isBrowser ? renderWithFragment ? $3152f4b5b57c36cc$var$React__default.createElement($P551f.Fragment, null, children) : $3152f4b5b57c36cc$var$React__default.createElement("div", props, children) : null;
};
var $3152f4b5b57c36cc$var$IEView = function IEView(_ref3) {
    var renderWithFragment = _ref3.renderWithFragment, children = _ref3.children, props = $3152f4b5b57c36cc$var$_objectWithoutProperties(_ref3, [
        "renderWithFragment",
        "children"
    ]);
    return $3152f4b5b57c36cc$var$isIE ? renderWithFragment ? $3152f4b5b57c36cc$var$React__default.createElement($P551f.Fragment, null, children) : $3152f4b5b57c36cc$var$React__default.createElement("div", props, children) : null;
};
var $3152f4b5b57c36cc$var$IOSView = function IOSView(_ref4) {
    var renderWithFragment = _ref4.renderWithFragment, children = _ref4.children, props = $3152f4b5b57c36cc$var$_objectWithoutProperties(_ref4, [
        "renderWithFragment",
        "children"
    ]);
    return $3152f4b5b57c36cc$var$isIOS ? renderWithFragment ? $3152f4b5b57c36cc$var$React__default.createElement($P551f.Fragment, null, children) : $3152f4b5b57c36cc$var$React__default.createElement("div", props, children) : null;
};
var $3152f4b5b57c36cc$var$MobileView = function MobileView(_ref5) {
    var renderWithFragment = _ref5.renderWithFragment, children = _ref5.children, props = $3152f4b5b57c36cc$var$_objectWithoutProperties(_ref5, [
        "renderWithFragment",
        "children"
    ]);
    return $3152f4b5b57c36cc$var$isMobile ? renderWithFragment ? $3152f4b5b57c36cc$var$React__default.createElement($P551f.Fragment, null, children) : $3152f4b5b57c36cc$var$React__default.createElement("div", props, children) : null;
};
var $3152f4b5b57c36cc$var$TabletView = function TabletView(_ref6) {
    var renderWithFragment = _ref6.renderWithFragment, children = _ref6.children, props = $3152f4b5b57c36cc$var$_objectWithoutProperties(_ref6, [
        "renderWithFragment",
        "children"
    ]);
    return $3152f4b5b57c36cc$var$isTablet ? renderWithFragment ? $3152f4b5b57c36cc$var$React__default.createElement($P551f.Fragment, null, children) : $3152f4b5b57c36cc$var$React__default.createElement("div", props, children) : null;
};
var $3152f4b5b57c36cc$var$WinPhoneView = function WinPhoneView(_ref7) {
    var renderWithFragment = _ref7.renderWithFragment, children = _ref7.children, props = $3152f4b5b57c36cc$var$_objectWithoutProperties(_ref7, [
        "renderWithFragment",
        "children"
    ]);
    return $3152f4b5b57c36cc$var$isWinPhone ? renderWithFragment ? $3152f4b5b57c36cc$var$React__default.createElement($P551f.Fragment, null, children) : $3152f4b5b57c36cc$var$React__default.createElement("div", props, children) : null;
};
var $3152f4b5b57c36cc$var$MobileOnlyView = function MobileOnlyView(_ref8) {
    var renderWithFragment = _ref8.renderWithFragment, children = _ref8.children, viewClassName = _ref8.viewClassName, style = _ref8.style, props = $3152f4b5b57c36cc$var$_objectWithoutProperties(_ref8, [
        "renderWithFragment",
        "children",
        "viewClassName",
        "style"
    ]);
    return $3152f4b5b57c36cc$var$isMobileOnly ? renderWithFragment ? $3152f4b5b57c36cc$var$React__default.createElement($P551f.Fragment, null, children) : $3152f4b5b57c36cc$var$React__default.createElement("div", props, children) : null;
};
var $3152f4b5b57c36cc$var$SmartTVView = function SmartTVView(_ref9) {
    var renderWithFragment = _ref9.renderWithFragment, children = _ref9.children, props = $3152f4b5b57c36cc$var$_objectWithoutProperties(_ref9, [
        "renderWithFragment",
        "children"
    ]);
    return $3152f4b5b57c36cc$var$isSmartTV ? renderWithFragment ? $3152f4b5b57c36cc$var$React__default.createElement($P551f.Fragment, null, children) : $3152f4b5b57c36cc$var$React__default.createElement("div", props, children) : null;
};
var $3152f4b5b57c36cc$var$ConsoleView = function ConsoleView(_ref10) {
    var renderWithFragment = _ref10.renderWithFragment, children = _ref10.children, props = $3152f4b5b57c36cc$var$_objectWithoutProperties(_ref10, [
        "renderWithFragment",
        "children"
    ]);
    return $3152f4b5b57c36cc$var$isConsole ? renderWithFragment ? $3152f4b5b57c36cc$var$React__default.createElement($P551f.Fragment, null, children) : $3152f4b5b57c36cc$var$React__default.createElement("div", props, children) : null;
};
var $3152f4b5b57c36cc$var$WearableView = function WearableView(_ref11) {
    var renderWithFragment = _ref11.renderWithFragment, children = _ref11.children, props = $3152f4b5b57c36cc$var$_objectWithoutProperties(_ref11, [
        "renderWithFragment",
        "children"
    ]);
    return $3152f4b5b57c36cc$var$isWearable ? renderWithFragment ? $3152f4b5b57c36cc$var$React__default.createElement($P551f.Fragment, null, children) : $3152f4b5b57c36cc$var$React__default.createElement("div", props, children) : null;
};
var $3152f4b5b57c36cc$var$CustomView = function CustomView(_ref12) {
    var renderWithFragment = _ref12.renderWithFragment, children = _ref12.children, viewClassName = _ref12.viewClassName, style = _ref12.style, condition = _ref12.condition, props = $3152f4b5b57c36cc$var$_objectWithoutProperties(_ref12, [
        "renderWithFragment",
        "children",
        "viewClassName",
        "style",
        "condition"
    ]);
    return condition ? renderWithFragment ? $3152f4b5b57c36cc$var$React__default.createElement($P551f.Fragment, null, children) : $3152f4b5b57c36cc$var$React__default.createElement("div", props, children) : null;
};
function $3152f4b5b57c36cc$var$withOrientationChange(WrappedComponent) {
    return /*#__PURE__*/ function(_React$Component) {
        $3152f4b5b57c36cc$var$_inherits(_class, _React$Component);
        function _class(props) {
            var _this;
            $3152f4b5b57c36cc$var$_classCallCheck(this, _class);
            _this = $3152f4b5b57c36cc$var$_possibleConstructorReturn(this, $3152f4b5b57c36cc$var$_getPrototypeOf(_class).call(this, props));
            _this.isEventListenerAdded = false;
            _this.handleOrientationChange = _this.handleOrientationChange.bind($3152f4b5b57c36cc$var$_assertThisInitialized(_this));
            _this.onOrientationChange = _this.onOrientationChange.bind($3152f4b5b57c36cc$var$_assertThisInitialized(_this));
            _this.onPageLoad = _this.onPageLoad.bind($3152f4b5b57c36cc$var$_assertThisInitialized(_this));
            _this.state = {
                isLandscape: false,
                isPortrait: false
            };
            return _this;
        }
        $3152f4b5b57c36cc$var$_createClass(_class, [
            {
                key: "handleOrientationChange",
                value: function handleOrientationChange() {
                    if (!this.isEventListenerAdded) this.isEventListenerAdded = true;
                    var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
                    this.setState({
                        isPortrait: orientation === 0,
                        isLandscape: orientation === 90
                    });
                }
            },
            {
                key: "onOrientationChange",
                value: function onOrientationChange() {
                    this.handleOrientationChange();
                }
            },
            {
                key: "onPageLoad",
                value: function onPageLoad() {
                    this.handleOrientationChange();
                }
            },
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    if ((typeof window === "undefined" ? "undefined" : $3152f4b5b57c36cc$var$_typeof(window)) !== undefined && $3152f4b5b57c36cc$var$isMobile) {
                        if (!this.isEventListenerAdded) {
                            this.handleOrientationChange();
                            window.addEventListener("load", this.onPageLoad, false);
                        } else window.removeEventListener("load", this.onPageLoad, false);
                        window.addEventListener("resize", this.onOrientationChange, false);
                    }
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    window.removeEventListener("resize", this.onOrientationChange, false);
                }
            },
            {
                key: "render",
                value: function render() {
                    return $3152f4b5b57c36cc$var$React__default.createElement(WrappedComponent, $3152f4b5b57c36cc$var$_extends({}, this.props, {
                        isLandscape: this.state.isLandscape,
                        isPortrait: this.state.isPortrait
                    }));
                }
            }
        ]);
        return _class;
    }($3152f4b5b57c36cc$var$React__default.Component);
}
function $3152f4b5b57c36cc$var$useMobileOrientation() {
    var _useState = $P551f.useState(function() {
        var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
        return {
            isPortrait: orientation === 0,
            isLandscape: orientation === 90,
            orientation: orientation === 0 ? "portrait" : "landscape"
        };
    }), _useState2 = $3152f4b5b57c36cc$var$_slicedToArray(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var handleOrientationChange = $P551f.useCallback(function() {
        var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
        var next = {
            isPortrait: orientation === 0,
            isLandscape: orientation === 90,
            orientation: orientation === 0 ? "portrait" : "landscape"
        };
        state.orientation !== next.orientation && setState(next);
    }, [
        state.orientation
    ]);
    $P551f.useEffect(function() {
        if ((typeof window === "undefined" ? "undefined" : $3152f4b5b57c36cc$var$_typeof(window)) !== undefined && $3152f4b5b57c36cc$var$isMobile) {
            handleOrientationChange();
            window.addEventListener("load", handleOrientationChange, false);
            window.addEventListener("resize", handleOrientationChange, false);
        }
        return function() {
            window.removeEventListener("resize", handleOrientationChange, false);
            window.removeEventListener("load", handleOrientationChange, false);
        };
    }, [
        handleOrientationChange
    ]);
    return state;
}
function $3152f4b5b57c36cc$var$useDeviceData(userAgent) {
    var hookUserAgent = userAgent ? userAgent : window.navigator.userAgent;
    return $3152f4b5b57c36cc$var$parseUserAgent(hookUserAgent);
}
function $3152f4b5b57c36cc$var$useDeviceSelectors(userAgent) {
    var hookUserAgent = userAgent ? userAgent : window.navigator.userAgent;
    var deviceData = $3152f4b5b57c36cc$var$useDeviceData(hookUserAgent);
    var selectors = $3152f4b5b57c36cc$var$buildSelectorsObject(deviceData);
    return [
        selectors,
        deviceData
    ];
}
$3152f4b5b57c36cc$exports.AndroidView = $3152f4b5b57c36cc$var$AndroidView;
$3152f4b5b57c36cc$exports.BrowserTypes = $3152f4b5b57c36cc$var$BrowserTypes;
$3152f4b5b57c36cc$exports.BrowserView = $3152f4b5b57c36cc$var$BrowserView;
$3152f4b5b57c36cc$exports.ConsoleView = $3152f4b5b57c36cc$var$ConsoleView;
$3152f4b5b57c36cc$exports.CustomView = $3152f4b5b57c36cc$var$CustomView;
$3152f4b5b57c36cc$exports.IEView = $3152f4b5b57c36cc$var$IEView;
$3152f4b5b57c36cc$exports.IOSView = $3152f4b5b57c36cc$var$IOSView;
$3152f4b5b57c36cc$exports.MobileOnlyView = $3152f4b5b57c36cc$var$MobileOnlyView;
$3152f4b5b57c36cc$exports.MobileView = $3152f4b5b57c36cc$var$MobileView;
$3152f4b5b57c36cc$exports.OsTypes = $3152f4b5b57c36cc$var$OsTypes;
$3152f4b5b57c36cc$exports.SmartTVView = $3152f4b5b57c36cc$var$SmartTVView;
$3152f4b5b57c36cc$exports.TabletView = $3152f4b5b57c36cc$var$TabletView;
$3152f4b5b57c36cc$exports.WearableView = $3152f4b5b57c36cc$var$WearableView;
$3152f4b5b57c36cc$exports.WinPhoneView = $3152f4b5b57c36cc$var$WinPhoneView;
$3152f4b5b57c36cc$exports.browserName = $3152f4b5b57c36cc$var$browserName;
$3152f4b5b57c36cc$exports.browserVersion = $3152f4b5b57c36cc$var$browserVersion;
$3152f4b5b57c36cc$exports.deviceDetect = $3152f4b5b57c36cc$var$deviceDetect;
$3152f4b5b57c36cc$exports.deviceType = $3152f4b5b57c36cc$var$deviceType;
$3152f4b5b57c36cc$exports.engineName = $3152f4b5b57c36cc$var$engineName;
$3152f4b5b57c36cc$exports.engineVersion = $3152f4b5b57c36cc$var$engineVersion;
$3152f4b5b57c36cc$exports.fullBrowserVersion = $3152f4b5b57c36cc$var$fullBrowserVersion;
$3152f4b5b57c36cc$exports.getSelectorsByUserAgent = $3152f4b5b57c36cc$var$getSelectorsByUserAgent;
$3152f4b5b57c36cc$exports.getUA = $3152f4b5b57c36cc$var$getUA;
$3152f4b5b57c36cc$exports.isAndroid = $3152f4b5b57c36cc$var$isAndroid;
$3152f4b5b57c36cc$exports.isBrowser = $3152f4b5b57c36cc$var$isBrowser;
$3152f4b5b57c36cc$exports.isChrome = $3152f4b5b57c36cc$var$isChrome;
$3152f4b5b57c36cc$exports.isChromium = $3152f4b5b57c36cc$var$isChromium;
$3152f4b5b57c36cc$exports.isConsole = $3152f4b5b57c36cc$var$isConsole;
$3152f4b5b57c36cc$exports.isDesktop = $3152f4b5b57c36cc$var$isDesktop;
$3152f4b5b57c36cc$exports.isEdge = $3152f4b5b57c36cc$var$isEdge;
$3152f4b5b57c36cc$exports.isEdgeChromium = $3152f4b5b57c36cc$var$isEdgeChromium;
$3152f4b5b57c36cc$exports.isElectron = $3152f4b5b57c36cc$var$isElectron;
$3152f4b5b57c36cc$exports.isEmbedded = $3152f4b5b57c36cc$var$isEmbedded;
$3152f4b5b57c36cc$exports.isFirefox = $3152f4b5b57c36cc$var$isFirefox;
$3152f4b5b57c36cc$exports.isIE = $3152f4b5b57c36cc$var$isIE;
$3152f4b5b57c36cc$exports.isIOS = $3152f4b5b57c36cc$var$isIOS;
$3152f4b5b57c36cc$exports.isIOS13 = $3152f4b5b57c36cc$var$isIOS13;
$3152f4b5b57c36cc$exports.isIPad13 = $3152f4b5b57c36cc$var$isIPad13;
$3152f4b5b57c36cc$exports.isIPhone13 = $3152f4b5b57c36cc$var$isIPhone13;
$3152f4b5b57c36cc$exports.isIPod13 = $3152f4b5b57c36cc$var$isIPod13;
$3152f4b5b57c36cc$exports.isLegacyEdge = $3152f4b5b57c36cc$var$isLegacyEdge;
$3152f4b5b57c36cc$exports.isMIUI = $3152f4b5b57c36cc$var$isMIUI;
$3152f4b5b57c36cc$exports.isMacOs = $3152f4b5b57c36cc$var$isMacOs;
$3152f4b5b57c36cc$exports.isMobile = $3152f4b5b57c36cc$var$isMobile;
$3152f4b5b57c36cc$exports.isMobileOnly = $3152f4b5b57c36cc$var$isMobileOnly;
$3152f4b5b57c36cc$exports.isMobileSafari = $3152f4b5b57c36cc$var$isMobileSafari;
$3152f4b5b57c36cc$exports.isOpera = $3152f4b5b57c36cc$var$isOpera;
$3152f4b5b57c36cc$exports.isSafari = $3152f4b5b57c36cc$var$isSafari;
$3152f4b5b57c36cc$exports.isSamsungBrowser = $3152f4b5b57c36cc$var$isSamsungBrowser;
$3152f4b5b57c36cc$exports.isSmartTV = $3152f4b5b57c36cc$var$isSmartTV;
$3152f4b5b57c36cc$exports.isTablet = $3152f4b5b57c36cc$var$isTablet;
$3152f4b5b57c36cc$exports.isWearable = $3152f4b5b57c36cc$var$isWearable;
$3152f4b5b57c36cc$exports.isWinPhone = $3152f4b5b57c36cc$var$isWinPhone;
$3152f4b5b57c36cc$exports.isWindows = $3152f4b5b57c36cc$var$isWindows;
$3152f4b5b57c36cc$exports.isYandex = $3152f4b5b57c36cc$var$isYandex;
$3152f4b5b57c36cc$exports.mobileModel = $3152f4b5b57c36cc$var$mobileModel;
$3152f4b5b57c36cc$exports.mobileVendor = $3152f4b5b57c36cc$var$mobileVendor;
$3152f4b5b57c36cc$exports.osName = $3152f4b5b57c36cc$var$osName;
$3152f4b5b57c36cc$exports.osVersion = $3152f4b5b57c36cc$var$osVersion;
$3152f4b5b57c36cc$exports.parseUserAgent = $3152f4b5b57c36cc$var$parseUserAgent;
$3152f4b5b57c36cc$exports.setUserAgent = $3152f4b5b57c36cc$var$setUserAgent;
$3152f4b5b57c36cc$exports.useDeviceData = $3152f4b5b57c36cc$var$useDeviceData;
$3152f4b5b57c36cc$exports.useDeviceSelectors = $3152f4b5b57c36cc$var$useDeviceSelectors;
$3152f4b5b57c36cc$exports.useMobileOrientation = $3152f4b5b57c36cc$var$useMobileOrientation;
$3152f4b5b57c36cc$exports.withOrientationChange = $3152f4b5b57c36cc$var$withOrientationChange;


var $bf7e93717fb1eb16$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $P551f.createContext)({
    toast: "",
    theme: (0, $93d2089b0ece27e4$export$14faa19a0f3bbeb2).Light,
    loading: false,
    platform: (0, $3152f4b5b57c36cc$exports.isMobile) ? "mobile" : "web",
    termsAgreement: false,
    experienceSettings: undefined,
    isPreview: false,
    setTheme: (0, $96962764729a993e$export$8793edee2d425525),
    setToast: (0, $96962764729a993e$export$8793edee2d425525),
    setLoading: (0, $96962764729a993e$export$8793edee2d425525),
    setPlatform: (0, $96962764729a993e$export$8793edee2d425525),
    setTermsAgreement: (0, $96962764729a993e$export$8793edee2d425525),
    setExperienceSettings: (0, $96962764729a993e$export$8793edee2d425525)
});





parcelRequire("P551f");
const $b1635f4e0acb4fcd$var$SvgLogtoLogoDark = (props)=>/*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("svg", (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({
        width: 52,
        height: 18,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("g", {
                clipPath: "url(#logto-logo-dark_svg__a)",
                fillRule: "evenodd",
                clipRule: "evenodd",
                children: [
                    /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("path", {
                        d: "M1 4.53c0-.374 0-.56.069-.71a.76.76 0 0 1 .28-.324c.138-.09.323-.116.692-.169l5.265-.756c.478-.069.717-.103.903-.03a.759.759 0 0 1 .385.334c.098.173.098.415.098.899v10.452c0 .484 0 .726-.098.9a.759.759 0 0 1-.385.334c-.186.072-.425.038-.903-.03l-5.265-.757c-.37-.053-.554-.08-.692-.169a.759.759 0 0 1-.28-.323C1 14.03 1 13.844 1 13.47V4.53Zm5.308 3.54c0-.111 0-.167.021-.211a.217.217 0 0 1 .086-.093c.042-.025.097-.03.209-.04l.498-.046c.131-.012.197-.018.247.004.045.02.082.053.105.096.026.048.026.114.026.245v1.95c0 .131 0 .197-.026.245a.217.217 0 0 1-.105.096c-.05.022-.116.016-.247.004l-.498-.046c-.112-.01-.167-.015-.21-.04a.217.217 0 0 1-.085-.093c-.02-.044-.02-.1-.02-.212V8.071Zm3.879-4.487H9.45v10.834h.737c.424 0 .637 0 .799-.083a.758.758 0 0 0 .331-.331c.083-.162.083-.375.083-.8V4.797c0-.425 0-.637-.083-.8a.758.758 0 0 0-.331-.331c-.162-.083-.375-.083-.8-.083Z",
                        fill: "#928F9A"
                    }),
                    /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("path", {
                        d: "M1 4.53c0-.374 0-.56.069-.71a.76.76 0 0 1 .28-.324c.138-.09.323-.116.692-.169l5.265-.756c.478-.069.717-.103.903-.03a.759.759 0 0 1 .385.334c.098.173.098.415.098.899v10.452c0 .484 0 .726-.098.9a.759.759 0 0 1-.385.334c-.186.072-.425.038-.903-.03l-5.265-.757c-.37-.053-.554-.08-.692-.169a.759.759 0 0 1-.28-.323C1 14.03 1 13.844 1 13.47V4.53Zm5.308 3.54c0-.111 0-.167.021-.211a.217.217 0 0 1 .086-.093c.042-.025.097-.03.209-.04l.498-.046c.131-.012.197-.018.247.004.045.02.082.053.105.096.026.048.026.114.026.245v1.95c0 .131 0 .197-.026.245a.217.217 0 0 1-.105.096c-.05.022-.116.016-.247.004l-.498-.046c-.112-.01-.167-.015-.21-.04a.217.217 0 0 1-.085-.093c-.02-.044-.02-.1-.02-.212V8.071Zm3.879-4.487H9.45v10.834h.737c.424 0 .637 0 .799-.083a.758.758 0 0 0 .331-.331c.083-.162.083-.375.083-.8V4.797c0-.425 0-.637-.083-.8a.758.758 0 0 0-.331-.331c-.162-.083-.375-.083-.8-.083Z",
                        fill: "url(#logto-logo-dark_svg__b)"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("path", {
                d: "M25.304 13.873c-.747 0-1.393-.156-1.937-.466a3.158 3.158 0 0 1-1.252-1.297c-.292-.563-.437-1.213-.437-1.951 0-.758.15-1.413.451-1.966a3.255 3.255 0 0 1 1.267-1.297c.554-.31 1.2-.466 1.937-.466.748 0 1.389.156 1.923.466.544.311.966.743 1.267 1.297.301.553.451 1.204.451 1.951 0 .738-.155 1.389-.466 1.952a3.23 3.23 0 0 1-1.267 1.31c-.543.302-1.19.457-1.937.467Zm.015-1.413c.408 0 .757-.102 1.048-.306.292-.204.515-.48.67-.83.166-.35.248-.743.248-1.18 0-.446-.078-.845-.233-1.194a1.861 1.861 0 0 0-.67-.816c-.291-.204-.64-.306-1.049-.306a1.8 1.8 0 0 0-1.034.306c-.3.204-.534.48-.699.83-.155.35-.238.743-.247 1.18 0 .447.077.845.233 1.194.155.35.383.627.684.83.301.195.65.292 1.049.292ZM36.5 6.696a.076.076 0 0 0-.077-.076H34.93a.076.076 0 0 0-.076.076v7.453c0 .496-.185.803-.554 1.075-.36.272-.763.36-1.336.37-.398-.01-.772-.045-1.102-.151a6.157 6.157 0 0 1-1.002-.402.077.077 0 0 0-.103.036l-.537 1.144a.074.074 0 0 0 .025.093c.163.112.355.212.574.3.243.096.49.174.743.232.262.068.533.125.766.154.243.03.472.033.618.033.738 0 1.369-.116 1.893-.35.534-.232.942-.563 1.224-.99.29-.427.436-.937.436-1.529V6.696Zm-1.19 4.824a.078.078 0 0 0-.13-.02 3.174 3.174 0 0 1-.85.712 2.002 2.002 0 0 1-1.006.248c-.388 0-.728-.097-1.02-.291a1.901 1.901 0 0 1-.64-.83 3.123 3.123 0 0 1-.219-1.21c0-.436.073-.825.219-1.165.146-.35.36-.626.64-.83a1.757 1.757 0 0 1 1.035-.306c.369 0 .66.078.961.233.281.141.58.462.838.797.035.047.109.038.132-.016l.413-.975a.075.075 0 0 0-.007-.073c-.522-.748-1.404-1.364-2.408-1.364-.728 0-1.303.156-1.837.466-.534.311-.947.743-1.238 1.297-.282.553-.422 1.199-.422 1.937 0 .757.14 1.417.422 1.98.282.554.684.986 1.209 1.297.534.31 1.165.466 1.893.466.272 0 .554-.054.845-.16.301-.098.592-.243.874-.438.27-.185.508-.407.715-.664a.075.075 0 0 0 .01-.076l-.429-1.015ZM41.986 6.754a.076.076 0 0 0-.076-.076h-1.624a.076.076 0 0 1-.077-.076V4.615a.076.076 0 0 0-.076-.076h-1.479a.076.076 0 0 0-.076.076v1.987a.076.076 0 0 1-.076.076h-.99a.076.076 0 0 0-.075.077l.013 1.231c0 .042.034.075.076.075h.976c.042 0 .076.034.076.076v3.434c0 .515.102.952.306 1.311.214.35.505.617.874.801.369.185.816.277 1.34.277.146 0 .3-.02.466-.058a3.23 3.23 0 0 0 .49-.138c.13-.049.383-.176.512-.25a.072.072 0 0 0 .025-.099l-.6-1.06a.078.078 0 0 0-.097-.033 2.279 2.279 0 0 1-.3.091 1.68 1.68 0 0 1-.38.044c-.34 0-.592-.036-.757-.26-.165-.232-.248-.528-.248-.888V8.137c0-.042.034-.076.076-.076h1.625a.076.076 0 0 0 .076-.076V6.754ZM46.406 13.873c-.748 0-1.393-.156-1.937-.466a3.158 3.158 0 0 1-1.252-1.297c-.292-.563-.438-1.213-.438-1.951 0-.758.151-1.413.452-1.966a3.255 3.255 0 0 1 1.267-1.297c.554-.31 1.2-.466 1.937-.466.748 0 1.389.156 1.923.466.544.311.966.743 1.267 1.297.3.553.451 1.204.451 1.951 0 .738-.155 1.389-.466 1.952-.3.563-.723 1-1.267 1.31-.544.302-1.19.457-1.937.467Zm.015-1.413c.407 0 .757-.102 1.048-.306a1.96 1.96 0 0 0 .67-.83 2.73 2.73 0 0 0 .248-1.18c0-.446-.078-.845-.233-1.194a1.86 1.86 0 0 0-.67-.816c-.291-.204-.641-.306-1.049-.306a1.8 1.8 0 0 0-1.034.306c-.3.204-.534.48-.699.83-.155.35-.238.743-.248 1.18 0 .447.078.845.233 1.194.156.35.384.627.685.83.301.195.65.292 1.049.292ZM21.053 12.402a.076.076 0 0 0-.076-.076h-3.91a.076.076 0 0 1-.076-.076V4.235a.076.076 0 0 0-.076-.076h-1.464a.076.076 0 0 0-.077.076v9.562c0 .042.034.076.076.076h5.527a.076.076 0 0 0 .076-.076v-1.395Z",
                fill: "#F7F8F8"
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("linearGradient", {
                        id: "logto-logo-dark_svg__b",
                        x1: -2.219,
                        y1: 11.49,
                        x2: 10.737,
                        y2: 6.406,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("stop", {
                                stopColor: "#4B2EFB"
                            }),
                            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#E65FFC"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("clipPath", {
                        id: "logto-logo-dark_svg__a",
                        children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("path", {
                            fill: "#fff",
                            transform: "translate(1 2.5)",
                            d: "M0 0h10.4v13H0z"
                        })
                    })
                ]
            })
        ]
    }));
var $b1635f4e0acb4fcd$export$2e2bcd8739ae039 = $b1635f4e0acb4fcd$var$SvgLogtoLogoDark;





parcelRequire("P551f");
const $97e472c8b66bd97d$var$SvgLogtoLogoLight = (props)=>/*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("svg", (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({
        width: 52,
        height: 18,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("g", {
                clipPath: "url(#logto-logo-light_svg__a)",
                fillRule: "evenodd",
                clipRule: "evenodd",
                children: [
                    /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("path", {
                        d: "M1 4.53c0-.374 0-.56.069-.71a.76.76 0 0 1 .28-.324c.138-.09.323-.116.692-.169l5.265-.756c.478-.069.717-.103.903-.03a.759.759 0 0 1 .385.334c.098.173.098.415.098.899v10.452c0 .484 0 .726-.098.9a.759.759 0 0 1-.385.334c-.186.072-.425.038-.903-.03l-5.265-.757c-.37-.053-.554-.08-.692-.169a.759.759 0 0 1-.28-.323C1 14.03 1 13.844 1 13.47V4.53Zm5.308 3.54c0-.111 0-.167.021-.211a.217.217 0 0 1 .086-.093c.042-.025.097-.03.209-.04l.498-.046c.131-.012.197-.018.247.004.045.02.082.053.105.096.026.048.026.114.026.245v1.95c0 .131 0 .197-.026.245a.217.217 0 0 1-.105.096c-.05.022-.116.016-.247.004l-.498-.046c-.112-.01-.167-.015-.21-.04a.217.217 0 0 1-.085-.093c-.02-.044-.02-.1-.02-.212V8.071Zm3.879-4.487H9.45v10.834h.737c.424 0 .637 0 .799-.083a.758.758 0 0 0 .331-.331c.083-.162.083-.375.083-.8V4.797c0-.425 0-.637-.083-.8a.758.758 0 0 0-.331-.331c-.162-.083-.375-.083-.8-.083Z",
                        fill: "#928F9A"
                    }),
                    /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("path", {
                        d: "M1 4.53c0-.374 0-.56.069-.71a.76.76 0 0 1 .28-.324c.138-.09.323-.116.692-.169l5.265-.756c.478-.069.717-.103.903-.03a.759.759 0 0 1 .385.334c.098.173.098.415.098.899v10.452c0 .484 0 .726-.098.9a.759.759 0 0 1-.385.334c-.186.072-.425.038-.903-.03l-5.265-.757c-.37-.053-.554-.08-.692-.169a.759.759 0 0 1-.28-.323C1 14.03 1 13.844 1 13.47V4.53Zm5.308 3.54c0-.111 0-.167.021-.211a.217.217 0 0 1 .086-.093c.042-.025.097-.03.209-.04l.498-.046c.131-.012.197-.018.247.004.045.02.082.053.105.096.026.048.026.114.026.245v1.95c0 .131 0 .197-.026.245a.217.217 0 0 1-.105.096c-.05.022-.116.016-.247.004l-.498-.046c-.112-.01-.167-.015-.21-.04a.217.217 0 0 1-.085-.093c-.02-.044-.02-.1-.02-.212V8.071Zm3.879-4.487H9.45v10.834h.737c.424 0 .637 0 .799-.083a.758.758 0 0 0 .331-.331c.083-.162.083-.375.083-.8V4.797c0-.425 0-.637-.083-.8a.758.758 0 0 0-.331-.331c-.162-.083-.375-.083-.8-.083Z",
                        fill: "url(#logto-logo-light_svg__b)"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("path", {
                d: "M25.304 13.873c-.747 0-1.393-.156-1.937-.466a3.158 3.158 0 0 1-1.252-1.297c-.292-.563-.437-1.213-.437-1.951 0-.758.15-1.413.451-1.966a3.255 3.255 0 0 1 1.267-1.297c.554-.31 1.2-.466 1.937-.466.748 0 1.389.156 1.923.466.544.311.966.743 1.267 1.297.301.553.451 1.204.451 1.951 0 .738-.155 1.389-.466 1.952a3.23 3.23 0 0 1-1.267 1.31c-.543.302-1.19.457-1.937.467Zm.015-1.413c.408 0 .757-.102 1.048-.306.292-.204.515-.48.67-.83.166-.35.248-.743.248-1.18 0-.446-.078-.845-.233-1.194a1.861 1.861 0 0 0-.67-.816c-.291-.204-.64-.306-1.049-.306a1.8 1.8 0 0 0-1.034.306c-.3.204-.534.48-.699.83-.155.35-.238.743-.247 1.18 0 .447.077.845.233 1.194.155.35.383.627.684.83.301.195.65.292 1.049.292ZM36.5 6.696a.076.076 0 0 0-.077-.076H34.93a.076.076 0 0 0-.076.076v7.453c0 .496-.185.803-.554 1.075-.36.272-.763.36-1.336.37-.398-.01-.772-.045-1.102-.151a6.157 6.157 0 0 1-1.002-.402.077.077 0 0 0-.103.036l-.537 1.144a.074.074 0 0 0 .025.093c.163.112.355.212.574.3.243.096.49.174.743.232.262.068.533.125.766.154.243.03.472.033.618.033.738 0 1.369-.116 1.893-.35.534-.232.942-.563 1.224-.99.29-.427.436-.937.436-1.529V6.696Zm-1.19 4.824a.078.078 0 0 0-.13-.02 3.174 3.174 0 0 1-.85.712 2.002 2.002 0 0 1-1.006.248c-.388 0-.728-.097-1.02-.291a1.901 1.901 0 0 1-.64-.83 3.123 3.123 0 0 1-.219-1.21c0-.436.073-.825.219-1.165.146-.35.36-.626.64-.83a1.757 1.757 0 0 1 1.035-.306c.369 0 .66.078.961.233.281.141.58.462.838.797.035.047.109.038.132-.016l.413-.975a.075.075 0 0 0-.007-.073c-.522-.748-1.404-1.364-2.408-1.364-.728 0-1.303.156-1.837.466-.534.311-.947.743-1.238 1.297-.282.553-.422 1.199-.422 1.937 0 .757.14 1.417.422 1.98.282.554.684.986 1.209 1.297.534.31 1.165.466 1.893.466.272 0 .554-.054.845-.16.301-.098.592-.243.874-.438.27-.185.508-.407.715-.664a.075.075 0 0 0 .01-.076l-.429-1.015ZM41.986 6.754a.076.076 0 0 0-.076-.076h-1.624a.076.076 0 0 1-.077-.076V4.615a.076.076 0 0 0-.076-.076h-1.479a.076.076 0 0 0-.076.076v1.987a.076.076 0 0 1-.076.076h-.99a.076.076 0 0 0-.075.077l.013 1.231c0 .042.034.075.076.075h.976c.042 0 .076.034.076.076v3.434c0 .515.102.952.306 1.311.214.35.505.617.874.801.369.185.816.277 1.34.277.146 0 .3-.02.466-.058.175-.039.344-.08.49-.138.13-.049.383-.176.512-.25a.072.072 0 0 0 .025-.099l-.6-1.06a.078.078 0 0 0-.097-.033 2.279 2.279 0 0 1-.3.091 1.68 1.68 0 0 1-.38.044c-.34 0-.592-.036-.757-.26-.165-.232-.248-.528-.248-.888V8.137c0-.042.034-.076.076-.076h1.625a.076.076 0 0 0 .076-.076V6.754ZM46.406 13.873c-.748 0-1.393-.156-1.937-.466a3.158 3.158 0 0 1-1.252-1.297c-.292-.563-.438-1.213-.438-1.951 0-.758.151-1.413.452-1.966a3.255 3.255 0 0 1 1.267-1.297c.554-.31 1.2-.466 1.937-.466.748 0 1.389.156 1.923.466.544.311.966.743 1.267 1.297.3.553.451 1.204.451 1.951 0 .738-.155 1.389-.466 1.952-.3.563-.723 1-1.267 1.31-.544.302-1.19.457-1.937.467Zm.015-1.413c.407 0 .757-.102 1.048-.306a1.96 1.96 0 0 0 .67-.83 2.73 2.73 0 0 0 .248-1.18c0-.446-.078-.845-.233-1.194a1.86 1.86 0 0 0-.67-.816c-.291-.204-.641-.306-1.049-.306a1.8 1.8 0 0 0-1.034.306c-.3.204-.534.48-.699.83-.155.35-.238.743-.248 1.18 0 .447.078.845.233 1.194.156.35.384.627.685.83.301.195.65.292 1.049.292ZM21.053 12.402a.076.076 0 0 0-.076-.076h-3.91a.076.076 0 0 1-.076-.076V4.235a.076.076 0 0 0-.076-.076h-1.464a.076.076 0 0 0-.077.076v9.562c0 .042.034.076.076.076h5.527a.076.076 0 0 0 .076-.076v-1.395Z",
                fill: "#191C1D"
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("linearGradient", {
                        id: "logto-logo-light_svg__b",
                        x1: -2.219,
                        y1: 11.49,
                        x2: 10.737,
                        y2: 6.406,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("stop", {
                                stopColor: "#4B2EFB"
                            }),
                            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#E65FFC"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("clipPath", {
                        id: "logto-logo-light_svg__a",
                        children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("path", {
                            fill: "#fff",
                            transform: "translate(1 2.5)",
                            d: "M0 0h10.4v13H0z"
                        })
                    })
                ]
            })
        ]
    }));
var $97e472c8b66bd97d$export$2e2bcd8739ae039 = $97e472c8b66bd97d$var$SvgLogtoLogoLight;





parcelRequire("P551f");
const $cb70f1dd16cacb5b$var$SvgLogtoLogoShadow = (props)=>/*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("svg", (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({
        width: 52,
        height: 18,
        fill: "currentcolor",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("g", {
                opacity: 0.8,
                clipPath: "url(#logto-logo-shadow_svg__a)",
                children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M1 4.53c0-.374 0-.56.069-.71a.76.76 0 0 1 .28-.324c.138-.09.323-.116.692-.169l5.265-.756c.478-.069.717-.103.903-.03a.759.759 0 0 1 .385.334c.098.173.098.415.098.899v10.452c0 .484 0 .726-.098.9a.759.759 0 0 1-.385.334c-.186.072-.425.038-.903-.03l-5.265-.757c-.37-.053-.554-.08-.692-.169a.759.759 0 0 1-.28-.323C1 14.03 1 13.844 1 13.47V4.53Zm5.308 3.54c0-.111 0-.167.021-.211a.217.217 0 0 1 .086-.093c.042-.025.097-.03.209-.04l.498-.046c.131-.012.197-.018.247.004.045.02.082.053.105.096.026.048.026.114.026.245v1.95c0 .131 0 .197-.026.245a.217.217 0 0 1-.105.096c-.05.022-.116.016-.247.004l-.498-.046c-.112-.01-.167-.015-.21-.04a.217.217 0 0 1-.085-.093c-.02-.044-.02-.1-.02-.212V8.071Zm3.879-4.487H9.45v10.834h.737c.424 0 .637 0 .799-.083a.758.758 0 0 0 .331-.331c.083-.162.083-.375.083-.8V4.797c0-.425 0-.637-.083-.8a.758.758 0 0 0-.331-.331c-.162-.083-.375-.083-.8-.083Z"
                })
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("path", {
                d: "M25.304 13.873c-.747 0-1.393-.156-1.937-.466a3.158 3.158 0 0 1-1.252-1.297c-.292-.563-.437-1.213-.437-1.951 0-.758.15-1.413.451-1.966a3.255 3.255 0 0 1 1.267-1.297c.554-.31 1.2-.466 1.937-.466.748 0 1.389.156 1.923.466.544.311.966.743 1.267 1.297.301.553.451 1.204.451 1.951 0 .738-.155 1.389-.466 1.952a3.23 3.23 0 0 1-1.267 1.31c-.543.302-1.19.457-1.937.467Zm.015-1.413c.408 0 .757-.102 1.048-.306.292-.204.515-.48.67-.83.166-.35.248-.743.248-1.18 0-.446-.078-.845-.233-1.194a1.861 1.861 0 0 0-.67-.816c-.291-.204-.64-.306-1.049-.306a1.8 1.8 0 0 0-1.034.306c-.3.204-.534.48-.699.83-.155.35-.238.743-.247 1.18 0 .447.077.845.233 1.194.155.35.383.627.684.83.301.195.65.292 1.049.292ZM36.5 6.696a.076.076 0 0 0-.077-.076H34.93a.076.076 0 0 0-.076.076v7.453c0 .496-.185.803-.554 1.075-.36.272-.763.36-1.336.37-.398-.01-.772-.045-1.102-.151a6.157 6.157 0 0 1-1.002-.402.077.077 0 0 0-.103.036l-.537 1.144a.074.074 0 0 0 .025.093c.163.112.355.212.574.3.243.096.49.174.743.232.262.068.533.125.766.154.243.03.472.033.618.033.738 0 1.369-.116 1.893-.35.534-.232.942-.563 1.224-.99.29-.427.436-.937.436-1.529V6.696Zm-1.19 4.824a.078.078 0 0 0-.13-.02 3.174 3.174 0 0 1-.85.712 2.002 2.002 0 0 1-1.006.248c-.388 0-.728-.097-1.02-.291a1.901 1.901 0 0 1-.64-.83 3.123 3.123 0 0 1-.219-1.21c0-.436.073-.825.219-1.165.146-.35.36-.626.64-.83a1.757 1.757 0 0 1 1.035-.306c.369 0 .66.078.961.233.281.141.58.462.838.797.035.047.109.038.132-.016l.413-.975a.075.075 0 0 0-.007-.073c-.522-.748-1.404-1.364-2.408-1.364-.728 0-1.303.156-1.837.466-.534.311-.947.743-1.238 1.297-.282.553-.422 1.199-.422 1.937 0 .757.14 1.417.422 1.98.282.554.684.986 1.209 1.297.534.31 1.165.466 1.893.466.272 0 .554-.054.845-.16.301-.098.592-.243.874-.438.27-.185.508-.407.715-.664a.075.075 0 0 0 .01-.076l-.429-1.015ZM41.986 6.754a.076.076 0 0 0-.076-.076h-1.624a.076.076 0 0 1-.077-.076V4.615a.076.076 0 0 0-.076-.076h-1.479a.076.076 0 0 0-.076.076v1.987a.076.076 0 0 1-.076.076h-.99a.076.076 0 0 0-.075.077l.013 1.231c0 .042.034.075.076.075h.976c.042 0 .076.034.076.076v3.434c0 .515.102.952.306 1.311.214.35.505.617.874.801.369.185.816.277 1.34.277.146 0 .3-.02.466-.058a3.23 3.23 0 0 0 .49-.138c.13-.049.383-.176.512-.25a.072.072 0 0 0 .025-.099l-.6-1.06a.078.078 0 0 0-.097-.033 2.279 2.279 0 0 1-.3.091 1.68 1.68 0 0 1-.38.044c-.34 0-.592-.036-.757-.26-.165-.232-.248-.528-.248-.888V8.137c0-.042.034-.076.076-.076h1.625a.076.076 0 0 0 .076-.076V6.754ZM46.406 13.873c-.748 0-1.393-.156-1.937-.466a3.158 3.158 0 0 1-1.252-1.297c-.292-.563-.438-1.213-.438-1.951 0-.758.151-1.413.452-1.966a3.255 3.255 0 0 1 1.267-1.297c.554-.31 1.2-.466 1.937-.466.748 0 1.389.156 1.923.466.544.311.966.743 1.267 1.297.3.553.451 1.204.451 1.951 0 .738-.155 1.389-.466 1.952-.3.563-.723 1-1.267 1.31-.544.302-1.19.457-1.937.467Zm.015-1.413c.407 0 .757-.102 1.048-.306a1.96 1.96 0 0 0 .67-.83 2.73 2.73 0 0 0 .248-1.18c0-.446-.078-.845-.233-1.194a1.86 1.86 0 0 0-.67-.816c-.291-.204-.641-.306-1.049-.306a1.8 1.8 0 0 0-1.034.306c-.3.204-.534.48-.699.83-.155.35-.238.743-.248 1.18 0 .447.078.845.233 1.194.156.35.384.627.685.83.301.195.65.292 1.049.292ZM21.053 12.402a.076.076 0 0 0-.076-.076h-3.91a.076.076 0 0 1-.076-.076V4.235a.076.076 0 0 0-.076-.076h-1.464a.076.076 0 0 0-.077.076v9.562c0 .042.034.076.076.076h5.527a.076.076 0 0 0 .076-.076v-1.395Z"
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("clipPath", {
                    id: "logto-logo-shadow_svg__a",
                    children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("path", {
                        fill: "#fff",
                        transform: "translate(1 2.5)",
                        d: "M0 0h10.4v13H0z"
                    })
                })
            })
        ]
    }));
var $cb70f1dd16cacb5b$export$2e2bcd8739ae039 = $cb70f1dd16cacb5b$var$SvgLogtoLogoShadow;


var $90c36da74f5de233$export$1e394180dfc32a3c;
var $90c36da74f5de233$export$c9cd164b539ebb63;
var $90c36da74f5de233$export$e3dbcf7481dc9d;
var $90c36da74f5de233$export$6f093cfa640b7166;
$90c36da74f5de233$export$1e394180dfc32a3c = `uuY68G_highlightIcon`;
$90c36da74f5de233$export$c9cd164b539ebb63 = `uuY68G_signature`;
$90c36da74f5de233$export$e3dbcf7481dc9d = `uuY68G_staticIcon`;
$90c36da74f5de233$export$6f093cfa640b7166 = `uuY68G_text`;


const $63e5b7f0d12b6aa8$var$logtoUrl = `https://logto.io/?${new URLSearchParams({
    utm_source: "sign_in",
    utm_medium: "powered_by"
}).toString()}`;
const $63e5b7f0d12b6aa8$var$LogtoSignature = ({ className: className })=>{
    const { theme: theme } = (0, $P551f.useContext)((0, $bf7e93717fb1eb16$export$2e2bcd8739ae039));
    const LogtoLogo = theme === (0, $93d2089b0ece27e4$export$14faa19a0f3bbeb2).Light ? (0, $97e472c8b66bd97d$export$2e2bcd8739ae039) : (0, $b1635f4e0acb4fcd$export$2e2bcd8739ae039);
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("a", {
            className: $90c36da74f5de233$export$c9cd164b539ebb63,
            "aria-label": "Powered By Logto",
            href: $63e5b7f0d12b6aa8$var$logtoUrl.toString(),
            target: "_blank",
            rel: "noopener",
            children: [
                /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("span", {
                    className: $90c36da74f5de233$export$6f093cfa640b7166,
                    children: "Powered by"
                }),
                /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $cb70f1dd16cacb5b$export$2e2bcd8739ae039), {
                    className: $90c36da74f5de233$export$e3dbcf7481dc9d
                }),
                /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)(LogtoLogo, {
                    className: $90c36da74f5de233$export$1e394180dfc32a3c
                })
            ]
        })
    });
};
var $63e5b7f0d12b6aa8$export$2e2bcd8739ae039 = $63e5b7f0d12b6aa8$var$LogtoSignature;





var $P551f = parcelRequire("P551f");
function $8a8a81e4d7494bfa$export$2e2bcd8739ae039(obj) {
    "@babel/helpers - typeof";
    return $8a8a81e4d7494bfa$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $8a8a81e4d7494bfa$export$2e2bcd8739ae039(obj);
}



function $4c194386646fb7bc$export$2e2bcd8739ae039(input, hint) {
    if ((0, $8a8a81e4d7494bfa$export$2e2bcd8739ae039)(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((0, $8a8a81e4d7494bfa$export$2e2bcd8739ae039)(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}


function $212fad89f87b96a9$export$2e2bcd8739ae039(arg) {
    var key = (0, $4c194386646fb7bc$export$2e2bcd8739ae039)(arg, "string");
    return (0, $8a8a81e4d7494bfa$export$2e2bcd8739ae039)(key) === "symbol" ? key : String(key);
}


function $7c55c7e50dabe3fa$export$2e2bcd8739ae039(obj, key, value) {
    key = (0, $212fad89f87b96a9$export$2e2bcd8739ae039)(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $0ebd6b4eed041417$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


function $79d3e505593004f1$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = (0, $0ebd6b4eed041417$export$2e2bcd8739ae039)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}



var $P551f = parcelRequire("P551f");




var $P551f = parcelRequire("P551f");
var $cee7970d31ce2b54$exports = {};
/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */ $cee7970d31ce2b54$exports = {
    "area": true,
    "base": true,
    "br": true,
    "col": true,
    "embed": true,
    "hr": true,
    "img": true,
    "input": true,
    "link": true,
    "meta": true,
    "param": true,
    "source": true,
    "track": true,
    "wbr": true
};


var $76882d1fe5614459$var$t = /\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?(".*?"|'.*?')/g;
function $76882d1fe5614459$var$n(n) {
    var r = {
        type: "tag",
        name: "",
        voidElement: !1,
        attrs: {},
        children: []
    }, i = n.match(/<\/?([^\s]+?)[/\s>]/);
    if (i && (r.name = i[1], ((0, (/*@__PURE__*/$parcel$interopDefault($cee7970d31ce2b54$exports)))[i[1]] || "/" === n.charAt(n.length - 2)) && (r.voidElement = !0), r.name.startsWith("!--"))) {
        var s = n.indexOf("-->");
        return {
            type: "comment",
            comment: -1 !== s ? n.slice(4, s) : ""
        };
    }
    for(var a = new RegExp($76882d1fe5614459$var$t), c = null; null !== (c = a.exec(n));)if (c[0].trim()) {
        if (c[1]) {
            var o = c[1].trim(), l = [
                o,
                ""
            ];
            o.indexOf("=") > -1 && (l = o.split("=")), r.attrs[l[0]] = l[1], a.lastIndex--;
        } else c[2] && (r.attrs[c[2]] = c[3].trim().substring(1, c[3].length - 1));
    }
    return r;
}
var $76882d1fe5614459$var$r = /<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g, $76882d1fe5614459$var$i = /^\s*$/, $76882d1fe5614459$var$s = Object.create(null);
function $76882d1fe5614459$var$a(e, t) {
    switch(t.type){
        case "text":
            return e + t.content;
        case "tag":
            return e += "<" + t.name + (t.attrs ? function(e) {
                var t = [];
                for(var n in e)t.push(n + '="' + e[n] + '"');
                return t.length ? " " + t.join(" ") : "";
            }(t.attrs) : "") + (t.voidElement ? "/>" : ">"), t.voidElement ? e : e + t.children.reduce($76882d1fe5614459$var$a, "") + "</" + t.name + ">";
        case "comment":
            return e + "<!--" + t.comment + "-->";
    }
}
var $76882d1fe5614459$var$c = {
    parse: function(e, t) {
        t || (t = {}), t.components || (t.components = $76882d1fe5614459$var$s);
        var a, c = [], o = [], l = -1, m = !1;
        if (0 !== e.indexOf("<")) {
            var u = e.indexOf("<");
            c.push({
                type: "text",
                content: -1 === u ? e : e.substring(0, u)
            });
        }
        return e.replace($76882d1fe5614459$var$r, function(r, s) {
            if (m) {
                if (r !== "</" + a.name + ">") return;
                m = !1;
            }
            var u, f = "/" !== r.charAt(1), h = r.startsWith("<!--"), p = s + r.length, d = e.charAt(p);
            if (h) {
                var v = $76882d1fe5614459$var$n(r);
                return l < 0 ? (c.push(v), c) : ((u = o[l]).children.push(v), c);
            }
            if (f && (l++, "tag" === (a = $76882d1fe5614459$var$n(r)).type && t.components[a.name] && (a.type = "component", m = !0), a.voidElement || m || !d || "<" === d || a.children.push({
                type: "text",
                content: e.slice(p, e.indexOf("<", p))
            }), 0 === l && c.push(a), (u = o[l - 1]) && u.children.push(a), o[l] = a), (!f || a.voidElement) && (l > -1 && (a.voidElement || a.name === r.slice(2, -1)) && (l--, a = -1 === l ? c : o[l]), !m && "<" !== d && d)) {
                u = -1 === l ? c : o[l].children;
                var x = e.indexOf("<", p), g = e.slice(p, -1 === x ? void 0 : x);
                $76882d1fe5614459$var$i.test(g) && (g = " "), (x > -1 && l + u.length >= 0 || " " !== g) && u.push({
                    type: "text",
                    content: g
                });
            }
        }), c;
    },
    stringify: function(e) {
        return e.reduce(function(e, t) {
            return e + $76882d1fe5614459$var$a("", t);
        }, "");
    }
};
var $76882d1fe5614459$export$2e2bcd8739ae039 = $76882d1fe5614459$var$c;


function $4e3ca914f9fd936a$export$c106dd0671a0fc2d() {
    if (console && console.warn) {
        var _console;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (typeof args[0] === "string") args[0] = "react-i18next:: ".concat(args[0]);
        (_console = console).warn.apply(_console, args);
    }
}
var $4e3ca914f9fd936a$var$alreadyWarned = {};
function $4e3ca914f9fd936a$export$5b28268982f175ba() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    if (typeof args[0] === "string" && $4e3ca914f9fd936a$var$alreadyWarned[args[0]]) return;
    if (typeof args[0] === "string") $4e3ca914f9fd936a$var$alreadyWarned[args[0]] = new Date();
    $4e3ca914f9fd936a$export$c106dd0671a0fc2d.apply(void 0, args);
}
var $4e3ca914f9fd936a$var$loadedClb = function loadedClb(i18n, cb) {
    return function() {
        if (i18n.isInitialized) cb();
        else {
            var initialized = function initialized() {
                setTimeout(function() {
                    i18n.off("initialized", initialized);
                }, 0);
                cb();
            };
            i18n.on("initialized", initialized);
        }
    };
};
function $4e3ca914f9fd936a$export$83be934b53fff43b(i18n, ns, cb) {
    i18n.loadNamespaces(ns, $4e3ca914f9fd936a$var$loadedClb(i18n, cb));
}
function $4e3ca914f9fd936a$export$8cd7e7a54fa865bc(i18n, lng, ns, cb) {
    if (typeof ns === "string") ns = [
        ns
    ];
    ns.forEach(function(n) {
        if (i18n.options.ns.indexOf(n) < 0) i18n.options.ns.push(n);
    });
    i18n.loadLanguages(lng, $4e3ca914f9fd936a$var$loadedClb(i18n, cb));
}
function $4e3ca914f9fd936a$var$oldI18nextHasLoadedNamespace(ns, i18n) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var lng = i18n.languages[0];
    var fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
    var lastLng = i18n.languages[i18n.languages.length - 1];
    if (lng.toLowerCase() === "cimode") return true;
    var loadNotPending = function loadNotPending(l, n) {
        var loadState = i18n.services.backendConnector.state["".concat(l, "|").concat(n)];
        return loadState === -1 || loadState === 2;
    };
    if (options.bindI18n && options.bindI18n.indexOf("languageChanging") > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
    if (i18n.hasResourceBundle(lng, ns)) return true;
    if (!i18n.services.backendConnector.backend || i18n.options.resources && !i18n.options.partialBundledLanguages) return true;
    if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
    return false;
}
function $4e3ca914f9fd936a$export$93d9ee97c1ad3f31(ns, i18n) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!i18n.languages || !i18n.languages.length) {
        $4e3ca914f9fd936a$export$5b28268982f175ba("i18n.languages were undefined or empty", i18n.languages);
        return true;
    }
    var isNewerI18next = i18n.options.ignoreJSONStructure !== undefined;
    if (!isNewerI18next) return $4e3ca914f9fd936a$var$oldI18nextHasLoadedNamespace(ns, i18n, options);
    return i18n.hasLoadedNamespace(ns, {
        lng: options.lng,
        precheck: function precheck(i18nInstance, loadNotPending) {
            if (options.bindI18n && options.bindI18n.indexOf("languageChanging") > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
        }
    });
}
function $4e3ca914f9fd936a$export$be63e0664592e141(Component) {
    return Component.displayName || Component.name || (typeof Component === "string" && Component.length > 0 ? Component : "Unknown");
}



var $95c16140ca32647b$var$matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
var $95c16140ca32647b$var$htmlEntities = {
    "&amp;": "&",
    "&#38;": "&",
    "&lt;": "<",
    "&#60;": "<",
    "&gt;": ">",
    "&#62;": ">",
    "&apos;": "'",
    "&#39;": "'",
    "&quot;": '"',
    "&#34;": '"',
    "&nbsp;": " ",
    "&#160;": " ",
    "&copy;": "\xa9",
    "&#169;": "\xa9",
    "&reg;": "\xae",
    "&#174;": "\xae",
    "&hellip;": "…",
    "&#8230;": "…",
    "&#x2F;": "/",
    "&#47;": "/"
};
var $95c16140ca32647b$var$unescapeHtmlEntity = function unescapeHtmlEntity(m) {
    return $95c16140ca32647b$var$htmlEntities[m];
};
var $95c16140ca32647b$export$e8bacd2802a88316 = function unescape(text) {
    return text.replace($95c16140ca32647b$var$matchHtmlEntity, $95c16140ca32647b$var$unescapeHtmlEntity);
};


function $edb13efe2328c827$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $edb13efe2328c827$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $edb13efe2328c827$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $7c55c7e50dabe3fa$export$2e2bcd8739ae039)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $edb13efe2328c827$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $edb13efe2328c827$var$defaultOptions = {
    bindI18n: "languageChanged",
    bindI18nStore: "",
    transEmptyNodeValue: "",
    transSupportBasicHtmlNodes: true,
    transWrapTextNodes: "",
    transKeepBasicHtmlNodesFor: [
        "br",
        "strong",
        "i",
        "p"
    ],
    useSuspense: true,
    unescape: (0, $95c16140ca32647b$export$e8bacd2802a88316)
};
function $edb13efe2328c827$export$2e2366488d12e20d() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    $edb13efe2328c827$var$defaultOptions = $edb13efe2328c827$var$_objectSpread($edb13efe2328c827$var$_objectSpread({}, $edb13efe2328c827$var$defaultOptions), options);
}
function $edb13efe2328c827$export$212bb2fc580a90a8() {
    return $edb13efe2328c827$var$defaultOptions;
}


var $74eea5b91afbe181$var$i18nInstance;
function $74eea5b91afbe181$export$a039134f2fc7e0(instance) {
    $74eea5b91afbe181$var$i18nInstance = instance;
}
function $74eea5b91afbe181$export$64af334f494c2f47() {
    return $74eea5b91afbe181$var$i18nInstance;
}


var $02e9f7067c1ec6a6$var$_excluded = [
    "format"
], $02e9f7067c1ec6a6$var$_excluded2 = [
    "children",
    "count",
    "parent",
    "i18nKey",
    "context",
    "tOptions",
    "values",
    "defaults",
    "components",
    "ns",
    "i18n",
    "t",
    "shouldUnescape"
];
function $02e9f7067c1ec6a6$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $02e9f7067c1ec6a6$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $02e9f7067c1ec6a6$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $7c55c7e50dabe3fa$export$2e2bcd8739ae039)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $02e9f7067c1ec6a6$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $02e9f7067c1ec6a6$var$hasChildren(node, checkLength) {
    if (!node) return false;
    var base = node.props ? node.props.children : node.children;
    if (checkLength) return base.length > 0;
    return !!base;
}
function $02e9f7067c1ec6a6$var$getChildren(node) {
    if (!node) return [];
    return node.props ? node.props.children : node.children;
}
function $02e9f7067c1ec6a6$var$hasValidReactChildren(children) {
    if (Object.prototype.toString.call(children) !== "[object Array]") return false;
    return children.every(function(child) {
        return (0, $P551f.isValidElement)(child);
    });
}
function $02e9f7067c1ec6a6$var$getAsArray(data) {
    return Array.isArray(data) ? data : [
        data
    ];
}
function $02e9f7067c1ec6a6$var$mergeProps(source, target) {
    var newTarget = $02e9f7067c1ec6a6$var$_objectSpread({}, target);
    newTarget.props = Object.assign(source.props, target.props);
    return newTarget;
}
function $02e9f7067c1ec6a6$export$4f7a36dd898f1267(children, i18nOptions) {
    if (!children) return "";
    var stringNode = "";
    var childrenArray = $02e9f7067c1ec6a6$var$getAsArray(children);
    var keepArray = i18nOptions.transSupportBasicHtmlNodes && i18nOptions.transKeepBasicHtmlNodesFor ? i18nOptions.transKeepBasicHtmlNodesFor : [];
    childrenArray.forEach(function(child, childIndex) {
        if (typeof child === "string") stringNode += "".concat(child);
        else if ((0, $P551f.isValidElement)(child)) {
            var childPropsCount = Object.keys(child.props).length;
            var shouldKeepChild = keepArray.indexOf(child.type) > -1;
            var childChildren = child.props.children;
            if (!childChildren && shouldKeepChild && childPropsCount === 0) stringNode += "<".concat(child.type, "/>");
            else if (!childChildren && (!shouldKeepChild || childPropsCount !== 0)) stringNode += "<".concat(childIndex, "></").concat(childIndex, ">");
            else if (child.props.i18nIsDynamicList) stringNode += "<".concat(childIndex, "></").concat(childIndex, ">");
            else if (shouldKeepChild && childPropsCount === 1 && typeof childChildren === "string") stringNode += "<".concat(child.type, ">").concat(childChildren, "</").concat(child.type, ">");
            else {
                var content = $02e9f7067c1ec6a6$export$4f7a36dd898f1267(childChildren, i18nOptions);
                stringNode += "<".concat(childIndex, ">").concat(content, "</").concat(childIndex, ">");
            }
        } else if (child === null) (0, $4e3ca914f9fd936a$export$c106dd0671a0fc2d)("Trans: the passed in value is invalid - seems you passed in a null child.");
        else if ((0, $8a8a81e4d7494bfa$export$2e2bcd8739ae039)(child) === "object") {
            var format = child.format, clone = (0, $79d3e505593004f1$export$2e2bcd8739ae039)(child, $02e9f7067c1ec6a6$var$_excluded);
            var keys = Object.keys(clone);
            if (keys.length === 1) {
                var value = format ? "".concat(keys[0], ", ").concat(format) : keys[0];
                stringNode += "{{".concat(value, "}}");
            } else (0, $4e3ca914f9fd936a$export$c106dd0671a0fc2d)("react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.", child);
        } else (0, $4e3ca914f9fd936a$export$c106dd0671a0fc2d)("Trans: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.", child);
    });
    return stringNode;
}
function $02e9f7067c1ec6a6$var$renderNodes(children, targetString, i18n, i18nOptions, combinedTOpts, shouldUnescape) {
    if (targetString === "") return [];
    var keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
    var emptyChildrenButNeedsHandling = targetString && new RegExp(keepArray.join("|")).test(targetString);
    if (!children && !emptyChildrenButNeedsHandling) return [
        targetString
    ];
    var data = {};
    function getData(childs) {
        var childrenArray = $02e9f7067c1ec6a6$var$getAsArray(childs);
        childrenArray.forEach(function(child) {
            if (typeof child === "string") return;
            if ($02e9f7067c1ec6a6$var$hasChildren(child)) getData($02e9f7067c1ec6a6$var$getChildren(child));
            else if ((0, $8a8a81e4d7494bfa$export$2e2bcd8739ae039)(child) === "object" && !(0, $P551f.isValidElement)(child)) Object.assign(data, child);
        });
    }
    getData(children);
    var ast = (0, $76882d1fe5614459$export$2e2bcd8739ae039).parse("<0>".concat(targetString, "</0>"));
    var opts = $02e9f7067c1ec6a6$var$_objectSpread($02e9f7067c1ec6a6$var$_objectSpread({}, data), combinedTOpts);
    function renderInner(child, node, rootReactNode) {
        var childs = $02e9f7067c1ec6a6$var$getChildren(child);
        var mappedChildren = mapAST(childs, node.children, rootReactNode);
        return $02e9f7067c1ec6a6$var$hasValidReactChildren(childs) && mappedChildren.length === 0 ? childs : mappedChildren;
    }
    function pushTranslatedJSX(child, inner, mem, i, isVoid) {
        if (child.dummy) child.children = inner;
        mem.push((0, $P551f.cloneElement)(child, $02e9f7067c1ec6a6$var$_objectSpread($02e9f7067c1ec6a6$var$_objectSpread({}, child.props), {}, {
            key: i
        }), isVoid ? undefined : inner));
    }
    function mapAST(reactNode, astNode, rootReactNode) {
        var reactNodes = $02e9f7067c1ec6a6$var$getAsArray(reactNode);
        var astNodes = $02e9f7067c1ec6a6$var$getAsArray(astNode);
        return astNodes.reduce(function(mem, node, i) {
            var translationContent = node.children && node.children[0] && node.children[0].content && i18n.services.interpolator.interpolate(node.children[0].content, opts, i18n.language);
            if (node.type === "tag") {
                var tmp = reactNodes[parseInt(node.name, 10)];
                if (!tmp && rootReactNode.length === 1 && rootReactNode[0][node.name]) tmp = rootReactNode[0][node.name];
                if (!tmp) tmp = {};
                var child = Object.keys(node.attrs).length !== 0 ? $02e9f7067c1ec6a6$var$mergeProps({
                    props: node.attrs
                }, tmp) : tmp;
                var isElement = (0, $P551f.isValidElement)(child);
                var isValidTranslationWithChildren = isElement && $02e9f7067c1ec6a6$var$hasChildren(node, true) && !node.voidElement;
                var isEmptyTransWithHTML = emptyChildrenButNeedsHandling && (0, $8a8a81e4d7494bfa$export$2e2bcd8739ae039)(child) === "object" && child.dummy && !isElement;
                var isKnownComponent = (0, $8a8a81e4d7494bfa$export$2e2bcd8739ae039)(children) === "object" && children !== null && Object.hasOwnProperty.call(children, node.name);
                if (typeof child === "string") {
                    var value = i18n.services.interpolator.interpolate(child, opts, i18n.language);
                    mem.push(value);
                } else if ($02e9f7067c1ec6a6$var$hasChildren(child) || isValidTranslationWithChildren) {
                    var inner = renderInner(child, node, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (isEmptyTransWithHTML) {
                    var _inner = mapAST(reactNodes, node.children, rootReactNode);
                    mem.push((0, $P551f.cloneElement)(child, $02e9f7067c1ec6a6$var$_objectSpread($02e9f7067c1ec6a6$var$_objectSpread({}, child.props), {}, {
                        key: i
                    }), _inner));
                } else if (Number.isNaN(parseFloat(node.name))) {
                    if (isKnownComponent) {
                        var _inner2 = renderInner(child, node, rootReactNode);
                        pushTranslatedJSX(child, _inner2, mem, i, node.voidElement);
                    } else if (i18nOptions.transSupportBasicHtmlNodes && keepArray.indexOf(node.name) > -1) {
                        if (node.voidElement) mem.push((0, $P551f.createElement)(node.name, {
                            key: "".concat(node.name, "-").concat(i)
                        }));
                        else {
                            var _inner3 = mapAST(reactNodes, node.children, rootReactNode);
                            mem.push((0, $P551f.createElement)(node.name, {
                                key: "".concat(node.name, "-").concat(i)
                            }, _inner3));
                        }
                    } else if (node.voidElement) mem.push("<".concat(node.name, " />"));
                    else {
                        var _inner4 = mapAST(reactNodes, node.children, rootReactNode);
                        mem.push("<".concat(node.name, ">").concat(_inner4, "</").concat(node.name, ">"));
                    }
                } else if ((0, $8a8a81e4d7494bfa$export$2e2bcd8739ae039)(child) === "object" && !isElement) {
                    var content = node.children[0] ? translationContent : null;
                    if (content) mem.push(content);
                } else if (node.children.length === 1 && translationContent) mem.push((0, $P551f.cloneElement)(child, $02e9f7067c1ec6a6$var$_objectSpread($02e9f7067c1ec6a6$var$_objectSpread({}, child.props), {}, {
                    key: i
                }), translationContent));
                else mem.push((0, $P551f.cloneElement)(child, $02e9f7067c1ec6a6$var$_objectSpread($02e9f7067c1ec6a6$var$_objectSpread({}, child.props), {}, {
                    key: i
                })));
            } else if (node.type === "text") {
                var wrapTextNodes = i18nOptions.transWrapTextNodes;
                var _content = shouldUnescape ? i18nOptions.unescape(i18n.services.interpolator.interpolate(node.content, opts, i18n.language)) : i18n.services.interpolator.interpolate(node.content, opts, i18n.language);
                if (wrapTextNodes) mem.push((0, $P551f.createElement)(wrapTextNodes, {
                    key: "".concat(node.name, "-").concat(i)
                }, _content));
                else mem.push(_content);
            }
            return mem;
        }, []);
    }
    var result = mapAST([
        {
            dummy: true,
            children: children || []
        }
    ], ast, $02e9f7067c1ec6a6$var$getAsArray(children || []));
    return $02e9f7067c1ec6a6$var$getChildren(result[0]);
}
function $02e9f7067c1ec6a6$export$8d6a9236f2e3f2ce(_ref) {
    var children = _ref.children, count = _ref.count, parent = _ref.parent, i18nKey = _ref.i18nKey, context = _ref.context, _ref$tOptions = _ref.tOptions, tOptions = _ref$tOptions === void 0 ? {} : _ref$tOptions, values = _ref.values, defaults = _ref.defaults, components = _ref.components, ns = _ref.ns, i18nFromProps = _ref.i18n, tFromProps = _ref.t, shouldUnescape = _ref.shouldUnescape, additionalProps = (0, $79d3e505593004f1$export$2e2bcd8739ae039)(_ref, $02e9f7067c1ec6a6$var$_excluded2);
    var i18n = i18nFromProps || (0, $74eea5b91afbe181$export$64af334f494c2f47)();
    if (!i18n) {
        (0, $4e3ca914f9fd936a$export$5b28268982f175ba)("You will need to pass in an i18next instance by using i18nextReactModule");
        return children;
    }
    var t = tFromProps || i18n.t.bind(i18n) || function(k) {
        return k;
    };
    if (context) tOptions.context = context;
    var reactI18nextOptions = $02e9f7067c1ec6a6$var$_objectSpread($02e9f7067c1ec6a6$var$_objectSpread({}, (0, $edb13efe2328c827$export$212bb2fc580a90a8)()), i18n.options && i18n.options.react);
    var namespaces = ns || t.ns || i18n.options && i18n.options.defaultNS;
    namespaces = typeof namespaces === "string" ? [
        namespaces
    ] : namespaces || [
        "translation"
    ];
    var defaultValue = defaults || $02e9f7067c1ec6a6$export$4f7a36dd898f1267(children, reactI18nextOptions) || reactI18nextOptions.transEmptyNodeValue || i18nKey;
    var hashTransKey = reactI18nextOptions.hashTransKey;
    var key = i18nKey || (hashTransKey ? hashTransKey(defaultValue) : defaultValue);
    var interpolationOverride = values ? tOptions.interpolation : {
        interpolation: $02e9f7067c1ec6a6$var$_objectSpread($02e9f7067c1ec6a6$var$_objectSpread({}, tOptions.interpolation), {}, {
            prefix: "#$?",
            suffix: "?$#"
        })
    };
    var combinedTOpts = $02e9f7067c1ec6a6$var$_objectSpread($02e9f7067c1ec6a6$var$_objectSpread($02e9f7067c1ec6a6$var$_objectSpread($02e9f7067c1ec6a6$var$_objectSpread({}, tOptions), {}, {
        count: count
    }, values), interpolationOverride), {}, {
        defaultValue: defaultValue,
        ns: namespaces
    });
    var translation = key ? t(key, combinedTOpts) : defaultValue;
    var content = $02e9f7067c1ec6a6$var$renderNodes(components || children, translation, i18n, reactI18nextOptions, combinedTOpts, shouldUnescape);
    var useAsParent = parent !== undefined ? parent : reactI18nextOptions.defaultTransParent;
    return useAsParent ? (0, $P551f.createElement)(useAsParent, additionalProps, content) : content;
}



function $f42f85cb8d7a52b7$export$2e2bcd8739ae039(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}



function $50f997bda58ccb7c$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, (0, $212fad89f87b96a9$export$2e2bcd8739ae039)(descriptor.key), descriptor);
    }
}
function $50f997bda58ccb7c$export$2e2bcd8739ae039(Constructor, protoProps, staticProps) {
    if (protoProps) $50f997bda58ccb7c$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $50f997bda58ccb7c$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}



var $P551f = parcelRequire("P551f");




var $8a6682c3b52eb927$export$ae7e14d40d89f296 = {
    type: "3rdParty",
    init: function init(instance) {
        (0, $edb13efe2328c827$export$2e2366488d12e20d)(instance.options.react);
        (0, $74eea5b91afbe181$export$a039134f2fc7e0)(instance);
    }
};


function $75f473e5ee928063$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $75f473e5ee928063$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $75f473e5ee928063$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $7c55c7e50dabe3fa$export$2e2bcd8739ae039)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $75f473e5ee928063$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $75f473e5ee928063$export$5603ab5ced17ce64 = (0, $P551f.createContext)();
var $75f473e5ee928063$export$ea171b67e3820290 = function() {
    function ReportNamespaces() {
        (0, $f42f85cb8d7a52b7$export$2e2bcd8739ae039)(this, ReportNamespaces);
        this.usedNamespaces = {};
    }
    (0, $50f997bda58ccb7c$export$2e2bcd8739ae039)(ReportNamespaces, [
        {
            key: "addUsedNamespaces",
            value: function addUsedNamespaces(namespaces) {
                var _this = this;
                namespaces.forEach(function(ns) {
                    if (!_this.usedNamespaces[ns]) _this.usedNamespaces[ns] = true;
                });
            }
        },
        {
            key: "getUsedNamespaces",
            value: function getUsedNamespaces() {
                return Object.keys(this.usedNamespaces);
            }
        }
    ]);
    return ReportNamespaces;
}();
function $75f473e5ee928063$export$30ff0342ccf735a(ForComponent) {
    return function(ctx) {
        return new Promise(function(resolve) {
            var i18nInitialProps = $75f473e5ee928063$export$704200e5d0b9e8f();
            if (ForComponent.getInitialProps) ForComponent.getInitialProps(ctx).then(function(componentsInitialProps) {
                resolve($75f473e5ee928063$var$_objectSpread($75f473e5ee928063$var$_objectSpread({}, componentsInitialProps), i18nInitialProps));
            });
            else resolve(i18nInitialProps);
        });
    };
}
function $75f473e5ee928063$export$704200e5d0b9e8f() {
    var i18n = (0, $74eea5b91afbe181$export$64af334f494c2f47)();
    var namespaces = i18n.reportNamespaces ? i18n.reportNamespaces.getUsedNamespaces() : [];
    var ret = {};
    var initialI18nStore = {};
    i18n.languages.forEach(function(l) {
        initialI18nStore[l] = {};
        namespaces.forEach(function(ns) {
            initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
        });
    });
    ret.initialI18nStore = initialI18nStore;
    ret.initialLanguage = i18n.language;
    return ret;
}


var $f51ffae15bc36a59$var$_excluded = [
    "children",
    "count",
    "parent",
    "i18nKey",
    "context",
    "tOptions",
    "values",
    "defaults",
    "components",
    "ns",
    "i18n",
    "t",
    "shouldUnescape"
];
function $f51ffae15bc36a59$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $f51ffae15bc36a59$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $f51ffae15bc36a59$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $7c55c7e50dabe3fa$export$2e2bcd8739ae039)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $f51ffae15bc36a59$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $f51ffae15bc36a59$export$8d6a9236f2e3f2ce(_ref) {
    var children = _ref.children, count = _ref.count, parent = _ref.parent, i18nKey = _ref.i18nKey, context = _ref.context, _ref$tOptions = _ref.tOptions, tOptions = _ref$tOptions === void 0 ? {} : _ref$tOptions, values = _ref.values, defaults = _ref.defaults, components = _ref.components, ns = _ref.ns, i18nFromProps = _ref.i18n, tFromProps = _ref.t, shouldUnescape = _ref.shouldUnescape, additionalProps = (0, $79d3e505593004f1$export$2e2bcd8739ae039)(_ref, $f51ffae15bc36a59$var$_excluded);
    var _ref2 = (0, $P551f.useContext)((0, $75f473e5ee928063$export$5603ab5ced17ce64)) || {}, i18nFromContext = _ref2.i18n, defaultNSFromContext = _ref2.defaultNS;
    var i18n = i18nFromProps || i18nFromContext || (0, $74eea5b91afbe181$export$64af334f494c2f47)();
    var t = tFromProps || i18n && i18n.t.bind(i18n);
    return (0, $02e9f7067c1ec6a6$export$8d6a9236f2e3f2ce)($f51ffae15bc36a59$var$_objectSpread({
        children: children,
        count: count,
        parent: parent,
        i18nKey: i18nKey,
        context: context,
        tOptions: tOptions,
        values: values,
        defaults: defaults,
        components: components,
        ns: ns || t && t.ns || defaultNSFromContext || i18n && i18n.options && i18n.options.defaultNS,
        i18n: i18n,
        t: tFromProps,
        shouldUnescape: shouldUnescape
    }, additionalProps));
}



function $6cad87a5f16ae95e$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return arr;
}


function $7c1fb92ee5c845e2$export$2e2bcd8739ae039(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}


function $cac3688328c46fe8$export$2e2bcd8739ae039(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $2db3567ee3f147f3$export$2e2bcd8739ae039(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $cac3688328c46fe8$export$2e2bcd8739ae039)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $cac3688328c46fe8$export$2e2bcd8739ae039)(o, minLen);
}


function $623d9be3df5632bd$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $90891d80a9b634ef$export$2e2bcd8739ae039(arr, i) {
    return (0, $6cad87a5f16ae95e$export$2e2bcd8739ae039)(arr) || (0, $7c1fb92ee5c845e2$export$2e2bcd8739ae039)(arr, i) || (0, $2db3567ee3f147f3$export$2e2bcd8739ae039)(arr, i) || (0, $623d9be3df5632bd$export$2e2bcd8739ae039)();
}





var $P551f = parcelRequire("P551f");


function $5d79e62c9ff74ac9$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $5d79e62c9ff74ac9$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $5d79e62c9ff74ac9$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $7c55c7e50dabe3fa$export$2e2bcd8739ae039)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $5d79e62c9ff74ac9$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $5d79e62c9ff74ac9$var$usePrevious = function usePrevious(value, ignore) {
    var ref = (0, $P551f.useRef)();
    (0, $P551f.useEffect)(function() {
        ref.current = ignore ? ref.current : value;
    }, [
        value,
        ignore
    ]);
    return ref.current;
};
function $5d79e62c9ff74ac9$export$9fc83ad70ead8663(ns) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var i18nFromProps = props.i18n;
    var _ref = (0, $P551f.useContext)((0, $75f473e5ee928063$export$5603ab5ced17ce64)) || {}, i18nFromContext = _ref.i18n, defaultNSFromContext = _ref.defaultNS;
    var i18n = i18nFromProps || i18nFromContext || (0, $74eea5b91afbe181$export$64af334f494c2f47)();
    if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new (0, $75f473e5ee928063$export$ea171b67e3820290)();
    if (!i18n) {
        (0, $4e3ca914f9fd936a$export$5b28268982f175ba)("You will need to pass in an i18next instance by using initReactI18next");
        var notReadyT = function notReadyT(k, optsOrDefaultValue) {
            if (typeof optsOrDefaultValue === "string") return optsOrDefaultValue;
            if (optsOrDefaultValue && (0, $8a8a81e4d7494bfa$export$2e2bcd8739ae039)(optsOrDefaultValue) === "object" && typeof optsOrDefaultValue.defaultValue === "string") return optsOrDefaultValue.defaultValue;
            return Array.isArray(k) ? k[k.length - 1] : k;
        };
        var retNotReady = [
            notReadyT,
            {},
            false
        ];
        retNotReady.t = notReadyT;
        retNotReady.i18n = {};
        retNotReady.ready = false;
        return retNotReady;
    }
    if (i18n.options.react && i18n.options.react.wait !== undefined) (0, $4e3ca914f9fd936a$export$5b28268982f175ba)("It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
    var i18nOptions = $5d79e62c9ff74ac9$var$_objectSpread($5d79e62c9ff74ac9$var$_objectSpread($5d79e62c9ff74ac9$var$_objectSpread({}, (0, $edb13efe2328c827$export$212bb2fc580a90a8)()), i18n.options.react), props);
    var useSuspense = i18nOptions.useSuspense, keyPrefix = i18nOptions.keyPrefix;
    var namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
    namespaces = typeof namespaces === "string" ? [
        namespaces
    ] : namespaces || [
        "translation"
    ];
    if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
    var ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every(function(n) {
        return (0, $4e3ca914f9fd936a$export$93d9ee97c1ad3f31)(n, i18n, i18nOptions);
    });
    function getT() {
        return i18n.getFixedT(props.lng || null, i18nOptions.nsMode === "fallback" ? namespaces : namespaces[0], keyPrefix);
    }
    var _useState = (0, $P551f.useState)(getT), _useState2 = (0, $90891d80a9b634ef$export$2e2bcd8739ae039)(_useState, 2), t = _useState2[0], setT = _useState2[1];
    var joinedNS = namespaces.join();
    if (props.lng) joinedNS = "".concat(props.lng).concat(joinedNS);
    var previousJoinedNS = $5d79e62c9ff74ac9$var$usePrevious(joinedNS);
    var isMounted = (0, $P551f.useRef)(true);
    (0, $P551f.useEffect)(function() {
        var bindI18n = i18nOptions.bindI18n, bindI18nStore = i18nOptions.bindI18nStore;
        isMounted.current = true;
        if (!ready && !useSuspense) {
            if (props.lng) (0, $4e3ca914f9fd936a$export$8cd7e7a54fa865bc)(i18n, props.lng, namespaces, function() {
                if (isMounted.current) setT(getT);
            });
            else (0, $4e3ca914f9fd936a$export$83be934b53fff43b)(i18n, namespaces, function() {
                if (isMounted.current) setT(getT);
            });
        }
        if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) setT(getT);
        function boundReset() {
            if (isMounted.current) setT(getT);
        }
        if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
        if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
        return function() {
            isMounted.current = false;
            if (bindI18n && i18n) bindI18n.split(" ").forEach(function(e) {
                return i18n.off(e, boundReset);
            });
            if (bindI18nStore && i18n) bindI18nStore.split(" ").forEach(function(e) {
                return i18n.store.off(e, boundReset);
            });
        };
    }, [
        i18n,
        joinedNS
    ]);
    var isInitial = (0, $P551f.useRef)(true);
    (0, $P551f.useEffect)(function() {
        if (isMounted.current && !isInitial.current) setT(getT);
        isInitial.current = false;
    }, [
        i18n,
        keyPrefix
    ]);
    var ret = [
        t,
        i18n,
        ready
    ];
    ret.t = t;
    ret.i18n = i18n;
    ret.ready = ready;
    if (ready) return ret;
    if (!ready && !useSuspense) return ret;
    throw new Promise(function(resolve) {
        if (props.lng) (0, $4e3ca914f9fd936a$export$8cd7e7a54fa865bc)(i18n, props.lng, namespaces, function() {
            return resolve();
        });
        else (0, $4e3ca914f9fd936a$export$83be934b53fff43b)(i18n, namespaces, function() {
            return resolve();
        });
    });
}






var $P551f = parcelRequire("P551f");


var $e372c5dd90c7ea22$var$_excluded = [
    "forwardedRef"
];
function $e372c5dd90c7ea22$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $e372c5dd90c7ea22$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $e372c5dd90c7ea22$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $7c55c7e50dabe3fa$export$2e2bcd8739ae039)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $e372c5dd90c7ea22$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $e372c5dd90c7ea22$export$2dcb0053efd21124(ns) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return function Extend(WrappedComponent) {
        function I18nextWithTranslation(_ref) {
            var forwardedRef = _ref.forwardedRef, rest = (0, $79d3e505593004f1$export$2e2bcd8739ae039)(_ref, $e372c5dd90c7ea22$var$_excluded);
            var _useTranslation = (0, $5d79e62c9ff74ac9$export$9fc83ad70ead8663)(ns, $e372c5dd90c7ea22$var$_objectSpread($e372c5dd90c7ea22$var$_objectSpread({}, rest), {}, {
                keyPrefix: options.keyPrefix
            })), _useTranslation2 = (0, $90891d80a9b634ef$export$2e2bcd8739ae039)(_useTranslation, 3), t = _useTranslation2[0], i18n = _useTranslation2[1], ready = _useTranslation2[2];
            var passDownProps = $e372c5dd90c7ea22$var$_objectSpread($e372c5dd90c7ea22$var$_objectSpread({}, rest), {}, {
                t: t,
                i18n: i18n,
                tReady: ready
            });
            if (options.withRef && forwardedRef) passDownProps.ref = forwardedRef;
            else if (!options.withRef && forwardedRef) passDownProps.forwardedRef = forwardedRef;
            return (0, $P551f.createElement)(WrappedComponent, passDownProps);
        }
        I18nextWithTranslation.displayName = "withI18nextTranslation(".concat((0, $4e3ca914f9fd936a$export$be63e0664592e141)(WrappedComponent), ")");
        I18nextWithTranslation.WrappedComponent = WrappedComponent;
        var forwardRef = function forwardRef(props, ref) {
            return (0, $P551f.createElement)(I18nextWithTranslation, Object.assign({}, props, {
                forwardedRef: ref
            }));
        };
        return options.withRef ? (0, $P551f.forwardRef)(forwardRef) : I18nextWithTranslation;
    };
}





var $c2bb67ddacdae164$var$_excluded = [
    "ns",
    "children"
];
function $c2bb67ddacdae164$export$b63289fbda65eed1(props) {
    var ns = props.ns, children = props.children, options = (0, $79d3e505593004f1$export$2e2bcd8739ae039)(props, $c2bb67ddacdae164$var$_excluded);
    var _useTranslation = (0, $5d79e62c9ff74ac9$export$9fc83ad70ead8663)(ns, options), _useTranslation2 = (0, $90891d80a9b634ef$export$2e2bcd8739ae039)(_useTranslation, 3), t = _useTranslation2[0], i18n = _useTranslation2[1], ready = _useTranslation2[2];
    return children(t, {
        i18n: i18n,
        lng: i18n.language
    }, ready);
}



var $P551f = parcelRequire("P551f");

function $502fe64e20a8aecf$export$1325e8699caa160f(_ref) {
    var i18n = _ref.i18n, defaultNS = _ref.defaultNS, children = _ref.children;
    var value = (0, $P551f.useMemo)(function() {
        return {
            i18n: i18n,
            defaultNS: defaultNS
        };
    }, [
        i18n,
        defaultNS
    ]);
    return (0, $P551f.createElement)((0, $75f473e5ee928063$export$5603ab5ced17ce64).Provider, {
        value: value
    }, children);
}





var $P551f = parcelRequire("P551f");

var $P551f = parcelRequire("P551f");

function $5918e975608c7ff4$export$3526fb65ade8d8b7(initialI18nStore, initialLanguage) {
    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var i18nFromProps = props.i18n;
    var _ref = (0, $P551f.useContext)((0, $75f473e5ee928063$export$5603ab5ced17ce64)) || {}, i18nFromContext = _ref.i18n;
    var i18n = i18nFromProps || i18nFromContext || (0, $74eea5b91afbe181$export$64af334f494c2f47)();
    if (i18n.options && i18n.options.isClone) return;
    if (initialI18nStore && !i18n.initializedStoreOnce) {
        i18n.services.resourceStore.data = initialI18nStore;
        i18n.options.ns = Object.values(initialI18nStore).reduce(function(mem, lngResources) {
            Object.keys(lngResources).forEach(function(ns) {
                if (mem.indexOf(ns) < 0) mem.push(ns);
            });
            return mem;
        }, i18n.options.ns);
        i18n.initializedStoreOnce = true;
        i18n.isInitialized = true;
    }
    if (initialLanguage && !i18n.initializedLanguageOnce) {
        i18n.changeLanguage(initialLanguage);
        i18n.initializedLanguageOnce = true;
    }
}




var $1b1e9a66f7704815$var$_excluded = [
    "initialI18nStore",
    "initialLanguage"
];
function $1b1e9a66f7704815$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1b1e9a66f7704815$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $1b1e9a66f7704815$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $7c55c7e50dabe3fa$export$2e2bcd8739ae039)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $1b1e9a66f7704815$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $1b1e9a66f7704815$export$80dfa519af1c8605() {
    return function Extend(WrappedComponent) {
        function I18nextWithSSR(_ref) {
            var initialI18nStore = _ref.initialI18nStore, initialLanguage = _ref.initialLanguage, rest = (0, $79d3e505593004f1$export$2e2bcd8739ae039)(_ref, $1b1e9a66f7704815$var$_excluded);
            (0, $5918e975608c7ff4$export$3526fb65ade8d8b7)(initialI18nStore, initialLanguage);
            return (0, $P551f.createElement)(WrappedComponent, $1b1e9a66f7704815$var$_objectSpread({}, rest));
        }
        I18nextWithSSR.getInitialProps = (0, $75f473e5ee928063$export$30ff0342ccf735a)(WrappedComponent);
        I18nextWithSSR.displayName = "withI18nextSSR(".concat((0, $4e3ca914f9fd936a$export$be63e0664592e141)(WrappedComponent), ")");
        I18nextWithSSR.WrappedComponent = WrappedComponent;
        return I18nextWithSSR;
    };
}







var $293a540a80bf4f1b$export$324d90190a8b822a = function date() {
    return "";
};
var $293a540a80bf4f1b$export$2da9be4cfdb689b1 = function time() {
    return "";
};
var $293a540a80bf4f1b$export$98e628dec113755e = function number() {
    return "";
};
var $293a540a80bf4f1b$export$2e6c959c16ff56b8 = function select() {
    return "";
};
var $293a540a80bf4f1b$export$4e35d5c922a95490 = function plural() {
    return "";
};
var $293a540a80bf4f1b$export$720a3b9db04b7a0f = function selectOrdinal() {
    return "";
};






parcelRequire("P551f");
const $31fff37a52e5e99b$var$SvgDevIcon = (props)=>/*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("svg", (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({
        width: 20,
        height: 20,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("path", {
            d: "M12.41 6.74a.771.771 0 0 0-1.422-.598L7.58 13.215a.771.771 0 1 0 1.422.597l3.407-7.073ZM3.668 10l2.917-2.916a.806.806 0 0 0 0-1.167.806.806 0 0 0-1.167 0l-3.5 3.5a.806.806 0 0 0 0 1.167l3.5 3.5c.167.166.333.25.583.25.25 0 .417-.084.584-.25a.806.806 0 0 0 0-1.167L3.668 10ZM16.335 10l-2.917-2.916a.805.805 0 0 1 0-1.167.805.805 0 0 1 1.167 0l3.5 3.5a.805.805 0 0 1 0 1.167l-3.5 3.5a.757.757 0 0 1-.584.25.757.757 0 0 1-.583-.25.805.805 0 0 1 0-1.167L16.335 10Z",
            fill: "currentColor"
        })
    }));
var $31fff37a52e5e99b$export$2e2bcd8739ae039 = $31fff37a52e5e99b$var$SvgDevIcon;



var $P551f = parcelRequire("P551f");

const $37bc2555b7bb33e3$var$usePlatform = ()=>{
    const { platform: platform } = (0, $P551f.useContext)((0, $bf7e93717fb1eb16$export$2e2bcd8739ae039));
    return {
        isMobile: platform === "mobile",
        platform: platform
    };
};
var $37bc2555b7bb33e3$export$2e2bcd8739ae039 = $37bc2555b7bb33e3$var$usePlatform;


/**
 * Styles that may effect the visibility of a DOM element.
 */ const $89563db4e02ca8d9$var$visibilityRelatedStyles = Object.freeze({
    visibility: "visible",
    height: "unset",
    width: "unset",
    transform: "unset",
    opacity: "unset",
    position: "static"
});
/** Build styles that will always be visible for a DOM element based on given styles */ const $89563db4e02ca8d9$var$buildPermanentVisibleStyles = (styles)=>(0, $0de5391da8318002$export$581ff339ea0ba762)({}, $89563db4e02ca8d9$var$visibilityRelatedStyles, styles);
/**
 * Apply inline styles with '!important' to a DOM element to make theses styles become the highest priority.
 *
 * It's useful when we want to ensure these styles won't be override via the user's custom CSS config.
 */ const $89563db4e02ca8d9$var$applyInlineStylesWithImportant = (element, styles)=>{
    for (const [key, value] of Object.entries(styles))element.style.setProperty(key, value, "important");
};
/**
 * Notification for development tenants to notify the user that the tenant is in development mode
 *
 * It is shown for development tenants and will be hidden in the preview mode even the tenant is a development tenant
 */ const $89563db4e02ca8d9$var$DevelopmentTenantNotification = ()=>{
    const { t: t } = (0, $5d79e62c9ff74ac9$export$9fc83ad70ead8663)();
    const ref = (0, $P551f.useRef)(null);
    /**
   * Add a ref to the icon to specify styles for the icon,
   * since we cannot use CSS selectors to select the icon from its parent node (notification) via inline CSS.
   */ const iconRef = (0, $P551f.useRef)(null);
    const { experienceSettings: experienceSettings, isPreview: isPreview } = (0, $P551f.useContext)((0, $bf7e93717fb1eb16$export$2e2bcd8739ae039));
    const { isDevelopmentTenant: isDevelopmentTenant } = experienceSettings !== null && experienceSettings !== void 0 ? experienceSettings : {};
    const { isMobile: isMobile } = (0, $37bc2555b7bb33e3$export$2e2bcd8739ae039)();
    const styles = Object.freeze({
        display: "flex",
        "align-items": "center",
        "justify-content": "center",
        "align-self": "stretch",
        gap: "8px",
        margin: isMobile ? "-16px -20px 16px" : "-24px -24px 0",
        padding: "12px 16px",
        "border-radius": isMobile ? "unset" : "8px 8px 0 0",
        background: "var(--color-container-alert)",
        font: "var(--font-label-2)",
        color: "var(--color-type-primary)"
    });
    const iconStyles = Object.freeze({
        // Use 'display: inline-flex' and 'align-items: center' to vertically center the icon
        display: "inline-flex",
        "align-items": "center",
        color: "var(--color-container-on-alert)"
    });
    (0, $P551f.useEffect)(()=>{
        if (isPreview || !ref.current || !iconRef.current) return;
        $89563db4e02ca8d9$var$applyInlineStylesWithImportant(ref.current, $89563db4e02ca8d9$var$buildPermanentVisibleStyles(styles));
        $89563db4e02ca8d9$var$applyInlineStylesWithImportant(iconRef.current, $89563db4e02ca8d9$var$buildPermanentVisibleStyles(iconStyles));
    }, [
        iconStyles,
        isDevelopmentTenant,
        isPreview,
        ref,
        styles
    ]);
    if (!isDevelopmentTenant || isPreview) return null;
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("div", {
        ref: ref,
        children: [
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("span", {
                ref: iconRef,
                children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $31fff37a52e5e99b$export$2e2bcd8739ae039), {})
            }),
            t("development_tenant.notification")
        ]
    });
};
var $89563db4e02ca8d9$export$2e2bcd8739ae039 = $89563db4e02ca8d9$var$DevelopmentTenantNotification;



const $407a83ef1df4ec3e$export$52b270a1b841cc00 = Object.freeze({
    pageContainer: "logto_page-container",
    mainContent: "logto_main-content",
    customContent: "logto_custom-content",
    signature: "logto_signature",
    brandingHeader: "logto_branding-header"
});








var $P551f = parcelRequire("P551f");


const $aa5a893d65a133eb$export$317715a729435b35 = ()=>{
    const { experienceSettings: experienceSettings } = (0, $P551f.useContext)((0, $bf7e93717fb1eb16$export$2e2bcd8739ae039));
    var _experienceSettings_signUp;
    const { identifiers: identifiers, password: password, verify: verify } = (_experienceSettings_signUp = experienceSettings === null || experienceSettings === void 0 ? void 0 : experienceSettings.signUp) !== null && _experienceSettings_signUp !== void 0 ? _experienceSettings_signUp : {};
    var _experienceSettings_signIn_methods_filter, _experienceSettings_socialConnectors, _experienceSettings_ssoConnectors;
    return {
        signUpMethods: identifiers !== null && identifiers !== void 0 ? identifiers : [],
        signUpSettings: {
            password: password,
            verify: verify
        },
        signInMethods: (_experienceSettings_signIn_methods_filter = experienceSettings === null || experienceSettings === void 0 ? void 0 : experienceSettings.signIn.methods.filter(// Filter out empty settings
        ({ password: password, verificationCode: verificationCode })=>password || verificationCode)) !== null && _experienceSettings_signIn_methods_filter !== void 0 ? _experienceSettings_signIn_methods_filter : [],
        socialConnectors: (_experienceSettings_socialConnectors = experienceSettings === null || experienceSettings === void 0 ? void 0 : experienceSettings.socialConnectors) !== null && _experienceSettings_socialConnectors !== void 0 ? _experienceSettings_socialConnectors : [],
        ssoConnectors: (_experienceSettings_ssoConnectors = experienceSettings === null || experienceSettings === void 0 ? void 0 : experienceSettings.ssoConnectors) !== null && _experienceSettings_ssoConnectors !== void 0 ? _experienceSettings_ssoConnectors : [],
        signInMode: experienceSettings === null || experienceSettings === void 0 ? void 0 : experienceSettings.signInMode,
        forgotPassword: experienceSettings === null || experienceSettings === void 0 ? void 0 : experienceSettings.forgotPassword,
        customContent: experienceSettings === null || experienceSettings === void 0 ? void 0 : experienceSettings.customContent,
        singleSignOnEnabled: experienceSettings === null || experienceSettings === void 0 ? void 0 : experienceSettings.singleSignOnEnabled
    };
};
const $aa5a893d65a133eb$export$b03f85e37d353e63 = ()=>{
    const { t: t } = (0, $5d79e62c9ff74ac9$export$9fc83ad70ead8663)();
    const { experienceSettings: experienceSettings } = (0, $P551f.useContext)((0, $bf7e93717fb1eb16$export$2e2bcd8739ae039));
    var _experienceSettings_passwordPolicy;
    const policy = (0, $P551f.useMemo)(()=>{
        return (0, $c16ce008c63b69bd$export$5fffa90e2e38377b).parse((_experienceSettings_passwordPolicy = experienceSettings === null || experienceSettings === void 0 ? void 0 : experienceSettings.passwordPolicy) !== null && _experienceSettings_passwordPolicy !== void 0 ? _experienceSettings_passwordPolicy : {});
    }, [
        experienceSettings
    ]);
    const policyChecker = (0, $P551f.useMemo)(()=>new (0, $c16ce008c63b69bd$export$d2f225c121fa68bd)(policy), [
        policy
    ]);
    const requirementsDescription = (0, $P551f.useMemo)(()=>policy.length.min <= 1 && policy.characterTypes.min <= 1 ? undefined : t("description.password_requirements", {
            items: (0, $dd763c2393b0d659$export$68c43792fed28aa6)(// There's no need to show the length requirement if it can be satisfied by the character types
            policy.length.min > policy.characterTypes.min && t("description.password_requirement.length", {
                count: policy.length.min
            }), // Show the character types requirement if it's greater than 1.
            policy.characterTypes.min > 1 && t("description.password_requirement.character_types", {
                count: policy.characterTypes.min
            }))
        }), [
        t,
        policy.length.min,
        policy.characterTypes.min
    ]);
    return {
        policy: policy,
        policyChecker: policyChecker,
        requirementsDescription: /** The localized description of the password policy. */ requirementsDescription
    };
};
const $aa5a893d65a133eb$export$9418daf6fcecfff4 = ()=>{
    const { experienceSettings: experienceSettings } = (0, $P551f.useContext)((0, $bf7e93717fb1eb16$export$2e2bcd8739ae039));
    const { forgotPassword: forgotPassword } = experienceSettings !== null && experienceSettings !== void 0 ? experienceSettings : {};
    const enabledMethodSet = new Set();
    if (forgotPassword === null || forgotPassword === void 0 ? void 0 : forgotPassword.email) enabledMethodSet.add((0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Email);
    if (forgotPassword === null || forgotPassword === void 0 ? void 0 : forgotPassword.phone) enabledMethodSet.add((0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Phone);
    return {
        isForgotPasswordEnabled: enabledMethodSet.size > 0,
        enabledMethodSet: enabledMethodSet
    };
};


const $7d2be0c6cb4725c8$var$CustomContent = ({ className: className })=>{
    const { customContent: customContent } = (0, $aa5a893d65a133eb$export$317715a729435b35)();
    const { pathname: pathname } = (0, $2ed817dc54ac40e6$export$45d76561a5302f2b)();
    const customHtml = customContent === null || customContent === void 0 ? void 0 : customContent[pathname];
    if (!customHtml) return null;
    try {
        // Expected error; CustomContent content is load from Logto remote server
        // eslint-disable-next-line react/no-danger
        return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("div", {
            dangerouslySetInnerHTML: {
                __html: customHtml
            },
            className: className
        });
    } catch (e) {
        return null;
    }
};
var $7d2be0c6cb4725c8$export$2e2bcd8739ae039 = $7d2be0c6cb4725c8$var$CustomContent;


var $b77308f52f1ef321$export$34e0f9847d4c02dd;
var $b77308f52f1ef321$export$f22da7240b7add18;
var $b77308f52f1ef321$export$c9cd164b539ebb63;
var $b77308f52f1ef321$export$a179c88182cb9d56;
$b77308f52f1ef321$export$34e0f9847d4c02dd = `uDMMma_container`;
$b77308f52f1ef321$export$f22da7240b7add18 = `uDMMma_main`;
$b77308f52f1ef321$export$c9cd164b539ebb63 = `uDMMma_signature`;
$b77308f52f1ef321$export$a179c88182cb9d56 = `uDMMma_viewBox`;


const $e0aef99e4cad3e2b$var$AppLayout = ()=>{
    const { isMobile: isMobile } = (0, $37bc2555b7bb33e3$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("div", {
        className: $b77308f52f1ef321$export$a179c88182cb9d56,
        children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($a6f0144cf2b2d456$exports)))($b77308f52f1ef321$export$34e0f9847d4c02dd, (0, $407a83ef1df4ec3e$export$52b270a1b841cc00).pageContainer),
            children: [
                !isMobile && /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $7d2be0c6cb4725c8$export$2e2bcd8739ae039), {
                    className: (0, $407a83ef1df4ec3e$export$52b270a1b841cc00).customContent
                }),
                /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("main", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($a6f0144cf2b2d456$exports)))($b77308f52f1ef321$export$f22da7240b7add18, (0, $407a83ef1df4ec3e$export$52b270a1b841cc00).mainContent),
                    children: [
                        /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $89563db4e02ca8d9$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $2ed817dc54ac40e6$export$910ae8079b2c2852), {}),
                        /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $63e5b7f0d12b6aa8$export$2e2bcd8739ae039), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($a6f0144cf2b2d456$exports)))($b77308f52f1ef321$export$c9cd164b539ebb63, (0, $407a83ef1df4ec3e$export$52b270a1b841cc00).signature)
                        })
                    ]
                })
            ]
        })
    });
};
var $e0aef99e4cad3e2b$export$2e2bcd8739ae039 = $e0aef99e4cad3e2b$var$AppLayout;







var $P551f = parcelRequire("P551f");

const $9dab4aae2c50f7eb$var$generateLightColorLibrary = (primaryColor)=>({
        [`--color-brand-default`]: primaryColor.hex(),
        [`--color-brand-hover`]: (0, $e54dff7b369bf34e$export$2b47dd798c93e22f)(primaryColor, 10).string(),
        [`--color-brand-pressed`]: (0, $e54dff7b369bf34e$export$13a5971b241f058c)(primaryColor, 10).string(),
        [`--color-overlay-brand-focused`]: primaryColor.alpha(0.16).string(),
        [`--color-overlay-brand-hover`]: primaryColor.alpha(0.08).string(),
        [`--color-overlay-brand-pressed`]: primaryColor.alpha(0.12).string()
    });
const $9dab4aae2c50f7eb$var$generateDarkColorLibrary = (primaryColor)=>({
        [`--color-brand-default`]: primaryColor.hex(),
        [`--color-brand-hover`]: (0, $e54dff7b369bf34e$export$2b47dd798c93e22f)(primaryColor, 10).string(),
        [`--color-brand-pressed`]: (0, $e54dff7b369bf34e$export$13a5971b241f058c)(primaryColor, 10).string(),
        [`--color-overlay-brand-focused`]: (0, $e54dff7b369bf34e$export$2b47dd798c93e22f)(primaryColor, 30).rgb().alpha(0.16).string(),
        [`--color-overlay-brand-hover`]: (0, $e54dff7b369bf34e$export$2b47dd798c93e22f)(primaryColor, 30).rgb().alpha(0.08).string(),
        [`--color-overlay-brand-pressed`]: (0, $e54dff7b369bf34e$export$2b47dd798c93e22f)(primaryColor, 30).rgb().alpha(0.12).string()
    });
const $9dab4aae2c50f7eb$var$useColorTheme = ()=>{
    const { theme: theme, experienceSettings: experienceSettings } = (0, $P551f.useContext)((0, $bf7e93717fb1eb16$export$2e2bcd8739ae039));
    const primaryColor = experienceSettings === null || experienceSettings === void 0 ? void 0 : experienceSettings.color.primaryColor;
    const darkPrimaryColor = experienceSettings === null || experienceSettings === void 0 ? void 0 : experienceSettings.color.darkPrimaryColor;
    (0, $P551f.useEffect)(()=>{
        if (!primaryColor) return;
        const lightPrimary = (0, (/*@__PURE__*/$parcel$interopDefault($65db2c8fcb86b5e5$exports)))(primaryColor);
        if (theme === (0, $93d2089b0ece27e4$export$14faa19a0f3bbeb2).Light) {
            const lightColorLibrary = $9dab4aae2c50f7eb$var$generateLightColorLibrary(lightPrimary);
            for (const [key, value] of Object.entries(lightColorLibrary))document.body.style.setProperty(key, value);
            return;
        }
        const darkPrimary = darkPrimaryColor ? (0, (/*@__PURE__*/$parcel$interopDefault($65db2c8fcb86b5e5$exports)))(darkPrimaryColor) : (0, $e54dff7b369bf34e$export$2b47dd798c93e22f)(lightPrimary, 10);
        const darkColorLibrary = $9dab4aae2c50f7eb$var$generateDarkColorLibrary(darkPrimary);
        for (const [key, value] of Object.entries(darkColorLibrary))document.body.style.setProperty(key, value);
    }, [
        darkPrimaryColor,
        primaryColor,
        theme
    ]);
};
var $9dab4aae2c50f7eb$export$2e2bcd8739ae039 = $9dab4aae2c50f7eb$var$useColorTheme;








var $P551f = parcelRequire("P551f");



var $P551f = parcelRequire("P551f");





parcelRequire("P551f");
const $8ef1f280e586fd6f$var$SvgCloseIcon = (props)=>/*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("svg", (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("path", {
            d: "m13.41 12 6.3-6.29a1.004 1.004 0 0 0-1.42-1.42L12 10.59l-6.29-6.3a1.004 1.004 0 1 0-1.42 1.42l6.3 6.29-6.3 6.29a.999.999 0 0 0 0 1.42 1 1 0 0 0 1.42 0l6.29-6.3 6.29 6.3a1.001 1.001 0 0 0 1.639-.325 1 1 0 0 0-.22-1.095L13.41 12Z",
            fill: "currentcolor"
        })
    }));
var $8ef1f280e586fd6f$export$2e2bcd8739ae039 = $8ef1f280e586fd6f$var$SvgCloseIcon;









/**
 * A component to render a dynamic translation key.
 */ const $cfcdc2df19be03b3$var$DynamicT = ({ forKey: forKey, interpolation: interpolation })=>{
    const { t: t } = (0, $5d79e62c9ff74ac9$export$9fc83ad70ead8663)();
    if (!forKey) return null;
    const translated = t(forKey, interpolation !== null && interpolation !== void 0 ? interpolation : {});
    if (typeof translated === "string") // The fragment will ensure the component has the return type that is compatible with `JSX.Element`.
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $b1404a408b0d045c$exports.Fragment), {
        children: translated
    });
    // The fragment will ensure the component has the return type that is compatible with `JSX.Element`.
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $b1404a408b0d045c$exports.Fragment), {
        children: `Translation key ${forKey} is invalid.`
    }); // This would be great to have i18n as well. Not harmful for now.
};
var $cfcdc2df19be03b3$export$2e2bcd8739ae039 = $cfcdc2df19be03b3$var$DynamicT;


var $38cf9015ace287df$exports = {};

$parcel$export($38cf9015ace287df$exports, "button", function () { return $38cf9015ace287df$export$2ba01fb71ed41cb6; }, function (v) { return $38cf9015ace287df$export$2ba01fb71ed41cb6 = v; });
$parcel$export($38cf9015ace287df$exports, "disabled", function () { return $38cf9015ace287df$export$683472f6198a076e; }, function (v) { return $38cf9015ace287df$export$683472f6198a076e = v; });
$parcel$export($38cf9015ace287df$exports, "icon", function () { return $38cf9015ace287df$export$1ca1ec8b29a4ce27; }, function (v) { return $38cf9015ace287df$export$1ca1ec8b29a4ce27 = v; });
$parcel$export($38cf9015ace287df$exports, "large", function () { return $38cf9015ace287df$export$f09585a853dddd32; }, function (v) { return $38cf9015ace287df$export$f09585a853dddd32 = v; });
$parcel$export($38cf9015ace287df$exports, "primary", function () { return $38cf9015ace287df$export$9ad721cf3b3debe0; }, function (v) { return $38cf9015ace287df$export$9ad721cf3b3debe0 = v; });
$parcel$export($38cf9015ace287df$exports, "secondary", function () { return $38cf9015ace287df$export$745c6f71a1e0e6f7; }, function (v) { return $38cf9015ace287df$export$745c6f71a1e0e6f7 = v; });
$parcel$export($38cf9015ace287df$exports, "small", function () { return $38cf9015ace287df$export$3c17b0e969a90510; }, function (v) { return $38cf9015ace287df$export$3c17b0e969a90510 = v; });
var $38cf9015ace287df$export$2ba01fb71ed41cb6;
var $38cf9015ace287df$export$683472f6198a076e;
var $38cf9015ace287df$export$1ca1ec8b29a4ce27;
var $38cf9015ace287df$export$f09585a853dddd32;
var $38cf9015ace287df$export$9ad721cf3b3debe0;
var $38cf9015ace287df$export$745c6f71a1e0e6f7;
var $38cf9015ace287df$export$3c17b0e969a90510;
$38cf9015ace287df$export$2ba01fb71ed41cb6 = `Ljn7Ea_button`;
$38cf9015ace287df$export$683472f6198a076e = `Ljn7Ea_disabled`;
$38cf9015ace287df$export$1ca1ec8b29a4ce27 = `Ljn7Ea_icon`;
$38cf9015ace287df$export$f09585a853dddd32 = `Ljn7Ea_large`;
$38cf9015ace287df$export$9ad721cf3b3debe0 = `Ljn7Ea_primary`;
$38cf9015ace287df$export$745c6f71a1e0e6f7 = `Ljn7Ea_secondary`;
$38cf9015ace287df$export$3c17b0e969a90510 = `Ljn7Ea_small`;


const $c6d8f26a28e11cb6$var$Button = (_param)=>{
    var { htmlType: htmlType = "button", type: type = "primary", size: size = "large", title: title, i18nProps: i18nProps, className: className, isDisabled: isDisabled = false, icon: icon, onClick: onClick } = _param, rest = (0, $451b529b5830e8ac$export$69fdd232f62cde60)(_param, [
        "htmlType",
        "type",
        "size",
        "title",
        "i18nProps",
        "className",
        "isDisabled",
        "icon",
        "onClick"
    ]);
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("button", (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({
        disabled: isDisabled,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a6f0144cf2b2d456$exports)))($38cf9015ace287df$exports.button, $38cf9015ace287df$exports[type], $38cf9015ace287df$exports[size], isDisabled && $38cf9015ace287df$exports.isDisabled, className),
        type: htmlType,
        onClick: onClick
    }, rest), {
        children: [
            icon && /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("span", {
                className: $38cf9015ace287df$exports.icon,
                children: icon
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $cfcdc2df19be03b3$export$2e2bcd8739ae039), {
                forKey: title,
                interpolation: i18nProps
            })
        ]
    }));
};
var $c6d8f26a28e11cb6$export$2e2bcd8739ae039 = $c6d8f26a28e11cb6$var$Button;








var $P551f = parcelRequire("P551f");
var $6bbc2ee692662e97$export$60bb6c1f29b8a8cc;
$6bbc2ee692662e97$export$60bb6c1f29b8a8cc = `D6WLUq_iconButton`;


const $328da03efb4c933c$var$IconButton = (_param, ref)=>{
    var { children: children, className: className } = _param, rest = (0, $451b529b5830e8ac$export$69fdd232f62cde60)(_param, [
        "children",
        "className"
    ]);
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("button", (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({
        ref: ref,
        type: "button",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a6f0144cf2b2d456$exports)))($6bbc2ee692662e97$export$60bb6c1f29b8a8cc, className)
    }, rest), {
        children: children
    }));
};
var $328da03efb4c933c$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $P551f.forwardRef)($328da03efb4c933c$var$IconButton);


/* istanbul ignore file */ const $f6f836671f603fea$export$c2c388d6a668999e = (callback)=>{
    return (event)=>{
        const { key: key } = event;
        if (typeof callback === "function" && [
            " ",
            "Enter"
        ].includes(key)) {
            callback(event);
            event.preventDefault();
        }
        if (typeof callback === "object") {
            var _callback_key;
            (_callback_key = callback[key]) === null || _callback_key === void 0 ? void 0 : _callback_key.call(callback, event);
            if (callback[key]) event.preventDefault();
        }
    };
};


var $a30a291001610819$export$29dd17c7f3c81c36;
$a30a291001610819$export$29dd17c7f3c81c36 = `LxEQZG_overlay`;


var $5ebc82ab068893b7$export$34e0f9847d4c02dd;
var $5ebc82ab068893b7$export$a7db06668cad9adb;
var $5ebc82ab068893b7$export$adb608be33961c98;
var $5ebc82ab068893b7$export$38e42c68cf43b5d4;
var $5ebc82ab068893b7$export$96e4b36520c26a2c;
var $5ebc82ab068893b7$export$29dd17c7f3c81c36;
$5ebc82ab068893b7$export$34e0f9847d4c02dd = `DJy3WW_container`;
$5ebc82ab068893b7$export$a7db06668cad9adb = `DJy3WW_content`;
$5ebc82ab068893b7$export$adb608be33961c98 = `DJy3WW_footer`;
$5ebc82ab068893b7$export$38e42c68cf43b5d4 = `DJy3WW_header`;
$5ebc82ab068893b7$export$96e4b36520c26a2c = `DJy3WW_modal`;
$5ebc82ab068893b7$export$29dd17c7f3c81c36 = `DJy3WW_overlay`;


const $a9f709acbd7443b8$var$AcModal = ({ className: className, isOpen: isOpen = false, children: children, cancelText: cancelText = "action.cancel", confirmText: confirmText = "action.confirm", confirmTextI18nProps: confirmTextI18nProps, cancelTextI18nProps: cancelTextI18nProps, onConfirm: onConfirm, onClose: onClose })=>{
    const { t: t } = (0, $5d79e62c9ff74ac9$export$9fc83ad70ead8663)();
    const contentRef = (0, $P551f.useRef)(null);
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e479b6ac5364ae16$exports))), {
        isOpen: isOpen,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a6f0144cf2b2d456$exports)))($5ebc82ab068893b7$export$96e4b36520c26a2c, className),
        overlayClassName: (0, (/*@__PURE__*/$parcel$interopDefault($a6f0144cf2b2d456$exports)))($a30a291001610819$export$29dd17c7f3c81c36, $5ebc82ab068893b7$export$29dd17c7f3c81c36),
        onAfterOpen: ()=>{
            var _contentRef_current;
            (_contentRef_current = contentRef.current) === null || _contentRef_current === void 0 ? void 0 : _contentRef_current.focus();
        },
        onRequestClose: onClose,
        children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("div", {
            ref: contentRef,
            className: $5ebc82ab068893b7$export$34e0f9847d4c02dd,
            role: "button",
            tabIndex: 0,
            onKeyDown: (0, $f6f836671f603fea$export$c2c388d6a668999e)({
                Enter: onConfirm !== null && onConfirm !== void 0 ? onConfirm : onClose,
                " ": onConfirm !== null && onConfirm !== void 0 ? onConfirm : onClose,
                Escape: onClose
            }),
            children: [
                /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("div", {
                    className: $5ebc82ab068893b7$export$38e42c68cf43b5d4,
                    children: [
                        t("description.reminder"),
                        /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $328da03efb4c933c$export$2e2bcd8739ae039), {
                            onClick: onClose,
                            children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $8ef1f280e586fd6f$export$2e2bcd8739ae039), {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("div", {
                    className: $5ebc82ab068893b7$export$a7db06668cad9adb,
                    children: children
                }),
                /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("div", {
                    className: $5ebc82ab068893b7$export$adb608be33961c98,
                    children: [
                        /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $c6d8f26a28e11cb6$export$2e2bcd8739ae039), {
                            title: cancelText,
                            type: "secondary",
                            i18nProps: cancelTextI18nProps,
                            size: "small",
                            onClick: onClose
                        }),
                        onConfirm && /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $c6d8f26a28e11cb6$export$2e2bcd8739ae039), {
                            title: confirmText,
                            i18nProps: confirmTextI18nProps,
                            size: "small",
                            onClick: onConfirm
                        })
                    ]
                })
            ]
        })
    });
};
var $a9f709acbd7443b8$export$2e2bcd8739ae039 = $a9f709acbd7443b8$var$AcModal;







var $4f9b71b58f90ab91$export$34e0f9847d4c02dd;
var $4f9b71b58f90ab91$export$a7db06668cad9adb;
var $4f9b71b58f90ab91$export$adb608be33961c98;
var $4f9b71b58f90ab91$export$908137cc4b52cbf2;
var $4f9b71b58f90ab91$export$96e4b36520c26a2c;
var $4f9b71b58f90ab91$export$29dd17c7f3c81c36;
$4f9b71b58f90ab91$export$34e0f9847d4c02dd = `XjKGIq_container`;
$4f9b71b58f90ab91$export$a7db06668cad9adb = `XjKGIq_content`;
$4f9b71b58f90ab91$export$adb608be33961c98 = `XjKGIq_footer`;
$4f9b71b58f90ab91$export$908137cc4b52cbf2 = `XjKGIq_iframeModal`;
$4f9b71b58f90ab91$export$96e4b36520c26a2c = `XjKGIq_modal`;
$4f9b71b58f90ab91$export$29dd17c7f3c81c36 = `XjKGIq_overlay`;


const $65c95b0900230f98$var$MobileModal = ({ className: className, isOpen: isOpen = false, children: children, cancelText: cancelText = "action.cancel", confirmText: confirmText = "action.confirm", cancelTextI18nProps: cancelTextI18nProps, confirmTextI18nProps: confirmTextI18nProps, onConfirm: onConfirm, onClose: onClose })=>{
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e479b6ac5364ae16$exports))), {
        shouldCloseOnEsc: true,
        role: "dialog",
        isOpen: isOpen,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a6f0144cf2b2d456$exports)))($4f9b71b58f90ab91$export$96e4b36520c26a2c, className),
        overlayClassName: (0, (/*@__PURE__*/$parcel$interopDefault($a6f0144cf2b2d456$exports)))($a30a291001610819$export$29dd17c7f3c81c36, $4f9b71b58f90ab91$export$29dd17c7f3c81c36),
        onRequestClose: onClose,
        children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("div", {
            className: $4f9b71b58f90ab91$export$34e0f9847d4c02dd,
            children: [
                /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("div", {
                    className: $4f9b71b58f90ab91$export$a7db06668cad9adb,
                    children: children
                }),
                /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("div", {
                    className: $4f9b71b58f90ab91$export$adb608be33961c98,
                    children: [
                        /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $c6d8f26a28e11cb6$export$2e2bcd8739ae039), {
                            title: cancelText,
                            i18nProps: cancelTextI18nProps,
                            type: "secondary",
                            onClick: onClose
                        }),
                        onConfirm && /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $c6d8f26a28e11cb6$export$2e2bcd8739ae039), {
                            title: confirmText,
                            i18nProps: confirmTextI18nProps,
                            onClick: onConfirm
                        })
                    ]
                })
            ]
        })
    });
};
var $65c95b0900230f98$export$2e2bcd8739ae039 = $65c95b0900230f98$var$MobileModal;





const $b54a682ed4ae76b2$export$48cb88dd95836c3a = /*#__PURE__*/ (0, $P551f.createContext)({
    show: async ()=>[
            true
        ],
    confirm: (0, $96962764729a993e$export$8793edee2d425525),
    cancel: (0, $96962764729a993e$export$8793edee2d425525)
});
const $b54a682ed4ae76b2$var$defaultModalState = {
    isOpen: false,
    type: "confirm",
    ModalContent: ()=>null
};
const $b54a682ed4ae76b2$var$ConfirmModalProvider = ({ children: children })=>{
    const [modalState, setModalState] = (0, $P551f.useState)($b54a682ed4ae76b2$var$defaultModalState);
    const resolver = (0, $P551f.useRef)();
    const { isMobile: isMobile } = (0, $37bc2555b7bb33e3$export$2e2bcd8739ae039)();
    const ConfirmModal = isMobile ? (0, $65c95b0900230f98$export$2e2bcd8739ae039) : (0, $a9f709acbd7443b8$export$2e2bcd8739ae039);
    const handleShow = (0, $P551f.useCallback)(async (_param)=>{
        var { type: type = "confirm" } = _param, props = (0, $451b529b5830e8ac$export$69fdd232f62cde60)(_param, [
            "type"
        ]);
        var _resolver_current;
        (_resolver_current = resolver.current) === null || _resolver_current === void 0 ? void 0 : _resolver_current.call(resolver, [
            false
        ]);
        setModalState((0, $0de5391da8318002$export$581ff339ea0ba762)({
            isOpen: true,
            type: type
        }, props));
        return new Promise((resolve)=>{
            // eslint-disable-next-line @silverhand/fp/no-mutation
            resolver.current = resolve;
        });
    }, []);
    const handleConfirm = (0, $P551f.useCallback)((data)=>{
        var _resolver_current;
        (_resolver_current = resolver.current) === null || _resolver_current === void 0 ? void 0 : _resolver_current.call(resolver, [
            true,
            data
        ]);
        setModalState($b54a682ed4ae76b2$var$defaultModalState);
    }, []);
    const handleCancel = (0, $P551f.useCallback)((data)=>{
        var _resolver_current;
        (_resolver_current = resolver.current) === null || _resolver_current === void 0 ? void 0 : _resolver_current.call(resolver, [
            false,
            data
        ]);
        setModalState($b54a682ed4ae76b2$var$defaultModalState);
    }, []);
    const contextValue = (0, $P551f.useMemo)(()=>({
            show: handleShow,
            confirm: handleConfirm,
            cancel: handleCancel
        }), [
        handleCancel,
        handleConfirm,
        handleShow
    ]);
    const { ModalContent: ModalContent, type: type } = modalState, restProps = (0, $451b529b5830e8ac$export$69fdd232f62cde60)(modalState, [
        "ModalContent",
        "type"
    ]);
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)($b54a682ed4ae76b2$export$48cb88dd95836c3a.Provider, {
        value: contextValue,
        children: [
            children,
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)(ConfirmModal, (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, restProps), {
                onConfirm: type === "confirm" ? ()=>{
                    handleConfirm();
                } : undefined,
                onClose: ()=>{
                    handleCancel();
                },
                children: typeof ModalContent === "string" ? ModalContent : /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)(ModalContent, {
                    confirm: handleConfirm,
                    cancel: handleCancel
                })
            }))
        ]
    });
};
var $b54a682ed4ae76b2$export$2e2bcd8739ae039 = $b54a682ed4ae76b2$var$ConfirmModalProvider;







var $P551f = parcelRequire("P551f");





var $P551f = parcelRequire("P551f");


var $P551f = parcelRequire("P551f");
function $609f9c250d82d76c$var$i() {
    return ($609f9c250d82d76c$var$i = Object.assign || function(t) {
        for(var e = 1; e < arguments.length; e++){
            var o = arguments[e];
            for(var n in o)Object.prototype.hasOwnProperty.call(o, n) && (t[n] = o[n]);
        }
        return t;
    }).apply(this, arguments);
}
var $609f9c250d82d76c$var$c = function() {};
function $609f9c250d82d76c$var$l(t, e) {
    return Math.random() * (e - t + 1) + t;
}
function $609f9c250d82d76c$var$s(t, e) {
    return Math.floor($609f9c250d82d76c$var$l(t, e));
}
var $609f9c250d82d76c$var$u = (0, $P551f.forwardRef)(function(o, u) {
    var d = o.progress, f = o.height, v = void 0 === f ? 2 : f, h = o.className, p = void 0 === h ? "" : h, m = o.color, b = void 0 === m ? "red" : m, g = o.background, y = void 0 === g ? "transparent" : g, w = o.onLoaderFinished, x = o.transitionTime, S = void 0 === x ? 300 : x, k = o.loaderSpeed, M = void 0 === k ? 500 : k, N = o.waitingTime, R = void 0 === N ? 1e3 : N, T = o.shadow, Y = void 0 === T || T, I = o.containerStyle, O = void 0 === I ? {} : I, j = o.style, P = void 0 === j ? {} : j, z = o.shadowStyle, C = void 0 === z ? {} : z, F = o.containerClassName, L = void 0 === F ? "" : F, q = (0, $P551f.useRef)(!1), A = (0, $P551f.useState)(0), B = A[0], D = A[1], E = (0, $P551f.useRef)({
        active: !1,
        refreshRate: 1e3
    }), G = (0, $P551f.useState)(!1), H = G[0], J = G[1], K = (0, $P551f.useState)({
        active: !1,
        value: 20
    }), Q = K[0], U = K[1], V = {
        position: "fixed",
        top: 0,
        left: 0,
        height: v,
        background: y,
        zIndex: 99999999999,
        width: "100%"
    }, W = {
        boxShadow: "0 0 10px " + b + ", 0 0 10px " + b,
        width: "5%",
        opacity: 1,
        position: "absolute",
        height: "100%",
        transition: "all " + M + "ms ease",
        transform: "rotate(3deg) translate(0px, -4px)",
        left: "-10rem"
    }, X = (0, $P551f.useState)({
        height: "100%",
        background: b,
        transition: "all " + M + "ms ease",
        width: "0%"
    }), Z = X[0], $ = X[1], _ = (0, $P551f.useState)(W), tt = _[0], et = _[1];
    (0, $P551f.useEffect)(function() {
        return q.current = !0, function() {
            q.current = !1;
        };
    }, []), (0, $P551f.useImperativeHandle)(u, function() {
        return {
            continuousStart: function(t, e) {
                if (void 0 === e && (e = 1e3), !Q.active) {
                    if (H) console.warn("react-top-loading-bar: You can't use both controlling by props and ref methods to control the bar!");
                    else {
                        var o = t || $609f9c250d82d76c$var$s(10, 20);
                        E.current = {
                            active: !0,
                            refreshRate: e
                        }, D(o), at(o);
                    }
                }
            },
            staticStart: function(t) {
                if (!E.current.active) {
                    if (H) console.warn("react-top-loading-bar: You can't use both controlling by props and ref methods to control the bar!");
                    else {
                        var e = t || $609f9c250d82d76c$var$s(30, 50);
                        U({
                            active: !0,
                            value: e
                        }), D(e), at(e);
                    }
                }
            },
            complete: function() {
                H ? console.warn("react-top-loading-bar: You can't use both controlling by props and ref methods to control the bar!") : (D(100), at(100));
            }
        };
    }), (0, $P551f.useEffect)(function() {
        $($609f9c250d82d76c$var$i({}, Z, {
            background: b
        })), et($609f9c250d82d76c$var$i({}, tt, {
            boxShadow: "0 0 10px " + b + ", 0 0 5px " + b
        }));
    }, [
        b
    ]), (0, $P551f.useEffect)(function() {
        if (u) {
            if (u && void 0 !== d) return void console.warn('react-top-loading-bar: You can\'t use both controlling by props and ref methods to control the bar! Please use only props or only ref methods! Ref methods will override props if "ref" property is available.');
            at(B), J(!1);
        } else d && at(d), J(!0);
    }, [
        d
    ]);
    var ot, nt, rt, at = function t(e) {
        e >= 100 ? ($($609f9c250d82d76c$var$i({}, Z, {
            width: "100%"
        })), Y && et($609f9c250d82d76c$var$i({}, tt, {
            left: e - 10 + "%"
        })), setTimeout(function() {
            q.current && ($($609f9c250d82d76c$var$i({}, Z, {
                opacity: 0,
                width: "100%",
                transition: "all " + S + "ms ease-out",
                color: b
            })), setTimeout(function() {
                q.current && (E.current.active && (E.current = $609f9c250d82d76c$var$i({}, E.current, {
                    active: !1
                }), D(0), t(0)), Q.active && (U($609f9c250d82d76c$var$i({}, Q, {
                    active: !1
                })), D(0), t(0)), w && w(), D(0), t(0));
            }, S));
        }, R)) : ($(function(t) {
            return $609f9c250d82d76c$var$i({}, t, {
                width: e + "%",
                opacity: 1,
                transition: e > 0 ? "all " + M + "ms ease" : ""
            });
        }), Y && et($609f9c250d82d76c$var$i({}, tt, {
            left: e - 5.5 + "%",
            transition: e > 0 ? "all " + M + "ms ease" : ""
        })));
    };
    return ot = function() {
        var t = $609f9c250d82d76c$var$l(Math.min(10, (100 - B) / 5), Math.min(20, (100 - B) / 3));
        B + t < 95 && (D(B + t), at(B + t));
    }, nt = E.current.active ? E.current.refreshRate : null, rt = (0, $P551f.useRef)($609f9c250d82d76c$var$c), (0, $P551f.useEffect)(function() {
        rt.current = ot;
    }), (0, $P551f.useEffect)(function() {}, [
        void 0
    ]), (0, $P551f.useEffect)(function() {
        if (null !== nt && !1 !== nt) {
            var t = setInterval(function() {
                return rt.current();
            }, nt);
            return function() {
                return clearInterval(t);
            };
        }
    }, [
        nt
    ]), (0, $P551f.createElement)("div", {
        className: L,
        style: $609f9c250d82d76c$var$i({}, V, O)
    }, (0, $P551f.createElement)("div", {
        className: p,
        style: $609f9c250d82d76c$var$i({}, Z, P)
    }, Y ? (0, $P551f.createElement)("div", {
        style: $609f9c250d82d76c$var$i({}, tt, C)
    }) : null));
});
var $609f9c250d82d76c$export$2e2bcd8739ae039 = $609f9c250d82d76c$var$u;





var $P551f = parcelRequire("P551f");





parcelRequire("P551f");
const $a82601beaadfb65a$var$SvgArrowPrev = (props)=>/*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("svg", (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({
        width: 24,
        height: 24,
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("path", {
            d: "m8.49 12.764 5.66 5.65a1.001 1.001 0 1 0 1.42-1.41l-4.95-5 4.95-4.95a1 1 0 0 0 0-1.41 1 1 0 0 0-.71-.3 1 1 0 0 0-.71.3l-5.66 5.65a1 1 0 0 0 0 1.47Z",
            fill: "currentcolor"
        })
    }));
var $a82601beaadfb65a$export$2e2bcd8739ae039 = $a82601beaadfb65a$var$SvgArrowPrev;





parcelRequire("P551f");
const $7e8bb0c2c74d7f06$var$SvgNavClose = (props)=>/*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("svg", (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({
        width: 24,
        height: 24,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("path", {
            d: "m13.41 12 4.3-4.29a1.004 1.004 0 0 0-1.42-1.42L12 10.59l-4.29-4.3a1.004 1.004 0 1 0-1.42 1.42l4.3 4.29-4.3 4.29a.999.999 0 0 0 0 1.42 1 1 0 0 0 1.42 0l4.29-4.3 4.29 4.3a1.001 1.001 0 0 0 1.639-.325 1 1 0 0 0-.22-1.095L13.41 12Z",
            fill: "currentcolor"
        })
    }));
var $7e8bb0c2c74d7f06$export$2e2bcd8739ae039 = $7e8bb0c2c74d7f06$var$SvgNavClose;



var $14191f61bdd65b24$export$73920f18ca706874;
var $14191f61bdd65b24$export$188e5e76577d6e93;
var $14191f61bdd65b24$export$2523f9cc9d8b8a36;
var $14191f61bdd65b24$export$bc892abb8d6aa6fd;
var $14191f61bdd65b24$export$fb184b623420d9be;
$14191f61bdd65b24$export$73920f18ca706874 = `YrdfMG_hidden`;
$14191f61bdd65b24$export$188e5e76577d6e93 = `YrdfMG_navBar`;
$14191f61bdd65b24$export$2523f9cc9d8b8a36 = `YrdfMG_navButton`;
$14191f61bdd65b24$export$bc892abb8d6aa6fd = `YrdfMG_skipButton`;
$14191f61bdd65b24$export$fb184b623420d9be = `YrdfMG_title`;


const $c3a009e3761dfcb2$var$NavBar = ({ title: title, type: type = "back", isHidden: isHidden, onClose: onClose, onSkip: onSkip })=>{
    const navigate = (0, $2ed817dc54ac40e6$export$9770f232ac06a008)();
    const { t: t } = (0, $5d79e62c9ff74ac9$export$9fc83ad70ead8663)();
    const isClosable = type === "close";
    const clickHandler = (0, $P551f.useCallback)(()=>{
        if (onClose) {
            onClose();
            return;
        }
        if (isClosable) {
            window.close();
            return;
        }
        navigate(-1);
    }, [
        isClosable,
        navigate,
        onClose
    ]);
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a6f0144cf2b2d456$exports)))($14191f61bdd65b24$export$188e5e76577d6e93, isHidden && $14191f61bdd65b24$export$73920f18ca706874),
        children: [
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("div", {
                role: "button",
                tabIndex: 0,
                className: $14191f61bdd65b24$export$2523f9cc9d8b8a36,
                onKeyDown: (0, $f6f836671f603fea$export$c2c388d6a668999e)(clickHandler),
                onClick: clickHandler,
                children: [
                    isClosable ? /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $7e8bb0c2c74d7f06$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $a82601beaadfb65a$export$2e2bcd8739ae039), {}),
                    !isClosable && /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("span", {
                        children: t("action.nav_back")
                    })
                ]
            }),
            title && /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("div", {
                className: $14191f61bdd65b24$export$fb184b623420d9be,
                children: title
            }),
            onSkip && /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("div", {
                role: "button",
                tabIndex: 0,
                className: $14191f61bdd65b24$export$bc892abb8d6aa6fd,
                onKeyDown: (0, $f6f836671f603fea$export$c2c388d6a668999e)(onSkip),
                onClick: onSkip,
                children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("span", {
                    children: t("action.nav_skip")
                })
            })
        ]
    });
};
var $c3a009e3761dfcb2$export$2e2bcd8739ae039 = $c3a009e3761dfcb2$var$NavBar;


var $34de55b0354aabca$export$29dd17c7f3c81c36;
var $34de55b0354aabca$export$96e4b36520c26a2c;
var $34de55b0354aabca$export$34e0f9847d4c02dd;
var $34de55b0354aabca$export$38e42c68cf43b5d4;
var $34de55b0354aabca$export$a7db06668cad9adb;
var $34de55b0354aabca$export$b40fc69c4a2927a1;
var $34de55b0354aabca$export$f4c5de44377d2946;
$34de55b0354aabca$export$29dd17c7f3c81c36 = "overlay_f6be6c";
$34de55b0354aabca$export$96e4b36520c26a2c = "modal_f6be6c";
$34de55b0354aabca$export$34e0f9847d4c02dd = "container_f6be6c";
$34de55b0354aabca$export$38e42c68cf43b5d4 = "header_f6be6c";
$34de55b0354aabca$export$a7db06668cad9adb = "content_f6be6c";
$34de55b0354aabca$export$b40fc69c4a2927a1 = "loaded_f6be6c";
$34de55b0354aabca$export$f4c5de44377d2946 = "loader_f6be6c";


const $89a2d432df615fd9$var$IframeModal = ({ className: className, title: title = "", href: href = "", onClose: onClose })=>{
    const [isLoaded, setIsLoaded] = (0, $P551f.useState)(false);
    const loadingBarRef = (0, $P551f.useRef)(null);
    const brandingColor = document.body.style.getPropertyValue("--color-brand-default") || "#5d34f2";
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e479b6ac5364ae16$exports))), {
        shouldCloseOnEsc: true,
        id: "iframe-modal",
        role: "dialog",
        isOpen: Boolean(href),
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a6f0144cf2b2d456$exports)))($34de55b0354aabca$export$96e4b36520c26a2c, className),
        overlayClassName: $34de55b0354aabca$export$29dd17c7f3c81c36,
        closeTimeoutMS: 300,
        onAfterOpen: ()=>{
            var _loadingBarRef_current;
            (_loadingBarRef_current = loadingBarRef.current) === null || _loadingBarRef_current === void 0 ? void 0 : _loadingBarRef_current.continuousStart();
        },
        onRequestClose: onClose,
        children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("div", {
            className: $34de55b0354aabca$export$34e0f9847d4c02dd,
            children: [
                /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("div", {
                    className: $34de55b0354aabca$export$38e42c68cf43b5d4,
                    children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $c3a009e3761dfcb2$export$2e2bcd8739ae039), {
                        type: "close",
                        title: title,
                        onClose: onClose
                    })
                }),
                /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $609f9c250d82d76c$export$2e2bcd8739ae039), {
                    ref: loadingBarRef,
                    containerStyle: {
                        position: "relative"
                    },
                    shadow: false,
                    color: brandingColor,
                    waitingTime: 300,
                    className: $34de55b0354aabca$export$f4c5de44377d2946
                }),
                /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("div", {
                    className: $34de55b0354aabca$export$a7db06668cad9adb,
                    children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("iframe", {
                        title: title,
                        src: href,
                        sandbox: "allow-same-origin",
                        className: (0, $dd763c2393b0d659$export$c327da55a124987a)(isLoaded && $34de55b0354aabca$export$b40fc69c4a2927a1),
                        onLoad: ()=>{
                            var _loadingBarRef_current;
                            setIsLoaded(true);
                            (_loadingBarRef_current = loadingBarRef.current) === null || _loadingBarRef_current === void 0 ? void 0 : _loadingBarRef_current.complete();
                        },
                        onError: ()=>{
                            var _loadingBarRef_current;
                            setIsLoaded(true);
                            (_loadingBarRef_current = loadingBarRef.current) === null || _loadingBarRef_current === void 0 ? void 0 : _loadingBarRef_current.complete();
                        }
                    })
                })
            ]
        })
    });
};
var $89a2d432df615fd9$export$2e2bcd8739ae039 = $89a2d432df615fd9$var$IframeModal;


const $2fd5ca85228c6378$export$d1ae3eb34bde7fa3 = /*#__PURE__*/ (0, $P551f.createContext)({
    href: undefined,
    title: undefined,
    setModalState: (0, $96962764729a993e$export$8793edee2d425525)
});
const $2fd5ca85228c6378$export$6875a035353dd898 = ()=>(0, $P551f.useContext)($2fd5ca85228c6378$export$d1ae3eb34bde7fa3);
const $2fd5ca85228c6378$var$IframeModalProvider = ({ children: children })=>{
    const [modalState, setModalState] = (0, $P551f.useState)();
    const { isMobile: isMobile } = (0, $37bc2555b7bb33e3$export$2e2bcd8739ae039)();
    const context = (0, $P551f.useMemo)(()=>(0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, modalState), {
            setModalState: setModalState
        }), [
        modalState
    ]);
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)($2fd5ca85228c6378$export$d1ae3eb34bde7fa3.Provider, {
        value: context,
        children: [
            children,
            isMobile && /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $89a2d432df615fd9$export$2e2bcd8739ae039), {
                href: modalState === null || modalState === void 0 ? void 0 : modalState.href,
                title: modalState === null || modalState === void 0 ? void 0 : modalState.title,
                onClose: ()=>{
                    setModalState(undefined);
                }
            })
        ]
    });
};
var $2fd5ca85228c6378$export$2e2bcd8739ae039 = $2fd5ca85228c6378$var$IframeModalProvider;




var $P551f = parcelRequire("P551f");



var $P551f = parcelRequire("P551f");

var $07302f4f1f838f94$export$71763d16552fd512;
var $07302f4f1f838f94$export$b410431fab84fa58;
$07302f4f1f838f94$export$71763d16552fd512 = "toastContainer_ba7e56";
$07302f4f1f838f94$export$b410431fab84fa58 = "toast_ba7e56";


const $9410dcc00ee5e8b1$var$Toast = ({ message: message, duration: duration = 3000, callback: callback })=>{
    const [text, setText] = (0, $P551f.useState)("");
    (0, $P551f.useEffect)(()=>{
        if (!message) return;
        setText(message);
        const timer = setTimeout(()=>{
            callback === null || callback === void 0 ? void 0 : callback();
        }, duration);
        return ()=>{
            clearTimeout(timer);
        };
    }, [
        callback,
        duration,
        message,
        text
    ]);
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e479b6ac5364ae16$exports))), {
        shouldFocusAfterRender: false,
        // For styling use
        // eslint-disable-next-line jsx-a11y/aria-role
        role: "toast",
        isOpen: Boolean(message),
        overlayClassName: $07302f4f1f838f94$export$71763d16552fd512,
        className: $07302f4f1f838f94$export$b410431fab84fa58,
        closeTimeoutMS: 300,
        children: text
    });
};
var $9410dcc00ee5e8b1$export$2e2bcd8739ae039 = $9410dcc00ee5e8b1$var$Toast;


const $20cd5f2365f0f1ae$var$ToastProvider = ({ children: children })=>{
    const { toast: toast, setToast: setToast } = (0, $P551f.useContext)((0, $bf7e93717fb1eb16$export$2e2bcd8739ae039));
    // Prevent internal eventListener rebind
    const hideToast = (0, $P551f.useCallback)(()=>{
        setToast("");
    }, [
        setToast
    ]);
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)((0, $b1404a408b0d045c$exports.Fragment), {
        children: [
            children,
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $9410dcc00ee5e8b1$export$2e2bcd8739ae039), {
                message: toast,
                callback: hideToast
            })
        ]
    });
};
var $20cd5f2365f0f1ae$export$2e2bcd8739ae039 = $20cd5f2365f0f1ae$var$ToastProvider;








function $2faaedb0e1c5efc8$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}


function $b479f5d470b218cc$export$2e2bcd8739ae039(o, p) {
    $b479f5d470b218cc$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $b479f5d470b218cc$export$2e2bcd8739ae039(o, p);
}


function $692a5d17e939dc75$export$2e2bcd8739ae039(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) (0, $b479f5d470b218cc$export$2e2bcd8739ae039)(subClass, superClass);
}




function $db6513e54265935d$export$2e2bcd8739ae039(self, call) {
    if (call && ((0, $8a8a81e4d7494bfa$export$2e2bcd8739ae039)(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $2faaedb0e1c5efc8$export$2e2bcd8739ae039)(self);
}


function $43beed77362b5ee2$export$2e2bcd8739ae039(o) {
    $43beed77362b5ee2$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $43beed77362b5ee2$export$2e2bcd8739ae039(o);
}




function $293bd7e2c6cbed47$export$2e2bcd8739ae039(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}




function $49f97a422a6b5aac$export$2e2bcd8739ae039(arr) {
    return (0, $6cad87a5f16ae95e$export$2e2bcd8739ae039)(arr) || (0, $293bd7e2c6cbed47$export$2e2bcd8739ae039)(arr) || (0, $2db3567ee3f147f3$export$2e2bcd8739ae039)(arr) || (0, $623d9be3df5632bd$export$2e2bcd8739ae039)();
}


function $86e325ac3ddbcfa1$var$ownKeys$6(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $86e325ac3ddbcfa1$var$_objectSpread$6(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $86e325ac3ddbcfa1$var$ownKeys$6(Object(source), !0).forEach(function(key) {
            (0, $7c55c7e50dabe3fa$export$2e2bcd8739ae039)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $86e325ac3ddbcfa1$var$ownKeys$6(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $86e325ac3ddbcfa1$var$consoleLogger = {
    type: "logger",
    log: function log(args) {
        this.output("log", args);
    },
    warn: function warn(args) {
        this.output("warn", args);
    },
    error: function error(args) {
        this.output("error", args);
    },
    output: function output(type, args) {
        if (console && console[type]) console[type].apply(console, args);
    }
};
var $86e325ac3ddbcfa1$var$Logger = function() {
    function Logger(concreteLogger) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $f42f85cb8d7a52b7$export$2e2bcd8739ae039)(this, Logger);
        this.init(concreteLogger, options);
    }
    (0, $50f997bda58ccb7c$export$2e2bcd8739ae039)(Logger, [
        {
            key: "init",
            value: function init(concreteLogger) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                this.prefix = options.prefix || "i18next:";
                this.logger = concreteLogger || $86e325ac3ddbcfa1$var$consoleLogger;
                this.options = options;
                this.debug = options.debug;
            }
        },
        {
            key: "setDebug",
            value: function setDebug(bool) {
                this.debug = bool;
            }
        },
        {
            key: "log",
            value: function log() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                return this.forward(args, "log", "", true);
            }
        },
        {
            key: "warn",
            value: function warn() {
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                return this.forward(args, "warn", "", true);
            }
        },
        {
            key: "error",
            value: function error() {
                for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
                return this.forward(args, "error", "");
            }
        },
        {
            key: "deprecate",
            value: function deprecate() {
                for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
                return this.forward(args, "warn", "WARNING DEPRECATED: ", true);
            }
        },
        {
            key: "forward",
            value: function forward(args, lvl, prefix, debugOnly) {
                if (debugOnly && !this.debug) return null;
                if (typeof args[0] === "string") args[0] = "".concat(prefix).concat(this.prefix, " ").concat(args[0]);
                return this.logger[lvl](args);
            }
        },
        {
            key: "create",
            value: function create(moduleName) {
                return new Logger(this.logger, $86e325ac3ddbcfa1$var$_objectSpread$6($86e325ac3ddbcfa1$var$_objectSpread$6({}, {
                    prefix: "".concat(this.prefix, ":").concat(moduleName, ":")
                }), this.options));
            }
        },
        {
            key: "clone",
            value: function clone(options) {
                options = options || this.options;
                options.prefix = options.prefix || this.prefix;
                return new Logger(this.logger, options);
            }
        }
    ]);
    return Logger;
}();
var $86e325ac3ddbcfa1$var$baseLogger = new $86e325ac3ddbcfa1$var$Logger();
var $86e325ac3ddbcfa1$var$EventEmitter = function() {
    function EventEmitter() {
        (0, $f42f85cb8d7a52b7$export$2e2bcd8739ae039)(this, EventEmitter);
        this.observers = {};
    }
    (0, $50f997bda58ccb7c$export$2e2bcd8739ae039)(EventEmitter, [
        {
            key: "on",
            value: function on(events, listener) {
                var _this = this;
                events.split(" ").forEach(function(event) {
                    _this.observers[event] = _this.observers[event] || [];
                    _this.observers[event].push(listener);
                });
                return this;
            }
        },
        {
            key: "off",
            value: function off(event, listener) {
                if (!this.observers[event]) return;
                if (!listener) {
                    delete this.observers[event];
                    return;
                }
                this.observers[event] = this.observers[event].filter(function(l) {
                    return l !== listener;
                });
            }
        },
        {
            key: "emit",
            value: function emit(event) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                if (this.observers[event]) {
                    var cloned = [].concat(this.observers[event]);
                    cloned.forEach(function(observer) {
                        observer.apply(void 0, args);
                    });
                }
                if (this.observers["*"]) {
                    var _cloned = [].concat(this.observers["*"]);
                    _cloned.forEach(function(observer) {
                        observer.apply(observer, [
                            event
                        ].concat(args));
                    });
                }
            }
        }
    ]);
    return EventEmitter;
}();
function $86e325ac3ddbcfa1$var$defer() {
    var res;
    var rej;
    var promise = new Promise(function(resolve, reject) {
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
}
function $86e325ac3ddbcfa1$var$makeString(object) {
    if (object == null) return "";
    return "" + object;
}
function $86e325ac3ddbcfa1$var$copy(a, s, t) {
    a.forEach(function(m) {
        if (s[m]) t[m] = s[m];
    });
}
function $86e325ac3ddbcfa1$var$getLastOfPath(object, path, Empty) {
    function cleanKey(key) {
        return key && key.indexOf("###") > -1 ? key.replace(/###/g, ".") : key;
    }
    function canNotTraverseDeeper() {
        return !object || typeof object === "string";
    }
    var stack = typeof path !== "string" ? [].concat(path) : path.split(".");
    while(stack.length > 1){
        if (canNotTraverseDeeper()) return {};
        var key = cleanKey(stack.shift());
        if (!object[key] && Empty) object[key] = new Empty();
        if (Object.prototype.hasOwnProperty.call(object, key)) object = object[key];
        else object = {};
    }
    if (canNotTraverseDeeper()) return {};
    return {
        obj: object,
        k: cleanKey(stack.shift())
    };
}
function $86e325ac3ddbcfa1$var$setPath(object, path, newValue) {
    var _getLastOfPath = $86e325ac3ddbcfa1$var$getLastOfPath(object, path, Object), obj = _getLastOfPath.obj, k = _getLastOfPath.k;
    obj[k] = newValue;
}
function $86e325ac3ddbcfa1$var$pushPath(object, path, newValue, concat) {
    var _getLastOfPath2 = $86e325ac3ddbcfa1$var$getLastOfPath(object, path, Object), obj = _getLastOfPath2.obj, k = _getLastOfPath2.k;
    obj[k] = obj[k] || [];
    if (concat) obj[k] = obj[k].concat(newValue);
    if (!concat) obj[k].push(newValue);
}
function $86e325ac3ddbcfa1$var$getPath(object, path) {
    var _getLastOfPath3 = $86e325ac3ddbcfa1$var$getLastOfPath(object, path), obj = _getLastOfPath3.obj, k = _getLastOfPath3.k;
    if (!obj) return undefined;
    return obj[k];
}
function $86e325ac3ddbcfa1$var$getPathWithDefaults(data, defaultData, key) {
    var value = $86e325ac3ddbcfa1$var$getPath(data, key);
    if (value !== undefined) return value;
    return $86e325ac3ddbcfa1$var$getPath(defaultData, key);
}
function $86e325ac3ddbcfa1$var$deepExtend(target, source, overwrite) {
    for(var prop in source)if (prop !== "__proto__" && prop !== "constructor") {
        if (prop in target) {
            if (typeof target[prop] === "string" || target[prop] instanceof String || typeof source[prop] === "string" || source[prop] instanceof String) {
                if (overwrite) target[prop] = source[prop];
            } else $86e325ac3ddbcfa1$var$deepExtend(target[prop], source[prop], overwrite);
        } else target[prop] = source[prop];
    }
    return target;
}
function $86e325ac3ddbcfa1$var$regexEscape(str) {
    return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}
var $86e325ac3ddbcfa1$var$_entityMap = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;",
    "/": "&#x2F;"
};
function $86e325ac3ddbcfa1$var$escape(data) {
    if (typeof data === "string") return data.replace(/[&<>"'\/]/g, function(s) {
        return $86e325ac3ddbcfa1$var$_entityMap[s];
    });
    return data;
}
var $86e325ac3ddbcfa1$var$isIE10 = typeof window !== "undefined" && window.navigator && typeof window.navigator.userAgentData === "undefined" && window.navigator.userAgent && window.navigator.userAgent.indexOf("MSIE") > -1;
var $86e325ac3ddbcfa1$var$chars = [
    " ",
    ",",
    "?",
    "!",
    ";"
];
function $86e325ac3ddbcfa1$var$looksLikeObjectPath(key, nsSeparator, keySeparator) {
    nsSeparator = nsSeparator || "";
    keySeparator = keySeparator || "";
    var possibleChars = $86e325ac3ddbcfa1$var$chars.filter(function(c) {
        return nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0;
    });
    if (possibleChars.length === 0) return true;
    var r = new RegExp("(".concat(possibleChars.map(function(c) {
        return c === "?" ? "\\?" : c;
    }).join("|"), ")"));
    var matched = !r.test(key);
    if (!matched) {
        var ki = key.indexOf(keySeparator);
        if (ki > 0 && !r.test(key.substring(0, ki))) matched = true;
    }
    return matched;
}
function $86e325ac3ddbcfa1$var$deepFind(obj, path) {
    var keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ".";
    if (!obj) return undefined;
    if (obj[path]) return obj[path];
    var paths = path.split(keySeparator);
    var current = obj;
    for(var i = 0; i < paths.length; ++i){
        if (!current) return undefined;
        if (typeof current[paths[i]] === "string" && i + 1 < paths.length) return undefined;
        if (current[paths[i]] === undefined) {
            var j = 2;
            var p = paths.slice(i, i + j).join(keySeparator);
            var mix = current[p];
            while(mix === undefined && paths.length > i + j){
                j++;
                p = paths.slice(i, i + j).join(keySeparator);
                mix = current[p];
            }
            if (mix === undefined) return undefined;
            if (mix === null) return null;
            if (path.endsWith(p)) {
                if (typeof mix === "string") return mix;
                if (p && typeof mix[p] === "string") return mix[p];
            }
            var joinedPath = paths.slice(i + j).join(keySeparator);
            if (joinedPath) return $86e325ac3ddbcfa1$var$deepFind(mix, joinedPath, keySeparator);
            return undefined;
        }
        current = current[paths[i]];
    }
    return current;
}
function $86e325ac3ddbcfa1$var$ownKeys$5(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $86e325ac3ddbcfa1$var$_objectSpread$5(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $86e325ac3ddbcfa1$var$ownKeys$5(Object(source), !0).forEach(function(key) {
            (0, $7c55c7e50dabe3fa$export$2e2bcd8739ae039)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $86e325ac3ddbcfa1$var$ownKeys$5(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $86e325ac3ddbcfa1$var$_createSuper$3(Derived) {
    var hasNativeReflectConstruct = $86e325ac3ddbcfa1$var$_isNativeReflectConstruct$3();
    return function _createSuperInternal() {
        var Super = (0, $43beed77362b5ee2$export$2e2bcd8739ae039)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $43beed77362b5ee2$export$2e2bcd8739ae039)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $db6513e54265935d$export$2e2bcd8739ae039)(this, result);
    };
}
function $86e325ac3ddbcfa1$var$_isNativeReflectConstruct$3() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $86e325ac3ddbcfa1$var$ResourceStore = function(_EventEmitter) {
    (0, $692a5d17e939dc75$export$2e2bcd8739ae039)(ResourceStore, _EventEmitter);
    var _super = $86e325ac3ddbcfa1$var$_createSuper$3(ResourceStore);
    function ResourceStore(data) {
        var _this;
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            ns: [
                "translation"
            ],
            defaultNS: "translation"
        };
        (0, $f42f85cb8d7a52b7$export$2e2bcd8739ae039)(this, ResourceStore);
        _this = _super.call(this);
        if ($86e325ac3ddbcfa1$var$isIE10) $86e325ac3ddbcfa1$var$EventEmitter.call((0, $2faaedb0e1c5efc8$export$2e2bcd8739ae039)(_this));
        _this.data = data || {};
        _this.options = options;
        if (_this.options.keySeparator === undefined) _this.options.keySeparator = ".";
        if (_this.options.ignoreJSONStructure === undefined) _this.options.ignoreJSONStructure = true;
        return _this;
    }
    (0, $50f997bda58ccb7c$export$2e2bcd8739ae039)(ResourceStore, [
        {
            key: "addNamespaces",
            value: function addNamespaces(ns) {
                if (this.options.ns.indexOf(ns) < 0) this.options.ns.push(ns);
            }
        },
        {
            key: "removeNamespaces",
            value: function removeNamespaces(ns) {
                var index = this.options.ns.indexOf(ns);
                if (index > -1) this.options.ns.splice(index, 1);
            }
        },
        {
            key: "getResource",
            value: function getResource(lng, ns, key) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
                var path = [
                    lng,
                    ns
                ];
                if (key && typeof key !== "string") path = path.concat(key);
                if (key && typeof key === "string") path = path.concat(keySeparator ? key.split(keySeparator) : key);
                if (lng.indexOf(".") > -1) path = lng.split(".");
                var result = $86e325ac3ddbcfa1$var$getPath(this.data, path);
                if (result || !ignoreJSONStructure || typeof key !== "string") return result;
                return $86e325ac3ddbcfa1$var$deepFind(this.data && this.data[lng] && this.data[lng][ns], key, keySeparator);
            }
        },
        {
            key: "addResource",
            value: function addResource(lng, ns, key, value) {
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
                    silent: false
                };
                var keySeparator = this.options.keySeparator;
                if (keySeparator === undefined) keySeparator = ".";
                var path = [
                    lng,
                    ns
                ];
                if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
                if (lng.indexOf(".") > -1) {
                    path = lng.split(".");
                    value = ns;
                    ns = path[1];
                }
                this.addNamespaces(ns);
                $86e325ac3ddbcfa1$var$setPath(this.data, path, value);
                if (!options.silent) this.emit("added", lng, ns, key, value);
            }
        },
        {
            key: "addResources",
            value: function addResources(lng, ns, resources) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
                    silent: false
                };
                for(var m in resources)if (typeof resources[m] === "string" || Object.prototype.toString.apply(resources[m]) === "[object Array]") this.addResource(lng, ns, m, resources[m], {
                    silent: true
                });
                if (!options.silent) this.emit("added", lng, ns, resources);
            }
        },
        {
            key: "addResourceBundle",
            value: function addResourceBundle(lng, ns, resources, deep, overwrite) {
                var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
                    silent: false
                };
                var path = [
                    lng,
                    ns
                ];
                if (lng.indexOf(".") > -1) {
                    path = lng.split(".");
                    deep = resources;
                    resources = ns;
                    ns = path[1];
                }
                this.addNamespaces(ns);
                var pack = $86e325ac3ddbcfa1$var$getPath(this.data, path) || {};
                if (deep) $86e325ac3ddbcfa1$var$deepExtend(pack, resources, overwrite);
                else pack = $86e325ac3ddbcfa1$var$_objectSpread$5($86e325ac3ddbcfa1$var$_objectSpread$5({}, pack), resources);
                $86e325ac3ddbcfa1$var$setPath(this.data, path, pack);
                if (!options.silent) this.emit("added", lng, ns, resources);
            }
        },
        {
            key: "removeResourceBundle",
            value: function removeResourceBundle(lng, ns) {
                if (this.hasResourceBundle(lng, ns)) delete this.data[lng][ns];
                this.removeNamespaces(ns);
                this.emit("removed", lng, ns);
            }
        },
        {
            key: "hasResourceBundle",
            value: function hasResourceBundle(lng, ns) {
                return this.getResource(lng, ns) !== undefined;
            }
        },
        {
            key: "getResourceBundle",
            value: function getResourceBundle(lng, ns) {
                if (!ns) ns = this.options.defaultNS;
                if (this.options.compatibilityAPI === "v1") return $86e325ac3ddbcfa1$var$_objectSpread$5($86e325ac3ddbcfa1$var$_objectSpread$5({}, {}), this.getResource(lng, ns));
                return this.getResource(lng, ns);
            }
        },
        {
            key: "getDataByLanguage",
            value: function getDataByLanguage(lng) {
                return this.data[lng];
            }
        },
        {
            key: "hasLanguageSomeTranslations",
            value: function hasLanguageSomeTranslations(lng) {
                var data = this.getDataByLanguage(lng);
                var n = data && Object.keys(data) || [];
                return !!n.find(function(v) {
                    return data[v] && Object.keys(data[v]).length > 0;
                });
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return this.data;
            }
        }
    ]);
    return ResourceStore;
}($86e325ac3ddbcfa1$var$EventEmitter);
var $86e325ac3ddbcfa1$var$postProcessor = {
    processors: {},
    addPostProcessor: function addPostProcessor(module) {
        this.processors[module.name] = module;
    },
    handle: function handle(processors, value, key, options, translator) {
        var _this = this;
        processors.forEach(function(processor) {
            if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
        });
        return value;
    }
};
function $86e325ac3ddbcfa1$var$ownKeys$4(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $86e325ac3ddbcfa1$var$_objectSpread$4(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $86e325ac3ddbcfa1$var$ownKeys$4(Object(source), !0).forEach(function(key) {
            (0, $7c55c7e50dabe3fa$export$2e2bcd8739ae039)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $86e325ac3ddbcfa1$var$ownKeys$4(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $86e325ac3ddbcfa1$var$_createSuper$2(Derived) {
    var hasNativeReflectConstruct = $86e325ac3ddbcfa1$var$_isNativeReflectConstruct$2();
    return function _createSuperInternal() {
        var Super = (0, $43beed77362b5ee2$export$2e2bcd8739ae039)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $43beed77362b5ee2$export$2e2bcd8739ae039)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $db6513e54265935d$export$2e2bcd8739ae039)(this, result);
    };
}
function $86e325ac3ddbcfa1$var$_isNativeReflectConstruct$2() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $86e325ac3ddbcfa1$var$checkedLoadedFor = {};
var $86e325ac3ddbcfa1$var$Translator = function(_EventEmitter) {
    (0, $692a5d17e939dc75$export$2e2bcd8739ae039)(Translator, _EventEmitter);
    var _super = $86e325ac3ddbcfa1$var$_createSuper$2(Translator);
    function Translator(services) {
        var _this;
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $f42f85cb8d7a52b7$export$2e2bcd8739ae039)(this, Translator);
        _this = _super.call(this);
        if ($86e325ac3ddbcfa1$var$isIE10) $86e325ac3ddbcfa1$var$EventEmitter.call((0, $2faaedb0e1c5efc8$export$2e2bcd8739ae039)(_this));
        $86e325ac3ddbcfa1$var$copy([
            "resourceStore",
            "languageUtils",
            "pluralResolver",
            "interpolator",
            "backendConnector",
            "i18nFormat",
            "utils"
        ], services, (0, $2faaedb0e1c5efc8$export$2e2bcd8739ae039)(_this));
        _this.options = options;
        if (_this.options.keySeparator === undefined) _this.options.keySeparator = ".";
        _this.logger = $86e325ac3ddbcfa1$var$baseLogger.create("translator");
        return _this;
    }
    (0, $50f997bda58ccb7c$export$2e2bcd8739ae039)(Translator, [
        {
            key: "changeLanguage",
            value: function changeLanguage(lng) {
                if (lng) this.language = lng;
            }
        },
        {
            key: "exists",
            value: function exists(key) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                    interpolation: {}
                };
                if (key === undefined || key === null) return false;
                var resolved = this.resolve(key, options);
                return resolved && resolved.res !== undefined;
            }
        },
        {
            key: "extractFromKey",
            value: function extractFromKey(key, options) {
                var nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
                if (nsSeparator === undefined) nsSeparator = ":";
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var namespaces = options.ns || this.options.defaultNS || [];
                var wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
                var seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !options.keySeparator && !this.options.userDefinedNsSeparator && !options.nsSeparator && !$86e325ac3ddbcfa1$var$looksLikeObjectPath(key, nsSeparator, keySeparator);
                if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
                    var m = key.match(this.interpolator.nestingRegexp);
                    if (m && m.length > 0) return {
                        key: key,
                        namespaces: namespaces
                    };
                    var parts = key.split(nsSeparator);
                    if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
                    key = parts.join(keySeparator);
                }
                if (typeof namespaces === "string") namespaces = [
                    namespaces
                ];
                return {
                    key: key,
                    namespaces: namespaces
                };
            }
        },
        {
            key: "translate",
            value: function translate(keys, options, lastKey) {
                var _this2 = this;
                if ((0, $8a8a81e4d7494bfa$export$2e2bcd8739ae039)(options) !== "object" && this.options.overloadTranslationOptionHandler) options = this.options.overloadTranslationOptionHandler(arguments);
                if ((0, $8a8a81e4d7494bfa$export$2e2bcd8739ae039)(options) === "object") options = $86e325ac3ddbcfa1$var$_objectSpread$4({}, options);
                if (!options) options = {};
                if (keys === undefined || keys === null) return "";
                if (!Array.isArray(keys)) keys = [
                    String(keys)
                ];
                var returnDetails = options.returnDetails !== undefined ? options.returnDetails : this.options.returnDetails;
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var _this$extractFromKey = this.extractFromKey(keys[keys.length - 1], options), key = _this$extractFromKey.key, namespaces = _this$extractFromKey.namespaces;
                var namespace = namespaces[namespaces.length - 1];
                var lng = options.lng || this.language;
                var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
                if (lng && lng.toLowerCase() === "cimode") {
                    if (appendNamespaceToCIMode) {
                        var nsSeparator = options.nsSeparator || this.options.nsSeparator;
                        if (returnDetails) return {
                            res: "".concat(namespace).concat(nsSeparator).concat(key),
                            usedKey: key,
                            exactUsedKey: key,
                            usedLng: lng,
                            usedNS: namespace
                        };
                        return "".concat(namespace).concat(nsSeparator).concat(key);
                    }
                    if (returnDetails) return {
                        res: key,
                        usedKey: key,
                        exactUsedKey: key,
                        usedLng: lng,
                        usedNS: namespace
                    };
                    return key;
                }
                var resolved = this.resolve(keys, options);
                var res = resolved && resolved.res;
                var resUsedKey = resolved && resolved.usedKey || key;
                var resExactUsedKey = resolved && resolved.exactUsedKey || key;
                var resType = Object.prototype.toString.apply(res);
                var noObject = [
                    "[object Number]",
                    "[object Function]",
                    "[object RegExp]"
                ];
                var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
                var handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
                var handleAsObject = typeof res !== "string" && typeof res !== "boolean" && typeof res !== "number";
                if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === "string" && resType === "[object Array]")) {
                    if (!options.returnObjects && !this.options.returnObjects) {
                        if (!this.options.returnedObjectHandler) this.logger.warn("accessing an object - but returnObjects options is not enabled!");
                        var r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, $86e325ac3ddbcfa1$var$_objectSpread$4($86e325ac3ddbcfa1$var$_objectSpread$4({}, options), {}, {
                            ns: namespaces
                        })) : "key '".concat(key, " (").concat(this.language, ")' returned an object instead of string.");
                        if (returnDetails) {
                            resolved.res = r;
                            return resolved;
                        }
                        return r;
                    }
                    if (keySeparator) {
                        var resTypeIsArray = resType === "[object Array]";
                        var copy = resTypeIsArray ? [] : {};
                        var newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
                        for(var m in res)if (Object.prototype.hasOwnProperty.call(res, m)) {
                            var deepKey = "".concat(newKeyToUse).concat(keySeparator).concat(m);
                            copy[m] = this.translate(deepKey, $86e325ac3ddbcfa1$var$_objectSpread$4($86e325ac3ddbcfa1$var$_objectSpread$4({}, options), {
                                joinArrays: false,
                                ns: namespaces
                            }));
                            if (copy[m] === deepKey) copy[m] = res[m];
                        }
                        res = copy;
                    }
                } else if (handleAsObjectInI18nFormat && typeof joinArrays === "string" && resType === "[object Array]") {
                    res = res.join(joinArrays);
                    if (res) res = this.extendTranslation(res, keys, options, lastKey);
                } else {
                    var usedDefault = false;
                    var usedKey = false;
                    var needsPluralHandling = options.count !== undefined && typeof options.count !== "string";
                    var hasDefaultValue = Translator.hasDefaultValue(options);
                    var defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, options) : "";
                    var defaultValue = options["defaultValue".concat(defaultValueSuffix)] || options.defaultValue;
                    if (!this.isValidLookup(res) && hasDefaultValue) {
                        usedDefault = true;
                        res = defaultValue;
                    }
                    if (!this.isValidLookup(res)) {
                        usedKey = true;
                        res = key;
                    }
                    var missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
                    var resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
                    var updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
                    if (usedKey || usedDefault || updateMissing) {
                        this.logger.log(updateMissing ? "updateKey" : "missingKey", lng, namespace, key, updateMissing ? defaultValue : res);
                        if (keySeparator) {
                            var fk = this.resolve(key, $86e325ac3ddbcfa1$var$_objectSpread$4($86e325ac3ddbcfa1$var$_objectSpread$4({}, options), {}, {
                                keySeparator: false
                            }));
                            if (fk && fk.res) this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
                        }
                        var lngs = [];
                        var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
                        if (this.options.saveMissingTo === "fallback" && fallbackLngs && fallbackLngs[0]) for(var i = 0; i < fallbackLngs.length; i++)lngs.push(fallbackLngs[i]);
                        else if (this.options.saveMissingTo === "all") lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
                        else lngs.push(options.lng || this.language);
                        var send = function send(l, k, specificDefaultValue) {
                            var defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
                            if (_this2.options.missingKeyHandler) _this2.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, options);
                            else if (_this2.backendConnector && _this2.backendConnector.saveMissing) _this2.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, options);
                            _this2.emit("missingKey", l, namespace, k, res);
                        };
                        if (this.options.saveMissing) {
                            if (this.options.saveMissingPlurals && needsPluralHandling) lngs.forEach(function(language) {
                                _this2.pluralResolver.getSuffixes(language, options).forEach(function(suffix) {
                                    send([
                                        language
                                    ], key + suffix, options["defaultValue".concat(suffix)] || defaultValue);
                                });
                            });
                            else send(lngs, key, defaultValue);
                        }
                    }
                    res = this.extendTranslation(res, keys, options, resolved, lastKey);
                    if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = "".concat(namespace, ":").concat(key);
                    if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) {
                        if (this.options.compatibilityAPI !== "v1") res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? "".concat(namespace, ":").concat(key) : key, usedDefault ? res : undefined);
                        else res = this.options.parseMissingKeyHandler(res);
                    }
                }
                if (returnDetails) {
                    resolved.res = res;
                    return resolved;
                }
                return res;
            }
        },
        {
            key: "extendTranslation",
            value: function extendTranslation(res, key, options, resolved, lastKey) {
                var _this3 = this;
                if (this.i18nFormat && this.i18nFormat.parse) res = this.i18nFormat.parse(res, $86e325ac3ddbcfa1$var$_objectSpread$4($86e325ac3ddbcfa1$var$_objectSpread$4({}, this.options.interpolation.defaultVariables), options), resolved.usedLng, resolved.usedNS, resolved.usedKey, {
                    resolved: resolved
                });
                else if (!options.skipInterpolation) {
                    if (options.interpolation) this.interpolator.init($86e325ac3ddbcfa1$var$_objectSpread$4($86e325ac3ddbcfa1$var$_objectSpread$4({}, options), {
                        interpolation: $86e325ac3ddbcfa1$var$_objectSpread$4($86e325ac3ddbcfa1$var$_objectSpread$4({}, this.options.interpolation), options.interpolation)
                    }));
                    var skipOnVariables = typeof res === "string" && (options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
                    var nestBef;
                    if (skipOnVariables) {
                        var nb = res.match(this.interpolator.nestingRegexp);
                        nestBef = nb && nb.length;
                    }
                    var data = options.replace && typeof options.replace !== "string" ? options.replace : options;
                    if (this.options.interpolation.defaultVariables) data = $86e325ac3ddbcfa1$var$_objectSpread$4($86e325ac3ddbcfa1$var$_objectSpread$4({}, this.options.interpolation.defaultVariables), data);
                    res = this.interpolator.interpolate(res, data, options.lng || this.language, options);
                    if (skipOnVariables) {
                        var na = res.match(this.interpolator.nestingRegexp);
                        var nestAft = na && na.length;
                        if (nestBef < nestAft) options.nest = false;
                    }
                    if (!options.lng && this.options.compatibilityAPI !== "v1" && resolved && resolved.res) options.lng = resolved.usedLng;
                    if (options.nest !== false) res = this.interpolator.nest(res, function() {
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                        if (lastKey && lastKey[0] === args[0] && !options.context) {
                            _this3.logger.warn("It seems you are nesting recursively key: ".concat(args[0], " in key: ").concat(key[0]));
                            return null;
                        }
                        return _this3.translate.apply(_this3, args.concat([
                            key
                        ]));
                    }, options);
                    if (options.interpolation) this.interpolator.reset();
                }
                var postProcess = options.postProcess || this.options.postProcess;
                var postProcessorNames = typeof postProcess === "string" ? [
                    postProcess
                ] : postProcess;
                if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) res = $86e325ac3ddbcfa1$var$postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? $86e325ac3ddbcfa1$var$_objectSpread$4({
                    i18nResolved: resolved
                }, options) : options, this);
                return res;
            }
        },
        {
            key: "resolve",
            value: function resolve(keys) {
                var _this4 = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var found;
                var usedKey;
                var exactUsedKey;
                var usedLng;
                var usedNS;
                if (typeof keys === "string") keys = [
                    keys
                ];
                keys.forEach(function(k) {
                    if (_this4.isValidLookup(found)) return;
                    var extracted = _this4.extractFromKey(k, options);
                    var key = extracted.key;
                    usedKey = key;
                    var namespaces = extracted.namespaces;
                    if (_this4.options.fallbackNS) namespaces = namespaces.concat(_this4.options.fallbackNS);
                    var needsPluralHandling = options.count !== undefined && typeof options.count !== "string";
                    var needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && _this4.pluralResolver.shouldUseIntlApi();
                    var needsContextHandling = options.context !== undefined && (typeof options.context === "string" || typeof options.context === "number") && options.context !== "";
                    var codes = options.lngs ? options.lngs : _this4.languageUtils.toResolveHierarchy(options.lng || _this4.language, options.fallbackLng);
                    namespaces.forEach(function(ns) {
                        if (_this4.isValidLookup(found)) return;
                        usedNS = ns;
                        if (!$86e325ac3ddbcfa1$var$checkedLoadedFor["".concat(codes[0], "-").concat(ns)] && _this4.utils && _this4.utils.hasLoadedNamespace && !_this4.utils.hasLoadedNamespace(usedNS)) {
                            $86e325ac3ddbcfa1$var$checkedLoadedFor["".concat(codes[0], "-").concat(ns)] = true;
                            _this4.logger.warn('key "'.concat(usedKey, '" for languages "').concat(codes.join(", "), '" won\'t get resolved as namespace "').concat(usedNS, '" was not yet loaded'), "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
                        }
                        codes.forEach(function(code) {
                            if (_this4.isValidLookup(found)) return;
                            usedLng = code;
                            var finalKeys = [
                                key
                            ];
                            if (_this4.i18nFormat && _this4.i18nFormat.addLookupKeys) _this4.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
                            else {
                                var pluralSuffix;
                                if (needsPluralHandling) pluralSuffix = _this4.pluralResolver.getSuffix(code, options.count, options);
                                var zeroSuffix = "".concat(_this4.options.pluralSeparator, "zero");
                                if (needsPluralHandling) {
                                    finalKeys.push(key + pluralSuffix);
                                    if (needsZeroSuffixLookup) finalKeys.push(key + zeroSuffix);
                                }
                                if (needsContextHandling) {
                                    var contextKey = "".concat(key).concat(_this4.options.contextSeparator).concat(options.context);
                                    finalKeys.push(contextKey);
                                    if (needsPluralHandling) {
                                        finalKeys.push(contextKey + pluralSuffix);
                                        if (needsZeroSuffixLookup) finalKeys.push(contextKey + zeroSuffix);
                                    }
                                }
                            }
                            var possibleKey;
                            while(possibleKey = finalKeys.pop())if (!_this4.isValidLookup(found)) {
                                exactUsedKey = possibleKey;
                                found = _this4.getResource(code, ns, possibleKey, options);
                            }
                        });
                    });
                });
                return {
                    res: found,
                    usedKey: usedKey,
                    exactUsedKey: exactUsedKey,
                    usedLng: usedLng,
                    usedNS: usedNS
                };
            }
        },
        {
            key: "isValidLookup",
            value: function isValidLookup(res) {
                return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === "");
            }
        },
        {
            key: "getResource",
            value: function getResource(code, ns, key) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
                return this.resourceStore.getResource(code, ns, key, options);
            }
        }
    ], [
        {
            key: "hasDefaultValue",
            value: function hasDefaultValue(options) {
                var prefix = "defaultValue";
                for(var option in options){
                    if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) return true;
                }
                return false;
            }
        }
    ]);
    return Translator;
}($86e325ac3ddbcfa1$var$EventEmitter);
function $86e325ac3ddbcfa1$var$capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
var $86e325ac3ddbcfa1$var$LanguageUtil = function() {
    function LanguageUtil(options) {
        (0, $f42f85cb8d7a52b7$export$2e2bcd8739ae039)(this, LanguageUtil);
        this.options = options;
        this.supportedLngs = this.options.supportedLngs || false;
        this.logger = $86e325ac3ddbcfa1$var$baseLogger.create("languageUtils");
    }
    (0, $50f997bda58ccb7c$export$2e2bcd8739ae039)(LanguageUtil, [
        {
            key: "getScriptPartFromCode",
            value: function getScriptPartFromCode(code) {
                if (!code || code.indexOf("-") < 0) return null;
                var p = code.split("-");
                if (p.length === 2) return null;
                p.pop();
                if (p[p.length - 1].toLowerCase() === "x") return null;
                return this.formatLanguageCode(p.join("-"));
            }
        },
        {
            key: "getLanguagePartFromCode",
            value: function getLanguagePartFromCode(code) {
                if (!code || code.indexOf("-") < 0) return code;
                var p = code.split("-");
                return this.formatLanguageCode(p[0]);
            }
        },
        {
            key: "formatLanguageCode",
            value: function formatLanguageCode(code) {
                if (typeof code === "string" && code.indexOf("-") > -1) {
                    var specialCases = [
                        "hans",
                        "hant",
                        "latn",
                        "cyrl",
                        "cans",
                        "mong",
                        "arab"
                    ];
                    var p = code.split("-");
                    if (this.options.lowerCaseLng) p = p.map(function(part) {
                        return part.toLowerCase();
                    });
                    else if (p.length === 2) {
                        p[0] = p[0].toLowerCase();
                        p[1] = p[1].toUpperCase();
                        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = $86e325ac3ddbcfa1$var$capitalize(p[1].toLowerCase());
                    } else if (p.length === 3) {
                        p[0] = p[0].toLowerCase();
                        if (p[1].length === 2) p[1] = p[1].toUpperCase();
                        if (p[0] !== "sgn" && p[2].length === 2) p[2] = p[2].toUpperCase();
                        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = $86e325ac3ddbcfa1$var$capitalize(p[1].toLowerCase());
                        if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = $86e325ac3ddbcfa1$var$capitalize(p[2].toLowerCase());
                    }
                    return p.join("-");
                }
                return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
            }
        },
        {
            key: "isSupportedCode",
            value: function isSupportedCode(code) {
                if (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) code = this.getLanguagePartFromCode(code);
                return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
            }
        },
        {
            key: "getBestMatchFromCodes",
            value: function getBestMatchFromCodes(codes) {
                var _this = this;
                if (!codes) return null;
                var found;
                codes.forEach(function(code) {
                    if (found) return;
                    var cleanedLng = _this.formatLanguageCode(code);
                    if (!_this.options.supportedLngs || _this.isSupportedCode(cleanedLng)) found = cleanedLng;
                });
                if (!found && this.options.supportedLngs) codes.forEach(function(code) {
                    if (found) return;
                    var lngOnly = _this.getLanguagePartFromCode(code);
                    if (_this.isSupportedCode(lngOnly)) return found = lngOnly;
                    found = _this.options.supportedLngs.find(function(supportedLng) {
                        if (supportedLng === lngOnly) return supportedLng;
                        if (supportedLng.indexOf("-") < 0 && lngOnly.indexOf("-") < 0) return;
                        if (supportedLng.indexOf(lngOnly) === 0) return supportedLng;
                    });
                });
                if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
                return found;
            }
        },
        {
            key: "getFallbackCodes",
            value: function getFallbackCodes(fallbacks, code) {
                if (!fallbacks) return [];
                if (typeof fallbacks === "function") fallbacks = fallbacks(code);
                if (typeof fallbacks === "string") fallbacks = [
                    fallbacks
                ];
                if (Object.prototype.toString.apply(fallbacks) === "[object Array]") return fallbacks;
                if (!code) return fallbacks["default"] || [];
                var found = fallbacks[code];
                if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
                if (!found) found = fallbacks[this.formatLanguageCode(code)];
                if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
                if (!found) found = fallbacks["default"];
                return found || [];
            }
        },
        {
            key: "toResolveHierarchy",
            value: function toResolveHierarchy(code, fallbackCode) {
                var _this2 = this;
                var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
                var codes = [];
                var addCode = function addCode(c) {
                    if (!c) return;
                    if (_this2.isSupportedCode(c)) codes.push(c);
                    else _this2.logger.warn("rejecting language code not found in supportedLngs: ".concat(c));
                };
                if (typeof code === "string" && code.indexOf("-") > -1) {
                    if (this.options.load !== "languageOnly") addCode(this.formatLanguageCode(code));
                    if (this.options.load !== "languageOnly" && this.options.load !== "currentOnly") addCode(this.getScriptPartFromCode(code));
                    if (this.options.load !== "currentOnly") addCode(this.getLanguagePartFromCode(code));
                } else if (typeof code === "string") addCode(this.formatLanguageCode(code));
                fallbackCodes.forEach(function(fc) {
                    if (codes.indexOf(fc) < 0) addCode(_this2.formatLanguageCode(fc));
                });
                return codes;
            }
        }
    ]);
    return LanguageUtil;
}();
var $86e325ac3ddbcfa1$var$sets = [
    {
        lngs: [
            "ach",
            "ak",
            "am",
            "arn",
            "br",
            "fil",
            "gun",
            "ln",
            "mfe",
            "mg",
            "mi",
            "oc",
            "pt",
            "pt-BR",
            "tg",
            "tl",
            "ti",
            "tr",
            "uz",
            "wa"
        ],
        nr: [
            1,
            2
        ],
        fc: 1
    },
    {
        lngs: [
            "af",
            "an",
            "ast",
            "az",
            "bg",
            "bn",
            "ca",
            "da",
            "de",
            "dev",
            "el",
            "en",
            "eo",
            "es",
            "et",
            "eu",
            "fi",
            "fo",
            "fur",
            "fy",
            "gl",
            "gu",
            "ha",
            "hi",
            "hu",
            "hy",
            "ia",
            "it",
            "kk",
            "kn",
            "ku",
            "lb",
            "mai",
            "ml",
            "mn",
            "mr",
            "nah",
            "nap",
            "nb",
            "ne",
            "nl",
            "nn",
            "no",
            "nso",
            "pa",
            "pap",
            "pms",
            "ps",
            "pt-PT",
            "rm",
            "sco",
            "se",
            "si",
            "so",
            "son",
            "sq",
            "sv",
            "sw",
            "ta",
            "te",
            "tk",
            "ur",
            "yo"
        ],
        nr: [
            1,
            2
        ],
        fc: 2
    },
    {
        lngs: [
            "ay",
            "bo",
            "cgg",
            "fa",
            "ht",
            "id",
            "ja",
            "jbo",
            "ka",
            "km",
            "ko",
            "ky",
            "lo",
            "ms",
            "sah",
            "su",
            "th",
            "tt",
            "ug",
            "vi",
            "wo",
            "zh"
        ],
        nr: [
            1
        ],
        fc: 3
    },
    {
        lngs: [
            "be",
            "bs",
            "cnr",
            "dz",
            "hr",
            "ru",
            "sr",
            "uk"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 4
    },
    {
        lngs: [
            "ar"
        ],
        nr: [
            0,
            1,
            2,
            3,
            11,
            100
        ],
        fc: 5
    },
    {
        lngs: [
            "cs",
            "sk"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 6
    },
    {
        lngs: [
            "csb",
            "pl"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 7
    },
    {
        lngs: [
            "cy"
        ],
        nr: [
            1,
            2,
            3,
            8
        ],
        fc: 8
    },
    {
        lngs: [
            "fr"
        ],
        nr: [
            1,
            2
        ],
        fc: 9
    },
    {
        lngs: [
            "ga"
        ],
        nr: [
            1,
            2,
            3,
            7,
            11
        ],
        fc: 10
    },
    {
        lngs: [
            "gd"
        ],
        nr: [
            1,
            2,
            3,
            20
        ],
        fc: 11
    },
    {
        lngs: [
            "is"
        ],
        nr: [
            1,
            2
        ],
        fc: 12
    },
    {
        lngs: [
            "jv"
        ],
        nr: [
            0,
            1
        ],
        fc: 13
    },
    {
        lngs: [
            "kw"
        ],
        nr: [
            1,
            2,
            3,
            4
        ],
        fc: 14
    },
    {
        lngs: [
            "lt"
        ],
        nr: [
            1,
            2,
            10
        ],
        fc: 15
    },
    {
        lngs: [
            "lv"
        ],
        nr: [
            1,
            2,
            0
        ],
        fc: 16
    },
    {
        lngs: [
            "mk"
        ],
        nr: [
            1,
            2
        ],
        fc: 17
    },
    {
        lngs: [
            "mnk"
        ],
        nr: [
            0,
            1,
            2
        ],
        fc: 18
    },
    {
        lngs: [
            "mt"
        ],
        nr: [
            1,
            2,
            11,
            20
        ],
        fc: 19
    },
    {
        lngs: [
            "or"
        ],
        nr: [
            2,
            1
        ],
        fc: 2
    },
    {
        lngs: [
            "ro"
        ],
        nr: [
            1,
            2,
            20
        ],
        fc: 20
    },
    {
        lngs: [
            "sl"
        ],
        nr: [
            5,
            1,
            2,
            3
        ],
        fc: 21
    },
    {
        lngs: [
            "he",
            "iw"
        ],
        nr: [
            1,
            2,
            20,
            21
        ],
        fc: 22
    }
];
var $86e325ac3ddbcfa1$var$_rulesPluralsTypes = {
    1: function _(n) {
        return Number(n > 1);
    },
    2: function _(n) {
        return Number(n != 1);
    },
    3: function _(n) {
        return 0;
    },
    4: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    5: function _(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
    },
    6: function _(n) {
        return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
    },
    7: function _(n) {
        return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    8: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
    },
    9: function _(n) {
        return Number(n >= 2);
    },
    10: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
    },
    11: function _(n) {
        return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
    },
    12: function _(n) {
        return Number(n % 10 != 1 || n % 100 == 11);
    },
    13: function _(n) {
        return Number(n !== 0);
    },
    14: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
    },
    15: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    16: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
    },
    17: function _(n) {
        return Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1);
    },
    18: function _(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
    },
    19: function _(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
    },
    20: function _(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
    },
    21: function _(n) {
        return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
    },
    22: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
    }
};
var $86e325ac3ddbcfa1$var$deprecatedJsonVersions = [
    "v1",
    "v2",
    "v3"
];
var $86e325ac3ddbcfa1$var$suffixesOrder = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
};
function $86e325ac3ddbcfa1$var$createRules() {
    var rules = {};
    $86e325ac3ddbcfa1$var$sets.forEach(function(set) {
        set.lngs.forEach(function(l) {
            rules[l] = {
                numbers: set.nr,
                plurals: $86e325ac3ddbcfa1$var$_rulesPluralsTypes[set.fc]
            };
        });
    });
    return rules;
}
var $86e325ac3ddbcfa1$var$PluralResolver = function() {
    function PluralResolver(languageUtils) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $f42f85cb8d7a52b7$export$2e2bcd8739ae039)(this, PluralResolver);
        this.languageUtils = languageUtils;
        this.options = options;
        this.logger = $86e325ac3ddbcfa1$var$baseLogger.create("pluralResolver");
        if ((!this.options.compatibilityJSON || this.options.compatibilityJSON === "v4") && (typeof Intl === "undefined" || !Intl.PluralRules)) {
            this.options.compatibilityJSON = "v3";
            this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.");
        }
        this.rules = $86e325ac3ddbcfa1$var$createRules();
    }
    (0, $50f997bda58ccb7c$export$2e2bcd8739ae039)(PluralResolver, [
        {
            key: "addRule",
            value: function addRule(lng, obj) {
                this.rules[lng] = obj;
            }
        },
        {
            key: "getRule",
            value: function getRule(code) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                if (this.shouldUseIntlApi()) try {
                    return new Intl.PluralRules(code, {
                        type: options.ordinal ? "ordinal" : "cardinal"
                    });
                } catch (_unused) {
                    return;
                }
                return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
            }
        },
        {
            key: "needsPlural",
            value: function needsPlural(code) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var rule = this.getRule(code, options);
                if (this.shouldUseIntlApi()) return rule && rule.resolvedOptions().pluralCategories.length > 1;
                return rule && rule.numbers.length > 1;
            }
        },
        {
            key: "getPluralFormsOfKey",
            value: function getPluralFormsOfKey(code, key) {
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return this.getSuffixes(code, options).map(function(suffix) {
                    return "".concat(key).concat(suffix);
                });
            }
        },
        {
            key: "getSuffixes",
            value: function getSuffixes(code) {
                var _this = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var rule = this.getRule(code, options);
                if (!rule) return [];
                if (this.shouldUseIntlApi()) return rule.resolvedOptions().pluralCategories.sort(function(pluralCategory1, pluralCategory2) {
                    return $86e325ac3ddbcfa1$var$suffixesOrder[pluralCategory1] - $86e325ac3ddbcfa1$var$suffixesOrder[pluralCategory2];
                }).map(function(pluralCategory) {
                    return "".concat(_this.options.prepend).concat(pluralCategory);
                });
                return rule.numbers.map(function(number) {
                    return _this.getSuffix(code, number, options);
                });
            }
        },
        {
            key: "getSuffix",
            value: function getSuffix(code, count) {
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var rule = this.getRule(code, options);
                if (rule) {
                    if (this.shouldUseIntlApi()) return "".concat(this.options.prepend).concat(rule.select(count));
                    return this.getSuffixRetroCompatible(rule, count);
                }
                this.logger.warn("no plural rule found for: ".concat(code));
                return "";
            }
        },
        {
            key: "getSuffixRetroCompatible",
            value: function getSuffixRetroCompatible(rule, count) {
                var _this2 = this;
                var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
                var suffix = rule.numbers[idx];
                if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
                    if (suffix === 2) suffix = "plural";
                    else if (suffix === 1) suffix = "";
                }
                var returnSuffix = function returnSuffix() {
                    return _this2.options.prepend && suffix.toString() ? _this2.options.prepend + suffix.toString() : suffix.toString();
                };
                if (this.options.compatibilityJSON === "v1") {
                    if (suffix === 1) return "";
                    if (typeof suffix === "number") return "_plural_".concat(suffix.toString());
                    return returnSuffix();
                } else if (this.options.compatibilityJSON === "v2") return returnSuffix();
                else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) return returnSuffix();
                return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
            }
        },
        {
            key: "shouldUseIntlApi",
            value: function shouldUseIntlApi() {
                return !$86e325ac3ddbcfa1$var$deprecatedJsonVersions.includes(this.options.compatibilityJSON);
            }
        }
    ]);
    return PluralResolver;
}();
function $86e325ac3ddbcfa1$var$ownKeys$3(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $86e325ac3ddbcfa1$var$_objectSpread$3(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $86e325ac3ddbcfa1$var$ownKeys$3(Object(source), !0).forEach(function(key) {
            (0, $7c55c7e50dabe3fa$export$2e2bcd8739ae039)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $86e325ac3ddbcfa1$var$ownKeys$3(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $86e325ac3ddbcfa1$var$deepFindWithDefaults(data, defaultData, key) {
    var keySeparator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ".";
    var ignoreJSONStructure = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    var path = $86e325ac3ddbcfa1$var$getPathWithDefaults(data, defaultData, key);
    if (!path && ignoreJSONStructure && typeof key === "string") {
        path = $86e325ac3ddbcfa1$var$deepFind(data, key, keySeparator);
        if (path === undefined) path = $86e325ac3ddbcfa1$var$deepFind(defaultData, key, keySeparator);
    }
    return path;
}
var $86e325ac3ddbcfa1$var$Interpolator = function() {
    function Interpolator() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, $f42f85cb8d7a52b7$export$2e2bcd8739ae039)(this, Interpolator);
        this.logger = $86e325ac3ddbcfa1$var$baseLogger.create("interpolator");
        this.options = options;
        this.format = options.interpolation && options.interpolation.format || function(value) {
            return value;
        };
        this.init(options);
    }
    (0, $50f997bda58ccb7c$export$2e2bcd8739ae039)(Interpolator, [
        {
            key: "init",
            value: function init() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                if (!options.interpolation) options.interpolation = {
                    escapeValue: true
                };
                var iOpts = options.interpolation;
                this.escape = iOpts.escape !== undefined ? iOpts.escape : $86e325ac3ddbcfa1$var$escape;
                this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
                this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
                this.prefix = iOpts.prefix ? $86e325ac3ddbcfa1$var$regexEscape(iOpts.prefix) : iOpts.prefixEscaped || "{{";
                this.suffix = iOpts.suffix ? $86e325ac3ddbcfa1$var$regexEscape(iOpts.suffix) : iOpts.suffixEscaped || "}}";
                this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ",";
                this.unescapePrefix = iOpts.unescapeSuffix ? "" : iOpts.unescapePrefix || "-";
                this.unescapeSuffix = this.unescapePrefix ? "" : iOpts.unescapeSuffix || "";
                this.nestingPrefix = iOpts.nestingPrefix ? $86e325ac3ddbcfa1$var$regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || $86e325ac3ddbcfa1$var$regexEscape("$t(");
                this.nestingSuffix = iOpts.nestingSuffix ? $86e325ac3ddbcfa1$var$regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || $86e325ac3ddbcfa1$var$regexEscape(")");
                this.nestingOptionsSeparator = iOpts.nestingOptionsSeparator ? iOpts.nestingOptionsSeparator : iOpts.nestingOptionsSeparator || ",";
                this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;
                this.alwaysFormat = iOpts.alwaysFormat !== undefined ? iOpts.alwaysFormat : false;
                this.resetRegExp();
            }
        },
        {
            key: "reset",
            value: function reset() {
                if (this.options) this.init(this.options);
            }
        },
        {
            key: "resetRegExp",
            value: function resetRegExp() {
                var regexpStr = "".concat(this.prefix, "(.+?)").concat(this.suffix);
                this.regexp = new RegExp(regexpStr, "g");
                var regexpUnescapeStr = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
                this.regexpUnescape = new RegExp(regexpUnescapeStr, "g");
                var nestingRegexpStr = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
                this.nestingRegexp = new RegExp(nestingRegexpStr, "g");
            }
        },
        {
            key: "interpolate",
            value: function interpolate(str, data, lng, options) {
                var _this = this;
                var match;
                var value;
                var replaces;
                var defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
                function regexSafe(val) {
                    return val.replace(/\$/g, "$$$$");
                }
                var handleFormat = function handleFormat(key) {
                    if (key.indexOf(_this.formatSeparator) < 0) {
                        var path = $86e325ac3ddbcfa1$var$deepFindWithDefaults(data, defaultData, key, _this.options.keySeparator, _this.options.ignoreJSONStructure);
                        return _this.alwaysFormat ? _this.format(path, undefined, lng, $86e325ac3ddbcfa1$var$_objectSpread$3($86e325ac3ddbcfa1$var$_objectSpread$3($86e325ac3ddbcfa1$var$_objectSpread$3({}, options), data), {}, {
                            interpolationkey: key
                        })) : path;
                    }
                    var p = key.split(_this.formatSeparator);
                    var k = p.shift().trim();
                    var f = p.join(_this.formatSeparator).trim();
                    return _this.format($86e325ac3ddbcfa1$var$deepFindWithDefaults(data, defaultData, k, _this.options.keySeparator, _this.options.ignoreJSONStructure), f, lng, $86e325ac3ddbcfa1$var$_objectSpread$3($86e325ac3ddbcfa1$var$_objectSpread$3($86e325ac3ddbcfa1$var$_objectSpread$3({}, options), data), {}, {
                        interpolationkey: k
                    }));
                };
                this.resetRegExp();
                var missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
                var skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
                var todos = [
                    {
                        regex: this.regexpUnescape,
                        safeValue: function safeValue(val) {
                            return regexSafe(val);
                        }
                    },
                    {
                        regex: this.regexp,
                        safeValue: function safeValue(val) {
                            return _this.escapeValue ? regexSafe(_this.escape(val)) : regexSafe(val);
                        }
                    }
                ];
                todos.forEach(function(todo) {
                    replaces = 0;
                    while(match = todo.regex.exec(str)){
                        var matchedVar = match[1].trim();
                        value = handleFormat(matchedVar);
                        if (value === undefined) {
                            if (typeof missingInterpolationHandler === "function") {
                                var temp = missingInterpolationHandler(str, match, options);
                                value = typeof temp === "string" ? temp : "";
                            } else if (options && Object.prototype.hasOwnProperty.call(options, matchedVar)) value = "";
                            else if (skipOnVariables) {
                                value = match[0];
                                continue;
                            } else {
                                _this.logger.warn("missed to pass in variable ".concat(matchedVar, " for interpolating ").concat(str));
                                value = "";
                            }
                        } else if (typeof value !== "string" && !_this.useRawValueToEscape) value = $86e325ac3ddbcfa1$var$makeString(value);
                        var safeValue = todo.safeValue(value);
                        str = str.replace(match[0], safeValue);
                        if (skipOnVariables) {
                            todo.regex.lastIndex += value.length;
                            todo.regex.lastIndex -= match[0].length;
                        } else todo.regex.lastIndex = 0;
                        replaces++;
                        if (replaces >= _this.maxReplaces) break;
                    }
                });
                return str;
            }
        },
        {
            key: "nest",
            value: function nest(str, fc) {
                var _this2 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var match;
                var value;
                var clonedOptions;
                function handleHasOptions(key, inheritedOptions) {
                    var sep = this.nestingOptionsSeparator;
                    if (key.indexOf(sep) < 0) return key;
                    var c = key.split(new RegExp("".concat(sep, "[ ]*{")));
                    var optionsString = "{".concat(c[1]);
                    key = c[0];
                    optionsString = this.interpolate(optionsString, clonedOptions);
                    var matchedSingleQuotes = optionsString.match(/'/g);
                    var matchedDoubleQuotes = optionsString.match(/"/g);
                    if (matchedSingleQuotes && matchedSingleQuotes.length % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) optionsString = optionsString.replace(/'/g, '"');
                    try {
                        clonedOptions = JSON.parse(optionsString);
                        if (inheritedOptions) clonedOptions = $86e325ac3ddbcfa1$var$_objectSpread$3($86e325ac3ddbcfa1$var$_objectSpread$3({}, inheritedOptions), clonedOptions);
                    } catch (e) {
                        this.logger.warn("failed parsing options string in nesting for key ".concat(key), e);
                        return "".concat(key).concat(sep).concat(optionsString);
                    }
                    delete clonedOptions.defaultValue;
                    return key;
                }
                while(match = this.nestingRegexp.exec(str)){
                    var formatters = [];
                    clonedOptions = $86e325ac3ddbcfa1$var$_objectSpread$3({}, options);
                    clonedOptions = clonedOptions.replace && typeof clonedOptions.replace !== "string" ? clonedOptions.replace : clonedOptions;
                    clonedOptions.applyPostProcessor = false;
                    delete clonedOptions.defaultValue;
                    var doReduce = false;
                    if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
                        var r = match[1].split(this.formatSeparator).map(function(elem) {
                            return elem.trim();
                        });
                        match[1] = r.shift();
                        formatters = r;
                        doReduce = true;
                    }
                    value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
                    if (value && match[0] === str && typeof value !== "string") return value;
                    if (typeof value !== "string") value = $86e325ac3ddbcfa1$var$makeString(value);
                    if (!value) {
                        this.logger.warn("missed to resolve ".concat(match[1], " for nesting ").concat(str));
                        value = "";
                    }
                    if (doReduce) value = formatters.reduce(function(v, f) {
                        return _this2.format(v, f, options.lng, $86e325ac3ddbcfa1$var$_objectSpread$3($86e325ac3ddbcfa1$var$_objectSpread$3({}, options), {}, {
                            interpolationkey: match[1].trim()
                        }));
                    }, value.trim());
                    str = str.replace(match[0], value);
                    this.regexp.lastIndex = 0;
                }
                return str;
            }
        }
    ]);
    return Interpolator;
}();
function $86e325ac3ddbcfa1$var$ownKeys$2(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $86e325ac3ddbcfa1$var$_objectSpread$2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $86e325ac3ddbcfa1$var$ownKeys$2(Object(source), !0).forEach(function(key) {
            (0, $7c55c7e50dabe3fa$export$2e2bcd8739ae039)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $86e325ac3ddbcfa1$var$ownKeys$2(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $86e325ac3ddbcfa1$var$parseFormatStr(formatStr) {
    var formatName = formatStr.toLowerCase().trim();
    var formatOptions = {};
    if (formatStr.indexOf("(") > -1) {
        var p = formatStr.split("(");
        formatName = p[0].toLowerCase().trim();
        var optStr = p[1].substring(0, p[1].length - 1);
        if (formatName === "currency" && optStr.indexOf(":") < 0) {
            if (!formatOptions.currency) formatOptions.currency = optStr.trim();
        } else if (formatName === "relativetime" && optStr.indexOf(":") < 0) {
            if (!formatOptions.range) formatOptions.range = optStr.trim();
        } else {
            var opts = optStr.split(";");
            opts.forEach(function(opt) {
                if (!opt) return;
                var _opt$split = opt.split(":"), _opt$split2 = (0, $49f97a422a6b5aac$export$2e2bcd8739ae039)(_opt$split), key = _opt$split2[0], rest = _opt$split2.slice(1);
                var val = rest.join(":").trim().replace(/^'+|'+$/g, "");
                if (!formatOptions[key.trim()]) formatOptions[key.trim()] = val;
                if (val === "false") formatOptions[key.trim()] = false;
                if (val === "true") formatOptions[key.trim()] = true;
                if (!isNaN(val)) formatOptions[key.trim()] = parseInt(val, 10);
            });
        }
    }
    return {
        formatName: formatName,
        formatOptions: formatOptions
    };
}
function $86e325ac3ddbcfa1$var$createCachedFormatter(fn) {
    var cache = {};
    return function invokeFormatter(val, lng, options) {
        var key = lng + JSON.stringify(options);
        var formatter = cache[key];
        if (!formatter) {
            formatter = fn(lng, options);
            cache[key] = formatter;
        }
        return formatter(val);
    };
}
var $86e325ac3ddbcfa1$var$Formatter = function() {
    function Formatter() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, $f42f85cb8d7a52b7$export$2e2bcd8739ae039)(this, Formatter);
        this.logger = $86e325ac3ddbcfa1$var$baseLogger.create("formatter");
        this.options = options;
        this.formats = {
            number: $86e325ac3ddbcfa1$var$createCachedFormatter(function(lng, opt) {
                var formatter = new Intl.NumberFormat(lng, $86e325ac3ddbcfa1$var$_objectSpread$2({}, opt));
                return function(val) {
                    return formatter.format(val);
                };
            }),
            currency: $86e325ac3ddbcfa1$var$createCachedFormatter(function(lng, opt) {
                var formatter = new Intl.NumberFormat(lng, $86e325ac3ddbcfa1$var$_objectSpread$2($86e325ac3ddbcfa1$var$_objectSpread$2({}, opt), {}, {
                    style: "currency"
                }));
                return function(val) {
                    return formatter.format(val);
                };
            }),
            datetime: $86e325ac3ddbcfa1$var$createCachedFormatter(function(lng, opt) {
                var formatter = new Intl.DateTimeFormat(lng, $86e325ac3ddbcfa1$var$_objectSpread$2({}, opt));
                return function(val) {
                    return formatter.format(val);
                };
            }),
            relativetime: $86e325ac3ddbcfa1$var$createCachedFormatter(function(lng, opt) {
                var formatter = new Intl.RelativeTimeFormat(lng, $86e325ac3ddbcfa1$var$_objectSpread$2({}, opt));
                return function(val) {
                    return formatter.format(val, opt.range || "day");
                };
            }),
            list: $86e325ac3ddbcfa1$var$createCachedFormatter(function(lng, opt) {
                var formatter = new Intl.ListFormat(lng, $86e325ac3ddbcfa1$var$_objectSpread$2({}, opt));
                return function(val) {
                    return formatter.format(val);
                };
            })
        };
        this.init(options);
    }
    (0, $50f997bda58ccb7c$export$2e2bcd8739ae039)(Formatter, [
        {
            key: "init",
            value: function init(services) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                    interpolation: {}
                };
                var iOpts = options.interpolation;
                this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ",";
            }
        },
        {
            key: "add",
            value: function add(name, fc) {
                this.formats[name.toLowerCase().trim()] = fc;
            }
        },
        {
            key: "addCached",
            value: function addCached(name, fc) {
                this.formats[name.toLowerCase().trim()] = $86e325ac3ddbcfa1$var$createCachedFormatter(fc);
            }
        },
        {
            key: "format",
            value: function format(value, _format, lng) {
                var _this = this;
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var formats = _format.split(this.formatSeparator);
                var result = formats.reduce(function(mem, f) {
                    var _parseFormatStr = $86e325ac3ddbcfa1$var$parseFormatStr(f), formatName = _parseFormatStr.formatName, formatOptions = _parseFormatStr.formatOptions;
                    if (_this.formats[formatName]) {
                        var formatted = mem;
                        try {
                            var valOptions = options && options.formatParams && options.formatParams[options.interpolationkey] || {};
                            var l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
                            formatted = _this.formats[formatName](mem, l, $86e325ac3ddbcfa1$var$_objectSpread$2($86e325ac3ddbcfa1$var$_objectSpread$2($86e325ac3ddbcfa1$var$_objectSpread$2({}, formatOptions), options), valOptions));
                        } catch (error) {
                            _this.logger.warn(error);
                        }
                        return formatted;
                    } else _this.logger.warn("there was no format function for ".concat(formatName));
                    return mem;
                }, value);
                return result;
            }
        }
    ]);
    return Formatter;
}();
function $86e325ac3ddbcfa1$var$ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $86e325ac3ddbcfa1$var$_objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $86e325ac3ddbcfa1$var$ownKeys$1(Object(source), !0).forEach(function(key) {
            (0, $7c55c7e50dabe3fa$export$2e2bcd8739ae039)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $86e325ac3ddbcfa1$var$ownKeys$1(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $86e325ac3ddbcfa1$var$_createSuper$1(Derived) {
    var hasNativeReflectConstruct = $86e325ac3ddbcfa1$var$_isNativeReflectConstruct$1();
    return function _createSuperInternal() {
        var Super = (0, $43beed77362b5ee2$export$2e2bcd8739ae039)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $43beed77362b5ee2$export$2e2bcd8739ae039)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $db6513e54265935d$export$2e2bcd8739ae039)(this, result);
    };
}
function $86e325ac3ddbcfa1$var$_isNativeReflectConstruct$1() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $86e325ac3ddbcfa1$var$removePending(q, name) {
    if (q.pending[name] !== undefined) {
        delete q.pending[name];
        q.pendingCount--;
    }
}
var $86e325ac3ddbcfa1$var$Connector = function(_EventEmitter) {
    (0, $692a5d17e939dc75$export$2e2bcd8739ae039)(Connector, _EventEmitter);
    var _super = $86e325ac3ddbcfa1$var$_createSuper$1(Connector);
    function Connector(backend, store, services) {
        var _this;
        var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        (0, $f42f85cb8d7a52b7$export$2e2bcd8739ae039)(this, Connector);
        _this = _super.call(this);
        if ($86e325ac3ddbcfa1$var$isIE10) $86e325ac3ddbcfa1$var$EventEmitter.call((0, $2faaedb0e1c5efc8$export$2e2bcd8739ae039)(_this));
        _this.backend = backend;
        _this.store = store;
        _this.services = services;
        _this.languageUtils = services.languageUtils;
        _this.options = options;
        _this.logger = $86e325ac3ddbcfa1$var$baseLogger.create("backendConnector");
        _this.waitingReads = [];
        _this.maxParallelReads = options.maxParallelReads || 10;
        _this.readingCalls = 0;
        _this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
        _this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
        _this.state = {};
        _this.queue = [];
        if (_this.backend && _this.backend.init) _this.backend.init(services, options.backend, options);
        return _this;
    }
    (0, $50f997bda58ccb7c$export$2e2bcd8739ae039)(Connector, [
        {
            key: "queueLoad",
            value: function queueLoad(languages, namespaces, options, callback) {
                var _this2 = this;
                var toLoad = {};
                var pending = {};
                var toLoadLanguages = {};
                var toLoadNamespaces = {};
                languages.forEach(function(lng) {
                    var hasAllNamespaces = true;
                    namespaces.forEach(function(ns) {
                        var name = "".concat(lng, "|").concat(ns);
                        if (!options.reload && _this2.store.hasResourceBundle(lng, ns)) _this2.state[name] = 2;
                        else if (_this2.state[name] < 0) ;
                        else if (_this2.state[name] === 1) {
                            if (pending[name] === undefined) pending[name] = true;
                        } else {
                            _this2.state[name] = 1;
                            hasAllNamespaces = false;
                            if (pending[name] === undefined) pending[name] = true;
                            if (toLoad[name] === undefined) toLoad[name] = true;
                            if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
                        }
                    });
                    if (!hasAllNamespaces) toLoadLanguages[lng] = true;
                });
                if (Object.keys(toLoad).length || Object.keys(pending).length) this.queue.push({
                    pending: pending,
                    pendingCount: Object.keys(pending).length,
                    loaded: {},
                    errors: [],
                    callback: callback
                });
                return {
                    toLoad: Object.keys(toLoad),
                    pending: Object.keys(pending),
                    toLoadLanguages: Object.keys(toLoadLanguages),
                    toLoadNamespaces: Object.keys(toLoadNamespaces)
                };
            }
        },
        {
            key: "loaded",
            value: function loaded(name, err, data) {
                var s = name.split("|");
                var lng = s[0];
                var ns = s[1];
                if (err) this.emit("failedLoading", lng, ns, err);
                if (data) this.store.addResourceBundle(lng, ns, data);
                this.state[name] = err ? -1 : 2;
                var loaded = {};
                this.queue.forEach(function(q) {
                    $86e325ac3ddbcfa1$var$pushPath(q.loaded, [
                        lng
                    ], ns);
                    $86e325ac3ddbcfa1$var$removePending(q, name);
                    if (err) q.errors.push(err);
                    if (q.pendingCount === 0 && !q.done) {
                        Object.keys(q.loaded).forEach(function(l) {
                            if (!loaded[l]) loaded[l] = {};
                            var loadedKeys = q.loaded[l];
                            if (loadedKeys.length) loadedKeys.forEach(function(n) {
                                if (loaded[l][n] === undefined) loaded[l][n] = true;
                            });
                        });
                        q.done = true;
                        if (q.errors.length) q.callback(q.errors);
                        else q.callback();
                    }
                });
                this.emit("loaded", loaded);
                this.queue = this.queue.filter(function(q) {
                    return !q.done;
                });
            }
        },
        {
            key: "read",
            value: function read(lng, ns, fcName) {
                var _this3 = this;
                var tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
                var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this.retryTimeout;
                var callback = arguments.length > 5 ? arguments[5] : undefined;
                if (!lng.length) return callback(null, {});
                if (this.readingCalls >= this.maxParallelReads) {
                    this.waitingReads.push({
                        lng: lng,
                        ns: ns,
                        fcName: fcName,
                        tried: tried,
                        wait: wait,
                        callback: callback
                    });
                    return;
                }
                this.readingCalls++;
                var resolver = function resolver(err, data) {
                    _this3.readingCalls--;
                    if (_this3.waitingReads.length > 0) {
                        var next = _this3.waitingReads.shift();
                        _this3.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
                    }
                    if (err && data && tried < _this3.maxRetries) {
                        setTimeout(function() {
                            _this3.read.call(_this3, lng, ns, fcName, tried + 1, wait * 2, callback);
                        }, wait);
                        return;
                    }
                    callback(err, data);
                };
                var fc = this.backend[fcName].bind(this.backend);
                if (fc.length === 2) {
                    try {
                        var r = fc(lng, ns);
                        if (r && typeof r.then === "function") r.then(function(data) {
                            return resolver(null, data);
                        })["catch"](resolver);
                        else resolver(null, r);
                    } catch (err) {
                        resolver(err);
                    }
                    return;
                }
                return fc(lng, ns, resolver);
            }
        },
        {
            key: "prepareLoading",
            value: function prepareLoading(languages, namespaces) {
                var _this4 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var callback = arguments.length > 3 ? arguments[3] : undefined;
                if (!this.backend) {
                    this.logger.warn("No backend was added via i18next.use. Will not load resources.");
                    return callback && callback();
                }
                if (typeof languages === "string") languages = this.languageUtils.toResolveHierarchy(languages);
                if (typeof namespaces === "string") namespaces = [
                    namespaces
                ];
                var toLoad = this.queueLoad(languages, namespaces, options, callback);
                if (!toLoad.toLoad.length) {
                    if (!toLoad.pending.length) callback();
                    return null;
                }
                toLoad.toLoad.forEach(function(name) {
                    _this4.loadOne(name);
                });
            }
        },
        {
            key: "load",
            value: function load(languages, namespaces, callback) {
                this.prepareLoading(languages, namespaces, {}, callback);
            }
        },
        {
            key: "reload",
            value: function reload(languages, namespaces, callback) {
                this.prepareLoading(languages, namespaces, {
                    reload: true
                }, callback);
            }
        },
        {
            key: "loadOne",
            value: function loadOne(name) {
                var _this5 = this;
                var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
                var s = name.split("|");
                var lng = s[0];
                var ns = s[1];
                this.read(lng, ns, "read", undefined, undefined, function(err, data) {
                    if (err) _this5.logger.warn("".concat(prefix, "loading namespace ").concat(ns, " for language ").concat(lng, " failed"), err);
                    if (!err && data) _this5.logger.log("".concat(prefix, "loaded namespace ").concat(ns, " for language ").concat(lng), data);
                    _this5.loaded(name, err, data);
                });
            }
        },
        {
            key: "saveMissing",
            value: function saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
                var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var clb = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : function() {};
                if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
                    this.logger.warn('did not save key "'.concat(key, '" as the namespace "').concat(namespace, '" was not yet loaded'), "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
                    return;
                }
                if (key === undefined || key === null || key === "") return;
                if (this.backend && this.backend.create) {
                    var opts = $86e325ac3ddbcfa1$var$_objectSpread$1($86e325ac3ddbcfa1$var$_objectSpread$1({}, options), {}, {
                        isUpdate: isUpdate
                    });
                    var fc = this.backend.create.bind(this.backend);
                    if (fc.length < 6) try {
                        var r;
                        if (fc.length === 5) r = fc(languages, namespace, key, fallbackValue, opts);
                        else r = fc(languages, namespace, key, fallbackValue);
                        if (r && typeof r.then === "function") r.then(function(data) {
                            return clb(null, data);
                        })["catch"](clb);
                        else clb(null, r);
                    } catch (err) {
                        clb(err);
                    }
                    else fc(languages, namespace, key, fallbackValue, clb, opts);
                }
                if (!languages || !languages[0]) return;
                this.store.addResource(languages[0], namespace, key, fallbackValue);
            }
        }
    ]);
    return Connector;
}($86e325ac3ddbcfa1$var$EventEmitter);
function $86e325ac3ddbcfa1$var$get() {
    return {
        debug: false,
        initImmediate: true,
        ns: [
            "translation"
        ],
        defaultNS: [
            "translation"
        ],
        fallbackLng: [
            "dev"
        ],
        fallbackNS: false,
        supportedLngs: false,
        nonExplicitSupportedLngs: false,
        load: "all",
        preload: false,
        simplifyPluralSuffix: true,
        keySeparator: ".",
        nsSeparator: ":",
        pluralSeparator: "_",
        contextSeparator: "_",
        partialBundledLanguages: false,
        saveMissing: false,
        updateMissing: false,
        saveMissingTo: "fallback",
        saveMissingPlurals: true,
        missingKeyHandler: false,
        missingInterpolationHandler: false,
        postProcess: false,
        postProcessPassResolved: false,
        returnNull: true,
        returnEmptyString: true,
        returnObjects: false,
        joinArrays: false,
        returnedObjectHandler: false,
        parseMissingKeyHandler: false,
        appendNamespaceToMissingKey: false,
        appendNamespaceToCIMode: false,
        overloadTranslationOptionHandler: function handle(args) {
            var ret = {};
            if ((0, $8a8a81e4d7494bfa$export$2e2bcd8739ae039)(args[1]) === "object") ret = args[1];
            if (typeof args[1] === "string") ret.defaultValue = args[1];
            if (typeof args[2] === "string") ret.tDescription = args[2];
            if ((0, $8a8a81e4d7494bfa$export$2e2bcd8739ae039)(args[2]) === "object" || (0, $8a8a81e4d7494bfa$export$2e2bcd8739ae039)(args[3]) === "object") {
                var options = args[3] || args[2];
                Object.keys(options).forEach(function(key) {
                    ret[key] = options[key];
                });
            }
            return ret;
        },
        interpolation: {
            escapeValue: true,
            format: function format(value, _format, lng, options) {
                return value;
            },
            prefix: "{{",
            suffix: "}}",
            formatSeparator: ",",
            unescapePrefix: "-",
            nestingPrefix: "$t(",
            nestingSuffix: ")",
            nestingOptionsSeparator: ",",
            maxReplaces: 1000,
            skipOnVariables: true
        }
    };
}
function $86e325ac3ddbcfa1$var$transformOptions(options) {
    if (typeof options.ns === "string") options.ns = [
        options.ns
    ];
    if (typeof options.fallbackLng === "string") options.fallbackLng = [
        options.fallbackLng
    ];
    if (typeof options.fallbackNS === "string") options.fallbackNS = [
        options.fallbackNS
    ];
    if (options.supportedLngs && options.supportedLngs.indexOf("cimode") < 0) options.supportedLngs = options.supportedLngs.concat([
        "cimode"
    ]);
    return options;
}
function $86e325ac3ddbcfa1$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $86e325ac3ddbcfa1$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $86e325ac3ddbcfa1$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $7c55c7e50dabe3fa$export$2e2bcd8739ae039)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $86e325ac3ddbcfa1$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $86e325ac3ddbcfa1$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $86e325ac3ddbcfa1$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $43beed77362b5ee2$export$2e2bcd8739ae039)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $43beed77362b5ee2$export$2e2bcd8739ae039)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $db6513e54265935d$export$2e2bcd8739ae039)(this, result);
    };
}
function $86e325ac3ddbcfa1$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $86e325ac3ddbcfa1$var$noop() {}
function $86e325ac3ddbcfa1$var$bindMemberFunctions(inst) {
    var mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
    mems.forEach(function(mem) {
        if (typeof inst[mem] === "function") inst[mem] = inst[mem].bind(inst);
    });
}
var $86e325ac3ddbcfa1$var$I18n = function(_EventEmitter) {
    (0, $692a5d17e939dc75$export$2e2bcd8739ae039)(I18n, _EventEmitter);
    var _super = $86e325ac3ddbcfa1$var$_createSuper(I18n);
    function I18n() {
        var _this;
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var callback = arguments.length > 1 ? arguments[1] : undefined;
        (0, $f42f85cb8d7a52b7$export$2e2bcd8739ae039)(this, I18n);
        _this = _super.call(this);
        if ($86e325ac3ddbcfa1$var$isIE10) $86e325ac3ddbcfa1$var$EventEmitter.call((0, $2faaedb0e1c5efc8$export$2e2bcd8739ae039)(_this));
        _this.options = $86e325ac3ddbcfa1$var$transformOptions(options);
        _this.services = {};
        _this.logger = $86e325ac3ddbcfa1$var$baseLogger;
        _this.modules = {
            external: []
        };
        $86e325ac3ddbcfa1$var$bindMemberFunctions((0, $2faaedb0e1c5efc8$export$2e2bcd8739ae039)(_this));
        if (callback && !_this.isInitialized && !options.isClone) {
            if (!_this.options.initImmediate) {
                _this.init(options, callback);
                return (0, $db6513e54265935d$export$2e2bcd8739ae039)(_this, (0, $2faaedb0e1c5efc8$export$2e2bcd8739ae039)(_this));
            }
            setTimeout(function() {
                _this.init(options, callback);
            }, 0);
        }
        return _this;
    }
    (0, $50f997bda58ccb7c$export$2e2bcd8739ae039)(I18n, [
        {
            key: "init",
            value: function init() {
                var _this2 = this;
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var callback = arguments.length > 1 ? arguments[1] : undefined;
                if (typeof options === "function") {
                    callback = options;
                    options = {};
                }
                if (!options.defaultNS && options.defaultNS !== false && options.ns) {
                    if (typeof options.ns === "string") options.defaultNS = options.ns;
                    else if (options.ns.indexOf("translation") < 0) options.defaultNS = options.ns[0];
                }
                var defOpts = $86e325ac3ddbcfa1$var$get();
                this.options = $86e325ac3ddbcfa1$var$_objectSpread($86e325ac3ddbcfa1$var$_objectSpread($86e325ac3ddbcfa1$var$_objectSpread({}, defOpts), this.options), $86e325ac3ddbcfa1$var$transformOptions(options));
                if (this.options.compatibilityAPI !== "v1") this.options.interpolation = $86e325ac3ddbcfa1$var$_objectSpread($86e325ac3ddbcfa1$var$_objectSpread({}, defOpts.interpolation), this.options.interpolation);
                if (options.keySeparator !== undefined) this.options.userDefinedKeySeparator = options.keySeparator;
                if (options.nsSeparator !== undefined) this.options.userDefinedNsSeparator = options.nsSeparator;
                function createClassOnDemand(ClassOrObject) {
                    if (!ClassOrObject) return null;
                    if (typeof ClassOrObject === "function") return new ClassOrObject();
                    return ClassOrObject;
                }
                if (!this.options.isClone) {
                    if (this.modules.logger) $86e325ac3ddbcfa1$var$baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
                    else $86e325ac3ddbcfa1$var$baseLogger.init(null, this.options);
                    var formatter;
                    if (this.modules.formatter) formatter = this.modules.formatter;
                    else if (typeof Intl !== "undefined") formatter = $86e325ac3ddbcfa1$var$Formatter;
                    var lu = new $86e325ac3ddbcfa1$var$LanguageUtil(this.options);
                    this.store = new $86e325ac3ddbcfa1$var$ResourceStore(this.options.resources, this.options);
                    var s = this.services;
                    s.logger = $86e325ac3ddbcfa1$var$baseLogger;
                    s.resourceStore = this.store;
                    s.languageUtils = lu;
                    s.pluralResolver = new $86e325ac3ddbcfa1$var$PluralResolver(lu, {
                        prepend: this.options.pluralSeparator,
                        compatibilityJSON: this.options.compatibilityJSON,
                        simplifyPluralSuffix: this.options.simplifyPluralSuffix
                    });
                    if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
                        s.formatter = createClassOnDemand(formatter);
                        s.formatter.init(s, this.options);
                        this.options.interpolation.format = s.formatter.format.bind(s.formatter);
                    }
                    s.interpolator = new $86e325ac3ddbcfa1$var$Interpolator(this.options);
                    s.utils = {
                        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
                    };
                    s.backendConnector = new $86e325ac3ddbcfa1$var$Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
                    s.backendConnector.on("*", function(event) {
                        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                        _this2.emit.apply(_this2, [
                            event
                        ].concat(args));
                    });
                    if (this.modules.languageDetector) {
                        s.languageDetector = createClassOnDemand(this.modules.languageDetector);
                        if (s.languageDetector.init) s.languageDetector.init(s, this.options.detection, this.options);
                    }
                    if (this.modules.i18nFormat) {
                        s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
                        if (s.i18nFormat.init) s.i18nFormat.init(this);
                    }
                    this.translator = new $86e325ac3ddbcfa1$var$Translator(this.services, this.options);
                    this.translator.on("*", function(event) {
                        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                        _this2.emit.apply(_this2, [
                            event
                        ].concat(args));
                    });
                    this.modules.external.forEach(function(m) {
                        if (m.init) m.init(_this2);
                    });
                }
                this.format = this.options.interpolation.format;
                if (!callback) callback = $86e325ac3ddbcfa1$var$noop;
                if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
                    var codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                    if (codes.length > 0 && codes[0] !== "dev") this.options.lng = codes[0];
                }
                if (!this.services.languageDetector && !this.options.lng) this.logger.warn("init: no languageDetector is used and no lng is defined");
                var storeApi = [
                    "getResource",
                    "hasResourceBundle",
                    "getResourceBundle",
                    "getDataByLanguage"
                ];
                storeApi.forEach(function(fcName) {
                    _this2[fcName] = function() {
                        var _this2$store;
                        return (_this2$store = _this2.store)[fcName].apply(_this2$store, arguments);
                    };
                });
                var storeApiChained = [
                    "addResource",
                    "addResources",
                    "addResourceBundle",
                    "removeResourceBundle"
                ];
                storeApiChained.forEach(function(fcName) {
                    _this2[fcName] = function() {
                        var _this2$store2;
                        (_this2$store2 = _this2.store)[fcName].apply(_this2$store2, arguments);
                        return _this2;
                    };
                });
                var deferred = $86e325ac3ddbcfa1$var$defer();
                var load = function load() {
                    var finish = function finish(err, t) {
                        if (_this2.isInitialized && !_this2.initializedStoreOnce) _this2.logger.warn("init: i18next is already initialized. You should call init just once!");
                        _this2.isInitialized = true;
                        if (!_this2.options.isClone) _this2.logger.log("initialized", _this2.options);
                        _this2.emit("initialized", _this2.options);
                        deferred.resolve(t);
                        callback(err, t);
                    };
                    if (_this2.languages && _this2.options.compatibilityAPI !== "v1" && !_this2.isInitialized) return finish(null, _this2.t.bind(_this2));
                    _this2.changeLanguage(_this2.options.lng, finish);
                };
                if (this.options.resources || !this.options.initImmediate) load();
                else setTimeout(load, 0);
                return deferred;
            }
        },
        {
            key: "loadResources",
            value: function loadResources(language) {
                var _this3 = this;
                var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $86e325ac3ddbcfa1$var$noop;
                var usedCallback = callback;
                var usedLng = typeof language === "string" ? language : this.language;
                if (typeof language === "function") usedCallback = language;
                if (!this.options.resources || this.options.partialBundledLanguages) {
                    if (usedLng && usedLng.toLowerCase() === "cimode") return usedCallback();
                    var toLoad = [];
                    var append = function append(lng) {
                        if (!lng) return;
                        var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);
                        lngs.forEach(function(l) {
                            if (toLoad.indexOf(l) < 0) toLoad.push(l);
                        });
                    };
                    if (!usedLng) {
                        var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                        fallbacks.forEach(function(l) {
                            return append(l);
                        });
                    } else append(usedLng);
                    if (this.options.preload) this.options.preload.forEach(function(l) {
                        return append(l);
                    });
                    this.services.backendConnector.load(toLoad, this.options.ns, function(e) {
                        if (!e && !_this3.resolvedLanguage && _this3.language) _this3.setResolvedLanguage(_this3.language);
                        usedCallback(e);
                    });
                } else usedCallback(null);
            }
        },
        {
            key: "reloadResources",
            value: function reloadResources(lngs, ns, callback) {
                var deferred = $86e325ac3ddbcfa1$var$defer();
                if (!lngs) lngs = this.languages;
                if (!ns) ns = this.options.ns;
                if (!callback) callback = $86e325ac3ddbcfa1$var$noop;
                this.services.backendConnector.reload(lngs, ns, function(err) {
                    deferred.resolve();
                    callback(err);
                });
                return deferred;
            }
        },
        {
            key: "use",
            value: function use(module) {
                if (!module) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
                if (!module.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
                if (module.type === "backend") this.modules.backend = module;
                if (module.type === "logger" || module.log && module.warn && module.error) this.modules.logger = module;
                if (module.type === "languageDetector") this.modules.languageDetector = module;
                if (module.type === "i18nFormat") this.modules.i18nFormat = module;
                if (module.type === "postProcessor") $86e325ac3ddbcfa1$var$postProcessor.addPostProcessor(module);
                if (module.type === "formatter") this.modules.formatter = module;
                if (module.type === "3rdParty") this.modules.external.push(module);
                return this;
            }
        },
        {
            key: "setResolvedLanguage",
            value: function setResolvedLanguage(l) {
                if (!l || !this.languages) return;
                if ([
                    "cimode",
                    "dev"
                ].indexOf(l) > -1) return;
                for(var li = 0; li < this.languages.length; li++){
                    var lngInLngs = this.languages[li];
                    if ([
                        "cimode",
                        "dev"
                    ].indexOf(lngInLngs) > -1) continue;
                    if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
                        this.resolvedLanguage = lngInLngs;
                        break;
                    }
                }
            }
        },
        {
            key: "changeLanguage",
            value: function changeLanguage(lng, callback) {
                var _this4 = this;
                this.isLanguageChangingTo = lng;
                var deferred = $86e325ac3ddbcfa1$var$defer();
                this.emit("languageChanging", lng);
                var setLngProps = function setLngProps(l) {
                    _this4.language = l;
                    _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
                    _this4.resolvedLanguage = undefined;
                    _this4.setResolvedLanguage(l);
                };
                var done = function done(err, l) {
                    if (l) {
                        setLngProps(l);
                        _this4.translator.changeLanguage(l);
                        _this4.isLanguageChangingTo = undefined;
                        _this4.emit("languageChanged", l);
                        _this4.logger.log("languageChanged", l);
                    } else _this4.isLanguageChangingTo = undefined;
                    deferred.resolve(function() {
                        return _this4.t.apply(_this4, arguments);
                    });
                    if (callback) callback(err, function() {
                        return _this4.t.apply(_this4, arguments);
                    });
                };
                var setLng = function setLng(lngs) {
                    if (!lng && !lngs && _this4.services.languageDetector) lngs = [];
                    var l = typeof lngs === "string" ? lngs : _this4.services.languageUtils.getBestMatchFromCodes(lngs);
                    if (l) {
                        if (!_this4.language) setLngProps(l);
                        if (!_this4.translator.language) _this4.translator.changeLanguage(l);
                        if (_this4.services.languageDetector && _this4.services.languageDetector.cacheUserLanguage) _this4.services.languageDetector.cacheUserLanguage(l);
                    }
                    _this4.loadResources(l, function(err) {
                        done(err, l);
                    });
                };
                if (!lng && this.services.languageDetector && !this.services.languageDetector.async) setLng(this.services.languageDetector.detect());
                else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
                    if (this.services.languageDetector.detect.length === 0) this.services.languageDetector.detect().then(setLng);
                    else this.services.languageDetector.detect(setLng);
                } else setLng(lng);
                return deferred;
            }
        },
        {
            key: "getFixedT",
            value: function getFixedT(lng, ns, keyPrefix) {
                var _this5 = this;
                var fixedT = function fixedT(key, opts) {
                    var options;
                    if ((0, $8a8a81e4d7494bfa$export$2e2bcd8739ae039)(opts) !== "object") {
                        for(var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)rest[_key3 - 2] = arguments[_key3];
                        options = _this5.options.overloadTranslationOptionHandler([
                            key,
                            opts
                        ].concat(rest));
                    } else options = $86e325ac3ddbcfa1$var$_objectSpread({}, opts);
                    options.lng = options.lng || fixedT.lng;
                    options.lngs = options.lngs || fixedT.lngs;
                    options.ns = options.ns || fixedT.ns;
                    options.keyPrefix = options.keyPrefix || keyPrefix || fixedT.keyPrefix;
                    var keySeparator = _this5.options.keySeparator || ".";
                    var resultKey;
                    if (options.keyPrefix && Array.isArray(key)) resultKey = key.map(function(k) {
                        return "".concat(options.keyPrefix).concat(keySeparator).concat(k);
                    });
                    else resultKey = options.keyPrefix ? "".concat(options.keyPrefix).concat(keySeparator).concat(key) : key;
                    return _this5.t(resultKey, options);
                };
                if (typeof lng === "string") fixedT.lng = lng;
                else fixedT.lngs = lng;
                fixedT.ns = ns;
                fixedT.keyPrefix = keyPrefix;
                return fixedT;
            }
        },
        {
            key: "t",
            value: function t() {
                var _this$translator;
                return this.translator && (_this$translator = this.translator).translate.apply(_this$translator, arguments);
            }
        },
        {
            key: "exists",
            value: function exists() {
                var _this$translator2;
                return this.translator && (_this$translator2 = this.translator).exists.apply(_this$translator2, arguments);
            }
        },
        {
            key: "setDefaultNamespace",
            value: function setDefaultNamespace(ns) {
                this.options.defaultNS = ns;
            }
        },
        {
            key: "hasLoadedNamespace",
            value: function hasLoadedNamespace(ns) {
                var _this6 = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                if (!this.isInitialized) {
                    this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages);
                    return false;
                }
                if (!this.languages || !this.languages.length) {
                    this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages);
                    return false;
                }
                var lng = this.resolvedLanguage || this.languages[0];
                var fallbackLng = this.options ? this.options.fallbackLng : false;
                var lastLng = this.languages[this.languages.length - 1];
                if (lng.toLowerCase() === "cimode") return true;
                var loadNotPending = function loadNotPending(l, n) {
                    var loadState = _this6.services.backendConnector.state["".concat(l, "|").concat(n)];
                    return loadState === -1 || loadState === 2;
                };
                if (options.precheck) {
                    var preResult = options.precheck(this, loadNotPending);
                    if (preResult !== undefined) return preResult;
                }
                if (this.hasResourceBundle(lng, ns)) return true;
                if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
                if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
                return false;
            }
        },
        {
            key: "loadNamespaces",
            value: function loadNamespaces(ns, callback) {
                var _this7 = this;
                var deferred = $86e325ac3ddbcfa1$var$defer();
                if (!this.options.ns) {
                    if (callback) callback();
                    return Promise.resolve();
                }
                if (typeof ns === "string") ns = [
                    ns
                ];
                ns.forEach(function(n) {
                    if (_this7.options.ns.indexOf(n) < 0) _this7.options.ns.push(n);
                });
                this.loadResources(function(err) {
                    deferred.resolve();
                    if (callback) callback(err);
                });
                return deferred;
            }
        },
        {
            key: "loadLanguages",
            value: function loadLanguages(lngs, callback) {
                var deferred = $86e325ac3ddbcfa1$var$defer();
                if (typeof lngs === "string") lngs = [
                    lngs
                ];
                var preloaded = this.options.preload || [];
                var newLngs = lngs.filter(function(lng) {
                    return preloaded.indexOf(lng) < 0;
                });
                if (!newLngs.length) {
                    if (callback) callback();
                    return Promise.resolve();
                }
                this.options.preload = preloaded.concat(newLngs);
                this.loadResources(function(err) {
                    deferred.resolve();
                    if (callback) callback(err);
                });
                return deferred;
            }
        },
        {
            key: "dir",
            value: function dir(lng) {
                if (!lng) lng = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language);
                if (!lng) return "rtl";
                var rtlLngs = [
                    "ar",
                    "shu",
                    "sqr",
                    "ssh",
                    "xaa",
                    "yhd",
                    "yud",
                    "aao",
                    "abh",
                    "abv",
                    "acm",
                    "acq",
                    "acw",
                    "acx",
                    "acy",
                    "adf",
                    "ads",
                    "aeb",
                    "aec",
                    "afb",
                    "ajp",
                    "apc",
                    "apd",
                    "arb",
                    "arq",
                    "ars",
                    "ary",
                    "arz",
                    "auz",
                    "avl",
                    "ayh",
                    "ayl",
                    "ayn",
                    "ayp",
                    "bbz",
                    "pga",
                    "he",
                    "iw",
                    "ps",
                    "pbt",
                    "pbu",
                    "pst",
                    "prp",
                    "prd",
                    "ug",
                    "ur",
                    "ydd",
                    "yds",
                    "yih",
                    "ji",
                    "yi",
                    "hbo",
                    "men",
                    "xmn",
                    "fa",
                    "jpr",
                    "peo",
                    "pes",
                    "prs",
                    "dv",
                    "sam",
                    "ckb"
                ];
                var languageUtils = this.services && this.services.languageUtils || new $86e325ac3ddbcfa1$var$LanguageUtil($86e325ac3ddbcfa1$var$get());
                return rtlLngs.indexOf(languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
            }
        },
        {
            key: "cloneInstance",
            value: function cloneInstance() {
                var _this8 = this;
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $86e325ac3ddbcfa1$var$noop;
                var mergedOptions = $86e325ac3ddbcfa1$var$_objectSpread($86e325ac3ddbcfa1$var$_objectSpread($86e325ac3ddbcfa1$var$_objectSpread({}, this.options), options), {
                    isClone: true
                });
                var clone = new I18n(mergedOptions);
                if (options.debug !== undefined || options.prefix !== undefined) clone.logger = clone.logger.clone(options);
                var membersToCopy = [
                    "store",
                    "services",
                    "language"
                ];
                membersToCopy.forEach(function(m) {
                    clone[m] = _this8[m];
                });
                clone.services = $86e325ac3ddbcfa1$var$_objectSpread({}, this.services);
                clone.services.utils = {
                    hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
                };
                clone.translator = new $86e325ac3ddbcfa1$var$Translator(clone.services, clone.options);
                clone.translator.on("*", function(event) {
                    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
                    clone.emit.apply(clone, [
                        event
                    ].concat(args));
                });
                clone.init(mergedOptions, callback);
                clone.translator.options = clone.options;
                clone.translator.backendConnector.services.utils = {
                    hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
                };
                return clone;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return {
                    options: this.options,
                    store: this.store,
                    language: this.language,
                    languages: this.languages,
                    resolvedLanguage: this.resolvedLanguage
                };
            }
        }
    ]);
    return I18n;
}($86e325ac3ddbcfa1$var$EventEmitter);
(0, $7c55c7e50dabe3fa$export$2e2bcd8739ae039)($86e325ac3ddbcfa1$var$I18n, "createInstance", function() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments.length > 1 ? arguments[1] : undefined;
    return new $86e325ac3ddbcfa1$var$I18n(options, callback);
});
var $86e325ac3ddbcfa1$export$2e2bcd8739ae039 = $86e325ac3ddbcfa1$var$I18n.createInstance();
$86e325ac3ddbcfa1$export$2e2bcd8739ae039.createInstance = $86e325ac3ddbcfa1$var$I18n.createInstance;
var $86e325ac3ddbcfa1$export$99152e8d49ca4e7d = $86e325ac3ddbcfa1$export$2e2bcd8739ae039.createInstance;
var $86e325ac3ddbcfa1$export$147ec2801e896265 = $86e325ac3ddbcfa1$export$2e2bcd8739ae039.dir;
var $86e325ac3ddbcfa1$export$2cd8252107eb640b = $86e325ac3ddbcfa1$export$2e2bcd8739ae039.init;
var $86e325ac3ddbcfa1$export$d3d08d944062d7e = $86e325ac3ddbcfa1$export$2e2bcd8739ae039.loadResources;
var $86e325ac3ddbcfa1$export$a5d9bf5d83fcab09 = $86e325ac3ddbcfa1$export$2e2bcd8739ae039.reloadResources;
var $86e325ac3ddbcfa1$export$1f96ae73734a86cc = $86e325ac3ddbcfa1$export$2e2bcd8739ae039.use;
var $86e325ac3ddbcfa1$export$61465194746e7fd2 = $86e325ac3ddbcfa1$export$2e2bcd8739ae039.changeLanguage;
var $86e325ac3ddbcfa1$export$f90d180fc7da3b3b = $86e325ac3ddbcfa1$export$2e2bcd8739ae039.getFixedT;
var $86e325ac3ddbcfa1$export$625550452a3fa3ec = $86e325ac3ddbcfa1$export$2e2bcd8739ae039.t;
var $86e325ac3ddbcfa1$export$f7e9f41ea797a17 = $86e325ac3ddbcfa1$export$2e2bcd8739ae039.exists;
var $86e325ac3ddbcfa1$export$2b4b218e406d2d00 = $86e325ac3ddbcfa1$export$2e2bcd8739ae039.setDefaultNamespace;
var $86e325ac3ddbcfa1$export$93d9ee97c1ad3f31 = $86e325ac3ddbcfa1$export$2e2bcd8739ae039.hasLoadedNamespace;
var $86e325ac3ddbcfa1$export$83be934b53fff43b = $86e325ac3ddbcfa1$export$2e2bcd8739ae039.loadNamespaces;
var $86e325ac3ddbcfa1$export$8cd7e7a54fa865bc = $86e325ac3ddbcfa1$export$2e2bcd8739ae039.loadLanguages;



var $P551f = parcelRequire("P551f");

var $3413d737b2b4f00a$exports = {};
"use strict";
function $3413d737b2b4f00a$var$_interopDefault(ex) {
    return ex && typeof ex === "object" && "default" in ex ? ex["default"] : ex;
}

var $P551f = parcelRequire("P551f");
var $3413d737b2b4f00a$var$React__default = $3413d737b2b4f00a$var$_interopDefault($P551f);
function $3413d737b2b4f00a$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3413d737b2b4f00a$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $3413d737b2b4f00a$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function $3413d737b2b4f00a$var$withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
    if (typeof reducePropsToState !== "function") throw new Error("Expected reducePropsToState to be a function.");
    if (typeof handleStateChangeOnClient !== "function") throw new Error("Expected handleStateChangeOnClient to be a function.");
    if (typeof mapStateOnServer !== "undefined" && typeof mapStateOnServer !== "function") throw new Error("Expected mapStateOnServer to either be undefined or a function.");
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || "Component";
    }
    return function wrap(WrappedComponent) {
        if (typeof WrappedComponent !== "function") throw new Error("Expected WrappedComponent to be a React component.");
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            if (SideEffect.canUseDOM) handleStateChangeOnClient(state);
            else if (mapStateOnServer) state = mapStateOnServer(state);
        }
        var SideEffect = /*#__PURE__*/ function(_PureComponent) {
            $3413d737b2b4f00a$var$_inheritsLoose(SideEffect, _PureComponent);
            function SideEffect() {
                return _PureComponent.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            // Expose canUseDOM so tests can monkeypatch it
            SideEffect.peek = function peek() {
                return state;
            };
            SideEffect.rewind = function rewind() {
                if (SideEffect.canUseDOM) throw new Error("You may only call rewind() on the server. Call peek() to read the current state.");
                var recordedState = state;
                state = undefined;
                mountedInstances = [];
                return recordedState;
            };
            var _proto = SideEffect.prototype;
            _proto.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return $3413d737b2b4f00a$var$React__default.createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }($P551f.PureComponent);
        $3413d737b2b4f00a$var$_defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        $3413d737b2b4f00a$var$_defineProperty(SideEffect, "canUseDOM", $3413d737b2b4f00a$var$canUseDOM);
        return SideEffect;
    };
}
$3413d737b2b4f00a$exports = $3413d737b2b4f00a$var$withSideEffect;


var $c144cd5644fa992f$exports = {};
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $c144cd5644fa992f$var$hasElementType = typeof Element !== "undefined";
var $c144cd5644fa992f$var$hasMap = typeof Map === "function";
var $c144cd5644fa992f$var$hasSet = typeof Set === "function";
var $c144cd5644fa992f$var$hasArrayBuffer = typeof ArrayBuffer === "function" && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $c144cd5644fa992f$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$c144cd5644fa992f$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($c144cd5644fa992f$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$c144cd5644fa992f$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($c144cd5644fa992f$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($c144cd5644fa992f$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === "function" && typeof b.valueOf === "function") return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === "function" && typeof b.toString === "function") return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($c144cd5644fa992f$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === "_owner" || keys[i] === "__v" || keys[i] === "__o") && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$c144cd5644fa992f$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
$c144cd5644fa992f$exports = function isEqual(a, b) {
    try {
        return $c144cd5644fa992f$var$equal(a, b);
    } catch (error) {
        if ((error.message || "").match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn("react-fast-compare cannot handle circular refs");
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};



var $P551f = parcelRequire("P551f");
var $64d9e7dbdf8245d6$exports = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
/* eslint-disable no-unused-vars */ var $64d9e7dbdf8245d6$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $64d9e7dbdf8245d6$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $64d9e7dbdf8245d6$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $64d9e7dbdf8245d6$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function $64d9e7dbdf8245d6$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join("") !== "0123456789") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
$64d9e7dbdf8245d6$exports = $64d9e7dbdf8245d6$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $64d9e7dbdf8245d6$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($64d9e7dbdf8245d6$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($64d9e7dbdf8245d6$var$getOwnPropertySymbols) {
            symbols = $64d9e7dbdf8245d6$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($64d9e7dbdf8245d6$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};


var $0381bd61330cc6bf$var$ATTRIBUTE_NAMES = {
    BODY: "bodyAttributes",
    HTML: "htmlAttributes",
    TITLE: "titleAttributes"
};
var $0381bd61330cc6bf$var$TAG_NAMES = {
    BASE: "base",
    BODY: "body",
    HEAD: "head",
    HTML: "html",
    LINK: "link",
    META: "meta",
    NOSCRIPT: "noscript",
    SCRIPT: "script",
    STYLE: "style",
    TITLE: "title"
};
var $0381bd61330cc6bf$var$VALID_TAG_NAMES = Object.keys($0381bd61330cc6bf$var$TAG_NAMES).map(function(name) {
    return $0381bd61330cc6bf$var$TAG_NAMES[name];
});
var $0381bd61330cc6bf$var$TAG_PROPERTIES = {
    CHARSET: "charset",
    CSS_TEXT: "cssText",
    HREF: "href",
    HTTPEQUIV: "http-equiv",
    INNER_HTML: "innerHTML",
    ITEM_PROP: "itemprop",
    NAME: "name",
    PROPERTY: "property",
    REL: "rel",
    SRC: "src",
    TARGET: "target"
};
var $0381bd61330cc6bf$var$REACT_TAG_MAP = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};
var $0381bd61330cc6bf$var$HELMET_PROPS = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate"
};
var $0381bd61330cc6bf$var$HTML_TAG_MAP = Object.keys($0381bd61330cc6bf$var$REACT_TAG_MAP).reduce(function(obj, key) {
    obj[$0381bd61330cc6bf$var$REACT_TAG_MAP[key]] = key;
    return obj;
}, {});
var $0381bd61330cc6bf$var$SELF_CLOSING_TAGS = [
    $0381bd61330cc6bf$var$TAG_NAMES.NOSCRIPT,
    $0381bd61330cc6bf$var$TAG_NAMES.SCRIPT,
    $0381bd61330cc6bf$var$TAG_NAMES.STYLE
];
var $0381bd61330cc6bf$var$HELMET_ATTRIBUTE = "data-react-helmet";
var $0381bd61330cc6bf$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $0381bd61330cc6bf$var$classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var $0381bd61330cc6bf$var$createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $0381bd61330cc6bf$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $0381bd61330cc6bf$var$inherits = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};
var $0381bd61330cc6bf$var$objectWithoutProperties = function(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
};
var $0381bd61330cc6bf$var$possibleConstructorReturn = function(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
};
var $0381bd61330cc6bf$var$encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (encode === false) return String(str);
    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};
var $0381bd61330cc6bf$var$getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = $0381bd61330cc6bf$var$getInnermostProperty(propsList, $0381bd61330cc6bf$var$TAG_NAMES.TITLE);
    var innermostTemplate = $0381bd61330cc6bf$var$getInnermostProperty(propsList, $0381bd61330cc6bf$var$HELMET_PROPS.TITLE_TEMPLATE);
    if (innermostTemplate && innermostTitle) // use function arg to avoid need to escape $ characters
    return innermostTemplate.replace(/%s/g, function() {
        return Array.isArray(innermostTitle) ? innermostTitle.join("") : innermostTitle;
    });
    var innermostDefaultTitle = $0381bd61330cc6bf$var$getInnermostProperty(propsList, $0381bd61330cc6bf$var$HELMET_PROPS.DEFAULT_TITLE);
    return innermostTitle || innermostDefaultTitle || undefined;
};
var $0381bd61330cc6bf$var$getOnChangeClientState = function getOnChangeClientState(propsList) {
    return $0381bd61330cc6bf$var$getInnermostProperty(propsList, $0381bd61330cc6bf$var$HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function() {};
};
var $0381bd61330cc6bf$var$getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function(props) {
        return typeof props[tagType] !== "undefined";
    }).map(function(props) {
        return props[tagType];
    }).reduce(function(tagAttrs, current) {
        return $0381bd61330cc6bf$var$_extends({}, tagAttrs, current);
    }, {});
};
var $0381bd61330cc6bf$var$getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function(props) {
        return typeof props[$0381bd61330cc6bf$var$TAG_NAMES.BASE] !== "undefined";
    }).map(function(props) {
        return props[$0381bd61330cc6bf$var$TAG_NAMES.BASE];
    }).reverse().reduce(function(innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);
            for(var i = 0; i < keys.length; i++){
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) return innermostBaseTag.concat(tag);
            }
        }
        return innermostBaseTag;
    }, []);
};
var $0381bd61330cc6bf$var$getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};
    return propsList.filter(function(props) {
        if (Array.isArray(props[tagName])) return true;
        if (typeof props[tagName] !== "undefined") $0381bd61330cc6bf$var$warn("Helmet: " + tagName + ' should be of type "Array". Instead found type "' + $0381bd61330cc6bf$var$_typeof(props[tagName]) + '"');
        return false;
    }).map(function(props) {
        return props[tagName];
    }).reverse().reduce(function(approvedTags, instanceTags) {
        var instanceSeenTags = {};
        instanceTags.filter(function(tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for(var i = 0; i < keys.length; i++){
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();
                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === $0381bd61330cc6bf$var$TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === $0381bd61330cc6bf$var$TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) primaryAttributeKey = lowerCaseAttributeKey;
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === $0381bd61330cc6bf$var$TAG_PROPERTIES.INNER_HTML || attributeKey === $0381bd61330cc6bf$var$TAG_PROPERTIES.CSS_TEXT || attributeKey === $0381bd61330cc6bf$var$TAG_PROPERTIES.ITEM_PROP)) primaryAttributeKey = attributeKey;
            }
            if (!primaryAttributeKey || !tag[primaryAttributeKey]) return false;
            var value = tag[primaryAttributeKey].toLowerCase();
            if (!approvedSeenTags[primaryAttributeKey]) approvedSeenTags[primaryAttributeKey] = {};
            if (!instanceSeenTags[primaryAttributeKey]) instanceSeenTags[primaryAttributeKey] = {};
            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }
            return false;
        }).reverse().forEach(function(tag) {
            return approvedTags.push(tag);
        });
        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for(var i = 0; i < keys.length; i++){
            var attributeKey = keys[i];
            var tagUnion = (0, (/*@__PURE__*/$parcel$interopDefault($64d9e7dbdf8245d6$exports)))({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
            approvedSeenTags[attributeKey] = tagUnion;
        }
        return approvedTags;
    }, []).reverse();
};
var $0381bd61330cc6bf$var$getInnermostProperty = function getInnermostProperty(propsList, property) {
    for(var i = propsList.length - 1; i >= 0; i--){
        var props = propsList[i];
        if (props.hasOwnProperty(property)) return props[property];
    }
    return null;
};
var $0381bd61330cc6bf$var$reducePropsToState = function reducePropsToState(propsList) {
    return {
        baseTag: $0381bd61330cc6bf$var$getBaseTagFromPropsList([
            $0381bd61330cc6bf$var$TAG_PROPERTIES.HREF,
            $0381bd61330cc6bf$var$TAG_PROPERTIES.TARGET
        ], propsList),
        bodyAttributes: $0381bd61330cc6bf$var$getAttributesFromPropsList($0381bd61330cc6bf$var$ATTRIBUTE_NAMES.BODY, propsList),
        defer: $0381bd61330cc6bf$var$getInnermostProperty(propsList, $0381bd61330cc6bf$var$HELMET_PROPS.DEFER),
        encode: $0381bd61330cc6bf$var$getInnermostProperty(propsList, $0381bd61330cc6bf$var$HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: $0381bd61330cc6bf$var$getAttributesFromPropsList($0381bd61330cc6bf$var$ATTRIBUTE_NAMES.HTML, propsList),
        linkTags: $0381bd61330cc6bf$var$getTagsFromPropsList($0381bd61330cc6bf$var$TAG_NAMES.LINK, [
            $0381bd61330cc6bf$var$TAG_PROPERTIES.REL,
            $0381bd61330cc6bf$var$TAG_PROPERTIES.HREF
        ], propsList),
        metaTags: $0381bd61330cc6bf$var$getTagsFromPropsList($0381bd61330cc6bf$var$TAG_NAMES.META, [
            $0381bd61330cc6bf$var$TAG_PROPERTIES.NAME,
            $0381bd61330cc6bf$var$TAG_PROPERTIES.CHARSET,
            $0381bd61330cc6bf$var$TAG_PROPERTIES.HTTPEQUIV,
            $0381bd61330cc6bf$var$TAG_PROPERTIES.PROPERTY,
            $0381bd61330cc6bf$var$TAG_PROPERTIES.ITEM_PROP
        ], propsList),
        noscriptTags: $0381bd61330cc6bf$var$getTagsFromPropsList($0381bd61330cc6bf$var$TAG_NAMES.NOSCRIPT, [
            $0381bd61330cc6bf$var$TAG_PROPERTIES.INNER_HTML
        ], propsList),
        onChangeClientState: $0381bd61330cc6bf$var$getOnChangeClientState(propsList),
        scriptTags: $0381bd61330cc6bf$var$getTagsFromPropsList($0381bd61330cc6bf$var$TAG_NAMES.SCRIPT, [
            $0381bd61330cc6bf$var$TAG_PROPERTIES.SRC,
            $0381bd61330cc6bf$var$TAG_PROPERTIES.INNER_HTML
        ], propsList),
        styleTags: $0381bd61330cc6bf$var$getTagsFromPropsList($0381bd61330cc6bf$var$TAG_NAMES.STYLE, [
            $0381bd61330cc6bf$var$TAG_PROPERTIES.CSS_TEXT
        ], propsList),
        title: $0381bd61330cc6bf$var$getTitleFromPropsList(propsList),
        titleAttributes: $0381bd61330cc6bf$var$getAttributesFromPropsList($0381bd61330cc6bf$var$ATTRIBUTE_NAMES.TITLE, propsList)
    };
};
var $0381bd61330cc6bf$var$rafPolyfill = function() {
    var clock = Date.now();
    return function(callback) {
        var currentTime = Date.now();
        if (currentTime - clock > 16) {
            clock = currentTime;
            callback(currentTime);
        } else setTimeout(function() {
            $0381bd61330cc6bf$var$rafPolyfill(callback);
        }, 0);
    };
}();
var $0381bd61330cc6bf$var$cafPolyfill = function cafPolyfill(id) {
    return clearTimeout(id);
};
var $0381bd61330cc6bf$var$requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame && window.requestAnimationFrame.bind(window) || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || $0381bd61330cc6bf$var$rafPolyfill : $parcel$global.requestAnimationFrame || $0381bd61330cc6bf$var$rafPolyfill;
var $0381bd61330cc6bf$var$cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || $0381bd61330cc6bf$var$cafPolyfill : $parcel$global.cancelAnimationFrame || $0381bd61330cc6bf$var$cafPolyfill;
var $0381bd61330cc6bf$var$warn = function warn(msg) {
    return console && typeof console.warn === "function" && console.warn(msg);
};
var $0381bd61330cc6bf$var$_helmetCallback = null;
var $0381bd61330cc6bf$var$handleClientStateChange = function handleClientStateChange(newState) {
    if ($0381bd61330cc6bf$var$_helmetCallback) $0381bd61330cc6bf$var$cancelAnimationFrame($0381bd61330cc6bf$var$_helmetCallback);
    if (newState.defer) $0381bd61330cc6bf$var$_helmetCallback = $0381bd61330cc6bf$var$requestAnimationFrame(function() {
        $0381bd61330cc6bf$var$commitTagChanges(newState, function() {
            $0381bd61330cc6bf$var$_helmetCallback = null;
        });
    });
    else {
        $0381bd61330cc6bf$var$commitTagChanges(newState);
        $0381bd61330cc6bf$var$_helmetCallback = null;
    }
};
var $0381bd61330cc6bf$var$commitTagChanges = function commitTagChanges(newState, cb) {
    var baseTag = newState.baseTag, bodyAttributes = newState.bodyAttributes, htmlAttributes = newState.htmlAttributes, linkTags = newState.linkTags, metaTags = newState.metaTags, noscriptTags = newState.noscriptTags, onChangeClientState = newState.onChangeClientState, scriptTags = newState.scriptTags, styleTags = newState.styleTags, title = newState.title, titleAttributes = newState.titleAttributes;
    $0381bd61330cc6bf$var$updateAttributes($0381bd61330cc6bf$var$TAG_NAMES.BODY, bodyAttributes);
    $0381bd61330cc6bf$var$updateAttributes($0381bd61330cc6bf$var$TAG_NAMES.HTML, htmlAttributes);
    $0381bd61330cc6bf$var$updateTitle(title, titleAttributes);
    var tagUpdates = {
        baseTag: $0381bd61330cc6bf$var$updateTags($0381bd61330cc6bf$var$TAG_NAMES.BASE, baseTag),
        linkTags: $0381bd61330cc6bf$var$updateTags($0381bd61330cc6bf$var$TAG_NAMES.LINK, linkTags),
        metaTags: $0381bd61330cc6bf$var$updateTags($0381bd61330cc6bf$var$TAG_NAMES.META, metaTags),
        noscriptTags: $0381bd61330cc6bf$var$updateTags($0381bd61330cc6bf$var$TAG_NAMES.NOSCRIPT, noscriptTags),
        scriptTags: $0381bd61330cc6bf$var$updateTags($0381bd61330cc6bf$var$TAG_NAMES.SCRIPT, scriptTags),
        styleTags: $0381bd61330cc6bf$var$updateTags($0381bd61330cc6bf$var$TAG_NAMES.STYLE, styleTags)
    };
    var addedTags = {};
    var removedTags = {};
    Object.keys(tagUpdates).forEach(function(tagType) {
        var _tagUpdates$tagType = tagUpdates[tagType], newTags = _tagUpdates$tagType.newTags, oldTags = _tagUpdates$tagType.oldTags;
        if (newTags.length) addedTags[tagType] = newTags;
        if (oldTags.length) removedTags[tagType] = tagUpdates[tagType].oldTags;
    });
    cb && cb();
    onChangeClientState(newState, addedTags, removedTags);
};
var $0381bd61330cc6bf$var$flattenArray = function flattenArray(possibleArray) {
    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
};
var $0381bd61330cc6bf$var$updateTitle = function updateTitle(title, attributes) {
    if (typeof title !== "undefined" && document.title !== title) document.title = $0381bd61330cc6bf$var$flattenArray(title);
    $0381bd61330cc6bf$var$updateAttributes($0381bd61330cc6bf$var$TAG_NAMES.TITLE, attributes);
};
var $0381bd61330cc6bf$var$updateAttributes = function updateAttributes(tagName, attributes) {
    var elementTag = document.getElementsByTagName(tagName)[0];
    if (!elementTag) return;
    var helmetAttributeString = elementTag.getAttribute($0381bd61330cc6bf$var$HELMET_ATTRIBUTE);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);
    for(var i = 0; i < attributeKeys.length; i++){
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";
        if (elementTag.getAttribute(attribute) !== value) elementTag.setAttribute(attribute, value);
        if (helmetAttributes.indexOf(attribute) === -1) helmetAttributes.push(attribute);
        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) attributesToRemove.splice(indexToSave, 1);
    }
    for(var _i = attributesToRemove.length - 1; _i >= 0; _i--)elementTag.removeAttribute(attributesToRemove[_i]);
    if (helmetAttributes.length === attributesToRemove.length) elementTag.removeAttribute($0381bd61330cc6bf$var$HELMET_ATTRIBUTE);
    else if (elementTag.getAttribute($0381bd61330cc6bf$var$HELMET_ATTRIBUTE) !== attributeKeys.join(",")) elementTag.setAttribute($0381bd61330cc6bf$var$HELMET_ATTRIBUTE, attributeKeys.join(","));
};
var $0381bd61330cc6bf$var$updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector($0381bd61330cc6bf$var$TAG_NAMES.HEAD);
    var tagNodes = headElement.querySelectorAll(type + "[" + $0381bd61330cc6bf$var$HELMET_ATTRIBUTE + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;
    if (tags && tags.length) tags.forEach(function(tag) {
        var newElement = document.createElement(type);
        for(var attribute in tag)if (tag.hasOwnProperty(attribute)) {
            if (attribute === $0381bd61330cc6bf$var$TAG_PROPERTIES.INNER_HTML) newElement.innerHTML = tag.innerHTML;
            else if (attribute === $0381bd61330cc6bf$var$TAG_PROPERTIES.CSS_TEXT) {
                if (newElement.styleSheet) newElement.styleSheet.cssText = tag.cssText;
                else newElement.appendChild(document.createTextNode(tag.cssText));
            } else {
                var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                newElement.setAttribute(attribute, value);
            }
        }
        newElement.setAttribute($0381bd61330cc6bf$var$HELMET_ATTRIBUTE, "true");
        // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
        if (oldTags.some(function(existingTag, index) {
            indexToDelete = index;
            return newElement.isEqualNode(existingTag);
        })) oldTags.splice(indexToDelete, 1);
        else newTags.push(newElement);
    });
    oldTags.forEach(function(tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function(tag) {
        return headElement.appendChild(tag);
    });
    return {
        oldTags: oldTags,
        newTags: newTags
    };
};
var $0381bd61330cc6bf$var$generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
    return Object.keys(attributes).reduce(function(str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + '="' + attributes[key] + '"' : "" + key;
        return str ? str + " " + attr : attr;
    }, "");
};
var $0381bd61330cc6bf$var$generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
    var attributeString = $0381bd61330cc6bf$var$generateElementAttributesAsString(attributes);
    var flattenedTitle = $0381bd61330cc6bf$var$flattenArray(title);
    return attributeString ? "<" + type + " " + $0381bd61330cc6bf$var$HELMET_ATTRIBUTE + '="true" ' + attributeString + ">" + $0381bd61330cc6bf$var$encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + $0381bd61330cc6bf$var$HELMET_ATTRIBUTE + '="true">' + $0381bd61330cc6bf$var$encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
};
var $0381bd61330cc6bf$var$generateTagsAsString = function generateTagsAsString(type, tags, encode) {
    return tags.reduce(function(str, tag) {
        var attributeHtml = Object.keys(tag).filter(function(attribute) {
            return !(attribute === $0381bd61330cc6bf$var$TAG_PROPERTIES.INNER_HTML || attribute === $0381bd61330cc6bf$var$TAG_PROPERTIES.CSS_TEXT);
        }).reduce(function(string, attribute) {
            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + '="' + $0381bd61330cc6bf$var$encodeSpecialCharacters(tag[attribute], encode) + '"';
            return string ? string + " " + attr : attr;
        }, "");
        var tagContent = tag.innerHTML || tag.cssText || "";
        var isSelfClosing = $0381bd61330cc6bf$var$SELF_CLOSING_TAGS.indexOf(type) === -1;
        return str + "<" + type + " " + $0381bd61330cc6bf$var$HELMET_ATTRIBUTE + '="true" ' + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
    }, "");
};
var $0381bd61330cc6bf$var$convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Object.keys(attributes).reduce(function(obj, key) {
        obj[$0381bd61330cc6bf$var$REACT_TAG_MAP[key] || key] = attributes[key];
        return obj;
    }, initProps);
};
var $0381bd61330cc6bf$var$convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Object.keys(props).reduce(function(obj, key) {
        obj[$0381bd61330cc6bf$var$HTML_TAG_MAP[key] || key] = props[key];
        return obj;
    }, initAttributes);
};
var $0381bd61330cc6bf$var$generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
    var _initProps;
    // assigning into an array to define toString function on it
    var initProps = (_initProps = {
        key: title
    }, _initProps[$0381bd61330cc6bf$var$HELMET_ATTRIBUTE] = true, _initProps);
    var props = $0381bd61330cc6bf$var$convertElementAttributestoReactProps(attributes, initProps);
    return [
        (0, (/*@__PURE__*/$parcel$interopDefault($P551f))).createElement($0381bd61330cc6bf$var$TAG_NAMES.TITLE, props, title)
    ];
};
var $0381bd61330cc6bf$var$generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
    return tags.map(function(tag, i) {
        var _mappedTag;
        var mappedTag = (_mappedTag = {
            key: i
        }, _mappedTag[$0381bd61330cc6bf$var$HELMET_ATTRIBUTE] = true, _mappedTag);
        Object.keys(tag).forEach(function(attribute) {
            var mappedAttribute = $0381bd61330cc6bf$var$REACT_TAG_MAP[attribute] || attribute;
            if (mappedAttribute === $0381bd61330cc6bf$var$TAG_PROPERTIES.INNER_HTML || mappedAttribute === $0381bd61330cc6bf$var$TAG_PROPERTIES.CSS_TEXT) {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = {
                    __html: content
                };
            } else mappedTag[mappedAttribute] = tag[attribute];
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($P551f))).createElement(type, mappedTag);
    });
};
var $0381bd61330cc6bf$var$getMethodsForTag = function getMethodsForTag(type, tags, encode) {
    switch(type){
        case $0381bd61330cc6bf$var$TAG_NAMES.TITLE:
            return {
                toComponent: function toComponent() {
                    return $0381bd61330cc6bf$var$generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
                },
                toString: function toString() {
                    return $0381bd61330cc6bf$var$generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
                }
            };
        case $0381bd61330cc6bf$var$ATTRIBUTE_NAMES.BODY:
        case $0381bd61330cc6bf$var$ATTRIBUTE_NAMES.HTML:
            return {
                toComponent: function toComponent() {
                    return $0381bd61330cc6bf$var$convertElementAttributestoReactProps(tags);
                },
                toString: function toString() {
                    return $0381bd61330cc6bf$var$generateElementAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return $0381bd61330cc6bf$var$generateTagsAsReactComponent(type, tags);
                },
                toString: function toString() {
                    return $0381bd61330cc6bf$var$generateTagsAsString(type, tags, encode);
                }
            };
    }
};
var $0381bd61330cc6bf$var$mapStateOnServer = function mapStateOnServer(_ref) {
    var baseTag = _ref.baseTag, bodyAttributes = _ref.bodyAttributes, encode = _ref.encode, htmlAttributes = _ref.htmlAttributes, linkTags = _ref.linkTags, metaTags = _ref.metaTags, noscriptTags = _ref.noscriptTags, scriptTags = _ref.scriptTags, styleTags = _ref.styleTags, _ref$title = _ref.title, title = _ref$title === undefined ? "" : _ref$title, titleAttributes = _ref.titleAttributes;
    return {
        base: $0381bd61330cc6bf$var$getMethodsForTag($0381bd61330cc6bf$var$TAG_NAMES.BASE, baseTag, encode),
        bodyAttributes: $0381bd61330cc6bf$var$getMethodsForTag($0381bd61330cc6bf$var$ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
        htmlAttributes: $0381bd61330cc6bf$var$getMethodsForTag($0381bd61330cc6bf$var$ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
        link: $0381bd61330cc6bf$var$getMethodsForTag($0381bd61330cc6bf$var$TAG_NAMES.LINK, linkTags, encode),
        meta: $0381bd61330cc6bf$var$getMethodsForTag($0381bd61330cc6bf$var$TAG_NAMES.META, metaTags, encode),
        noscript: $0381bd61330cc6bf$var$getMethodsForTag($0381bd61330cc6bf$var$TAG_NAMES.NOSCRIPT, noscriptTags, encode),
        script: $0381bd61330cc6bf$var$getMethodsForTag($0381bd61330cc6bf$var$TAG_NAMES.SCRIPT, scriptTags, encode),
        style: $0381bd61330cc6bf$var$getMethodsForTag($0381bd61330cc6bf$var$TAG_NAMES.STYLE, styleTags, encode),
        title: $0381bd61330cc6bf$var$getMethodsForTag($0381bd61330cc6bf$var$TAG_NAMES.TITLE, {
            title: title,
            titleAttributes: titleAttributes
        }, encode)
    };
};
var $0381bd61330cc6bf$var$Helmet = function Helmet(Component) {
    var _class, _temp;
    return _temp = _class = function(_React$Component) {
        $0381bd61330cc6bf$var$inherits(HelmetWrapper, _React$Component);
        function HelmetWrapper() {
            $0381bd61330cc6bf$var$classCallCheck(this, HelmetWrapper);
            return $0381bd61330cc6bf$var$possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }
        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            return !(0, (/*@__PURE__*/$parcel$interopDefault($c144cd5644fa992f$exports)))(this.props, nextProps);
        };
        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
            if (!nestedChildren) return null;
            switch(child.type){
                case $0381bd61330cc6bf$var$TAG_NAMES.SCRIPT:
                case $0381bd61330cc6bf$var$TAG_NAMES.NOSCRIPT:
                    return {
                        innerHTML: nestedChildren
                    };
                case $0381bd61330cc6bf$var$TAG_NAMES.STYLE:
                    return {
                        cssText: nestedChildren
                    };
            }
            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
        };
        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
            var _babelHelpers$extends;
            var child = _ref.child, arrayTypeChildren = _ref.arrayTypeChildren, newChildProps = _ref.newChildProps, nestedChildren = _ref.nestedChildren;
            return $0381bd61330cc6bf$var$_extends({}, arrayTypeChildren, (_babelHelpers$extends = {}, _babelHelpers$extends[child.type] = [].concat(arrayTypeChildren[child.type] || [], [
                $0381bd61330cc6bf$var$_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))
            ]), _babelHelpers$extends));
        };
        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
            var _babelHelpers$extends2, _babelHelpers$extends3;
            var child = _ref2.child, newProps = _ref2.newProps, newChildProps = _ref2.newChildProps, nestedChildren = _ref2.nestedChildren;
            switch(child.type){
                case $0381bd61330cc6bf$var$TAG_NAMES.TITLE:
                    return $0381bd61330cc6bf$var$_extends({}, newProps, (_babelHelpers$extends2 = {}, _babelHelpers$extends2[child.type] = nestedChildren, _babelHelpers$extends2.titleAttributes = $0381bd61330cc6bf$var$_extends({}, newChildProps), _babelHelpers$extends2));
                case $0381bd61330cc6bf$var$TAG_NAMES.BODY:
                    return $0381bd61330cc6bf$var$_extends({}, newProps, {
                        bodyAttributes: $0381bd61330cc6bf$var$_extends({}, newChildProps)
                    });
                case $0381bd61330cc6bf$var$TAG_NAMES.HTML:
                    return $0381bd61330cc6bf$var$_extends({}, newProps, {
                        htmlAttributes: $0381bd61330cc6bf$var$_extends({}, newChildProps)
                    });
            }
            return $0381bd61330cc6bf$var$_extends({}, newProps, (_babelHelpers$extends3 = {}, _babelHelpers$extends3[child.type] = $0381bd61330cc6bf$var$_extends({}, newChildProps), _babelHelpers$extends3));
        };
        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
            var newFlattenedProps = $0381bd61330cc6bf$var$_extends({}, newProps);
            Object.keys(arrayTypeChildren).forEach(function(arrayChildName) {
                var _babelHelpers$extends4;
                newFlattenedProps = $0381bd61330cc6bf$var$_extends({}, newFlattenedProps, (_babelHelpers$extends4 = {}, _babelHelpers$extends4[arrayChildName] = arrayTypeChildren[arrayChildName], _babelHelpers$extends4));
            });
            return newFlattenedProps;
        };
        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
            return true;
        };
        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
            var _this2 = this;
            var arrayTypeChildren = {};
            (0, (/*@__PURE__*/$parcel$interopDefault($P551f))).Children.forEach(children, function(child) {
                if (!child || !child.props) return;
                var _child$props = child.props, nestedChildren = _child$props.children, childProps = $0381bd61330cc6bf$var$objectWithoutProperties(_child$props, [
                    "children"
                ]);
                var newChildProps = $0381bd61330cc6bf$var$convertReactPropstoHtmlAttributes(childProps);
                _this2.warnOnInvalidChildren(child, nestedChildren);
                switch(child.type){
                    case $0381bd61330cc6bf$var$TAG_NAMES.LINK:
                    case $0381bd61330cc6bf$var$TAG_NAMES.META:
                    case $0381bd61330cc6bf$var$TAG_NAMES.NOSCRIPT:
                    case $0381bd61330cc6bf$var$TAG_NAMES.SCRIPT:
                    case $0381bd61330cc6bf$var$TAG_NAMES.STYLE:
                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
                            child: child,
                            arrayTypeChildren: arrayTypeChildren,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                    default:
                        newProps = _this2.mapObjectTypeChildren({
                            child: child,
                            newProps: newProps,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                }
            });
            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
            return newProps;
        };
        HelmetWrapper.prototype.render = function render() {
            var _props = this.props, children = _props.children, props = $0381bd61330cc6bf$var$objectWithoutProperties(_props, [
                "children"
            ]);
            var newProps = $0381bd61330cc6bf$var$_extends({}, props);
            if (children) newProps = this.mapChildrenToProps(children, newProps);
            return (0, (/*@__PURE__*/$parcel$interopDefault($P551f))).createElement(Component, newProps);
        };
        $0381bd61330cc6bf$var$createClass(HelmetWrapper, null, [
            {
                key: "canUseDOM",
                // Component.peek comes from react-side-effect:
                // For testing, you may use a static peek() method available on the returned component.
                // It lets you get the current state without resetting the mounted instance stack.
                // Don’t use it for anything other than testing.
                /**
             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
             * @param {Object} bodyAttributes: {"className": "root"}
             * @param {String} defaultTitle: "Default Title"
             * @param {Boolean} defer: true
             * @param {Boolean} encodeSpecialCharacters: true
             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
             * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
             * @param {String} title: "Title"
             * @param {Object} titleAttributes: {"itemprop": "name"}
             * @param {String} titleTemplate: "MySite.com - %s"
             */ set: function set$$1(canUseDOM) {
                    Component.canUseDOM = canUseDOM;
                }
            }
        ]);
        return HelmetWrapper;
    }((0, (/*@__PURE__*/$parcel$interopDefault($P551f))).Component), _class.propTypes = {
        base: (0, (/*@__PURE__*/$parcel$interopDefault($bd6ef712189d85ad$exports))).object,
        bodyAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($bd6ef712189d85ad$exports))).object,
        children: (0, (/*@__PURE__*/$parcel$interopDefault($bd6ef712189d85ad$exports))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($bd6ef712189d85ad$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($bd6ef712189d85ad$exports))).node),
            (0, (/*@__PURE__*/$parcel$interopDefault($bd6ef712189d85ad$exports))).node
        ]),
        defaultTitle: (0, (/*@__PURE__*/$parcel$interopDefault($bd6ef712189d85ad$exports))).string,
        defer: (0, (/*@__PURE__*/$parcel$interopDefault($bd6ef712189d85ad$exports))).bool,
        encodeSpecialCharacters: (0, (/*@__PURE__*/$parcel$interopDefault($bd6ef712189d85ad$exports))).bool,
        htmlAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($bd6ef712189d85ad$exports))).object,
        link: (0, (/*@__PURE__*/$parcel$interopDefault($bd6ef712189d85ad$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($bd6ef712189d85ad$exports))).object),
        meta: (0, (/*@__PURE__*/$parcel$interopDefault($bd6ef712189d85ad$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($bd6ef712189d85ad$exports))).object),
        noscript: (0, (/*@__PURE__*/$parcel$interopDefault($bd6ef712189d85ad$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($bd6ef712189d85ad$exports))).object),
        onChangeClientState: (0, (/*@__PURE__*/$parcel$interopDefault($bd6ef712189d85ad$exports))).func,
        script: (0, (/*@__PURE__*/$parcel$interopDefault($bd6ef712189d85ad$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($bd6ef712189d85ad$exports))).object),
        style: (0, (/*@__PURE__*/$parcel$interopDefault($bd6ef712189d85ad$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($bd6ef712189d85ad$exports))).object),
        title: (0, (/*@__PURE__*/$parcel$interopDefault($bd6ef712189d85ad$exports))).string,
        titleAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($bd6ef712189d85ad$exports))).object,
        titleTemplate: (0, (/*@__PURE__*/$parcel$interopDefault($bd6ef712189d85ad$exports))).string
    }, _class.defaultProps = {
        defer: true,
        encodeSpecialCharacters: true
    }, _class.peek = Component.peek, _class.rewind = function() {
        var mappedState = Component.rewind();
        if (!mappedState) // provide fallback if mappedState is undefined
        mappedState = $0381bd61330cc6bf$var$mapStateOnServer({
            baseTag: [],
            bodyAttributes: {},
            encodeSpecialCharacters: true,
            htmlAttributes: {},
            linkTags: [],
            metaTags: [],
            noscriptTags: [],
            scriptTags: [],
            styleTags: [],
            title: "",
            titleAttributes: {}
        });
        return mappedState;
    }, _temp;
};
var $0381bd61330cc6bf$var$NullComponent = function NullComponent() {
    return null;
};
var $0381bd61330cc6bf$var$HelmetSideEffects = (0, (/*@__PURE__*/$parcel$interopDefault($3413d737b2b4f00a$exports)))($0381bd61330cc6bf$var$reducePropsToState, $0381bd61330cc6bf$var$handleClientStateChange, $0381bd61330cc6bf$var$mapStateOnServer)($0381bd61330cc6bf$var$NullComponent);
var $0381bd61330cc6bf$export$dcef8f9bb9a41431 = $0381bd61330cc6bf$var$Helmet($0381bd61330cc6bf$var$HelmetSideEffects);
$0381bd61330cc6bf$export$dcef8f9bb9a41431.renderStatic = $0381bd61330cc6bf$export$dcef8f9bb9a41431.rewind;
var $0381bd61330cc6bf$export$2e2bcd8739ae039 = $0381bd61330cc6bf$export$dcef8f9bb9a41431;



var $a9f547138519fa08$exports = {};


$a9f547138519fa08$exports = (parcelRequire("dvCpl")).getBundleURL("fCzRa") + (parcelRequire("e26He")).resolve("l4XaK");


var $10aab89e08633c3c$exports = {};


$10aab89e08633c3c$exports = (parcelRequire("dvCpl")).getBundleURL("fCzRa") + (parcelRequire("e26He")).resolve("53ysa");


var $da8c5afca09bf5d7$exports = {};

$parcel$export($da8c5afca09bf5d7$exports, "dark", function () { return $da8c5afca09bf5d7$export$55ce6f3a06c59543; }, function (v) { return $da8c5afca09bf5d7$export$55ce6f3a06c59543 = v; });
$parcel$export($da8c5afca09bf5d7$exports, "light", function () { return $da8c5afca09bf5d7$export$a43af521ac8c3202; }, function (v) { return $da8c5afca09bf5d7$export$a43af521ac8c3202 = v; });
$parcel$export($da8c5afca09bf5d7$exports, "preview", function () { return $da8c5afca09bf5d7$export$48c2d0f2f545ac27; }, function (v) { return $da8c5afca09bf5d7$export$48c2d0f2f545ac27 = v; });
$parcel$export($da8c5afca09bf5d7$exports, "viewBox", function () { return $da8c5afca09bf5d7$export$a179c88182cb9d56; }, function (v) { return $da8c5afca09bf5d7$export$a179c88182cb9d56 = v; });
var $da8c5afca09bf5d7$export$55ce6f3a06c59543;
var $da8c5afca09bf5d7$export$a43af521ac8c3202;
var $da8c5afca09bf5d7$export$48c2d0f2f545ac27;
var $da8c5afca09bf5d7$export$a179c88182cb9d56;
$da8c5afca09bf5d7$export$55ce6f3a06c59543 = `mUhaAq_dark`;
$da8c5afca09bf5d7$export$a43af521ac8c3202 = `mUhaAq_light`;
$da8c5afca09bf5d7$export$48c2d0f2f545ac27 = `mUhaAq_preview`;
$da8c5afca09bf5d7$export$a179c88182cb9d56 = `mUhaAq_viewBox`;


/**
 * User React Helmet to manage html and body attributes
 * @see https://github.com/nfl/react-helmet
 *
 * - lang: set html lang attribute
 * - data-theme: set html data-theme attribute
 * - favicon: set favicon
 * - apple-touch-icon: set apple touch icon
 * - body class: set preview body class
 * - body class: set platform body class
 * - body class: set theme body class
 * - custom css: set custom css style tag
 */ const $d26ebf4eea07fe75$var$AppMeta = ()=>{
    const { experienceSettings: experienceSettings, theme: theme, platform: platform, isPreview: isPreview } = (0, $P551f.useContext)((0, $bf7e93717fb1eb16$export$2e2bcd8739ae039));
    var _experienceSettings_branding_favicon, _experienceSettings_branding_favicon1;
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)((0, $0381bd61330cc6bf$export$dcef8f9bb9a41431), {
        children: [
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("html", {
                lang: (0, $86e325ac3ddbcfa1$export$2e2bcd8739ae039).language,
                "data-theme": theme
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("link", {
                rel: "shortcut icon",
                href: (_experienceSettings_branding_favicon = experienceSettings === null || experienceSettings === void 0 ? void 0 : experienceSettings.branding.favicon) !== null && _experienceSettings_branding_favicon !== void 0 ? _experienceSettings_branding_favicon : (0, (/*@__PURE__*/$parcel$interopDefault($10aab89e08633c3c$exports)))
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("link", {
                rel: "apple-touch-icon",
                href: (_experienceSettings_branding_favicon1 = experienceSettings === null || experienceSettings === void 0 ? void 0 : experienceSettings.branding.favicon) !== null && _experienceSettings_branding_favicon1 !== void 0 ? _experienceSettings_branding_favicon1 : (0, (/*@__PURE__*/$parcel$interopDefault($a9f547138519fa08$exports))),
                sizes: "180x180"
            }),
            (experienceSettings === null || experienceSettings === void 0 ? void 0 : experienceSettings.customCss) && /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("style", {
                children: experienceSettings.customCss
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("body", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($a6f0144cf2b2d456$exports)))((0, $dd763c2393b0d659$export$78aa88a01782ee9d)(isPreview && $da8c5afca09bf5d7$exports.preview), platform === "mobile" ? "mobile" : "desktop", (0, $dd763c2393b0d659$export$78aa88a01782ee9d)($da8c5afca09bf5d7$exports[theme]))
            })
        ]
    });
};
var $d26ebf4eea07fe75$export$2e2bcd8739ae039 = $d26ebf4eea07fe75$var$AppMeta;


const $989ece0370d3b835$var$AppBoundary = ({ children: children })=>{
    (0, $9dab4aae2c50f7eb$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)((0, $b1404a408b0d045c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $d26ebf4eea07fe75$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $2fd5ca85228c6378$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $b54a682ed4ae76b2$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $20cd5f2365f0f1ae$export$2e2bcd8739ae039), {
                        children: children
                    })
                })
            })
        ]
    });
};
var $989ece0370d3b835$export$2e2bcd8739ae039 = $989ece0370d3b835$var$AppBoundary;




var $P551f = parcelRequire("P551f");


var $P551f = parcelRequire("P551f");
/**
 * Hook-based wrapper for `setTimeout()`.
 */ function $f2712847eaa6d545$export$632123ff591ac565() {
    var _useState = (0, $P551f.useState)({
        time: null,
        done: false
    }), state = _useState[0], setState = _useState[1];
    var timerId = (0, $P551f.useRef)(null);
    var start = (0, $P551f.useCallback)(function(ms) {
        setState({
            time: ms,
            done: false
        });
    }, [
        setState
    ]);
    (0, $P551f.useEffect)(function() {
        if (!timerId.current && state.time) timerId.current = setTimeout(function() {
            setState({
                time: null,
                done: true
            });
            timerId.current = null;
        }, state.time);
        return function() {
            if (timerId.current) clearTimeout(timerId.current);
        };
    }, [
        state,
        setState
    ]);
    return {
        start: start,
        done: state.done
    };
}
var $f2712847eaa6d545$var$reducer = function reducer(state, action) {
    var isLoading = action.isLoading, timerDone = action.timerDone;
    switch(state){
        case "off":
            return isLoading ? "delayTrigger" : "off";
        case "delayTrigger":
            return isLoading ? "delayWait" : "off";
        case "delayWait":
            return isLoading ? timerDone ? "onTrigger" : "delayWait" : "off";
        case "onTrigger":
            return isLoading ? "onWait" : "off";
        case "onWait":
            return timerDone ? "on" : "onWait";
        case "on":
            return isLoading ? "on" : "off";
    }
};
/**
 * Debounces `isLoading` input. If `isLoading` remains `true` for at least `initialDelay` miliseconds, this hook
 * will returns `true` for `minimalTimeOn` miliseconds.
 * @param isLoading - Input signal you wish to debounce (usually it connects to a spinner and indicates a pending operation)
 * @param initialDelay - Delay in miliseconds. Requests shorter than `initialDelay` will be ignored.
 * @param minimalTimeOn - Once spinner appears, it will stay on screen for a least `minimalTimeOn` miliseconds.
 * @returns Debounced `isLoading` signal
 */ function $f2712847eaa6d545$export$acf523bed0f127d8(isLoading, initialDelay, minimalTimeOn) {
    if (initialDelay === void 0) initialDelay = 400;
    if (minimalTimeOn === void 0) minimalTimeOn = 400;
    var _useReducer = (0, $P551f.useReducer)($f2712847eaa6d545$var$reducer, "off"), state = _useReducer[0], dispatch = _useReducer[1];
    var _useTimer = $f2712847eaa6d545$export$632123ff591ac565(), start = _useTimer.start, done = _useTimer.done;
    (0, $P551f.useEffect)(function() {
        if (state === "delayTrigger") start(initialDelay);
        else if (state === "onTrigger") start(minimalTimeOn);
        dispatch({
            isLoading: isLoading,
            timerDone: done
        });
    }, [
        state,
        isLoading,
        start,
        done,
        initialDelay,
        minimalTimeOn
    ]);
    return state === "on" || state === "onWait";
}









parcelRequire("P551f");
const $75924c2fe25528b9$var$SvgLoadingIcon = (props)=>/*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("svg", (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({
        width: 32,
        height: 32,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("rect", {
                opacity: 0.48,
                x: 15,
                width: 2,
                height: 8,
                rx: 1,
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("rect", {
                opacity: 0.96,
                x: 15,
                y: 24,
                width: 2,
                height: 8,
                rx: 1,
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("rect", {
                opacity: 0.72,
                y: 17,
                width: 2,
                height: 8,
                rx: 1,
                transform: "rotate(-90 0 17)",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("rect", {
                opacity: 0.24,
                x: 24,
                y: 17,
                width: 2,
                height: 8,
                rx: 1,
                transform: "rotate(-90 24 17)",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("rect", {
                opacity: 0.32,
                x: 29.356,
                y: 7.134,
                width: 2,
                height: 8,
                rx: 1,
                transform: "rotate(60 29.356 7.134)",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("rect", {
                opacity: 0.8,
                x: 8.572,
                y: 19.134,
                width: 2,
                height: 8,
                rx: 1,
                transform: "rotate(60 8.572 19.134)",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("rect", {
                opacity: 0.64,
                x: 1.644,
                y: 8.866,
                width: 2,
                height: 8,
                rx: 1,
                transform: "rotate(-60 1.644 8.866)",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("rect", {
                opacity: 0.16,
                x: 22.428,
                y: 20.866,
                width: 2,
                height: 8,
                rx: 1,
                transform: "rotate(-60 22.428 20.866)",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("rect", {
                opacity: 0.4,
                x: 23.134,
                y: 1.644,
                width: 2,
                height: 8,
                rx: 1,
                transform: "rotate(30 23.134 1.644)",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("rect", {
                opacity: 0.88,
                x: 11.134,
                y: 22.428,
                width: 2,
                height: 8,
                rx: 1,
                transform: "rotate(30 11.134 22.428)",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("rect", {
                opacity: 0.56,
                x: 7.134,
                y: 2.644,
                width: 2,
                height: 8,
                rx: 1,
                transform: "rotate(-30 7.134 2.644)",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("rect", {
                opacity: 0.08,
                x: 19.134,
                y: 23.428,
                width: 2,
                height: 8,
                rx: 1,
                transform: "rotate(-30 19.134 23.428)",
                fill: "currentColor"
            })
        ]
    }));
var $75924c2fe25528b9$export$2e2bcd8739ae039 = $75924c2fe25528b9$var$SvgLoadingIcon;


var $7abb945c87dc2bd0$export$34e0f9847d4c02dd;
var $7abb945c87dc2bd0$export$5dd8d3d3c0fde971;
var $7abb945c87dc2bd0$export$29dd17c7f3c81c36;
var $7abb945c87dc2bd0$export$bfd64c937657f93a;
$7abb945c87dc2bd0$export$34e0f9847d4c02dd = `qNKCfW_container`;
$7abb945c87dc2bd0$export$5dd8d3d3c0fde971 = `qNKCfW_loadingIcon`;
$7abb945c87dc2bd0$export$29dd17c7f3c81c36 = `qNKCfW_overlay`;
$7abb945c87dc2bd0$export$bfd64c937657f93a = `qNKCfW_rotating`;
$7abb945c87dc2bd0$export$bfd64c937657f93a;


const $3ed5ba9f44211243$var$LoadingIcon = ({ className: className })=>/*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $75924c2fe25528b9$export$2e2bcd8739ae039), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a6f0144cf2b2d456$exports)))($7abb945c87dc2bd0$export$5dd8d3d3c0fde971, className)
    });
var $3ed5ba9f44211243$export$2e2bcd8739ae039 = $3ed5ba9f44211243$var$LoadingIcon;



const $8aa5ba1326567b1e$var$LoadingLayer = ()=>/*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("div", {
        className: $7abb945c87dc2bd0$export$29dd17c7f3c81c36,
        children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("div", {
            className: $7abb945c87dc2bd0$export$34e0f9847d4c02dd,
            children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $3ed5ba9f44211243$export$2e2bcd8739ae039), {})
        })
    });
var $8aa5ba1326567b1e$export$2e2bcd8739ae039 = $8aa5ba1326567b1e$var$LoadingLayer;


const $7df47bd2f5575fc8$var$LoadingLayerProvider = ()=>{
    const { loading: loading } = (0, $P551f.useContext)((0, $bf7e93717fb1eb16$export$2e2bcd8739ae039));
    const debouncedLoading = (0, $f2712847eaa6d545$export$acf523bed0f127d8)(loading, 500);
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)((0, $b1404a408b0d045c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $2ed817dc54ac40e6$export$910ae8079b2c2852), {}),
            debouncedLoading && /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $8aa5ba1326567b1e$export$2e2bcd8739ae039), {})
        ]
    });
};
var $7df47bd2f5575fc8$export$2e2bcd8739ae039 = $7df47bd2f5575fc8$var$LoadingLayerProvider;





var $P551f = parcelRequire("P551f");



const $3b4c3e5c846a9406$var$PageContextProvider = ({ children: children, preset: preset })=>{
    const [searchParameters] = (0, $efe29403354254eb$export$f1a78c17382fe22a)();
    var _preset_loading;
    const [loading, setLoading] = (0, $P551f.useState)((_preset_loading = preset === null || preset === void 0 ? void 0 : preset.loading) !== null && _preset_loading !== void 0 ? _preset_loading : false);
    var _preset_toast;
    const [toast, setToast] = (0, $P551f.useState)((_preset_toast = preset === null || preset === void 0 ? void 0 : preset.toast) !== null && _preset_toast !== void 0 ? _preset_toast : "");
    var _preset_theme;
    const [theme, setTheme] = (0, $P551f.useState)((_preset_theme = preset === null || preset === void 0 ? void 0 : preset.theme) !== null && _preset_theme !== void 0 ? _preset_theme : (0, $93d2089b0ece27e4$export$14faa19a0f3bbeb2).Light);
    var _preset_platform;
    const [platform, setPlatform] = (0, $P551f.useState)((_preset_platform = preset === null || preset === void 0 ? void 0 : preset.platform) !== null && _preset_platform !== void 0 ? _preset_platform : (0, $3152f4b5b57c36cc$exports.isMobile) ? "mobile" : "web");
    var _preset_termsAgreement;
    const [termsAgreement, setTermsAgreement] = (0, $P551f.useState)((_preset_termsAgreement = preset === null || preset === void 0 ? void 0 : preset.termsAgreement) !== null && _preset_termsAgreement !== void 0 ? _preset_termsAgreement : false);
    var _preset_experienceSettings;
    const [experienceSettings, setExperienceSettings] = (0, $P551f.useState)((_preset_experienceSettings = preset === null || preset === void 0 ? void 0 : preset.experienceSettings) !== null && _preset_experienceSettings !== void 0 ? _preset_experienceSettings : undefined);
    const isPreview = searchParameters.get("preview") === "true";
    const pageContext = (0, $P551f.useMemo)(()=>({
            theme: theme,
            toast: toast,
            loading: loading,
            platform: platform,
            termsAgreement: termsAgreement,
            experienceSettings: experienceSettings,
            isPreview: isPreview,
            setTheme: setTheme,
            setLoading: setLoading,
            setToast: setToast,
            setPlatform: setPlatform,
            setTermsAgreement: setTermsAgreement,
            setExperienceSettings: setExperienceSettings
        }), [
        experienceSettings,
        isPreview,
        loading,
        platform,
        termsAgreement,
        theme,
        toast
    ]);
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $bf7e93717fb1eb16$export$2e2bcd8739ae039).Provider, {
        value: pageContext,
        children: children
    });
};
var $3b4c3e5c846a9406$export$2e2bcd8739ae039 = $3b4c3e5c846a9406$var$PageContextProvider;



var $P551f = parcelRequire("P551f");






var $P551f = parcelRequire("P551f");





const $3fdb66bf24a228ee$var$action = {
    sign_in: "Anmelden",
    continue: "Weiter",
    create_account: "Konto erstellen",
    create_account_without_linking: "Erstelle ein Konto ohne Verkn\xfcpfung",
    create: "Erstellen",
    enter_passcode: "Best\xe4tigungscode eingeben",
    confirm: "Best\xe4tigen",
    cancel: "Abbrechen",
    save_password: "Passwort speichern",
    bind: "Mit {{address}} verkn\xfcpfen",
    bind_and_continue: "Verkn\xfcpfen und weiter",
    back: "Gehe zur\xfcck",
    nav_back: "Zur\xfcck",
    nav_skip: "\xdcberspringen",
    agree: "Zustimmen",
    got_it: "Alles klar",
    sign_in_with: "Mit {{name}} anmelden",
    forgot_password: "Passwort vergessen?",
    switch_to: "Zu {{method}} wechseln",
    sign_in_via_passcode: "Mit Best\xe4tigungscode anmelden",
    sign_in_via_password: "Mit Passwort anmelden",
    change: "{{method}} \xe4ndern",
    link_another_email: "Andere Email verkn\xfcpfen",
    link_another_phone: "Andere Telefonnummer verkn\xfcpfen",
    link_another_email_or_phone: "Andere Email oder Telefonnummer verkn\xfcpfen",
    show_password: "Passwort anzeigen",
    copy: "Kopieren",
    verify_via_passkey: "\xdcberpr\xfcfen \xfcber Passkey",
    download: "Herunterladen",
    single_sign_on: "Single Sign-On",
    /** UNTRANSLATED */ authorize: "Authorize",
    /** UNTRANSLATED */ use_another_account: "Use another account"
};
var $3fdb66bf24a228ee$export$2e2bcd8739ae039 = Object.freeze($3fdb66bf24a228ee$var$action);


const $a4d55efd84700005$var$description = {
    email: "Email",
    phone_number: "Telefonnummer",
    username: "Benutzername",
    reminder: "Erinnerung",
    not_found: "404 Nicht gefunden",
    agree_with_terms: "Ich akzeptiere die ",
    agree_with_terms_modal: "Bitte akzeptiere die <link></link>.",
    terms_of_use: "Nutzungsbedingungen",
    sign_in: "Anmelden",
    privacy_policy: "Datenschutzrichtlinien",
    create_account: "Konto erstellen",
    or: "oder",
    and: "und",
    enter_passcode: "Der Best\xe4tigungscode wurde an deine {{address}} gesendet",
    passcode_sent: "Der Best\xe4tigungscode wurde erneut gesendet",
    resend_after_seconds: "Nach <span>{{seconds}}</span> Sekunden erneut senden",
    resend_passcode: "Best\xe4tigungscode erneut senden",
    create_account_id_exists: "Das Konto mit {{type}} {{value}} existiert bereits, m\xf6chtest du dich anmelden?",
    link_account_id_exists: "Das Konto mit {{type}} {{value}} existiert bereits, m\xf6chtest du es mit deinem Konto verkn\xfcpfen?",
    sign_in_id_does_not_exist: "Das Konto mit {{type}} {{value}} existiert nicht, m\xf6chtest du ein neues Konto erstellen?",
    sign_in_id_does_not_exist_alert: "Das Konto mit {{type}} {{value}} existiert nicht",
    create_account_id_exists_alert: "Das Konto mit {{type}} {{value}} ist mit einem anderen Konto verkn\xfcpft. Bitte versuche es mit einem anderen {{type}} erneut",
    social_identity_exist: "{{type}} {{value}} ist mit einem anderen Konto verkn\xfcpft. Bitte versuche ein(e(n)) andere(n/s) {{type}}",
    bind_account_title: "Verlinke oder erstelle ein Konto",
    social_create_account: "Sie k\xf6nnen ein neues Konto erstellen.",
    social_link_email: "Du kannst eine weitere Email verkn\xfcpfen",
    social_link_phone: "Du kannst eine weitere Telefonnummer verkn\xfcpfen",
    social_link_email_or_phone: "Du kannst eine weitere Email oder Telefonnummer verkn\xfcpfen",
    social_bind_with_existing: "Wir haben eine verwandte {{method}} gefunden, die bereits registriert wurde, und Sie k\xf6nnen sie direkt verkn\xfcpfen.",
    reset_password: "Passwort vergessen",
    reset_password_description: "Gib die {{types, list(type: disjunction;)}} deines Kontos ein und wir senden dir einen Best\xe4tigungscode um dein Passwort zur\xfcckzusetzen.",
    new_password: "Neues Passwort",
    set_password: "Passwort setzen",
    password_changed: "Passwort ge\xe4ndert",
    no_account: "Noch kein Konto? ",
    have_account: "Hast du schon ein Konto?",
    enter_password: "Passwort eingeben",
    enter_password_for: "Passwort f\xfcr {{method}} {{value}} eingeben",
    enter_username: "Benutzernamen festlegen",
    enter_username_description: "Der Benutzername kann f\xfcr die Anmeldung verwendet werden. Der Benutzername darf nur Buchstaben, Zahlen und Unterstriche enthalten.",
    link_email: "Email verkn\xfcpfen",
    link_phone: "Telefonnummer verkn\xfcpfen",
    link_email_or_phone: "Email oder Telefonnummer verkn\xfcpfen",
    link_email_description: "F\xfcr zus\xe4tzliche Sicherheit, verkn\xfcpfe bitte deine Email mit dem Konto.",
    link_phone_description: "F\xfcr zus\xe4tzliche Sicherheit, verkn\xfcpfe bitte deine Telefonnummer mit dem Konto.",
    link_email_or_phone_description: "F\xfcr zus\xe4tzliche Sicherheit, verkn\xfcpfe bitte deine Email oder Telefonnummer mit dem Konto.",
    continue_with_more_information: "F\xfcr zus\xe4tzliche Sicherheit, vervollst\xe4ndige bitte deine Informationen.",
    create_your_account: "Erstelle dein Konto",
    sign_in_to_your_account: "Melde dich in deinem Konto an",
    no_region_code_found: "Kein Regionencode gefunden",
    verify_email: "Best\xe4tige deine E-Mail-Adresse",
    verify_phone: "Best\xe4tige deine Telefonnummer",
    password_requirements: "Passwort {{items, list}}.",
    password_requirement: {
        length_one: "erfordert mindestens {{count}} Zeichen",
        length_other: "erfordert mindestens {{count}} Zeichen",
        character_types_one: "sollte mindestens {{count}} Kategorie der folgenden Zeichenarten enthalten: Gro\xdfbuchstaben, Kleinbuchstaben, Zahlen und Symbole",
        character_types_other: "sollte mindestens {{count}} Kategorien der folgenden Zeichenarten enthalten: Gro\xdfbuchstaben, Kleinbuchstaben, Zahlen und Symbole"
    },
    use: "Verwenden",
    single_sign_on_email_form: "Gib deine Unternehmens-E-Mail-Adresse ein.",
    single_sign_on_connectors_list: "Ihr Unternehmen hat Single Sign-On f\xfcr das E-Mail-Konto {{email}} aktiviert. Sie k\xf6nnen sich weiterhin mit den folgenden SSO-Anbietern anmelden.",
    single_sign_on_enabled: "Single Sign-On ist f\xfcr dieses Konto aktiviert",
    /** UNTRANSLATED */ authorize_title: "Authorize {{name}}",
    /** UNTRANSLATED */ request_permission: "{{name}} is requesting access to:",
    /** UNTRANSLATED */ grant_organization_access: "Grant the organization access:",
    /** UNTRANSLATED */ user_scopes: "Personal user data",
    /** UNTRANSLATED */ organization_scopes: "Organization access",
    /** UNTRANSLATED */ authorize_agreement: `By authorize the access, you agree to the {{name}}'s <link></link>.`,
    /** UNTRANSLATED */ not_you: "Not you?",
    /** UNTRANSLATED */ user_id: "User ID: {{id}}",
    /** UNTRANSLATED */ redirect_to: "You will be redirected to {{name}}."
};
var $a4d55efd84700005$export$2e2bcd8739ae039 = Object.freeze($a4d55efd84700005$var$description);


const $3b2718ac2013c502$var$development_tenant = {
    notification: "Du befindest dich im Entwicklungsmodus"
};
var $3b2718ac2013c502$export$2e2bcd8739ae039 = Object.freeze($3b2718ac2013c502$var$development_tenant);


const $df93a52a1f092e51$var$password_rejected = {
    too_short: "Die minimale L\xe4nge betr\xe4gt {{min}}.",
    too_long: "Die maximale L\xe4nge betr\xe4gt {{max}}.",
    character_types: "Mindestens {{min}} Arten von Zeichen sind erforderlich.",
    unsupported_characters: "Nicht unterst\xfctztes Zeichen gefunden.",
    pwned: "Verwenden Sie keine einfachen Passw\xf6rter, die leicht zu erraten sind.",
    restricted_found: "Vermeiden Sie \xfcberm\xe4\xdfigen Gebrauch von {{list, list}}.",
    restricted: {
        repetition: "wiederholte Zeichen",
        sequence: "sequenzielle Zeichen",
        user_info: "Ihre pers\xf6nlichen Informationen",
        words: "Produktkontext"
    }
};
var $df93a52a1f092e51$export$2e2bcd8739ae039 = Object.freeze($df93a52a1f092e51$var$password_rejected);


const $0b2ef6483cf8245f$var$error = {
    general_required: "{{types, list(type: disjunction;)}} ist erforderlich",
    general_invalid: "Die {{types, list(type: disjunction;)}} is ung\xfcltig",
    username_required: "Benutzername ist erforderlich",
    password_required: "Passwort ist erforderlich",
    username_exists: "Benutzername existiert bereits",
    username_should_not_start_with_number: "Benutzername darf nicht mit einer Zahl beginnen",
    username_invalid_charset: "Benutzername darf nur Buchstaben, Zahlen und Unterstriche enthalten",
    invalid_email: "Die Email ist ung\xfcltig",
    invalid_phone: "Die Telefonnummer ist ung\xfcltig",
    passwords_do_not_match: "Passw\xf6rter stimmen nicht \xfcberein",
    invalid_passcode: "Der Best\xe4tigungscode ist ung\xfcltig",
    invalid_connector_auth: "Die Autorisierung ist ung\xfcltig",
    invalid_connector_request: "Connector Daten sind ung\xfcltig",
    unknown: "Unbekannter Fehler. Versuche es sp\xe4ter noch einmal.",
    invalid_session: "Die Sitzung ist ung\xfcltig. Bitte melde dich erneut an.",
    timeout: "Zeit\xfcberschreitung. Bitte melde dich erneut an.",
    password_rejected: $df93a52a1f092e51$export$2e2bcd8739ae039,
    sso_not_enabled: "Single Sign-On ist f\xfcr dieses E-Mail-Konto nicht aktiviert."
};
var $0b2ef6483cf8245f$export$2e2bcd8739ae039 = Object.freeze($0b2ef6483cf8245f$var$error);


const $7932cf9218f534ab$var$input = {
    username: "Benutzername",
    password: "Passwort",
    email: "Email",
    phone_number: "Telefonnummer",
    confirm_password: "Passwort best\xe4tigen",
    search_region_code: "Suche region code",
    backup_code: "Backup-Code"
};
var $7932cf9218f534ab$export$2e2bcd8739ae039 = Object.freeze($7932cf9218f534ab$var$input);


const $b3720bbebd345aad$var$list = {
    or: "oder",
    and: "und",
    separator: ","
};
var $b3720bbebd345aad$export$2e2bcd8739ae039 = Object.freeze($b3720bbebd345aad$var$list);


const $0b344cd287c1967d$var$mfa = {
    totp: "Authenticator-App-OTP",
    webauthn: "Passkey",
    backup_code: "Backup-Code",
    link_totp_description: "z.B. Google Authenticator usw.",
    link_webauthn_description: "Verkn\xfcpfen Sie Ihr Ger\xe4t oder USB-Hardware",
    link_backup_code_description: "Backup-Code generieren",
    verify_totp_description: "Geben Sie den Einmalcode in der App ein",
    verify_webauthn_description: "Verifizieren Sie Ihr Ger\xe4t oder Ihre USB-Hardware",
    verify_backup_code_description: "F\xfcgen Sie den gespeicherten Backup-Code ein",
    add_mfa_factors: "2-Schritte-Verifizierung hinzuf\xfcgen",
    add_mfa_description: "Die Zwei-Faktor-Verifizierung ist aktiviert. W\xe4hlen Sie Ihre zweite Verifizierungsmethode f\xfcr sicheres Anmelden aus.",
    verify_mfa_factors: "2-Schritte-Verifizierung",
    verify_mfa_description: "Die 2-Schritte-Verifizierung ist f\xfcr dieses Konto aktiviert. Bitte w\xe4hlen Sie die zweite Methode zur Verifizierung Ihrer Identit\xe4t aus.",
    add_authenticator_app: "Authenticator-App hinzuf\xfcgen",
    step: "Schritt {{step, number}}: {{content}}",
    scan_qr_code: "Scannen Sie diesen QR-Code",
    scan_qr_code_description: "Scannen Sie den folgenden QR-Code mit Ihrer Authenticator-App, wie z.B. Google Authenticator, Duo Mobile, Authy usw.",
    qr_code_not_available: "Kann den QR-Code nicht scannen?",
    copy_and_paste_key: "Schl\xfcssel kopieren und einf\xfcgen",
    copy_and_paste_key_description: "Kopieren Sie den folgenden Schl\xfcssel und f\xfcgen Sie ihn in Ihre Authenticator-App ein, wie z.B. Google Authenticator, Duo Mobile, Authy usw.",
    want_to_scan_qr_code: "M\xf6chten Sie den QR-Code scannen?",
    enter_one_time_code: "Einmalcode eingeben",
    enter_one_time_code_link_description: "Geben Sie den 6-stelligen Verifizierungscode ein, der von der Authenticator-App generiert wurde.",
    enter_one_time_code_description: "F\xfcr dieses Konto wurde die Zwei-Faktor-Authentifizierung aktiviert. Bitte geben Sie den einmaligen Code ein, der in Ihrer verkn\xfcpften Authentifizierungs-App angezeigt wird.",
    link_another_mfa_factor: "Zu einer anderen Methode wechseln",
    save_backup_code: "Backup-Code speichern",
    save_backup_code_description: "Sie k\xf6nnen einen dieser Backup-Codes verwenden, um auf Ihr Konto zuzugreifen, wenn Sie w\xe4hrend der 2-Schritte-Verifizierung auf andere Weise Probleme haben. Jeder Code kann nur einmal verwendet werden.",
    backup_code_hint: "Stellen Sie sicher, dass Sie sie kopieren und an einem sicheren Ort speichern.",
    enter_a_backup_code: "Backup-Code eingeben",
    enter_backup_code_description: "Geben Sie den Backup-Code ein, den Sie gespeichert haben, als die 2-Schritte-Verifizierung initial aktiviert wurde.",
    create_a_passkey: "Passkey erstellen",
    create_passkey_description: "Registrieren Sie Ihren Passkey mit biometrischen Daten, Sicherheitsschl\xfcsseln (z.B. YubiKey) oder anderen verf\xfcgbaren Methoden.",
    try_another_verification_method: "Versuchen Sie eine andere Methode zur Verifizierung",
    verify_via_passkey: "\xdcber Passkey verifizieren",
    verify_via_passkey_description: "Verwenden Sie den Passkey zur Verifizierung durch Ihr Ger\xe4tepasswort oder Biometrie, zum Scannen des QR-Codes oder zum Verwenden eines USB-Sicherheitsschl\xfcssels wie YubiKey.",
    secret_key_copied: "Geheimer Schl\xfcssel kopiert.",
    backup_code_copied: "Backup-Code kopiert.",
    webauthn_not_ready: "WebAuthn ist noch nicht bereit. Bitte versuchen Sie es sp\xe4ter erneut.",
    webauthn_not_supported: "WebAuthn wird in diesem Browser nicht unterst\xfctzt.",
    webauthn_failed_to_create: "Erstellung fehlgeschlagen. Bitte versuchen Sie es erneut.",
    webauthn_failed_to_verify: "Verifizierung fehlgeschlagen. Bitte versuchen Sie es erneut."
};
var $0b344cd287c1967d$export$2e2bcd8739ae039 = Object.freeze($0b344cd287c1967d$var$mfa);


const $2a1e1b73bb0137e2$var$secondary = {
    social_bind_with: "Besitzt du schon ein Konto? Melde dich an, um {{methods, list(type: disjunction;)}} mit deiner Identit\xe4t zu verbinden."
};
var $2a1e1b73bb0137e2$export$2e2bcd8739ae039 = Object.freeze($2a1e1b73bb0137e2$var$secondary);


const $1a116cb1c7022176$var$user_scopes = {
    descriptions: {
        /** UNTRANSLATED */ custom_data: "Your custom data",
        /** UNTRANSLATED */ email: "Your email address",
        /** UNTRANSLATED */ phone: "Your phone number",
        /** UNTRANSLATED */ profile: "Your name, username, avatar, and other profile info",
        /** UNTRANSLATED */ roles: "Your roles",
        /** UNTRANSLATED */ identities: "Your linked social identities",
        /** UNTRANSLATED */ "urn:logto:scope:organizations": "Your organizations info",
        /** UNTRANSLATED */ "urn:logto:scope:organization_roles": "Your organization roles",
        /** UNTRANSLATED */ address: "Your address"
    }
};
var $1a116cb1c7022176$export$2e2bcd8739ae039 = Object.freeze($1a116cb1c7022176$var$user_scopes);


const $5b0671ce25d71bc2$var$de = {
    translation: {
        input: $7932cf9218f534ab$export$2e2bcd8739ae039,
        secondary: $2a1e1b73bb0137e2$export$2e2bcd8739ae039,
        action: $3fdb66bf24a228ee$export$2e2bcd8739ae039,
        description: $a4d55efd84700005$export$2e2bcd8739ae039,
        error: $0b2ef6483cf8245f$export$2e2bcd8739ae039,
        list: $b3720bbebd345aad$export$2e2bcd8739ae039,
        mfa: $0b344cd287c1967d$export$2e2bcd8739ae039,
        development_tenant: $3b2718ac2013c502$export$2e2bcd8739ae039,
        user_scopes: $1a116cb1c7022176$export$2e2bcd8739ae039
    }
};
var $5b0671ce25d71bc2$export$2e2bcd8739ae039 = Object.freeze($5b0671ce25d71bc2$var$de);


const $81d975a3d7056a86$var$action = {
    sign_in: "Sign in",
    continue: "Continue",
    create_account: "Create account",
    create_account_without_linking: "Create account without linking",
    create: "Create",
    enter_passcode: "Enter verification code",
    confirm: "Confirm",
    cancel: "Cancel",
    save_password: "Save password",
    bind: "Link with {{address}}",
    bind_and_continue: "Link and continue",
    back: "Go back",
    nav_back: "Back",
    nav_skip: "Skip",
    agree: "Agree",
    got_it: "Got it",
    sign_in_with: "Continue with {{name}}",
    forgot_password: "Forgot your password?",
    switch_to: "Switch to {{method}}",
    sign_in_via_passcode: "Sign in with verification code",
    sign_in_via_password: "Sign in with password",
    change: "Change {{method}}",
    link_another_email: "Link another email",
    link_another_phone: "Link another phone",
    link_another_email_or_phone: "Link another email or phone",
    show_password: "Show password",
    copy: "Copy",
    verify_via_passkey: "Verify via passkey",
    download: "Download",
    single_sign_on: "Single Sign-On",
    authorize: "Authorize",
    use_another_account: "Use another account"
};
var $81d975a3d7056a86$export$2e2bcd8739ae039 = Object.freeze($81d975a3d7056a86$var$action);


const $a0f3f62520bd0787$var$description = {
    email: "email",
    phone_number: "phone number",
    username: "username",
    reminder: "Reminder",
    not_found: "404 Not Found",
    agree_with_terms: "I have read and agree to the ",
    agree_with_terms_modal: "To proceed, please agree to the <link></link>.",
    terms_of_use: "Terms of Use",
    sign_in: "Sign in",
    privacy_policy: "Privacy Policy",
    create_account: "Create account",
    or: "or",
    and: "and",
    enter_passcode: "The verification code has been sent to your {{address}} {{target}}",
    passcode_sent: "The verification code has been resent",
    resend_after_seconds: "Resend after <span>{{seconds}}</span> seconds",
    resend_passcode: "Resend verification code",
    create_account_id_exists: "The account with {{type}} {{value}} already exists, would you like to sign in?",
    link_account_id_exists: "The account with {{type}} {{value}} already exists. Would you like to link?",
    sign_in_id_does_not_exist: "The account with {{type}} {{value}} does not exist, would you like to create a new account?",
    sign_in_id_does_not_exist_alert: "The account with {{type}} {{value}} does not exist.",
    create_account_id_exists_alert: "The account with {{type}} {{value}} is linked to another account. Please try another {{type}}.",
    social_identity_exist: "The {{type}} {{value}} is linked to another account. Please try another {{type}}.",
    bind_account_title: "Link or create account",
    social_create_account: "You can create a new account.",
    social_link_email: "You can link another email",
    social_link_phone: "You can link another phone",
    social_link_email_or_phone: "You can link another email or phone",
    social_bind_with_existing: "We find a related account, you can link it directly.",
    reset_password: "Reset password",
    reset_password_description: "Enter the {{types, list(type: disjunction;)}} associated with your account, and we’ll send you the verification code to reset your password.",
    new_password: "New password",
    set_password: "Set password",
    password_changed: "Password changed",
    no_account: "No account yet? ",
    have_account: "Already had an account?",
    enter_password: "Enter password",
    enter_password_for: "Sign in with the password to {{method}} {{value}}",
    enter_username: "Set username",
    enter_username_description: "Username is an alternative for sign-in. Username should contain only letters, numbers, and underscores.",
    link_email: "Link email",
    link_phone: "Link phone",
    link_email_or_phone: "Link email or phone",
    link_email_description: "For added security, please link your email with the account.",
    link_phone_description: "For added security, please link your phone with the account.",
    link_email_or_phone_description: "For added security, please link your email or phone with the account.",
    continue_with_more_information: "For added security, please complete below account details.",
    create_your_account: "Create your account",
    sign_in_to_your_account: "Sign in to your account",
    no_region_code_found: "No region code found",
    verify_email: "Verify your email",
    verify_phone: "Verify your phone number",
    password_requirements: "Password {{items, list}}.",
    password_requirement: {
        length_one: "requires a minimum of {{count}} character",
        length_other: "requires a minimum of {{count}} characters",
        character_types_one: "should contain at least {{count}} type of uppercase letters, lowercase letters, digits, and symbols",
        character_types_other: "should contain at least {{count}} types of uppercase letters, lowercase letters, digits, and symbols"
    },
    use: "Use",
    single_sign_on_email_form: "Enter your enterprise email address",
    single_sign_on_connectors_list: "Your enterprise has enabled Single Sign-On for the email account {{email}}. You can continue to sign in with the following SSO providers.",
    single_sign_on_enabled: "Single Sign-On is enabled for this account",
    authorize_title: "Authorize {{name}}",
    request_permission: "{{name}} is requesting access to:",
    grant_organization_access: "Grant the organization access:",
    user_scopes: "Personal user data",
    organization_scopes: "Organization access",
    authorize_agreement: `By authorize the access, you agree to the {{name}}'s <link></link>.`,
    not_you: "Not you?",
    user_id: "User ID: {{id}}",
    redirect_to: "You will be redirected to {{name}}."
};
var $a0f3f62520bd0787$export$2e2bcd8739ae039 = Object.freeze($a0f3f62520bd0787$var$description);


const $ea4eed7ee24bc983$var$development_tenant = {
    notification: "You're in development mode"
};
var $ea4eed7ee24bc983$export$2e2bcd8739ae039 = Object.freeze($ea4eed7ee24bc983$var$development_tenant);


const $b72c67927799b630$var$password_rejected = {
    too_short: "Minimum length is {{min}}.",
    too_long: "Maximum length is {{max}}.",
    character_types: "At least {{min}} types of characters are required.",
    unsupported_characters: "Unsupported character found.",
    pwned: "Avoid using simple passwords that are easy to guess.",
    restricted_found: "Avoid overusing {{list, list}}.",
    restricted: {
        repetition: "repeated characters",
        sequence: "sequential characters",
        user_info: "your personal information",
        words: "product context"
    }
};
var $b72c67927799b630$export$2e2bcd8739ae039 = Object.freeze($b72c67927799b630$var$password_rejected);


const $328623bf7f6b271c$var$error = {
    general_required: `{{types, list(type: disjunction;)}} is required`,
    general_invalid: `The {{types, list(type: disjunction;)}} is invalid`,
    username_required: "Username is required",
    password_required: "Password is required",
    username_exists: "Username already exists",
    username_should_not_start_with_number: "Username should not start with a number",
    username_invalid_charset: "Username should only contain letters, numbers, or underscores.",
    invalid_email: "The email is invalid",
    invalid_phone: "The phone number is invalid",
    passwords_do_not_match: "Your passwords don’t match. Please try again.",
    invalid_passcode: "The verification code is invalid",
    invalid_connector_auth: "The authorization is invalid",
    invalid_connector_request: "The connector data is invalid",
    unknown: "Unknown error. Please try again later.",
    invalid_session: "Session not found. Please go back and sign in again.",
    timeout: "Request timeout. Please try again later.",
    password_rejected: $b72c67927799b630$export$2e2bcd8739ae039,
    sso_not_enabled: "Single Sign-On is not enabled for this email account."
};
var $328623bf7f6b271c$export$2e2bcd8739ae039 = Object.freeze($328623bf7f6b271c$var$error);


const $00440532ada1b173$var$input = {
    username: "Username",
    password: "Password",
    email: "Email",
    phone_number: "Phone number",
    confirm_password: "Confirm password",
    search_region_code: "Search region code",
    backup_code: "Backup code"
};
var $00440532ada1b173$export$2e2bcd8739ae039 = Object.freeze($00440532ada1b173$var$input);


const $e379fa184b8deaba$var$list = {
    or: "or",
    and: "and",
    separator: ","
};
var $e379fa184b8deaba$export$2e2bcd8739ae039 = Object.freeze($e379fa184b8deaba$var$list);


const $1885328e0f97bf0a$var$mfa = {
    totp: "Authenticator app OTP",
    webauthn: "Passkey",
    backup_code: "Backup code",
    link_totp_description: "E.g., Google Authenticator, etc.",
    link_webauthn_description: "Link your device or USB hardware",
    link_backup_code_description: "Generate a backup code",
    verify_totp_description: "Enter the one-time code in app",
    verify_webauthn_description: "Verify your device or USB hardware",
    verify_backup_code_description: "Paste the backup code you saved",
    add_mfa_factors: "Add 2-step verification",
    add_mfa_description: "Two-factor verification is enabled. Select your second verification method for secure sign-in.",
    verify_mfa_factors: "2-step verification",
    verify_mfa_description: "2-step verification has been enabled for this account. Please select the second way to verify your identity.",
    add_authenticator_app: "Add authenticator app",
    step: "Step {{step, number}}: {{content}}",
    scan_qr_code: "Scan this QR code",
    scan_qr_code_description: "Scan the following QR code with your authenticator app, such as Google Authenticator, Duo Mobile, Authy, etc.",
    qr_code_not_available: "Can’t scan the QR code?",
    copy_and_paste_key: "Copy and paste the key",
    copy_and_paste_key_description: "Copy and paste the following key into your authenticator app, such as Google Authenticator, Duo Mobile, Authy, etc.",
    want_to_scan_qr_code: "Want to scan QR code?",
    enter_one_time_code: "Enter the one-time code",
    enter_one_time_code_link_description: "Enter the 6-digit verification code generated by the authenticator app.",
    enter_one_time_code_description: "2-step verification has been enabled for this account. Please enter the one-time code shown on your linked authenticator app.",
    link_another_mfa_factor: "Switch to another method",
    save_backup_code: "Save your backup code",
    save_backup_code_description: "You can use one of these backup code to access your account if you have trouble during 2-step verification in another ways. Each code may be used only once.",
    backup_code_hint: "Make sure copy them and save in a safe place.",
    enter_a_backup_code: "Enter a backup code",
    enter_backup_code_description: "Enter the backup code you saved when the 2-step verification was initially enabled.",
    create_a_passkey: "Create a passkey",
    create_passkey_description: "Register your passkey using device biometrics, security keys (e.g., YubiKey), or other available methods.",
    try_another_verification_method: "Try another method to verify",
    verify_via_passkey: "Verify via passkey",
    verify_via_passkey_description: "Use passkey to verify by your device password or biometrics, scanning QR code, or using USB security key like YubiKey.",
    secret_key_copied: "Secret key copied.",
    backup_code_copied: "Backup code copied.",
    webauthn_not_ready: "WebAuthn is not ready yet. Please try again later.",
    webauthn_not_supported: "WebAuthn is not supported in this browser.",
    webauthn_failed_to_create: "Failed to create. Please try again.",
    webauthn_failed_to_verify: "Failed to verify. Please try again."
};
var $1885328e0f97bf0a$export$2e2bcd8739ae039 = Object.freeze($1885328e0f97bf0a$var$mfa);


const $7d3d4fdbc9db9a2c$var$secondary = {
    social_bind_with: "Already had an account? Sign in to link {{methods, list(type: disjunction;)}} with your social identity."
};
var $7d3d4fdbc9db9a2c$export$2e2bcd8739ae039 = Object.freeze($7d3d4fdbc9db9a2c$var$secondary);


const $b685746665f4d766$var$user_scopes = {
    descriptions: {
        custom_data: "Your custom data",
        email: "Your email address",
        phone: "Your phone number",
        profile: "Your name, username, avatar, and other profile info",
        roles: "Your roles",
        identities: "Your linked social identities",
        "urn:logto:scope:organizations": "Your organizations info",
        "urn:logto:scope:organization_roles": "Your organization roles",
        address: "Your address"
    }
};
var $b685746665f4d766$export$2e2bcd8739ae039 = Object.freeze($b685746665f4d766$var$user_scopes);


const $7959f66baa72ceb2$var$en = {
    translation: {
        input: $00440532ada1b173$export$2e2bcd8739ae039,
        secondary: $7d3d4fdbc9db9a2c$export$2e2bcd8739ae039,
        action: $81d975a3d7056a86$export$2e2bcd8739ae039,
        description: $a0f3f62520bd0787$export$2e2bcd8739ae039,
        error: $328623bf7f6b271c$export$2e2bcd8739ae039,
        list: $e379fa184b8deaba$export$2e2bcd8739ae039,
        mfa: $1885328e0f97bf0a$export$2e2bcd8739ae039,
        development_tenant: $ea4eed7ee24bc983$export$2e2bcd8739ae039,
        user_scopes: $b685746665f4d766$export$2e2bcd8739ae039
    }
};
var $7959f66baa72ceb2$export$2e2bcd8739ae039 = Object.freeze($7959f66baa72ceb2$var$en);


const $e8c7ab8a84d9fb5f$var$action = {
    sign_in: "Iniciar sesi\xf3n",
    continue: "Continuar",
    create_account: "Crear una cuenta",
    create_account_without_linking: "Crear una cuenta sin vinculaci\xf3n",
    create: "Crear",
    enter_passcode: "Ingresar c\xf3digo de verificaci\xf3n",
    confirm: "Confirmar",
    cancel: "Cancelar",
    save_password: "Guardar contrase\xf1a",
    bind: "Vincular con {{address}}",
    bind_and_continue: "Vincular y continuar",
    back: "Regresar",
    nav_back: "Atr\xe1s",
    nav_skip: "Omitir",
    agree: "Aceptar",
    got_it: "Entendido",
    sign_in_with: "Continuar con {{name}}",
    forgot_password: "\xbfOlvidaste tu contrase\xf1a?",
    switch_to: "Cambiar a {{method}}",
    sign_in_via_passcode: "Iniciar sesi\xf3n con c\xf3digo de verificaci\xf3n",
    sign_in_via_password: "Iniciar sesi\xf3n con contrase\xf1a",
    change: "Cambiar {{method}}",
    link_another_email: "Vincular otro correo electr\xf3nico",
    link_another_phone: "Vincular otro n\xfamero de tel\xe9fono",
    link_another_email_or_phone: "Vincular otro correo electr\xf3nico o n\xfamero de tel\xe9fono",
    show_password: "Mostrar contrase\xf1a",
    copy: "Copiar",
    verify_via_passkey: "Verificar mediante clave de acceso",
    download: "Descargar",
    single_sign_on: "Inicio de sesi\xf3n \xfanico",
    /** UNTRANSLATED */ authorize: "Authorize",
    /** UNTRANSLATED */ use_another_account: "Use another account"
};
var $e8c7ab8a84d9fb5f$export$2e2bcd8739ae039 = Object.freeze($e8c7ab8a84d9fb5f$var$action);


const $7bd86a138275e61e$var$description = {
    email: "correo electr\xf3nico",
    phone_number: "n\xfamero de tel\xe9fono",
    username: "nombre de usuario",
    reminder: "Recordatorio",
    not_found: "404 No encontrado",
    agree_with_terms: "He le\xeddo y acepto los ",
    agree_with_terms_modal: "Para continuar, por favor acepte los <link></link>.",
    terms_of_use: "T\xe9rminos de uso",
    sign_in: "Iniciar sesi\xf3n",
    privacy_policy: "Pol\xedtica de privacidad",
    create_account: "Crear cuenta",
    or: "o",
    and: "y",
    enter_passcode: "El c\xf3digo de verificaci\xf3n ha sido enviado a su {{address}} {{target}}",
    passcode_sent: "El c\xf3digo de verificaci\xf3n ha sido reenviado",
    resend_after_seconds: "Reenviar despu\xe9s de <span>{{seconds}}</span> segundos",
    resend_passcode: "Reenviar c\xf3digo de verificaci\xf3n",
    create_account_id_exists: "La cuenta con {{type}} {{value}} ya existe, \xbfdesea iniciar sesi\xf3n?",
    link_account_id_exists: "La cuenta con {{type}} {{value}} ya existe. \xbfDesea vincular?",
    sign_in_id_does_not_exist: "La cuenta con {{type}} {{value}} no existe, \xbfdesea crear una nueva cuenta?",
    sign_in_id_does_not_exist_alert: "La cuenta con {{type}} {{value}} no existe.",
    create_account_id_exists_alert: "La cuenta con {{type}} {{value}} est\xe1 vinculada a otra cuenta. Por favor intente con otra {{type}}.",
    social_identity_exist: "La {{type}} {{value}} est\xe1 vinculada a otra cuenta. Por favor intente con otra {{type}}.",
    bind_account_title: "Vincular o crear cuenta",
    social_create_account: "Puede crear una nueva cuenta.",
    social_link_email: "Puede vincular otro correo electr\xf3nico",
    social_link_phone: "Puede vincular otro tel\xe9fono",
    social_link_email_or_phone: "Puede vincular otro correo electr\xf3nico o tel\xe9fono",
    social_bind_with_existing: "Hemos encontrado una cuenta relacionada, puede vincularla directamente.",
    reset_password: "Restablecer contrase\xf1a",
    reset_password_description: "Ingrese los {{types, lista(type: disyunci\xf3n;)}} asociados a su cuenta, y le enviaremos el c\xf3digo de verificaci\xf3n para restablecer su contrase\xf1a.",
    new_password: "Nueva contrase\xf1a",
    set_password: "Establecer contrase\xf1a",
    password_changed: "Contrase\xf1a cambiada",
    no_account: "\xbfNo tiene una cuenta todav\xeda? ",
    have_account: "\xbfYa tiene una cuenta?",
    enter_password: "Ingrese la contrase\xf1a",
    enter_password_for: "Inicie sesi\xf3n con la contrase\xf1a de {{method}} {{value}}",
    enter_username: "Establecer nombre de usuario",
    enter_username_description: "El nombre de usuario es una alternativa para iniciar sesi\xf3n. Debe contener solo letras, n\xfameros y guiones bajos.",
    link_email: "Vincular correo electr\xf3nico",
    link_phone: "Vincular tel\xe9fono",
    link_email_or_phone: "Vincular correo electr\xf3nico o tel\xe9fono",
    link_email_description: "Para mayor seguridad, por favor vincule su correo electr\xf3nico con la cuenta.",
    link_phone_description: "Para mayor seguridad, por favor vincule su tel\xe9fono con la cuenta.",
    link_email_or_phone_description: "Para mayor seguridad, por favor vincule su correo electr\xf3nico o tel\xe9fono con la cuenta.",
    continue_with_more_information: "Para mayor seguridad, por favor complete los detalles de su cuenta a continuaci\xf3n.",
    create_your_account: "Cree su cuenta",
    sign_in_to_your_account: "Inicie sesi\xf3n en su cuenta",
    no_region_code_found: "No se encontr\xf3 c\xf3digo de regi\xf3n",
    verify_email: "Verificar su correo electr\xf3nico",
    verify_phone: "Verificar su n\xfamero de tel\xe9fono",
    password_requirements: "Contrase\xf1a {{items, lista}}.",
    password_requirement: {
        length_one: "requiere un m\xednimo de {{count}} car\xe1cter",
        length_other: "requiere un m\xednimo de {{count}} caracteres",
        character_types_one: "debe contener al menos {{count}} tipo de letras may\xfasculas, letras min\xfasculas, d\xedgitos y s\xedmbolos",
        character_types_other: "debe contener al menos {{count}} tipos de letras may\xfasculas, letras min\xfasculas, d\xedgitos y s\xedmbolos"
    },
    use: "Usar",
    single_sign_on_email_form: "Ingrese su direcci\xf3n de correo electr\xf3nico corporativo",
    single_sign_on_connectors_list: "Su empresa ha habilitado el inicio de sesi\xf3n \xfanico (Single Sign-On) para la cuenta de correo electr\xf3nico {{email}}. Puede continuar iniciando sesi\xf3n con los siguientes proveedores de SSO.",
    single_sign_on_enabled: "El inicio de sesi\xf3n \xfanico (Single Sign-On) est\xe1 habilitado para esta cuenta",
    /** UNTRANSLATED */ authorize_title: "Authorize {{name}}",
    /** UNTRANSLATED */ request_permission: "{{name}} is requesting access to:",
    /** UNTRANSLATED */ grant_organization_access: "Grant the organization access:",
    /** UNTRANSLATED */ user_scopes: "Personal user data",
    /** UNTRANSLATED */ organization_scopes: "Organization access",
    /** UNTRANSLATED */ authorize_agreement: `By authorize the access, you agree to the {{name}}'s <link></link>.`,
    /** UNTRANSLATED */ not_you: "Not you?",
    /** UNTRANSLATED */ user_id: "User ID: {{id}}",
    /** UNTRANSLATED */ redirect_to: "You will be redirected to {{name}}."
};
var $7bd86a138275e61e$export$2e2bcd8739ae039 = Object.freeze($7bd86a138275e61e$var$description);


const $5ed5727fe24d2fd9$var$development_tenant = {
    notification: "Est\xe1s en modo de desarrollo"
};
var $5ed5727fe24d2fd9$export$2e2bcd8739ae039 = Object.freeze($5ed5727fe24d2fd9$var$development_tenant);


const $357ee791ccf22577$var$password_rejected = {
    too_short: "La longitud m\xednima es {{min}}.",
    too_long: "La longitud m\xe1xima es {{max}}.",
    character_types: "Se necesitan al menos {{min}} tipos de caracteres.",
    unsupported_characters: "Se encontr\xf3 un car\xe1cter no admitido.",
    pwned: "Evite usar contrase\xf1as simples que sean f\xe1ciles de adivinar.",
    restricted_found: "Evite utilizar en exceso {{list, list}}.",
    restricted: {
        repetition: "caracteres repetidos",
        sequence: "caracteres secuenciales",
        user_info: "su informaci\xf3n personal",
        words: "contexto del producto"
    }
};
var $357ee791ccf22577$export$2e2bcd8739ae039 = Object.freeze($357ee791ccf22577$var$password_rejected);


const $b79241fb8611003a$var$error = {
    general_required: `{{types, list(type: disjunction;)}} es requerido`,
    general_invalid: `El/La {{types, list(type: disjunction;)}} no es válido`,
    username_required: "Se requiere un nombre de usuario",
    password_required: "Se requiere una contrase\xf1a",
    username_exists: "El nombre de usuario ya existe",
    username_should_not_start_with_number: "El nombre de usuario no debe comenzar con un n\xfamero",
    username_invalid_charset: "El nombre de usuario solo debe contener letras, n\xfameros o guiones bajos.",
    invalid_email: "El correo electr\xf3nico no es v\xe1lido",
    invalid_phone: "El n\xfamero de tel\xe9fono no es v\xe1lido",
    passwords_do_not_match: "Las contrase\xf1as no coinciden. Por favor intente de nuevo",
    invalid_passcode: "El c\xf3digo de verificaci\xf3n no es v\xe1lido",
    invalid_connector_auth: "La autorizaci\xf3n no es v\xe1lida",
    invalid_connector_request: "Los datos del conector no son v\xe1lidos",
    unknown: "Error desconocido. Por favor intente de nuevo m\xe1s tarde.",
    invalid_session: "No se encontr\xf3 la sesi\xf3n. Por favor regrese e inicie sesi\xf3n nuevamente.",
    timeout: "Tiempo de espera de solicitud agotado. Por favor intente de nuevo m\xe1s tarde.",
    password_rejected: $357ee791ccf22577$export$2e2bcd8739ae039,
    sso_not_enabled: "El inicio de sesi\xf3n \xfanico no est\xe1 habilitado para esta cuenta de correo electr\xf3nico."
};
var $b79241fb8611003a$export$2e2bcd8739ae039 = Object.freeze($b79241fb8611003a$var$error);


const $8a12b130b4d53e90$var$input = {
    username: "Nombre de usuario",
    password: "Contrase\xf1a",
    email: "Correo electr\xf3nico",
    phone_number: "N\xfamero de tel\xe9fono",
    confirm_password: "Confirmar contrase\xf1a",
    search_region_code: "C\xf3digo de regi\xf3n de b\xfasqueda",
    backup_code: "C\xf3digo de respaldo"
};
var $8a12b130b4d53e90$export$2e2bcd8739ae039 = Object.freeze($8a12b130b4d53e90$var$input);


const $4764509ca0dd01c2$var$list = {
    or: "o",
    and: "y",
    separator: ","
};
var $4764509ca0dd01c2$export$2e2bcd8739ae039 = Object.freeze($4764509ca0dd01c2$var$list);


const $21b4cc10945e497f$var$mfa = {
    totp: "OTP de la aplicaci\xf3n autenticadora",
    webauthn: "Contrase\xf1a",
    backup_code: "C\xf3digo de respaldo",
    link_totp_description: "Ej., Google Authenticator, etc.",
    link_webauthn_description: "Vincule su dispositivo o hardware USB",
    link_backup_code_description: "Genere un c\xf3digo de respaldo",
    verify_totp_description: "Ingrese el c\xf3digo de un solo uso en la aplicaci\xf3n",
    verify_webauthn_description: "Verifique su dispositivo o hardware USB",
    verify_backup_code_description: "Pegue el c\xf3digo de respaldo que guard\xf3",
    add_mfa_factors: "Agregar verificaci\xf3n de 2 pasos",
    add_mfa_description: "La verificaci\xf3n de dos factores est\xe1 habilitada. Seleccione su segundo m\xe9todo de verificaci\xf3n para iniciar sesi\xf3n de forma segura.",
    verify_mfa_factors: "Verificaci\xf3n de 2 pasos",
    verify_mfa_description: "La verificaci\xf3n de 2 pasos se ha habilitado para esta cuenta. Seleccione la segunda forma de verificar su identidad.",
    add_authenticator_app: "Agregar aplicaci\xf3n autenticadora",
    step: "Paso {{step, number}}: {{content}}",
    scan_qr_code: "Escanee este c\xf3digo QR",
    scan_qr_code_description: "Escanee el siguiente c\xf3digo QR con su aplicaci\xf3n autenticadora, como Google Authenticator, Duo Mobile, Authy, etc.",
    qr_code_not_available: "\xbfNo puede escanear el c\xf3digo QR?",
    copy_and_paste_key: "Copie y pegue la clave",
    copy_and_paste_key_description: "Copie y pegue la siguiente clave en su aplicaci\xf3n autenticadora, como Google Authenticator, Duo Mobile, Authy, etc.",
    want_to_scan_qr_code: "\xbfQuiere escanear el c\xf3digo QR?",
    enter_one_time_code: "Ingrese el c\xf3digo de un solo uso",
    enter_one_time_code_link_description: "Ingrese el c\xf3digo de verificaci\xf3n de 6 d\xedgitos generado por la aplicaci\xf3n autenticadora.",
    enter_one_time_code_description: "Se ha habilitado la verificaci\xf3n en dos pasos para esta cuenta. Por favor, ingrese el c\xf3digo de un solo uso que se muestra en su aplicaci\xf3n de autenticaci\xf3n vinculada.",
    link_another_mfa_factor: "Cambiar a otro m\xe9todo",
    save_backup_code: "Guarde su c\xf3digo de respaldo",
    save_backup_code_description: "Puede usar uno de estos c\xf3digos de respaldo para acceder a su cuenta si tiene problemas durante la verificaci\xf3n de 2 pasos de otras maneras. Cada c\xf3digo solo se puede usar una vez.",
    backup_code_hint: "Aseg\xfarese de copiarlos y guardarlos en un lugar seguro.",
    enter_a_backup_code: "Ingrese un c\xf3digo de respaldo",
    enter_backup_code_description: "Ingrese el c\xf3digo de respaldo que guard\xf3 cuando se habilit\xf3 la verificaci\xf3n de 2 pasos inicialmente.",
    create_a_passkey: "Crear una contrase\xf1a",
    create_passkey_description: "Registre su contrase\xf1a utilizando la biometr\xeda del dispositivo, claves de seguridad (por ejemplo, YubiKey) u otros m\xe9todos disponibles.",
    try_another_verification_method: "Pruebe otro m\xe9todo de verificaci\xf3n",
    verify_via_passkey: "Verificar mediante contrase\xf1a",
    verify_via_passkey_description: "Use la contrase\xf1a para verificar mediante la contrase\xf1a de su dispositivo o biometr\xeda, escanee el c\xf3digo QR o use una clave de seguridad USB como YubiKey.",
    secret_key_copied: "Clave secreta copiada.",
    backup_code_copied: "C\xf3digo de respaldo copiado.",
    webauthn_not_ready: "WebAuthn a\xfan no est\xe1 listo. Por favor, int\xe9ntelo de nuevo m\xe1s tarde.",
    webauthn_not_supported: "WebAuthn no es compatible con este navegador.",
    webauthn_failed_to_create: "Error al crear. Por favor, int\xe9ntelo de nuevo.",
    webauthn_failed_to_verify: "Error al verificar. Por favor, int\xe9ntelo de nuevo."
};
var $21b4cc10945e497f$export$2e2bcd8739ae039 = Object.freeze($21b4cc10945e497f$var$mfa);


const $763f770cd3dd192c$var$secondary = {
    social_bind_with: "\xbfYa tienes una cuenta? Inicia sesi\xf3n para vincular {{methods, list(type: disjunction;)}} con tu identidad social."
};
var $763f770cd3dd192c$export$2e2bcd8739ae039 = Object.freeze($763f770cd3dd192c$var$secondary);


const $b74340b5cc144205$var$user_scopes = {
    descriptions: {
        /** UNTRANSLATED */ custom_data: "Your custom data",
        /** UNTRANSLATED */ email: "Your email address",
        /** UNTRANSLATED */ phone: "Your phone number",
        /** UNTRANSLATED */ profile: "Your name, username, avatar, and other profile info",
        /** UNTRANSLATED */ roles: "Your roles",
        /** UNTRANSLATED */ identities: "Your linked social identities",
        /** UNTRANSLATED */ "urn:logto:scope:organizations": "Your organizations info",
        /** UNTRANSLATED */ "urn:logto:scope:organization_roles": "Your organization roles",
        /** UNTRANSLATED */ address: "Your address"
    }
};
var $b74340b5cc144205$export$2e2bcd8739ae039 = Object.freeze($b74340b5cc144205$var$user_scopes);


const $42b851f3e35aa8ef$var$es = {
    translation: {
        input: $8a12b130b4d53e90$export$2e2bcd8739ae039,
        secondary: $763f770cd3dd192c$export$2e2bcd8739ae039,
        action: $e8c7ab8a84d9fb5f$export$2e2bcd8739ae039,
        description: $7bd86a138275e61e$export$2e2bcd8739ae039,
        error: $b79241fb8611003a$export$2e2bcd8739ae039,
        list: $4764509ca0dd01c2$export$2e2bcd8739ae039,
        mfa: $21b4cc10945e497f$export$2e2bcd8739ae039,
        development_tenant: $5ed5727fe24d2fd9$export$2e2bcd8739ae039,
        user_scopes: $b74340b5cc144205$export$2e2bcd8739ae039
    }
};
var $42b851f3e35aa8ef$export$2e2bcd8739ae039 = Object.freeze($42b851f3e35aa8ef$var$es);


const $6d9a8e6fe0d41ede$var$action = {
    sign_in: "Connexion",
    continue: "Continuer",
    create_account: "Cr\xe9er un compte",
    create_account_without_linking: "Cr\xe9er un compte sans lier",
    create: "Cr\xe9er",
    enter_passcode: "Entrer le code",
    confirm: "Confirmer",
    cancel: "Annuler",
    save_password: "Enregistrer le mot de passe",
    bind: "Lier avec {{address}}",
    bind_and_continue: "Lier et continuer",
    back: "Aller en arri\xe8re",
    nav_back: "Retour",
    nav_skip: "Passer",
    agree: "Accepter",
    got_it: "Compris",
    sign_in_with: "Continuer avec {{name}}",
    forgot_password: "Mot de passe oubli\xe9?",
    switch_to: "Passer au {{method}}",
    sign_in_via_passcode: "Se connecter avec le code de v\xe9rification",
    sign_in_via_password: "Se connecter avec le mot de passe",
    change: "Changer {{method}}",
    link_another_email: "Lier une autre adresse e-mail",
    link_another_phone: "Lier un autre num\xe9ro de t\xe9l\xe9phone",
    link_another_email_or_phone: "Lier une autre adresse e-mail ou un autre num\xe9ro de t\xe9l\xe9phone",
    show_password: "Afficher le mot de passe",
    copy: "Copier",
    verify_via_passkey: "V\xe9rifier via la cl\xe9 d'acc\xe8s",
    download: "T\xe9l\xe9charger",
    single_sign_on: "Connexion unique",
    /** UNTRANSLATED */ authorize: "Authorize",
    /** UNTRANSLATED */ use_another_account: "Use another account"
};
var $6d9a8e6fe0d41ede$export$2e2bcd8739ae039 = Object.freeze($6d9a8e6fe0d41ede$var$action);


const $10b6e43355bb48e2$var$description = {
    email: "email",
    phone_number: "num\xe9ro de t\xe9l\xe9phone",
    username: "nom d'utilisateur",
    reminder: "Rappel",
    not_found: "404 Non trouv\xe9",
    agree_with_terms: "J'ai lu et accept\xe9 les ",
    agree_with_terms_modal: "Pour continuer, veuillez accepter le <link></link>.",
    terms_of_use: "Conditions d'utilisation",
    sign_in: "Connexion",
    privacy_policy: "Politique de confidentialit\xe9",
    create_account: "Cr\xe9er un compte",
    or: "ou",
    and: "et",
    enter_passcode: "Le code a \xe9t\xe9 envoy\xe9 \xe0 {{address}} {{target}}",
    passcode_sent: "Le code a \xe9t\xe9 renvoy\xe9",
    resend_after_seconds: "Renvoyer apr\xe8s <span>{{seconds}}</span> secondes",
    resend_passcode: "Renvoyer le code",
    create_account_id_exists: "Le compte avec {{type}} {{value}} existe d\xe9j\xe0, voulez-vous vous connecter?",
    link_account_id_exists: "Le compte avec {{type}} {{value}} existe d\xe9j\xe0, voulez-vous le lier?",
    sign_in_id_does_not_exist: "Le compte avec {{type}} {{value}} n'existe pas, voulez-vous cr\xe9er un nouveau compte?",
    sign_in_id_does_not_exist_alert: "Nous ne trouvons aucun compte associ\xe9 \xe0 {{type}} {{value}}.",
    create_account_id_exists_alert: "Le compte avec {{type}} {{value}} est li\xe9 \xe0 un autre compte. Veuillez essayer un autre {{type}}.",
    social_identity_exist: "Le {{type}} {{value}} est li\xe9 \xe0 un autre compte. Veuillez essayer un autre {{type}}.",
    bind_account_title: "Lier ou cr\xe9er un compte",
    social_create_account: "Vous pouvez cr\xe9er un nouveau compte",
    social_link_email: "Vous pouvez lier une autre adresse e-mail",
    social_link_phone: "Vous pouvez lier un autre num\xe9ro de t\xe9l\xe9phone",
    social_link_email_or_phone: "Vous pouvez lier une autre adresse e-mail ou un autre num\xe9ro de t\xe9l\xe9phone",
    social_bind_with_existing: "Nous avons trouv\xe9 une {{method}} connexe qui a \xe9t\xe9 enregistr\xe9e, et vous pouvez la lier directement.",
    reset_password: "Mot de passe oubli\xe9",
    reset_password_description: "Entrez le {{types, list(type: disjunction;)}} associ\xe9 \xe0 votre compte et nous vous enverrons le code de v\xe9rification pour r\xe9initialiser votre mot de passe.",
    new_password: "Nouveau mot de passe",
    set_password: "D\xe9finir un mot de passe",
    password_changed: "Mot de passe modifi\xe9",
    no_account: "Pas encore de compte? ",
    have_account: "D\xe9j\xe0 un compte?",
    enter_password: "Entrer le mot de passe",
    enter_password_for: "Connectez-vous avec le mot de passe pour {{method}} {{value}}",
    enter_username: "D\xe9finir un nom d'utilisateur",
    enter_username_description: "Le nom d'utilisateur est une alternative pour la connexion. Le nom d'utilisateur doit contenir uniquement des lettres, des chiffres et des underscores.",
    link_email: "Lier l'adresse e-mail",
    link_phone: "Lier le num\xe9ro de t\xe9l\xe9phone",
    link_email_or_phone: "Lier l'adresse e-mail ou le num\xe9ro de t\xe9l\xe9phone",
    link_email_description: "Pour une s\xe9curit\xe9 accrue, veuillez lier votre adresse e-mail au compte.",
    link_phone_description: "Pour une s\xe9curit\xe9 accrue, veuillez lier votre num\xe9ro de t\xe9l\xe9phone au compte.",
    link_email_or_phone_description: "Pour une s\xe9curit\xe9 accrue, veuillez lier votre adresse e-mail ou votre num\xe9ro de t\xe9l\xe9phone au compte.",
    continue_with_more_information: "Pour une s\xe9curit\xe9 accrue, veuillez compl\xe9ter les d\xe9tails du compte ci-dessous.",
    create_your_account: "Cr\xe9er votre compte",
    sign_in_to_your_account: "Connecte-toi \xe0 ton compte",
    no_region_code_found: "Aucun code de r\xe9gion trouv\xe9",
    verify_email: "V\xe9rifiez votre e-mail",
    verify_phone: "V\xe9rifiez votre num\xe9ro de t\xe9l\xe9phone",
    password_requirements: "Mot de passe {{items, list}}.",
    password_requirement: {
        length_one: "doit contenir au minimum {{count}} caract\xe8re",
        length_other: "doit contenir au minimum {{count}} caract\xe8res",
        character_types_one: "doit contenir au moins {{count}} type de lettres majuscules, lettres minuscules, chiffres et symboles",
        character_types_other: "doit contenir au moins {{count}} types de lettres majuscules, lettres minuscules, chiffres et symboles"
    },
    use: "Utiliser",
    single_sign_on_email_form: "Entrez votre adresse e-mail d'entreprise",
    single_sign_on_connectors_list: "Votre entreprise a activ\xe9 la connexion unique (Single Sign-On) pour le compte email {{email}}. Vous pouvez continuer \xe0 vous connecter avec les fournisseurs SSO suivants.",
    single_sign_on_enabled: "La connexion unique (Single Sign-On) est activ\xe9e pour ce compte",
    /** UNTRANSLATED */ authorize_title: "Authorize {{name}}",
    /** UNTRANSLATED */ request_permission: "{{name}} is requesting access to:",
    /** UNTRANSLATED */ grant_organization_access: "Grant the organization access:",
    /** UNTRANSLATED */ user_scopes: "Personal user data",
    /** UNTRANSLATED */ organization_scopes: "Organization access",
    /** UNTRANSLATED */ authorize_agreement: `By authorize the access, you agree to the {{name}}'s <link></link>.`,
    /** UNTRANSLATED */ not_you: "Not you?",
    /** UNTRANSLATED */ user_id: "User ID: {{id}}",
    /** UNTRANSLATED */ redirect_to: "You will be redirected to {{name}}."
};
var $10b6e43355bb48e2$export$2e2bcd8739ae039 = Object.freeze($10b6e43355bb48e2$var$description);


const $8934c04316444918$var$development_tenant = {
    notification: "Vous \xeates en mode d\xe9veloppement"
};
var $8934c04316444918$export$2e2bcd8739ae039 = Object.freeze($8934c04316444918$var$development_tenant);


const $d5a62f3eaff451e4$var$password_rejected = {
    too_short: "La longueur minimale est {{min}}.",
    too_long: "La longueur maximale est {{max}}.",
    character_types: "Au moins {{min}} types de caract\xe8res sont requis.",
    unsupported_characters: "Caract\xe8re non support\xe9 trouv\xe9.",
    pwned: "\xc9vitez d'utiliser des mots de passe simples faciles \xe0 deviner.",
    restricted_found: "\xc9vitez d'utiliser de mani\xe8re excessive {{list, list}}.",
    restricted: {
        repetition: "caract\xe8res r\xe9p\xe9t\xe9s",
        sequence: "caract\xe8res s\xe9quentiels",
        user_info: "vos informations personnelles",
        words: "contexte produit"
    }
};
var $d5a62f3eaff451e4$export$2e2bcd8739ae039 = Object.freeze($d5a62f3eaff451e4$var$password_rejected);


const $84e4ca1af415e36b$var$error = {
    general_required: "Le {{types, list(type: disjunction;)}} est requis",
    general_invalid: "Le {{types, list(type: disjunction;)}} n'est pas valide",
    username_required: "Le nom d'utilisateur est requis",
    password_required: "Le mot de passe est requis",
    username_exists: "Ce Nom d'utilisateur existe d\xe9j\xe0",
    username_should_not_start_with_number: "Le nom d'utilisateur ne doit pas commencer par un chiffre",
    username_invalid_charset: "Le nom d'utilisateur ne doit contenir que des lettres, des chiffres ou des caract\xe8res de soulignement.",
    invalid_email: "L'email n'est pas valide",
    invalid_phone: "Le num\xe9ro de t\xe9l\xe9phone n'est pas valide",
    passwords_do_not_match: "Les mots de passe ne correspondent pas",
    invalid_passcode: "Le code est invalide",
    invalid_connector_auth: "L'autorisation n'est pas valide",
    invalid_connector_request: "Les donn\xe9es du connecteur ne sont pas valides",
    unknown: "Erreur inconnue. Veuillez r\xe9essayer plus tard.",
    invalid_session: "Session non trouv\xe9e. Veuillez revenir en arri\xe8re et vous connecter \xe0 nouveau.",
    timeout: "D\xe9lai d'attente de la requ\xeate d\xe9pass\xe9. Veuillez r\xe9essayer plus tard.",
    password_rejected: $d5a62f3eaff451e4$export$2e2bcd8739ae039,
    sso_not_enabled: "La authentification unique n'est pas activ\xe9e pour ce compte de messagerie."
};
var $84e4ca1af415e36b$export$2e2bcd8739ae039 = Object.freeze($84e4ca1af415e36b$var$error);


const $82e33aaa0fa702d9$var$input = {
    username: "Nom d'utilisateur",
    password: "Mot de passe",
    email: "Email",
    phone_number: "Num\xe9ro de t\xe9l\xe9phone",
    confirm_password: "Confirmer le mot de passe",
    search_region_code: "Rechercher le code de r\xe9gion",
    backup_code: "Code de sauvegarde"
};
var $82e33aaa0fa702d9$export$2e2bcd8739ae039 = Object.freeze($82e33aaa0fa702d9$var$input);


const $a98ae34a8bc6fa5c$var$list = {
    or: "ou",
    and: "et",
    separator: ","
};
var $a98ae34a8bc6fa5c$export$2e2bcd8739ae039 = Object.freeze($a98ae34a8bc6fa5c$var$list);


const $345d634b1645f9ca$var$mfa = {
    totp: "OTP de l'application d'authentification",
    webauthn: "Passkey",
    backup_code: "Code de sauvegarde",
    link_totp_description: "Par exemple, Google Authenticator, etc.",
    link_webauthn_description: "Associez votre appareil ou mat\xe9riel USB",
    link_backup_code_description: "G\xe9n\xe9rez un code de sauvegarde",
    verify_totp_description: "Saisissez le code \xe0 usage unique dans l'application",
    verify_webauthn_description: "V\xe9rifiez votre appareil ou mat\xe9riel USB",
    verify_backup_code_description: "Collez le code de sauvegarde que vous avez enregistr\xe9",
    add_mfa_factors: "Ajouter la v\xe9rification en deux \xe9tapes",
    add_mfa_description: "La v\xe9rification en deux \xe9tapes est activ\xe9e. S\xe9lectionnez votre deuxi\xe8me m\xe9thode de v\xe9rification pour une connexion s\xe9curis\xe9e.",
    verify_mfa_factors: "V\xe9rification en deux \xe9tapes",
    verify_mfa_description: "La v\xe9rification en deux \xe9tapes a \xe9t\xe9 activ\xe9e pour ce compte. Veuillez s\xe9lectionner la deuxi\xe8me fa\xe7on de v\xe9rifier votre identit\xe9.",
    add_authenticator_app: "Ajouter une application d'authentification",
    step: "\xc9tape {{step, number}} : {{content}}",
    scan_qr_code: "Scannez ce code QR",
    scan_qr_code_description: "Scannez le code QR suivant avec votre application d'authentification, telle que Google Authenticator, Duo Mobile, Authy, etc.",
    qr_code_not_available: "Impossible de scanner le code QR ?",
    copy_and_paste_key: "Copiez et collez la cl\xe9",
    copy_and_paste_key_description: "Copiez et collez la cl\xe9 suivante dans votre application d'authentification, telle que Google Authenticator, Duo Mobile, Authy, etc.",
    want_to_scan_qr_code: "Vous voulez scanner le code QR ?",
    enter_one_time_code: "Saisissez le code \xe0 usage unique",
    enter_one_time_code_link_description: "Saisissez le code de v\xe9rification \xe0 6 chiffres g\xe9n\xe9r\xe9 par l'application d'authentification.",
    enter_one_time_code_description: "La v\xe9rification en deux \xe9tapes a \xe9t\xe9 activ\xe9e pour ce compte. Veuillez entrer le code \xe0 usage unique affich\xe9 sur votre application d'authentification li\xe9e.",
    link_another_mfa_factor: "Passez \xe0 une autre m\xe9thode",
    save_backup_code: "Enregistrez votre code de sauvegarde",
    save_backup_code_description: "Vous pouvez utiliser l'un de ces codes de sauvegarde pour acc\xe9der \xe0 votre compte en cas de probl\xe8me lors de la v\xe9rification en deux \xe9tapes par d'autres moyens. Chaque code ne peut \xeatre utilis\xe9 qu'une fois.",
    backup_code_hint: "Assurez-vous de les copier et de les sauvegarder dans un endroit s\xfbr.",
    enter_a_backup_code: "Saisissez un code de sauvegarde",
    enter_backup_code_description: "Saisissez le code de sauvegarde que vous avez enregistr\xe9 lorsque la v\xe9rification en deux \xe9tapes a \xe9t\xe9 activ\xe9e initialement.",
    create_a_passkey: "Cr\xe9ez une cl\xe9 d'acc\xe8s",
    create_passkey_description: "Enregistrez votre cl\xe9 d'acc\xe8s \xe0 l'aide de la biom\xe9trie de l'appareil, de cl\xe9s de s\xe9curit\xe9 (par exemple, YubiKey) ou d'autres m\xe9thodes disponibles.",
    try_another_verification_method: "Essayez une autre m\xe9thode de v\xe9rification",
    verify_via_passkey: "V\xe9rifiez via la cl\xe9 d'acc\xe8s",
    verify_via_passkey_description: "Utilisez la cl\xe9 d'acc\xe8s pour v\xe9rifier avec votre mot de passe ou la biom\xe9trie de votre appareil, en scannant le code QR ou en utilisant une cl\xe9 de s\xe9curit\xe9 USB comme la YubiKey.",
    secret_key_copied: "Cl\xe9 secr\xe8te copi\xe9e.",
    backup_code_copied: "Code de sauvegarde copi\xe9.",
    webauthn_not_ready: "WebAuthn n'est pas pr\xeat pour le moment. Veuillez r\xe9essayer plus tard.",
    webauthn_not_supported: "WebAuthn n'est pas pris en charge dans ce navigateur.",
    webauthn_failed_to_create: "\xc9chec de la cr\xe9ation. Veuillez r\xe9essayer.",
    webauthn_failed_to_verify: "\xc9chec de la v\xe9rification. Veuillez r\xe9essayer."
};
var $345d634b1645f9ca$export$2e2bcd8739ae039 = Object.freeze($345d634b1645f9ca$var$mfa);


const $4b2f704cef514cfa$var$secondary = {
    social_bind_with: "Vous avez d\xe9j\xe0 un compte? Connectez-vous pour lier {{methods, list(type: disjunction;)}} avec votre identit\xe9 sociale."
};
var $4b2f704cef514cfa$export$2e2bcd8739ae039 = Object.freeze($4b2f704cef514cfa$var$secondary);


const $1b65f02caed027be$var$user_scopes = {
    descriptions: {
        /** UNTRANSLATED */ custom_data: "Your custom data",
        /** UNTRANSLATED */ email: "Your email address",
        /** UNTRANSLATED */ phone: "Your phone number",
        /** UNTRANSLATED */ profile: "Your name, username, avatar, and other profile info",
        /** UNTRANSLATED */ roles: "Your roles",
        /** UNTRANSLATED */ identities: "Your linked social identities",
        /** UNTRANSLATED */ "urn:logto:scope:organizations": "Your organizations info",
        /** UNTRANSLATED */ "urn:logto:scope:organization_roles": "Your organization roles",
        /** UNTRANSLATED */ address: "Your address"
    }
};
var $1b65f02caed027be$export$2e2bcd8739ae039 = Object.freeze($1b65f02caed027be$var$user_scopes);


const $9a4174cdd99ec5a3$var$fr = {
    translation: {
        input: $82e33aaa0fa702d9$export$2e2bcd8739ae039,
        secondary: $4b2f704cef514cfa$export$2e2bcd8739ae039,
        action: $6d9a8e6fe0d41ede$export$2e2bcd8739ae039,
        description: $10b6e43355bb48e2$export$2e2bcd8739ae039,
        error: $84e4ca1af415e36b$export$2e2bcd8739ae039,
        list: $a98ae34a8bc6fa5c$export$2e2bcd8739ae039,
        mfa: $345d634b1645f9ca$export$2e2bcd8739ae039,
        development_tenant: $8934c04316444918$export$2e2bcd8739ae039,
        user_scopes: $1b65f02caed027be$export$2e2bcd8739ae039
    }
};
var $9a4174cdd99ec5a3$export$2e2bcd8739ae039 = Object.freeze($9a4174cdd99ec5a3$var$fr);


const $8a311932977f8765$var$action = {
    sign_in: "Accedi",
    continue: "Continua",
    create_account: "Crea account",
    create_account_without_linking: "Crea account senza collegare",
    create: "Crea",
    enter_passcode: "Inserisci il codice di verifica",
    confirm: "Conferma",
    cancel: "Annulla",
    save_password: "Salva password",
    bind: "Collega con {{address}}",
    bind_and_continue: "Collega e continua",
    back: "Torna indietro",
    nav_back: "Indietro",
    nav_skip: "Salta",
    agree: "Accetto",
    got_it: "Capito",
    sign_in_with: "Continua con {{name}}",
    forgot_password: "Hai dimenticato la password?",
    switch_to: "Passa a {{method}}",
    sign_in_via_passcode: "Accedi con il codice di verifica",
    sign_in_via_password: "Accedi con la password",
    change: "Cambia {{method}}",
    link_another_email: "Collega un altro indirizzo email",
    link_another_phone: "Collega un altro numero di telefono",
    link_another_email_or_phone: "Collega un altro indirizzo email o numero di telefono",
    show_password: "Mostra password",
    copy: "Copia",
    verify_via_passkey: "Verifica tramite passkey",
    download: "Scarica",
    single_sign_on: "Single Sign-On",
    /** UNTRANSLATED */ authorize: "Authorize",
    /** UNTRANSLATED */ use_another_account: "Use another account"
};
var $8a311932977f8765$export$2e2bcd8739ae039 = Object.freeze($8a311932977f8765$var$action);


const $cab0e0467a747a0d$var$description = {
    email: "email",
    phone_number: "numero di telefono",
    username: "username",
    reminder: "Promemoria",
    not_found: "404 Non trovato",
    agree_with_terms: "Ho letto e accetto i ",
    agree_with_terms_modal: "Per procedere, si prega di accettare i <link></link>.",
    terms_of_use: "Termini di utilizzo",
    sign_in: "Accedi",
    privacy_policy: "Informativa sulla privacy",
    create_account: "Crea account",
    or: "o",
    and: "e",
    enter_passcode: "Il codice di verifica \xe8 stato inviato alla tua {{address}} {{target}}",
    passcode_sent: "Il codice di verifica \xe8 stato inviato di nuovo",
    resend_after_seconds: "Inviare di nuovo dopo <span>{{seconds}}</span> secondi",
    resend_passcode: "Inviare nuovamente il codice di verifica",
    create_account_id_exists: "L'account con {{type}} {{value}} gi\xe0 esiste, vuoi accedere?",
    link_account_id_exists: "L'account con {{type}} {{value}} \xe8 gi\xe0 esistente. Vuoi collegarlo?",
    sign_in_id_does_not_exist: "L'account con {{type}} {{value}} non esiste, vuoi creare un nuovo account?",
    sign_in_id_does_not_exist_alert: "L'account con {{type}} {{value}} non esiste.",
    create_account_id_exists_alert: "L'account {{type}} {{value}} \xe8 collegato ad un altro account. Prova con un altro {{type}}.",
    social_identity_exist: "L'{{type}} {{value}} \xe8 collegato ad un altro account. Prova con un altro {{type}}.",
    bind_account_title: "Collega o crea un account",
    social_create_account: "Puoi creare un nuovo account.",
    social_link_email: "Puoi collegare un'altra email",
    social_link_phone: "Puoi collegare un altro telefono",
    social_link_email_or_phone: "Puoi collegare un'altra email o telefono",
    social_bind_with_existing: "Abbiamo trovato un account correlato, puoi collegarlo direttamente.",
    reset_password: "Resetta la password",
    reset_password_description: "Inserisci il {{types, list(type: disjunction;)}} associato al tuo account, e ti invieremo il codice di verifica per resettare la password.",
    new_password: "Nuova password",
    set_password: "Imposta una password",
    password_changed: "Password cambiata",
    no_account: "Ancora nessun account? ",
    have_account: "Hai gi\xe0 un account?",
    enter_password: "Inserisci la password",
    enter_password_for: "Accedi con la password per {{method}} {{value}}",
    enter_username: "Imposta username",
    enter_username_description: "L'username \xe8 un'alternativa per l'accesso. L'username deve contenere solo lettere, numeri e trattini bassi.",
    link_email: "Collega emails",
    link_phone: "Collega telefono",
    link_email_or_phone: "Collega email o telefono",
    link_email_description: "Per maggiore sicurezza, collega la tua email all'account.",
    link_phone_description: "Per maggiore sicurezza, collega il tuo telefono all'account.",
    link_email_or_phone_description: "Per maggiore sicurezza, collega la tua email o il tuo telefono all'account.",
    continue_with_more_information: "Per maggiore sicurezza, completa i dettagli dell'account qui sotto.",
    create_your_account: "Crea il tuo account",
    sign_in_to_your_account: "Accedi al tuo account",
    no_region_code_found: "Nessun codice di regione trovato",
    verify_email: "Verifica la tua email",
    verify_phone: "Verifica il tuo numero di telefono",
    password_requirements: "Password {{items, list}}.",
    password_requirement: {
        length_one: "richiede almeno {{count}} carattere",
        length_other: "richiede almeno {{count}} caratteri",
        character_types_one: "dovrebbe contenere almeno {{count}} tipo di lettere maiuscole, lettere minuscole, numeri e simboli",
        character_types_other: "dovrebbe contenere almeno {{count}} tipi di lettere maiuscole, lettere minuscole, numeri e simboli"
    },
    use: "Utilizzare",
    single_sign_on_email_form: "Inserisci il tuo indirizzo email aziendale",
    single_sign_on_connectors_list: "La tua azienda ha abilitato il Single Sign-On per l'account email {{email}}. Puoi continuare ad accedere con i seguenti fornitori di SSO.",
    single_sign_on_enabled: "Il Single Sign-On \xe8 abilitato per questo account",
    /** UNTRANSLATED */ authorize_title: "Authorize {{name}}",
    /** UNTRANSLATED */ request_permission: "{{name}} is requesting access to:",
    /** UNTRANSLATED */ grant_organization_access: "Grant the organization access:",
    /** UNTRANSLATED */ user_scopes: "Personal user data",
    /** UNTRANSLATED */ organization_scopes: "Organization access",
    /** UNTRANSLATED */ authorize_agreement: `By authorize the access, you agree to the {{name}}'s <link></link>.`,
    /** UNTRANSLATED */ not_you: "Not you?",
    /** UNTRANSLATED */ user_id: "User ID: {{id}}",
    /** UNTRANSLATED */ redirect_to: "You will be redirected to {{name}}."
};
var $cab0e0467a747a0d$export$2e2bcd8739ae039 = Object.freeze($cab0e0467a747a0d$var$description);


const $f9e78823128e3fbb$var$development_tenant = {
    notification: "Sei in modalit\xe0 di sviluppo"
};
var $f9e78823128e3fbb$export$2e2bcd8739ae039 = Object.freeze($f9e78823128e3fbb$var$development_tenant);


const $bd11282c3ef7ac43$var$password_rejected = {
    too_short: "La lunghezza minima \xe8 {{min}}.",
    too_long: "La lunghezza massima \xe8 {{max}}.",
    character_types: "Sono richiesti almeno {{min}} tipi di caratteri.",
    unsupported_characters: "Carattere non supportato trovato.",
    pwned: "Evita di utilizzare password semplici facili da indovinare.",
    restricted_found: "Evita di utilizzare in eccesso {{list, list}}.",
    restricted: {
        repetition: "caratteri ripetuti",
        sequence: "caratteri sequenziali",
        user_info: "le tue informazioni personali",
        words: "contesto del prodotto"
    }
};
var $bd11282c3ef7ac43$export$2e2bcd8739ae039 = Object.freeze($bd11282c3ef7ac43$var$password_rejected);


const $56cb0259bf58fd2d$var$error = {
    general_required: `{{types, list(type: disjunction;)}} è richiesto`,
    general_invalid: `Il {{types, list(type: disjunction;)}} non è valido`,
    username_required: "Username \xe8 richiesto",
    password_required: "La password \xe8 richiesta",
    username_exists: "Username esiste gi\xe0",
    username_should_not_start_with_number: "L'username non dovrebbe iniziare con un numero",
    username_invalid_charset: "L'username dovrebbe contenere solo lettere, numeri o underscore.",
    invalid_email: "L'email non \xe8 valida",
    invalid_phone: "Il numero di telefono non \xe8 valido",
    passwords_do_not_match: "Le password non corrispondono. Per favore prova di nuovo.",
    invalid_passcode: "Il codice di verifica non \xe8 valido",
    invalid_connector_auth: "L'autorizzazione \xe8 invalida",
    invalid_connector_request: "I dati del connettore non sono validi",
    unknown: "Errore sconosciuto. Si prega di riprovare pi\xf9 tardi.",
    invalid_session: "Sessione non trovata. Si prega di tornare indietro e accedere di nuovo.",
    timeout: "Timeout della richiesta. Si prega di riprovare pi\xf9 tardi.",
    password_rejected: $bd11282c3ef7ac43$export$2e2bcd8739ae039,
    sso_not_enabled: "Single sign-on non abilitato per questo account email."
};
var $56cb0259bf58fd2d$export$2e2bcd8739ae039 = Object.freeze($56cb0259bf58fd2d$var$error);


const $0c57e186858d54d7$var$input = {
    username: "Nome utente",
    password: "Password",
    email: "Email",
    phone_number: "Numero di telefono",
    confirm_password: "Conferma password",
    search_region_code: "Codice regione di ricerca",
    backup_code: "Codice di backup"
};
var $0c57e186858d54d7$export$2e2bcd8739ae039 = Object.freeze($0c57e186858d54d7$var$input);


const $e4765afe4629b207$var$list = {
    or: "o",
    and: "e",
    separator: ","
};
var $e4765afe4629b207$export$2e2bcd8739ae039 = Object.freeze($e4765afe4629b207$var$list);


const $3bf0c1551878ef16$var$mfa = {
    totp: "OTP dell'app Autenticatore",
    webauthn: "Passkey",
    backup_code: "Codice di backup",
    link_totp_description: "Ad esempio, Google Authenticator, ecc.",
    link_webauthn_description: "Collega il tuo dispositivo o hardware USB",
    link_backup_code_description: "Genera un codice di backup",
    verify_totp_description: "Inserisci il codice monouso nell'app",
    verify_webauthn_description: "Verifica il tuo dispositivo o hardware USB",
    verify_backup_code_description: "Incolla il codice di backup che hai salvato",
    add_mfa_factors: "Aggiungi la verifica in due passaggi",
    add_mfa_description: "La verifica in due passaggi \xe8 abilitata. Seleziona il tuo secondo metodo di verifica per un accesso sicuro.",
    verify_mfa_factors: "Verifica in due passaggi",
    verify_mfa_description: "La verifica in due passaggi \xe8 stata abilitata per questo account. Seleziona il secondo modo per verificare la tua identit\xe0.",
    add_authenticator_app: "Aggiungi app di autenticazione",
    step: "Passo {{step, number}}: {{content}}",
    scan_qr_code: "Scansiona questo codice QR",
    scan_qr_code_description: "Scansiona il seguente codice QR con la tua app di autenticazione, come Google Authenticator, Duo Mobile, Authy, ecc.",
    qr_code_not_available: "Non \xe8 possibile scansionare il codice QR?",
    copy_and_paste_key: "Copia e incolla la chiave",
    copy_and_paste_key_description: "Copia e incolla la seguente chiave nella tua app di autenticazione, come Google Authenticator, Duo Mobile, Authy, ecc.",
    want_to_scan_qr_code: "Vuoi scansionare il codice QR?",
    enter_one_time_code: "Inserisci il codice monouso",
    enter_one_time_code_link_description: "Inserisci il codice di verifica a 6 cifre generato dall'app di autenticazione.",
    enter_one_time_code_description: "La verifica in due passaggi \xe8 stata abilitata per questo account. Inserisci il codice monouso mostrato sulla tua app di autenticazione collegata.",
    link_another_mfa_factor: "Passa a un altro metodo",
    save_backup_code: "Salva il codice di backup",
    save_backup_code_description: "Puoi utilizzare uno di questi codici di backup per accedere al tuo account in caso di problemi durante la verifica in due passaggi in altri modi. Ogni codice pu\xf2 essere utilizzato solo una volta.",
    backup_code_hint: "Assicurati di copiarli e salvarli in un luogo sicuro.",
    enter_a_backup_code: "Inserisci un codice di backup",
    enter_backup_code_description: "Inserisci il codice di backup salvato quando \xe8 stata abilitata la verifica in due passaggi.",
    create_a_passkey: "Crea una chiave di accesso",
    create_passkey_description: "Registra la tua chiave di accesso utilizzando le biometrie del dispositivo, le chiavi di sicurezza (ad esempio, YubiKey) o altri metodi disponibili.",
    try_another_verification_method: "Prova un altro metodo di verifica",
    verify_via_passkey: "Verifica tramite chiave di accesso",
    verify_via_passkey_description: "Usa la chiave di accesso per verificare tramite la password o le biometrie del tuo dispositivo, la scansione del codice QR o l'uso di una chiave di sicurezza USB come YubiKey.",
    secret_key_copied: "Chiave segreta copiata.",
    backup_code_copied: "Codice di backup copiato.",
    webauthn_not_ready: "WebAuthn non \xe8 ancora pronto. Riprova pi\xf9 tardi.",
    webauthn_not_supported: "WebAuthn non \xe8 supportato in questo browser.",
    webauthn_failed_to_create: "Impossibile creare. Riprova.",
    webauthn_failed_to_verify: "Verifica non riuscita. Riprova."
};
var $3bf0c1551878ef16$export$2e2bcd8739ae039 = Object.freeze($3bf0c1551878ef16$var$mfa);


const $f6beed827c5841fa$var$secondary = {
    social_bind_with: "Gi\xe0 un account? Accedi per collegare {{methods, list(type: disjunction;)}} con la tua identit\xe0 sociale."
};
var $f6beed827c5841fa$export$2e2bcd8739ae039 = Object.freeze($f6beed827c5841fa$var$secondary);


const $8902be347289577e$var$user_scopes = {
    descriptions: {
        /** UNTRANSLATED */ custom_data: "Your custom data",
        /** UNTRANSLATED */ email: "Your email address",
        /** UNTRANSLATED */ phone: "Your phone number",
        /** UNTRANSLATED */ profile: "Your name, username, avatar, and other profile info",
        /** UNTRANSLATED */ roles: "Your roles",
        /** UNTRANSLATED */ identities: "Your linked social identities",
        /** UNTRANSLATED */ "urn:logto:scope:organizations": "Your organizations info",
        /** UNTRANSLATED */ "urn:logto:scope:organization_roles": "Your organization roles",
        /** UNTRANSLATED */ address: "Your address"
    }
};
var $8902be347289577e$export$2e2bcd8739ae039 = Object.freeze($8902be347289577e$var$user_scopes);


const $0c60d1aa166e8b9b$var$it = {
    translation: {
        input: $0c57e186858d54d7$export$2e2bcd8739ae039,
        secondary: $f6beed827c5841fa$export$2e2bcd8739ae039,
        action: $8a311932977f8765$export$2e2bcd8739ae039,
        description: $cab0e0467a747a0d$export$2e2bcd8739ae039,
        error: $56cb0259bf58fd2d$export$2e2bcd8739ae039,
        list: $e4765afe4629b207$export$2e2bcd8739ae039,
        mfa: $3bf0c1551878ef16$export$2e2bcd8739ae039,
        development_tenant: $f9e78823128e3fbb$export$2e2bcd8739ae039,
        user_scopes: $8902be347289577e$export$2e2bcd8739ae039
    }
};
var $0c60d1aa166e8b9b$export$2e2bcd8739ae039 = Object.freeze($0c60d1aa166e8b9b$var$it);


const $1a7754f366c8a5f4$var$action = {
    sign_in: "サインイン",
    continue: "続ける",
    create_account: "アカウントを作成する",
    create_account_without_linking: "リンクなしでアカウントを作成する",
    create: "作成する",
    enter_passcode: "認証コードを入力してください",
    confirm: "確認する",
    cancel: "キャンセル",
    save_password: "パスワードを保存する",
    bind: "{{address}} とリンクする",
    bind_and_continue: "リンクして続行する",
    back: "戻る",
    nav_back: "戻る",
    nav_skip: "スキップ",
    agree: "同意する",
    got_it: "わかりました",
    sign_in_with: "{{name}} で続ける",
    forgot_password: "パスワードを忘れましたか？",
    switch_to: "{{method}} に切り替える",
    sign_in_via_passcode: "認証コードでサインインする",
    sign_in_via_password: "パスワードでサインインする",
    change: "{{method}} を変更する",
    link_another_email: "別のメールアドレスをリンクする",
    link_another_phone: "別の電話番号をリンクする",
    link_another_email_or_phone: "別のメールアドレスまたは電話番号をリンクする",
    show_password: "パスワードを表示する",
    copy: "コピー",
    verify_via_passkey: "パスキー経由で確認",
    download: "ダウンロード",
    single_sign_on: "シングルサインオン",
    /** UNTRANSLATED */ authorize: "Authorize",
    /** UNTRANSLATED */ use_another_account: "Use another account"
};
var $1a7754f366c8a5f4$export$2e2bcd8739ae039 = Object.freeze($1a7754f366c8a5f4$var$action);


const $58c213227df95ab0$var$description = {
    email: "メールアドレス",
    phone_number: "電話番号",
    username: "ユーザー名",
    reminder: "リマインダー",
    not_found: "404 Not Found",
    agree_with_terms: "以下に同意することを確認しました：",
    agree_with_terms_modal: "続行するには、<link></link>に同意してください。",
    terms_of_use: "利用規約",
    sign_in: "サインイン",
    privacy_policy: "プライバシーポリシー",
    create_account: "アカウントを作成する",
    or: "または",
    and: "及び",
    enter_passcode: "確認コードが{{address}} {{target}}に送信されました",
    passcode_sent: "確認コードを再送します",
    resend_after_seconds: "<span>{{seconds}}</span>秒後に再送信",
    resend_passcode: "確認コードを再送信します",
    create_account_id_exists: "{{type}} {{value}}でアカウントが既に存在しています。ログインしますか？",
    link_account_id_exists: "{{type}} {{value}}でアカウントが既に存在しています。リンクしますか？",
    sign_in_id_does_not_exist: "{{type}} {{value}}のアカウントは存在しません。新しいアカウントを作成しますか？",
    sign_in_id_does_not_exist_alert: "{{type}} {{value}}のアカウントは存在しません。",
    create_account_id_exists_alert: "{{type}} {{value}}は他のアカウントにリンクされています。他の{{type}}を試してください。",
    social_identity_exist: "{{type}} {{value}}は他のアカウントにリンクされています。他の{{type}}を試してください。",
    bind_account_title: "アカウントのリンクまたは作成",
    social_create_account: "新しいアカウントを作成できます。",
    social_link_email: "別のメールアドレスをリンクできます。",
    social_link_phone: "他の電話番号にリンクできます。",
    social_link_email_or_phone: "他のメールアドレスまたは電話番号にリンクできます。",
    social_bind_with_existing: "関連するアカウントが見つかりました。それを直接リンクできます。",
    reset_password: "パスワードを再設定する",
    reset_password_description: "アカウントに関連する{{types, list(type: disjunction;)}}を入力すると、パスワードの再設定に必要な確認コードが送信されます。",
    new_password: "新しいパスワード",
    set_password: "パスワードを設定する",
    password_changed: "パスワードが変更されました",
    no_account: "アカウントを作成していませんか？",
    have_account: "すでにアカウントをお持ちですか？",
    enter_password: "パスワードを入力する",
    enter_password_for: "{{method}} {{value}}でパスワードでサインインする",
    enter_username: "ユーザー名を入力する",
    enter_username_description: "ユーザー名はサインインの代替手段です。ユーザー名には、文字、数字、アンダースコアのみを含める必要があります。",
    link_email: "メールアドレスをリンクする",
    link_phone: "電話番号をリンクする",
    link_email_or_phone: "メールアドレスまたは電話番号をリンクする",
    link_email_description: "セキュリティを高めるために、アカウントにメールアドレスをリンクしてください。",
    link_phone_description: "セキュリティを高めるために、アカウントに電話番号をリンクしてください。",
    link_email_or_phone_description: "セキュリティを高めるために、アカウントに別のメールアドレスまたは電話番号をリンクしてください。",
    continue_with_more_information: "以下にアカウントの詳細を入力して、セキュリティを高めてください。",
    create_your_account: "アカウントを作成する",
    sign_in_to_your_account: "アカウントにサインインする",
    no_region_code_found: "地域コードが見つかりません",
    verify_email: "Eメールを確認する",
    verify_phone: "電話番号を確認する",
    password_requirements: "パスワード {{items, list}}。",
    password_requirement: {
        length_one: "最低 {{count}} 文字",
        length_other: "最低 {{count}} 文字",
        character_types_one: "大文字、小文字、数字、記号のうち {{count}} 種類を含む必要があります",
        character_types_other: "大文字、小文字、数字、記号のうち {{count}} 種類を含む必要があります"
    },
    use: "使用する",
    single_sign_on_email_form: "企業のメールアドレスを入力してください",
    single_sign_on_connectors_list: "あなたの企業は、メールアカウント{{email}}に対してシングルサインオンを有効にしました。以下のSSOプロバイダーを使用してサインインを続けることができます。",
    single_sign_on_enabled: "このアカウントではシングル サインオンが有効になっています",
    /** UNTRANSLATED */ authorize_title: "Authorize {{name}}",
    /** UNTRANSLATED */ request_permission: "{{name}} is requesting access to:",
    /** UNTRANSLATED */ grant_organization_access: "Grant the organization access:",
    /** UNTRANSLATED */ user_scopes: "Personal user data",
    /** UNTRANSLATED */ organization_scopes: "Organization access",
    /** UNTRANSLATED */ authorize_agreement: `By authorize the access, you agree to the {{name}}'s <link></link>.`,
    /** UNTRANSLATED */ not_you: "Not you?",
    /** UNTRANSLATED */ user_id: "User ID: {{id}}",
    /** UNTRANSLATED */ redirect_to: "You will be redirected to {{name}}."
};
var $58c213227df95ab0$export$2e2bcd8739ae039 = Object.freeze($58c213227df95ab0$var$description);


const $c7c08f6c606f595e$var$development_tenant = {
    notification: "開発モードです"
};
var $c7c08f6c606f595e$export$2e2bcd8739ae039 = Object.freeze($c7c08f6c606f595e$var$development_tenant);


const $c2adb0d65aa43d81$var$password_rejected = {
    too_short: "最小の長さは{{min}}です。",
    too_long: "最大の長さは{{max}}です。",
    character_types: "少なくとも{{min}}種類の文字が必要です。",
    unsupported_characters: "サポートされていない文字が見つかりました。",
    pwned: "簡単に推測できる簡単なパスワードの使用を避けてください。",
    restricted_found: "{{list, list}}の過度な使用を避けてください。",
    restricted: {
        repetition: "繰り返された文字",
        sequence: "連続する文字",
        user_info: "個人情報",
        words: "製品のコンテキスト"
    }
};
var $c2adb0d65aa43d81$export$2e2bcd8739ae039 = Object.freeze($c2adb0d65aa43d81$var$password_rejected);


const $6dac242f8556b48a$var$error = {
    general_required: `{{types, list(type: disjunction;)}}が必要です`,
    general_invalid: `{{types, list(type: disjunction;)}}が無効です`,
    username_required: "ユーザー名が必要です",
    password_required: "パスワードが必要です",
    username_exists: "ユーザー名が既に存在しています",
    username_should_not_start_with_number: "ユーザー名は数字で始めることはできません",
    username_invalid_charset: "ユーザー名は文字、数字、またはアンダースコアのみを含める必要があります。",
    invalid_email: "メールアドレスが無効です",
    invalid_phone: "電話番号が無効です",
    passwords_do_not_match: "パスワードが一致しません。もう一度お試しください。",
    invalid_passcode: "検証コードが無効です",
    invalid_connector_auth: "認証が無効です",
    invalid_connector_request: "コネクターデータが無効です",
    unknown: "不明なエラーが発生しました。後でもう一度お試しください。",
    invalid_session: "セッションが見つかりません。もう一度サインインしてください。",
    timeout: "リクエストタイムアウト。後でもう一度お試しください。",
    password_rejected: $c2adb0d65aa43d81$export$2e2bcd8739ae039,
    sso_not_enabled: "このメールアカウントではシングルサインオンが有効になっていません。"
};
var $6dac242f8556b48a$export$2e2bcd8739ae039 = Object.freeze($6dac242f8556b48a$var$error);


const $43a48a45dd155955$var$input = {
    username: "ユーザー名",
    password: "パスワード",
    email: "メールアドレス",
    phone_number: "電話番号",
    confirm_password: "パスワード確認",
    search_region_code: "地域コード検索",
    backup_code: "バックアップコード"
};
var $43a48a45dd155955$export$2e2bcd8739ae039 = Object.freeze($43a48a45dd155955$var$input);


const $e91609bb32c62d17$var$list = {
    or: "または",
    and: "そして",
    separator: ","
};
var $e91609bb32c62d17$export$2e2bcd8739ae039 = Object.freeze($e91609bb32c62d17$var$list);


const $92cc02779b6cc512$var$mfa = {
    totp: "認証アプリOTP",
    webauthn: "パスキー",
    backup_code: "バックアップコード",
    link_totp_description: "例：Google Authenticator など",
    link_webauthn_description: "デバイスまたはUSBハードウェアをリンク",
    link_backup_code_description: "バックアップコードを生成",
    verify_totp_description: "アプリに表示されるワンタイムコードを入力",
    verify_webauthn_description: "デバイスまたはUSBハードウェアを確認",
    verify_backup_code_description: "保存したバックアップコードを貼り付け",
    add_mfa_factors: "2段階認証を追加",
    add_mfa_description: "2段階認証が有効になっています。安全なサインインのために第二の認証方法を選択してください。",
    verify_mfa_factors: "2段階認証",
    verify_mfa_description: "このアカウントでは2段階認証が有効になっています。アイデンティティを確認するための第二の方法を選択してください。",
    add_authenticator_app: "認証アプリを追加",
    step: "ステップ{{step, number}}：{{content}}",
    scan_qr_code: "このQRコードをスキャン",
    scan_qr_code_description: "次のQRコードを認証アプリ（例：Google Authenticator、Duo Mobile、Authyなど）でスキャンしてください。",
    qr_code_not_available: "QRコードをスキャンできませんか？",
    copy_and_paste_key: "キーをコピーして貼り付ける",
    copy_and_paste_key_description: "次のキーを認証アプリ（例：Google Authenticator、Duo Mobile、Authyなど）にコピーして貼り付けてください。",
    want_to_scan_qr_code: "QRコードをスキャンしますか？",
    enter_one_time_code: "ワンタイムコードを入力",
    enter_one_time_code_link_description: "認証アプリで生成された6桁の確認コードを入力してください。",
    enter_one_time_code_description: "このアカウントでは2段階認証が有効になっています。リンクされた認証アプリに表示されるワンタイムコードを入力してください。",
    link_another_mfa_factor: "別の方法に切り替える",
    save_backup_code: "バックアップコードを保存",
    save_backup_code_description: "2段階認証中に他の方法で問題が発生した場合、これらのバックアップコードのいずれかを使用してアカウントにアクセスできます。各コードは一度だけ使用できます。",
    backup_code_hint: "必ずコピーして安全な場所に保存してください。",
    enter_a_backup_code: "バックアップコードを入力",
    enter_backup_code_description: "初めて2段階認証が有効になったときに保存したバックアップコードを入力してください。",
    create_a_passkey: "パスキーを作成",
    create_passkey_description: "デバイスの生体認証、セキュリティキー（例：YubiKey）などを使用してパスキーを登録します。",
    try_another_verification_method: "別の検証方法を試す",
    verify_via_passkey: "パスキーで確認",
    verify_via_passkey_description: "デバイスのパスワードまたは生体認証、QRコードのスキャン、YubiKeyなどのUSBセキュリティキーを使用してパスキーで確認します。",
    secret_key_copied: "秘密鍵がコピーされました。",
    backup_code_copied: "バックアップコードがコピーされました。",
    webauthn_not_ready: "WebAuthnはまだ準備ができていません。後でもう一度試してください。",
    webauthn_not_supported: "このブラウザではWebAuthnはサポートされていません。",
    webauthn_failed_to_create: "作成に失敗しました。もう一度試してください。",
    webauthn_failed_to_verify: "確認に失敗しました。もう一度試してください。"
};
var $92cc02779b6cc512$export$2e2bcd8739ae039 = Object.freeze($92cc02779b6cc512$var$mfa);


const $75aa6c73a0eec968$var$secondary = {
    social_bind_with: "既にアカウントを持っていますか？{{methods, list(type: disjunction;)}}をソーシャルアイデンティティにリンクするためにサインインしてください。"
};
var $75aa6c73a0eec968$export$2e2bcd8739ae039 = Object.freeze($75aa6c73a0eec968$var$secondary);


const $5439f329b31868a0$var$user_scopes = {
    descriptions: {
        /** UNTRANSLATED */ custom_data: "Your custom data",
        /** UNTRANSLATED */ email: "Your email address",
        /** UNTRANSLATED */ phone: "Your phone number",
        /** UNTRANSLATED */ profile: "Your name, username, avatar, and other profile info",
        /** UNTRANSLATED */ roles: "Your roles",
        /** UNTRANSLATED */ identities: "Your linked social identities",
        /** UNTRANSLATED */ "urn:logto:scope:organizations": "Your organizations info",
        /** UNTRANSLATED */ "urn:logto:scope:organization_roles": "Your organization roles",
        /** UNTRANSLATED */ address: "Your address"
    }
};
var $5439f329b31868a0$export$2e2bcd8739ae039 = Object.freeze($5439f329b31868a0$var$user_scopes);


const $248a3f867fd893fa$var$ja = {
    translation: {
        input: $43a48a45dd155955$export$2e2bcd8739ae039,
        secondary: $75aa6c73a0eec968$export$2e2bcd8739ae039,
        action: $1a7754f366c8a5f4$export$2e2bcd8739ae039,
        description: $58c213227df95ab0$export$2e2bcd8739ae039,
        error: $6dac242f8556b48a$export$2e2bcd8739ae039,
        list: $e91609bb32c62d17$export$2e2bcd8739ae039,
        mfa: $92cc02779b6cc512$export$2e2bcd8739ae039,
        development_tenant: $c7c08f6c606f595e$export$2e2bcd8739ae039,
        user_scopes: $5439f329b31868a0$export$2e2bcd8739ae039
    }
};
var $248a3f867fd893fa$export$2e2bcd8739ae039 = Object.freeze($248a3f867fd893fa$var$ja);


const $c725276831682d93$var$action = {
    sign_in: "로그인",
    continue: "계속",
    create_account: "계정 생성",
    create_account_without_linking: "연동 없이 계정 생성하기",
    create: "생성",
    enter_passcode: "비밀번호 입력",
    confirm: "확인",
    cancel: "취소",
    save_password: "저장",
    bind: "{{address}}로 연동",
    bind_and_continue: "연동하고 계속하기",
    back: "뒤로 가기",
    nav_back: "뒤로",
    nav_skip: "건너뛰기",
    agree: "동의",
    got_it: "알겠습니다",
    sign_in_with: "{{name}} 계속",
    forgot_password: "비밀번호를 잊어버리셨나요?",
    switch_to: "{{method}}로 전환",
    sign_in_via_passcode: "인증번호로 로그인",
    sign_in_via_password: "비밀번호로 로그인",
    change: "변경 {{method}}",
    link_another_email: "다른 이메일 연동",
    link_another_phone: "다른 전화번호 연동",
    link_another_email_or_phone: "다른 이메일 또는 전화번호 연동",
    show_password: "비밀번호 보기",
    copy: "복사",
    verify_via_passkey: "패스키로 확인",
    download: "다운로드",
    single_sign_on: "단일 로그인",
    /** UNTRANSLATED */ authorize: "Authorize",
    /** UNTRANSLATED */ use_another_account: "Use another account"
};
var $c725276831682d93$export$2e2bcd8739ae039 = Object.freeze($c725276831682d93$var$action);


const $06b2bd4878b802da$var$description = {
    email: "이메일",
    phone_number: "휴대전화번호",
    username: "사용자 이름",
    reminder: "리마인더",
    not_found: "404 찾을 수 없음",
    agree_with_terms: "나는 내용을 읽었으며, 이에 동의합니다.",
    agree_with_terms_modal: "진행하기 위해서는, 다음을 동의해주세요 <link></link>.",
    terms_of_use: "이용약관",
    sign_in: "로그인",
    privacy_policy: "개인정보처리방침",
    create_account: "계정 생성",
    or: "또는",
    and: "그리고",
    enter_passcode: "{{address}} {{target}} 으로 비밀번호가 전송되었어요.",
    passcode_sent: "비밀번호가 재전송되었어요.",
    resend_after_seconds: "<span>{{seconds}}</span> 초 후에 재전송",
    resend_passcode: "비밀번호 재전송",
    create_account_id_exists: "{{type}} {{value}} 계정은 다른 계정과 연결되어 있습니다. 다른 {{type}}을(를) 시도해주세요.",
    link_account_id_exists: "{{type}} {{value}}와/과 연동된 계정이 이미 존재해요. 연동할까요?",
    sign_in_id_does_not_exist: "{type}} {{value}} 계정이 존재하지 않아요. 새로 만드시겠어요?",
    sign_in_id_does_not_exist_alert: "{{type}} {{value}} 계정이 존재하지 않아요.",
    create_account_id_exists_alert: "{{type}} {{value}} 이미 존재해요.",
    social_identity_exist: "{{type}} {{value}}이/가 다른 계정과 연동되어 있어요. 다른 {{type}}을/를 시도해 보세요.",
    bind_account_title: "계정 만들거나 연동하기",
    social_create_account: "새로운 계정을 만들 수 있습니다.",
    social_link_email: "다른 이메일을 연동할 수 있어요",
    social_link_phone: "다른 휴대전화를 연동할 수 있어요",
    social_link_email_or_phone: "다른 이메일이나 휴대전화를 연동할 수 있어요",
    social_bind_with_existing: "등록된 관련 {{method}}이 있습니다. 직접 연결할 수 있습니다.",
    reset_password: "비밀번호를 잊으셨나요",
    reset_password_description: "귀하의 계정과 연결된 {{types, list(type: disjunction;)}}를 입력하면 비밀번호 재설정을 위한 인증 코드를 보내드립니다.",
    new_password: "새 비밀번호",
    set_password: "비밀번호 설정",
    password_changed: "비밀번호 변경됨",
    no_account: "계정이 없나요?",
    have_account: "이미 계정이 있나요?",
    enter_password: "비밀번호 입력",
    enter_password_for: "{{method}} {{value}} 비밀번호 로그인",
    enter_username: "사용자 이름 설정하기",
    enter_username_description: "사용자 이름은 로그인을 할 때 사용되요. 사용자 이름에는 문자, 숫자 및 밑줄만 포함되어야 해요.",
    link_email: "이메일 연동",
    link_phone: "휴대전화번호 연동",
    link_email_or_phone: "이메일 또는 휴대전화번호 연동",
    link_email_description: "더 나은 보안을 위해 이메일을 연동해 주세요.",
    link_phone_description: "더 나은 보안을 위해 휴대전화번호를 연동해 주세요.",
    link_email_or_phone_description: "더 나은 보안을 위해 이메일 또는 휴대전화번호를 연동해 주세요.",
    continue_with_more_information: "더 나은 보안을 위해 아래 자세한 내용을 따라 주세요.",
    create_your_account: "계정 생성하기",
    sign_in_to_your_account: "계정에 로그인하세요",
    no_region_code_found: "지역 코드를 찾을 수 없습니다.",
    verify_email: "이메일 인증",
    verify_phone: "휴대전화번호 인증",
    password_requirements: "비밀번호는 {{items, list}} 로 이루어져야 합니다.",
    password_requirement: {
        length_one: "최소 {{count}} 자 이상이어야 함",
        length_other: "최소 {{count}} 문자 이상이어야 함",
        character_types_one: "최소 {{count}} 개의 대문자, 소문자, 숫자, 특수 기호를 포함해야 함",
        character_types_other: "최소 {{count}} 개의 대문자, 소문자, 숫자, 특수 기호를 포함해야 함"
    },
    use: "사용",
    single_sign_on_email_form: "기업 이메일 주소를 입력하세요",
    single_sign_on_connectors_list: "귀하의 기업은 {{email}} 이메일 계정에 대해 Single Sign-On을 활성화했습니다. 다음 SSO 제공업체를 사용하여 로그인을 계속할 수 있습니다.",
    single_sign_on_enabled: "이 계정에는 Single Sign-On이 활성화되어 있습니다.",
    /** UNTRANSLATED */ authorize_title: "Authorize {{name}}",
    /** UNTRANSLATED */ request_permission: "{{name}} is requesting access to:",
    /** UNTRANSLATED */ grant_organization_access: "Grant the organization access:",
    /** UNTRANSLATED */ user_scopes: "Personal user data",
    /** UNTRANSLATED */ organization_scopes: "Organization access",
    /** UNTRANSLATED */ authorize_agreement: `By authorize the access, you agree to the {{name}}'s <link></link>.`,
    /** UNTRANSLATED */ not_you: "Not you?",
    /** UNTRANSLATED */ user_id: "User ID: {{id}}",
    /** UNTRANSLATED */ redirect_to: "You will be redirected to {{name}}."
};
var $06b2bd4878b802da$export$2e2bcd8739ae039 = Object.freeze($06b2bd4878b802da$var$description);


const $47f6dc84010f612a$var$development_tenant = {
    notification: "개발 모드입니다"
};
var $47f6dc84010f612a$export$2e2bcd8739ae039 = Object.freeze($47f6dc84010f612a$var$development_tenant);


const $5123aae5b1e047e7$var$password_rejected = {
    too_short: "최소 길이는 {{min}}입니다.",
    too_long: "최대 길이는 {{max}}입니다.",
    character_types: "최소 {{min}}개의 문자 유형이 필요합니다.",
    unsupported_characters: "지원되지 않는 문자가 발견되었습니다.",
    pwned: "추측하기 쉬운 간단한 암호 사용을 피하십시오.",
    restricted_found: "{{list, list}}을(를) 과도하게 사용하지 마십시오.",
    restricted: {
        repetition: "반복된 문자",
        sequence: "연속된 문자",
        user_info: "개인 정보",
        words: "품질 가능성"
    }
};
var $5123aae5b1e047e7$export$2e2bcd8739ae039 = Object.freeze($5123aae5b1e047e7$var$password_rejected);


const $e63c75c527421777$var$error = {
    general_required: "{{types, list(type: disjunction;)}}은/는 필수예요.",
    general_invalid: "{{types, list(type: disjunction;)}}은/는 유효하지 않아요.",
    username_required: "사용자 이름은 필수예요.",
    password_required: "비밀번호는 필수예요.",
    username_exists: "사용자 이름이 이미 존재해요.",
    username_should_not_start_with_number: "사용자 이름은 숫자로 시작하면 안 돼요.",
    username_invalid_charset: "사용자 이름은 문자, 숫자, _(밑줄 문자) 로만 이루어져야 해요.",
    invalid_email: "이메일이 유효하지 않아요.",
    invalid_phone: "휴대전화번호가 유효하지 않아요.",
    passwords_do_not_match: "비밀번호가 일치하지 않아요.",
    invalid_passcode: "비밀번호가 유효하지 않아요.",
    invalid_connector_auth: "인증이 유효하지 않아요.",
    invalid_connector_request: "연동 정보가 유효하지 않아요.",
    unknown: "알 수 없는 오류가 발생했어요. 잠시 후에 시도해 주세요.",
    invalid_session: "세션을 찾을 수 없어요. 다시 로그인해 주세요.",
    timeout: "요청 시간이 초과되었어요. 잠시 후에 다시 시도해 주세요.",
    password_rejected: $5123aae5b1e047e7$export$2e2bcd8739ae039,
    sso_not_enabled: "이 이메일 계정에 대해 단일 로그인이 활성화되지 않았어요."
};
var $e63c75c527421777$export$2e2bcd8739ae039 = Object.freeze($e63c75c527421777$var$error);


const $f2d7ad397b5ec807$var$input = {
    username: "사용자 이름",
    password: "비밀번호",
    email: "이메일",
    phone_number: "휴대전화번호",
    confirm_password: "비밀번호 확인",
    search_region_code: "지역 코드 검색",
    backup_code: "백업 코드"
};
var $f2d7ad397b5ec807$export$2e2bcd8739ae039 = Object.freeze($f2d7ad397b5ec807$var$input);


const $709372a03cd6d657$var$list = {
    or: "또는",
    and: "및",
    separator: ","
};
var $709372a03cd6d657$export$2e2bcd8739ae039 = Object.freeze($709372a03cd6d657$var$list);


const $504da83bd0260eab$var$mfa = {
    totp: "인증 앱 OTP",
    webauthn: "패스키",
    backup_code: "백업 코드",
    link_totp_description: "예: Google Authenticator 등",
    link_webauthn_description: "기기 또는 USB 하드웨어 연결",
    link_backup_code_description: "백업 코드 생성",
    verify_totp_description: "앱에 일회용 코드 입력",
    verify_webauthn_description: "기기 또는 USB 하드웨어 확인",
    verify_backup_code_description: "저장한 백업 코드 붙여넣기",
    add_mfa_factors: "2단계 인증 추가",
    add_mfa_description: "2단계 인증이 활성화되었습니다. 안전한 로그인을 위해 두 번째 인증 방법을 선택하세요.",
    verify_mfa_factors: "2단계 인증 확인",
    verify_mfa_description: "이 계정에 대해 2단계 인증이 활성화되었습니다. 신원을 확인하는 두 번째 방법을 선택하세요.",
    add_authenticator_app: "인증 앱 추가",
    step: "단계 {{step, number}}: {{content}}",
    scan_qr_code: "이 QR 코드 스캔",
    scan_qr_code_description: "Google Authenticator, Duo Mobile, Authy 등의 인증 앱으로 다음 QR 코드를 스캔하세요.",
    qr_code_not_available: "QR 코드를 스캔할 수 없나요?",
    copy_and_paste_key: "키 복사 및 붙여넣기",
    copy_and_paste_key_description: "다음 키를 Google Authenticator, Duo Mobile, Authy 등의 인증 앱에 복사하여 붙여넣으세요.",
    want_to_scan_qr_code: "QR 코드를 스캔하고 싶나요?",
    enter_one_time_code: "일회용 코드 입력",
    enter_one_time_code_link_description: "인증 앱에서 생성된 6자리 확인 코드를 입력하세요.",
    enter_one_time_code_description: "이 계정에서는 2단계 인증이 활성화되었습니다. 연결된 인증 앱에 표시된 일회용 코드를 입력하세요.",
    link_another_mfa_factor: "다른 방법으로 전환",
    save_backup_code: "백업 코드 저장",
    save_backup_code_description: "다른 방법으로 2단계 인증 중 문제가 발생하면 이러한 백업 코드 중 하나를 사용하여 계정에 액세스할 수 있습니다. 각 코드는 한 번만 사용할 수 있습니다.",
    backup_code_hint: "반드시 복사하고 안전한 곳에 저장하세요.",
    enter_a_backup_code: "백업 코드 입력",
    enter_backup_code_description: "2단계 인증이 초기에 활성화될 때 저장한 백업 코드를 입력하세요.",
    create_a_passkey: "패스키 생성",
    create_passkey_description: "기기 바이오메트릭스, 보안 키(예: YubiKey) 또는 기타 사용 가능한 방법을 사용하여 패스키를 등록하세요.",
    try_another_verification_method: "다른 방법으로 확인해보세요",
    verify_via_passkey: "패스키로 확인",
    verify_via_passkey_description: "디바이스 비밀번호 또는 바이오메트릭스, QR 코드 스캔 또는 YubiKey와 같은 USB 보안 키 사용하여 패스키로 확인하세요.",
    secret_key_copied: "비밀 키가 복사되었습니다.",
    backup_code_copied: "백업 코드가 복사되었습니다.",
    webauthn_not_ready: "WebAuthn이 아직 준비되지 않았습니다. 나중에 다시 시도하세요.",
    webauthn_not_supported: "이 브라우저에서는 WebAuthn이 지원되지 않습니다.",
    webauthn_failed_to_create: "생성 실패. 다시 시도하세요.",
    webauthn_failed_to_verify: "확인 실패. 다시 시도하세요."
};
var $504da83bd0260eab$export$2e2bcd8739ae039 = Object.freeze($504da83bd0260eab$var$mfa);


const $745c109c80a48b8c$var$secondary = {
    social_bind_with: "이미 계정이 있으신가요? {{methods, list(type: disjunction;)}}로 로그인 해보세요!"
};
var $745c109c80a48b8c$export$2e2bcd8739ae039 = Object.freeze($745c109c80a48b8c$var$secondary);


const $3036f0a468a41c01$var$user_scopes = {
    descriptions: {
        /** UNTRANSLATED */ custom_data: "Your custom data",
        /** UNTRANSLATED */ email: "Your email address",
        /** UNTRANSLATED */ phone: "Your phone number",
        /** UNTRANSLATED */ profile: "Your name, username, avatar, and other profile info",
        /** UNTRANSLATED */ roles: "Your roles",
        /** UNTRANSLATED */ identities: "Your linked social identities",
        /** UNTRANSLATED */ "urn:logto:scope:organizations": "Your organizations info",
        /** UNTRANSLATED */ "urn:logto:scope:organization_roles": "Your organization roles",
        /** UNTRANSLATED */ address: "Your address"
    }
};
var $3036f0a468a41c01$export$2e2bcd8739ae039 = Object.freeze($3036f0a468a41c01$var$user_scopes);


const $bc760d237821fbb7$var$ko = {
    translation: {
        input: $f2d7ad397b5ec807$export$2e2bcd8739ae039,
        secondary: $745c109c80a48b8c$export$2e2bcd8739ae039,
        action: $c725276831682d93$export$2e2bcd8739ae039,
        description: $06b2bd4878b802da$export$2e2bcd8739ae039,
        error: $e63c75c527421777$export$2e2bcd8739ae039,
        list: $709372a03cd6d657$export$2e2bcd8739ae039,
        mfa: $504da83bd0260eab$export$2e2bcd8739ae039,
        development_tenant: $47f6dc84010f612a$export$2e2bcd8739ae039,
        user_scopes: $3036f0a468a41c01$export$2e2bcd8739ae039
    }
};
var $bc760d237821fbb7$export$2e2bcd8739ae039 = Object.freeze($bc760d237821fbb7$var$ko);


const $ca784389a0bcee7a$var$action = {
    sign_in: "Zaloguj się",
    continue: "Kontynuuj",
    create_account: "Utw\xf3rz konto",
    create_account_without_linking: "Utw\xf3rz konto bez łączenia",
    create: "Utw\xf3rz",
    enter_passcode: "Wprowadź kod weryfikacyjny",
    confirm: "Potwierdź",
    cancel: "Anuluj",
    save_password: "Zapisz hasło",
    bind: "Połącz z {{address}}",
    bind_and_continue: "Połącz i kontynuuj",
    back: "Wr\xf3ć",
    nav_back: "Wstecz",
    nav_skip: "Pomiń",
    agree: "Zgadzam się",
    got_it: "Zrozumiałem",
    sign_in_with: "Kontynuuj z {{name}}",
    forgot_password: "Zapomniałeś hasła?",
    switch_to: "Przełącz na {{method}}",
    sign_in_via_passcode: "Zaloguj się za pomocą kodu weryfikacyjnego",
    sign_in_via_password: "Zaloguj się za pomocą hasła",
    change: "Zmień {{method}}",
    link_another_email: "Połącz inne konto email",
    link_another_phone: "Połącz inne konto telefoniczne",
    link_another_email_or_phone: "Połącz inne konto email lub telefoniczne",
    show_password: "Pokaż hasło",
    copy: "Kopiuj",
    verify_via_passkey: "Weryfikacja za pomocą klucza dostępu",
    download: "Pobierz",
    single_sign_on: "Pojedyncze logowanie",
    /** UNTRANSLATED */ authorize: "Authorize",
    /** UNTRANSLATED */ use_another_account: "Use another account"
};
var $ca784389a0bcee7a$export$2e2bcd8739ae039 = Object.freeze($ca784389a0bcee7a$var$action);


const $16e6e97c77ae917e$var$description = {
    email: "adres email",
    phone_number: "numer telefonu",
    username: "nazwa użytkownika",
    reminder: "Przypomnienie",
    not_found: "404 Nie znaleziono",
    agree_with_terms: "Przeczytałem/am i zgadzam się z ",
    agree_with_terms_modal: "Do kontynuacji należy zaakceptować <link></link>.",
    terms_of_use: "Warunki korzystania",
    sign_in: "Zaloguj się",
    privacy_policy: "Polityka prywatności",
    create_account: "Utw\xf3rz konto",
    or: "lub",
    and: "i",
    enter_passcode: "Kod weryfikacyjny został wysłany na twoje {{address}} {{target}}",
    passcode_sent: "Kod weryfikacyjny został wysłany ponownie",
    resend_after_seconds: "Wyślij ponownie po <span>{{seconds}}</span> sekundach",
    resend_passcode: "Wyślij kod weryfikacyjny ponownie",
    create_account_id_exists: "Konto z {{type}} {{value}} już istnieje. Czy chcesz się zalogować?",
    link_account_id_exists: "Konto z {{type}} {{value}} już istnieje. Czy chcesz je połączyć?",
    sign_in_id_does_not_exist: "Konto z {{type}} {{value}} nie istnieje. Czy chcesz utworzyć nowe konto?",
    sign_in_id_does_not_exist_alert: "Konto z {{type}} {{value}} nie istnieje.",
    create_account_id_exists_alert: "Konto z {{type}} {{value}} jest połączone z innym kontem. Spr\xf3buj inny {{type}}.",
    social_identity_exist: "{{type}} {{value}} jest połączony z innym kontem. Spr\xf3buj inny {{type}}.",
    bind_account_title: "Połącz lub utw\xf3rz konto",
    social_create_account: "Możesz utworzyć nowe konto.",
    social_link_email: "Możesz połączyć kolejny adres email",
    social_link_phone: "Możesz połączyć kolejny numer telefonu",
    social_link_email_or_phone: "Możesz połączyć kolejny adres email lub numer telefonu",
    social_bind_with_existing: "Znaleźliśmy powiązane konto, możesz je połączyć bezpośrednio.",
    reset_password: "Zresetuj hasło",
    reset_password_description: "Wpisz {{types, lista(type: złączonych;)}} związanego z twoim kontem, a wyślemy ci kod weryfikacyjny do zresetowania hasła.",
    new_password: "Nowe hasło",
    set_password: "Ustaw hasło",
    password_changed: "Hasło zmienione",
    no_account: "Nie masz jeszcze konta? ",
    have_account: "Masz już konto?",
    enter_password: "Wpisz hasło",
    enter_password_for: "Zaloguj się przy użyciu hasła do {{method}} {{value}}",
    enter_username: "Ustaw nazwę użytkownika",
    enter_username_description: "Nazwa użytkownika jest alternatywną formą logowania. Nazwa użytkownika powinna zawierać tylko litery, cyfry i podkreślenia.",
    link_email: "Połącz adres email",
    link_phone: "Połącz numer telefonu",
    link_email_or_phone: "Połącz adres email lub numer telefonu",
    link_email_description: "Dla zwiększenia bezpieczeństwa, proszę połączyć konto z adresem e-mail.",
    link_phone_description: "Dla zwiększenia bezpieczeństwa, proszę połączyć konto z numerem telefonu.",
    link_email_or_phone_description: "Dla zwiększenia bezpieczeństwa, proszę połączyć konto z adresem e-mail lub numerem telefonu.",
    continue_with_more_information: "Dla zwiększenia bezpieczeństwa, proszę uzupełnić poniższe informacje o koncie.",
    create_your_account: "Utw\xf3rz konto",
    sign_in_to_your_account: "Zaloguj się do swojego konta",
    no_region_code_found: "Nie znaleziono kodu regionu",
    verify_email: "Potwierdź sw\xf3j email",
    verify_phone: "Potwierdź sw\xf3j numer telefonu",
    password_requirements: "Wymagania dotyczące hasła {{items, list}}.",
    password_requirement: {
        length_one: "wymaga co najmniej {{count}} znaku",
        length_other: "wymaga co najmniej {{count}} znak\xf3w",
        character_types_one: "powinno zawierać co najmniej {{count}} rodzaj liter wielkich, małych liter, cyfr i symboli",
        character_types_other: "powinno zawierać co najmniej {{count}} rodzaje liter wielkich, małych liter, cyfr i symboli"
    },
    use: "Użyj",
    single_sign_on_email_form: "Wpisz sw\xf3j służbowy adres email",
    single_sign_on_connectors_list: "Twoja firma włączyła jednokrotne logowanie dla konta e-mail {{email}}. Możesz kontynuować logowanie za pomocą następujących dostawc\xf3w SSO.",
    single_sign_on_enabled: "To konto ma włączone jednokrotne logowanie.",
    /** UNTRANSLATED */ authorize_title: "Authorize {{name}}",
    /** UNTRANSLATED */ request_permission: "{{name}} is requesting access to:",
    /** UNTRANSLATED */ grant_organization_access: "Grant the organization access:",
    /** UNTRANSLATED */ user_scopes: "Personal user data",
    /** UNTRANSLATED */ organization_scopes: "Organization access",
    /** UNTRANSLATED */ authorize_agreement: `By authorize the access, you agree to the {{name}}'s <link></link>.`,
    /** UNTRANSLATED */ not_you: "Not you?",
    /** UNTRANSLATED */ user_id: "User ID: {{id}}",
    /** UNTRANSLATED */ redirect_to: "You will be redirected to {{name}}."
};
var $16e6e97c77ae917e$export$2e2bcd8739ae039 = Object.freeze($16e6e97c77ae917e$var$description);


const $98843c9164c60345$var$development_tenant = {
    notification: "Jesteś w trybie deweloperskim"
};
var $98843c9164c60345$export$2e2bcd8739ae039 = Object.freeze($98843c9164c60345$var$development_tenant);


const $ac0614037b254b07$var$password_rejected = {
    too_short: "Minimalna długość to {{min}}.",
    too_long: "Maksymalna długość to {{max}}.",
    character_types: "Wymagane są przynajmniej {{min}} rodzaje znak\xf3w.",
    unsupported_characters: "Znaleziono niedozwolony znak.",
    pwned: "Unikaj używania prostych haseł, kt\xf3re są łatwe do odgadnięcia.",
    restricted_found: "Unikaj nadużywania {{list, list}}.",
    restricted: {
        repetition: "powtarzających się znak\xf3w",
        sequence: "sekwencyjnych znak\xf3w",
        user_info: "twoich informacji osobistych",
        words: "kontekstu produktu"
    }
};
var $ac0614037b254b07$export$2e2bcd8739ae039 = Object.freeze($ac0614037b254b07$var$password_rejected);


const $bcd5aa52dcc9fc36$var$error = {
    general_required: `{{types, list(type: disjunction;)}} jest wymagany`,
    general_invalid: `{{types, list(type: disjunction;)}} jest nieprawidłowe`,
    username_required: "Nazwa użytkownika jest wymagana",
    password_required: "Hasło jest wymagane",
    username_exists: "Nazwa użytkownika już istnieje",
    username_should_not_start_with_number: "Nazwa użytkownika nie powinna zaczynać się od liczby",
    username_invalid_charset: "Nazwa użytkownika powinna zawierać tylko litery, liczby lub podkreślenia.",
    invalid_email: "Nieprawidłowy adres e-mail",
    invalid_phone: "Nieprawidłowy numer telefonu",
    passwords_do_not_match: "Hasła nie pasują do siebie. Proszę spr\xf3buj ponownie.",
    invalid_passcode: "Nieprawidłowy kod weryfikacyjny",
    invalid_connector_auth: "Nieprawidłowa autoryzacja",
    invalid_connector_request: "Nieprawidłowe dane konektora",
    unknown: "Nieznany błąd. Proszę spr\xf3buj ponownie p\xf3źniej.",
    invalid_session: "Sesja nie znaleziona. Proszę wr\xf3ć i zaloguj się ponownie.",
    timeout: "Czas żądania upłynął. Proszę spr\xf3buj ponownie p\xf3źniej.",
    password_rejected: $ac0614037b254b07$export$2e2bcd8739ae039,
    sso_not_enabled: "Pojedyncze logowanie nie jest włączony dla tego konta e-mail."
};
var $bcd5aa52dcc9fc36$export$2e2bcd8739ae039 = Object.freeze($bcd5aa52dcc9fc36$var$error);


const $54aa254b5997a78e$var$input = {
    username: "Nazwa użytkownika",
    password: "Hasło",
    email: "E-mail",
    phone_number: "Numer telefonu",
    confirm_password: "Potwierdź hasło",
    search_region_code: "Kod regionu wyszukiwania",
    backup_code: "Kod kopii zapasowej"
};
var $54aa254b5997a78e$export$2e2bcd8739ae039 = Object.freeze($54aa254b5997a78e$var$input);


const $8de03796db4836e9$var$list = {
    or: "lub",
    and: "i",
    separator: ","
};
var $8de03796db4836e9$export$2e2bcd8739ae039 = Object.freeze($8de03796db4836e9$var$list);


const $a3f811481079d142$var$mfa = {
    totp: "OTP aplikacji autentykacyjnej",
    webauthn: "Klucz gł\xf3wny",
    backup_code: "Kod zapasowy",
    link_totp_description: "Np. Google Authenticator itp.",
    link_webauthn_description: "Połącz urządzenie lub sprzęt USB",
    link_backup_code_description: "Generuj kod zapasowy",
    verify_totp_description: "Wprowadź jednorazowy kod w aplikacji",
    verify_webauthn_description: "Zweryfikuj urządzenie lub sprzęt USB",
    verify_backup_code_description: "Wklej kod zapasowy, kt\xf3ry zapisałeś",
    add_mfa_factors: "Dodaj weryfikację dwuetapową",
    add_mfa_description: "Weryfikacja dwuetapowa jest włączona. Wybierz sw\xf3j drugi spos\xf3b weryfikacji dla bezpiecznego logowania.",
    verify_mfa_factors: "Weryfikacja dwuetapowa",
    verify_mfa_description: "Włączono weryfikację dwuetapową dla tego konta. Proszę wybrać drugi spos\xf3b weryfikacji swojej tożsamości.",
    add_authenticator_app: "Dodaj aplikację autentykacyjną",
    step: "Krok {{step, number}}: {{content}}",
    scan_qr_code: "Zeskanuj ten kod QR",
    scan_qr_code_description: "Zeskanuj poniższy kod QR za pomocą aplikacji autentykacyjnej, takiej jak Google Authenticator, Duo Mobile, Authy, itp.",
    qr_code_not_available: "Nie można zeskanować kodu QR?",
    copy_and_paste_key: "Skopiuj i wklej klucz",
    copy_and_paste_key_description: "Skopiuj i wklej poniższy klucz do aplikacji autentykacyjnej, takiej jak Google Authenticator, Duo Mobile, Authy, itp.",
    want_to_scan_qr_code: "Chcesz zeskanować kod QR?",
    enter_one_time_code: "Wprowadź jednorazowy kod",
    enter_one_time_code_link_description: "Wprowadź 6-cyfrowy kod weryfikacyjny wygenerowany przez aplikację autentykacyjną.",
    enter_one_time_code_description: "Dla tego konta włączono weryfikację dwuetapową. Proszę wprowadzić jednorazowy kod widoczny w aplikacji autentykacyjnej powiązanej z kontem.",
    link_another_mfa_factor: "Przełącz na inny spos\xf3b",
    save_backup_code: "Zapisz sw\xf3j kod zapasowy",
    save_backup_code_description: "Możesz użyć jednego z tych kod\xf3w zapasowych, aby uzyskać dostęp do swojego konta w przypadku problem\xf3w z weryfikacją dwuetapową w inny spos\xf3b. Każdy kod można użyć tylko raz.",
    backup_code_hint: "Upewnij się, że je skopiujesz i zapiszesz w bezpiecznym miejscu.",
    enter_a_backup_code: "Wprowadź kod zapasowy",
    enter_backup_code_description: "Wprowadź kod zapasowy, kt\xf3ry zapisałeś, gdy włączono weryfikację dwuetapową.",
    create_a_passkey: "Utw\xf3rz klucz dostępu",
    create_passkey_description: "Zarejestruj sw\xf3j klucz dostępu za pomocą biometrii urządzenia, kluczy bezpieczeństwa (np. YubiKey) lub innych dostępnych metod.",
    try_another_verification_method: "Wypr\xf3buj inny spos\xf3b weryfikacji",
    verify_via_passkey: "Zweryfikuj za pomocą klucza dostępu",
    verify_via_passkey_description: "Użyj klucza dostępu do weryfikacji za pomocą hasła urządzenia lub biometrii, skanowania kodu QR lub użycia klucza bezpieczeństwa USB, takiego jak YubiKey.",
    secret_key_copied: "Skopiowano klucz prywatny.",
    backup_code_copied: "Skopiowano kod zapasowy.",
    webauthn_not_ready: "WebAuthn nie jest jeszcze gotowy. Spr\xf3buj ponownie p\xf3źniej.",
    webauthn_not_supported: "WebAuthn nie jest obsługiwane w tej przeglądarce.",
    webauthn_failed_to_create: "Nie udało się utworzyć. Spr\xf3buj ponownie.",
    webauthn_failed_to_verify: "Nie udało się zweryfikować. Spr\xf3buj ponownie."
};
var $a3f811481079d142$export$2e2bcd8739ae039 = Object.freeze($a3f811481079d142$var$mfa);


const $2d077d4535cc4610$var$secondary = {
    social_bind_with: "Masz już konto? Zaloguj się, aby połączyć {{methods, list(type: disjunction;)}} z twoją tożsamością społeczną."
};
var $2d077d4535cc4610$export$2e2bcd8739ae039 = Object.freeze($2d077d4535cc4610$var$secondary);


const $c9dec8f1b35ec88f$var$user_scopes = {
    descriptions: {
        /** UNTRANSLATED */ custom_data: "Your custom data",
        /** UNTRANSLATED */ email: "Your email address",
        /** UNTRANSLATED */ phone: "Your phone number",
        /** UNTRANSLATED */ profile: "Your name, username, avatar, and other profile info",
        /** UNTRANSLATED */ roles: "Your roles",
        /** UNTRANSLATED */ identities: "Your linked social identities",
        /** UNTRANSLATED */ "urn:logto:scope:organizations": "Your organizations info",
        /** UNTRANSLATED */ "urn:logto:scope:organization_roles": "Your organization roles",
        /** UNTRANSLATED */ address: "Your address"
    }
};
var $c9dec8f1b35ec88f$export$2e2bcd8739ae039 = Object.freeze($c9dec8f1b35ec88f$var$user_scopes);


const $0f974191227b33f7$var$pl_pl = {
    translation: {
        input: $54aa254b5997a78e$export$2e2bcd8739ae039,
        secondary: $2d077d4535cc4610$export$2e2bcd8739ae039,
        action: $ca784389a0bcee7a$export$2e2bcd8739ae039,
        description: $16e6e97c77ae917e$export$2e2bcd8739ae039,
        error: $bcd5aa52dcc9fc36$export$2e2bcd8739ae039,
        list: $8de03796db4836e9$export$2e2bcd8739ae039,
        mfa: $a3f811481079d142$export$2e2bcd8739ae039,
        development_tenant: $98843c9164c60345$export$2e2bcd8739ae039,
        user_scopes: $c9dec8f1b35ec88f$export$2e2bcd8739ae039
    }
};
var $0f974191227b33f7$export$2e2bcd8739ae039 = Object.freeze($0f974191227b33f7$var$pl_pl);


const $3ba3931a225d721d$var$action = {
    sign_in: "Entrar",
    continue: "Continuar",
    create_account: "Criar conta",
    create_account_without_linking: "Criar conta sem vincular",
    create: "Criar",
    enter_passcode: "Inserir c\xf3digo de verifica\xe7\xe3o",
    confirm: "Confirmar",
    cancel: "Cancelar",
    save_password: "Salvar senha",
    bind: "Link com {{address}}",
    bind_and_continue: "Linkar e continuar",
    back: "Voltar",
    nav_back: "Voltar",
    nav_skip: "Pular",
    agree: "Aceito",
    got_it: "Entendido",
    sign_in_with: "Continuar com {{name}}",
    forgot_password: "Esqueceu sua senha?",
    switch_to: "Trocar para {{method}}",
    sign_in_via_passcode: "Fazer login com c\xf3digo de verifica\xe7\xe3o",
    sign_in_via_password: "Fazer login com senha",
    change: "Alterar {{method}}",
    link_another_email: "Vincular outro e-mail",
    link_another_phone: "Vincular outro telefone",
    link_another_email_or_phone: "Vincular outro e-mail ou telefone",
    show_password: "Mostrar senha",
    copy: "Copiar",
    verify_via_passkey: "Verificar via chave de acesso",
    download: "Baixar",
    single_sign_on: "Single Sign-On",
    /** UNTRANSLATED */ authorize: "Authorize",
    /** UNTRANSLATED */ use_another_account: "Use another account"
};
var $3ba3931a225d721d$export$2e2bcd8739ae039 = Object.freeze($3ba3931a225d721d$var$action);


const $a83f03cf1688df9e$var$description = {
    email: "e-mail",
    phone_number: "n\xfamero de telefone",
    username: "nome de usu\xe1rio",
    reminder: "Lembrete",
    not_found: "404 N\xe3o Encontrado",
    agree_with_terms: "Eu li e concordo com os ",
    agree_with_terms_modal: "Para continuar, por favor, concorde com os <link></link>.",
    terms_of_use: "Termos de uso",
    sign_in: "Entrar",
    privacy_policy: "Pol\xedtica de privacidade",
    create_account: "Criar conta",
    or: "ou",
    and: "e",
    enter_passcode: "O c\xf3digo de verifica\xe7\xe3o foi enviado para o seu {{address}} {{target}}",
    passcode_sent: "O c\xf3digo de verifica\xe7\xe3o foi reenviado",
    resend_after_seconds: "Reenviar depois <span>{{seconds}}</span> segundos",
    resend_passcode: "Reenviar c\xf3digo de verifica\xe7\xe3o",
    create_account_id_exists: "A conta com {{type}} {{value}} j\xe1 existe, gostaria de entrar?",
    link_account_id_exists: "A conta com {{type}} {{value}} j\xe1 existe, gostaria de vincular?",
    sign_in_id_does_not_exist: "A conta com {{type}} {{value}} n\xe3o existe, gostaria de criar uma nova conta?",
    sign_in_id_does_not_exist_alert: "A conta com {{type}} {{value}} n\xe3o existe.",
    create_account_id_exists_alert: "A conta com {{type}} {{value}} est\xe1 vinculada a outra conta. Por favor, tente outro {{type}}.",
    social_identity_exist: "O {{type}} {{value}} est\xe1 vinculado a outra conta. Por favor, tente outro {{type}}.",
    bind_account_title: "Vincular ou criar conta",
    social_create_account: "Voc\xea pode criar uma nova conta.",
    social_link_email: "\xc9 poss\xedvel vincular outro e-mail",
    social_link_phone: "\xc9 poss\xedvel vincular outro telefone",
    social_link_email_or_phone: "\xc9 poss\xedvel vincular outro e-mail ou telefone",
    social_bind_with_existing: "Encontramos uma conta relacionada registrada e voc\xea pode vincul\xe1-la diretamente.",
    reset_password: "Esqueceu a senha",
    reset_password_description: "Digite o {{types, list(type: disjunction;)}} \xe0 sua conta e enviaremos a voc\xea o c\xf3digo de verifica\xe7\xe3o para redefinir sua senha.",
    new_password: "Nova senha",
    set_password: "Configurar senha",
    password_changed: "Senha alterada",
    no_account: "Ainda n\xe3o tem conta? ",
    have_account: "J\xe1 tinha uma conta?",
    enter_password: "Digite a senha",
    enter_password_for: "Entre com a senha para {{method}} {{value}}",
    enter_username: "Definir nome de usu\xe1rio",
    enter_username_description: "O nome de usu\xe1rio \xe9 uma alternativa para fazer login. O nome de usu\xe1rio deve conter apenas letras, n\xfameros e sublinhados.",
    link_email: "Linkar e-mail",
    link_phone: "Linkar telefone",
    link_email_or_phone: "Linkar e-mail ou telefone",
    link_email_description: "Para maior seguran\xe7a, vincule seu e-mail \xe0 conta.",
    link_phone_description: "Para maior seguran\xe7a, vincule seu telefone \xe0 conta.",
    link_email_or_phone_description: "Para maior seguran\xe7a, vincule seu e-mail ou telefone \xe0 conta.",
    continue_with_more_information: "Para maior seguran\xe7a, preencha os detalhes da conta abaixo.",
    create_your_account: "Crie sua conta",
    sign_in_to_your_account: "Fa\xe7a login na sua conta",
    no_region_code_found: "N\xe3o foi poss\xedvel encontrar o c\xf3digo de regi\xe3o do seu telefone.",
    verify_email: "Verificar e-mail",
    verify_phone: "Verificar n\xfamero de telefone",
    password_requirements: "Senha {{items, list}}.",
    password_requirement: {
        length_one: "requer no m\xednimo 1 caractere.",
        length_other: "requer no m\xednimo {{count}} caracteres.",
        character_types_one: "deve conter pelo menos 1 tipo de letra mai\xfascula, letra min\xfascula, d\xedgito e s\xedmbolo.",
        character_types_other: "deve conter pelo menos {{count}} tipos de letra mai\xfascula, letra min\xfascula, d\xedgito e s\xedmbolo."
    },
    use: "Usar",
    single_sign_on_email_form: "Insira o endere\xe7o de e-mail corporativo",
    single_sign_on_connectors_list: "Sua empresa ativou o Single Sign-On para a conta de email {{email}}. Voc\xea pode continuar a fazer login com os seguintes provedores de SSO.",
    single_sign_on_enabled: "Esta conta tem Single Sign-On ativado.",
    /** UNTRANSLATED */ authorize_title: "Authorize {{name}}",
    /** UNTRANSLATED */ request_permission: "{{name}} is requesting access to:",
    /** UNTRANSLATED */ grant_organization_access: "Grant the organization access:",
    /** UNTRANSLATED */ user_scopes: "Personal user data",
    /** UNTRANSLATED */ organization_scopes: "Organization access",
    /** UNTRANSLATED */ authorize_agreement: `By authorize the access, you agree to the {{name}}'s <link></link>.`,
    /** UNTRANSLATED */ not_you: "Not you?",
    /** UNTRANSLATED */ user_id: "User ID: {{id}}",
    /** UNTRANSLATED */ redirect_to: "You will be redirected to {{name}}."
};
var $a83f03cf1688df9e$export$2e2bcd8739ae039 = Object.freeze($a83f03cf1688df9e$var$description);


const $926b4e314c23fb54$var$development_tenant = {
    notification: "Voc\xea est\xe1 no modo de desenvolvimento"
};
var $926b4e314c23fb54$export$2e2bcd8739ae039 = Object.freeze($926b4e314c23fb54$var$development_tenant);


const $42d67a5cdf2a9a95$var$password_rejected = {
    too_short: "O comprimento m\xednimo \xe9 {{min}}.",
    too_long: "O comprimento m\xe1ximo \xe9 {{max}}.",
    character_types: "Pelo menos {{min}} tipos de caracteres s\xe3o necess\xe1rios.",
    unsupported_characters: "Caractere n\xe3o suportado encontrado.",
    pwned: "Evite o uso de senhas simples que s\xe3o f\xe1ceis de adivinhar.",
    restricted_found: "Evite usar em excesso {{list, list}}.",
    restricted: {
        repetition: "caracteres repetidos",
        sequence: "caracteres sequenciais",
        user_info: "suas informa\xe7\xf5es pessoais",
        words: "contexto do produto"
    }
};
var $42d67a5cdf2a9a95$export$2e2bcd8739ae039 = Object.freeze($42d67a5cdf2a9a95$var$password_rejected);


const $38865a16c6def14e$var$error = {
    general_required: "{{types, list(type: disjunction;)}} \xe9 obrigat\xf3rio",
    general_invalid: "O {{types, list(type: disjunction;)}} \xe9 inv\xe1lido",
    username_required: "Nome de usu\xe1rio \xe9 obrigat\xf3rio",
    password_required: "Senha \xe9 obrigat\xf3rio",
    username_exists: "O nome de usu\xe1rio j\xe1 existe",
    username_should_not_start_with_number: "O nome de usu\xe1rio n\xe3o deve come\xe7ar com um n\xfamero",
    username_invalid_charset: "O nome de usu\xe1rio deve conter apenas letras, n\xfameros ou sublinhados.",
    invalid_email: "O e-mail \xe9 inv\xe1lido",
    invalid_phone: "O n\xfamero de telefone \xe9 inv\xe1lido",
    passwords_do_not_match: "Suas senhas n\xe3o correspondem. Por favor, tente novamente.",
    invalid_passcode: "O c\xf3digo de verifica\xe7\xe3o \xe9 inv\xe1lido",
    invalid_connector_auth: "A autoriza\xe7\xe3o \xe9 inv\xe1lida",
    invalid_connector_request: "Os dados do conector s\xe3o inv\xe1lidos",
    unknown: "Erro desconhecido. Por favor, tente novamente mais tarde.",
    invalid_session: "Sess\xe3o n\xe3o encontrada. Volte e fa\xe7a login novamente.",
    timeout: "Tempo limite excedido. Por favor, tente novamente mais tarde.",
    password_rejected: $42d67a5cdf2a9a95$export$2e2bcd8739ae039,
    sso_not_enabled: "O Single Sign-On n\xe3o est\xe1 habilitado para esta conta de e-mail."
};
var $38865a16c6def14e$export$2e2bcd8739ae039 = Object.freeze($38865a16c6def14e$var$error);


const $15122b8ba3ca09ae$var$input = {
    username: "Nome de usu\xe1rio",
    password: "Senha",
    email: "E-mail",
    phone_number: "N\xfamero de telefone",
    confirm_password: "Confirme a senha",
    search_region_code: "Pesquisar c\xf3digo de regi\xe3o",
    backup_code: "C\xf3digo de backup"
};
var $15122b8ba3ca09ae$export$2e2bcd8739ae039 = Object.freeze($15122b8ba3ca09ae$var$input);


const $9219182f5a3452a7$var$list = {
    or: "ou",
    and: "e",
    separator: ","
};
var $9219182f5a3452a7$export$2e2bcd8739ae039 = Object.freeze($9219182f5a3452a7$var$list);


const $aca9cad5678d181f$var$mfa = {
    totp: "Senha \xfanica do aplicativo autenticador",
    webauthn: "Senha de dispositivo",
    backup_code: "C\xf3digo de backup",
    link_totp_description: "Por exemplo, Google Authenticator, etc.",
    link_webauthn_description: "Vincule seu dispositivo ou hardware USB",
    link_backup_code_description: "Gere um c\xf3digo de backup",
    verify_totp_description: "Digite o c\xf3digo \xfanico no aplicativo",
    verify_webauthn_description: "Verifique seu dispositivo ou hardware USB",
    verify_backup_code_description: "Cole o c\xf3digo de backup que voc\xea salvou",
    add_mfa_factors: "Adicionar verifica\xe7\xe3o em duas etapas",
    add_mfa_description: "A verifica\xe7\xe3o em duas etapas est\xe1 ativada. Selecione seu segundo m\xe9todo de verifica\xe7\xe3o para login seguro.",
    verify_mfa_factors: "Verifica\xe7\xe3o em duas etapas",
    verify_mfa_description: "A verifica\xe7\xe3o em duas etapas foi ativada para esta conta. Por favor, selecione a segunda forma de verificar sua identidade.",
    add_authenticator_app: "Adicionar aplicativo autenticador",
    step: "Passo {{step, number}}: {{content}}",
    scan_qr_code: "Escanear este c\xf3digo QR",
    scan_qr_code_description: "Escanee o seguinte c\xf3digo QR com seu aplicativo autenticador, como Google Authenticator, Duo Mobile, Authy, etc.",
    qr_code_not_available: "N\xe3o consegue escanear o c\xf3digo QR?",
    copy_and_paste_key: "Copiar e colar a chave",
    copy_and_paste_key_description: "Copie e cole a seguinte chave no seu aplicativo autenticador, como Google Authenticator, Duo Mobile, Authy, etc.",
    want_to_scan_qr_code: "Quer escanear o c\xf3digo QR?",
    enter_one_time_code: "Digite o c\xf3digo \xfanico",
    enter_one_time_code_link_description: "Digite o c\xf3digo de verifica\xe7\xe3o de 6 d\xedgitos gerado pelo aplicativo autenticador.",
    enter_one_time_code_description: "A verifica\xe7\xe3o em duas etapas foi habilitada para esta conta. Por favor, insira o c\xf3digo de uso \xfanico mostrado no seu aplicativo autenticador vinculado.",
    link_another_mfa_factor: "Trocar para outro m\xe9todo",
    save_backup_code: "Salve seu c\xf3digo de backup",
    save_backup_code_description: "Voc\xea pode usar um desses c\xf3digos de backup para acessar sua conta se tiver problemas durante a verifica\xe7\xe3o em duas etapas de outras maneiras. Cada c\xf3digo pode ser usado apenas uma vez.",
    backup_code_hint: "Certifique-se de copi\xe1-los e salvar em um local seguro.",
    enter_a_backup_code: "Digite um c\xf3digo de backup",
    enter_backup_code_description: "Digite o c\xf3digo de backup que voc\xea salvou quando a verifica\xe7\xe3o em duas etapas foi ativada inicialmente.",
    create_a_passkey: "Criar uma senha",
    create_passkey_description: "Registre sua senha usando biometria do dispositivo, chaves de seguran\xe7a (por exemplo, YubiKey) ou outros m\xe9todos dispon\xedveis.",
    try_another_verification_method: "Experimente outro m\xe9todo de verifica\xe7\xe3o",
    verify_via_passkey: "Verificar via senha",
    verify_via_passkey_description: "Use a senha para verificar por meio da senha do seu dispositivo ou biometria, escaneando o c\xf3digo QR ou usando uma chave de seguran\xe7a USB como a YubiKey.",
    secret_key_copied: "Chave secreta copiada.",
    backup_code_copied: "C\xf3digo de backup copiado.",
    webauthn_not_ready: "WebAuthn ainda n\xe3o est\xe1 pronto. Por favor, tente novamente mais tarde.",
    webauthn_not_supported: "WebAuthn n\xe3o \xe9 suportado neste navegador.",
    webauthn_failed_to_create: "Falha ao criar. Por favor, tente novamente.",
    webauthn_failed_to_verify: "Falha ao verificar. Por favor, tente novamente."
};
var $aca9cad5678d181f$export$2e2bcd8739ae039 = Object.freeze($aca9cad5678d181f$var$mfa);


const $0d9d98f268b03024$var$secondary = {
    social_bind_with: "J\xe1 tinha uma conta? Fa\xe7a login no link {{methods, list(type: disjunction;)}} com sua identidade social."
};
var $0d9d98f268b03024$export$2e2bcd8739ae039 = Object.freeze($0d9d98f268b03024$var$secondary);


const $5fa269e0036cf4b8$var$user_scopes = {
    descriptions: {
        /** UNTRANSLATED */ custom_data: "Your custom data",
        /** UNTRANSLATED */ email: "Your email address",
        /** UNTRANSLATED */ phone: "Your phone number",
        /** UNTRANSLATED */ profile: "Your name, username, avatar, and other profile info",
        /** UNTRANSLATED */ roles: "Your roles",
        /** UNTRANSLATED */ identities: "Your linked social identities",
        /** UNTRANSLATED */ "urn:logto:scope:organizations": "Your organizations info",
        /** UNTRANSLATED */ "urn:logto:scope:organization_roles": "Your organization roles",
        /** UNTRANSLATED */ address: "Your address"
    }
};
var $5fa269e0036cf4b8$export$2e2bcd8739ae039 = Object.freeze($5fa269e0036cf4b8$var$user_scopes);


const $f4a53d345243d0b8$var$pt_br = {
    translation: {
        input: $15122b8ba3ca09ae$export$2e2bcd8739ae039,
        secondary: $0d9d98f268b03024$export$2e2bcd8739ae039,
        action: $3ba3931a225d721d$export$2e2bcd8739ae039,
        description: $a83f03cf1688df9e$export$2e2bcd8739ae039,
        error: $38865a16c6def14e$export$2e2bcd8739ae039,
        list: $9219182f5a3452a7$export$2e2bcd8739ae039,
        mfa: $aca9cad5678d181f$export$2e2bcd8739ae039,
        development_tenant: $926b4e314c23fb54$export$2e2bcd8739ae039,
        user_scopes: $5fa269e0036cf4b8$export$2e2bcd8739ae039
    }
};
var $f4a53d345243d0b8$export$2e2bcd8739ae039 = Object.freeze($f4a53d345243d0b8$var$pt_br);


const $8f39ea4782a61d0e$var$action = {
    sign_in: "Entrar",
    continue: "Continuar",
    create_account: "Criar uma conta",
    create_account_without_linking: "Criar conta sem vincula\xe7\xe3o",
    create: "Criar",
    enter_passcode: "Introduzir c\xf3digo de verifica\xe7\xe3o",
    confirm: "Confirmar",
    cancel: "Cancelar",
    save_password: "Guardar palavra-passe",
    bind: "Agregar a {{address}}",
    bind_and_continue: "Ligar e continuar",
    back: "Voltar",
    nav_back: "Anterior",
    nav_skip: "Saltar",
    agree: "Aceito",
    got_it: "Entendi",
    sign_in_with: "Continuar com {{name}}",
    forgot_password: "Esqueceu-se da palavra-passe?",
    switch_to: "Mudar para {{method}}",
    sign_in_via_passcode: "Iniciar sess\xe3o com c\xf3digo de verifica\xe7\xe3o",
    sign_in_via_password: "Iniciar sess\xe3o com palavra-passe",
    change: "Alterar {{method}}",
    link_another_email: "Vincular outro email",
    link_another_phone: "Vincular outro telefone",
    link_another_email_or_phone: "Vincular outro email ou telefone",
    show_password: "Mostrar palavra-passe",
    copy: "Copiar",
    verify_via_passkey: "Verificar atrav\xe9s de chave de acesso",
    download: "Transferir",
    single_sign_on: "Logon \xdanico",
    /** UNTRANSLATED */ authorize: "Authorize",
    /** UNTRANSLATED */ use_another_account: "Use another account"
};
var $8f39ea4782a61d0e$export$2e2bcd8739ae039 = Object.freeze($8f39ea4782a61d0e$var$action);


const $6e499882c0c0c1fd$var$description = {
    email: "email",
    phone_number: "telefone",
    username: "utilizador",
    reminder: "Lembrete",
    not_found: "404 N\xe3o encontrado",
    agree_with_terms: "Eu li e concordo com os ",
    agree_with_terms_modal: "Para prosseguir, por favor, concorde com o <link></link>.",
    terms_of_use: "Termos de uso",
    sign_in: "Entrar",
    privacy_policy: "Pol\xedtica de privacidade",
    create_account: "Criar uma conta",
    or: "ou",
    and: "e",
    enter_passcode: "O c\xf3digo de verifica\xe7\xe3o foi enviado para o seu {{address}} {{target}}",
    passcode_sent: "O c\xf3digo de verifica\xe7\xe3o foi reenviado",
    resend_after_seconds: "Reenviar ap\xf3s <span>{{seconds}}</span> segundos",
    resend_passcode: "Reenviar c\xf3digo de verifica\xe7\xe3o",
    create_account_id_exists: "A conta com {{type}} {{value}} j\xe1 existe, gostaria de fazer login?",
    link_account_id_exists: "A conta com {{type}} {{value}} j\xe1 existe, gostaria de vincul\xe1-la?",
    sign_in_id_does_not_exist: "A conta com {{type}} {{value}} n\xe3o existe, gostaria de criar uma?",
    sign_in_id_does_not_exist_alert: "A conta com {{type}} {{value}} n\xe3o existe.",
    create_account_id_exists_alert: "A conta com {{type}} {{value}} est\xe1 vinculada a outra conta. Por favor, tente outro {{type}}.",
    social_identity_exist: "O {{type}} {{value}} est\xe1 vinculado a outra conta. Por favor, tente outro {{type}}.",
    bind_account_title: "Vincular ou criar conta",
    social_create_account: "Pode criar uma nova conta.",
    social_link_email: "Pode vincular outro email",
    social_link_phone: "Pode vincular outro telefone",
    social_link_email_or_phone: "Pode vincular outro email ou telefone",
    social_bind_with_existing: "Encontramos uma conta relacionada registrada e voc\xea pode vincul\xe1-la diretamente.",
    reset_password: "Esqueceu a senha",
    reset_password_description: "Insira os {{types, list(type: disjunction;)}} associados \xe0 sua conta e enviaremos o c\xf3digo de verifica\xe7\xe3o para redefinir sua senha.",
    new_password: "Nova Senha",
    set_password: "Definir senha",
    password_changed: "Senha alterada",
    no_account: "Ainda n\xe3o tem conta?",
    have_account: "J\xe1 tem conta?",
    enter_password: "Digite a senha",
    enter_password_for: "Fa\xe7a login com a senha do {{method}} {{value}}",
    enter_username: "Definir nome de usu\xe1rio",
    enter_username_description: "O nome de usu\xe1rio \xe9 uma alternativa para o login. O nome de usu\xe1rio deve conter apenas letras, n\xfameros e sublinhados.",
    link_email: "Vincular email",
    link_phone: "Vincular telefone",
    link_email_or_phone: "Vincular email ou telefone",
    link_email_description: "Para maior seguran\xe7a, vincule o seu email \xe0 conta.",
    link_phone_description: "Para maior seguran\xe7a, vincule o seu telefone \xe0 conta.",
    link_email_or_phone_description: "Para maior seguran\xe7a, vincule o seu email ou telefone \xe0 conta.",
    continue_with_more_information: "Para maior seguran\xe7a, por favor complete os detalhes da conta abaixo.",
    create_your_account: "Crie a sua conta",
    sign_in_to_your_account: "Inicie sess\xe3o na sua conta",
    no_region_code_found: "N\xe3o foi poss\xedvel encontrar o c\xf3digo de regi\xe3o do seu telefone.",
    verify_email: "Verifique o seu email",
    verify_phone: "Verifique o seu n\xfamero de telefone",
    password_requirements: "Requisitos de senha {{items, list}}.",
    password_requirement: {
        length_one: "requer um m\xednimo de {{count}} caracter",
        length_other: "requer um m\xednimo de {{count}} caracteres",
        character_types_one: "deve conter pelo menos {{count}} tipo de letras mai\xfasculas, letras min\xfasculas, d\xedgitos e s\xedmbolos",
        character_types_other: "deve conter pelo menos {{count}} tipos de letras mai\xfasculas, letras min\xfasculas, d\xedgitos e s\xedmbolos"
    },
    use: "Usar",
    single_sign_on_email_form: "Insira o endere\xe7o de email corporativo",
    single_sign_on_connectors_list: "A sua empresa ativou o Single Sign-On para a conta de email {{email}}. Pode continuar a iniciar sess\xe3o com os seguintes fornecedores de SSO.",
    single_sign_on_enabled: "Esta conta tem o Single Sign-On ativado.",
    /** UNTRANSLATED */ authorize_title: "Authorize {{name}}",
    /** UNTRANSLATED */ request_permission: "{{name}} is requesting access to:",
    /** UNTRANSLATED */ grant_organization_access: "Grant the organization access:",
    /** UNTRANSLATED */ user_scopes: "Personal user data",
    /** UNTRANSLATED */ organization_scopes: "Organization access",
    /** UNTRANSLATED */ authorize_agreement: `By authorize the access, you agree to the {{name}}'s <link></link>.`,
    /** UNTRANSLATED */ not_you: "Not you?",
    /** UNTRANSLATED */ user_id: "User ID: {{id}}",
    /** UNTRANSLATED */ redirect_to: "You will be redirected to {{name}}."
};
var $6e499882c0c0c1fd$export$2e2bcd8739ae039 = Object.freeze($6e499882c0c0c1fd$var$description);


const $3a97e404f8dafa06$var$development_tenant = {
    notification: "Est\xe1s em modo de desenvolvimento"
};
var $3a97e404f8dafa06$export$2e2bcd8739ae039 = Object.freeze($3a97e404f8dafa06$var$development_tenant);


const $75f2ca9162d75168$var$password_rejected = {
    too_short: "M\xednimo de comprimento \xe9 {{min}}.",
    too_long: "M\xe1ximo de comprimento \xe9 {{max}}.",
    character_types: "S\xe3o necess\xe1rios pelo menos {{min}} tipos de caracteres.",
    unsupported_characters: "Caractere n\xe3o suportado encontrado.",
    pwned: "Evite o uso de senhas simples que s\xe3o f\xe1ceis de adivinhar.",
    restricted_found: "Evite o uso excessivo de {{list, list}}.",
    restricted: {
        repetition: "caracteres repetidos",
        sequence: "caracteres sequenciais",
        user_info: "suas informa\xe7\xf5es pessoais",
        words: "contexto do produto"
    }
};
var $75f2ca9162d75168$export$2e2bcd8739ae039 = Object.freeze($75f2ca9162d75168$var$password_rejected);


const $7ff82afd08152f97$var$error = {
    general_required: "{{types, list(type: disjunction;)}} is necess\xe1rio",
    general_invalid: "O {{types, list(type: disjunction;)}} \xe9 inv\xe1lido",
    username_required: "Utilizador necess\xe1rio",
    password_required: "Password necess\xe1ria",
    username_exists: "O nome de utilizador j\xe1 existe",
    username_should_not_start_with_number: "O nome de utilizador n\xe3o deve come\xe7ar com um n\xfamero",
    username_invalid_charset: "O nome de utilizador deve conter apenas letras, n\xfameros ou underscores.",
    invalid_email: "O email \xe9 inv\xe1lido",
    invalid_phone: "O n\xfamero de telefone \xe9 inv\xe1lido",
    passwords_do_not_match: "As passwords n\xe3o coincidem",
    invalid_passcode: "O c\xf3digo de verifica\xe7\xe3o \xe9 inv\xe1lido.",
    invalid_connector_auth: "A autoriza\xe7\xe3o \xe9 inv\xe1lida",
    invalid_connector_request: "Os dados do conector s\xe3o inv\xe1lidos",
    unknown: "Erro desconhecido. Por favor, tente novamente mais tarde.",
    invalid_session: "Sess\xe3o n\xe3o encontrada. Volte e fa\xe7a login novamente.",
    timeout: "Tempo limite de sess\xe3o. Volte e fa\xe7a login novamente.",
    password_rejected: $75f2ca9162d75168$export$2e2bcd8739ae039,
    sso_not_enabled: "O Single Sign-On n\xe3o est\xe1 habilitado para esta conta de e-mail."
};
var $7ff82afd08152f97$export$2e2bcd8739ae039 = Object.freeze($7ff82afd08152f97$var$error);


const $e6c8cc51c96c0005$var$input = {
    username: "Utilizador",
    password: "Palavra-passe",
    email: "Email",
    phone_number: "Telefone",
    confirm_password: "Confirmar palavra-passe",
    search_region_code: "Procurar c\xf3digo de regi\xe3o",
    backup_code: "C\xf3digo de backup"
};
var $e6c8cc51c96c0005$export$2e2bcd8739ae039 = Object.freeze($e6c8cc51c96c0005$var$input);


const $7fd45d9601d13176$var$list = {
    or: "ou",
    and: "e",
    separator: ","
};
var $7fd45d9601d13176$export$2e2bcd8739ae039 = Object.freeze($7fd45d9601d13176$var$list);


const $3237a6e016122c04$var$mfa = {
    totp: "Senha \xfanica do aplicativo autenticador",
    webauthn: "Senha de dispositivo",
    backup_code: "C\xf3digo de backup",
    link_totp_description: "Por exemplo, Google Authenticator, etc.",
    link_webauthn_description: "Vincule o seu dispositivo ou hardware USB",
    link_backup_code_description: "Gere um c\xf3digo de backup",
    verify_totp_description: "Introduza o c\xf3digo \xfanico na aplica\xe7\xe3o",
    verify_webauthn_description: "Verifique o seu dispositivo ou hardware USB",
    verify_backup_code_description: "Cole o c\xf3digo de backup que guardou",
    add_mfa_factors: "Adicionar verifica\xe7\xe3o em duas etapas",
    add_mfa_description: "A verifica\xe7\xe3o em duas etapas est\xe1 ativada. Selecione o seu segundo m\xe9todo de verifica\xe7\xe3o para iniciar sess\xe3o de forma segura.",
    verify_mfa_factors: "Verifica\xe7\xe3o em duas etapas",
    verify_mfa_description: "A verifica\xe7\xe3o em duas etapas foi ativada para esta conta. Por favor, selecione a segunda forma de verificar a sua identidade.",
    add_authenticator_app: "Adicionar aplicativo autenticador",
    step: "Passo {{step, number}}: {{content}}",
    scan_qr_code: "Digitalize este c\xf3digo QR",
    scan_qr_code_description: "Digitalize o c\xf3digo QR seguinte com a sua aplica\xe7\xe3o autenticadora, como o Google Authenticator, Duo Mobile, Authy, etc.",
    qr_code_not_available: "N\xe3o consegue digitalizar o c\xf3digo QR?",
    copy_and_paste_key: "Copiar e colar a chave",
    copy_and_paste_key_description: "Copie e cole a seguinte chave na sua aplica\xe7\xe3o autenticadora, como o Google Authenticator, Duo Mobile, Authy, etc.",
    want_to_scan_qr_code: "Quer digitalizar o c\xf3digo QR?",
    enter_one_time_code: "Introduza o c\xf3digo \xfanico",
    enter_one_time_code_link_description: "Introduza o c\xf3digo de verifica\xe7\xe3o de 6 d\xedgitos gerado pela aplica\xe7\xe3o autenticadora.",
    enter_one_time_code_description: "A verifica\xe7\xe3o em duas etapas foi ativada para esta conta. Por favor, insira o c\xf3digo de utiliza\xe7\xe3o \xfanica mostrado na sua aplica\xe7\xe3o autenticadora vinculada.",
    link_another_mfa_factor: "Mudar para outro m\xe9todo",
    save_backup_code: "Guarde o seu c\xf3digo de backup",
    save_backup_code_description: "Pode usar um destes c\xf3digos de backup para aceder \xe0 sua conta se tiver problemas durante a verifica\xe7\xe3o em duas etapas de outras formas. Cada c\xf3digo s\xf3 pode ser utilizado uma vez.",
    backup_code_hint: "Certifique-se de os copiar e guardar num local seguro.",
    enter_a_backup_code: "Introduza um c\xf3digo de backup",
    enter_backup_code_description: "Introduza o c\xf3digo de backup que guardou quando a verifica\xe7\xe3o em duas etapas foi ativada inicialmente.",
    create_a_passkey: "Criar uma palavra-passe",
    create_passkey_description: "Registe a sua palavra-passe utilizando a biometria do dispositivo, chaves de seguran\xe7a (por exemplo, YubiKey) ou outros m\xe9todos dispon\xedveis.",
    try_another_verification_method: "Experimente outro m\xe9todo de verifica\xe7\xe3o",
    verify_via_passkey: "Verificar atrav\xe9s da palavra-passe",
    verify_via_passkey_description: "Utilize a palavra-passe para verificar atrav\xe9s da senha do seu dispositivo ou biometria, digitalizando o c\xf3digo QR ou utilizando uma chave de seguran\xe7a USB como a YubiKey.",
    secret_key_copied: "Chave secreta copiada.",
    backup_code_copied: "C\xf3digo de backup copiado.",
    webauthn_not_ready: "O WebAuthn ainda n\xe3o est\xe1 pronto. Por favor, tente novamente mais tarde.",
    webauthn_not_supported: "O WebAuthn n\xe3o \xe9 suportado neste navegador.",
    webauthn_failed_to_create: "Falha ao criar. Por favor, tente novamente.",
    webauthn_failed_to_verify: "Falha ao verificar. Por favor, tente novamente."
};
var $3237a6e016122c04$export$2e2bcd8739ae039 = Object.freeze($3237a6e016122c04$var$mfa);


const $0bb7e680f174bc7a$var$secondary = {
    social_bind_with: "J\xe1 tem uma conta? Fa\xe7a login para agregar {{methods, list(type: disjunction;)}} com a sua identidade social."
};
var $0bb7e680f174bc7a$export$2e2bcd8739ae039 = Object.freeze($0bb7e680f174bc7a$var$secondary);


const $1ba0200cbe0509b1$var$user_scopes = {
    descriptions: {
        /** UNTRANSLATED */ custom_data: "Your custom data",
        /** UNTRANSLATED */ email: "Your email address",
        /** UNTRANSLATED */ phone: "Your phone number",
        /** UNTRANSLATED */ profile: "Your name, username, avatar, and other profile info",
        /** UNTRANSLATED */ roles: "Your roles",
        /** UNTRANSLATED */ identities: "Your linked social identities",
        /** UNTRANSLATED */ "urn:logto:scope:organizations": "Your organizations info",
        /** UNTRANSLATED */ "urn:logto:scope:organization_roles": "Your organization roles",
        /** UNTRANSLATED */ address: "Your address"
    }
};
var $1ba0200cbe0509b1$export$2e2bcd8739ae039 = Object.freeze($1ba0200cbe0509b1$var$user_scopes);


const $7dcf521217d3a81b$var$pt_pt = {
    translation: {
        input: $e6c8cc51c96c0005$export$2e2bcd8739ae039,
        secondary: $0bb7e680f174bc7a$export$2e2bcd8739ae039,
        action: $8f39ea4782a61d0e$export$2e2bcd8739ae039,
        description: $6e499882c0c0c1fd$export$2e2bcd8739ae039,
        error: $7ff82afd08152f97$export$2e2bcd8739ae039,
        list: $7fd45d9601d13176$export$2e2bcd8739ae039,
        mfa: $3237a6e016122c04$export$2e2bcd8739ae039,
        development_tenant: $3a97e404f8dafa06$export$2e2bcd8739ae039,
        user_scopes: $1ba0200cbe0509b1$export$2e2bcd8739ae039
    }
};
var $7dcf521217d3a81b$export$2e2bcd8739ae039 = Object.freeze($7dcf521217d3a81b$var$pt_pt);


const $cf1baff59357642f$var$action = {
    sign_in: "Войти",
    continue: "Продолжить",
    create_account: "Создать аккаунт",
    create_account_without_linking: "Создать аккаунт без связывания",
    create: "Создать",
    enter_passcode: "Введите код подтверждения",
    confirm: "Подтвердить",
    cancel: "Отменить",
    save_password: "Сохраните пароль",
    bind: "Привязать к {{address}}",
    bind_and_continue: "Привязать и продолжить",
    back: "Назад",
    nav_back: "Назад",
    nav_skip: "Пропустить",
    agree: "Согласен",
    got_it: "Понял",
    sign_in_with: "Войти через {{name}}",
    forgot_password: "Забыли пароль?",
    switch_to: "Изменить на {{method}}",
    sign_in_via_passcode: "Войти с кодом подтверждения",
    sign_in_via_password: "Войти с паролем",
    change: "Изменить {{method}}",
    link_another_email: "Привязать другую почту",
    link_another_phone: "Привязать другой номер",
    link_another_email_or_phone: "Привязать другую почту или номер",
    show_password: "Показать пароль",
    copy: "Копировать",
    verify_via_passkey: "Проверить с помощью ключа доступа",
    download: "Скачать",
    single_sign_on: "Единый вход",
    /** UNTRANSLATED */ authorize: "Authorize",
    /** UNTRANSLATED */ use_another_account: "Use another account"
};
var $cf1baff59357642f$export$2e2bcd8739ae039 = Object.freeze($cf1baff59357642f$var$action);


const $6a45680d9185a082$var$description = {
    email: "адрес электронной почты",
    phone_number: "номер телефона",
    username: "имя пользователя",
    reminder: "Напоминание",
    not_found: "404 Не найдено",
    agree_with_terms: "Я прочитал и согласен с ",
    agree_with_terms_modal: "Чтобы продолжить, пожалуйста, согласитесь с <link></link>",
    terms_of_use: "Условиями использования",
    sign_in: "Войти",
    privacy_policy: "Политикой конфиденциальности",
    create_account: "Создать аккаунт",
    or: "или",
    and: "и",
    enter_passcode: "Код подтверждения был отправлен на {{address}}",
    passcode_sent: "Код подтверждения был отправлен повторно",
    resend_after_seconds: "Отправить повторно через <span>{{seconds}}</span> сек.",
    resend_passcode: "Отправить повторно",
    create_account_id_exists: "Учетная запись для {{value}} уже существует, хотите войти?",
    link_account_id_exists: "Учетная запись для {{value}} уже существует, хотите привязать?",
    sign_in_id_does_not_exist: "Учетная запись для {{value}} не существует, хотите зарегистрироваться?",
    sign_in_id_does_not_exist_alert: "Учетная запись для {{value}} не существует.",
    create_account_id_exists_alert: "Аккаунт с {{type}} {{value}} связан с другим аккаунтом. Пожалуйста, попробуйте другой {{type}}.",
    social_identity_exist: "{{type}} {{value}} связан с другим аккаунтом. Пожалуйста, попробуйте другой {{type}}.",
    bind_account_title: "Привязать или создать аккаунт",
    social_create_account: "Вы можете создать новую учетную запись.",
    social_link_email: "Вы можете привязать другой адрес электронной почты",
    social_link_phone: "Вы можете привязать другой номер телефона",
    social_link_email_or_phone: "Вы можете привязать другой адрес электронной почты или телефон",
    social_bind_with_existing: "Мы находим зарегистрированную связанную учетную запись, и вы можете связать ее напрямую.",
    reset_password: "Забыли пароль",
    reset_password_description: "Введите {{types, list(type: disjunction;)}} от вашей учетной записи, и мы вышлем вам код для восстановления пароля.",
    new_password: "Новый пароль",
    set_password: "Задать пароль",
    password_changed: "Пароль изменен",
    no_account: "Еще не зарегистрированы? ",
    have_account: "Уже есть аккаунт?",
    enter_password: "Введите пароль",
    enter_password_for: "Введите пароль для {{value}}",
    enter_username: "Установить имя пользователя",
    enter_username_description: "Имя пользователя является альтернативой для входа в систему. Имя пользователя должно содержать только буквы, цифры и символы подчеркивания.",
    link_email: "Привязать почту",
    link_phone: "Привязать номер телефона",
    link_email_or_phone: "Привязать почту или номер телефона",
    link_email_description: "Для дополнительной безопасности, пожалуйста, привяжите свою электронную почту к учетной записи.",
    link_phone_description: "Для дополнительной безопасности, пожалуйста, привяжите свой номер телефона к учетной записи.",
    link_email_or_phone_description: "Для дополнительной безопасности, пожалуйста, привяжите свою электронную почту или номер телефона к учетной записи.",
    continue_with_more_information: "Для дополнительной безопасности, пожалуйста, заполните приведенные ниже данные учетной записи.",
    create_your_account: "Создайте свой аккаунт",
    sign_in_to_your_account: "Войди в свой аккаунт",
    no_region_code_found: "Не удалось определить код региона",
    verify_email: "Подтвердите Ваш электронный адрес",
    verify_phone: "Подтвердите свой номер телефона",
    password_requirements: "Требования к паролю {{items, list}}.",
    password_requirement: {
        length_one: "требуется минимум {{count}} символ",
        length_other: "требуется минимум {{count}} символов",
        character_types_one: "должен содержать по крайней мере {{count}} тип прописных букв, строчных букв, цифр и символов",
        character_types_other: "должен содержать по крайней мере {{count}} типа прописных букв, строчных букв, цифр и символов"
    },
    use: "Использовать",
    single_sign_on_email_form: "Введите корпоративный адрес электронной почты",
    single_sign_on_connectors_list: "Ваше предприятие включило функцию единого входа для электронной почты {{email}}. Вы можете продолжить вход в систему с помощью следующих провайдеров SSO.",
    single_sign_on_enabled: "Единый вход в систему включен для этой учетной записи",
    /** UNTRANSLATED */ authorize_title: "Authorize {{name}}",
    /** UNTRANSLATED */ request_permission: "{{name}} is requesting access to:",
    /** UNTRANSLATED */ grant_organization_access: "Grant the organization access:",
    /** UNTRANSLATED */ user_scopes: "Personal user data",
    /** UNTRANSLATED */ organization_scopes: "Organization access",
    /** UNTRANSLATED */ authorize_agreement: `By authorize the access, you agree to the {{name}}'s <link></link>.`,
    /** UNTRANSLATED */ not_you: "Not you?",
    /** UNTRANSLATED */ user_id: "User ID: {{id}}",
    /** UNTRANSLATED */ redirect_to: "You will be redirected to {{name}}."
};
var $6a45680d9185a082$export$2e2bcd8739ae039 = Object.freeze($6a45680d9185a082$var$description);


const $56f72a193a34ed1e$var$development_tenant = {
    notification: "Вы в режиме разработки"
};
var $56f72a193a34ed1e$export$2e2bcd8739ae039 = Object.freeze($56f72a193a34ed1e$var$development_tenant);


const $45218bbb1a2d1b19$var$password_rejected = {
    too_short: "Минимальная длина {{min}} символов.",
    too_long: "Максимальная длина {{max}} символов.",
    character_types: "Требуется как минимум {{min}} типов символов.",
    unsupported_characters: "Найден неподдерживаемый символ.",
    pwned: "Избегайте использования простых паролей, которые легко угадать.",
    restricted_found: "Избегайте чрезмерного использования {{list,list}}.",
    restricted: {
        repetition: "повторяющиеся символы",
        sequence: "последовательные символы",
        user_info: "ваши личные данные",
        words: "контекст продукта"
    }
};
var $45218bbb1a2d1b19$export$2e2bcd8739ae039 = Object.freeze($45218bbb1a2d1b19$var$password_rejected);


const $a6994260a8c2c3b3$var$error = {
    general_required: "Введите {{types, list(type: disjunction;)}}",
    general_invalid: "Проверьте {{types, list(type: disjunction;)}}",
    username_required: "Введите имя пользователя",
    password_required: "Введите пароль",
    username_exists: "Имя пользователя занято",
    username_should_not_start_with_number: "Имя пользователя не должно начинаться с цифры",
    username_invalid_charset: "Имя пользователя должно содержать только буквы, цифры или символы подчеркивания",
    invalid_email: "Электронная почта указана неправильно",
    invalid_phone: "Номер телефона указан неправильно",
    passwords_do_not_match: "Пароли не совпадают. Пожалуйста, попробуйте еще раз.",
    invalid_passcode: "Неправильный код подтверждения",
    invalid_connector_auth: "Авторизация недействительна",
    invalid_connector_request: "Данные коннектора недействительны.",
    unknown: "Неизвестная ошибка. Пожалуйста, повторите попытку позднее.",
    invalid_session: "Сессия не найдена. Пожалуйста, войдите снова.",
    timeout: "Время ожидания истекло. Пожалуйста, повторите попытку позднее.",
    password_rejected: $45218bbb1a2d1b19$export$2e2bcd8739ae039,
    sso_not_enabled: "Односторонняя авторизация не включена для этого аккаунта электронной почты."
};
var $a6994260a8c2c3b3$export$2e2bcd8739ae039 = Object.freeze($a6994260a8c2c3b3$var$error);


const $660317099c22ca36$var$input = {
    username: "Имя пользователя",
    password: "Пароль",
    email: "Электронная почта",
    phone_number: "Номер телефона",
    confirm_password: "Подтверждение пароля",
    search_region_code: "Поиск кода региона",
    backup_code: "Резервный код"
};
var $660317099c22ca36$export$2e2bcd8739ae039 = Object.freeze($660317099c22ca36$var$input);


const $48360ed33c0f8ddd$var$list = {
    or: "или",
    and: "и",
    separator: ","
};
var $48360ed33c0f8ddd$export$2e2bcd8739ae039 = Object.freeze($48360ed33c0f8ddd$var$list);


const $388cd66a4bdaeca4$var$mfa = {
    totp: "Одноразовый пароль приложения для аутентификации",
    webauthn: "Пароль",
    backup_code: "Резервный код",
    link_totp_description: "Например, Google Authenticator и др.",
    link_webauthn_description: "Привяжите ваше устройство или USB-ключ",
    link_backup_code_description: "Создайте резервный код",
    verify_totp_description: "Введите одноразовый код в приложении",
    verify_webauthn_description: "Подтвердите ваше устройство или USB-ключ",
    verify_backup_code_description: "Вставьте резервный код, который вы сохранили",
    add_mfa_factors: "Добавить двухфакторную аутентификацию",
    add_mfa_description: "Включена двухфакторная аутентификация. Выберите второй метод для безопасного входа.",
    verify_mfa_factors: "Двухфакторная аутентификация",
    verify_mfa_description: "Двухфакторная аутентификация включена для этого аккаунта. Выберите второй способ подтверждения вашей личности.",
    add_authenticator_app: "Добавить приложение для аутентификации",
    step: "Шаг {{step, number}}: {{content}}",
    scan_qr_code: "Отсканируйте этот QR-код",
    scan_qr_code_description: "Отсканируйте следующий QR-код с помощью вашего приложения для аутентификации, такого как Google Authenticator, Duo Mobile, Authy и др.",
    qr_code_not_available: "Нельзя отсканировать QR-код?",
    copy_and_paste_key: "Скопируйте и вставьте ключ",
    copy_and_paste_key_description: "Скопируйте и вставьте следующий ключ в ваше приложение для аутентификации, такое как Google Authenticator, Duo Mobile, Authy и др.",
    want_to_scan_qr_code: "Хотите отсканировать QR-код?",
    enter_one_time_code: "Введите одноразовый код",
    enter_one_time_code_link_description: "Введите 6-значный код, сгенерированный приложением для аутентификации.",
    enter_one_time_code_description: "Для этого аккаунта включена двухэтапная аутентификация. Введите одноразовый код, отображаемый в вашем связанном приложении для аутентификации.",
    link_another_mfa_factor: "Переключиться на другой метод",
    save_backup_code: "Сохраните ваш резервный код",
    save_backup_code_description: "Вы можете использовать один из этих резервных кодов для доступа к своему аккаунту, если у вас возникнут проблемы с двухфакторной аутентификацией другим способом. Каждый код может быть использован только один раз.",
    backup_code_hint: "Убедитесь, что вы скопировали и сохранили их в надежном месте.",
    enter_a_backup_code: "Введите резервный код",
    enter_backup_code_description: "Введите резервный код, который вы сохранили при включении двухфакторной аутентификации.",
    create_a_passkey: "Создать код доступа",
    create_passkey_description: "Зарегистрируйте свой код доступа с использованием биометрических данных устройства, ключей безопасности (например, YubiKey) или других доступных методов.",
    try_another_verification_method: "Попробуйте другой метод подтверждения",
    verify_via_passkey: "Подтвердите через код доступа",
    verify_via_passkey_description: "Используйте код доступа для подтверждения с помощью пароля устройства или биометрии, сканирования QR-кода или использования USB-ключа безопасности, такого как YubiKey.",
    secret_key_copied: "Ключ скопирован.",
    backup_code_copied: "Резервный код скопирован.",
    webauthn_not_ready: "WebAuthn еще не готов. Пожалуйста, попробуйте позже.",
    webauthn_not_supported: "WebAuthn не поддерживается в этом браузере.",
    webauthn_failed_to_create: "Не удалось создать. Пожалуйста, попробуйте еще раз.",
    webauthn_failed_to_verify: "Не удалось проверить. Пожалуйста, попробуйте еще раз."
};
var $388cd66a4bdaeca4$export$2e2bcd8739ae039 = Object.freeze($388cd66a4bdaeca4$var$mfa);


const $029508267918c707$var$secondary = {
    social_bind_with: "Уже есть аккаунт? Войдите, чтобы привязать {{methods, list(type: disjunction;)}}."
};
var $029508267918c707$export$2e2bcd8739ae039 = Object.freeze($029508267918c707$var$secondary);


const $ea6a916efdc03f17$var$user_scopes = {
    descriptions: {
        /** UNTRANSLATED */ custom_data: "Your custom data",
        /** UNTRANSLATED */ email: "Your email address",
        /** UNTRANSLATED */ phone: "Your phone number",
        /** UNTRANSLATED */ profile: "Your name, username, avatar, and other profile info",
        /** UNTRANSLATED */ roles: "Your roles",
        /** UNTRANSLATED */ identities: "Your linked social identities",
        /** UNTRANSLATED */ "urn:logto:scope:organizations": "Your organizations info",
        /** UNTRANSLATED */ "urn:logto:scope:organization_roles": "Your organization roles",
        /** UNTRANSLATED */ address: "Your address"
    }
};
var $ea6a916efdc03f17$export$2e2bcd8739ae039 = Object.freeze($ea6a916efdc03f17$var$user_scopes);


const $0ef4b8c3c8055d80$var$ru = {
    translation: {
        input: $660317099c22ca36$export$2e2bcd8739ae039,
        secondary: $029508267918c707$export$2e2bcd8739ae039,
        action: $cf1baff59357642f$export$2e2bcd8739ae039,
        description: $6a45680d9185a082$export$2e2bcd8739ae039,
        error: $a6994260a8c2c3b3$export$2e2bcd8739ae039,
        list: $48360ed33c0f8ddd$export$2e2bcd8739ae039,
        mfa: $388cd66a4bdaeca4$export$2e2bcd8739ae039,
        development_tenant: $56f72a193a34ed1e$export$2e2bcd8739ae039,
        user_scopes: $ea6a916efdc03f17$export$2e2bcd8739ae039
    }
};
var $0ef4b8c3c8055d80$export$2e2bcd8739ae039 = Object.freeze($0ef4b8c3c8055d80$var$ru);


const $03718b129843fa95$var$action = {
    sign_in: "Giriş Yap",
    continue: "İlerle",
    create_account: "Hesap Oluştur",
    create_account_without_linking: "Bağlamadan hesap oluştur",
    create: "Oluştur",
    enter_passcode: "Doğrulama kodunu girin",
    confirm: "Onayla",
    cancel: "İptal Et",
    save_password: "Şifreyi kaydet",
    bind: "{{address}} ile birleştir",
    bind_and_continue: "Bağla ve devam et",
    back: "Geri D\xf6n",
    nav_back: "Geri",
    nav_skip: "Atla",
    agree: "Kabul Et",
    got_it: "Anladım",
    sign_in_with: "{{name}} ile ilerle",
    forgot_password: "Şifremi Unuttum?",
    switch_to: "{{method}} y\xf6ntemine ge\xe7",
    sign_in_via_passcode: "Doğrulama koduyla oturum a\xe7ın",
    sign_in_via_password: "şifre ile giriş yap",
    change: "{{method}} değiştir",
    link_another_email: "Başka bir e-postayı bağla",
    link_another_phone: "Başka bir telefon bağla",
    link_another_email_or_phone: "Başka bir e-posta veya telefon bağlayın",
    show_password: "Şifreyi g\xf6ster",
    copy: "Kopyala",
    verify_via_passkey: "Parola ile doğrula",
    download: "İndir",
    single_sign_on: "Tek oturum a\xe7ma",
    /** UNTRANSLATED */ authorize: "Authorize",
    /** UNTRANSLATED */ use_another_account: "Use another account"
};
var $03718b129843fa95$export$2e2bcd8739ae039 = Object.freeze($03718b129843fa95$var$action);


const $27eaf9de5f781c37$var$description = {
    email: "e-posta adresi",
    phone_number: "telefon numarası",
    username: "kullanıcı Adı",
    reminder: "Hatırlatıcı",
    not_found: "404 Bulunamadı",
    agree_with_terms: "Okudum ve anladım",
    agree_with_terms_modal: "Devam etmek i\xe7in l\xfctfen <link></link>'i kabul edin.",
    terms_of_use: "Kullanım Koşulları",
    sign_in: "Giriş Yap",
    privacy_policy: "Gizlilik Politikası",
    create_account: "Hesap Oluştur",
    or: "veya",
    and: "ve",
    enter_passcode: "Doğrulama kodu {{address}} {{target}} adresinize g\xf6nderildi",
    passcode_sent: "Doğrulama kodu yeniden g\xf6nderildi",
    resend_after_seconds: "<span>{{seconds}}</span> saniye sonra tekrar g\xf6nder",
    resend_passcode: "Doğrulama kodunu tekrar g\xf6nder",
    create_account_id_exists: "{{type}} {{value}} ile hesap mevcut, giriş yapmak ister misiniz?",
    link_account_id_exists: "{{type}} {{value}} olan hesap zaten var, bağlamak ister misiniz?",
    sign_in_id_does_not_exist: "{{type}} {{value}} ile hesap mevcut değil, yeni bir hesap oluşturmak ister misiniz?",
    sign_in_id_does_not_exist_alert: "{{type}} {{value}} olan hesap mevcut değil.",
    create_account_id_exists_alert: "{{type}} {{value}} olan hesap başka bir hesaba bağlı. L\xfctfen başka bir {{type}} deneyin.",
    social_identity_exist: "{{type}} {{value}} başka bir hesaba bağlı. L\xfctfen başka bir {{type}} deneyin.",
    bind_account_title: "Bağla veya hesap oluştur",
    social_create_account: "Yeni bir hesap oluşturabilirsiniz.",
    social_link_email: "Başka bir e-posta bağlayabilirsiniz",
    social_link_phone: "Başka bir telefon bağlayabilirsiniz",
    social_link_email_or_phone: "Başka bir e-posta veya telefon bağlayabilirsiniz",
    social_bind_with_existing: "Kayıtlı ilgili bir hesap bulduk ve onu doğrudan bağlayabilirsiniz.",
    reset_password: "Parolanızı mı unuttunuz",
    reset_password_description: "Hesabınızla ilişkili {{types, list(type: disjunction;)}} girin, şifrenizi sıfırlamanız i\xe7in size doğrulama kodunu g\xf6ndereceğiz.",
    new_password: "Yeni Şifre",
    set_password: "Şifreyi belirle",
    password_changed: "Şifre değişti",
    no_account: "Hen\xfcz hesap yok mu?",
    have_account: "Zaten bir hesabınız var mıydı?",
    enter_password: "Parolanı Gir",
    enter_password_for: "{{method}} {{value}} şifresiyle oturum a\xe7ın",
    enter_username: "Kullanıcı adını ayarla",
    enter_username_description: "Kullanıcı adı, oturum a\xe7mak i\xe7in bir alternatiftir. Kullanıcı adı yalnızca harf, sayı ve alt \xe7izgi i\xe7ermelidir.",
    link_email: "E-postayı bağla",
    link_phone: "Telefonu bağla",
    link_email_or_phone: "E-posta veya telefon bağlantısı",
    link_email_description: "Daha fazla g\xfcvenlik i\xe7in l\xfctfen e-postanızı hesapla ilişkilendirin.",
    link_phone_description: "Daha fazla g\xfcvenlik i\xe7in l\xfctfen telefonunuzu hesaba bağlayın.",
    link_email_or_phone_description: "Daha fazla g\xfcvenlik i\xe7in l\xfctfen e-postanızı veya telefonunuzu hesaba bağlayın.",
    continue_with_more_information: "Daha fazla g\xfcvenlik i\xe7in l\xfctfen aşağıdaki hesap ayrıntılarını tamamlayın.",
    create_your_account: "Hesabını oluştur",
    sign_in_to_your_account: "Hesabına giriş yap",
    no_region_code_found: "B\xf6lge kodu bulunamadı",
    verify_email: "E-postanızın doğrulanması",
    verify_phone: "Telefon numaranızın doğrulanması",
    password_requirements: "Şifre {{items, list}}.",
    password_requirement: {
        length_one: "en az {{count}} karakter gerektirir",
        length_other: "en az {{count}} karakter gerektirir",
        character_types_one: "en az {{count}} tane b\xfcy\xfck harf, k\xfc\xe7\xfck harf, rakam ve sembol i\xe7ermelidir",
        character_types_other: "en az {{count}} tane b\xfcy\xfck harf, k\xfc\xe7\xfck harf, rakam ve sembol i\xe7ermelidir"
    },
    use: "Kullan",
    single_sign_on_email_form: "Kurumsal e-posta adresinizi girin",
    single_sign_on_connectors_list: "Şirketiniz, {{email}} e-posta hesabı i\xe7in Tekli Oturum A\xe7mayı (Single Sign-On) etkinleştirdi. Aşağıdaki SSO sağlayıcıları ile oturum a\xe7maya devam edebilirsiniz.",
    single_sign_on_enabled: "Bu hesapta Tekli Oturum A\xe7ma etkinleştirildi.",
    /** UNTRANSLATED */ authorize_title: "Authorize {{name}}",
    /** UNTRANSLATED */ request_permission: "{{name}} is requesting access to:",
    /** UNTRANSLATED */ grant_organization_access: "Grant the organization access:",
    /** UNTRANSLATED */ user_scopes: "Personal user data",
    /** UNTRANSLATED */ organization_scopes: "Organization access",
    /** UNTRANSLATED */ authorize_agreement: `By authorize the access, you agree to the {{name}}'s <link></link>.`,
    /** UNTRANSLATED */ not_you: "Not you?",
    /** UNTRANSLATED */ user_id: "User ID: {{id}}",
    /** UNTRANSLATED */ redirect_to: "You will be redirected to {{name}}."
};
var $27eaf9de5f781c37$export$2e2bcd8739ae039 = Object.freeze($27eaf9de5f781c37$var$description);


const $4b67ad4d3f22c523$var$development_tenant = {
    notification: "Geliştirme modundasın"
};
var $4b67ad4d3f22c523$export$2e2bcd8739ae039 = Object.freeze($4b67ad4d3f22c523$var$development_tenant);


const $f6e9fdf376e14424$var$password_rejected = {
    too_short: "Minimum length is {{min}}.",
    too_long: "Maximum length is {{max}}.",
    character_types: "En az {{min}} t\xfcrde karakter gereklidir.",
    unsupported_characters: "Desteklenmeyen karakter bulundu.",
    pwned: "Kolayca tahmin edilebilen basit şifreleri kullanmaktan ka\xe7ının.",
    restricted_found: "{{list, list}} fazla kullanımdan ka\xe7ının.",
    restricted: {
        repetition: "tekrarlanan karakterler",
        sequence: "dizisel karakterler",
        user_info: "kişisel bilgileriniz",
        words: "\xfcr\xfcnle ilgili terimler"
    }
};
var $f6e9fdf376e14424$export$2e2bcd8739ae039 = Object.freeze($f6e9fdf376e14424$var$password_rejected);


const $c7a67a4a8af52b59$var$error = {
    general_required: "{{types, list(type: disjunction;)}} gerekli",
    general_invalid: "{{types, list(type: disjunction;)}} ge\xe7ersiz",
    username_required: "Kullanıcı adı gerekli.",
    password_required: "Şifre gerekli.",
    username_exists: "Kullanıcı adı mevcut.",
    username_should_not_start_with_number: "Kullanıcı adı sayı ile başlayamaz.",
    username_invalid_charset: "Kullanıcı adı yalnızca harf,sayı veya alt \xe7izgi i\xe7ermeli.",
    invalid_email: "E-posta adresi ge\xe7ersiz",
    invalid_phone: "Telefon numarası ge\xe7ersiz",
    passwords_do_not_match: "Şifreler eşleşmiyor",
    invalid_passcode: "Doğrulama kodu ge\xe7ersiz",
    invalid_connector_auth: "Yetki ge\xe7ersiz",
    invalid_connector_request: "Bağlayıcı veri ge\xe7ersiz",
    unknown: "Bilinmeyen hata. L\xfctfen daha sonra tekrar deneyiniz.",
    invalid_session: "Oturum bulunamadı. L\xfctfen geri d\xf6n\xfcp tekrar giriş yapınız.",
    timeout: "Oturum zaman aşımına uğradı. L\xfctfen geri d\xf6n\xfcp tekrar giriş yapınız.",
    password_rejected: $f6e9fdf376e14424$export$2e2bcd8739ae039,
    sso_not_enabled: "Bu e-posta hesabı i\xe7in tek oturum a\xe7ma etkin değil."
};
var $c7a67a4a8af52b59$export$2e2bcd8739ae039 = Object.freeze($c7a67a4a8af52b59$var$error);


const $307c1ca95d92afe9$var$input = {
    username: "Kullanıcı Adı",
    password: "Şifre",
    email: "E-posta Adresi",
    phone_number: "Telefon Numarası",
    confirm_password: "Şifreyi Doğrula",
    search_region_code: "B\xf6lge kodunu ara",
    backup_code: "Yedek kod"
};
var $307c1ca95d92afe9$export$2e2bcd8739ae039 = Object.freeze($307c1ca95d92afe9$var$input);


const $6466f56bae17bdcf$var$list = {
    or: "veya",
    and: "ve",
    separator: ","
};
var $6466f56bae17bdcf$export$2e2bcd8739ae039 = Object.freeze($6466f56bae17bdcf$var$list);


const $f90d23b23740b12f$var$mfa = {
    totp: "Authenticator uygulaması OTP",
    webauthn: "Anahtar",
    backup_code: "Yedek kod",
    link_totp_description: "\xd6rn., Google Authenticator, vb.",
    link_webauthn_description: "Cihazınızı veya USB donanımınızı bağlayın",
    link_backup_code_description: "Yedek kod oluşturun",
    verify_totp_description: "Uygulamadaki tek kullanımlık kodu girin",
    verify_webauthn_description: "Cihazınızı veya USB donanımınızı doğrulayın",
    verify_backup_code_description: "Kaydettiğiniz yedek kodu yapıştırın",
    add_mfa_factors: "2 aşamalı doğrulamayı ekle",
    add_mfa_description: "İki fakt\xf6rl\xfc doğrulama etkin. G\xfcvenli giriş i\xe7in ikinci doğrulama y\xf6nteminizi se\xe7in.",
    verify_mfa_factors: "2 aşamalı doğrulama",
    verify_mfa_description: "Bu hesap i\xe7in 2 aşamalı doğrulama etkinleştirildi. L\xfctfen kimliğinizi doğrulamak i\xe7in ikinci yolu se\xe7in.",
    add_authenticator_app: "Authenticator uygulaması ekle",
    step: "Adım {{step, number}}: {{content}}",
    scan_qr_code: "Bu QR kodunu tarayın",
    scan_qr_code_description: "Bu QR kodunu authenticator uygulamanızla tarayın, \xf6rneğin Google Authenticator, Duo Mobile, Authy, vb.",
    qr_code_not_available: "QR kodu taranamıyor mu?",
    copy_and_paste_key: "Anahtarı kopyala ve yapıştır",
    copy_and_paste_key_description: "Aşağıdaki anahtarı authenticator uygulamanıza kopyala ve yapıştır, \xf6rneğin Google Authenticator, Duo Mobile, Authy, vb.",
    want_to_scan_qr_code: "QR kodunu tarımak mı istiyorsunuz?",
    enter_one_time_code: "Tek kullanımlık kodu girin",
    enter_one_time_code_link_description: "Authenticator uygulaması tarafından oluşturulan 6 haneli doğrulama kodunu girin.",
    enter_one_time_code_description: "Bu hesap i\xe7in iki aşamalı doğrulama etkinleştirildi. L\xfctfen bağlı kimlik doğrulama uygulamanızda g\xf6sterilen tek kullanımlık kodu girin.",
    link_another_mfa_factor: "Başka bir y\xf6nteme ge\xe7in",
    save_backup_code: "Yedek kodunuzu kaydedin",
    save_backup_code_description: "Başka bir y\xf6ntemle 2 aşamalı doğrulama sırasında sorun yaşarsanız bu yedek kodlardan birini kullanabilirsiniz. Her kod sadece bir kez kullanılabilir.",
    backup_code_hint: "Onları kopyalayın ve g\xfcvenli bir yerde sakladığınızdan emin olun.",
    enter_a_backup_code: "Bir yedek kod girin",
    enter_backup_code_description: "İlk olarak 2 aşamalı doğrulama etkinleştirildiğinde kaydettiğiniz yedek kodu girin.",
    create_a_passkey: "Bir anahtar oluşturun",
    create_passkey_description: "Cihaz biyometrisi, g\xfcvenlik anahtarları (\xf6rneğin YubiKey) veya diğer kullanılabilir y\xf6ntemler kullanarak anahtarınızı kaydedin.",
    try_another_verification_method: "Başka bir doğrulama y\xf6ntemini deneyin",
    verify_via_passkey: "Anahtar ile doğrula",
    verify_via_passkey_description: "Anahtar kullanarak cihaz parolanız veya biyometri ile doğrulama, QR kodunu tarama veya YubiKey gibi USB g\xfcvenlik anahtarı kullanma.",
    secret_key_copied: "Gizli anahtar kopyalandı.",
    backup_code_copied: "Yedek kod kopyalandı.",
    webauthn_not_ready: "WebAuthn hen\xfcz hazır değil. L\xfctfen daha sonra tekrar deneyin.",
    webauthn_not_supported: "Bu tarayıcıda WebAuthn desteklenmiyor.",
    webauthn_failed_to_create: "Oluşturulamadı. L\xfctfen tekrar deneyin.",
    webauthn_failed_to_verify: "Doğrulama başarısız oldu. L\xfctfen tekrar deneyin."
};
var $f90d23b23740b12f$export$2e2bcd8739ae039 = Object.freeze($f90d23b23740b12f$var$mfa);


const $94b4bbc231a19192$var$secondary = {
    social_bind_with: "Hesabınız zaten var mı? {{methods, list(type: disjunction;)}} bağlantısına tıklayarak giriş yapabilirsiniz"
};
var $94b4bbc231a19192$export$2e2bcd8739ae039 = Object.freeze($94b4bbc231a19192$var$secondary);


const $720d6555e74ab037$var$user_scopes = {
    descriptions: {
        /** UNTRANSLATED */ custom_data: "Your custom data",
        /** UNTRANSLATED */ email: "Your email address",
        /** UNTRANSLATED */ phone: "Your phone number",
        /** UNTRANSLATED */ profile: "Your name, username, avatar, and other profile info",
        /** UNTRANSLATED */ roles: "Your roles",
        /** UNTRANSLATED */ identities: "Your linked social identities",
        /** UNTRANSLATED */ "urn:logto:scope:organizations": "Your organizations info",
        /** UNTRANSLATED */ "urn:logto:scope:organization_roles": "Your organization roles",
        /** UNTRANSLATED */ address: "Your address"
    }
};
var $720d6555e74ab037$export$2e2bcd8739ae039 = Object.freeze($720d6555e74ab037$var$user_scopes);


const $a04478c9d68e0cae$var$tr_tr = {
    translation: {
        input: $307c1ca95d92afe9$export$2e2bcd8739ae039,
        secondary: $94b4bbc231a19192$export$2e2bcd8739ae039,
        action: $03718b129843fa95$export$2e2bcd8739ae039,
        description: $27eaf9de5f781c37$export$2e2bcd8739ae039,
        error: $c7a67a4a8af52b59$export$2e2bcd8739ae039,
        list: $6466f56bae17bdcf$export$2e2bcd8739ae039,
        mfa: $f90d23b23740b12f$export$2e2bcd8739ae039,
        development_tenant: $4b67ad4d3f22c523$export$2e2bcd8739ae039,
        user_scopes: $720d6555e74ab037$export$2e2bcd8739ae039
    }
};
var $a04478c9d68e0cae$export$2e2bcd8739ae039 = Object.freeze($a04478c9d68e0cae$var$tr_tr);


const $f81468cf6096eaca$var$action = {
    sign_in: "登录",
    continue: "继续",
    create_account: "注册",
    create_account_without_linking: "注册新的账号",
    create: "注册",
    enter_passcode: "输入验证码",
    confirm: "确认",
    cancel: "取消",
    save_password: "保存密码",
    bind: "绑定到 {{address}}",
    bind_and_continue: "绑定并继续",
    back: "返回",
    nav_back: "返回",
    nav_skip: "跳过",
    agree: "同意",
    got_it: "知道了",
    sign_in_with: "通过 {{name}} 继续",
    forgot_password: "忘记密码？",
    switch_to: "切换到{{method}}",
    sign_in_via_passcode: "用验证码登录",
    sign_in_via_password: "密码登录",
    change: "更改{{method}}",
    link_another_email: "绑定其它邮箱",
    link_another_phone: "绑定其它手机",
    link_another_email_or_phone: "绑定邮箱或手机号",
    show_password: "显示密码",
    copy: "复制",
    verify_via_passkey: "通过 Passkey 验证",
    download: "下载",
    single_sign_on: "单点登录",
    /** UNTRANSLATED */ authorize: "Authorize",
    /** UNTRANSLATED */ use_another_account: "Use another account"
};
var $f81468cf6096eaca$export$2e2bcd8739ae039 = Object.freeze($f81468cf6096eaca$var$action);


const $845238fbf6c49375$var$description = {
    email: "邮箱",
    phone_number: "手机号",
    username: "用户名",
    reminder: "提示",
    not_found: "404 页面不存在",
    agree_with_terms: "我已阅读并同意 ",
    agree_with_terms_modal: "请先同意 <link></link> 以继续",
    terms_of_use: "使用条款",
    sign_in: "登录",
    privacy_policy: "隐私政策",
    create_account: "创建帐号",
    or: "或",
    and: "和",
    enter_passcode: "验证码已经发送至你的{{ address }} {{target}}",
    passcode_sent: "验证码已经发送",
    resend_after_seconds: "在 <span>{{ seconds }}</span> 秒后重发",
    resend_passcode: "重发验证码",
    create_account_id_exists: "{{type}}为 {{value}} 的帐号已存在，你要登录吗？",
    link_account_id_exists: " {{type}}为 {{value}} 的账号已注册，你要绑定至这个账号吗？",
    sign_in_id_does_not_exist: "{{type}}为 {{value}} 的帐号不存在，你要创建一个新帐号吗？",
    sign_in_id_does_not_exist_alert: "{{type}}为 {{value}} 的帐号不存在。",
    create_account_id_exists_alert: "{{type}} {{value}} 已绑定其他账号。请尝试其他{{type}}。",
    social_identity_exist: " {{type}} {{value}} 已绑定其他账号。请尝试其他{{type}}",
    bind_account_title: "绑定或注册帐号",
    social_create_account: "你可以注册一个新的账号。",
    social_link_email: "你可以绑定其他邮箱",
    social_link_phone: "你可以绑定其他手机号",
    social_link_email_or_phone: "你可以绑定其他邮箱或手机号",
    social_bind_with_existing: "找到了一个已注册的账号，你可以直接绑定。",
    reset_password: "忘记密码",
    reset_password_description: "输入{{types, list(type: disjunction;)}}，获取验证码以重设密码。",
    new_password: "新密码",
    set_password: "设置密码",
    password_changed: "已重置密码！",
    no_account: "还没有账号？",
    have_account: " 已有账号？",
    enter_password: "输入密码",
    enter_password_for: "输入{{method}} {{value}} 对应的密码进行登录",
    enter_username: "设置用户名",
    enter_username_description: "用户名可以用来进行登录。用户名仅可以包含字母、数字和下划线。",
    link_email: "绑定邮箱",
    link_phone: "绑定手机",
    link_email_or_phone: "绑定邮箱或手机号",
    link_email_description: "绑定邮箱以保障你的账号安全",
    link_phone_description: "绑定手机号以保障你的账号安全",
    link_email_or_phone_description: "绑定邮箱或手机号以保障你的账号安全",
    continue_with_more_information: "为保障你的账号安全，需要你补充以下信息。",
    create_your_account: "注册你的账号",
    sign_in_to_your_account: "登录你的账号",
    no_region_code_found: "没有找到区域码",
    verify_email: "验证你的邮箱",
    verify_phone: "验证你的手机号",
    password_requirements: "密码 {{items, list}}。",
    password_requirement: {
        length_one: "应至少有 {{count}} 个字符",
        length_other: "应至少有 {{count}} 个字符",
        character_types_one: "应包含至少 {{count}} 种大写字母、小写字母、数字和符号",
        character_types_other: "应包含至少 {{count}} 种大写字母、小写字母、数字和符号"
    },
    use: "使用",
    single_sign_on_email_form: "输入你的企业电子邮件地址",
    single_sign_on_connectors_list: "你的企业已为电子邮件账户 {{email}} 启用了单点登录。你可以继续使用以下SSO提供商进行登录。",
    single_sign_on_enabled: "该帐户已启用单点登录",
    authorize_title: "授权给 {{name}}",
    request_permission: "{{name}} 需要权限：",
    grant_organization_access: "授予组织访问权限：",
    user_scopes: "用户个人信息",
    organization_scopes: "组织权限",
    authorize_agreement: `你将同意授权给 {{name}} <link></link>.`,
    not_you: "不是你本人吗？",
    user_id: "用户 ID: {{id}}",
    redirect_to: "你将被重定向到 {{name}}。"
};
var $845238fbf6c49375$export$2e2bcd8739ae039 = Object.freeze($845238fbf6c49375$var$description);


const $24be055eac7f3576$var$development_tenant = {
    notification: "你处于开发模式"
};
var $24be055eac7f3576$export$2e2bcd8739ae039 = Object.freeze($24be055eac7f3576$var$development_tenant);


const $5d8a7c4dae3fbce6$var$password_rejected = {
    too_short: "最短长度为{{min}}。",
    too_long: "最长长度为{{max}}。",
    character_types: "需要至少{{min}}种字符类型。",
    unsupported_characters: "发现不支持的字符。",
    pwned: "避免使用容易被猜到的简单密码。",
    restricted_found: "避免过度使用{{list, list}}。",
    restricted: {
        repetition: "重复字符",
        sequence: "连续字符",
        user_info: "您的个人信息",
        words: "产品上下文"
    }
};
var $5d8a7c4dae3fbce6$export$2e2bcd8739ae039 = Object.freeze($5d8a7c4dae3fbce6$var$password_rejected);


const $22131d0916222edd$var$error = {
    general_required: "{{types, list(type: disjunction;)}}必填",
    general_invalid: "无效的{{types, list(type: disjunction;)}}",
    username_required: "用户名必填",
    password_required: "密码必填",
    username_exists: "用户名已存在",
    username_should_not_start_with_number: "用户名不能以数字开头",
    username_invalid_charset: "用户名只能包含英文字母、数字或下划线。",
    invalid_email: "无效的邮箱",
    invalid_phone: "无效的手机号",
    passwords_do_not_match: "两次输入的密码不一致，请重试。",
    invalid_passcode: "无效的验证码",
    invalid_connector_auth: "登录失败",
    invalid_connector_request: "无效的登录请求",
    unknown: "未知错误，请稍后重试。",
    invalid_session: "未找到会话，请返回并重新登录。",
    timeout: "请求超时，请稍后重试。",
    password_rejected: $5d8a7c4dae3fbce6$export$2e2bcd8739ae039,
    sso_not_enabled: "此邮箱账户未启用单点登录。"
};
var $22131d0916222edd$export$2e2bcd8739ae039 = Object.freeze($22131d0916222edd$var$error);


const $6b920fd9e1213a52$var$input = {
    username: "用户名",
    password: "密码",
    email: "邮箱",
    phone_number: "手机号",
    confirm_password: "确认密码",
    search_region_code: "搜索区域码",
    backup_code: "备用码"
};
var $6b920fd9e1213a52$export$2e2bcd8739ae039 = Object.freeze($6b920fd9e1213a52$var$input);


const $9e73ef7a6aa10ccc$var$list = {
    or: "或者",
    and: "和",
    separator: "，"
};
var $9e73ef7a6aa10ccc$export$2e2bcd8739ae039 = Object.freeze($9e73ef7a6aa10ccc$var$list);


const $f9daef37b8748847$var$mfa = {
    totp: "身份验证应用 OTP",
    webauthn: "通行证",
    backup_code: "备份代码",
    link_totp_description: "例如，Google Authenticator 等。",
    link_webauthn_description: "链接您的设备或 USB 硬件",
    link_backup_code_description: "生成备份代码",
    verify_totp_description: "在应用程序中输入一次性代码",
    verify_webauthn_description: "验证您的设备或 USB 硬件",
    verify_backup_code_description: "粘贴您保存的备份代码",
    add_mfa_factors: "添加两步验证",
    add_mfa_description: "已启用两步验证。选择第二种验证方法以进行安全登录。",
    verify_mfa_factors: "两步验证",
    verify_mfa_description: "此帐户已启用两步验证。请选择第二种验证身份的方式。",
    add_authenticator_app: "添加身份验证应用",
    step: "步骤 {{step, number}}: {{content}}",
    scan_qr_code: "扫描此 QR 码",
    scan_qr_code_description: "使用身份验证应用程序（如 Google Authenticator、Duo Mobile、Authy 等）扫描以下 QR 码。",
    qr_code_not_available: "无法扫描 QR 码？",
    copy_and_paste_key: "复制并粘贴密钥",
    copy_and_paste_key_description: "将以下密钥复制并粘贴到身份验证应用程序中，如 Google Authenticator、Duo Mobile、Authy 等。",
    want_to_scan_qr_code: "想要扫描 QR 码吗？",
    enter_one_time_code: "输入一次性代码",
    enter_one_time_code_link_description: "输入身份验证应用生成的 6 位验证码。",
    enter_one_time_code_description: "此帐户启用了两步验证。请在你关联的认证应用中输入显示的一次性代码。",
    link_another_mfa_factor: "切换到另一种方法",
    save_backup_code: "保存您的备份代码",
    save_backup_code_description: "如果在其他方式的两步验证中遇到问题，您可以使用这些备份代码之一访问您的帐户。每个代码只能使用一次。",
    backup_code_hint: "确保复制它们并保存在安全的地方。",
    enter_a_backup_code: "输入备份代码",
    enter_backup_code_description: "输入初始启用两步验证时保存的备份代码。",
    create_a_passkey: "创建通行证",
    create_passkey_description: "使用设备生物识别、安全密钥（例如 YubiKey）或其他可用方法注册您的通行证。",
    try_another_verification_method: "尝试其他验证方法",
    verify_via_passkey: "通过通行证验证",
    verify_via_passkey_description: "使用通行证通过设备密码或生物识别、扫描 QR 码或使用 USB 安全密钥（如 YubiKey）进行验证。",
    secret_key_copied: "密钥已复制。",
    backup_code_copied: "备份代码已复制。",
    webauthn_not_ready: "WebAuthn 尚未准备就绪。请稍后重试。",
    webauthn_not_supported: "此浏览器不支持 WebAuthn。",
    webauthn_failed_to_create: "创建失败。请重试。",
    webauthn_failed_to_verify: "验证失败。请重试。"
};
var $f9daef37b8748847$export$2e2bcd8739ae039 = Object.freeze($f9daef37b8748847$var$mfa);


const $3c0dcd52816740b2$var$secondary = {
    social_bind_with: "绑定到已有账户? 使用 {{methods, list(type: disjunction;), zhOrSpaces}} 登录并绑定。"
};
var $3c0dcd52816740b2$export$2e2bcd8739ae039 = Object.freeze($3c0dcd52816740b2$var$secondary);


const $d55ccc3caff484fe$var$user_scopes = {
    descriptions: {
        /** UNTRANSLATED */ custom_data: "Your custom data",
        /** UNTRANSLATED */ email: "Your email address",
        /** UNTRANSLATED */ phone: "Your phone number",
        /** UNTRANSLATED */ profile: "Your name, username, avatar, and other profile info",
        /** UNTRANSLATED */ roles: "Your roles",
        /** UNTRANSLATED */ identities: "Your linked social identities",
        /** UNTRANSLATED */ "urn:logto:scope:organizations": "Your organizations info",
        /** UNTRANSLATED */ "urn:logto:scope:organization_roles": "Your organization roles",
        /** UNTRANSLATED */ address: "Your address"
    }
};
var $d55ccc3caff484fe$export$2e2bcd8739ae039 = Object.freeze($d55ccc3caff484fe$var$user_scopes);


const $42e382f27811bd49$var$zh_cn = {
    translation: {
        input: $6b920fd9e1213a52$export$2e2bcd8739ae039,
        secondary: $3c0dcd52816740b2$export$2e2bcd8739ae039,
        action: $f81468cf6096eaca$export$2e2bcd8739ae039,
        description: $845238fbf6c49375$export$2e2bcd8739ae039,
        error: $22131d0916222edd$export$2e2bcd8739ae039,
        list: $9e73ef7a6aa10ccc$export$2e2bcd8739ae039,
        mfa: $f9daef37b8748847$export$2e2bcd8739ae039,
        development_tenant: $24be055eac7f3576$export$2e2bcd8739ae039,
        user_scopes: $d55ccc3caff484fe$export$2e2bcd8739ae039
    }
};
var $42e382f27811bd49$export$2e2bcd8739ae039 = Object.freeze($42e382f27811bd49$var$zh_cn);


const $4ffff31c7496f349$var$action = {
    sign_in: "登錄",
    continue: "繼續",
    create_account: "註冊",
    create_account_without_linking: "註冊新的帳號",
    create: "註冊",
    enter_passcode: "輸入驗證碼",
    confirm: "確認",
    cancel: "取消",
    save_password: "保存密碼",
    bind: "綁定到 {{address}}",
    bind_and_continue: "綁定並繼續",
    back: "返回",
    nav_back: "返回",
    nav_skip: "跳過",
    agree: "同意",
    got_it: "知道了",
    sign_in_with: "通過 {{name}} 繼續",
    forgot_password: "忘記密碼？",
    switch_to: "切換到{{method}}",
    sign_in_via_passcode: "用驗證碼登錄",
    sign_in_via_password: "密碼登錄",
    change: "更改{{method}}",
    link_another_email: "綁定其他電子郵件",
    link_another_phone: "綁定其他手機",
    link_another_email_or_phone: "綁定電子郵件或手機號碼",
    show_password: "顯示密碼",
    copy: "複製",
    verify_via_passkey: "透過 Passkey 驗證",
    download: "下載",
    single_sign_on: "單點登錄",
    /** UNTRANSLATED */ authorize: "Authorize",
    /** UNTRANSLATED */ use_another_account: "Use another account"
};
var $4ffff31c7496f349$export$2e2bcd8739ae039 = Object.freeze($4ffff31c7496f349$var$action);


const $0222c322a1dfd94a$var$description = {
    email: "郵箱",
    phone_number: "手機號",
    username: "用戶名",
    reminder: "提示",
    not_found: "404 頁面不存在",
    agree_with_terms: "我已閱讀並同意 ",
    agree_with_terms_modal: "請先同意 <link></link> 以繼續",
    terms_of_use: "使用條款",
    sign_in: "登錄",
    privacy_policy: "隱私政策",
    create_account: "創建帳號",
    or: "或",
    and: "和",
    enter_passcode: "驗證碼已經發送至你的{{ address }} {{target}}",
    passcode_sent: "驗證碼已經發送",
    resend_after_seconds: "在 <span>{{ seconds }}</span> 秒後重發",
    resend_passcode: "重發驗證碼",
    create_account_id_exists: "{{type}}為 {{value}} 的帳號已存在，你要登錄嗎？",
    link_account_id_exists: " {{type}}為 {{value}} 的帳號已註冊，你要綁定至這個帳號嗎？",
    sign_in_id_does_not_exist: "{{type}}為 {{value}} 的帳號不存在，你要創建一個新帳號嗎？",
    sign_in_id_does_not_exist_alert: "{{type}}為 {{value}} 的帳號不存在。",
    create_account_id_exists_alert: "{{type}} {{value}} 已綁定其他帳號。請嘗試其他{{type}}。",
    social_identity_exist: " {{type}} {{value}} 已綁定其他帳號。請嘗試其他{{type}}",
    bind_account_title: "綁定或註冊帳號",
    social_create_account: "你可以註冊一個新的帳號。",
    social_link_email: "你可以綁定其他郵箱",
    social_link_phone: "你可以綁定其他手機號",
    social_link_email_or_phone: "你可以綁定其他郵箱或手機號",
    social_bind_with_existing: "找到了一個已註冊的帳號，你可以直接綁定。",
    reset_password: "忘記密碼",
    reset_password_description: "輸入{{types, list(type: disjunction;)}}，獲取驗證碼以重設密碼。",
    new_password: "新密碼",
    set_password: "設定密碼",
    password_changed: "已重置密碼！",
    no_account: "還沒有帳號？",
    have_account: " 已有帳號？",
    enter_password: "輸入密碼",
    enter_password_for: "輸入{{method}} {{value}} 對應的密碼進行登錄",
    enter_username: "設定用戶名",
    enter_username_description: "用戶名可以用來進行登錄。用戶名僅可以包含字母、數字和下劃線。",
    link_email: "綁定郵箱",
    link_phone: "綁定手機",
    link_email_or_phone: "綁定郵箱或手機號",
    link_email_description: "綁定郵箱以保障你的帳號安全",
    link_phone_description: "綁定手機號以保障你的帳號安全",
    link_email_or_phone_description: "綁定郵箱或手機號以保障你的帳號安全",
    continue_with_more_information: "為保障你的帳號安全，需要你補充以下信息。",
    create_your_account: "註冊你的帳號",
    sign_in_to_your_account: "登錄你的帳號",
    no_region_code_found: "沒有找到區域碼",
    verify_email: "驗證你的郵箱",
    verify_phone: "驗證你的手機號",
    password_requirements: "要求密碼 {{items, list}}。",
    password_requirement: {
        length_one: "要求至少 {{count}} 個字符",
        length_other: "要求至少 {{count}} 個字符",
        character_types_one: "要求包含至少 {{count}} 類型的大寫字母，小寫字母，數字和符號",
        character_types_other: "要求包含至少 {{count}} 類型的大寫字母，小寫字母，數字和符號"
    },
    use: "使用",
    single_sign_on_email_form: "輸入你的企業電子郵件地址",
    single_sign_on_connectors_list: "您的企業已為電郵賬戶{{email}}啟用單一登入。您可以繼續使用以下的SSO供應商登入。",
    single_sign_on_enabled: "該帳戶已啟用單一登入",
    /** UNTRANSLATED */ authorize_title: "Authorize {{name}}",
    /** UNTRANSLATED */ request_permission: "{{name}} is requesting access to:",
    /** UNTRANSLATED */ grant_organization_access: "Grant the organization access:",
    /** UNTRANSLATED */ user_scopes: "Personal user data",
    /** UNTRANSLATED */ organization_scopes: "Organization access",
    /** UNTRANSLATED */ authorize_agreement: `By authorize the access, you agree to the {{name}}'s <link></link>.`,
    /** UNTRANSLATED */ not_you: "Not you?",
    /** UNTRANSLATED */ user_id: "User ID: {{id}}",
    /** UNTRANSLATED */ redirect_to: "You will be redirected to {{name}}."
};
var $0222c322a1dfd94a$export$2e2bcd8739ae039 = Object.freeze($0222c322a1dfd94a$var$description);


const $881c17774e22fd53$var$development_tenant = {
    notification: "你處於開發模式"
};
var $881c17774e22fd53$export$2e2bcd8739ae039 = Object.freeze($881c17774e22fd53$var$development_tenant);


const $1003683333563e5c$var$password_rejected = {
    too_short: "最少長度為{{min}}。",
    too_long: "最大長度為{{max}}。",
    character_types: "至少需要{{min}}種類的字符。",
    unsupported_characters: "發現不支援的字符。",
    pwned: "避免使用容易猜測的簡單密碼。",
    restricted_found: "避免過度使用{{list, list}}。",
    restricted: {
        repetition: "重複的字符",
        sequence: "連續的字符",
        user_info: "個人資訊",
        words: "產品上下文"
    }
};
var $1003683333563e5c$export$2e2bcd8739ae039 = Object.freeze($1003683333563e5c$var$password_rejected);


const $348f266e8f63b9c9$var$error = {
    general_required: "{{types, list(type: disjunction;)}}必填",
    general_invalid: "無效的{{types, list(type: disjunction;)}}",
    username_required: "用戶名必填",
    password_required: "密碼必填",
    username_exists: "用戶名已存在",
    username_should_not_start_with_number: "用戶名不能以數字開頭",
    username_invalid_charset: "用戶名只能包含英文字母、數字或下劃線。",
    invalid_email: "無效的電子郵件",
    invalid_phone: "無效的手機號碼",
    passwords_do_not_match: "兩次輸入的密碼不一致，請重試。",
    invalid_passcode: "無效的驗證碼",
    invalid_connector_auth: "登錄失敗",
    invalid_connector_request: "無效的登錄請求",
    unknown: "未知錯誤，請稍後重試。",
    invalid_session: "未找到會話，請返回並重新登錄。",
    timeout: "請求超時，請稍後重試。",
    password_rejected: $1003683333563e5c$export$2e2bcd8739ae039,
    sso_not_enabled: "此電子郵件帳戶未啟用單一登錄。"
};
var $348f266e8f63b9c9$export$2e2bcd8739ae039 = Object.freeze($348f266e8f63b9c9$var$error);


const $2feef9af2b49fce3$var$input = {
    username: "用戶名",
    password: "密碼",
    email: "電郵",
    phone_number: "手機號碼",
    confirm_password: "確認密碼",
    search_region_code: "搜索區域碼",
    backup_code: "備用碼"
};
var $2feef9af2b49fce3$export$2e2bcd8739ae039 = Object.freeze($2feef9af2b49fce3$var$input);


const $f7787533cbad375a$var$list = {
    or: "或",
    and: "和",
    separator: "，"
};
var $f7787533cbad375a$export$2e2bcd8739ae039 = Object.freeze($f7787533cbad375a$var$list);


const $c4bb9c3f7955cba1$var$mfa = {
    totp: "身份驗證應用 OTP",
    webauthn: "通行證",
    backup_code: "備份代碼",
    link_totp_description: "例如，Google Authenticator 等。",
    link_webauthn_description: "鏈接您的設備或 USB 硬件",
    link_backup_code_description: "生成備份代碼",
    verify_totp_description: "在應用程序中輸入一次性代碼",
    verify_webauthn_description: "驗證您的設備或 USB 硬件",
    verify_backup_code_description: "粘貼您保存的備份代碼",
    add_mfa_factors: "添加兩步驗證",
    add_mfa_description: "已啟用兩步驗證。選擇第二種驗證方法進行安全登錄。",
    verify_mfa_factors: "兩步驗證",
    verify_mfa_description: "此帳戶已啟用兩步驗證。請選擇第二種驗證身份的方式。",
    add_authenticator_app: "添加身份驗證應用",
    step: "步驟 {{step, number}}: {{content}}",
    scan_qr_code: "掃描此 QR 碼",
    scan_qr_code_description: "使用身份驗證應用程序（如 Google Authenticator、Duo Mobile、Authy 等）掃描以下 QR 碼。",
    qr_code_not_available: "無法掃描 QR 碼？",
    copy_and_paste_key: "複製並粘貼密鑰",
    copy_and_paste_key_description: "將以下密鑰複製並粘貼到身份驗證應用程序中，如 Google Authenticator、Duo Mobile、Authy 等。",
    want_to_scan_qr_code: "想要掃描 QR 碼嗎？",
    enter_one_time_code: "輸入一次性代碼",
    enter_one_time_code_link_description: "輸入身份驗證應用生成的 6 位驗證碼。",
    enter_one_time_code_description: "此帳戶啟用了兩步驗證。請輸入在您關聯的認證應用中顯示的一次性代碼。",
    link_another_mfa_factor: "切換到另一種方法",
    save_backup_code: "保存您的備份代碼",
    save_backup_code_description: "如果在其他方式的兩步驗證中遇到問題，您可以使用這些備份代碼之一訪問您的帳戶。每個代碼只能使用一次。",
    backup_code_hint: "確保複製它們並保存在安全的地方。",
    enter_a_backup_code: "輸入備份代碼",
    enter_backup_code_description: "輸入初始啟用兩步驗證時保存的備份代碼。",
    create_a_passkey: "創建通行證",
    create_passkey_description: "使用設備生物識別、安全密鑰（例如 YubiKey）或其他可用方法註冊您的通行證。",
    try_another_verification_method: "嘗試其他驗證方法",
    verify_via_passkey: "通過通行證驗證",
    verify_via_passkey_description: "使用通行證通過設備密碼或生物識別、掃描 QR 碼或使用 USB 安全密鑰（如 YubiKey）進行驗證。",
    secret_key_copied: "密鑰已複製。",
    backup_code_copied: "備份代碼已複製。",
    webauthn_not_ready: "WebAuthn 尚未準備就緒。請稍後重試。",
    webauthn_not_supported: "此瀏覽器不支援 WebAuthn。",
    webauthn_failed_to_create: "創建失敗。請重試。",
    webauthn_failed_to_verify: "驗證失敗。請重試。"
};
var $c4bb9c3f7955cba1$export$2e2bcd8739ae039 = Object.freeze($c4bb9c3f7955cba1$var$mfa);


const $a12c4e914a5af113$var$secondary = {
    social_bind_with: "綁定到已有帳戶? 使用 {{methods, list(type: disjunction;), zhOrSpaces}} 登入並綁定。"
};
var $a12c4e914a5af113$export$2e2bcd8739ae039 = Object.freeze($a12c4e914a5af113$var$secondary);


const $40601c8052153f4b$var$user_scopes = {
    descriptions: {
        /** UNTRANSLATED */ custom_data: "Your custom data",
        /** UNTRANSLATED */ email: "Your email address",
        /** UNTRANSLATED */ phone: "Your phone number",
        /** UNTRANSLATED */ profile: "Your name, username, avatar, and other profile info",
        /** UNTRANSLATED */ roles: "Your roles",
        /** UNTRANSLATED */ identities: "Your linked social identities",
        /** UNTRANSLATED */ "urn:logto:scope:organizations": "Your organizations info",
        /** UNTRANSLATED */ "urn:logto:scope:organization_roles": "Your organization roles",
        /** UNTRANSLATED */ address: "Your address"
    }
};
var $40601c8052153f4b$export$2e2bcd8739ae039 = Object.freeze($40601c8052153f4b$var$user_scopes);


const $3f3e9d7b87582b94$var$zh_hk = {
    translation: {
        input: $2feef9af2b49fce3$export$2e2bcd8739ae039,
        secondary: $a12c4e914a5af113$export$2e2bcd8739ae039,
        action: $4ffff31c7496f349$export$2e2bcd8739ae039,
        description: $0222c322a1dfd94a$export$2e2bcd8739ae039,
        error: $348f266e8f63b9c9$export$2e2bcd8739ae039,
        list: $f7787533cbad375a$export$2e2bcd8739ae039,
        mfa: $c4bb9c3f7955cba1$export$2e2bcd8739ae039,
        development_tenant: $881c17774e22fd53$export$2e2bcd8739ae039,
        user_scopes: $40601c8052153f4b$export$2e2bcd8739ae039
    }
};
var $3f3e9d7b87582b94$export$2e2bcd8739ae039 = Object.freeze($3f3e9d7b87582b94$var$zh_hk);


const $82d828448aab784a$var$action = {
    sign_in: "登錄",
    continue: "繼續",
    create_account: "註冊",
    create_account_without_linking: "註冊新的帳號",
    create: "註冊",
    enter_passcode: "輸入驗證碼",
    confirm: "確認",
    cancel: "取消",
    save_password: "保存密碼",
    bind: "綁定到 {{address}}",
    bind_and_continue: "綁定並繼續",
    back: "返回",
    nav_back: "返回",
    nav_skip: "跳過",
    agree: "同意",
    got_it: "知道了",
    sign_in_with: "通過 {{name}} 繼續",
    forgot_password: "忘記密碼？",
    switch_to: "切換到{{method}}",
    sign_in_via_passcode: "用驗證碼登錄",
    sign_in_via_password: "密碼登錄",
    change: "更改{{method}}",
    link_another_email: "綁定其他郵箱",
    link_another_phone: "綁定其他手機",
    link_another_email_or_phone: "綁定郵箱或手機號",
    show_password: "顯示密碼",
    copy: "複製",
    verify_via_passkey: "透過 Passkey 驗證",
    download: "下載",
    single_sign_on: "單點登錄",
    /** UNTRANSLATED */ authorize: "Authorize",
    /** UNTRANSLATED */ use_another_account: "Use another account"
};
var $82d828448aab784a$export$2e2bcd8739ae039 = Object.freeze($82d828448aab784a$var$action);


const $261628ab6645b89d$var$description = {
    email: "郵箱",
    phone_number: "手機號碼",
    username: "用戶名",
    reminder: "提示",
    not_found: "404 頁面不存在",
    agree_with_terms: "我已閱讀並同意 ",
    agree_with_terms_modal: "請先同意<link></link>以繼續",
    terms_of_use: "使用條款",
    sign_in: "登錄",
    privacy_policy: "隱私政策",
    create_account: "創建帳號",
    or: "或",
    and: "和",
    enter_passcode: "驗證碼已經發送至你的{{address}} {{target}}",
    passcode_sent: "驗證碼已經發送",
    resend_after_seconds: "在 <span>{{seconds}}</span> 秒後重新發送",
    resend_passcode: "重新發送驗證碼",
    create_account_id_exists: "{{type}} 為 {{value}} 的帳號已存在，你要登錄嗎？",
    link_account_id_exists: " {{type}} 為 {{value}} 的帳號已註冊，你要綁定至這個帳號嗎？",
    sign_in_id_does_not_exist: "{{type}} 為 {{value}} 的帳號不存在，你要創建一個新帳號嗎？",
    sign_in_id_does_not_exist_alert: "{{type}} 為 {{value}} 的帳號不存在。",
    create_account_id_exists_alert: "{{type}} {{value}} 已綁定其他帳號。請嘗試其他{{type}}。",
    social_identity_exist: " {{type}} {{value}} 已綁定其他帳號。請嘗試其他{{type}}",
    bind_account_title: "綁定或註冊帳號",
    social_create_account: "你可以註冊一個新的帳號。",
    social_link_email: "你可以綁定其他郵箱",
    social_link_phone: "你可以綁定其他手機號碼",
    social_link_email_or_phone: "你可以綁定其他郵箱或手機號碼",
    social_bind_with_existing: "找到了一個已註冊的帳號，你可以直接綁定。",
    reset_password: "忘記密碼",
    reset_password_description: "輸入{{types, list(type: disjunction;)}}，獲取驗證碼以重設密碼。",
    new_password: "新密碼",
    set_password: "設置密碼",
    password_changed: "已重置密碼！",
    no_account: "還沒有帳號？",
    have_account: " 已有帳號？",
    enter_password: "輸入密碼",
    enter_password_for: "輸入{{method}} {{value}}對應的密碼進行登錄",
    enter_username: "設置用戶名",
    enter_username_description: "用戶名可以用來進行登錄。用戶名僅可以包含字母、數字和下劃線。",
    link_email: "綁定郵箱",
    link_phone: "綁定手機",
    link_email_or_phone: "綁定郵箱或手機號碼",
    link_email_description: "綁定郵箱以保障你的帳號安全",
    link_phone_description: "綁定手機號碼以保障你的帳號安全",
    link_email_or_phone_description: "綁定郵箱或手機號碼以保障你的帳號安全",
    continue_with_more_information: "為保障你的帳號安全，需要你補充以下信息。",
    create_your_account: "註冊你的帳號",
    sign_in_to_your_account: "登錄你的帳號",
    no_region_code_found: "沒有找到區域碼",
    verify_email: "驗證你的郵箱",
    verify_phone: "驗證你的手機號碼",
    password_requirements: "密碼{{items, list}}。",
    password_requirement: {
        length_one: "長度至少為 {{count}} 個字符",
        length_other: "長度至少為 {{count}} 個字符",
        character_types_one: "需包含 {{count}} 類型的大寫字母、小寫字母、數字和符號",
        character_types_other: "需包含 {{count}} 類型的大寫字母、小寫字母、數字和符號"
    },
    use: "使用",
    single_sign_on_email_form: "輸入你的企業電子郵件地址",
    single_sign_on_connectors_list: "您的企業已為電子郵件帳戶{{email}}啟用單一登入。您可以繼續使用以下的SSO供應商登入。",
    single_sign_on_enabled: "該帳戶已啟用單一登入",
    /** UNTRANSLATED */ authorize_title: "Authorize {{name}}",
    /** UNTRANSLATED */ request_permission: "{{name}} is requesting access to:",
    /** UNTRANSLATED */ grant_organization_access: "Grant the organization access:",
    /** UNTRANSLATED */ user_scopes: "Personal user data",
    /** UNTRANSLATED */ organization_scopes: "Organization access",
    /** UNTRANSLATED */ authorize_agreement: `By authorize the access, you agree to the {{name}}'s <link></link>.`,
    /** UNTRANSLATED */ not_you: "Not you?",
    /** UNTRANSLATED */ user_id: "User ID: {{id}}",
    /** UNTRANSLATED */ redirect_to: "You will be redirected to {{name}}."
};
var $261628ab6645b89d$export$2e2bcd8739ae039 = Object.freeze($261628ab6645b89d$var$description);


const $205ab678f0ae6a7b$var$development_tenant = {
    notification: "你處於開發模式"
};
var $205ab678f0ae6a7b$export$2e2bcd8739ae039 = Object.freeze($205ab678f0ae6a7b$var$development_tenant);


const $aa7e5b980a40d606$var$password_rejected = {
    too_short: "最少需要 {{min}} 位字元。",
    too_long: "最多只能有 {{max}} 位字元。",
    character_types: "至少需要 {{min}} 種不同的字元類型。",
    unsupported_characters: "發現不支援的字元。",
    pwned: "請避免使用容易被猜中的簡單密碼。",
    restricted_found: "請避免過度使用 {{list, list}}。",
    restricted: {
        repetition: "連續重複的字元",
        sequence: "連續的字元",
        user_info: "個人資訊",
        words: "使用產品相關的字詞"
    }
};
var $aa7e5b980a40d606$export$2e2bcd8739ae039 = Object.freeze($aa7e5b980a40d606$var$password_rejected);


const $3808d5158c5ee9ad$var$error = {
    general_required: "{{types, list(type: disjunction;)}}必填",
    general_invalid: "無效的{{types, list(type: disjunction;)}}",
    username_required: "使用者名稱必填",
    password_required: "密碼必填",
    username_exists: "使用者名稱已存在",
    username_should_not_start_with_number: "使用者名稱不能以數字開頭",
    username_invalid_charset: "使用者名稱只能包含英文字母、數字或下劃線。",
    invalid_email: "無效的郵箱",
    invalid_phone: "無效的手機號",
    passwords_do_not_match: "兩次輸入的密碼不一致，請重試。",
    invalid_passcode: "無效的驗證碼",
    invalid_connector_auth: "登錄失敗",
    invalid_connector_request: "無效的登錄請求",
    unknown: "未知錯誤，請稍後重試。",
    invalid_session: "未找到會話，請返回並重新登錄。",
    timeout: "請求超時，請稍後重試。",
    password_rejected: $aa7e5b980a40d606$export$2e2bcd8739ae039,
    sso_not_enabled: "此郵箱帳戶未啟用單一登錄。"
};
var $3808d5158c5ee9ad$export$2e2bcd8739ae039 = Object.freeze($3808d5158c5ee9ad$var$error);


const $4026b84509fa5cad$var$input = {
    username: "用戶名",
    password: "密碼",
    email: "電子郵件",
    phone_number: "手機號碼",
    confirm_password: "確認密碼",
    search_region_code: "搜尋區域碼",
    backup_code: "備用碼"
};
var $4026b84509fa5cad$export$2e2bcd8739ae039 = Object.freeze($4026b84509fa5cad$var$input);


const $24e2451fddad1a55$var$list = {
    or: "或",
    and: "和",
    separator: "，"
};
var $24e2451fddad1a55$export$2e2bcd8739ae039 = Object.freeze($24e2451fddad1a55$var$list);


const $5e542a0488eb3a73$var$mfa = {
    totp: "身份驗證應用 OTP",
    webauthn: "通行證",
    backup_code: "備份代碼",
    link_totp_description: "例如，Google Authenticator 等。",
    link_webauthn_description: "鏈接您的設備或 USB 硬件",
    link_backup_code_description: "生成備份代碼",
    verify_totp_description: "在應用程序中輸入一次性代碼",
    verify_webauthn_description: "驗證您的設備或 USB 硬件",
    verify_backup_code_description: "粘貼您保存的備份代碼",
    add_mfa_factors: "添加兩步驗證",
    add_mfa_description: "已啟用兩步驗證。選擇第二種驗證方法進行安全登錄。",
    verify_mfa_factors: "兩步驗證",
    verify_mfa_description: "此帳戶已啟用兩步驗證。請選擇第二種驗證身份的方式。",
    add_authenticator_app: "添加身份驗證應用",
    step: "步驟 {{step, number}}: {{content}}",
    scan_qr_code: "掃描此 QR 碼",
    scan_qr_code_description: "使用身份驗證應用程序（如 Google Authenticator、Duo Mobile、Authy 等）掃描以下 QR 碼。",
    qr_code_not_available: "無法掃描 QR 碼？",
    copy_and_paste_key: "複製並粘貼密鑰",
    copy_and_paste_key_description: "將以下密鑰複製並粘貼到身份驗證應用程序中，如 Google Authenticator、Duo Mobile、Authy 等。",
    want_to_scan_qr_code: "想要掃描 QR 碼嗎？",
    enter_one_time_code: "輸入一次性代碼",
    enter_one_time_code_link_description: "輸入身份驗證應用生成的 6 位驗證碼。",
    enter_one_time_code_description: "此帳戶啟用了兩步驗證。請輸入在您關聯的認證應用中顯示的一次性代碼。",
    link_another_mfa_factor: "切換到另一種方法",
    save_backup_code: "保存您的備份代碼",
    save_backup_code_description: "如果在其他方式的兩步驗證中遇到問題，您可以使用這些備份代碼之一訪問您的帳戶。每個代碼只能使用一次。",
    backup_code_hint: "確保複製它們並保存在安全的地方。",
    enter_a_backup_code: "輸入備份代碼",
    enter_backup_code_description: "輸入初始啟用兩步驗證時保存的備份代碼。",
    create_a_passkey: "創建通行證",
    create_passkey_description: "使用設備生物識別、安全密鑰（例如 YubiKey）或其他可用方法註冊您的通行證。",
    try_another_verification_method: "嘗試其他驗證方法",
    verify_via_passkey: "通過通行證驗證",
    verify_via_passkey_description: "使用通行證通過設備密碼或生物識別、掃描 QR 碼或使用 USB 安全密鑰（如 YubiKey）進行驗證。",
    secret_key_copied: "密鑰已複製。",
    backup_code_copied: "備份代碼已複製。",
    webauthn_not_ready: "WebAuthn 尚未準備就緒。請稍後重試。",
    webauthn_not_supported: "此瀏覽器不支援 WebAuthn。",
    webauthn_failed_to_create: "創建失敗。請重試。",
    webauthn_failed_to_verify: "驗證失敗。請重試。"
};
var $5e542a0488eb3a73$export$2e2bcd8739ae039 = Object.freeze($5e542a0488eb3a73$var$mfa);


const $47f800bd0a977c08$var$secondary = {
    social_bind_with: "綁定到已有帳戶？使用 {{methods，list(type：disjunction;)，zhOrSpaces}} 登入並綁定。"
};
var $47f800bd0a977c08$export$2e2bcd8739ae039 = Object.freeze($47f800bd0a977c08$var$secondary);


const $2f3544d8ae9d4f98$var$user_scopes = {
    descriptions: {
        /** UNTRANSLATED */ custom_data: "Your custom data",
        /** UNTRANSLATED */ email: "Your email address",
        /** UNTRANSLATED */ phone: "Your phone number",
        /** UNTRANSLATED */ profile: "Your name, username, avatar, and other profile info",
        /** UNTRANSLATED */ roles: "Your roles",
        /** UNTRANSLATED */ identities: "Your linked social identities",
        /** UNTRANSLATED */ "urn:logto:scope:organizations": "Your organizations info",
        /** UNTRANSLATED */ "urn:logto:scope:organization_roles": "Your organization roles",
        /** UNTRANSLATED */ address: "Your address"
    }
};
var $2f3544d8ae9d4f98$export$2e2bcd8739ae039 = Object.freeze($2f3544d8ae9d4f98$var$user_scopes);


const $a7bc2ca1a4b2cd0d$var$zh_tw = {
    translation: {
        input: $4026b84509fa5cad$export$2e2bcd8739ae039,
        secondary: $47f800bd0a977c08$export$2e2bcd8739ae039,
        action: $82d828448aab784a$export$2e2bcd8739ae039,
        description: $261628ab6645b89d$export$2e2bcd8739ae039,
        error: $3808d5158c5ee9ad$export$2e2bcd8739ae039,
        list: $24e2451fddad1a55$export$2e2bcd8739ae039,
        mfa: $5e542a0488eb3a73$export$2e2bcd8739ae039,
        development_tenant: $205ab678f0ae6a7b$export$2e2bcd8739ae039,
        user_scopes: $2f3544d8ae9d4f98$export$2e2bcd8739ae039
    }
};
var $a7bc2ca1a4b2cd0d$export$2e2bcd8739ae039 = Object.freeze($a7bc2ca1a4b2cd0d$var$zh_tw);


const $882a56a1515c0b96$export$651548ae3cf5e245 = [
    "de",
    "en",
    "es",
    "fr",
    "it",
    "ja",
    "ko",
    "pl-PL",
    "pt-PT",
    "pt-BR",
    "ru",
    "tr-TR",
    "zh-CN",
    "zh-HK",
    "zh-TW"
];
const $882a56a1515c0b96$export$91d555a17bb93dc7 = $882a56a1515c0b96$export$651548ae3cf5e245.map((languageTag)=>({
        value: languageTag,
        title: (0, $6bd3c4907d3be429$export$d0d68bb9ed2c643d)[languageTag]
    }));
const $882a56a1515c0b96$export$5ac61cba82e41a23 = (0, $db5e9db6ef1a480f$export$2e2bcd8739ae039).enum($882a56a1515c0b96$export$651548ae3cf5e245);
const $882a56a1515c0b96$var$resource = {
    de: $5b0671ce25d71bc2$export$2e2bcd8739ae039,
    en: $7959f66baa72ceb2$export$2e2bcd8739ae039,
    es: $42b851f3e35aa8ef$export$2e2bcd8739ae039,
    fr: $9a4174cdd99ec5a3$export$2e2bcd8739ae039,
    it: $0c60d1aa166e8b9b$export$2e2bcd8739ae039,
    ja: $248a3f867fd893fa$export$2e2bcd8739ae039,
    ko: $bc760d237821fbb7$export$2e2bcd8739ae039,
    "pl-PL": (0, $0f974191227b33f7$export$2e2bcd8739ae039),
    "pt-PT": (0, $7dcf521217d3a81b$export$2e2bcd8739ae039),
    "pt-BR": (0, $f4a53d345243d0b8$export$2e2bcd8739ae039),
    ru: $0ef4b8c3c8055d80$export$2e2bcd8739ae039,
    "tr-TR": (0, $a04478c9d68e0cae$export$2e2bcd8739ae039),
    "zh-CN": (0, $42e382f27811bd49$export$2e2bcd8739ae039),
    "zh-HK": (0, $3f3e9d7b87582b94$export$2e2bcd8739ae039),
    "zh-TW": (0, $a7bc2ca1a4b2cd0d$export$2e2bcd8739ae039)
};
const $882a56a1515c0b96$export$559ef0bafb7e082f = (language)=>$882a56a1515c0b96$export$5ac61cba82e41a23.or((0, $c6adf4a17941b3cf$export$bcd1dd1f397bba12)("en")).parse(language);
const $882a56a1515c0b96$export$562f9b4f03c85f6c = (language)=>$882a56a1515c0b96$export$5ac61cba82e41a23.safeParse(language).success;
var $882a56a1515c0b96$export$2e2bcd8739ae039 = $882a56a1515c0b96$var$resource;





var $c07c92a0dc846bcc$var$arr = [];
var $c07c92a0dc846bcc$var$each = $c07c92a0dc846bcc$var$arr.forEach;
var $c07c92a0dc846bcc$var$slice = $c07c92a0dc846bcc$var$arr.slice;
function $c07c92a0dc846bcc$var$defaults(obj) {
    $c07c92a0dc846bcc$var$each.call($c07c92a0dc846bcc$var$slice.call(arguments, 1), function(source) {
        if (source) {
            for(var prop in source)if (obj[prop] === undefined) obj[prop] = source[prop];
        }
    });
    return obj;
}
// eslint-disable-next-line no-control-regex
var $c07c92a0dc846bcc$var$fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
var $c07c92a0dc846bcc$var$serializeCookie = function serializeCookie(name, val, options) {
    var opt = options || {};
    opt.path = opt.path || "/";
    var value = encodeURIComponent(val);
    var str = "".concat(name, "=").concat(value);
    if (opt.maxAge > 0) {
        var maxAge = opt.maxAge - 0;
        if (Number.isNaN(maxAge)) throw new Error("maxAge should be a Number");
        str += "; Max-Age=".concat(Math.floor(maxAge));
    }
    if (opt.domain) {
        if (!$c07c92a0dc846bcc$var$fieldContentRegExp.test(opt.domain)) throw new TypeError("option domain is invalid");
        str += "; Domain=".concat(opt.domain);
    }
    if (opt.path) {
        if (!$c07c92a0dc846bcc$var$fieldContentRegExp.test(opt.path)) throw new TypeError("option path is invalid");
        str += "; Path=".concat(opt.path);
    }
    if (opt.expires) {
        if (typeof opt.expires.toUTCString !== "function") throw new TypeError("option expires is invalid");
        str += "; Expires=".concat(opt.expires.toUTCString());
    }
    if (opt.httpOnly) str += "; HttpOnly";
    if (opt.secure) str += "; Secure";
    if (opt.sameSite) {
        var sameSite = typeof opt.sameSite === "string" ? opt.sameSite.toLowerCase() : opt.sameSite;
        switch(sameSite){
            case true:
                str += "; SameSite=Strict";
                break;
            case "lax":
                str += "; SameSite=Lax";
                break;
            case "strict":
                str += "; SameSite=Strict";
                break;
            case "none":
                str += "; SameSite=None";
                break;
            default:
                throw new TypeError("option sameSite is invalid");
        }
    }
    return str;
};
var $c07c92a0dc846bcc$var$cookie = {
    create: function create(name, value, minutes, domain) {
        var cookieOptions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
            path: "/",
            sameSite: "strict"
        };
        if (minutes) {
            cookieOptions.expires = new Date();
            cookieOptions.expires.setTime(cookieOptions.expires.getTime() + minutes * 60000);
        }
        if (domain) cookieOptions.domain = domain;
        document.cookie = $c07c92a0dc846bcc$var$serializeCookie(name, encodeURIComponent(value), cookieOptions);
    },
    read: function read(name) {
        var nameEQ = "".concat(name, "=");
        var ca = document.cookie.split(";");
        for(var i = 0; i < ca.length; i++){
            var c = ca[i];
            while(c.charAt(0) === " ")c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    },
    remove: function remove(name) {
        this.create(name, "", -1);
    }
};
var $c07c92a0dc846bcc$var$cookie$1 = {
    name: "cookie",
    lookup: function lookup(options) {
        var found;
        if (options.lookupCookie && typeof document !== "undefined") {
            var c = $c07c92a0dc846bcc$var$cookie.read(options.lookupCookie);
            if (c) found = c;
        }
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupCookie && typeof document !== "undefined") $c07c92a0dc846bcc$var$cookie.create(options.lookupCookie, lng, options.cookieMinutes, options.cookieDomain, options.cookieOptions);
    }
};
var $c07c92a0dc846bcc$var$querystring = {
    name: "querystring",
    lookup: function lookup(options) {
        var found;
        if (typeof window !== "undefined") {
            var search = window.location.search;
            if (!window.location.search && window.location.hash && window.location.hash.indexOf("?") > -1) search = window.location.hash.substring(window.location.hash.indexOf("?"));
            var query = search.substring(1);
            var params = query.split("&");
            for(var i = 0; i < params.length; i++){
                var pos = params[i].indexOf("=");
                if (pos > 0) {
                    var key = params[i].substring(0, pos);
                    if (key === options.lookupQuerystring) found = params[i].substring(pos + 1);
                }
            }
        }
        return found;
    }
};
var $c07c92a0dc846bcc$var$hasLocalStorageSupport = null;
var $c07c92a0dc846bcc$var$localStorageAvailable = function localStorageAvailable() {
    if ($c07c92a0dc846bcc$var$hasLocalStorageSupport !== null) return $c07c92a0dc846bcc$var$hasLocalStorageSupport;
    try {
        $c07c92a0dc846bcc$var$hasLocalStorageSupport = window !== "undefined" && window.localStorage !== null;
        var testKey = "i18next.translate.boo";
        window.localStorage.setItem(testKey, "foo");
        window.localStorage.removeItem(testKey);
    } catch (e) {
        $c07c92a0dc846bcc$var$hasLocalStorageSupport = false;
    }
    return $c07c92a0dc846bcc$var$hasLocalStorageSupport;
};
var $c07c92a0dc846bcc$var$localStorage = {
    name: "localStorage",
    lookup: function lookup(options) {
        var found;
        if (options.lookupLocalStorage && $c07c92a0dc846bcc$var$localStorageAvailable()) {
            var lng = window.localStorage.getItem(options.lookupLocalStorage);
            if (lng) found = lng;
        }
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupLocalStorage && $c07c92a0dc846bcc$var$localStorageAvailable()) window.localStorage.setItem(options.lookupLocalStorage, lng);
    }
};
var $c07c92a0dc846bcc$var$hasSessionStorageSupport = null;
var $c07c92a0dc846bcc$var$sessionStorageAvailable = function sessionStorageAvailable() {
    if ($c07c92a0dc846bcc$var$hasSessionStorageSupport !== null) return $c07c92a0dc846bcc$var$hasSessionStorageSupport;
    try {
        $c07c92a0dc846bcc$var$hasSessionStorageSupport = window !== "undefined" && window.sessionStorage !== null;
        var testKey = "i18next.translate.boo";
        window.sessionStorage.setItem(testKey, "foo");
        window.sessionStorage.removeItem(testKey);
    } catch (e) {
        $c07c92a0dc846bcc$var$hasSessionStorageSupport = false;
    }
    return $c07c92a0dc846bcc$var$hasSessionStorageSupport;
};
var $c07c92a0dc846bcc$var$sessionStorage = {
    name: "sessionStorage",
    lookup: function lookup(options) {
        var found;
        if (options.lookupSessionStorage && $c07c92a0dc846bcc$var$sessionStorageAvailable()) {
            var lng = window.sessionStorage.getItem(options.lookupSessionStorage);
            if (lng) found = lng;
        }
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupSessionStorage && $c07c92a0dc846bcc$var$sessionStorageAvailable()) window.sessionStorage.setItem(options.lookupSessionStorage, lng);
    }
};
var $c07c92a0dc846bcc$var$navigator$1 = {
    name: "navigator",
    lookup: function lookup(options) {
        var found = [];
        if (typeof navigator !== "undefined") {
            if (navigator.languages) // chrome only; not an array, so can't use .push.apply instead of iterating
            for(var i = 0; i < navigator.languages.length; i++)found.push(navigator.languages[i]);
            if (navigator.userLanguage) found.push(navigator.userLanguage);
            if (navigator.language) found.push(navigator.language);
        }
        return found.length > 0 ? found : undefined;
    }
};
var $c07c92a0dc846bcc$var$htmlTag = {
    name: "htmlTag",
    lookup: function lookup(options) {
        var found;
        var htmlTag = options.htmlTag || (typeof document !== "undefined" ? document.documentElement : null);
        if (htmlTag && typeof htmlTag.getAttribute === "function") found = htmlTag.getAttribute("lang");
        return found;
    }
};
var $c07c92a0dc846bcc$var$path = {
    name: "path",
    lookup: function lookup(options) {
        var found;
        if (typeof window !== "undefined") {
            var language = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
            if (language instanceof Array) {
                if (typeof options.lookupFromPathIndex === "number") {
                    if (typeof language[options.lookupFromPathIndex] !== "string") return undefined;
                    found = language[options.lookupFromPathIndex].replace("/", "");
                } else found = language[0].replace("/", "");
            }
        }
        return found;
    }
};
var $c07c92a0dc846bcc$var$subdomain = {
    name: "subdomain",
    lookup: function lookup(options) {
        // If given get the subdomain index else 1
        var lookupFromSubdomainIndex = typeof options.lookupFromSubdomainIndex === "number" ? options.lookupFromSubdomainIndex + 1 : 1;
        // get all matches if window.location. is existing
        // first item of match is the match itself and the second is the first group macht which sould be the first subdomain match
        // is the hostname no public domain get the or option of localhost
        var language = typeof window !== "undefined" && window.location && window.location.hostname && window.location.hostname.match(/^(\w{2,5})\.(([a-z0-9-]{1,63}\.[a-z]{2,6})|localhost)/i);
        // if there is no match (null) return undefined
        if (!language) return undefined;
        // return the given group match
        return language[lookupFromSubdomainIndex];
    }
};
function $c07c92a0dc846bcc$var$getDefaults() {
    return {
        order: [
            "querystring",
            "cookie",
            "localStorage",
            "sessionStorage",
            "navigator",
            "htmlTag"
        ],
        lookupQuerystring: "lng",
        lookupCookie: "i18next",
        lookupLocalStorage: "i18nextLng",
        lookupSessionStorage: "i18nextLng",
        // cache user language
        caches: [
            "localStorage"
        ],
        excludeCacheFor: [
            "cimode"
        ]
    };
}
var $c07c92a0dc846bcc$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Browser(services) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $f42f85cb8d7a52b7$export$2e2bcd8739ae039)(this, Browser);
        this.type = "languageDetector";
        this.detectors = {};
        this.init(services, options);
    }
    (0, $50f997bda58ccb7c$export$2e2bcd8739ae039)(Browser, [
        {
            key: "init",
            value: function init(services) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var i18nOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                this.services = services;
                this.options = $c07c92a0dc846bcc$var$defaults(options, this.options || {}, $c07c92a0dc846bcc$var$getDefaults());
                // backwards compatibility
                if (this.options.lookupFromUrlIndex) this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex;
                this.i18nOptions = i18nOptions;
                this.addDetector($c07c92a0dc846bcc$var$cookie$1);
                this.addDetector($c07c92a0dc846bcc$var$querystring);
                this.addDetector($c07c92a0dc846bcc$var$localStorage);
                this.addDetector($c07c92a0dc846bcc$var$sessionStorage);
                this.addDetector($c07c92a0dc846bcc$var$navigator$1);
                this.addDetector($c07c92a0dc846bcc$var$htmlTag);
                this.addDetector($c07c92a0dc846bcc$var$path);
                this.addDetector($c07c92a0dc846bcc$var$subdomain);
            }
        },
        {
            key: "addDetector",
            value: function addDetector(detector) {
                this.detectors[detector.name] = detector;
            }
        },
        {
            key: "detect",
            value: function detect(detectionOrder) {
                var _this = this;
                if (!detectionOrder) detectionOrder = this.options.order;
                var detected = [];
                detectionOrder.forEach(function(detectorName) {
                    if (_this.detectors[detectorName]) {
                        var lookup = _this.detectors[detectorName].lookup(_this.options);
                        if (lookup && typeof lookup === "string") lookup = [
                            lookup
                        ];
                        if (lookup) detected = detected.concat(lookup);
                    }
                });
                if (this.services.languageUtils.getBestMatchFromCodes) return detected; // new i18next v19.5.0
                return detected.length > 0 ? detected[0] : null; // a little backward compatibility
            }
        },
        {
            key: "cacheUserLanguage",
            value: function cacheUserLanguage(lng, caches) {
                var _this2 = this;
                if (!caches) caches = this.options.caches;
                if (!caches) return;
                if (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(lng) > -1) return;
                caches.forEach(function(cacheName) {
                    if (_this2.detectors[cacheName]) _this2.detectors[cacheName].cacheUserLanguage(lng, _this2.options);
                });
            }
        }
    ]);
    return Browser;
}();
$c07c92a0dc846bcc$export$2e2bcd8739ae039.type = "languageDetector";


/**
 * Used to get and general sign-in experience settings.
 * The API will be deprecated in the future once SSR is implemented.
 */ 
/*! MIT License © Sindre Sorhus */ 

// eslint-lint-disable-next-line @typescript-eslint/naming-convention
class $78de8ebe19ed87e8$export$aa9d629c530f62a7 extends Error {
    constructor(response, request, options){
        const code = response.status || response.status === 0 ? response.status : "";
        const title = response.statusText || "";
        const status = `${code} ${title}`.trim();
        const reason = status ? `status code ${status}` : "an unknown error";
        super(`Request failed with ${reason}`);
        Object.defineProperty(this, "response", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "request", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "options", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.name = "HTTPError";
        this.response = response;
        this.request = request;
        this.options = options;
    }
}


class $84c8ed1839a26db4$export$66d311bf29d5c89c extends Error {
    constructor(request){
        super("Request timed out");
        Object.defineProperty(this, "request", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.name = "TimeoutError";
        this.request = request;
    }
}




// eslint-disable-next-line @typescript-eslint/ban-types
const $5ed819758b87fdae$export$a6cdc56e425d0d0a = (value)=>value !== null && typeof value === "object";


const $f20f15e20e633b66$export$8886f5ba30bd5e0 = (...sources)=>{
    for (const source of sources){
        if ((!(0, $5ed819758b87fdae$export$a6cdc56e425d0d0a)(source) || Array.isArray(source)) && source !== undefined) throw new TypeError("The `options` argument must be an object");
    }
    return $f20f15e20e633b66$export$6969335ea1e4e77c({}, ...sources);
};
const $f20f15e20e633b66$export$eee1781d075786ae = (source1 = {}, source2 = {})=>{
    const result = new globalThis.Headers(source1);
    const isHeadersInstance = source2 instanceof globalThis.Headers;
    const source = new globalThis.Headers(source2);
    for (const [key, value] of source.entries())if (isHeadersInstance && value === "undefined" || value === undefined) result.delete(key);
    else result.set(key, value);
    return result;
};
const $f20f15e20e633b66$export$6969335ea1e4e77c = (...sources)=>{
    let returnValue = {};
    let headers = {};
    for (const source of sources){
        if (Array.isArray(source)) {
            if (!Array.isArray(returnValue)) returnValue = [];
            returnValue = [
                ...returnValue,
                ...source
            ];
        } else if ((0, $5ed819758b87fdae$export$a6cdc56e425d0d0a)(source)) {
            for (let [key, value] of Object.entries(source)){
                if ((0, $5ed819758b87fdae$export$a6cdc56e425d0d0a)(value) && key in returnValue) value = $f20f15e20e633b66$export$6969335ea1e4e77c(returnValue[key], value);
                returnValue = (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, returnValue), {
                    [key]: value
                });
            }
            if ((0, $5ed819758b87fdae$export$a6cdc56e425d0d0a)(source.headers)) {
                headers = $f20f15e20e633b66$export$eee1781d075786ae(headers, source.headers);
                returnValue.headers = headers;
            }
        }
    }
    return returnValue;
};




const $99b01bdd3a955b26$export$d8618555562b76b7 = (()=>{
    let duplexAccessed = false;
    let hasContentType = false;
    const supportsReadableStream = typeof globalThis.ReadableStream === "function";
    const supportsRequest = typeof globalThis.Request === "function";
    if (supportsReadableStream && supportsRequest) hasContentType = new globalThis.Request("https://empty.invalid", {
        body: new globalThis.ReadableStream(),
        method: "POST",
        // @ts-expect-error - Types are outdated.
        get duplex () {
            duplexAccessed = true;
            return "half";
        }
    }).headers.has("Content-Type");
    return duplexAccessed && !hasContentType;
})();
const $99b01bdd3a955b26$export$6c0aacaed85a4966 = typeof globalThis.AbortController === "function";
const $99b01bdd3a955b26$export$135162ac70ac2b21 = typeof globalThis.ReadableStream === "function";
const $99b01bdd3a955b26$export$f1525fa7979d0aa9 = typeof globalThis.FormData === "function";
const $99b01bdd3a955b26$export$fb003dbd6df95edb = [
    "get",
    "post",
    "put",
    "patch",
    "head",
    "delete"
];
const $99b01bdd3a955b26$var$validate = ()=>undefined;
$99b01bdd3a955b26$var$validate();
const $99b01bdd3a955b26$export$a6f212d4ee888d8c = {
    json: "application/json",
    text: "text/*",
    formData: "multipart/form-data",
    arrayBuffer: "*/*",
    blob: "*/*"
};
const $99b01bdd3a955b26$export$9b60a72e3f70a1d2 = 2147483647;
const $99b01bdd3a955b26$export$fa6813432f753b0d = Symbol("stop");
const $99b01bdd3a955b26$export$601fffa09f19102d = {
    json: true,
    parseJson: true,
    searchParams: true,
    prefixUrl: true,
    retry: true,
    timeout: true,
    hooks: true,
    throwHttpErrors: true,
    onDownloadProgress: true,
    fetch: true
};
const $99b01bdd3a955b26$export$b2ec467665ae937d = {
    method: true,
    headers: true,
    body: true,
    mode: true,
    credentials: true,
    cache: true,
    redirect: true,
    referrer: true,
    referrerPolicy: true,
    integrity: true,
    keepalive: true,
    signal: true,
    window: true,
    dispatcher: true,
    duplex: true,
    priority: true
};


const $d9fa09497c093051$export$d585027d4667ffce = (input)=>(0, $99b01bdd3a955b26$export$fb003dbd6df95edb).includes(input) ? input.toUpperCase() : input;
const $d9fa09497c093051$var$retryMethods = [
    "get",
    "put",
    "head",
    "delete",
    "options",
    "trace"
];
const $d9fa09497c093051$var$retryStatusCodes = [
    408,
    413,
    429,
    500,
    502,
    503,
    504
];
const $d9fa09497c093051$var$retryAfterStatusCodes = [
    413,
    429,
    503
];
const $d9fa09497c093051$var$defaultRetryOptions = {
    limit: 2,
    methods: $d9fa09497c093051$var$retryMethods,
    statusCodes: $d9fa09497c093051$var$retryStatusCodes,
    afterStatusCodes: $d9fa09497c093051$var$retryAfterStatusCodes,
    maxRetryAfter: Number.POSITIVE_INFINITY,
    backoffLimit: Number.POSITIVE_INFINITY,
    delay: (attemptCount)=>0.3 * 2 ** (attemptCount - 1) * 1000
};
const $d9fa09497c093051$export$3e5471bb9440c9c1 = (retry = {})=>{
    if (typeof retry === "number") return (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, $d9fa09497c093051$var$defaultRetryOptions), {
        limit: retry
    });
    if (retry.methods && !Array.isArray(retry.methods)) throw new Error("retry.methods must be an array");
    if (retry.statusCodes && !Array.isArray(retry.statusCodes)) throw new Error("retry.statusCodes must be an array");
    return (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, $d9fa09497c093051$var$defaultRetryOptions, retry), {
        afterStatusCodes: $d9fa09497c093051$var$retryAfterStatusCodes
    });
};



async function $3293d7d343f927b5$export$2e2bcd8739ae039(request, init, abortController, options) {
    return new Promise((resolve, reject)=>{
        const timeoutId = setTimeout(()=>{
            if (abortController) abortController.abort();
            reject(new (0, $84c8ed1839a26db4$export$66d311bf29d5c89c)(request));
        }, options.timeout);
        options.fetch(request, init).then(resolve).catch(reject).then(()=>{
            clearTimeout(timeoutId);
        });
    });
}


// https://github.com/sindresorhus/delay/tree/ab98ae8dfcb38e1593286c94d934e70d14a4e111
async function $9b48a863e5551412$export$2e2bcd8739ae039(ms, { signal: signal }) {
    return new Promise((resolve, reject)=>{
        if (signal) {
            signal.throwIfAborted();
            signal.addEventListener("abort", abortHandler, {
                once: true
            });
        }
        function abortHandler() {
            clearTimeout(timeoutId);
            reject(signal.reason);
        }
        const timeoutId = setTimeout(()=>{
            signal === null || signal === void 0 ? void 0 : signal.removeEventListener("abort", abortHandler);
            resolve();
        }, ms);
    });
}



const $7d2032e9ec29d9a8$export$95d8775889ec941f = (request, options)=>{
    const unknownOptions = {};
    for(const key in options)if (!(key in (0, $99b01bdd3a955b26$export$b2ec467665ae937d)) && !(key in (0, $99b01bdd3a955b26$export$601fffa09f19102d)) && !(key in request)) unknownOptions[key] = options[key];
    return unknownOptions;
};



class $188a34da84d13333$export$c482d6f00e170af3 {
    static create(input, options) {
        const ky = new $188a34da84d13333$export$c482d6f00e170af3(input, options);
        const function_ = async ()=>{
            if (typeof ky._options.timeout === "number" && ky._options.timeout > (0, $99b01bdd3a955b26$export$9b60a72e3f70a1d2)) throw new RangeError(`The \`timeout\` option cannot be greater than ${(0, $99b01bdd3a955b26$export$9b60a72e3f70a1d2)}`);
            // Delay the fetch so that body method shortcuts can set the Accept header
            await Promise.resolve();
            let response = await ky._fetch();
            for (const hook of ky._options.hooks.afterResponse){
                // eslint-disable-next-line no-await-in-loop
                const modifiedResponse = await hook(ky.request, ky._options, ky._decorateResponse(response.clone()));
                if (modifiedResponse instanceof globalThis.Response) response = modifiedResponse;
            }
            ky._decorateResponse(response);
            if (!response.ok && ky._options.throwHttpErrors) {
                let error = new (0, $78de8ebe19ed87e8$export$aa9d629c530f62a7)(response, ky.request, ky._options);
                for (const hook of ky._options.hooks.beforeError)// eslint-disable-next-line no-await-in-loop
                error = await hook(error);
                throw error;
            }
            // If `onDownloadProgress` is passed, it uses the stream API internally
            /* istanbul ignore next */ if (ky._options.onDownloadProgress) {
                if (typeof ky._options.onDownloadProgress !== "function") throw new TypeError("The `onDownloadProgress` option must be a function");
                if (!(0, $99b01bdd3a955b26$export$135162ac70ac2b21)) throw new Error("Streams are not supported in your environment. `ReadableStream` is missing.");
                return ky._stream(response.clone(), ky._options.onDownloadProgress);
            }
            return response;
        };
        const isRetriableMethod = ky._options.retry.methods.includes(ky.request.method.toLowerCase());
        const result = isRetriableMethod ? ky._retry(function_) : function_();
        for (const [type, mimeType] of Object.entries((0, $99b01bdd3a955b26$export$a6f212d4ee888d8c)))result[type] = async ()=>{
            // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
            ky.request.headers.set("accept", ky.request.headers.get("accept") || mimeType);
            const awaitedResult = await result;
            const response = awaitedResult.clone();
            if (type === "json") {
                if (response.status === 204) return "";
                const arrayBuffer = await response.clone().arrayBuffer();
                const responseSize = arrayBuffer.byteLength;
                if (responseSize === 0) return "";
                if (options.parseJson) return options.parseJson(await response.text());
            }
            return response[type]();
        };
        return result;
    }
    _calculateRetryDelay(error) {
        this._retryCount++;
        if (this._retryCount <= this._options.retry.limit && !(error instanceof (0, $84c8ed1839a26db4$export$66d311bf29d5c89c))) {
            if (error instanceof (0, $78de8ebe19ed87e8$export$aa9d629c530f62a7)) {
                if (!this._options.retry.statusCodes.includes(error.response.status)) return 0;
                const retryAfter = error.response.headers.get("Retry-After");
                if (retryAfter && this._options.retry.afterStatusCodes.includes(error.response.status)) {
                    let after = Number(retryAfter);
                    if (Number.isNaN(after)) after = Date.parse(retryAfter) - Date.now();
                    else after *= 1000;
                    if (this._options.retry.maxRetryAfter !== undefined && after > this._options.retry.maxRetryAfter) return 0;
                    return after;
                }
                if (error.response.status === 413) return 0;
            }
            const retryDelay = this._options.retry.delay(this._retryCount);
            return Math.min(this._options.retry.backoffLimit, retryDelay);
        }
        return 0;
    }
    _decorateResponse(response) {
        if (this._options.parseJson) response.json = async ()=>this._options.parseJson(await response.text());
        return response;
    }
    async _retry(function_) {
        try {
            return await function_();
        } catch (error) {
            const ms = Math.min(this._calculateRetryDelay(error), (0, $99b01bdd3a955b26$export$9b60a72e3f70a1d2));
            if (ms !== 0 && this._retryCount > 0) {
                await (0, $9b48a863e5551412$export$2e2bcd8739ae039)(ms, {
                    signal: this._options.signal
                });
                for (const hook of this._options.hooks.beforeRetry){
                    // eslint-disable-next-line no-await-in-loop
                    const hookResult = await hook({
                        request: this.request,
                        options: this._options,
                        error: error,
                        retryCount: this._retryCount
                    });
                    // If `stop` is returned from the hook, the retry process is stopped
                    if (hookResult === (0, $99b01bdd3a955b26$export$fa6813432f753b0d)) return;
                }
                return this._retry(function_);
            }
            throw error;
        }
    }
    async _fetch() {
        for (const hook of this._options.hooks.beforeRequest){
            // eslint-disable-next-line no-await-in-loop
            const result = await hook(this.request, this._options);
            if (result instanceof Request) {
                this.request = result;
                break;
            }
            if (result instanceof Response) return result;
        }
        const nonRequestOptions = (0, $7d2032e9ec29d9a8$export$95d8775889ec941f)(this.request, this._options);
        if (this._options.timeout === false) return this._options.fetch(this.request.clone(), nonRequestOptions);
        return (0, $3293d7d343f927b5$export$2e2bcd8739ae039)(this.request.clone(), nonRequestOptions, this.abortController, this._options);
    }
    /* istanbul ignore next */ _stream(response, onDownloadProgress) {
        const totalBytes = Number(response.headers.get("content-length")) || 0;
        let transferredBytes = 0;
        if (response.status === 204) {
            if (onDownloadProgress) onDownloadProgress({
                percent: 1,
                totalBytes: totalBytes,
                transferredBytes: transferredBytes
            }, new Uint8Array());
            return new globalThis.Response(null, {
                status: response.status,
                statusText: response.statusText,
                headers: response.headers
            });
        }
        return new globalThis.Response(new globalThis.ReadableStream({
            async start (controller) {
                const reader = response.body.getReader();
                if (onDownloadProgress) onDownloadProgress({
                    percent: 0,
                    transferredBytes: 0,
                    totalBytes: totalBytes
                }, new Uint8Array());
                async function read() {
                    const { done: done, value: value } = await reader.read();
                    if (done) {
                        controller.close();
                        return;
                    }
                    if (onDownloadProgress) {
                        transferredBytes += value.byteLength;
                        const percent = totalBytes === 0 ? 0 : transferredBytes / totalBytes;
                        onDownloadProgress({
                            percent: percent,
                            transferredBytes: transferredBytes,
                            totalBytes: totalBytes
                        }, value);
                    }
                    controller.enqueue(value);
                    await read();
                }
                await read();
            }
        }), {
            status: response.status,
            statusText: response.statusText,
            headers: response.headers
        });
    }
    // eslint-disable-next-line complexity
    constructor(input, options = {}){
        Object.defineProperty(this, "request", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "abortController", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_retryCount", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "_input", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_options", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._input = input;
        const credentials = this._input instanceof Request && "credentials" in Request.prototype ? this._input.credentials : undefined;
        var _options_method, _options_timeout, _options_fetch;
        this._options = (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, credentials && {
            credentials: credentials
        }, options), {
            headers: (0, $f20f15e20e633b66$export$eee1781d075786ae)(this._input.headers, options.headers),
            hooks: (0, $f20f15e20e633b66$export$6969335ea1e4e77c)({
                beforeRequest: [],
                beforeRetry: [],
                beforeError: [],
                afterResponse: []
            }, options.hooks),
            method: (0, $d9fa09497c093051$export$d585027d4667ffce)((_options_method = options.method) !== null && _options_method !== void 0 ? _options_method : this._input.method),
            // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
            prefixUrl: String(options.prefixUrl || ""),
            retry: (0, $d9fa09497c093051$export$3e5471bb9440c9c1)(options.retry),
            throwHttpErrors: options.throwHttpErrors !== false,
            timeout: (_options_timeout = options.timeout) !== null && _options_timeout !== void 0 ? _options_timeout : 10000,
            fetch: (_options_fetch = options.fetch) !== null && _options_fetch !== void 0 ? _options_fetch : globalThis.fetch.bind(globalThis)
        });
        if (typeof this._input !== "string" && !(this._input instanceof URL || this._input instanceof globalThis.Request)) throw new TypeError("`input` must be a string, URL, or Request");
        if (this._options.prefixUrl && typeof this._input === "string") {
            if (this._input.startsWith("/")) throw new Error("`input` must not begin with a slash when using `prefixUrl`");
            if (!this._options.prefixUrl.endsWith("/")) this._options.prefixUrl += "/";
            this._input = this._options.prefixUrl + this._input;
        }
        if (0, $99b01bdd3a955b26$export$6c0aacaed85a4966) {
            this.abortController = new globalThis.AbortController();
            if (this._options.signal) {
                const originalSignal = this._options.signal;
                this._options.signal.addEventListener("abort", ()=>{
                    this.abortController.abort(originalSignal.reason);
                });
            }
            this._options.signal = this.abortController.signal;
        }
        if (0, $99b01bdd3a955b26$export$d8618555562b76b7) // @ts-expect-error - Types are outdated.
        this._options.duplex = "half";
        this.request = new globalThis.Request(this._input, this._options);
        if (this._options.searchParams) {
            // eslint-disable-next-line unicorn/prevent-abbreviations
            const textSearchParams = typeof this._options.searchParams === "string" ? this._options.searchParams.replace(/^\?/, "") : new URLSearchParams(this._options.searchParams).toString();
            // eslint-disable-next-line unicorn/prevent-abbreviations
            const searchParams = "?" + textSearchParams;
            const url = this.request.url.replace(/(?:\?.*?)?(?=#|$)/, searchParams);
            // To provide correct form boundary, Content-Type header should be deleted each time when new Request instantiated from another one
            if (((0, $99b01bdd3a955b26$export$f1525fa7979d0aa9) && this._options.body instanceof globalThis.FormData || this._options.body instanceof URLSearchParams) && !(this._options.headers && this._options.headers["content-type"])) this.request.headers.delete("content-type");
            // The spread of `this.request` is required as otherwise it misses the `duplex` option for some reason and throws.
            this.request = new globalThis.Request(new globalThis.Request(url, (0, $0de5391da8318002$export$581ff339ea0ba762)({}, this.request)), this._options);
        }
        if (this._options.json !== undefined) {
            this._options.body = JSON.stringify(this._options.json);
            var _this__options_headers_get;
            this.request.headers.set("content-type", (_this__options_headers_get = this._options.headers.get("content-type")) !== null && _this__options_headers_get !== void 0 ? _this__options_headers_get : "application/json");
            this.request = new globalThis.Request(this.request, {
                body: this._options.body
            });
        }
    }
}






const $f1067a5e706ab1d5$var$createInstance = (defaults)=>{
    // eslint-disable-next-line @typescript-eslint/promise-function-async
    const ky = (input, options)=>(0, $188a34da84d13333$export$c482d6f00e170af3).create(input, (0, $f20f15e20e633b66$export$8886f5ba30bd5e0)(defaults, options));
    for (const method of (0, $99b01bdd3a955b26$export$fb003dbd6df95edb))// eslint-disable-next-line @typescript-eslint/promise-function-async
    ky[method] = (input, options)=>(0, $188a34da84d13333$export$c482d6f00e170af3).create(input, (0, $f20f15e20e633b66$export$8886f5ba30bd5e0)(defaults, options, {
            method: method
        }));
    ky.create = (newDefaults)=>$f1067a5e706ab1d5$var$createInstance((0, $f20f15e20e633b66$export$8886f5ba30bd5e0)(newDefaults));
    ky.extend = (newDefaults)=>$f1067a5e706ab1d5$var$createInstance((0, $f20f15e20e633b66$export$8886f5ba30bd5e0)(defaults, newDefaults));
    ky.stop = (0, $99b01bdd3a955b26$export$fa6813432f753b0d);
    return ky;
};
const $f1067a5e706ab1d5$var$ky = $f1067a5e706ab1d5$var$createInstance();
var $f1067a5e706ab1d5$export$2e2bcd8739ae039 = $f1067a5e706ab1d5$var$ky;


const $43897e40155c833c$export$7b45cbfd4fd1e917 = Object.freeze({
    noCache: "no_cache"
});
const $43897e40155c833c$export$24c2f7fddd6751e5 = ()=>{
    const { search: search } = window.location;
    if (!search) return;
    const parameters = new URLSearchParams(search);
    if (parameters.get($43897e40155c833c$export$7b45cbfd4fd1e917.noCache) !== null) sessionStorage.setItem($43897e40155c833c$export$7b45cbfd4fd1e917.noCache, "true");
};


const $940df709877d34cf$var$buildSearchParameters = (record)=>{
    const entries = Object.entries(record).filter((entry)=>Boolean(entry[0] && entry[1]));
    return (0, $dd763c2393b0d659$export$c327da55a124987a)(entries.length > 0 && entries);
};
const $940df709877d34cf$export$acc5aa4723208a61 = async ()=>{
    return (0, $f1067a5e706ab1d5$export$2e2bcd8739ae039).get("/api/.well-known/sign-in-exp", {
        searchParams: $940df709877d34cf$var$buildSearchParameters({
            [(0, $43897e40155c833c$export$7b45cbfd4fd1e917).noCache]: sessionStorage.getItem((0, $43897e40155c833c$export$7b45cbfd4fd1e917).noCache)
        })
    }).json();
};
const $940df709877d34cf$export$bc4d46b9876ba37 = async ({ localLanguage: localLanguage, language: language })=>(0, $f1067a5e706ab1d5$export$2e2bcd8739ae039).extend({
        hooks: {
            beforeRequest: [
                (request)=>{
                    if (localLanguage) request.headers.set("Accept-Language", localLanguage);
                }
            ]
        }
    }).get("/api/.well-known/phrases", {
        searchParams: $940df709877d34cf$var$buildSearchParameters({
            [(0, $43897e40155c833c$export$7b45cbfd4fd1e917).noCache]: sessionStorage.getItem((0, $43897e40155c833c$export$7b45cbfd4fd1e917).noCache),
            lng: language
        })
    });


const $92b5b3d2d00a4086$export$ac7fcc5388462ab3 = async (language)=>{
    const detectedLanguage = $92b5b3d2d00a4086$export$ae9ea24a1b29b07c();
    try {
        const response = await (0, $940df709877d34cf$export$bc4d46b9876ba37)({
            localLanguage: Array.isArray(detectedLanguage) ? detectedLanguage.join(" ") : detectedLanguage,
            language: language
        });
        const phrases = await response.json();
        const lng = response.headers.get("Content-Language");
        if (!lng) throw new Error("lng not found");
        return {
            resources: {
                [lng]: phrases
            },
            lng: lng
        };
    } catch (e) {
        // Fallback to build in en
        return {
            resources: {
                en: (0, $882a56a1515c0b96$export$2e2bcd8739ae039).en
            },
            lng: "en"
        };
    }
};
const $92b5b3d2d00a4086$var$storageKey = "i18nextLogtoUiLng";
const $92b5b3d2d00a4086$export$ae9ea24a1b29b07c = (languageSettings)=>{
    if ((languageSettings === null || languageSettings === void 0 ? void 0 : languageSettings.autoDetect) === false) return languageSettings.fallbackLanguage;
    const languageDetector = new (0, $c07c92a0dc846bcc$export$2e2bcd8739ae039)();
    languageDetector.init(// Pass in a empty i18n languageUtils server instance to bypass the [languageDetector detection](https://github.com/i18next/i18next-browser-languageDetector/blob/master/src/index.js#L70)
    {
        languageUtils: {}
    }, {
        lookupLocalStorage: $92b5b3d2d00a4086$var$storageKey,
        lookupSessionStorage: $92b5b3d2d00a4086$var$storageKey
    });
    return languageDetector.detect();
};
const $92b5b3d2d00a4086$export$61465194746e7fd2 = async (language)=>{
    const { resources: resources, lng: lng } = await $92b5b3d2d00a4086$export$ac7fcc5388462ab3(language);
    var _resources_lng;
    for (const [namespace, resource] of Object.entries((_resources_lng = resources[lng]) !== null && _resources_lng !== void 0 ? _resources_lng : {}))(0, $86e325ac3ddbcfa1$export$2e2bcd8739ae039).addResourceBundle(lng, namespace, resource);
    await (0, $86e325ac3ddbcfa1$export$2e2bcd8739ae039).changeLanguage(lng);
};


// Call once globally
(0, $86e325ac3ddbcfa1$export$2e2bcd8739ae039).use((0, $8a6682c3b52eb927$export$ae7e14d40d89f296));
const $69e6fdd584e929f8$var$initI18n = async (initialLanguage)=>{
    var /**
   * Note
   * - Must call after i18next is initialized
   * - Don't worry to call this multiple times, i18next will replace the formatter if it's already added.
   */ _i18next_services_formatter;
    const { resources: resources, lng: lng } = await (0, $92b5b3d2d00a4086$export$ac7fcc5388462ab3)(initialLanguage);
    const options = {
        resources: resources,
        lng: lng,
        interpolation: {
            escapeValue: false
        }
    };
    const i18n = (0, $86e325ac3ddbcfa1$export$2e2bcd8739ae039).init(options);
    (_i18next_services_formatter = (0, $86e325ac3ddbcfa1$export$2e2bcd8739ae039).services.formatter) === null || _i18next_services_formatter === void 0 ? void 0 : _i18next_services_formatter.add("zhOrSpaces", (value, lng)=>{
        if (lng !== "zh-CN") return value;
        return value.replaceAll(/或/g, " 或 ");
    });
    return i18n;
};
var $69e6fdd584e929f8$export$2e2bcd8739ae039 = $69e6fdd584e929f8$var$initI18n;




var $6b1416e8e4d304fe$export$12e44e23ec720850;
(function(UserFlow) {
    UserFlow["SignIn"] = "sign-in";
    UserFlow["Register"] = "register";
    UserFlow["ForgotPassword"] = "forgot-password";
    UserFlow["Continue"] = "continue";
})($6b1416e8e4d304fe$export$12e44e23ec720850 || ($6b1416e8e4d304fe$export$12e44e23ec720850 = {}));
var $6b1416e8e4d304fe$export$6a49be5b3307a2d;
(function(UserMfaFlow) {
    UserMfaFlow["MfaBinding"] = "mfa-binding";
    UserMfaFlow["MfaVerification"] = "mfa-verification";
})($6b1416e8e4d304fe$export$6a49be5b3307a2d || ($6b1416e8e4d304fe$export$6a49be5b3307a2d = {}));
var $6b1416e8e4d304fe$export$c4eb3ba4f04fab5;
(function(SearchParameters) {
    SearchParameters["NativeCallbackLink"] = "native_callback";
    SearchParameters["RedirectTo"] = "redirect_to";
    SearchParameters["LinkSocial"] = "link_social";
})($6b1416e8e4d304fe$export$c4eb3ba4f04fab5 || ($6b1416e8e4d304fe$export$c4eb3ba4f04fab5 = {}));


/**
 *  base64.ts
 *
 *  Licensed under the BSD 3-Clause License.
 *    http://opensource.org/licenses/BSD-3-Clause
 *
 *  References:
 *    http://en.wikipedia.org/wiki/Base64
 *
 * @author Dan Kogai (https://github.com/dankogai)
 */ /*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $e79507a12544c5d3$export$a143d493d941bafc;
var $e79507a12544c5d3$export$e4cf37d7f6fb9e0a;
var $e79507a12544c5d3$export$f99ded8fe4b79145;
var $e79507a12544c5d3$export$599f31c3813fae4d;
"use strict";
var $d3066c22f7e953ca$export$a48f0734ac7c2329;
var $d3066c22f7e953ca$export$d622b2ad8d90c771;
var $d3066c22f7e953ca$export$6100ba28696e12de;
"use strict";
$d3066c22f7e953ca$export$a48f0734ac7c2329 = $d3066c22f7e953ca$var$byteLength;
$d3066c22f7e953ca$export$d622b2ad8d90c771 = $d3066c22f7e953ca$var$toByteArray;
$d3066c22f7e953ca$export$6100ba28696e12de = $d3066c22f7e953ca$var$fromByteArray;
var $d3066c22f7e953ca$var$lookup = [];
var $d3066c22f7e953ca$var$revLookup = [];
var $d3066c22f7e953ca$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $d3066c22f7e953ca$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $d3066c22f7e953ca$var$i = 0, $d3066c22f7e953ca$var$len = $d3066c22f7e953ca$var$code.length; $d3066c22f7e953ca$var$i < $d3066c22f7e953ca$var$len; ++$d3066c22f7e953ca$var$i){
    $d3066c22f7e953ca$var$lookup[$d3066c22f7e953ca$var$i] = $d3066c22f7e953ca$var$code[$d3066c22f7e953ca$var$i];
    $d3066c22f7e953ca$var$revLookup[$d3066c22f7e953ca$var$code.charCodeAt($d3066c22f7e953ca$var$i)] = $d3066c22f7e953ca$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$d3066c22f7e953ca$var$revLookup["-".charCodeAt(0)] = 62;
$d3066c22f7e953ca$var$revLookup["_".charCodeAt(0)] = 63;
function $d3066c22f7e953ca$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $d3066c22f7e953ca$var$byteLength(b64) {
    var lens = $d3066c22f7e953ca$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $d3066c22f7e953ca$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $d3066c22f7e953ca$var$toByteArray(b64) {
    var tmp;
    var lens = $d3066c22f7e953ca$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $d3066c22f7e953ca$var$Arr($d3066c22f7e953ca$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $d3066c22f7e953ca$var$revLookup[b64.charCodeAt(i)] << 18 | $d3066c22f7e953ca$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $d3066c22f7e953ca$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $d3066c22f7e953ca$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $d3066c22f7e953ca$var$revLookup[b64.charCodeAt(i)] << 2 | $d3066c22f7e953ca$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $d3066c22f7e953ca$var$revLookup[b64.charCodeAt(i)] << 10 | $d3066c22f7e953ca$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $d3066c22f7e953ca$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $d3066c22f7e953ca$var$tripletToBase64(num) {
    return $d3066c22f7e953ca$var$lookup[num >> 18 & 0x3F] + $d3066c22f7e953ca$var$lookup[num >> 12 & 0x3F] + $d3066c22f7e953ca$var$lookup[num >> 6 & 0x3F] + $d3066c22f7e953ca$var$lookup[num & 0x3F];
}
function $d3066c22f7e953ca$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($d3066c22f7e953ca$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $d3066c22f7e953ca$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($d3066c22f7e953ca$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($d3066c22f7e953ca$var$lookup[tmp >> 2] + $d3066c22f7e953ca$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($d3066c22f7e953ca$var$lookup[tmp >> 10] + $d3066c22f7e953ca$var$lookup[tmp >> 4 & 0x3F] + $d3066c22f7e953ca$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $d5c2e28429be8713$export$aafa59e2e03f2942;
var $d5c2e28429be8713$export$68d8715fc104d294;
$d5c2e28429be8713$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$d5c2e28429be8713$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


var $e79507a12544c5d3$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$e79507a12544c5d3$export$a143d493d941bafc = $e79507a12544c5d3$var$Buffer;
$e79507a12544c5d3$export$e4cf37d7f6fb9e0a = $e79507a12544c5d3$var$SlowBuffer;
$e79507a12544c5d3$export$f99ded8fe4b79145 = 50;
var $e79507a12544c5d3$var$K_MAX_LENGTH = 0x7fffffff;
$e79507a12544c5d3$export$599f31c3813fae4d = $e79507a12544c5d3$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $e79507a12544c5d3$var$Buffer.TYPED_ARRAY_SUPPORT = $e79507a12544c5d3$var$typedArraySupport();
if (!$e79507a12544c5d3$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $e79507a12544c5d3$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($e79507a12544c5d3$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$e79507a12544c5d3$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($e79507a12544c5d3$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$e79507a12544c5d3$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $e79507a12544c5d3$var$createBuffer(length) {
    if (length > $e79507a12544c5d3$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $e79507a12544c5d3$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $e79507a12544c5d3$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $e79507a12544c5d3$var$allocUnsafe(arg);
    }
    return $e79507a12544c5d3$var$from(arg, encodingOrOffset, length);
}
$e79507a12544c5d3$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $e79507a12544c5d3$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $e79507a12544c5d3$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $e79507a12544c5d3$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($e79507a12544c5d3$var$isInstance(value, ArrayBuffer) || value && $e79507a12544c5d3$var$isInstance(value.buffer, ArrayBuffer)) return $e79507a12544c5d3$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($e79507a12544c5d3$var$isInstance(value, SharedArrayBuffer) || value && $e79507a12544c5d3$var$isInstance(value.buffer, SharedArrayBuffer))) return $e79507a12544c5d3$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $e79507a12544c5d3$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $e79507a12544c5d3$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $e79507a12544c5d3$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $e79507a12544c5d3$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $e79507a12544c5d3$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($e79507a12544c5d3$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($e79507a12544c5d3$var$Buffer, Uint8Array);
function $e79507a12544c5d3$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $e79507a12544c5d3$var$alloc(size, fill, encoding) {
    $e79507a12544c5d3$var$assertSize(size);
    if (size <= 0) return $e79507a12544c5d3$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $e79507a12544c5d3$var$createBuffer(size).fill(fill, encoding) : $e79507a12544c5d3$var$createBuffer(size).fill(fill);
    return $e79507a12544c5d3$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $e79507a12544c5d3$var$Buffer.alloc = function(size, fill, encoding) {
    return $e79507a12544c5d3$var$alloc(size, fill, encoding);
};
function $e79507a12544c5d3$var$allocUnsafe(size) {
    $e79507a12544c5d3$var$assertSize(size);
    return $e79507a12544c5d3$var$createBuffer(size < 0 ? 0 : $e79507a12544c5d3$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $e79507a12544c5d3$var$Buffer.allocUnsafe = function(size) {
    return $e79507a12544c5d3$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $e79507a12544c5d3$var$Buffer.allocUnsafeSlow = function(size) {
    return $e79507a12544c5d3$var$allocUnsafe(size);
};
function $e79507a12544c5d3$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$e79507a12544c5d3$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    var length = $e79507a12544c5d3$var$byteLength(string, encoding) | 0;
    var buf = $e79507a12544c5d3$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $e79507a12544c5d3$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $e79507a12544c5d3$var$checked(array.length) | 0;
    var buf = $e79507a12544c5d3$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $e79507a12544c5d3$var$fromArrayView(arrayView) {
    if ($e79507a12544c5d3$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $e79507a12544c5d3$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $e79507a12544c5d3$var$fromArrayLike(arrayView);
}
function $e79507a12544c5d3$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $e79507a12544c5d3$var$Buffer.prototype);
    return buf;
}
function $e79507a12544c5d3$var$fromObject(obj) {
    if ($e79507a12544c5d3$var$Buffer.isBuffer(obj)) {
        var len = $e79507a12544c5d3$var$checked(obj.length) | 0;
        var buf = $e79507a12544c5d3$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $e79507a12544c5d3$var$numberIsNaN(obj.length)) return $e79507a12544c5d3$var$createBuffer(0);
        return $e79507a12544c5d3$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $e79507a12544c5d3$var$fromArrayLike(obj.data);
}
function $e79507a12544c5d3$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $e79507a12544c5d3$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $e79507a12544c5d3$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $e79507a12544c5d3$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $e79507a12544c5d3$var$Buffer.alloc(+length);
}
$e79507a12544c5d3$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $e79507a12544c5d3$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$e79507a12544c5d3$var$Buffer.compare = function compare(a, b) {
    if ($e79507a12544c5d3$var$isInstance(a, Uint8Array)) a = $e79507a12544c5d3$var$Buffer.from(a, a.offset, a.byteLength);
    if ($e79507a12544c5d3$var$isInstance(b, Uint8Array)) b = $e79507a12544c5d3$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$e79507a12544c5d3$var$Buffer.isBuffer(a) || !$e79507a12544c5d3$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$e79507a12544c5d3$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$e79507a12544c5d3$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $e79507a12544c5d3$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $e79507a12544c5d3$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($e79507a12544c5d3$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $e79507a12544c5d3$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$e79507a12544c5d3$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $e79507a12544c5d3$var$byteLength(string, encoding) {
    if ($e79507a12544c5d3$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $e79507a12544c5d3$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $e79507a12544c5d3$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $e79507a12544c5d3$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $e79507a12544c5d3$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$e79507a12544c5d3$var$Buffer.byteLength = $e79507a12544c5d3$var$byteLength;
function $e79507a12544c5d3$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $e79507a12544c5d3$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $e79507a12544c5d3$var$utf8Slice(this, start, end);
        case "ascii":
            return $e79507a12544c5d3$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $e79507a12544c5d3$var$latin1Slice(this, start, end);
        case "base64":
            return $e79507a12544c5d3$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $e79507a12544c5d3$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$e79507a12544c5d3$var$Buffer.prototype._isBuffer = true;
function $e79507a12544c5d3$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$e79507a12544c5d3$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$e79507a12544c5d3$var$swap(this, i, i + 1);
    return this;
};
$e79507a12544c5d3$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $e79507a12544c5d3$var$swap(this, i, i + 3);
        $e79507a12544c5d3$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$e79507a12544c5d3$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $e79507a12544c5d3$var$swap(this, i, i + 7);
        $e79507a12544c5d3$var$swap(this, i + 1, i + 6);
        $e79507a12544c5d3$var$swap(this, i + 2, i + 5);
        $e79507a12544c5d3$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$e79507a12544c5d3$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $e79507a12544c5d3$var$utf8Slice(this, 0, length);
    return $e79507a12544c5d3$var$slowToString.apply(this, arguments);
};
$e79507a12544c5d3$var$Buffer.prototype.toLocaleString = $e79507a12544c5d3$var$Buffer.prototype.toString;
$e79507a12544c5d3$var$Buffer.prototype.equals = function equals(b) {
    if (!$e79507a12544c5d3$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $e79507a12544c5d3$var$Buffer.compare(this, b) === 0;
};
$e79507a12544c5d3$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $e79507a12544c5d3$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($e79507a12544c5d3$var$customInspectSymbol) $e79507a12544c5d3$var$Buffer.prototype[$e79507a12544c5d3$var$customInspectSymbol] = $e79507a12544c5d3$var$Buffer.prototype.inspect;
$e79507a12544c5d3$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($e79507a12544c5d3$var$isInstance(target, Uint8Array)) target = $e79507a12544c5d3$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$e79507a12544c5d3$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $e79507a12544c5d3$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($e79507a12544c5d3$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $e79507a12544c5d3$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($e79507a12544c5d3$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $e79507a12544c5d3$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $e79507a12544c5d3$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $e79507a12544c5d3$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$e79507a12544c5d3$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$e79507a12544c5d3$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $e79507a12544c5d3$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$e79507a12544c5d3$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $e79507a12544c5d3$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $e79507a12544c5d3$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($e79507a12544c5d3$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $e79507a12544c5d3$var$utf8Write(buf, string, offset, length) {
    return $e79507a12544c5d3$var$blitBuffer($e79507a12544c5d3$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $e79507a12544c5d3$var$asciiWrite(buf, string, offset, length) {
    return $e79507a12544c5d3$var$blitBuffer($e79507a12544c5d3$var$asciiToBytes(string), buf, offset, length);
}
function $e79507a12544c5d3$var$base64Write(buf, string, offset, length) {
    return $e79507a12544c5d3$var$blitBuffer($e79507a12544c5d3$var$base64ToBytes(string), buf, offset, length);
}
function $e79507a12544c5d3$var$ucs2Write(buf, string, offset, length) {
    return $e79507a12544c5d3$var$blitBuffer($e79507a12544c5d3$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$e79507a12544c5d3$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $e79507a12544c5d3$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $e79507a12544c5d3$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $e79507a12544c5d3$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $e79507a12544c5d3$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $e79507a12544c5d3$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$e79507a12544c5d3$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $e79507a12544c5d3$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $d3066c22f7e953ca$export$6100ba28696e12de(buf);
    else return $d3066c22f7e953ca$export$6100ba28696e12de(buf.slice(start, end));
}
function $e79507a12544c5d3$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $e79507a12544c5d3$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $e79507a12544c5d3$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $e79507a12544c5d3$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $e79507a12544c5d3$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $e79507a12544c5d3$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $e79507a12544c5d3$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $e79507a12544c5d3$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $e79507a12544c5d3$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $e79507a12544c5d3$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $e79507a12544c5d3$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$e79507a12544c5d3$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $e79507a12544c5d3$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $e79507a12544c5d3$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$e79507a12544c5d3$var$Buffer.prototype.readUintLE = $e79507a12544c5d3$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $e79507a12544c5d3$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$e79507a12544c5d3$var$Buffer.prototype.readUintBE = $e79507a12544c5d3$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $e79507a12544c5d3$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$e79507a12544c5d3$var$Buffer.prototype.readUint8 = $e79507a12544c5d3$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e79507a12544c5d3$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$e79507a12544c5d3$var$Buffer.prototype.readUint16LE = $e79507a12544c5d3$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e79507a12544c5d3$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$e79507a12544c5d3$var$Buffer.prototype.readUint16BE = $e79507a12544c5d3$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e79507a12544c5d3$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$e79507a12544c5d3$var$Buffer.prototype.readUint32LE = $e79507a12544c5d3$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e79507a12544c5d3$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$e79507a12544c5d3$var$Buffer.prototype.readUint32BE = $e79507a12544c5d3$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e79507a12544c5d3$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$e79507a12544c5d3$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $e79507a12544c5d3$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$e79507a12544c5d3$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $e79507a12544c5d3$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$e79507a12544c5d3$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e79507a12544c5d3$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$e79507a12544c5d3$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e79507a12544c5d3$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$e79507a12544c5d3$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e79507a12544c5d3$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$e79507a12544c5d3$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e79507a12544c5d3$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$e79507a12544c5d3$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e79507a12544c5d3$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$e79507a12544c5d3$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e79507a12544c5d3$var$checkOffset(offset, 4, this.length);
    return $d5c2e28429be8713$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$e79507a12544c5d3$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e79507a12544c5d3$var$checkOffset(offset, 4, this.length);
    return $d5c2e28429be8713$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$e79507a12544c5d3$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e79507a12544c5d3$var$checkOffset(offset, 8, this.length);
    return $d5c2e28429be8713$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$e79507a12544c5d3$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e79507a12544c5d3$var$checkOffset(offset, 8, this.length);
    return $d5c2e28429be8713$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $e79507a12544c5d3$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$e79507a12544c5d3$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$e79507a12544c5d3$var$Buffer.prototype.writeUintLE = $e79507a12544c5d3$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $e79507a12544c5d3$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$e79507a12544c5d3$var$Buffer.prototype.writeUintBE = $e79507a12544c5d3$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $e79507a12544c5d3$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$e79507a12544c5d3$var$Buffer.prototype.writeUint8 = $e79507a12544c5d3$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e79507a12544c5d3$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$e79507a12544c5d3$var$Buffer.prototype.writeUint16LE = $e79507a12544c5d3$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e79507a12544c5d3$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$e79507a12544c5d3$var$Buffer.prototype.writeUint16BE = $e79507a12544c5d3$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e79507a12544c5d3$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$e79507a12544c5d3$var$Buffer.prototype.writeUint32LE = $e79507a12544c5d3$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e79507a12544c5d3$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$e79507a12544c5d3$var$Buffer.prototype.writeUint32BE = $e79507a12544c5d3$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e79507a12544c5d3$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$e79507a12544c5d3$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $e79507a12544c5d3$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$e79507a12544c5d3$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $e79507a12544c5d3$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$e79507a12544c5d3$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e79507a12544c5d3$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$e79507a12544c5d3$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e79507a12544c5d3$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$e79507a12544c5d3$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e79507a12544c5d3$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$e79507a12544c5d3$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e79507a12544c5d3$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$e79507a12544c5d3$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e79507a12544c5d3$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $e79507a12544c5d3$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $e79507a12544c5d3$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e79507a12544c5d3$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $d5c2e28429be8713$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$e79507a12544c5d3$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $e79507a12544c5d3$var$writeFloat(this, value, offset, true, noAssert);
};
$e79507a12544c5d3$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $e79507a12544c5d3$var$writeFloat(this, value, offset, false, noAssert);
};
function $e79507a12544c5d3$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e79507a12544c5d3$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $d5c2e28429be8713$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$e79507a12544c5d3$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $e79507a12544c5d3$var$writeDouble(this, value, offset, true, noAssert);
};
$e79507a12544c5d3$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $e79507a12544c5d3$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$e79507a12544c5d3$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$e79507a12544c5d3$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$e79507a12544c5d3$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$e79507a12544c5d3$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $e79507a12544c5d3$var$Buffer.isBuffer(val) ? val : $e79507a12544c5d3$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $e79507a12544c5d3$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $e79507a12544c5d3$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($e79507a12544c5d3$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $e79507a12544c5d3$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $e79507a12544c5d3$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $e79507a12544c5d3$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $e79507a12544c5d3$var$base64ToBytes(str) {
    return $d3066c22f7e953ca$export$d622b2ad8d90c771($e79507a12544c5d3$var$base64clean(str));
}
function $e79507a12544c5d3$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $e79507a12544c5d3$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $e79507a12544c5d3$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $e79507a12544c5d3$var$hexSliceLookupTable = function() {
    var alphabet = "0123456789abcdef";
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();


var $7d6869fc83b379a5$require$Buffer = $e79507a12544c5d3$export$a143d493d941bafc;
const $7d6869fc83b379a5$export$83d89fbfd8236492 = "3.7.5";
/**
 * @deprecated use lowercase `version`.
 */ const $7d6869fc83b379a5$export$a4ad2735b021c132 = $7d6869fc83b379a5$export$83d89fbfd8236492;
const $7d6869fc83b379a5$var$_hasatob = typeof atob === "function";
const $7d6869fc83b379a5$var$_hasbtoa = typeof btoa === "function";
const $7d6869fc83b379a5$var$_hasBuffer = typeof $7d6869fc83b379a5$require$Buffer === "function";
const $7d6869fc83b379a5$var$_TD = typeof TextDecoder === "function" ? new TextDecoder() : undefined;
const $7d6869fc83b379a5$var$_TE = typeof TextEncoder === "function" ? new TextEncoder() : undefined;
const $7d6869fc83b379a5$var$b64ch = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
const $7d6869fc83b379a5$var$b64chs = Array.prototype.slice.call($7d6869fc83b379a5$var$b64ch);
const $7d6869fc83b379a5$var$b64tab = ((a)=>{
    let tab = {};
    a.forEach((c, i)=>tab[c] = i);
    return tab;
})($7d6869fc83b379a5$var$b64chs);
const $7d6869fc83b379a5$var$b64re = /^(?:[A-Za-z\d+\/]{4})*?(?:[A-Za-z\d+\/]{2}(?:==)?|[A-Za-z\d+\/]{3}=?)?$/;
const $7d6869fc83b379a5$var$_fromCC = String.fromCharCode.bind(String);
const $7d6869fc83b379a5$var$_U8Afrom = typeof Uint8Array.from === "function" ? Uint8Array.from.bind(Uint8Array) : (it)=>new Uint8Array(Array.prototype.slice.call(it, 0));
const $7d6869fc83b379a5$var$_mkUriSafe = (src)=>src.replace(/=/g, "").replace(/[+\/]/g, (m0)=>m0 == "+" ? "-" : "_");
const $7d6869fc83b379a5$var$_tidyB64 = (s)=>s.replace(/[^A-Za-z0-9\+\/]/g, "");
/**
 * polyfill version of `btoa`
 */ const $7d6869fc83b379a5$export$ec0fb543302ee251 = (bin)=>{
    // console.log('polyfilled');
    let u32, c0, c1, c2, asc = "";
    const pad = bin.length % 3;
    for(let i = 0; i < bin.length;){
        if ((c0 = bin.charCodeAt(i++)) > 255 || (c1 = bin.charCodeAt(i++)) > 255 || (c2 = bin.charCodeAt(i++)) > 255) throw new TypeError("invalid character found");
        u32 = c0 << 16 | c1 << 8 | c2;
        asc += $7d6869fc83b379a5$var$b64chs[u32 >> 18 & 63] + $7d6869fc83b379a5$var$b64chs[u32 >> 12 & 63] + $7d6869fc83b379a5$var$b64chs[u32 >> 6 & 63] + $7d6869fc83b379a5$var$b64chs[u32 & 63];
    }
    return pad ? asc.slice(0, pad - 3) + "===".substring(pad) : asc;
};
/**
 * does what `window.btoa` of web browsers do.
 * @param {String} bin binary string
 * @returns {string} Base64-encoded string
 */ const $7d6869fc83b379a5$export$a32219e24f8d1e2 = $7d6869fc83b379a5$var$_hasbtoa ? (bin)=>btoa(bin) : $7d6869fc83b379a5$var$_hasBuffer ? (bin)=>$7d6869fc83b379a5$require$Buffer.from(bin, "binary").toString("base64") : $7d6869fc83b379a5$export$ec0fb543302ee251;
const $7d6869fc83b379a5$var$_fromUint8Array = $7d6869fc83b379a5$var$_hasBuffer ? (u8a)=>$7d6869fc83b379a5$require$Buffer.from(u8a).toString("base64") : (u8a)=>{
    // cf. https://stackoverflow.com/questions/12710001/how-to-convert-uint8-array-to-base64-encoded-string/12713326#12713326
    const maxargs = 0x1000;
    let strs = [];
    for(let i = 0, l = u8a.length; i < l; i += maxargs)strs.push($7d6869fc83b379a5$var$_fromCC.apply(null, u8a.subarray(i, i + maxargs)));
    return $7d6869fc83b379a5$export$a32219e24f8d1e2(strs.join(""));
};
/**
 * converts a Uint8Array to a Base64 string.
 * @param {boolean} [urlsafe] URL-and-filename-safe a la RFC4648 §5
 * @returns {string} Base64 string
 */ const $7d6869fc83b379a5$export$27bbb4e040978768 = (u8a, urlsafe = false)=>urlsafe ? $7d6869fc83b379a5$var$_mkUriSafe($7d6869fc83b379a5$var$_fromUint8Array(u8a)) : $7d6869fc83b379a5$var$_fromUint8Array(u8a);
// This trick is found broken https://github.com/dankogai/js-base64/issues/130
// const utob = (src: string) => unescape(encodeURIComponent(src));
// reverting good old fationed regexp
const $7d6869fc83b379a5$var$cb_utob = (c)=>{
    if (c.length < 2) {
        var cc = c.charCodeAt(0);
        return cc < 0x80 ? c : cc < 0x800 ? $7d6869fc83b379a5$var$_fromCC(0xc0 | cc >>> 6) + $7d6869fc83b379a5$var$_fromCC(0x80 | cc & 0x3f) : $7d6869fc83b379a5$var$_fromCC(0xe0 | cc >>> 12 & 0x0f) + $7d6869fc83b379a5$var$_fromCC(0x80 | cc >>> 6 & 0x3f) + $7d6869fc83b379a5$var$_fromCC(0x80 | cc & 0x3f);
    } else {
        var cc = 0x10000 + (c.charCodeAt(0) - 0xD800) * 0x400 + (c.charCodeAt(1) - 0xDC00);
        return $7d6869fc83b379a5$var$_fromCC(0xf0 | cc >>> 18 & 0x07) + $7d6869fc83b379a5$var$_fromCC(0x80 | cc >>> 12 & 0x3f) + $7d6869fc83b379a5$var$_fromCC(0x80 | cc >>> 6 & 0x3f) + $7d6869fc83b379a5$var$_fromCC(0x80 | cc & 0x3f);
    }
};
const $7d6869fc83b379a5$var$re_utob = /[\uD800-\uDBFF][\uDC00-\uDFFFF]|[^\x00-\x7F]/g;
/**
 * @deprecated should have been internal use only.
 * @param {string} src UTF-8 string
 * @returns {string} UTF-16 string
 */ const $7d6869fc83b379a5$export$10d4b9bd20a66b0 = (u)=>u.replace($7d6869fc83b379a5$var$re_utob, $7d6869fc83b379a5$var$cb_utob);
//
const $7d6869fc83b379a5$var$_encode = $7d6869fc83b379a5$var$_hasBuffer ? (s)=>$7d6869fc83b379a5$require$Buffer.from(s, "utf8").toString("base64") : $7d6869fc83b379a5$var$_TE ? (s)=>$7d6869fc83b379a5$var$_fromUint8Array($7d6869fc83b379a5$var$_TE.encode(s)) : (s)=>$7d6869fc83b379a5$export$a32219e24f8d1e2($7d6869fc83b379a5$export$10d4b9bd20a66b0(s));
/**
 * converts a UTF-8-encoded string to a Base64 string.
 * @param {boolean} [urlsafe] if `true` make the result URL-safe
 * @returns {string} Base64 string
 */ const $7d6869fc83b379a5$export$37cc283d8fbd3462 = (src, urlsafe = false)=>urlsafe ? $7d6869fc83b379a5$var$_mkUriSafe($7d6869fc83b379a5$var$_encode(src)) : $7d6869fc83b379a5$var$_encode(src);
/**
 * converts a UTF-8-encoded string to URL-safe Base64 RFC4648 §5.
 * @returns {string} Base64 string
 */ const $7d6869fc83b379a5$export$90c31d5baa78df44 = (src)=>$7d6869fc83b379a5$export$37cc283d8fbd3462(src, true);
// This trick is found broken https://github.com/dankogai/js-base64/issues/130
// const btou = (src: string) => decodeURIComponent(escape(src));
// reverting good old fationed regexp
const $7d6869fc83b379a5$var$re_btou = /[\xC0-\xDF][\x80-\xBF]|[\xE0-\xEF][\x80-\xBF]{2}|[\xF0-\xF7][\x80-\xBF]{3}/g;
const $7d6869fc83b379a5$var$cb_btou = (cccc)=>{
    switch(cccc.length){
        case 4:
            var cp = (0x07 & cccc.charCodeAt(0)) << 18 | (0x3f & cccc.charCodeAt(1)) << 12 | (0x3f & cccc.charCodeAt(2)) << 6 | 0x3f & cccc.charCodeAt(3), offset = cp - 0x10000;
            return $7d6869fc83b379a5$var$_fromCC((offset >>> 10) + 0xD800) + $7d6869fc83b379a5$var$_fromCC((offset & 0x3FF) + 0xDC00);
        case 3:
            return $7d6869fc83b379a5$var$_fromCC((0x0f & cccc.charCodeAt(0)) << 12 | (0x3f & cccc.charCodeAt(1)) << 6 | 0x3f & cccc.charCodeAt(2));
        default:
            return $7d6869fc83b379a5$var$_fromCC((0x1f & cccc.charCodeAt(0)) << 6 | 0x3f & cccc.charCodeAt(1));
    }
};
/**
 * @deprecated should have been internal use only.
 * @param {string} src UTF-16 string
 * @returns {string} UTF-8 string
 */ const $7d6869fc83b379a5$export$67e9defdeac3dd95 = (b)=>b.replace($7d6869fc83b379a5$var$re_btou, $7d6869fc83b379a5$var$cb_btou);
/**
 * polyfill version of `atob`
 */ const $7d6869fc83b379a5$export$7f16d8e674ddec24 = (asc)=>{
    // console.log('polyfilled');
    asc = asc.replace(/\s+/g, "");
    if (!$7d6869fc83b379a5$var$b64re.test(asc)) throw new TypeError("malformed base64.");
    asc += "==".slice(2 - (asc.length & 3));
    let u24, bin = "", r1, r2;
    for(let i = 0; i < asc.length;){
        u24 = $7d6869fc83b379a5$var$b64tab[asc.charAt(i++)] << 18 | $7d6869fc83b379a5$var$b64tab[asc.charAt(i++)] << 12 | (r1 = $7d6869fc83b379a5$var$b64tab[asc.charAt(i++)]) << 6 | (r2 = $7d6869fc83b379a5$var$b64tab[asc.charAt(i++)]);
        bin += r1 === 64 ? $7d6869fc83b379a5$var$_fromCC(u24 >> 16 & 255) : r2 === 64 ? $7d6869fc83b379a5$var$_fromCC(u24 >> 16 & 255, u24 >> 8 & 255) : $7d6869fc83b379a5$var$_fromCC(u24 >> 16 & 255, u24 >> 8 & 255, u24 & 255);
    }
    return bin;
};
/**
 * does what `window.atob` of web browsers do.
 * @param {String} asc Base64-encoded string
 * @returns {string} binary string
 */ const $7d6869fc83b379a5$export$1406ac7a6dfd7b7a = $7d6869fc83b379a5$var$_hasatob ? (asc)=>atob($7d6869fc83b379a5$var$_tidyB64(asc)) : $7d6869fc83b379a5$var$_hasBuffer ? (asc)=>$7d6869fc83b379a5$require$Buffer.from(asc, "base64").toString("binary") : $7d6869fc83b379a5$export$7f16d8e674ddec24;
//
const $7d6869fc83b379a5$var$_toUint8Array = $7d6869fc83b379a5$var$_hasBuffer ? (a)=>$7d6869fc83b379a5$var$_U8Afrom($7d6869fc83b379a5$require$Buffer.from(a, "base64")) : (a)=>$7d6869fc83b379a5$var$_U8Afrom($7d6869fc83b379a5$export$1406ac7a6dfd7b7a(a).split("").map((c)=>c.charCodeAt(0)));
/**
 * converts a Base64 string to a Uint8Array.
 */ const $7d6869fc83b379a5$export$73470fd2221e6aef = (a)=>$7d6869fc83b379a5$var$_toUint8Array($7d6869fc83b379a5$var$_unURI(a));
//
const $7d6869fc83b379a5$var$_decode = $7d6869fc83b379a5$var$_hasBuffer ? (a)=>$7d6869fc83b379a5$require$Buffer.from(a, "base64").toString("utf8") : $7d6869fc83b379a5$var$_TD ? (a)=>$7d6869fc83b379a5$var$_TD.decode($7d6869fc83b379a5$var$_toUint8Array(a)) : (a)=>$7d6869fc83b379a5$export$67e9defdeac3dd95($7d6869fc83b379a5$export$1406ac7a6dfd7b7a(a));
const $7d6869fc83b379a5$var$_unURI = (a)=>$7d6869fc83b379a5$var$_tidyB64(a.replace(/[-_]/g, (m0)=>m0 == "-" ? "+" : "/"));
/**
 * converts a Base64 string to a UTF-8 string.
 * @param {String} src Base64 string.  Both normal and URL-safe are supported
 * @returns {string} UTF-8 string
 */ const $7d6869fc83b379a5$export$c537b38001c583b7 = (src)=>$7d6869fc83b379a5$var$_decode($7d6869fc83b379a5$var$_unURI(src));
/**
 * check if a value is a valid Base64 string
 * @param {String} src a value to check
  */ const $7d6869fc83b379a5$export$1ea939691cdc45b8 = (src)=>{
    if (typeof src !== "string") return false;
    const s = src.replace(/\s+/g, "").replace(/={0,2}$/, "");
    return !/[^\s0-9a-zA-Z\+/]/.test(s) || !/[^\s0-9a-zA-Z\-_]/.test(s);
};
//
const $7d6869fc83b379a5$var$_noEnum = (v)=>{
    return {
        value: v,
        enumerable: false,
        writable: true,
        configurable: true
    };
};
/**
 * extend String.prototype with relevant methods
 */ const $7d6869fc83b379a5$export$4678ebf2295c49b = function() {
    const _add = (name, body)=>Object.defineProperty(String.prototype, name, $7d6869fc83b379a5$var$_noEnum(body));
    _add("fromBase64", function() {
        return $7d6869fc83b379a5$export$c537b38001c583b7(this);
    });
    _add("toBase64", function(urlsafe) {
        return $7d6869fc83b379a5$export$37cc283d8fbd3462(this, urlsafe);
    });
    _add("toBase64URI", function() {
        return $7d6869fc83b379a5$export$37cc283d8fbd3462(this, true);
    });
    _add("toBase64URL", function() {
        return $7d6869fc83b379a5$export$37cc283d8fbd3462(this, true);
    });
    _add("toUint8Array", function() {
        return $7d6869fc83b379a5$export$73470fd2221e6aef(this);
    });
};
/**
 * extend Uint8Array.prototype with relevant methods
 */ const $7d6869fc83b379a5$export$a105d6a15258bd2 = function() {
    const _add = (name, body)=>Object.defineProperty(Uint8Array.prototype, name, $7d6869fc83b379a5$var$_noEnum(body));
    _add("toBase64", function(urlsafe) {
        return $7d6869fc83b379a5$export$27bbb4e040978768(this, urlsafe);
    });
    _add("toBase64URI", function() {
        return $7d6869fc83b379a5$export$27bbb4e040978768(this, true);
    });
    _add("toBase64URL", function() {
        return $7d6869fc83b379a5$export$27bbb4e040978768(this, true);
    });
};
/**
 * extend Builtin prototypes with relevant methods
 */ const $7d6869fc83b379a5$export$1abf1fe5ebfd5245 = ()=>{
    $7d6869fc83b379a5$export$4678ebf2295c49b();
    $7d6869fc83b379a5$export$a105d6a15258bd2();
};
const $7d6869fc83b379a5$export$f436b0c2107cbd35 = {
    version: $7d6869fc83b379a5$export$83d89fbfd8236492,
    VERSION: $7d6869fc83b379a5$export$a4ad2735b021c132,
    atob: $7d6869fc83b379a5$export$1406ac7a6dfd7b7a,
    atobPolyfill: $7d6869fc83b379a5$export$7f16d8e674ddec24,
    btoa: $7d6869fc83b379a5$export$a32219e24f8d1e2,
    btoaPolyfill: $7d6869fc83b379a5$export$ec0fb543302ee251,
    fromBase64: $7d6869fc83b379a5$export$c537b38001c583b7,
    toBase64: $7d6869fc83b379a5$export$37cc283d8fbd3462,
    encode: $7d6869fc83b379a5$export$37cc283d8fbd3462,
    encodeURI: $7d6869fc83b379a5$export$90c31d5baa78df44,
    encodeURL: $7d6869fc83b379a5$export$90c31d5baa78df44,
    utob: $7d6869fc83b379a5$export$10d4b9bd20a66b0,
    btou: $7d6869fc83b379a5$export$67e9defdeac3dd95,
    decode: $7d6869fc83b379a5$export$c537b38001c583b7,
    isValid: $7d6869fc83b379a5$export$1ea939691cdc45b8,
    fromUint8Array: $7d6869fc83b379a5$export$27bbb4e040978768,
    toUint8Array: $7d6869fc83b379a5$export$73470fd2221e6aef,
    extendString: $7d6869fc83b379a5$export$4678ebf2295c49b,
    extendUint8Array: $7d6869fc83b379a5$export$a105d6a15258bd2,
    extendBuiltins: $7d6869fc83b379a5$export$1abf1fe5ebfd5245
};


const $53aabef915cc623b$export$9e15fb06e64c4810 = (length = 8)=>(0, $7d6869fc83b379a5$export$27bbb4e040978768)(crypto.getRandomValues(new Uint8Array(length)), true);
const $53aabef915cc623b$export$2469638cb19f7e00 = (parameters)=>{
    const searchParameters = parameters instanceof URLSearchParams ? parameters : new URLSearchParams(parameters);
    return Object.fromEntries([
        ...searchParameters.entries()
    ].map(([key, value])=>[
            key,
            decodeURIComponent(value)
        ]));
};
const $53aabef915cc623b$export$160057b430cb5a30 = (parameters)=>{
    const searchParameters = parameters instanceof URLSearchParams ? parameters : new URLSearchParams(parameters);
    return searchParameters.toString();
};
const $53aabef915cc623b$export$6bcd65cae0372ddf = (parameters, key)=>{
    const searchParameters = parameters instanceof URLSearchParams ? parameters : new URLSearchParams(parameters);
    var _searchParameters_get;
    return (_searchParameters_get = searchParameters.get(key)) !== null && _searchParameters_get !== void 0 ? _searchParameters_get : undefined;
};
const $53aabef915cc623b$export$3e9f948b41964866 = (object)=>// eslint-disable-next-line no-restricted-syntax
    Object.entries(object);
const $53aabef915cc623b$export$5150077fc2e7c662 = (entries)=>// eslint-disable-next-line no-restricted-syntax
    Object.fromEntries(entries);
const $53aabef915cc623b$export$593c2aea212a54d2 = (key, object)=>key in object;


/**
 * Native SDK Utility Methods
 */ const $955117e21b41598e$export$83ff207f4052eaad = ()=>{
    if (typeof logtoNativeSdk !== "undefined") return logtoNativeSdk;
};
const $955117e21b41598e$export$a38f4a317af23d71 = ()=>{
    var _getLogtoNativeSdk;
    var _getLogtoNativeSdk_platform;
    const platform = (_getLogtoNativeSdk_platform = (_getLogtoNativeSdk = $955117e21b41598e$export$83ff207f4052eaad()) === null || _getLogtoNativeSdk === void 0 ? void 0 : _getLogtoNativeSdk.platform) !== null && _getLogtoNativeSdk_platform !== void 0 ? _getLogtoNativeSdk_platform : "";
    return [
        "ios",
        "android"
    ].includes(platform);
};


/**
 * Social Connector State Utility Methods
 */ const $a48a66106483a58a$var$storageStateKeyPrefix = "social_auth_state";
const $a48a66106483a58a$export$9ccd2716e53a229b = ()=>{
    const uuid = (0, $53aabef915cc623b$export$9e15fb06e64c4810)();
    return uuid;
};
const $a48a66106483a58a$export$ca97131192bad836 = (state, connectorId)=>{
    sessionStorage.setItem(`${$a48a66106483a58a$var$storageStateKeyPrefix}:${connectorId}`, state);
};
const $a48a66106483a58a$export$cd0e7726290ef99e = (state, connectorId)=>{
    const storageKey = `${$a48a66106483a58a$var$storageStateKeyPrefix}:${connectorId}`;
    const stateStorage = sessionStorage.getItem(storageKey);
    sessionStorage.removeItem(storageKey);
    return stateStorage === state;
};
const $a48a66106483a58a$export$4c3119be9cbddec4 = "social_callback_data";
const $a48a66106483a58a$export$89813b95fc66aafa = (path, redirectTo)=>{
    var _getLogtoNativeSdk;
    const { origin: origin } = window.location;
    const url = new URL(`${origin}${path}`);
    url.searchParams.set((0, $6b1416e8e4d304fe$export$c4eb3ba4f04fab5).RedirectTo, redirectTo);
    const callbackLink = (_getLogtoNativeSdk = (0, $955117e21b41598e$export$83ff207f4052eaad)()) === null || _getLogtoNativeSdk === void 0 ? void 0 : _getLogtoNativeSdk.callbackLink;
    if (callbackLink) url.searchParams.set((0, $6b1416e8e4d304fe$export$c4eb3ba4f04fab5).NativeCallbackLink, callbackLink);
    return url;
};
const $a48a66106483a58a$export$1532ee36eebdb77d = (connectorId, callbackLink)=>{
    sessionStorage.setItem(`${$a48a66106483a58a$export$4c3119be9cbddec4}:${connectorId}`, callbackLink);
};
const $a48a66106483a58a$export$179d5bca54e18dc6 = (connectorId)=>{
    return sessionStorage.getItem(`${$a48a66106483a58a$export$4c3119be9cbddec4}:${connectorId}`);
};
const $a48a66106483a58a$export$d02cb51c63c7e560 = (connectorId)=>{
    sessionStorage.removeItem(`${$a48a66106483a58a$export$4c3119be9cbddec4}:${connectorId}`);
};
const $a48a66106483a58a$export$a52a66b412bd435d = (socialConnectors)=>{
    if (!socialConnectors) return [];
    const connectorMap = new Map();
    /**
   * Browser Environment
   * Accepts both web and universal platform connectors.
   * Insert universal connectors only if there is no web platform connector provided with the same target.
   * Web platform has higher priority.
   **/ if (!(0, $955117e21b41598e$export$a38f4a317af23d71)()) {
        for (const connector of socialConnectors){
            const { platform: platform, target: target } = connector;
            if (platform === "Native") continue;
            if (platform === "Web" || !connectorMap.get(target)) {
                connectorMap.set(target, connector);
                continue;
            }
        }
        return Array.from(connectorMap.values());
    }
    var _getLogtoNativeSdk;
    /**
   * Native Webview Environment
   * Accepts both native and universal platform connectors.
   * Native platform has higher priority.
   **/ const { supportedConnector: supportedConnector, getPostMessage: getPostMessage, callbackLink: callbackLink } = (_getLogtoNativeSdk = (0, $955117e21b41598e$export$83ff207f4052eaad)()) !== null && _getLogtoNativeSdk !== void 0 ? _getLogtoNativeSdk : {};
    if (!getPostMessage) // Invalid Native SDK bridge injections, not able to sign in with any social connectors.
    return [];
    for (const connector of socialConnectors){
        const { platform: platform, target: target } = connector;
        if (platform === "Web") continue;
        // Native SupportedConnector Settings is required
        if (!supportedConnector) continue;
        // Native supported nativeTargets flag is required
        if (platform === "Native" && supportedConnector.nativeTargets.includes(target)) {
            connectorMap.set(target, connector);
            continue;
        }
        /**
     *  Native supportedConnector.universal flag is required
     *  Native callback link settings is required
     *  Only if there is no native platform connector provided with the same target.
     **/ if (platform === "Universal" && supportedConnector.universal && callbackLink && !connectorMap.get(target)) {
            connectorMap.set(target, connector);
            continue;
        }
    }
    return Array.from(connectorMap.values());
};
const $a48a66106483a58a$export$d5f28122a6cebc76 = (platform, socialConnectors)=>{
    if (!socialConnectors) return [];
    const connectorMap = new Map();
    /**
   * Browser Environment
   * Accepts both web and universal platform connectors.
   * Insert universal connectors only if there is no web platform connector provided with the same target.
   * Web platform has higher priority.
   **/ if (platform === (0, $a5946dc029c62388$export$e2b8cfc001e78efb).Web) {
        for (const connector of socialConnectors){
            const { platform: platform, target: target } = connector;
            if (platform === "Native") continue;
            if (platform === "Web" || !connectorMap.get(target)) {
                connectorMap.set(target, connector);
                continue;
            }
        }
        return Array.from(connectorMap.values());
    }
    /**
   * Native Webview Environment
   * Accepts both native and universal platform connectors.
   * Insert universal connectors only if there is no native platform connector provided with the same target.
   * Native platform has higher priority.
   **/ for (const connector of socialConnectors){
        const { platform: platform, target: target } = connector;
        if (platform === "Web") continue;
        if (platform === "Native" || !connectorMap.get(target)) {
            connectorMap.set(target, connector);
            continue;
        }
    }
    return Array.from(connectorMap.values());
};
const $a48a66106483a58a$export$f48dbaf6d711748a = (target)=>target === "apple";


const $0444c21692baa1d5$var$usePreview = ()=>{
    const [previewConfig, setPreviewConfig] = (0, $P551f.useState)();
    const { setTheme: setTheme, setPlatform: setPlatform, setExperienceSettings: setExperienceSettings } = (0, $P551f.useContext)((0, $bf7e93717fb1eb16$export$2e2bcd8739ae039));
    // Fetch the preview config
    (0, $P551f.useEffect)(()=>{
        // Listen to the message from the ancestor window
        const previewMessageHandler = async (event)=>{
            // #event.data should be guarded at the provider's side
            if (event.data.sender === "ac_preview") {
                // eslint-disable-next-line no-restricted-syntax
                const previewConfig = event.data.config;
                // Wait for i18n to be initialized
                await (0, $69e6fdd584e929f8$export$2e2bcd8739ae039)(previewConfig.language);
                setPreviewConfig(previewConfig);
            }
        };
        window.addEventListener("message", previewMessageHandler);
        return ()=>{
            window.removeEventListener("message", previewMessageHandler);
        };
    }, []);
    // Set Experience settings
    (0, $P551f.useEffect)(()=>{
        if (!previewConfig) return;
        const { signInExperience: { socialConnectors: socialConnectors }, isNative: isNative } = previewConfig, rest = (0, $451b529b5830e8ac$export$69fdd232f62cde60)(previewConfig.signInExperience, [
            "socialConnectors"
        ]);
        const experienceSettings = (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, rest), {
            socialConnectors: (0, $a48a66106483a58a$export$d5f28122a6cebc76)(isNative ? (0, $a5946dc029c62388$export$e2b8cfc001e78efb).Native : (0, $a5946dc029c62388$export$e2b8cfc001e78efb).Web, socialConnectors)
        });
        setExperienceSettings(experienceSettings);
    }, [
        previewConfig,
        setExperienceSettings
    ]);
    // Set Theme
    (0, $P551f.useEffect)(()=>{
        if (previewConfig === null || previewConfig === void 0 ? void 0 : previewConfig.mode) setTheme(previewConfig.mode);
    }, [
        previewConfig === null || previewConfig === void 0 ? void 0 : previewConfig.mode,
        setTheme
    ]);
    // Set Platform
    (0, $P551f.useEffect)(()=>{
        if (previewConfig === null || previewConfig === void 0 ? void 0 : previewConfig.platform) setPlatform(previewConfig.platform);
    }, [
        previewConfig === null || previewConfig === void 0 ? void 0 : previewConfig.platform,
        setPlatform
    ]);
    // Set Language
    (0, $P551f.useEffect)(()=>{
        if (previewConfig === null || previewConfig === void 0 ? void 0 : previewConfig.language) (async ()=>{
            await (0, $92b5b3d2d00a4086$export$61465194746e7fd2)(previewConfig.language);
        })();
    }, [
        previewConfig === null || previewConfig === void 0 ? void 0 : previewConfig.language
    ]);
};
var $0444c21692baa1d5$export$2e2bcd8739ae039 = $0444c21692baa1d5$var$usePreview;



var $P551f = parcelRequire("P551f");


/**
 * Temp Solution for getting the sign in experience
 * Remove this once we have a better way to get the sign in experience through SSR
 */ 






const $66bee81b081b16c8$var$parseSignInExperienceResponse = (response)=>{
    const { socialConnectors: socialConnectors } = response, rest = (0, $451b529b5830e8ac$export$69fdd232f62cde60)(response, [
        "socialConnectors"
    ]);
    return (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, rest), {
        socialConnectors: (0, $a48a66106483a58a$export$a52a66b412bd435d)(socialConnectors)
    });
};
const $66bee81b081b16c8$export$8ca2c7a89b3c710d = async ()=>{
    const response = await (0, $940df709877d34cf$export$acc5aa4723208a61)();
    return $66bee81b081b16c8$var$parseSignInExperienceResponse(response);
};
const $66bee81b081b16c8$export$627424bf77ed4c79 = (method)=>[
        (0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Email,
        (0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Phone
    ].includes(method);
const $66bee81b081b16c8$export$9eebb4c3f2056b81 = (path)=>{
    // Will update soon, remove generic of `.t()` to unblock
    if (path.startsWith("/sign-in") || path.startsWith("/callback") || path.startsWith("/consent")) return (0, $86e325ac3ddbcfa1$export$2e2bcd8739ae039).t("description.sign_in");
    if (path.startsWith("/register") || path.startsWith("/social/link")) return (0, $86e325ac3ddbcfa1$export$2e2bcd8739ae039).t("description.create_account");
    if (path.startsWith("/forgot-password")) return (0, $86e325ac3ddbcfa1$export$2e2bcd8739ae039).t("description.reset_password");
    // Return undefined for all continue flow pages to keep title remain the same as the previous page
    if (path.startsWith("/continue")) return;
    return "Logto";
};




var $P551f = parcelRequire("P551f");

const $1909951a952f4670$var$darkThemeWatchMedia = window.matchMedia("(prefers-color-scheme: dark)");
const $1909951a952f4670$var$getThemeBySystemConfiguration = ()=>$1909951a952f4670$var$darkThemeWatchMedia.matches ? (0, $93d2089b0ece27e4$export$14faa19a0f3bbeb2).Dark : (0, $93d2089b0ece27e4$export$14faa19a0f3bbeb2).Light;
function $1909951a952f4670$export$2e2bcd8739ae039() {
    const { isPreview: isPreview, experienceSettings: experienceSettings, setTheme: setTheme } = (0, $P551f.useContext)((0, $bf7e93717fb1eb16$export$2e2bcd8739ae039));
    (0, $P551f.useEffect)(()=>{
        if (!(experienceSettings === null || experienceSettings === void 0 ? void 0 : experienceSettings.color.isDarkModeEnabled)) return;
        const changeTheme = ()=>{
            setTheme($1909951a952f4670$var$getThemeBySystemConfiguration());
        };
        changeTheme();
        $1909951a952f4670$var$darkThemeWatchMedia.addEventListener("change", changeTheme);
        return ()=>{
            $1909951a952f4670$var$darkThemeWatchMedia.removeEventListener("change", changeTheme);
        };
    }, [
        experienceSettings,
        isPreview,
        setTheme
    ]);
}


const $65bde0ffb12d3da8$var$useSignInExperience = ()=>{
    const { isPreview: isPreview, setExperienceSettings: setExperienceSettings } = (0, $P551f.useContext)((0, $bf7e93717fb1eb16$export$2e2bcd8739ae039));
    (0, $1909951a952f4670$export$2e2bcd8739ae039)();
    (0, $P551f.useEffect)(()=>{
        (async ()=>{
            const [settings] = await Promise.all([
                (0, $66bee81b081b16c8$export$8ca2c7a89b3c710d)(),
                (0, $69e6fdd584e929f8$export$2e2bcd8739ae039)()
            ]);
            // Init the page settings and render
            setExperienceSettings(settings);
        })();
    }, [
        isPreview,
        setExperienceSettings
    ]);
};
var $65bde0ffb12d3da8$export$2e2bcd8739ae039 = $65bde0ffb12d3da8$var$useSignInExperience;


const $c16df7251a343c37$var$SettingsProvider = ({ children: children })=>{
    const { isPreview: isPreview, experienceSettings: experienceSettings } = (0, $P551f.useContext)((0, $bf7e93717fb1eb16$export$2e2bcd8739ae039));
    const usePageLoad = (0, $P551f.useMemo)(()=>isPreview ? (0, $0444c21692baa1d5$export$2e2bcd8739ae039) : (0, $65bde0ffb12d3da8$export$2e2bcd8739ae039), [
        isPreview
    ]);
    usePageLoad();
    return experienceSettings ? children : null;
};
var $c16df7251a343c37$export$2e2bcd8739ae039 = $c16df7251a343c37$var$SettingsProvider;




var $P551f = parcelRequire("P551f");
/**
 * Provides a hook to access the session storage.
 */ 
var $P551f = parcelRequire("P551f");
/**
 * A `StructFailure` represents a single specific failure in validation.
 */ /**
 * `StructError` objects are thrown (or returned) when validation fails.
 *
 * Validation logic is design to exit early for maximum performance. The error
 * represents the first error encountered during validation. For more detail,
 * the `error.failures` property is a generator function that can be run to
 * continue validation and receive all the failures in the data.
 */ 


class $8a18d710f1d13368$export$58cc9131e3e8861b extends TypeError {
    constructor(failure, failures){
        let cached;
        const { message: message, explanation: explanation } = failure, rest = (0, $451b529b5830e8ac$export$69fdd232f62cde60)(failure, [
            "message",
            "explanation"
        ]);
        const { path: path } = failure;
        const msg = path.length === 0 ? message : `At path: ${path.join(".")} -- ${message}`;
        super(explanation !== null && explanation !== void 0 ? explanation : msg);
        if (explanation != null) this.cause = msg;
        Object.assign(this, rest);
        this.name = this.constructor.name;
        this.failures = ()=>{
            return cached !== null && cached !== void 0 ? cached : cached = [
                failure,
                ...failures()
            ];
        };
    }
}
/**
 * Check if a value is an iterator.
 */ function $8a18d710f1d13368$var$isIterable(x) {
    return $8a18d710f1d13368$var$isObject(x) && typeof x[Symbol.iterator] === "function";
}
/**
 * Check if a value is a plain object.
 */ function $8a18d710f1d13368$var$isObject(x) {
    return typeof x === "object" && x != null;
}
/**
 * Check if a value is a plain object.
 */ function $8a18d710f1d13368$var$isPlainObject(x) {
    if (Object.prototype.toString.call(x) !== "[object Object]") return false;
    const prototype = Object.getPrototypeOf(x);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Return a value as a printable string.
 */ function $8a18d710f1d13368$var$print(value) {
    if (typeof value === "symbol") return value.toString();
    return typeof value === "string" ? JSON.stringify(value) : `${value}`;
}
/**
 * Shifts (removes and returns) the first value from the `input` iterator.
 * Like `Array.prototype.shift()` but for an `Iterator`.
 */ function $8a18d710f1d13368$var$shiftIterator(input) {
    const { done: done, value: value } = input.next();
    return done ? undefined : value;
}
/**
 * Convert a single validation result to a failure.
 */ function $8a18d710f1d13368$var$toFailure(result, context, struct, value) {
    if (result === true) return;
    else if (result === false) result = {};
    else if (typeof result === "string") result = {
        message: result
    };
    const { path: path, branch: branch } = context;
    const { type: type } = struct;
    const { refinement: refinement, message: message = `Expected a value of type \`${type}\`${refinement ? ` with refinement \`${refinement}\`` : ""}, but received: \`${$8a18d710f1d13368$var$print(value)}\`` } = result;
    return (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({
        value: value,
        type: type,
        refinement: refinement,
        key: path[path.length - 1],
        path: path,
        branch: branch
    }, result), {
        message: message
    });
}
/**
 * Convert a validation result to an iterable of failures.
 */ function* $8a18d710f1d13368$var$toFailures(result, context, struct, value) {
    if (!$8a18d710f1d13368$var$isIterable(result)) result = [
        result
    ];
    for (const r of result){
        const failure = $8a18d710f1d13368$var$toFailure(r, context, struct, value);
        if (failure) yield failure;
    }
}
/**
 * Check a value against a struct, traversing deeply into nested values, and
 * returning an iterator of failures or success.
 */ function* $8a18d710f1d13368$var$run(value, struct, options = {}) {
    const { path: path = [], branch: branch = [
        value
    ], coerce: coerce = false, mask: mask = false } = options;
    const ctx = {
        path: path,
        branch: branch
    };
    if (coerce) {
        value = struct.coercer(value, ctx);
        if (mask && struct.type !== "type" && $8a18d710f1d13368$var$isObject(struct.schema) && $8a18d710f1d13368$var$isObject(value) && !Array.isArray(value)) {
            for(const key in value)if (struct.schema[key] === undefined) delete value[key];
        }
    }
    let status = "valid";
    for (const failure of struct.validator(value, ctx)){
        failure.explanation = options.message;
        status = "not_valid";
        yield [
            failure,
            undefined
        ];
    }
    for (let [k, v, s] of struct.entries(value, ctx)){
        const ts = $8a18d710f1d13368$var$run(v, s, {
            path: k === undefined ? path : [
                ...path,
                k
            ],
            branch: k === undefined ? branch : [
                ...branch,
                v
            ],
            coerce: coerce,
            mask: mask,
            message: options.message
        });
        for (const t of ts){
            if (t[0]) {
                status = t[0].refinement != null ? "not_refined" : "not_valid";
                yield [
                    t[0],
                    undefined
                ];
            } else if (coerce) {
                v = t[1];
                if (k === undefined) value = v;
                else if (value instanceof Map) value.set(k, v);
                else if (value instanceof Set) value.add(v);
                else if ($8a18d710f1d13368$var$isObject(value)) {
                    if (v !== undefined || k in value) value[k] = v;
                }
            }
        }
    }
    if (status !== "not_valid") for (const failure of struct.refiner(value, ctx)){
        failure.explanation = options.message;
        status = "not_refined";
        yield [
            failure,
            undefined
        ];
    }
    if (status === "valid") yield [
        undefined,
        value
    ];
}
/**
 * `Struct` objects encapsulate the validation logic for a specific type of
 * values. Once constructed, you use the `assert`, `is` or `validate` helpers to
 * validate unknown input data against the struct.
 */ class $8a18d710f1d13368$export$eabc71f011df675a {
    /**
     * Assert that a value passes the struct's validation, throwing if it doesn't.
     */ assert(value, message) {
        return $8a18d710f1d13368$export$a7a9523472993e97(value, this, message);
    }
    /**
     * Create a value with the struct's coercion logic, then validate it.
     */ create(value, message) {
        return $8a18d710f1d13368$export$185802fd694ee1f5(value, this, message);
    }
    /**
     * Check if a value passes the struct's validation.
     */ is(value) {
        return $8a18d710f1d13368$export$226b3eccf92c9ed9(value, this);
    }
    /**
     * Mask a value, coercing and validating it, but returning only the subset of
     * properties defined by the struct's schema.
     */ mask(value, message) {
        return $8a18d710f1d13368$export$d99f0801a68bbcf1(value, this, message);
    }
    /**
     * Validate a value with the struct's validation logic, returning a tuple
     * representing the result.
     *
     * You may optionally pass `true` for the `withCoercion` argument to coerce
     * the value before attempting to validate it. If you do, the result will
     * contain the coerced result when successful.
     */ validate(value, options = {}) {
        return $8a18d710f1d13368$export$a22775fa5e2eebd9(value, this, options);
    }
    constructor(props){
        const { type: type, schema: schema, validator: validator, refiner: refiner, coercer: coercer = (value)=>value, entries: entries = function*() {} } = props;
        this.type = type;
        this.schema = schema;
        this.entries = entries;
        this.coercer = coercer;
        if (validator) this.validator = (value, context)=>{
            const result = validator(value, context);
            return $8a18d710f1d13368$var$toFailures(result, context, this, value);
        };
        else this.validator = ()=>[];
        if (refiner) this.refiner = (value, context)=>{
            const result = refiner(value, context);
            return $8a18d710f1d13368$var$toFailures(result, context, this, value);
        };
        else this.refiner = ()=>[];
    }
}
/**
 * Assert that a value passes a struct, throwing if it doesn't.
 */ function $8a18d710f1d13368$export$a7a9523472993e97(value, struct, message) {
    const result = $8a18d710f1d13368$export$a22775fa5e2eebd9(value, struct, {
        message: message
    });
    if (result[0]) throw result[0];
}
/**
 * Create a value with the coercion logic of struct and validate it.
 */ function $8a18d710f1d13368$export$185802fd694ee1f5(value, struct, message) {
    const result = $8a18d710f1d13368$export$a22775fa5e2eebd9(value, struct, {
        coerce: true,
        message: message
    });
    if (result[0]) throw result[0];
    else return result[1];
}
/**
 * Mask a value, returning only the subset of properties defined by a struct.
 */ function $8a18d710f1d13368$export$d99f0801a68bbcf1(value, struct, message) {
    const result = $8a18d710f1d13368$export$a22775fa5e2eebd9(value, struct, {
        coerce: true,
        mask: true,
        message: message
    });
    if (result[0]) throw result[0];
    else return result[1];
}
/**
 * Check if a value passes a struct.
 */ function $8a18d710f1d13368$export$226b3eccf92c9ed9(value, struct) {
    const result = $8a18d710f1d13368$export$a22775fa5e2eebd9(value, struct);
    return !result[0];
}
/**
 * Validate a value against a struct, returning an error if invalid, or the
 * value (with potential coercion) if valid.
 */ function $8a18d710f1d13368$export$a22775fa5e2eebd9(value, struct, options = {}) {
    const tuples = $8a18d710f1d13368$var$run(value, struct, options);
    const tuple = $8a18d710f1d13368$var$shiftIterator(tuples);
    if (tuple[0]) {
        const error = new $8a18d710f1d13368$export$58cc9131e3e8861b(tuple[0], function*() {
            for (const t of tuples)if (t[0]) yield t[0];
        });
        return [
            error,
            undefined
        ];
    } else {
        const v = tuple[1];
        return [
            undefined,
            v
        ];
    }
}
function $8a18d710f1d13368$export$e6e34fd1f2686227(...Structs) {
    const isType = Structs[0].type === "type";
    const schemas = Structs.map((s)=>s.schema);
    const schema = Object.assign({}, ...schemas);
    return isType ? $8a18d710f1d13368$export$bf9fb029d174d554(schema) : $8a18d710f1d13368$export$be5493f9613cbbe(schema);
}
/**
 * Define a new struct type with a custom validation function.
 */ function $8a18d710f1d13368$export$f36d6a7a5c09a23e(name, validator) {
    return new $8a18d710f1d13368$export$eabc71f011df675a({
        type: name,
        schema: null,
        validator: validator
    });
}
/**
 * Create a new struct based on an existing struct, but the value is allowed to
 * be `undefined`. `log` will be called if the value is not `undefined`.
 */ function $8a18d710f1d13368$export$cdd73fc4100a6ef4(struct, log) {
    return new $8a18d710f1d13368$export$eabc71f011df675a((0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, struct), {
        refiner: (value, ctx)=>value === undefined || struct.refiner(value, ctx),
        validator (value, ctx) {
            if (value === undefined) return true;
            else {
                log(value, ctx);
                return struct.validator(value, ctx);
            }
        }
    }));
}
/**
 * Create a struct with dynamic validation logic.
 *
 * The callback will receive the value currently being validated, and must
 * return a struct object to validate it with. This can be useful to model
 * validation logic that changes based on its input.
 */ function $8a18d710f1d13368$export$7077912c31975674(fn) {
    return new $8a18d710f1d13368$export$eabc71f011df675a({
        type: "dynamic",
        schema: null,
        *entries (value, ctx) {
            const struct = fn(value, ctx);
            yield* struct.entries(value, ctx);
        },
        validator (value, ctx) {
            const struct = fn(value, ctx);
            return struct.validator(value, ctx);
        },
        coercer (value, ctx) {
            const struct = fn(value, ctx);
            return struct.coercer(value, ctx);
        },
        refiner (value, ctx) {
            const struct = fn(value, ctx);
            return struct.refiner(value, ctx);
        }
    });
}
/**
 * Create a struct with lazily evaluated validation logic.
 *
 * The first time validation is run with the struct, the callback will be called
 * and must return a struct object to use. This is useful for cases where you
 * want to have self-referential structs for nested data structures to avoid a
 * circular definition problem.
 */ function $8a18d710f1d13368$export$488013bae63b21da(fn) {
    let struct;
    return new $8a18d710f1d13368$export$eabc71f011df675a({
        type: "lazy",
        schema: null,
        *entries (value, ctx) {
            struct !== null && struct !== void 0 ? struct : struct = fn();
            yield* struct.entries(value, ctx);
        },
        validator (value, ctx) {
            struct !== null && struct !== void 0 ? struct : struct = fn();
            return struct.validator(value, ctx);
        },
        coercer (value, ctx) {
            struct !== null && struct !== void 0 ? struct : struct = fn();
            return struct.coercer(value, ctx);
        },
        refiner (value, ctx) {
            struct !== null && struct !== void 0 ? struct : struct = fn();
            return struct.refiner(value, ctx);
        }
    });
}
/**
 * Create a new struct based on an existing object struct, but excluding
 * specific properties.
 *
 * Like TypeScript's `Omit` utility.
 */ function $8a18d710f1d13368$export$30a06c8d3562193f(struct, keys) {
    const { schema: schema } = struct;
    const subschema = (0, $0de5391da8318002$export$581ff339ea0ba762)({}, schema);
    for (const key of keys)delete subschema[key];
    switch(struct.type){
        case "type":
            return $8a18d710f1d13368$export$bf9fb029d174d554(subschema);
        default:
            return $8a18d710f1d13368$export$be5493f9613cbbe(subschema);
    }
}
/**
 * Create a new struct based on an existing object struct, but with all of its
 * properties allowed to be `undefined`.
 *
 * Like TypeScript's `Partial` utility.
 */ function $8a18d710f1d13368$export$e45945969df8035a(struct) {
    const schema = struct instanceof $8a18d710f1d13368$export$eabc71f011df675a ? (0, $0de5391da8318002$export$581ff339ea0ba762)({}, struct.schema) : (0, $0de5391da8318002$export$581ff339ea0ba762)({}, struct);
    for(const key in schema)schema[key] = $8a18d710f1d13368$export$516e28dec6a4b6d4(schema[key]);
    return $8a18d710f1d13368$export$be5493f9613cbbe(schema);
}
/**
 * Create a new struct based on an existing object struct, but only including
 * specific properties.
 *
 * Like TypeScript's `Pick` utility.
 */ function $8a18d710f1d13368$export$357523c63a2253b9(struct, keys) {
    const { schema: schema } = struct;
    const subschema = {};
    for (const key of keys)subschema[key] = schema[key];
    return $8a18d710f1d13368$export$be5493f9613cbbe(subschema);
}
/**
 * Define a new struct type with a custom validation function.
 *
 * @deprecated This function has been renamed to `define`.
 */ function $8a18d710f1d13368$export$8cf3da7c1c9174ea(name, validator) {
    console.warn("superstruct@0.11 - The `struct` helper has been renamed to `define`.");
    return $8a18d710f1d13368$export$f36d6a7a5c09a23e(name, validator);
}
/**
 * Ensure that any value passes validation.
 */ function $8a18d710f1d13368$export$4154a199d7d90455() {
    return $8a18d710f1d13368$export$f36d6a7a5c09a23e("any", ()=>true);
}
function $8a18d710f1d13368$export$2f23118c22fb2630(Element) {
    return new $8a18d710f1d13368$export$eabc71f011df675a({
        type: "array",
        schema: Element,
        *entries (value) {
            if (Element && Array.isArray(value)) for (const [i, v] of value.entries())yield [
                i,
                v,
                Element
            ];
        },
        coercer (value) {
            return Array.isArray(value) ? value.slice() : value;
        },
        validator (value) {
            return Array.isArray(value) || `Expected an array value, but received: ${$8a18d710f1d13368$var$print(value)}`;
        }
    });
}
/**
 * Ensure that a value is a bigint.
 */ function $8a18d710f1d13368$export$a0f65b52274bcc00() {
    return $8a18d710f1d13368$export$f36d6a7a5c09a23e("bigint", (value)=>{
        return typeof value === "bigint";
    });
}
/**
 * Ensure that a value is a boolean.
 */ function $8a18d710f1d13368$export$4a21f16c33752377() {
    return $8a18d710f1d13368$export$f36d6a7a5c09a23e("boolean", (value)=>{
        return typeof value === "boolean";
    });
}
/**
 * Ensure that a value is a valid `Date`.
 *
 * Note: this also ensures that the value is *not* an invalid `Date` object,
 * which can occur when parsing a date fails but still returns a `Date`.
 */ function $8a18d710f1d13368$export$324d90190a8b822a() {
    return $8a18d710f1d13368$export$f36d6a7a5c09a23e("date", (value)=>{
        return value instanceof Date && !isNaN(value.getTime()) || `Expected a valid \`Date\` object, but received: ${$8a18d710f1d13368$var$print(value)}`;
    });
}
function $8a18d710f1d13368$export$9b16c434df8cc259(values) {
    const schema = {};
    const description = values.map((v)=>$8a18d710f1d13368$var$print(v)).join();
    for (const key of values)schema[key] = key;
    return new $8a18d710f1d13368$export$eabc71f011df675a({
        type: "enums",
        schema: schema,
        validator (value) {
            return values.includes(value) || `Expected one of \`${description}\`, but received: ${$8a18d710f1d13368$var$print(value)}`;
        }
    });
}
/**
 * Ensure that a value is a function.
 */ function $8a18d710f1d13368$export$86951950244e2001() {
    return $8a18d710f1d13368$export$f36d6a7a5c09a23e("func", (value)=>{
        return typeof value === "function" || `Expected a function, but received: ${$8a18d710f1d13368$var$print(value)}`;
    });
}
/**
 * Ensure that a value is an instance of a specific class.
 */ function $8a18d710f1d13368$export$9544d5bb712b01ea(Class) {
    return $8a18d710f1d13368$export$f36d6a7a5c09a23e("instance", (value)=>{
        return value instanceof Class || `Expected a \`${Class.name}\` instance, but received: ${$8a18d710f1d13368$var$print(value)}`;
    });
}
/**
 * Ensure that a value is an integer.
 */ function $8a18d710f1d13368$export$32744b5b3bba4764() {
    return $8a18d710f1d13368$export$f36d6a7a5c09a23e("integer", (value)=>{
        return typeof value === "number" && !isNaN(value) && Number.isInteger(value) || `Expected an integer, but received: ${$8a18d710f1d13368$var$print(value)}`;
    });
}
/**
 * Ensure that a value matches all of a set of types.
 */ function $8a18d710f1d13368$export$bc86dfbf7795668c(Structs) {
    return new $8a18d710f1d13368$export$eabc71f011df675a({
        type: "intersection",
        schema: null,
        *entries (value, ctx) {
            for (const S of Structs)yield* S.entries(value, ctx);
        },
        *validator (value, ctx) {
            for (const S of Structs)yield* S.validator(value, ctx);
        },
        *refiner (value, ctx) {
            for (const S of Structs)yield* S.refiner(value, ctx);
        }
    });
}
function $8a18d710f1d13368$export$c8ec6e1ec9fefcb0(constant) {
    const description = $8a18d710f1d13368$var$print(constant);
    const t = typeof constant;
    return new $8a18d710f1d13368$export$eabc71f011df675a({
        type: "literal",
        schema: t === "string" || t === "number" || t === "boolean" ? constant : null,
        validator (value) {
            return value === constant || `Expected the literal \`${description}\`, but received: ${$8a18d710f1d13368$var$print(value)}`;
        }
    });
}
function $8a18d710f1d13368$export$871de8747c9eaa88(Key, Value) {
    return new $8a18d710f1d13368$export$eabc71f011df675a({
        type: "map",
        schema: null,
        *entries (value) {
            if (Key && Value && value instanceof Map) for (const [k, v] of value.entries()){
                yield [
                    k,
                    k,
                    Key
                ];
                yield [
                    k,
                    v,
                    Value
                ];
            }
        },
        coercer (value) {
            return value instanceof Map ? new Map(value) : value;
        },
        validator (value) {
            return value instanceof Map || `Expected a \`Map\` object, but received: ${$8a18d710f1d13368$var$print(value)}`;
        }
    });
}
/**
 * Ensure that no value ever passes validation.
 */ function $8a18d710f1d13368$export$b3e22bcfd64c1022() {
    return $8a18d710f1d13368$export$f36d6a7a5c09a23e("never", ()=>false);
}
/**
 * Augment an existing struct to allow `null` values.
 */ function $8a18d710f1d13368$export$133fc36489ac9add(struct) {
    return new $8a18d710f1d13368$export$eabc71f011df675a((0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, struct), {
        validator: (value, ctx)=>value === null || struct.validator(value, ctx),
        refiner: (value, ctx)=>value === null || struct.refiner(value, ctx)
    }));
}
/**
 * Ensure that a value is a number.
 */ function $8a18d710f1d13368$export$98e628dec113755e() {
    return $8a18d710f1d13368$export$f36d6a7a5c09a23e("number", (value)=>{
        return typeof value === "number" && !isNaN(value) || `Expected a number, but received: ${$8a18d710f1d13368$var$print(value)}`;
    });
}
function $8a18d710f1d13368$export$be5493f9613cbbe(schema) {
    const knowns = schema ? Object.keys(schema) : [];
    const Never = $8a18d710f1d13368$export$b3e22bcfd64c1022();
    return new $8a18d710f1d13368$export$eabc71f011df675a({
        type: "object",
        schema: schema ? schema : null,
        *entries (value) {
            if (schema && $8a18d710f1d13368$var$isObject(value)) {
                const unknowns = new Set(Object.keys(value));
                for (const key of knowns){
                    unknowns.delete(key);
                    yield [
                        key,
                        value[key],
                        schema[key]
                    ];
                }
                for (const key of unknowns)yield [
                    key,
                    value[key],
                    Never
                ];
            }
        },
        validator (value) {
            return $8a18d710f1d13368$var$isObject(value) || `Expected an object, but received: ${$8a18d710f1d13368$var$print(value)}`;
        },
        coercer (value) {
            return $8a18d710f1d13368$var$isObject(value) ? (0, $0de5391da8318002$export$581ff339ea0ba762)({}, value) : value;
        }
    });
}
/**
 * Augment a struct to allow `undefined` values.
 */ function $8a18d710f1d13368$export$516e28dec6a4b6d4(struct) {
    return new $8a18d710f1d13368$export$eabc71f011df675a((0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, struct), {
        validator: (value, ctx)=>value === undefined || struct.validator(value, ctx),
        refiner: (value, ctx)=>value === undefined || struct.refiner(value, ctx)
    }));
}
/**
 * Ensure that a value is an object with keys and values of specific types, but
 * without ensuring any specific shape of properties.
 *
 * Like TypeScript's `Record` utility.
 */ function $8a18d710f1d13368$export$e5185e241753e543(Key, Value) {
    return new $8a18d710f1d13368$export$eabc71f011df675a({
        type: "record",
        schema: null,
        *entries (value) {
            if ($8a18d710f1d13368$var$isObject(value)) for(const k in value){
                const v = value[k];
                yield [
                    k,
                    k,
                    Key
                ];
                yield [
                    k,
                    v,
                    Value
                ];
            }
        },
        validator (value) {
            return $8a18d710f1d13368$var$isObject(value) || `Expected an object, but received: ${$8a18d710f1d13368$var$print(value)}`;
        }
    });
}
/**
 * Ensure that a value is a `RegExp`.
 *
 * Note: this does not test the value against the regular expression! For that
 * you need to use the `pattern()` refinement.
 */ function $8a18d710f1d13368$export$efdc1e5bdb609bb() {
    return $8a18d710f1d13368$export$f36d6a7a5c09a23e("regexp", (value)=>{
        return value instanceof RegExp;
    });
}
function $8a18d710f1d13368$export$adaa4cf7ef1b65be(Element) {
    return new $8a18d710f1d13368$export$eabc71f011df675a({
        type: "set",
        schema: null,
        *entries (value) {
            if (Element && value instanceof Set) for (const v of value)yield [
                v,
                v,
                Element
            ];
        },
        coercer (value) {
            return value instanceof Set ? new Set(value) : value;
        },
        validator (value) {
            return value instanceof Set || `Expected a \`Set\` object, but received: ${$8a18d710f1d13368$var$print(value)}`;
        }
    });
}
/**
 * Ensure that a value is a string.
 */ function $8a18d710f1d13368$export$22b082955e083ec3() {
    return $8a18d710f1d13368$export$f36d6a7a5c09a23e("string", (value)=>{
        return typeof value === "string" || `Expected a string, but received: ${$8a18d710f1d13368$var$print(value)}`;
    });
}
/**
 * Ensure that a value is a tuple of a specific length, and that each of its
 * elements is of a specific type.
 */ function $8a18d710f1d13368$export$65e3907585753458(Structs) {
    const Never = $8a18d710f1d13368$export$b3e22bcfd64c1022();
    return new $8a18d710f1d13368$export$eabc71f011df675a({
        type: "tuple",
        schema: null,
        *entries (value) {
            if (Array.isArray(value)) {
                const length = Math.max(Structs.length, value.length);
                for(let i = 0; i < length; i++)yield [
                    i,
                    value[i],
                    Structs[i] || Never
                ];
            }
        },
        validator (value) {
            return Array.isArray(value) || `Expected an array, but received: ${$8a18d710f1d13368$var$print(value)}`;
        }
    });
}
/**
 * Ensure that a value has a set of known properties of specific types.
 *
 * Note: Unrecognized properties are allowed and untouched. This is similar to
 * how TypeScript's structural typing works.
 */ function $8a18d710f1d13368$export$bf9fb029d174d554(schema) {
    const keys = Object.keys(schema);
    return new $8a18d710f1d13368$export$eabc71f011df675a({
        type: "type",
        schema: schema,
        *entries (value) {
            if ($8a18d710f1d13368$var$isObject(value)) for (const k of keys)yield [
                k,
                value[k],
                schema[k]
            ];
        },
        validator (value) {
            return $8a18d710f1d13368$var$isObject(value) || `Expected an object, but received: ${$8a18d710f1d13368$var$print(value)}`;
        },
        coercer (value) {
            return $8a18d710f1d13368$var$isObject(value) ? (0, $0de5391da8318002$export$581ff339ea0ba762)({}, value) : value;
        }
    });
}
/**
 * Ensure that a value matches one of a set of types.
 */ function $8a18d710f1d13368$export$971dd5b0dfd021b6(Structs) {
    const description = Structs.map((s)=>s.type).join(" | ");
    return new $8a18d710f1d13368$export$eabc71f011df675a({
        type: "union",
        schema: null,
        coercer (value) {
            for (const S of Structs){
                const [error, coerced] = S.validate(value, {
                    coerce: true
                });
                if (!error) return coerced;
            }
            return value;
        },
        validator (value, ctx) {
            const failures = [];
            for (const S of Structs){
                const [...tuples] = $8a18d710f1d13368$var$run(value, S, ctx);
                const [first] = tuples;
                if (!first[0]) return [];
                else {
                    for (const [failure] of tuples)if (failure) failures.push(failure);
                }
            }
            return [
                `Expected the value to satisfy a union of \`${description}\`, but received: ${$8a18d710f1d13368$var$print(value)}`,
                ...failures
            ];
        }
    });
}
/**
 * Ensure that any value passes validation, without widening its type to `any`.
 */ function $8a18d710f1d13368$export$19282c40b967aec6() {
    return $8a18d710f1d13368$export$f36d6a7a5c09a23e("unknown", ()=>true);
}
/**
 * Augment a `Struct` to add an additional coercion step to its input.
 *
 * This allows you to transform input data before validating it, to increase the
 * likelihood that it passes validation—for example for default values, parsing
 * different formats, etc.
 *
 * Note: You must use `create(value, Struct)` on the value to have the coercion
 * take effect! Using simply `assert()` or `is()` will not use coercion.
 */ function $8a18d710f1d13368$export$8c14e57e778d3873(struct, condition, coercer) {
    return new $8a18d710f1d13368$export$eabc71f011df675a((0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, struct), {
        coercer: (value, ctx)=>{
            return $8a18d710f1d13368$export$226b3eccf92c9ed9(value, condition) ? struct.coercer(coercer(value, ctx), ctx) : struct.coercer(value, ctx);
        }
    }));
}
/**
 * Augment a struct to replace `undefined` values with a default.
 *
 * Note: You must use `create(value, Struct)` on the value to have the coercion
 * take effect! Using simply `assert()` or `is()` will not use coercion.
 */ function $8a18d710f1d13368$export$83c510c4356017ae(struct, fallback, options = {}) {
    return $8a18d710f1d13368$export$8c14e57e778d3873(struct, $8a18d710f1d13368$export$19282c40b967aec6(), (x)=>{
        const f = typeof fallback === "function" ? fallback() : fallback;
        if (x === undefined) return f;
        if (!options.strict && $8a18d710f1d13368$var$isPlainObject(x) && $8a18d710f1d13368$var$isPlainObject(f)) {
            const ret = (0, $0de5391da8318002$export$581ff339ea0ba762)({}, x);
            let changed = false;
            for(const key in f)if (ret[key] === undefined) {
                ret[key] = f[key];
                changed = true;
            }
            if (changed) return ret;
        }
        return x;
    });
}
/**
 * Augment a struct to trim string inputs.
 *
 * Note: You must use `create(value, Struct)` on the value to have the coercion
 * take effect! Using simply `assert()` or `is()` will not use coercion.
 */ function $8a18d710f1d13368$export$41f369984ed28930(struct) {
    return $8a18d710f1d13368$export$8c14e57e778d3873(struct, $8a18d710f1d13368$export$22b082955e083ec3(), (x)=>x.trim());
}
/**
 * Ensure that a string, array, map, or set is empty.
 */ function $8a18d710f1d13368$export$6e22c362a0406a2c(struct) {
    return $8a18d710f1d13368$export$edc9d475108b3212(struct, "empty", (value)=>{
        const size = $8a18d710f1d13368$var$getSize(value);
        return size === 0 || `Expected an empty ${struct.type} but received one with a size of \`${size}\``;
    });
}
function $8a18d710f1d13368$var$getSize(value) {
    if (value instanceof Map || value instanceof Set) return value.size;
    else return value.length;
}
/**
 * Ensure that a number or date is below a threshold.
 */ function $8a18d710f1d13368$export$8960430cfd85939f(struct, threshold, options = {}) {
    const { exclusive: exclusive } = options;
    return $8a18d710f1d13368$export$edc9d475108b3212(struct, "max", (value)=>{
        return exclusive ? value < threshold : value <= threshold || `Expected a ${struct.type} less than ${exclusive ? "" : "or equal to "}${threshold} but received \`${value}\``;
    });
}
/**
 * Ensure that a number or date is above a threshold.
 */ function $8a18d710f1d13368$export$96ec731ed4dcb222(struct, threshold, options = {}) {
    const { exclusive: exclusive } = options;
    return $8a18d710f1d13368$export$edc9d475108b3212(struct, "min", (value)=>{
        return exclusive ? value > threshold : value >= threshold || `Expected a ${struct.type} greater than ${exclusive ? "" : "or equal to "}${threshold} but received \`${value}\``;
    });
}
/**
 * Ensure that a string, array, map or set is not empty.
 */ function $8a18d710f1d13368$export$6ce6c9218151d511(struct) {
    return $8a18d710f1d13368$export$edc9d475108b3212(struct, "nonempty", (value)=>{
        const size = $8a18d710f1d13368$var$getSize(value);
        return size > 0 || `Expected a nonempty ${struct.type} but received an empty one`;
    });
}
/**
 * Ensure that a string matches a regular expression.
 */ function $8a18d710f1d13368$export$24f82734ea047e6f(struct, regexp) {
    return $8a18d710f1d13368$export$edc9d475108b3212(struct, "pattern", (value)=>{
        return regexp.test(value) || `Expected a ${struct.type} matching \`/${regexp.source}/\` but received "${value}"`;
    });
}
/**
 * Ensure that a string, array, number, date, map, or set has a size (or length, or time) between `min` and `max`.
 */ function $8a18d710f1d13368$export$346677f925de839c(struct, min, max = min) {
    const expected = `Expected a ${struct.type}`;
    const of = min === max ? `of \`${min}\`` : `between \`${min}\` and \`${max}\``;
    return $8a18d710f1d13368$export$edc9d475108b3212(struct, "size", (value)=>{
        if (typeof value === "number" || value instanceof Date) return min <= value && value <= max || `${expected} ${of} but received \`${value}\``;
        else if (value instanceof Map || value instanceof Set) {
            const { size: size } = value;
            return min <= size && size <= max || `${expected} with a size ${of} but received one with a size of \`${size}\``;
        } else {
            const { length: length } = value;
            return min <= length && length <= max || `${expected} with a length ${of} but received one with a length of \`${length}\``;
        }
    });
}
/**
 * Augment a `Struct` to add an additional refinement to the validation.
 *
 * The refiner function is guaranteed to receive a value of the struct's type,
 * because the struct's existing validation will already have passed. This
 * allows you to layer additional validation on top of existing structs.
 */ function $8a18d710f1d13368$export$edc9d475108b3212(struct, name, refiner) {
    return new $8a18d710f1d13368$export$eabc71f011df675a((0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, struct), {
        *refiner (value, ctx) {
            yield* struct.refiner(value, ctx);
            const result = refiner(value, ctx);
            const failures = $8a18d710f1d13368$var$toFailures(result, ctx, struct, value);
            for (const failure of failures)yield (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, failure), {
                refinement: name
            });
        }
    }));
}





const $4ffc90f7233cdad4$export$76ad0037102e2eeb = $8a18d710f1d13368$export$9b16c434df8cc259([
    (0, $6b1416e8e4d304fe$export$12e44e23ec720850).SignIn,
    (0, $6b1416e8e4d304fe$export$12e44e23ec720850).Register,
    (0, $6b1416e8e4d304fe$export$12e44e23ec720850).ForgotPassword,
    (0, $6b1416e8e4d304fe$export$12e44e23ec720850).Continue
]);
const $4ffc90f7233cdad4$export$1e3360d68cdc393f = $8a18d710f1d13368$export$be5493f9613cbbe({
    identifier: $8a18d710f1d13368$export$9b16c434df8cc259([
        (0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Email,
        (0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Phone,
        (0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Username
    ]),
    value: $8a18d710f1d13368$export$22b082955e083ec3()
});
/* Verification Code Flow Guard */ const $4ffc90f7233cdad4$var$verificationCodeMethodGuard = $8a18d710f1d13368$export$971dd5b0dfd021b6([
    $8a18d710f1d13368$export$c8ec6e1ec9fefcb0((0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Email),
    $8a18d710f1d13368$export$c8ec6e1ec9fefcb0((0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Phone)
]);
const $4ffc90f7233cdad4$export$1e0c25ccbe67b008 = $8a18d710f1d13368$export$be5493f9613cbbe({
    identifier: $4ffc90f7233cdad4$var$verificationCodeMethodGuard,
    value: $8a18d710f1d13368$export$22b082955e083ec3()
});
/* Social Flow Guard */ const $4ffc90f7233cdad4$var$registeredSocialIdentity = $8a18d710f1d13368$export$516e28dec6a4b6d4($8a18d710f1d13368$export$be5493f9613cbbe({
    email: $8a18d710f1d13368$export$516e28dec6a4b6d4($8a18d710f1d13368$export$22b082955e083ec3()),
    phone: $8a18d710f1d13368$export$516e28dec6a4b6d4($8a18d710f1d13368$export$22b082955e083ec3())
}));
const $4ffc90f7233cdad4$export$4563eb9e4106afd7 = $8a18d710f1d13368$export$be5493f9613cbbe({
    missingProfile: $8a18d710f1d13368$export$2f23118c22fb2630($8a18d710f1d13368$export$971dd5b0dfd021b6([
        $8a18d710f1d13368$export$c8ec6e1ec9fefcb0((0, $e77cfc775e0ed7e6$export$68a887ed3b61b98e).password),
        $8a18d710f1d13368$export$c8ec6e1ec9fefcb0((0, $e77cfc775e0ed7e6$export$68a887ed3b61b98e).email),
        $8a18d710f1d13368$export$c8ec6e1ec9fefcb0((0, $e77cfc775e0ed7e6$export$68a887ed3b61b98e).phone),
        $8a18d710f1d13368$export$c8ec6e1ec9fefcb0((0, $e77cfc775e0ed7e6$export$68a887ed3b61b98e).username),
        $8a18d710f1d13368$export$c8ec6e1ec9fefcb0((0, $e77cfc775e0ed7e6$export$68a887ed3b61b98e).emailOrPhone)
    ])),
    registeredSocialIdentity: $4ffc90f7233cdad4$var$registeredSocialIdentity
});
const $4ffc90f7233cdad4$export$184f9f29032ada80 = $8a18d710f1d13368$export$bf9fb029d174d554({
    registeredSocialIdentity: $4ffc90f7233cdad4$var$registeredSocialIdentity
});
const $4ffc90f7233cdad4$export$d3035cdec99fb931 = $8a18d710f1d13368$export$be5493f9613cbbe({
    relatedUser: $8a18d710f1d13368$export$be5493f9613cbbe({
        type: $8a18d710f1d13368$export$971dd5b0dfd021b6([
            $8a18d710f1d13368$export$c8ec6e1ec9fefcb0("email"),
            $8a18d710f1d13368$export$c8ec6e1ec9fefcb0("phone")
        ]),
        value: $8a18d710f1d13368$export$22b082955e083ec3()
    })
});
/* Mfa */ const $4ffc90f7233cdad4$var$mfaFactorsGuard = $8a18d710f1d13368$export$2f23118c22fb2630($8a18d710f1d13368$export$971dd5b0dfd021b6([
    $8a18d710f1d13368$export$c8ec6e1ec9fefcb0((0, $c0e46a7ec45ea8f3$export$c62e7669a75c5961).TOTP),
    $8a18d710f1d13368$export$c8ec6e1ec9fefcb0((0, $c0e46a7ec45ea8f3$export$c62e7669a75c5961).WebAuthn),
    $8a18d710f1d13368$export$c8ec6e1ec9fefcb0((0, $c0e46a7ec45ea8f3$export$c62e7669a75c5961).BackupCode)
]));
const $4ffc90f7233cdad4$export$c098e744493f7349 = $8a18d710f1d13368$export$be5493f9613cbbe({
    availableFactors: $4ffc90f7233cdad4$var$mfaFactorsGuard,
    skippable: $8a18d710f1d13368$export$516e28dec6a4b6d4($8a18d710f1d13368$export$4a21f16c33752377())
});
const $4ffc90f7233cdad4$export$5b8a6b67ca446381 = $4ffc90f7233cdad4$export$c098e744493f7349;
const $4ffc90f7233cdad4$export$8014a7293b97852c = $8a18d710f1d13368$export$e6e34fd1f2686227($8a18d710f1d13368$export$be5493f9613cbbe({
    secret: $8a18d710f1d13368$export$22b082955e083ec3(),
    secretQrCode: $8a18d710f1d13368$export$22b082955e083ec3()
}), $4ffc90f7233cdad4$export$5b8a6b67ca446381);
const $4ffc90f7233cdad4$export$4a47cfca3f992c62 = $8a18d710f1d13368$export$be5493f9613cbbe({
    codes: $8a18d710f1d13368$export$2f23118c22fb2630($8a18d710f1d13368$export$22b082955e083ec3())
});
const $4ffc90f7233cdad4$export$8572183290edea8b = $4ffc90f7233cdad4$export$4a47cfca3f992c62;
const $4ffc90f7233cdad4$export$491937bf2814b26 = $8a18d710f1d13368$export$e6e34fd1f2686227($8a18d710f1d13368$export$be5493f9613cbbe({
    options: $8a18d710f1d13368$export$e5185e241753e543($8a18d710f1d13368$export$22b082955e083ec3(), $8a18d710f1d13368$export$19282c40b967aec6())
}), $4ffc90f7233cdad4$export$5b8a6b67ca446381);
const $4ffc90f7233cdad4$export$7f91c1744e02ec3c = $8a18d710f1d13368$export$be5493f9613cbbe({
    id: $8a18d710f1d13368$export$22b082955e083ec3(),
    logo: $8a18d710f1d13368$export$22b082955e083ec3(),
    darkLogo: $8a18d710f1d13368$export$516e28dec6a4b6d4($8a18d710f1d13368$export$22b082955e083ec3()),
    connectorName: $8a18d710f1d13368$export$22b082955e083ec3()
});


const $036315183b264566$var$logtoStorageKeyPrefix = `logto:${window.location.origin}`;
var $036315183b264566$export$25c0d5b425a20ec;
(function(StorageKeys) {
    StorageKeys["SsoEmail"] = "sso-email";
    StorageKeys["SsoConnectors"] = "sso-connectors";
})($036315183b264566$export$25c0d5b425a20ec || ($036315183b264566$export$25c0d5b425a20ec = {}));
const $036315183b264566$var$valueGuard = Object.freeze({
    [$036315183b264566$export$25c0d5b425a20ec.SsoEmail]: $8a18d710f1d13368$export$22b082955e083ec3(),
    [$036315183b264566$export$25c0d5b425a20ec.SsoConnectors]: $8a18d710f1d13368$export$2f23118c22fb2630((0, $4ffc90f7233cdad4$export$7f91c1744e02ec3c))
});
const $036315183b264566$var$useSessionStorage = ()=>{
    const set = (0, $P551f.useCallback)((key, value)=>{
        if (typeof value === "object") {
            sessionStorage.setItem(`${$036315183b264566$var$logtoStorageKeyPrefix}:${key}`, JSON.stringify(value));
            return;
        }
        sessionStorage.setItem(`${$036315183b264566$var$logtoStorageKeyPrefix}:${key}`, value);
    }, []);
    const remove = (0, $P551f.useCallback)((key)=>{
        sessionStorage.removeItem(`${$036315183b264566$var$logtoStorageKeyPrefix}:${key}`);
    }, []);
    const get = (0, $P551f.useCallback)((key)=>{
        const value = sessionStorage.getItem(`${$036315183b264566$var$logtoStorageKeyPrefix}:${key}`);
        if (value === null) return;
        const [error, rawValue] = $036315183b264566$var$valueGuard[key].validate((()=>{
            try {
                // eslint-disable-next-line no-restricted-syntax -- we use superstruct to validate the value
                return JSON.parse(value);
            } catch (e) {
                return value;
            }
        })());
        if (error) {
            // Clear the invalid value
            remove(key);
            return;
        }
        return rawValue;
    }, [
        remove
    ]);
    return {
        set: set,
        get: get,
        remove: remove
    };
};
var $036315183b264566$export$2e2bcd8739ae039 = $036315183b264566$var$useSessionStorage;





var $P551f = parcelRequire("P551f");
var $9df90ef155637237$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $P551f.createContext)({
    email: undefined,
    availableSsoConnectorsMap: new Map(),
    ssoConnectors: [],
    setEmail: (0, $96962764729a993e$export$8793edee2d425525),
    setSsoConnectors: (0, $96962764729a993e$export$8793edee2d425525)
});


const $8ab2267ce4741904$var$SingleSignOnContextProvider = ({ children: children })=>{
    const { ssoConnectors: ssoConnectors } = (0, $aa5a893d65a133eb$export$317715a729435b35)();
    const { get: get, set: set, remove: remove } = (0, $036315183b264566$export$2e2bcd8739ae039)();
    const [email, setEmail] = (0, $P551f.useState)(get((0, $036315183b264566$export$25c0d5b425a20ec).SsoEmail));
    var _get;
    const [domainFilteredConnectors, setDomainFilteredConnectors] = (0, $P551f.useState)((_get = get((0, $036315183b264566$export$25c0d5b425a20ec).SsoConnectors)) !== null && _get !== void 0 ? _get : []);
    (0, $P551f.useEffect)(()=>{
        if (!email) {
            remove((0, $036315183b264566$export$25c0d5b425a20ec).SsoEmail);
            return;
        }
        set((0, $036315183b264566$export$25c0d5b425a20ec).SsoEmail, email);
    }, [
        email,
        remove,
        set
    ]);
    (0, $P551f.useEffect)(()=>{
        if (domainFilteredConnectors.length === 0) {
            remove((0, $036315183b264566$export$25c0d5b425a20ec).SsoConnectors);
            return;
        }
        set((0, $036315183b264566$export$25c0d5b425a20ec).SsoConnectors, domainFilteredConnectors);
    }, [
        domainFilteredConnectors,
        remove,
        set
    ]);
    const ssoConnectorsMap = (0, $P551f.useMemo)(()=>new Map(ssoConnectors.map((connector)=>[
                connector.id,
                connector
            ])), [
        ssoConnectors
    ]);
    const singleSignOnContext = (0, $P551f.useMemo)(()=>({
            email: email,
            setEmail: setEmail,
            availableSsoConnectorsMap: ssoConnectorsMap,
            ssoConnectors: domainFilteredConnectors,
            setSsoConnectors: setDomainFilteredConnectors
        }), [
        domainFilteredConnectors,
        email,
        ssoConnectorsMap
    ]);
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $9df90ef155637237$export$2e2bcd8739ae039).Provider, {
        value: singleSignOnContext,
        children: children
    });
};
var $8ab2267ce4741904$export$2e2bcd8739ae039 = $8ab2267ce4741904$var$SingleSignOnContextProvider;




var $P551f = parcelRequire("P551f");


var $4ae296e29cc53c31$export$cc74dcc53cfce4eb;
$4ae296e29cc53c31$export$cc74dcc53cfce4eb = `UttbVG_wrapper`;


const $d8eff111d5c2e667$var$StaticPageLayout = ({ children: children })=>{
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("div", {
        className: $4ae296e29cc53c31$export$cc74dcc53cfce4eb,
        children: children
    });
};
var $d8eff111d5c2e667$export$2e2bcd8739ae039 = $d8eff111d5c2e667$var$StaticPageLayout;







var $P551f = parcelRequire("P551f");


const $4da1ed1badb5f5c0$var$useConnectors = ()=>{
    const { socialConnectors: socialConnectors, ssoConnectors: ssoConnectors } = (0, $aa5a893d65a133eb$export$317715a729435b35)();
    const { theme: theme } = (0, $P551f.useContext)((0, $bf7e93717fb1eb16$export$2e2bcd8739ae039));
    /**
   * Find the single sign-on or social connector by given connector id
   */ const findConnectorById = (0, $P551f.useCallback)((connectorId)=>{
        const ssoConnector = ssoConnectors.find((connector)=>connector.id === connectorId);
        if (ssoConnector) return {
            connector: ssoConnector,
            type: "sso"
        };
        const socialConnector = socialConnectors.find((connector)=>connector.id === connectorId);
        if (socialConnector) return {
            connector: socialConnector,
            type: "social"
        };
    }, [
        socialConnectors,
        ssoConnectors
    ]);
    const getConnectorLogo = (0, $P551f.useCallback)(({ connector: connector, type: type })=>{
        var _connector_darkLogo;
        if (type === "sso") return theme === (0, $93d2089b0ece27e4$export$14faa19a0f3bbeb2).Dark ? (_connector_darkLogo = connector.darkLogo) !== null && _connector_darkLogo !== void 0 ? _connector_darkLogo : connector.logo : connector.logo;
        var _connector_logoDark;
        return theme === (0, $93d2089b0ece27e4$export$14faa19a0f3bbeb2).Dark ? (_connector_logoDark = connector.logoDark) !== null && _connector_logoDark !== void 0 ? _connector_logoDark : connector.logo : connector.logo;
    }, [
        theme
    ]);
    return {
        findConnectorById: findConnectorById,
        getConnectorLogo: getConnectorLogo
    };
};
var $4da1ed1badb5f5c0$export$2e2bcd8739ae039 = $4da1ed1badb5f5c0$var$useConnectors;


var $6cd37e4f30e1fa07$export$f79a732982c93a3b;
var $6cd37e4f30e1fa07$export$34e0f9847d4c02dd;
var $6cd37e4f30e1fa07$export$a8ecead220dd38a6;
$6cd37e4f30e1fa07$export$f79a732982c93a3b = `OMwqca_connector`;
$6cd37e4f30e1fa07$export$34e0f9847d4c02dd = `OMwqca_container`;
$6cd37e4f30e1fa07$export$a8ecead220dd38a6 = `OMwqca_message`;


const $f627b889a102cdfb$var$SocialLanding = ({ className: className, connectorId: connectorId, isLoading: isLoading = false })=>{
    const { findConnectorById: findConnectorById, getConnectorLogo: getConnectorLogo } = (0, $4da1ed1badb5f5c0$export$2e2bcd8739ae039)();
    const result = findConnectorById(connectorId);
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a6f0144cf2b2d456$exports)))($6cd37e4f30e1fa07$export$34e0f9847d4c02dd, className),
        children: [
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("div", {
                className: $6cd37e4f30e1fa07$export$f79a732982c93a3b,
                children: result ? /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("img", {
                    src: getConnectorLogo(result),
                    alt: "logo",
                    crossOrigin: "anonymous"
                }) : connectorId
            }),
            isLoading && /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $3ed5ba9f44211243$export$2e2bcd8739ae039), {})
        ]
    });
};
var $f627b889a102cdfb$export$2e2bcd8739ae039 = $f627b889a102cdfb$var$SocialLanding;


var $dcd6d08459efec94$export$bd05d1c161235462;
$dcd6d08459efec94$export$bd05d1c161235462 = `-76m7q_connectorContainer`;



var $P551f = parcelRequire("P551f");


const $bc8f385eceac0fa3$var$useSocialCallbackHandler = ()=>{
    const navigate = (0, $2ed817dc54ac40e6$export$9770f232ac06a008)();
    const socialCallbackHandler = (0, $P551f.useCallback)((connectorId)=>{
        // Get search parameter to evaluate
        const searchParams = new URLSearchParams(window.location.search);
        // Get hash parameter to evaluate
        const hashParams = new URLSearchParams(window.location.hash.slice(1));
        // Join search and hash parameters
        const joinedSearchParams = new URLSearchParams([
            ...searchParams,
            ...hashParams
        ]);
        const search = joinedSearchParams.toString() ? `?${joinedSearchParams.toString()}` : "";
        // Get native callback link from storage
        const callbackLink = (0, $a48a66106483a58a$export$179d5bca54e18dc6)(connectorId);
        (0, $a48a66106483a58a$export$d02cb51c63c7e560)(connectorId);
        if (callbackLink) {
            window.location.replace(new URL(`${callbackLink}${search}`));
            return;
        }
        // Web flow
        navigate({
            pathname: `/callback/social/${connectorId}`,
            search: search
        }, {
            replace: true
        });
    }, [
        navigate
    ]);
    return {
        socialCallbackHandler: socialCallbackHandler
    };
};
var $bc8f385eceac0fa3$export$2e2bcd8739ae039 = $bc8f385eceac0fa3$var$useSocialCallbackHandler;


/**
 * Callback landing page for social sign-in and single sign-on.
 */ const $a82510b1f88da2d3$var$Callback = ()=>{
    const { connectorId: connectorId } = (0, $2ed817dc54ac40e6$export$99eaa27ddbbb95ef)();
    const { socialCallbackHandler: socialCallbackHandler } = (0, $bc8f385eceac0fa3$export$2e2bcd8739ae039)();
    // SocialSignIn Callback Handler
    (0, $P551f.useEffect)(()=>{
        if (!connectorId) return;
        socialCallbackHandler(connectorId);
    }, [
        socialCallbackHandler,
        connectorId
    ]);
    if (!connectorId) return null;
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $d8eff111d5c2e667$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $f627b889a102cdfb$export$2e2bcd8739ae039), {
            isLoading: true,
            className: $dcd6d08459efec94$export$bd05d1c161235462,
            connectorId: connectorId
        })
    });
};
var $a82510b1f88da2d3$export$2e2bcd8739ae039 = $a82510b1f88da2d3$var$Callback;




var $P551f = parcelRequire("P551f");




var $P551f = parcelRequire("P551f");






parcelRequire("P551f");
const $34288e40281ddec4$var$SvgConnectIcon = (props)=>/*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("svg", (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({
        width: 21,
        height: 4,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("circle", {
                cx: 2.5,
                cy: 2,
                r: 2,
                fill: "currentcolor"
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("circle", {
                cx: 10.5,
                cy: 2,
                r: 2,
                fill: "currentcolor"
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("circle", {
                cx: 18.5,
                cy: 2,
                r: 2,
                fill: "currentcolor"
            })
        ]
    }));
var $34288e40281ddec4$export$2e2bcd8739ae039 = $34288e40281ddec4$var$SvgConnectIcon;



var $90db2cec789d5e93$export$e9cf79b2df667146;
var $90db2cec789d5e93$export$34e0f9847d4c02dd;
var $90db2cec789d5e93$export$516dd90aeaaabcf0;
var $90db2cec789d5e93$export$db3c28d99448dcff;
var $90db2cec789d5e93$export$3fca35e0a6eb1bfc;
$90db2cec789d5e93$export$e9cf79b2df667146 = `ctiCua_connectIcon`;
$90db2cec789d5e93$export$34e0f9847d4c02dd = `ctiCua_container`;
$90db2cec789d5e93$export$516dd90aeaaabcf0 = `ctiCua_headline`;
$90db2cec789d5e93$export$db3c28d99448dcff = `ctiCua_logo`;
$90db2cec789d5e93$export$3fca35e0a6eb1bfc = `ctiCua_logoWrapper`;


const $943b5c9ea824771d$var$BrandingHeader = ({ logo: logo, thirdPartyLogo: thirdPartyLogo, headline: headline, headlineInterpolation: headlineInterpolation, className: className })=>{
    const shouldShowLogo = Boolean(thirdPartyLogo !== null && thirdPartyLogo !== void 0 ? thirdPartyLogo : logo);
    const shouldConnectSvg = Boolean(thirdPartyLogo && logo);
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a6f0144cf2b2d456$exports)))($90db2cec789d5e93$export$34e0f9847d4c02dd, className),
        children: [
            shouldShowLogo && /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("div", {
                className: $90db2cec789d5e93$export$3fca35e0a6eb1bfc,
                children: [
                    thirdPartyLogo && /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("img", {
                        className: $90db2cec789d5e93$export$db3c28d99448dcff,
                        alt: "third party logo",
                        src: thirdPartyLogo,
                        crossOrigin: "anonymous"
                    }),
                    shouldConnectSvg && /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $34288e40281ddec4$export$2e2bcd8739ae039), {
                        className: $90db2cec789d5e93$export$e9cf79b2df667146
                    }),
                    logo && /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("img", {
                        className: $90db2cec789d5e93$export$db3c28d99448dcff,
                        alt: "app logo",
                        src: logo,
                        crossOrigin: "anonymous"
                    })
                ]
            }),
            headline && /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("div", {
                className: $90db2cec789d5e93$export$516dd90aeaaabcf0,
                children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $cfcdc2df19be03b3$export$2e2bcd8739ae039), {
                    forKey: headline,
                    interpolation: headlineInterpolation
                })
            })
        ]
    });
};
var $943b5c9ea824771d$export$2e2bcd8739ae039 = $943b5c9ea824771d$var$BrandingHeader;






var $P551f = parcelRequire("P551f");




/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var $8cc494e1a8503b30$var$__assign = function() {
    $8cc494e1a8503b30$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8cc494e1a8503b30$var$__assign.apply(this, arguments);
};
function $8cc494e1a8503b30$var$hasOwn(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
// Escape special characters.
function $8cc494e1a8503b30$var$escapeRe(str) {
    return str.replace(/[.*+?^$|[\](){}\\-]/g, "\\$&");
}
// Return a future date by the given string.
function $8cc494e1a8503b30$var$computeExpires(str) {
    var lastCh = str.charAt(str.length - 1);
    var value = parseInt(str, 10);
    var expires = new Date();
    switch(lastCh){
        case "Y":
            expires.setFullYear(expires.getFullYear() + value);
            break;
        case "M":
            expires.setMonth(expires.getMonth() + value);
            break;
        case "D":
            expires.setDate(expires.getDate() + value);
            break;
        case "h":
            expires.setHours(expires.getHours() + value);
            break;
        case "m":
            expires.setMinutes(expires.getMinutes() + value);
            break;
        case "s":
            expires.setSeconds(expires.getSeconds() + value);
            break;
        default:
            expires = new Date(str);
    }
    return expires;
}
// Convert an object to a cookie option string.
function $8cc494e1a8503b30$var$convert(opts) {
    var res = "";
    for(var _i = 0, _a = Object.keys(opts); _i < _a.length; _i++){
        var key = _a[_i];
        if (/^expires$/i.test(key)) {
            var expires = opts[key];
            var expiresDate = void 0;
            if (typeof expires === "object") expiresDate = expires;
            else {
                expires += typeof expires === "number" ? "D" : "";
                expiresDate = $8cc494e1a8503b30$var$computeExpires(String(expires));
            }
            res += ";".concat(key, "=").concat(expiresDate.toUTCString());
        } else if (/^secure$/.test(key)) {
            if (opts[key]) res += ";".concat(key);
        } else res += ";".concat(key, "=").concat(opts[key]);
    }
    if (!$8cc494e1a8503b30$var$hasOwn(opts, "path")) res += ";path=/";
    return res;
}
// Check if the browser cookie is enabled.
function $8cc494e1a8503b30$export$51bff930ee5c3551() {
    var key = "@key@";
    var value = "1";
    var re = new RegExp("(?:^|; )".concat(key, "=").concat(value, "(?:;|$)"));
    document.cookie = "".concat(key, "=").concat(value, ";path=/");
    var enabled = re.test(document.cookie);
    if (enabled) // eslint-disable-next-line
    $8cc494e1a8503b30$export$cd7f480d6b8286c3(key);
    return enabled;
}
// Get the cookie value by key.
function $8cc494e1a8503b30$export$3988ae62b71be9a3(key, decoder) {
    if (decoder === void 0) decoder = decodeURIComponent;
    if (typeof key !== "string" || !key) return null;
    var reKey = new RegExp("(?:^|; )".concat($8cc494e1a8503b30$var$escapeRe(key), "(?:=([^;]*))?(?:;|$)"));
    var match = reKey.exec(document.cookie);
    if (match === null) return null;
    if (typeof decoder === "function") return decoder(match[1]);
    return match[1];
}
// The all cookies
function $8cc494e1a8503b30$export$2774c37398bee8b2(decoder) {
    if (decoder === void 0) decoder = decodeURIComponent;
    var reKey = /(?:^|; )([^=]+?)(?:=([^;]*))?(?:;|$)/g;
    var cookies = {};
    var match;
    /* eslint-disable no-cond-assign */ while(match = reKey.exec(document.cookie)){
        reKey.lastIndex = match.index + match.length - 1;
        cookies[match[1]] = typeof decoder === "function" ? decoder(match[2]) : match[2];
    }
    return cookies;
}
function $8cc494e1a8503b30$export$adaa4cf7ef1b65be(key, value, encoder, options) {
    if (encoder === void 0) encoder = encodeURIComponent;
    if (typeof encoder === "object" && encoder !== null) {
        /* eslint-disable no-param-reassign */ options = encoder;
        encoder = encodeURIComponent;
    /* eslint-enable no-param-reassign */ }
    var attrsStr = $8cc494e1a8503b30$var$convert(options || {});
    var valueStr = typeof encoder === "function" ? encoder(value) : value;
    var newCookie = "".concat(key, "=").concat(valueStr).concat(attrsStr);
    document.cookie = newCookie;
}
// Remove a cookie by the specified key.
function $8cc494e1a8503b30$export$cd7f480d6b8286c3(key, options) {
    var opts = {
        expires: -1
    };
    if (options) opts = $8cc494e1a8503b30$var$__assign($8cc494e1a8503b30$var$__assign({}, options), opts);
    return $8cc494e1a8503b30$export$adaa4cf7ef1b65be(key, "a", opts);
}
// Get the cookie's value without decoding.
function $8cc494e1a8503b30$export$d049e3525cb8af5d(key) {
    return $8cc494e1a8503b30$export$3988ae62b71be9a3(key, null);
}
// Set a cookie without encoding the value.
function $8cc494e1a8503b30$export$8fedf57504d88c23(key, value, options) {
    return $8cc494e1a8503b30$export$adaa4cf7ef1b65be(key, value, null, options);
}


var $47231853241ed263$var$_trySafe;
const $47231853241ed263$export$bda207505e1c7a07 = ($47231853241ed263$var$_trySafe = (0, $96962764729a993e$export$a3a27526e073307)(()=>(0, $f045820dfe30a75b$export$3b9208034fe791c1).parse((0, $8cc494e1a8503b30$export$3988ae62b71be9a3)((0, $4310b4eb43b15310$export$58a828960e98f161), JSON.parse)))) !== null && $47231853241ed263$var$_trySafe !== void 0 ? $47231853241ed263$var$_trySafe : {};
const $47231853241ed263$export$5e44d4064da3b434 = $47231853241ed263$export$bda207505e1c7a07.appId === (0, $87b8dc3d7e1487b6$export$1bb5e159b3d64354);


const $59bdcd02987e290e$var$PageMeta = ({ titleKey: titleKey, titleKeyInterpolation: titleKeyInterpolation = {}, trackPageView: trackPageView = true })=>{
    const { t: t } = (0, $5d79e62c9ff74ac9$export$9fc83ad70ead8663)();
    const { isSetupFinished: isSetupFinished, appInsights: appInsights } = (0, $P551f.useContext)((0, $cb4ffea6932908cb$export$c17a2d427d600cd));
    const [pageViewTracked, setPageViewTracked] = (0, $P551f.useState)(false);
    const rawTitle = t(titleKey, (0, $0de5391da8318002$export$581ff339ea0ba762)({
        lng: "en"
    }, titleKeyInterpolation));
    const title = t(titleKey, titleKeyInterpolation);
    (0, $P551f.useEffect)(()=>{
        // Only track once for the same page
        if ((0, $47231853241ed263$export$5e44d4064da3b434) && isSetupFinished && trackPageView && !pageViewTracked) {
            var _appInsights_trackPageView;
            (_appInsights_trackPageView = appInsights.trackPageView) === null || _appInsights_trackPageView === void 0 ? void 0 : _appInsights_trackPageView.call(appInsights, {
                name: `Main flow: ${String(rawTitle)}`
            });
            setPageViewTracked(true);
        }
    }, [
        appInsights,
        isSetupFinished,
        pageViewTracked,
        rawTitle,
        trackPageView
    ]);
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $0381bd61330cc6bf$export$dcef8f9bb9a41431), {
        title: String(title)
    });
};
var $59bdcd02987e290e$export$2e2bcd8739ae039 = $59bdcd02987e290e$var$PageMeta;




const $105477e2633d7ba8$export$976f80239b15365 = ({ theme: theme, logoUrl: logoUrl, darkLogoUrl: darkLogoUrl, isApple: isApple })=>{
    if (theme === (isApple ? (0, $93d2089b0ece27e4$export$14faa19a0f3bbeb2).Light : (0, $93d2089b0ece27e4$export$14faa19a0f3bbeb2).Dark)) return darkLogoUrl !== null && darkLogoUrl !== void 0 ? darkLogoUrl : logoUrl;
    return logoUrl;
};
const $105477e2633d7ba8$export$7de80206228fa969 = ({ theme: theme, branding: branding, isDarkModeEnabled: isDarkModeEnabled })=>{
    const { logoUrl: logoUrl, darkLogoUrl: darkLogoUrl } = branding;
    if (!isDarkModeEnabled) return logoUrl;
    if (!logoUrl && !darkLogoUrl) return null;
    if (logoUrl && darkLogoUrl) return $105477e2633d7ba8$export$976f80239b15365({
        theme: theme,
        logoUrl: logoUrl,
        darkLogoUrl: darkLogoUrl
    });
    return logoUrl !== null && logoUrl !== void 0 ? logoUrl : darkLogoUrl;
};


var $a9536c39a975ae40$export$38e42c68cf43b5d4;
var $a9536c39a975ae40$export$d039a117f4b4a172;
var $a9536c39a975ae40$export$2a783d3dea58cac6;
var $a9536c39a975ae40$export$cc74dcc53cfce4eb;
$a9536c39a975ae40$export$38e42c68cf43b5d4 = `pdwYva_header`;
$a9536c39a975ae40$export$d039a117f4b4a172 = `pdwYva_placeholderBottom`;
$a9536c39a975ae40$export$2a783d3dea58cac6 = `pdwYva_placeholderTop`;
$a9536c39a975ae40$export$cc74dcc53cfce4eb = `pdwYva_wrapper`;


const $b30f555a3018f307$var$LandingPageLayout = ({ children: children, className: className, title: title, titleInterpolation: titleInterpolation, thirdPartyBranding: thirdPartyBranding })=>{
    const { experienceSettings: experienceSettings, theme: theme, platform: platform } = (0, $P551f.useContext)((0, $bf7e93717fb1eb16$export$2e2bcd8739ae039));
    if (!experienceSettings) return null;
    const { color: { isDarkModeEnabled: isDarkModeEnabled }, branding: branding } = experienceSettings;
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)((0, $b1404a408b0d045c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $59bdcd02987e290e$export$2e2bcd8739ae039), {
                titleKey: title,
                titleKeyInterpolation: titleInterpolation
            }),
            platform === "web" && /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("div", {
                className: $a9536c39a975ae40$export$2a783d3dea58cac6
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($a6f0144cf2b2d456$exports)))($a9536c39a975ae40$export$cc74dcc53cfce4eb, className),
                children: [
                    /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $943b5c9ea824771d$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($a6f0144cf2b2d456$exports)))($a9536c39a975ae40$export$38e42c68cf43b5d4, (0, $407a83ef1df4ec3e$export$52b270a1b841cc00).brandingHeader),
                        headline: title,
                        headlineInterpolation: titleInterpolation,
                        logo: (0, $105477e2633d7ba8$export$7de80206228fa969)({
                            theme: theme,
                            branding: branding,
                            isDarkModeEnabled: isDarkModeEnabled
                        }),
                        thirdPartyLogo: thirdPartyBranding && (0, $105477e2633d7ba8$export$7de80206228fa969)({
                            theme: theme,
                            branding: thirdPartyBranding,
                            isDarkModeEnabled: isDarkModeEnabled
                        })
                    }),
                    children
                ]
            }),
            platform === "web" && /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("div", {
                className: $a9536c39a975ae40$export$d039a117f4b4a172
            })
        ]
    });
};
var $b30f555a3018f307$export$2e2bcd8739ae039 = $b30f555a3018f307$var$LandingPageLayout;




var $22a2a3b4b60018dd$export$2e2bcd8739ae039 = (0, $f1067a5e706ab1d5$export$2e2bcd8739ae039).extend({
    hooks: {
        beforeRequest: [
            (request)=>{
                request.headers.set("Accept-Language", (0, $86e325ac3ddbcfa1$export$2e2bcd8739ae039).language);
            }
        ]
    }
});


const $722cb2783eca02d6$export$a6dfab0e9e63c404 = async (organizationId)=>{
    return (0, $22a2a3b4b60018dd$export$2e2bcd8739ae039).post("/api/interaction/consent", {
        json: {
            organizationIds: organizationId && [
                organizationId
            ]
        }
    }).json();
};
const $722cb2783eca02d6$export$63817cd70bf84ca6 = async ()=>{
    return (0, $22a2a3b4b60018dd$export$2e2bcd8739ae039).get("/api/interaction/consent").json();
};









var $P551f = parcelRequire("P551f");





var $a7821db000611b65$exports = {};

$parcel$export($a7821db000611b65$exports, "link", function () { return $a7821db000611b65$export$9c30223ca0a664fb; }, function (v) { return $a7821db000611b65$export$9c30223ca0a664fb = v; });
$parcel$export($a7821db000611b65$exports, "primary", function () { return $a7821db000611b65$export$9ad721cf3b3debe0; }, function (v) { return $a7821db000611b65$export$9ad721cf3b3debe0 = v; });
$parcel$export($a7821db000611b65$exports, "secondary", function () { return $a7821db000611b65$export$745c6f71a1e0e6f7; }, function (v) { return $a7821db000611b65$export$745c6f71a1e0e6f7 = v; });
var $a7821db000611b65$export$9c30223ca0a664fb;
var $a7821db000611b65$export$9ad721cf3b3debe0;
var $a7821db000611b65$export$745c6f71a1e0e6f7;
$a7821db000611b65$export$9c30223ca0a664fb = `R5EY3G_link`;
$a7821db000611b65$export$9ad721cf3b3debe0 = `R5EY3G_primary`;
$a7821db000611b65$export$745c6f71a1e0e6f7 = `R5EY3G_secondary`;


const $b6cc3a098ca171c6$var$TextLink = (_param)=>{
    var { className: className, children: children, text: text, icon: icon, type: type = "primary", to: to } = _param, rest = (0, $451b529b5830e8ac$export$69fdd232f62cde60)(_param, [
        "className",
        "children",
        "text",
        "icon",
        "type",
        "to"
    ]);
    const { t: t } = (0, $5d79e62c9ff74ac9$export$9fc83ad70ead8663)();
    const { isMobile: isMobile } = (0, $37bc2555b7bb33e3$export$2e2bcd8739ae039)();
    const { setModalState: setModalState } = (0, $2fd5ca85228c6378$export$6875a035353dd898)();
    // By default the behavior of opening a new window is not supported in WkWebView, or in android webview.
    // Hijack the hyperlink props and open the link in an iframe modal instead.
    const hyperLinkProps = (0, $P551f.useMemo)(()=>{
        const { href: href, target: target, onClick: onClick } = rest, others = (0, $451b529b5830e8ac$export$69fdd232f62cde60)(rest, [
            "href",
            "target",
            "onClick"
        ]);
        // Keep the original behavior if the link is not external.
        if (!href || target !== "_blank") return rest;
        return (0, $0de5391da8318002$export$581ff339ea0ba762)({
            href: href,
            target: target,
            onClick: (event)=>{
                if (isMobile) {
                    const title = text && t(text);
                    event.preventDefault();
                    setModalState({
                        href: href,
                        title: typeof title === "string" ? title : undefined
                    });
                }
                onClick === null || onClick === void 0 ? void 0 : onClick(event);
            }
        }, others);
    }, [
        isMobile,
        rest,
        setModalState,
        t,
        text
    ]);
    if (to) return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)((0, $efe29403354254eb$export$a6c7ac8248d6e38a), (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a6f0144cf2b2d456$exports)))($a7821db000611b65$exports.link, $a7821db000611b65$exports[type], className),
        to: to
    }, rest), {
        children: [
            icon,
            children !== null && children !== void 0 ? children : /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $cfcdc2df19be03b3$export$2e2bcd8739ae039), {
                forKey: text
            })
        ]
    }));
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("a", (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a6f0144cf2b2d456$exports)))($a7821db000611b65$exports.link, $a7821db000611b65$exports[type], className)
    }, hyperLinkProps), {
        rel: "noopener",
        children: [
            icon,
            children !== null && children !== void 0 ? children : /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $cfcdc2df19be03b3$export$2e2bcd8739ae039), {
                forKey: text
            })
        ]
    }));
};
var $b6cc3a098ca171c6$export$2e2bcd8739ae039 = $b6cc3a098ca171c6$var$TextLink;



var $P551f = parcelRequire("P551f");

const $ab5ab705a7d3e209$var$useApi = (api, options)=>{
    const { setLoading: setLoading } = (0, $P551f.useContext)((0, $bf7e93717fb1eb16$export$2e2bcd8739ae039));
    const request = (0, $P551f.useCallback)(async (...args)=>{
        if (!(options === null || options === void 0 ? void 0 : options.silent)) setLoading(true);
        try {
            const result = await api(...args);
            return [
                null,
                result
            ];
        } catch (error) {
            return [
                error
            ];
        } finally{
            setLoading(false);
        }
    }, [
        api,
        options === null || options === void 0 ? void 0 : options.silent,
        setLoading
    ]);
    return request;
};
var $ab5ab705a7d3e209$export$2e2bcd8739ae039 = $ab5ab705a7d3e209$var$useApi;




var $P551f = parcelRequire("P551f");


var $P551f = parcelRequire("P551f");

const $d1e7a25fbbe7c8e1$var$useToast = ()=>{
    const { toast: toast, setToast: setToast } = (0, $P551f.useContext)((0, $bf7e93717fb1eb16$export$2e2bcd8739ae039));
    return {
        toast: toast,
        setToast: setToast
    };
};
var $d1e7a25fbbe7c8e1$export$2e2bcd8739ae039 = $d1e7a25fbbe7c8e1$var$useToast;


const $7ebd5fdad7a45c9e$var$useErrorHandler = ()=>{
    const { t: t } = (0, $5d79e62c9ff74ac9$export$9fc83ad70ead8663)();
    const { setToast: setToast } = (0, $d1e7a25fbbe7c8e1$export$2e2bcd8739ae039)();
    const handleError = (0, $P551f.useCallback)(async (error, errorHandlers)=>{
        if (error instanceof (0, $78de8ebe19ed87e8$export$aa9d629c530f62a7)) try {
            const logtoError = await error.response.json();
            const { code: code, message: message } = logtoError;
            var _errorHandlers_code;
            const handler = (_errorHandlers_code = errorHandlers === null || errorHandlers === void 0 ? void 0 : errorHandlers[code]) !== null && _errorHandlers_code !== void 0 ? _errorHandlers_code : errorHandlers === null || errorHandlers === void 0 ? void 0 : errorHandlers.global;
            if (handler) await handler(logtoError);
            else setToast(message);
            return;
        } catch (e) {
            setToast(t("error.unknown"));
            console.error(error);
            return;
        }
        if (error instanceof (0, $84c8ed1839a26db4$export$66d311bf29d5c89c)) {
            setToast(t("error.timeout"));
            return;
        }
        setToast(t("error.unknown"));
        console.error(error);
    }, [
        setToast,
        t
    ]);
    return handleError;
};
var $7ebd5fdad7a45c9e$export$2e2bcd8739ae039 = $7ebd5fdad7a45c9e$var$useErrorHandler;




var $P551f = parcelRequire("P551f");




parcelRequire("P551f");
const $5204b3c6bd532778$var$SvgExpandableIcon = (props)=>/*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("svg", (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({
        width: 20,
        height: 20,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("path", {
            d: "M13.575 11.908 10 15.492l-3.575-3.584a.837.837 0 0 0-1.183 1.184l4.166 4.166a.833.833 0 0 0 1.184 0l4.166-4.166a.836.836 0 1 0-1.183-1.184Zm-7.15-3.816L10 4.508l3.575 3.584a.833.833 0 0 0 1.183 0 .833.833 0 0 0 0-1.184l-4.166-4.166a.834.834 0 0 0-1.184 0L5.242 6.908a.837.837 0 0 0 1.183 1.184Z",
            fill: "currentcolor"
        })
    }));
var $5204b3c6bd532778$export$2e2bcd8739ae039 = $5204b3c6bd532778$var$SvgExpandableIcon;









parcelRequire("P551f");
const $3e545ca7b4b2c19a$var$SvgCheckMark = (props)=>/*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("svg", (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({
        width: 20,
        height: 21,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("path", {
            d: "M15.584 6.5a.806.806 0 0 0-1.167 0l-6.25 6.25-2.583-2.583a.805.805 0 0 0-1.167 0 .805.805 0 0 0 0 1.166L7.584 14.5c.166.167.333.25.583.25.25 0 .417-.083.583-.25l6.834-6.833a.806.806 0 0 0 0-1.167Z",
            fill: "currentcolor"
        })
    }));
var $3e545ca7b4b2c19a$export$2e2bcd8739ae039 = $3e545ca7b4b2c19a$var$SvgCheckMark;





parcelRequire("P551f");
const $52be705118bacebd$var$SvgOrganizationIcon = (props)=>/*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("svg", (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({
        width: 20,
        height: 20,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("path", {
            d: "M11.666 6.667h.834A.833.833 0 1 0 12.5 5h-.834a.833.833 0 0 0 0 1.667Zm0 3.333h.834a.833.833 0 1 0 0-1.666h-.834a.833.833 0 0 0 0 1.666ZM7.5 6.667h.833a.833.833 0 1 0 0-1.667H7.5a.833.833 0 1 0 0 1.667ZM7.5 10h.833a.833.833 0 1 0 0-1.666H7.5A.833.833 0 1 0 7.5 10Zm10 6.667h-.834V2.5a.833.833 0 0 0-.833-.833H4.167a.833.833 0 0 0-.834.833v14.167H2.5a.833.833 0 1 0 0 1.667h15a.833.833 0 1 0 0-1.667Zm-6.667 0H9.166v-3.333h1.667v3.333Zm4.167 0h-2.5V12.5a.834.834 0 0 0-.834-.833H8.333a.833.833 0 0 0-.833.833v4.167H5V3.334h10v13.333Z",
            fill: "currentcolor"
        })
    }));
var $52be705118bacebd$export$2e2bcd8739ae039 = $52be705118bacebd$var$SvgOrganizationIcon;



var $dfea21252bb44600$export$1ca1ec8b29a4ce27;
var $dfea21252bb44600$export$b13d9ff9b87243f5;
var $dfea21252bb44600$export$cda7feabc85def4e;
$dfea21252bb44600$export$1ca1ec8b29a4ce27 = `_6z3pgG_icon`;
$dfea21252bb44600$export$b13d9ff9b87243f5 = `_6z3pgG_organizationItem`;
$dfea21252bb44600$export$cda7feabc85def4e = `_6z3pgG_organizationName`;


const $52cf83ccd1e23423$var$OrganizationItem = ({ organization: organization, onSelect: onSelect, isSelected: isSelected, suffixElement: suffixElement, className: className })=>{
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("div", (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a6f0144cf2b2d456$exports)))($dfea21252bb44600$export$b13d9ff9b87243f5, className),
        "data-selected": isSelected
    }, onSelect && {
        role: "button",
        tabIndex: 0,
        onClick: ()=>{
            onSelect(organization);
        },
        onKeyDown: (0, $f6f836671f603fea$export$c2c388d6a668999e)(()=>{
            onSelect(organization);
        })
    }), {
        children: [
            isSelected ? /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $3e545ca7b4b2c19a$export$2e2bcd8739ae039), {
                className: $dfea21252bb44600$export$1ca1ec8b29a4ce27
            }) : /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $52be705118bacebd$export$2e2bcd8739ae039), {
                className: $dfea21252bb44600$export$1ca1ec8b29a4ce27
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("div", {
                className: $dfea21252bb44600$export$cda7feabc85def4e,
                children: organization.name
            }),
            suffixElement
        ]
    }));
};
var $52cf83ccd1e23423$export$2e2bcd8739ae039 = $52cf83ccd1e23423$var$OrganizationItem;





var $P551f = parcelRequire("P551f");



var $70c5f2ebce22e24f$export$955245c47f738f8a;
var $70c5f2ebce22e24f$export$ec06ab6513f0c8c6;
var $70c5f2ebce22e24f$export$34e0f9847d4c02dd;
var $70c5f2ebce22e24f$export$b13d9ff9b87243f5;
$70c5f2ebce22e24f$export$955245c47f738f8a = "dropdownOverlay_cdf321";
$70c5f2ebce22e24f$export$ec06ab6513f0c8c6 = "dropdownModal_cdf321";
$70c5f2ebce22e24f$export$34e0f9847d4c02dd = "container_cdf321";
$70c5f2ebce22e24f$export$b13d9ff9b87243f5 = "organizationItem_cdf321";


const $a6764bd7593302ec$var$OrganizationSelectorModal = ({ isOpen: isOpen, parentElementRef: parentElementRef, organizations: organizations, selectedOrganization: selectedOrganization, onSelect: onSelect, onClose: onClose })=>{
    const { isMobile: isMobile } = (0, $37bc2555b7bb33e3$export$2e2bcd8739ae039)();
    const [position, setPosition] = (0, $P551f.useState)({});
    const updatePosition = (0, $P551f.useCallback)(()=>{
        const parent = parentElementRef.current;
        if (!parent || isMobile || !isOpen) {
            setPosition({});
            return;
        }
        const { top: top, left: left, height: height, width: width } = parent.getBoundingClientRect();
        // Offset the modal from the parent element
        const offset = 8;
        // The height of each organization item
        const organizationItemHeight = 40;
        // The padding around the modal content
        const organizationModalPadding = 8;
        // Calculate the max top position so that the modal doesn't go off the screen
        const modalContentHeight = organizations.length * organizationItemHeight + organizationModalPadding * 2;
        const windowHeight = window.innerHeight;
        const maxTop = windowHeight - modalContentHeight;
        setPosition({
            top: Math.min(top + height + offset, maxTop),
            left: left,
            width: width
        });
    }, [
        isMobile,
        isOpen,
        organizations.length,
        parentElementRef
    ]);
    (0, $P551f.useLayoutEffect)(()=>{
        updatePosition();
        window.addEventListener("resize", updatePosition);
        return ()=>{
            window.removeEventListener("resize", updatePosition);
        };
    }, [
        updatePosition,
        isOpen
    ]);
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e479b6ac5364ae16$exports))), {
        isOpen: isOpen,
        overlayClassName: $70c5f2ebce22e24f$export$955245c47f738f8a,
        className: $70c5f2ebce22e24f$export$ec06ab6513f0c8c6,
        style: {
            content: (0, $0de5391da8318002$export$581ff339ea0ba762)({}, position)
        },
        closeTimeoutMS: isMobile ? 300 : 0,
        onRequestClose: onClose,
        children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("div", {
            className: $70c5f2ebce22e24f$export$34e0f9847d4c02dd,
            children: organizations.map((organization)=>/*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $52cf83ccd1e23423$export$2e2bcd8739ae039), {
                    className: $70c5f2ebce22e24f$export$b13d9ff9b87243f5,
                    organization: organization,
                    isSelected: organization.id === selectedOrganization.id,
                    onSelect: ()=>{
                        onClose();
                        onSelect(organization);
                    }
                }, organization.id))
        })
    });
};
var $a6764bd7593302ec$export$2e2bcd8739ae039 = $a6764bd7593302ec$var$OrganizationSelectorModal;


var $0e37b5efbcd92e17$export$3f5ca3638bdbafaf;
var $0e37b5efbcd92e17$export$b94e31e2de63b9f5;
var $0e37b5efbcd92e17$export$63105c67789fc26a;
var $0e37b5efbcd92e17$export$fb184b623420d9be;
$0e37b5efbcd92e17$export$3f5ca3638bdbafaf = `_4xxBLa_cardWrapper`;
$0e37b5efbcd92e17$export$b94e31e2de63b9f5 = `_4xxBLa_expandButton`;
$0e37b5efbcd92e17$export$63105c67789fc26a = `_4xxBLa_selectedOrganization`;
$0e37b5efbcd92e17$export$fb184b623420d9be = `_4xxBLa_title`;


const $6fbb8de595db251f$var$OrganizationSelector = ({ organizations: organizations, selectedOrganization: selectedOrganization, onSelect: onSelect, className: className })=>{
    const { t: t } = (0, $5d79e62c9ff74ac9$export$9fc83ad70ead8663)();
    const parentElementRef = (0, $P551f.useRef)(null);
    const [showDropdown, setShowDropdown] = (0, $P551f.useState)(false);
    if (organizations.length === 0 || !selectedOrganization) return null;
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("div", {
                className: $0e37b5efbcd92e17$export$fb184b623420d9be,
                children: t("description.grant_organization_access")
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("div", {
                ref: parentElementRef,
                className: $0e37b5efbcd92e17$export$3f5ca3638bdbafaf,
                "data-active": showDropdown,
                children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $52cf83ccd1e23423$export$2e2bcd8739ae039), {
                    className: $0e37b5efbcd92e17$export$63105c67789fc26a,
                    organization: selectedOrganization,
                    suffixElement: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $5204b3c6bd532778$export$2e2bcd8739ae039), {
                        className: $0e37b5efbcd92e17$export$b94e31e2de63b9f5
                    }),
                    onSelect: ()=>{
                        setShowDropdown(true);
                    }
                })
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $a6764bd7593302ec$export$2e2bcd8739ae039), {
                isOpen: showDropdown,
                parentElementRef: parentElementRef,
                organizations: organizations,
                selectedOrganization: selectedOrganization,
                onSelect: onSelect,
                onClose: ()=>{
                    setShowDropdown(false);
                }
            })
        ]
    });
};
var $6fbb8de595db251f$export$2e2bcd8739ae039 = $6fbb8de595db251f$var$OrganizationSelector;






var $P551f = parcelRequire("P551f");




parcelRequire("P551f");
const $98ccf19a2b9ce7a6$var$SvgArrowDown = (props)=>/*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("svg", (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({
        viewBox: "0 0 20 20",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("path", {
            d: "M10.592 12.95 15.3 8.233a.833.833 0 1 0-1.175-1.183l-4.167 4.125L5.833 7.05a.833.833 0 0 0-1.36.27.833.833 0 0 0-.065.322.833.833 0 0 0 .25.591l4.709 4.717a.834.834 0 0 0 1.225 0Z",
            fill: "currentcolor"
        })
    }));
var $98ccf19a2b9ce7a6$export$2e2bcd8739ae039 = $98ccf19a2b9ce7a6$var$SvgArrowDown;






var $1fc4c14713ea278b$export$e8c9778bf415dd08;
var $1fc4c14713ea278b$export$9c30223ca0a664fb;
$1fc4c14713ea278b$export$e8c9778bf415dd08 = `_2WTKYW_divider`;
$1fc4c14713ea278b$export$9c30223ca0a664fb = `_2WTKYW_link`;


const $ea24fc73cce16e14$var$TermsLinks = ({ inline: inline, termsOfUseUrl: termsOfUseUrl, privacyPolicyUrl: privacyPolicyUrl })=>{
    const { t: t } = (0, $5d79e62c9ff74ac9$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)((0, $b1404a408b0d045c$exports.Fragment), {
        children: [
            termsOfUseUrl && /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $b6cc3a098ca171c6$export$2e2bcd8739ae039), {
                className: $1fc4c14713ea278b$export$9c30223ca0a664fb,
                text: "description.terms_of_use",
                href: termsOfUseUrl,
                type: "secondary",
                target: "_blank",
                onClick: (event)=>{
                    event.stopPropagation();
                }
            }),
            termsOfUseUrl && privacyPolicyUrl && inline && ` ${t("description.and")} `,
            termsOfUseUrl && privacyPolicyUrl && !inline && /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("i", {
                className: $1fc4c14713ea278b$export$e8c9778bf415dd08
            }),
            privacyPolicyUrl && /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $b6cc3a098ca171c6$export$2e2bcd8739ae039), {
                className: $1fc4c14713ea278b$export$9c30223ca0a664fb,
                text: "description.privacy_policy",
                href: privacyPolicyUrl,
                type: "secondary",
                target: "_blank",
                onClick: (event)=>{
                    event.stopPropagation();
                }
            })
        ]
    });
};
var $ea24fc73cce16e14$export$2e2bcd8739ae039 = $ea24fc73cce16e14$var$TermsLinks;



var $6a79636f5e0ac8a1$export$3f5ca3638bdbafaf;
var $6a79636f5e0ac8a1$export$35dc45686fc2dbd7;
var $6a79636f5e0ac8a1$export$7b7a21e0da99e9eb;
var $6a79636f5e0ac8a1$export$b630af4ecfd2d6e7;
var $6a79636f5e0ac8a1$export$deb14886aeaa75c6;
var $6a79636f5e0ac8a1$export$93f351753d52de5b;
var $6a79636f5e0ac8a1$export$4c6c3452301d55be;
var $6a79636f5e0ac8a1$export$8a21ba990ca4a7cb;
var $6a79636f5e0ac8a1$export$fb184b623420d9be;
var $6a79636f5e0ac8a1$export$c3f9788a1ddcf2d9;
$6a79636f5e0ac8a1$export$3f5ca3638bdbafaf = `CCj1Qq_cardWrapper`;
$6a79636f5e0ac8a1$export$35dc45686fc2dbd7 = `CCj1Qq_check`;
$6a79636f5e0ac8a1$export$7b7a21e0da99e9eb = `CCj1Qq_scopeGroup`;
$6a79636f5e0ac8a1$export$b630af4ecfd2d6e7 = `CCj1Qq_scopeGroupHeader`;
$6a79636f5e0ac8a1$export$deb14886aeaa75c6 = `CCj1Qq_scopeGroupName`;
$6a79636f5e0ac8a1$export$93f351753d52de5b = `CCj1Qq_scopeItem`;
$6a79636f5e0ac8a1$export$4c6c3452301d55be = `CCj1Qq_scopesList`;
$6a79636f5e0ac8a1$export$8a21ba990ca4a7cb = `CCj1Qq_terms`;
$6a79636f5e0ac8a1$export$fb184b623420d9be = `CCj1Qq_title`;
$6a79636f5e0ac8a1$export$c3f9788a1ddcf2d9 = `CCj1Qq_toggleButton`;


const $e29b9e1869361ed2$var$isUserScope = (scope)=>Object.values((0, $7e115e7b30c7027b$export$4b02c5b431f6eb78)).includes(scope);
const $e29b9e1869361ed2$var$ScopeGroup = ({ groupName: groupName, scopes: scopes, isAutoExpand: isAutoExpand = false })=>{
    const [expanded, setExpanded] = (0, $P551f.useState)(isAutoExpand);
    const toggle = (0, $P551f.useCallback)(()=>{
        setExpanded((previous)=>!previous);
    }, []);
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a6f0144cf2b2d456$exports)))($6a79636f5e0ac8a1$export$7b7a21e0da99e9eb),
        children: [
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("div", {
                className: $6a79636f5e0ac8a1$export$b630af4ecfd2d6e7,
                role: "button",
                tabIndex: 0,
                onClick: toggle,
                onKeyDown: (0, $f6f836671f603fea$export$c2c388d6a668999e)(toggle),
                children: [
                    /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $3e545ca7b4b2c19a$export$2e2bcd8739ae039), {
                        className: $6a79636f5e0ac8a1$export$35dc45686fc2dbd7
                    }),
                    /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("div", {
                        className: $6a79636f5e0ac8a1$export$deb14886aeaa75c6,
                        children: groupName
                    }),
                    /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $98ccf19a2b9ce7a6$export$2e2bcd8739ae039), {
                        className: $6a79636f5e0ac8a1$export$c3f9788a1ddcf2d9,
                        "data-expanded": expanded
                    })
                ]
            }),
            expanded && /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("ul", {
                className: $6a79636f5e0ac8a1$export$4c6c3452301d55be,
                children: scopes.map(({ id: id, name: name, description: description })=>/*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("li", {
                        className: $6a79636f5e0ac8a1$export$93f351753d52de5b,
                        children: description !== null && description !== void 0 ? description : name
                    }, id))
            })
        ]
    });
};
const $e29b9e1869361ed2$var$ScopesListCard = ({ userScopes: userScopes, resourceScopes: resourceScopes, appName: appName, termsUrl: termsUrl, privacyUrl: privacyUrl, className: className })=>{
    const { t: t } = (0, $5d79e62c9ff74ac9$export$9fc83ad70ead8663)();
    const userScopesData = (0, $P551f.useMemo)(()=>{
        return userScopes === null || userScopes === void 0 ? void 0 : userScopes.map((scope)=>({
                id: scope,
                name: scope,
                description: $e29b9e1869361ed2$var$isUserScope(scope) ? t(`user_scopes.descriptions.${scope}`, {
                    nsSeparator: "|"
                }) : undefined
            }));
    }, [
        t,
        userScopes
    ]);
    const showTerms = Boolean(termsUrl !== null && termsUrl !== void 0 ? termsUrl : privacyUrl);
    // If there is no user scopes and resource scopes, we don't need to show the scopes list.
    // This is a fallback for the corner case that all the scopes are already granted.
    if (!(userScopesData === null || userScopesData === void 0 ? void 0 : userScopesData.length) && !(resourceScopes === null || resourceScopes === void 0 ? void 0 : resourceScopes.length)) return showTerms ? /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $f51ffae15bc36a59$export$8d6a9236f2e3f2ce), {
            components: {
                link: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $ea24fc73cce16e14$export$2e2bcd8739ae039), {
                    inline: true,
                    termsOfUseUrl: termsUrl,
                    privacyPolicyUrl: privacyUrl
                })
            },
            children: t("description.authorize_agreement", {
                name: appName
            })
        })
    }) : null;
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("div", {
                className: $6a79636f5e0ac8a1$export$fb184b623420d9be,
                children: t("description.request_permission", {
                    name: appName
                })
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("div", {
                className: $6a79636f5e0ac8a1$export$3f5ca3638bdbafaf,
                children: [
                    userScopesData && userScopesData.length > 0 && /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)($e29b9e1869361ed2$var$ScopeGroup, {
                        groupName: "User Scopes",
                        scopes: userScopesData,
                        // If there is no resource scopes, we should auto expand the user scopes
                        isAutoExpand: !(resourceScopes === null || resourceScopes === void 0 ? void 0 : resourceScopes.length)
                    }),
                    resourceScopes === null || resourceScopes === void 0 ? void 0 : resourceScopes.map(({ resource: resource, scopes: scopes })=>{
                        /*#__PURE__*/ return (0, $b1404a408b0d045c$exports.jsx)($e29b9e1869361ed2$var$ScopeGroup, {
                            groupName: resource.name === (0, $7e115e7b30c7027b$export$36ba08a8e14b2df6).Organization ? t("description.organization_scopes") : resource.name,
                            scopes: scopes,
                            // If there is no user scopes, we should auto expand the resource scopes
                            isAutoExpand: !(userScopesData === null || userScopesData === void 0 ? void 0 : userScopesData.length) && resourceScopes.length === 1
                        }, resource.id);
                    }),
                    showTerms && /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("div", {
                        className: $6a79636f5e0ac8a1$export$8a21ba990ca4a7cb,
                        children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $f51ffae15bc36a59$export$8d6a9236f2e3f2ce), {
                            components: {
                                link: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $ea24fc73cce16e14$export$2e2bcd8739ae039), {
                                    inline: true,
                                    termsOfUseUrl: termsUrl,
                                    privacyPolicyUrl: privacyUrl
                                })
                            },
                            children: t("description.authorize_agreement", {
                                name: appName
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var $e29b9e1869361ed2$export$2e2bcd8739ae039 = $e29b9e1869361ed2$var$ScopesListCard;








parcelRequire("P551f");
const $4ff3ab347b252c92$var$SvgDefaultUserAvatar = (props)=>/*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("svg", (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({
        width: 40,
        height: 40,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("rect", {
                width: 40,
                height: 40,
                rx: 6,
                fill: "#F7F8F8"
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("rect", {
                width: 40,
                height: 40,
                rx: 6,
                fill: "#78767F",
                fillOpacity: 0.02
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("rect", {
                width: 40,
                height: 40,
                rx: 6,
                fill: "#5D34F2",
                fillOpacity: 0.16
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20.145 8.334a4.565 4.565 0 0 0-4.565 4.565v1.014a4.565 4.565 0 0 0 9.13 0V12.9a4.565 4.565 0 0 0-4.565-4.565Zm0 23.333c10.145 0 10.145-3.298 10.145-3.298 0-4.277-2.123-8.264-7.609-8.369-.023 0-.181.154-.411.377-.603.587-1.696 1.65-2.125 1.65-.429 0-1.522-1.064-2.125-1.65-.23-.223-.388-.377-.411-.377C12.123 20.105 10 24.092 10 28.37c0 0 0 3.298 10.145 3.298Z",
                fill: "#947DFF"
            })
        ]
    }));
var $4ff3ab347b252c92$export$2e2bcd8739ae039 = $4ff3ab347b252c92$var$SvgDefaultUserAvatar;


var $57149aea97e5fee5$export$345c5736c8054f22;
var $57149aea97e5fee5$export$c2ab62c7bf24634;
var $57149aea97e5fee5$export$a8ff84c12d48cfa6;
var $57149aea97e5fee5$export$cc74dcc53cfce4eb;
$57149aea97e5fee5$export$345c5736c8054f22 = `kEaEPG_avatar`;
$57149aea97e5fee5$export$c2ab62c7bf24634 = `kEaEPG_identifier`;
$57149aea97e5fee5$export$a8ff84c12d48cfa6 = `kEaEPG_name`;
$57149aea97e5fee5$export$cc74dcc53cfce4eb = `kEaEPG_wrapper`;


const $2718720b447a173c$var$UserProfile = ({ user: { id: id, avatar: avatar, name: name, primaryEmail: primaryEmail, primaryPhone: primaryPhone, username: username }, className: className })=>{
    const { t: t } = (0, $5d79e62c9ff74ac9$export$9fc83ad70ead8663)();
    var _ref;
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a6f0144cf2b2d456$exports)))($57149aea97e5fee5$export$cc74dcc53cfce4eb, className),
        children: [
            avatar ? /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("img", {
                src: avatar,
                alt: "avatar",
                className: $57149aea97e5fee5$export$345c5736c8054f22
            }) : /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $4ff3ab347b252c92$export$2e2bcd8739ae039), {
                className: $57149aea97e5fee5$export$345c5736c8054f22
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("div", {
                        className: $57149aea97e5fee5$export$a8ff84c12d48cfa6,
                        children: name !== null && name !== void 0 ? name : t("description.user_id", {
                            id: id
                        })
                    }),
                    /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("div", {
                        className: $57149aea97e5fee5$export$c2ab62c7bf24634,
                        children: (_ref = primaryEmail !== null && primaryEmail !== void 0 ? primaryEmail : primaryPhone) !== null && _ref !== void 0 ? _ref : username
                    })
                ]
            })
        ]
    });
};
var $2718720b447a173c$export$2e2bcd8739ae039 = $2718720b447a173c$var$UserProfile;


var $0a9499bb79f47489$export$f66169a144f13441;
var $0a9499bb79f47489$export$479d2866b0c2b2a9;
var $0a9499bb79f47489$export$3b0cadee2e474bed;
var $0a9499bb79f47489$export$472007267a19777f;
var $0a9499bb79f47489$export$aecd16287464ee90;
$0a9499bb79f47489$export$f66169a144f13441 = `U5sxCa_footerButton`;
$0a9499bb79f47489$export$479d2866b0c2b2a9 = `U5sxCa_footerLink`;
$0a9499bb79f47489$export$3b0cadee2e474bed = `U5sxCa_organizationSelector`;
$0a9499bb79f47489$export$472007267a19777f = `U5sxCa_redirectUri`;
$0a9499bb79f47489$export$aecd16287464ee90 = `U5sxCa_scopesCard`;


/**
 * We need to hide the query params and path from the redirectUri for security reasons when displaying it to the user.
 *
 * if the redirectUri is a http url, we should return the origin
 * Otherwise return the original uri. e.g. native schema io.logto://callback
 */ const $6bcbac2a7f6e6f43$export$941e0612af2803f1 = (redirectUri)=>{
    const url = new URL(redirectUri);
    // If the redirectUri is a http url, we should return the origin
    if (url.protocol.startsWith("http")) return url.origin;
    // Otherwise return the original uri. e.g. native schema io.logto://callback
    return redirectUri;
};


const $419e526a97bad927$var$Consent = ()=>{
    const handleError = (0, $7ebd5fdad7a45c9e$export$2e2bcd8739ae039)();
    const asyncConsent = (0, $ab5ab705a7d3e209$export$2e2bcd8739ae039)((0, $722cb2783eca02d6$export$a6dfab0e9e63c404));
    const { t: t } = (0, $5d79e62c9ff74ac9$export$9fc83ad70ead8663)();
    const [consentData, setConsentData] = (0, $P551f.useState)();
    const [selectedOrganization, setSelectedOrganization] = (0, $P551f.useState)();
    const asyncGetConsentInfo = (0, $ab5ab705a7d3e209$export$2e2bcd8739ae039)((0, $722cb2783eca02d6$export$63817cd70bf84ca6));
    const consentHandler = (0, $P551f.useCallback)(async ()=>{
        const [error, result] = await asyncConsent(selectedOrganization === null || selectedOrganization === void 0 ? void 0 : selectedOrganization.id);
        if (error) {
            await handleError(error);
            return;
        }
        if (result === null || result === void 0 ? void 0 : result.redirectTo) window.location.replace(result.redirectTo);
    }, [
        asyncConsent,
        handleError,
        selectedOrganization === null || selectedOrganization === void 0 ? void 0 : selectedOrganization.id
    ]);
    (0, $P551f.useEffect)(()=>{
        const getConsentInfoHandler = async ()=>{
            var _result_organizations;
            const [error, result] = await asyncGetConsentInfo();
            if (error) {
                await handleError(error);
                return;
            }
            setConsentData(result);
            // Init the default organization selection
            if (!(result === null || result === void 0 ? void 0 : (_result_organizations = result.organizations) === null || _result_organizations === void 0 ? void 0 : _result_organizations.length)) return;
            setSelectedOrganization(result.organizations[0]);
        };
        getConsentInfoHandler();
    }, [
        asyncGetConsentInfo,
        handleError
    ]);
    if (!consentData) return null;
    var _consentData_application_displayName;
    const applicationName = (_consentData_application_displayName = consentData.application.displayName) !== null && _consentData_application_displayName !== void 0 ? _consentData_application_displayName : consentData.application.name;
    var _consentData_application_termsOfUseUrl, _consentData_application_privacyPolicyUrl;
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)((0, $b30f555a3018f307$export$2e2bcd8739ae039), {
        title: "description.authorize_title",
        titleInterpolation: {
            name: applicationName
        },
        thirdPartyBranding: consentData.application.branding,
        children: [
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $2718720b447a173c$export$2e2bcd8739ae039), {
                user: consentData.user
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $e29b9e1869361ed2$export$2e2bcd8739ae039), {
                userScopes: consentData.missingOIDCScope,
                resourceScopes: consentData.missingResourceScopes,
                appName: applicationName,
                className: $0a9499bb79f47489$export$aecd16287464ee90,
                termsUrl: (_consentData_application_termsOfUseUrl = consentData.application.termsOfUseUrl) !== null && _consentData_application_termsOfUseUrl !== void 0 ? _consentData_application_termsOfUseUrl : undefined,
                privacyUrl: (_consentData_application_privacyPolicyUrl = consentData.application.privacyPolicyUrl) !== null && _consentData_application_privacyPolicyUrl !== void 0 ? _consentData_application_privacyPolicyUrl : undefined
            }),
            consentData.organizations && /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $6fbb8de595db251f$export$2e2bcd8739ae039), {
                className: $0a9499bb79f47489$export$3b0cadee2e474bed,
                organizations: consentData.organizations,
                selectedOrganization: selectedOrganization,
                onSelect: setSelectedOrganization
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("div", {
                className: $0a9499bb79f47489$export$f66169a144f13441,
                children: [
                    /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $c6d8f26a28e11cb6$export$2e2bcd8739ae039), {
                        title: "action.cancel",
                        type: "secondary",
                        onClick: ()=>{
                            window.location.replace(consentData.redirectUri);
                        }
                    }),
                    /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $c6d8f26a28e11cb6$export$2e2bcd8739ae039), {
                        title: "action.authorize",
                        onClick: consentHandler
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("div", {
                className: $0a9499bb79f47489$export$472007267a19777f,
                children: t("description.redirect_to", {
                    name: (0, $6bcbac2a7f6e6f43$export$941e0612af2803f1)(consentData.redirectUri)
                })
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("div", {
                className: $0a9499bb79f47489$export$479d2866b0c2b2a9,
                children: [
                    t("description.not_you"),
                    " ",
                    /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $b6cc3a098ca171c6$export$2e2bcd8739ae039), {
                        replace: true,
                        to: "/sign-in",
                        text: "action.use_another_account"
                    })
                ]
            })
        ]
    });
};
var $419e526a97bad927$export$2e2bcd8739ae039 = $419e526a97bad927$var$Consent;








var $P551f = parcelRequire("P551f");





parcelRequire("P551f");
const $d29b81ee8ee87397$var$SvgEmptyStateDark = (props)=>/*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("svg", (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({
        width: 194,
        height: 196,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("rect", {
                x: 34,
                y: 46,
                width: 140,
                height: 108,
                rx: 12,
                fill: "#928F9A"
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("mask", {
                id: "empty-state-dark_svg__a",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: 34,
                y: 46,
                width: 140,
                height: 108,
                children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("rect", {
                    x: 34,
                    y: 46,
                    width: 140,
                    height: 108,
                    rx: 12.191,
                    fill: "#928F9A"
                })
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("path", {
                d: "M34 58c0-6.627 5.373-12 12-12h116c6.627 0 12 5.373 12 12v4H34v-4Z",
                fill: "#78767F"
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M77.686 96.686a4 4 0 0 0 0 5.657L83.343 108l-5.656 5.657a3.999 3.999 0 0 0 0 5.656 3.998 3.998 0 0 0 5.657 0L89 113.657l5.656 5.656a4 4 0 0 0 5.657-5.656L94.657 108l5.658-5.657a4 4 0 0 0-5.657-5.657L89 102.344l-5.657-5.658a4 4 0 0 0-5.657 0ZM125.686 96.686a4 4 0 0 0 0 5.657l5.657 5.657-5.656 5.657a4 4 0 1 0 5.657 5.656l5.656-5.656 5.656 5.656a4 4 0 0 0 5.657-5.656L142.657 108l5.658-5.657a4 4 0 0 0-5.657-5.657L137 102.344l-5.657-5.658a4 4 0 0 0-5.657 0Z",
                fill: "#CABEFF"
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("circle", {
                cx: 48,
                cy: 54,
                r: 2,
                fill: "#5F5D67"
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("circle", {
                cx: 58,
                cy: 54,
                r: 2,
                fill: "#ADAAB4"
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("circle", {
                cx: 68,
                cy: 54,
                r: 2,
                fill: "#ADAAB4"
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("rect", {
                x: 50,
                y: 74,
                width: 64,
                height: 4,
                rx: 2,
                fill: "#ADAAB4"
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("rect", {
                x: 50,
                y: 81,
                width: 14,
                height: 4,
                rx: 2,
                fill: "#ADAAB4"
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("rect", {
                x: 148,
                y: 81,
                width: 10,
                height: 4,
                rx: 2,
                fill: "#ADAAB4"
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("rect", {
                x: 68,
                y: 81,
                width: 74,
                height: 4,
                rx: 2,
                fill: "#ADAAB4"
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("rect", {
                x: 122,
                y: 74,
                width: 10,
                height: 4,
                rx: 2,
                fill: "#ADAAB4"
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("rect", {
                x: 135,
                y: 74,
                width: 23,
                height: 4,
                rx: 2,
                fill: "#ADAAB4"
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("mask", {
                id: "empty-state-dark_svg__b",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: 1,
                y: 65,
                width: 92,
                height: 99,
                children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("path", {
                    d: "M92 70.5V66H1.5v97.5H39c13.255 0 24-10.745 24-24v-40C63 91.492 69.492 85 77.5 85S92 78.508 92 70.5Z",
                    fill: "#fff",
                    stroke: "#F7F8F8",
                    strokeOpacity: 0.16,
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("g", {
                mask: "url(#empty-state-dark_svg__b)",
                stroke: "#F7F8F8",
                strokeOpacity: 0.16,
                strokeWidth: 0.8,
                children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("path", {
                    d: "m-28 62 4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.03 9.03 0 0 0 7.981.048l.31-.15a8.692 8.692 0 0 1 7.777.082 8.692 8.692 0 0 0 7.86.043l.086-.044a8.912 8.912 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.028 9.028 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.919 8.919 0 0 1 7.99-.002 8.918 8.918 0 0 0 7.985 0L100 62M-28 66l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.03 9.03 0 0 0 7.981.048l.31-.15a8.692 8.692 0 0 1 7.777.082 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.028 9.028 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.919 8.919 0 0 1 7.99-.002 8.918 8.918 0 0 0 7.985 0L100 66M-28 70l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.03 9.03 0 0 0 7.981.048l.31-.15a8.692 8.692 0 0 1 7.777.082 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.028 9.028 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.919 8.919 0 0 1 7.99-.002 8.918 8.918 0 0 0 7.985 0L100 70M-28 74l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.03 9.03 0 0 0 7.981.048l.31-.15a8.692 8.692 0 0 1 7.777.082 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.028 9.028 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.919 8.919 0 0 1 7.99-.002 8.918 8.918 0 0 0 7.985 0L100 74M-28 78l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.03 9.03 0 0 0 7.981.048l.31-.15a8.692 8.692 0 0 1 7.777.082 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.028 9.028 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.919 8.919 0 0 1 7.99-.002 8.918 8.918 0 0 0 7.985 0L100 78M-28 82l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.03 9.03 0 0 0 7.981.048l.31-.15a8.692 8.692 0 0 1 7.777.082 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.028 9.028 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.919 8.919 0 0 1 7.99-.002 8.918 8.918 0 0 0 7.985 0L100 82M-28 86l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.03 9.03 0 0 0 7.981.048l.31-.15a8.692 8.692 0 0 1 7.777.082 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.028 9.028 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.919 8.919 0 0 1 7.99-.002 8.918 8.918 0 0 0 7.985 0L100 86M-28 90l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.03 9.03 0 0 0 7.981.048l.31-.15a8.692 8.692 0 0 1 7.777.082 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.028 9.028 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.919 8.919 0 0 1 7.99-.002 8.918 8.918 0 0 0 7.985 0L100 90M-28 94l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.03 9.03 0 0 0 7.981.048l.31-.15a8.692 8.692 0 0 1 7.777.082 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.028 9.028 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.919 8.919 0 0 1 7.99-.002 8.918 8.918 0 0 0 7.985 0L100 94M-28 98l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.971 8.971 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.15a8.692 8.692 0 0 1 7.777.082 8.695 8.695 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.979 8.979 0 0 0 8.016.006 9.027 9.027 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.92 8.92 0 0 1 7.99-.002 8.92 8.92 0 0 0 7.985 0L100 98M-28 102l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.921 8.921 0 0 1 7.99-.002 8.92 8.92 0 0 0 7.985 0L100 102M-28 106l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.921 8.921 0 0 1 7.99-.002 8.92 8.92 0 0 0 7.985 0L100 106M-28 110l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.921 8.921 0 0 1 7.99-.002 8.92 8.92 0 0 0 7.985 0L100 110M-28 114l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.921 8.921 0 0 1 7.99-.002 8.92 8.92 0 0 0 7.985 0L100 114M-28 118l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.921 8.921 0 0 1 7.99-.002 8.92 8.92 0 0 0 7.985 0L100 118M-28 122l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.921 8.921 0 0 1 7.99-.002 8.92 8.92 0 0 0 7.985 0L100 122M-28 126l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.921 8.921 0 0 1 7.99-.002 8.92 8.92 0 0 0 7.985 0L100 126M-28 130l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.921 8.921 0 0 1 7.99-.002 8.92 8.92 0 0 0 7.985 0L100 130M-28 134l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.921 8.921 0 0 1 7.99-.002 8.92 8.92 0 0 0 7.985 0L100 134M-28 138l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.921 8.921 0 0 1 7.99-.002 8.92 8.92 0 0 0 7.985 0L100 138M-28 142l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.921 8.921 0 0 1 7.99-.002 8.92 8.92 0 0 0 7.985 0L100 142M-28 146l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.921 8.921 0 0 1 7.99-.002 8.92 8.92 0 0 0 7.985 0L100 146M-28 150l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.921 8.921 0 0 1 7.99-.002 8.92 8.92 0 0 0 7.985 0L100 150M-28 154l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.921 8.921 0 0 1 7.99-.002 8.92 8.92 0 0 0 7.985 0L100 154M-28 158l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.921 8.921 0 0 1 7.99-.002 8.92 8.92 0 0 0 7.985 0L100 158M-28 162l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.921 8.921 0 0 1 7.99-.002 8.92 8.92 0 0 0 7.985 0L100 162"
                })
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("rect", {
                x: 143.453,
                y: 24,
                width: 24,
                height: 24,
                rx: 4,
                transform: "rotate(50.249 143.453 24)",
                fill: "#F7F8F8",
                fillOpacity: 0.16
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M181.914.209a.21.21 0 0 1 .209-.209h3.755a.21.21 0 0 1 .209.209v6.608l5.723-3.304a.209.209 0 0 1 .285.076l1.877 3.252c.058.1.024.228-.076.285l-5.724 3.305 5.724 3.304a.209.209 0 0 1 .076.285l-1.878 3.252a.208.208 0 0 1-.284.076l-5.723-3.304v6.609a.21.21 0 0 1-.209.208h-3.755a.21.21 0 0 1-.209-.208v-6.61l-5.723 3.305a.208.208 0 0 1-.285-.076l-1.878-3.252a.21.21 0 0 1 .077-.285l5.723-3.304-5.724-3.305a.209.209 0 0 1-.076-.285l1.878-3.252a.208.208 0 0 1 .284-.076l5.724 3.305V.208Z",
                fill: "#CABEFF",
                fillOpacity: 0.16
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M8 25A8 8 0 1 0 8 9a8 8 0 0 0 0 16Zm0-4a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z",
                fill: "#F7F8F8",
                fillOpacity: 0.16
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M170 162c6.627 0 12-5.373 12-12s-5.373-12-12-12-12 5.373-12 12 5.373 12 12 12Zm0-6a6 6 0 1 0 0-12 6 6 0 0 0 0 12Z",
                fill: "#ADAAB4"
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("path", {
                d: "M52.305 25.602c-1.066-2.889 1.395-5.848 4.43-5.327l4.552.783c3.035.521 4.367 4.132 2.398 6.5l-2.953 3.55c-1.97 2.368-5.763 1.716-6.829-1.173l-1.598-4.333Z",
                fill: "#F7F8F8",
                fillOpacity: 0.12
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("rect", {
                x: 51,
                y: 192,
                width: 80,
                height: 4,
                rx: 2,
                fill: "#CABEFF",
                fillOpacity: 0.12
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("rect", {
                x: 143,
                y: 192,
                width: 19,
                height: 4,
                rx: 2,
                fill: "#CABEFF",
                fillOpacity: 0.12
            })
        ]
    }));
var $d29b81ee8ee87397$export$2e2bcd8739ae039 = $d29b81ee8ee87397$var$SvgEmptyStateDark;





parcelRequire("P551f");
const $d32f53e4bf7fd710$var$SvgEmptyState = (props)=>/*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("svg", (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({
        width: 194,
        height: 196,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("rect", {
                x: 34,
                y: 46,
                width: 140,
                height: 108,
                rx: 12,
                fill: "#C9C5D0"
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("mask", {
                id: "empty-state_svg__a",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: 34,
                y: 46,
                width: 140,
                height: 108,
                children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("rect", {
                    x: 34,
                    y: 46,
                    width: 140,
                    height: 108,
                    rx: 12,
                    fill: "#D5CFF1"
                })
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("path", {
                d: "M34 58c0-6.627 5.373-12 12-12h116c6.627 0 12 5.373 12 12v4H34v-4Z",
                fill: "#78767F"
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M77.686 96.686a4 4 0 0 0 0 5.657l5.657 5.658-5.656 5.656a4 4 0 0 0 5.657 5.657L89 113.658l5.656 5.656a4 4 0 1 0 5.657-5.657l-5.656-5.656 5.658-5.658a4 4 0 1 0-5.657-5.657L89 102.344l-5.657-5.658a4 4 0 0 0-5.657 0ZM125.686 96.686a4 4 0 0 0 0 5.657l5.657 5.658-5.656 5.656a4 4 0 0 0 5.657 5.657l5.656-5.656 5.656 5.656a4 4 0 0 0 5.657-5.657l-5.656-5.656 5.658-5.658a4 4 0 0 0-5.657-5.657L137 102.344l-5.657-5.658a4 4 0 0 0-5.657 0Z",
                fill: "#947DFF"
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("circle", {
                cx: 48,
                cy: 54,
                r: 2,
                fill: "#78767F"
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("circle", {
                cx: 58,
                cy: 54,
                r: 2,
                fill: "#C9C5D0"
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("circle", {
                cx: 68,
                cy: 54,
                r: 2,
                fill: "#C9C5D0"
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("rect", {
                x: 50,
                y: 74,
                width: 64,
                height: 4,
                rx: 2,
                fill: "#ADAAB4"
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("rect", {
                x: 50,
                y: 81,
                width: 14,
                height: 4,
                rx: 2,
                fill: "#ADAAB4"
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("rect", {
                x: 148,
                y: 81,
                width: 10,
                height: 4,
                rx: 2,
                fill: "#ADAAB4"
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("rect", {
                x: 68,
                y: 81,
                width: 74,
                height: 4,
                rx: 2,
                fill: "#ADAAB4"
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("rect", {
                x: 122,
                y: 74,
                width: 10,
                height: 4,
                rx: 2,
                fill: "#ADAAB4"
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("rect", {
                x: 135,
                y: 74,
                width: 23,
                height: 4,
                rx: 2,
                fill: "#ADAAB4"
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("mask", {
                id: "empty-state_svg__b",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: 1,
                y: 66,
                width: 91,
                height: 98,
                children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("path", {
                    d: "M92 70.5V66H1.5v97.5H39c13.255 0 24-10.745 24-24v-40C63 91.492 69.492 85 77.5 85S92 78.508 92 70.5Z",
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("g", {
                mask: "url(#empty-state_svg__b)",
                stroke: "#C9C5D0",
                strokeWidth: 0.8,
                children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("path", {
                    d: "m-28 66 4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.03 9.03 0 0 0 7.981.048l.31-.15a8.692 8.692 0 0 1 7.777.082 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.028 9.028 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.919 8.919 0 0 1 7.99-.002 8.918 8.918 0 0 0 7.985 0L100 66M-28 70l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.03 9.03 0 0 0 7.981.048l.31-.15a8.692 8.692 0 0 1 7.777.082 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.028 9.028 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.919 8.919 0 0 1 7.99-.002 8.918 8.918 0 0 0 7.985 0L100 70M-28 74l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.03 9.03 0 0 0 7.981.048l.31-.15a8.692 8.692 0 0 1 7.777.082 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.028 9.028 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.919 8.919 0 0 1 7.99-.002 8.918 8.918 0 0 0 7.985 0L100 74M-28 78l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.03 9.03 0 0 0 7.981.048l.31-.15a8.692 8.692 0 0 1 7.777.082 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.028 9.028 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.919 8.919 0 0 1 7.99-.002 8.918 8.918 0 0 0 7.985 0L100 78M-28 82l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.03 9.03 0 0 0 7.981.048l.31-.15a8.692 8.692 0 0 1 7.777.082 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.028 9.028 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.919 8.919 0 0 1 7.99-.002 8.918 8.918 0 0 0 7.985 0L100 82M-28 86l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.03 9.03 0 0 0 7.981.048l.31-.15a8.692 8.692 0 0 1 7.777.082 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.028 9.028 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.919 8.919 0 0 1 7.99-.002 8.918 8.918 0 0 0 7.985 0L100 86M-28 90l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.03 9.03 0 0 0 7.981.048l.31-.15a8.692 8.692 0 0 1 7.777.082 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.028 9.028 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.919 8.919 0 0 1 7.99-.002 8.918 8.918 0 0 0 7.985 0L100 90M-28 94l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.03 9.03 0 0 0 7.981.048l.31-.15a8.692 8.692 0 0 1 7.777.082 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.028 9.028 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.919 8.919 0 0 1 7.99-.002 8.918 8.918 0 0 0 7.985 0L100 94M-28 98l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.971 8.971 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.15a8.692 8.692 0 0 1 7.777.082 8.695 8.695 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.979 8.979 0 0 0 8.016.006 9.027 9.027 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.92 8.92 0 0 1 7.99-.002 8.92 8.92 0 0 0 7.985 0L100 98M-28 102l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.921 8.921 0 0 1 7.99-.002 8.92 8.92 0 0 0 7.985 0L100 102M-28 106l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.921 8.921 0 0 1 7.99-.002 8.92 8.92 0 0 0 7.985 0L100 106M-28 110l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.921 8.921 0 0 1 7.99-.002 8.92 8.92 0 0 0 7.985 0L100 110M-28 114l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.921 8.921 0 0 1 7.99-.002 8.92 8.92 0 0 0 7.985 0L100 114M-28 118l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.921 8.921 0 0 1 7.99-.002 8.92 8.92 0 0 0 7.985 0L100 118M-28 122l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.921 8.921 0 0 1 7.99-.002 8.92 8.92 0 0 0 7.985 0L100 122M-28 126l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.921 8.921 0 0 1 7.99-.002 8.92 8.92 0 0 0 7.985 0L100 126M-28 130l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.921 8.921 0 0 1 7.99-.002 8.92 8.92 0 0 0 7.985 0L100 130M-28 134l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.921 8.921 0 0 1 7.99-.002 8.92 8.92 0 0 0 7.985 0L100 134M-28 138l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.921 8.921 0 0 1 7.99-.002 8.92 8.92 0 0 0 7.985 0L100 138M-28 142l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.921 8.921 0 0 1 7.99-.002 8.92 8.92 0 0 0 7.985 0L100 142M-28 146l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.921 8.921 0 0 1 7.99-.002 8.92 8.92 0 0 0 7.985 0L100 146M-28 150l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.921 8.921 0 0 1 7.99-.002 8.92 8.92 0 0 0 7.985 0L100 150M-28 154l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.921 8.921 0 0 1 7.99-.002 8.92 8.92 0 0 0 7.985 0L100 154M-28 158l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.921 8.921 0 0 1 7.99-.002 8.92 8.92 0 0 0 7.985 0L100 158M-28 162l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.985 8.985 0 0 0 8 0 8.921 8.921 0 0 1 7.99-.002 8.92 8.92 0 0 0 7.985 0L100 162"
                })
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("rect", {
                x: 143.453,
                y: 24,
                width: 24,
                height: 24,
                rx: 6,
                transform: "rotate(50.249 143.453 24)",
                fill: "#C9C5D0",
                style: {
                    mixBlendMode: "multiply"
                }
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M181.914.209a.21.21 0 0 1 .209-.209h3.755a.21.21 0 0 1 .209.209v6.608l5.723-3.304a.209.209 0 0 1 .285.076l1.877 3.252c.058.1.024.228-.076.285l-5.724 3.305 5.724 3.304a.209.209 0 0 1 .076.285l-1.878 3.252a.208.208 0 0 1-.284.076l-5.723-3.304v6.609a.21.21 0 0 1-.209.208h-3.755a.21.21 0 0 1-.209-.208v-6.61l-5.723 3.305a.208.208 0 0 1-.285-.076l-1.878-3.252a.21.21 0 0 1 .077-.285l5.723-3.304-5.724-3.305a.209.209 0 0 1-.076-.285l1.878-3.252a.208.208 0 0 1 .284-.076l5.724 3.305V.208Z",
                fill: "#E5E1EC"
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M8 25A8 8 0 1 0 8 9a8 8 0 0 0 0 16Zm0-4a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z",
                fill: "#F3EFFA"
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M170 162c6.627 0 12-5.373 12-12s-5.373-12-12-12-12 5.373-12 12 5.373 12 12 12Zm0-6a6 6 0 1 0 0-12 6 6 0 0 0 0 12Z",
                fill: "#E5E1EC",
                style: {
                    mixBlendMode: "multiply"
                }
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("path", {
                d: "M52.305 25.602c-1.066-2.889 1.395-5.848 4.43-5.327l4.552.783c3.035.521 4.367 4.132 2.398 6.5l-2.953 3.55c-1.97 2.368-5.763 1.716-6.829-1.173l-1.598-4.333Z",
                fill: "#F3EFFA"
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("rect", {
                x: 51,
                y: 192,
                width: 80,
                height: 4,
                rx: 2,
                fill: "#C9C5D0"
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("rect", {
                x: 143,
                y: 192,
                width: 19,
                height: 4,
                rx: 2,
                fill: "#C9C5D0"
            })
        ]
    }));
var $d32f53e4bf7fd710$export$2e2bcd8739ae039 = $d32f53e4bf7fd710$var$SvgEmptyState;





var $9c7e3930430d5c60$export$8d6d009d1f06226e;
var $9c7e3930430d5c60$export$34e0f9847d4c02dd;
var $9c7e3930430d5c60$export$a8ecead220dd38a6;
var $9c7e3930430d5c60$export$fb184b623420d9be;
$9c7e3930430d5c60$export$8d6d009d1f06226e = `yIkPZG_backButton`;
$9c7e3930430d5c60$export$34e0f9847d4c02dd = `yIkPZG_container`;
$9c7e3930430d5c60$export$a8ecead220dd38a6 = `yIkPZG_message`;
$9c7e3930430d5c60$export$fb184b623420d9be = `yIkPZG_title`;


const $bcc9cc4bed8427a6$var$ErrorPage = ({ title: title = "description.not_found", message: message, rawMessage: rawMessage })=>{
    const { theme: theme } = (0, $P551f.useContext)((0, $bf7e93717fb1eb16$export$2e2bcd8739ae039));
    const errorMessage = Boolean(rawMessage !== null && rawMessage !== void 0 ? rawMessage : message);
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)((0, $d8eff111d5c2e667$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $59bdcd02987e290e$export$2e2bcd8739ae039), {
                titleKey: title
            }),
            history.length > 1 && /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $c3a009e3761dfcb2$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("div", {
                className: $9c7e3930430d5c60$export$34e0f9847d4c02dd,
                children: [
                    theme === (0, $93d2089b0ece27e4$export$14faa19a0f3bbeb2).Light ? /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $d32f53e4bf7fd710$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $d29b81ee8ee87397$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("div", {
                        className: $9c7e3930430d5c60$export$fb184b623420d9be,
                        children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $cfcdc2df19be03b3$export$2e2bcd8739ae039), {
                            forKey: title
                        })
                    }),
                    errorMessage && /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("div", {
                        className: $9c7e3930430d5c60$export$a8ecead220dd38a6,
                        children: rawMessage !== null && rawMessage !== void 0 ? rawMessage : /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $cfcdc2df19be03b3$export$2e2bcd8739ae039), {
                            forKey: message
                        })
                    })
                ]
            })
        ]
    });
};
var $bcc9cc4bed8427a6$export$2e2bcd8739ae039 = $bcc9cc4bed8427a6$var$ErrorPage;














var $P551f = parcelRequire("P551f");



parcelRequire("P551f");
const $0f374b5a6cfd5abe$var$SvgInfoIcon = (props)=>/*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("svg", (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({
        width: 20,
        height: 20,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("path", {
                d: "M10 1.667a8.333 8.333 0 1 0 0 16.666 8.333 8.333 0 0 0 0-16.666Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("path", {
                d: "M9.41 9.41a.833.833 0 0 1 1.423.59v3.333a.833.833 0 1 1-1.666 0V10c0-.221.088-.433.244-.59ZM9.683 5.9a.833.833 0 0 1 .634 0c.102.04.195.1.275.175.152.16.238.37.241.592a.834.834 0 0 1-1.15.766.958.958 0 0 1-.275-.175.833.833 0 0 1-.175-.908.958.958 0 0 1 .175-.275.834.834 0 0 1 .275-.175Z",
                fill: "#fff"
            })
        ]
    }));
var $0f374b5a6cfd5abe$export$2e2bcd8739ae039 = $0f374b5a6cfd5abe$var$SvgInfoIcon;



var $3f75247faaedd1c6$export$1ca1ec8b29a4ce27;
var $3f75247faaedd1c6$export$9c30223ca0a664fb;
var $3f75247faaedd1c6$export$a8ecead220dd38a6;
var $3f75247faaedd1c6$export$2adf6238a2d0dafa;
$3f75247faaedd1c6$export$1ca1ec8b29a4ce27 = `HCi3vq_icon`;
$3f75247faaedd1c6$export$9c30223ca0a664fb = `HCi3vq_link`;
$3f75247faaedd1c6$export$a8ecead220dd38a6 = `HCi3vq_message`;
$3f75247faaedd1c6$export$2adf6238a2d0dafa = `HCi3vq_notification`;


/* eslint-enable react/require-default-props */ const $f2cd3c99048a5b8e$var$AppNotification = /*#__PURE__*/ (0, $P551f.forwardRef)(({ className: className, message: message, style: style, onClose: onClose }, ref)=>{
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("div", {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a6f0144cf2b2d456$exports)))($3f75247faaedd1c6$export$2adf6238a2d0dafa, className),
        style: style,
        children: [
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $0f374b5a6cfd5abe$export$2e2bcd8739ae039), {
                className: $3f75247faaedd1c6$export$1ca1ec8b29a4ce27
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("div", {
                className: $3f75247faaedd1c6$export$a8ecead220dd38a6,
                children: message
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $b6cc3a098ca171c6$export$2e2bcd8739ae039), {
                text: "action.got_it",
                className: $3f75247faaedd1c6$export$9c30223ca0a664fb,
                onClick: onClose
            })
        ]
    });
});
var $f2cd3c99048a5b8e$export$2e2bcd8739ae039 = $f2cd3c99048a5b8e$var$AppNotification;





var $a85a5bab09baa903$export$2adf6238a2d0dafa;
$a85a5bab09baa903$export$2adf6238a2d0dafa = `TGbnSW_notification`;


const $c7cd429ecd3be9c1$var$InlineNotification = ({ className: className, message: message })=>{
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a6f0144cf2b2d456$exports)))($a85a5bab09baa903$export$2adf6238a2d0dafa, className),
        children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $cfcdc2df19be03b3$export$2e2bcd8739ae039), {
            forKey: message
        })
    });
};
var $c7cd429ecd3be9c1$export$2e2bcd8739ae039 = $c7cd429ecd3be9c1$var$InlineNotification;




var $15e6b8796512c65c$export$34e0f9847d4c02dd;
var $15e6b8796512c65c$export$6d59db4903f20f7d;
var $15e6b8796512c65c$export$38e42c68cf43b5d4;
var $15e6b8796512c65c$export$2adf6238a2d0dafa;
var $15e6b8796512c65c$export$fb184b623420d9be;
var $15e6b8796512c65c$export$cc74dcc53cfce4eb;
$15e6b8796512c65c$export$34e0f9847d4c02dd = `Se2C6G_container`;
$15e6b8796512c65c$export$6d59db4903f20f7d = `Se2C6G_description`;
$15e6b8796512c65c$export$38e42c68cf43b5d4 = `Se2C6G_header`;
$15e6b8796512c65c$export$2adf6238a2d0dafa = `Se2C6G_notification`;
$15e6b8796512c65c$export$fb184b623420d9be = `Se2C6G_title`;
$15e6b8796512c65c$export$cc74dcc53cfce4eb = `Se2C6G_wrapper`;


const $3dc734e3f6636ef1$var$SecondaryPageLayout = ({ title: title, description: description, titleProps: titleProps, descriptionProps: descriptionProps, notification: notification, onSkip: onSkip, isNavBarHidden: isNavBarHidden, children: children })=>{
    const { isMobile: isMobile } = (0, $37bc2555b7bb33e3$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("div", {
        className: $15e6b8796512c65c$export$cc74dcc53cfce4eb,
        children: [
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $59bdcd02987e290e$export$2e2bcd8739ae039), {
                titleKey: title
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $c3a009e3761dfcb2$export$2e2bcd8739ae039), {
                isHidden: isNavBarHidden,
                onSkip: onSkip
            }),
            isMobile && notification && /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $c7cd429ecd3be9c1$export$2e2bcd8739ae039), {
                message: notification,
                className: $15e6b8796512c65c$export$2adf6238a2d0dafa
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("div", {
                className: $15e6b8796512c65c$export$34e0f9847d4c02dd,
                children: [
                    /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("div", {
                        className: $15e6b8796512c65c$export$38e42c68cf43b5d4,
                        children: [
                            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("div", {
                                className: $15e6b8796512c65c$export$fb184b623420d9be,
                                children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $cfcdc2df19be03b3$export$2e2bcd8739ae039), {
                                    forKey: title,
                                    interpolation: titleProps
                                })
                            }),
                            description && /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("div", {
                                className: $15e6b8796512c65c$export$6d59db4903f20f7d,
                                children: typeof description === "string" ? /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $cfcdc2df19be03b3$export$2e2bcd8739ae039), {
                                    forKey: description,
                                    interpolation: descriptionProps
                                }) : description
                            })
                        ]
                    }),
                    children
                ]
            }),
            !isMobile && notification && /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $c7cd429ecd3be9c1$export$2e2bcd8739ae039), {
                message: notification,
                className: $15e6b8796512c65c$export$2adf6238a2d0dafa
            })
        ]
    });
};
var $3dc734e3f6636ef1$export$2e2bcd8739ae039 = $3dc734e3f6636ef1$var$SecondaryPageLayout;


/* Replace legacy useSendVerificationCode hook with this one after the refactor */ 

var $P551f = parcelRequire("P551f");



/* istanbul ignore file */ 




const $72a4b194eaf87ab0$var$interactionPrefix = "/api/interaction";
const $72a4b194eaf87ab0$var$verificationPath = `verification`;
const $72a4b194eaf87ab0$export$9e0f2ad532e0b36f = async (payload)=>{
    await (0, $22a2a3b4b60018dd$export$2e2bcd8739ae039).put(`${$72a4b194eaf87ab0$var$interactionPrefix}`, {
        json: {
            event: (0, $e77cfc775e0ed7e6$export$5b6496a0e009b82d).SignIn,
            identifier: payload
        }
    });
    return (0, $22a2a3b4b60018dd$export$2e2bcd8739ae039).post(`${$72a4b194eaf87ab0$var$interactionPrefix}/submit`).json();
};
const $72a4b194eaf87ab0$export$3053dcea78a60348 = async (username, password)=>{
    await (0, $22a2a3b4b60018dd$export$2e2bcd8739ae039).put(`${$72a4b194eaf87ab0$var$interactionPrefix}`, {
        json: {
            event: (0, $e77cfc775e0ed7e6$export$5b6496a0e009b82d).Register,
            profile: (0, $0de5391da8318002$export$581ff339ea0ba762)({
                username: username
            }, (0, $dd763c2393b0d659$export$c327da55a124987a)(password && {
                password: password
            }))
        }
    });
    return (0, $22a2a3b4b60018dd$export$2e2bcd8739ae039).post(`${$72a4b194eaf87ab0$var$interactionPrefix}/submit`).json();
};
const $72a4b194eaf87ab0$export$bc3a34d5df3015fe = async (password)=>{
    await (0, $22a2a3b4b60018dd$export$2e2bcd8739ae039).patch(`${$72a4b194eaf87ab0$var$interactionPrefix}/profile`, {
        json: {
            password: password
        }
    });
    const result = await (0, $22a2a3b4b60018dd$export$2e2bcd8739ae039).post(`${$72a4b194eaf87ab0$var$interactionPrefix}/submit`).json();
    // Reset password does not have any response body
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    return result || {
        success: true
    };
};
const $72a4b194eaf87ab0$export$b8e11e1a71f798c = async (event)=>(0, $22a2a3b4b60018dd$export$2e2bcd8739ae039).put(`${$72a4b194eaf87ab0$var$interactionPrefix}`, {
        json: {
            event: event
        }
    });
const $72a4b194eaf87ab0$export$fa789d461ee63605 = async (payload)=>{
    await (0, $22a2a3b4b60018dd$export$2e2bcd8739ae039).post(`${$72a4b194eaf87ab0$var$interactionPrefix}/${$72a4b194eaf87ab0$var$verificationPath}/verification-code`, {
        json: payload
    });
    return {
        success: true
    };
};
const $72a4b194eaf87ab0$export$e01e93c3ae4f0e08 = async (payload)=>{
    await (0, $22a2a3b4b60018dd$export$2e2bcd8739ae039).patch(`${$72a4b194eaf87ab0$var$interactionPrefix}/identifiers`, {
        json: payload
    });
    return (0, $22a2a3b4b60018dd$export$2e2bcd8739ae039).post(`${$72a4b194eaf87ab0$var$interactionPrefix}/submit`).json();
};
const $72a4b194eaf87ab0$export$1f2cf4d85f14ded7 = async (payload)=>{
    await (0, $22a2a3b4b60018dd$export$2e2bcd8739ae039).patch(`${$72a4b194eaf87ab0$var$interactionPrefix}/identifiers`, {
        json: payload
    });
    const { verificationCode: verificationCode } = payload, identifier = (0, $451b529b5830e8ac$export$69fdd232f62cde60)(payload, [
        "verificationCode"
    ]);
    await (0, $22a2a3b4b60018dd$export$2e2bcd8739ae039).patch(`${$72a4b194eaf87ab0$var$interactionPrefix}/profile`, {
        json: identifier
    });
    return (0, $22a2a3b4b60018dd$export$2e2bcd8739ae039).post(`${$72a4b194eaf87ab0$var$interactionPrefix}/submit`).json();
};
const $72a4b194eaf87ab0$export$df60c504f9d9103e = async (payload)=>{
    await (0, $22a2a3b4b60018dd$export$2e2bcd8739ae039).patch(`${$72a4b194eaf87ab0$var$interactionPrefix}/identifiers`, {
        json: payload
    });
    return (0, $22a2a3b4b60018dd$export$2e2bcd8739ae039).post(`${$72a4b194eaf87ab0$var$interactionPrefix}/submit`).json();
};
const $72a4b194eaf87ab0$export$85e251dbbdeeea73 = async ()=>{
    await (0, $22a2a3b4b60018dd$export$2e2bcd8739ae039).delete(`${$72a4b194eaf87ab0$var$interactionPrefix}/profile`);
    await (0, $22a2a3b4b60018dd$export$2e2bcd8739ae039).put(`${$72a4b194eaf87ab0$var$interactionPrefix}/event`, {
        json: {
            event: (0, $e77cfc775e0ed7e6$export$5b6496a0e009b82d).SignIn
        }
    });
    return (0, $22a2a3b4b60018dd$export$2e2bcd8739ae039).post(`${$72a4b194eaf87ab0$var$interactionPrefix}/submit`).json();
};
const $72a4b194eaf87ab0$export$ec172577cee1ef2a = async (payload)=>{
    await (0, $22a2a3b4b60018dd$export$2e2bcd8739ae039).put(`${$72a4b194eaf87ab0$var$interactionPrefix}/event`, {
        json: {
            event: (0, $e77cfc775e0ed7e6$export$5b6496a0e009b82d).Register
        }
    });
    await (0, $22a2a3b4b60018dd$export$2e2bcd8739ae039).put(`${$72a4b194eaf87ab0$var$interactionPrefix}/profile`, {
        json: payload
    });
    return (0, $22a2a3b4b60018dd$export$2e2bcd8739ae039).post(`${$72a4b194eaf87ab0$var$interactionPrefix}/submit`).json();
};
const $72a4b194eaf87ab0$export$32da561ec87acb84 = async (payload)=>{
    await (0, $22a2a3b4b60018dd$export$2e2bcd8739ae039).patch(`${$72a4b194eaf87ab0$var$interactionPrefix}/profile`, {
        json: payload
    });
    return (0, $22a2a3b4b60018dd$export$2e2bcd8739ae039).post(`${$72a4b194eaf87ab0$var$interactionPrefix}/submit`).json();
};
const $72a4b194eaf87ab0$export$58837cdda1b658ed = async (connectorId, state, redirectUri)=>{
    await (0, $22a2a3b4b60018dd$export$2e2bcd8739ae039).put(`${$72a4b194eaf87ab0$var$interactionPrefix}`, {
        json: {
            event: (0, $e77cfc775e0ed7e6$export$5b6496a0e009b82d).SignIn
        }
    });
    return (0, $22a2a3b4b60018dd$export$2e2bcd8739ae039).post(`${$72a4b194eaf87ab0$var$interactionPrefix}/${$72a4b194eaf87ab0$var$verificationPath}/social-authorization-uri`, {
        json: {
            connectorId: connectorId,
            state: state,
            redirectUri: redirectUri
        }
    }).json();
};
const $72a4b194eaf87ab0$export$90917f4878ed116a = async (payload)=>{
    await (0, $22a2a3b4b60018dd$export$2e2bcd8739ae039).patch(`${$72a4b194eaf87ab0$var$interactionPrefix}/identifiers`, {
        json: payload
    });
    return (0, $22a2a3b4b60018dd$export$2e2bcd8739ae039).post(`${$72a4b194eaf87ab0$var$interactionPrefix}/submit`).json();
};
const $72a4b194eaf87ab0$export$ae2a9e5eae510a93 = async (connectorId)=>{
    await (0, $22a2a3b4b60018dd$export$2e2bcd8739ae039).put(`${$72a4b194eaf87ab0$var$interactionPrefix}/event`, {
        json: {
            event: (0, $e77cfc775e0ed7e6$export$5b6496a0e009b82d).Register
        }
    });
    await (0, $22a2a3b4b60018dd$export$2e2bcd8739ae039).patch(`${$72a4b194eaf87ab0$var$interactionPrefix}/profile`, {
        json: {
            connectorId: connectorId
        }
    });
    return (0, $22a2a3b4b60018dd$export$2e2bcd8739ae039).post(`${$72a4b194eaf87ab0$var$interactionPrefix}/submit`).json();
};
const $72a4b194eaf87ab0$export$bd9511c461958ea7 = async (payload)=>{
    await (0, $22a2a3b4b60018dd$export$2e2bcd8739ae039).put(`${$72a4b194eaf87ab0$var$interactionPrefix}/event`, {
        json: {
            event: (0, $e77cfc775e0ed7e6$export$5b6496a0e009b82d).SignIn
        }
    });
    await (0, $22a2a3b4b60018dd$export$2e2bcd8739ae039).patch(`${$72a4b194eaf87ab0$var$interactionPrefix}/identifiers`, {
        json: payload
    });
    await (0, $22a2a3b4b60018dd$export$2e2bcd8739ae039).patch(`${$72a4b194eaf87ab0$var$interactionPrefix}/profile`, {
        json: {
            connectorId: payload.connectorId
        }
    });
    return (0, $22a2a3b4b60018dd$export$2e2bcd8739ae039).post(`${$72a4b194eaf87ab0$var$interactionPrefix}/submit`).json();
};
const $72a4b194eaf87ab0$export$75b0bae8270ba103 = async (connectorId)=>{
    // Sign-in with pre-verified email/phone identifier instead and replace the email/phone profile with connectorId.
    await (0, $22a2a3b4b60018dd$export$2e2bcd8739ae039).put(`${$72a4b194eaf87ab0$var$interactionPrefix}/event`, {
        json: {
            event: (0, $e77cfc775e0ed7e6$export$5b6496a0e009b82d).SignIn
        }
    });
    await (0, $22a2a3b4b60018dd$export$2e2bcd8739ae039).put(`${$72a4b194eaf87ab0$var$interactionPrefix}/profile`, {
        json: {
            connectorId: connectorId
        }
    });
    return (0, $22a2a3b4b60018dd$export$2e2bcd8739ae039).post(`${$72a4b194eaf87ab0$var$interactionPrefix}/submit`).json();
};
const $72a4b194eaf87ab0$export$ed04f454e58389a8 = async ()=>(0, $22a2a3b4b60018dd$export$2e2bcd8739ae039).post(`${$72a4b194eaf87ab0$var$interactionPrefix}/${$72a4b194eaf87ab0$var$verificationPath}/totp`).json();
const $72a4b194eaf87ab0$export$4a7a1c8b5ba74d74 = async ()=>(0, $22a2a3b4b60018dd$export$2e2bcd8739ae039).post(`${$72a4b194eaf87ab0$var$interactionPrefix}/${$72a4b194eaf87ab0$var$verificationPath}/webauthn-registration`).json();
const $72a4b194eaf87ab0$export$dddc1626e5376ab0 = async ()=>(0, $22a2a3b4b60018dd$export$2e2bcd8739ae039).post(`${$72a4b194eaf87ab0$var$interactionPrefix}/${$72a4b194eaf87ab0$var$verificationPath}/webauthn-authentication`).json();
const $72a4b194eaf87ab0$export$8a7ec544b861c507 = async (payload)=>{
    await (0, $22a2a3b4b60018dd$export$2e2bcd8739ae039).post(`${$72a4b194eaf87ab0$var$interactionPrefix}/bind-mfa`, {
        json: payload
    });
    return (0, $22a2a3b4b60018dd$export$2e2bcd8739ae039).post(`${$72a4b194eaf87ab0$var$interactionPrefix}/submit`).json();
};
const $72a4b194eaf87ab0$export$f34dd6a11cbbbf5c = async (payload)=>{
    await (0, $22a2a3b4b60018dd$export$2e2bcd8739ae039).put(`${$72a4b194eaf87ab0$var$interactionPrefix}/mfa`, {
        json: payload
    });
    return (0, $22a2a3b4b60018dd$export$2e2bcd8739ae039).post(`${$72a4b194eaf87ab0$var$interactionPrefix}/submit`).json();
};
const $72a4b194eaf87ab0$export$19773ff1b0ccf87f = async ()=>{
    await (0, $22a2a3b4b60018dd$export$2e2bcd8739ae039).put(`${$72a4b194eaf87ab0$var$interactionPrefix}/mfa-skipped`, {
        json: {
            mfaSkipped: true
        }
    });
    return (0, $22a2a3b4b60018dd$export$2e2bcd8739ae039).post(`${$72a4b194eaf87ab0$var$interactionPrefix}/submit`).json();
};


const $93b564bd57b019d2$export$6443fa89a66c693a = async (type, payload)=>{
    if (type === (0, $6b1416e8e4d304fe$export$12e44e23ec720850).ForgotPassword) await (0, $72a4b194eaf87ab0$export$b8e11e1a71f798c)((0, $e77cfc775e0ed7e6$export$5b6496a0e009b82d).ForgotPassword);
    if (type === (0, $6b1416e8e4d304fe$export$12e44e23ec720850).SignIn) await (0, $72a4b194eaf87ab0$export$b8e11e1a71f798c)((0, $e77cfc775e0ed7e6$export$5b6496a0e009b82d).SignIn);
    if (type === (0, $6b1416e8e4d304fe$export$12e44e23ec720850).Register) await (0, $72a4b194eaf87ab0$export$b8e11e1a71f798c)((0, $e77cfc775e0ed7e6$export$5b6496a0e009b82d).Register);
    return (0, $72a4b194eaf87ab0$export$fa789d461ee63605)(payload);
};




const $e5f910429b93015b$var$useSendVerificationCode = (flow, replaceCurrentPage)=>{
    const [errorMessage, setErrorMessage] = (0, $P551f.useState)();
    const navigate = (0, $2ed817dc54ac40e6$export$9770f232ac06a008)();
    const handleError = (0, $7ebd5fdad7a45c9e$export$2e2bcd8739ae039)();
    const asyncSendVerificationCode = (0, $ab5ab705a7d3e209$export$2e2bcd8739ae039)((0, $93b564bd57b019d2$export$6443fa89a66c693a));
    const clearErrorMessage = (0, $P551f.useCallback)(()=>{
        setErrorMessage("");
    }, []);
    const onSubmit = (0, $P551f.useCallback)(async ({ identifier: identifier, value: value })=>{
        const [error, result] = await asyncSendVerificationCode(flow, {
            [identifier]: value
        });
        if (error) {
            await handleError(error, {
                "guard.invalid_input": ()=>{
                    setErrorMessage(identifier === (0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Email ? "invalid_email" : "invalid_phone");
                }
            });
            return;
        }
        if (result) navigate({
            pathname: `/${flow}/verification-code`,
            search: location.search
        }, {
            state: {
                identifier: identifier,
                value: value
            },
            replace: replaceCurrentPage
        });
    }, [
        asyncSendVerificationCode,
        flow,
        handleError,
        navigate,
        replaceCurrentPage
    ]);
    return {
        errorMessage: errorMessage,
        clearErrorMessage: clearErrorMessage,
        onSubmit: onSubmit
    };
};
var $e5f910429b93015b$export$2e2bcd8739ae039 = $e5f910429b93015b$var$useSendVerificationCode;








var $P551f = parcelRequire("P551f");




var $P551f = parcelRequire("P551f");
var $afcc65e7f92ff559$var$isCheckBoxInput = (element)=>element.type === "checkbox";
var $afcc65e7f92ff559$var$isDateObject = (value1)=>value1 instanceof Date;
var $afcc65e7f92ff559$var$isNullOrUndefined = (value1)=>value1 == null;
const $afcc65e7f92ff559$var$isObjectType = (value1)=>typeof value1 === "object";
var $afcc65e7f92ff559$var$isObject = (value1)=>!$afcc65e7f92ff559$var$isNullOrUndefined(value1) && !Array.isArray(value1) && $afcc65e7f92ff559$var$isObjectType(value1) && !$afcc65e7f92ff559$var$isDateObject(value1);
var $afcc65e7f92ff559$var$getEventValue = (event)=>$afcc65e7f92ff559$var$isObject(event) && event.target ? $afcc65e7f92ff559$var$isCheckBoxInput(event.target) ? event.target.checked : event.target.value : event;
var $afcc65e7f92ff559$var$getNodeParentName = (name)=>name.substring(0, name.search(/\.\d+(\.|$)/)) || name;
var $afcc65e7f92ff559$var$isNameInFieldArray = (names, name)=>names.has($afcc65e7f92ff559$var$getNodeParentName(name));
var $afcc65e7f92ff559$var$compact = (value1)=>Array.isArray(value1) ? value1.filter(Boolean) : [];
var $afcc65e7f92ff559$var$isUndefined = (val)=>val === undefined;
var $afcc65e7f92ff559$export$3988ae62b71be9a3 = (obj, path, defaultValue)=>{
    if (!path || !$afcc65e7f92ff559$var$isObject(obj)) return defaultValue;
    const result = $afcc65e7f92ff559$var$compact(path.split(/[,[\].]+?/)).reduce((result, key)=>$afcc65e7f92ff559$var$isNullOrUndefined(result) ? result : result[key], obj);
    return $afcc65e7f92ff559$var$isUndefined(result) || result === obj ? $afcc65e7f92ff559$var$isUndefined(obj[path]) ? defaultValue : obj[path] : result;
};
const $afcc65e7f92ff559$var$EVENTS = {
    BLUR: "blur",
    FOCUS_OUT: "focusout",
    CHANGE: "change"
};
const $afcc65e7f92ff559$var$VALIDATION_MODE = {
    onBlur: "onBlur",
    onChange: "onChange",
    onSubmit: "onSubmit",
    onTouched: "onTouched",
    all: "all"
};
const $afcc65e7f92ff559$var$INPUT_VALIDATION_RULES = {
    max: "max",
    min: "min",
    maxLength: "maxLength",
    minLength: "minLength",
    pattern: "pattern",
    required: "required",
    validate: "validate"
};
const $afcc65e7f92ff559$var$HookFormContext = (0, (/*@__PURE__*/$parcel$interopDefault($P551f))).createContext(null);
/**
 * This custom hook allows you to access the form context. useFormContext is intended to be used in deeply nested structures, where it would become inconvenient to pass the context as a prop. To be used with {@link FormProvider}.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @returns return all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const $afcc65e7f92ff559$export$4d957a5e1be13b03 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($P551f))).useContext($afcc65e7f92ff559$var$HookFormContext);
/**
 * A provider component that propagates the `useForm` methods to all children components via [React Context](https://reactjs.org/docs/context.html) API. To be used with {@link useFormContext}.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @param props - all useFrom methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const $afcc65e7f92ff559$export$8ce1ff4f94d08846 = (props)=>{
    const { children: children } = props, data = (0, $451b529b5830e8ac$export$69fdd232f62cde60)(props, [
        "children"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($P551f))).createElement($afcc65e7f92ff559$var$HookFormContext.Provider, {
        value: data
    }, children);
};
var $afcc65e7f92ff559$var$getProxyFormState = (formState, _proxyFormState, localProxyFormState, isRoot = true)=>{
    const result = {};
    for(const key in formState)Object.defineProperty(result, key, {
        get: ()=>{
            const _key = key;
            if (_proxyFormState[_key] !== $afcc65e7f92ff559$var$VALIDATION_MODE.all) _proxyFormState[_key] = !isRoot || $afcc65e7f92ff559$var$VALIDATION_MODE.all;
            localProxyFormState && (localProxyFormState[_key] = true);
            return formState[_key];
        }
    });
    return result;
};
var $afcc65e7f92ff559$var$isEmptyObject = (value1)=>$afcc65e7f92ff559$var$isObject(value1) && !Object.keys(value1).length;
var $afcc65e7f92ff559$var$shouldRenderFormState = (formStateData, _proxyFormState, isRoot)=>{
    const { name: name } = formStateData, formState = (0, $451b529b5830e8ac$export$69fdd232f62cde60)(formStateData, [
        "name"
    ]);
    return $afcc65e7f92ff559$var$isEmptyObject(formState) || Object.keys(formState).length >= Object.keys(_proxyFormState).length || Object.keys(formState).find((key)=>_proxyFormState[key] === (!isRoot || $afcc65e7f92ff559$var$VALIDATION_MODE.all));
};
var $afcc65e7f92ff559$var$convertToArrayPayload = (value1)=>Array.isArray(value1) ? value1 : [
        value1
    ];
var $afcc65e7f92ff559$var$shouldSubscribeByName = (name, signalName, exact)=>exact && signalName ? name === signalName : !name || !signalName || name === signalName || $afcc65e7f92ff559$var$convertToArrayPayload(name).some((currentName)=>currentName && (currentName.startsWith(signalName) || signalName.startsWith(currentName)));
function $afcc65e7f92ff559$var$useSubscribe(props) {
    const _props = (0, (/*@__PURE__*/$parcel$interopDefault($P551f))).useRef(props);
    _props.current = props;
    (0, (/*@__PURE__*/$parcel$interopDefault($P551f))).useEffect(()=>{
        const tearDown = (subscription)=>{
            if (subscription) subscription.unsubscribe();
        };
        const subscription = !props.disabled && _props.current.subject.subscribe({
            next: _props.current.callback
        });
        return ()=>tearDown(subscription);
    }, [
        props.disabled
    ]);
}
/**
 * This custom hook allows you to subscribe to each form state, and isolate the re-render at the custom hook level. It has its scope in terms of form state subscription, so it would not affect other useFormState and useForm. Using this hook can reduce the re-render impact on large and complex form application.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/useformstate) • [Demo](https://codesandbox.io/s/useformstate-75xly)
 *
 * @param props - include options on specify fields to subscribe. {@link UseFormStateReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, control } = useForm({
 *     defaultValues: {
 *     firstName: "firstName"
 *   }});
 *   const { dirtyFields } = useFormState({
 *     control
 *   });
 *   const onSubmit = (data) => console.log(data);
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input {...register("firstName")} placeholder="First Name" />
 *       {dirtyFields.firstName && <p>Field is dirty.</p>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $afcc65e7f92ff559$export$606f11b2eb45ecc6(props) {
    const methods = $afcc65e7f92ff559$export$4d957a5e1be13b03();
    const { control: control = methods.control, disabled: disabled, name: name, exact: exact } = props || {};
    const [formState, updateFormState] = (0, (/*@__PURE__*/$parcel$interopDefault($P551f))).useState(control._formState);
    const _localProxyFormState = (0, (/*@__PURE__*/$parcel$interopDefault($P551f))).useRef({
        isDirty: false,
        dirtyFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    });
    const _name = (0, (/*@__PURE__*/$parcel$interopDefault($P551f))).useRef(name);
    const _mounted = (0, (/*@__PURE__*/$parcel$interopDefault($P551f))).useRef(true);
    _name.current = name;
    const callback = (0, (/*@__PURE__*/$parcel$interopDefault($P551f))).useCallback((value1)=>_mounted.current && $afcc65e7f92ff559$var$shouldSubscribeByName(_name.current, value1.name, exact) && $afcc65e7f92ff559$var$shouldRenderFormState(value1, _localProxyFormState.current) && updateFormState((0, $0de5391da8318002$export$581ff339ea0ba762)({}, control._formState, value1)), [
        control,
        exact
    ]);
    $afcc65e7f92ff559$var$useSubscribe({
        disabled: disabled,
        callback: callback,
        subject: control._subjects.state
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($P551f))).useEffect(()=>{
        _mounted.current = true;
        return ()=>{
            _mounted.current = false;
        };
    }, []);
    return $afcc65e7f92ff559$var$getProxyFormState(formState, control._proxyFormState, _localProxyFormState.current, false);
}
var $afcc65e7f92ff559$var$isString = (value1)=>typeof value1 === "string";
var $afcc65e7f92ff559$var$generateWatchOutput = (names, _names, formValues, isGlobal)=>{
    const isArray = Array.isArray(names);
    if ($afcc65e7f92ff559$var$isString(names)) {
        isGlobal && _names.watch.add(names);
        return $afcc65e7f92ff559$export$3988ae62b71be9a3(formValues, names);
    }
    if (isArray) return names.map((fieldName)=>(isGlobal && _names.watch.add(fieldName), $afcc65e7f92ff559$export$3988ae62b71be9a3(formValues, fieldName)));
    isGlobal && (_names.watchAll = true);
    return formValues;
};
var $afcc65e7f92ff559$var$isFunction = (value1)=>typeof value1 === "function";
var $afcc65e7f92ff559$var$objectHasFunction = (data)=>{
    for(const key in data){
        if ($afcc65e7f92ff559$var$isFunction(data[key])) return true;
    }
    return false;
};
/**
 * Custom hook to subscribe to field change and isolate re-rendering at the component level.
 *
 * @remarks
 *
 * [API](https://react-hook-form.com/api/usewatch) • [Demo](https://codesandbox.io/s/react-hook-form-v7-ts-usewatch-h9i5e)
 *
 * @example
 * ```tsx
 * const { watch } = useForm();
 * const values = useWatch({
 *   name: "fieldName"
 *   control,
 * })
 * ```
 */ function $afcc65e7f92ff559$export$3c773aa2b84f29e0(props) {
    const methods = $afcc65e7f92ff559$export$4d957a5e1be13b03();
    const { control: control = methods.control, name: name, defaultValue: defaultValue, disabled: disabled, exact: exact } = props || {};
    const _name = (0, (/*@__PURE__*/$parcel$interopDefault($P551f))).useRef(name);
    _name.current = name;
    const callback = (0, (/*@__PURE__*/$parcel$interopDefault($P551f))).useCallback((formState)=>{
        if ($afcc65e7f92ff559$var$shouldSubscribeByName(_name.current, formState.name, exact)) {
            const fieldValues = $afcc65e7f92ff559$var$generateWatchOutput(_name.current, control._names, formState.values || control._formValues);
            updateValue($afcc65e7f92ff559$var$isUndefined(_name.current) || $afcc65e7f92ff559$var$isObject(fieldValues) && !$afcc65e7f92ff559$var$objectHasFunction(fieldValues) ? (0, $0de5391da8318002$export$581ff339ea0ba762)({}, fieldValues) : Array.isArray(fieldValues) ? [
                ...fieldValues
            ] : $afcc65e7f92ff559$var$isUndefined(fieldValues) ? defaultValue : fieldValues);
        }
    }, [
        control,
        exact,
        defaultValue
    ]);
    $afcc65e7f92ff559$var$useSubscribe({
        disabled: disabled,
        subject: control._subjects.watch,
        callback: callback
    });
    const [value1, updateValue] = (0, (/*@__PURE__*/$parcel$interopDefault($P551f))).useState($afcc65e7f92ff559$var$isUndefined(defaultValue) ? control._getWatch(name) : defaultValue);
    (0, (/*@__PURE__*/$parcel$interopDefault($P551f))).useEffect(()=>{
        control._removeUnmounted();
    });
    return value1;
}
/**
 * Custom hook to work with controlled component, this function provide you with both form and field level state. Re-render is isolated at the hook level.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/usecontroller) • [Demo](https://codesandbox.io/s/usecontroller-0o8px)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns field properties, field and form state. {@link UseControllerReturn}
 *
 * @example
 * ```tsx
 * function Input(props) {
 *   const { field, fieldState, formState } = useController(props);
 *   return (
 *     <div>
 *       <input {...field} placeholder={props.name} />
 *       <p>{fieldState.isTouched && "Touched"}</p>
 *       <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *     </div>
 *   );
 * }
 * ```
 */ function $afcc65e7f92ff559$export$e8c786024a2b0a79(props) {
    const methods = $afcc65e7f92ff559$export$4d957a5e1be13b03();
    const { name: name, control: control = methods.control, shouldUnregister: shouldUnregister } = props;
    const isArrayField = $afcc65e7f92ff559$var$isNameInFieldArray(control._names.array, name);
    const value1 = $afcc65e7f92ff559$export$3c773aa2b84f29e0({
        control: control,
        name: name,
        defaultValue: $afcc65e7f92ff559$export$3988ae62b71be9a3(control._formValues, name, $afcc65e7f92ff559$export$3988ae62b71be9a3(control._defaultValues, name, props.defaultValue)),
        exact: true
    });
    const formState = $afcc65e7f92ff559$export$606f11b2eb45ecc6({
        control: control,
        name: name
    });
    const _registerProps = (0, (/*@__PURE__*/$parcel$interopDefault($P551f))).useRef(control.register(name, (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, props.rules), {
        value: value1
    })));
    (0, (/*@__PURE__*/$parcel$interopDefault($P551f))).useEffect(()=>{
        const updateMounted = (name, value1)=>{
            const field = $afcc65e7f92ff559$export$3988ae62b71be9a3(control._fields, name);
            if (field) field._f.mount = value1;
        };
        updateMounted(name, true);
        return ()=>{
            const _shouldUnregisterField = control._options.shouldUnregister || shouldUnregister;
            (isArrayField ? _shouldUnregisterField && !control._stateFlags.action : _shouldUnregisterField) ? control.unregister(name) : updateMounted(name, false);
        };
    }, [
        name,
        control,
        isArrayField,
        shouldUnregister
    ]);
    return {
        field: {
            name: name,
            value: value1,
            onChange: (0, (/*@__PURE__*/$parcel$interopDefault($P551f))).useCallback((event)=>{
                _registerProps.current.onChange({
                    target: {
                        value: $afcc65e7f92ff559$var$getEventValue(event),
                        name: name
                    },
                    type: $afcc65e7f92ff559$var$EVENTS.CHANGE
                });
            }, [
                name
            ]),
            onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($P551f))).useCallback(()=>{
                _registerProps.current.onBlur({
                    target: {
                        value: $afcc65e7f92ff559$export$3988ae62b71be9a3(control._formValues, name),
                        name: name
                    },
                    type: $afcc65e7f92ff559$var$EVENTS.BLUR
                });
            }, [
                name,
                control
            ]),
            ref: (0, (/*@__PURE__*/$parcel$interopDefault($P551f))).useCallback((elm)=>{
                const field = $afcc65e7f92ff559$export$3988ae62b71be9a3(control._fields, name);
                if (elm && field && elm.focus) field._f.ref = {
                    focus: ()=>elm.focus(),
                    select: ()=>elm.select(),
                    setCustomValidity: (message)=>elm.setCustomValidity(message),
                    reportValidity: ()=>elm.reportValidity()
                };
            }, [
                name,
                control._fields
            ])
        },
        formState: formState,
        fieldState: Object.defineProperties({}, {
            invalid: {
                get: ()=>!!$afcc65e7f92ff559$export$3988ae62b71be9a3(formState.errors, name)
            },
            isDirty: {
                get: ()=>!!$afcc65e7f92ff559$export$3988ae62b71be9a3(formState.dirtyFields, name)
            },
            isTouched: {
                get: ()=>!!$afcc65e7f92ff559$export$3988ae62b71be9a3(formState.touchedFields, name)
            },
            error: {
                get: ()=>$afcc65e7f92ff559$export$3988ae62b71be9a3(formState.errors, name)
            }
        })
    };
}
/**
 * Component based on `useController` hook to work with controlled component.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/usecontroller/controller) • [Demo](https://codesandbox.io/s/react-hook-form-v6-controller-ts-jwyzw) • [Video](https://www.youtube.com/watch?v=N2UNk_UCVyA)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns provide field handler functions, field and form state.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control } = useForm<FormValues>({
 *     defaultValues: {
 *       test: ""
 *     }
 *   });
 *
 *   return (
 *     <form>
 *       <Controller
 *         control={control}
 *         name="test"
 *         render={({ field: { onChange, onBlur, value, ref }, formState, fieldState }) => (
 *           <>
 *             <input
 *               onChange={onChange} // send value to hook form
 *               onBlur={onBlur} // notify when input is touched
 *               value={value} // return updated value
 *               ref={ref} // set ref for focus management
 *             />
 *             <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *             <p>{fieldState.isTouched ? "touched" : ""}</p>
 *           </>
 *         )}
 *       />
 *     </form>
 *   );
 * }
 * ```
 */ const $afcc65e7f92ff559$export$bd0bf19f25da8474 = (props)=>props.render($afcc65e7f92ff559$export$e8c786024a2b0a79(props));
var $afcc65e7f92ff559$export$b196c2a4f765bd30 = (name, validateAllFieldCriteria, errors, type, message)=>validateAllFieldCriteria ? (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, errors[name]), {
        types: (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, errors[name] && errors[name].types ? errors[name].types : {}), {
            [type]: message || true
        })
    }) : {};
var $afcc65e7f92ff559$var$isKey = (value1)=>/^\w*$/.test(value1);
var $afcc65e7f92ff559$var$stringToPath = (input)=>$afcc65e7f92ff559$var$compact(input.replace(/["|']|\]/g, "").split(/\.|\[/));
function $afcc65e7f92ff559$export$adaa4cf7ef1b65be(object, path, value1) {
    let index = -1;
    const tempPath = $afcc65e7f92ff559$var$isKey(path) ? [
        path
    ] : $afcc65e7f92ff559$var$stringToPath(path);
    const length = tempPath.length;
    const lastIndex = length - 1;
    while(++index < length){
        const key = tempPath[index];
        let newValue = value1;
        if (index !== lastIndex) {
            const objValue = object[key];
            newValue = $afcc65e7f92ff559$var$isObject(objValue) || Array.isArray(objValue) ? objValue : !isNaN(+tempPath[index + 1]) ? [] : {};
        }
        object[key] = newValue;
        object = object[key];
    }
    return object;
}
const $afcc65e7f92ff559$var$focusFieldBy = (fields, callback, fieldsNames)=>{
    for (const _ref of fieldsNames || Object.keys(fields)){
        let key = _ref;
        const field = $afcc65e7f92ff559$export$3988ae62b71be9a3(fields, key);
        if (field) {
            const { _f: _f } = field, currentField = (0, $451b529b5830e8ac$export$69fdd232f62cde60)(field, [
                "_f"
            ]);
            if (_f && callback(_f.name)) {
                if (_f.ref.focus && $afcc65e7f92ff559$var$isUndefined(_f.ref.focus())) break;
                else if (_f.refs) {
                    _f.refs[0].focus();
                    break;
                }
            } else if ($afcc65e7f92ff559$var$isObject(currentField)) $afcc65e7f92ff559$var$focusFieldBy(currentField, callback);
        }
    }
};
var $afcc65e7f92ff559$var$generateId = ()=>{
    const d = typeof performance === "undefined" ? Date.now() : performance.now() * 1000;
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c)=>{
        const r = (Math.random() * 16 + d) % 16 | 0;
        return (c == "x" ? r : r & 0x3 | 0x8).toString(16);
    });
};
var $afcc65e7f92ff559$var$getFocusFieldName = (name, index, options = {})=>options.shouldFocus || $afcc65e7f92ff559$var$isUndefined(options.shouldFocus) ? options.focusName || `${name}.${$afcc65e7f92ff559$var$isUndefined(options.focusIndex) ? index : options.focusIndex}.` : "";
var $afcc65e7f92ff559$var$isWatched = (name, _names, isBlurEvent)=>!isBlurEvent && (_names.watchAll || _names.watch.has(name) || [
        ..._names.watch
    ].some((watchName)=>name.startsWith(watchName) && /^\.\w+/.test(name.slice(watchName.length))));
var $afcc65e7f92ff559$var$updateFieldArrayRootError = (errors, error, name)=>{
    const fieldArrayErrors = $afcc65e7f92ff559$var$compact($afcc65e7f92ff559$export$3988ae62b71be9a3(errors, name));
    $afcc65e7f92ff559$export$adaa4cf7ef1b65be(fieldArrayErrors, "root", error[name]);
    $afcc65e7f92ff559$export$adaa4cf7ef1b65be(errors, name, fieldArrayErrors);
    return errors;
};
var $afcc65e7f92ff559$var$isBoolean = (value1)=>typeof value1 === "boolean";
var $afcc65e7f92ff559$var$isFileInput = (element)=>element.type === "file";
var $afcc65e7f92ff559$var$isMessage = (value1)=>$afcc65e7f92ff559$var$isString(value1) || (0, (/*@__PURE__*/$parcel$interopDefault($P551f))).isValidElement(value1);
var $afcc65e7f92ff559$var$isRadioInput = (element)=>element.type === "radio";
var $afcc65e7f92ff559$var$isRegex = (value1)=>value1 instanceof RegExp;
const $afcc65e7f92ff559$var$defaultResult = {
    value: false,
    isValid: false
};
const $afcc65e7f92ff559$var$validResult = {
    value: true,
    isValid: true
};
var $afcc65e7f92ff559$var$getCheckboxValue = (options)=>{
    if (Array.isArray(options)) {
        if (options.length > 1) {
            const values = options.filter((option)=>option && option.checked && !option.disabled).map((option)=>option.value);
            return {
                value: values,
                isValid: !!values.length
            };
        }
        return options[0].checked && !options[0].disabled ? options[0].attributes && !$afcc65e7f92ff559$var$isUndefined(options[0].attributes.value) ? $afcc65e7f92ff559$var$isUndefined(options[0].value) || options[0].value === "" ? $afcc65e7f92ff559$var$validResult : {
            value: options[0].value,
            isValid: true
        } : $afcc65e7f92ff559$var$validResult : $afcc65e7f92ff559$var$defaultResult;
    }
    return $afcc65e7f92ff559$var$defaultResult;
};
const $afcc65e7f92ff559$var$defaultReturn = {
    isValid: false,
    value: null
};
var $afcc65e7f92ff559$var$getRadioValue = (options)=>Array.isArray(options) ? options.reduce((previous, option)=>option && option.checked && !option.disabled ? {
            isValid: true,
            value: option.value
        } : previous, $afcc65e7f92ff559$var$defaultReturn) : $afcc65e7f92ff559$var$defaultReturn;
function $afcc65e7f92ff559$var$getValidateError(result, ref, type = "validate") {
    if ($afcc65e7f92ff559$var$isMessage(result) || Array.isArray(result) && result.every($afcc65e7f92ff559$var$isMessage) || $afcc65e7f92ff559$var$isBoolean(result) && !result) return {
        type: type,
        message: $afcc65e7f92ff559$var$isMessage(result) ? result : "",
        ref: ref
    };
}
var $afcc65e7f92ff559$var$getValueAndMessage = (validationData)=>$afcc65e7f92ff559$var$isObject(validationData) && !$afcc65e7f92ff559$var$isRegex(validationData) ? validationData : {
        value: validationData,
        message: ""
    };
var $afcc65e7f92ff559$var$validateField = async (field, inputValue, validateAllFieldCriteria, shouldUseNativeValidation, isFieldArray)=>{
    const { ref: ref, refs: refs, required: required, maxLength: maxLength, minLength: minLength, min: min, max: max, pattern: pattern, validate: validate, name: name, valueAsNumber: valueAsNumber, mount: mount, disabled: disabled } = field._f;
    if (!mount || disabled) return {};
    const inputRef = refs ? refs[0] : ref;
    const setCustomValidity = (message)=>{
        if (shouldUseNativeValidation && inputRef.reportValidity) {
            inputRef.setCustomValidity($afcc65e7f92ff559$var$isBoolean(message) ? "" : message || " ");
            inputRef.reportValidity();
        }
    };
    const error = {};
    const isRadio = $afcc65e7f92ff559$var$isRadioInput(ref);
    const isCheckBox = $afcc65e7f92ff559$var$isCheckBoxInput(ref);
    const isRadioOrCheckbox = isRadio || isCheckBox;
    const isEmpty = (valueAsNumber || $afcc65e7f92ff559$var$isFileInput(ref)) && !ref.value || inputValue === "" || Array.isArray(inputValue) && !inputValue.length;
    const appendErrorsCurry = $afcc65e7f92ff559$export$b196c2a4f765bd30.bind(null, name, validateAllFieldCriteria, error);
    const getMinMaxMessage = (exceedMax, maxLengthMessage, minLengthMessage, maxType = $afcc65e7f92ff559$var$INPUT_VALIDATION_RULES.maxLength, minType = $afcc65e7f92ff559$var$INPUT_VALIDATION_RULES.minLength)=>{
        const message = exceedMax ? maxLengthMessage : minLengthMessage;
        error[name] = (0, $0de5391da8318002$export$581ff339ea0ba762)({
            type: exceedMax ? maxType : minType,
            message: message,
            ref: ref
        }, appendErrorsCurry(exceedMax ? maxType : minType, message));
    };
    if (isFieldArray ? !Array.isArray(inputValue) || !inputValue.length : required && (!isRadioOrCheckbox && (isEmpty || $afcc65e7f92ff559$var$isNullOrUndefined(inputValue)) || $afcc65e7f92ff559$var$isBoolean(inputValue) && !inputValue || isCheckBox && !$afcc65e7f92ff559$var$getCheckboxValue(refs).isValid || isRadio && !$afcc65e7f92ff559$var$getRadioValue(refs).isValid)) {
        const { value: value1, message: message } = $afcc65e7f92ff559$var$isMessage(required) ? {
            value: !!required,
            message: required
        } : $afcc65e7f92ff559$var$getValueAndMessage(required);
        if (value1) {
            error[name] = (0, $0de5391da8318002$export$581ff339ea0ba762)({
                type: $afcc65e7f92ff559$var$INPUT_VALIDATION_RULES.required,
                message: message,
                ref: inputRef
            }, appendErrorsCurry($afcc65e7f92ff559$var$INPUT_VALIDATION_RULES.required, message));
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (!isEmpty && (!$afcc65e7f92ff559$var$isNullOrUndefined(min) || !$afcc65e7f92ff559$var$isNullOrUndefined(max))) {
        let exceedMax;
        let exceedMin;
        const maxOutput = $afcc65e7f92ff559$var$getValueAndMessage(max);
        const minOutput = $afcc65e7f92ff559$var$getValueAndMessage(min);
        if (!$afcc65e7f92ff559$var$isNullOrUndefined(inputValue) && !isNaN(inputValue)) {
            const valueNumber = ref.valueAsNumber || +inputValue;
            if (!$afcc65e7f92ff559$var$isNullOrUndefined(maxOutput.value)) exceedMax = valueNumber > maxOutput.value;
            if (!$afcc65e7f92ff559$var$isNullOrUndefined(minOutput.value)) exceedMin = valueNumber < minOutput.value;
        } else {
            const valueDate = ref.valueAsDate || new Date(inputValue);
            if ($afcc65e7f92ff559$var$isString(maxOutput.value)) exceedMax = valueDate > new Date(maxOutput.value);
            if ($afcc65e7f92ff559$var$isString(minOutput.value)) exceedMin = valueDate < new Date(minOutput.value);
        }
        if (exceedMax || exceedMin) {
            getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, $afcc65e7f92ff559$var$INPUT_VALIDATION_RULES.max, $afcc65e7f92ff559$var$INPUT_VALIDATION_RULES.min);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if ((maxLength || minLength) && !isEmpty && ($afcc65e7f92ff559$var$isString(inputValue) || isFieldArray && Array.isArray(inputValue))) {
        const maxLengthOutput = $afcc65e7f92ff559$var$getValueAndMessage(maxLength);
        const minLengthOutput = $afcc65e7f92ff559$var$getValueAndMessage(minLength);
        const exceedMax = !$afcc65e7f92ff559$var$isNullOrUndefined(maxLengthOutput.value) && inputValue.length > maxLengthOutput.value;
        const exceedMin = !$afcc65e7f92ff559$var$isNullOrUndefined(minLengthOutput.value) && inputValue.length < minLengthOutput.value;
        if (exceedMax || exceedMin) {
            getMinMaxMessage(exceedMax, maxLengthOutput.message, minLengthOutput.message);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if (pattern && !isEmpty && $afcc65e7f92ff559$var$isString(inputValue)) {
        const { value: patternValue, message: message } = $afcc65e7f92ff559$var$getValueAndMessage(pattern);
        if ($afcc65e7f92ff559$var$isRegex(patternValue) && !inputValue.match(patternValue)) {
            error[name] = (0, $0de5391da8318002$export$581ff339ea0ba762)({
                type: $afcc65e7f92ff559$var$INPUT_VALIDATION_RULES.pattern,
                message: message,
                ref: ref
            }, appendErrorsCurry($afcc65e7f92ff559$var$INPUT_VALIDATION_RULES.pattern, message));
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (validate) {
        if ($afcc65e7f92ff559$var$isFunction(validate)) {
            const result = await validate(inputValue);
            const validateError = $afcc65e7f92ff559$var$getValidateError(result, inputRef);
            if (validateError) {
                error[name] = (0, $0de5391da8318002$export$581ff339ea0ba762)({}, validateError, appendErrorsCurry($afcc65e7f92ff559$var$INPUT_VALIDATION_RULES.validate, validateError.message));
                if (!validateAllFieldCriteria) {
                    setCustomValidity(validateError.message);
                    return error;
                }
            }
        } else if ($afcc65e7f92ff559$var$isObject(validate)) {
            let validationResult = {};
            for(const key in validate){
                if (!$afcc65e7f92ff559$var$isEmptyObject(validationResult) && !validateAllFieldCriteria) break;
                const validateError = $afcc65e7f92ff559$var$getValidateError(await validate[key](inputValue), inputRef, key);
                if (validateError) {
                    validationResult = (0, $0de5391da8318002$export$581ff339ea0ba762)({}, validateError, appendErrorsCurry(key, validateError.message));
                    setCustomValidity(validateError.message);
                    if (validateAllFieldCriteria) error[name] = validationResult;
                }
            }
            if (!$afcc65e7f92ff559$var$isEmptyObject(validationResult)) {
                error[name] = (0, $0de5391da8318002$export$581ff339ea0ba762)({
                    ref: inputRef
                }, validationResult);
                if (!validateAllFieldCriteria) return error;
            }
        }
    }
    setCustomValidity(true);
    return error;
};
function $afcc65e7f92ff559$var$append(data, value1) {
    return [
        ...data,
        ...$afcc65e7f92ff559$var$convertToArrayPayload(value1)
    ];
}
var $afcc65e7f92ff559$var$isWeb = typeof window !== "undefined" && typeof window.HTMLElement !== "undefined" && typeof document !== "undefined";
function $afcc65e7f92ff559$var$cloneObject(data) {
    let copy;
    const isArray = Array.isArray(data);
    if (data instanceof Date) copy = new Date(data);
    else if (data instanceof Set) copy = new Set(data);
    else if (!($afcc65e7f92ff559$var$isWeb && (data instanceof Blob || data instanceof FileList)) && (isArray || $afcc65e7f92ff559$var$isObject(data))) {
        copy = isArray ? [] : {};
        for(const key in data){
            if ($afcc65e7f92ff559$var$isFunction(data[key])) {
                copy = data;
                break;
            }
            copy[key] = $afcc65e7f92ff559$var$cloneObject(data[key]);
        }
    } else return data;
    return copy;
}
var $afcc65e7f92ff559$var$fillEmptyArray = (value1)=>Array.isArray(value1) ? value1.map(()=>undefined) : undefined;
var $afcc65e7f92ff559$var$getValidationModes = (mode)=>({
        isOnSubmit: !mode || mode === $afcc65e7f92ff559$var$VALIDATION_MODE.onSubmit,
        isOnBlur: mode === $afcc65e7f92ff559$var$VALIDATION_MODE.onBlur,
        isOnChange: mode === $afcc65e7f92ff559$var$VALIDATION_MODE.onChange,
        isOnAll: mode === $afcc65e7f92ff559$var$VALIDATION_MODE.all,
        isOnTouch: mode === $afcc65e7f92ff559$var$VALIDATION_MODE.onTouched
    });
function $afcc65e7f92ff559$var$insert(data, index, value1) {
    return [
        ...data.slice(0, index),
        ...$afcc65e7f92ff559$var$convertToArrayPayload(value1),
        ...data.slice(index)
    ];
}
var $afcc65e7f92ff559$var$moveArrayAt = (data, from, to)=>{
    if (!Array.isArray(data)) return [];
    if ($afcc65e7f92ff559$var$isUndefined(data[to])) data[to] = undefined;
    data.splice(to, 0, data.splice(from, 1)[0]);
    return data;
};
function $afcc65e7f92ff559$var$prepend(data, value1) {
    return [
        ...$afcc65e7f92ff559$var$convertToArrayPayload(value1),
        ...$afcc65e7f92ff559$var$convertToArrayPayload(data)
    ];
}
function $afcc65e7f92ff559$var$removeAtIndexes(data, indexes) {
    let i = 0;
    const temp = [
        ...data
    ];
    for (const index of indexes){
        temp.splice(index - i, 1);
        i++;
    }
    return $afcc65e7f92ff559$var$compact(temp).length ? temp : [];
}
var $afcc65e7f92ff559$var$removeArrayAt = (data, index)=>$afcc65e7f92ff559$var$isUndefined(index) ? [] : $afcc65e7f92ff559$var$removeAtIndexes(data, $afcc65e7f92ff559$var$convertToArrayPayload(index).sort((a, b)=>a - b));
var $afcc65e7f92ff559$var$swapArrayAt = (data, indexA, indexB)=>{
    data[indexA] = [
        data[indexB],
        data[indexB] = data[indexA]
    ][0];
};
function $afcc65e7f92ff559$var$baseGet(object, updatePath) {
    const length = updatePath.slice(0, -1).length;
    let index = 0;
    while(index < length)object = $afcc65e7f92ff559$var$isUndefined(object) ? index++ : object[updatePath[index++]];
    return object;
}
function $afcc65e7f92ff559$var$isEmptyArray(obj) {
    for(const key in obj){
        if (!$afcc65e7f92ff559$var$isUndefined(obj[key])) return false;
    }
    return true;
}
function $afcc65e7f92ff559$var$unset(object, path) {
    const updatePath = $afcc65e7f92ff559$var$isKey(path) ? [
        path
    ] : $afcc65e7f92ff559$var$stringToPath(path);
    const childObject = updatePath.length == 1 ? object : $afcc65e7f92ff559$var$baseGet(object, updatePath);
    const key = updatePath[updatePath.length - 1];
    let previousObjRef;
    if (childObject) delete childObject[key];
    for(let k = 0; k < updatePath.slice(0, -1).length; k++){
        let index = -1;
        let objectRef;
        const currentPaths = updatePath.slice(0, -(k + 1));
        const currentPathsLength = currentPaths.length - 1;
        if (k > 0) previousObjRef = object;
        while(++index < currentPaths.length){
            const item = currentPaths[index];
            objectRef = objectRef ? objectRef[item] : object[item];
            if (currentPathsLength === index && ($afcc65e7f92ff559$var$isObject(objectRef) && $afcc65e7f92ff559$var$isEmptyObject(objectRef) || Array.isArray(objectRef) && $afcc65e7f92ff559$var$isEmptyArray(objectRef))) previousObjRef ? delete previousObjRef[item] : delete object[item];
            previousObjRef = objectRef;
        }
    }
    return object;
}
var $afcc65e7f92ff559$var$updateAt = (fieldValues, index, value1)=>{
    fieldValues[index] = value1;
    return fieldValues;
};
/**
 * A custom hook that exposes convenient methods to perform operations with a list of dynamic inputs that need to be appended, updated, removed etc.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/usefieldarray) • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn)
 *
 * @param props - useFieldArray props
 *
 * @returns methods - functions to manipulate with the Field Arrays (dynamic inputs) {@link UseFieldArrayReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, control, handleSubmit, reset, trigger, setError } = useForm({
 *     defaultValues: {
 *       test: []
 *     }
 *   });
 *   const { fields, append } = useFieldArray({
 *     control,
 *     name: "test"
 *   });
 *
 *   return (
 *     <form onSubmit={handleSubmit(data => console.log(data))}>
 *       {fields.map((item, index) => (
 *          <input key={item.id} {...register(`test.${index}.firstName`)}  />
 *       ))}
 *       <button type="button" onClick={() => append({ firstName: "bill" })}>
 *         append
 *       </button>
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $afcc65e7f92ff559$export$310131896651d559(props) {
    const methods = $afcc65e7f92ff559$export$4d957a5e1be13b03();
    const { control: control = methods.control, name: name, keyName: keyName = "id", shouldUnregister: shouldUnregister } = props;
    const [fields, setFields] = (0, (/*@__PURE__*/$parcel$interopDefault($P551f))).useState(control._getFieldArray(name));
    const ids = (0, (/*@__PURE__*/$parcel$interopDefault($P551f))).useRef(control._getFieldArray(name).map($afcc65e7f92ff559$var$generateId));
    const _fieldIds = (0, (/*@__PURE__*/$parcel$interopDefault($P551f))).useRef(fields);
    const _name = (0, (/*@__PURE__*/$parcel$interopDefault($P551f))).useRef(name);
    const _actioned = (0, (/*@__PURE__*/$parcel$interopDefault($P551f))).useRef(false);
    _name.current = name;
    _fieldIds.current = fields;
    control._names.array.add(name);
    props.rules && control.register(name, props.rules);
    const callback = (0, (/*@__PURE__*/$parcel$interopDefault($P551f))).useCallback(({ values: values, name: fieldArrayName })=>{
        if (fieldArrayName === _name.current || !fieldArrayName) {
            const fieldValues = $afcc65e7f92ff559$export$3988ae62b71be9a3(values, _name.current, []);
            setFields(fieldValues);
            ids.current = fieldValues.map($afcc65e7f92ff559$var$generateId);
        }
    }, []);
    $afcc65e7f92ff559$var$useSubscribe({
        callback: callback,
        subject: control._subjects.array
    });
    const updateValues = (0, (/*@__PURE__*/$parcel$interopDefault($P551f))).useCallback((updatedFieldArrayValues)=>{
        _actioned.current = true;
        control._updateFieldArray(name, updatedFieldArrayValues);
    }, [
        control,
        name
    ]);
    const append$1 = (value1, options)=>{
        const appendValue = $afcc65e7f92ff559$var$convertToArrayPayload($afcc65e7f92ff559$var$cloneObject(value1));
        const updatedFieldArrayValues = $afcc65e7f92ff559$var$append(control._getFieldArray(name), appendValue);
        control._names.focus = $afcc65e7f92ff559$var$getFocusFieldName(name, updatedFieldArrayValues.length - 1, options);
        ids.current = $afcc65e7f92ff559$var$append(ids.current, appendValue.map($afcc65e7f92ff559$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $afcc65e7f92ff559$var$append, {
            argA: $afcc65e7f92ff559$var$fillEmptyArray(value1)
        });
    };
    const prepend$1 = (value1, options)=>{
        const prependValue = $afcc65e7f92ff559$var$convertToArrayPayload($afcc65e7f92ff559$var$cloneObject(value1));
        const updatedFieldArrayValues = $afcc65e7f92ff559$var$prepend(control._getFieldArray(name), prependValue);
        control._names.focus = $afcc65e7f92ff559$var$getFocusFieldName(name, 0, options);
        ids.current = $afcc65e7f92ff559$var$prepend(ids.current, prependValue.map($afcc65e7f92ff559$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $afcc65e7f92ff559$var$prepend, {
            argA: $afcc65e7f92ff559$var$fillEmptyArray(value1)
        });
    };
    const remove = (index)=>{
        const updatedFieldArrayValues = $afcc65e7f92ff559$var$removeArrayAt(control._getFieldArray(name), index);
        ids.current = $afcc65e7f92ff559$var$removeArrayAt(ids.current, index);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $afcc65e7f92ff559$var$removeArrayAt, {
            argA: index
        });
    };
    const insert$1 = (index, value1, options)=>{
        const insertValue = $afcc65e7f92ff559$var$convertToArrayPayload($afcc65e7f92ff559$var$cloneObject(value1));
        const updatedFieldArrayValues = $afcc65e7f92ff559$var$insert(control._getFieldArray(name), index, insertValue);
        control._names.focus = $afcc65e7f92ff559$var$getFocusFieldName(name, index, options);
        ids.current = $afcc65e7f92ff559$var$insert(ids.current, index, insertValue.map($afcc65e7f92ff559$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $afcc65e7f92ff559$var$insert, {
            argA: index,
            argB: $afcc65e7f92ff559$var$fillEmptyArray(value1)
        });
    };
    const swap = (indexA, indexB)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        $afcc65e7f92ff559$var$swapArrayAt(updatedFieldArrayValues, indexA, indexB);
        $afcc65e7f92ff559$var$swapArrayAt(ids.current, indexA, indexB);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $afcc65e7f92ff559$var$swapArrayAt, {
            argA: indexA,
            argB: indexB
        }, false);
    };
    const move = (from, to)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        $afcc65e7f92ff559$var$moveArrayAt(updatedFieldArrayValues, from, to);
        $afcc65e7f92ff559$var$moveArrayAt(ids.current, from, to);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $afcc65e7f92ff559$var$moveArrayAt, {
            argA: from,
            argB: to
        }, false);
    };
    const update = (index, value1)=>{
        const updateValue = $afcc65e7f92ff559$var$cloneObject(value1);
        const updatedFieldArrayValues = $afcc65e7f92ff559$var$updateAt(control._getFieldArray(name), index, updateValue);
        ids.current = [
            ...updatedFieldArrayValues
        ].map((item, i)=>!item || i === index ? $afcc65e7f92ff559$var$generateId() : ids.current[i]);
        updateValues(updatedFieldArrayValues);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._updateFieldArray(name, updatedFieldArrayValues, $afcc65e7f92ff559$var$updateAt, {
            argA: index,
            argB: updateValue
        }, true, false);
    };
    const replace = (value1)=>{
        const updatedFieldArrayValues = $afcc65e7f92ff559$var$convertToArrayPayload($afcc65e7f92ff559$var$cloneObject(value1));
        ids.current = updatedFieldArrayValues.map($afcc65e7f92ff559$var$generateId);
        updateValues([
            ...updatedFieldArrayValues
        ]);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._updateFieldArray(name, [
            ...updatedFieldArrayValues
        ], (data)=>data, {}, true, false);
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($P551f))).useEffect(()=>{
        control._stateFlags.action = false;
        $afcc65e7f92ff559$var$isWatched(name, control._names) && control._subjects.state.next({});
        if (_actioned.current) {
            if (control._options.resolver) control._executeSchema([
                name
            ]).then((result)=>{
                const error = $afcc65e7f92ff559$export$3988ae62b71be9a3(result.errors, name);
                const existingError = $afcc65e7f92ff559$export$3988ae62b71be9a3(control._formState.errors, name);
                if (existingError ? !error && existingError.type : error && error.type) {
                    error ? $afcc65e7f92ff559$export$adaa4cf7ef1b65be(control._formState.errors, name, error) : $afcc65e7f92ff559$var$unset(control._formState.errors, name);
                    control._subjects.state.next({
                        errors: control._formState.errors
                    });
                }
            });
            else {
                const field = $afcc65e7f92ff559$export$3988ae62b71be9a3(control._fields, name);
                const validationModeBeforeSubmit = $afcc65e7f92ff559$var$getValidationModes(control._options.mode);
                if ((!validationModeBeforeSubmit.isOnSubmit || control._formState.isSubmitted) && field && field._f) $afcc65e7f92ff559$var$validateField(field, $afcc65e7f92ff559$export$3988ae62b71be9a3(control._formValues, name), control._options.criteriaMode === $afcc65e7f92ff559$var$VALIDATION_MODE.all, control._options.shouldUseNativeValidation, true).then((error)=>!$afcc65e7f92ff559$var$isEmptyObject(error) && control._subjects.state.next({
                        errors: $afcc65e7f92ff559$var$updateFieldArrayRootError(control._formState.errors, error, name)
                    }));
            }
        }
        control._subjects.watch.next({
            name: name,
            values: control._formValues
        });
        control._names.focus && $afcc65e7f92ff559$var$focusFieldBy(control._fields, (key)=>key.startsWith(control._names.focus));
        control._names.focus = "";
        control._proxyFormState.isValid && control._updateValid();
    }, [
        fields,
        name,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($P551f))).useEffect(()=>{
        !$afcc65e7f92ff559$export$3988ae62b71be9a3(control._formValues, name) && control._updateFieldArray(name);
        return ()=>{
            (control._options.shouldUnregister || shouldUnregister) && control.unregister(name);
        };
    }, [
        name,
        control,
        keyName,
        shouldUnregister
    ]);
    return {
        swap: (0, (/*@__PURE__*/$parcel$interopDefault($P551f))).useCallback(swap, [
            updateValues,
            name,
            control
        ]),
        move: (0, (/*@__PURE__*/$parcel$interopDefault($P551f))).useCallback(move, [
            updateValues,
            name,
            control
        ]),
        prepend: (0, (/*@__PURE__*/$parcel$interopDefault($P551f))).useCallback(prepend$1, [
            updateValues,
            name,
            control
        ]),
        append: (0, (/*@__PURE__*/$parcel$interopDefault($P551f))).useCallback(append$1, [
            updateValues,
            name,
            control
        ]),
        remove: (0, (/*@__PURE__*/$parcel$interopDefault($P551f))).useCallback(remove, [
            updateValues,
            name,
            control
        ]),
        insert: (0, (/*@__PURE__*/$parcel$interopDefault($P551f))).useCallback(insert$1, [
            updateValues,
            name,
            control
        ]),
        update: (0, (/*@__PURE__*/$parcel$interopDefault($P551f))).useCallback(update, [
            updateValues,
            name,
            control
        ]),
        replace: (0, (/*@__PURE__*/$parcel$interopDefault($P551f))).useCallback(replace, [
            updateValues,
            name,
            control
        ]),
        fields: (0, (/*@__PURE__*/$parcel$interopDefault($P551f))).useMemo(()=>fields.map((field, index)=>(0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, field), {
                    [keyName]: ids.current[index] || $afcc65e7f92ff559$var$generateId()
                })), [
            fields,
            keyName
        ])
    };
}
function $afcc65e7f92ff559$var$createSubject() {
    let _observers = [];
    const next = (value1)=>{
        for (const observer of _observers)observer.next(value1);
    };
    const subscribe = (observer)=>{
        _observers.push(observer);
        return {
            unsubscribe: ()=>{
                _observers = _observers.filter((o)=>o !== observer);
            }
        };
    };
    const unsubscribe = ()=>{
        _observers = [];
    };
    return {
        get observers () {
            return _observers;
        },
        next: next,
        subscribe: subscribe,
        unsubscribe: unsubscribe
    };
}
var $afcc65e7f92ff559$var$isPrimitive = (value1)=>$afcc65e7f92ff559$var$isNullOrUndefined(value1) || !$afcc65e7f92ff559$var$isObjectType(value1);
function $afcc65e7f92ff559$var$deepEqual(object1, object2) {
    if ($afcc65e7f92ff559$var$isPrimitive(object1) || $afcc65e7f92ff559$var$isPrimitive(object2)) return object1 === object2;
    if ($afcc65e7f92ff559$var$isDateObject(object1) && $afcc65e7f92ff559$var$isDateObject(object2)) return object1.getTime() === object2.getTime();
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) return false;
    for (const key of keys1){
        const val1 = object1[key];
        if (!keys2.includes(key)) return false;
        if (key !== "ref") {
            const val2 = object2[key];
            if ($afcc65e7f92ff559$var$isDateObject(val1) && $afcc65e7f92ff559$var$isDateObject(val2) || $afcc65e7f92ff559$var$isObject(val1) && $afcc65e7f92ff559$var$isObject(val2) || Array.isArray(val1) && Array.isArray(val2) ? !$afcc65e7f92ff559$var$deepEqual(val1, val2) : val1 !== val2) return false;
        }
    }
    return true;
}
var $afcc65e7f92ff559$var$isHTMLElement = (value1)=>{
    const owner = value1 ? value1.ownerDocument : 0;
    const ElementClass = owner && owner.defaultView ? owner.defaultView.HTMLElement : HTMLElement;
    return value1 instanceof ElementClass;
};
var $afcc65e7f92ff559$var$isMultipleSelect = (element)=>element.type === `select-multiple`;
var $afcc65e7f92ff559$var$isRadioOrCheckbox = (ref)=>$afcc65e7f92ff559$var$isRadioInput(ref) || $afcc65e7f92ff559$var$isCheckBoxInput(ref);
var $afcc65e7f92ff559$var$live = (ref)=>$afcc65e7f92ff559$var$isHTMLElement(ref) && ref.isConnected;
function $afcc65e7f92ff559$var$markFieldsDirty(data, fields = {}) {
    const isParentNodeArray = Array.isArray(data);
    if ($afcc65e7f92ff559$var$isObject(data) || isParentNodeArray) for(const key in data){
        if (Array.isArray(data[key]) || $afcc65e7f92ff559$var$isObject(data[key]) && !$afcc65e7f92ff559$var$objectHasFunction(data[key])) {
            fields[key] = Array.isArray(data[key]) ? [] : {};
            $afcc65e7f92ff559$var$markFieldsDirty(data[key], fields[key]);
        } else if (!$afcc65e7f92ff559$var$isNullOrUndefined(data[key])) fields[key] = true;
    }
    return fields;
}
function $afcc65e7f92ff559$var$getDirtyFieldsFromDefaultValues(data, formValues, dirtyFieldsFromValues) {
    const isParentNodeArray = Array.isArray(data);
    if ($afcc65e7f92ff559$var$isObject(data) || isParentNodeArray) {
        for(const key in data)if (Array.isArray(data[key]) || $afcc65e7f92ff559$var$isObject(data[key]) && !$afcc65e7f92ff559$var$objectHasFunction(data[key])) {
            if ($afcc65e7f92ff559$var$isUndefined(formValues) || $afcc65e7f92ff559$var$isPrimitive(dirtyFieldsFromValues[key])) dirtyFieldsFromValues[key] = Array.isArray(data[key]) ? $afcc65e7f92ff559$var$markFieldsDirty(data[key], []) : (0, $0de5391da8318002$export$581ff339ea0ba762)({}, $afcc65e7f92ff559$var$markFieldsDirty(data[key]));
            else $afcc65e7f92ff559$var$getDirtyFieldsFromDefaultValues(data[key], $afcc65e7f92ff559$var$isNullOrUndefined(formValues) ? {} : formValues[key], dirtyFieldsFromValues[key]);
        } else dirtyFieldsFromValues[key] = !$afcc65e7f92ff559$var$deepEqual(data[key], formValues[key]);
    }
    return dirtyFieldsFromValues;
}
var $afcc65e7f92ff559$var$getDirtyFields = (defaultValues, formValues)=>$afcc65e7f92ff559$var$getDirtyFieldsFromDefaultValues(defaultValues, formValues, $afcc65e7f92ff559$var$markFieldsDirty(formValues));
var $afcc65e7f92ff559$var$getFieldValueAs = (value1, { valueAsNumber: valueAsNumber, valueAsDate: valueAsDate, setValueAs: setValueAs })=>$afcc65e7f92ff559$var$isUndefined(value1) ? value1 : valueAsNumber ? value1 === "" || $afcc65e7f92ff559$var$isNullOrUndefined(value1) ? NaN : +value1 : valueAsDate && $afcc65e7f92ff559$var$isString(value1) ? new Date(value1) : setValueAs ? setValueAs(value1) : value1;
function $afcc65e7f92ff559$var$getFieldValue(_f) {
    const ref = _f.ref;
    if (_f.refs ? _f.refs.every((ref)=>ref.disabled) : ref.disabled) return;
    if ($afcc65e7f92ff559$var$isFileInput(ref)) return ref.files;
    if ($afcc65e7f92ff559$var$isRadioInput(ref)) return $afcc65e7f92ff559$var$getRadioValue(_f.refs).value;
    if ($afcc65e7f92ff559$var$isMultipleSelect(ref)) return [
        ...ref.selectedOptions
    ].map(({ value: value1 })=>value1);
    if ($afcc65e7f92ff559$var$isCheckBoxInput(ref)) return $afcc65e7f92ff559$var$getCheckboxValue(_f.refs).value;
    return $afcc65e7f92ff559$var$getFieldValueAs($afcc65e7f92ff559$var$isUndefined(ref.value) ? _f.ref.value : ref.value, _f);
}
var $afcc65e7f92ff559$var$getResolverOptions = (fieldsNames, _fields, criteriaMode, shouldUseNativeValidation)=>{
    const fields = {};
    for (const name of fieldsNames){
        const field = $afcc65e7f92ff559$export$3988ae62b71be9a3(_fields, name);
        field && $afcc65e7f92ff559$export$adaa4cf7ef1b65be(fields, name, field._f);
    }
    return {
        criteriaMode: criteriaMode,
        names: [
            ...fieldsNames
        ],
        fields: fields,
        shouldUseNativeValidation: shouldUseNativeValidation
    };
};
var $afcc65e7f92ff559$var$getRuleValue = (rule)=>$afcc65e7f92ff559$var$isUndefined(rule) ? undefined : $afcc65e7f92ff559$var$isRegex(rule) ? rule.source : $afcc65e7f92ff559$var$isObject(rule) ? $afcc65e7f92ff559$var$isRegex(rule.value) ? rule.value.source : rule.value : rule;
var $afcc65e7f92ff559$var$hasValidation = (options)=>options.mount && (options.required || options.min || options.max || options.maxLength || options.minLength || options.pattern || options.validate);
function $afcc65e7f92ff559$var$schemaErrorLookup(errors, _fields, name) {
    const error = $afcc65e7f92ff559$export$3988ae62b71be9a3(errors, name);
    if (error || $afcc65e7f92ff559$var$isKey(name)) return {
        error: error,
        name: name
    };
    const names = name.split(".");
    while(names.length){
        const fieldName = names.join(".");
        const field = $afcc65e7f92ff559$export$3988ae62b71be9a3(_fields, fieldName);
        const foundError = $afcc65e7f92ff559$export$3988ae62b71be9a3(errors, fieldName);
        if (field && !Array.isArray(field) && name !== fieldName) return {
            name: name
        };
        if (foundError && foundError.type) return {
            name: fieldName,
            error: foundError
        };
        names.pop();
    }
    return {
        name: name
    };
}
var $afcc65e7f92ff559$var$skipValidation = (isBlurEvent, isTouched, isSubmitted, reValidateMode, mode)=>{
    if (mode.isOnAll) return false;
    else if (!isSubmitted && mode.isOnTouch) return !(isTouched || isBlurEvent);
    else if (isSubmitted ? reValidateMode.isOnBlur : mode.isOnBlur) return !isBlurEvent;
    else if (isSubmitted ? reValidateMode.isOnChange : mode.isOnChange) return isBlurEvent;
    return true;
};
var $afcc65e7f92ff559$var$unsetEmptyArray = (ref, name)=>!$afcc65e7f92ff559$var$compact($afcc65e7f92ff559$export$3988ae62b71be9a3(ref, name)).length && $afcc65e7f92ff559$var$unset(ref, name);
const $afcc65e7f92ff559$var$defaultOptions = {
    mode: $afcc65e7f92ff559$var$VALIDATION_MODE.onSubmit,
    reValidateMode: $afcc65e7f92ff559$var$VALIDATION_MODE.onChange,
    shouldFocusError: true
};
function $afcc65e7f92ff559$var$createFormControl(props = {}) {
    let _options = (0, $0de5391da8318002$export$581ff339ea0ba762)({}, $afcc65e7f92ff559$var$defaultOptions, props);
    let _formState = {
        isDirty: false,
        isValidating: false,
        dirtyFields: {},
        isSubmitted: false,
        submitCount: 0,
        touchedFields: {},
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        errors: {}
    };
    let _fields = {};
    let _defaultValues = $afcc65e7f92ff559$var$cloneObject(_options.defaultValues) || {};
    let _formValues = _options.shouldUnregister ? {} : $afcc65e7f92ff559$var$cloneObject(_defaultValues);
    let _stateFlags = {
        action: false,
        mount: false,
        watch: false
    };
    let _names = {
        mount: new Set(),
        unMount: new Set(),
        array: new Set(),
        watch: new Set()
    };
    let delayErrorCallback;
    let timer = 0;
    let validateFields = {};
    const _proxyFormState = {
        isDirty: false,
        dirtyFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    };
    const _subjects = {
        watch: $afcc65e7f92ff559$var$createSubject(),
        array: $afcc65e7f92ff559$var$createSubject(),
        state: $afcc65e7f92ff559$var$createSubject()
    };
    const validationModeBeforeSubmit = $afcc65e7f92ff559$var$getValidationModes(_options.mode);
    const validationModeAfterSubmit = $afcc65e7f92ff559$var$getValidationModes(_options.reValidateMode);
    const shouldDisplayAllAssociatedErrors = _options.criteriaMode === $afcc65e7f92ff559$var$VALIDATION_MODE.all;
    const debounce = (callback)=>(wait)=>{
            clearTimeout(timer);
            timer = window.setTimeout(callback, wait);
        };
    const _updateValid = async (shouldSkipRender)=>{
        let isValid = false;
        if (_proxyFormState.isValid) {
            isValid = _options.resolver ? $afcc65e7f92ff559$var$isEmptyObject((await _executeSchema()).errors) : await executeBuiltInValidation(_fields, true);
            if (!shouldSkipRender && isValid !== _formState.isValid) {
                _formState.isValid = isValid;
                _subjects.state.next({
                    isValid: isValid
                });
            }
        }
        return isValid;
    };
    const _updateFieldArray = (name, values = [], method, args, shouldSetValues = true, shouldUpdateFieldsAndState = true)=>{
        if (args && method) {
            _stateFlags.action = true;
            if (shouldUpdateFieldsAndState && Array.isArray($afcc65e7f92ff559$export$3988ae62b71be9a3(_fields, name))) {
                const fieldValues = method($afcc65e7f92ff559$export$3988ae62b71be9a3(_fields, name), args.argA, args.argB);
                shouldSetValues && $afcc65e7f92ff559$export$adaa4cf7ef1b65be(_fields, name, fieldValues);
            }
            if (_proxyFormState.errors && shouldUpdateFieldsAndState && Array.isArray($afcc65e7f92ff559$export$3988ae62b71be9a3(_formState.errors, name))) {
                const errors = method($afcc65e7f92ff559$export$3988ae62b71be9a3(_formState.errors, name), args.argA, args.argB);
                shouldSetValues && $afcc65e7f92ff559$export$adaa4cf7ef1b65be(_formState.errors, name, errors);
                $afcc65e7f92ff559$var$unsetEmptyArray(_formState.errors, name);
            }
            if (_proxyFormState.touchedFields && shouldUpdateFieldsAndState && Array.isArray($afcc65e7f92ff559$export$3988ae62b71be9a3(_formState.touchedFields, name))) {
                const touchedFields = method($afcc65e7f92ff559$export$3988ae62b71be9a3(_formState.touchedFields, name), args.argA, args.argB);
                shouldSetValues && $afcc65e7f92ff559$export$adaa4cf7ef1b65be(_formState.touchedFields, name, touchedFields);
            }
            if (_proxyFormState.dirtyFields) _formState.dirtyFields = $afcc65e7f92ff559$var$getDirtyFields(_defaultValues, _formValues);
            _subjects.state.next({
                isDirty: _getDirty(name, values),
                dirtyFields: _formState.dirtyFields,
                errors: _formState.errors,
                isValid: _formState.isValid
            });
        } else $afcc65e7f92ff559$export$adaa4cf7ef1b65be(_formValues, name, values);
    };
    const updateErrors = (name, error)=>{
        $afcc65e7f92ff559$export$adaa4cf7ef1b65be(_formState.errors, name, error);
        _subjects.state.next({
            errors: _formState.errors
        });
    };
    const updateValidAndValue = (name, shouldSkipSetValueAs, value1, ref)=>{
        const field = $afcc65e7f92ff559$export$3988ae62b71be9a3(_fields, name);
        if (field) {
            const defaultValue = $afcc65e7f92ff559$export$3988ae62b71be9a3(_formValues, name, $afcc65e7f92ff559$var$isUndefined(value1) ? $afcc65e7f92ff559$export$3988ae62b71be9a3(_defaultValues, name) : value1);
            $afcc65e7f92ff559$var$isUndefined(defaultValue) || ref && ref.defaultChecked || shouldSkipSetValueAs ? $afcc65e7f92ff559$export$adaa4cf7ef1b65be(_formValues, name, shouldSkipSetValueAs ? defaultValue : $afcc65e7f92ff559$var$getFieldValue(field._f)) : setFieldValue(name, defaultValue);
            _stateFlags.mount && _updateValid();
        }
    };
    const updateTouchAndDirty = (name, fieldValue, isBlurEvent, shouldDirty, shouldRender)=>{
        let isFieldDirty = false;
        const output = {
            name: name
        };
        const isPreviousFieldTouched = $afcc65e7f92ff559$export$3988ae62b71be9a3(_formState.touchedFields, name);
        if (_proxyFormState.isDirty) {
            const isPreviousFormDirty = _formState.isDirty;
            _formState.isDirty = output.isDirty = _getDirty();
            isFieldDirty = isPreviousFormDirty !== output.isDirty;
        }
        if (_proxyFormState.dirtyFields && (!isBlurEvent || shouldDirty)) {
            const isPreviousFieldDirty = $afcc65e7f92ff559$export$3988ae62b71be9a3(_formState.dirtyFields, name);
            const isCurrentFieldPristine = $afcc65e7f92ff559$var$deepEqual($afcc65e7f92ff559$export$3988ae62b71be9a3(_defaultValues, name), fieldValue);
            isCurrentFieldPristine ? $afcc65e7f92ff559$var$unset(_formState.dirtyFields, name) : $afcc65e7f92ff559$export$adaa4cf7ef1b65be(_formState.dirtyFields, name, true);
            output.dirtyFields = _formState.dirtyFields;
            isFieldDirty = isFieldDirty || isPreviousFieldDirty !== $afcc65e7f92ff559$export$3988ae62b71be9a3(_formState.dirtyFields, name);
        }
        if (isBlurEvent && !isPreviousFieldTouched) {
            $afcc65e7f92ff559$export$adaa4cf7ef1b65be(_formState.touchedFields, name, isBlurEvent);
            output.touchedFields = _formState.touchedFields;
            isFieldDirty = isFieldDirty || _proxyFormState.touchedFields && isPreviousFieldTouched !== isBlurEvent;
        }
        isFieldDirty && shouldRender && _subjects.state.next(output);
        return isFieldDirty ? output : {};
    };
    const shouldRenderByError = async (name, isValid, error, fieldState)=>{
        const previousFieldError = $afcc65e7f92ff559$export$3988ae62b71be9a3(_formState.errors, name);
        const shouldUpdateValid = _proxyFormState.isValid && _formState.isValid !== isValid;
        if (props.delayError && error) {
            delayErrorCallback = debounce(()=>updateErrors(name, error));
            delayErrorCallback(props.delayError);
        } else {
            clearTimeout(timer);
            delayErrorCallback = null;
            error ? $afcc65e7f92ff559$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $afcc65e7f92ff559$var$unset(_formState.errors, name);
        }
        if ((error ? !$afcc65e7f92ff559$var$deepEqual(previousFieldError, error) : previousFieldError) || !$afcc65e7f92ff559$var$isEmptyObject(fieldState) || shouldUpdateValid) {
            const updatedFormState = (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, fieldState, shouldUpdateValid ? {
                isValid: isValid
            } : {}), {
                errors: _formState.errors,
                name: name
            });
            _formState = (0, $0de5391da8318002$export$581ff339ea0ba762)({}, _formState, updatedFormState);
            _subjects.state.next(updatedFormState);
        }
        validateFields[name]--;
        if (_proxyFormState.isValidating && !Object.values(validateFields).some((v)=>v)) {
            _subjects.state.next({
                isValidating: false
            });
            validateFields = {};
        }
    };
    const _executeSchema = async (name)=>_options.resolver ? await _options.resolver((0, $0de5391da8318002$export$581ff339ea0ba762)({}, _formValues), _options.context, $afcc65e7f92ff559$var$getResolverOptions(name || _names.mount, _fields, _options.criteriaMode, _options.shouldUseNativeValidation)) : {};
    const executeSchemaAndUpdateState = async (names)=>{
        const { errors: errors } = await _executeSchema();
        if (names) for (const name of names){
            const error = $afcc65e7f92ff559$export$3988ae62b71be9a3(errors, name);
            error ? $afcc65e7f92ff559$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $afcc65e7f92ff559$var$unset(_formState.errors, name);
        }
        else _formState.errors = errors;
        return errors;
    };
    const executeBuiltInValidation = async (fields, shouldOnlyCheckValid, context = {
        valid: true
    })=>{
        for(const _ref in fields){
            let name = _ref;
            const field = fields[name];
            if (field) {
                const { _f: _f } = field, fieldValue = (0, $451b529b5830e8ac$export$69fdd232f62cde60)(field, [
                    "_f"
                ]);
                if (_f) {
                    const isFieldArrayRoot = _names.array.has(_f.name);
                    const fieldError = await $afcc65e7f92ff559$var$validateField(field, $afcc65e7f92ff559$export$3988ae62b71be9a3(_formValues, _f.name), shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation, isFieldArrayRoot);
                    if (fieldError[_f.name]) {
                        context.valid = false;
                        if (shouldOnlyCheckValid) break;
                    }
                    !shouldOnlyCheckValid && ($afcc65e7f92ff559$export$3988ae62b71be9a3(fieldError, _f.name) ? isFieldArrayRoot ? $afcc65e7f92ff559$var$updateFieldArrayRootError(_formState.errors, fieldError, _f.name) : $afcc65e7f92ff559$export$adaa4cf7ef1b65be(_formState.errors, _f.name, fieldError[_f.name]) : $afcc65e7f92ff559$var$unset(_formState.errors, _f.name));
                }
                fieldValue && await executeBuiltInValidation(fieldValue, shouldOnlyCheckValid, context);
            }
        }
        return context.valid;
    };
    const _removeUnmounted = ()=>{
        for (const name of _names.unMount){
            const field = $afcc65e7f92ff559$export$3988ae62b71be9a3(_fields, name);
            field && (field._f.refs ? field._f.refs.every((ref)=>!$afcc65e7f92ff559$var$live(ref)) : !$afcc65e7f92ff559$var$live(field._f.ref)) && unregister(name);
        }
        _names.unMount = new Set();
    };
    const _getDirty = (name, data)=>(name && data && $afcc65e7f92ff559$export$adaa4cf7ef1b65be(_formValues, name, data), !$afcc65e7f92ff559$var$deepEqual(getValues(), _defaultValues));
    const _getWatch = (names, defaultValue, isGlobal)=>{
        const fieldValues = (0, $0de5391da8318002$export$581ff339ea0ba762)({}, _stateFlags.mount ? _formValues : $afcc65e7f92ff559$var$isUndefined(defaultValue) ? _defaultValues : $afcc65e7f92ff559$var$isString(names) ? {
            [names]: defaultValue
        } : defaultValue);
        return $afcc65e7f92ff559$var$generateWatchOutput(names, _names, fieldValues, isGlobal);
    };
    const _getFieldArray = (name)=>$afcc65e7f92ff559$var$compact($afcc65e7f92ff559$export$3988ae62b71be9a3(_stateFlags.mount ? _formValues : _defaultValues, name, props.shouldUnregister ? $afcc65e7f92ff559$export$3988ae62b71be9a3(_defaultValues, name, []) : []));
    const setFieldValue = (name, value1, options = {})=>{
        const field = $afcc65e7f92ff559$export$3988ae62b71be9a3(_fields, name);
        let fieldValue = value1;
        if (field) {
            const fieldReference = field._f;
            if (fieldReference) {
                !fieldReference.disabled && $afcc65e7f92ff559$export$adaa4cf7ef1b65be(_formValues, name, $afcc65e7f92ff559$var$getFieldValueAs(value1, fieldReference));
                fieldValue = $afcc65e7f92ff559$var$isWeb && $afcc65e7f92ff559$var$isHTMLElement(fieldReference.ref) && $afcc65e7f92ff559$var$isNullOrUndefined(value1) ? "" : value1;
                if ($afcc65e7f92ff559$var$isMultipleSelect(fieldReference.ref)) [
                    ...fieldReference.ref.options
                ].forEach((selectRef)=>selectRef.selected = fieldValue.includes(selectRef.value));
                else if (fieldReference.refs) {
                    if ($afcc65e7f92ff559$var$isCheckBoxInput(fieldReference.ref)) fieldReference.refs.length > 1 ? fieldReference.refs.forEach((checkboxRef)=>!checkboxRef.disabled && (checkboxRef.checked = Array.isArray(fieldValue) ? !!fieldValue.find((data)=>data === checkboxRef.value) : fieldValue === checkboxRef.value)) : fieldReference.refs[0] && (fieldReference.refs[0].checked = !!fieldValue);
                    else fieldReference.refs.forEach((radioRef)=>radioRef.checked = radioRef.value === fieldValue);
                } else if ($afcc65e7f92ff559$var$isFileInput(fieldReference.ref)) fieldReference.ref.value = "";
                else {
                    fieldReference.ref.value = fieldValue;
                    if (!fieldReference.ref.type) _subjects.watch.next({
                        name: name
                    });
                }
            }
        }
        (options.shouldDirty || options.shouldTouch) && updateTouchAndDirty(name, fieldValue, options.shouldTouch, options.shouldDirty, true);
        options.shouldValidate && trigger(name);
    };
    const setValues = (name, value1, options)=>{
        for(const fieldKey in value1){
            const fieldValue = value1[fieldKey];
            const fieldName = `${name}.${fieldKey}`;
            const field = $afcc65e7f92ff559$export$3988ae62b71be9a3(_fields, fieldName);
            (_names.array.has(name) || !$afcc65e7f92ff559$var$isPrimitive(fieldValue) || field && !field._f) && !$afcc65e7f92ff559$var$isDateObject(fieldValue) ? setValues(fieldName, fieldValue, options) : setFieldValue(fieldName, fieldValue, options);
        }
    };
    const setValue = (name, value1, options = {})=>{
        const field = $afcc65e7f92ff559$export$3988ae62b71be9a3(_fields, name);
        const isFieldArray = _names.array.has(name);
        const cloneValue = $afcc65e7f92ff559$var$cloneObject(value1);
        $afcc65e7f92ff559$export$adaa4cf7ef1b65be(_formValues, name, cloneValue);
        if (isFieldArray) {
            _subjects.array.next({
                name: name,
                values: _formValues
            });
            if ((_proxyFormState.isDirty || _proxyFormState.dirtyFields) && options.shouldDirty) {
                _formState.dirtyFields = $afcc65e7f92ff559$var$getDirtyFields(_defaultValues, _formValues);
                _subjects.state.next({
                    name: name,
                    dirtyFields: _formState.dirtyFields,
                    isDirty: _getDirty(name, cloneValue)
                });
            }
        } else field && !field._f && !$afcc65e7f92ff559$var$isNullOrUndefined(cloneValue) ? setValues(name, cloneValue, options) : setFieldValue(name, cloneValue, options);
        $afcc65e7f92ff559$var$isWatched(name, _names) && _subjects.state.next({});
        _subjects.watch.next({
            name: name
        });
    };
    const onChange = async (event)=>{
        const target = event.target;
        let name = target.name;
        const field = $afcc65e7f92ff559$export$3988ae62b71be9a3(_fields, name);
        if (field) {
            let error;
            let isValid;
            const fieldValue = target.type ? $afcc65e7f92ff559$var$getFieldValue(field._f) : $afcc65e7f92ff559$var$getEventValue(event);
            const isBlurEvent = event.type === $afcc65e7f92ff559$var$EVENTS.BLUR || event.type === $afcc65e7f92ff559$var$EVENTS.FOCUS_OUT;
            const shouldSkipValidation = !$afcc65e7f92ff559$var$hasValidation(field._f) && !_options.resolver && !$afcc65e7f92ff559$export$3988ae62b71be9a3(_formState.errors, name) && !field._f.deps || $afcc65e7f92ff559$var$skipValidation(isBlurEvent, $afcc65e7f92ff559$export$3988ae62b71be9a3(_formState.touchedFields, name), _formState.isSubmitted, validationModeAfterSubmit, validationModeBeforeSubmit);
            const watched = $afcc65e7f92ff559$var$isWatched(name, _names, isBlurEvent);
            $afcc65e7f92ff559$export$adaa4cf7ef1b65be(_formValues, name, fieldValue);
            if (isBlurEvent) {
                field._f.onBlur && field._f.onBlur(event);
                delayErrorCallback && delayErrorCallback(0);
            } else if (field._f.onChange) field._f.onChange(event);
            const fieldState = updateTouchAndDirty(name, fieldValue, isBlurEvent, false);
            const shouldRender = !$afcc65e7f92ff559$var$isEmptyObject(fieldState) || watched;
            !isBlurEvent && _subjects.watch.next({
                name: name,
                type: event.type
            });
            if (shouldSkipValidation) return shouldRender && _subjects.state.next((0, $0de5391da8318002$export$581ff339ea0ba762)({
                name: name
            }, watched ? {} : fieldState));
            !isBlurEvent && watched && _subjects.state.next({});
            validateFields[name] = validateFields[name] ? 1 : 1;
            _subjects.state.next({
                isValidating: true
            });
            if (_options.resolver) {
                const { errors: errors } = await _executeSchema([
                    name
                ]);
                const previousErrorLookupResult = $afcc65e7f92ff559$var$schemaErrorLookup(_formState.errors, _fields, name);
                const errorLookupResult = $afcc65e7f92ff559$var$schemaErrorLookup(errors, _fields, previousErrorLookupResult.name || name);
                error = errorLookupResult.error;
                name = errorLookupResult.name;
                isValid = $afcc65e7f92ff559$var$isEmptyObject(errors);
            } else {
                error = (await $afcc65e7f92ff559$var$validateField(field, $afcc65e7f92ff559$export$3988ae62b71be9a3(_formValues, name), shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation))[name];
                isValid = await _updateValid(true);
            }
            field._f.deps && trigger(field._f.deps);
            shouldRenderByError(name, isValid, error, fieldState);
        }
    };
    const trigger = async (name, options = {})=>{
        let isValid;
        let validationResult;
        const fieldNames = $afcc65e7f92ff559$var$convertToArrayPayload(name);
        _subjects.state.next({
            isValidating: true
        });
        if (_options.resolver) {
            const errors = await executeSchemaAndUpdateState($afcc65e7f92ff559$var$isUndefined(name) ? name : fieldNames);
            isValid = $afcc65e7f92ff559$var$isEmptyObject(errors);
            validationResult = name ? !fieldNames.some((name)=>$afcc65e7f92ff559$export$3988ae62b71be9a3(errors, name)) : isValid;
        } else if (name) {
            validationResult = (await Promise.all(fieldNames.map(async (fieldName)=>{
                const field = $afcc65e7f92ff559$export$3988ae62b71be9a3(_fields, fieldName);
                return await executeBuiltInValidation(field && field._f ? {
                    [fieldName]: field
                } : field);
            }))).every(Boolean);
            !(!validationResult && !_formState.isValid) && _updateValid();
        } else validationResult = isValid = await executeBuiltInValidation(_fields);
        _subjects.state.next((0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, !$afcc65e7f92ff559$var$isString(name) || _proxyFormState.isValid && isValid !== _formState.isValid ? {} : {
            name: name
        }, _options.resolver ? {
            isValid: isValid
        } : {}), {
            errors: _formState.errors,
            isValidating: false
        }));
        options.shouldFocus && !validationResult && $afcc65e7f92ff559$var$focusFieldBy(_fields, (key)=>$afcc65e7f92ff559$export$3988ae62b71be9a3(_formState.errors, key), name ? fieldNames : _names.mount);
        return validationResult;
    };
    const getValues = (fieldNames)=>{
        const values = (0, $0de5391da8318002$export$581ff339ea0ba762)({}, _defaultValues, _stateFlags.mount ? _formValues : {});
        return $afcc65e7f92ff559$var$isUndefined(fieldNames) ? values : $afcc65e7f92ff559$var$isString(fieldNames) ? $afcc65e7f92ff559$export$3988ae62b71be9a3(values, fieldNames) : fieldNames.map((name)=>$afcc65e7f92ff559$export$3988ae62b71be9a3(values, name));
    };
    const getFieldState = (name, formState)=>({
            invalid: !!$afcc65e7f92ff559$export$3988ae62b71be9a3((formState || _formState).errors, name),
            isDirty: !!$afcc65e7f92ff559$export$3988ae62b71be9a3((formState || _formState).dirtyFields, name),
            isTouched: !!$afcc65e7f92ff559$export$3988ae62b71be9a3((formState || _formState).touchedFields, name),
            error: $afcc65e7f92ff559$export$3988ae62b71be9a3((formState || _formState).errors, name)
        });
    const clearErrors = (name)=>{
        name ? $afcc65e7f92ff559$var$convertToArrayPayload(name).forEach((inputName)=>$afcc65e7f92ff559$var$unset(_formState.errors, inputName)) : _formState.errors = {};
        _subjects.state.next({
            errors: _formState.errors
        });
    };
    const setError = (name, error, options)=>{
        const ref = ($afcc65e7f92ff559$export$3988ae62b71be9a3(_fields, name, {
            _f: {}
        })._f || {}).ref;
        $afcc65e7f92ff559$export$adaa4cf7ef1b65be(_formState.errors, name, (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, error), {
            ref: ref
        }));
        _subjects.state.next({
            name: name,
            errors: _formState.errors,
            isValid: false
        });
        options && options.shouldFocus && ref && ref.focus && ref.focus();
    };
    const watch = (name, defaultValue)=>$afcc65e7f92ff559$var$isFunction(name) ? _subjects.watch.subscribe({
            next: (info)=>name(_getWatch(undefined, defaultValue), info)
        }) : _getWatch(name, defaultValue, true);
    const unregister = (name, options = {})=>{
        for (const fieldName of name ? $afcc65e7f92ff559$var$convertToArrayPayload(name) : _names.mount){
            _names.mount.delete(fieldName);
            _names.array.delete(fieldName);
            if ($afcc65e7f92ff559$export$3988ae62b71be9a3(_fields, fieldName)) {
                if (!options.keepValue) {
                    $afcc65e7f92ff559$var$unset(_fields, fieldName);
                    $afcc65e7f92ff559$var$unset(_formValues, fieldName);
                }
                !options.keepError && $afcc65e7f92ff559$var$unset(_formState.errors, fieldName);
                !options.keepDirty && $afcc65e7f92ff559$var$unset(_formState.dirtyFields, fieldName);
                !options.keepTouched && $afcc65e7f92ff559$var$unset(_formState.touchedFields, fieldName);
                !_options.shouldUnregister && !options.keepDefaultValue && $afcc65e7f92ff559$var$unset(_defaultValues, fieldName);
            }
        }
        _subjects.watch.next({});
        _subjects.state.next((0, $0de5391da8318002$export$581ff339ea0ba762)({}, _formState, !options.keepDirty ? {} : {
            isDirty: _getDirty()
        }));
        !options.keepIsValid && _updateValid();
    };
    const register = (name, options = {})=>{
        let field = $afcc65e7f92ff559$export$3988ae62b71be9a3(_fields, name);
        const disabledIsDefined = $afcc65e7f92ff559$var$isBoolean(options.disabled);
        $afcc65e7f92ff559$export$adaa4cf7ef1b65be(_fields, name, {
            _f: (0, $0de5391da8318002$export$581ff339ea0ba762)((0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, field && field._f ? field._f : {
                ref: {
                    name: name
                }
            }), {
                name: name,
                mount: true
            }), options)
        });
        _names.mount.add(name);
        field ? disabledIsDefined && $afcc65e7f92ff559$export$adaa4cf7ef1b65be(_formValues, name, options.disabled ? undefined : $afcc65e7f92ff559$export$3988ae62b71be9a3(_formValues, name, $afcc65e7f92ff559$var$getFieldValue(field._f))) : updateValidAndValue(name, true, options.value);
        return (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, disabledIsDefined ? {
            disabled: options.disabled
        } : {}, _options.shouldUseNativeValidation ? {
            required: !!options.required,
            min: $afcc65e7f92ff559$var$getRuleValue(options.min),
            max: $afcc65e7f92ff559$var$getRuleValue(options.max),
            minLength: $afcc65e7f92ff559$var$getRuleValue(options.minLength),
            maxLength: $afcc65e7f92ff559$var$getRuleValue(options.maxLength),
            pattern: $afcc65e7f92ff559$var$getRuleValue(options.pattern)
        } : {}), {
            name: name,
            onChange: onChange,
            onBlur: onChange,
            ref: (ref)=>{
                if (ref) {
                    register(name, options);
                    field = $afcc65e7f92ff559$export$3988ae62b71be9a3(_fields, name);
                    const fieldRef = $afcc65e7f92ff559$var$isUndefined(ref.value) ? ref.querySelectorAll ? ref.querySelectorAll("input,select,textarea")[0] || ref : ref : ref;
                    const radioOrCheckbox = $afcc65e7f92ff559$var$isRadioOrCheckbox(fieldRef);
                    const refs = field._f.refs || [];
                    if (radioOrCheckbox ? refs.find((option)=>option === fieldRef) : fieldRef === field._f.ref) return;
                    $afcc65e7f92ff559$export$adaa4cf7ef1b65be(_fields, name, {
                        _f: (0, $0de5391da8318002$export$581ff339ea0ba762)({}, field._f, radioOrCheckbox ? {
                            refs: [
                                ...refs.filter($afcc65e7f92ff559$var$live),
                                fieldRef,
                                ...!!Array.isArray($afcc65e7f92ff559$export$3988ae62b71be9a3(_defaultValues, name)) ? [
                                    {}
                                ] : []
                            ],
                            ref: {
                                type: fieldRef.type,
                                name: name
                            }
                        } : {
                            ref: fieldRef
                        })
                    });
                    updateValidAndValue(name, false, undefined, fieldRef);
                } else {
                    field = $afcc65e7f92ff559$export$3988ae62b71be9a3(_fields, name, {});
                    if (field._f) field._f.mount = false;
                    (_options.shouldUnregister || options.shouldUnregister) && !($afcc65e7f92ff559$var$isNameInFieldArray(_names.array, name) && _stateFlags.action) && _names.unMount.add(name);
                }
            }
        });
    };
    const handleSubmit = (onValid, onInvalid)=>async (e)=>{
            if (e) {
                e.preventDefault && e.preventDefault();
                e.persist && e.persist();
            }
            let hasNoPromiseError = true;
            let fieldValues = $afcc65e7f92ff559$var$cloneObject(_formValues);
            _subjects.state.next({
                isSubmitting: true
            });
            try {
                if (_options.resolver) {
                    const { errors: errors, values: values } = await _executeSchema();
                    _formState.errors = errors;
                    fieldValues = values;
                } else await executeBuiltInValidation(_fields);
                if ($afcc65e7f92ff559$var$isEmptyObject(_formState.errors)) {
                    _subjects.state.next({
                        errors: {},
                        isSubmitting: true
                    });
                    await onValid(fieldValues, e);
                } else {
                    if (onInvalid) await onInvalid((0, $0de5391da8318002$export$581ff339ea0ba762)({}, _formState.errors), e);
                    _options.shouldFocusError && $afcc65e7f92ff559$var$focusFieldBy(_fields, (key)=>$afcc65e7f92ff559$export$3988ae62b71be9a3(_formState.errors, key), _names.mount);
                }
            } catch (err) {
                hasNoPromiseError = false;
                throw err;
            } finally{
                _formState.isSubmitted = true;
                _subjects.state.next({
                    isSubmitted: true,
                    isSubmitting: false,
                    isSubmitSuccessful: $afcc65e7f92ff559$var$isEmptyObject(_formState.errors) && hasNoPromiseError,
                    submitCount: _formState.submitCount + 1,
                    errors: _formState.errors
                });
            }
        };
    const resetField = (name, options = {})=>{
        if ($afcc65e7f92ff559$export$3988ae62b71be9a3(_fields, name)) {
            if ($afcc65e7f92ff559$var$isUndefined(options.defaultValue)) setValue(name, $afcc65e7f92ff559$export$3988ae62b71be9a3(_defaultValues, name));
            else {
                setValue(name, options.defaultValue);
                $afcc65e7f92ff559$export$adaa4cf7ef1b65be(_defaultValues, name, options.defaultValue);
            }
            if (!options.keepTouched) $afcc65e7f92ff559$var$unset(_formState.touchedFields, name);
            if (!options.keepDirty) {
                $afcc65e7f92ff559$var$unset(_formState.dirtyFields, name);
                _formState.isDirty = options.defaultValue ? _getDirty(name, $afcc65e7f92ff559$export$3988ae62b71be9a3(_defaultValues, name)) : _getDirty();
            }
            if (!options.keepError) {
                $afcc65e7f92ff559$var$unset(_formState.errors, name);
                _proxyFormState.isValid && _updateValid();
            }
            _subjects.state.next((0, $0de5391da8318002$export$581ff339ea0ba762)({}, _formState));
        }
    };
    const reset = (formValues, keepStateOptions = {})=>{
        const updatedValues = formValues || _defaultValues;
        const cloneUpdatedValues = $afcc65e7f92ff559$var$cloneObject(updatedValues);
        const values = formValues && !$afcc65e7f92ff559$var$isEmptyObject(formValues) ? cloneUpdatedValues : _defaultValues;
        if (!keepStateOptions.keepDefaultValues) _defaultValues = updatedValues;
        if (!keepStateOptions.keepValues) {
            if (keepStateOptions.keepDirtyValues) for (const fieldName of _names.mount)$afcc65e7f92ff559$export$3988ae62b71be9a3(_formState.dirtyFields, fieldName) ? $afcc65e7f92ff559$export$adaa4cf7ef1b65be(values, fieldName, $afcc65e7f92ff559$export$3988ae62b71be9a3(_formValues, fieldName)) : setValue(fieldName, $afcc65e7f92ff559$export$3988ae62b71be9a3(values, fieldName));
            else {
                if ($afcc65e7f92ff559$var$isWeb && $afcc65e7f92ff559$var$isUndefined(formValues)) for (const name of _names.mount){
                    const field = $afcc65e7f92ff559$export$3988ae62b71be9a3(_fields, name);
                    if (field && field._f) {
                        const fieldReference = Array.isArray(field._f.refs) ? field._f.refs[0] : field._f.ref;
                        try {
                            if ($afcc65e7f92ff559$var$isHTMLElement(fieldReference)) {
                                fieldReference.closest("form").reset();
                                break;
                            }
                        } catch (_a) {}
                    }
                }
                _fields = {};
            }
            _formValues = props.shouldUnregister ? keepStateOptions.keepDefaultValues ? $afcc65e7f92ff559$var$cloneObject(_defaultValues) : {} : cloneUpdatedValues;
            _subjects.array.next({
                values: values
            });
            _subjects.watch.next({
                values: values
            });
        }
        _names = {
            mount: new Set(),
            unMount: new Set(),
            array: new Set(),
            watch: new Set(),
            watchAll: false,
            focus: ""
        };
        _stateFlags.mount = !_proxyFormState.isValid || !!keepStateOptions.keepIsValid;
        _stateFlags.watch = !!props.shouldUnregister;
        _subjects.state.next({
            submitCount: keepStateOptions.keepSubmitCount ? _formState.submitCount : 0,
            isDirty: keepStateOptions.keepDirty || keepStateOptions.keepDirtyValues ? _formState.isDirty : !!(keepStateOptions.keepDefaultValues && !$afcc65e7f92ff559$var$deepEqual(formValues, _defaultValues)),
            isSubmitted: keepStateOptions.keepIsSubmitted ? _formState.isSubmitted : false,
            dirtyFields: keepStateOptions.keepDirty || keepStateOptions.keepDirtyValues ? _formState.dirtyFields : keepStateOptions.keepDefaultValues && formValues ? $afcc65e7f92ff559$var$getDirtyFields(_defaultValues, formValues) : {},
            touchedFields: keepStateOptions.keepTouched ? _formState.touchedFields : {},
            errors: keepStateOptions.keepErrors ? _formState.errors : {},
            isSubmitting: false,
            isSubmitSuccessful: false
        });
    };
    const setFocus = (name, options = {})=>{
        const field = $afcc65e7f92ff559$export$3988ae62b71be9a3(_fields, name)._f;
        const fieldRef = field.refs ? field.refs[0] : field.ref;
        fieldRef.focus();
        options.shouldSelect && fieldRef.select();
    };
    return {
        control: {
            register: register,
            unregister: unregister,
            getFieldState: getFieldState,
            _executeSchema: _executeSchema,
            _getWatch: _getWatch,
            _getDirty: _getDirty,
            _updateValid: _updateValid,
            _removeUnmounted: _removeUnmounted,
            _updateFieldArray: _updateFieldArray,
            _getFieldArray: _getFieldArray,
            _subjects: _subjects,
            _proxyFormState: _proxyFormState,
            get _fields () {
                return _fields;
            },
            get _formValues () {
                return _formValues;
            },
            get _stateFlags () {
                return _stateFlags;
            },
            set _stateFlags (value){
                _stateFlags = value;
            },
            get _defaultValues () {
                return _defaultValues;
            },
            get _names () {
                return _names;
            },
            set _names (value){
                _names = value;
            },
            get _formState () {
                return _formState;
            },
            set _formState (value){
                _formState = value;
            },
            get _options () {
                return _options;
            },
            set _options (value){
                _options = (0, $0de5391da8318002$export$581ff339ea0ba762)({}, _options, value);
            }
        },
        trigger: trigger,
        register: register,
        handleSubmit: handleSubmit,
        watch: watch,
        setValue: setValue,
        getValues: getValues,
        reset: reset,
        resetField: resetField,
        clearErrors: clearErrors,
        unregister: unregister,
        setError: setError,
        setFocus: setFocus,
        getFieldState: getFieldState
    };
}
/**
 * Custom hook to manage the entire form.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/useform) • [Demo](https://codesandbox.io/s/react-hook-form-get-started-ts-5ksmm) • [Video](https://www.youtube.com/watch?v=RkXv4AXXC_4)
 *
 * @param props - form configuration and validation parameters.
 *
 * @returns methods - individual functions to manage the form state. {@link UseFormReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, watch, formState: { errors } } = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   console.log(watch("example"));
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input defaultValue="test" {...register("example")} />
 *       <input {...register("exampleRequired", { required: true })} />
 *       {errors.exampleRequired && <span>This field is required</span>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $afcc65e7f92ff559$export$87c0cf8eb5a167e0(props = {}) {
    const _formControl = (0, (/*@__PURE__*/$parcel$interopDefault($P551f))).useRef();
    const [formState, updateFormState] = (0, (/*@__PURE__*/$parcel$interopDefault($P551f))).useState({
        isDirty: false,
        isValidating: false,
        dirtyFields: {},
        isSubmitted: false,
        submitCount: 0,
        touchedFields: {},
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        errors: {}
    });
    if (_formControl.current) _formControl.current.control._options = props;
    else _formControl.current = (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, $afcc65e7f92ff559$var$createFormControl(props)), {
        formState: formState
    });
    const control = _formControl.current.control;
    const callback = (0, (/*@__PURE__*/$parcel$interopDefault($P551f))).useCallback((value1)=>{
        if ($afcc65e7f92ff559$var$shouldRenderFormState(value1, control._proxyFormState, true)) {
            control._formState = (0, $0de5391da8318002$export$581ff339ea0ba762)({}, control._formState, value1);
            updateFormState((0, $0de5391da8318002$export$581ff339ea0ba762)({}, control._formState));
        }
    }, [
        control
    ]);
    $afcc65e7f92ff559$var$useSubscribe({
        subject: control._subjects.state,
        callback: callback
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($P551f))).useEffect(()=>{
        if (!control._stateFlags.mount) {
            control._proxyFormState.isValid && control._updateValid();
            control._stateFlags.mount = true;
        }
        if (control._stateFlags.watch) {
            control._stateFlags.watch = false;
            control._subjects.state.next({});
        }
        control._removeUnmounted();
    });
    _formControl.current.formState = $afcc65e7f92ff559$var$getProxyFormState(formState, control._proxyFormState);
    return _formControl.current;
}








var $4af0a0867febf3aa$export$a3bc9b8ed74fc;
$4af0a0867febf3aa$export$a3bc9b8ed74fc = `_55yO2a_error`;


const $4ebb9c3ba9ede754$var$ErrorMessage = ({ error: error, className: className, children: children })=>{
    const { t: t } = (0, $5d79e62c9ff74ac9$export$9fc83ad70ead8663)(undefined, {
        keyPrefix: "error"
    });
    const getMessage = ()=>{
        if (!error) return children;
        if (typeof error === "string") return t(error);
        return t(error.code, (0, $0de5391da8318002$export$581ff339ea0ba762)({}, error.data));
    };
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("div", {
        role: "alert",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a6f0144cf2b2d456$exports)))($4af0a0867febf3aa$export$a3bc9b8ed74fc, className),
        children: getMessage()
    });
};
var $4ebb9c3ba9ede754$export$2e2bcd8739ae039 = $4ebb9c3ba9ede754$var$ErrorMessage;








var $P551f = parcelRequire("P551f");

var $399f7f2d2256e1fc$export$7c4df8d735fa2705;
var $399f7f2d2256e1fc$export$493b5823483d2c4e;
var $399f7f2d2256e1fc$export$6f2f4d5c38fc8e55;
var $399f7f2d2256e1fc$export$f2996ff41e4216ef;
var $399f7f2d2256e1fc$export$559d1204393b53b9;
$399f7f2d2256e1fc$export$7c4df8d735fa2705 = `jUeeQa_danger`;
$399f7f2d2256e1fc$export$493b5823483d2c4e = `jUeeQa_errorMessage`;
$399f7f2d2256e1fc$export$6f2f4d5c38fc8e55 = `jUeeQa_inputField`;
$399f7f2d2256e1fc$export$f2996ff41e4216ef = `jUeeQa_isSuffixFocusVisible`;
$399f7f2d2256e1fc$export$559d1204393b53b9 = `jUeeQa_suffix`;


const $89edc8164fec0424$var$InputField = (_param, reference)=>{
    var { className: className, errorMessage: errorMessage, isDanger: isDanger, prefix: prefix, suffix: suffix, isSuffixFocusVisible: isSuffixFocusVisible } = _param, props = (0, $451b529b5830e8ac$export$69fdd232f62cde60)(_param, [
        "className",
        "errorMessage",
        "isDanger",
        "prefix",
        "suffix",
        "isSuffixFocusVisible"
    ]);
    const errorMessages = errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage.split("\n");
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($a6f0144cf2b2d456$exports)))($399f7f2d2256e1fc$export$6f2f4d5c38fc8e55, isDanger && $399f7f2d2256e1fc$export$7c4df8d735fa2705, isSuffixFocusVisible && $399f7f2d2256e1fc$export$f2996ff41e4216ef),
                children: [
                    prefix,
                    /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("input", (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, props), {
                        ref: reference
                    })),
                    suffix && /*#__PURE__*/ (0, $P551f.cloneElement)(suffix, {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($a6f0144cf2b2d456$exports)))([
                            suffix.props.className,
                            $399f7f2d2256e1fc$export$559d1204393b53b9
                        ])
                    })
                ]
            }),
            errorMessages && /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $4ebb9c3ba9ede754$export$2e2bcd8739ae039), {
                className: $399f7f2d2256e1fc$export$493b5823483d2c4e,
                children: errorMessages.length > 1 ? /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("ul", {
                    children: errorMessages.map((message)=>/*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("li", {
                            children: message
                        }, message))
                }) : errorMessages[0]
            })
        ]
    });
};
var $89edc8164fec0424$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $P551f.forwardRef)($89edc8164fec0424$var$InputField);






var $P551f = parcelRequire("P551f");



parcelRequire("P551f");
const $c85bae0e5a45bf2d$var$SvgPasswordHideIcon = (props)=>/*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("svg", (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M4.929 3.929a1 1 0 0 0 0 1.414L6.505 6.92C3.791 8.797 2 11.452 2 12c0 .866 4.477 7 10 7 1.82 0 3.526-.666 4.996-1.59l.66.661a1 1 0 0 0 1.415-1.414L6.343 3.929a1 1 0 0 0-1.414 0Zm9.685 11.099L8.972 9.386a4 4 0 0 0 5.642 5.642Zm-1.057-6.714a4.014 4.014 0 0 1 2.129 2.13l4.39 4.389C21.285 13.533 22 12.346 22 12c0-.866-4.477-7-10-7-.542 0-1.073.059-1.591.166l3.148 3.148Z",
            fill: "currentcolor"
        })
    }));
var $c85bae0e5a45bf2d$export$2e2bcd8739ae039 = $c85bae0e5a45bf2d$var$SvgPasswordHideIcon;





parcelRequire("P551f");
const $2ff2622948654746$var$SvgPasswordShowIcon = (props)=>/*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("svg", (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M22 12c0 .866-4.477 7-10 7S2 12.866 2 12c0-.866 4.477-7 10-7s10 6.134 10 7Zm-6 0a4 4 0 1 1-8 0 4 4 0 0 1 8 0Zm-5 2a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
            fill: "currentcolor"
        })
    }));
var $2ff2622948654746$export$2e2bcd8739ae039 = $2ff2622948654746$var$SvgPasswordShowIcon;




var $P551f = parcelRequire("P551f");
const $54bb1acf95b53623$var$useToggle = (defaultValue = false)=>{
    const [value, setValue] = (0, $P551f.useState)(defaultValue);
    const toggle = ()=>{
        setValue((previous)=>!previous);
    };
    return [
        value,
        toggle
    ];
};
var $54bb1acf95b53623$export$2e2bcd8739ae039 = $54bb1acf95b53623$var$useToggle;



const $942ba6b6db15403b$var$PasswordInputField = (props, forwardRef)=>{
    const [showPassword, toggleShowPassword] = (0, $54bb1acf95b53623$export$2e2bcd8739ae039)(false);
    const innerRef = (0, $P551f.useRef)(null);
    (0, $P551f.useImperativeHandle)(forwardRef, ()=>innerRef.current);
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $89edc8164fec0424$export$2e2bcd8739ae039), (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({
        isSuffixFocusVisible: true,
        type: showPassword ? "text" : "password",
        suffix: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $328da03efb4c933c$export$2e2bcd8739ae039), {
            onMouseDown: (event)=>{
                event.preventDefault();
                toggleShowPassword();
            },
            children: showPassword ? /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $2ff2622948654746$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $c85bae0e5a45bf2d$export$2e2bcd8739ae039), {})
        })
    }, props), {
        ref: innerRef
    }));
};
var $942ba6b6db15403b$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $P551f.forwardRef)($942ba6b6db15403b$var$PasswordInputField);







let $511d096570a914ae$var$updateQueue = $511d096570a914ae$var$makeQueue();
const $511d096570a914ae$export$27f233d61a9e2fa4 = (fn)=>$511d096570a914ae$var$schedule(fn, $511d096570a914ae$var$updateQueue);
let $511d096570a914ae$var$writeQueue = $511d096570a914ae$var$makeQueue();
$511d096570a914ae$export$27f233d61a9e2fa4.write = (fn)=>$511d096570a914ae$var$schedule(fn, $511d096570a914ae$var$writeQueue);
let $511d096570a914ae$var$onStartQueue = $511d096570a914ae$var$makeQueue();
$511d096570a914ae$export$27f233d61a9e2fa4.onStart = (fn)=>$511d096570a914ae$var$schedule(fn, $511d096570a914ae$var$onStartQueue);
let $511d096570a914ae$var$onFrameQueue = $511d096570a914ae$var$makeQueue();
$511d096570a914ae$export$27f233d61a9e2fa4.onFrame = (fn)=>$511d096570a914ae$var$schedule(fn, $511d096570a914ae$var$onFrameQueue);
let $511d096570a914ae$var$onFinishQueue = $511d096570a914ae$var$makeQueue();
$511d096570a914ae$export$27f233d61a9e2fa4.onFinish = (fn)=>$511d096570a914ae$var$schedule(fn, $511d096570a914ae$var$onFinishQueue);
let $511d096570a914ae$var$timeouts = [];
$511d096570a914ae$export$27f233d61a9e2fa4.setTimeout = (handler, ms)=>{
    let time = $511d096570a914ae$export$27f233d61a9e2fa4.now() + ms;
    let cancel = ()=>{
        let i = $511d096570a914ae$var$timeouts.findIndex((t)=>t.cancel == cancel);
        if (~i) $511d096570a914ae$var$timeouts.splice(i, 1);
        $511d096570a914ae$var$pendingCount -= ~i ? 1 : 0;
    };
    let timeout = {
        time: time,
        handler: handler,
        cancel: cancel
    };
    $511d096570a914ae$var$timeouts.splice($511d096570a914ae$var$findTimeout(time), 0, timeout);
    $511d096570a914ae$var$pendingCount += 1;
    $511d096570a914ae$var$start();
    return timeout;
};
let $511d096570a914ae$var$findTimeout = (time)=>~(~$511d096570a914ae$var$timeouts.findIndex((t)=>t.time > time) || ~$511d096570a914ae$var$timeouts.length);
$511d096570a914ae$export$27f233d61a9e2fa4.cancel = (fn)=>{
    $511d096570a914ae$var$onStartQueue.delete(fn);
    $511d096570a914ae$var$onFrameQueue.delete(fn);
    $511d096570a914ae$var$onFinishQueue.delete(fn);
    $511d096570a914ae$var$updateQueue.delete(fn);
    $511d096570a914ae$var$writeQueue.delete(fn);
};
$511d096570a914ae$export$27f233d61a9e2fa4.sync = (fn)=>{
    $511d096570a914ae$var$sync = true;
    $511d096570a914ae$export$27f233d61a9e2fa4.batchedUpdates(fn);
    $511d096570a914ae$var$sync = false;
};
$511d096570a914ae$export$27f233d61a9e2fa4.throttle = (fn)=>{
    let lastArgs;
    function queuedFn() {
        try {
            fn(...lastArgs);
        } finally{
            lastArgs = null;
        }
    }
    function throttled(...args) {
        lastArgs = args;
        $511d096570a914ae$export$27f233d61a9e2fa4.onStart(queuedFn);
    }
    throttled.handler = fn;
    throttled.cancel = ()=>{
        $511d096570a914ae$var$onStartQueue.delete(queuedFn);
        lastArgs = null;
    };
    return throttled;
};
let $511d096570a914ae$var$nativeRaf = typeof window != "undefined" ? window.requestAnimationFrame : ()=>{};
$511d096570a914ae$export$27f233d61a9e2fa4.use = (impl)=>$511d096570a914ae$var$nativeRaf = impl;
$511d096570a914ae$export$27f233d61a9e2fa4.now = typeof performance != "undefined" ? ()=>performance.now() : Date.now;
$511d096570a914ae$export$27f233d61a9e2fa4.batchedUpdates = (fn)=>fn();
$511d096570a914ae$export$27f233d61a9e2fa4.catch = console.error;
$511d096570a914ae$export$27f233d61a9e2fa4.frameLoop = "always";
$511d096570a914ae$export$27f233d61a9e2fa4.advance = ()=>{
    if ($511d096570a914ae$export$27f233d61a9e2fa4.frameLoop !== "demand") console.warn("Cannot call the manual advancement of rafz whilst frameLoop is not set as demand");
    else $511d096570a914ae$var$update();
};
let $511d096570a914ae$var$ts = -1;
let $511d096570a914ae$var$pendingCount = 0;
let $511d096570a914ae$var$sync = false;
function $511d096570a914ae$var$schedule(fn, queue) {
    if ($511d096570a914ae$var$sync) {
        queue.delete(fn);
        fn(0);
    } else {
        queue.add(fn);
        $511d096570a914ae$var$start();
    }
}
function $511d096570a914ae$var$start() {
    if ($511d096570a914ae$var$ts < 0) {
        $511d096570a914ae$var$ts = 0;
        if ($511d096570a914ae$export$27f233d61a9e2fa4.frameLoop !== "demand") $511d096570a914ae$var$nativeRaf($511d096570a914ae$var$loop);
    }
}
function $511d096570a914ae$var$stop() {
    $511d096570a914ae$var$ts = -1;
}
function $511d096570a914ae$var$loop() {
    if (~$511d096570a914ae$var$ts) {
        $511d096570a914ae$var$nativeRaf($511d096570a914ae$var$loop);
        $511d096570a914ae$export$27f233d61a9e2fa4.batchedUpdates($511d096570a914ae$var$update);
    }
}
function $511d096570a914ae$var$update() {
    let prevTs = $511d096570a914ae$var$ts;
    $511d096570a914ae$var$ts = $511d096570a914ae$export$27f233d61a9e2fa4.now();
    let count = $511d096570a914ae$var$findTimeout($511d096570a914ae$var$ts);
    if (count) {
        $511d096570a914ae$var$eachSafely($511d096570a914ae$var$timeouts.splice(0, count), (t)=>t.handler());
        $511d096570a914ae$var$pendingCount -= count;
    }
    if (!$511d096570a914ae$var$pendingCount) {
        $511d096570a914ae$var$stop();
        return;
    }
    $511d096570a914ae$var$onStartQueue.flush();
    $511d096570a914ae$var$updateQueue.flush(prevTs ? Math.min(64, $511d096570a914ae$var$ts - prevTs) : 16.667);
    $511d096570a914ae$var$onFrameQueue.flush();
    $511d096570a914ae$var$writeQueue.flush();
    $511d096570a914ae$var$onFinishQueue.flush();
}
function $511d096570a914ae$var$makeQueue() {
    let next = new Set();
    let current = next;
    return {
        add (fn) {
            $511d096570a914ae$var$pendingCount += current == next && !next.has(fn) ? 1 : 0;
            next.add(fn);
        },
        delete (fn) {
            $511d096570a914ae$var$pendingCount -= current == next && next.has(fn) ? 1 : 0;
            return next.delete(fn);
        },
        flush (arg) {
            if (current.size) {
                next = new Set();
                $511d096570a914ae$var$pendingCount -= current.size;
                $511d096570a914ae$var$eachSafely(current, (fn)=>fn(arg) && next.add(fn));
                $511d096570a914ae$var$pendingCount += next.size;
                current = next;
            }
        }
    };
}
function $511d096570a914ae$var$eachSafely(values, each) {
    values.forEach((value)=>{
        try {
            each(value);
        } catch (e) {
            $511d096570a914ae$export$27f233d61a9e2fa4.catch(e);
        }
    });
}
const $511d096570a914ae$export$ef91a23fc803e177 = {
    count () {
        return $511d096570a914ae$var$pendingCount;
    },
    isRunning () {
        return $511d096570a914ae$var$ts >= 0;
    },
    clear () {
        $511d096570a914ae$var$ts = -1;
        $511d096570a914ae$var$timeouts = [];
        $511d096570a914ae$var$onStartQueue = $511d096570a914ae$var$makeQueue();
        $511d096570a914ae$var$updateQueue = $511d096570a914ae$var$makeQueue();
        $511d096570a914ae$var$onFrameQueue = $511d096570a914ae$var$makeQueue();
        $511d096570a914ae$var$writeQueue = $511d096570a914ae$var$makeQueue();
        $511d096570a914ae$var$onFinishQueue = $511d096570a914ae$var$makeQueue();
        $511d096570a914ae$var$pendingCount = 0;
    }
};



var $P551f = parcelRequire("P551f");
function $b06859765afdca70$export$8793edee2d425525() {}
const $b06859765afdca70$export$5c74248ea0e35446 = (obj, key, value)=>Object.defineProperty(obj, key, {
        value: value,
        writable: true,
        configurable: true
    });
const $b06859765afdca70$export$226b3eccf92c9ed9 = {
    arr: Array.isArray,
    obj: (a)=>!!a && a.constructor.name === "Object",
    fun: (a)=>typeof a === "function",
    str: (a)=>typeof a === "string",
    num: (a)=>typeof a === "number",
    und: (a)=>a === undefined
};
function $b06859765afdca70$export$248d38f6296296c5(a, b) {
    if ($b06859765afdca70$export$226b3eccf92c9ed9.arr(a)) {
        if (!$b06859765afdca70$export$226b3eccf92c9ed9.arr(b) || a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (a[i] !== b[i]) return false;
        }
        return true;
    }
    return a === b;
}
const $b06859765afdca70$export$79b2f7037acddd43 = (obj, fn)=>obj.forEach(fn);
function $b06859765afdca70$export$f4c6fe153f5a944e(obj, fn, ctx) {
    if ($b06859765afdca70$export$226b3eccf92c9ed9.arr(obj)) {
        for(let i = 0; i < obj.length; i++)fn.call(ctx, obj[i], `${i}`);
        return;
    }
    for(const key in obj)if (obj.hasOwnProperty(key)) fn.call(ctx, obj[key], key);
}
const $b06859765afdca70$export$45b10814cc054894 = (a)=>$b06859765afdca70$export$226b3eccf92c9ed9.und(a) ? [] : $b06859765afdca70$export$226b3eccf92c9ed9.arr(a) ? a : [
        a
    ];
function $b06859765afdca70$export$4909b86c8034bf73(queue, iterator) {
    if (queue.size) {
        const items = Array.from(queue);
        queue.clear();
        $b06859765afdca70$export$79b2f7037acddd43(items, iterator);
    }
}
const $b06859765afdca70$export$7ba486852759e806 = (queue, ...args)=>$b06859765afdca70$export$4909b86c8034bf73(queue, (fn)=>fn(...args));
const $b06859765afdca70$export$48d7c418edadb60c = ()=>typeof window === "undefined" || !window.navigator || /ServerSideRendering|^Deno\//.test(window.navigator.userAgent);
let $b06859765afdca70$var$createStringInterpolator$1;
let $b06859765afdca70$var$to;
let $b06859765afdca70$var$colors$1 = null;
let $b06859765afdca70$var$skipAnimation = false;
let $b06859765afdca70$var$willAdvance = $b06859765afdca70$export$8793edee2d425525;
const $b06859765afdca70$var$assign = (globals)=>{
    if (globals.to) $b06859765afdca70$var$to = globals.to;
    if (globals.now) (0, $511d096570a914ae$export$27f233d61a9e2fa4).now = globals.now;
    if (globals.colors !== undefined) $b06859765afdca70$var$colors$1 = globals.colors;
    if (globals.skipAnimation != null) $b06859765afdca70$var$skipAnimation = globals.skipAnimation;
    if (globals.createStringInterpolator) $b06859765afdca70$var$createStringInterpolator$1 = globals.createStringInterpolator;
    if (globals.requestAnimationFrame) (0, $511d096570a914ae$export$27f233d61a9e2fa4).use(globals.requestAnimationFrame);
    if (globals.batchedUpdates) (0, $511d096570a914ae$export$27f233d61a9e2fa4).batchedUpdates = globals.batchedUpdates;
    if (globals.willAdvance) $b06859765afdca70$var$willAdvance = globals.willAdvance;
    if (globals.frameLoop) (0, $511d096570a914ae$export$27f233d61a9e2fa4).frameLoop = globals.frameLoop;
};
var $b06859765afdca70$export$cceeabf822b64fc0 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    get createStringInterpolator () {
        return $b06859765afdca70$var$createStringInterpolator$1;
    },
    get to () {
        return $b06859765afdca70$var$to;
    },
    get colors () {
        return $b06859765afdca70$var$colors$1;
    },
    get skipAnimation () {
        return $b06859765afdca70$var$skipAnimation;
    },
    get willAdvance () {
        return $b06859765afdca70$var$willAdvance;
    },
    assign: $b06859765afdca70$var$assign
});
const $b06859765afdca70$var$startQueue = new Set();
let $b06859765afdca70$var$currentFrame = [];
let $b06859765afdca70$var$prevFrame = [];
let $b06859765afdca70$var$priority = 0;
const $b06859765afdca70$export$a57f5080a3bcc90a = {
    get idle () {
        return !$b06859765afdca70$var$startQueue.size && !$b06859765afdca70$var$currentFrame.length;
    },
    start (animation) {
        if ($b06859765afdca70$var$priority > animation.priority) {
            $b06859765afdca70$var$startQueue.add(animation);
            (0, $511d096570a914ae$export$27f233d61a9e2fa4).onStart($b06859765afdca70$var$flushStartQueue);
        } else {
            $b06859765afdca70$var$startSafely(animation);
            (0, $511d096570a914ae$export$27f233d61a9e2fa4)($b06859765afdca70$var$advance);
        }
    },
    advance: $b06859765afdca70$var$advance,
    sort (animation) {
        if ($b06859765afdca70$var$priority) (0, $511d096570a914ae$export$27f233d61a9e2fa4).onFrame(()=>$b06859765afdca70$export$a57f5080a3bcc90a.sort(animation));
        else {
            const prevIndex = $b06859765afdca70$var$currentFrame.indexOf(animation);
            if (~prevIndex) {
                $b06859765afdca70$var$currentFrame.splice(prevIndex, 1);
                $b06859765afdca70$var$startUnsafely(animation);
            }
        }
    },
    clear () {
        $b06859765afdca70$var$currentFrame = [];
        $b06859765afdca70$var$startQueue.clear();
    }
};
function $b06859765afdca70$var$flushStartQueue() {
    $b06859765afdca70$var$startQueue.forEach($b06859765afdca70$var$startSafely);
    $b06859765afdca70$var$startQueue.clear();
    (0, $511d096570a914ae$export$27f233d61a9e2fa4)($b06859765afdca70$var$advance);
}
function $b06859765afdca70$var$startSafely(animation) {
    if (!$b06859765afdca70$var$currentFrame.includes(animation)) $b06859765afdca70$var$startUnsafely(animation);
}
function $b06859765afdca70$var$startUnsafely(animation) {
    $b06859765afdca70$var$currentFrame.splice($b06859765afdca70$var$findIndex($b06859765afdca70$var$currentFrame, (other)=>other.priority > animation.priority), 0, animation);
}
function $b06859765afdca70$var$advance(dt) {
    const nextFrame = $b06859765afdca70$var$prevFrame;
    for(let i = 0; i < $b06859765afdca70$var$currentFrame.length; i++){
        const animation = $b06859765afdca70$var$currentFrame[i];
        $b06859765afdca70$var$priority = animation.priority;
        if (!animation.idle) {
            $b06859765afdca70$var$willAdvance(animation);
            animation.advance(dt);
            if (!animation.idle) nextFrame.push(animation);
        }
    }
    $b06859765afdca70$var$priority = 0;
    $b06859765afdca70$var$prevFrame = $b06859765afdca70$var$currentFrame;
    $b06859765afdca70$var$prevFrame.length = 0;
    $b06859765afdca70$var$currentFrame = nextFrame;
    return $b06859765afdca70$var$currentFrame.length > 0;
}
function $b06859765afdca70$var$findIndex(arr, test) {
    const index = arr.findIndex(test);
    return index < 0 ? arr.length : index;
}
const $b06859765afdca70$export$7d15b64cf5a3a4c4 = (min, max, v)=>Math.min(Math.max(v, min), max);
const $b06859765afdca70$export$8f45430ccf837300 = {
    transparent: 0x00000000,
    aliceblue: 0xf0f8ffff,
    antiquewhite: 0xfaebd7ff,
    aqua: 0x00ffffff,
    aquamarine: 0x7fffd4ff,
    azure: 0xf0ffffff,
    beige: 0xf5f5dcff,
    bisque: 0xffe4c4ff,
    black: 0x000000ff,
    blanchedalmond: 0xffebcdff,
    blue: 0x0000ffff,
    blueviolet: 0x8a2be2ff,
    brown: 0xa52a2aff,
    burlywood: 0xdeb887ff,
    burntsienna: 0xea7e5dff,
    cadetblue: 0x5f9ea0ff,
    chartreuse: 0x7fff00ff,
    chocolate: 0xd2691eff,
    coral: 0xff7f50ff,
    cornflowerblue: 0x6495edff,
    cornsilk: 0xfff8dcff,
    crimson: 0xdc143cff,
    cyan: 0x00ffffff,
    darkblue: 0x00008bff,
    darkcyan: 0x008b8bff,
    darkgoldenrod: 0xb8860bff,
    darkgray: 0xa9a9a9ff,
    darkgreen: 0x006400ff,
    darkgrey: 0xa9a9a9ff,
    darkkhaki: 0xbdb76bff,
    darkmagenta: 0x8b008bff,
    darkolivegreen: 0x556b2fff,
    darkorange: 0xff8c00ff,
    darkorchid: 0x9932ccff,
    darkred: 0x8b0000ff,
    darksalmon: 0xe9967aff,
    darkseagreen: 0x8fbc8fff,
    darkslateblue: 0x483d8bff,
    darkslategray: 0x2f4f4fff,
    darkslategrey: 0x2f4f4fff,
    darkturquoise: 0x00ced1ff,
    darkviolet: 0x9400d3ff,
    deeppink: 0xff1493ff,
    deepskyblue: 0x00bfffff,
    dimgray: 0x696969ff,
    dimgrey: 0x696969ff,
    dodgerblue: 0x1e90ffff,
    firebrick: 0xb22222ff,
    floralwhite: 0xfffaf0ff,
    forestgreen: 0x228b22ff,
    fuchsia: 0xff00ffff,
    gainsboro: 0xdcdcdcff,
    ghostwhite: 0xf8f8ffff,
    gold: 0xffd700ff,
    goldenrod: 0xdaa520ff,
    gray: 0x808080ff,
    green: 0x008000ff,
    greenyellow: 0xadff2fff,
    grey: 0x808080ff,
    honeydew: 0xf0fff0ff,
    hotpink: 0xff69b4ff,
    indianred: 0xcd5c5cff,
    indigo: 0x4b0082ff,
    ivory: 0xfffff0ff,
    khaki: 0xf0e68cff,
    lavender: 0xe6e6faff,
    lavenderblush: 0xfff0f5ff,
    lawngreen: 0x7cfc00ff,
    lemonchiffon: 0xfffacdff,
    lightblue: 0xadd8e6ff,
    lightcoral: 0xf08080ff,
    lightcyan: 0xe0ffffff,
    lightgoldenrodyellow: 0xfafad2ff,
    lightgray: 0xd3d3d3ff,
    lightgreen: 0x90ee90ff,
    lightgrey: 0xd3d3d3ff,
    lightpink: 0xffb6c1ff,
    lightsalmon: 0xffa07aff,
    lightseagreen: 0x20b2aaff,
    lightskyblue: 0x87cefaff,
    lightslategray: 0x778899ff,
    lightslategrey: 0x778899ff,
    lightsteelblue: 0xb0c4deff,
    lightyellow: 0xffffe0ff,
    lime: 0x00ff00ff,
    limegreen: 0x32cd32ff,
    linen: 0xfaf0e6ff,
    magenta: 0xff00ffff,
    maroon: 0x800000ff,
    mediumaquamarine: 0x66cdaaff,
    mediumblue: 0x0000cdff,
    mediumorchid: 0xba55d3ff,
    mediumpurple: 0x9370dbff,
    mediumseagreen: 0x3cb371ff,
    mediumslateblue: 0x7b68eeff,
    mediumspringgreen: 0x00fa9aff,
    mediumturquoise: 0x48d1ccff,
    mediumvioletred: 0xc71585ff,
    midnightblue: 0x191970ff,
    mintcream: 0xf5fffaff,
    mistyrose: 0xffe4e1ff,
    moccasin: 0xffe4b5ff,
    navajowhite: 0xffdeadff,
    navy: 0x000080ff,
    oldlace: 0xfdf5e6ff,
    olive: 0x808000ff,
    olivedrab: 0x6b8e23ff,
    orange: 0xffa500ff,
    orangered: 0xff4500ff,
    orchid: 0xda70d6ff,
    palegoldenrod: 0xeee8aaff,
    palegreen: 0x98fb98ff,
    paleturquoise: 0xafeeeeff,
    palevioletred: 0xdb7093ff,
    papayawhip: 0xffefd5ff,
    peachpuff: 0xffdab9ff,
    peru: 0xcd853fff,
    pink: 0xffc0cbff,
    plum: 0xdda0ddff,
    powderblue: 0xb0e0e6ff,
    purple: 0x800080ff,
    rebeccapurple: 0x663399ff,
    red: 0xff0000ff,
    rosybrown: 0xbc8f8fff,
    royalblue: 0x4169e1ff,
    saddlebrown: 0x8b4513ff,
    salmon: 0xfa8072ff,
    sandybrown: 0xf4a460ff,
    seagreen: 0x2e8b57ff,
    seashell: 0xfff5eeff,
    sienna: 0xa0522dff,
    silver: 0xc0c0c0ff,
    skyblue: 0x87ceebff,
    slateblue: 0x6a5acdff,
    slategray: 0x708090ff,
    slategrey: 0x708090ff,
    snow: 0xfffafaff,
    springgreen: 0x00ff7fff,
    steelblue: 0x4682b4ff,
    tan: 0xd2b48cff,
    teal: 0x008080ff,
    thistle: 0xd8bfd8ff,
    tomato: 0xff6347ff,
    turquoise: 0x40e0d0ff,
    violet: 0xee82eeff,
    wheat: 0xf5deb3ff,
    white: 0xffffffff,
    whitesmoke: 0xf5f5f5ff,
    yellow: 0xffff00ff,
    yellowgreen: 0x9acd32ff
};
const $b06859765afdca70$var$NUMBER = "[-+]?\\d*\\.?\\d+";
const $b06859765afdca70$var$PERCENTAGE = $b06859765afdca70$var$NUMBER + "%";
function $b06859765afdca70$var$call(...parts) {
    return "\\(\\s*(" + parts.join(")\\s*,\\s*(") + ")\\s*\\)";
}
const $b06859765afdca70$export$8972dc0e6ad9238f = new RegExp("rgb" + $b06859765afdca70$var$call($b06859765afdca70$var$NUMBER, $b06859765afdca70$var$NUMBER, $b06859765afdca70$var$NUMBER));
const $b06859765afdca70$export$4e46ac54fc82cf3b = new RegExp("rgba" + $b06859765afdca70$var$call($b06859765afdca70$var$NUMBER, $b06859765afdca70$var$NUMBER, $b06859765afdca70$var$NUMBER, $b06859765afdca70$var$NUMBER));
const $b06859765afdca70$export$8f4a7c0bb78e6ea8 = new RegExp("hsl" + $b06859765afdca70$var$call($b06859765afdca70$var$NUMBER, $b06859765afdca70$var$PERCENTAGE, $b06859765afdca70$var$PERCENTAGE));
const $b06859765afdca70$export$810b04175080204c = new RegExp("hsla" + $b06859765afdca70$var$call($b06859765afdca70$var$NUMBER, $b06859765afdca70$var$PERCENTAGE, $b06859765afdca70$var$PERCENTAGE, $b06859765afdca70$var$NUMBER));
const $b06859765afdca70$export$a99b93d698493da5 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
const $b06859765afdca70$export$4573e032242724d8 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
const $b06859765afdca70$export$86e51e8f361b966e = /^#([0-9a-fA-F]{6})$/;
const $b06859765afdca70$export$a09ec12fb14c61c4 = /^#([0-9a-fA-F]{8})$/;
function $b06859765afdca70$var$normalizeColor(color) {
    let match;
    if (typeof color === "number") return color >>> 0 === color && color >= 0 && color <= 0xffffffff ? color : null;
    if (match = $b06859765afdca70$export$86e51e8f361b966e.exec(color)) return parseInt(match[1] + "ff", 16) >>> 0;
    if ($b06859765afdca70$var$colors$1 && $b06859765afdca70$var$colors$1[color] !== undefined) return $b06859765afdca70$var$colors$1[color];
    if (match = $b06859765afdca70$export$8972dc0e6ad9238f.exec(color)) return ($b06859765afdca70$var$parse255(match[1]) << 24 | $b06859765afdca70$var$parse255(match[2]) << 16 | $b06859765afdca70$var$parse255(match[3]) << 8 | 0x000000ff) >>> 0;
    if (match = $b06859765afdca70$export$4e46ac54fc82cf3b.exec(color)) return ($b06859765afdca70$var$parse255(match[1]) << 24 | $b06859765afdca70$var$parse255(match[2]) << 16 | $b06859765afdca70$var$parse255(match[3]) << 8 | $b06859765afdca70$var$parse1(match[4])) >>> 0;
    if (match = $b06859765afdca70$export$a99b93d698493da5.exec(color)) return parseInt(match[1] + match[1] + match[2] + match[2] + match[3] + match[3] + "ff", 16) >>> 0;
    if (match = $b06859765afdca70$export$a09ec12fb14c61c4.exec(color)) return parseInt(match[1], 16) >>> 0;
    if (match = $b06859765afdca70$export$4573e032242724d8.exec(color)) return parseInt(match[1] + match[1] + match[2] + match[2] + match[3] + match[3] + match[4] + match[4], 16) >>> 0;
    if (match = $b06859765afdca70$export$8f4a7c0bb78e6ea8.exec(color)) return ($b06859765afdca70$var$hslToRgb($b06859765afdca70$var$parse360(match[1]), $b06859765afdca70$var$parsePercentage(match[2]), $b06859765afdca70$var$parsePercentage(match[3])) | 0x000000ff) >>> 0;
    if (match = $b06859765afdca70$export$810b04175080204c.exec(color)) return ($b06859765afdca70$var$hslToRgb($b06859765afdca70$var$parse360(match[1]), $b06859765afdca70$var$parsePercentage(match[2]), $b06859765afdca70$var$parsePercentage(match[3])) | $b06859765afdca70$var$parse1(match[4])) >>> 0;
    return null;
}
function $b06859765afdca70$var$hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $b06859765afdca70$var$hslToRgb(h, s, l) {
    const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    const p = 2 * l - q;
    const r = $b06859765afdca70$var$hue2rgb(p, q, h + 1 / 3);
    const g = $b06859765afdca70$var$hue2rgb(p, q, h);
    const b = $b06859765afdca70$var$hue2rgb(p, q, h - 1 / 3);
    return Math.round(r * 255) << 24 | Math.round(g * 255) << 16 | Math.round(b * 255) << 8;
}
function $b06859765afdca70$var$parse255(str) {
    const int = parseInt(str, 10);
    if (int < 0) return 0;
    if (int > 255) return 255;
    return int;
}
function $b06859765afdca70$var$parse360(str) {
    const int = parseFloat(str);
    return (int % 360 + 360) % 360 / 360;
}
function $b06859765afdca70$var$parse1(str) {
    const num = parseFloat(str);
    if (num < 0) return 0;
    if (num > 1) return 255;
    return Math.round(num * 255);
}
function $b06859765afdca70$var$parsePercentage(str) {
    const int = parseFloat(str);
    if (int < 0) return 0;
    if (int > 100) return 1;
    return int / 100;
}
function $b06859765afdca70$export$61db176b839af1f(input) {
    let int32Color = $b06859765afdca70$var$normalizeColor(input);
    if (int32Color === null) return input;
    int32Color = int32Color || 0;
    let r = (int32Color & 0xff000000) >>> 24;
    let g = (int32Color & 0x00ff0000) >>> 16;
    let b = (int32Color & 0x0000ff00) >>> 8;
    let a = (int32Color & 0x000000ff) / 255;
    return `rgba(${r}, ${g}, ${b}, ${a})`;
}
const $b06859765afdca70$export$b12af43b97697ef5 = (range, output, extrapolate)=>{
    if ($b06859765afdca70$export$226b3eccf92c9ed9.fun(range)) return range;
    if ($b06859765afdca70$export$226b3eccf92c9ed9.arr(range)) return $b06859765afdca70$export$b12af43b97697ef5({
        range: range,
        output: output,
        extrapolate: extrapolate
    });
    if ($b06859765afdca70$export$226b3eccf92c9ed9.str(range.output[0])) return $b06859765afdca70$var$createStringInterpolator$1(range);
    const config = range;
    const outputRange = config.output;
    const inputRange = config.range || [
        0,
        1
    ];
    const extrapolateLeft = config.extrapolateLeft || config.extrapolate || "extend";
    const extrapolateRight = config.extrapolateRight || config.extrapolate || "extend";
    const easing = config.easing || ((t)=>t);
    return (input)=>{
        const range = $b06859765afdca70$var$findRange(input, inputRange);
        return $b06859765afdca70$var$interpolate(input, inputRange[range], inputRange[range + 1], outputRange[range], outputRange[range + 1], easing, extrapolateLeft, extrapolateRight, config.map);
    };
};
function $b06859765afdca70$var$interpolate(input, inputMin, inputMax, outputMin, outputMax, easing, extrapolateLeft, extrapolateRight, map) {
    let result = map ? map(input) : input;
    if (result < inputMin) {
        if (extrapolateLeft === "identity") return result;
        else if (extrapolateLeft === "clamp") result = inputMin;
    }
    if (result > inputMax) {
        if (extrapolateRight === "identity") return result;
        else if (extrapolateRight === "clamp") result = inputMax;
    }
    if (outputMin === outputMax) return outputMin;
    if (inputMin === inputMax) return input <= inputMin ? outputMin : outputMax;
    if (inputMin === -Infinity) result = -result;
    else if (inputMax === Infinity) result = result - inputMin;
    else result = (result - inputMin) / (inputMax - inputMin);
    result = easing(result);
    if (outputMin === -Infinity) result = -result;
    else if (outputMax === Infinity) result = result + outputMin;
    else result = result * (outputMax - outputMin) + outputMin;
    return result;
}
function $b06859765afdca70$var$findRange(input, inputRange) {
    for(var i = 1; i < inputRange.length - 1; ++i)if (inputRange[i] >= input) break;
    return i - 1;
}
const $b06859765afdca70$var$steps = (steps, direction = "end")=>(progress)=>{
        progress = direction === "end" ? Math.min(progress, 0.999) : Math.max(progress, 0.001);
        const expanded = progress * steps;
        const rounded = direction === "end" ? Math.floor(expanded) : Math.ceil(expanded);
        return $b06859765afdca70$export$7d15b64cf5a3a4c4(0, 1, rounded / steps);
    };
const $b06859765afdca70$var$c1 = 1.70158;
const $b06859765afdca70$var$c2 = $b06859765afdca70$var$c1 * 1.525;
const $b06859765afdca70$var$c3 = $b06859765afdca70$var$c1 + 1;
const $b06859765afdca70$var$c4 = 2 * Math.PI / 3;
const $b06859765afdca70$var$c5 = 2 * Math.PI / 4.5;
const $b06859765afdca70$var$bounceOut = (x)=>{
    const n1 = 7.5625;
    const d1 = 2.75;
    if (x < 1 / d1) return n1 * x * x;
    else if (x < 2 / d1) return n1 * (x -= 1.5 / d1) * x + 0.75;
    else if (x < 2.5 / d1) return n1 * (x -= 2.25 / d1) * x + 0.9375;
    else return n1 * (x -= 2.625 / d1) * x + 0.984375;
};
const $b06859765afdca70$export$15a0bf1b4bbacad8 = {
    linear: (x)=>x,
    easeInQuad: (x)=>x * x,
    easeOutQuad: (x)=>1 - (1 - x) * (1 - x),
    easeInOutQuad: (x)=>x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2,
    easeInCubic: (x)=>x * x * x,
    easeOutCubic: (x)=>1 - Math.pow(1 - x, 3),
    easeInOutCubic: (x)=>x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2,
    easeInQuart: (x)=>x * x * x * x,
    easeOutQuart: (x)=>1 - Math.pow(1 - x, 4),
    easeInOutQuart: (x)=>x < 0.5 ? 8 * x * x * x * x : 1 - Math.pow(-2 * x + 2, 4) / 2,
    easeInQuint: (x)=>x * x * x * x * x,
    easeOutQuint: (x)=>1 - Math.pow(1 - x, 5),
    easeInOutQuint: (x)=>x < 0.5 ? 16 * x * x * x * x * x : 1 - Math.pow(-2 * x + 2, 5) / 2,
    easeInSine: (x)=>1 - Math.cos(x * Math.PI / 2),
    easeOutSine: (x)=>Math.sin(x * Math.PI / 2),
    easeInOutSine: (x)=>-(Math.cos(Math.PI * x) - 1) / 2,
    easeInExpo: (x)=>x === 0 ? 0 : Math.pow(2, 10 * x - 10),
    easeOutExpo: (x)=>x === 1 ? 1 : 1 - Math.pow(2, -10 * x),
    easeInOutExpo: (x)=>x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? Math.pow(2, 20 * x - 10) / 2 : (2 - Math.pow(2, -20 * x + 10)) / 2,
    easeInCirc: (x)=>1 - Math.sqrt(1 - Math.pow(x, 2)),
    easeOutCirc: (x)=>Math.sqrt(1 - Math.pow(x - 1, 2)),
    easeInOutCirc: (x)=>x < 0.5 ? (1 - Math.sqrt(1 - Math.pow(2 * x, 2))) / 2 : (Math.sqrt(1 - Math.pow(-2 * x + 2, 2)) + 1) / 2,
    easeInBack: (x)=>$b06859765afdca70$var$c3 * x * x * x - $b06859765afdca70$var$c1 * x * x,
    easeOutBack: (x)=>1 + $b06859765afdca70$var$c3 * Math.pow(x - 1, 3) + $b06859765afdca70$var$c1 * Math.pow(x - 1, 2),
    easeInOutBack: (x)=>x < 0.5 ? Math.pow(2 * x, 2) * (($b06859765afdca70$var$c2 + 1) * 2 * x - $b06859765afdca70$var$c2) / 2 : (Math.pow(2 * x - 2, 2) * (($b06859765afdca70$var$c2 + 1) * (x * 2 - 2) + $b06859765afdca70$var$c2) + 2) / 2,
    easeInElastic: (x)=>x === 0 ? 0 : x === 1 ? 1 : -Math.pow(2, 10 * x - 10) * Math.sin((x * 10 - 10.75) * $b06859765afdca70$var$c4),
    easeOutElastic: (x)=>x === 0 ? 0 : x === 1 ? 1 : Math.pow(2, -10 * x) * Math.sin((x * 10 - 0.75) * $b06859765afdca70$var$c4) + 1,
    easeInOutElastic: (x)=>x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? -(Math.pow(2, 20 * x - 10) * Math.sin((20 * x - 11.125) * $b06859765afdca70$var$c5)) / 2 : Math.pow(2, -20 * x + 10) * Math.sin((20 * x - 11.125) * $b06859765afdca70$var$c5) / 2 + 1,
    easeInBounce: (x)=>1 - $b06859765afdca70$var$bounceOut(1 - x),
    easeOutBounce: $b06859765afdca70$var$bounceOut,
    easeInOutBounce: (x)=>x < 0.5 ? (1 - $b06859765afdca70$var$bounceOut(1 - 2 * x)) / 2 : (1 + $b06859765afdca70$var$bounceOut(2 * x - 1)) / 2,
    steps: $b06859765afdca70$var$steps
};
function $b06859765afdca70$var$_extends() {
    $b06859765afdca70$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b06859765afdca70$var$_extends.apply(this, arguments);
}
const $b06859765afdca70$var$$get = Symbol.for("FluidValue.get");
const $b06859765afdca70$var$$observers = Symbol.for("FluidValue.observers");
const $b06859765afdca70$export$57ea7e3a7f6280c7 = (arg)=>Boolean(arg && arg[$b06859765afdca70$var$$get]);
const $b06859765afdca70$export$e37b7520edd66839 = (arg)=>arg && arg[$b06859765afdca70$var$$get] ? arg[$b06859765afdca70$var$$get]() : arg;
const $b06859765afdca70$export$133f54e9f7cf1796 = (target)=>target[$b06859765afdca70$var$$observers] || null;
function $b06859765afdca70$export$8cbca1207adce0c0(observer, event) {
    if (observer.eventObserved) observer.eventObserved(event);
    else observer(event);
}
function $b06859765afdca70$export$31752c40a5fab62a(target, event) {
    let observers = target[$b06859765afdca70$var$$observers];
    if (observers) observers.forEach((observer)=>{
        $b06859765afdca70$export$8cbca1207adce0c0(observer, event);
    });
}
class $b06859765afdca70$export$aff8e1ac1a016a2 {
    constructor(get){
        this[$b06859765afdca70$var$$get] = void 0;
        this[$b06859765afdca70$var$$observers] = void 0;
        if (!get && !(get = this.get)) throw Error("Unknown getter");
        $b06859765afdca70$export$a3b4618659637aa3(this, get);
    }
}
const $b06859765afdca70$export$a3b4618659637aa3 = (target, get)=>$b06859765afdca70$var$setHidden(target, $b06859765afdca70$var$$get, get);
function $b06859765afdca70$export$72d604e3f8d000a5(target, observer) {
    if (target[$b06859765afdca70$var$$get]) {
        let observers = target[$b06859765afdca70$var$$observers];
        if (!observers) $b06859765afdca70$var$setHidden(target, $b06859765afdca70$var$$observers, observers = new Set());
        if (!observers.has(observer)) {
            observers.add(observer);
            if (target.observerAdded) target.observerAdded(observers.size, observer);
        }
    }
    return observer;
}
function $b06859765afdca70$export$7a0eb830d336339b(target, observer) {
    let observers = target[$b06859765afdca70$var$$observers];
    if (observers && observers.has(observer)) {
        const count = observers.size - 1;
        if (count) observers.delete(observer);
        else target[$b06859765afdca70$var$$observers] = null;
        if (target.observerRemoved) target.observerRemoved(count, observer);
    }
}
const $b06859765afdca70$var$setHidden = (target, key, value)=>Object.defineProperty(target, key, {
        value: value,
        writable: true,
        configurable: true
    });
const $b06859765afdca70$var$numberRegex = /[+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?/g;
const $b06859765afdca70$var$colorRegex = /(#(?:[0-9a-f]{2}){2,4}|(#[0-9a-f]{3})|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d\.]+%?\))/gi;
const $b06859765afdca70$var$unitRegex = new RegExp(`(${$b06859765afdca70$var$numberRegex.source})(%|[a-z]+)`, "i");
const $b06859765afdca70$var$rgbaRegex = /rgba\(([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+)\)/gi;
const $b06859765afdca70$var$cssVariableRegex = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
const $b06859765afdca70$var$variableToRgba = (input)=>{
    const [token, fallback] = $b06859765afdca70$var$parseCSSVariable(input);
    if (!token || $b06859765afdca70$export$48d7c418edadb60c()) return input;
    const value = window.getComputedStyle(document.documentElement).getPropertyValue(token);
    if (value) return value.trim();
    else if (fallback && fallback.startsWith("--")) {
        const _value = window.getComputedStyle(document.documentElement).getPropertyValue(fallback);
        if (_value) return _value;
        else return input;
    } else if (fallback && $b06859765afdca70$var$cssVariableRegex.test(fallback)) return $b06859765afdca70$var$variableToRgba(fallback);
    else if (fallback) return fallback;
    return input;
};
const $b06859765afdca70$var$parseCSSVariable = (current)=>{
    const match = $b06859765afdca70$var$cssVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    const [, token, fallback] = match;
    return [
        token,
        fallback
    ];
};
let $b06859765afdca70$var$namedColorRegex;
const $b06859765afdca70$var$rgbaRound = (_, p1, p2, p3, p4)=>`rgba(${Math.round(p1)}, ${Math.round(p2)}, ${Math.round(p3)}, ${p4})`;
const $b06859765afdca70$export$4759a013d387347a = (config)=>{
    if (!$b06859765afdca70$var$namedColorRegex) $b06859765afdca70$var$namedColorRegex = $b06859765afdca70$var$colors$1 ? new RegExp(`(${Object.keys($b06859765afdca70$var$colors$1).join("|")})(?!\\w)`, "g") : /^\b$/;
    const output = config.output.map((value)=>{
        return $b06859765afdca70$export$e37b7520edd66839(value).replace($b06859765afdca70$var$cssVariableRegex, $b06859765afdca70$var$variableToRgba).replace($b06859765afdca70$var$colorRegex, $b06859765afdca70$export$61db176b839af1f).replace($b06859765afdca70$var$namedColorRegex, $b06859765afdca70$export$61db176b839af1f);
    });
    const keyframes = output.map((value)=>value.match($b06859765afdca70$var$numberRegex).map(Number));
    const outputRanges = keyframes[0].map((_, i)=>keyframes.map((values)=>{
            if (!(i in values)) throw Error('The arity of each "output" value must be equal');
            return values[i];
        }));
    const interpolators = outputRanges.map((output)=>$b06859765afdca70$export$b12af43b97697ef5($b06859765afdca70$var$_extends({}, config, {
            output: output
        })));
    return (input)=>{
        var _output$find;
        const missingUnit = !$b06859765afdca70$var$unitRegex.test(output[0]) && ((_output$find = output.find((value)=>$b06859765afdca70$var$unitRegex.test(value))) == null ? void 0 : _output$find.replace($b06859765afdca70$var$numberRegex, ""));
        let i = 0;
        return output[0].replace($b06859765afdca70$var$numberRegex, ()=>`${interpolators[i++](input)}${missingUnit || ""}`).replace($b06859765afdca70$var$rgbaRegex, $b06859765afdca70$var$rgbaRound);
    };
};
const $b06859765afdca70$export$82e9f45cca5ba907 = "react-spring: ";
const $b06859765afdca70$export$d2de3aaeafa91619 = (fn)=>{
    const func = fn;
    let called = false;
    if (typeof func != "function") throw new TypeError(`${$b06859765afdca70$export$82e9f45cca5ba907}once requires a function parameter`);
    return (...args)=>{
        if (!called) {
            func(...args);
            called = true;
        }
    };
};
const $b06859765afdca70$var$warnInterpolate = $b06859765afdca70$export$d2de3aaeafa91619(console.warn);
function $b06859765afdca70$export$2abfcde8ae218ba8() {
    $b06859765afdca70$var$warnInterpolate(`${$b06859765afdca70$export$82e9f45cca5ba907}The "interpolate" function is deprecated in v9 (use "to" instead)`);
}
const $b06859765afdca70$var$warnDirectCall = $b06859765afdca70$export$d2de3aaeafa91619(console.warn);
function $b06859765afdca70$export$d99d974913ad3b12() {
    $b06859765afdca70$var$warnDirectCall(`${$b06859765afdca70$export$82e9f45cca5ba907}Directly calling start instead of using the api object is deprecated in v9 (use ".start" instead), this will be removed in later 0.X.0 versions`);
}
function $b06859765afdca70$export$75bed621f62abfa9(value) {
    return $b06859765afdca70$export$226b3eccf92c9ed9.str(value) && (value[0] == "#" || /\d/.test(value) || !$b06859765afdca70$export$48d7c418edadb60c() && $b06859765afdca70$var$cssVariableRegex.test(value) || value in ($b06859765afdca70$var$colors$1 || {}));
}
let $b06859765afdca70$var$observer;
const $b06859765afdca70$var$resizeHandlers = new WeakMap();
const $b06859765afdca70$var$handleObservation = (entries)=>entries.forEach(({ target: target, contentRect: contentRect })=>{
        var _resizeHandlers$get;
        return (_resizeHandlers$get = $b06859765afdca70$var$resizeHandlers.get(target)) == null ? void 0 : _resizeHandlers$get.forEach((handler)=>handler(contentRect));
    });
function $b06859765afdca70$var$resizeElement(handler, target) {
    if (!$b06859765afdca70$var$observer) {
        if (typeof ResizeObserver !== "undefined") $b06859765afdca70$var$observer = new ResizeObserver($b06859765afdca70$var$handleObservation);
    }
    let elementHandlers = $b06859765afdca70$var$resizeHandlers.get(target);
    if (!elementHandlers) {
        elementHandlers = new Set();
        $b06859765afdca70$var$resizeHandlers.set(target, elementHandlers);
    }
    elementHandlers.add(handler);
    if ($b06859765afdca70$var$observer) $b06859765afdca70$var$observer.observe(target);
    return ()=>{
        const elementHandlers = $b06859765afdca70$var$resizeHandlers.get(target);
        if (!elementHandlers) return;
        elementHandlers.delete(handler);
        if (!elementHandlers.size && $b06859765afdca70$var$observer) $b06859765afdca70$var$observer.unobserve(target);
    };
}
const $b06859765afdca70$var$listeners = new Set();
let $b06859765afdca70$var$cleanupWindowResizeHandler;
const $b06859765afdca70$var$createResizeHandler = ()=>{
    const handleResize = ()=>{
        $b06859765afdca70$var$listeners.forEach((callback)=>callback({
                width: window.innerWidth,
                height: window.innerHeight
            }));
    };
    window.addEventListener("resize", handleResize);
    return ()=>{
        window.removeEventListener("resize", handleResize);
    };
};
const $b06859765afdca70$var$resizeWindow = (callback)=>{
    $b06859765afdca70$var$listeners.add(callback);
    if (!$b06859765afdca70$var$cleanupWindowResizeHandler) $b06859765afdca70$var$cleanupWindowResizeHandler = $b06859765afdca70$var$createResizeHandler();
    return ()=>{
        $b06859765afdca70$var$listeners.delete(callback);
        if (!$b06859765afdca70$var$listeners.size && $b06859765afdca70$var$cleanupWindowResizeHandler) {
            $b06859765afdca70$var$cleanupWindowResizeHandler();
            $b06859765afdca70$var$cleanupWindowResizeHandler = undefined;
        }
    };
};
const $b06859765afdca70$export$45b39e67d4ce4921 = (callback, { container: _container = document.documentElement } = {})=>{
    if (_container === document.documentElement) return $b06859765afdca70$var$resizeWindow(callback);
    else return $b06859765afdca70$var$resizeElement(callback, _container);
};
const $b06859765afdca70$var$progress = (min, max, value)=>max - min === 0 ? 1 : (value - min) / (max - min);
const $b06859765afdca70$var$SCROLL_KEYS = {
    x: {
        length: "Width",
        position: "Left"
    },
    y: {
        length: "Height",
        position: "Top"
    }
};
class $b06859765afdca70$var$ScrollHandler {
    constructor(callback, container){
        this.callback = void 0;
        this.container = void 0;
        this.info = void 0;
        this.createAxis = ()=>({
                current: 0,
                progress: 0,
                scrollLength: 0
            });
        this.updateAxis = (axisName)=>{
            const axis = this.info[axisName];
            const { length: length, position: position } = $b06859765afdca70$var$SCROLL_KEYS[axisName];
            axis.current = this.container[`scroll${position}`];
            axis.scrollLength = this.container["scroll" + length] - this.container["client" + length];
            axis.progress = $b06859765afdca70$var$progress(0, axis.scrollLength, axis.current);
        };
        this.update = ()=>{
            this.updateAxis("x");
            this.updateAxis("y");
        };
        this.sendEvent = ()=>{
            this.callback(this.info);
        };
        this.advance = ()=>{
            this.update();
            this.sendEvent();
        };
        this.callback = callback;
        this.container = container;
        this.info = {
            time: 0,
            x: this.createAxis(),
            y: this.createAxis()
        };
    }
}
const $b06859765afdca70$var$scrollListeners = new WeakMap();
const $b06859765afdca70$var$resizeListeners = new WeakMap();
const $b06859765afdca70$var$onScrollHandlers = new WeakMap();
const $b06859765afdca70$var$getTarget = (container)=>container === document.documentElement ? window : container;
const $b06859765afdca70$export$d4d89fd61e5416ee = (callback, { container: _container = document.documentElement } = {})=>{
    let containerHandlers = $b06859765afdca70$var$onScrollHandlers.get(_container);
    if (!containerHandlers) {
        containerHandlers = new Set();
        $b06859765afdca70$var$onScrollHandlers.set(_container, containerHandlers);
    }
    const containerHandler = new $b06859765afdca70$var$ScrollHandler(callback, _container);
    containerHandlers.add(containerHandler);
    if (!$b06859765afdca70$var$scrollListeners.has(_container)) {
        const listener = ()=>{
            var _containerHandlers;
            (_containerHandlers = containerHandlers) == null || _containerHandlers.forEach((handler)=>handler.advance());
            return true;
        };
        $b06859765afdca70$var$scrollListeners.set(_container, listener);
        const target = $b06859765afdca70$var$getTarget(_container);
        window.addEventListener("resize", listener, {
            passive: true
        });
        if (_container !== document.documentElement) $b06859765afdca70$var$resizeListeners.set(_container, $b06859765afdca70$export$45b39e67d4ce4921(listener, {
            container: _container
        }));
        target.addEventListener("scroll", listener, {
            passive: true
        });
    }
    const animateScroll = $b06859765afdca70$var$scrollListeners.get(_container);
    (0, $511d096570a914ae$export$27f233d61a9e2fa4)(animateScroll);
    return ()=>{
        (0, $511d096570a914ae$export$27f233d61a9e2fa4).cancel(animateScroll);
        const containerHandlers = $b06859765afdca70$var$onScrollHandlers.get(_container);
        if (!containerHandlers) return;
        containerHandlers.delete(containerHandler);
        if (containerHandlers.size) return;
        const listener = $b06859765afdca70$var$scrollListeners.get(_container);
        $b06859765afdca70$var$scrollListeners.delete(_container);
        if (listener) {
            var _resizeListeners$get;
            $b06859765afdca70$var$getTarget(_container).removeEventListener("scroll", listener);
            window.removeEventListener("resize", listener);
            (_resizeListeners$get = $b06859765afdca70$var$resizeListeners.get(_container)) == null || _resizeListeners$get();
        }
    };
};
function $b06859765afdca70$export$fe4300aa8eebea86(init) {
    const ref = (0, $P551f.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}
const $b06859765afdca70$export$700979bc83e7db82 = $b06859765afdca70$export$48d7c418edadb60c() ? (0, $P551f.useEffect) : (0, $P551f.useLayoutEffect);
const $b06859765afdca70$var$useIsMounted = ()=>{
    const isMounted = (0, $P551f.useRef)(false);
    $b06859765afdca70$export$700979bc83e7db82(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return isMounted;
};
function $b06859765afdca70$export$91db9bc4f8ac944a() {
    const update = (0, $P551f.useState)()[1];
    const isMounted = $b06859765afdca70$var$useIsMounted();
    return ()=>{
        if (isMounted.current) update(Math.random());
    };
}
function $b06859765afdca70$export$b6feb8998cd9b342(getResult, inputs) {
    const [initial] = (0, $P551f.useState)(()=>({
            inputs: inputs,
            result: getResult()
        }));
    const committed = (0, $P551f.useRef)();
    const prevCache = committed.current;
    let cache = prevCache;
    if (cache) {
        const useCache = Boolean(inputs && cache.inputs && $b06859765afdca70$var$areInputsEqual(inputs, cache.inputs));
        if (!useCache) cache = {
            inputs: inputs,
            result: getResult()
        };
    } else cache = initial;
    (0, $P551f.useEffect)(()=>{
        committed.current = cache;
        if (prevCache == initial) initial.inputs = initial.result = undefined;
    }, [
        cache
    ]);
    return cache.result;
}
function $b06859765afdca70$var$areInputsEqual(next, prev) {
    if (next.length !== prev.length) return false;
    for(let i = 0; i < next.length; i++){
        if (next[i] !== prev[i]) return false;
    }
    return true;
}
const $b06859765afdca70$export$392544347a18b6ea = (effect)=>(0, $P551f.useEffect)(effect, $b06859765afdca70$var$emptyDeps);
const $b06859765afdca70$var$emptyDeps = [];
function $b06859765afdca70$export$ef7ad0c4e19d7fbf(value) {
    const prevRef = (0, $P551f.useRef)();
    (0, $P551f.useEffect)(()=>{
        prevRef.current = value;
    });
    return prevRef.current;
}
const $b06859765afdca70$export$6a42007cf1e7b6f8 = ()=>{
    const [reducedMotion, setReducedMotion] = (0, $P551f.useState)(null);
    $b06859765afdca70$export$700979bc83e7db82(()=>{
        const mql = window.matchMedia("(prefers-reduced-motion)");
        const handleMediaChange = (e)=>{
            setReducedMotion(e.matches);
            $b06859765afdca70$var$assign({
                skipAnimation: e.matches
            });
        };
        handleMediaChange(mql);
        mql.addEventListener("change", handleMediaChange);
        return ()=>{
            mql.removeEventListener("change", handleMediaChange);
        };
    }, []);
    return reducedMotion;
};



var $P551f = parcelRequire("P551f");


var $P551f = parcelRequire("P551f");
const $1057aa8b0a5ee787$var$$node = Symbol.for("Animated:node");
const $1057aa8b0a5ee787$export$3df5e165e801a70f = (value)=>!!value && value[$1057aa8b0a5ee787$var$$node] === value;
const $1057aa8b0a5ee787$export$6b63995194a3a9e4 = (owner)=>owner && owner[$1057aa8b0a5ee787$var$$node];
const $1057aa8b0a5ee787$export$b553cb5b22b81b04 = (owner, node)=>(0, $b06859765afdca70$export$5c74248ea0e35446)(owner, $1057aa8b0a5ee787$var$$node, node);
const $1057aa8b0a5ee787$export$ccab2b64c5d440 = (owner)=>owner && owner[$1057aa8b0a5ee787$var$$node] && owner[$1057aa8b0a5ee787$var$$node].getPayload();
class $1057aa8b0a5ee787$export$31627395a3b18e54 {
    getPayload() {
        return this.payload || [];
    }
    constructor(){
        this.payload = void 0;
        $1057aa8b0a5ee787$export$b553cb5b22b81b04(this, this);
    }
}
class $1057aa8b0a5ee787$export$cb1e8f3c05d37ad5 extends $1057aa8b0a5ee787$export$31627395a3b18e54 {
    static create(value) {
        return new $1057aa8b0a5ee787$export$cb1e8f3c05d37ad5(value);
    }
    getPayload() {
        return [
            this
        ];
    }
    getValue() {
        return this._value;
    }
    setValue(value, step) {
        if ((0, $b06859765afdca70$export$226b3eccf92c9ed9).num(value)) {
            this.lastPosition = value;
            if (step) {
                value = Math.round(value / step) * step;
                if (this.done) this.lastPosition = value;
            }
        }
        if (this._value === value) return false;
        this._value = value;
        return true;
    }
    reset() {
        const { done: done } = this;
        this.done = false;
        if ((0, $b06859765afdca70$export$226b3eccf92c9ed9).num(this._value)) {
            this.elapsedTime = 0;
            this.durationProgress = 0;
            this.lastPosition = this._value;
            if (done) this.lastVelocity = null;
            this.v0 = null;
        }
    }
    constructor(_value){
        super();
        this.done = true;
        this.elapsedTime = void 0;
        this.lastPosition = void 0;
        this.lastVelocity = void 0;
        this.v0 = void 0;
        this.durationProgress = 0;
        this._value = _value;
        if ((0, $b06859765afdca70$export$226b3eccf92c9ed9).num(this._value)) this.lastPosition = this._value;
    }
}
class $1057aa8b0a5ee787$export$f6c6c4cbd7fa5b93 extends $1057aa8b0a5ee787$export$cb1e8f3c05d37ad5 {
    static create(value) {
        return new $1057aa8b0a5ee787$export$f6c6c4cbd7fa5b93(value);
    }
    getValue() {
        let value = this._string;
        return value == null ? this._string = this._toString(this._value) : value;
    }
    setValue(value) {
        if ((0, $b06859765afdca70$export$226b3eccf92c9ed9).str(value)) {
            if (value == this._string) return false;
            this._string = value;
            this._value = 1;
        } else if (super.setValue(value)) this._string = null;
        else return false;
        return true;
    }
    reset(goal) {
        if (goal) this._toString = (0, $b06859765afdca70$export$b12af43b97697ef5)({
            output: [
                this.getValue(),
                goal
            ]
        });
        this._value = 0;
        super.reset();
    }
    constructor(value){
        super(0);
        this._string = null;
        this._toString = void 0;
        this._toString = (0, $b06859765afdca70$export$b12af43b97697ef5)({
            output: [
                value,
                value
            ]
        });
    }
}
const $1057aa8b0a5ee787$var$TreeContext = {
    dependencies: null
};
class $1057aa8b0a5ee787$export$f1b0b9e366a6e2d4 extends $1057aa8b0a5ee787$export$31627395a3b18e54 {
    getValue(animated) {
        const values = {};
        (0, $b06859765afdca70$export$f4c6fe153f5a944e)(this.source, (source, key)=>{
            if ($1057aa8b0a5ee787$export$3df5e165e801a70f(source)) values[key] = source.getValue(animated);
            else if ((0, $b06859765afdca70$export$57ea7e3a7f6280c7)(source)) values[key] = (0, $b06859765afdca70$export$e37b7520edd66839)(source);
            else if (!animated) values[key] = source;
        });
        return values;
    }
    setValue(source) {
        this.source = source;
        this.payload = this._makePayload(source);
    }
    reset() {
        if (this.payload) (0, $b06859765afdca70$export$79b2f7037acddd43)(this.payload, (node)=>node.reset());
    }
    _makePayload(source) {
        if (source) {
            const payload = new Set();
            (0, $b06859765afdca70$export$f4c6fe153f5a944e)(source, this._addToPayload, payload);
            return Array.from(payload);
        }
    }
    _addToPayload(source) {
        if ($1057aa8b0a5ee787$var$TreeContext.dependencies && (0, $b06859765afdca70$export$57ea7e3a7f6280c7)(source)) $1057aa8b0a5ee787$var$TreeContext.dependencies.add(source);
        const payload = $1057aa8b0a5ee787$export$ccab2b64c5d440(source);
        if (payload) (0, $b06859765afdca70$export$79b2f7037acddd43)(payload, (node)=>this.add(node));
    }
    constructor(source){
        super();
        this.source = source;
        this.setValue(source);
    }
}
class $1057aa8b0a5ee787$export$ede394683406942d extends $1057aa8b0a5ee787$export$f1b0b9e366a6e2d4 {
    static create(source) {
        return new $1057aa8b0a5ee787$export$ede394683406942d(source);
    }
    getValue() {
        return this.source.map((node)=>node.getValue());
    }
    setValue(source) {
        const payload = this.getPayload();
        if (source.length == payload.length) return payload.map((node, i)=>node.setValue(source[i])).some(Boolean);
        super.setValue(source.map($1057aa8b0a5ee787$var$makeAnimated));
        return true;
    }
    constructor(source){
        super(source);
    }
}
function $1057aa8b0a5ee787$var$makeAnimated(value) {
    const nodeType = (0, $b06859765afdca70$export$75bed621f62abfa9)(value) ? $1057aa8b0a5ee787$export$f6c6c4cbd7fa5b93 : $1057aa8b0a5ee787$export$cb1e8f3c05d37ad5;
    return nodeType.create(value);
}
function $1057aa8b0a5ee787$export$e6b77ddbe47b132e(value) {
    const parentNode = $1057aa8b0a5ee787$export$6b63995194a3a9e4(value);
    return parentNode ? parentNode.constructor : (0, $b06859765afdca70$export$226b3eccf92c9ed9).arr(value) ? $1057aa8b0a5ee787$export$ede394683406942d : (0, $b06859765afdca70$export$75bed621f62abfa9)(value) ? $1057aa8b0a5ee787$export$f6c6c4cbd7fa5b93 : $1057aa8b0a5ee787$export$cb1e8f3c05d37ad5;
}
function $1057aa8b0a5ee787$var$_extends() {
    $1057aa8b0a5ee787$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1057aa8b0a5ee787$var$_extends.apply(this, arguments);
}
const $1057aa8b0a5ee787$var$withAnimated = (Component, host)=>{
    const hasInstance = !(0, $b06859765afdca70$export$226b3eccf92c9ed9).fun(Component) || Component.prototype && Component.prototype.isReactComponent;
    return (0, $P551f.forwardRef)((givenProps, givenRef)=>{
        const instanceRef = (0, $P551f.useRef)(null);
        const ref = hasInstance && (0, $P551f.useCallback)((value)=>{
            instanceRef.current = $1057aa8b0a5ee787$var$updateRef(givenRef, value);
        }, [
            givenRef
        ]);
        const [props, deps] = $1057aa8b0a5ee787$var$getAnimatedState(givenProps, host);
        const forceUpdate = (0, $b06859765afdca70$export$91db9bc4f8ac944a)();
        const callback = ()=>{
            const instance = instanceRef.current;
            if (hasInstance && !instance) return;
            const didUpdate = instance ? host.applyAnimatedValues(instance, props.getValue(true)) : false;
            if (didUpdate === false) forceUpdate();
        };
        const observer = new $1057aa8b0a5ee787$var$PropsObserver(callback, deps);
        const observerRef = (0, $P551f.useRef)();
        (0, $b06859765afdca70$export$700979bc83e7db82)(()=>{
            observerRef.current = observer;
            (0, $b06859765afdca70$export$79b2f7037acddd43)(deps, (dep)=>(0, $b06859765afdca70$export$72d604e3f8d000a5)(dep, observer));
            return ()=>{
                if (observerRef.current) {
                    (0, $b06859765afdca70$export$79b2f7037acddd43)(observerRef.current.deps, (dep)=>(0, $b06859765afdca70$export$7a0eb830d336339b)(dep, observerRef.current));
                    (0, $511d096570a914ae$export$27f233d61a9e2fa4).cancel(observerRef.current.update);
                }
            };
        });
        (0, $P551f.useEffect)(callback, []);
        (0, $b06859765afdca70$export$392544347a18b6ea)(()=>()=>{
                const observer = observerRef.current;
                (0, $b06859765afdca70$export$79b2f7037acddd43)(observer.deps, (dep)=>(0, $b06859765afdca70$export$7a0eb830d336339b)(dep, observer));
            });
        const usedProps = host.getComponentProps(props.getValue());
        return $P551f.createElement(Component, $1057aa8b0a5ee787$var$_extends({}, usedProps, {
            ref: ref
        }));
    });
};
class $1057aa8b0a5ee787$var$PropsObserver {
    eventObserved(event) {
        if (event.type == "change") (0, $511d096570a914ae$export$27f233d61a9e2fa4).write(this.update);
    }
    constructor(update, deps){
        this.update = update;
        this.deps = deps;
    }
}
function $1057aa8b0a5ee787$var$getAnimatedState(props, host) {
    const dependencies = new Set();
    $1057aa8b0a5ee787$var$TreeContext.dependencies = dependencies;
    if (props.style) props = $1057aa8b0a5ee787$var$_extends({}, props, {
        style: host.createAnimatedStyle(props.style)
    });
    props = new $1057aa8b0a5ee787$export$f1b0b9e366a6e2d4(props);
    $1057aa8b0a5ee787$var$TreeContext.dependencies = null;
    return [
        props,
        dependencies
    ];
}
function $1057aa8b0a5ee787$var$updateRef(ref, value) {
    if (ref) {
        if ((0, $b06859765afdca70$export$226b3eccf92c9ed9).fun(ref)) ref(value);
        else ref.current = value;
    }
    return value;
}
const $1057aa8b0a5ee787$var$cacheKey = Symbol.for("AnimatedComponent");
const $1057aa8b0a5ee787$export$4ee5c78f6dcbcef = (components, { applyAnimatedValues: _applyAnimatedValues = ()=>false, createAnimatedStyle: _createAnimatedStyle = (style)=>new $1057aa8b0a5ee787$export$f1b0b9e366a6e2d4(style), getComponentProps: _getComponentProps = (props)=>props } = {})=>{
    const hostConfig = {
        applyAnimatedValues: _applyAnimatedValues,
        createAnimatedStyle: _createAnimatedStyle,
        getComponentProps: _getComponentProps
    };
    const animated = (Component)=>{
        const displayName = $1057aa8b0a5ee787$var$getDisplayName(Component) || "Anonymous";
        if ((0, $b06859765afdca70$export$226b3eccf92c9ed9).str(Component)) Component = animated[Component] || (animated[Component] = $1057aa8b0a5ee787$var$withAnimated(Component, hostConfig));
        else Component = Component[$1057aa8b0a5ee787$var$cacheKey] || (Component[$1057aa8b0a5ee787$var$cacheKey] = $1057aa8b0a5ee787$var$withAnimated(Component, hostConfig));
        Component.displayName = `Animated(${displayName})`;
        return Component;
    };
    (0, $b06859765afdca70$export$f4c6fe153f5a944e)(components, (Component, key)=>{
        if ((0, $b06859765afdca70$export$226b3eccf92c9ed9).arr(components)) key = $1057aa8b0a5ee787$var$getDisplayName(Component);
        animated[key] = animated(Component);
    });
    return {
        animated: animated
    };
};
const $1057aa8b0a5ee787$var$getDisplayName = (arg)=>(0, $b06859765afdca70$export$226b3eccf92c9ed9).str(arg) ? arg : arg && (0, $b06859765afdca70$export$226b3eccf92c9ed9).str(arg.displayName) ? arg.displayName : (0, $b06859765afdca70$export$226b3eccf92c9ed9).fun(arg) && arg.name || null;






function $8df965278a3bc58d$var$_extends() {
    $8df965278a3bc58d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8df965278a3bc58d$var$_extends.apply(this, arguments);
}
function $8df965278a3bc58d$var$callProp(value, ...args) {
    return (0, $b06859765afdca70$export$226b3eccf92c9ed9).fun(value) ? value(...args) : value;
}
const $8df965278a3bc58d$var$matchProp = (value, key)=>value === true || !!(key && value && ((0, $b06859765afdca70$export$226b3eccf92c9ed9).fun(value) ? value(key) : (0, $b06859765afdca70$export$45b10814cc054894)(value).includes(key)));
const $8df965278a3bc58d$var$resolveProp = (prop, key)=>(0, $b06859765afdca70$export$226b3eccf92c9ed9).obj(prop) ? key && prop[key] : prop;
const $8df965278a3bc58d$var$getDefaultProp = (props, key)=>props.default === true ? props[key] : props.default ? props.default[key] : undefined;
const $8df965278a3bc58d$var$noopTransform = (value)=>value;
const $8df965278a3bc58d$var$getDefaultProps = (props, transform = $8df965278a3bc58d$var$noopTransform)=>{
    let keys = $8df965278a3bc58d$var$DEFAULT_PROPS;
    if (props.default && props.default !== true) {
        props = props.default;
        keys = Object.keys(props);
    }
    const defaults = {};
    for (const key of keys){
        const value = transform(props[key], key);
        if (!(0, $b06859765afdca70$export$226b3eccf92c9ed9).und(value)) defaults[key] = value;
    }
    return defaults;
};
const $8df965278a3bc58d$var$DEFAULT_PROPS = [
    "config",
    "onProps",
    "onStart",
    "onChange",
    "onPause",
    "onResume",
    "onRest"
];
const $8df965278a3bc58d$var$RESERVED_PROPS = {
    config: 1,
    from: 1,
    to: 1,
    ref: 1,
    loop: 1,
    reset: 1,
    pause: 1,
    cancel: 1,
    reverse: 1,
    immediate: 1,
    default: 1,
    delay: 1,
    onProps: 1,
    onStart: 1,
    onChange: 1,
    onPause: 1,
    onResume: 1,
    onRest: 1,
    onResolve: 1,
    items: 1,
    trail: 1,
    sort: 1,
    expires: 1,
    initial: 1,
    enter: 1,
    update: 1,
    leave: 1,
    children: 1,
    onDestroyed: 1,
    keys: 1,
    callId: 1,
    parentId: 1
};
function $8df965278a3bc58d$var$getForwardProps(props) {
    const forward = {};
    let count = 0;
    (0, $b06859765afdca70$export$f4c6fe153f5a944e)(props, (value, prop)=>{
        if (!$8df965278a3bc58d$var$RESERVED_PROPS[prop]) {
            forward[prop] = value;
            count++;
        }
    });
    if (count) return forward;
}
function $8df965278a3bc58d$export$b971039a739bf227(props) {
    const to = $8df965278a3bc58d$var$getForwardProps(props);
    if (to) {
        const out = {
            to: to
        };
        (0, $b06859765afdca70$export$f4c6fe153f5a944e)(props, (val, key)=>key in to || (out[key] = val));
        return out;
    }
    return $8df965278a3bc58d$var$_extends({}, props);
}
function $8df965278a3bc58d$var$computeGoal(value) {
    value = (0, $b06859765afdca70$export$e37b7520edd66839)(value);
    return (0, $b06859765afdca70$export$226b3eccf92c9ed9).arr(value) ? value.map($8df965278a3bc58d$var$computeGoal) : (0, $b06859765afdca70$export$75bed621f62abfa9)(value) ? (0, $b06859765afdca70$export$cceeabf822b64fc0).createStringInterpolator({
        range: [
            0,
            1
        ],
        output: [
            value,
            value
        ]
    })(1) : value;
}
function $8df965278a3bc58d$var$hasProps(props) {
    for(const _ in props)return true;
    return false;
}
function $8df965278a3bc58d$var$isAsyncTo(to) {
    return (0, $b06859765afdca70$export$226b3eccf92c9ed9).fun(to) || (0, $b06859765afdca70$export$226b3eccf92c9ed9).arr(to) && (0, $b06859765afdca70$export$226b3eccf92c9ed9).obj(to[0]);
}
function $8df965278a3bc58d$var$detachRefs(ctrl, ref) {
    var _ctrl$ref;
    (_ctrl$ref = ctrl.ref) == null || _ctrl$ref.delete(ctrl);
    ref == null || ref.delete(ctrl);
}
function $8df965278a3bc58d$var$replaceRef(ctrl, ref) {
    if (ref && ctrl.ref !== ref) {
        var _ctrl$ref2;
        (_ctrl$ref2 = ctrl.ref) == null || _ctrl$ref2.delete(ctrl);
        ref.add(ctrl);
        ctrl.ref = ref;
    }
}
function $8df965278a3bc58d$export$a4a17273dffcc09c(refs, timeSteps, timeFrame = 1000) {
    (0, $b06859765afdca70$export$700979bc83e7db82)(()=>{
        if (timeSteps) {
            let prevDelay = 0;
            (0, $b06859765afdca70$export$79b2f7037acddd43)(refs, (ref, i)=>{
                const controllers = ref.current;
                if (controllers.length) {
                    let delay = timeFrame * timeSteps[i];
                    if (isNaN(delay)) delay = prevDelay;
                    else prevDelay = delay;
                    (0, $b06859765afdca70$export$79b2f7037acddd43)(controllers, (ctrl)=>{
                        (0, $b06859765afdca70$export$79b2f7037acddd43)(ctrl.queue, (props)=>{
                            const memoizedDelayProp = props.delay;
                            props.delay = (key)=>delay + $8df965278a3bc58d$var$callProp(memoizedDelayProp || 0, key);
                        });
                    });
                    ref.start();
                }
            });
        } else {
            let p = Promise.resolve();
            (0, $b06859765afdca70$export$79b2f7037acddd43)(refs, (ref)=>{
                const controllers = ref.current;
                if (controllers.length) {
                    const queues = controllers.map((ctrl)=>{
                        const q = ctrl.queue;
                        ctrl.queue = [];
                        return q;
                    });
                    p = p.then(()=>{
                        (0, $b06859765afdca70$export$79b2f7037acddd43)(controllers, (ctrl, i)=>(0, $b06859765afdca70$export$79b2f7037acddd43)(queues[i] || [], (update)=>ctrl.queue.push(update)));
                        return Promise.all(ref.start());
                    });
                }
            });
        }
    });
}
const $8df965278a3bc58d$export$e506a1d27d1eaa20 = {
    default: {
        tension: 170,
        friction: 26
    },
    gentle: {
        tension: 120,
        friction: 14
    },
    wobbly: {
        tension: 180,
        friction: 12
    },
    stiff: {
        tension: 210,
        friction: 20
    },
    slow: {
        tension: 280,
        friction: 60
    },
    molasses: {
        tension: 280,
        friction: 120
    }
};
const $8df965278a3bc58d$var$defaults = $8df965278a3bc58d$var$_extends({}, $8df965278a3bc58d$export$e506a1d27d1eaa20.default, {
    mass: 1,
    damping: 1,
    easing: (0, $b06859765afdca70$export$15a0bf1b4bbacad8).linear,
    clamp: false
});
class $8df965278a3bc58d$var$AnimationConfig {
    constructor(){
        this.tension = void 0;
        this.friction = void 0;
        this.frequency = void 0;
        this.damping = void 0;
        this.mass = void 0;
        this.velocity = 0;
        this.restVelocity = void 0;
        this.precision = void 0;
        this.progress = void 0;
        this.duration = void 0;
        this.easing = void 0;
        this.clamp = void 0;
        this.bounce = void 0;
        this.decay = void 0;
        this.round = void 0;
        Object.assign(this, $8df965278a3bc58d$var$defaults);
    }
}
function $8df965278a3bc58d$var$mergeConfig(config, newConfig, defaultConfig) {
    if (defaultConfig) {
        defaultConfig = $8df965278a3bc58d$var$_extends({}, defaultConfig);
        $8df965278a3bc58d$var$sanitizeConfig(defaultConfig, newConfig);
        newConfig = $8df965278a3bc58d$var$_extends({}, defaultConfig, newConfig);
    }
    $8df965278a3bc58d$var$sanitizeConfig(config, newConfig);
    Object.assign(config, newConfig);
    for(const key in $8df965278a3bc58d$var$defaults)if (config[key] == null) config[key] = $8df965278a3bc58d$var$defaults[key];
    let { mass: mass, frequency: frequency, damping: damping } = config;
    if (!(0, $b06859765afdca70$export$226b3eccf92c9ed9).und(frequency)) {
        if (frequency < 0.01) frequency = 0.01;
        if (damping < 0) damping = 0;
        config.tension = Math.pow(2 * Math.PI / frequency, 2) * mass;
        config.friction = 4 * Math.PI * damping * mass / frequency;
    }
    return config;
}
function $8df965278a3bc58d$var$sanitizeConfig(config, props) {
    if (!(0, $b06859765afdca70$export$226b3eccf92c9ed9).und(props.decay)) config.duration = undefined;
    else {
        const isTensionConfig = !(0, $b06859765afdca70$export$226b3eccf92c9ed9).und(props.tension) || !(0, $b06859765afdca70$export$226b3eccf92c9ed9).und(props.friction);
        if (isTensionConfig || !(0, $b06859765afdca70$export$226b3eccf92c9ed9).und(props.frequency) || !(0, $b06859765afdca70$export$226b3eccf92c9ed9).und(props.damping) || !(0, $b06859765afdca70$export$226b3eccf92c9ed9).und(props.mass)) {
            config.duration = undefined;
            config.decay = undefined;
        }
        if (isTensionConfig) config.frequency = undefined;
    }
}
const $8df965278a3bc58d$var$emptyArray = [];
class $8df965278a3bc58d$var$Animation {
    constructor(){
        this.changed = false;
        this.values = $8df965278a3bc58d$var$emptyArray;
        this.toValues = null;
        this.fromValues = $8df965278a3bc58d$var$emptyArray;
        this.to = void 0;
        this.from = void 0;
        this.config = new $8df965278a3bc58d$var$AnimationConfig();
        this.immediate = false;
    }
}
function $8df965278a3bc58d$var$scheduleProps(callId, { key: key, props: props, defaultProps: defaultProps, state: state, actions: actions }) {
    return new Promise((resolve, reject)=>{
        var _props$cancel;
        let delay;
        let timeout;
        let cancel = $8df965278a3bc58d$var$matchProp((_props$cancel = props.cancel) != null ? _props$cancel : defaultProps == null ? void 0 : defaultProps.cancel, key);
        if (cancel) onStart();
        else {
            if (!(0, $b06859765afdca70$export$226b3eccf92c9ed9).und(props.pause)) state.paused = $8df965278a3bc58d$var$matchProp(props.pause, key);
            let pause = defaultProps == null ? void 0 : defaultProps.pause;
            if (pause !== true) pause = state.paused || $8df965278a3bc58d$var$matchProp(pause, key);
            delay = $8df965278a3bc58d$var$callProp(props.delay || 0, key);
            if (pause) {
                state.resumeQueue.add(onResume);
                actions.pause();
            } else {
                actions.resume();
                onResume();
            }
        }
        function onPause() {
            state.resumeQueue.add(onResume);
            state.timeouts.delete(timeout);
            timeout.cancel();
            delay = timeout.time - (0, $511d096570a914ae$export$27f233d61a9e2fa4).now();
        }
        function onResume() {
            if (delay > 0 && !(0, $b06859765afdca70$export$cceeabf822b64fc0).skipAnimation) {
                state.delayed = true;
                timeout = (0, $511d096570a914ae$export$27f233d61a9e2fa4).setTimeout(onStart, delay);
                state.pauseQueue.add(onPause);
                state.timeouts.add(timeout);
            } else onStart();
        }
        function onStart() {
            if (state.delayed) state.delayed = false;
            state.pauseQueue.delete(onPause);
            state.timeouts.delete(timeout);
            if (callId <= (state.cancelId || 0)) cancel = true;
            try {
                actions.start($8df965278a3bc58d$var$_extends({}, props, {
                    callId: callId,
                    cancel: cancel
                }), resolve);
            } catch (err) {
                reject(err);
            }
        }
    });
}
const $8df965278a3bc58d$var$getCombinedResult = (target, results)=>results.length == 1 ? results[0] : results.some((result)=>result.cancelled) ? $8df965278a3bc58d$var$getCancelledResult(target.get()) : results.every((result)=>result.noop) ? $8df965278a3bc58d$var$getNoopResult(target.get()) : $8df965278a3bc58d$var$getFinishedResult(target.get(), results.every((result)=>result.finished));
const $8df965278a3bc58d$var$getNoopResult = (value)=>({
        value: value,
        noop: true,
        finished: true,
        cancelled: false
    });
const $8df965278a3bc58d$var$getFinishedResult = (value, finished, cancelled = false)=>({
        value: value,
        finished: finished,
        cancelled: cancelled
    });
const $8df965278a3bc58d$var$getCancelledResult = (value)=>({
        value: value,
        cancelled: true,
        finished: false
    });
function $8df965278a3bc58d$var$runAsync(to, props, state, target) {
    const { callId: callId, parentId: parentId, onRest: onRest } = props;
    const { asyncTo: prevTo, promise: prevPromise } = state;
    if (!parentId && to === prevTo && !props.reset) return prevPromise;
    return state.promise = (async ()=>{
        state.asyncId = callId;
        state.asyncTo = to;
        const defaultProps = $8df965278a3bc58d$var$getDefaultProps(props, (value, key)=>key === "onRest" ? undefined : value);
        let preventBail;
        let bail;
        const bailPromise = new Promise((resolve, reject)=>(preventBail = resolve, bail = reject));
        const bailIfEnded = (bailSignal)=>{
            const bailResult = callId <= (state.cancelId || 0) && $8df965278a3bc58d$var$getCancelledResult(target) || callId !== state.asyncId && $8df965278a3bc58d$var$getFinishedResult(target, false);
            if (bailResult) {
                bailSignal.result = bailResult;
                bail(bailSignal);
                throw bailSignal;
            }
        };
        const animate = (arg1, arg2)=>{
            const bailSignal = new $8df965278a3bc58d$export$d362d093fa99dc7();
            const skipAnimationSignal = new $8df965278a3bc58d$var$SkipAnimationSignal();
            return (async ()=>{
                if ((0, $b06859765afdca70$export$cceeabf822b64fc0).skipAnimation) {
                    $8df965278a3bc58d$var$stopAsync(state);
                    skipAnimationSignal.result = $8df965278a3bc58d$var$getFinishedResult(target, false);
                    bail(skipAnimationSignal);
                    throw skipAnimationSignal;
                }
                bailIfEnded(bailSignal);
                const props = (0, $b06859765afdca70$export$226b3eccf92c9ed9).obj(arg1) ? $8df965278a3bc58d$var$_extends({}, arg1) : $8df965278a3bc58d$var$_extends({}, arg2, {
                    to: arg1
                });
                props.parentId = callId;
                (0, $b06859765afdca70$export$f4c6fe153f5a944e)(defaultProps, (value, key)=>{
                    if ((0, $b06859765afdca70$export$226b3eccf92c9ed9).und(props[key])) props[key] = value;
                });
                const result = await target.start(props);
                bailIfEnded(bailSignal);
                if (state.paused) await new Promise((resume)=>{
                    state.resumeQueue.add(resume);
                });
                return result;
            })();
        };
        let result;
        if ((0, $b06859765afdca70$export$cceeabf822b64fc0).skipAnimation) {
            $8df965278a3bc58d$var$stopAsync(state);
            return $8df965278a3bc58d$var$getFinishedResult(target, false);
        }
        try {
            let animating;
            if ((0, $b06859765afdca70$export$226b3eccf92c9ed9).arr(to)) animating = (async (queue)=>{
                for (const props of queue)await animate(props);
            })(to);
            else animating = Promise.resolve(to(animate, target.stop.bind(target)));
            await Promise.all([
                animating.then(preventBail),
                bailPromise
            ]);
            result = $8df965278a3bc58d$var$getFinishedResult(target.get(), true, false);
        } catch (err) {
            if (err instanceof $8df965278a3bc58d$export$d362d093fa99dc7) result = err.result;
            else if (err instanceof $8df965278a3bc58d$var$SkipAnimationSignal) result = err.result;
            else throw err;
        } finally{
            if (callId == state.asyncId) {
                state.asyncId = parentId;
                state.asyncTo = parentId ? prevTo : undefined;
                state.promise = parentId ? prevPromise : undefined;
            }
        }
        if ((0, $b06859765afdca70$export$226b3eccf92c9ed9).fun(onRest)) (0, $511d096570a914ae$export$27f233d61a9e2fa4).batchedUpdates(()=>{
            onRest(result, target, target.item);
        });
        return result;
    })();
}
function $8df965278a3bc58d$var$stopAsync(state, cancelId) {
    (0, $b06859765afdca70$export$4909b86c8034bf73)(state.timeouts, (t)=>t.cancel());
    state.pauseQueue.clear();
    state.resumeQueue.clear();
    state.asyncId = state.asyncTo = state.promise = undefined;
    if (cancelId) state.cancelId = cancelId;
}
class $8df965278a3bc58d$export$d362d093fa99dc7 extends Error {
    constructor(){
        super("An async animation has been interrupted. You see this error because you forgot to use `await` or `.catch(...)` on its returned promise.");
        this.result = void 0;
    }
}
class $8df965278a3bc58d$var$SkipAnimationSignal extends Error {
    constructor(){
        super("SkipAnimationSignal");
        this.result = void 0;
    }
}
const $8df965278a3bc58d$var$isFrameValue = (value)=>value instanceof $8df965278a3bc58d$export$8229896f80e2495e;
let $8df965278a3bc58d$var$nextId$1 = 1;
class $8df965278a3bc58d$export$8229896f80e2495e extends (0, $b06859765afdca70$export$aff8e1ac1a016a2) {
    get priority() {
        return this._priority;
    }
    set priority(priority) {
        if (this._priority != priority) {
            this._priority = priority;
            this._onPriorityChange(priority);
        }
    }
    get() {
        const node = (0, $1057aa8b0a5ee787$export$6b63995194a3a9e4)(this);
        return node && node.getValue();
    }
    to(...args) {
        return (0, $b06859765afdca70$export$cceeabf822b64fc0).to(this, args);
    }
    interpolate(...args) {
        (0, $b06859765afdca70$export$2abfcde8ae218ba8)();
        return (0, $b06859765afdca70$export$cceeabf822b64fc0).to(this, args);
    }
    toJSON() {
        return this.get();
    }
    observerAdded(count) {
        if (count == 1) this._attach();
    }
    observerRemoved(count) {
        if (count == 0) this._detach();
    }
    _attach() {}
    _detach() {}
    _onChange(value, idle = false) {
        (0, $b06859765afdca70$export$31752c40a5fab62a)(this, {
            type: "change",
            parent: this,
            value: value,
            idle: idle
        });
    }
    _onPriorityChange(priority) {
        if (!this.idle) (0, $b06859765afdca70$export$a57f5080a3bcc90a).sort(this);
        (0, $b06859765afdca70$export$31752c40a5fab62a)(this, {
            type: "priority",
            parent: this,
            priority: priority
        });
    }
    constructor(...args){
        super(...args);
        this.id = $8df965278a3bc58d$var$nextId$1++;
        this.key = void 0;
        this._priority = 0;
    }
}
const $8df965278a3bc58d$var$$P = Symbol.for("SpringPhase");
const $8df965278a3bc58d$var$HAS_ANIMATED = 1;
const $8df965278a3bc58d$var$IS_ANIMATING = 2;
const $8df965278a3bc58d$var$IS_PAUSED = 4;
const $8df965278a3bc58d$var$hasAnimated = (target)=>(target[$8df965278a3bc58d$var$$P] & $8df965278a3bc58d$var$HAS_ANIMATED) > 0;
const $8df965278a3bc58d$var$isAnimating = (target)=>(target[$8df965278a3bc58d$var$$P] & $8df965278a3bc58d$var$IS_ANIMATING) > 0;
const $8df965278a3bc58d$var$isPaused = (target)=>(target[$8df965278a3bc58d$var$$P] & $8df965278a3bc58d$var$IS_PAUSED) > 0;
const $8df965278a3bc58d$var$setActiveBit = (target, active)=>active ? target[$8df965278a3bc58d$var$$P] |= $8df965278a3bc58d$var$IS_ANIMATING | $8df965278a3bc58d$var$HAS_ANIMATED : target[$8df965278a3bc58d$var$$P] &= ~$8df965278a3bc58d$var$IS_ANIMATING;
const $8df965278a3bc58d$var$setPausedBit = (target, paused)=>paused ? target[$8df965278a3bc58d$var$$P] |= $8df965278a3bc58d$var$IS_PAUSED : target[$8df965278a3bc58d$var$$P] &= ~$8df965278a3bc58d$var$IS_PAUSED;
class $8df965278a3bc58d$export$5854d13427d5a954 extends $8df965278a3bc58d$export$8229896f80e2495e {
    get idle() {
        return !($8df965278a3bc58d$var$isAnimating(this) || this._state.asyncTo) || $8df965278a3bc58d$var$isPaused(this);
    }
    get goal() {
        return (0, $b06859765afdca70$export$e37b7520edd66839)(this.animation.to);
    }
    get velocity() {
        const node = (0, $1057aa8b0a5ee787$export$6b63995194a3a9e4)(this);
        return node instanceof (0, $1057aa8b0a5ee787$export$cb1e8f3c05d37ad5) ? node.lastVelocity || 0 : node.getPayload().map((node)=>node.lastVelocity || 0);
    }
    get hasAnimated() {
        return $8df965278a3bc58d$var$hasAnimated(this);
    }
    get isAnimating() {
        return $8df965278a3bc58d$var$isAnimating(this);
    }
    get isPaused() {
        return $8df965278a3bc58d$var$isPaused(this);
    }
    get isDelayed() {
        return this._state.delayed;
    }
    advance(dt) {
        let idle = true;
        let changed = false;
        const anim = this.animation;
        let { config: config, toValues: toValues } = anim;
        const payload = (0, $1057aa8b0a5ee787$export$ccab2b64c5d440)(anim.to);
        if (!payload && (0, $b06859765afdca70$export$57ea7e3a7f6280c7)(anim.to)) toValues = (0, $b06859765afdca70$export$45b10814cc054894)((0, $b06859765afdca70$export$e37b7520edd66839)(anim.to));
        anim.values.forEach((node, i)=>{
            if (node.done) return;
            const to = node.constructor == (0, $1057aa8b0a5ee787$export$f6c6c4cbd7fa5b93) ? 1 : payload ? payload[i].lastPosition : toValues[i];
            let finished = anim.immediate;
            let position = to;
            if (!finished) {
                position = node.lastPosition;
                if (config.tension <= 0) {
                    node.done = true;
                    return;
                }
                let elapsed = node.elapsedTime += dt;
                const from = anim.fromValues[i];
                const v0 = node.v0 != null ? node.v0 : node.v0 = (0, $b06859765afdca70$export$226b3eccf92c9ed9).arr(config.velocity) ? config.velocity[i] : config.velocity;
                let velocity;
                const precision = config.precision || (from == to ? 0.005 : Math.min(1, Math.abs(to - from) * 0.001));
                if (!(0, $b06859765afdca70$export$226b3eccf92c9ed9).und(config.duration)) {
                    let p = 1;
                    if (config.duration > 0) {
                        if (this._memoizedDuration !== config.duration) {
                            this._memoizedDuration = config.duration;
                            if (node.durationProgress > 0) {
                                node.elapsedTime = config.duration * node.durationProgress;
                                elapsed = node.elapsedTime += dt;
                            }
                        }
                        p = (config.progress || 0) + elapsed / this._memoizedDuration;
                        p = p > 1 ? 1 : p < 0 ? 0 : p;
                        node.durationProgress = p;
                    }
                    position = from + config.easing(p) * (to - from);
                    velocity = (position - node.lastPosition) / dt;
                    finished = p == 1;
                } else if (config.decay) {
                    const decay = config.decay === true ? 0.998 : config.decay;
                    const e = Math.exp(-(1 - decay) * elapsed);
                    position = from + v0 / (1 - decay) * (1 - e);
                    finished = Math.abs(node.lastPosition - position) <= precision;
                    velocity = v0 * e;
                } else {
                    velocity = node.lastVelocity == null ? v0 : node.lastVelocity;
                    const restVelocity = config.restVelocity || precision / 10;
                    const bounceFactor = config.clamp ? 0 : config.bounce;
                    const canBounce = !(0, $b06859765afdca70$export$226b3eccf92c9ed9).und(bounceFactor);
                    const isGrowing = from == to ? node.v0 > 0 : from < to;
                    let isMoving;
                    let isBouncing = false;
                    const step = 1;
                    const numSteps = Math.ceil(dt / step);
                    for(let n = 0; n < numSteps; ++n){
                        isMoving = Math.abs(velocity) > restVelocity;
                        if (!isMoving) {
                            finished = Math.abs(to - position) <= precision;
                            if (finished) break;
                        }
                        if (canBounce) {
                            isBouncing = position == to || position > to == isGrowing;
                            if (isBouncing) {
                                velocity = -velocity * bounceFactor;
                                position = to;
                            }
                        }
                        const springForce = -config.tension * 0.000001 * (position - to);
                        const dampingForce = -config.friction * 0.001 * velocity;
                        const acceleration = (springForce + dampingForce) / config.mass;
                        velocity = velocity + acceleration * step;
                        position = position + velocity * step;
                    }
                }
                node.lastVelocity = velocity;
                if (Number.isNaN(position)) {
                    console.warn(`Got NaN while animating:`, this);
                    finished = true;
                }
            }
            if (payload && !payload[i].done) finished = false;
            if (finished) node.done = true;
            else idle = false;
            if (node.setValue(position, config.round)) changed = true;
        });
        const node = (0, $1057aa8b0a5ee787$export$6b63995194a3a9e4)(this);
        const currVal = node.getValue();
        if (idle) {
            const finalVal = (0, $b06859765afdca70$export$e37b7520edd66839)(anim.to);
            if ((currVal !== finalVal || changed) && !config.decay) {
                node.setValue(finalVal);
                this._onChange(finalVal);
            } else if (changed && config.decay) this._onChange(currVal);
            this._stop();
        } else if (changed) this._onChange(currVal);
    }
    set(value) {
        (0, $511d096570a914ae$export$27f233d61a9e2fa4).batchedUpdates(()=>{
            this._stop();
            this._focus(value);
            this._set(value);
        });
        return this;
    }
    pause() {
        this._update({
            pause: true
        });
    }
    resume() {
        this._update({
            pause: false
        });
    }
    finish() {
        if ($8df965278a3bc58d$var$isAnimating(this)) {
            const { to: to, config: config } = this.animation;
            (0, $511d096570a914ae$export$27f233d61a9e2fa4).batchedUpdates(()=>{
                this._onStart();
                if (!config.decay) this._set(to, false);
                this._stop();
            });
        }
        return this;
    }
    update(props) {
        const queue = this.queue || (this.queue = []);
        queue.push(props);
        return this;
    }
    start(to, arg2) {
        let queue;
        if (!(0, $b06859765afdca70$export$226b3eccf92c9ed9).und(to)) queue = [
            (0, $b06859765afdca70$export$226b3eccf92c9ed9).obj(to) ? to : $8df965278a3bc58d$var$_extends({}, arg2, {
                to: to
            })
        ];
        else {
            queue = this.queue || [];
            this.queue = [];
        }
        return Promise.all(queue.map((props)=>{
            const up = this._update(props);
            return up;
        })).then((results)=>$8df965278a3bc58d$var$getCombinedResult(this, results));
    }
    stop(cancel) {
        const { to: to } = this.animation;
        this._focus(this.get());
        $8df965278a3bc58d$var$stopAsync(this._state, cancel && this._lastCallId);
        (0, $511d096570a914ae$export$27f233d61a9e2fa4).batchedUpdates(()=>this._stop(to, cancel));
        return this;
    }
    reset() {
        this._update({
            reset: true
        });
    }
    eventObserved(event) {
        if (event.type == "change") this._start();
        else if (event.type == "priority") this.priority = event.priority + 1;
    }
    _prepareNode(props) {
        const key = this.key || "";
        let { to: to, from: from } = props;
        to = (0, $b06859765afdca70$export$226b3eccf92c9ed9).obj(to) ? to[key] : to;
        if (to == null || $8df965278a3bc58d$var$isAsyncTo(to)) to = undefined;
        from = (0, $b06859765afdca70$export$226b3eccf92c9ed9).obj(from) ? from[key] : from;
        if (from == null) from = undefined;
        const range = {
            to: to,
            from: from
        };
        if (!$8df965278a3bc58d$var$hasAnimated(this)) {
            if (props.reverse) [to, from] = [
                from,
                to
            ];
            from = (0, $b06859765afdca70$export$e37b7520edd66839)(from);
            if (!(0, $b06859765afdca70$export$226b3eccf92c9ed9).und(from)) this._set(from);
            else if (!(0, $1057aa8b0a5ee787$export$6b63995194a3a9e4)(this)) this._set(to);
        }
        return range;
    }
    _update(_ref, isLoop) {
        let props = $8df965278a3bc58d$var$_extends({}, _ref);
        const { key: key, defaultProps: defaultProps } = this;
        if (props.default) Object.assign(defaultProps, $8df965278a3bc58d$var$getDefaultProps(props, (value, prop)=>/^on/.test(prop) ? $8df965278a3bc58d$var$resolveProp(value, key) : value));
        $8df965278a3bc58d$var$mergeActiveFn(this, props, "onProps");
        $8df965278a3bc58d$var$sendEvent(this, "onProps", props, this);
        const range = this._prepareNode(props);
        if (Object.isFrozen(this)) throw Error("Cannot animate a `SpringValue` object that is frozen. Did you forget to pass your component to `animated(...)` before animating its props?");
        const state = this._state;
        return $8df965278a3bc58d$var$scheduleProps(++this._lastCallId, {
            key: key,
            props: props,
            defaultProps: defaultProps,
            state: state,
            actions: {
                pause: ()=>{
                    if (!$8df965278a3bc58d$var$isPaused(this)) {
                        $8df965278a3bc58d$var$setPausedBit(this, true);
                        (0, $b06859765afdca70$export$7ba486852759e806)(state.pauseQueue);
                        $8df965278a3bc58d$var$sendEvent(this, "onPause", $8df965278a3bc58d$var$getFinishedResult(this, $8df965278a3bc58d$var$checkFinished(this, this.animation.to)), this);
                    }
                },
                resume: ()=>{
                    if ($8df965278a3bc58d$var$isPaused(this)) {
                        $8df965278a3bc58d$var$setPausedBit(this, false);
                        if ($8df965278a3bc58d$var$isAnimating(this)) this._resume();
                        (0, $b06859765afdca70$export$7ba486852759e806)(state.resumeQueue);
                        $8df965278a3bc58d$var$sendEvent(this, "onResume", $8df965278a3bc58d$var$getFinishedResult(this, $8df965278a3bc58d$var$checkFinished(this, this.animation.to)), this);
                    }
                },
                start: this._merge.bind(this, range)
            }
        }).then((result)=>{
            if (props.loop && result.finished && !(isLoop && result.noop)) {
                const nextProps = $8df965278a3bc58d$var$createLoopUpdate(props);
                if (nextProps) return this._update(nextProps, true);
            }
            return result;
        });
    }
    _merge(range, props, resolve) {
        if (props.cancel) {
            this.stop(true);
            return resolve($8df965278a3bc58d$var$getCancelledResult(this));
        }
        const hasToProp = !(0, $b06859765afdca70$export$226b3eccf92c9ed9).und(range.to);
        const hasFromProp = !(0, $b06859765afdca70$export$226b3eccf92c9ed9).und(range.from);
        if (hasToProp || hasFromProp) {
            if (props.callId > this._lastToId) this._lastToId = props.callId;
            else return resolve($8df965278a3bc58d$var$getCancelledResult(this));
        }
        const { key: key, defaultProps: defaultProps, animation: anim } = this;
        const { to: prevTo, from: prevFrom } = anim;
        let { to: to = prevTo, from: from = prevFrom } = range;
        if (hasFromProp && !hasToProp && (!props.default || (0, $b06859765afdca70$export$226b3eccf92c9ed9).und(to))) to = from;
        if (props.reverse) [to, from] = [
            from,
            to
        ];
        const hasFromChanged = !(0, $b06859765afdca70$export$248d38f6296296c5)(from, prevFrom);
        if (hasFromChanged) anim.from = from;
        from = (0, $b06859765afdca70$export$e37b7520edd66839)(from);
        const hasToChanged = !(0, $b06859765afdca70$export$248d38f6296296c5)(to, prevTo);
        if (hasToChanged) this._focus(to);
        const hasAsyncTo = $8df965278a3bc58d$var$isAsyncTo(props.to);
        const { config: config } = anim;
        const { decay: decay, velocity: velocity } = config;
        if (hasToProp || hasFromProp) config.velocity = 0;
        if (props.config && !hasAsyncTo) $8df965278a3bc58d$var$mergeConfig(config, $8df965278a3bc58d$var$callProp(props.config, key), props.config !== defaultProps.config ? $8df965278a3bc58d$var$callProp(defaultProps.config, key) : void 0);
        let node = (0, $1057aa8b0a5ee787$export$6b63995194a3a9e4)(this);
        if (!node || (0, $b06859765afdca70$export$226b3eccf92c9ed9).und(to)) return resolve($8df965278a3bc58d$var$getFinishedResult(this, true));
        const reset = (0, $b06859765afdca70$export$226b3eccf92c9ed9).und(props.reset) ? hasFromProp && !props.default : !(0, $b06859765afdca70$export$226b3eccf92c9ed9).und(from) && $8df965278a3bc58d$var$matchProp(props.reset, key);
        const value = reset ? from : this.get();
        const goal = $8df965278a3bc58d$var$computeGoal(to);
        const isAnimatable = (0, $b06859765afdca70$export$226b3eccf92c9ed9).num(goal) || (0, $b06859765afdca70$export$226b3eccf92c9ed9).arr(goal) || (0, $b06859765afdca70$export$75bed621f62abfa9)(goal);
        const immediate = !hasAsyncTo && (!isAnimatable || $8df965278a3bc58d$var$matchProp(defaultProps.immediate || props.immediate, key));
        if (hasToChanged) {
            const nodeType = (0, $1057aa8b0a5ee787$export$e6b77ddbe47b132e)(to);
            if (nodeType !== node.constructor) {
                if (immediate) node = this._set(goal);
                else throw Error(`Cannot animate between ${node.constructor.name} and ${nodeType.name}, as the "to" prop suggests`);
            }
        }
        const goalType = node.constructor;
        let started = (0, $b06859765afdca70$export$57ea7e3a7f6280c7)(to);
        let finished = false;
        if (!started) {
            const hasValueChanged = reset || !$8df965278a3bc58d$var$hasAnimated(this) && hasFromChanged;
            if (hasToChanged || hasValueChanged) {
                finished = (0, $b06859765afdca70$export$248d38f6296296c5)($8df965278a3bc58d$var$computeGoal(value), goal);
                started = !finished;
            }
            if (!(0, $b06859765afdca70$export$248d38f6296296c5)(anim.immediate, immediate) && !immediate || !(0, $b06859765afdca70$export$248d38f6296296c5)(config.decay, decay) || !(0, $b06859765afdca70$export$248d38f6296296c5)(config.velocity, velocity)) started = true;
        }
        if (finished && $8df965278a3bc58d$var$isAnimating(this)) {
            if (anim.changed && !reset) started = true;
            else if (!started) this._stop(prevTo);
        }
        if (!hasAsyncTo) {
            if (started || (0, $b06859765afdca70$export$57ea7e3a7f6280c7)(prevTo)) {
                anim.values = node.getPayload();
                anim.toValues = (0, $b06859765afdca70$export$57ea7e3a7f6280c7)(to) ? null : goalType == (0, $1057aa8b0a5ee787$export$f6c6c4cbd7fa5b93) ? [
                    1
                ] : (0, $b06859765afdca70$export$45b10814cc054894)(goal);
            }
            if (anim.immediate != immediate) {
                anim.immediate = immediate;
                if (!immediate && !reset) this._set(prevTo);
            }
            if (started) {
                const { onRest: onRest } = anim;
                (0, $b06859765afdca70$export$79b2f7037acddd43)($8df965278a3bc58d$var$ACTIVE_EVENTS, (type)=>$8df965278a3bc58d$var$mergeActiveFn(this, props, type));
                const result = $8df965278a3bc58d$var$getFinishedResult(this, $8df965278a3bc58d$var$checkFinished(this, prevTo));
                (0, $b06859765afdca70$export$7ba486852759e806)(this._pendingCalls, result);
                this._pendingCalls.add(resolve);
                if (anim.changed) (0, $511d096570a914ae$export$27f233d61a9e2fa4).batchedUpdates(()=>{
                    anim.changed = !reset;
                    onRest == null || onRest(result, this);
                    if (reset) $8df965278a3bc58d$var$callProp(defaultProps.onRest, result);
                    else anim.onStart == null || anim.onStart(result, this);
                });
            }
        }
        if (reset) this._set(value);
        if (hasAsyncTo) resolve($8df965278a3bc58d$var$runAsync(props.to, props, this._state, this));
        else if (started) this._start();
        else if ($8df965278a3bc58d$var$isAnimating(this) && !hasToChanged) this._pendingCalls.add(resolve);
        else resolve($8df965278a3bc58d$var$getNoopResult(value));
    }
    _focus(value) {
        const anim = this.animation;
        if (value !== anim.to) {
            if ((0, $b06859765afdca70$export$133f54e9f7cf1796)(this)) this._detach();
            anim.to = value;
            if ((0, $b06859765afdca70$export$133f54e9f7cf1796)(this)) this._attach();
        }
    }
    _attach() {
        let priority = 0;
        const { to: to } = this.animation;
        if ((0, $b06859765afdca70$export$57ea7e3a7f6280c7)(to)) {
            (0, $b06859765afdca70$export$72d604e3f8d000a5)(to, this);
            if ($8df965278a3bc58d$var$isFrameValue(to)) priority = to.priority + 1;
        }
        this.priority = priority;
    }
    _detach() {
        const { to: to } = this.animation;
        if ((0, $b06859765afdca70$export$57ea7e3a7f6280c7)(to)) (0, $b06859765afdca70$export$7a0eb830d336339b)(to, this);
    }
    _set(arg, idle = true) {
        const value = (0, $b06859765afdca70$export$e37b7520edd66839)(arg);
        if (!(0, $b06859765afdca70$export$226b3eccf92c9ed9).und(value)) {
            const oldNode = (0, $1057aa8b0a5ee787$export$6b63995194a3a9e4)(this);
            if (!oldNode || !(0, $b06859765afdca70$export$248d38f6296296c5)(value, oldNode.getValue())) {
                const nodeType = (0, $1057aa8b0a5ee787$export$e6b77ddbe47b132e)(value);
                if (!oldNode || oldNode.constructor != nodeType) (0, $1057aa8b0a5ee787$export$b553cb5b22b81b04)(this, nodeType.create(value));
                else oldNode.setValue(value);
                if (oldNode) (0, $511d096570a914ae$export$27f233d61a9e2fa4).batchedUpdates(()=>{
                    this._onChange(value, idle);
                });
            }
        }
        return (0, $1057aa8b0a5ee787$export$6b63995194a3a9e4)(this);
    }
    _onStart() {
        const anim = this.animation;
        if (!anim.changed) {
            anim.changed = true;
            $8df965278a3bc58d$var$sendEvent(this, "onStart", $8df965278a3bc58d$var$getFinishedResult(this, $8df965278a3bc58d$var$checkFinished(this, anim.to)), this);
        }
    }
    _onChange(value, idle) {
        if (!idle) {
            this._onStart();
            $8df965278a3bc58d$var$callProp(this.animation.onChange, value, this);
        }
        $8df965278a3bc58d$var$callProp(this.defaultProps.onChange, value, this);
        super._onChange(value, idle);
    }
    _start() {
        const anim = this.animation;
        (0, $1057aa8b0a5ee787$export$6b63995194a3a9e4)(this).reset((0, $b06859765afdca70$export$e37b7520edd66839)(anim.to));
        if (!anim.immediate) anim.fromValues = anim.values.map((node)=>node.lastPosition);
        if (!$8df965278a3bc58d$var$isAnimating(this)) {
            $8df965278a3bc58d$var$setActiveBit(this, true);
            if (!$8df965278a3bc58d$var$isPaused(this)) this._resume();
        }
    }
    _resume() {
        if ((0, $b06859765afdca70$export$cceeabf822b64fc0).skipAnimation) this.finish();
        else (0, $b06859765afdca70$export$a57f5080a3bcc90a).start(this);
    }
    _stop(goal, cancel) {
        if ($8df965278a3bc58d$var$isAnimating(this)) {
            $8df965278a3bc58d$var$setActiveBit(this, false);
            const anim = this.animation;
            (0, $b06859765afdca70$export$79b2f7037acddd43)(anim.values, (node)=>{
                node.done = true;
            });
            if (anim.toValues) anim.onChange = anim.onPause = anim.onResume = undefined;
            (0, $b06859765afdca70$export$31752c40a5fab62a)(this, {
                type: "idle",
                parent: this
            });
            const result = cancel ? $8df965278a3bc58d$var$getCancelledResult(this.get()) : $8df965278a3bc58d$var$getFinishedResult(this.get(), $8df965278a3bc58d$var$checkFinished(this, goal != null ? goal : anim.to));
            (0, $b06859765afdca70$export$7ba486852759e806)(this._pendingCalls, result);
            if (anim.changed) {
                anim.changed = false;
                $8df965278a3bc58d$var$sendEvent(this, "onRest", result, this);
            }
        }
    }
    constructor(arg1, arg2){
        super();
        this.key = void 0;
        this.animation = new $8df965278a3bc58d$var$Animation();
        this.queue = void 0;
        this.defaultProps = {};
        this._state = {
            paused: false,
            delayed: false,
            pauseQueue: new Set(),
            resumeQueue: new Set(),
            timeouts: new Set()
        };
        this._pendingCalls = new Set();
        this._lastCallId = 0;
        this._lastToId = 0;
        this._memoizedDuration = 0;
        if (!(0, $b06859765afdca70$export$226b3eccf92c9ed9).und(arg1) || !(0, $b06859765afdca70$export$226b3eccf92c9ed9).und(arg2)) {
            const props = (0, $b06859765afdca70$export$226b3eccf92c9ed9).obj(arg1) ? $8df965278a3bc58d$var$_extends({}, arg1) : $8df965278a3bc58d$var$_extends({}, arg2, {
                from: arg1
            });
            if ((0, $b06859765afdca70$export$226b3eccf92c9ed9).und(props.default)) props.default = true;
            this.start(props);
        }
    }
}
function $8df965278a3bc58d$var$checkFinished(target, to) {
    const goal = $8df965278a3bc58d$var$computeGoal(to);
    const value = $8df965278a3bc58d$var$computeGoal(target.get());
    return (0, $b06859765afdca70$export$248d38f6296296c5)(value, goal);
}
function $8df965278a3bc58d$var$createLoopUpdate(props, loop = props.loop, to = props.to) {
    let loopRet = $8df965278a3bc58d$var$callProp(loop);
    if (loopRet) {
        const overrides = loopRet !== true && $8df965278a3bc58d$export$b971039a739bf227(loopRet);
        const reverse = (overrides || props).reverse;
        const reset = !overrides || overrides.reset;
        return $8df965278a3bc58d$var$createUpdate($8df965278a3bc58d$var$_extends({}, props, {
            loop: loop,
            default: false,
            pause: undefined,
            to: !reverse || $8df965278a3bc58d$var$isAsyncTo(to) ? to : undefined,
            from: reset ? props.from : undefined,
            reset: reset
        }, overrides));
    }
}
function $8df965278a3bc58d$var$createUpdate(props) {
    const { to: to, from: from } = props = $8df965278a3bc58d$export$b971039a739bf227(props);
    const keys = new Set();
    if ((0, $b06859765afdca70$export$226b3eccf92c9ed9).obj(to)) $8df965278a3bc58d$var$findDefined(to, keys);
    if ((0, $b06859765afdca70$export$226b3eccf92c9ed9).obj(from)) $8df965278a3bc58d$var$findDefined(from, keys);
    props.keys = keys.size ? Array.from(keys) : null;
    return props;
}
function $8df965278a3bc58d$var$declareUpdate(props) {
    const update = $8df965278a3bc58d$var$createUpdate(props);
    if ((0, $b06859765afdca70$export$226b3eccf92c9ed9).und(update.default)) update.default = $8df965278a3bc58d$var$getDefaultProps(update);
    return update;
}
function $8df965278a3bc58d$var$findDefined(values, keys) {
    (0, $b06859765afdca70$export$f4c6fe153f5a944e)(values, (value, key)=>value != null && keys.add(key));
}
const $8df965278a3bc58d$var$ACTIVE_EVENTS = [
    "onStart",
    "onRest",
    "onChange",
    "onPause",
    "onResume"
];
function $8df965278a3bc58d$var$mergeActiveFn(target, props, type) {
    target.animation[type] = props[type] !== $8df965278a3bc58d$var$getDefaultProp(props, type) ? $8df965278a3bc58d$var$resolveProp(props[type], target.key) : undefined;
}
function $8df965278a3bc58d$var$sendEvent(target, type, ...args) {
    var _target$animation$typ, _target$animation, _target$defaultProps$, _target$defaultProps;
    (_target$animation$typ = (_target$animation = target.animation)[type]) == null || _target$animation$typ.call(_target$animation, ...args);
    (_target$defaultProps$ = (_target$defaultProps = target.defaultProps)[type]) == null || _target$defaultProps$.call(_target$defaultProps, ...args);
}
const $8df965278a3bc58d$var$BATCHED_EVENTS = [
    "onStart",
    "onChange",
    "onRest"
];
let $8df965278a3bc58d$var$nextId = 1;
class $8df965278a3bc58d$export$bd0bf19f25da8474 {
    get idle() {
        return !this._state.asyncTo && Object.values(this.springs).every((spring)=>{
            return spring.idle && !spring.isDelayed && !spring.isPaused;
        });
    }
    get item() {
        return this._item;
    }
    set item(item) {
        this._item = item;
    }
    get() {
        const values = {};
        this.each((spring, key)=>values[key] = spring.get());
        return values;
    }
    set(values) {
        for(const key in values){
            const value = values[key];
            if (!(0, $b06859765afdca70$export$226b3eccf92c9ed9).und(value)) this.springs[key].set(value);
        }
    }
    update(props) {
        if (props) this.queue.push($8df965278a3bc58d$var$createUpdate(props));
        return this;
    }
    start(props) {
        let { queue: queue } = this;
        if (props) queue = (0, $b06859765afdca70$export$45b10814cc054894)(props).map($8df965278a3bc58d$var$createUpdate);
        else this.queue = [];
        if (this._flush) return this._flush(this, queue);
        $8df965278a3bc58d$var$prepareKeys(this, queue);
        return $8df965278a3bc58d$var$flushUpdateQueue(this, queue);
    }
    stop(arg, keys) {
        if (arg !== !!arg) keys = arg;
        if (keys) {
            const springs = this.springs;
            (0, $b06859765afdca70$export$79b2f7037acddd43)((0, $b06859765afdca70$export$45b10814cc054894)(keys), (key)=>springs[key].stop(!!arg));
        } else {
            $8df965278a3bc58d$var$stopAsync(this._state, this._lastAsyncId);
            this.each((spring)=>spring.stop(!!arg));
        }
        return this;
    }
    pause(keys) {
        if ((0, $b06859765afdca70$export$226b3eccf92c9ed9).und(keys)) this.start({
            pause: true
        });
        else {
            const springs = this.springs;
            (0, $b06859765afdca70$export$79b2f7037acddd43)((0, $b06859765afdca70$export$45b10814cc054894)(keys), (key)=>springs[key].pause());
        }
        return this;
    }
    resume(keys) {
        if ((0, $b06859765afdca70$export$226b3eccf92c9ed9).und(keys)) this.start({
            pause: false
        });
        else {
            const springs = this.springs;
            (0, $b06859765afdca70$export$79b2f7037acddd43)((0, $b06859765afdca70$export$45b10814cc054894)(keys), (key)=>springs[key].resume());
        }
        return this;
    }
    each(iterator) {
        (0, $b06859765afdca70$export$f4c6fe153f5a944e)(this.springs, iterator);
    }
    _onFrame() {
        const { onStart: onStart, onChange: onChange, onRest: onRest } = this._events;
        const active = this._active.size > 0;
        const changed = this._changed.size > 0;
        if (active && !this._started || changed && !this._started) {
            this._started = true;
            (0, $b06859765afdca70$export$4909b86c8034bf73)(onStart, ([onStart, result])=>{
                result.value = this.get();
                onStart(result, this, this._item);
            });
        }
        const idle = !active && this._started;
        const values = changed || idle && onRest.size ? this.get() : null;
        if (changed && onChange.size) (0, $b06859765afdca70$export$4909b86c8034bf73)(onChange, ([onChange, result])=>{
            result.value = values;
            onChange(result, this, this._item);
        });
        if (idle) {
            this._started = false;
            (0, $b06859765afdca70$export$4909b86c8034bf73)(onRest, ([onRest, result])=>{
                result.value = values;
                onRest(result, this, this._item);
            });
        }
    }
    eventObserved(event) {
        if (event.type == "change") {
            this._changed.add(event.parent);
            if (!event.idle) this._active.add(event.parent);
        } else if (event.type == "idle") this._active.delete(event.parent);
        else return;
        (0, $511d096570a914ae$export$27f233d61a9e2fa4).onFrame(this._onFrame);
    }
    constructor(props, flush){
        this.id = $8df965278a3bc58d$var$nextId++;
        this.springs = {};
        this.queue = [];
        this.ref = void 0;
        this._flush = void 0;
        this._initialProps = void 0;
        this._lastAsyncId = 0;
        this._active = new Set();
        this._changed = new Set();
        this._started = false;
        this._item = void 0;
        this._state = {
            paused: false,
            pauseQueue: new Set(),
            resumeQueue: new Set(),
            timeouts: new Set()
        };
        this._events = {
            onStart: new Map(),
            onChange: new Map(),
            onRest: new Map()
        };
        this._onFrame = this._onFrame.bind(this);
        if (flush) this._flush = flush;
        if (props) this.start($8df965278a3bc58d$var$_extends({
            default: true
        }, props));
    }
}
function $8df965278a3bc58d$var$flushUpdateQueue(ctrl, queue) {
    return Promise.all(queue.map((props)=>$8df965278a3bc58d$var$flushUpdate(ctrl, props))).then((results)=>$8df965278a3bc58d$var$getCombinedResult(ctrl, results));
}
async function $8df965278a3bc58d$var$flushUpdate(ctrl, props, isLoop) {
    const { keys: keys, to: to, from: from, loop: loop, onRest: onRest, onResolve: onResolve } = props;
    const defaults = (0, $b06859765afdca70$export$226b3eccf92c9ed9).obj(props.default) && props.default;
    if (loop) props.loop = false;
    if (to === false) props.to = null;
    if (from === false) props.from = null;
    const asyncTo = (0, $b06859765afdca70$export$226b3eccf92c9ed9).arr(to) || (0, $b06859765afdca70$export$226b3eccf92c9ed9).fun(to) ? to : undefined;
    if (asyncTo) {
        props.to = undefined;
        props.onRest = undefined;
        if (defaults) defaults.onRest = undefined;
    } else (0, $b06859765afdca70$export$79b2f7037acddd43)($8df965278a3bc58d$var$BATCHED_EVENTS, (key)=>{
        const handler = props[key];
        if ((0, $b06859765afdca70$export$226b3eccf92c9ed9).fun(handler)) {
            const queue = ctrl["_events"][key];
            props[key] = ({ finished: finished, cancelled: cancelled })=>{
                const result = queue.get(handler);
                if (result) {
                    if (!finished) result.finished = false;
                    if (cancelled) result.cancelled = true;
                } else queue.set(handler, {
                    value: null,
                    finished: finished || false,
                    cancelled: cancelled || false
                });
            };
            if (defaults) defaults[key] = props[key];
        }
    });
    const state = ctrl["_state"];
    if (props.pause === !state.paused) {
        state.paused = props.pause;
        (0, $b06859765afdca70$export$7ba486852759e806)(props.pause ? state.pauseQueue : state.resumeQueue);
    } else if (state.paused) props.pause = true;
    const promises = (keys || Object.keys(ctrl.springs)).map((key)=>ctrl.springs[key].start(props));
    const cancel = props.cancel === true || $8df965278a3bc58d$var$getDefaultProp(props, "cancel") === true;
    if (asyncTo || cancel && state.asyncId) promises.push($8df965278a3bc58d$var$scheduleProps(++ctrl["_lastAsyncId"], {
        props: props,
        state: state,
        actions: {
            pause: (0, $b06859765afdca70$export$8793edee2d425525),
            resume: (0, $b06859765afdca70$export$8793edee2d425525),
            start (props, resolve) {
                if (cancel) {
                    $8df965278a3bc58d$var$stopAsync(state, ctrl["_lastAsyncId"]);
                    resolve($8df965278a3bc58d$var$getCancelledResult(ctrl));
                } else {
                    props.onRest = onRest;
                    resolve($8df965278a3bc58d$var$runAsync(asyncTo, props, state, ctrl));
                }
            }
        }
    }));
    if (state.paused) await new Promise((resume)=>{
        state.resumeQueue.add(resume);
    });
    const result = $8df965278a3bc58d$var$getCombinedResult(ctrl, await Promise.all(promises));
    if (loop && result.finished && !(isLoop && result.noop)) {
        const nextProps = $8df965278a3bc58d$var$createLoopUpdate(props, loop, to);
        if (nextProps) {
            $8df965278a3bc58d$var$prepareKeys(ctrl, [
                nextProps
            ]);
            return $8df965278a3bc58d$var$flushUpdate(ctrl, nextProps, true);
        }
    }
    if (onResolve) (0, $511d096570a914ae$export$27f233d61a9e2fa4).batchedUpdates(()=>onResolve(result, ctrl, ctrl.item));
    return result;
}
function $8df965278a3bc58d$var$getSprings(ctrl, props) {
    const springs = $8df965278a3bc58d$var$_extends({}, ctrl.springs);
    if (props) (0, $b06859765afdca70$export$79b2f7037acddd43)((0, $b06859765afdca70$export$45b10814cc054894)(props), (props)=>{
        if ((0, $b06859765afdca70$export$226b3eccf92c9ed9).und(props.keys)) props = $8df965278a3bc58d$var$createUpdate(props);
        if (!(0, $b06859765afdca70$export$226b3eccf92c9ed9).obj(props.to)) props = $8df965278a3bc58d$var$_extends({}, props, {
            to: undefined
        });
        $8df965278a3bc58d$var$prepareSprings(springs, props, (key)=>{
            return $8df965278a3bc58d$var$createSpring(key);
        });
    });
    $8df965278a3bc58d$var$setSprings(ctrl, springs);
    return springs;
}
function $8df965278a3bc58d$var$setSprings(ctrl, springs) {
    (0, $b06859765afdca70$export$f4c6fe153f5a944e)(springs, (spring, key)=>{
        if (!ctrl.springs[key]) {
            ctrl.springs[key] = spring;
            (0, $b06859765afdca70$export$72d604e3f8d000a5)(spring, ctrl);
        }
    });
}
function $8df965278a3bc58d$var$createSpring(key, observer) {
    const spring = new $8df965278a3bc58d$export$5854d13427d5a954();
    spring.key = key;
    if (observer) (0, $b06859765afdca70$export$72d604e3f8d000a5)(spring, observer);
    return spring;
}
function $8df965278a3bc58d$var$prepareSprings(springs, props, create) {
    if (props.keys) (0, $b06859765afdca70$export$79b2f7037acddd43)(props.keys, (key)=>{
        const spring = springs[key] || (springs[key] = create(key));
        spring["_prepareNode"](props);
    });
}
function $8df965278a3bc58d$var$prepareKeys(ctrl, queue) {
    (0, $b06859765afdca70$export$79b2f7037acddd43)(queue, (props)=>{
        $8df965278a3bc58d$var$prepareSprings(ctrl.springs, props, (key)=>{
            return $8df965278a3bc58d$var$createSpring(key, ctrl);
        });
    });
}
function $8df965278a3bc58d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $8df965278a3bc58d$var$_excluded$6 = [
    "children"
];
const $8df965278a3bc58d$export$f12a216ec50d2cf1 = (_ref)=>{
    let { children: children } = _ref, props = $8df965278a3bc58d$var$_objectWithoutPropertiesLoose(_ref, $8df965278a3bc58d$var$_excluded$6);
    const inherited = (0, $P551f.useContext)($8df965278a3bc58d$var$ctx);
    const pause = props.pause || !!inherited.pause, immediate = props.immediate || !!inherited.immediate;
    props = (0, $b06859765afdca70$export$b6feb8998cd9b342)(()=>({
            pause: pause,
            immediate: immediate
        }), [
        pause,
        immediate
    ]);
    const { Provider: Provider } = $8df965278a3bc58d$var$ctx;
    return $P551f.createElement(Provider, {
        value: props
    }, children);
};
const $8df965278a3bc58d$var$ctx = $8df965278a3bc58d$var$makeContext($8df965278a3bc58d$export$f12a216ec50d2cf1, {});
$8df965278a3bc58d$export$f12a216ec50d2cf1.Provider = $8df965278a3bc58d$var$ctx.Provider;
$8df965278a3bc58d$export$f12a216ec50d2cf1.Consumer = $8df965278a3bc58d$var$ctx.Consumer;
function $8df965278a3bc58d$var$makeContext(target, init) {
    Object.assign(target, $P551f.createContext(init));
    target.Provider._context = target;
    target.Consumer._context = target;
    return target;
}
const $8df965278a3bc58d$export$2471ae76e2946684 = ()=>{
    const current = [];
    const SpringRef = function SpringRef(props) {
        (0, $b06859765afdca70$export$d99d974913ad3b12)();
        const results = [];
        (0, $b06859765afdca70$export$79b2f7037acddd43)(current, (ctrl, i)=>{
            if ((0, $b06859765afdca70$export$226b3eccf92c9ed9).und(props)) results.push(ctrl.start());
            else {
                const update = _getProps(props, ctrl, i);
                if (update) results.push(ctrl.start(update));
            }
        });
        return results;
    };
    SpringRef.current = current;
    SpringRef.add = function(ctrl) {
        if (!current.includes(ctrl)) current.push(ctrl);
    };
    SpringRef.delete = function(ctrl) {
        const i = current.indexOf(ctrl);
        if (~i) current.splice(i, 1);
    };
    SpringRef.pause = function() {
        (0, $b06859765afdca70$export$79b2f7037acddd43)(current, (ctrl)=>ctrl.pause(...arguments));
        return this;
    };
    SpringRef.resume = function() {
        (0, $b06859765afdca70$export$79b2f7037acddd43)(current, (ctrl)=>ctrl.resume(...arguments));
        return this;
    };
    SpringRef.set = function(values) {
        (0, $b06859765afdca70$export$79b2f7037acddd43)(current, (ctrl)=>ctrl.set(values));
    };
    SpringRef.start = function(props) {
        const results = [];
        (0, $b06859765afdca70$export$79b2f7037acddd43)(current, (ctrl, i)=>{
            if ((0, $b06859765afdca70$export$226b3eccf92c9ed9).und(props)) results.push(ctrl.start());
            else {
                const update = this._getProps(props, ctrl, i);
                if (update) results.push(ctrl.start(update));
            }
        });
        return results;
    };
    SpringRef.stop = function() {
        (0, $b06859765afdca70$export$79b2f7037acddd43)(current, (ctrl)=>ctrl.stop(...arguments));
        return this;
    };
    SpringRef.update = function(props) {
        (0, $b06859765afdca70$export$79b2f7037acddd43)(current, (ctrl, i)=>ctrl.update(this._getProps(props, ctrl, i)));
        return this;
    };
    const _getProps = function _getProps(arg, ctrl, index) {
        return (0, $b06859765afdca70$export$226b3eccf92c9ed9).fun(arg) ? arg(index, ctrl) : arg;
    };
    SpringRef._getProps = _getProps;
    return SpringRef;
};
function $8df965278a3bc58d$export$15786d483ab9f469(length, props, deps) {
    const propsFn = (0, $b06859765afdca70$export$226b3eccf92c9ed9).fun(props) && props;
    if (propsFn && !deps) deps = [];
    const ref = (0, $P551f.useMemo)(()=>propsFn || arguments.length == 3 ? $8df965278a3bc58d$export$2471ae76e2946684() : void 0, []);
    const layoutId = (0, $P551f.useRef)(0);
    const forceUpdate = (0, $b06859765afdca70$export$91db9bc4f8ac944a)();
    const state = (0, $P551f.useMemo)(()=>({
            ctrls: [],
            queue: [],
            flush (ctrl, updates) {
                const springs = $8df965278a3bc58d$var$getSprings(ctrl, updates);
                const canFlushSync = layoutId.current > 0 && !state.queue.length && !Object.keys(springs).some((key)=>!ctrl.springs[key]);
                return canFlushSync ? $8df965278a3bc58d$var$flushUpdateQueue(ctrl, updates) : new Promise((resolve)=>{
                    $8df965278a3bc58d$var$setSprings(ctrl, springs);
                    state.queue.push(()=>{
                        resolve($8df965278a3bc58d$var$flushUpdateQueue(ctrl, updates));
                    });
                    forceUpdate();
                });
            }
        }), []);
    const ctrls = (0, $P551f.useRef)([
        ...state.ctrls
    ]);
    const updates = [];
    const prevLength = (0, $b06859765afdca70$export$ef7ad0c4e19d7fbf)(length) || 0;
    (0, $P551f.useMemo)(()=>{
        (0, $b06859765afdca70$export$79b2f7037acddd43)(ctrls.current.slice(length, prevLength), (ctrl)=>{
            $8df965278a3bc58d$var$detachRefs(ctrl, ref);
            ctrl.stop(true);
        });
        ctrls.current.length = length;
        declareUpdates(prevLength, length);
    }, [
        length
    ]);
    (0, $P551f.useMemo)(()=>{
        declareUpdates(0, Math.min(prevLength, length));
    }, deps);
    function declareUpdates(startIndex, endIndex) {
        for(let i = startIndex; i < endIndex; i++){
            const ctrl = ctrls.current[i] || (ctrls.current[i] = new $8df965278a3bc58d$export$bd0bf19f25da8474(null, state.flush));
            const update = propsFn ? propsFn(i, ctrl) : props[i];
            if (update) updates[i] = $8df965278a3bc58d$var$declareUpdate(update);
        }
    }
    const springs = ctrls.current.map((ctrl, i)=>$8df965278a3bc58d$var$getSprings(ctrl, updates[i]));
    const context = (0, $P551f.useContext)($8df965278a3bc58d$export$f12a216ec50d2cf1);
    const prevContext = (0, $b06859765afdca70$export$ef7ad0c4e19d7fbf)(context);
    const hasContext = context !== prevContext && $8df965278a3bc58d$var$hasProps(context);
    (0, $b06859765afdca70$export$700979bc83e7db82)(()=>{
        layoutId.current++;
        state.ctrls = ctrls.current;
        const { queue: queue } = state;
        if (queue.length) {
            state.queue = [];
            (0, $b06859765afdca70$export$79b2f7037acddd43)(queue, (cb)=>cb());
        }
        (0, $b06859765afdca70$export$79b2f7037acddd43)(ctrls.current, (ctrl, i)=>{
            ref == null || ref.add(ctrl);
            if (hasContext) ctrl.start({
                default: context
            });
            const update = updates[i];
            if (update) {
                $8df965278a3bc58d$var$replaceRef(ctrl, update.ref);
                if (ctrl.ref) ctrl.queue.push(update);
                else ctrl.start(update);
            }
        });
    });
    (0, $b06859765afdca70$export$392544347a18b6ea)(()=>()=>{
            (0, $b06859765afdca70$export$79b2f7037acddd43)(state.ctrls, (ctrl)=>ctrl.stop(true));
        });
    const values = springs.map((x)=>$8df965278a3bc58d$var$_extends({}, x));
    return ref ? [
        values,
        ref
    ] : values;
}
function $8df965278a3bc58d$export$c4af9125706c4d30(props, deps) {
    const isFn = (0, $b06859765afdca70$export$226b3eccf92c9ed9).fun(props);
    const [[values], ref] = $8df965278a3bc58d$export$15786d483ab9f469(1, isFn ? props : [
        props
    ], isFn ? deps || [] : deps);
    return isFn || arguments.length == 2 ? [
        values,
        ref
    ] : values;
}
const $8df965278a3bc58d$var$initSpringRef = ()=>$8df965278a3bc58d$export$2471ae76e2946684();
const $8df965278a3bc58d$export$564bff9c23cad2ca = ()=>(0, $P551f.useState)($8df965278a3bc58d$var$initSpringRef)[0];
const $8df965278a3bc58d$export$ab73804b080feffc = (initial, props)=>{
    const springValue = (0, $b06859765afdca70$export$fe4300aa8eebea86)(()=>new $8df965278a3bc58d$export$5854d13427d5a954(initial, props));
    (0, $b06859765afdca70$export$392544347a18b6ea)(()=>()=>{
            springValue.stop();
        });
    return springValue;
};
function $8df965278a3bc58d$export$250279104b4672ed(length, propsArg, deps) {
    const propsFn = (0, $b06859765afdca70$export$226b3eccf92c9ed9).fun(propsArg) && propsArg;
    if (propsFn && !deps) deps = [];
    let reverse = true;
    let passedRef = undefined;
    const result = $8df965278a3bc58d$export$15786d483ab9f469(length, (i, ctrl)=>{
        const props = propsFn ? propsFn(i, ctrl) : propsArg;
        passedRef = props.ref;
        reverse = reverse && props.reverse;
        return props;
    }, deps || [
        {}
    ]);
    (0, $b06859765afdca70$export$700979bc83e7db82)(()=>{
        (0, $b06859765afdca70$export$79b2f7037acddd43)(result[1].current, (ctrl, i)=>{
            const parent = result[1].current[i + (reverse ? 1 : -1)];
            $8df965278a3bc58d$var$replaceRef(ctrl, passedRef);
            if (ctrl.ref) {
                if (parent) ctrl.update({
                    to: parent.springs
                });
                return;
            }
            if (parent) ctrl.start({
                to: parent.springs
            });
            else ctrl.start();
        });
    }, deps);
    if (propsFn || arguments.length == 3) {
        var _passedRef;
        const ref = (_passedRef = passedRef) != null ? _passedRef : result[1];
        ref["_getProps"] = (propsArg, ctrl, i)=>{
            const props = (0, $b06859765afdca70$export$226b3eccf92c9ed9).fun(propsArg) ? propsArg(i, ctrl) : propsArg;
            if (props) {
                const parent = ref.current[i + (props.reverse ? 1 : -1)];
                if (parent) props.to = parent.springs;
                return props;
            }
        };
        return result;
    }
    return result[0];
}
let $8df965278a3bc58d$var$TransitionPhase;
(function(TransitionPhase) {
    TransitionPhase["MOUNT"] = "mount";
    TransitionPhase["ENTER"] = "enter";
    TransitionPhase["UPDATE"] = "update";
    TransitionPhase["LEAVE"] = "leave";
})($8df965278a3bc58d$var$TransitionPhase || ($8df965278a3bc58d$var$TransitionPhase = {}));
function $8df965278a3bc58d$export$7b286972b8d8ccbf(data, props, deps) {
    const propsFn = (0, $b06859765afdca70$export$226b3eccf92c9ed9).fun(props) && props;
    const { reset: reset, sort: sort, trail: trail = 0, expires: expires = true, exitBeforeEnter: exitBeforeEnter = false, onDestroyed: onDestroyed, ref: propsRef, config: propsConfig } = propsFn ? propsFn() : props;
    const ref = (0, $P551f.useMemo)(()=>propsFn || arguments.length == 3 ? $8df965278a3bc58d$export$2471ae76e2946684() : void 0, []);
    const items = (0, $b06859765afdca70$export$45b10814cc054894)(data);
    const transitions = [];
    const usedTransitions = (0, $P551f.useRef)(null);
    const prevTransitions = reset ? null : usedTransitions.current;
    (0, $b06859765afdca70$export$700979bc83e7db82)(()=>{
        usedTransitions.current = transitions;
    });
    (0, $b06859765afdca70$export$392544347a18b6ea)(()=>{
        (0, $b06859765afdca70$export$79b2f7037acddd43)(transitions, (t)=>{
            ref == null || ref.add(t.ctrl);
            t.ctrl.ref = ref;
        });
        return ()=>{
            (0, $b06859765afdca70$export$79b2f7037acddd43)(usedTransitions.current, (t)=>{
                if (t.expired) clearTimeout(t.expirationId);
                $8df965278a3bc58d$var$detachRefs(t.ctrl, ref);
                t.ctrl.stop(true);
            });
        };
    });
    const keys = $8df965278a3bc58d$var$getKeys(items, propsFn ? propsFn() : props, prevTransitions);
    const expired = reset && usedTransitions.current || [];
    (0, $b06859765afdca70$export$700979bc83e7db82)(()=>(0, $b06859765afdca70$export$79b2f7037acddd43)(expired, ({ ctrl: ctrl, item: item, key: key })=>{
            $8df965278a3bc58d$var$detachRefs(ctrl, ref);
            $8df965278a3bc58d$var$callProp(onDestroyed, item, key);
        }));
    const reused = [];
    if (prevTransitions) (0, $b06859765afdca70$export$79b2f7037acddd43)(prevTransitions, (t, i)=>{
        if (t.expired) {
            clearTimeout(t.expirationId);
            expired.push(t);
        } else {
            i = reused[i] = keys.indexOf(t.key);
            if (~i) transitions[i] = t;
        }
    });
    (0, $b06859765afdca70$export$79b2f7037acddd43)(items, (item, i)=>{
        if (!transitions[i]) {
            transitions[i] = {
                key: keys[i],
                item: item,
                phase: $8df965278a3bc58d$var$TransitionPhase.MOUNT,
                ctrl: new $8df965278a3bc58d$export$bd0bf19f25da8474()
            };
            transitions[i].ctrl.item = item;
        }
    });
    if (reused.length) {
        let i = -1;
        const { leave: leave } = propsFn ? propsFn() : props;
        (0, $b06859765afdca70$export$79b2f7037acddd43)(reused, (keyIndex, prevIndex)=>{
            const t = prevTransitions[prevIndex];
            if (~keyIndex) {
                i = transitions.indexOf(t);
                transitions[i] = $8df965278a3bc58d$var$_extends({}, t, {
                    item: items[keyIndex]
                });
            } else if (leave) transitions.splice(++i, 0, t);
        });
    }
    if ((0, $b06859765afdca70$export$226b3eccf92c9ed9).fun(sort)) transitions.sort((a, b)=>sort(a.item, b.item));
    let delay = -trail;
    const forceUpdate = (0, $b06859765afdca70$export$91db9bc4f8ac944a)();
    const defaultProps = $8df965278a3bc58d$var$getDefaultProps(props);
    const changes = new Map();
    const exitingTransitions = (0, $P551f.useRef)(new Map());
    const forceChange = (0, $P551f.useRef)(false);
    (0, $b06859765afdca70$export$79b2f7037acddd43)(transitions, (t, i)=>{
        const key = t.key;
        const prevPhase = t.phase;
        const p = propsFn ? propsFn() : props;
        let to;
        let phase;
        let propsDelay = $8df965278a3bc58d$var$callProp(p.delay || 0, key);
        if (prevPhase == $8df965278a3bc58d$var$TransitionPhase.MOUNT) {
            to = p.enter;
            phase = $8df965278a3bc58d$var$TransitionPhase.ENTER;
        } else {
            const isLeave = keys.indexOf(key) < 0;
            if (prevPhase != $8df965278a3bc58d$var$TransitionPhase.LEAVE) {
                if (isLeave) {
                    to = p.leave;
                    phase = $8df965278a3bc58d$var$TransitionPhase.LEAVE;
                } else if (to = p.update) phase = $8df965278a3bc58d$var$TransitionPhase.UPDATE;
                else return;
            } else if (!isLeave) {
                to = p.enter;
                phase = $8df965278a3bc58d$var$TransitionPhase.ENTER;
            } else return;
        }
        to = $8df965278a3bc58d$var$callProp(to, t.item, i);
        to = (0, $b06859765afdca70$export$226b3eccf92c9ed9).obj(to) ? $8df965278a3bc58d$export$b971039a739bf227(to) : {
            to: to
        };
        if (!to.config) {
            const config = propsConfig || defaultProps.config;
            to.config = $8df965278a3bc58d$var$callProp(config, t.item, i, phase);
        }
        delay += trail;
        const payload = $8df965278a3bc58d$var$_extends({}, defaultProps, {
            delay: propsDelay + delay,
            ref: propsRef,
            immediate: p.immediate,
            reset: false
        }, to);
        if (phase == $8df965278a3bc58d$var$TransitionPhase.ENTER && (0, $b06859765afdca70$export$226b3eccf92c9ed9).und(payload.from)) {
            const _p = propsFn ? propsFn() : props;
            const from = (0, $b06859765afdca70$export$226b3eccf92c9ed9).und(_p.initial) || prevTransitions ? _p.from : _p.initial;
            payload.from = $8df965278a3bc58d$var$callProp(from, t.item, i);
        }
        const { onResolve: onResolve } = payload;
        payload.onResolve = (result)=>{
            $8df965278a3bc58d$var$callProp(onResolve, result);
            const transitions = usedTransitions.current;
            const t = transitions.find((t)=>t.key === key);
            if (!t) return;
            if (result.cancelled && t.phase != $8df965278a3bc58d$var$TransitionPhase.UPDATE) return;
            if (t.ctrl.idle) {
                const idle = transitions.every((t)=>t.ctrl.idle);
                if (t.phase == $8df965278a3bc58d$var$TransitionPhase.LEAVE) {
                    const expiry = $8df965278a3bc58d$var$callProp(expires, t.item);
                    if (expiry !== false) {
                        const expiryMs = expiry === true ? 0 : expiry;
                        t.expired = true;
                        if (!idle && expiryMs > 0) {
                            if (expiryMs <= 0x7fffffff) t.expirationId = setTimeout(forceUpdate, expiryMs);
                            return;
                        }
                    }
                }
                if (idle && transitions.some((t)=>t.expired)) {
                    exitingTransitions.current.delete(t);
                    if (exitBeforeEnter) forceChange.current = true;
                    forceUpdate();
                }
            }
        };
        const springs = $8df965278a3bc58d$var$getSprings(t.ctrl, payload);
        if (phase === $8df965278a3bc58d$var$TransitionPhase.LEAVE && exitBeforeEnter) exitingTransitions.current.set(t, {
            phase: phase,
            springs: springs,
            payload: payload
        });
        else changes.set(t, {
            phase: phase,
            springs: springs,
            payload: payload
        });
    });
    const context = (0, $P551f.useContext)($8df965278a3bc58d$export$f12a216ec50d2cf1);
    const prevContext = (0, $b06859765afdca70$export$ef7ad0c4e19d7fbf)(context);
    const hasContext = context !== prevContext && $8df965278a3bc58d$var$hasProps(context);
    (0, $b06859765afdca70$export$700979bc83e7db82)(()=>{
        if (hasContext) (0, $b06859765afdca70$export$79b2f7037acddd43)(transitions, (t)=>{
            t.ctrl.start({
                default: context
            });
        });
    }, [
        context
    ]);
    (0, $b06859765afdca70$export$79b2f7037acddd43)(changes, (_, t)=>{
        if (exitingTransitions.current.size) {
            const ind = transitions.findIndex((state)=>state.key === t.key);
            transitions.splice(ind, 1);
        }
    });
    (0, $b06859765afdca70$export$700979bc83e7db82)(()=>{
        (0, $b06859765afdca70$export$79b2f7037acddd43)(exitingTransitions.current.size ? exitingTransitions.current : changes, ({ phase: phase, payload: payload }, t)=>{
            const { ctrl: ctrl } = t;
            t.phase = phase;
            ref == null || ref.add(ctrl);
            if (hasContext && phase == $8df965278a3bc58d$var$TransitionPhase.ENTER) ctrl.start({
                default: context
            });
            if (payload) {
                $8df965278a3bc58d$var$replaceRef(ctrl, payload.ref);
                if ((ctrl.ref || ref) && !forceChange.current) ctrl.update(payload);
                else {
                    ctrl.start(payload);
                    if (forceChange.current) forceChange.current = false;
                }
            }
        });
    }, reset ? void 0 : deps);
    const renderTransitions = (render)=>$P551f.createElement($P551f.Fragment, null, transitions.map((t, i)=>{
            const { springs: springs } = changes.get(t) || t.ctrl;
            const elem = render($8df965278a3bc58d$var$_extends({}, springs), t.item, t, i);
            return elem && elem.type ? $P551f.createElement(elem.type, $8df965278a3bc58d$var$_extends({}, elem.props, {
                key: (0, $b06859765afdca70$export$226b3eccf92c9ed9).str(t.key) || (0, $b06859765afdca70$export$226b3eccf92c9ed9).num(t.key) ? t.key : t.ctrl.id,
                ref: elem.ref
            })) : elem;
        }));
    return ref ? [
        renderTransitions,
        ref
    ] : renderTransitions;
}
let $8df965278a3bc58d$var$nextKey = 1;
function $8df965278a3bc58d$var$getKeys(items, { key: key, keys: keys = key }, prevTransitions) {
    if (keys === null) {
        const reused = new Set();
        return items.map((item)=>{
            const t = prevTransitions && prevTransitions.find((t)=>t.item === item && t.phase !== $8df965278a3bc58d$var$TransitionPhase.LEAVE && !reused.has(t));
            if (t) {
                reused.add(t);
                return t.key;
            }
            return $8df965278a3bc58d$var$nextKey++;
        });
    }
    return (0, $b06859765afdca70$export$226b3eccf92c9ed9).und(keys) ? items : (0, $b06859765afdca70$export$226b3eccf92c9ed9).fun(keys) ? items.map(keys) : (0, $b06859765afdca70$export$45b10814cc054894)(keys);
}
const $8df965278a3bc58d$var$_excluded$5 = [
    "container"
];
const $8df965278a3bc58d$export$d928051c8cd740b = (_ref = {})=>{
    let { container: container } = _ref, springOptions = $8df965278a3bc58d$var$_objectWithoutPropertiesLoose(_ref, $8df965278a3bc58d$var$_excluded$5);
    const [scrollValues, api] = $8df965278a3bc58d$export$c4af9125706c4d30(()=>$8df965278a3bc58d$var$_extends({
            scrollX: 0,
            scrollY: 0,
            scrollXProgress: 0,
            scrollYProgress: 0
        }, springOptions), []);
    (0, $b06859765afdca70$export$700979bc83e7db82)(()=>{
        const cleanupScroll = (0, $b06859765afdca70$export$d4d89fd61e5416ee)(({ x: x, y: y })=>{
            api.start({
                scrollX: x.current,
                scrollXProgress: x.progress,
                scrollY: y.current,
                scrollYProgress: y.progress
            });
        }, {
            container: (container == null ? void 0 : container.current) || undefined
        });
        return ()=>{
            (0, $b06859765afdca70$export$79b2f7037acddd43)(Object.values(scrollValues), (value)=>value.stop());
            cleanupScroll();
        };
    }, []);
    return scrollValues;
};
const $8df965278a3bc58d$var$_excluded$4 = [
    "container"
];
const $8df965278a3bc58d$export$e8b771555dc4a003 = (_ref)=>{
    let { container: container } = _ref, springOptions = $8df965278a3bc58d$var$_objectWithoutPropertiesLoose(_ref, $8df965278a3bc58d$var$_excluded$4);
    const [sizeValues, api] = $8df965278a3bc58d$export$c4af9125706c4d30(()=>$8df965278a3bc58d$var$_extends({
            width: 0,
            height: 0
        }, springOptions), []);
    (0, $b06859765afdca70$export$700979bc83e7db82)(()=>{
        const cleanupScroll = (0, $b06859765afdca70$export$45b39e67d4ce4921)(({ width: width, height: height })=>{
            api.start({
                width: width,
                height: height,
                immediate: sizeValues.width.get() === 0 || sizeValues.height.get() === 0
            });
        }, {
            container: (container == null ? void 0 : container.current) || undefined
        });
        return ()=>{
            (0, $b06859765afdca70$export$79b2f7037acddd43)(Object.values(sizeValues), (value)=>value.stop());
            cleanupScroll();
        };
    }, []);
    return sizeValues;
};
const $8df965278a3bc58d$var$_excluded$3 = [
    "to",
    "from"
], $8df965278a3bc58d$var$_excluded2 = [
    "root",
    "once",
    "amount"
];
const $8df965278a3bc58d$var$defaultThresholdOptions = {
    any: 0,
    all: 1
};
function $8df965278a3bc58d$export$2f62ee6831462844(props, args) {
    const [isInView, setIsInView] = (0, $P551f.useState)(false);
    const ref = (0, $P551f.useRef)();
    const propsFn = (0, $b06859765afdca70$export$226b3eccf92c9ed9).fun(props) && props;
    const springsProps = propsFn ? propsFn() : {};
    const { to: to = {}, from: from = {} } = springsProps, restSpringProps = $8df965278a3bc58d$var$_objectWithoutPropertiesLoose(springsProps, $8df965278a3bc58d$var$_excluded$3);
    const intersectionArguments = propsFn ? args : props;
    const [springs, api] = $8df965278a3bc58d$export$c4af9125706c4d30(()=>$8df965278a3bc58d$var$_extends({
            from: from
        }, restSpringProps), []);
    (0, $b06859765afdca70$export$700979bc83e7db82)(()=>{
        const element = ref.current;
        const _ref = intersectionArguments != null ? intersectionArguments : {}, { root: root, once: once, amount: amount = "any" } = _ref, restArgs = $8df965278a3bc58d$var$_objectWithoutPropertiesLoose(_ref, $8df965278a3bc58d$var$_excluded2);
        if (!element || once && isInView || typeof IntersectionObserver === "undefined") return;
        const activeIntersections = new WeakMap();
        const onEnter = ()=>{
            if (to) api.start(to);
            setIsInView(true);
            const cleanup = ()=>{
                if (from) api.start(from);
                setIsInView(false);
            };
            return once ? undefined : cleanup;
        };
        const handleIntersection = (entries)=>{
            entries.forEach((entry)=>{
                const onLeave = activeIntersections.get(entry.target);
                if (entry.isIntersecting === Boolean(onLeave)) return;
                if (entry.isIntersecting) {
                    const newOnLeave = onEnter();
                    if ((0, $b06859765afdca70$export$226b3eccf92c9ed9).fun(newOnLeave)) activeIntersections.set(entry.target, newOnLeave);
                    else observer.unobserve(entry.target);
                } else if (onLeave) {
                    onLeave();
                    activeIntersections.delete(entry.target);
                }
            });
        };
        const observer = new IntersectionObserver(handleIntersection, $8df965278a3bc58d$var$_extends({
            root: root && root.current || undefined,
            threshold: typeof amount === "number" || Array.isArray(amount) ? amount : $8df965278a3bc58d$var$defaultThresholdOptions[amount]
        }, restArgs));
        observer.observe(element);
        return ()=>observer.unobserve(element);
    }, [
        intersectionArguments
    ]);
    if (propsFn) return [
        ref,
        springs
    ];
    return [
        ref,
        isInView
    ];
}
const $8df965278a3bc58d$var$_excluded$2 = [
    "children"
];
function $8df965278a3bc58d$export$a500e5b516cedfc(_ref) {
    let { children: children } = _ref, props = $8df965278a3bc58d$var$_objectWithoutPropertiesLoose(_ref, $8df965278a3bc58d$var$_excluded$2);
    return children($8df965278a3bc58d$export$c4af9125706c4d30(props));
}
const $8df965278a3bc58d$var$_excluded$1 = [
    "items",
    "children"
];
function $8df965278a3bc58d$export$3b8b9d47fbf8fd2b(_ref) {
    let { items: items, children: children } = _ref, props = $8df965278a3bc58d$var$_objectWithoutPropertiesLoose(_ref, $8df965278a3bc58d$var$_excluded$1);
    const trails = $8df965278a3bc58d$export$250279104b4672ed(items.length, props);
    return items.map((item, index)=>{
        const result = children(item, index);
        return (0, $b06859765afdca70$export$226b3eccf92c9ed9).fun(result) ? result(trails[index]) : result;
    });
}
const $8df965278a3bc58d$var$_excluded = [
    "items",
    "children"
];
function $8df965278a3bc58d$export$be58926105124dd4(_ref) {
    let { items: items, children: children } = _ref, props = $8df965278a3bc58d$var$_objectWithoutPropertiesLoose(_ref, $8df965278a3bc58d$var$_excluded);
    return $8df965278a3bc58d$export$7b286972b8d8ccbf(items, props)(children);
}
class $8df965278a3bc58d$export$b0cc4f9860136880 extends $8df965278a3bc58d$export$8229896f80e2495e {
    advance(_dt) {
        const value = this._get();
        const oldValue = this.get();
        if (!(0, $b06859765afdca70$export$248d38f6296296c5)(value, oldValue)) {
            (0, $1057aa8b0a5ee787$export$6b63995194a3a9e4)(this).setValue(value);
            this._onChange(value, this.idle);
        }
        if (!this.idle && $8df965278a3bc58d$var$checkIdle(this._active)) $8df965278a3bc58d$var$becomeIdle(this);
    }
    _get() {
        const inputs = (0, $b06859765afdca70$export$226b3eccf92c9ed9).arr(this.source) ? this.source.map((0, $b06859765afdca70$export$e37b7520edd66839)) : (0, $b06859765afdca70$export$45b10814cc054894)((0, $b06859765afdca70$export$e37b7520edd66839)(this.source));
        return this.calc(...inputs);
    }
    _start() {
        if (this.idle && !$8df965278a3bc58d$var$checkIdle(this._active)) {
            this.idle = false;
            (0, $b06859765afdca70$export$79b2f7037acddd43)((0, $1057aa8b0a5ee787$export$ccab2b64c5d440)(this), (node)=>{
                node.done = false;
            });
            if ((0, $b06859765afdca70$export$cceeabf822b64fc0).skipAnimation) {
                (0, $511d096570a914ae$export$27f233d61a9e2fa4).batchedUpdates(()=>this.advance());
                $8df965278a3bc58d$var$becomeIdle(this);
            } else (0, $b06859765afdca70$export$a57f5080a3bcc90a).start(this);
        }
    }
    _attach() {
        let priority = 1;
        (0, $b06859765afdca70$export$79b2f7037acddd43)((0, $b06859765afdca70$export$45b10814cc054894)(this.source), (source)=>{
            if ((0, $b06859765afdca70$export$57ea7e3a7f6280c7)(source)) (0, $b06859765afdca70$export$72d604e3f8d000a5)(source, this);
            if ($8df965278a3bc58d$var$isFrameValue(source)) {
                if (!source.idle) this._active.add(source);
                priority = Math.max(priority, source.priority + 1);
            }
        });
        this.priority = priority;
        this._start();
    }
    _detach() {
        (0, $b06859765afdca70$export$79b2f7037acddd43)((0, $b06859765afdca70$export$45b10814cc054894)(this.source), (source)=>{
            if ((0, $b06859765afdca70$export$57ea7e3a7f6280c7)(source)) (0, $b06859765afdca70$export$7a0eb830d336339b)(source, this);
        });
        this._active.clear();
        $8df965278a3bc58d$var$becomeIdle(this);
    }
    eventObserved(event) {
        if (event.type == "change") {
            if (event.idle) this.advance();
            else {
                this._active.add(event.parent);
                this._start();
            }
        } else if (event.type == "idle") this._active.delete(event.parent);
        else if (event.type == "priority") this.priority = (0, $b06859765afdca70$export$45b10814cc054894)(this.source).reduce((highest, parent)=>Math.max(highest, ($8df965278a3bc58d$var$isFrameValue(parent) ? parent.priority : 0) + 1), 0);
    }
    constructor(source, args){
        super();
        this.key = void 0;
        this.idle = true;
        this.calc = void 0;
        this._active = new Set();
        this.source = source;
        this.calc = (0, $b06859765afdca70$export$b12af43b97697ef5)(...args);
        const value = this._get();
        const nodeType = (0, $1057aa8b0a5ee787$export$e6b77ddbe47b132e)(value);
        (0, $1057aa8b0a5ee787$export$b553cb5b22b81b04)(this, nodeType.create(value));
    }
}
function $8df965278a3bc58d$var$isIdle(source) {
    return source.idle !== false;
}
function $8df965278a3bc58d$var$checkIdle(active) {
    return !active.size || Array.from(active).every($8df965278a3bc58d$var$isIdle);
}
function $8df965278a3bc58d$var$becomeIdle(self) {
    if (!self.idle) {
        self.idle = true;
        (0, $b06859765afdca70$export$79b2f7037acddd43)((0, $1057aa8b0a5ee787$export$ccab2b64c5d440)(self), (node)=>{
            node.done = true;
        });
        (0, $b06859765afdca70$export$31752c40a5fab62a)(self, {
            type: "idle",
            parent: self
        });
    }
}
const $8df965278a3bc58d$export$2c618a4308a30424 = (source, ...args)=>new $8df965278a3bc58d$export$b0cc4f9860136880(source, args);
const $8df965278a3bc58d$export$89e29e4ab65e70a9 = (source, ...args)=>((0, $b06859765afdca70$export$2abfcde8ae218ba8)(), new $8df965278a3bc58d$export$b0cc4f9860136880(source, args));
(0, $b06859765afdca70$export$cceeabf822b64fc0).assign({
    createStringInterpolator: $b06859765afdca70$export$4759a013d387347a,
    to: (source, args)=>new $8df965278a3bc58d$export$b0cc4f9860136880(source, args)
});
const $8df965278a3bc58d$export$722fbec263ad908a = (0, $b06859765afdca70$export$a57f5080a3bcc90a).advance;





function $d6ee01a8227ffa94$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $d6ee01a8227ffa94$var$_excluded$2 = [
    "style",
    "children",
    "scrollTop",
    "scrollLeft",
    "viewBox"
];
const $d6ee01a8227ffa94$var$isCustomPropRE = /^--/;
function $d6ee01a8227ffa94$var$dangerousStyleValue(name, value) {
    if (value == null || typeof value === "boolean" || value === "") return "";
    if (typeof value === "number" && value !== 0 && !$d6ee01a8227ffa94$var$isCustomPropRE.test(name) && !($d6ee01a8227ffa94$var$isUnitlessNumber.hasOwnProperty(name) && $d6ee01a8227ffa94$var$isUnitlessNumber[name])) return value + "px";
    return ("" + value).trim();
}
const $d6ee01a8227ffa94$var$attributeCache = {};
function $d6ee01a8227ffa94$var$applyAnimatedValues(instance, props) {
    if (!instance.nodeType || !instance.setAttribute) return false;
    const isFilterElement = instance.nodeName === "filter" || instance.parentNode && instance.parentNode.nodeName === "filter";
    const _ref = props, { style: style, children: children, scrollTop: scrollTop, scrollLeft: scrollLeft, viewBox: viewBox } = _ref, attributes = $d6ee01a8227ffa94$var$_objectWithoutPropertiesLoose(_ref, $d6ee01a8227ffa94$var$_excluded$2);
    const values = Object.values(attributes);
    const names = Object.keys(attributes).map((name)=>isFilterElement || instance.hasAttribute(name) ? name : $d6ee01a8227ffa94$var$attributeCache[name] || ($d6ee01a8227ffa94$var$attributeCache[name] = name.replace(/([A-Z])/g, (n)=>"-" + n.toLowerCase())));
    if (children !== void 0) instance.textContent = children;
    for(let name in style)if (style.hasOwnProperty(name)) {
        const value = $d6ee01a8227ffa94$var$dangerousStyleValue(name, style[name]);
        if ($d6ee01a8227ffa94$var$isCustomPropRE.test(name)) instance.style.setProperty(name, value);
        else instance.style[name] = value;
    }
    names.forEach((name, i)=>{
        instance.setAttribute(name, values[i]);
    });
    if (scrollTop !== void 0) instance.scrollTop = scrollTop;
    if (scrollLeft !== void 0) instance.scrollLeft = scrollLeft;
    if (viewBox !== void 0) instance.setAttribute("viewBox", viewBox);
}
let $d6ee01a8227ffa94$var$isUnitlessNumber = {
    animationIterationCount: true,
    borderImageOutset: true,
    borderImageSlice: true,
    borderImageWidth: true,
    boxFlex: true,
    boxFlexGroup: true,
    boxOrdinalGroup: true,
    columnCount: true,
    columns: true,
    flex: true,
    flexGrow: true,
    flexPositive: true,
    flexShrink: true,
    flexNegative: true,
    flexOrder: true,
    gridRow: true,
    gridRowEnd: true,
    gridRowSpan: true,
    gridRowStart: true,
    gridColumn: true,
    gridColumnEnd: true,
    gridColumnSpan: true,
    gridColumnStart: true,
    fontWeight: true,
    lineClamp: true,
    lineHeight: true,
    opacity: true,
    order: true,
    orphans: true,
    tabSize: true,
    widows: true,
    zIndex: true,
    zoom: true,
    fillOpacity: true,
    floodOpacity: true,
    stopOpacity: true,
    strokeDasharray: true,
    strokeDashoffset: true,
    strokeMiterlimit: true,
    strokeOpacity: true,
    strokeWidth: true
};
const $d6ee01a8227ffa94$var$prefixKey = (prefix, key)=>prefix + key.charAt(0).toUpperCase() + key.substring(1);
const $d6ee01a8227ffa94$var$prefixes = [
    "Webkit",
    "Ms",
    "Moz",
    "O"
];
$d6ee01a8227ffa94$var$isUnitlessNumber = Object.keys($d6ee01a8227ffa94$var$isUnitlessNumber).reduce((acc, prop)=>{
    $d6ee01a8227ffa94$var$prefixes.forEach((prefix)=>acc[$d6ee01a8227ffa94$var$prefixKey(prefix, prop)] = acc[prop]);
    return acc;
}, $d6ee01a8227ffa94$var$isUnitlessNumber);
const $d6ee01a8227ffa94$var$_excluded$1 = [
    "x",
    "y",
    "z"
];
const $d6ee01a8227ffa94$var$domTransforms = /^(matrix|translate|scale|rotate|skew)/;
const $d6ee01a8227ffa94$var$pxTransforms = /^(translate)/;
const $d6ee01a8227ffa94$var$degTransforms = /^(rotate|skew)/;
const $d6ee01a8227ffa94$var$addUnit = (value, unit)=>(0, $b06859765afdca70$export$226b3eccf92c9ed9).num(value) && value !== 0 ? value + unit : value;
const $d6ee01a8227ffa94$var$isValueIdentity = (value, id)=>(0, $b06859765afdca70$export$226b3eccf92c9ed9).arr(value) ? value.every((v)=>$d6ee01a8227ffa94$var$isValueIdentity(v, id)) : (0, $b06859765afdca70$export$226b3eccf92c9ed9).num(value) ? value === id : parseFloat(value) === id;
class $d6ee01a8227ffa94$var$AnimatedStyle extends (0, $1057aa8b0a5ee787$export$f1b0b9e366a6e2d4) {
    constructor(_ref){
        let { x: x, y: y, z: z } = _ref, style = $d6ee01a8227ffa94$var$_objectWithoutPropertiesLoose(_ref, $d6ee01a8227ffa94$var$_excluded$1);
        const inputs = [];
        const transforms = [];
        if (x || y || z) {
            inputs.push([
                x || 0,
                y || 0,
                z || 0
            ]);
            transforms.push((xyz)=>[
                    `translate3d(${xyz.map((v)=>$d6ee01a8227ffa94$var$addUnit(v, "px")).join(",")})`,
                    $d6ee01a8227ffa94$var$isValueIdentity(xyz, 0)
                ]);
        }
        (0, $b06859765afdca70$export$f4c6fe153f5a944e)(style, (value, key)=>{
            if (key === "transform") {
                inputs.push([
                    value || ""
                ]);
                transforms.push((transform)=>[
                        transform,
                        transform === ""
                    ]);
            } else if ($d6ee01a8227ffa94$var$domTransforms.test(key)) {
                delete style[key];
                if ((0, $b06859765afdca70$export$226b3eccf92c9ed9).und(value)) return;
                const unit = $d6ee01a8227ffa94$var$pxTransforms.test(key) ? "px" : $d6ee01a8227ffa94$var$degTransforms.test(key) ? "deg" : "";
                inputs.push((0, $b06859765afdca70$export$45b10814cc054894)(value));
                transforms.push(key === "rotate3d" ? ([x, y, z, deg])=>[
                        `rotate3d(${x},${y},${z},${$d6ee01a8227ffa94$var$addUnit(deg, unit)})`,
                        $d6ee01a8227ffa94$var$isValueIdentity(deg, 0)
                    ] : (input)=>[
                        `${key}(${input.map((v)=>$d6ee01a8227ffa94$var$addUnit(v, unit)).join(",")})`,
                        $d6ee01a8227ffa94$var$isValueIdentity(input, key.startsWith("scale") ? 1 : 0)
                    ]);
            }
        });
        if (inputs.length) style.transform = new $d6ee01a8227ffa94$var$FluidTransform(inputs, transforms);
        super(style);
    }
}
class $d6ee01a8227ffa94$var$FluidTransform extends (0, $b06859765afdca70$export$aff8e1ac1a016a2) {
    get() {
        return this._value || (this._value = this._get());
    }
    _get() {
        let transform = "";
        let identity = true;
        (0, $b06859765afdca70$export$79b2f7037acddd43)(this.inputs, (input, i)=>{
            const arg1 = (0, $b06859765afdca70$export$e37b7520edd66839)(input[0]);
            const [t, id] = this.transforms[i]((0, $b06859765afdca70$export$226b3eccf92c9ed9).arr(arg1) ? arg1 : input.map((0, $b06859765afdca70$export$e37b7520edd66839)));
            transform += " " + t;
            identity = identity && id;
        });
        return identity ? "none" : transform;
    }
    observerAdded(count) {
        if (count == 1) (0, $b06859765afdca70$export$79b2f7037acddd43)(this.inputs, (input)=>(0, $b06859765afdca70$export$79b2f7037acddd43)(input, (value)=>(0, $b06859765afdca70$export$57ea7e3a7f6280c7)(value) && (0, $b06859765afdca70$export$72d604e3f8d000a5)(value, this)));
    }
    observerRemoved(count) {
        if (count == 0) (0, $b06859765afdca70$export$79b2f7037acddd43)(this.inputs, (input)=>(0, $b06859765afdca70$export$79b2f7037acddd43)(input, (value)=>(0, $b06859765afdca70$export$57ea7e3a7f6280c7)(value) && (0, $b06859765afdca70$export$7a0eb830d336339b)(value, this)));
    }
    eventObserved(event) {
        if (event.type == "change") this._value = null;
        (0, $b06859765afdca70$export$31752c40a5fab62a)(this, event);
    }
    constructor(inputs, transforms){
        super();
        this._value = null;
        this.inputs = inputs;
        this.transforms = transforms;
    }
}
const $d6ee01a8227ffa94$var$primitives = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
const $d6ee01a8227ffa94$var$_excluded = [
    "scrollTop",
    "scrollLeft"
];
(0, $b06859765afdca70$export$cceeabf822b64fc0).assign({
    batchedUpdates: (0, $dcf5062905338935$exports.unstable_batchedUpdates),
    createStringInterpolator: $b06859765afdca70$export$4759a013d387347a,
    colors: $b06859765afdca70$export$8f45430ccf837300
});
const $d6ee01a8227ffa94$var$host = (0, $1057aa8b0a5ee787$export$4ee5c78f6dcbcef)($d6ee01a8227ffa94$var$primitives, {
    applyAnimatedValues: $d6ee01a8227ffa94$var$applyAnimatedValues,
    createAnimatedStyle: (style)=>new $d6ee01a8227ffa94$var$AnimatedStyle(style),
    getComponentProps: (_ref)=>{
        let props = $d6ee01a8227ffa94$var$_objectWithoutPropertiesLoose(_ref, $d6ee01a8227ffa94$var$_excluded);
        return props;
    }
});
const $d6ee01a8227ffa94$export$407448d2b89b1813 = $d6ee01a8227ffa94$var$host.animated;



var $P551f = parcelRequire("P551f");



parcelRequire("P551f");
const $8d625ccbe854106b$var$SvgClearIcon = (props)=>/*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("svg", (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18ZM8.464 9.879A1 1 0 1 1 9.88 8.464L12 10.586l2.121-2.122a1 1 0 1 1 1.415 1.415L13.414 12l2.122 2.121a1 1 0 1 1-1.415 1.415L12 13.414l-2.121 2.122a1 1 0 1 1-1.415-1.415L10.586 12 8.464 9.879Z",
            fill: "currentcolor"
        })
    }));
var $8d625ccbe854106b$export$2e2bcd8739ae039 = $8d625ccbe854106b$var$SvgClearIcon;










var $P551f = parcelRequire("P551f");
var $5ff98f92f4393e39$export$82e9f45cca5ba907;
$5ff98f92f4393e39$export$82e9f45cca5ba907 = `_3Ci-sW_prefix`;


const $07528ff3ec4308c1$var$AnimatedPrefix = ({ children: children, isVisible: isVisible })=>{
    const [domReady, setDomReady] = (0, $P551f.useState)(false);
    const elementRef = (0, $P551f.useRef)(null);
    // Get target width for the children
    const getTargetWidth = (0, $P551f.useCallback)(()=>{
        var _elementRef_current;
        return isVisible ? (_elementRef_current = elementRef.current) === null || _elementRef_current === void 0 ? void 0 : _elementRef_current.getBoundingClientRect().width : 0;
    }, [
        isVisible
    ]);
    const [animation, api] = (0, $8df965278a3bc58d$export$c4af9125706c4d30)(()=>({
            width: getTargetWidth(),
            config: (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, (0, $8df965278a3bc58d$export$e506a1d27d1eaa20).default), {
                clamp: true
            })
        }), [
        getTargetWidth,
        domReady
    ]);
    (0, $b06859765afdca70$export$700979bc83e7db82)(()=>{
        const { current: current } = elementRef;
        setDomReady(true);
        const cleanup = current && (0, $b06859765afdca70$export$45b39e67d4ce4921)(()=>{
            api.start({
                width: getTargetWidth()
            });
        }, {
            container: current
        });
        return ()=>{
            // Stop animation before cleanup
            api.stop();
            cleanup === null || cleanup === void 0 ? void 0 : cleanup();
        };
    }, [
        api,
        getTargetWidth
    ]);
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $d6ee01a8227ffa94$export$407448d2b89b1813).div, {
        className: $5ff98f92f4393e39$export$82e9f45cca5ba907,
        style: animation,
        "data-testid": "prefix",
        children: /*#__PURE__*/ (0, $P551f.cloneElement)(children, {
            ref: elementRef,
            isVisible: isVisible
        })
    });
};
var $07528ff3ec4308c1$export$2e2bcd8739ae039 = $07528ff3ec4308c1$var$AnimatedPrefix;





var $P551f = parcelRequire("P551f");



// Importing from a ".js" file is a workaround for Node.js "ES Modules"
// importing system which is even uncapable of importing "*.json" files.
// This file is a workaround for a bug in web browsers' "native"
// ES6 importing system which is uncapable of importing "*.json" files.
// https://github.com/catamphetamine/libphonenumber-js/issues/239
var $4b3438e9ed9332db$export$2e2bcd8739ae039 = {
    "version": 4,
    "country_calling_codes": {
        "1": [
            "US",
            "AG",
            "AI",
            "AS",
            "BB",
            "BM",
            "BS",
            "CA",
            "DM",
            "DO",
            "GD",
            "GU",
            "JM",
            "KN",
            "KY",
            "LC",
            "MP",
            "MS",
            "PR",
            "SX",
            "TC",
            "TT",
            "VC",
            "VG",
            "VI"
        ],
        "7": [
            "RU",
            "KZ"
        ],
        "20": [
            "EG"
        ],
        "27": [
            "ZA"
        ],
        "30": [
            "GR"
        ],
        "31": [
            "NL"
        ],
        "32": [
            "BE"
        ],
        "33": [
            "FR"
        ],
        "34": [
            "ES"
        ],
        "36": [
            "HU"
        ],
        "39": [
            "IT",
            "VA"
        ],
        "40": [
            "RO"
        ],
        "41": [
            "CH"
        ],
        "43": [
            "AT"
        ],
        "44": [
            "GB",
            "GG",
            "IM",
            "JE"
        ],
        "45": [
            "DK"
        ],
        "46": [
            "SE"
        ],
        "47": [
            "NO",
            "SJ"
        ],
        "48": [
            "PL"
        ],
        "49": [
            "DE"
        ],
        "51": [
            "PE"
        ],
        "52": [
            "MX"
        ],
        "53": [
            "CU"
        ],
        "54": [
            "AR"
        ],
        "55": [
            "BR"
        ],
        "56": [
            "CL"
        ],
        "57": [
            "CO"
        ],
        "58": [
            "VE"
        ],
        "60": [
            "MY"
        ],
        "61": [
            "AU",
            "CC",
            "CX"
        ],
        "62": [
            "ID"
        ],
        "63": [
            "PH"
        ],
        "64": [
            "NZ"
        ],
        "65": [
            "SG"
        ],
        "66": [
            "TH"
        ],
        "81": [
            "JP"
        ],
        "82": [
            "KR"
        ],
        "84": [
            "VN"
        ],
        "86": [
            "CN"
        ],
        "90": [
            "TR"
        ],
        "91": [
            "IN"
        ],
        "92": [
            "PK"
        ],
        "93": [
            "AF"
        ],
        "94": [
            "LK"
        ],
        "95": [
            "MM"
        ],
        "98": [
            "IR"
        ],
        "211": [
            "SS"
        ],
        "212": [
            "MA",
            "EH"
        ],
        "213": [
            "DZ"
        ],
        "216": [
            "TN"
        ],
        "218": [
            "LY"
        ],
        "220": [
            "GM"
        ],
        "221": [
            "SN"
        ],
        "222": [
            "MR"
        ],
        "223": [
            "ML"
        ],
        "224": [
            "GN"
        ],
        "225": [
            "CI"
        ],
        "226": [
            "BF"
        ],
        "227": [
            "NE"
        ],
        "228": [
            "TG"
        ],
        "229": [
            "BJ"
        ],
        "230": [
            "MU"
        ],
        "231": [
            "LR"
        ],
        "232": [
            "SL"
        ],
        "233": [
            "GH"
        ],
        "234": [
            "NG"
        ],
        "235": [
            "TD"
        ],
        "236": [
            "CF"
        ],
        "237": [
            "CM"
        ],
        "238": [
            "CV"
        ],
        "239": [
            "ST"
        ],
        "240": [
            "GQ"
        ],
        "241": [
            "GA"
        ],
        "242": [
            "CG"
        ],
        "243": [
            "CD"
        ],
        "244": [
            "AO"
        ],
        "245": [
            "GW"
        ],
        "246": [
            "IO"
        ],
        "247": [
            "AC"
        ],
        "248": [
            "SC"
        ],
        "249": [
            "SD"
        ],
        "250": [
            "RW"
        ],
        "251": [
            "ET"
        ],
        "252": [
            "SO"
        ],
        "253": [
            "DJ"
        ],
        "254": [
            "KE"
        ],
        "255": [
            "TZ"
        ],
        "256": [
            "UG"
        ],
        "257": [
            "BI"
        ],
        "258": [
            "MZ"
        ],
        "260": [
            "ZM"
        ],
        "261": [
            "MG"
        ],
        "262": [
            "RE",
            "YT"
        ],
        "263": [
            "ZW"
        ],
        "264": [
            "NA"
        ],
        "265": [
            "MW"
        ],
        "266": [
            "LS"
        ],
        "267": [
            "BW"
        ],
        "268": [
            "SZ"
        ],
        "269": [
            "KM"
        ],
        "290": [
            "SH",
            "TA"
        ],
        "291": [
            "ER"
        ],
        "297": [
            "AW"
        ],
        "298": [
            "FO"
        ],
        "299": [
            "GL"
        ],
        "350": [
            "GI"
        ],
        "351": [
            "PT"
        ],
        "352": [
            "LU"
        ],
        "353": [
            "IE"
        ],
        "354": [
            "IS"
        ],
        "355": [
            "AL"
        ],
        "356": [
            "MT"
        ],
        "357": [
            "CY"
        ],
        "358": [
            "FI",
            "AX"
        ],
        "359": [
            "BG"
        ],
        "370": [
            "LT"
        ],
        "371": [
            "LV"
        ],
        "372": [
            "EE"
        ],
        "373": [
            "MD"
        ],
        "374": [
            "AM"
        ],
        "375": [
            "BY"
        ],
        "376": [
            "AD"
        ],
        "377": [
            "MC"
        ],
        "378": [
            "SM"
        ],
        "380": [
            "UA"
        ],
        "381": [
            "RS"
        ],
        "382": [
            "ME"
        ],
        "383": [
            "XK"
        ],
        "385": [
            "HR"
        ],
        "386": [
            "SI"
        ],
        "387": [
            "BA"
        ],
        "389": [
            "MK"
        ],
        "420": [
            "CZ"
        ],
        "421": [
            "SK"
        ],
        "423": [
            "LI"
        ],
        "500": [
            "FK"
        ],
        "501": [
            "BZ"
        ],
        "502": [
            "GT"
        ],
        "503": [
            "SV"
        ],
        "504": [
            "HN"
        ],
        "505": [
            "NI"
        ],
        "506": [
            "CR"
        ],
        "507": [
            "PA"
        ],
        "508": [
            "PM"
        ],
        "509": [
            "HT"
        ],
        "590": [
            "GP",
            "BL",
            "MF"
        ],
        "591": [
            "BO"
        ],
        "592": [
            "GY"
        ],
        "593": [
            "EC"
        ],
        "594": [
            "GF"
        ],
        "595": [
            "PY"
        ],
        "596": [
            "MQ"
        ],
        "597": [
            "SR"
        ],
        "598": [
            "UY"
        ],
        "599": [
            "CW",
            "BQ"
        ],
        "670": [
            "TL"
        ],
        "672": [
            "NF"
        ],
        "673": [
            "BN"
        ],
        "674": [
            "NR"
        ],
        "675": [
            "PG"
        ],
        "676": [
            "TO"
        ],
        "677": [
            "SB"
        ],
        "678": [
            "VU"
        ],
        "679": [
            "FJ"
        ],
        "680": [
            "PW"
        ],
        "681": [
            "WF"
        ],
        "682": [
            "CK"
        ],
        "683": [
            "NU"
        ],
        "685": [
            "WS"
        ],
        "686": [
            "KI"
        ],
        "687": [
            "NC"
        ],
        "688": [
            "TV"
        ],
        "689": [
            "PF"
        ],
        "690": [
            "TK"
        ],
        "691": [
            "FM"
        ],
        "692": [
            "MH"
        ],
        "850": [
            "KP"
        ],
        "852": [
            "HK"
        ],
        "853": [
            "MO"
        ],
        "855": [
            "KH"
        ],
        "856": [
            "LA"
        ],
        "880": [
            "BD"
        ],
        "886": [
            "TW"
        ],
        "960": [
            "MV"
        ],
        "961": [
            "LB"
        ],
        "962": [
            "JO"
        ],
        "963": [
            "SY"
        ],
        "964": [
            "IQ"
        ],
        "965": [
            "KW"
        ],
        "966": [
            "SA"
        ],
        "967": [
            "YE"
        ],
        "968": [
            "OM"
        ],
        "970": [
            "PS"
        ],
        "971": [
            "AE"
        ],
        "972": [
            "IL"
        ],
        "973": [
            "BH"
        ],
        "974": [
            "QA"
        ],
        "975": [
            "BT"
        ],
        "976": [
            "MN"
        ],
        "977": [
            "NP"
        ],
        "992": [
            "TJ"
        ],
        "993": [
            "TM"
        ],
        "994": [
            "AZ"
        ],
        "995": [
            "GE"
        ],
        "996": [
            "KG"
        ],
        "998": [
            "UZ"
        ]
    },
    "countries": {
        "AC": [
            "247",
            "00",
            "(?:[01589]\\d|[46])\\d{4}",
            [
                5,
                6
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "4\\d{4}",
                    [
                        5
                    ]
                ]
            ]
        ],
        "AD": [
            "376",
            "00",
            "(?:1|6\\d)\\d{7}|[135-9]\\d{5}",
            [
                6,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "[135-9]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "690\\d{6}|[356]\\d{5}",
                    [
                        6,
                        9
                    ]
                ]
            ]
        ],
        "AE": [
            "971",
            "00",
            "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{2,9})",
                    "$1 $2",
                    [
                        "60|8"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[236]|[479][2-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[479]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "5[024-68]\\d{7}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "AF": [
            "93",
            "00",
            "[2-7]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "7\\d{8}"
                ]
            ]
        ],
        "AG": [
            "1",
            "011",
            "(?:268|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([457]\\d{6})$|1",
            "268$1",
            0,
            "268",
            [
                0,
                [
                    "268(?:464|7(?:1[3-9]|[28]\\d|3[0246]|64|7[0-689]))\\d{4}"
                ]
            ]
        ],
        "AI": [
            "1",
            "011",
            "(?:264|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2457]\\d{6})$|1",
            "264$1",
            0,
            "264",
            [
                0,
                [
                    "264(?:235|4(?:69|76)|5(?:3[6-9]|8[1-4])|7(?:29|72))\\d{4}"
                ]
            ]
        ],
        "AL": [
            "355",
            "00",
            "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3,4})",
                    "$1 $2",
                    [
                        "80|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "4[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2358][2-5]|4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[23578]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "6(?:[78][2-9]|9\\d)\\d{6}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "AM": [
            "374",
            "00",
            "(?:[1-489]\\d|55|60|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]0"
                    ],
                    "0 $1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "2|3[12]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "1|47"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[3-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:33|4[1349]|55|77|88|9[13-9])\\d{6}"
                ]
            ]
        ],
        "AO": [
            "244",
            "00",
            "[29]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[29]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "9[1-59]\\d{7}"
                ]
            ]
        ],
        "AR": [
            "54",
            "00",
            "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}",
            [
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{2})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])",
                        "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)",
                        "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                        "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "1"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[68]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[23]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d)(\\d{4})(\\d{2})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "9(?:2[2-469]|3[3-578])",
                        "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))",
                        "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)",
                        "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                        "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ],
                [
                    "(\\d)(\\d{2})(\\d{4})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "91"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1-$2-$3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "9"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ]
            ],
            "0",
            0,
            "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?",
            "9$1",
            0,
            0,
            [
                0,
                [
                    "93(?:7(?:1[15]|81)[46]|8(?:(?:21|4[16]|69|9[12])[46]|88[013-9]))\\d{5}|9(?:29(?:54|66)|3(?:7(?:55|77)|865))[2-8]\\d{5}|9(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|473|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|9(?:2(?:284|3(?:02|23)|657|920)|3(?:4(?:8[27]|92)|541|878))[2-7]\\d{5}|9(?:2(?:(?:26|62)2|320|477|9(?:42|83))|3(?:329|4(?:[47]6|62|89)|564))[2-6]\\d{5}|(?:675\\d|9(?:11[1-8]\\d|2(?:2(?:0[45]|1[2-6]|3[3-6])|3(?:[06]4|7[45])|494|6(?:04|1[2-8]|[36][45]|4[3-6])|80[45]|9(?:[17][4-6]|[48][45]|9[3-6]))|3(?:364|4(?:1[2-8]|[235][4-6]|84)|5(?:1[2-9]|[38][4-6])|6(?:2[45]|44)|7[069][45]|8(?:0[45]|[17][2-6]|3[4-6]|[58][3-6]))))\\d{6}|92(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|475|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|9(?:2(?:2(?:57|81)|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|71)|5(?:25|37|4[347]|71)|7(?:18|5[17])))[3-6]\\d{5}|9(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[03-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[145]|4[13]|5[468]|7[2-5]|8[26])|8(?:2[5-7]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}"
                ]
            ]
        ],
        "AS": [
            "1",
            "011",
            "(?:[58]\\d\\d|684|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([267]\\d{6})$|1",
            "684$1",
            0,
            "684",
            [
                0,
                [
                    "684(?:2(?:48|5[2468]|7[26])|7(?:3[13]|70|82))\\d{4}"
                ]
            ]
        ],
        "AT": [
            "43",
            "00",
            "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d)(\\d{3,12})",
                    "$1 $2",
                    [
                        "1(?:11|[2-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})",
                    "$1 $2",
                    [
                        "517"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,5})",
                    "$1 $2",
                    [
                        "5[079]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,10})",
                    "$1 $2",
                    [
                        "(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,9})",
                    "$1 $2",
                    [
                        "[2-467]|5[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4,7})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "6(?:5[0-3579]|6[013-9]|[7-9]\\d)\\d{4,10}",
                    [
                        7,
                        8,
                        9,
                        10,
                        11,
                        12,
                        13
                    ]
                ]
            ]
        ],
        "AU": [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1 $2",
                    [
                        "16"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "16"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "14|4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2378]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1(?:30|[89])"
                    ]
                ]
            ],
            "0",
            0,
            "(183[12])|0",
            0,
            0,
            0,
            [
                0,
                [
                    "4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-26-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
                    [
                        9
                    ]
                ]
            ],
            "0011"
        ],
        "AW": [
            "297",
            "00",
            "(?:[25-79]\\d\\d|800)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[25-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:290|5[69]\\d|6(?:[03]0|22|4[0-2]|[69]\\d)|7(?:[34]\\d|7[07])|9(?:6[45]|9[4-8]))\\d{4}"
                ]
            ]
        ],
        "AX": [
            "358",
            "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
            "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            "18",
            [
                0,
                [
                    "4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}",
                    [
                        6,
                        7,
                        8,
                        9,
                        10
                    ]
                ]
            ],
            "00"
        ],
        "AZ": [
            "994",
            "00",
            "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[28]|2|365|46",
                        "1[28]|2|365[45]|46",
                        "1[28]|2|365(?:4|5[02])|46"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[13-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "36554\\d{4}|(?:[16]0|4[04]|5[015]|7[07]|99)\\d{7}"
                ]
            ]
        ],
        "BA": [
            "387",
            "00",
            "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6[1-3]|[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2-$3",
                    [
                        "[3-5]|6[56]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "6040\\d{5}|6(?:03|[1-356]|44|7\\d)\\d{6}"
                ]
            ]
        ],
        "BB": [
            "1",
            "011",
            "(?:246|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "246$1",
            0,
            "246",
            [
                0,
                [
                    "246(?:(?:2(?:[3568]\\d|4[0-57-9])|3(?:5[2-9]|6[0-6])|4(?:46|5\\d)|69[5-7]|8(?:[2-5]\\d|83))\\d|52(?:1[147]|20))\\d{3}"
                ]
            ]
        ],
        "BD": [
            "880",
            "00",
            "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1-$2",
                    [
                        "31[5-8]|[459]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1-$2",
                    [
                        "3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,6})",
                    "$1-$2",
                    [
                        "[13-9]|22"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{7,8})",
                    "$1-$2",
                    [
                        "2"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:1[13-9]\\d|644)\\d{7}|(?:3[78]|44|66)[02-9]\\d{7}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "BE": [
            "32",
            "00",
            "4\\d{8}|[1-9]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:80|9)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[239]|4[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[15-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "4"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "4[5-9]\\d{7}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "BF": [
            "226",
            "00",
            "[025-7]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[025-7]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:0[1-35-7]|5[0-8]|[67]\\d)\\d{6}"
                ]
            ]
        ],
        "BG": [
            "359",
            "00",
            "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}",
            [
                6,
                7,
                8,
                9,
                12
            ],
            [
                [
                    "(\\d)(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "43[1-6]|70[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:70|8)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "43[1-7]|7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[48]|9[08]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:43[07-9]|99[69]\\d)\\d{5}|(?:8[7-9]|98)\\d{7}",
                    [
                        8,
                        9
                    ]
                ]
            ]
        ],
        "BH": [
            "973",
            "00",
            "[136-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[13679]|8[02-4679]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:3(?:[0-79]\\d|8[0-57-9])\\d|6(?:3(?:00|33|6[16])|441|6(?:3[03-9]|[69]\\d|7[0-6])))\\d{4}"
                ]
            ]
        ],
        "BI": [
            "257",
            "00",
            "(?:[267]\\d|31)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2367]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:29|[67][125-9])\\d{6}"
                ]
            ]
        ],
        "BJ": [
            "229",
            "00",
            "[24-689]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24-689]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:4[0-6]|[56]\\d|9[013-9])\\d{6}"
                ]
            ]
        ],
        "BL": [
            "590",
            "00",
            "590\\d{6}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"
                ]
            ]
        ],
        "BM": [
            "1",
            "011",
            "(?:441|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "441$1",
            0,
            "441",
            [
                0,
                [
                    "441(?:[2378]\\d|5[0-39]|92)\\d{5}"
                ]
            ]
        ],
        "BN": [
            "673",
            "00",
            "[2-578]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-578]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:22[89]|[78]\\d\\d)\\d{4}"
                ]
            ]
        ],
        "BO": [
            "591",
            "00(?:1\\d)?",
            "(?:[2-467]\\d\\d|8001)\\d{5}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "[23]|4[46]"
                    ]
                ],
                [
                    "(\\d{8})",
                    "$1",
                    [
                        "[67]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            "0",
            0,
            "0(1\\d)?",
            0,
            0,
            0,
            [
                0,
                [
                    "[67]\\d{7}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "BQ": [
            "599",
            "00",
            "(?:[34]1|7\\d)\\d{5}",
            [
                7
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "[347]",
            [
                0,
                [
                    "(?:31(?:8[14-8]|9[14578])|416[14-9]|7(?:0[01]|7[07]|8\\d|9[056])\\d)\\d{3}"
                ]
            ]
        ],
        "BR": [
            "55",
            "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)",
            "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}",
            [
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "300|4(?:0[02]|37)",
                        "4(?:02|37)0|[34]00"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "(?:[358]|90)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{2})(\\d{5})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[16][1-9]|[2-57-9]"
                    ],
                    "($1)"
                ]
            ],
            "0",
            0,
            "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?",
            "$2",
            0,
            0,
            [
                0,
                [
                    "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])(?:7|9\\d)\\d{7}",
                    [
                        10,
                        11
                    ]
                ]
            ]
        ],
        "BS": [
            "1",
            "011",
            "(?:242|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([3-8]\\d{6})$|1",
            "242$1",
            0,
            "242",
            [
                0,
                [
                    "242(?:3(?:5[79]|7[56]|95)|4(?:[23][1-9]|4[1-35-9]|5[1-8]|6[2-8]|7\\d|81)|5(?:2[45]|3[35]|44|5[1-46-9]|65|77)|6[34]6|7(?:27|38)|8(?:0[1-9]|1[02-9]|2\\d|[89]9))\\d{4}"
                ]
            ]
        ],
        "BT": [
            "975",
            "00",
            "[17]\\d{7}|[2-8]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-68]|7[246]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[67]|7"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:1[67]|77)\\d{6}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "BW": [
            "267",
            "00",
            "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "90"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[24-6]|3[15-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[37]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:321|7[1-8]\\d)\\d{5}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "BY": [
            "375",
            "810",
            "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "8 $1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "800"
                    ],
                    "8 $1"
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{3})",
                    "$1 $2-$3",
                    [
                        "1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])",
                        "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "1(?:[56]|7[467])|2[1-3]"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[1-4]"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "8 $1"
                ]
            ],
            "8",
            0,
            "0|80?",
            0,
            0,
            0,
            [
                0,
                [
                    "(?:2(?:5[5-79]|9[1-9])|(?:33|44)\\d)\\d{6}",
                    [
                        9
                    ]
                ]
            ],
            "8~10"
        ],
        "BZ": [
            "501",
            "00",
            "(?:0800\\d|[2-8])\\d{6}",
            [
                7,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[2-8]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})(\\d{3})",
                    "$1-$2-$3-$4",
                    [
                        "0"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "6[0-35-7]\\d{5}",
                    [
                        7
                    ]
                ]
            ]
        ],
        "CA": [
            "1",
            "011",
            "(?:[2-8]\\d|90)\\d{8}|3\\d{6}",
            [
                7,
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "CC": [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",
            [
                6,
                7,
                8,
                9,
                10,
                12
            ],
            0,
            "0",
            0,
            "([59]\\d{7})$|0",
            "8$1",
            0,
            0,
            [
                0,
                [
                    "4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-26-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
                    [
                        9
                    ]
                ]
            ],
            "0011"
        ],
        "CD": [
            "243",
            "00",
            "[189]\\d{8}|[1-68]\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "[1-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "88\\d{5}|(?:8[0-59]|9[017-9])\\d{7}"
                ]
            ]
        ],
        "CF": [
            "236",
            "00",
            "(?:[27]\\d{3}|8776)\\d{4}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[278]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "7[024-7]\\d{6}"
                ]
            ]
        ],
        "CG": [
            "242",
            "00",
            "222\\d{6}|(?:0\\d|80)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[02]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "026(?:1[0-5]|6[6-9])\\d{4}|0(?:[14-6]\\d\\d|2(?:40|5[5-8]|6[07-9]))\\d{5}"
                ]
            ]
        ],
        "CH": [
            "41",
            "00",
            "8\\d{11}|[2-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8[047]|90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-79]|81"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "7[35-9]\\d{7}"
                ]
            ]
        ],
        "CI": [
            "225",
            "00",
            "[02]\\d{9}",
            [
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d)(\\d{5})",
                    "$1 $2 $3 $4",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "0[157]\\d{8}"
                ]
            ]
        ],
        "CK": [
            "682",
            "00",
            "[2-578]\\d{4}",
            [
                5
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "[2-578]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "[578]\\d{4}"
                ]
            ]
        ],
        "CL": [
            "56",
            "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0",
            "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}",
            [
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "219",
                        "2196"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "44"
                    ]
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[1-36]"
                    ],
                    "($1)"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9[2-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "60|8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "60"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "2(?:1982[0-6]|3314[05-9])\\d{3}|(?:2(?:1(?:160|962)|3(?:2\\d\\d|3(?:[03467]\\d|1[0-35-9]|2[1-9]|5[0-24-9]|8[0-3])|600)|646[59])|80[1-9]\\d\\d|9(?:3(?:[0-57-9]\\d\\d|6(?:0[02-9]|[1-9]\\d))|6(?:[0-8]\\d\\d|9(?:[02-79]\\d|1[05-9]))|7[1-9]\\d\\d|9(?:[03-9]\\d\\d|1(?:[0235-9]\\d|4[0-24-9])|2(?:[0-79]\\d|8[0-46-9]))))\\d{4}|(?:22|3[2-5]|[47][1-35]|5[1-3578]|6[13-57]|8[1-9]|9[2458])\\d{7}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "CM": [
            "237",
            "00",
            "[26]\\d{8}|88\\d{6,7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "88"
                    ]
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "[26]|88"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:24[23]|6[25-9]\\d)\\d{6}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "CN": [
            "86",
            "00|1(?:[12]\\d|79)\\d\\d00",
            "1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5,6})",
                    "$1 $2",
                    [
                        "(?:10|2[0-57-9])[19]",
                        "(?:10|2[0-57-9])(?:10|9[56])",
                        "10(?:10|9[56])|2[0-57-9](?:100|9[56])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]",
                        "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]",
                        "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])",
                        "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "(?:4|80)0"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "10|2(?:[02-57-9]|1[1-9])",
                        "10|2(?:[02-57-9]|1[1-9])",
                        "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{7,8})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-578]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1[3-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "[12]"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0",
            0,
            "(1(?:[12]\\d|79)\\d\\d)|0",
            0,
            0,
            0,
            [
                0,
                [
                    "1740[0-5]\\d{6}|1(?:[38]\\d|4[57]|[59][0-35-9]|6[25-7]|7[0-35-8])\\d{8}",
                    [
                        11
                    ]
                ]
            ],
            "00"
        ],
        "CO": [
            "57",
            "00(?:4(?:[14]4|56)|[579])",
            "(?:60\\d\\d|9101)\\d{6}|(?:1\\d|3)\\d{9}",
            [
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "6"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "3[0-357]|91"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{7})",
                    "$1-$2-$3",
                    [
                        "1"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ]
            ],
            "0",
            0,
            "0([3579]|4(?:[14]4|56))?",
            0,
            0,
            0,
            [
                0,
                [
                    "333301[0-5]\\d{3}|3333(?:00|2[5-9]|[3-9]\\d)\\d{4}|(?:3(?:24[1-9]|3(?:00|3[0-24-9]))|9101)\\d{6}|3(?:0[0-5]|1\\d|2[0-3]|5[01]|70)\\d{7}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "CR": [
            "506",
            "00",
            "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-7]|8[3-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[89]"
                    ]
                ]
            ],
            0,
            0,
            "(19(?:0[0-2468]|1[09]|20|66|77|99))",
            0,
            0,
            0,
            [
                0,
                [
                    "(?:3005\\d|6500[01])\\d{3}|(?:5[07]|6[0-4]|7[0-3]|8[3-9])\\d{6}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "CU": [
            "53",
            "119",
            "[27]\\d{6,7}|[34]\\d{5,7}|63\\d{6}|(?:5|8\\d\\d)\\d{7}",
            [
                6,
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1 $2",
                    [
                        "2[1-4]|[34]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{6,7})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "[56]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:5\\d|63)\\d{6}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "CV": [
            "238",
            "0",
            "(?:[2-59]\\d\\d|800)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[2-589]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:36|5[1-389]|9\\d)\\d{5}"
                ]
            ]
        ],
        "CW": [
            "599",
            "00",
            "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[3467]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9[4-8]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            "[69]",
            [
                0,
                [
                    "953[01]\\d{4}|9(?:5[12467]|6[5-9])\\d{5}"
                ]
            ]
        ],
        "CX": [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",
            [
                6,
                7,
                8,
                9,
                10,
                12
            ],
            0,
            "0",
            0,
            "([59]\\d{7})$|0",
            "8$1",
            0,
            0,
            [
                0,
                [
                    "4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-26-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
                    [
                        9
                    ]
                ]
            ],
            "0011"
        ],
        "CY": [
            "357",
            "00",
            "(?:[279]\\d|[58]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[257-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "9(?:10|[4-79]\\d)\\d{5}"
                ]
            ]
        ],
        "CZ": [
            "420",
            "00",
            "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-8]|9[015-7]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "96"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:60[1-8]|7(?:0[2-5]|[2379]\\d))\\d{6}"
                ]
            ]
        ],
        "DE": [
            "49",
            "00",
            "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15
            ],
            [
                [
                    "(\\d{2})(\\d{3,13})",
                    "$1 $2",
                    [
                        "3[02]|40|[68]9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,12})",
                    "$1 $2",
                    [
                        "2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1",
                        "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{2,11})",
                    "$1 $2",
                    [
                        "[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]",
                        "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "138"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{2,10})",
                    "$1 $2",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,11})",
                    "$1 $2",
                    [
                        "181"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{4,10})",
                    "$1 $2 $3",
                    [
                        "1(?:3|80)|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7,8})",
                    "$1 $2",
                    [
                        "1[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7,12})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{6})",
                    "$1 $2",
                    [
                        "185",
                        "1850",
                        "18500"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{7})",
                    "$1 $2",
                    [
                        "18[68]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{6})",
                    "$1 $2",
                    [
                        "15[0568]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{7})",
                    "$1 $2",
                    [
                        "15[1279]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{8})",
                    "$1 $2",
                    [
                        "18"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{7,8})",
                    "$1 $2 $3",
                    [
                        "1(?:6[023]|7)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{7})",
                    "$1 $2 $3",
                    [
                        "15[279]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{8})",
                    "$1 $2 $3",
                    [
                        "15"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "15[0-25-9]\\d{8}|1(?:6[023]|7\\d)\\d{7,8}",
                    [
                        10,
                        11
                    ]
                ]
            ]
        ],
        "DJ": [
            "253",
            "00",
            "(?:2\\d|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[27]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "77\\d{6}"
                ]
            ]
        ],
        "DK": [
            "45",
            "00",
            "[2-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:[2-7]\\d|8[126-9]|9[1-46-9])\\d{6}"
                ]
            ]
        ],
        "DM": [
            "1",
            "011",
            "(?:[58]\\d\\d|767|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-7]\\d{6})$|1",
            "767$1",
            0,
            "767",
            [
                0,
                [
                    "767(?:2(?:[2-4689]5|7[5-7])|31[5-7]|61[1-8]|70[1-6])\\d{4}"
                ]
            ]
        ],
        "DO": [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "8001|8[024]9",
            [
                0,
                [
                    "8[024]9[2-9]\\d{6}"
                ]
            ]
        ],
        "DZ": [
            "213",
            "00",
            "(?:[1-4]|[5-79]\\d|80)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-8]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:5(?:4[0-29]|5\\d|6[0-2])|6(?:[569]\\d|7[0-6])|7[7-9]\\d)\\d{6}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "EC": [
            "593",
            "00",
            "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}",
            [
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[2-7]"
                    ],
                    "(0$1)",
                    0,
                    "$1-$2-$3"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "964[0-2]\\d{5}|9(?:39|[57][89]|6[0-36-9]|[89]\\d)\\d{6}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "EE": [
            "372",
            "00",
            "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88",
                        "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3,4})",
                    "$1 $2",
                    [
                        "[45]|8(?:00|[1-49])",
                        "[45]|8(?:00[1-9]|[1-49])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:5\\d{5}|8(?:1(?:0(?:0(?:00|[178]\\d)|[3-9]\\d\\d)|(?:1(?:0[236]|1\\d)|(?:2[0-59]|[3-79]\\d)\\d)\\d)|2(?:0(?:000|(?:19|[2-7]\\d)\\d)|(?:(?:[124-6]\\d|3[5-9])\\d|7(?:[0-79]\\d|8[13-9])|8(?:[2-6]\\d|7[01]))\\d)|[349]\\d{4}))\\d\\d|5(?:(?:[02]\\d|5[0-478])\\d|1(?:[0-8]\\d|95)|6(?:4[0-4]|5[1-589]))\\d{3}",
                    [
                        7,
                        8
                    ]
                ]
            ]
        ],
        "EG": [
            "20",
            "00",
            "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{7,8})",
                    "$1 $2",
                    [
                        "[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6,7})",
                    "$1 $2",
                    [
                        "1[35]|[4-6]|8[2468]|9[235-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{8})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "1[0-25]\\d{8}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "EH": [
            "212",
            "00",
            "[5-8]\\d{8}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            "528[89]",
            [
                0,
                [
                    "(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-2]|5[01]|8[0-3]))\\d{6}"
                ]
            ]
        ],
        "ER": [
            "291",
            "00",
            "[178]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[178]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:17[1-3]|7\\d\\d)\\d{4}"
                ]
            ]
        ],
        "ES": [
            "34",
            "00",
            "[5-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]00"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:590[16]00\\d|9(?:6906(?:09|10)|7390\\d\\d))\\d\\d|(?:6\\d|7[1-48])\\d{7}"
                ]
            ]
        ],
        "ET": [
            "251",
            "00",
            "(?:11|[2-579]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-579]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "700[1-9]\\d{5}|(?:7(?:0[1-9]|1[0-8]|22|77|86|99)|9\\d\\d)\\d{6}"
                ]
            ]
        ],
        "FI": [
            "358",
            "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
            "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d)(\\d{4,9})",
                    "$1 $2",
                    [
                        "[2568][1-8]|3(?:0[1-9]|[1-9])|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1 $2",
                    [
                        "[12]00|[368]|70[07-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4,8})",
                    "$1 $2",
                    [
                        "[1245]|7[135]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6,10})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            "1[03-79]|[2-9]",
            [
                0,
                [
                    "4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}",
                    [
                        6,
                        7,
                        8,
                        9,
                        10
                    ]
                ]
            ],
            "00"
        ],
        "FJ": [
            "679",
            "0(?:0|52)",
            "45\\d{5}|(?:0800\\d|[235-9])\\d{6}",
            [
                7,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[235-9]|45"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:[279]\\d|45|5[01568]|8[034679])\\d{5}",
                    [
                        7
                    ]
                ]
            ],
            "00"
        ],
        "FK": [
            "500",
            "00",
            "[2-7]\\d{4}",
            [
                5
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "[56]\\d{4}"
                ]
            ]
        ],
        "FM": [
            "691",
            "00",
            "(?:[39]\\d\\d|820)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[389]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-7]\\d)\\d)\\d{3}"
                ]
            ]
        ],
        "FO": [
            "298",
            "00",
            "[2-9]\\d{5}",
            [
                6
            ],
            [
                [
                    "(\\d{6})",
                    "$1",
                    [
                        "[2-9]"
                    ]
                ]
            ],
            0,
            0,
            "(10(?:01|[12]0|88))",
            0,
            0,
            0,
            [
                0,
                [
                    "(?:[27][1-9]|5\\d|9[16])\\d{4}"
                ]
            ]
        ],
        "FR": [
            "33",
            "00",
            "[1-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0 $1"
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "[1-79]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:6(?:[0-24-8]\\d|3[0-8]|9[589])|7[3-9]\\d)\\d{6}"
                ]
            ]
        ],
        "GA": [
            "241",
            "00",
            "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "11|[67]"
                    ],
                    "0$1"
                ]
            ],
            0,
            0,
            "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})",
            "$1",
            0,
            0,
            [
                0,
                [
                    "(?:(?:0[2-7]|7[467])\\d|6(?:0[0-4]|10|[256]\\d))\\d{5}|[2-7]\\d{6}"
                ]
            ]
        ],
        "GB": [
            "44",
            "00",
            "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}",
            [
                7,
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "800",
                        "8001",
                        "80011",
                        "800111",
                        "8001111"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "845",
                        "8454",
                        "84546",
                        "845464"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{4,5})",
                    "$1 $2",
                    [
                        "1(?:38|5[23]|69|76|94)",
                        "1(?:(?:38|69)7|5(?:24|39)|768|946)",
                        "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5,6})",
                    "$1 $2",
                    [
                        "1(?:[2-69][02-9]|[78])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[25]|7(?:0|6[02-9])",
                        "[25]|7(?:0|6(?:[03-9]|2[356]))"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1389]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}",
                    [
                        10
                    ]
                ]
            ],
            0,
            " x"
        ],
        "GD": [
            "1",
            "011",
            "(?:473|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "473$1",
            0,
            "473",
            [
                0,
                [
                    "473(?:4(?:0[2-79]|1[04-9]|2[0-5]|58)|5(?:2[01]|3[3-8])|901)\\d{4}"
                ]
            ]
        ],
        "GE": [
            "995",
            "00",
            "(?:[3-57]\\d\\d|800)\\d{6}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "32"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[57]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[348]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "5(?:(?:(?:0555|1(?:[17]77|555))[5-9]|757(?:7[7-9]|8[01]))\\d|22252[0-4])\\d\\d|(?:5(?:00(?:0\\d|11|22|33|44|5[05]|77|88|99)|1(?:1(?:00|[124]\\d|3[01])|4\\d\\d)|(?:44|68)\\d\\d|5(?:[0157-9]\\d\\d|200)|7(?:[0147-9]\\d\\d|5(?:00|[57]5))|8(?:0(?:[018]\\d|2[0-4])|58[89]|8(?:55|88))|9(?:090|[1-35-9]\\d\\d))|790\\d\\d)\\d{4}|5(?:0(?:070|505)|1(?:0[01]0|1(?:07|33|51))|2(?:0[02]0|2[25]2)|3(?:0[03]0|3[35]3)|(?:40[04]|900)0|5222)[0-4]\\d{3}"
                ]
            ]
        ],
        "GF": [
            "594",
            "00",
            "[56]94\\d{6}|(?:80|9\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[56]|9[47]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "694(?:[0-249]\\d|3[0-8])\\d{4}"
                ]
            ]
        ],
        "GG": [
            "44",
            "00",
            "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?",
            [
                7,
                9,
                10
            ],
            0,
            "0",
            0,
            "([25-9]\\d{5})$|0",
            "1481$1",
            0,
            0,
            [
                0,
                [
                    "7(?:(?:781|839)\\d|911[17])\\d{5}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "GH": [
            "233",
            "00",
            "(?:[235]\\d{3}|800)\\d{5}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[235]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:2(?:[0346-9]\\d|5[67])|5(?:[03-7]\\d|9[1-9]))\\d{6}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "GI": [
            "350",
            "00",
            "(?:[25]\\d|60)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "5251[0-4]\\d{3}|(?:5(?:[146-8]\\d\\d|250)|60(?:1[01]|6\\d))\\d{4}"
                ]
            ]
        ],
        "GL": [
            "299",
            "00",
            "(?:19|[2-689]\\d|70)\\d{4}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "19|[2-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "[245]\\d{5}"
                ]
            ]
        ],
        "GM": [
            "220",
            "00",
            "[2-9]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:[23679]\\d|5[0-489])\\d{5}"
                ]
            ]
        ],
        "GN": [
            "224",
            "00",
            "722\\d{6}|(?:3|6\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "3"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[67]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "6[0-356]\\d{7}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "GP": [
            "590",
            "00",
            "590\\d{6}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[569]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"
                ]
            ]
        ],
        "GQ": [
            "240",
            "00",
            "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[235]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[89]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:222|55\\d)\\d{6}"
                ]
            ]
        ],
        "GR": [
            "30",
            "00",
            "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}",
            [
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "21|7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2689]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "68[57-9]\\d{7}|(?:69|94)\\d{8}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "GT": [
            "502",
            "00",
            "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}",
            [
                8,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-8]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:[3-5]\\d\\d|80[0-4])\\d{5}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "GU": [
            "1",
            "011",
            "(?:[58]\\d\\d|671|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "671$1",
            0,
            "671",
            [
                0,
                [
                    "671(?:2\\d\\d|3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[02-46-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[0479]7|2[0167]|3[45]|8[7-9])|8(?:[2-57-9]8|6[48])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[78]))\\d{4}"
                ]
            ]
        ],
        "GW": [
            "245",
            "00",
            "[49]\\d{8}|4\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "40"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "9(?:5\\d|6[569]|77)\\d{6}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "GY": [
            "592",
            "001",
            "(?:[2-8]\\d{3}|9008)\\d{3}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:510|6\\d\\d|7(?:0\\d|1[0-8]|25|49))\\d{4}"
                ]
            ]
        ],
        "HK": [
            "852",
            "00(?:30|5[09]|[126-9]?)",
            "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}",
            [
                5,
                6,
                7,
                8,
                9,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{2,5})",
                    "$1 $2",
                    [
                        "900",
                        "9003"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:4(?:44[5-9]|6(?:1[0-7]|4[0-57-9]|6[0-4]))|5(?:73[0-6]|95[0-8])|6(?:26[013-8]|66[0-3])|70(?:7[1-6]|8[0-4])|848[0-25-9]|9(?:29[013-9]|59[0-4]|899))\\d{4}|(?:4(?:4[015]|6[02357-9])|5(?:[1-59][0-46-9]|6[0-4689]|7[0-246-9])|6(?:0[1-9]|[13-59]\\d|[268][0-57-9]|7[0-79])|84[09]|9(?:0[1-9]|1[02-9]|[2358][0-8]|[467]\\d))\\d{5}",
                    [
                        8
                    ]
                ]
            ],
            "00"
        ],
        "HN": [
            "504",
            "00",
            "8\\d{10}|[237-9]\\d{7}",
            [
                8,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "[237-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "[37-9]\\d{7}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "HR": [
            "385",
            "00",
            "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "6[01]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-5]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "9(?:(?:0[1-9]|[12589]\\d)\\d\\d|7(?:[0679]\\d\\d|5(?:[01]\\d|44|77|9[5-7])))\\d{4}|98\\d{6}",
                    [
                        8,
                        9
                    ]
                ]
            ]
        ],
        "HT": [
            "509",
            "00",
            "(?:[2-489]\\d|55)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-589]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:[34]\\d|55)\\d{6}"
                ]
            ]
        ],
        "HU": [
            "36",
            "00",
            "[235-7]\\d{8}|[1-9]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "(06 $1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"
                    ],
                    "(06 $1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ],
                    "06 $1"
                ]
            ],
            "06",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:[257]0|3[01])\\d{7}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "ID": [
            "62",
            "00[89]",
            "(?:(?:00[1-9]|8\\d)\\d{4}|[1-36])\\d{6}|00\\d{10}|[1-9]\\d{8,10}|[2-9]\\d{7}",
            [
                7,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "15"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5,9})",
                    "$1 $2",
                    [
                        "2[124]|[36]1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5,7})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,8})",
                    "$1 $2",
                    [
                        "[2-79]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "8[1-35-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6,8})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "804"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "80"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1-$2-$3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "8[1-35-9]\\d{7,10}",
                    [
                        9,
                        10,
                        11,
                        12
                    ]
                ]
            ]
        ],
        "IE": [
            "353",
            "00",
            "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "2[24-9]|47|58|6[237-9]|9[35-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[45]0"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2569]|4[1-69]|7[14]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "81"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "4"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "8(?:22|[35-9]\\d)\\d{6}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "IL": [
            "972",
            "0(?:0|1[2-9])",
            "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{4})(\\d{3})",
                    "$1-$2",
                    [
                        "125"
                    ]
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{2})",
                    "$1-$2-$3",
                    [
                        "121"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[2-489]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[57]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "12"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1-$2",
                    [
                        "159"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{3})",
                    "$1-$2-$3-$4",
                    [
                        "1[7-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})",
                    "$1-$2 $3-$4",
                    [
                        "15"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "55410\\d{4}|5(?:(?:[02][02-9]|[149][2-9]|[36]\\d|8[3-7])\\d|5(?:01|2\\d|3[0-3]|4[34]|5[0-25689]|6[6-8]|7[0-267]|8[7-9]|9[1-9]))\\d{5}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "IM": [
            "44",
            "00",
            "1624\\d{6}|(?:[3578]\\d|90)\\d{8}",
            [
                10
            ],
            0,
            "0",
            0,
            "([25-8]\\d{5})$|0",
            "1624$1",
            0,
            "74576|(?:16|7[56])24",
            [
                0,
                [
                    "76245[06]\\d{4}|7(?:4576|[59]24\\d|624[0-4689])\\d{5}"
                ]
            ]
        ],
        "IN": [
            "91",
            "00",
            "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}",
            [
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d{8})",
                    "$1",
                    [
                        "5(?:0|2[23]|3[03]|[67]1|88)",
                        "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)",
                        "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{4})(\\d{4,5})",
                    "$1 $2",
                    [
                        "180",
                        "1800"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "140"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "11|2[02]|33|4[04]|79[1-7]|80[2-46]",
                        "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])",
                        "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]",
                        "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]",
                        "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807",
                        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]",
                        "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "[6-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{2,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1(?:6|8[06])",
                        "1(?:6|8[06]0)"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "18"
                    ],
                    0,
                    1
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:61279|7(?:887[02-9]|9(?:313|79[07-9]))|8(?:079[04-9]|(?:84|91)7[02-8]))\\d{5}|(?:6(?:12|[2-47]1|5[17]|6[13]|80)[0189]|7(?:1(?:2[0189]|9[0-5])|2(?:[14][017-9]|8[0-59])|3(?:2[5-8]|[34][017-9]|9[016-9])|4(?:1[015-9]|[29][89]|39|8[389])|5(?:[15][017-9]|2[04-9]|9[7-9])|6(?:0[0-47]|1[0-257-9]|2[0-4]|3[19]|5[4589])|70[0289]|88[089]|97[02-8])|8(?:0(?:6[67]|7[02-8])|70[017-9]|84[01489]|91[0-289]))\\d{6}|(?:7(?:31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[0189]\\d|7[02-8])\\d{5}|(?:6(?:[09]\\d|1[04679]|2[03689]|3[05-9]|4[0489]|50|6[069]|7[07]|8[7-9])|7(?:0\\d|2[0235-79]|3[05-8]|40|5[0346-8]|6[6-9]|7[1-9]|8[0-79]|9[089])|8(?:0[01589]|1[0-57-9]|2[235-9]|3[03-57-9]|[45]\\d|6[02457-9]|7[1-69]|8[0-25-9]|9[02-9])|9\\d\\d)\\d{7}|(?:6(?:(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|8[124-6])\\d|7(?:[235689]\\d|4[0189]))|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-5])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]|881))[0189]\\d{5}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "IO": [
            "246",
            "00",
            "3\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "3"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "38\\d{5}"
                ]
            ]
        ],
        "IQ": [
            "964",
            "00",
            "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "7[3-9]\\d{8}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "IR": [
            "98",
            "00",
            "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}",
            [
                4,
                5,
                6,
                7,
                10
            ],
            [
                [
                    "(\\d{4,5})",
                    "$1",
                    [
                        "96"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4,5})",
                    "$1 $2",
                    [
                        "(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-8]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "9(?:(?:0(?:[0-35]\\d|4[4-6])|(?:[13]\\d|2[0-3])\\d)\\d|9(?:[0-46]\\d\\d|5[15]0|8(?:[12]\\d|88)|9(?:0[0-3]|[19]\\d|21|69|77|8[7-9])))\\d{5}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "IS": [
            "354",
            "00|1(?:0(?:01|[12]0)|100)",
            "(?:38\\d|[4-9])\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[4-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "3"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:38[589]\\d\\d|6(?:1[1-8]|2[0-6]|3[026-9]|4[014679]|5[0159]|6[0-69]|70|8[06-8]|9\\d)|7(?:5[057]|[6-9]\\d)|8(?:2[0-59]|[3-69]\\d|8[238]))\\d{4}"
                ]
            ],
            "00"
        ],
        "IT": [
            "39",
            "00",
            "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1 $2",
                    [
                        "0[26]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,6})",
                    "$1 $2",
                    [
                        "0[13-57-9][0159]|8(?:03|4[17]|9[2-5])",
                        "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"
                    ]
                ],
                [
                    "(\\d{4})(\\d{2,6})",
                    "$1 $2",
                    [
                        "0(?:[13-579][2-46-8]|8[236-8])"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "894"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0[26]|5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "1(?:44|[679])|[378]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0[13-57-9][0159]|14"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "0[26]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "3"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "3[1-9]\\d{8}|3[2-9]\\d{7}",
                    [
                        9,
                        10
                    ]
                ]
            ]
        ],
        "JE": [
            "44",
            "00",
            "1534\\d{6}|(?:[3578]\\d|90)\\d{8}",
            [
                10
            ],
            0,
            "0",
            0,
            "([0-24-8]\\d{5})$|0",
            "1534$1",
            0,
            0,
            [
                0,
                [
                    "7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97[7-9]))\\d{5}"
                ]
            ]
        ],
        "JM": [
            "1",
            "011",
            "(?:[58]\\d\\d|658|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "658|876",
            [
                0,
                [
                    "(?:658295|876(?:2(?:0[1-9]|[13-9]\\d|2[013-9])|[348]\\d\\d|5(?:0[1-9]|[1-9]\\d)|6(?:4[89]|6[67])|7(?:0[07]|7\\d|8[1-47-9]|9[0-36-9])|9(?:[01]9|9[0579])))\\d{4}"
                ]
            ]
        ],
        "JO": [
            "962",
            "00",
            "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2356]|87"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "7(?:[78][0-25-9]|9\\d)\\d{6}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "JP": [
            "81",
            "010",
            "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}",
            [
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15,
                16,
                17
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "(?:12|57|99)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d)(\\d{4})",
                    "$1-$2-$3",
                    [
                        "1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])",
                        "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]",
                        "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "60"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[36]|4(?:2[09]|7[01])",
                        "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])",
                        "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]",
                        "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[14]|[289][2-9]|5[3-9]|7[2-4679]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[257-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "(000[259]\\d{6})$|(?:(?:003768)0?)|0",
            "$1",
            0,
            0,
            [
                0,
                [
                    "[7-9]0[1-9]\\d{7}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "KE": [
            "254",
            "000",
            "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5,7})",
                    "$1 $2",
                    [
                        "[24-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[17]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:1(?:0[0-6]|1[0-5]|2[014]|30)|7\\d\\d)\\d{6}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "KG": [
            "996",
            "00",
            "8\\d{9}|[235-9]\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "3(?:1[346]|[24-79])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[235-79]|88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d)(\\d{2,3})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "312(?:58\\d|973)\\d{3}|(?:2(?:0[0-35]|2\\d)|5[0-24-7]\\d|600|7(?:[07]\\d|55)|88[08]|9(?:12|9[05-9]))\\d{6}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "KH": [
            "855",
            "00[14-9]",
            "1\\d{9}|[1-9]\\d{7,8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:(?:1[28]|3[18]|9[67])\\d|6[016-9]|7(?:[07-9]|[16]\\d)|8(?:[013-79]|8\\d))\\d{6}|(?:1\\d|9[0-57-9])\\d{6}|(?:2[3-6]|3[2-6]|4[2-4]|[5-7][2-5])48\\d{5}",
                    [
                        8,
                        9
                    ]
                ]
            ]
        ],
        "KI": [
            "686",
            "00",
            "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}",
            [
                5,
                8
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:6200[01]|7(?:310[1-9]|5(?:02[03-9]|12[0-47-9]|22[0-7]|[34](?:0[1-9]|8[02-9])|50[1-9])))\\d{3}|(?:63\\d\\d|7(?:(?:[0146-9]\\d|2[0-689])\\d|3(?:[02-9]\\d|1[1-9])|5(?:[0-2][013-9]|[34][1-79]|5[1-9]|[6-9]\\d)))\\d{4}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "KM": [
            "269",
            "00",
            "[3478]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[3478]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "[34]\\d{6}"
                ]
            ]
        ],
        "KN": [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-7]\\d{6})$|1",
            "869$1",
            0,
            "869",
            [
                0,
                [
                    "869(?:48[89]|55[6-8]|66\\d|76[02-7])\\d{4}"
                ]
            ]
        ],
        "KP": [
            "850",
            "00|99",
            "85\\d{6}|(?:19\\d|[2-7])\\d{7}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "19[1-3]\\d{7}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "KR": [
            "82",
            "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))",
            "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}",
            [
                5,
                6,
                8,
                9,
                10,
                11,
                12,
                13,
                14
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1-$2",
                    [
                        "(?:3[1-3]|[46][1-4]|5[1-5])1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "60|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[1346]|5[1-5]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[57]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "0(8(?:[1-46-8]|5\\d\\d))?",
            0,
            0,
            0,
            [
                0,
                [
                    "1(?:05(?:[0-8]\\d|9[0-6])|22[13]\\d)\\d{4,5}|1(?:0[0-46-9]|[16-9]\\d|2[013-9])\\d{6,7}",
                    [
                        9,
                        10
                    ]
                ]
            ]
        ],
        "KW": [
            "965",
            "00",
            "18\\d{5}|(?:[2569]\\d|41)\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{4})(\\d{3,4})",
                    "$1 $2",
                    [
                        "[169]|2(?:[235]|4[1-35-9])|52"
                    ]
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[245]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:41\\d\\d|5(?:(?:[05]\\d|1[0-7]|6[56])\\d|2(?:22|5[25])|7(?:55|77)|88[58])|6(?:(?:0[034679]|5[015-9]|6\\d)\\d|1(?:00|11|66)|222|3[36]3|444|7(?:0[013-9]|[67]\\d)|888|9(?:[069]\\d|3[039]))|9(?:(?:0[09]|[4679]\\d|8[057-9])\\d|1(?:1[01]|99)|2(?:00|2\\d)|3(?:00|3[03])|5(?:00|5\\d)))\\d{4}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "KY": [
            "1",
            "011",
            "(?:345|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "345$1",
            0,
            "345",
            [
                0,
                [
                    "345(?:32[1-9]|42[0-4]|5(?:1[67]|2[5-79]|4[6-9]|50|76)|649|82[56]|9(?:1[679]|2[2-9]|3[06-9]|90))\\d{4}"
                ]
            ]
        ],
        "KZ": [
            "7",
            "810",
            "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}",
            [
                10,
                14
            ],
            0,
            "8",
            0,
            0,
            0,
            0,
            "33|7",
            [
                0,
                [
                    "7(?:0[0-25-8]|47|6[0-4]|7[15-8]|85)\\d{7}",
                    [
                        10
                    ]
                ]
            ],
            "8~10"
        ],
        "LA": [
            "856",
            "00",
            "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2[13]|3[14]|[4-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "30[013-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[23]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:20(?:[2359]\\d|7[6-8]|88)|302\\d)\\d{6}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "LB": [
            "961",
            "00",
            "[27-9]\\d{7}|[13-9]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[27-9]"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "793(?:[01]\\d|2[0-4])\\d{3}|(?:(?:3|81)\\d|7(?:[01]\\d|6[013-9]|8[89]|9[12]))\\d{5}"
                ]
            ]
        ],
        "LC": [
            "1",
            "011",
            "(?:[58]\\d\\d|758|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-8]\\d{6})$|1",
            "758$1",
            0,
            "758",
            [
                0,
                [
                    "758(?:28[4-7]|384|4(?:6[01]|8[4-9])|5(?:1[89]|20|84)|7(?:1[2-9]|2\\d|3[0-3])|812)\\d{4}"
                ]
            ]
        ],
        "LI": [
            "423",
            "00",
            "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[2379]|8(?:0[09]|7)",
                        "[2379]|8(?:0(?:02|9)|7)"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "69"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ],
            "0",
            0,
            "(1001)|0",
            0,
            0,
            0,
            [
                0,
                [
                    "(?:6(?:(?:4[5-9]|5[0-469])\\d|6(?:[0245]\\d|[17]0|3[7-9]))\\d|7(?:[37-9]\\d|42|56))\\d{4}"
                ]
            ]
        ],
        "LK": [
            "94",
            "00",
            "[1-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[1-689]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "7(?:[0-25-8]\\d|4[0-4])\\d{6}"
                ]
            ]
        ],
        "LR": [
            "231",
            "00",
            "(?:[25]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[4-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[23578]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:(?:(?:22|33)0|555|(?:77|88)\\d)\\d|4[67])\\d{5}|[56]\\d{6}",
                    [
                        7,
                        9
                    ]
                ]
            ]
        ],
        "LS": [
            "266",
            "00",
            "(?:[256]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2568]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "[56]\\d{7}"
                ]
            ]
        ],
        "LT": [
            "370",
            "00",
            "(?:[3469]\\d|52|[78]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "52[0-7]"
                    ],
                    "(8-$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "8 $1",
                    1
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "37|4(?:[15]|6[1-8])"
                    ],
                    "(8-$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[3-6]"
                    ],
                    "(8-$1)",
                    1
                ]
            ],
            "8",
            0,
            "[08]",
            0,
            0,
            0,
            [
                0,
                [
                    "6\\d{7}"
                ]
            ]
        ],
        "LU": [
            "352",
            "00",
            "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "20[2-689]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
                    "$1 $2 $3 $4",
                    [
                        "2(?:[0367]|4[3-8])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "80[01]|90[015]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "20"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "2(?:[0367]|4[3-8])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})",
                    "$1 $2 $3 $4",
                    [
                        "[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"
                    ]
                ]
            ],
            0,
            0,
            "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)",
            0,
            0,
            0,
            [
                0,
                [
                    "6(?:[269][18]|5[1568]|7[189]|81)\\d{6}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "LV": [
            "371",
            "00",
            "(?:[268]\\d|90)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[269]|8[01]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "23(?:23[0-57-9]|33[0238])\\d{3}|2(?:[0-24-9]\\d\\d|3(?:0[07]|[14-9]\\d|2[024-9]|3[0-24-9]))\\d{4}"
                ]
            ]
        ],
        "LY": [
            "218",
            "00",
            "[2-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{7})",
                    "$1-$2",
                    [
                        "[2-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "9[1-6]\\d{7}"
                ]
            ]
        ],
        "MA": [
            "212",
            "00",
            "[5-8]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "5[45]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1-$2",
                    [
                        "5(?:2[2-489]|3[5-9]|9)|8(?:0[89]|92)",
                        "5(?:2(?:[2-49]|8[235-9])|3[5-9]|9)|8(?:0[89]|92)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1-$2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1-$2",
                    [
                        "[5-7]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-2]|5[01]|8[0-3]))\\d{6}"
                ]
            ]
        ],
        "MC": [
            "377",
            "00",
            "(?:[3489]|6\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[389]"
                    ]
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "4(?:[46]\\d|5[1-9])\\d{5}|(?:3|6\\d)\\d{7}"
                ]
            ]
        ],
        "MD": [
            "373",
            "00",
            "(?:[235-7]\\d|[89]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "22|3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[25-7]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "562\\d{5}|(?:6\\d|7[16-9])\\d{6}"
                ]
            ]
        ],
        "ME": [
            "382",
            "00",
            "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "6(?:[07-9]\\d|3[024]|6[0-25])\\d{5}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "MF": [
            "590",
            "00",
            "590\\d{6}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"
                ]
            ]
        ],
        "MG": [
            "261",
            "00",
            "[23]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[23]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "([24-9]\\d{6})$|0",
            "20$1",
            0,
            0,
            [
                0,
                [
                    "3[2-47-9]\\d{7}"
                ]
            ]
        ],
        "MH": [
            "692",
            "011",
            "329\\d{4}|(?:[256]\\d|45)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[2-6]"
                    ]
                ]
            ],
            "1",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:(?:23|54)5|329|45[356])\\d{4}"
                ]
            ]
        ],
        "MK": [
            "389",
            "00",
            "[2-578]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2|34[47]|4(?:[37]7|5[47]|64)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[347]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[58]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "7(?:3555|(?:474|9[019]7)7)\\d{3}|7(?:[0-25-8]\\d\\d|3(?:[1-48]\\d|6[01]|7[01578])|4(?:2\\d|60|7[01578])|9(?:[2-4]\\d|5[01]|7[015]))\\d{4}"
                ]
            ]
        ],
        "ML": [
            "223",
            "00",
            "[24-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "2(?:0(?:01|79)|17\\d)\\d{4}|(?:5[01]|[679]\\d|8[2-49])\\d{6}"
                ]
            ]
        ],
        "MM": [
            "95",
            "00",
            "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "16|2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[12]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[4-7]|8[1-35]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4,6})",
                    "$1 $2 $3",
                    [
                        "9(?:2[0-4]|[35-9]|4[137-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "92"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{5})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:17[01]|9(?:2(?:[0-4]|[56]\\d\\d)|(?:3(?:[0-36]|4\\d)|(?:6\\d|8[89]|9[4-8])\\d|7(?:3|40|[5-9]\\d))\\d|4(?:(?:[0245]\\d|[1379])\\d|88)|5[0-6])\\d)\\d{4}|9[69]1\\d{6}|9(?:[68]\\d|9[089])\\d{5}",
                    [
                        7,
                        8,
                        9,
                        10
                    ]
                ]
            ]
        ],
        "MN": [
            "976",
            "001",
            "[12]\\d{7,9}|[5-9]\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[12]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[5-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[12]2[1-3]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[12](?:27|3[2-8]|4[2-68]|5[1-4689])",
                        "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{4,5})",
                    "$1 $2",
                    [
                        "[12]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:83[01]|92[039])\\d{5}|(?:5[05]|6[069]|8[015689]|9[013-9])\\d{6}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "MO": [
            "853",
            "00",
            "0800\\d{3}|(?:28|[68]\\d)\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{4})(\\d{3})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[268]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "6800[0-79]\\d{3}|6(?:[235]\\d\\d|6(?:0[0-5]|[1-9]\\d)|8(?:0[1-9]|[14-8]\\d|2[5-9]|[39][0-4]))\\d{4}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "MP": [
            "1",
            "011",
            "[58]\\d{9}|(?:67|90)0\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "670$1",
            0,
            "670",
            [
                0,
                [
                    "670(?:2(?:3[3-7]|56|8[4-8])|32[1-38]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}"
                ]
            ]
        ],
        "MQ": [
            "596",
            "00",
            "596\\d{6}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[569]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "69(?:6(?:[0-46-9]\\d|5[0-6])|727)\\d{4}"
                ]
            ]
        ],
        "MR": [
            "222",
            "00",
            "(?:[2-4]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-48]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "[2-4][0-46-9]\\d{6}"
                ]
            ]
        ],
        "MS": [
            "1",
            "011",
            "(?:[58]\\d\\d|664|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([34]\\d{6})$|1",
            "664$1",
            0,
            "664",
            [
                0,
                [
                    "664(?:3(?:49|9[1-6])|49[2-6])\\d{4}"
                ]
            ]
        ],
        "MT": [
            "356",
            "00",
            "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2357-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:7(?:210|[79]\\d\\d)|9(?:[29]\\d\\d|69[67]|8(?:1[1-3]|89|97)))\\d{4}"
                ]
            ]
        ],
        "MU": [
            "230",
            "0(?:0|[24-7]0|3[03])",
            "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-46]|8[013]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[57]"
                    ]
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "8"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "5(?:4(?:2[1-389]|7[1-9])|87[15-8])\\d{4}|(?:5(?:2[5-9]|4[3-689]|[57]\\d|8[0-689]|9[0-8])|7(?:0[0-3]|3[013]))\\d{5}",
                    [
                        8
                    ]
                ]
            ],
            "020"
        ],
        "MV": [
            "960",
            "0(?:0|19)",
            "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}",
            [
                7,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[34679]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:46[46]|[79]\\d\\d)\\d{4}",
                    [
                        7
                    ]
                ]
            ],
            "00"
        ],
        "MW": [
            "265",
            "00",
            "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1[2-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[137-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "111\\d{6}|(?:31|77|[89][89])\\d{7}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "MX": [
            "52",
            "0[09]",
            "1(?:(?:[27]2|44|87|99)[1-9]|65[0-689])\\d{7}|(?:1(?:[01]\\d|2[13-9]|[35][1-9]|4[0-35-9]|6[0-46-9]|7[013-9]|8[1-69]|9[1-8])|[2-9]\\d)\\d{8}",
            [
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "33|5[56]|81"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d)(\\d{2})(\\d{4})(\\d{4})",
                    "$2 $3 $4",
                    [
                        "1(?:33|5[56]|81)"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{4})",
                    "$2 $3 $4",
                    [
                        "1"
                    ],
                    0,
                    1
                ]
            ],
            "01",
            0,
            "0(?:[12]|4[45])|1",
            0,
            0,
            0,
            [
                0,
                [
                    "657[12]\\d{6}|(?:1(?:2(?:2[1-9]|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[24-7][1-9]|3[1-8]|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[1-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1-467][1-9]|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[1-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69][1-9]|7[12]|8[1-8]))|2(?:2\\d|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[25-7][1-9]|3[1-8]|4\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[1-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[13467][1-9]|2\\d|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[0-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|6[1-9]|7[12]|8[1-8]|9\\d))\\d{7}"
                ]
            ],
            "00"
        ],
        "MY": [
            "60",
            "00",
            "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "[4-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1-$2 $3",
                    [
                        "1(?:[02469]|[378][1-9]|53)|8",
                        "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{4})",
                    "$1-$2-$3-$4",
                    [
                        "1(?:[367]|80)"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "15"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "1(?:1888[689]|4400|8(?:47|8[27])[0-4])\\d{4}|1(?:0(?:[23568]\\d|4[0-6]|7[016-9]|9[0-8])|1(?:[1-5]\\d\\d|6(?:0[5-9]|[1-9]\\d)|7(?:[0-4]\\d|5[0-7]))|(?:[269]\\d|[37][1-9]|4[235-9])\\d|5(?:31|9\\d\\d)|8(?:1[23]|[236]\\d|4[06]|5(?:46|[7-9])|7[016-9]|8[01]|9[0-8]))\\d{5}",
                    [
                        9,
                        10
                    ]
                ]
            ]
        ],
        "MZ": [
            "258",
            "00",
            "(?:2|8\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2|8[2-79]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "8[2-79]\\d{7}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "NA": [
            "264",
            "00",
            "[68]\\d{7,8}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "87"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:60|8[1245])\\d{7}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "NC": [
            "687",
            "00",
            "(?:050|[2-57-9]\\d\\d)\\d{3}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1.$2.$3",
                    [
                        "[02-57-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:5[0-4]|[79]\\d|8[0-79])\\d{4}"
                ]
            ]
        ],
        "NE": [
            "227",
            "00",
            "[027-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "08"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[089]|2[013]|7[047]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:23|7[047]|[89]\\d)\\d{6}"
                ]
            ]
        ],
        "NF": [
            "672",
            "00",
            "[13]\\d{5}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "1[0-3]"
                    ]
                ],
                [
                    "(\\d)(\\d{5})",
                    "$1 $2",
                    [
                        "[13]"
                    ]
                ]
            ],
            0,
            0,
            "([0-258]\\d{4})$",
            "3$1",
            0,
            0,
            [
                0,
                [
                    "(?:14|3[58])\\d{4}"
                ]
            ]
        ],
        "NG": [
            "234",
            "009",
            "(?:[124-7]|9\\d{3})\\d{6}|[1-9]\\d{7}|[78]\\d{9,13}",
            [
                7,
                8,
                10,
                11,
                12,
                13,
                14
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "78"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[12]|9(?:0[3-9]|[1-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[3-7]|8[2-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})(\\d{5,6})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:702[0-24-9]|819[01])\\d{6}|(?:70[13-689]|8(?:0[1-9]|1[0-8])|9(?:0[1-9]|1[1-356]))\\d{7}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "NI": [
            "505",
            "00",
            "(?:1800|[25-8]\\d{3})\\d{4}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[125-8]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:5(?:5[0-7]|[78]\\d)|6(?:20|3[035]|4[045]|5[05]|77|8[1-9]|9[059])|(?:7[5-8]|8\\d)\\d)\\d{5}"
                ]
            ]
        ],
        "NL": [
            "31",
            "00",
            "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4,7})",
                    "$1 $2",
                    [
                        "[89]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "66"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{8})",
                    "$1 $2",
                    [
                        "6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-578]|91"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:6[1-58]|970\\d)\\d{7}",
                    [
                        9,
                        11
                    ]
                ]
            ]
        ],
        "NO": [
            "47",
            "00",
            "(?:0|[2-9]\\d{3})\\d{4}",
            [
                5,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-79]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            "[02-689]|7[0-8]",
            [
                0,
                [
                    "(?:4[015-8]|9\\d)\\d{6}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "NP": [
            "977",
            "00",
            "(?:1\\d|9)\\d{9}|[1-9]\\d{7}",
            [
                8,
                10,
                11
            ],
            [
                [
                    "(\\d)(\\d{7})",
                    "$1-$2",
                    [
                        "1[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1-$2",
                    [
                        "1[01]|[2-8]|9(?:[1-59]|[67][2-6])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1-$2",
                    [
                        "9"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "9(?:6[0-3]|7[024-6]|8[0-24-68])\\d{7}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "NR": [
            "674",
            "00",
            "(?:444|(?:55|8\\d)\\d|666)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[4-68]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:55[3-9]|666|8\\d\\d)\\d{4}"
                ]
            ]
        ],
        "NU": [
            "683",
            "00",
            "(?:[4-7]|888\\d)\\d{3}",
            [
                4,
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "8"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:[56]|888[1-9])\\d{3}"
                ]
            ]
        ],
        "NZ": [
            "64",
            "0(?:0|161)",
            "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3,8})",
                    "$1 $2",
                    [
                        "8[1-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "50[036-8]|8|90",
                        "50(?:[0367]|88)|8|90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "24|[346]|7[2-57-9]|9[2-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2(?:10|74)|[589]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1|2[028]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,5})",
                    "$1 $2 $3",
                    [
                        "2(?:[169]|7[0-35-9])|7"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "2(?:[0-27-9]\\d|6)\\d{6,7}|2(?:1\\d|75)\\d{5}",
                    [
                        8,
                        9,
                        10
                    ]
                ]
            ],
            "00"
        ],
        "OM": [
            "968",
            "00",
            "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4,6})",
                    "$1 $2",
                    [
                        "[58]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[179]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "1505\\d{4}|(?:7(?:[1289]\\d|6[89]|7[0-5])|9(?:0[1-9]|[1-9]\\d))\\d{5}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "PA": [
            "507",
            "00",
            "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}",
            [
                7,
                8,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[1-57-9]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "[68]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:1[16]1|21[89]|6\\d{3}|8(?:1[01]|7[23]))\\d{4}",
                    [
                        7,
                        8
                    ]
                ]
            ]
        ],
        "PE": [
            "51",
            "00|19(?:1[124]|77|90)00",
            "(?:[14-8]|9\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[4-8]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "9\\d{8}",
                    [
                        9
                    ]
                ]
            ],
            "00",
            " Anexo "
        ],
        "PF": [
            "689",
            "00",
            "4\\d{5}(?:\\d{2})?|8\\d{7,8}",
            [
                6,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "44"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "4|8[7-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "8[7-9]\\d{6}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "PG": [
            "675",
            "00|140[1-3]",
            "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "18|[2-69]|85"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[78]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:7\\d|8[128])\\d{6}",
                    [
                        8
                    ]
                ]
            ],
            "00"
        ],
        "PH": [
            "63",
            "00",
            "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}",
            [
                6,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d)(\\d{5})",
                    "$1 $2",
                    [
                        "2"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{4})(\\d{4,6})",
                    "$1 $2",
                    [
                        "3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2",
                        "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "346|4(?:27|9[35])|883",
                        "3469|4(?:279|9(?:30|56))|8834"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-7]|8[2-8]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "1"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:8(?:1[37]|9[5-8])|9(?:0[5-9]|1[0-24-9]|[235-7]\\d|4[2-9]|8[135-9]|9[1-9]))\\d{7}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "PK": [
            "92",
            "00",
            "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}",
            [
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{2,7})",
                    "$1 $2 $3",
                    [
                        "[89]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6,7})",
                    "$1 $2",
                    [
                        "2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])",
                        "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{7,8})",
                    "$1 $2",
                    [
                        "(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "58"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[24-9]"
                    ],
                    "(0$1)"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "3(?:[0-247]\\d|3[0-79]|55|64)\\d{7}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "PL": [
            "48",
            "00",
            "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{5})",
                    "$1",
                    [
                        "19"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "11|20|64"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1",
                        "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "64"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[2-8]|[2-7]|8[1-79]|9[145]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "21(?:1(?:[145]\\d|3[1-5])|2\\d\\d)\\d{4}|(?:45|5[0137]|6[069]|7[2389]|88)\\d{7}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "PM": [
            "508",
            "00",
            "[45]\\d{5}|(?:708|80\\d)\\d{6}",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[45]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:4[02-4]|5[056]|708[45][0-5])\\d{4}"
                ]
            ]
        ],
        "PR": [
            "1",
            "011",
            "(?:[589]\\d\\d|787)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "787|939",
            [
                0,
                [
                    "(?:787|939)[2-9]\\d{6}"
                ]
            ]
        ],
        "PS": [
            "970",
            "00",
            "[2489]2\\d{6}|(?:1\\d|5)\\d{8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2489]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "5[69]\\d{7}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "PT": [
            "351",
            "00",
            "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[12]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "16|[236-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "6(?:[06]92(?:30|9\\d)|[35]92(?:3[03]|9\\d))\\d{3}|(?:(?:16|6[0356])93|9(?:[1-36]\\d\\d|480))\\d{5}"
                ]
            ]
        ],
        "PW": [
            "680",
            "01[12]",
            "(?:[24-8]\\d\\d|345|900)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:(?:46|83)[0-5]|6[2-4689]0)\\d{4}|(?:45|77|88)\\d{5}"
                ]
            ]
        ],
        "PY": [
            "595",
            "00",
            "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3,6})",
                    "$1 $2",
                    [
                        "[2-9]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{4,5})",
                    "$1 $2",
                    [
                        "2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "87"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "9(?:[5-79]|8[1-6])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "9(?:51|6[129]|[78][1-6]|9[1-5])\\d{6}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "QA": [
            "974",
            "00",
            "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}",
            [
                7,
                8,
                9,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "2[16]|8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[3-7]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "[35-7]\\d{7}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "RE": [
            "262",
            "00",
            "(?:26|[689]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2689]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "69(?:2\\d\\d|3(?:[06][0-6]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))\\d{4}"
                ]
            ]
        ],
        "RO": [
            "40",
            "00",
            "(?:[2378]\\d|62|90)\\d{7}|[23]\\d{5}",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "2[3-6]",
                        "2[3-6]\\d9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "219|31"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[23]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[236-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "7020\\d{5}|(?:62\\d|7(?:0[013-9]|1[0-3]|[2-7]\\d|8[03-8]|9[0-39]))\\d{6}",
                    [
                        9
                    ]
                ]
            ],
            0,
            " int "
        ],
        "RS": [
            "381",
            "00",
            "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}",
            [
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3,9})",
                    "$1 $2",
                    [
                        "(?:2[389]|39)0|[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5,10})",
                    "$1 $2",
                    [
                        "[1-36]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "6(?:[0-689]|7\\d)\\d{6,7}",
                    [
                        8,
                        9,
                        10
                    ]
                ]
            ]
        ],
        "RU": [
            "7",
            "810",
            "8\\d{13}|[347-9]\\d{9}",
            [
                10,
                14
            ],
            [
                [
                    "(\\d{4})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "7(?:1[0-8]|2[1-9])",
                        "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))",
                        "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{5})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "7(?:1[0-68]|2[1-9])",
                        "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))",
                        "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[349]|8(?:[02-7]|1[1-8])"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "8 ($1)"
                ]
            ],
            "8",
            0,
            0,
            0,
            0,
            "3[04-689]|[489]",
            [
                0,
                [
                    "9\\d{9}",
                    [
                        10
                    ]
                ]
            ],
            "8~10"
        ],
        "RW": [
            "250",
            "00",
            "(?:06|[27]\\d\\d|[89]00)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "7[237-9]\\d{7}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "SA": [
            "966",
            "00",
            "92\\d{7}|(?:[15]|8\\d)\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "81"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "579[01]\\d{5}|5(?:[013-689]\\d|7[0-8])\\d{6}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "SB": [
            "677",
            "0[01]",
            "(?:[1-6]|[7-9]\\d\\d)\\d{4}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "7|8[4-9]|9(?:[1-8]|9[0-8])"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "48\\d{3}|(?:(?:7[1-9]|8[4-9])\\d|9(?:1[2-9]|2[013-9]|3[0-2]|[46]\\d|5[0-46-9]|7[0-689]|8[0-79]|9[0-8]))\\d{4}"
                ]
            ]
        ],
        "SC": [
            "248",
            "010|0[0-2]",
            "800\\d{4}|(?:[249]\\d|64)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[246]|9[57]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "2[125-8]\\d{5}"
                ]
            ],
            "00"
        ],
        "SD": [
            "249",
            "00",
            "[19]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[19]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:1[0-2]|9[0-3569])\\d{7}"
                ]
            ]
        ],
        "SE": [
            "46",
            "00",
            "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2,3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "20"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "9(?:00|39|44|9)"
                    ],
                    "0$1",
                    0,
                    "$1 $2"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "[12][136]|3[356]|4[0246]|6[03]|90[1-9]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d)(\\d{2,3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{3})",
                    "$1-$2 $3",
                    [
                        "9(?:00|39|44)"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "10|7"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{3})",
                    "$1-$2 $3 $4",
                    [
                        "9"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4 $5",
                    [
                        "[26]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4 $5"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "7[02369]\\d{7}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "SG": [
            "65",
            "0[0-3]\\d",
            "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}",
            [
                8,
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[369]|8(?:0[1-8]|[1-9])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "8(?:08[013]|95[0-2])\\d{4}|(?:8(?:0[1-7]|[1-8]\\d|9[0-4])|9[0-8]\\d)\\d{5}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "SH": [
            "290",
            "00",
            "(?:[256]\\d|8)\\d{3}",
            [
                4,
                5
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "[256]",
            [
                0,
                [
                    "[56]\\d{4}",
                    [
                        5
                    ]
                ]
            ]
        ],
        "SI": [
            "386",
            "00|10(?:22|66|88|99)",
            "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}",
            [
                5,
                6,
                7,
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3,6})",
                    "$1 $2",
                    [
                        "8[09]|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "59|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[37][01]|4[0139]|51|6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[1-57]"
                    ],
                    "(0$1)"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "65(?:[178]\\d|5[56]|6[01])\\d{4}|(?:[37][01]|4[0139]|51|6[489])\\d{6}",
                    [
                        8
                    ]
                ]
            ],
            "00"
        ],
        "SJ": [
            "47",
            "00",
            "0\\d{4}|(?:[489]\\d|79)\\d{6}",
            [
                5,
                8
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "79",
            [
                0,
                [
                    "(?:4[015-8]|9\\d)\\d{6}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "SK": [
            "421",
            "00",
            "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}",
            [
                6,
                7,
                9
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "21"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[3-5][1-8]1",
                        "[3-5][1-8]1[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                    "$1/$2 $3 $4",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[689]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1/$2 $3 $4",
                    [
                        "[3-5]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "909[1-9]\\d{5}|9(?:0[1-8]|1[0-24-9]|4[03-57-9]|5\\d)\\d{6}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "SL": [
            "232",
            "00",
            "(?:[237-9]\\d|66)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[236-9]"
                    ],
                    "(0$1)"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:25|3[0-5]|66|7[2-9]|8[08]|9[09])\\d{6}"
                ]
            ]
        ],
        "SM": [
            "378",
            "00",
            "(?:0549|[5-7]\\d)\\d{6}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-7]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ]
            ],
            0,
            0,
            "([89]\\d{5})$",
            "0549$1",
            0,
            0,
            [
                0,
                [
                    "6[16]\\d{6}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "SN": [
            "221",
            "00",
            "(?:[378]\\d|93)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[379]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "7(?:(?:[06-8]\\d|21|90)\\d|5(?:01|[19]0|25|[38]3|[4-7]\\d))\\d{5}"
                ]
            ]
        ],
        "SO": [
            "252",
            "00",
            "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "8[125]"
                    ]
                ],
                [
                    "(\\d{6})",
                    "$1",
                    [
                        "[134]"
                    ]
                ],
                [
                    "(\\d)(\\d{6})",
                    "$1 $2",
                    [
                        "[15]|2[0-79]|3[0-46-8]|4[0-7]"
                    ]
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "(?:2|90)4|[67]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[348]|64|79|90"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5,7})",
                    "$1 $2",
                    [
                        "1|28|6[0-35-9]|77|9[2-9]"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:(?:15|(?:3[59]|4[89]|6\\d|7[79]|8[08])\\d|9(?:0\\d|[2-9]))\\d|2(?:4\\d|8))\\d{5}|(?:[67]\\d\\d|904)\\d{5}",
                    [
                        7,
                        8,
                        9
                    ]
                ]
            ]
        ],
        "SR": [
            "597",
            "00",
            "(?:[2-5]|68|[78]\\d)\\d{5}",
            [
                6,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1-$2-$3",
                    [
                        "56"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})",
                    "$1-$2",
                    [
                        "[2-5]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[6-8]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:7[124-7]|8[124-9])\\d{5}",
                    [
                        7
                    ]
                ]
            ]
        ],
        "SS": [
            "211",
            "00",
            "[19]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[19]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:12|9[1257-9])\\d{7}"
                ]
            ]
        ],
        "ST": [
            "239",
            "00",
            "(?:22|9\\d)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[29]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "900[5-9]\\d{3}|9(?:0[1-9]|[89]\\d)\\d{4}"
                ]
            ]
        ],
        "SV": [
            "503",
            "00",
            "[267]\\d{7}|[89]00\\d{4}(?:\\d{4})?",
            [
                7,
                8,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[89]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[267]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "[67]\\d{7}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "SX": [
            "1",
            "011",
            "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "(5\\d{6})$|1",
            "721$1",
            0,
            "721",
            [
                0,
                [
                    "7215(?:1[02]|2\\d|5[034679]|8[014-8])\\d{4}"
                ]
            ]
        ],
        "SY": [
            "963",
            "00",
            "[1-39]\\d{8}|[1-5]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-5]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "9[1-689]\\d{7}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "SZ": [
            "268",
            "00",
            "0800\\d{4}|(?:[237]\\d|900)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[0237]"
                    ]
                ],
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "7[6-9]\\d{6}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "TA": [
            "290",
            "00",
            "8\\d{3}",
            [
                4
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "8"
        ],
        "TC": [
            "1",
            "011",
            "(?:[58]\\d\\d|649|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-479]\\d{6})$|1",
            "649$1",
            0,
            "649",
            [
                0,
                [
                    "649(?:2(?:3[129]|4[1-79])|3\\d\\d|4[34][1-3])\\d{4}"
                ]
            ]
        ],
        "TD": [
            "235",
            "00|16",
            "(?:22|[69]\\d|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2679]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:6[0235689]|77|9\\d)\\d{6}"
                ]
            ],
            "00"
        ],
        "TG": [
            "228",
            "00",
            "[279]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[279]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:7[019]|9[0-36-9])\\d{6}"
                ]
            ]
        ],
        "TH": [
            "66",
            "00[1-9]",
            "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}",
            [
                8,
                9,
                10,
                13
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[13-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "671[0-8]\\d{5}|(?:14|6[1-6]|[89]\\d)\\d{7}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "TJ": [
            "992",
            "810",
            "[0-57-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{6})(\\d)(\\d{2})",
                    "$1 $2 $3",
                    [
                        "331",
                        "3317"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "44[02-479]|[34]7"
                    ]
                ],
                [
                    "(\\d{4})(\\d)(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3[1-5]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[0-57-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:4(?:1[18]|4[02-479])|81[1-9])\\d{6}|(?:0[0-57-9]|1[017]|2[02]|[34]0|5[05]|7[0178]|8[078]|9\\d)\\d{7}"
                ]
            ],
            "8~10"
        ],
        "TK": [
            "690",
            "00",
            "[2-47]\\d{3,6}",
            [
                4,
                5,
                6,
                7
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "7[2-4]\\d{2,5}"
                ]
            ]
        ],
        "TL": [
            "670",
            "00",
            "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-489]|70"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "7[2-8]\\d{6}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "TM": [
            "993",
            "810",
            "[1-6]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "12"
                    ],
                    "(8 $1)"
                ],
                [
                    "(\\d{3})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[1-5]"
                    ],
                    "(8 $1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "6"
                    ],
                    "8 $1"
                ]
            ],
            "8",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "6\\d{7}"
                ]
            ],
            "8~10"
        ],
        "TN": [
            "216",
            "00",
            "[2-57-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-57-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "3(?:001|[12]40)\\d{4}|(?:(?:[259]\\d|4[0-8])\\d|3(?:1[1-35]|6[0-4]|91))\\d{5}"
                ]
            ]
        ],
        "TO": [
            "676",
            "00",
            "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1-$2",
                    [
                        "[2-4]|50|6[09]|7[0-24-69]|8[05]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[5-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:55[4-6]|6(?:[09]\\d|3[02]|8[15-9])|(?:7\\d|8[46-9])\\d|999)\\d{4}",
                    [
                        7
                    ]
                ]
            ]
        ],
        "TR": [
            "90",
            "00",
            "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}",
            [
                7,
                10,
                12,
                13
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "512|8[01589]|90"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "5(?:[0-59]|61)",
                        "5(?:[0-59]|61[06])",
                        "5(?:[0-59]|61[06]1)"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24][1-8]|3[1-9]"
                    ],
                    "(0$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{6,7})",
                    "$1 $2 $3",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "561(?:011|61\\d)\\d{4}|5(?:0[15-7]|1[06]|24|[34]\\d|5[1-59]|9[46])\\d{7}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "TT": [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-46-8]\\d{6})$|1",
            "868$1",
            0,
            "868",
            [
                0,
                [
                    "868(?:(?:2[5-9]|3\\d)\\d|4(?:3[0-6]|[6-9]\\d)|6(?:20|78|8\\d)|7(?:0[1-9]|1[02-9]|[2-9]\\d))\\d{4}"
                ]
            ]
        ],
        "TV": [
            "688",
            "00",
            "(?:2|7\\d\\d|90)\\d{4}",
            [
                5,
                6,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "90"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:7[01]\\d|90)\\d{4}",
                    [
                        6,
                        7
                    ]
                ]
            ]
        ],
        "TW": [
            "886",
            "0(?:0[25-79]|19)",
            "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}",
            [
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d)(\\d{4})",
                    "$1 $2 $3",
                    [
                        "202"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[258]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]",
                        "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:40001[0-2]|9[0-8]\\d{4})\\d{3}",
                    [
                        9
                    ]
                ]
            ],
            0,
            "#"
        ],
        "TZ": [
            "255",
            "00[056]",
            "(?:[25-8]\\d|41|90)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[24]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[67]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "77[2-9]\\d{6}|(?:6[125-9]|7[13-689])\\d{7}"
                ]
            ]
        ],
        "UA": [
            "380",
            "00",
            "[89]\\d{9}|[3-9]\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]",
                        "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])",
                        "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-7]|89|9[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:39|50|6[36-8]|7[1-3]|9[1-9])\\d{7}",
                    [
                        9
                    ]
                ]
            ],
            "0~0"
        ],
        "UG": [
            "256",
            "00[057]",
            "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "202",
                        "2024"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[27-9]|4(?:6[45]|[7-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "[34]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "726[01]\\d{5}|7(?:[015-8]\\d|20|36|4[0-4]|9[89])\\d{6}"
                ]
            ]
        ],
        "US": [
            "1",
            "011",
            "[2-9]\\d{9}|3\\d{6}",
            [
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "310"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "($1) $2-$3",
                    [
                        "[2-9]"
                    ],
                    0,
                    1,
                    "$1-$2-$3"
                ]
            ],
            "1",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:5056(?:[0-35-9]\\d|4[468])|73020\\d)\\d{4}|(?:4722|505[2-57-9]|983[289])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[013569]|3[0-24679]|4[167]|5[0-2]|6[0149]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"
                ]
            ]
        ],
        "UY": [
            "598",
            "0(?:0|1[3-9]\\d)",
            "0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}",
            [
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d{3})(\\d{3,4})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[49]0|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[124]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "9[1-9]\\d{6}",
                    [
                        8
                    ]
                ]
            ],
            "00",
            " int. "
        ],
        "UZ": [
            "998",
            "810",
            "(?:20|33|[5-79]\\d|88)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[235-9]"
                    ],
                    "8 $1"
                ]
            ],
            "8",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:(?:[25]0|33|88|9[0-57-9])\\d{3}|6(?:1(?:2(?:2[01]|98)|35[0-4]|50\\d|61[23]|7(?:[01][017]|4\\d|55|9[5-9]))|2(?:(?:11|7\\d)\\d|2(?:[12]1|9[01379])|5(?:[126]\\d|3[0-4]))|5(?:19[01]|2(?:27|9[26])|(?:30|59|7\\d)\\d)|6(?:2(?:1[5-9]|2[0367]|38|41|52|60)|(?:3[79]|9[0-3])\\d|4(?:56|83)|7(?:[07]\\d|1[017]|3[07]|4[047]|5[057]|67|8[0178]|9[79]))|7(?:2(?:24|3[237]|4[5-9]|7[15-8])|5(?:7[12]|8[0589])|7(?:0\\d|[39][07])|9(?:0\\d|7[079]))|9(?:2(?:1[1267]|3[01]|5\\d|7[0-4])|(?:5[67]|7\\d)\\d|6(?:2[0-26]|8\\d)))|7(?:[07]\\d{3}|1(?:13[01]|6(?:0[47]|1[67]|66)|71[3-69]|98\\d)|2(?:2(?:2[79]|95)|3(?:2[5-9]|6[0-6])|57\\d|7(?:0\\d|1[17]|2[27]|3[37]|44|5[057]|66|88))|3(?:2(?:1[0-6]|21|3[469]|7[159])|(?:33|9[4-6])\\d|5(?:0[0-4]|5[579]|9\\d)|7(?:[0-3579]\\d|4[0467]|6[67]|8[078]))|4(?:2(?:29|5[0257]|6[0-7]|7[1-57])|5(?:1[0-4]|8\\d|9[5-9])|7(?:0\\d|1[024589]|2[0-27]|3[0137]|[46][07]|5[01]|7[5-9]|9[079])|9(?:7[015-9]|[89]\\d))|5(?:112|2(?:0\\d|2[29]|[49]4)|3[1568]\\d|52[6-9]|7(?:0[01578]|1[017]|[23]7|4[047]|[5-7]\\d|8[78]|9[079]))|9(?:22[128]|3(?:2[0-4]|7\\d)|57[02569]|7(?:2[05-9]|3[37]|4\\d|60|7[2579]|87|9[07]))))\\d{4}"
                ]
            ],
            "8~10"
        ],
        "VA": [
            "39",
            "00",
            "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "06698",
            [
                0,
                [
                    "3[1-9]\\d{8}|3[2-9]\\d{7}",
                    [
                        9,
                        10
                    ]
                ]
            ]
        ],
        "VC": [
            "1",
            "011",
            "(?:[58]\\d\\d|784|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-7]\\d{6})$|1",
            "784$1",
            0,
            "784",
            [
                0,
                [
                    "784(?:4(?:3[0-5]|5[45]|89|9[0-8])|5(?:2[6-9]|3[0-4])|720)\\d{4}"
                ]
            ]
        ],
        "VE": [
            "58",
            "00",
            "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}",
            [
                10
            ],
            [
                [
                    "(\\d{3})(\\d{7})",
                    "$1-$2",
                    [
                        "[24-689]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "4(?:1[24-8]|2[46])\\d{7}"
                ]
            ]
        ],
        "VG": [
            "1",
            "011",
            "(?:284|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-578]\\d{6})$|1",
            "284$1",
            0,
            "284",
            [
                0,
                [
                    "284(?:245|3(?:0[0-3]|4[0-7]|68|9[34])|4(?:4[0-6]|68|9[69])|5(?:4[0-7]|68|9[69]))\\d{4}"
                ]
            ]
        ],
        "VI": [
            "1",
            "011",
            "[58]\\d{9}|(?:34|90)0\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "340$1",
            0,
            "340",
            [
                0,
                [
                    "340(?:2(?:0[0-368]|2[06-8]|4[49]|77)|3(?:32|44)|4(?:2[23]|44|7[34]|89)|5(?:1[34]|55)|6(?:2[56]|4[23]|77|9[023])|7(?:1[2-57-9]|2[57]|7\\d)|884|998)\\d{4}"
                ]
            ]
        ],
        "VN": [
            "84",
            "00",
            "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{4,6})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "6"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[357-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[48]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:5(?:2[238]|59)|89[6-9]|99[013-9])\\d{6}|(?:3\\d|5[1689]|7[06-9]|8[1-8]|9[0-8])\\d{7}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "VU": [
            "678",
            "00",
            "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[57-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:[58]\\d|7[013-7])\\d{5}",
                    [
                        7
                    ]
                ]
            ]
        ],
        "WF": [
            "681",
            "00",
            "(?:40|72)\\d{4}|8\\d{5}(?:\\d{3})?",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[478]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:72|8[23])\\d{4}",
                    [
                        6
                    ]
                ]
            ]
        ],
        "WS": [
            "685",
            "0",
            "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}",
            [
                5,
                6,
                7,
                10
            ],
            [
                [
                    "(\\d{5})",
                    "$1",
                    [
                        "[2-5]|6[1-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1 $2",
                    [
                        "[68]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:7[1-35-7]|8(?:[3-7]|9\\d{3}))\\d{5}",
                    [
                        7,
                        10
                    ]
                ]
            ]
        ],
        "XK": [
            "383",
            "00",
            "[23]\\d{7,8}|(?:4\\d\\d|[89]00)\\d{5}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[23]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "4[3-9]\\d{6}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "YE": [
            "967",
            "00",
            "(?:1|7\\d)\\d{7}|[1-7]\\d{6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-6]|7(?:[24-6]|8[0-7])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "7[01378]\\d{7}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "YT": [
            "262",
            "00",
            "(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])\\d{4}"
                ]
            ]
        ],
        "ZA": [
            "27",
            "00",
            "[1-79]\\d{8}|8\\d{4,9}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1 $2",
                    [
                        "8[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "8[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "860"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:1(?:3492[0-25]|4495[0235]|549(?:20|5[01]))|4[34]492[01])\\d{3}|8[1-4]\\d{3,7}|(?:2[27]|47|54)4950\\d{3}|(?:1(?:049[2-4]|9[12]\\d\\d)|(?:6\\d|7[0-46-9])\\d{3}|8(?:5\\d{3}|7(?:08[67]|158|28[5-9]|310)))\\d{4}|(?:1[6-8]|28|3[2-69]|4[025689]|5[36-8])4920\\d{3}|(?:12|[2-5]1)492\\d{4}",
                    [
                        5,
                        6,
                        7,
                        8,
                        9
                    ]
                ]
            ]
        ],
        "ZM": [
            "260",
            "00",
            "800\\d{6}|(?:21|63|[79]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[28]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "[79]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:7[5-79]|9[5-8])\\d{7}"
                ]
            ]
        ],
        "ZW": [
            "263",
            "00",
            "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{3,5})",
                    "$1 $2",
                    [
                        "2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2",
                        "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)",
                        "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,5})",
                    "$1 $2",
                    [
                        "1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "29[013-9]|39|54"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,5})",
                    "$1 $2",
                    [
                        "(?:25|54)8",
                        "258|5483"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "7(?:[178]\\d|3[1-9])\\d{6}",
                    [
                        9
                    ]
                ]
            ]
        ]
    },
    "nonGeographic": {
        "800": [
            "800",
            0,
            "(?:00|[1-9]\\d)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "\\d"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                [
                    "(?:00|[1-9]\\d)\\d{6}"
                ]
            ]
        ],
        "808": [
            "808",
            0,
            "[1-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[1-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "[1-9]\\d{7}"
                ]
            ]
        ],
        "870": [
            "870",
            0,
            "7\\d{11}|[35-7]\\d{8}",
            [
                9,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[35-7]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"
                ]
            ]
        ],
        "878": [
            "878",
            0,
            "10\\d{10}",
            [
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "10\\d{10}"
                ]
            ]
        ],
        "881": [
            "881",
            0,
            "6\\d{9}|[0-36-9]\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[0-37-9]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{5,6})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "6\\d{9}|[0-36-9]\\d{8}"
                ]
            ]
        ],
        "882": [
            "882",
            0,
            "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "16|342"
                    ]
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "49"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1[36]|9"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "3[23]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "16"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "10|23|3(?:[15]|4[57])|4|51"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "34"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4,5})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[1-35]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}",
                    [
                        7,
                        8,
                        9,
                        10,
                        12
                    ]
                ],
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"
                ]
            ]
        ],
        "883": [
            "883",
            0,
            "(?:[1-4]\\d|51)\\d{6,10}",
            [
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{2,8})",
                    "$1 $2 $3",
                    [
                        "[14]|2[24-689]|3[02-689]|51[24-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "510"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "21"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "51[13]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[235]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"
                ]
            ]
        ],
        "888": [
            "888",
            0,
            "\\d{11}",
            [
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1 $2 $3"
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "\\d{11}"
                ]
            ]
        ],
        "979": [
            "979",
            0,
            "[1359]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1359]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                [
                    "[1359]\\d{8}"
                ]
            ]
        ]
    }
};


function $036559a4d8f4d583$export$2e2bcd8739ae039(func, _arguments) {
    var args = Array.prototype.slice.call(_arguments);
    args.push((0, $4b3438e9ed9332db$export$2e2bcd8739ae039));
    return func.apply(this, args);
}



function $6dfcdea52315509f$export$2e2bcd8739ae039(metadata) {
    return new (0, $3542b2b23489a694$export$2e2bcd8739ae039)(metadata).getCountries();
}


function $95330c9b390639ae$export$44f7508c6c352cc6() {
    return (0, $036559a4d8f4d583$export$2e2bcd8739ae039)((0, $6dfcdea52315509f$export$2e2bcd8739ae039), arguments);
}



function $019816c1aaf5d79d$export$32876ca2f1919cf0() {
    return (0, $036559a4d8f4d583$export$2e2bcd8739ae039)((0, $3542b2b23489a694$export$32876ca2f1919cf0), arguments);
}



function $a434de0db86aeebd$export$176bb591929cc9a8() {
    return (0, $036559a4d8f4d583$export$2e2bcd8739ae039)((0, $c832506221b95168$export$2e2bcd8739ae039), arguments);
}


const $dc69be136f5b72f6$export$4154d15e6abcdc1 = "US";
const $dc69be136f5b72f6$export$f69fd5b458c8e2d = {
    zh: "CN",
    en: "US"
};
const $dc69be136f5b72f6$export$3c2105ee38ea5c77 = (countryCode)=>{
    try {
        // Use getCountryCallingCode method to guard the input's value is in CountryCode union type, if type not match exceptions are expected
        // eslint-disable-next-line no-restricted-syntax
        (0, $019816c1aaf5d79d$export$32876ca2f1919cf0)(countryCode);
        return true;
    } catch (e) {
        return false;
    }
};
const $dc69be136f5b72f6$export$4e6096437c36f4c2 = ()=>{
    const { language: language } = (0, $86e325ac3ddbcfa1$export$2e2bcd8739ae039);
    // Extract the country code from language tag suffix
    const [languageCode, countryCode] = language.split("-");
    if (countryCode && $dc69be136f5b72f6$export$3c2105ee38ea5c77(countryCode)) return countryCode;
    const upperCaseLanguageCode = languageCode === null || languageCode === void 0 ? void 0 : languageCode.toUpperCase();
    if (upperCaseLanguageCode && $dc69be136f5b72f6$export$3c2105ee38ea5c77(upperCaseLanguageCode)) return upperCaseLanguageCode;
    var _countryCallingCodeMap_language;
    return (_countryCallingCodeMap_language = $dc69be136f5b72f6$export$f69fd5b458c8e2d[language]) !== null && _countryCallingCodeMap_language !== void 0 ? _countryCallingCodeMap_language : $dc69be136f5b72f6$export$4154d15e6abcdc1;
};
const $dc69be136f5b72f6$export$93cb54c01a2c1072 = ()=>(0, $019816c1aaf5d79d$export$32876ca2f1919cf0)($dc69be136f5b72f6$export$4e6096437c36f4c2());
const $dc69be136f5b72f6$export$4fa5c00ca385a5d = ()=>{
    const defaultCountryCode = $dc69be136f5b72f6$export$4e6096437c36f4c2();
    const defaultCountryCallingCode = (0, $019816c1aaf5d79d$export$32876ca2f1919cf0)(defaultCountryCode);
    const countryList = (0, $95330c9b390639ae$export$44f7508c6c352cc6)().map((code)=>({
            countryCode: code,
            countryCallingCode: (0, $019816c1aaf5d79d$export$32876ca2f1919cf0)(code)
        }))// Filter the detected default countryCode & duplicates
    .filter(({ countryCallingCode: countryCallingCode }, index, self)=>{
        if (countryCallingCode === defaultCountryCallingCode) return false;
        return self.findIndex((element)=>element.countryCallingCode === countryCallingCode) === index;
    }).slice()// Sort by countryCallingCode
    .sort((previous, next)=>next.countryCallingCode > previous.countryCallingCode ? -1 : 1);
    return [
        {
            countryCode: defaultCountryCode,
            countryCallingCode: defaultCountryCallingCode
        },
        ...countryList
    ];
};
const $dc69be136f5b72f6$export$9974d4de222cbb3a = (value)=>{
    if (!value || value.startsWith("+")) return value;
    return `+${value}`;
};
const $dc69be136f5b72f6$export$79abe912f70ec8f5 = (number)=>{
    try {
        const phoneNumber = (0, $a434de0db86aeebd$export$176bb591929cc9a8)($dc69be136f5b72f6$export$9974d4de222cbb3a(number));
        return `+${phoneNumber.countryCallingCode} ${phoneNumber.nationalNumber}`;
    } catch (e) {
        return number;
    }
};
const $dc69be136f5b72f6$export$da44e4eaa54bc82e = (value)=>{
    try {
        const phoneNumber = (0, $a434de0db86aeebd$export$176bb591929cc9a8)($dc69be136f5b72f6$export$9974d4de222cbb3a(value));
        return {
            countryCallingCode: phoneNumber.countryCallingCode,
            nationalNumber: phoneNumber.nationalNumber
        };
    } catch (e) {}
};







var $P551f = parcelRequire("P551f");






parcelRequire("P551f");
const $fbc3e4916fff3b85$var$SvgSearchIcon = (props)=>/*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("svg", (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({
        width: 16,
        height: 17,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M6 10.5a4 4 0 1 1 0-8 4 4 0 0 1 0 8Zm9.707 4.293-4.82-4.82A5.968 5.968 0 0 0 12 6.5a6 6 0 0 0-12 0 6 6 0 0 0 6 6 5.968 5.968 0 0 0 3.473-1.113l4.82 4.82a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414Z",
            fill: "currentcolor"
        })
    }));
var $fbc3e4916fff3b85$export$2e2bcd8739ae039 = $fbc3e4916fff3b85$var$SvgSearchIcon;




/**
 * Original Reference: https://github.com/juliencrn/usehooks-ts/blob/master/src/useDebounce/useDebounce.ts
 *
 * The MIT License (MIT)
 *
 * Copyright (c) 2020 Julien CARON
 *Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ 
var $P551f = parcelRequire("P551f");
function $ba0959f2a8d29b9c$var$useDebounce(value, delay) {
    const [debouncedValue, setDebouncedValue] = (0, $P551f.useState)(value);
    (0, $P551f.useEffect)(()=>{
        const timer = setTimeout(()=>{
            setDebouncedValue(value);
        }, delay !== null && delay !== void 0 ? delay : 500);
        return ()=>{
            clearTimeout(timer);
        };
    }, [
        value,
        delay
    ]);
    return debouncedValue;
}
var $ba0959f2a8d29b9c$export$2e2bcd8739ae039 = $ba0959f2a8d29b9c$var$useDebounce;




var $50ca20f83d4d7877$export$955245c47f738f8a;
var $50ca20f83d4d7877$export$ec06ab6513f0c8c6;
var $50ca20f83d4d7877$export$2c192705e93dd8a6;
var $50ca20f83d4d7877$export$1c1680d5365f3f93;
var $50ca20f83d4d7877$export$d4fb61928174ef64;
var $50ca20f83d4d7877$export$89da14300d534261;
var $50ca20f83d4d7877$export$d90250155de6d7e7;
var $50ca20f83d4d7877$export$a33e918cb4258370;
$50ca20f83d4d7877$export$955245c47f738f8a = "dropdownOverlay_ec29ff";
$50ca20f83d4d7877$export$ec06ab6513f0c8c6 = "dropdownModal_ec29ff";
$50ca20f83d4d7877$export$2c192705e93dd8a6 = "dropdownContent_ec29ff";
$50ca20f83d4d7877$export$1c1680d5365f3f93 = "searchInputField_ec29ff";
$50ca20f83d4d7877$export$d4fb61928174ef64 = "countryList_ec29ff";
$50ca20f83d4d7877$export$89da14300d534261 = "active_ec29ff";
$50ca20f83d4d7877$export$d90250155de6d7e7 = "selected_ec29ff";
$50ca20f83d4d7877$export$a33e918cb4258370 = "notFound_ec29ff";


const $428e1c9c88c154a2$var$CountryCodeDropdown = ({ isOpen: isOpen, countryCode: countryCode, countryList: countryList, inputRef: inputRef, onClose: onClose, onChange: onChange })=>{
    const { isMobile: isMobile } = (0, $37bc2555b7bb33e3$export$2e2bcd8739ae039)();
    const { t: t } = (0, $5d79e62c9ff74ac9$export$9fc83ad70ead8663)();
    const [searchValue, setSearchValue] = (0, $P551f.useState)("");
    const [position, setPosition] = (0, $P551f.useState)({});
    const [selectedCountryCode, setSelectedCountryCode] = (0, $P551f.useState)("");
    const debouncedSearchValue = (0, $ba0959f2a8d29b9c$export$2e2bcd8739ae039)(searchValue, 100);
    const onSearchChange = (0, $P551f.useCallback)(({ target: target })=>{
        setSearchValue(target.value);
    }, []);
    const onDestroy = (0, $P551f.useCallback)(()=>{
        setSearchValue("");
        onClose();
    }, [
        onClose
    ]);
    const onCodeChange = (0, $P551f.useCallback)((value)=>{
        onChange === null || onChange === void 0 ? void 0 : onChange(value);
        onDestroy();
    }, [
        onChange,
        onDestroy
    ]);
    const updatePosition = (0, $P551f.useCallback)(()=>{
        const parent = inputRef === null || inputRef === void 0 ? void 0 : inputRef.parentElement;
        const offset = 8;
        if (!isMobile && parent) {
            const { top: top, left: left, height: height, width: width } = parent.getBoundingClientRect();
            setPosition({
                top: top + height + offset,
                left: left,
                width: width
            });
            return;
        }
        setPosition({});
    }, [
        inputRef === null || inputRef === void 0 ? void 0 : inputRef.parentElement,
        isMobile
    ]);
    (0, $P551f.useLayoutEffect)(()=>{
        updatePosition();
        window.addEventListener("resize", updatePosition);
        window.addEventListener("scroll", updatePosition);
        return ()=>{
            window.removeEventListener("resize", updatePosition);
            window.removeEventListener("scroll", updatePosition);
        };
    }, [
        updatePosition
    ]);
    const filteredCountryList = (0, $P551f.useMemo)(()=>countryList.filter(({ countryCallingCode: countryCallingCode })=>{
            const searchValue = debouncedSearchValue.startsWith("+") ? debouncedSearchValue.slice(1) : debouncedSearchValue;
            return countryCallingCode.startsWith(searchValue);
        }), [
        countryList,
        debouncedSearchValue
    ]);
    (0, $P551f.useLayoutEffect)(()=>{
        var _filteredCountryList_;
        if (!debouncedSearchValue) {
            setSelectedCountryCode("");
            return;
        }
        // Auto Focus on the first available element
        const firstCountryCode = (_filteredCountryList_ = filteredCountryList[0]) === null || _filteredCountryList_ === void 0 ? void 0 : _filteredCountryList_.countryCallingCode;
        setSelectedCountryCode(firstCountryCode !== null && firstCountryCode !== void 0 ? firstCountryCode : "");
    }, [
        filteredCountryList,
        debouncedSearchValue
    ]);
    const onInputKeyDown = (0, $P551f.useCallback)((event)=>{
        const { key: key } = event;
        switch(key){
            case "Enter":
            case " ":
                event.preventDefault();
                event.stopPropagation();
                if (selectedCountryCode) onCodeChange(selectedCountryCode);
                break;
            case "Escape":
                event.preventDefault();
                event.stopPropagation();
                onDestroy();
                break;
            case "ArrowUp":
            case "ArrowLeft":
                {
                    event.preventDefault();
                    event.stopPropagation();
                    const currentSelectedIndex = filteredCountryList.findIndex(({ countryCallingCode: countryCallingCode })=>countryCallingCode === selectedCountryCode);
                    if (currentSelectedIndex <= 0) return;
                    const nextSelectedCountryCode = filteredCountryList[currentSelectedIndex - 1];
                    var _nextSelectedCountryCode_countryCallingCode;
                    setSelectedCountryCode((_nextSelectedCountryCode_countryCallingCode = nextSelectedCountryCode === null || nextSelectedCountryCode === void 0 ? void 0 : nextSelectedCountryCode.countryCallingCode) !== null && _nextSelectedCountryCode_countryCallingCode !== void 0 ? _nextSelectedCountryCode_countryCallingCode : "");
                    break;
                }
            case "-":
            case "e":
            case ".":
                event.preventDefault();
                event.stopPropagation();
                break;
            case "ArrowRight":
            case "ArrowDown":
                {
                    event.preventDefault();
                    event.stopPropagation();
                    const currentSelectedIndex = filteredCountryList.findIndex(({ countryCallingCode: countryCallingCode })=>countryCallingCode === selectedCountryCode);
                    if (currentSelectedIndex >= filteredCountryList.length - 1) return;
                    const nextSelectedCountryCode = filteredCountryList[currentSelectedIndex + 1];
                    var _nextSelectedCountryCode_countryCallingCode1;
                    setSelectedCountryCode((_nextSelectedCountryCode_countryCallingCode1 = nextSelectedCountryCode === null || nextSelectedCountryCode === void 0 ? void 0 : nextSelectedCountryCode.countryCallingCode) !== null && _nextSelectedCountryCode_countryCallingCode1 !== void 0 ? _nextSelectedCountryCode_countryCallingCode1 : "");
                    break;
                }
            default:
                break;
        }
    }, [
        filteredCountryList,
        onCodeChange,
        onDestroy,
        selectedCountryCode
    ]);
    (0, $P551f.useLayoutEffect)(()=>{
        const selectedItemDom = document.querySelector(`li[data-id="${selectedCountryCode}"]`);
        if (selectedItemDom) selectedItemDom.scrollIntoView({
            behavior: "smooth",
            block: "nearest"
        });
    }, [
        selectedCountryCode
    ]);
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e479b6ac5364ae16$exports))), {
        id: "country-code-dropdown",
        isOpen: isOpen,
        overlayClassName: $50ca20f83d4d7877$export$955245c47f738f8a,
        className: $50ca20f83d4d7877$export$ec06ab6513f0c8c6,
        style: {
            content: (0, $0de5391da8318002$export$581ff339ea0ba762)({}, position)
        },
        closeTimeoutMS: 200,
        onRequestClose: (event)=>{
            event.stopPropagation();
            onDestroy();
        },
        children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("div", {
            className: $50ca20f83d4d7877$export$2c192705e93dd8a6,
            role: "button",
            tabIndex: 0,
            onClick: (event)=>{
                // Prevent parent node trigger onClick show modal event
                event.stopPropagation();
            },
            onKeyDown: (event)=>{
                // Prevent parent node trigger onClick show modal event
                event.stopPropagation();
            },
            children: [
                isMobile && /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $c3a009e3761dfcb2$export$2e2bcd8739ae039), {
                    type: "back",
                    title: t("input.search_region_code"),
                    onClose: onDestroy
                }),
                /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $89edc8164fec0424$export$2e2bcd8739ae039), {
                    autoFocus: true,
                    name: "country-code-search",
                    type: "number",
                    min: 0,
                    prefix: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $fbc3e4916fff3b85$export$2e2bcd8739ae039), {}),
                    value: searchValue,
                    className: $50ca20f83d4d7877$export$1c1680d5365f3f93,
                    placeholder: t("input.search_region_code"),
                    onChange: onSearchChange,
                    onKeyDown: onInputKeyDown
                }),
                /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("ul", {
                    className: $50ca20f83d4d7877$export$d4fb61928174ef64,
                    children: filteredCountryList.map(({ countryCallingCode: countryCallingCode, countryCode: countryKeyCode })=>{
                        const isActive = countryCallingCode === countryCode;
                        const isSelected = countryCallingCode === selectedCountryCode;
                        return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("li", {
                            tabIndex: 0,
                            "data-id": countryCallingCode,
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($a6f0144cf2b2d456$exports)))((0, $dd763c2393b0d659$export$c327da55a124987a)(isActive && $50ca20f83d4d7877$export$89da14300d534261), (0, $dd763c2393b0d659$export$c327da55a124987a)(isSelected && $50ca20f83d4d7877$export$d90250155de6d7e7)),
                            // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
                            role: "button",
                            onKeyDown: (0, $f6f836671f603fea$export$c2c388d6a668999e)({
                                Enter: ()=>{
                                    onCodeChange(countryCallingCode);
                                }
                            }),
                            onClick: ()=>{
                                onCodeChange(countryCallingCode);
                            },
                            onMouseEnter: ()=>{
                                setSelectedCountryCode(countryCallingCode);
                            },
                            onMouseLeave: ()=>{
                                setSelectedCountryCode("");
                            },
                            children: [
                                isActive && /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $3e545ca7b4b2c19a$export$2e2bcd8739ae039), {}),
                                `+${countryCallingCode}`
                            ]
                        }, countryKeyCode);
                    })
                }),
                filteredCountryList.length === 0 && /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("div", {
                    className: $50ca20f83d4d7877$export$a33e918cb4258370,
                    children: t("description.no_region_code_found")
                })
            ]
        })
    });
};
var $428e1c9c88c154a2$export$2e2bcd8739ae039 = $428e1c9c88c154a2$var$CountryCodeDropdown;


var $ece181d490c7be51$export$cb3d6e18dd82ab60;
$ece181d490c7be51$export$cb3d6e18dd82ab60 = `Q8dYkq_countryCodeSelector`;


const $cb56022ab74eb6f5$var$CountryCodeSelector = ({ className: className, value: value, inputRef: inputRef, isVisible: isVisible = true, onChange: onChange }, ref)=>{
    const [isDropdownOpen, setIsDropdownOpen] = (0, $P551f.useState)(false);
    const countryList = (0, $P551f.useMemo)((0, $dc69be136f5b72f6$export$4fa5c00ca385a5d), []);
    const defaultCountCode = (0, $P551f.useMemo)((0, $dc69be136f5b72f6$export$93cb54c01a2c1072), []);
    const showDropDown = ()=>{
        setIsDropdownOpen(true);
    };
    const hideDropDown = ()=>{
        setIsDropdownOpen(false);
    };
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    const countryCode = value || defaultCountCode;
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("div", {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a6f0144cf2b2d456$exports)))($ece181d490c7be51$export$cb3d6e18dd82ab60, className),
        role: "button",
        tabIndex: isVisible ? 0 : -1,
        onClick: showDropDown,
        onKeyDown: (0, $f6f836671f603fea$export$c2c388d6a668999e)({
            Enter: showDropDown
        }),
        children: [
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("span", {
                children: `+${countryCode}`
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $98ccf19a2b9ce7a6$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $428e1c9c88c154a2$export$2e2bcd8739ae039), {
                inputRef: inputRef,
                isOpen: isDropdownOpen,
                countryCode: countryCode,
                countryList: countryList,
                onClose: hideDropDown,
                onChange: onChange
            })
        ]
    });
};
var $cb56022ab74eb6f5$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $P551f.forwardRef)($cb56022ab74eb6f5$var$CountryCodeSelector);





var $P551f = parcelRequire("P551f");

var $P551f = parcelRequire("P551f");
const $4e2a69ac2c1fa4c6$var$useUpdateEffect = (effect, dependencies = [])=>{
    const isMounted = (0, $P551f.useRef)(false);
    (0, $P551f.useEffect)(()=>{
        if (!isMounted.current) {
            // eslint-disable-next-line @silverhand/fp/no-mutation
            isMounted.current = true;
            return;
        }
        return effect();
    }, [
        ...dependencies
    ]);
};
var $4e2a69ac2c1fa4c6$export$2e2bcd8739ae039 = $4e2a69ac2c1fa4c6$var$useUpdateEffect;








const { t: $5f609015ba424ff1$var$t } = (0, $86e325ac3ddbcfa1$export$2e2bcd8739ae039);
const $5f609015ba424ff1$export$729c1ad6a2d5e1a2 = (username)=>{
    if (!username) return "username_required";
    if (/^\d/.test(username)) return "username_should_not_start_with_number";
    if (!(0, $ca8ea17c0d092285$export$221be9ce6b96eec3).test(username)) return "username_invalid_charset";
};
const $5f609015ba424ff1$export$18148d12c805c5b0 = (email)=>{
    if (!(0, $ca8ea17c0d092285$export$bdb23a0789f9885e).test(email)) return "invalid_email";
};
const $5f609015ba424ff1$export$375cde19889b052f = (value)=>{
    try {
        const phoneNumber = (0, $a434de0db86aeebd$export$176bb591929cc9a8)((0, $dc69be136f5b72f6$export$9974d4de222cbb3a)(value));
        if (!phoneNumber.isValid()) return "invalid_phone";
    } catch (error) {
        if (error instanceof (0, $f05781b554dcd2cc$export$2e2bcd8739ae039)) return "invalid_phone";
        throw error;
    }
};
const $5f609015ba424ff1$export$1222f18ddc446c49 = (type, value)=>{
    switch(type){
        case (0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Username:
            return $5f609015ba424ff1$export$729c1ad6a2d5e1a2(value);
        case (0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Email:
            return $5f609015ba424ff1$export$18148d12c805c5b0(value);
        case (0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Phone:
            return $5f609015ba424ff1$export$375cde19889b052f(value);
        default:
    }
};
const $5f609015ba424ff1$export$d13aed56243e4d = {
    [(0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Phone]: "input.phone_number",
    [(0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Email]: "input.email",
    [(0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Username]: "input.username"
};
const $5f609015ba424ff1$export$71b8592ba731d4b5 = {
    [(0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Phone]: "description.phone_number",
    [(0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Email]: "description.email",
    [(0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Username]: "description.username"
};
const $5f609015ba424ff1$export$87161604d0c960f6 = (enabledFields, type)=>{
    const data = {
        types: enabledFields.map((field)=>$5f609015ba424ff1$var$t($5f609015ba424ff1$export$71b8592ba731d4b5[field]))
    };
    const code = type === "required" ? "error.general_required" : "error.general_invalid";
    return $5f609015ba424ff1$var$t(code, data);
};
const $5f609015ba424ff1$export$7778466abc57125c = (type, value)=>{
    if (type === (0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Phone && value) {
        const validPhoneNumber = (0, $dc69be136f5b72f6$export$da44e4eaa54bc82e)(value);
        if (validPhoneNumber) return {
            countryCode: validPhoneNumber.countryCallingCode,
            inputValue: validPhoneNumber.nationalNumber
        };
    }
    return {
        inputValue: value
    };
};


const $874c4faa50971190$var$digitsRegex = /^\d*$/;
const $874c4faa50971190$var$useSmartInputField = ({ _defaultType: _defaultType, defaultValue: defaultValue, enabledTypes: enabledTypes })=>{
    const enabledTypeSet = (0, $P551f.useMemo)(()=>new Set(enabledTypes), [
        enabledTypes
    ]);
    (0, $4f95a9cf034a847d$export$a7a9523472993e97)(!_defaultType || enabledTypeSet.has(_defaultType), new Error(`Invalid input type. Current inputType ${_defaultType !== null && _defaultType !== void 0 ? _defaultType : ""} is detected but missing in enabledTypes`));
    // Parse default type from enabled types if default type is not provided and only one type is enabled
    const defaultType = (0, $P551f.useMemo)(()=>_defaultType !== null && _defaultType !== void 0 ? _defaultType : enabledTypes.length === 1 ? enabledTypes[0] : undefined, [
        _defaultType,
        enabledTypes
    ]);
    // Parse default value if provided
    const { countryCode: defaultCountryCode, inputValue: defaultInputValue } = (0, $P551f.useMemo)(()=>(0, $5f609015ba424ff1$export$7778466abc57125c)(defaultType, defaultValue), [
        defaultType,
        defaultValue
    ]);
    const [currentType, setCurrentType] = (0, $P551f.useState)(defaultType);
    const [countryCode, setCountryCode] = (0, $P551f.useState)(defaultCountryCode !== null && defaultCountryCode !== void 0 ? defaultCountryCode : (0, $dc69be136f5b72f6$export$93cb54c01a2c1072)());
    const [inputValue, setInputValue] = (0, $P551f.useState)(defaultInputValue !== null && defaultInputValue !== void 0 ? defaultInputValue : "");
    const detectInputType = (0, $P551f.useCallback)((value)=>{
        // Reset InputType
        if (!value && enabledTypeSet.size > 1) return;
        if (enabledTypeSet.size === 1) return defaultType;
        const hasAtSymbol = value.includes("@");
        const isAllDigits = $874c4faa50971190$var$digitsRegex.test(value);
        if (enabledTypeSet.has((0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Phone) && value.length >= 3 && isAllDigits) return (0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Phone;
        if (enabledTypeSet.has((0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Email) && hasAtSymbol) return (0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Email;
        if (currentType === (0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Phone && isAllDigits) return (0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Phone;
        if (enabledTypeSet.has((0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Username)) return (0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Username;
        if (enabledTypeSet.has((0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Email)) return (0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Email;
        return currentType;
    }, [
        defaultType,
        currentType,
        enabledTypeSet
    ]);
    const onCountryCodeChange = (0, $P551f.useCallback)((value)=>{
        if (currentType === (0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Phone) {
            const code = value.replace(/\D/g, "");
            setCountryCode(code);
        }
    }, [
        currentType
    ]);
    const onInputValueChange = (0, $P551f.useCallback)(({ target: { value: value } })=>{
        const trimValue = value.trim();
        setInputValue(trimValue);
        const type = detectInputType(trimValue);
        setCurrentType(type);
    }, [
        detectInputType
    ]);
    const onInputValueClear = (0, $P551f.useCallback)(()=>{
        setInputValue("");
        setCurrentType(enabledTypeSet.size === 1 ? defaultType : undefined);
    }, [
        defaultType,
        enabledTypeSet.size
    ]);
    // CAUTION: For preview use only, enabledTypes and defaultType should not be changed after component mounted
    (0, $4e2a69ac2c1fa4c6$export$2e2bcd8739ae039)(()=>{
        setInputValue("");
        setCurrentType(defaultType);
    }, [
        defaultType
    ]);
    return {
        countryCode: countryCode,
        onCountryCodeChange: onCountryCodeChange,
        inputValue: inputValue,
        onInputValueChange: onInputValueChange,
        onInputValueClear: onInputValueClear,
        identifierType: currentType
    };
};
var $874c4faa50971190$export$2e2bcd8739ae039 = $874c4faa50971190$var$useSmartInputField;





const $5f28c0bac18b5d70$export$88bf6311e069f4ec = (enabledTypes, currentType)=>{
    if (currentType === (0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Phone && enabledTypes.length === 1) return {
        type: "tel",
        pattern: "[0-9]*",
        inputMode: "numeric",
        autoComplete: "tel",
        placeholder: (0, $86e325ac3ddbcfa1$export$2e2bcd8739ae039).t("input.phone_number")
    };
    if (currentType === (0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Email && enabledTypes.length === 1) return {
        type: "email",
        inputMode: "email",
        autoComplete: "email",
        placeholder: (0, $86e325ac3ddbcfa1$export$2e2bcd8739ae039).t("input.email")
    };
    return {
        type: "text",
        autoComplete: enabledTypes.map((type)=>type === (0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Phone ? "tel" : type).join(" "),
        placeholder: enabledTypes.map((type)=>(0, $86e325ac3ddbcfa1$export$2e2bcd8739ae039).t((0, $5f609015ba424ff1$export$d13aed56243e4d)[type])).join(" / ")
    };
};


const $5fa6bf3f237eb8ef$var$AnimatedInputField = (0, $d6ee01a8227ffa94$export$407448d2b89b1813)((0, $89edc8164fec0424$export$2e2bcd8739ae039));
const $5fa6bf3f237eb8ef$var$SmartInputField = (_param, ref)=>{
    var { defaultValue: defaultValue, defaultType: defaultType, enabledTypes: enabledTypes = [], onChange: onChange } = _param, rest = (0, $451b529b5830e8ac$export$69fdd232f62cde60)(_param, [
        "defaultValue",
        "defaultType",
        "enabledTypes",
        "onChange"
    ]);
    const innerRef = (0, $P551f.useRef)(null);
    (0, $P551f.useImperativeHandle)(ref, ()=>innerRef.current);
    const { countryCode: countryCode, onCountryCodeChange: onCountryCodeChange, inputValue: inputValue, onInputValueChange: onInputValueChange, onInputValueClear: onInputValueClear, identifierType: identifierType } = (0, $874c4faa50971190$export$2e2bcd8739ae039)({
        _defaultType: defaultType,
        defaultValue: defaultValue,
        enabledTypes: enabledTypes
    });
    const isPrefixVisible = identifierType === (0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Phone;
    const { paddingLeft: paddingLeft } = (0, $8df965278a3bc58d$export$c4af9125706c4d30)({
        paddingLeft: isPrefixVisible ? 4 : 16,
        config: (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, (0, $8df965278a3bc58d$export$e506a1d27d1eaa20).default), {
            clamp: true
        })
    });
    (0, $P551f.useEffect)(()=>{
        onChange === null || onChange === void 0 ? void 0 : onChange({
            type: identifierType,
            value: isPrefixVisible && inputValue ? `${countryCode}${inputValue}` : inputValue
        });
    }, [
        countryCode,
        identifierType,
        inputValue,
        isPrefixVisible,
        onChange
    ]);
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)($5fa6bf3f237eb8ef$var$AnimatedInputField, (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, (0, $5f28c0bac18b5d70$export$88bf6311e069f4ec)(enabledTypes, identifierType), rest), {
        ref: innerRef,
        isSuffixFocusVisible: Boolean(inputValue),
        style: {
            zIndex: 1,
            paddingLeft: paddingLeft
        },
        value: inputValue,
        prefix: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $07528ff3ec4308c1$export$2e2bcd8739ae039), {
            isVisible: isPrefixVisible,
            children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $cb56022ab74eb6f5$export$2e2bcd8739ae039), {
                value: countryCode,
                inputRef: innerRef.current,
                onChange: (value)=>{
                    var _innerRef_current;
                    onCountryCodeChange(value);
                    (_innerRef_current = innerRef.current) === null || _innerRef_current === void 0 ? void 0 : _innerRef_current.focus();
                }
            })
        }),
        suffix: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $328da03efb4c933c$export$2e2bcd8739ae039), {
            onMouseDown: (event)=>{
                event.preventDefault();
            },
            onClick: onInputValueClear,
            children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $8d625ccbe854106b$export$2e2bcd8739ae039), {})
        }),
        onChange: onInputValueChange
    }));
};
var $5fa6bf3f237eb8ef$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $P551f.forwardRef)($5fa6bf3f237eb8ef$var$SmartInputField);





var $5112bd3e92ae7d83$export$6210fa4921d2a466;
var $5112bd3e92ae7d83$export$ce85b9b1fe34d6d3;
var $5112bd3e92ae7d83$export$6f2f4d5c38fc8e55;
$5112bd3e92ae7d83$export$6210fa4921d2a466 = `uRK25q_form`;
$5112bd3e92ae7d83$export$ce85b9b1fe34d6d3 = `uRK25q_formErrors`;
$5112bd3e92ae7d83$export$6f2f4d5c38fc8e55 = `uRK25q_inputField`;


const $0de1ddd0411fb7d9$var$IdentifierProfileForm = ({ className: className, autoFocus: autoFocus, defaultType: defaultType, enabledTypes: enabledTypes, onSubmit: onSubmit, errorMessage: errorMessage, clearErrorMessage: clearErrorMessage })=>{
    const { t: t } = (0, $5d79e62c9ff74ac9$export$9fc83ad70ead8663)();
    const { handleSubmit: handleSubmit, control: control, formState: { errors: errors, isValid: isValid } } = (0, $afcc65e7f92ff559$export$87c0cf8eb5a167e0)({
        reValidateMode: "onBlur",
        defaultValues: {
            identifier: {
                type: defaultType,
                value: ""
            }
        }
    });
    (0, $P551f.useEffect)(()=>{
        if (!isValid) clearErrorMessage === null || clearErrorMessage === void 0 ? void 0 : clearErrorMessage();
    }, [
        clearErrorMessage,
        isValid
    ]);
    const onSubmitHandler = (0, $P551f.useCallback)(async (event)=>{
        clearErrorMessage === null || clearErrorMessage === void 0 ? void 0 : clearErrorMessage();
        handleSubmit(async ({ identifier: { type: type, value: value } })=>{
            if (!type) return;
            await (onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(type, value));
        })(event);
    }, [
        clearErrorMessage,
        handleSubmit,
        onSubmit
    ]);
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("form", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a6f0144cf2b2d456$exports)))($5112bd3e92ae7d83$export$6210fa4921d2a466, className),
        onSubmit: onSubmitHandler,
        children: [
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $afcc65e7f92ff559$export$bd0bf19f25da8474), {
                control: control,
                name: "identifier",
                rules: {
                    validate: (identifier)=>{
                        const { type: type, value: value } = identifier;
                        if (!type || !value) return (0, $5f609015ba424ff1$export$87161604d0c960f6)(enabledTypes, "required");
                        const errorMessage = (0, $5f609015ba424ff1$export$1222f18ddc446c49)(type, value);
                        var _errorMessage_data;
                        if (errorMessage) return typeof errorMessage === "string" ? t(`error.${errorMessage}`) : t(`error.${errorMessage.code}`, (_errorMessage_data = errorMessage.data) !== null && _errorMessage_data !== void 0 ? _errorMessage_data : {});
                        return true;
                    }
                },
                render: ({ field: field })=>{
                    var _errors_identifier;
                    /*#__PURE__*/ return (0, $b1404a408b0d045c$exports.jsx)((0, $5fa6bf3f237eb8ef$export$2e2bcd8739ae039), (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({
                        autoComplete: "off",
                        autoFocus: autoFocus,
                        className: $5112bd3e92ae7d83$export$6f2f4d5c38fc8e55
                    }, field), {
                        defaultType: defaultType,
                        isDanger: !!errors.identifier,
                        errorMessage: (_errors_identifier = errors.identifier) === null || _errors_identifier === void 0 ? void 0 : _errors_identifier.message,
                        enabledTypes: enabledTypes
                    }));
                }
            }),
            errorMessage && /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $4ebb9c3ba9ede754$export$2e2bcd8739ae039), {
                className: $5112bd3e92ae7d83$export$ce85b9b1fe34d6d3,
                children: errorMessage
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $c6d8f26a28e11cb6$export$2e2bcd8739ae039), {
                title: "action.continue",
                htmlType: "submit"
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("input", {
                hidden: true,
                type: "submit"
            })
        ]
    });
};
var $0de1ddd0411fb7d9$export$2e2bcd8739ae039 = $0de1ddd0411fb7d9$var$IdentifierProfileForm;








const $aaaf907508d04279$export$2a51ca354add32e1 = (email)=>{
    const [name = "", domain = ""] = email.split("@");
    const preview = name.length > 4 ? `${name.slice(0, 4)}` : "";
    return `${preview}****@${domain}`;
};
const $aaaf907508d04279$export$1f64b92865689d0d = (phone)=>`****${phone.slice(-4)}`;


var $f24bc559ba7560ba$export$6d59db4903f20f7d;
$f24bc559ba7560ba$export$6d59db4903f20f7d = `KdxC9G_description`;


const $3dd3365116e8b25a$var$SocialIdentityNotification = ({ missingProfileTypes: missingProfileTypes })=>{
    var _state_registeredSocialIdentity, _state_registeredSocialIdentity1;
    const { t: t } = (0, $5d79e62c9ff74ac9$export$9fc83ad70ead8663)();
    const { state: state } = (0, $2ed817dc54ac40e6$export$45d76561a5302f2b)();
    const hasSocialIdentity = (0, $8a18d710f1d13368$export$226b3eccf92c9ed9)(state, (0, $4ffc90f7233cdad4$export$184f9f29032ada80));
    if (!hasSocialIdentity) return null;
    if (missingProfileTypes.includes((0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Email) && ((_state_registeredSocialIdentity = state.registeredSocialIdentity) === null || _state_registeredSocialIdentity === void 0 ? void 0 : _state_registeredSocialIdentity.email)) return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("div", {
        className: $f24bc559ba7560ba$export$6d59db4903f20f7d,
        children: t("description.social_identity_exist", {
            type: t("description.email"),
            value: (0, $aaaf907508d04279$export$2a51ca354add32e1)(state.registeredSocialIdentity.email)
        })
    });
    if (missingProfileTypes.includes((0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Phone) && ((_state_registeredSocialIdentity1 = state.registeredSocialIdentity) === null || _state_registeredSocialIdentity1 === void 0 ? void 0 : _state_registeredSocialIdentity1.phone)) return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("div", {
        className: $f24bc559ba7560ba$export$6d59db4903f20f7d,
        children: t("description.social_identity_exist", {
            type: t("description.phone_number"),
            value: state.registeredSocialIdentity.phone
        })
    });
    return null;
};
var $3dd3365116e8b25a$export$2e2bcd8739ae039 = $3dd3365116e8b25a$var$SocialIdentityNotification;


const $c22df810d505ef45$export$b2c1506c6ba891d6 = {
    email: {
        title: "description.link_email",
        description: "description.link_email_description"
    },
    phone: {
        title: "description.link_phone",
        description: "description.link_phone_description"
    },
    emailOrPhone: {
        title: "description.link_email_or_phone",
        description: "description.link_email_or_phone_description"
    }
};
const $c22df810d505ef45$var$formSettings = {
    email: {
        defaultType: (0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Email,
        enabledTypes: [
            (0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Email
        ]
    },
    phone: {
        defaultType: (0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Phone,
        enabledTypes: [
            (0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Phone
        ]
    },
    emailOrPhone: {
        defaultType: (0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Email,
        enabledTypes: [
            (0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Email,
            (0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Phone
        ]
    }
};
const $c22df810d505ef45$var$SetEmailOrPhone = ({ missingProfile: missingProfile, notification: notification })=>{
    const { onSubmit: onSubmit, errorMessage: errorMessage, clearErrorMessage: clearErrorMessage } = (0, $e5f910429b93015b$export$2e2bcd8739ae039)((0, $6b1416e8e4d304fe$export$12e44e23ec720850).Continue);
    const handleSubmit = async (identifier, value)=>{
        // Only handles email and phone
        if (identifier === (0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Username) return;
        return onSubmit({
            identifier: identifier,
            value: value
        });
    };
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)((0, $3dc734e3f6636ef1$export$2e2bcd8739ae039), (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, $c22df810d505ef45$export$b2c1506c6ba891d6[missingProfile]), {
        notification: notification,
        children: [
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $0de1ddd0411fb7d9$export$2e2bcd8739ae039), (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({
                autoFocus: true,
                errorMessage: errorMessage,
                clearErrorMessage: clearErrorMessage
            }, $c22df810d505ef45$var$formSettings[missingProfile]), {
                onSubmit: handleSubmit
            })),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $3dd3365116e8b25a$export$2e2bcd8739ae039), {
                missingProfileTypes: $c22df810d505ef45$var$formSettings[missingProfile].enabledTypes
            })
        ]
    }));
};
var $c22df810d505ef45$export$2e2bcd8739ae039 = $c22df810d505ef45$var$SetEmailOrPhone;





var $P551f = parcelRequire("P551f");










var $P551f = parcelRequire("P551f");





var $83f57e1aa3772099$export$b07e517d22efa1ca;
var $83f57e1aa3772099$export$6210fa4921d2a466;
var $83f57e1aa3772099$export$ce85b9b1fe34d6d3;
var $83f57e1aa3772099$export$6f2f4d5c38fc8e55;
var $83f57e1aa3772099$export$b408996a1ca2a1d7;
$83f57e1aa3772099$export$b07e517d22efa1ca = `i0vptW_checkbox`;
$83f57e1aa3772099$export$6210fa4921d2a466 = `i0vptW_form`;
$83f57e1aa3772099$export$ce85b9b1fe34d6d3 = `i0vptW_formErrors`;
$83f57e1aa3772099$export$6f2f4d5c38fc8e55 = `i0vptW_inputField`;
$83f57e1aa3772099$export$b408996a1ca2a1d7 = `i0vptW_passwordSwitch`;


const $22b75d2d5bc47ad9$var$Lite = ({ className: className, autoFocus: autoFocus, onSubmit: onSubmit, errorMessage: errorMessage, clearErrorMessage: clearErrorMessage })=>{
    var _errors_newPassword;
    const { t: t } = (0, $5d79e62c9ff74ac9$export$9fc83ad70ead8663)();
    const { register: register, handleSubmit: handleSubmit, formState: { errors: errors, isValid: isValid } } = (0, $afcc65e7f92ff559$export$87c0cf8eb5a167e0)({
        reValidateMode: "onBlur",
        defaultValues: {
            newPassword: ""
        }
    });
    (0, $P551f.useEffect)(()=>{
        if (!isValid) clearErrorMessage === null || clearErrorMessage === void 0 ? void 0 : clearErrorMessage();
    }, [
        clearErrorMessage,
        isValid
    ]);
    const onSubmitHandler = (0, $P551f.useCallback)((event)=>{
        clearErrorMessage === null || clearErrorMessage === void 0 ? void 0 : clearErrorMessage();
        handleSubmit((data, event)=>{
            onSubmit(data.newPassword);
        })(event);
    }, [
        clearErrorMessage,
        handleSubmit,
        onSubmit
    ]);
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("form", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a6f0144cf2b2d456$exports)))($83f57e1aa3772099$export$6210fa4921d2a466, className),
        onSubmit: onSubmitHandler,
        children: [
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $942ba6b6db15403b$export$2e2bcd8739ae039), (0, $0de5391da8318002$export$581ff339ea0ba762)({
                className: $83f57e1aa3772099$export$6f2f4d5c38fc8e55,
                autoComplete: "new-password",
                placeholder: t("input.password"),
                autoFocus: autoFocus,
                isDanger: !!errors.newPassword,
                errorMessage: (_errors_newPassword = errors.newPassword) === null || _errors_newPassword === void 0 ? void 0 : _errors_newPassword.message,
                "aria-invalid": !!errors.newPassword
            }, register("newPassword", {
                required: t("error.password_required")
            }))),
            errorMessage && /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $4ebb9c3ba9ede754$export$2e2bcd8739ae039), {
                className: $83f57e1aa3772099$export$ce85b9b1fe34d6d3,
                children: errorMessage
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $c6d8f26a28e11cb6$export$2e2bcd8739ae039), {
                name: "submit",
                title: "action.save_password",
                htmlType: "submit"
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("input", {
                hidden: true,
                type: "submit"
            })
        ]
    });
};
var $22b75d2d5bc47ad9$export$2e2bcd8739ae039 = $22b75d2d5bc47ad9$var$Lite;







var $P551f = parcelRequire("P551f");















var $P551f = parcelRequire("P551f");



parcelRequire("P551f");
const $413f766531294cad$var$SvgCheckboxIcon = (props)=>/*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("svg", (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.246 2.21H3.752c-.852 0-1.543.69-1.543 1.543v10.494c0 .852.691 1.543 1.543 1.543h10.494c.853 0 1.543-.69 1.543-1.543V3.753c0-.852-.69-1.543-1.543-1.543ZM3.752.667A3.086 3.086 0 0 0 .666 3.753v10.494a3.086 3.086 0 0 0 3.086 3.086h10.494a3.086 3.086 0 0 0 3.087-3.086V3.753A3.086 3.086 0 0 0 14.246.667H3.752Z",
                fill: "currentcolor"
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("rect", {
                width: 18,
                height: 18,
                rx: 4,
                fill: "currentcolor"
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M7.315 12.858 4.133 9.441a.506.506 0 0 1 0-.684l.643-.683a.437.437 0 0 1 .642 0l2.219 2.392 4.944-5.325a.437.437 0 0 1 .643 0l.643.684a.504.504 0 0 1 0 .682l-5.91 6.351a.437.437 0 0 1-.642 0Z",
                fill: "#fff"
            })
        ]
    }));
var $413f766531294cad$export$2e2bcd8739ae039 = $413f766531294cad$var$SvgCheckboxIcon;


var $0e92090c1d875635$export$b07e517d22efa1ca;
var $0e92090c1d875635$export$1ca1ec8b29a4ce27;
var $0e92090c1d875635$export$3c17b0e969a90510;
$0e92090c1d875635$export$b07e517d22efa1ca = `mYxYSW_checkbox`;
$0e92090c1d875635$export$1ca1ec8b29a4ce27 = `mYxYSW_icon`;
$0e92090c1d875635$export$3c17b0e969a90510 = `mYxYSW_small`;


const $0cf903e40c0bf2ef$var$Checkbox = (_param, ref)=>{
    var { disabled: disabled, size: size = "default" } = _param, rest = (0, $451b529b5830e8ac$export$69fdd232f62cde60)(_param, [
        "disabled",
        "size"
    ]);
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("div", {
        className: $0e92090c1d875635$export$b07e517d22efa1ca,
        children: [
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("input", (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({
                type: "checkbox",
                disabled: disabled
            }, rest), {
                ref: ref,
                readOnly: true
            })),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $413f766531294cad$export$2e2bcd8739ae039), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($a6f0144cf2b2d456$exports)))($0e92090c1d875635$export$1ca1ec8b29a4ce27, size === "small" && $0e92090c1d875635$export$3c17b0e969a90510)
            })
        ]
    });
};
var $0cf903e40c0bf2ef$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $P551f.forwardRef)($0cf903e40c0bf2ef$var$Checkbox);




const $0dde4fc8b92678f3$var$TogglePassword = ({ isChecked: isChecked, onChange: onChange })=>{
    const { t: t } = (0, $5d79e62c9ff74ac9$export$9fc83ad70ead8663)();
    const toggle = ()=>{
        onChange(!isChecked);
    };
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("div", {
        role: "radio",
        "aria-checked": isChecked,
        tabIndex: 0,
        className: $83f57e1aa3772099$export$b408996a1ca2a1d7,
        onClick: toggle,
        onKeyDown: (0, $f6f836671f603fea$export$c2c388d6a668999e)({
            Escape: ()=>{
                onChange(false);
            },
            Enter: toggle,
            " ": toggle
        }),
        children: [
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $0cf903e40c0bf2ef$export$2e2bcd8739ae039), {
                name: "toggle-password",
                checked: isChecked,
                className: $83f57e1aa3772099$export$b07e517d22efa1ca
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("div", {
                children: t("action.show_password")
            })
        ]
    });
};
var $0dde4fc8b92678f3$export$2e2bcd8739ae039 = $0dde4fc8b92678f3$var$TogglePassword;



const $d37feff1c7cf2e84$var$SetPassword = ({ className: className, autoFocus: autoFocus, onSubmit: onSubmit, errorMessage: errorMessage, clearErrorMessage: clearErrorMessage })=>{
    var _errors_newPassword, _errors_confirmPassword;
    const { t: t } = (0, $5d79e62c9ff74ac9$export$9fc83ad70ead8663)();
    const [showPassword, setShowPassword] = (0, $P551f.useState)(false);
    const { register: register, watch: watch, resetField: resetField, handleSubmit: handleSubmit, formState: { errors: errors, isValid: isValid } } = (0, $afcc65e7f92ff559$export$87c0cf8eb5a167e0)({
        reValidateMode: "onBlur",
        defaultValues: {
            newPassword: "",
            confirmPassword: ""
        }
    });
    (0, $P551f.useEffect)(()=>{
        if (!isValid) clearErrorMessage === null || clearErrorMessage === void 0 ? void 0 : clearErrorMessage();
    }, [
        clearErrorMessage,
        isValid
    ]);
    const onSubmitHandler = (0, $P551f.useCallback)((event)=>{
        clearErrorMessage === null || clearErrorMessage === void 0 ? void 0 : clearErrorMessage();
        handleSubmit((data, event)=>{
            onSubmit(data.newPassword);
        })(event);
    }, [
        clearErrorMessage,
        handleSubmit,
        onSubmit
    ]);
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("form", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a6f0144cf2b2d456$exports)))($83f57e1aa3772099$export$6210fa4921d2a466, className),
        onSubmit: onSubmitHandler,
        children: [
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $89edc8164fec0424$export$2e2bcd8739ae039), (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({
                className: $83f57e1aa3772099$export$6f2f4d5c38fc8e55,
                type: showPassword ? "text" : "password",
                autoComplete: "new-password",
                placeholder: t("input.password"),
                autoFocus: autoFocus,
                isDanger: !!errors.newPassword,
                errorMessage: (_errors_newPassword = errors.newPassword) === null || _errors_newPassword === void 0 ? void 0 : _errors_newPassword.message,
                "aria-invalid": !!errors.newPassword
            }, register("newPassword", {
                required: t("error.password_required")
            })), {
                isSuffixFocusVisible: !!watch("newPassword"),
                suffix: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $328da03efb4c933c$export$2e2bcd8739ae039), {
                    onClick: ()=>{
                        resetField("newPassword");
                    },
                    children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $8d625ccbe854106b$export$2e2bcd8739ae039), {})
                })
            })),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $89edc8164fec0424$export$2e2bcd8739ae039), (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({
                className: $83f57e1aa3772099$export$6f2f4d5c38fc8e55,
                type: showPassword ? "text" : "password",
                autoComplete: "new-password",
                placeholder: t("input.confirm_password"),
                errorMessage: (_errors_confirmPassword = errors.confirmPassword) === null || _errors_confirmPassword === void 0 ? void 0 : _errors_confirmPassword.message,
                "aria-invalid": !!errors.confirmPassword
            }, register("confirmPassword", {
                validate: (value)=>value === watch("newPassword") || t("error.passwords_do_not_match")
            })), {
                isSuffixFocusVisible: !!watch("confirmPassword"),
                suffix: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $328da03efb4c933c$export$2e2bcd8739ae039), {
                    onClick: ()=>{
                        resetField("confirmPassword");
                    },
                    children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $8d625ccbe854106b$export$2e2bcd8739ae039), {})
                })
            })),
            errorMessage && /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $4ebb9c3ba9ede754$export$2e2bcd8739ae039), {
                className: $83f57e1aa3772099$export$ce85b9b1fe34d6d3,
                children: errorMessage
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $0dde4fc8b92678f3$export$2e2bcd8739ae039), {
                isChecked: showPassword,
                onChange: setShowPassword
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $c6d8f26a28e11cb6$export$2e2bcd8739ae039), {
                name: "submit",
                title: "action.save_password",
                htmlType: "submit"
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("input", {
                hidden: true,
                type: "submit"
            })
        ]
    });
};
var $d37feff1c7cf2e84$export$2e2bcd8739ae039 = $d37feff1c7cf2e84$var$SetPassword;


const $b82e639c4d502e57$var$SetPassword = (props)=>{
    const { isForgotPasswordEnabled: isForgotPasswordEnabled } = (0, $aa5a893d65a133eb$export$9418daf6fcecfff4)();
    return isForgotPasswordEnabled ? /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $22b75d2d5bc47ad9$export$2e2bcd8739ae039), (0, $0de5391da8318002$export$581ff339ea0ba762)({}, props)) : /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $d37feff1c7cf2e84$export$2e2bcd8739ae039), (0, $0de5391da8318002$export$581ff339ea0ba762)({}, props));
};
var $b82e639c4d502e57$export$2e2bcd8739ae039 = $b82e639c4d502e57$var$SetPassword;



var $P551f = parcelRequire("P551f");

const $f3ae436b724671df$export$753980156bc86c10 = ()=>(0, $P551f.useContext)((0, $b54a682ed4ae76b2$export$48cb88dd95836c3a));




var $P551f = parcelRequire("P551f");



var $P551f = parcelRequire("P551f");

/**
 * Return an object with two functions for getting the error message from an array of {@link PasswordIssue} or a {@link RequestErrorBody}.
 */ const $eeb9b414b2f671f0$var$usePasswordErrorMessage = ()=>{
    const { t: t } = (0, $5d79e62c9ff74ac9$export$9fc83ad70ead8663)();
    const getErrorMessage = (0, $P551f.useCallback)((issues)=>{
        // Errors that should be displayed first and alone
        const singleDisplayError = [
            "unsupported_characters",
            "too_short",
            "character_types",
            "too_long",
            "pwned"
        ].map((code)=>issues.find((issue)=>issue.code === `password_rejected.${code}`)).find(Boolean);
        var _singleDisplayError_interpolation;
        if (singleDisplayError) return t(`error.${singleDisplayError.code}`, (_singleDisplayError_interpolation = singleDisplayError.interpolation) !== null && _singleDisplayError_interpolation !== void 0 ? _singleDisplayError_interpolation : {});
        // The `restricted` errors should be displayed together
        const restrictedErrors = issues.filter((issue)=>issue.code.startsWith("password_rejected.restricted.")).map((issue)=>t(`error.${issue.code}`));
        if (restrictedErrors.length > 0) return t("error.password_rejected.restricted_found", {
            list: restrictedErrors
        });
    }, [
        t
    ]);
    const getErrorMessageFromBody = (0, $P551f.useCallback)((error)=>{
        var _getErrorMessage;
        if (error.code === "password.rejected") // eslint-disable-next-line no-restricted-syntax -- trust the type from the server if the code matches
        return (_getErrorMessage = getErrorMessage(error.data)) !== null && _getErrorMessage !== void 0 ? _getErrorMessage : error.message;
    }, [
        getErrorMessage
    ]);
    return {
        getErrorMessage: /**
     * Get the error message from an array of {@link PasswordIssue}.
     * If the array is empty or the error is not recognized, `undefined` is returned.
     */ getErrorMessage,
        getErrorMessageFromBody: /**
     * Get the error message from a {@link RequestErrorBody}.
     *
     * First, it will check if the error code is `password.rejected`:
     * - If so, it will assume `error.data` is an array of {@link PasswordIssue}, then it will call
     * {@link getErrorMessage} with the array;
     *   - If the result is `undefined`, it will directly return the error message from the body.
     * - Otherwise, it will return `undefined`.
     */ getErrorMessageFromBody
    };
};
var $eeb9b414b2f671f0$export$2e2bcd8739ae039 = $eeb9b414b2f671f0$var$usePasswordErrorMessage;



const $cdc84a946f7d64eb$var$usePasswordAction = ({ api: api, errorHandlers: errorHandlers, setErrorMessage: setErrorMessage, successHandler: successHandler })=>{
    const asyncAction = (0, $ab5ab705a7d3e209$export$2e2bcd8739ae039)(api);
    const handleError = (0, $7ebd5fdad7a45c9e$export$2e2bcd8739ae039)();
    const { getErrorMessage: getErrorMessage, getErrorMessageFromBody: getErrorMessageFromBody } = (0, $eeb9b414b2f671f0$export$2e2bcd8739ae039)();
    const { policyChecker: policyChecker } = (0, $aa5a893d65a133eb$export$b03f85e37d353e63)();
    const passwordRejectionHandler = (0, $P551f.useCallback)((error)=>{
        setErrorMessage(getErrorMessageFromBody(error));
    }, [
        getErrorMessageFromBody,
        setErrorMessage
    ]);
    const action = (0, $P551f.useCallback)(async (password)=>{
        // Perform fast check before sending request
        const fastCheckErrorMessage = getErrorMessage(policyChecker.fastCheck(password));
        if (fastCheckErrorMessage) {
            setErrorMessage(fastCheckErrorMessage);
            return;
        }
        const [error, result] = await asyncAction(password);
        if (error) {
            await handleError(error, (0, $0de5391da8318002$export$581ff339ea0ba762)({
                "password.rejected": passwordRejectionHandler
            }, errorHandlers));
            return;
        }
        successHandler(result);
    }, [
        asyncAction,
        errorHandlers,
        getErrorMessage,
        handleError,
        passwordRejectionHandler,
        policyChecker,
        setErrorMessage,
        successHandler
    ]);
    return [
        action
    ];
};
var $cdc84a946f7d64eb$export$2e2bcd8739ae039 = $cdc84a946f7d64eb$var$usePasswordAction;




var $P551f = parcelRequire("P551f");


var $P551f = parcelRequire("P551f");









var $P551f = parcelRequire("P551f");





const $939f090fab5f8181$var$useStartTotpBinding = ({ replace: replace } = {})=>{
    const navigate = (0, $2ed817dc54ac40e6$export$9770f232ac06a008)();
    const asyncCreateTotpSecret = (0, $ab5ab705a7d3e209$export$2e2bcd8739ae039)((0, $72a4b194eaf87ab0$export$ed04f454e58389a8));
    const handleError = (0, $7ebd5fdad7a45c9e$export$2e2bcd8739ae039)();
    return (0, $P551f.useCallback)(async (flowState)=>{
        const [error, result] = await asyncCreateTotpSecret();
        if (error) {
            await handleError(error);
            return;
        }
        const { secret: secret, secretQrCode: secretQrCode } = result !== null && result !== void 0 ? result : {};
        if (secret && secretQrCode) {
            const state = (0, $0de5391da8318002$export$581ff339ea0ba762)({
                secret: secret,
                secretQrCode: secretQrCode
            }, flowState);
            navigate({
                pathname: `/${(0, $6b1416e8e4d304fe$export$6a49be5b3307a2d).MfaBinding}/${(0, $c0e46a7ec45ea8f3$export$c62e7669a75c5961).TOTP}`
            }, {
                replace: replace,
                state: state
            });
        }
    }, [
        asyncCreateTotpSecret,
        handleError,
        navigate,
        replace
    ]);
};
var $939f090fab5f8181$export$2e2bcd8739ae039 = $939f090fab5f8181$var$useStartTotpBinding;





var $P551f = parcelRequire("P551f");





const $cac28407a0c07ec3$var$useStartWebAuthnProcessing = ({ replace: replace } = {})=>{
    const navigate = (0, $2ed817dc54ac40e6$export$9770f232ac06a008)();
    const asyncCreateRegistrationOptions = (0, $ab5ab705a7d3e209$export$2e2bcd8739ae039)((0, $72a4b194eaf87ab0$export$4a7a1c8b5ba74d74));
    const asyncGenerateAuthnOptions = (0, $ab5ab705a7d3e209$export$2e2bcd8739ae039)((0, $72a4b194eaf87ab0$export$dddc1626e5376ab0));
    const handleError = (0, $7ebd5fdad7a45c9e$export$2e2bcd8739ae039)();
    return (0, $P551f.useCallback)(async (flow, flowState)=>{
        const [error, options] = flow === (0, $6b1416e8e4d304fe$export$6a49be5b3307a2d).MfaBinding ? await asyncCreateRegistrationOptions() : await asyncGenerateAuthnOptions();
        if (error) {
            await handleError(error);
            return;
        }
        if (options) {
            const state = (0, $0de5391da8318002$export$581ff339ea0ba762)({
                options: options
            }, flowState);
            navigate({
                pathname: `/${flow}/${(0, $c0e46a7ec45ea8f3$export$c62e7669a75c5961).WebAuthn}`
            }, {
                replace: replace,
                state: state
            });
        }
    }, [
        asyncCreateRegistrationOptions,
        asyncGenerateAuthnOptions,
        handleError,
        navigate,
        replace
    ]);
};
var $cac28407a0c07ec3$export$2e2bcd8739ae039 = $cac28407a0c07ec3$var$useStartWebAuthnProcessing;



const $3159c2bcbe0310be$var$useMfaErrorHandler = ({ replace: replace } = {})=>{
    const navigate = (0, $2ed817dc54ac40e6$export$9770f232ac06a008)();
    const { t: t } = (0, $5d79e62c9ff74ac9$export$9fc83ad70ead8663)();
    const { setToast: setToast } = (0, $d1e7a25fbbe7c8e1$export$2e2bcd8739ae039)();
    const startTotpBinding = (0, $939f090fab5f8181$export$2e2bcd8739ae039)({
        replace: replace
    });
    const startWebAuthnProcessing = (0, $cac28407a0c07ec3$export$2e2bcd8739ae039)({
        replace: replace
    });
    /**
   * Redirect the user to the corresponding MFA page.
   *
   * Binding pages are hosted on following routes:
   * - /{@link UserMfaFlow.MfaBinding} List of available MFA factors for binding.
   * - /{@link UserMfaFlow.MfaBinding}/{@link MfaFactor} Binding page for the specific factor.
   *
   * Verification pages are hosted on following routes:
   * - /{@link UserMfaFlow.MfaVerification} List of available MFA factors for verification.
   * - /{@link UserMfaFlow.MfaVerification}/{@link MfaFactor} Verification page for the specific factor.
   *
   * Redirection rules:
   * - If there is only one available factor, redirect to the specific MFA factor page.
   * - If there are multiple available factors:
   *    - Binding: redirect to the available factors list page.
   *    - Verification: redirect to the last used specific factor page.
   */ const handleMfaRedirect = (0, $P551f.useCallback)(async (flow, state)=>{
        const { availableFactors: availableFactors } = state;
        if (availableFactors.length > 1 && flow === (0, $6b1416e8e4d304fe$export$6a49be5b3307a2d).MfaBinding) {
            /**
         * Redirect to the MFA binding page if there are multiple available factors.
         */ navigate({
                pathname: `/${flow}`
            }, {
                replace: replace,
                state: state
            });
            return;
        }
        /**
       * For verification: the first available factor is the last used factor which is guaranteed by the backend.
       * For binding: the first available factor is the only available factor since we handle the multiple factors case above.
       */ const factor = availableFactors[0];
        if (!factor) {
            /**
         * This should never happen since we check the available factors' length before handling the redirection.
         */ setToast(t("error.unknown"));
            return;
        }
        if (factor === (0, $c0e46a7ec45ea8f3$export$c62e7669a75c5961).TOTP && flow === (0, $6b1416e8e4d304fe$export$6a49be5b3307a2d).MfaBinding) /**
         * Start TOTP binding process if only TOTP is available.
         */ return startTotpBinding(state);
        if (factor === (0, $c0e46a7ec45ea8f3$export$c62e7669a75c5961).WebAuthn) /**
         * Start WebAuthn processing if only TOTP is available.
         */ return startWebAuthnProcessing(flow, state);
        /**
       * Redirect to the specific MFA factor page.
       */ navigate({
            pathname: `/${flow}/${factor}`
        }, {
            replace: replace,
            state: state
        });
    }, [
        navigate,
        replace,
        setToast,
        startTotpBinding,
        startWebAuthnProcessing,
        t
    ]);
    const handleMfaError = (0, $P551f.useCallback)((flow)=>{
        return async (error)=>{
            const [_, data] = (0, $8a18d710f1d13368$export$a22775fa5e2eebd9)(error.data, (0, $4ffc90f7233cdad4$export$c098e744493f7349));
            var _data_availableFactors;
            const factors = (_data_availableFactors = data === null || data === void 0 ? void 0 : data.availableFactors) !== null && _data_availableFactors !== void 0 ? _data_availableFactors : [];
            const skippable = data === null || data === void 0 ? void 0 : data.skippable;
            if (factors.length === 0) {
                setToast(error.message);
                return;
            }
            const availableFactors = // Hide the webauthn factor on native webview if the user has other options, since it's not supported.
            (0, $955117e21b41598e$export$a38f4a317af23d71)() && factors.length > 1 ? factors.filter((factor)=>factor !== (0, $c0e46a7ec45ea8f3$export$c62e7669a75c5961).WebAuthn) : factors;
            await handleMfaRedirect(flow, {
                availableFactors: availableFactors,
                skippable: skippable
            });
        };
    }, [
        handleMfaRedirect,
        setToast
    ]);
    const handleBackupCodeError = (0, $P551f.useCallback)((error)=>{
        const [_, data] = (0, $8a18d710f1d13368$export$a22775fa5e2eebd9)(error.data, (0, $4ffc90f7233cdad4$export$4a47cfca3f992c62));
        if (!data) {
            setToast(error.message);
            return;
        }
        navigate({
            pathname: `/${(0, $6b1416e8e4d304fe$export$6a49be5b3307a2d).MfaBinding}/${(0, $c0e46a7ec45ea8f3$export$c62e7669a75c5961).BackupCode}`
        }, {
            replace: replace,
            state: data
        });
    }, [
        navigate,
        replace,
        setToast
    ]);
    const mfaVerificationErrorHandler = (0, $P551f.useMemo)(()=>({
            "user.missing_mfa": handleMfaError((0, $6b1416e8e4d304fe$export$6a49be5b3307a2d).MfaBinding),
            "session.mfa.require_mfa_verification": handleMfaError((0, $6b1416e8e4d304fe$export$6a49be5b3307a2d).MfaVerification),
            "session.mfa.backup_code_required": handleBackupCodeError
        }), [
        handleBackupCodeError,
        handleMfaError
    ]);
    return mfaVerificationErrorHandler;
};
var $3159c2bcbe0310be$export$2e2bcd8739ae039 = $3159c2bcbe0310be$var$useMfaErrorHandler;




var $P551f = parcelRequire("P551f");






const $53eb02d183f5611a$var$useRequiredProfileErrorHandler = ({ replace: replace, linkSocial: linkSocial } = {})=>{
    const navigate = (0, $2ed817dc54ac40e6$export$9770f232ac06a008)();
    const { setToast: setToast } = (0, $d1e7a25fbbe7c8e1$export$2e2bcd8739ae039)();
    const requiredProfileErrorHandler = (0, $P551f.useMemo)(()=>{
        return {
            "user.missing_profile": (error)=>{
                const [, data] = (0, $8a18d710f1d13368$export$a22775fa5e2eebd9)(error.data, (0, $4ffc90f7233cdad4$export$4563eb9e4106afd7));
                // Required as a sign up method but missing in the user profile
                const missingProfile = data === null || data === void 0 ? void 0 : data.missingProfile[0];
                // Required as a sign up method, verified email or phone can be found in Social Identity, but registered with a different account
                const registeredSocialIdentity = data === null || data === void 0 ? void 0 : data.registeredSocialIdentity;
                const linkSocialQueryString = linkSocial ? `?${(0, $53aabef915cc623b$export$160057b430cb5a30)({
                    [(0, $6b1416e8e4d304fe$export$c4eb3ba4f04fab5).LinkSocial]: linkSocial
                })}` : undefined;
                switch(missingProfile){
                    case (0, $e77cfc775e0ed7e6$export$68a887ed3b61b98e).password:
                    case (0, $e77cfc775e0ed7e6$export$68a887ed3b61b98e).username:
                        navigate({
                            pathname: `/${(0, $6b1416e8e4d304fe$export$12e44e23ec720850).Continue}/${missingProfile}`
                        }, {
                            replace: replace
                        });
                        break;
                    case (0, $e77cfc775e0ed7e6$export$68a887ed3b61b98e).email:
                    case (0, $e77cfc775e0ed7e6$export$68a887ed3b61b98e).phone:
                    case (0, $e77cfc775e0ed7e6$export$68a887ed3b61b98e).emailOrPhone:
                        navigate({
                            pathname: `/${(0, $6b1416e8e4d304fe$export$12e44e23ec720850).Continue}/${missingProfile}`,
                            search: linkSocialQueryString
                        }, {
                            replace: replace,
                            state: {
                                registeredSocialIdentity: registeredSocialIdentity
                            }
                        });
                        break;
                    default:
                        setToast(error.message);
                        break;
                }
            }
        };
    }, [
        linkSocial,
        navigate,
        replace,
        setToast
    ]);
    return requiredProfileErrorHandler;
};
var $53eb02d183f5611a$export$2e2bcd8739ae039 = $53eb02d183f5611a$var$useRequiredProfileErrorHandler;


const $c93ac0a28f6f81db$var$usePreSignInErrorHandler = ({ replace: replace, linkSocial: linkSocial } = {})=>{
    const requiredProfileErrorHandler = (0, $53eb02d183f5611a$export$2e2bcd8739ae039)({
        replace: replace,
        linkSocial: linkSocial
    });
    const mfaErrorHandler = (0, $3159c2bcbe0310be$export$2e2bcd8739ae039)({
        replace: replace
    });
    return (0, $P551f.useMemo)(()=>(0, $0de5391da8318002$export$581ff339ea0ba762)({}, requiredProfileErrorHandler, mfaErrorHandler), [
        mfaErrorHandler,
        requiredProfileErrorHandler
    ]);
};
var $c93ac0a28f6f81db$export$2e2bcd8739ae039 = $c93ac0a28f6f81db$var$usePreSignInErrorHandler;



const $c0e7eb9d74783f13$var$SetPassword = ()=>{
    const [errorMessage, setErrorMessage] = (0, $P551f.useState)();
    const clearErrorMessage = (0, $P551f.useCallback)(()=>{
        setErrorMessage(undefined);
    }, []);
    const navigate = (0, $2ed817dc54ac40e6$export$9770f232ac06a008)();
    const { show: show } = (0, $f3ae436b724671df$export$753980156bc86c10)();
    const preSignInErrorHandler = (0, $c93ac0a28f6f81db$export$2e2bcd8739ae039)();
    const errorHandlers = (0, $P551f.useMemo)(()=>(0, $0de5391da8318002$export$581ff339ea0ba762)({
            "user.password_exists_in_profile": async (error)=>{
                await show({
                    type: "alert",
                    ModalContent: error.message,
                    cancelText: "action.got_it"
                });
                navigate(-1);
            }
        }, preSignInErrorHandler), [
        navigate,
        preSignInErrorHandler,
        show
    ]);
    const successHandler = (0, $P551f.useCallback)((result)=>{
        if (result === null || result === void 0 ? void 0 : result.redirectTo) window.location.replace(result.redirectTo);
    }, []);
    const [action] = (0, $cdc84a946f7d64eb$export$2e2bcd8739ae039)({
        api: async (password)=>(0, $72a4b194eaf87ab0$export$32da561ec87acb84)({
                password: password
            }),
        setErrorMessage: setErrorMessage,
        errorHandlers: errorHandlers,
        successHandler: successHandler
    });
    const { policy: { length: { min: min, max: max }, characterTypes: { min: count } }, requirementsDescription: requirementsDescription } = (0, $aa5a893d65a133eb$export$b03f85e37d353e63)();
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $3dc734e3f6636ef1$export$2e2bcd8739ae039), {
        title: "description.set_password",
        description: requirementsDescription && /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("span", {
            children: requirementsDescription
        }),
        descriptionProps: {
            min: min,
            count: count
        },
        children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $b82e639c4d502e57$export$2e2bcd8739ae039), {
            autoFocus: true,
            errorMessage: errorMessage,
            maxLength: max,
            clearErrorMessage: clearErrorMessage,
            onSubmit: action
        })
    });
};
var $c0e7eb9d74783f13$export$2e2bcd8739ae039 = $c0e7eb9d74783f13$var$SetPassword;










var $P551f = parcelRequire("P551f");




const $64f13073424bcf48$var$useSetUsername = ()=>{
    const [errorMessage, setErrorMessage] = (0, $P551f.useState)();
    const clearErrorMessage = (0, $P551f.useCallback)(()=>{
        setErrorMessage("");
    }, []);
    const asyncAddProfile = (0, $ab5ab705a7d3e209$export$2e2bcd8739ae039)((0, $72a4b194eaf87ab0$export$32da561ec87acb84));
    const handleError = (0, $7ebd5fdad7a45c9e$export$2e2bcd8739ae039)();
    const preSignInErrorHandler = (0, $c93ac0a28f6f81db$export$2e2bcd8739ae039)();
    const errorHandlers = (0, $P551f.useMemo)(()=>(0, $0de5391da8318002$export$581ff339ea0ba762)({
            "user.username_already_in_use": (error)=>{
                setErrorMessage(error.message);
            }
        }, preSignInErrorHandler), [
        preSignInErrorHandler
    ]);
    const onSubmit = (0, $P551f.useCallback)(async (username)=>{
        const [error, result] = await asyncAddProfile({
            username: username
        });
        if (error) {
            await handleError(error, errorHandlers);
            return;
        }
        if (result === null || result === void 0 ? void 0 : result.redirectTo) window.location.replace(result.redirectTo);
    }, [
        asyncAddProfile,
        errorHandlers,
        handleError
    ]);
    return {
        errorMessage: errorMessage,
        clearErrorMessage: clearErrorMessage,
        onSubmit: onSubmit
    };
};
var $64f13073424bcf48$export$2e2bcd8739ae039 = $64f13073424bcf48$var$useSetUsername;


const $1c34dae73468f63b$var$SetUsername = (props)=>{
    const { onSubmit: onSubmit, errorMessage: errorMessage, clearErrorMessage: clearErrorMessage } = (0, $64f13073424bcf48$export$2e2bcd8739ae039)();
    const handleSubmit = async (identifier, value)=>{
        if (identifier !== (0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Username) return;
        return onSubmit(value);
    };
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $3dc734e3f6636ef1$export$2e2bcd8739ae039), (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({
        title: "description.enter_username",
        description: "description.enter_username_description"
    }, props), {
        children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $0de1ddd0411fb7d9$export$2e2bcd8739ae039), {
            autoFocus: true,
            errorMessage: errorMessage,
            clearErrorMessage: clearErrorMessage,
            defaultType: (0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Username,
            enabledTypes: [
                (0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Username
            ],
            onSubmit: handleSubmit
        })
    }));
};
var $1c34dae73468f63b$export$2e2bcd8739ae039 = $1c34dae73468f63b$var$SetUsername;


const $720c4ec3fe81222b$var$Continue = ()=>{
    const { method: method = "" } = (0, $2ed817dc54ac40e6$export$99eaa27ddbbb95ef)();
    if (method === (0, $e77cfc775e0ed7e6$export$68a887ed3b61b98e).password) return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $c0e7eb9d74783f13$export$2e2bcd8739ae039), {});
    if (method === (0, $e77cfc775e0ed7e6$export$68a887ed3b61b98e).username) return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $1c34dae73468f63b$export$2e2bcd8739ae039), {});
    if (method === (0, $e77cfc775e0ed7e6$export$68a887ed3b61b98e).email || method === (0, $e77cfc775e0ed7e6$export$68a887ed3b61b98e).phone || method === (0, $e77cfc775e0ed7e6$export$68a887ed3b61b98e).emailOrPhone) return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $c22df810d505ef45$export$2e2bcd8739ae039), {
        missingProfile: method
    });
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $bcc9cc4bed8427a6$export$2e2bcd8739ae039), {});
};
var $720c4ec3fe81222b$export$2e2bcd8739ae039 = $720c4ec3fe81222b$var$Continue;





var $P551f = parcelRequire("P551f");



var $P551f = parcelRequire("P551f");






const $80697e682fabf88a$var$useSocial = ()=>{
    const { experienceSettings: experienceSettings, theme: theme } = (0, $P551f.useContext)((0, $bf7e93717fb1eb16$export$2e2bcd8739ae039));
    const handleError = (0, $7ebd5fdad7a45c9e$export$2e2bcd8739ae039)();
    const asyncInvokeSocialSignIn = (0, $ab5ab705a7d3e209$export$2e2bcd8739ae039)((0, $72a4b194eaf87ab0$export$58837cdda1b658ed));
    const nativeSignInHandler = (0, $P551f.useCallback)((redirectTo, connector)=>{
        var _getLogtoNativeSdk;
        const { id: connectorId, platform: platform } = connector;
        const redirectUri = platform === "Universal" ? (0, $a48a66106483a58a$export$89813b95fc66aafa)(`/social/landing/${connectorId}`, redirectTo).toString() : redirectTo;
        (_getLogtoNativeSdk = (0, $955117e21b41598e$export$83ff207f4052eaad)()) === null || _getLogtoNativeSdk === void 0 ? void 0 : _getLogtoNativeSdk.getPostMessage()({
            callbackUri: `${window.location.origin}/sign-in/social/${connectorId}`,
            redirectTo: redirectUri
        });
    }, []);
    const invokeSocialSignInHandler = (0, $P551f.useCallback)(async (connector)=>{
        const { id: connectorId } = connector;
        const state = (0, $a48a66106483a58a$export$9ccd2716e53a229b)();
        (0, $a48a66106483a58a$export$ca97131192bad836)(state, connectorId);
        const [error, result] = await asyncInvokeSocialSignIn(connectorId, state, `${window.location.origin}/callback/${connectorId}`);
        if (error) {
            await handleError(error);
            return;
        }
        if (!(result === null || result === void 0 ? void 0 : result.redirectTo)) return;
        // Invoke Native Social Sign In flow
        if ((0, $955117e21b41598e$export$a38f4a317af23d71)()) {
            nativeSignInHandler(result.redirectTo, connector);
            return;
        }
        // Invoke Web Social Sign In flow
        window.location.assign(result.redirectTo);
    }, [
        asyncInvokeSocialSignIn,
        handleError,
        nativeSignInHandler
    ]);
    var _experienceSettings_socialConnectors;
    return {
        theme: theme,
        socialConnectors: (_experienceSettings_socialConnectors = experienceSettings === null || experienceSettings === void 0 ? void 0 : experienceSettings.socialConnectors) !== null && _experienceSettings_socialConnectors !== void 0 ? _experienceSettings_socialConnectors : [],
        invokeSocialSignIn: invokeSocialSignInHandler
    };
};
var $80697e682fabf88a$export$2e2bcd8739ae039 = $80697e682fabf88a$var$useSocial;




var $P551f = parcelRequire("P551f");

const $c27d4b4a657466b5$var$ssoPrefix = "/api/interaction/single-sign-on";
const $c27d4b4a657466b5$export$d4b3da5d4dacc637 = async (email)=>(0, $22a2a3b4b60018dd$export$2e2bcd8739ae039).get(`${$c27d4b4a657466b5$var$ssoPrefix}/connectors`, {
        searchParams: {
            email: email
        }
    }).json();
const $c27d4b4a657466b5$export$503f7663efe558b2 = async (connectorId, state, redirectUri)=>{
    const { redirectTo: redirectTo } = await (0, $22a2a3b4b60018dd$export$2e2bcd8739ae039).post(`${$c27d4b4a657466b5$var$ssoPrefix}/${connectorId}/authorization-url`, {
        json: {
            state: state,
            redirectUri: redirectUri
        }
    }).json();
    return redirectTo;
};
const $c27d4b4a657466b5$export$c0aa2525151c2215 = async (connectorId, payload)=>(0, $22a2a3b4b60018dd$export$2e2bcd8739ae039).post(`${$c27d4b4a657466b5$var$ssoPrefix}/${connectorId}/authentication`, {
        json: payload
    }).json();
const $c27d4b4a657466b5$export$db343ec66e79e78a = async (connectorId)=>(0, $22a2a3b4b60018dd$export$2e2bcd8739ae039).post(`${$c27d4b4a657466b5$var$ssoPrefix}/${connectorId}/registration`).json();






const $4e5779525579582e$var$useSingleSignOn = ()=>{
    const handleError = (0, $7ebd5fdad7a45c9e$export$2e2bcd8739ae039)();
    const asyncInvokeSingleSignOn = (0, $ab5ab705a7d3e209$export$2e2bcd8739ae039)((0, $c27d4b4a657466b5$export$503f7663efe558b2));
    /**
   * Native IdP Sign In Flow
   * @param redirectTo - The redirect uri to redirect after the IdP Sign In flow (Need for OIDC Code Flow)
   *
   * @remarks In Native we need to open a new window to invoke the IdP Sign In flow (safariViewController in iOS and Custom Tabs in Android)
   * Forked from @see `hooks/user-social.ts`
   *
   */ const nativeSignInHandler = (0, $P551f.useCallback)((redirectTo, connectorId)=>{
        var _getLogtoNativeSdk;
        const redirectUri = (0, $a48a66106483a58a$export$89813b95fc66aafa)(`/social/landing/${connectorId}`, redirectTo).toString();
        (_getLogtoNativeSdk = (0, $955117e21b41598e$export$83ff207f4052eaad)()) === null || _getLogtoNativeSdk === void 0 ? void 0 : _getLogtoNativeSdk.getPostMessage()({
            callbackUri: `${window.location.origin}/sign-in/social/${connectorId}`,
            redirectTo: redirectUri
        });
    }, []);
    /**
   * Invoke Single Sign On flow
   * Get the Single Sign On url from the backend and redirect to it
   */ return (0, $P551f.useCallback)(async (connectorId)=>{
        const state = (0, $a48a66106483a58a$export$9ccd2716e53a229b)();
        (0, $a48a66106483a58a$export$ca97131192bad836)(state, connectorId);
        const [error, redirectTo] = await asyncInvokeSingleSignOn(connectorId, state, `${window.location.origin}/callback/${connectorId}`);
        if (error) {
            await handleError(error);
            return;
        }
        if (!redirectTo) return;
        // Invoke Native Sign In flow
        if ((0, $955117e21b41598e$export$a38f4a317af23d71)()) nativeSignInHandler(redirectTo, connectorId);
        // Invoke Web Sign In flow
        window.location.assign(redirectTo);
    }, [
        asyncInvokeSingleSignOn,
        handleError,
        nativeSignInHandler
    ]);
};
var $4e5779525579582e$export$2e2bcd8739ae039 = $4e5779525579582e$var$useSingleSignOn;


const $21435978485dd732$var$DirectSignIn = ()=>{
    const { method: method, target: target } = (0, $2ed817dc54ac40e6$export$99eaa27ddbbb95ef)();
    const { socialConnectors: socialConnectors, ssoConnectors: ssoConnectors } = (0, $aa5a893d65a133eb$export$317715a729435b35)();
    const { invokeSocialSignIn: invokeSocialSignIn } = (0, $80697e682fabf88a$export$2e2bcd8739ae039)();
    const invokeSso = (0, $4e5779525579582e$export$2e2bcd8739ae039)();
    const fallback = (0, $P551f.useMemo)(()=>{
        var _Object_entries_find;
        const fallbackKey = new URLSearchParams(window.location.search).get("fallback");
        var _Object_entries_find_;
        return (_Object_entries_find_ = (_Object_entries_find = Object.entries((0, $a0052762c6755033$export$45794d16c9d83fe2).routes).find(([key])=>key === fallbackKey)) === null || _Object_entries_find === void 0 ? void 0 : _Object_entries_find[1]) !== null && _Object_entries_find_ !== void 0 ? _Object_entries_find_ : (0, $a0052762c6755033$export$45794d16c9d83fe2).routes.signIn;
    }, []);
    (0, $P551f.useEffect)(()=>{
        if (method === "social") {
            const social = socialConnectors.find((connector)=>connector.target === target);
            if (social) {
                invokeSocialSignIn(social);
                return;
            }
        }
        if (method === "sso") {
            const sso = ssoConnectors.find((connector)=>connector.id === target);
            if (sso) {
                invokeSso(sso.id);
                return;
            }
        }
        window.location.replace("/" + fallback);
    }, [
        fallback,
        invokeSocialSignIn,
        invokeSso,
        method,
        socialConnectors,
        ssoConnectors,
        target
    ]);
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $8aa5ba1326567b1e$export$2e2bcd8739ae039), {});
};
var $21435978485dd732$export$2e2bcd8739ae039 = $21435978485dd732$var$DirectSignIn;






var $P551f = parcelRequire("P551f");













var $P551f = parcelRequire("P551f");








var $1de6e73ff9719877$export$6210fa4921d2a466;
var $1de6e73ff9719877$export$ce85b9b1fe34d6d3;
var $1de6e73ff9719877$export$6f2f4d5c38fc8e55;
$1de6e73ff9719877$export$6210fa4921d2a466 = `jUsIwq_form`;
$1de6e73ff9719877$export$ce85b9b1fe34d6d3 = `jUsIwq_formErrors`;
$1de6e73ff9719877$export$6f2f4d5c38fc8e55 = `jUsIwq_inputField`;


const $3df703892cd008c1$var$ForgotPasswordForm = ({ className: className, autoFocus: autoFocus, defaultType: defaultType, defaultValue: defaultValue = "", enabledTypes: enabledTypes })=>{
    const { t: t } = (0, $5d79e62c9ff74ac9$export$9fc83ad70ead8663)();
    const { errorMessage: errorMessage, clearErrorMessage: clearErrorMessage, onSubmit: onSubmit } = (0, $e5f910429b93015b$export$2e2bcd8739ae039)((0, $6b1416e8e4d304fe$export$12e44e23ec720850).ForgotPassword);
    const { handleSubmit: handleSubmit, control: control, formState: { errors: errors, isValid: isValid } } = (0, $afcc65e7f92ff559$export$87c0cf8eb5a167e0)({
        reValidateMode: "onBlur",
        defaultValues: {
            identifier: {
                type: defaultType,
                value: defaultValue
            }
        }
    });
    (0, $P551f.useEffect)(()=>{
        if (!isValid) clearErrorMessage();
    }, [
        clearErrorMessage,
        isValid
    ]);
    const onSubmitHandler = (0, $P551f.useCallback)(async (event)=>{
        clearErrorMessage();
        handleSubmit(async ({ identifier: { type: type, value: value } })=>{
            if (!type) return;
            await onSubmit({
                identifier: type,
                value: value
            });
        })(event);
    }, [
        clearErrorMessage,
        handleSubmit,
        onSubmit
    ]);
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("form", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a6f0144cf2b2d456$exports)))($1de6e73ff9719877$export$6210fa4921d2a466, className),
        onSubmit: onSubmitHandler,
        children: [
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $afcc65e7f92ff559$export$bd0bf19f25da8474), {
                control: control,
                name: "identifier",
                rules: {
                    validate: (identifier)=>{
                        const { type: type, value: value } = identifier;
                        if (!type || !value) return (0, $5f609015ba424ff1$export$87161604d0c960f6)(enabledTypes, "required");
                        const errorMessage = (0, $5f609015ba424ff1$export$1222f18ddc446c49)(type, value);
                        var _errorMessage_data;
                        if (errorMessage) return typeof errorMessage === "string" ? t(`error.${errorMessage}`) : t(`error.${errorMessage.code}`, (_errorMessage_data = errorMessage.data) !== null && _errorMessage_data !== void 0 ? _errorMessage_data : {});
                        return true;
                    }
                },
                render: ({ field: field })=>{
                    var _errors_identifier;
                    /*#__PURE__*/ return (0, $b1404a408b0d045c$exports.jsx)((0, $5fa6bf3f237eb8ef$export$2e2bcd8739ae039), (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({
                        autoFocus: autoFocus,
                        className: $1de6e73ff9719877$export$6f2f4d5c38fc8e55
                    }, field), {
                        defaultType: defaultType,
                        defaultValue: defaultValue,
                        isDanger: !!errors.identifier,
                        errorMessage: (_errors_identifier = errors.identifier) === null || _errors_identifier === void 0 ? void 0 : _errors_identifier.message,
                        enabledTypes: enabledTypes
                    }));
                }
            }),
            errorMessage && /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $4ebb9c3ba9ede754$export$2e2bcd8739ae039), {
                className: $1de6e73ff9719877$export$ce85b9b1fe34d6d3,
                children: errorMessage
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $c6d8f26a28e11cb6$export$2e2bcd8739ae039), {
                title: "action.continue",
                htmlType: "submit"
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("input", {
                hidden: true,
                type: "submit"
            })
        ]
    });
};
var $3df703892cd008c1$export$2e2bcd8739ae039 = $3df703892cd008c1$var$ForgotPasswordForm;


const $58d5e993209d607f$var$ForgotPassword = ()=>{
    const { isForgotPasswordEnabled: isForgotPasswordEnabled, enabledMethodSet: enabledMethodSet } = (0, $aa5a893d65a133eb$export$9418daf6fcecfff4)();
    const { state: state } = (0, $2ed817dc54ac40e6$export$45d76561a5302f2b)();
    const { t: t } = (0, $5d79e62c9ff74ac9$export$9fc83ad70ead8663)();
    const enabledMethods = [
        ...enabledMethodSet
    ];
    const getDefaultIdentifierType = (0, $P551f.useCallback)((identifier)=>{
        if (identifier === (0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Username || identifier === (0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Email || !identifier) return enabledMethodSet.has((0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Email) ? (0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Email : (0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Phone;
        return enabledMethodSet.has((0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Phone) ? (0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Phone : (0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Email;
    }, [
        enabledMethodSet
    ]);
    if (!isForgotPasswordEnabled) return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $bcc9cc4bed8427a6$export$2e2bcd8739ae039), {});
    const [_, identifierState] = (0, $8a18d710f1d13368$export$a22775fa5e2eebd9)(state, (0, $4ffc90f7233cdad4$export$1e3360d68cdc393f));
    const defaultType = getDefaultIdentifierType(identifierState === null || identifierState === void 0 ? void 0 : identifierState.identifier);
    const defaultValue = (identifierState === null || identifierState === void 0 ? void 0 : identifierState.identifier) === defaultType && identifierState.value || "";
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $3dc734e3f6636ef1$export$2e2bcd8739ae039), {
        title: "description.reset_password",
        description: "description.reset_password_description",
        descriptionProps: {
            types: enabledMethods.map((method)=>t((0, $5f609015ba424ff1$export$71b8592ba731d4b5)[method]))
        },
        children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $3df703892cd008c1$export$2e2bcd8739ae039), {
            autoFocus: true,
            defaultType: defaultType,
            defaultValue: defaultValue,
            enabledTypes: enabledMethods
        })
    });
};
var $58d5e993209d607f$export$2e2bcd8739ae039 = $58d5e993209d607f$var$ForgotPassword;








var $P551f = parcelRequire("P551f");







parcelRequire("P551f");
const $90fadbbf30000ebc$var$SvgArrowNext = (props)=>/*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("svg", (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({
        width: 22,
        height: 22,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("path", {
            d: "m14.245 10.349-5.188-5.18a.917.917 0 1 0-1.302 1.293l4.537 4.583-4.537 4.538a.917.917 0 0 0 .298 1.495.917.917 0 0 0 .353.072.917.917 0 0 0 .65-.275l5.189-5.179a.917.917 0 0 0 0-1.347Z",
            fill: "currentcolor"
        })
    }));
var $90fadbbf30000ebc$export$2e2bcd8739ae039 = $90fadbbf30000ebc$var$SvgArrowNext;





parcelRequire("P551f");
const $6487e266ee531b3f$var$SvgFactorBackupCode = (props)=>/*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("svg", (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({
        width: 20,
        height: 20,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("path", {
            d: "M10 16.667H4.167a.833.833 0 0 1-.834-.834V4.167a.833.833 0 0 1 .834-.834h4.166v2.5a2.5 2.5 0 0 0 2.5 2.5h2.5v.834a.833.833 0 1 0 1.667 0V7.45a1.09 1.09 0 0 0-.05-.225V7.15a.893.893 0 0 0-.158-.233l-5-5a.892.892 0 0 0-.234-.159.267.267 0 0 0-.075 0 .733.733 0 0 0-.275-.091H4.167a2.5 2.5 0 0 0-2.5 2.5v11.666a2.5 2.5 0 0 0 2.5 2.5H10a.833.833 0 0 0 0-1.666Zm0-12.159 2.158 2.159h-1.325A.833.833 0 0 1 10 5.833V4.508ZM5.833 6.667a.833.833 0 1 0 0 1.666h.834a.833.833 0 1 0 0-1.666h-.834Zm12.259 10.241-.975-.966a2.867 2.867 0 0 0-.45-3.442 2.908 2.908 0 0 0-5 2.075 2.883 2.883 0 0 0 4.275 2.542l.966.975a.834.834 0 0 0 1.366-.272.833.833 0 0 0-.182-.912ZM15.45 15.45a1.283 1.283 0 0 1-1.758 0 1.25 1.25 0 0 1 .008-1.758c.222-.221.52-.35.833-.359a1.223 1.223 0 0 1 1.3 1.242 1.25 1.25 0 0 1-.383.875ZM10.833 10h-5a.834.834 0 0 0 0 1.667h5a.833.833 0 0 0 0-1.667Zm-1.666 5a.833.833 0 1 0 0-1.667H5.833a.833.833 0 1 0 0 1.667h3.334Z",
            fill: "currentColor"
        })
    }));
var $6487e266ee531b3f$export$2e2bcd8739ae039 = $6487e266ee531b3f$var$SvgFactorBackupCode;





parcelRequire("P551f");
const $e7ad2222fb87b0e0$var$SvgFactorTotp = (props)=>/*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("svg", (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({
        width: 20,
        height: 20,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("path", {
            d: "M17.5 1.667h-5a.833.833 0 0 0 0 1.666h4.167V7.5a.833.833 0 0 0 1.666 0v-5a.833.833 0 0 0-.833-.833Zm0 10a.833.833 0 0 0-.833.833v4.167H12.5a.833.833 0 0 0 0 1.666h5a.833.833 0 0 0 .833-.833v-5a.833.833 0 0 0-.833-.833ZM10 5a2.5 2.5 0 0 0-2.5 2.5v.833A1.667 1.667 0 0 0 5.833 10v3.333A1.667 1.667 0 0 0 7.5 15h5a1.667 1.667 0 0 0 1.667-1.667V10A1.666 1.666 0 0 0 12.5 8.333V7.5A2.5 2.5 0 0 0 10 5Zm-.833 2.5a.833.833 0 0 1 1.666 0v.833H9.167V7.5Zm3.333 5.833h-5V10h5v3.333Zm-10-5a.833.833 0 0 0 .833-.833V3.333H7.5a.833.833 0 1 0 0-1.666h-5a.833.833 0 0 0-.833.833v5a.833.833 0 0 0 .833.833Zm5 8.334H3.333V12.5a.833.833 0 1 0-1.666 0v5a.833.833 0 0 0 .833.833h5a.833.833 0 1 0 0-1.666Z",
            fill: "currentColor"
        })
    }));
var $e7ad2222fb87b0e0$export$2e2bcd8739ae039 = $e7ad2222fb87b0e0$var$SvgFactorTotp;





parcelRequire("P551f");
const $b6992b603c78c32f$var$SvgFactorWebauthn = (props)=>/*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("svg", (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({
        width: 20,
        height: 20,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("g", {
                clipPath: "url(#factor-webauthn_svg__a)",
                fillRule: "evenodd",
                clipRule: "evenodd",
                fill: "currentColor",
                children: [
                    /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("path", {
                        d: "M10 2.917a.417.417 0 0 0-.417-.417h-5a.417.417 0 0 0-.416.417v2.916H10V2.917ZM4.167.833C3.247.833 2.5 1.58 2.5 2.5v3.333c0 .92.746.834 1.667.834H10c.92 0 1.667.087 1.667-.834V2.5c0-.92-.746-1.667-1.667-1.667H4.167Z"
                    }),
                    /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("path", {
                        d: "M.833 7.5c0-.92.747-1.667 1.667-1.667h9.167c.92 0 1.666.746 1.666 1.667H2.917a.417.417 0 0 0-.417.417v9.166c0 .23.187.417.417.417H5a.833.833 0 0 1 0 1.667H2.5c-.92 0-1.667-.747-1.667-1.667v-10ZM5.833 5a.833.833 0 1 1 0-1.667.833.833 0 0 1 0 1.667ZM8.333 5a.833.833 0 1 1 0-1.667.833.833 0 0 1 0 1.667Z"
                    }),
                    /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("path", {
                        d: "M13.75 10C11.602 10 10 11.565 10 13.333v5a.833.833 0 0 1-1.667 0v-5c0-2.834 2.502-5 5.417-5s5.417 2.166 5.417 5V15a.833.833 0 1 1-1.667 0v-1.667c0-1.768-1.602-3.333-3.75-3.333Z"
                    }),
                    /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("path", {
                        d: "M13.75 12.5c.767 0 1.25.548 1.25 1.06v4.773a.833.833 0 0 0 1.667 0v-4.772c0-1.58-1.383-2.728-2.917-2.728-1.534 0-2.917 1.148-2.917 2.727v.758a.833.833 0 0 0 1.667 0v-.758c0-.512.483-1.06 1.25-1.06ZM18.333 16.666c.46 0 .834.374.834.834v.833a.833.833 0 0 1-1.667 0V17.5c0-.46.373-.834.833-.834Z"
                    }),
                    /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("path", {
                        d: "M13.75 16.666c.46 0 .833.374.833.834v.833a.833.833 0 0 1-1.666 0V17.5c0-.46.373-.834.833-.834ZM11.667 15.833c.46 0 .833.373.833.834v1.666a.833.833 0 0 1-1.667 0v-1.666c0-.46.373-.834.834-.834ZM13.75 13.333c.46 0 .833.373.833.834V15a.833.833 0 1 1-1.666 0v-.833c0-.46.373-.834.833-.834Z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("clipPath", {
                    id: "factor-webauthn_svg__a",
                    children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h20v20H0z"
                    })
                })
            })
        ]
    }));
var $b6992b603c78c32f$export$2e2bcd8739ae039 = $b6992b603c78c32f$var$SvgFactorWebauthn;



var $f6967769ba75094b$export$6d59db4903f20f7d;
var $f6967769ba75094b$export$1ca1ec8b29a4ce27;
var $f6967769ba75094b$export$c4590d09863419f6;
var $f6967769ba75094b$export$a8ff84c12d48cfa6;
var $f6967769ba75094b$export$fb184b623420d9be;
$f6967769ba75094b$export$6d59db4903f20f7d = `lgmZXW_description`;
$f6967769ba75094b$export$1ca1ec8b29a4ce27 = `lgmZXW_icon`;
$f6967769ba75094b$export$c4590d09863419f6 = `lgmZXW_mfaFactorButton`;
$f6967769ba75094b$export$a8ff84c12d48cfa6 = `lgmZXW_name`;
$f6967769ba75094b$export$fb184b623420d9be = `lgmZXW_title`;



const $0ce1d2cc0074879c$var$factorIcon = {
    [(0, $c0e46a7ec45ea8f3$export$c62e7669a75c5961).TOTP]: (0, $e7ad2222fb87b0e0$export$2e2bcd8739ae039),
    [(0, $c0e46a7ec45ea8f3$export$c62e7669a75c5961).WebAuthn]: (0, $b6992b603c78c32f$export$2e2bcd8739ae039),
    [(0, $c0e46a7ec45ea8f3$export$c62e7669a75c5961).BackupCode]: (0, $6487e266ee531b3f$export$2e2bcd8739ae039)
};
const $0ce1d2cc0074879c$var$factorName = {
    [(0, $c0e46a7ec45ea8f3$export$c62e7669a75c5961).TOTP]: "mfa.totp",
    [(0, $c0e46a7ec45ea8f3$export$c62e7669a75c5961).WebAuthn]: "mfa.webauthn",
    [(0, $c0e46a7ec45ea8f3$export$c62e7669a75c5961).BackupCode]: "mfa.backup_code"
};
const $0ce1d2cc0074879c$var$factorDescription = {
    [(0, $c0e46a7ec45ea8f3$export$c62e7669a75c5961).TOTP]: "mfa.verify_totp_description",
    [(0, $c0e46a7ec45ea8f3$export$c62e7669a75c5961).WebAuthn]: "mfa.verify_webauthn_description",
    [(0, $c0e46a7ec45ea8f3$export$c62e7669a75c5961).BackupCode]: "mfa.verify_backup_code_description"
};
const $0ce1d2cc0074879c$var$linkFactorDescription = {
    [(0, $c0e46a7ec45ea8f3$export$c62e7669a75c5961).TOTP]: "mfa.link_totp_description",
    [(0, $c0e46a7ec45ea8f3$export$c62e7669a75c5961).WebAuthn]: "mfa.link_webauthn_description",
    [(0, $c0e46a7ec45ea8f3$export$c62e7669a75c5961).BackupCode]: "mfa.link_backup_code_description"
};
const $0ce1d2cc0074879c$var$MfaFactorButton = ({ factor: factor, isBinding: isBinding, onClick: onClick })=>{
    const Icon = $0ce1d2cc0074879c$var$factorIcon[factor];
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("button", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a6f0144cf2b2d456$exports)))($38cf9015ace287df$export$2ba01fb71ed41cb6, $38cf9015ace287df$export$745c6f71a1e0e6f7, $38cf9015ace287df$export$f09585a853dddd32, $f6967769ba75094b$export$c4590d09863419f6),
        type: "button",
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)(Icon, {
                className: $f6967769ba75094b$export$1ca1ec8b29a4ce27
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("div", {
                className: $f6967769ba75094b$export$fb184b623420d9be,
                children: [
                    /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("div", {
                        className: $f6967769ba75094b$export$a8ff84c12d48cfa6,
                        children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $cfcdc2df19be03b3$export$2e2bcd8739ae039), {
                            forKey: $0ce1d2cc0074879c$var$factorName[factor]
                        })
                    }),
                    /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("div", {
                        className: $f6967769ba75094b$export$6d59db4903f20f7d,
                        children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $cfcdc2df19be03b3$export$2e2bcd8739ae039), {
                            forKey: (isBinding ? $0ce1d2cc0074879c$var$linkFactorDescription : $0ce1d2cc0074879c$var$factorDescription)[factor]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $90fadbbf30000ebc$export$2e2bcd8739ae039), {
                className: $f6967769ba75094b$export$1ca1ec8b29a4ce27
            })
        ]
    });
};
var $0ce1d2cc0074879c$export$2e2bcd8739ae039 = $0ce1d2cc0074879c$var$MfaFactorButton;





var $b1142f0c328cd81b$export$de1e4d7d21c95b75;
$b1142f0c328cd81b$export$de1e4d7d21c95b75 = `uWV7sG_factorList`;


const $eff2560959689c59$var$MfaFactorList = ({ flow: flow, flowState: flowState })=>{
    const startTotpBinding = (0, $939f090fab5f8181$export$2e2bcd8739ae039)();
    const startWebAuthnProcessing = (0, $cac28407a0c07ec3$export$2e2bcd8739ae039)();
    const navigate = (0, $2ed817dc54ac40e6$export$9770f232ac06a008)();
    const { availableFactors: availableFactors } = flowState;
    const handleSelectFactor = (0, $P551f.useCallback)(async (factor)=>{
        if (factor === (0, $c0e46a7ec45ea8f3$export$c62e7669a75c5961).TOTP && flow === (0, $6b1416e8e4d304fe$export$6a49be5b3307a2d).MfaBinding) return startTotpBinding(flowState);
        if (factor === (0, $c0e46a7ec45ea8f3$export$c62e7669a75c5961).WebAuthn) return startWebAuthnProcessing(flow, flowState);
        navigate(`/${flow}/${factor}`, {
            state: flowState
        });
    }, [
        flow,
        flowState,
        navigate,
        startTotpBinding,
        startWebAuthnProcessing
    ]);
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("div", {
        className: $b1142f0c328cd81b$export$de1e4d7d21c95b75,
        children: availableFactors.map((factor)=>/*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $0ce1d2cc0074879c$export$2e2bcd8739ae039), {
                factor: factor,
                isBinding: flow === (0, $6b1416e8e4d304fe$export$6a49be5b3307a2d).MfaBinding,
                onClick: async ()=>{
                    await handleSelectFactor(factor);
                }
            }, factor))
    });
};
var $eff2560959689c59$export$2e2bcd8739ae039 = $eff2560959689c59$var$MfaFactorList;





const $53925cf076a1980a$var$useMfaFlowState = ()=>{
    const { state: state } = (0, $2ed817dc54ac40e6$export$45d76561a5302f2b)();
    const [, mfaFlowState] = (0, $8a18d710f1d13368$export$a22775fa5e2eebd9)(state, (0, $4ffc90f7233cdad4$export$5b8a6b67ca446381));
    return mfaFlowState;
};
var $53925cf076a1980a$export$2e2bcd8739ae039 = $53925cf076a1980a$var$useMfaFlowState;



var $P551f = parcelRequire("P551f");




const $8527019be94cc548$var$useSkipMfa = ()=>{
    const asyncSkipMfa = (0, $ab5ab705a7d3e209$export$2e2bcd8739ae039)((0, $72a4b194eaf87ab0$export$19773ff1b0ccf87f));
    const handleError = (0, $7ebd5fdad7a45c9e$export$2e2bcd8739ae039)();
    const preSignInErrorHandler = (0, $c93ac0a28f6f81db$export$2e2bcd8739ae039)({
        replace: true
    });
    return (0, $P551f.useCallback)(async ()=>{
        const [error, result] = await asyncSkipMfa();
        if (error) {
            await handleError(error, preSignInErrorHandler);
            return;
        }
        if (result) window.location.replace(result.redirectTo);
    }, [
        asyncSkipMfa,
        handleError,
        preSignInErrorHandler
    ]);
};
var $8527019be94cc548$export$2e2bcd8739ae039 = $8527019be94cc548$var$useSkipMfa;




const $c6e46251486b8cf2$var$MfaBinding = ()=>{
    const flowState = (0, $53925cf076a1980a$export$2e2bcd8739ae039)();
    const skipMfa = (0, $8527019be94cc548$export$2e2bcd8739ae039)();
    if (!flowState) return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $bcc9cc4bed8427a6$export$2e2bcd8739ae039), {
        title: "error.invalid_session"
    });
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $3dc734e3f6636ef1$export$2e2bcd8739ae039), {
        title: "mfa.add_mfa_factors",
        description: "mfa.add_mfa_description",
        onSkip: (0, $dd763c2393b0d659$export$c327da55a124987a)(flowState.skippable && skipMfa),
        children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $eff2560959689c59$export$2e2bcd8739ae039), {
            flow: (0, $6b1416e8e4d304fe$export$6a49be5b3307a2d).MfaBinding,
            flowState: flowState
        })
    });
};
var $c6e46251486b8cf2$export$2e2bcd8739ae039 = $c6e46251486b8cf2$var$MfaBinding;












var $P551f = parcelRequire("P551f");





const $7af16b0b7f1047f2$var$sendMfaPayloadApi = async ({ flow: flow, payload: payload })=>{
    if (flow === (0, $6b1416e8e4d304fe$export$6a49be5b3307a2d).MfaBinding) return (0, $72a4b194eaf87ab0$export$8a7ec544b861c507)(payload);
    return (0, $72a4b194eaf87ab0$export$f34dd6a11cbbbf5c)(payload);
};
const $7af16b0b7f1047f2$var$useSendMfaPayload = ()=>{
    const asyncSendMfaPayload = (0, $ab5ab705a7d3e209$export$2e2bcd8739ae039)($7af16b0b7f1047f2$var$sendMfaPayloadApi);
    const preSignInErrorHandler = (0, $c93ac0a28f6f81db$export$2e2bcd8739ae039)({
        replace: true
    });
    const handleError = (0, $7ebd5fdad7a45c9e$export$2e2bcd8739ae039)();
    return (0, $P551f.useCallback)(async (apiOptions, errorHandlers, errorCallback)=>{
        const [error, result] = await asyncSendMfaPayload(apiOptions);
        if (error) {
            await handleError(error, (0, $0de5391da8318002$export$581ff339ea0ba762)({}, errorHandlers, preSignInErrorHandler));
            errorCallback === null || errorCallback === void 0 ? void 0 : errorCallback();
            return;
        }
        if (result) window.location.replace(result.redirectTo);
    }, [
        asyncSendMfaPayload,
        handleError,
        preSignInErrorHandler
    ]);
};
var $7af16b0b7f1047f2$export$2e2bcd8739ae039 = $7af16b0b7f1047f2$var$useSendMfaPayload;



var $P551f = parcelRequire("P551f");

const $5ad83ab2e959593d$var$useTextHandler = ()=>{
    const { setToast: setToast } = (0, $d1e7a25fbbe7c8e1$export$2e2bcd8739ae039)();
    const copyText = (0, $P551f.useCallback)(async (text, successMessage)=>{
        await navigator.clipboard.writeText(text);
        setToast(successMessage);
    }, [
        setToast
    ]);
    const downloadText = (0, $P551f.useCallback)((text, filename)=>{
        const blob = new Blob([
            text
        ], {
            type: "text/plain"
        });
        const downloadLink = document.createElement("a");
        // eslint-disable-next-line @silverhand/fp/no-mutation
        downloadLink.href = URL.createObjectURL(blob);
        // eslint-disable-next-line @silverhand/fp/no-mutation
        downloadLink.download = filename;
        downloadLink.click();
    }, []);
    return {
        copyText: copyText,
        downloadText: downloadText
    };
};
var $5ad83ab2e959593d$export$2e2bcd8739ae039 = $5ad83ab2e959593d$var$useTextHandler;






var $3f92ef32a0a0e4ff$export$e324594224ef24da;
var $3f92ef32a0a0e4ff$export$d948f76ad23c84aa;
var $3f92ef32a0a0e4ff$export$34e0f9847d4c02dd;
var $3f92ef32a0a0e4ff$export$464c821cd4347539;
$3f92ef32a0a0e4ff$export$e324594224ef24da = `-6MASG_actions`;
$3f92ef32a0a0e4ff$export$d948f76ad23c84aa = `-6MASG_backupCodes`;
$3f92ef32a0a0e4ff$export$34e0f9847d4c02dd = `-6MASG_container`;
$3f92ef32a0a0e4ff$export$464c821cd4347539 = `-6MASG_hint`;


const $02fd4339abc7ac9a$var$BackupCodeBinding = ()=>{
    const { copyText: copyText, downloadText: downloadText } = (0, $5ad83ab2e959593d$export$2e2bcd8739ae039)();
    const sendMfaPayload = (0, $7af16b0b7f1047f2$export$2e2bcd8739ae039)();
    const { state: state } = (0, $2ed817dc54ac40e6$export$45d76561a5302f2b)();
    const [, backupCodeBindingState] = (0, $8a18d710f1d13368$export$a22775fa5e2eebd9)(state, (0, $4ffc90f7233cdad4$export$8572183290edea8b));
    if (!backupCodeBindingState) return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $bcc9cc4bed8427a6$export$2e2bcd8739ae039), {
        title: "error.invalid_session"
    });
    const { codes: codes } = backupCodeBindingState;
    const backupCodeTextContent = codes.join("\n");
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $3dc734e3f6636ef1$export$2e2bcd8739ae039), {
        isNavBarHidden: true,
        title: "mfa.save_backup_code",
        description: "mfa.save_backup_code_description",
        children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("div", {
            className: $3f92ef32a0a0e4ff$export$34e0f9847d4c02dd,
            children: [
                /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("div", {
                    className: $3f92ef32a0a0e4ff$export$d948f76ad23c84aa,
                    children: codes.map((code)=>/*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("span", {
                            children: code
                        }, code))
                }),
                /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("div", {
                    className: $3f92ef32a0a0e4ff$export$e324594224ef24da,
                    children: [
                        !(0, $955117e21b41598e$export$a38f4a317af23d71)() && /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $c6d8f26a28e11cb6$export$2e2bcd8739ae039), {
                            title: "action.download",
                            type: "secondary",
                            onClick: ()=>{
                                downloadText(backupCodeTextContent, "backup_code.txt");
                            }
                        }),
                        /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $c6d8f26a28e11cb6$export$2e2bcd8739ae039), {
                            title: "action.copy",
                            type: "secondary",
                            onClick: ()=>{
                                copyText(backupCodeTextContent, (0, $86e325ac3ddbcfa1$export$625550452a3fa3ec)("mfa.backup_code_copied"));
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("div", {
                    className: $3f92ef32a0a0e4ff$export$464c821cd4347539,
                    children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $cfcdc2df19be03b3$export$2e2bcd8739ae039), {
                        forKey: "mfa.backup_code_hint"
                    })
                }),
                /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $c6d8f26a28e11cb6$export$2e2bcd8739ae039), {
                    title: "action.continue",
                    onClick: ()=>{
                        sendMfaPayload({
                            flow: (0, $6b1416e8e4d304fe$export$6a49be5b3307a2d).MfaBinding,
                            payload: {
                                type: (0, $c0e46a7ec45ea8f3$export$c62e7669a75c5961).BackupCode
                            }
                        });
                    }
                })
            ]
        })
    });
};
var $02fd4339abc7ac9a$export$2e2bcd8739ae039 = $02fd4339abc7ac9a$var$BackupCodeBinding;











var $48af440808fa527e$export$e8c9778bf415dd08;
var $48af440808fa527e$export$53f1d5ea8de3d7c;
var $48af440808fa527e$export$f0e8bbb074e276d6;
$48af440808fa527e$export$e8c9778bf415dd08 = `xfK4vq_divider`;
$48af440808fa527e$export$53f1d5ea8de3d7c = `xfK4vq_line`;
$48af440808fa527e$export$f0e8bbb074e276d6 = `xfK4vq_withLabel`;


const $6994ccd4805f2603$var$Divider = ({ className: className, label: label })=>{
    const lineStyle = (0, (/*@__PURE__*/$parcel$interopDefault($a6f0144cf2b2d456$exports)))($48af440808fa527e$export$53f1d5ea8de3d7c, label && $48af440808fa527e$export$f0e8bbb074e276d6);
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a6f0144cf2b2d456$exports)))($48af440808fa527e$export$e8c9778bf415dd08, className),
        children: [
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("i", {
                className: lineStyle
            }),
            label && /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)((0, $b1404a408b0d045c$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $cfcdc2df19be03b3$export$2e2bcd8739ae039), {
                        forKey: label
                    }),
                    /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("i", {
                        className: lineStyle
                    })
                ]
            })
        ]
    });
};
var $6994ccd4805f2603$export$2e2bcd8739ae039 = $6994ccd4805f2603$var$Divider;






parcelRequire("P551f");
const $26ff4924fb501836$var$SvgSwitchIcon = (props)=>/*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("svg", (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({
        width: 18,
        height: 18,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("path", {
            d: "m16.282 6.713-3-3a.753.753 0 0 0-1.065 1.065l1.726 1.718H5.25a.75.75 0 0 0 0 1.5h10.5a.75.75 0 0 0 .69-.465.75.75 0 0 0-.158-.818Zm-3.532 3.783H2.25a.75.75 0 0 0-.69.465.75.75 0 0 0 .157.817l3 3a.752.752 0 0 0 1.23-.82.75.75 0 0 0-.165-.245l-1.725-1.717h8.693a.75.75 0 0 0 0-1.5Z",
            fill: "currentcolor"
        })
    }));
var $26ff4924fb501836$export$2e2bcd8739ae039 = $26ff4924fb501836$var$SvgSwitchIcon;




const $b558eda3fd627c81$var$SwitchMfaFactorsLink = ({ flow: flow, flowState: flowState, className: className })=>{
    const { availableFactors: availableFactors } = flowState;
    if (availableFactors.length < 2) return null;
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $b6cc3a098ca171c6$export$2e2bcd8739ae039), {
        to: `/${flow}`,
        text: flow === (0, $6b1416e8e4d304fe$export$6a49be5b3307a2d).MfaBinding ? "mfa.link_another_mfa_factor" : "mfa.try_another_verification_method",
        className: className,
        icon: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $26ff4924fb501836$export$2e2bcd8739ae039), {}),
        state: flowState
    });
};
var $b558eda3fd627c81$export$2e2bcd8739ae039 = $b558eda3fd627c81$var$SwitchMfaFactorsLink;








var $P551f = parcelRequire("P551f");



var $9beb64d38c64c033$export$6d59db4903f20f7d;
var $9beb64d38c64c033$export$fb184b623420d9be;
$9beb64d38c64c033$export$6d59db4903f20f7d = `jP7_6G_description`;
$9beb64d38c64c033$export$fb184b623420d9be = `jP7_6G_title`;


const $27060c9ab8bf4b0d$var$SectionLayout = ({ title: title, description: description, titleProps: titleProps, descriptionProps: descriptionProps, children: children })=>{
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("div", {
                className: $9beb64d38c64c033$export$fb184b623420d9be,
                children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $cfcdc2df19be03b3$export$2e2bcd8739ae039), {
                    forKey: title,
                    interpolation: titleProps
                })
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("div", {
                className: $9beb64d38c64c033$export$6d59db4903f20f7d,
                children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $cfcdc2df19be03b3$export$2e2bcd8739ae039), {
                    forKey: description,
                    interpolation: descriptionProps
                })
            }),
            children
        ]
    });
};
var $27060c9ab8bf4b0d$export$2e2bcd8739ae039 = $27060c9ab8bf4b0d$var$SectionLayout;






var $c4f526faaacf50fe$export$4e64a6b8369675a7;
var $c4f526faaacf50fe$export$b60d6dac5af5488;
var $c4f526faaacf50fe$export$16e41c2d67dd1b0e;
var $c4f526faaacf50fe$export$5835540ef8b17ae6;
$c4f526faaacf50fe$export$4e64a6b8369675a7 = `aeeO8G_copySecret`;
$c4f526faaacf50fe$export$b60d6dac5af5488 = `aeeO8G_qrCode`;
$c4f526faaacf50fe$export$16e41c2d67dd1b0e = `aeeO8G_rawSecret`;
$c4f526faaacf50fe$export$5835540ef8b17ae6 = `aeeO8G_secretContent`;


const $6e44d0e714cef9cd$var$SecretSection = ({ secret: secret, secretQrCode: secretQrCode })=>{
    const { t: t } = (0, $5d79e62c9ff74ac9$export$9fc83ad70ead8663)();
    const { isMobile: isMobile } = (0, $37bc2555b7bb33e3$export$2e2bcd8739ae039)();
    const [isQrCodeFormat, setIsQrCodeFormat] = (0, $P551f.useState)(!isMobile);
    const { copyText: copyText } = (0, $5ad83ab2e959593d$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $27060c9ab8bf4b0d$export$2e2bcd8739ae039), {
        title: "mfa.step",
        titleProps: {
            step: 1,
            content: t(isQrCodeFormat ? "mfa.scan_qr_code" : "mfa.copy_and_paste_key")
        },
        description: isQrCodeFormat ? "mfa.scan_qr_code_description" : "mfa.copy_and_paste_key_description",
        children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("div", {
            className: $c4f526faaacf50fe$export$5835540ef8b17ae6,
            children: [
                isQrCodeFormat && secretQrCode && /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("div", {
                    className: $c4f526faaacf50fe$export$b60d6dac5af5488,
                    children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("img", {
                        src: secretQrCode,
                        alt: "QR code"
                    })
                }),
                !isQrCodeFormat && /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("div", {
                    className: $c4f526faaacf50fe$export$4e64a6b8369675a7,
                    children: [
                        /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("div", {
                            className: $c4f526faaacf50fe$export$16e41c2d67dd1b0e,
                            children: secret
                        }),
                        /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $c6d8f26a28e11cb6$export$2e2bcd8739ae039), {
                            title: "action.copy",
                            type: "secondary",
                            onClick: ()=>{
                                copyText(secret, t("mfa.secret_key_copied"));
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $b6cc3a098ca171c6$export$2e2bcd8739ae039), {
                    text: isQrCodeFormat ? "mfa.qr_code_not_available" : "mfa.want_to_scan_qr_code",
                    onClick: ()=>{
                        setIsQrCodeFormat(!isQrCodeFormat);
                    }
                })
            ]
        })
    });
};
var $6e44d0e714cef9cd$export$2e2bcd8739ae039 = $6e44d0e714cef9cd$var$SecretSection;







var $P551f = parcelRequire("P551f");


var $P551f = parcelRequire("P551f");

var $b1fef8ec68b31886$export$493b5823483d2c4e;
var $b1fef8ec68b31886$export$b3b71c1d4dc5616d;
$b1fef8ec68b31886$export$493b5823483d2c4e = `Ndr59a_errorMessage`;
$b1fef8ec68b31886$export$b3b71c1d4dc5616d = `Ndr59a_passcode`;


const $f054060f7cd4db44$export$439d7c9fdf7148d2 = 6;
const $f054060f7cd4db44$var$isNumeric = (char)=>/^\d+$/.test(char);
const $f054060f7cd4db44$var$normalize = (value, length)=>{
    if (value.length > length) return value.slice(0, length);
    if (value.length < length) // Undefined will not overwrite the original input displays, need to pass in empty string instead
    return value.concat(Array.from({
        length: length - value.length
    }).fill(""));
    return value;
};
const $f054060f7cd4db44$var$VerificationCode = ({ name: name, className: className, value: value, length: length = $f054060f7cd4db44$export$439d7c9fdf7148d2, error: error, onChange: onChange })=>{
    /* eslint-disable @typescript-eslint/ban-types */ const inputReferences = (0, $P551f.useRef)(Array.from({
        length: length
    }).fill(null));
    /* eslint-enable @typescript-eslint/ban-types */ const codes = (0, $P551f.useMemo)(()=>$f054060f7cd4db44$var$normalize(value, length), [
        length,
        value
    ]);
    const updateValue = (0, $P551f.useCallback)((data, targetId)=>{
        // Filter non-numeric input
        if (!$f054060f7cd4db44$var$isNumeric(data)) return;
        const chars = data.split("");
        const trimmedChars = chars.slice(0, Math.min(chars.length, codes.length - targetId));
        const value = [
            ...codes.slice(0, targetId),
            ...trimmedChars,
            ...codes.slice(targetId + trimmedChars.length, codes.length)
        ];
        onChange(value);
        // Move to the next target
        const nextTarget = inputReferences.current[Math.min(targetId + trimmedChars.length, codes.length - 1)];
        nextTarget === null || nextTarget === void 0 ? void 0 : nextTarget.focus();
    }, [
        codes,
        onChange
    ]);
    const onInputHandler = (0, $P551f.useCallback)((event)=>{
        const { target: target } = event;
        if (!(target instanceof HTMLInputElement)) return;
        const { value: value, dataset: dataset } = target;
        // Unrecognized target input field
        if (!dataset.id) return;
        event.preventDefault();
        updateValue(value, Number(dataset.id));
    }, [
        updateValue
    ]);
    const onPasteHandler = (0, $P551f.useCallback)((event)=>{
        var _clipboardData_getData_match;
        if (!(event.target instanceof HTMLInputElement)) return;
        const { target: { dataset: dataset }, clipboardData: clipboardData } = event;
        var _clipboardData_getData_match_join;
        const data = (_clipboardData_getData_match_join = (_clipboardData_getData_match = clipboardData.getData("text").match(/\d/g)) === null || _clipboardData_getData_match === void 0 ? void 0 : _clipboardData_getData_match.join("")) !== null && _clipboardData_getData_match_join !== void 0 ? _clipboardData_getData_match_join : "";
        // Unrecognized target input field
        if (!dataset.id) return;
        event.preventDefault();
        updateValue(data, Number(dataset.id));
    }, [
        updateValue
    ]);
    const onKeyDownHandler = (0, $P551f.useCallback)((event)=>{
        const { key: key, target: target } = event;
        if (!(target instanceof HTMLInputElement)) return;
        const { value: value, dataset: dataset } = target;
        if (!dataset.id) return;
        const targetId = Number(dataset.id);
        const nextTarget = inputReferences.current[targetId + 1];
        const previousTarget = inputReferences.current[targetId - 1];
        switch(key){
            case "Backspace":
                event.preventDefault();
                if (value) {
                    onChange(Object.assign([], codes, {
                        [targetId]: ""
                    }));
                    break;
                }
                if (previousTarget) {
                    previousTarget.focus();
                    onChange(Object.assign([], codes, {
                        [targetId - 1]: ""
                    }));
                }
                break;
            case "ArrowLeft":
                event.preventDefault();
                previousTarget === null || previousTarget === void 0 ? void 0 : previousTarget.focus();
                break;
            case "ArrowRight":
                event.preventDefault();
                nextTarget === null || nextTarget === void 0 ? void 0 : nextTarget.focus();
                break;
            case "+":
            case "-":
            case "e":
            case ".":
            case "ArrowUp":
            case "ArrowDown":
                event.preventDefault();
                break;
            default:
                break;
        }
    }, [
        codes,
        onChange
    ]);
    (0, $P551f.useEffect)(()=>{
        var _inputReferences_current_;
        if (value.length === 0) (_inputReferences_current_ = inputReferences.current[0]) === null || _inputReferences_current_ === void 0 ? void 0 : _inputReferences_current_.focus();
    }, [
        value
    ]);
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("div", {
                className: $b1fef8ec68b31886$export$b3b71c1d4dc5616d,
                children: Array.from({
                    length: length
                }).map((_, index)=>/*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("input", {
                        ref: (element)=>{
                            // eslint-disable-next-line @silverhand/fp/no-mutation
                            inputReferences.current[index] = element;
                        },
                        name: `${name}_${index}`,
                        "data-id": index,
                        value: codes[index],
                        type: "number",
                        inputMode: "numeric",
                        pattern: "[0-9]*",
                        autoComplete: "off",
                        onPaste: onPasteHandler,
                        onInput: onInputHandler,
                        onKeyDown: onKeyDownHandler
                    }, `${name}_${index}`))
            }),
            error && /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $4ebb9c3ba9ede754$export$2e2bcd8739ae039), {
                className: $b1fef8ec68b31886$export$493b5823483d2c4e,
                children: error
            })
        ]
    });
};
var $f054060f7cd4db44$export$2e2bcd8739ae039 = $f054060f7cd4db44$var$VerificationCode;


var $2e40f3a95bf05e98$export$6bfe5f8f78a52905;
$2e40f3a95bf05e98$export$6bfe5f8f78a52905 = `UnDi8G_totpCodeInput`;




var $P551f = parcelRequire("P551f");

const $095eeac1196028f1$var$useTotpCodeVerification = (flow, errorCallback)=>{
    const [errorMessage, setErrorMessage] = (0, $P551f.useState)();
    const sendMfaPayload = (0, $7af16b0b7f1047f2$export$2e2bcd8739ae039)();
    const invalidCodeErrorHandlers = (0, $P551f.useMemo)(()=>({
            "session.mfa.invalid_totp_code": (error)=>{
                setErrorMessage(error.message);
            }
        }), []);
    const onSubmit = (0, $P551f.useCallback)((code)=>{
        sendMfaPayload({
            flow: flow,
            payload: {
                type: (0, $c0e46a7ec45ea8f3$export$c62e7669a75c5961).TOTP,
                code: code
            }
        }, invalidCodeErrorHandlers, errorCallback);
    }, [
        errorCallback,
        flow,
        invalidCodeErrorHandlers,
        sendMfaPayload
    ]);
    return {
        errorMessage: errorMessage,
        onSubmit: onSubmit
    };
};
var $095eeac1196028f1$export$2e2bcd8739ae039 = $095eeac1196028f1$var$useTotpCodeVerification;


const $869cf96729320806$var$totpCodeLength = 6;
const $869cf96729320806$var$TotpCodeVerification = ({ flow: flow })=>{
    const [code, setCode] = (0, $P551f.useState)([]);
    const errorCallback = (0, $P551f.useCallback)(()=>{
        setCode([]);
    }, []);
    const { errorMessage: errorMessage, onSubmit: onSubmit } = (0, $095eeac1196028f1$export$2e2bcd8739ae039)(flow, errorCallback);
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $f054060f7cd4db44$export$2e2bcd8739ae039), {
        name: "totpCode",
        value: code,
        className: $2e40f3a95bf05e98$export$6bfe5f8f78a52905,
        error: errorMessage,
        onChange: (code)=>{
            setCode(code);
            if (code.length === $869cf96729320806$var$totpCodeLength && code.every(Boolean)) onSubmit(code.join(""));
        }
    });
};
var $869cf96729320806$export$2e2bcd8739ae039 = $869cf96729320806$var$TotpCodeVerification;



const $8aa5cd5f09419c8f$var$VerificationSection = ()=>{
    const { t: t } = (0, $5d79e62c9ff74ac9$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $27060c9ab8bf4b0d$export$2e2bcd8739ae039), {
        title: "mfa.step",
        titleProps: {
            step: 2,
            content: t("mfa.enter_one_time_code")
        },
        description: "mfa.enter_one_time_code_link_description",
        children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $869cf96729320806$export$2e2bcd8739ae039), {
            flow: (0, $6b1416e8e4d304fe$export$6a49be5b3307a2d).MfaBinding
        })
    });
};
var $8aa5cd5f09419c8f$export$2e2bcd8739ae039 = $8aa5cd5f09419c8f$var$VerificationSection;


var $fb7fcc8d6dfafab7$export$34e0f9847d4c02dd;
var $fb7fcc8d6dfafab7$export$a7420864310200cb;
$fb7fcc8d6dfafab7$export$34e0f9847d4c02dd = `_2QrTXW_container`;
$fb7fcc8d6dfafab7$export$a7420864310200cb = `_2QrTXW_switchLink`;


const $b5d659fa14e7bd68$var$TotpBinding = ()=>{
    const { state: state } = (0, $2ed817dc54ac40e6$export$45d76561a5302f2b)();
    const [, totpBindingState] = (0, $8a18d710f1d13368$export$a22775fa5e2eebd9)(state, (0, $4ffc90f7233cdad4$export$8014a7293b97852c));
    const skipMfa = (0, $8527019be94cc548$export$2e2bcd8739ae039)();
    if (!totpBindingState) return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $bcc9cc4bed8427a6$export$2e2bcd8739ae039), {
        title: "error.invalid_session"
    });
    const { availableFactors: availableFactors, skippable: skippable } = totpBindingState;
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $3dc734e3f6636ef1$export$2e2bcd8739ae039), {
        title: "mfa.add_authenticator_app",
        onSkip: (0, $dd763c2393b0d659$export$c327da55a124987a)(skippable && skipMfa),
        children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("div", {
            className: $fb7fcc8d6dfafab7$export$34e0f9847d4c02dd,
            children: [
                /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $6e44d0e714cef9cd$export$2e2bcd8739ae039), (0, $0de5391da8318002$export$581ff339ea0ba762)({}, totpBindingState)),
                /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $6994ccd4805f2603$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $8aa5cd5f09419c8f$export$2e2bcd8739ae039), {}),
                availableFactors.length > 1 && /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)((0, $b1404a408b0d045c$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $6994ccd4805f2603$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $b558eda3fd627c81$export$2e2bcd8739ae039), {
                            flow: (0, $6b1416e8e4d304fe$export$6a49be5b3307a2d).MfaBinding,
                            flowState: {
                                availableFactors: availableFactors,
                                skippable: skippable
                            },
                            className: $fb7fcc8d6dfafab7$export$a7420864310200cb
                        })
                    ]
                })
            ]
        })
    });
};
var $b5d659fa14e7bd68$export$2e2bcd8739ae039 = $b5d659fa14e7bd68$var$TotpBinding;














/* [@simplewebauthn/browser@9.0.1] */ 

function $f70da54cd888e8ae$var$utf8StringToBuffer(value) {
    return new TextEncoder().encode(value);
}
function $f70da54cd888e8ae$export$a2e0e37897ea77dc(buffer) {
    const bytes = new Uint8Array(buffer);
    let str = "";
    for (const charCode of bytes)str += String.fromCharCode(charCode);
    const base64String = btoa(str);
    return base64String.replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
}
function $f70da54cd888e8ae$export$5fed9f4baa53df29(base64URLString) {
    const base64 = base64URLString.replace(/-/g, "+").replace(/_/g, "/");
    const padLength = (4 - base64.length % 4) % 4;
    const padded = base64.padEnd(base64.length + padLength, "=");
    const binary = atob(padded);
    const buffer = new ArrayBuffer(binary.length);
    const bytes = new Uint8Array(buffer);
    for(let i = 0; i < binary.length; i++)bytes[i] = binary.charCodeAt(i);
    return buffer;
}
function $f70da54cd888e8ae$export$21f8045e1be8a25d() {
    return (window === null || window === void 0 ? void 0 : window.PublicKeyCredential) !== undefined && typeof window.PublicKeyCredential === "function";
}
function $f70da54cd888e8ae$var$toPublicKeyCredentialDescriptor(descriptor) {
    const { id: id } = descriptor;
    return (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, descriptor), {
        id: $f70da54cd888e8ae$export$5fed9f4baa53df29(id),
        transports: descriptor.transports
    });
}
function $f70da54cd888e8ae$var$isValidDomain(hostname) {
    return hostname === "localhost" || /^([a-z0-9]+(-[a-z0-9]+)*\.)+[a-z]{2,}$/i.test(hostname);
}
class $f70da54cd888e8ae$export$90f0c14a652de832 extends Error {
    constructor({ message: message, code: code, cause: cause, name: name }){
        super(message, {
            cause: cause
        });
        this.name = name !== null && name !== void 0 ? name : cause.name;
        this.code = code;
    }
}
function $f70da54cd888e8ae$var$identifyRegistrationError({ error: error, options: options }) {
    const { publicKey: publicKey } = options;
    if (!publicKey) throw Error("options was missing required publicKey property");
    if (error.name === "AbortError") {
        if (options.signal instanceof AbortSignal) return new $f70da54cd888e8ae$export$90f0c14a652de832({
            message: "Registration ceremony was sent an abort signal",
            code: "ERROR_CEREMONY_ABORTED",
            cause: error
        });
    } else if (error.name === "ConstraintError") {
        var _publicKey_authenticatorSelection, _publicKey_authenticatorSelection1;
        if (((_publicKey_authenticatorSelection = publicKey.authenticatorSelection) === null || _publicKey_authenticatorSelection === void 0 ? void 0 : _publicKey_authenticatorSelection.requireResidentKey) === true) return new $f70da54cd888e8ae$export$90f0c14a652de832({
            message: "Discoverable credentials were required but no available authenticator supported it",
            code: "ERROR_AUTHENTICATOR_MISSING_DISCOVERABLE_CREDENTIAL_SUPPORT",
            cause: error
        });
        else if (((_publicKey_authenticatorSelection1 = publicKey.authenticatorSelection) === null || _publicKey_authenticatorSelection1 === void 0 ? void 0 : _publicKey_authenticatorSelection1.userVerification) === "required") return new $f70da54cd888e8ae$export$90f0c14a652de832({
            message: "User verification was required but no available authenticator supported it",
            code: "ERROR_AUTHENTICATOR_MISSING_USER_VERIFICATION_SUPPORT",
            cause: error
        });
    } else if (error.name === "InvalidStateError") return new $f70da54cd888e8ae$export$90f0c14a652de832({
        message: "The authenticator was previously registered",
        code: "ERROR_AUTHENTICATOR_PREVIOUSLY_REGISTERED",
        cause: error
    });
    else if (error.name === "NotAllowedError") return new $f70da54cd888e8ae$export$90f0c14a652de832({
        message: error.message,
        code: "ERROR_PASSTHROUGH_SEE_CAUSE_PROPERTY",
        cause: error
    });
    else if (error.name === "NotSupportedError") {
        const validPubKeyCredParams = publicKey.pubKeyCredParams.filter((param)=>param.type === "public-key");
        if (validPubKeyCredParams.length === 0) return new $f70da54cd888e8ae$export$90f0c14a652de832({
            message: 'No entry in pubKeyCredParams was of type "public-key"',
            code: "ERROR_MALFORMED_PUBKEYCREDPARAMS",
            cause: error
        });
        return new $f70da54cd888e8ae$export$90f0c14a652de832({
            message: "No available authenticator supported any of the specified pubKeyCredParams algorithms",
            code: "ERROR_AUTHENTICATOR_NO_SUPPORTED_PUBKEYCREDPARAMS_ALG",
            cause: error
        });
    } else if (error.name === "SecurityError") {
        const effectiveDomain = window.location.hostname;
        if (!$f70da54cd888e8ae$var$isValidDomain(effectiveDomain)) return new $f70da54cd888e8ae$export$90f0c14a652de832({
            message: `${window.location.hostname} is an invalid domain`,
            code: "ERROR_INVALID_DOMAIN",
            cause: error
        });
        else if (publicKey.rp.id !== effectiveDomain) return new $f70da54cd888e8ae$export$90f0c14a652de832({
            message: `The RP ID "${publicKey.rp.id}" is invalid for this domain`,
            code: "ERROR_INVALID_RP_ID",
            cause: error
        });
    } else if (error.name === "TypeError") {
        if (publicKey.user.id.byteLength < 1 || publicKey.user.id.byteLength > 64) return new $f70da54cd888e8ae$export$90f0c14a652de832({
            message: "User ID was not between 1 and 64 characters",
            code: "ERROR_INVALID_USER_ID_LENGTH",
            cause: error
        });
    } else if (error.name === "UnknownError") return new $f70da54cd888e8ae$export$90f0c14a652de832({
        message: "The authenticator was unable to process the specified options, or could not create a new credential",
        code: "ERROR_AUTHENTICATOR_GENERAL_ERROR",
        cause: error
    });
    return error;
}
class $f70da54cd888e8ae$var$BaseWebAuthnAbortService {
    createNewAbortSignal() {
        if (this.controller) {
            const abortError = new Error("Cancelling existing WebAuthn API call for new one");
            abortError.name = "AbortError";
            this.controller.abort(abortError);
        }
        const newController = new AbortController();
        this.controller = newController;
        return newController.signal;
    }
    cancelCeremony() {
        if (this.controller) {
            const abortError = new Error("Manually cancelling existing WebAuthn API call");
            abortError.name = "AbortError";
            this.controller.abort(abortError);
            this.controller = undefined;
        }
    }
}
const $f70da54cd888e8ae$export$442ada5d34ca6e87 = new $f70da54cd888e8ae$var$BaseWebAuthnAbortService();
const $f70da54cd888e8ae$var$attachments = [
    "cross-platform",
    "platform"
];
function $f70da54cd888e8ae$var$toAuthenticatorAttachment(attachment) {
    if (!attachment) return;
    if ($f70da54cd888e8ae$var$attachments.indexOf(attachment) < 0) return;
    return attachment;
}
async function $f70da54cd888e8ae$export$20d6f277a113c2ce(creationOptionsJSON) {
    var _creationOptionsJSON_excludeCredentials;
    if (!$f70da54cd888e8ae$export$21f8045e1be8a25d()) throw new Error("WebAuthn is not supported in this browser");
    const publicKey = (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, creationOptionsJSON), {
        challenge: $f70da54cd888e8ae$export$5fed9f4baa53df29(creationOptionsJSON.challenge),
        user: (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, creationOptionsJSON.user), {
            id: $f70da54cd888e8ae$var$utf8StringToBuffer(creationOptionsJSON.user.id)
        }),
        excludeCredentials: (_creationOptionsJSON_excludeCredentials = creationOptionsJSON.excludeCredentials) === null || _creationOptionsJSON_excludeCredentials === void 0 ? void 0 : _creationOptionsJSON_excludeCredentials.map($f70da54cd888e8ae$var$toPublicKeyCredentialDescriptor)
    });
    const options = {
        publicKey: publicKey
    };
    options.signal = $f70da54cd888e8ae$export$442ada5d34ca6e87.createNewAbortSignal();
    let credential;
    try {
        credential = await navigator.credentials.create(options);
    } catch (err) {
        throw $f70da54cd888e8ae$var$identifyRegistrationError({
            error: err,
            options: options
        });
    }
    if (!credential) throw new Error("Registration was not completed");
    const { id: id, rawId: rawId, response: response, type: type } = credential;
    let transports = undefined;
    if (typeof response.getTransports === "function") transports = response.getTransports();
    let responsePublicKeyAlgorithm = undefined;
    if (typeof response.getPublicKeyAlgorithm === "function") try {
        responsePublicKeyAlgorithm = response.getPublicKeyAlgorithm();
    } catch (error) {
        $f70da54cd888e8ae$var$warnOnBrokenImplementation("getPublicKeyAlgorithm()", error);
    }
    let responsePublicKey = undefined;
    if (typeof response.getPublicKey === "function") try {
        const _publicKey = response.getPublicKey();
        if (_publicKey !== null) responsePublicKey = $f70da54cd888e8ae$export$a2e0e37897ea77dc(_publicKey);
    } catch (error) {
        $f70da54cd888e8ae$var$warnOnBrokenImplementation("getPublicKey()", error);
    }
    let responseAuthenticatorData;
    if (typeof response.getAuthenticatorData === "function") try {
        responseAuthenticatorData = $f70da54cd888e8ae$export$a2e0e37897ea77dc(response.getAuthenticatorData());
    } catch (error) {
        $f70da54cd888e8ae$var$warnOnBrokenImplementation("getAuthenticatorData()", error);
    }
    return {
        id: id,
        rawId: $f70da54cd888e8ae$export$a2e0e37897ea77dc(rawId),
        response: {
            attestationObject: $f70da54cd888e8ae$export$a2e0e37897ea77dc(response.attestationObject),
            clientDataJSON: $f70da54cd888e8ae$export$a2e0e37897ea77dc(response.clientDataJSON),
            transports: transports,
            publicKeyAlgorithm: responsePublicKeyAlgorithm,
            publicKey: responsePublicKey,
            authenticatorData: responseAuthenticatorData
        },
        type: type,
        clientExtensionResults: credential.getClientExtensionResults(),
        authenticatorAttachment: $f70da54cd888e8ae$var$toAuthenticatorAttachment(credential.authenticatorAttachment)
    };
}
function $f70da54cd888e8ae$var$warnOnBrokenImplementation(methodName, cause) {
    console.warn(`The browser extension that intercepted this WebAuthn API call incorrectly implemented ${methodName}. You should report this error to them.\n`, cause);
}
function $f70da54cd888e8ae$var$bufferToUTF8String(value) {
    return new TextDecoder("utf-8").decode(value);
}
function $f70da54cd888e8ae$export$18d4f667a5042852() {
    const globalPublicKeyCredential = window.PublicKeyCredential;
    if (globalPublicKeyCredential.isConditionalMediationAvailable === undefined) return new Promise((resolve)=>resolve(false));
    return globalPublicKeyCredential.isConditionalMediationAvailable();
}
function $f70da54cd888e8ae$var$identifyAuthenticationError({ error: error, options: options }) {
    const { publicKey: publicKey } = options;
    if (!publicKey) throw Error("options was missing required publicKey property");
    if (error.name === "AbortError") {
        if (options.signal instanceof AbortSignal) return new $f70da54cd888e8ae$export$90f0c14a652de832({
            message: "Authentication ceremony was sent an abort signal",
            code: "ERROR_CEREMONY_ABORTED",
            cause: error
        });
    } else if (error.name === "NotAllowedError") return new $f70da54cd888e8ae$export$90f0c14a652de832({
        message: error.message,
        code: "ERROR_PASSTHROUGH_SEE_CAUSE_PROPERTY",
        cause: error
    });
    else if (error.name === "SecurityError") {
        const effectiveDomain = window.location.hostname;
        if (!$f70da54cd888e8ae$var$isValidDomain(effectiveDomain)) return new $f70da54cd888e8ae$export$90f0c14a652de832({
            message: `${window.location.hostname} is an invalid domain`,
            code: "ERROR_INVALID_DOMAIN",
            cause: error
        });
        else if (publicKey.rpId !== effectiveDomain) return new $f70da54cd888e8ae$export$90f0c14a652de832({
            message: `The RP ID "${publicKey.rpId}" is invalid for this domain`,
            code: "ERROR_INVALID_RP_ID",
            cause: error
        });
    } else if (error.name === "UnknownError") return new $f70da54cd888e8ae$export$90f0c14a652de832({
        message: "The authenticator was unable to process the specified options, or could not create a new assertion signature",
        code: "ERROR_AUTHENTICATOR_GENERAL_ERROR",
        cause: error
    });
    return error;
}
async function $f70da54cd888e8ae$export$c4f13730a14de143(requestOptionsJSON, useBrowserAutofill = false) {
    var _requestOptionsJSON_allowCredentials, _requestOptionsJSON_allowCredentials1;
    if (!$f70da54cd888e8ae$export$21f8045e1be8a25d()) throw new Error("WebAuthn is not supported in this browser");
    let allowCredentials;
    if (((_requestOptionsJSON_allowCredentials = requestOptionsJSON.allowCredentials) === null || _requestOptionsJSON_allowCredentials === void 0 ? void 0 : _requestOptionsJSON_allowCredentials.length) !== 0) allowCredentials = (_requestOptionsJSON_allowCredentials1 = requestOptionsJSON.allowCredentials) === null || _requestOptionsJSON_allowCredentials1 === void 0 ? void 0 : _requestOptionsJSON_allowCredentials1.map($f70da54cd888e8ae$var$toPublicKeyCredentialDescriptor);
    const publicKey = (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, requestOptionsJSON), {
        challenge: $f70da54cd888e8ae$export$5fed9f4baa53df29(requestOptionsJSON.challenge),
        allowCredentials: allowCredentials
    });
    const options = {};
    if (useBrowserAutofill) {
        if (!await $f70da54cd888e8ae$export$18d4f667a5042852()) throw Error("Browser does not support WebAuthn autofill");
        const eligibleInputs = document.querySelectorAll("input[autocomplete$='webauthn']");
        if (eligibleInputs.length < 1) throw Error('No <input> with "webauthn" as the only or last value in its `autocomplete` attribute was detected');
        options.mediation = "conditional";
        publicKey.allowCredentials = [];
    }
    options.publicKey = publicKey;
    options.signal = $f70da54cd888e8ae$export$442ada5d34ca6e87.createNewAbortSignal();
    let credential;
    try {
        credential = await navigator.credentials.get(options);
    } catch (err) {
        throw $f70da54cd888e8ae$var$identifyAuthenticationError({
            error: err,
            options: options
        });
    }
    if (!credential) throw new Error("Authentication was not completed");
    const { id: id, rawId: rawId, response: response, type: type } = credential;
    let userHandle = undefined;
    if (response.userHandle) userHandle = $f70da54cd888e8ae$var$bufferToUTF8String(response.userHandle);
    return {
        id: id,
        rawId: $f70da54cd888e8ae$export$a2e0e37897ea77dc(rawId),
        response: {
            authenticatorData: $f70da54cd888e8ae$export$a2e0e37897ea77dc(response.authenticatorData),
            clientDataJSON: $f70da54cd888e8ae$export$a2e0e37897ea77dc(response.clientDataJSON),
            signature: $f70da54cd888e8ae$export$a2e0e37897ea77dc(response.signature),
            userHandle: userHandle
        },
        type: type,
        clientExtensionResults: credential.getClientExtensionResults(),
        authenticatorAttachment: $f70da54cd888e8ae$var$toAuthenticatorAttachment(credential.authenticatorAttachment)
    };
}
function $f70da54cd888e8ae$export$d2e10ee5223ea44b() {
    if (!$f70da54cd888e8ae$export$21f8045e1be8a25d()) return new Promise((resolve)=>resolve(false));
    return PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable();
}



var $P551f = parcelRequire("P551f");




const $29c76feebdbc8ac9$var$isAuthenticationResponseJSON = (responseJson)=>{
    return "signature" in responseJson.response;
};
const $29c76feebdbc8ac9$var$useWebAuthnOperation = ()=>{
    const { t: t } = (0, $5d79e62c9ff74ac9$export$9fc83ad70ead8663)();
    const { setToast: setToast } = (0, $d1e7a25fbbe7c8e1$export$2e2bcd8739ae039)();
    const sendMfaPayload = (0, $7af16b0b7f1047f2$export$2e2bcd8739ae039)();
    return (0, $P551f.useCallback)(/**
     * Note:
     * Due to limitations in the iOS system, user interaction is required for the use of the WebAuthn API.
     * Therefore, we should avoid asynchronous operations before invoking the WebAuthn API or the os may consider the WebAuthn authorization is not initiated by the user.
     * So, we need to prepare the necessary WebAuthn options before calling the WebAuthn API, this is why we don't generate the options in this function.
     */ async (options)=>{
        if (!(0, $f70da54cd888e8ae$export$21f8045e1be8a25d)()) {
            setToast(t("mfa.webauthn_not_supported"));
            return;
        }
        const parsedRegistrationOptions = (0, $10085c8ffbd8a996$export$2334438dedb2ca6f).safeParse(options);
        const response = await (0, $96962764729a993e$export$a3a27526e073307)(async ()=>parsedRegistrationOptions.success ? (0, $f70da54cd888e8ae$export$20d6f277a113c2ce)(parsedRegistrationOptions.data) : (0, $f70da54cd888e8ae$export$c4f13730a14de143)(options), ()=>{
            setToast(t(parsedRegistrationOptions.success ? "mfa.webauthn_failed_to_create" : "mfa.webauthn_failed_to_verify"));
        });
        if (response) sendMfaPayload($29c76feebdbc8ac9$var$isAuthenticationResponseJSON(response) ? {
            flow: (0, $6b1416e8e4d304fe$export$6a49be5b3307a2d).MfaVerification,
            payload: (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, response), {
                type: (0, $c0e46a7ec45ea8f3$export$c62e7669a75c5961).WebAuthn
            })
        } : {
            flow: (0, $6b1416e8e4d304fe$export$6a49be5b3307a2d).MfaBinding,
            payload: (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, response), {
                type: (0, $c0e46a7ec45ea8f3$export$c62e7669a75c5961).WebAuthn
            })
        });
    }, [
        sendMfaPayload,
        setToast,
        t
    ]);
};
var $29c76feebdbc8ac9$export$2e2bcd8739ae039 = $29c76feebdbc8ac9$var$useWebAuthnOperation;






const $41cdcea475ddc905$export$7734b820bb2d3474 = (options)=>(0, $10085c8ffbd8a996$export$2334438dedb2ca6f).safeParse(options).success || (0, $10085c8ffbd8a996$export$e849189769e7ddda).safeParse(options).success;


var $75292a1c24aa1868$export$a7420864310200cb;
$75292a1c24aa1868$export$a7420864310200cb = `dUJVga_switchLink`;


const $237d9bc7df8064df$var$WebAuthnBinding = ()=>{
    const { state: state } = (0, $2ed817dc54ac40e6$export$45d76561a5302f2b)();
    const [, webAuthnState] = (0, $8a18d710f1d13368$export$a22775fa5e2eebd9)(state, (0, $4ffc90f7233cdad4$export$491937bf2814b26));
    const handleWebAuthn = (0, $29c76feebdbc8ac9$export$2e2bcd8739ae039)();
    const skipMfa = (0, $8527019be94cc548$export$2e2bcd8739ae039)();
    if (!webAuthnState) return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $bcc9cc4bed8427a6$export$2e2bcd8739ae039), {
        title: "error.invalid_session"
    });
    const { options: options, availableFactors: availableFactors, skippable: skippable } = webAuthnState;
    if (!(0, $41cdcea475ddc905$export$7734b820bb2d3474)(options)) return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $bcc9cc4bed8427a6$export$2e2bcd8739ae039), {
        title: "error.invalid_session"
    });
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)((0, $3dc734e3f6636ef1$export$2e2bcd8739ae039), {
        title: "mfa.create_a_passkey",
        description: "mfa.create_passkey_description",
        onSkip: (0, $dd763c2393b0d659$export$c327da55a124987a)(skippable && skipMfa),
        children: [
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $c6d8f26a28e11cb6$export$2e2bcd8739ae039), {
                title: "mfa.create_a_passkey",
                onClick: ()=>{
                    handleWebAuthn(options);
                }
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $b558eda3fd627c81$export$2e2bcd8739ae039), {
                flow: (0, $6b1416e8e4d304fe$export$6a49be5b3307a2d).MfaBinding,
                flowState: {
                    availableFactors: availableFactors,
                    skippable: skippable
                },
                className: $75292a1c24aa1868$export$a7420864310200cb
            })
        ]
    });
};
var $237d9bc7df8064df$export$2e2bcd8739ae039 = $237d9bc7df8064df$var$WebAuthnBinding;








const $302be2f1a49c3daf$var$MfaVerification = ()=>{
    const flowState = (0, $53925cf076a1980a$export$2e2bcd8739ae039)();
    if (!flowState) return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $bcc9cc4bed8427a6$export$2e2bcd8739ae039), {
        title: "error.invalid_session"
    });
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $3dc734e3f6636ef1$export$2e2bcd8739ae039), {
        title: "mfa.verify_mfa_factors",
        description: "mfa.verify_mfa_description",
        children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $eff2560959689c59$export$2e2bcd8739ae039), {
            flow: (0, $6b1416e8e4d304fe$export$6a49be5b3307a2d).MfaVerification,
            flowState: flowState
        })
    });
};
var $302be2f1a49c3daf$export$2e2bcd8739ae039 = $302be2f1a49c3daf$var$MfaVerification;







var $P551f = parcelRequire("P551f");










var $d67e05cc6773155e$export$c2850a7f00aa86ec;
var $d67e05cc6773155e$export$b2c4be835e9aed68;
$d67e05cc6773155e$export$c2850a7f00aa86ec = `tQPvAq_backupCodeInput`;
$d67e05cc6773155e$export$b2c4be835e9aed68 = `tQPvAq_switchFactorLink`;


const $6d8f4031aa915671$var$BackupCodeVerification = ()=>{
    const flowState = (0, $53925cf076a1980a$export$2e2bcd8739ae039)();
    const sendMfaPayload = (0, $7af16b0b7f1047f2$export$2e2bcd8739ae039)();
    const { register: register, handleSubmit: handleSubmit } = (0, $afcc65e7f92ff559$export$87c0cf8eb5a167e0)({
        defaultValues: {
            code: ""
        }
    });
    const onSubmitHandler = (0, $P551f.useCallback)((event)=>{
        handleSubmit(async ({ code: code })=>{
            sendMfaPayload({
                flow: (0, $6b1416e8e4d304fe$export$6a49be5b3307a2d).MfaVerification,
                payload: {
                    type: (0, $c0e46a7ec45ea8f3$export$c62e7669a75c5961).BackupCode,
                    code: code
                }
            });
        })(event);
    }, [
        handleSubmit,
        sendMfaPayload
    ]);
    if (!flowState) return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $bcc9cc4bed8427a6$export$2e2bcd8739ae039), {
        title: "error.invalid_session"
    });
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)((0, $3dc734e3f6636ef1$export$2e2bcd8739ae039), {
        title: "mfa.verify_mfa_factors",
        children: [
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $27060c9ab8bf4b0d$export$2e2bcd8739ae039), {
                title: "mfa.enter_a_backup_code",
                description: "mfa.enter_backup_code_description",
                children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("form", {
                    onSubmit: onSubmitHandler,
                    children: [
                        /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $89edc8164fec0424$export$2e2bcd8739ae039), (0, $0de5391da8318002$export$581ff339ea0ba762)({
                            autoComplete: "off",
                            placeholder: (0, $86e325ac3ddbcfa1$export$625550452a3fa3ec)("input.backup_code"),
                            className: $d67e05cc6773155e$export$c2850a7f00aa86ec
                        }, register("code"))),
                        /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $c6d8f26a28e11cb6$export$2e2bcd8739ae039), {
                            title: "action.continue",
                            htmlType: "submit"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $b558eda3fd627c81$export$2e2bcd8739ae039), {
                flow: (0, $6b1416e8e4d304fe$export$6a49be5b3307a2d).MfaVerification,
                flowState: flowState,
                className: $d67e05cc6773155e$export$b2c4be835e9aed68
            })
        ]
    });
};
var $6d8f4031aa915671$export$2e2bcd8739ae039 = $6d8f4031aa915671$var$BackupCodeVerification;










var $8deb4244b79ff618$export$b2c4be835e9aed68;
$8deb4244b79ff618$export$b2c4be835e9aed68 = `uqcIpq_switchFactorLink`;


const $93353585ff980d81$var$TotpVerification = ()=>{
    const flowState = (0, $53925cf076a1980a$export$2e2bcd8739ae039)();
    if (!flowState) return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $bcc9cc4bed8427a6$export$2e2bcd8739ae039), {
        title: "error.invalid_session"
    });
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)((0, $3dc734e3f6636ef1$export$2e2bcd8739ae039), {
        title: "mfa.verify_mfa_factors",
        children: [
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $27060c9ab8bf4b0d$export$2e2bcd8739ae039), {
                title: "mfa.enter_one_time_code",
                description: "mfa.enter_one_time_code_description",
                children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $869cf96729320806$export$2e2bcd8739ae039), {
                    flow: (0, $6b1416e8e4d304fe$export$6a49be5b3307a2d).MfaVerification
                })
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $b558eda3fd627c81$export$2e2bcd8739ae039), {
                flow: (0, $6b1416e8e4d304fe$export$6a49be5b3307a2d).MfaVerification,
                flowState: flowState,
                className: $8deb4244b79ff618$export$b2c4be835e9aed68
            })
        ]
    });
};
var $93353585ff980d81$export$2e2bcd8739ae039 = $93353585ff980d81$var$TotpVerification;














var $f309040b7f29fcee$export$30f015e46281c810;
$f309040b7f29fcee$export$30f015e46281c810 = `KMS2Oa_verifyButton`;


const $5526df7bfc055688$var$WebAuthnVerification = ()=>{
    const { state: state } = (0, $2ed817dc54ac40e6$export$45d76561a5302f2b)();
    const [, webAuthnState] = (0, $8a18d710f1d13368$export$a22775fa5e2eebd9)(state, (0, $4ffc90f7233cdad4$export$491937bf2814b26));
    const handleWebAuthn = (0, $29c76feebdbc8ac9$export$2e2bcd8739ae039)();
    if (!webAuthnState) return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $bcc9cc4bed8427a6$export$2e2bcd8739ae039), {
        title: "error.invalid_session"
    });
    const { options: options, availableFactors: availableFactors, skippable: skippable } = webAuthnState;
    if (!(0, $41cdcea475ddc905$export$7734b820bb2d3474)(options)) return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $bcc9cc4bed8427a6$export$2e2bcd8739ae039), {
        title: "error.invalid_session"
    });
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)((0, $3dc734e3f6636ef1$export$2e2bcd8739ae039), {
        title: "mfa.verify_mfa_factors",
        children: [
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $27060c9ab8bf4b0d$export$2e2bcd8739ae039), {
                title: "mfa.verify_via_passkey",
                description: "mfa.verify_via_passkey_description",
                children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $c6d8f26a28e11cb6$export$2e2bcd8739ae039), {
                    title: "action.verify_via_passkey",
                    className: $f309040b7f29fcee$export$30f015e46281c810,
                    onClick: ()=>{
                        handleWebAuthn(options);
                    }
                })
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $b558eda3fd627c81$export$2e2bcd8739ae039), {
                flow: (0, $6b1416e8e4d304fe$export$6a49be5b3307a2d).MfaVerification,
                flowState: {
                    availableFactors: availableFactors,
                    skippable: skippable
                }
            })
        ]
    });
};
var $5526df7bfc055688$export$2e2bcd8739ae039 = $5526df7bfc055688$var$WebAuthnVerification;





var $P551f = parcelRequire("P551f");





var $P551f = parcelRequire("P551f");


var $P551f = parcelRequire("P551f");
/**
 * This context is used to share the single sign on identifier status cross the page and form components.
 * If the user has entered an identifier that is associated with a single sign on method, we will show the single sign on form.
 */ const $39efb6d80db8b9ee$var$SingleSignOnFormModeContext = /*#__PURE__*/ (0, $P551f.createContext)({
    showSingleSignOnForm: false,
    setShowSingleSignOnForm: (0, $96962764729a993e$export$8793edee2d425525)
});
var $39efb6d80db8b9ee$export$2e2bcd8739ae039 = $39efb6d80db8b9ee$var$SingleSignOnFormModeContext;


const $2be0f25b6ad9b7d7$var$SingleSignOnFormModeContextProvider = ({ children: children })=>{
    const [showSingleSignOnForm, setShowSingleSignOnForm] = (0, $P551f.useState)(false);
    const contextValue = (0, $P551f.useMemo)(()=>({
            showSingleSignOnForm: showSingleSignOnForm,
            setShowSingleSignOnForm: setShowSingleSignOnForm
        }), [
        showSingleSignOnForm
    ]);
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $39efb6d80db8b9ee$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: children
    });
};
var $2be0f25b6ad9b7d7$export$2e2bcd8739ae039 = $2be0f25b6ad9b7d7$var$SingleSignOnFormModeContextProvider;










var $4c9bc2cf362a9183$export$1ca1ec8b29a4ce27;
var $4c9bc2cf362a9183$export$a8ff84c12d48cfa6;
var $4c9bc2cf362a9183$export$86d0200e957dbda1;
var $4c9bc2cf362a9183$export$e046c82eba182184;
$4c9bc2cf362a9183$export$1ca1ec8b29a4ce27 = `yRYpXa_icon`;
$4c9bc2cf362a9183$export$a8ff84c12d48cfa6 = `yRYpXa_name`;
$4c9bc2cf362a9183$export$86d0200e957dbda1 = `yRYpXa_placeHolder`;
$4c9bc2cf362a9183$export$e046c82eba182184 = `yRYpXa_socialButton`;



const $d82d136cdafd2cb6$var$SocialLinkButton = ({ isDisabled: isDisabled, className: className, target: target, name: name, logo: logo, onClick: onClick })=>{
    const { t: t, i18n: { language: language } } = (0, $5d79e62c9ff74ac9$export$9fc83ad70ead8663)();
    var _name_language;
    const localName = (_name_language = name[language]) !== null && _name_language !== void 0 ? _name_language : name.en;
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("button", {
        disabled: isDisabled,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a6f0144cf2b2d456$exports)))($38cf9015ace287df$export$2ba01fb71ed41cb6, $38cf9015ace287df$export$745c6f71a1e0e6f7, $38cf9015ace287df$export$f09585a853dddd32, $4c9bc2cf362a9183$export$e046c82eba182184, isDisabled && $38cf9015ace287df$export$683472f6198a076e, className),
        type: "button",
        onClick: onClick,
        children: [
            logo && /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("img", {
                src: logo,
                alt: target,
                className: $4c9bc2cf362a9183$export$1ca1ec8b29a4ce27,
                crossOrigin: "anonymous"
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("div", {
                className: $4c9bc2cf362a9183$export$a8ff84c12d48cfa6,
                children: [
                    /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("div", {
                        className: $4c9bc2cf362a9183$export$86d0200e957dbda1
                    }),
                    /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("span", {
                        children: t("action.sign_in_with", {
                            name: localName
                        })
                    }),
                    /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("div", {
                        className: $4c9bc2cf362a9183$export$86d0200e957dbda1
                    })
                ]
            })
        ]
    });
};
var $d82d136cdafd2cb6$export$2e2bcd8739ae039 = $d82d136cdafd2cb6$var$SocialLinkButton;




var $P551f = parcelRequire("P551f");


/**
 * UseNativeMessageListener
 *
 * Used to monitor native error message.
 * If native error message is sent, it will be displayed as toast.
 * Add a bypass parameter to bypass the native error message listener.
 *
 * @param {boolean} bypass (default: false)
 */ const $1a4d4d211af0412c$var$useNativeMessageListener = (bypass = false)=>{
    const { setToast: setToast } = (0, $d1e7a25fbbe7c8e1$export$2e2bcd8739ae039)();
    // Monitor Native Error Message
    (0, $P551f.useEffect)(()=>{
        if (!(0, $955117e21b41598e$export$a38f4a317af23d71)() || bypass) return;
        const nativeMessageHandler = (event)=>{
            // In the `WKWebView` of new iOS versions, some script will constantly post messages to the
            // window object with increasing numbers as the message content ("1", "2", "3", ...).
            //
            // Ideally, we should check the source of the message with Logto-specific identifier in the
            // `event.data`; however, this change will result a breaking change for the existing
            // native SDK implementations. Add the `isObject` check to prevent the crazy messages while
            // keeping the backward compatibility.
            if (event.origin === window.location.origin && (0, $ead635d18ff5c4e4$export$a6cdc56e425d0d0a)(event.data)) try {
                setToast(JSON.stringify(event.data));
            } catch (e) {}
        };
        window.addEventListener("message", nativeMessageHandler);
        return ()=>{
            window.removeEventListener("message", nativeMessageHandler);
        };
    }, [
        bypass,
        setToast
    ]);
};
var $1a4d4d211af0412c$export$2e2bcd8739ae039 = $1a4d4d211af0412c$var$useNativeMessageListener;



var $5e32973f25897e71$export$54999fc00c2d01e0;
var $5e32973f25897e71$export$11b6045879ed3994;
$5e32973f25897e71$export$54999fc00c2d01e0 = `_1lnZ2a_socialLinkButton`;
$5e32973f25897e71$export$11b6045879ed3994 = `_1lnZ2a_socialLinkList`;



const $888c6bd147509dd9$var$SocialSignInList = ({ className: className, socialConnectors: socialConnectors = [] })=>{
    const { invokeSocialSignIn: invokeSocialSignIn, theme: theme } = (0, $80697e682fabf88a$export$2e2bcd8739ae039)();
    (0, $1a4d4d211af0412c$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a6f0144cf2b2d456$exports)))($5e32973f25897e71$export$11b6045879ed3994, className),
        children: socialConnectors.map((connector)=>{
            const { id: id, name: name, logo: logoUrl, logoDark: darkLogoUrl, target: target } = connector;
            return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $d82d136cdafd2cb6$export$2e2bcd8739ae039), {
                className: $5e32973f25897e71$export$54999fc00c2d01e0,
                name: name,
                logo: (0, $105477e2633d7ba8$export$976f80239b15365)({
                    theme: theme,
                    logoUrl: logoUrl,
                    darkLogoUrl: darkLogoUrl
                }),
                target: target,
                onClick: ()=>{
                    invokeSocialSignIn(connector);
                }
            }, id);
        })
    });
};
var $888c6bd147509dd9$export$2e2bcd8739ae039 = $888c6bd147509dd9$var$SocialSignInList;





var $P551f = parcelRequire("P551f");





var $P551f = parcelRequire("P551f");




var $P551f = parcelRequire("P551f");



const $df2aae6cfaf84a98$var$TermsAndPrivacyConfirmModalContent = ()=>{
    const { experienceSettings: experienceSettings } = (0, $P551f.useContext)((0, $bf7e93717fb1eb16$export$2e2bcd8739ae039));
    const { termsOfUseUrl: termsOfUseUrl, privacyPolicyUrl: privacyPolicyUrl } = experienceSettings !== null && experienceSettings !== void 0 ? experienceSettings : {};
    const { t: t } = (0, $5d79e62c9ff74ac9$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $f51ffae15bc36a59$export$8d6a9236f2e3f2ce), {
        components: {
            link: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $ea24fc73cce16e14$export$2e2bcd8739ae039), {
                inline: true,
                termsOfUseUrl: (0, $dd763c2393b0d659$export$c327da55a124987a)(termsOfUseUrl),
                privacyPolicyUrl: (0, $dd763c2393b0d659$export$c327da55a124987a)(privacyPolicyUrl)
            })
        },
        children: t("description.agree_with_terms_modal")
    });
};
var $df2aae6cfaf84a98$export$2e2bcd8739ae039 = $df2aae6cfaf84a98$var$TermsAndPrivacyConfirmModalContent;



const $a109f6d946545a69$var$useTerms = ()=>{
    const { termsAgreement: termsAgreement, setTermsAgreement: setTermsAgreement, experienceSettings: experienceSettings } = (0, $P551f.useContext)((0, $bf7e93717fb1eb16$export$2e2bcd8739ae039));
    const { show: show } = (0, $f3ae436b724671df$export$753980156bc86c10)();
    const { termsOfUseUrl: termsOfUseUrl, privacyPolicyUrl: privacyPolicyUrl, isTermsDisabled: isTermsDisabled } = (0, $P551f.useMemo)(()=>{
        const { termsOfUseUrl: termsOfUseUrl, privacyPolicyUrl: privacyPolicyUrl } = experienceSettings !== null && experienceSettings !== void 0 ? experienceSettings : {};
        const isTermsDisabled = !termsOfUseUrl && !privacyPolicyUrl;
        return {
            termsOfUseUrl: (0, $dd763c2393b0d659$export$c327da55a124987a)(termsOfUseUrl),
            privacyPolicyUrl: (0, $dd763c2393b0d659$export$c327da55a124987a)(privacyPolicyUrl),
            isTermsDisabled: isTermsDisabled
        };
    }, [
        experienceSettings
    ]);
    const termsAndPrivacyConfirmModalHandler = (0, $P551f.useCallback)(async ()=>{
        const [result] = await show({
            ModalContent: (0, $df2aae6cfaf84a98$export$2e2bcd8739ae039),
            confirmText: "action.agree"
        });
        // Update the local terms status
        if (result) setTermsAgreement(true);
        return result;
    }, [
        setTermsAgreement,
        show
    ]);
    const termsValidation = (0, $P551f.useCallback)(async ()=>{
        if (termsAgreement || isTermsDisabled) return true;
        return termsAndPrivacyConfirmModalHandler();
    }, [
        termsAgreement,
        isTermsDisabled,
        termsAndPrivacyConfirmModalHandler
    ]);
    return {
        termsOfUseUrl: termsOfUseUrl,
        privacyPolicyUrl: privacyPolicyUrl,
        termsAgreement: termsAgreement,
        isTermsDisabled: isTermsDisabled,
        termsValidation: termsValidation,
        setTermsAgreement: setTermsAgreement,
        termsAndPrivacyConfirmModalHandler: termsAndPrivacyConfirmModalHandler
    };
};
var $a109f6d946545a69$export$2e2bcd8739ae039 = $a109f6d946545a69$var$useTerms;



var $121e0315ea589e66$export$b07e517d22efa1ca;
var $121e0315ea589e66$export$a7db06668cad9adb;
var $121e0315ea589e66$export$493b5823483d2c4e;
var $121e0315ea589e66$export$8a21ba990ca4a7cb;
$121e0315ea589e66$export$b07e517d22efa1ca = `VJP9aa_checkbox`;
$121e0315ea589e66$export$a7db06668cad9adb = `VJP9aa_content`;
$121e0315ea589e66$export$493b5823483d2c4e = `VJP9aa_errorMessage`;
$121e0315ea589e66$export$8a21ba990ca4a7cb = `VJP9aa_terms`;


const $7d5d4f120f897ecc$var$TermsAndPrivacy = ({ className: className })=>{
    const { termsAgreement: termsAgreement, setTermsAgreement: setTermsAgreement, termsOfUseUrl: termsOfUseUrl, privacyPolicyUrl: privacyPolicyUrl, isTermsDisabled: isTermsDisabled } = (0, $a109f6d946545a69$export$2e2bcd8739ae039)();
    const { t: t } = (0, $5d79e62c9ff74ac9$export$9fc83ad70ead8663)();
    const prefix = t("description.agree_with_terms");
    const toggle = (0, $P551f.useCallback)(()=>{
        setTermsAgreement((termsAgreement)=>!termsAgreement);
    }, [
        setTermsAgreement
    ]);
    if (isTermsDisabled) return null;
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("div", {
        role: "radio",
        "aria-checked": termsAgreement,
        tabIndex: 0,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a6f0144cf2b2d456$exports)))($121e0315ea589e66$export$8a21ba990ca4a7cb, className),
        onClick: toggle,
        onKeyDown: (0, $f6f836671f603fea$export$c2c388d6a668999e)({
            Escape: ()=>{
                setTermsAgreement(false);
            },
            Enter: toggle,
            " ": toggle
        }),
        children: [
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $0cf903e40c0bf2ef$export$2e2bcd8739ae039), {
                name: "termsAgreement",
                checked: termsAgreement,
                className: $121e0315ea589e66$export$b07e517d22efa1ca,
                size: "small"
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("div", {
                className: $121e0315ea589e66$export$a7db06668cad9adb,
                children: [
                    /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("span", {
                        children: prefix
                    }),
                    /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $ea24fc73cce16e14$export$2e2bcd8739ae039), {
                        inline: true,
                        termsOfUseUrl: termsOfUseUrl,
                        privacyPolicyUrl: privacyPolicyUrl
                    })
                ]
            })
        ]
    });
};
var $7d5d4f120f897ecc$export$2e2bcd8739ae039 = $7d5d4f120f897ecc$var$TermsAndPrivacy;









var $P551f = parcelRequire("P551f");





parcelRequire("P551f");
const $ad452ea4e6bcb412$var$SvgLock = (props)=>/*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("svg", (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({
        width: 21,
        height: 20,
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("path", {
            d: "M10.5 10.833a1.241 1.241 0 0 0-.833 2.175v1.159a.833.833 0 0 0 1.667 0v-1.159a1.242 1.242 0 0 0-.833-2.175ZM14.668 7.5V5.833a4.167 4.167 0 0 0-8.333 0V7.5a2.5 2.5 0 0 0-2.5 2.5v5.833a2.5 2.5 0 0 0 2.5 2.5h8.333a2.5 2.5 0 0 0 2.5-2.5V10a2.5 2.5 0 0 0-2.5-2.5ZM8.001 5.833a2.5 2.5 0 1 1 5 0V7.5H8V5.833Zm7.5 10a.833.833 0 0 1-.834.833H6.334a.833.833 0 0 1-.833-.833V10a.833.833 0 0 1 .833-.834h8.333a.833.833 0 0 1 .834.834v5.833Z",
            fill: "#fff",
            fillOpacity: 0.7
        })
    }));
var $ad452ea4e6bcb412$export$2e2bcd8739ae039 = $ad452ea4e6bcb412$var$SvgLock;








var $P551f = parcelRequire("P551f");








const $40a2da7fe56680a9$var$useSingleSignOnWatch = (identifierInput)=>{
    const navigate = (0, $2ed817dc54ac40e6$export$9770f232ac06a008)();
    const { singleSignOnEnabled: singleSignOnEnabled } = (0, $aa5a893d65a133eb$export$317715a729435b35)();
    const { setEmail: setEmail, setSsoConnectors: setSsoConnectors, ssoConnectors: ssoConnectors, availableSsoConnectorsMap: availableSsoConnectorsMap } = (0, $P551f.useContext)((0, $9df90ef155637237$export$2e2bcd8739ae039));
    const { showSingleSignOnForm: showSingleSignOnForm, setShowSingleSignOnForm: setShowSingleSignOnForm } = (0, $P551f.useContext)((0, $39efb6d80db8b9ee$export$2e2bcd8739ae039));
    const request = (0, $ab5ab705a7d3e209$export$2e2bcd8739ae039)((0, $c27d4b4a657466b5$export$d4b3da5d4dacc637), {
        silent: true
    });
    const singleSignOn = (0, $4e5779525579582e$export$2e2bcd8739ae039)();
    // Silently check if the email is registered with any SSO connectors
    const fetchSsoConnectors = (0, $P551f.useCallback)(async (email)=>{
        const [, result] = await request(email);
        if (!result) return false;
        const connectors = result.map((connectorId)=>availableSsoConnectorsMap.get(connectorId))// eslint-disable-next-line unicorn/prefer-native-coercion-functions -- make the type more specific
        .filter((connector)=>Boolean(connector));
        if (connectors.length === 0) return false;
        setSsoConnectors(connectors);
        setEmail(email);
        return true;
    }, [
        availableSsoConnectorsMap,
        request,
        setEmail,
        setSsoConnectors
    ]);
    // Reset the ssoContext
    (0, $P551f.useEffect)(()=>{
        if (!showSingleSignOnForm) {
            setSsoConnectors([]);
            // eslint-disable-next-line unicorn/no-useless-undefined
            setEmail(undefined);
        }
    }, [
        setEmail,
        setSsoConnectors,
        showSingleSignOnForm
    ]);
    const navigateToSingleSignOn = (0, $P551f.useCallback)(async ()=>{
        var _ssoConnectors_;
        if (!showSingleSignOnForm) return;
        // If there is only one connector, we can directly invoke the SSO flow
        if (ssoConnectors.length === 1 && ((_ssoConnectors_ = ssoConnectors[0]) === null || _ssoConnectors_ === void 0 ? void 0 : _ssoConnectors_.id)) {
            await singleSignOn(ssoConnectors[0].id);
            return;
        }
        navigate(`/${(0, $a0052762c6755033$export$45794d16c9d83fe2).routes.sso}/connectors`);
    }, [
        navigate,
        showSingleSignOnForm,
        singleSignOn,
        ssoConnectors
    ]);
    (0, $P551f.useEffect)(()=>{
        if (!singleSignOnEnabled) return;
        // Input is undefined if no user interaction has happened
        if (!identifierInput) {
            setShowSingleSignOnForm(false);
            return;
        }
        const { type: type, value: value } = identifierInput;
        if (type !== (0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Email) {
            setShowSingleSignOnForm(false);
            return;
        }
        // Will throw an error if the value is not a valid email
        if ((0, $5f609015ba424ff1$export$18148d12c805c5b0)(value)) {
            setShowSingleSignOnForm(false);
            return;
        }
        // Add a debouncing delay to avoid unnecessary API calls
        const handler = setTimeout(async ()=>{
            setShowSingleSignOnForm(await fetchSsoConnectors(value));
        }, 300);
        return ()=>{
            clearTimeout(handler);
        };
    }, [
        fetchSsoConnectors,
        identifierInput,
        setShowSingleSignOnForm,
        singleSignOnEnabled
    ]);
    return {
        showSingleSignOnForm: showSingleSignOnForm,
        navigateToSingleSignOn: navigateToSingleSignOn
    };
};
var $40a2da7fe56680a9$export$2e2bcd8739ae039 = $40a2da7fe56680a9$var$useSingleSignOnWatch;




var $59389391e367d16d$export$6210fa4921d2a466;
var $59389391e367d16d$export$ce85b9b1fe34d6d3;
var $59389391e367d16d$export$73920f18ca706874;
var $59389391e367d16d$export$6f2f4d5c38fc8e55;
var $59389391e367d16d$export$a8ecead220dd38a6;
var $59389391e367d16d$export$8a21ba990ca4a7cb;
$59389391e367d16d$export$6210fa4921d2a466 = `_0W0Rda_form`;
$59389391e367d16d$export$ce85b9b1fe34d6d3 = `_0W0Rda_formErrors`;
$59389391e367d16d$export$73920f18ca706874 = `_0W0Rda_hidden`;
$59389391e367d16d$export$6f2f4d5c38fc8e55 = `_0W0Rda_inputField`;
$59389391e367d16d$export$a8ecead220dd38a6 = `_0W0Rda_message`;
$59389391e367d16d$export$8a21ba990ca4a7cb = `_0W0Rda_terms`;




var $P551f = parcelRequire("P551f");


var $P551f = parcelRequire("P551f");







const $260284b237e1ed97$var$useCheckSingleSignOn = ()=>{
    const { t: t } = (0, $5d79e62c9ff74ac9$export$9fc83ad70ead8663)();
    const navigate = (0, $2ed817dc54ac40e6$export$9770f232ac06a008)();
    const request = (0, $ab5ab705a7d3e209$export$2e2bcd8739ae039)((0, $c27d4b4a657466b5$export$d4b3da5d4dacc637));
    const [errorMessage, setErrorMessage] = (0, $P551f.useState)();
    const { setEmail: setEmail, setSsoConnectors: setSsoConnectors, availableSsoConnectorsMap: availableSsoConnectorsMap } = (0, $P551f.useContext)((0, $9df90ef155637237$export$2e2bcd8739ae039));
    const singleSignOn = (0, $4e5779525579582e$export$2e2bcd8739ae039)();
    const handleError = (0, $7ebd5fdad7a45c9e$export$2e2bcd8739ae039)();
    const clearErrorMessage = (0, $P551f.useCallback)(()=>{
        // eslint-disable-next-line unicorn/no-useless-undefined
        setErrorMessage(undefined);
    }, [
        setErrorMessage
    ]);
    // Should clear the context and storage if the user trying to resubmit the form
    const clearContext = (0, $P551f.useCallback)(()=>{
        // eslint-disable-next-line unicorn/no-useless-undefined
        setEmail(undefined);
        setSsoConnectors([]);
    }, [
        setEmail,
        setSsoConnectors
    ]);
    /**
   * Check if the email is registered with any SSO connectors
   * @param {string} email
   * @param {boolean} continueSignIn - whether to continue the single sign-on flow if the email is registered with any SSO connectors
   * @returns {Promise<boolean>} - true if the email is registered with any SSO connectors
   */ const onSubmit = (0, $P551f.useCallback)(async (email, continueSignIn = false)=>{
        var _connectors_;
        clearContext();
        const [error, result] = await request(email);
        if (error) {
            // Show error message only if the user is trying to continue the single sign-on flow, otherwise, silently fail
            if (continueSignIn) await handleError(error, {
                "guard.invalid_input": ()=>{
                    setErrorMessage(t("error.invalid_email"));
                }
            });
            return;
        }
        const connectors = result === null || result === void 0 ? void 0 : result.map((connectorId)=>availableSsoConnectorsMap.get(connectorId))// eslint-disable-next-line unicorn/prefer-native-coercion-functions -- make the type more specific
        .filter((connector)=>Boolean(connector));
        if (!connectors || connectors.length === 0) {
            setErrorMessage(t("error.sso_not_enabled"));
            return;
        }
        setSsoConnectors(connectors);
        setEmail(email);
        if (!continueSignIn) return true;
        // If there is only one connector, we can directly invoke the SSO flow
        if (connectors.length === 1 && ((_connectors_ = connectors[0]) === null || _connectors_ === void 0 ? void 0 : _connectors_.id)) {
            await singleSignOn(connectors[0].id);
            return true;
        }
        navigate(`/${(0, $a0052762c6755033$export$45794d16c9d83fe2).routes.sso}/connectors`);
        return true;
    }, [
        availableSsoConnectorsMap,
        clearContext,
        handleError,
        navigate,
        request,
        setEmail,
        setSsoConnectors,
        singleSignOn,
        t
    ]);
    return {
        onSubmit: onSubmit,
        errorMessage: errorMessage,
        clearErrorMessage: clearErrorMessage
    };
};
var $260284b237e1ed97$export$2e2bcd8739ae039 = $260284b237e1ed97$var$useCheckSingleSignOn;






var $P551f = parcelRequire("P551f");




const $73c9cc1cebabf8c1$var$useRegisterWithUsername = ()=>{
    const navigate = (0, $2ed817dc54ac40e6$export$9770f232ac06a008)();
    const [errorMessage, setErrorMessage] = (0, $P551f.useState)();
    const clearErrorMessage = (0, $P551f.useCallback)(()=>{
        setErrorMessage("");
    }, []);
    const errorHandlers = (0, $P551f.useMemo)(()=>({
            "user.username_already_in_use": (error)=>{
                setErrorMessage(error.message);
            },
            "user.missing_profile": ()=>{
                navigate("password");
            }
        }), [
        navigate
    ]);
    const handleError = (0, $7ebd5fdad7a45c9e$export$2e2bcd8739ae039)();
    const asyncRegister = (0, $ab5ab705a7d3e209$export$2e2bcd8739ae039)((0, $72a4b194eaf87ab0$export$3053dcea78a60348));
    const onSubmit = (0, $P551f.useCallback)(async (username)=>{
        const [error] = await asyncRegister(username);
        if (error) await handleError(error, errorHandlers);
    }, [
        asyncRegister,
        errorHandlers,
        handleError
    ]);
    return {
        errorMessage: errorMessage,
        clearErrorMessage: clearErrorMessage,
        onSubmit: onSubmit
    };
};
var $73c9cc1cebabf8c1$export$2e2bcd8739ae039 = $73c9cc1cebabf8c1$var$useRegisterWithUsername;


const $7d0715e8e0c5088b$var$useOnSubmit = ()=>{
    const { ssoConnectors: ssoConnectors } = (0, $aa5a893d65a133eb$export$317715a729435b35)();
    const { onSubmit: checkSingleSignOn } = (0, $260284b237e1ed97$export$2e2bcd8739ae039)();
    const { errorMessage: usernameRegisterErrorMessage, clearErrorMessage: clearUsernameRegisterErrorMessage, onSubmit: registerWithUsername } = (0, $73c9cc1cebabf8c1$export$2e2bcd8739ae039)();
    const { errorMessage: sendVerificationCodeErrorMessage, clearErrorMessage: clearSendVerificationCodeErrorMessage, onSubmit: sendVerificationCode } = (0, $e5f910429b93015b$export$2e2bcd8739ae039)((0, $6b1416e8e4d304fe$export$12e44e23ec720850).Register);
    const clearErrorMessage = (0, $P551f.useCallback)(()=>{
        clearUsernameRegisterErrorMessage();
        clearSendVerificationCodeErrorMessage();
    }, [
        clearSendVerificationCodeErrorMessage,
        clearUsernameRegisterErrorMessage
    ]);
    const onSubmit = (0, $P551f.useCallback)(async (identifier, value)=>{
        if (identifier === (0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Username) {
            await registerWithUsername(value);
            return;
        }
        // Check if the email is registered with any SSO connectors. If the email is registered with any SSO connectors, we should not proceed to the next step
        if (identifier === (0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Email && ssoConnectors.length > 0) {
            const result = await checkSingleSignOn(value);
            if (result) return;
        }
        await sendVerificationCode({
            identifier: identifier,
            value: value
        });
    }, [
        checkSingleSignOn,
        registerWithUsername,
        sendVerificationCode,
        ssoConnectors.length
    ]);
    return {
        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
        errorMessage: usernameRegisterErrorMessage || sendVerificationCodeErrorMessage,
        clearErrorMessage: clearErrorMessage,
        onSubmit: onSubmit
    };
};
var $7d0715e8e0c5088b$export$2e2bcd8739ae039 = $7d0715e8e0c5088b$var$useOnSubmit;


const $b01a7ef8bdb3718f$var$IdentifierRegisterForm = ({ className: className, autoFocus: autoFocus, signUpMethods: signUpMethods })=>{
    const { t: t } = (0, $5d79e62c9ff74ac9$export$9fc83ad70ead8663)();
    const { termsValidation: termsValidation } = (0, $a109f6d946545a69$export$2e2bcd8739ae039)();
    const { errorMessage: errorMessage, clearErrorMessage: clearErrorMessage, onSubmit: onSubmit } = (0, $7d0715e8e0c5088b$export$2e2bcd8739ae039)();
    const { watch: watch, handleSubmit: handleSubmit, formState: { errors: errors, isValid: isValid }, control: control } = (0, $afcc65e7f92ff559$export$87c0cf8eb5a167e0)({
        reValidateMode: "onBlur"
    });
    // Watch identifier field and check single sign on method availability
    const { showSingleSignOnForm: showSingleSignOnForm, navigateToSingleSignOn: navigateToSingleSignOn } = (0, $40a2da7fe56680a9$export$2e2bcd8739ae039)(watch("id"));
    (0, $P551f.useEffect)(()=>{
        if (!isValid) clearErrorMessage();
    }, [
        clearErrorMessage,
        isValid
    ]);
    const onSubmitHandler = (0, $P551f.useCallback)(async (event)=>{
        clearErrorMessage();
        handleSubmit(async ({ id: { type: type, value: value } })=>{
            if (!type) return;
            if (showSingleSignOnForm) {
                await navigateToSingleSignOn();
                return;
            }
            if (!await termsValidation()) return;
            await onSubmit(type, value);
        })(event);
    }, [
        clearErrorMessage,
        handleSubmit,
        navigateToSingleSignOn,
        onSubmit,
        showSingleSignOnForm,
        termsValidation
    ]);
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("form", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a6f0144cf2b2d456$exports)))($59389391e367d16d$export$6210fa4921d2a466, className),
        onSubmit: onSubmitHandler,
        children: [
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $afcc65e7f92ff559$export$bd0bf19f25da8474), {
                control: control,
                name: "id",
                rules: {
                    validate: ({ type: type, value: value })=>{
                        if (!type || !value) return (0, $5f609015ba424ff1$export$87161604d0c960f6)(signUpMethods, "required");
                        const errorMessage = (0, $5f609015ba424ff1$export$1222f18ddc446c49)(type, value);
                        var _errorMessage_data;
                        if (errorMessage) return typeof errorMessage === "string" ? t(`error.${errorMessage}`) : t(`error.${errorMessage.code}`, (_errorMessage_data = errorMessage.data) !== null && _errorMessage_data !== void 0 ? _errorMessage_data : {});
                        return true;
                    }
                },
                render: ({ field: field })=>{
                    var _errors_id;
                    /*#__PURE__*/ return (0, $b1404a408b0d045c$exports.jsx)((0, $5fa6bf3f237eb8ef$export$2e2bcd8739ae039), (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({
                        autoComplete: "off",
                        autoFocus: autoFocus,
                        className: $59389391e367d16d$export$6f2f4d5c38fc8e55
                    }, field), {
                        isDanger: !!errors.id || !!errorMessage,
                        errorMessage: (_errors_id = errors.id) === null || _errors_id === void 0 ? void 0 : _errors_id.message,
                        enabledTypes: signUpMethods
                    }));
                }
            }),
            errorMessage && /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $4ebb9c3ba9ede754$export$2e2bcd8739ae039), {
                className: $59389391e367d16d$export$ce85b9b1fe34d6d3,
                children: errorMessage
            }),
            showSingleSignOnForm && /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("div", {
                className: $59389391e367d16d$export$a8ecead220dd38a6,
                children: t("description.single_sign_on_enabled")
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $7d5d4f120f897ecc$export$2e2bcd8739ae039), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($a6f0144cf2b2d456$exports)))($59389391e367d16d$export$8a21ba990ca4a7cb, showSingleSignOnForm && $59389391e367d16d$export$73920f18ca706874)
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $c6d8f26a28e11cb6$export$2e2bcd8739ae039), {
                name: "submit",
                title: showSingleSignOnForm ? "action.single_sign_on" : "action.create_account",
                icon: showSingleSignOnForm ? /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $ad452ea4e6bcb412$export$2e2bcd8739ae039), {}) : undefined,
                htmlType: "submit"
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("input", {
                hidden: true,
                type: "submit"
            })
        ]
    });
};
var $b01a7ef8bdb3718f$export$2e2bcd8739ae039 = $b01a7ef8bdb3718f$var$IdentifierRegisterForm;


var $3d26e6e9a7c4ebbc$export$6f5378aa3397b877;
var $3d26e6e9a7c4ebbc$export$e8c9778bf415dd08;
var $3d26e6e9a7c4ebbc$export$f22da7240b7add18;
var $3d26e6e9a7c4ebbc$export$70284e70a748b99d;
var $3d26e6e9a7c4ebbc$export$86d0200e957dbda1;
var $3d26e6e9a7c4ebbc$export$a865beef2b207e4c;
var $3d26e6e9a7c4ebbc$export$8a21ba990ca4a7cb;
$3d26e6e9a7c4ebbc$export$6f5378aa3397b877 = `l0GcaG_createAccount`;
$3d26e6e9a7c4ebbc$export$e8c9778bf415dd08 = `l0GcaG_divider`;
$3d26e6e9a7c4ebbc$export$f22da7240b7add18 = `l0GcaG_main`;
$3d26e6e9a7c4ebbc$export$70284e70a748b99d = `l0GcaG_otherMethods`;
$3d26e6e9a7c4ebbc$export$86d0200e957dbda1 = `l0GcaG_placeHolder`;
$3d26e6e9a7c4ebbc$export$a865beef2b207e4c = `l0GcaG_singleSignOn`;
$3d26e6e9a7c4ebbc$export$8a21ba990ca4a7cb = `l0GcaG_terms`;


const $017128ca51452c7d$var$RegisterFooter = ()=>{
    const { signUpMethods: signUpMethods, socialConnectors: socialConnectors, signInMode: signInMode, signInMethods: signInMethods, singleSignOnEnabled: singleSignOnEnabled } = (0, $aa5a893d65a133eb$export$317715a729435b35)();
    const { t: t } = (0, $5d79e62c9ff74ac9$export$9fc83ad70ead8663)();
    const { showSingleSignOnForm: showSingleSignOnForm } = (0, $P551f.useContext)((0, $39efb6d80db8b9ee$export$2e2bcd8739ae039));
    /* Hide footers when showing Single Sign On form */ if (showSingleSignOnForm) return null;
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)((0, $b1404a408b0d045c$exports.Fragment), {
        children: [
            // Single Sign On footer
            singleSignOnEnabled && /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("div", {
                className: $3d26e6e9a7c4ebbc$export$a865beef2b207e4c,
                children: [
                    t("description.use"),
                    " ",
                    /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $b6cc3a098ca171c6$export$2e2bcd8739ae039), {
                        to: "/single-sign-on/email",
                        text: "action.single_sign_on"
                    })
                ]
            }),
            // SignIn footer
            signInMode === (0, $3ce2871eb3919730$export$f927bbb3d448dc2b).SignInAndRegister && signInMethods.length > 0 && /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("div", {
                className: $3d26e6e9a7c4ebbc$export$6f5378aa3397b877,
                children: [
                    t("description.have_account"),
                    " ",
                    /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $b6cc3a098ca171c6$export$2e2bcd8739ae039), {
                        replace: true,
                        to: "/sign-in",
                        text: "action.sign_in"
                    })
                ]
            }),
            // Social sign-in methods
            signUpMethods.length > 0 && socialConnectors.length > 0 && /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)((0, $b1404a408b0d045c$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $6994ccd4805f2603$export$2e2bcd8739ae039), {
                        label: "description.or",
                        className: $3d26e6e9a7c4ebbc$export$e8c9778bf415dd08
                    }),
                    /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $888c6bd147509dd9$export$2e2bcd8739ae039), {
                        socialConnectors: socialConnectors,
                        className: $3d26e6e9a7c4ebbc$export$f22da7240b7add18
                    })
                ]
            })
        ]
    });
};
const $017128ca51452c7d$var$Register = ()=>{
    const { signUpMethods: signUpMethods, socialConnectors: socialConnectors, signInMode: signInMode } = (0, $aa5a893d65a133eb$export$317715a729435b35)();
    if (!signInMode) return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $bcc9cc4bed8427a6$export$2e2bcd8739ae039), {});
    if (signInMode === (0, $3ce2871eb3919730$export$f927bbb3d448dc2b).SignIn) return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $2ed817dc54ac40e6$export$444b3ab0cb9aec40), {
        to: "/sign-in"
    });
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $b30f555a3018f307$export$2e2bcd8739ae039), {
        title: "description.create_your_account",
        children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)((0, $2be0f25b6ad9b7d7$export$2e2bcd8739ae039), {
            children: [
                signUpMethods.length > 0 && /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $b01a7ef8bdb3718f$export$2e2bcd8739ae039), {
                    signUpMethods: signUpMethods,
                    className: $3d26e6e9a7c4ebbc$export$f22da7240b7add18
                }),
                signUpMethods.length === 0 && socialConnectors.length > 0 && /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)((0, $b1404a408b0d045c$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $7d5d4f120f897ecc$export$2e2bcd8739ae039), {
                            className: $3d26e6e9a7c4ebbc$export$8a21ba990ca4a7cb
                        }),
                        /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $888c6bd147509dd9$export$2e2bcd8739ae039), {
                            className: $3d26e6e9a7c4ebbc$export$f22da7240b7add18,
                            socialConnectors: socialConnectors
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)($017128ca51452c7d$var$RegisterFooter, {})
            ]
        })
    });
};
var $017128ca51452c7d$export$2e2bcd8739ae039 = $017128ca51452c7d$var$Register;






var $P551f = parcelRequire("P551f");









const $aa9af0979d19e376$var$RegisterPassword = ()=>{
    const { signUpMethods: signUpMethods } = (0, $aa5a893d65a133eb$export$317715a729435b35)();
    const navigate = (0, $2ed817dc54ac40e6$export$9770f232ac06a008)();
    const { show: show } = (0, $f3ae436b724671df$export$753980156bc86c10)();
    const [errorMessage, setErrorMessage] = (0, $P551f.useState)();
    const clearErrorMessage = (0, $P551f.useCallback)(()=>{
        setErrorMessage(undefined);
    }, []);
    const mfaErrorHandler = (0, $3159c2bcbe0310be$export$2e2bcd8739ae039)({
        replace: true
    });
    const errorHandlers = (0, $P551f.useMemo)(()=>(0, $0de5391da8318002$export$581ff339ea0ba762)({
            // Incase previous page submitted username has been taken
            "user.username_already_in_use": async (error)=>{
                await show({
                    type: "alert",
                    ModalContent: error.message,
                    cancelText: "action.got_it"
                });
                navigate(-1);
            }
        }, mfaErrorHandler), [
        navigate,
        mfaErrorHandler,
        show
    ]);
    const successHandler = (0, $P551f.useCallback)((result)=>{
        if (result && "redirectTo" in result) window.location.replace(result.redirectTo);
    }, []);
    const [action] = (0, $cdc84a946f7d64eb$export$2e2bcd8739ae039)({
        api: (0, $72a4b194eaf87ab0$export$bc3a34d5df3015fe),
        setErrorMessage: setErrorMessage,
        errorHandlers: errorHandlers,
        successHandler: successHandler
    });
    const { policy: { length: { min: min, max: max }, characterTypes: { min: count } }, requirementsDescription: requirementsDescription } = (0, $aa5a893d65a133eb$export$b03f85e37d353e63)();
    if (!signUpMethods.includes((0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Username)) return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $bcc9cc4bed8427a6$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $3dc734e3f6636ef1$export$2e2bcd8739ae039), {
        title: "description.new_password",
        description: requirementsDescription && /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("span", {
            children: requirementsDescription
        }),
        descriptionProps: {
            min: min,
            count: count
        },
        children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $b82e639c4d502e57$export$2e2bcd8739ae039), {
            autoFocus: true,
            errorMessage: errorMessage,
            maxLength: max,
            clearErrorMessage: clearErrorMessage,
            onSubmit: action
        })
    });
};
var $aa9af0979d19e376$export$2e2bcd8739ae039 = $aa9af0979d19e376$var$RegisterPassword;




var $P551f = parcelRequire("P551f");









const $d94b40f4ca3d298b$var$ResetPassword = ()=>{
    const [errorMessage, setErrorMessage] = (0, $P551f.useState)();
    const clearErrorMessage = (0, $P551f.useCallback)(()=>{
        setErrorMessage(undefined);
    }, []);
    const { t: t } = (0, $5d79e62c9ff74ac9$export$9fc83ad70ead8663)();
    const { setToast: setToast } = (0, $d1e7a25fbbe7c8e1$export$2e2bcd8739ae039)();
    const navigate = (0, $2ed817dc54ac40e6$export$9770f232ac06a008)();
    const { show: show } = (0, $f3ae436b724671df$export$753980156bc86c10)();
    const errorHandlers = (0, $P551f.useMemo)(()=>({
            "session.verification_session_not_found": async (error)=>{
                await show({
                    type: "alert",
                    ModalContent: error.message,
                    cancelText: "action.got_it"
                });
                navigate(-2);
            },
            "user.same_password": (error)=>{
                setErrorMessage(error.message);
            }
        }), [
        navigate,
        setErrorMessage,
        show
    ]);
    const successHandler = (0, $P551f.useCallback)((result)=>{
        if (result) {
            setToast(t("description.password_changed"));
            navigate("/sign-in", {
                replace: true
            });
        }
    }, [
        navigate,
        setToast,
        t
    ]);
    const [action] = (0, $cdc84a946f7d64eb$export$2e2bcd8739ae039)({
        api: (0, $72a4b194eaf87ab0$export$bc3a34d5df3015fe),
        setErrorMessage: setErrorMessage,
        errorHandlers: errorHandlers,
        successHandler: successHandler
    });
    const { policy: { length: { min: min, max: max }, characterTypes: { min: count } }, requirementsDescription: requirementsDescription } = (0, $aa5a893d65a133eb$export$b03f85e37d353e63)();
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $3dc734e3f6636ef1$export$2e2bcd8739ae039), {
        title: "description.new_password",
        description: requirementsDescription && /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("span", {
            children: requirementsDescription
        }),
        descriptionProps: {
            min: min,
            count: count
        },
        children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $b82e639c4d502e57$export$2e2bcd8739ae039), {
            autoFocus: true,
            errorMessage: errorMessage,
            maxLength: max,
            clearErrorMessage: clearErrorMessage,
            onSubmit: action
        })
    });
};
var $d94b40f4ca3d298b$export$2e2bcd8739ae039 = $d94b40f4ca3d298b$var$ResetPassword;





var $P551f = parcelRequire("P551f");











const $f129e65d6bab932a$var$TermsAndPrivacyLinks = ({ className: className })=>{
    const { termsOfUseUrl: termsOfUseUrl, privacyPolicyUrl: privacyPolicyUrl, isTermsDisabled: isTermsDisabled } = (0, $a109f6d946545a69$export$2e2bcd8739ae039)();
    if (isTermsDisabled) return null;
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $ea24fc73cce16e14$export$2e2bcd8739ae039), {
            termsOfUseUrl: termsOfUseUrl,
            privacyPolicyUrl: privacyPolicyUrl
        })
    });
};
var $f129e65d6bab932a$export$2e2bcd8739ae039 = $f129e65d6bab932a$var$TermsAndPrivacyLinks;











var $P551f = parcelRequire("P551f");








var $1e6af7e00dc300a8$export$6210fa4921d2a466;
var $1e6af7e00dc300a8$export$ce85b9b1fe34d6d3;
var $1e6af7e00dc300a8$export$6f2f4d5c38fc8e55;
var $1e6af7e00dc300a8$export$a8ecead220dd38a6;
$1e6af7e00dc300a8$export$6210fa4921d2a466 = `idrqUa_form`;
$1e6af7e00dc300a8$export$ce85b9b1fe34d6d3 = `idrqUa_formErrors`;
$1e6af7e00dc300a8$export$6f2f4d5c38fc8e55 = `idrqUa_inputField`;
$1e6af7e00dc300a8$export$a8ecead220dd38a6 = `idrqUa_message`;




var $P551f = parcelRequire("P551f");





const $9fbac3fb0b624e39$var$useOnSubmit = (signInMethods)=>{
    const navigate = (0, $2ed817dc54ac40e6$export$9770f232ac06a008)();
    const { ssoConnectors: ssoConnectors } = (0, $aa5a893d65a133eb$export$317715a729435b35)();
    const { onSubmit: checkSingleSignOn } = (0, $260284b237e1ed97$export$2e2bcd8739ae039)();
    const signInWithPassword = (0, $P551f.useCallback)((identifier, value)=>{
        navigate({
            pathname: `/${(0, $6b1416e8e4d304fe$export$12e44e23ec720850).SignIn}/password`
        }, {
            state: {
                identifier: identifier,
                value: value
            }
        });
    }, [
        navigate
    ]);
    const { errorMessage: errorMessage, clearErrorMessage: clearErrorMessage, onSubmit: sendVerificationCode } = (0, $e5f910429b93015b$export$2e2bcd8739ae039)((0, $6b1416e8e4d304fe$export$12e44e23ec720850).SignIn);
    const onSubmit = (0, $P551f.useCallback)(async (identifier, value)=>{
        const method = signInMethods.find((method)=>method.identifier === identifier);
        if (!method) throw new Error(`Cannot find method with identifier type ${identifier}`);
        const { password: password, isPasswordPrimary: isPasswordPrimary, verificationCode: verificationCode } = method;
        if (identifier === (0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Username) {
            signInWithPassword(identifier, value);
            return;
        }
        // Check if the email is registered with any SSO connectors. If the email is registered with any SSO connectors, we should not proceed to the next step
        if (identifier === (0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Email && ssoConnectors.length > 0) {
            const result = await checkSingleSignOn(value);
            if (result) return;
        }
        if (password && (isPasswordPrimary || !verificationCode)) {
            signInWithPassword(identifier, value);
            return;
        }
        if (verificationCode) await sendVerificationCode({
            identifier: identifier,
            value: value
        });
    }, [
        checkSingleSignOn,
        sendVerificationCode,
        signInMethods,
        signInWithPassword,
        ssoConnectors.length
    ]);
    return {
        errorMessage: errorMessage,
        clearErrorMessage: clearErrorMessage,
        onSubmit: onSubmit
    };
};
var $9fbac3fb0b624e39$export$2e2bcd8739ae039 = $9fbac3fb0b624e39$var$useOnSubmit;


const $136aabb1948df766$var$IdentifierSignInForm = ({ className: className, autoFocus: autoFocus, signInMethods: signInMethods })=>{
    const { t: t } = (0, $5d79e62c9ff74ac9$export$9fc83ad70ead8663)();
    const { errorMessage: errorMessage, clearErrorMessage: clearErrorMessage, onSubmit: onSubmit } = (0, $9fbac3fb0b624e39$export$2e2bcd8739ae039)(signInMethods);
    const enabledSignInMethods = (0, $P551f.useMemo)(()=>signInMethods.map(({ identifier: identifier })=>identifier), [
        signInMethods
    ]);
    const { watch: watch, handleSubmit: handleSubmit, control: control, formState: { errors: errors, isValid: isValid } } = (0, $afcc65e7f92ff559$export$87c0cf8eb5a167e0)({
        reValidateMode: "onBlur"
    });
    // Watch identifier field and check single sign on method availability
    const { showSingleSignOnForm: showSingleSignOnForm, navigateToSingleSignOn: navigateToSingleSignOn } = (0, $40a2da7fe56680a9$export$2e2bcd8739ae039)(watch("identifier"));
    (0, $P551f.useEffect)(()=>{
        if (!isValid) clearErrorMessage();
    }, [
        clearErrorMessage,
        isValid
    ]);
    const onSubmitHandler = (0, $P551f.useCallback)(async (event)=>{
        clearErrorMessage();
        handleSubmit(async ({ identifier: { type: type, value: value } })=>{
            if (!type) return;
            if (showSingleSignOnForm) {
                await navigateToSingleSignOn();
                return;
            }
            await onSubmit(type, value);
        })(event);
    }, [
        clearErrorMessage,
        handleSubmit,
        navigateToSingleSignOn,
        onSubmit,
        showSingleSignOnForm
    ]);
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("form", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a6f0144cf2b2d456$exports)))($1e6af7e00dc300a8$export$6210fa4921d2a466, className),
        onSubmit: onSubmitHandler,
        children: [
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $afcc65e7f92ff559$export$bd0bf19f25da8474), {
                control: control,
                name: "identifier",
                rules: {
                    validate: ({ type: type, value: value })=>{
                        if (!type || !value) return (0, $5f609015ba424ff1$export$87161604d0c960f6)(enabledSignInMethods, "required");
                        const errorMessage = (0, $5f609015ba424ff1$export$1222f18ddc446c49)(type, value);
                        return errorMessage ? (0, $5f609015ba424ff1$export$87161604d0c960f6)(enabledSignInMethods, "invalid") : true;
                    }
                },
                render: ({ field: field })=>{
                    var _errors_identifier;
                    /*#__PURE__*/ return (0, $b1404a408b0d045c$exports.jsx)((0, $5fa6bf3f237eb8ef$export$2e2bcd8739ae039), (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({
                        autoFocus: autoFocus,
                        className: $1e6af7e00dc300a8$export$6f2f4d5c38fc8e55
                    }, field), {
                        isDanger: !!errors.identifier || !!errorMessage,
                        errorMessage: (_errors_identifier = errors.identifier) === null || _errors_identifier === void 0 ? void 0 : _errors_identifier.message,
                        enabledTypes: enabledSignInMethods
                    }));
                }
            }),
            errorMessage && /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $4ebb9c3ba9ede754$export$2e2bcd8739ae039), {
                className: $1e6af7e00dc300a8$export$ce85b9b1fe34d6d3,
                children: errorMessage
            }),
            showSingleSignOnForm && /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("div", {
                className: $1e6af7e00dc300a8$export$a8ecead220dd38a6,
                children: t("description.single_sign_on_enabled")
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $c6d8f26a28e11cb6$export$2e2bcd8739ae039), {
                name: "submit",
                title: showSingleSignOnForm ? "action.single_sign_on" : "action.sign_in",
                icon: showSingleSignOnForm ? /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $ad452ea4e6bcb412$export$2e2bcd8739ae039), {}) : undefined,
                htmlType: "submit"
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("input", {
                hidden: true,
                type: "submit"
            })
        ]
    });
};
var $136aabb1948df766$export$2e2bcd8739ae039 = $136aabb1948df766$var$IdentifierSignInForm;







var $P551f = parcelRequire("P551f");










const $17872d4ae3dc43d8$var$ForgotPasswordLink = (_param)=>/*#__PURE__*/ {
    var { className: className } = _param, identifierData = (0, $451b529b5830e8ac$export$69fdd232f62cde60)(_param, [
        "className"
    ]);
    return (0, $b1404a408b0d045c$exports.jsx)((0, $b6cc3a098ca171c6$export$2e2bcd8739ae039), {
        className: className,
        to: {
            pathname: `/${(0, $6b1416e8e4d304fe$export$12e44e23ec720850).ForgotPassword}`
        },
        state: identifierData,
        text: "action.forgot_password"
    });
};
var $17872d4ae3dc43d8$export$2e2bcd8739ae039 = $17872d4ae3dc43d8$var$ForgotPasswordLink;




var $P551f = parcelRequire("P551f");





const $970abfb7bafe24a7$var$usePasswordSignIn = ()=>{
    const [errorMessage, setErrorMessage] = (0, $P551f.useState)();
    const { onSubmit: checkSingleSignOn } = (0, $260284b237e1ed97$export$2e2bcd8739ae039)();
    const clearErrorMessage = (0, $P551f.useCallback)(()=>{
        setErrorMessage("");
    }, []);
    const handleError = (0, $7ebd5fdad7a45c9e$export$2e2bcd8739ae039)();
    const asyncSignIn = (0, $ab5ab705a7d3e209$export$2e2bcd8739ae039)((0, $72a4b194eaf87ab0$export$9e0f2ad532e0b36f));
    const preSignInErrorHandler = (0, $c93ac0a28f6f81db$export$2e2bcd8739ae039)();
    const errorHandlers = (0, $P551f.useMemo)(()=>(0, $0de5391da8318002$export$581ff339ea0ba762)({
            "session.invalid_credentials": (error)=>{
                setErrorMessage(error.message);
            }
        }, preSignInErrorHandler), [
        preSignInErrorHandler
    ]);
    const onSubmit = (0, $P551f.useCallback)(async (payload)=>{
        // Check if the email is registered with any SSO connectors. If the email is registered with any SSO connectors, we should not proceed to the next step
        if (payload.email) {
            const result = await checkSingleSignOn(payload.email);
            if (result) return;
        }
        const [error, result] = await asyncSignIn(payload);
        if (error) {
            await handleError(error, errorHandlers);
            return;
        }
        if (result === null || result === void 0 ? void 0 : result.redirectTo) window.location.replace(result.redirectTo);
    }, [
        asyncSignIn,
        checkSingleSignOn,
        errorHandlers,
        handleError
    ]);
    return {
        errorMessage: errorMessage,
        clearErrorMessage: clearErrorMessage,
        onSubmit: onSubmit
    };
};
var $970abfb7bafe24a7$export$2e2bcd8739ae039 = $970abfb7bafe24a7$var$usePasswordSignIn;





var $188f0ad964c8328f$export$6210fa4921d2a466;
var $188f0ad964c8328f$export$ce85b9b1fe34d6d3;
var $188f0ad964c8328f$export$6f2f4d5c38fc8e55;
var $188f0ad964c8328f$export$9c30223ca0a664fb;
var $188f0ad964c8328f$export$a8ecead220dd38a6;
var $188f0ad964c8328f$export$8a21ba990ca4a7cb;
$188f0ad964c8328f$export$6210fa4921d2a466 = `H0bY_G_form`;
$188f0ad964c8328f$export$ce85b9b1fe34d6d3 = `H0bY_G_formErrors`;
$188f0ad964c8328f$export$6f2f4d5c38fc8e55 = `H0bY_G_inputField`;
$188f0ad964c8328f$export$9c30223ca0a664fb = `H0bY_G_link`;
$188f0ad964c8328f$export$a8ecead220dd38a6 = `H0bY_G_message`;
$188f0ad964c8328f$export$8a21ba990ca4a7cb = `H0bY_G_terms`;


const $0696e52871308c47$var$PasswordSignInForm = ({ className: className, autoFocus: autoFocus, signInMethods: signInMethods })=>{
    var _errors_password;
    const { t: t } = (0, $5d79e62c9ff74ac9$export$9fc83ad70ead8663)();
    const { errorMessage: errorMessage, clearErrorMessage: clearErrorMessage, onSubmit: onSubmit } = (0, $970abfb7bafe24a7$export$2e2bcd8739ae039)();
    const { isForgotPasswordEnabled: isForgotPasswordEnabled } = (0, $aa5a893d65a133eb$export$9418daf6fcecfff4)();
    const { watch: watch, register: register, handleSubmit: handleSubmit, control: control, formState: { errors: errors, isValid: isValid } } = (0, $afcc65e7f92ff559$export$87c0cf8eb5a167e0)({
        reValidateMode: "onBlur",
        defaultValues: {
            identifier: {},
            password: ""
        }
    });
    const { showSingleSignOnForm: showSingleSignOnForm, navigateToSingleSignOn: navigateToSingleSignOn } = (0, $40a2da7fe56680a9$export$2e2bcd8739ae039)(watch("identifier"));
    const onSubmitHandler = (0, $P551f.useCallback)(async (event)=>{
        clearErrorMessage();
        await handleSubmit(async ({ identifier: { type: type, value: value }, password: password })=>{
            if (!type) return;
            if (showSingleSignOnForm) {
                await navigateToSingleSignOn();
                return;
            }
            await onSubmit({
                [type]: value,
                password: password
            });
        })(event);
    }, [
        clearErrorMessage,
        handleSubmit,
        navigateToSingleSignOn,
        onSubmit,
        showSingleSignOnForm
    ]);
    (0, $P551f.useEffect)(()=>{
        if (!isValid) clearErrorMessage();
    }, [
        clearErrorMessage,
        isValid
    ]);
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("form", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a6f0144cf2b2d456$exports)))($188f0ad964c8328f$export$6210fa4921d2a466, className),
        onSubmit: onSubmitHandler,
        children: [
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $afcc65e7f92ff559$export$bd0bf19f25da8474), {
                control: control,
                name: "identifier",
                rules: {
                    validate: ({ type: type, value: value })=>{
                        if (!type || !value) return (0, $5f609015ba424ff1$export$87161604d0c960f6)(signInMethods, "required");
                        const errorMessage = (0, $5f609015ba424ff1$export$1222f18ddc446c49)(type, value);
                        return errorMessage ? (0, $5f609015ba424ff1$export$87161604d0c960f6)(signInMethods, "invalid") : true;
                    }
                },
                render: ({ field: field })=>{
                    var _errors_identifier;
                    /*#__PURE__*/ return (0, $b1404a408b0d045c$exports.jsx)((0, $5fa6bf3f237eb8ef$export$2e2bcd8739ae039), (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({
                        autoFocus: autoFocus,
                        className: $188f0ad964c8328f$export$6f2f4d5c38fc8e55
                    }, field), {
                        isDanger: !!errors.identifier,
                        errorMessage: (_errors_identifier = errors.identifier) === null || _errors_identifier === void 0 ? void 0 : _errors_identifier.message,
                        enabledTypes: signInMethods
                    }));
                }
            }),
            showSingleSignOnForm && /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("div", {
                className: $188f0ad964c8328f$export$a8ecead220dd38a6,
                children: t("description.single_sign_on_enabled")
            }),
            !showSingleSignOnForm && /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $942ba6b6db15403b$export$2e2bcd8739ae039), (0, $0de5391da8318002$export$581ff339ea0ba762)({
                className: $188f0ad964c8328f$export$6f2f4d5c38fc8e55,
                autoComplete: "current-password",
                placeholder: t("input.password"),
                isDanger: !!errors.password,
                errorMessage: (_errors_password = errors.password) === null || _errors_password === void 0 ? void 0 : _errors_password.message
            }, register("password", {
                required: t("error.password_required")
            }))),
            errorMessage && /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $4ebb9c3ba9ede754$export$2e2bcd8739ae039), {
                className: $188f0ad964c8328f$export$ce85b9b1fe34d6d3,
                children: errorMessage
            }),
            isForgotPasswordEnabled && !showSingleSignOnForm && /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $17872d4ae3dc43d8$export$2e2bcd8739ae039), {
                className: $188f0ad964c8328f$export$9c30223ca0a664fb,
                identifier: watch("identifier").type,
                value: watch("identifier").value
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $c6d8f26a28e11cb6$export$2e2bcd8739ae039), {
                name: "submit",
                title: showSingleSignOnForm ? "action.single_sign_on" : "action.sign_in",
                icon: showSingleSignOnForm ? /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $ad452ea4e6bcb412$export$2e2bcd8739ae039), {}) : undefined,
                htmlType: "submit"
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("input", {
                hidden: true,
                type: "submit"
            })
        ]
    });
};
var $0696e52871308c47$export$2e2bcd8739ae039 = $0696e52871308c47$var$PasswordSignInForm;


var $c3e04236db67ed44$export$6f5378aa3397b877;
var $c3e04236db67ed44$export$e8c9778bf415dd08;
var $c3e04236db67ed44$export$f22da7240b7add18;
var $c3e04236db67ed44$export$70284e70a748b99d;
var $c3e04236db67ed44$export$86d0200e957dbda1;
var $c3e04236db67ed44$export$a865beef2b207e4c;
var $c3e04236db67ed44$export$8a21ba990ca4a7cb;
$c3e04236db67ed44$export$6f5378aa3397b877 = `ZAqXAW_createAccount`;
$c3e04236db67ed44$export$e8c9778bf415dd08 = `ZAqXAW_divider`;
$c3e04236db67ed44$export$f22da7240b7add18 = `ZAqXAW_main`;
$c3e04236db67ed44$export$70284e70a748b99d = `ZAqXAW_otherMethods`;
$c3e04236db67ed44$export$86d0200e957dbda1 = `ZAqXAW_placeHolder`;
$c3e04236db67ed44$export$a865beef2b207e4c = `ZAqXAW_singleSignOn`;
$c3e04236db67ed44$export$8a21ba990ca4a7cb = `ZAqXAW_terms`;


const $a3e8f1a1e7402e5e$var$Main = ({ signInMethods: signInMethods, socialConnectors: socialConnectors })=>{
    if (signInMethods.length === 0 && socialConnectors.length > 0) return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $888c6bd147509dd9$export$2e2bcd8739ae039), {
        className: $c3e04236db67ed44$export$f22da7240b7add18,
        socialConnectors: socialConnectors
    });
    const isPasswordOnly = signInMethods.length > 0 && signInMethods.every(({ password: password, verificationCode: verificationCode })=>password && !verificationCode);
    if (isPasswordOnly) return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $0696e52871308c47$export$2e2bcd8739ae039), {
        className: $c3e04236db67ed44$export$f22da7240b7add18,
        signInMethods: signInMethods.map(({ identifier: identifier })=>identifier)
    });
    if (signInMethods.length > 0) return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $136aabb1948df766$export$2e2bcd8739ae039), {
        className: $c3e04236db67ed44$export$f22da7240b7add18,
        signInMethods: signInMethods
    });
    return null;
};
var $a3e8f1a1e7402e5e$export$2e2bcd8739ae039 = $a3e8f1a1e7402e5e$var$Main;



const $a292010c85feba82$var$SignInFooters = ()=>{
    const { t: t } = (0, $5d79e62c9ff74ac9$export$9fc83ad70ead8663)();
    const { signInMethods: signInMethods, signUpMethods: signUpMethods, socialConnectors: socialConnectors, signInMode: signInMode, singleSignOnEnabled: singleSignOnEnabled } = (0, $aa5a893d65a133eb$export$317715a729435b35)();
    const { showSingleSignOnForm: showSingleSignOnForm } = (0, $P551f.useContext)((0, $39efb6d80db8b9ee$export$2e2bcd8739ae039));
    /* Hide footers when showing Single Sign On form */ if (showSingleSignOnForm) return null;
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)((0, $b1404a408b0d045c$exports.Fragment), {
        children: [
            // Single Sign On footer
            singleSignOnEnabled && /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("div", {
                className: $c3e04236db67ed44$export$a865beef2b207e4c,
                children: [
                    t("description.use"),
                    " ",
                    /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $b6cc3a098ca171c6$export$2e2bcd8739ae039), {
                        to: "/single-sign-on/email",
                        text: "action.single_sign_on"
                    })
                ]
            }),
            // Create Account footer
            signInMode === (0, $3ce2871eb3919730$export$f927bbb3d448dc2b).SignInAndRegister && signUpMethods.length > 0 && /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("div", {
                className: $c3e04236db67ed44$export$6f5378aa3397b877,
                children: [
                    t("description.no_account"),
                    " ",
                    /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $b6cc3a098ca171c6$export$2e2bcd8739ae039), {
                        replace: true,
                        to: "/register",
                        text: "action.create_account"
                    })
                ]
            }),
            // Social sign-in methods
            signInMethods.length > 0 && socialConnectors.length > 0 && /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)((0, $b1404a408b0d045c$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $6994ccd4805f2603$export$2e2bcd8739ae039), {
                        label: "description.or",
                        className: $c3e04236db67ed44$export$e8c9778bf415dd08
                    }),
                    /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $888c6bd147509dd9$export$2e2bcd8739ae039), {
                        socialConnectors: socialConnectors,
                        className: $c3e04236db67ed44$export$f22da7240b7add18
                    })
                ]
            })
        ]
    });
};
const $a292010c85feba82$var$SignIn = ()=>{
    const { signInMethods: signInMethods, socialConnectors: socialConnectors, signInMode: signInMode } = (0, $aa5a893d65a133eb$export$317715a729435b35)();
    if (!signInMode) return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $bcc9cc4bed8427a6$export$2e2bcd8739ae039), {});
    if (signInMode === (0, $3ce2871eb3919730$export$f927bbb3d448dc2b).Register) return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $2ed817dc54ac40e6$export$444b3ab0cb9aec40), {
        to: "/register"
    });
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)((0, $b30f555a3018f307$export$2e2bcd8739ae039), {
        title: "description.sign_in_to_your_account",
        children: [
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)((0, $2be0f25b6ad9b7d7$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $a3e8f1a1e7402e5e$export$2e2bcd8739ae039), {
                        signInMethods: signInMethods,
                        socialConnectors: socialConnectors
                    }),
                    /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)($a292010c85feba82$var$SignInFooters, {})
                ]
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $f129e65d6bab932a$export$2e2bcd8739ae039), {
                className: $c3e04236db67ed44$export$8a21ba990ca4a7cb
            })
        ]
    });
};
var $a292010c85feba82$export$2e2bcd8739ae039 = $a292010c85feba82$var$SignIn;


















var $P551f = parcelRequire("P551f");








var $1f3d7fa8fe537fd7$export$6210fa4921d2a466;
var $1f3d7fa8fe537fd7$export$ce85b9b1fe34d6d3;
var $1f3d7fa8fe537fd7$export$6f2f4d5c38fc8e55;
var $1f3d7fa8fe537fd7$export$9c30223ca0a664fb;
var $1f3d7fa8fe537fd7$export$52002a3975269b5d;
$1f3d7fa8fe537fd7$export$6210fa4921d2a466 = `jWjpkG_form`;
$1f3d7fa8fe537fd7$export$ce85b9b1fe34d6d3 = `jWjpkG_formErrors`;
$1f3d7fa8fe537fd7$export$6f2f4d5c38fc8e55 = `jWjpkG_inputField`;
$1f3d7fa8fe537fd7$export$9c30223ca0a664fb = `jWjpkG_link`;
$1f3d7fa8fe537fd7$export$52002a3975269b5d = `jWjpkG_switch`;




var $P551f = parcelRequire("P551f");





const $71453af90660847b$var$VerificationCodeLink = ({ className: className, identifier: identifier, value: value })=>{
    const { setToast: setToast } = (0, $d1e7a25fbbe7c8e1$export$2e2bcd8739ae039)();
    const { errorMessage: errorMessage, clearErrorMessage: clearErrorMessage, onSubmit: onSubmit } = (0, $e5f910429b93015b$export$2e2bcd8739ae039)((0, $6b1416e8e4d304fe$export$12e44e23ec720850).SignIn, true);
    (0, $P551f.useEffect)(()=>{
        if (errorMessage) setToast(errorMessage);
    }, [
        errorMessage,
        setToast
    ]);
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $b6cc3a098ca171c6$export$2e2bcd8739ae039), {
        className: className,
        text: "action.sign_in_via_passcode",
        icon: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $26ff4924fb501836$export$2e2bcd8739ae039), {}),
        onClick: ()=>{
            clearErrorMessage();
            onSubmit({
                identifier: identifier,
                value: value
            });
        }
    });
};
var $71453af90660847b$export$2e2bcd8739ae039 = $71453af90660847b$var$VerificationCodeLink;


const $c14fb40b972148e8$var$PasswordForm = ({ className: className, autoFocus: autoFocus, isVerificationCodeEnabled: isVerificationCodeEnabled = false, identifier: identifier, value: value })=>{
    var _errors_password;
    const { t: t } = (0, $5d79e62c9ff74ac9$export$9fc83ad70ead8663)();
    const { errorMessage: errorMessage, clearErrorMessage: clearErrorMessage, onSubmit: onSubmit } = (0, $970abfb7bafe24a7$export$2e2bcd8739ae039)();
    const { isForgotPasswordEnabled: isForgotPasswordEnabled } = (0, $aa5a893d65a133eb$export$9418daf6fcecfff4)();
    const { register: register, handleSubmit: handleSubmit, control: control, formState: { errors: errors, isValid: isValid } } = (0, $afcc65e7f92ff559$export$87c0cf8eb5a167e0)({
        reValidateMode: "onBlur",
        defaultValues: {
            identifier: {
                type: identifier,
                value: value
            },
            password: ""
        }
    });
    (0, $P551f.useEffect)(()=>{
        if (!isValid) clearErrorMessage();
    }, [
        clearErrorMessage,
        isValid
    ]);
    const onSubmitHandler = (0, $P551f.useCallback)(async (event)=>{
        clearErrorMessage();
        handleSubmit(async ({ identifier: { type: type, value: value }, password: password })=>{
            if (!type) return;
            await onSubmit({
                [type]: value,
                password: password
            });
        })(event);
    }, [
        clearErrorMessage,
        handleSubmit,
        onSubmit
    ]);
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("form", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a6f0144cf2b2d456$exports)))($1f3d7fa8fe537fd7$export$6210fa4921d2a466, className),
        onSubmit: onSubmitHandler,
        children: [
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $afcc65e7f92ff559$export$bd0bf19f25da8474), {
                control: control,
                name: "identifier",
                render: ({ field: { name: name, value: { type: type, value: value } } })=>/*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("input", {
                        readOnly: true,
                        hidden: true,
                        name: name,
                        value: value,
                        autoComplete: type
                    })
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $942ba6b6db15403b$export$2e2bcd8739ae039), (0, $0de5391da8318002$export$581ff339ea0ba762)({
                autoFocus: autoFocus,
                className: $1f3d7fa8fe537fd7$export$6f2f4d5c38fc8e55,
                autoComplete: "current-password",
                placeholder: t("input.password"),
                isDanger: !!errors.password,
                errorMessage: (_errors_password = errors.password) === null || _errors_password === void 0 ? void 0 : _errors_password.message
            }, register("password", {
                required: t("error.password_required")
            }))),
            errorMessage && /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $4ebb9c3ba9ede754$export$2e2bcd8739ae039), {
                className: $1f3d7fa8fe537fd7$export$ce85b9b1fe34d6d3,
                children: errorMessage
            }),
            isForgotPasswordEnabled && /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $17872d4ae3dc43d8$export$2e2bcd8739ae039), {
                className: $1f3d7fa8fe537fd7$export$9c30223ca0a664fb,
                identifier: identifier,
                value: value
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $c6d8f26a28e11cb6$export$2e2bcd8739ae039), {
                title: "action.continue",
                name: "submit",
                htmlType: "submit"
            }),
            identifier !== (0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Username && isVerificationCodeEnabled && /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $71453af90660847b$export$2e2bcd8739ae039), {
                className: $1f3d7fa8fe537fd7$export$52002a3975269b5d,
                identifier: identifier,
                value: value
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("input", {
                hidden: true,
                type: "submit"
            })
        ]
    });
};
var $c14fb40b972148e8$export$2e2bcd8739ae039 = $c14fb40b972148e8$var$PasswordForm;


const $11c0c069669583be$var$SignInPassword = ()=>{
    const { t: t } = (0, $5d79e62c9ff74ac9$export$9fc83ad70ead8663)();
    const { state: state } = (0, $2ed817dc54ac40e6$export$45d76561a5302f2b)();
    const { signInMethods: signInMethods } = (0, $aa5a893d65a133eb$export$317715a729435b35)();
    const [_, identifierState] = (0, $8a18d710f1d13368$export$a22775fa5e2eebd9)(state, (0, $4ffc90f7233cdad4$export$1e3360d68cdc393f));
    if (!identifierState) return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $bcc9cc4bed8427a6$export$2e2bcd8739ae039), {
        title: "error.invalid_session"
    });
    const { identifier: identifier, value: value } = identifierState;
    const methodSetting = signInMethods.find((method)=>method.identifier === identifier);
    // Sign-in method not enabled
    if (!(methodSetting === null || methodSetting === void 0 ? void 0 : methodSetting.password)) return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $bcc9cc4bed8427a6$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $3dc734e3f6636ef1$export$2e2bcd8739ae039), {
        title: "description.enter_password",
        description: "description.enter_password_for",
        descriptionProps: {
            method: t((0, $5f609015ba424ff1$export$71b8592ba731d4b5)[identifier]),
            value: identifier === (0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Phone ? (0, $dc69be136f5b72f6$export$79abe912f70ec8f5)(value) : value
        },
        children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $c14fb40b972148e8$export$2e2bcd8739ae039), {
            autoFocus: true,
            identifier: methodSetting.identifier,
            value: value,
            isVerificationCodeEnabled: methodSetting.verificationCode
        })
    });
};
var $11c0c069669583be$export$2e2bcd8739ae039 = $11c0c069669583be$var$SignInPassword;




var $P551f = parcelRequire("P551f");








var $f24141bf50d41a18$export$160bd65cfa324065;
var $f24141bf50d41a18$export$abccc2d7327871f5;
$f24141bf50d41a18$export$160bd65cfa324065 = `RkFnmq_ssoLinkButton`;
$f24141bf50d41a18$export$abccc2d7327871f5 = `RkFnmq_ssoLinkList`;


const $91b600b6f8274192$var$SingleSignOnConnectors = ()=>{
    const { theme: theme } = (0, $P551f.useContext)((0, $bf7e93717fb1eb16$export$2e2bcd8739ae039));
    const { email: email, ssoConnectors: ssoConnectors } = (0, $P551f.useContext)((0, $9df90ef155637237$export$2e2bcd8739ae039));
    const navigate = (0, $2ed817dc54ac40e6$export$9770f232ac06a008)();
    const onSubmit = (0, $4e5779525579582e$export$2e2bcd8739ae039)();
    // Listen to native message
    (0, $1a4d4d211af0412c$export$2e2bcd8739ae039)();
    (0, $P551f.useEffect)(()=>{
        // Return to the previous page if no email and no connectors are available in the context
        if (!email || ssoConnectors.length === 0) navigate("../email", {
            replace: true
        });
    }, [
        email,
        navigate,
        ssoConnectors.length
    ]);
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $3dc734e3f6636ef1$export$2e2bcd8739ae039), {
        title: "action.single_sign_on",
        description: "description.single_sign_on_connectors_list",
        descriptionProps: {
            email: email
        },
        children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("div", {
            className: $f24141bf50d41a18$export$abccc2d7327871f5,
            children: ssoConnectors.map((connector)=>{
                const { id: id, connectorName: connectorName, logo: logoUrl, darkLogo: darkLogoUrl } = connector;
                return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $d82d136cdafd2cb6$export$2e2bcd8739ae039), {
                    className: $f24141bf50d41a18$export$160bd65cfa324065,
                    name: {
                        en: connectorName
                    },
                    logo: (0, $105477e2633d7ba8$export$976f80239b15365)({
                        theme: theme,
                        logoUrl: logoUrl,
                        darkLogoUrl: darkLogoUrl
                    }),
                    target: connectorName,
                    onClick: async ()=>onSubmit(id)
                }, id);
            })
        })
    });
};
var $91b600b6f8274192$export$2e2bcd8739ae039 = $91b600b6f8274192$var$SingleSignOnConnectors;







var $P551f = parcelRequire("P551f");









var $7ced5dda5f3f5cc4$export$6210fa4921d2a466;
var $7ced5dda5f3f5cc4$export$ce85b9b1fe34d6d3;
var $7ced5dda5f3f5cc4$export$6f2f4d5c38fc8e55;
$7ced5dda5f3f5cc4$export$6210fa4921d2a466 = `d4_jQq_form`;
$7ced5dda5f3f5cc4$export$ce85b9b1fe34d6d3 = `d4_jQq_formErrors`;
$7ced5dda5f3f5cc4$export$6f2f4d5c38fc8e55 = `d4_jQq_inputField`;


const $5bba50cfe1a799bc$var$SingleSignOnEmail = ()=>{
    const { errorMessage: errorMessage, clearErrorMessage: clearErrorMessage, onSubmit: onSubmit } = (0, $260284b237e1ed97$export$2e2bcd8739ae039)();
    const { email: email } = (0, $P551f.useContext)((0, $9df90ef155637237$export$2e2bcd8739ae039));
    const { handleSubmit: handleSubmit, control: control, formState: { errors: errors, isValid: isValid } } = (0, $afcc65e7f92ff559$export$87c0cf8eb5a167e0)({
        reValidateMode: "onBlur"
    });
    (0, $P551f.useEffect)(()=>{
        if (!isValid) clearErrorMessage();
    }, [
        clearErrorMessage,
        isValid
    ]);
    const onSubmitHandler = (0, $P551f.useCallback)(async (event)=>{
        clearErrorMessage();
        await handleSubmit(async ({ identifier: { value: value } })=>onSubmit(value, true))(event);
    }, [
        clearErrorMessage,
        handleSubmit,
        onSubmit
    ]);
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $3dc734e3f6636ef1$export$2e2bcd8739ae039), {
        title: "action.single_sign_on",
        description: "description.single_sign_on_email_form",
        children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("form", {
            className: $7ced5dda5f3f5cc4$export$6210fa4921d2a466,
            onSubmit: onSubmitHandler,
            children: [
                /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $afcc65e7f92ff559$export$bd0bf19f25da8474), {
                    control: control,
                    name: "identifier",
                    rules: {
                        validate: ({ value: value })=>{
                            if (!value) return (0, $5f609015ba424ff1$export$87161604d0c960f6)([
                                (0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Email
                            ], "required");
                            const errorMessage = (0, $5f609015ba424ff1$export$1222f18ddc446c49)((0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Email, value);
                            return errorMessage ? (0, $5f609015ba424ff1$export$87161604d0c960f6)([
                                (0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Email
                            ], "invalid") : true;
                        }
                    },
                    render: ({ field: field })=>{
                        var _errors_identifier;
                        /*#__PURE__*/ return (0, $b1404a408b0d045c$exports.jsx)((0, $5fa6bf3f237eb8ef$export$2e2bcd8739ae039), (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({
                            autoFocus: true,
                            className: $7ced5dda5f3f5cc4$export$6f2f4d5c38fc8e55
                        }, field), {
                            isDanger: !!errors.identifier,
                            defaultValue: email,
                            errorMessage: (_errors_identifier = errors.identifier) === null || _errors_identifier === void 0 ? void 0 : _errors_identifier.message,
                            enabledTypes: [
                                (0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Email
                            ]
                        }));
                    }
                }),
                errorMessage && /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $4ebb9c3ba9ede754$export$2e2bcd8739ae039), {
                    className: $7ced5dda5f3f5cc4$export$ce85b9b1fe34d6d3,
                    children: errorMessage
                }),
                /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $c6d8f26a28e11cb6$export$2e2bcd8739ae039), {
                    title: "action.single_sign_on",
                    htmlType: "submit",
                    icon: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $ad452ea4e6bcb412$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("input", {
                    hidden: true,
                    type: "submit"
                })
            ]
        })
    });
};
var $5bba50cfe1a799bc$export$2e2bcd8739ae039 = $5bba50cfe1a799bc$var$SingleSignOnEmail;




var $P551f = parcelRequire("P551f");



var $095ca6e89bf9217f$export$bd05d1c161235462;
$095ca6e89bf9217f$export$bd05d1c161235462 = `HgNuBq_connectorContainer`;



var $P551f = parcelRequire("P551f");





const $5ecce5958d07d053$var$useSocialLandingHandler = ()=>{
    const [loading, setLoading] = (0, $P551f.useState)(true);
    const { setToast: setToast } = (0, $d1e7a25fbbe7c8e1$export$2e2bcd8739ae039)();
    const { t: t } = (0, $5d79e62c9ff74ac9$export$9fc83ad70ead8663)();
    const { search: search } = window.location;
    const socialLandingHandler = (0, $P551f.useCallback)((connectorId)=>{
        const redirectUri = (0, $53aabef915cc623b$export$6bcd65cae0372ddf)(search, (0, $6b1416e8e4d304fe$export$c4eb3ba4f04fab5).RedirectTo);
        if (!redirectUri) {
            setLoading(false);
            setToast(t("error.invalid_connector_request"));
            return;
        }
        const nativeCallbackLink = (0, $53aabef915cc623b$export$6bcd65cae0372ddf)(search, (0, $6b1416e8e4d304fe$export$c4eb3ba4f04fab5).NativeCallbackLink);
        if (nativeCallbackLink) (0, $a48a66106483a58a$export$1532ee36eebdb77d)(connectorId, nativeCallbackLink);
        window.location.replace(new URL(redirectUri));
    }, [
        search,
        setToast,
        t
    ]);
    return {
        loading: loading,
        socialLandingHandler: socialLandingHandler
    };
};
var $5ecce5958d07d053$export$2e2bcd8739ae039 = $5ecce5958d07d053$var$useSocialLandingHandler;


/**
 * SocialLanding page
 * Used for both SocialSignIn and SingleSignOn
 * Only used for native app out of the app webview sign-in flow
 * Store the native callback url in the session storage before redirect to the IdP
 */ const $c923ad08dcea5115$var$SocialLanding = ()=>{
    const { connectorId: connectorId } = (0, $2ed817dc54ac40e6$export$99eaa27ddbbb95ef)();
    const { loading: loading, socialLandingHandler: socialLandingHandler } = (0, $5ecce5958d07d053$export$2e2bcd8739ae039)();
    // SocialSignIn Callback Handler
    (0, $P551f.useEffect)(()=>{
        if (!connectorId) return;
        socialLandingHandler(connectorId);
    }, [
        connectorId,
        socialLandingHandler
    ]);
    if (!connectorId) return null;
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $d8eff111d5c2e667$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $f627b889a102cdfb$export$2e2bcd8739ae039), {
            className: $095ca6e89bf9217f$export$bd05d1c161235462,
            connectorId: connectorId,
            isLoading: loading
        })
    });
};
var $c923ad08dcea5115$export$2e2bcd8739ae039 = $c923ad08dcea5115$var$SocialLanding;

















var $P551f = parcelRequire("P551f");




const $b07f39b8ce862499$var$useSocialRegister = (connectorId, replace)=>{
    const handleError = (0, $7ebd5fdad7a45c9e$export$2e2bcd8739ae039)();
    const asyncRegisterWithSocial = (0, $ab5ab705a7d3e209$export$2e2bcd8739ae039)((0, $72a4b194eaf87ab0$export$ae2a9e5eae510a93));
    const preSignInErrorHandler = (0, $c93ac0a28f6f81db$export$2e2bcd8739ae039)({
        linkSocial: connectorId,
        replace: replace
    });
    return (0, $P551f.useCallback)(async (connectorId)=>{
        const [error, result] = await asyncRegisterWithSocial(connectorId);
        if (error) {
            await handleError(error, preSignInErrorHandler);
            return;
        }
        if (result === null || result === void 0 ? void 0 : result.redirectTo) window.location.replace(result.redirectTo);
    }, [
        asyncRegisterWithSocial,
        handleError,
        preSignInErrorHandler
    ]);
};
var $b07f39b8ce862499$export$2e2bcd8739ae039 = $b07f39b8ce862499$var$useSocialRegister;



var $d8eb8c1ff1596ef6$export$34e0f9847d4c02dd;
var $d8eb8c1ff1596ef6$export$51987bb50e1f6752;
var $d8eb8c1ff1596ef6$export$e8c9778bf415dd08;
$d8eb8c1ff1596ef6$export$34e0f9847d4c02dd = `jPOtVa_container`;
$d8eb8c1ff1596ef6$export$51987bb50e1f6752 = `jPOtVa_desc`;
$d8eb8c1ff1596ef6$export$e8c9778bf415dd08 = `jPOtVa_divider`;



var $P551f = parcelRequire("P551f");




const $6efe74cf9b9d8ada$var$useBindSocialRelatedUser = ()=>{
    const handleError = (0, $7ebd5fdad7a45c9e$export$2e2bcd8739ae039)();
    const preSignInErrorHandler = (0, $c93ac0a28f6f81db$export$2e2bcd8739ae039)();
    const asyncBindSocialRelatedUser = (0, $ab5ab705a7d3e209$export$2e2bcd8739ae039)((0, $72a4b194eaf87ab0$export$bd9511c461958ea7));
    return (0, $P551f.useCallback)(async (...payload)=>{
        const [error, result] = await asyncBindSocialRelatedUser(...payload);
        if (error) {
            await handleError(error, preSignInErrorHandler);
            return;
        }
        if (result === null || result === void 0 ? void 0 : result.redirectTo) window.location.replace(result.redirectTo);
    }, [
        asyncBindSocialRelatedUser,
        handleError,
        preSignInErrorHandler
    ]);
};
var $6efe74cf9b9d8ada$export$2e2bcd8739ae039 = $6efe74cf9b9d8ada$var$useBindSocialRelatedUser;


const $9178a3e9beadee83$var$getCreateAccountContent = (signUpMethods)=>{
    if (signUpMethods.includes((0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Email) && signUpMethods.includes((0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Phone)) return {
        desc: "description.social_link_email_or_phone",
        buttonText: "action.link_another_email_or_phone"
    };
    if (signUpMethods.includes((0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Email)) return {
        desc: "description.social_link_email",
        buttonText: "action.link_another_email"
    };
    if (signUpMethods.includes((0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Phone)) return {
        desc: "description.social_link_phone",
        buttonText: "action.link_another_phone"
    };
    return {
        desc: "description.social_create_account",
        buttonText: "action.create_account_without_linking"
    };
};
const $9178a3e9beadee83$var$SocialLinkAccount = ({ connectorId: connectorId, className: className, relatedUser: relatedUser })=>{
    const { t: t } = (0, $5d79e62c9ff74ac9$export$9fc83ad70ead8663)();
    const { signUpMethods: signUpMethods } = (0, $aa5a893d65a133eb$export$317715a729435b35)();
    const bindSocialRelatedUser = (0, $6efe74cf9b9d8ada$export$2e2bcd8739ae039)();
    const registerWithSocial = (0, $b07f39b8ce862499$export$2e2bcd8739ae039)(connectorId);
    const content = $9178a3e9beadee83$var$getCreateAccountContent(signUpMethods);
    const { type: type, value: value } = relatedUser;
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a6f0144cf2b2d456$exports)))($d8eb8c1ff1596ef6$export$34e0f9847d4c02dd, className),
        children: [
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("div", {
                className: $d8eb8c1ff1596ef6$export$51987bb50e1f6752,
                children: t("description.social_bind_with_existing")
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $c6d8f26a28e11cb6$export$2e2bcd8739ae039), {
                title: "action.bind",
                i18nProps: {
                    address: type === "email" ? (0, $aaaf907508d04279$export$2a51ca354add32e1)(value) : (0, $aaaf907508d04279$export$1f64b92865689d0d)(value)
                },
                onClick: ()=>{
                    bindSocialRelatedUser((0, $0de5391da8318002$export$581ff339ea0ba762)({
                        connectorId: connectorId
                    }, type === "email" ? {
                        email: value
                    } : {
                        phone: value
                    }));
                }
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $6994ccd4805f2603$export$2e2bcd8739ae039), {
                label: "description.or",
                className: $d8eb8c1ff1596ef6$export$e8c9778bf415dd08
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("div", {
                className: $d8eb8c1ff1596ef6$export$51987bb50e1f6752,
                children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $cfcdc2df19be03b3$export$2e2bcd8739ae039), {
                    forKey: content.desc
                })
            }),
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $c6d8f26a28e11cb6$export$2e2bcd8739ae039), {
                title: content.buttonText,
                type: "secondary",
                onClick: ()=>{
                    registerWithSocial(connectorId);
                }
            })
        ]
    });
};
var $9178a3e9beadee83$export$2e2bcd8739ae039 = $9178a3e9beadee83$var$SocialLinkAccount;





const $67837aa82fc0a64d$var$getPageTitle = (signUpMethods)=>{
    if (signUpMethods.includes((0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Email) && signUpMethods.includes((0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Phone)) return "description.link_email_or_phone";
    if (signUpMethods.includes((0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Email)) return "description.link_email";
    if (signUpMethods.includes((0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Phone)) return "description.link_phone";
    return "description.bind_account_title";
};
const $67837aa82fc0a64d$var$SocialLinkAccount = ()=>{
    const { connectorId: connectorId } = (0, $2ed817dc54ac40e6$export$99eaa27ddbbb95ef)();
    const { state: state } = (0, $2ed817dc54ac40e6$export$45d76561a5302f2b)();
    const { signUpMethods: signUpMethods } = (0, $aa5a893d65a133eb$export$317715a729435b35)();
    if (!(0, $8a18d710f1d13368$export$226b3eccf92c9ed9)(state, (0, $4ffc90f7233cdad4$export$d3035cdec99fb931))) return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $bcc9cc4bed8427a6$export$2e2bcd8739ae039), {
        rawMessage: "Missing relate account info"
    });
    if (!connectorId) return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $bcc9cc4bed8427a6$export$2e2bcd8739ae039), {
        rawMessage: "Connector not found"
    });
    const { relatedUser: relatedUser } = state;
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $3dc734e3f6636ef1$export$2e2bcd8739ae039), {
        title: $67837aa82fc0a64d$var$getPageTitle(signUpMethods),
        children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $9178a3e9beadee83$export$2e2bcd8739ae039), {
            connectorId: connectorId,
            relatedUser: relatedUser
        })
    });
};
var $67837aa82fc0a64d$export$2e2bcd8739ae039 = $67837aa82fc0a64d$var$SocialLinkAccount;















var $P551f = parcelRequire("P551f");










const $28889ab935e39c87$var$useSingleSignOnRegister = ()=>{
    const handleError = (0, $7ebd5fdad7a45c9e$export$2e2bcd8739ae039)();
    const request = (0, $ab5ab705a7d3e209$export$2e2bcd8739ae039)((0, $c27d4b4a657466b5$export$db343ec66e79e78a));
    const { termsValidation: termsValidation } = (0, $a109f6d946545a69$export$2e2bcd8739ae039)();
    const navigate = (0, $2ed817dc54ac40e6$export$9770f232ac06a008)();
    return (0, $P551f.useCallback)(async (connectorId)=>{
        // Agree to terms and conditions first before proceeding
        if (!await termsValidation()) {
            navigate("/" + (0, $a0052762c6755033$export$45794d16c9d83fe2).routes.signIn);
            return;
        }
        const [error, result] = await request(connectorId);
        if (error) {
            await handleError(error);
            return;
        }
        if (result === null || result === void 0 ? void 0 : result.redirectTo) window.location.replace(result.redirectTo);
    }, [
        handleError,
        navigate,
        request,
        termsValidation
    ]);
};
/**
 * Single Sign On authentication callback handler.
 *
 * @remark This hook is used by the Single Sign On authentication sign-in callback page.
 * Read the IdP parameters from the URL and call the Single Sign On authentication API.
 * Forked from @see `useSocialSignInListener`.
 * - SingleSignOn has different API endpoints.
 * - SingleSignOn has different error handling logic.
 */ const $28889ab935e39c87$var$useSingleSignOnListener = (connectorId)=>{
    const { t: t } = (0, $5d79e62c9ff74ac9$export$9fc83ad70ead8663)();
    const [loading, setLoading] = (0, $P551f.useState)(true);
    const [isConsumed, setIsConsumed] = (0, $P551f.useState)(false);
    const [searchParameters, setSearchParameters] = (0, $efe29403354254eb$export$f1a78c17382fe22a)();
    const { setToast: setToast } = (0, $d1e7a25fbbe7c8e1$export$2e2bcd8739ae039)();
    const { signInMode: signInMode } = (0, $aa5a893d65a133eb$export$317715a729435b35)();
    const handleError = (0, $7ebd5fdad7a45c9e$export$2e2bcd8739ae039)();
    const navigate = (0, $2ed817dc54ac40e6$export$9770f232ac06a008)();
    const singleSignOnAuthorizationRequest = (0, $ab5ab705a7d3e209$export$2e2bcd8739ae039)((0, $c27d4b4a657466b5$export$c0aa2525151c2215));
    const registerSingleSignOnIdentity = $28889ab935e39c87$var$useSingleSignOnRegister();
    const singleSignOnHandler = (0, $P551f.useCallback)(async (connectorId, data)=>{
        const [error, result] = await singleSignOnAuthorizationRequest(connectorId, (0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({}, data), {
            // For connector validation use
            redirectUri: `${window.location.origin}/callback/${connectorId}`
        }));
        if (error) {
            setLoading(false);
            await handleError(error, {
                "user.identity_not_exist": async (error)=>{
                    // Should not let user register new social account under sign-in only mode
                    if (signInMode === (0, $3ce2871eb3919730$export$f927bbb3d448dc2b).SignIn) {
                        setToast(error.message);
                        navigate("/" + (0, $a0052762c6755033$export$45794d16c9d83fe2).routes.signIn);
                        return;
                    }
                    await registerSingleSignOnIdentity(connectorId);
                }
            });
            return;
        }
        if (result === null || result === void 0 ? void 0 : result.redirectTo) window.location.replace(result.redirectTo);
    }, [
        handleError,
        navigate,
        registerSingleSignOnIdentity,
        setToast,
        signInMode,
        singleSignOnAuthorizationRequest
    ]);
    // Single Sign On Callback Handler
    (0, $P551f.useEffect)(()=>{
        if (isConsumed) return;
        setIsConsumed(true);
        const _parseQueryParameters = (0, $53aabef915cc623b$export$2469638cb19f7e00)(searchParameters), { state: state } = _parseQueryParameters, rest = (0, $451b529b5830e8ac$export$69fdd232f62cde60)(_parseQueryParameters, [
            "state"
        ]);
        // Cleanup the search parameters once it's consumed
        setSearchParameters({}, {
            replace: true
        });
        // Validate the state parameter
        if (!state || !(0, $a48a66106483a58a$export$cd0e7726290ef99e)(state, connectorId)) {
            setToast(t("error.invalid_connector_auth"));
            navigate("/" + (0, $a0052762c6755033$export$45794d16c9d83fe2).routes.signIn);
            return;
        }
        singleSignOnHandler(connectorId, rest);
    }, [
        connectorId,
        isConsumed,
        navigate,
        searchParameters,
        setSearchParameters,
        setToast,
        singleSignOnHandler,
        t
    ]);
    return {
        loading: loading
    };
};
var $28889ab935e39c87$export$2e2bcd8739ae039 = $28889ab935e39c87$var$useSingleSignOnListener;


const $c800f2ada089ef66$var$SingleSignOn = ({ connectorId: connectorId })=>{
    const { socialConnectors: socialConnectors } = (0, $aa5a893d65a133eb$export$317715a729435b35)();
    /* To avoid register duplicated native message listeners,
    we only add the native message listener if there are no social connectors.
    Set the bypass flag to true if there are social connectors.
  */ (0, $1a4d4d211af0412c$export$2e2bcd8739ae039)(socialConnectors.length > 0);
    const { loading: loading } = (0, $28889ab935e39c87$export$2e2bcd8739ae039)(connectorId);
    return loading ? /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $8aa5ba1326567b1e$export$2e2bcd8739ae039), {}) : null;
};
var $c800f2ada089ef66$export$2e2bcd8739ae039 = $c800f2ada089ef66$var$SingleSignOn;








var $P551f = parcelRequire("P551f");














const $e7f246d24d154471$var$useSocialSignInListener = (connectorId)=>{
    const [loading, setLoading] = (0, $P551f.useState)(true);
    const { setToast: setToast } = (0, $d1e7a25fbbe7c8e1$export$2e2bcd8739ae039)();
    const { signInMode: signInMode } = (0, $aa5a893d65a133eb$export$317715a729435b35)();
    const { t: t } = (0, $5d79e62c9ff74ac9$export$9fc83ad70ead8663)();
    const { termsValidation: termsValidation } = (0, $a109f6d946545a69$export$2e2bcd8739ae039)();
    const [isConsumed, setIsConsumed] = (0, $P551f.useState)(false);
    const [searchParameters, setSearchParameters] = (0, $efe29403354254eb$export$f1a78c17382fe22a)();
    const navigate = (0, $2ed817dc54ac40e6$export$9770f232ac06a008)();
    const handleError = (0, $7ebd5fdad7a45c9e$export$2e2bcd8739ae039)();
    const registerWithSocial = (0, $b07f39b8ce862499$export$2e2bcd8739ae039)(connectorId, true);
    const asyncSignInWithSocial = (0, $ab5ab705a7d3e209$export$2e2bcd8739ae039)((0, $72a4b194eaf87ab0$export$90917f4878ed116a));
    const accountNotExistErrorHandler = (0, $P551f.useCallback)(async (error)=>{
        const [, data] = (0, $8a18d710f1d13368$export$a22775fa5e2eebd9)(error.data, (0, $4ffc90f7233cdad4$export$d3035cdec99fb931));
        const { relatedUser: relatedUser } = data !== null && data !== void 0 ? data : {};
        if (relatedUser) {
            navigate(`/social/link/${connectorId}`, {
                replace: true,
                state: {
                    relatedUser: relatedUser
                }
            });
            return;
        }
        // Register with social
        await registerWithSocial(connectorId);
    }, [
        connectorId,
        navigate,
        registerWithSocial
    ]);
    const preSignInErrorHandler = (0, $c93ac0a28f6f81db$export$2e2bcd8739ae039)({
        replace: true
    });
    const signInWithSocialErrorHandlers = (0, $P551f.useMemo)(()=>(0, $0de5391da8318002$export$581ff339ea0ba762)({
            "user.identity_not_exist": async (error)=>{
                // Should not let user register new social account under sign-in only mode
                if (signInMode === (0, $3ce2871eb3919730$export$f927bbb3d448dc2b).SignIn) {
                    setToast(error.message);
                    navigate("/" + (0, $a0052762c6755033$export$45794d16c9d83fe2).routes.signIn);
                    return;
                }
                // Agree to terms and conditions first before proceeding
                if (!await termsValidation()) {
                    navigate("/" + (0, $a0052762c6755033$export$45794d16c9d83fe2).routes.signIn);
                    return;
                }
                await accountNotExistErrorHandler(error);
            }
        }, preSignInErrorHandler), [
        preSignInErrorHandler,
        signInMode,
        termsValidation,
        accountNotExistErrorHandler,
        setToast,
        navigate
    ]);
    const signInWithSocialHandler = (0, $P551f.useCallback)(async (connectorId, data)=>{
        const [error, result] = await asyncSignInWithSocial({
            connectorId: connectorId,
            connectorData: (0, $0de5391da8318002$export$581ff339ea0ba762)({
                // For validation use only
                redirectUri: `${window.location.origin}/callback/${connectorId}`
            }, data)
        });
        if (error) {
            setLoading(false);
            await handleError(error, signInWithSocialErrorHandlers);
            return;
        }
        if (result === null || result === void 0 ? void 0 : result.redirectTo) window.location.replace(result.redirectTo);
    }, [
        asyncSignInWithSocial,
        handleError,
        signInWithSocialErrorHandlers
    ]);
    // Social Sign-in Callback Handler
    (0, $P551f.useEffect)(()=>{
        if (isConsumed) return;
        setIsConsumed(true);
        const _parseQueryParameters = (0, $53aabef915cc623b$export$2469638cb19f7e00)(searchParameters), { state: state } = _parseQueryParameters, rest = (0, $451b529b5830e8ac$export$69fdd232f62cde60)(_parseQueryParameters, [
            "state"
        ]);
        // Cleanup the search parameters once it's consumed
        setSearchParameters({}, {
            replace: true
        });
        if (!state || !(0, $a48a66106483a58a$export$cd0e7726290ef99e)(state, connectorId)) {
            setToast(t("error.invalid_connector_auth"));
            navigate("/" + (0, $a0052762c6755033$export$45794d16c9d83fe2).routes.signIn);
            return;
        }
        signInWithSocialHandler(connectorId, rest);
    }, [
        connectorId,
        isConsumed,
        navigate,
        searchParameters,
        setSearchParameters,
        setToast,
        signInWithSocialHandler,
        t
    ]);
    return {
        loading: loading
    };
};
var $e7f246d24d154471$export$2e2bcd8739ae039 = $e7f246d24d154471$var$useSocialSignInListener;


const $3a4ac6a26b7ea635$var$SocialSignIn = ({ connectorId: connectorId })=>{
    const { loading: loading } = (0, $e7f246d24d154471$export$2e2bcd8739ae039)(connectorId);
    return loading ? /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $8aa5ba1326567b1e$export$2e2bcd8739ae039), {}) : null;
};
var $3a4ac6a26b7ea635$export$2e2bcd8739ae039 = $3a4ac6a26b7ea635$var$SocialSignIn;


/** The real callback page for social sign-in in web browsers. */ const $5fc75cc17bf86447$var$SocialSignInWebCallback = ()=>{
    const parameters = (0, $2ed817dc54ac40e6$export$99eaa27ddbbb95ef)();
    const { findConnectorById: findConnectorById } = (0, $4da1ed1badb5f5c0$export$2e2bcd8739ae039)();
    const result = findConnectorById(parameters.connectorId);
    if ((result === null || result === void 0 ? void 0 : result.type) === "social") return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $3a4ac6a26b7ea635$export$2e2bcd8739ae039), {
        connectorId: result.connector.id
    });
    if ((result === null || result === void 0 ? void 0 : result.type) === "sso") return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $c800f2ada089ef66$export$2e2bcd8739ae039), {
        connectorId: result.connector.id
    });
    // Connector not found, return sign in page
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $2ed817dc54ac40e6$export$444b3ab0cb9aec40), {
        to: "/" + (0, $a0052762c6755033$export$45794d16c9d83fe2).routes.signIn
    });
};
var $5fc75cc17bf86447$export$2e2bcd8739ae039 = $5fc75cc17bf86447$var$SocialSignInWebCallback;




var $P551f = parcelRequire("P551f");



const $6160caab2f3e5c0d$var$Springboard = ()=>{
    const [searchParameters] = (0, $efe29403354254eb$export$f1a78c17382fe22a)();
    (0, $P551f.useEffect)(()=>{
        const state = searchParameters.get("state");
        const connectorId = searchParameters.get("connectorId");
        const callback = searchParameters.get("callback");
        const redirectTo = searchParameters.get("redirectTo");
        if (callback && connectorId) (0, $a48a66106483a58a$export$1532ee36eebdb77d)(connectorId, callback);
        if (state && connectorId) (0, $a48a66106483a58a$export$ca97131192bad836)(state, connectorId);
        if (redirectTo) window.location.assign(redirectTo);
    }, [
        searchParameters
    ]);
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $8aa5ba1326567b1e$export$2e2bcd8739ae039), {});
};
var $6160caab2f3e5c0d$export$2e2bcd8739ae039 = $6160caab2f3e5c0d$var$Springboard;











var $P551f = parcelRequire("P551f");








const $932257d7966166a2$var$PasswordSignInLink = ({ className: className, method: method, target: target })=>{
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $b6cc3a098ca171c6$export$2e2bcd8739ae039), {
        replace: true,
        className: className,
        icon: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $26ff4924fb501836$export$2e2bcd8739ae039), {}),
        text: "action.sign_in_via_password",
        to: `/${(0, $6b1416e8e4d304fe$export$12e44e23ec720850).SignIn}/password`,
        state: {
            identifier: method,
            value: target
        }
    });
};
var $932257d7966166a2$export$2e2bcd8739ae039 = $932257d7966166a2$var$PasswordSignInLink;


var $a351b1bce2c9a3aa$export$6210fa4921d2a466;
var $a351b1bce2c9a3aa$export$6f2f4d5c38fc8e55;
var $a351b1bce2c9a3aa$export$9c30223ca0a664fb;
var $a351b1bce2c9a3aa$export$a8ecead220dd38a6;
var $a351b1bce2c9a3aa$export$52002a3975269b5d;
var $a351b1bce2c9a3aa$export$60e9e0884ce12b55;
$a351b1bce2c9a3aa$export$6210fa4921d2a466 = `_8gzYyG_form`;
$a351b1bce2c9a3aa$export$6f2f4d5c38fc8e55 = `_8gzYyG_inputField`;
$a351b1bce2c9a3aa$export$9c30223ca0a664fb = `_8gzYyG_link`;
$a351b1bce2c9a3aa$export$a8ecead220dd38a6 = `_8gzYyG_message`;
$a351b1bce2c9a3aa$export$52002a3975269b5d = `_8gzYyG_switch`;
$a351b1bce2c9a3aa$export$60e9e0884ce12b55 = `_8gzYyG_withError`;





var $P551f = parcelRequire("P551f");
var $3f1cd7f9a7df3e0c$exports = {};

!function(e, t) {
    $3f1cd7f9a7df3e0c$exports = t((parcelRequire("P551f")));
}("undefined" != typeof self ? self : $3f1cd7f9a7df3e0c$exports, function(e) {
    return function(e) {
        var t = {};
        function r(n) {
            if (t[n]) return t[n].exports;
            var o = t[n] = {
                i: n,
                l: !1,
                exports: {}
            };
            return e[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
        }
        return r.m = e, r.c = t, r.d = function(e, t, n) {
            r.o(e, t) || Object.defineProperty(e, t, {
                enumerable: !0,
                get: n
            });
        }, r.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, r.t = function(e, t) {
            if (1 & t && (e = r(e)), 8 & t) return e;
            if (4 & t && "object" == typeof e && e && e.__esModule) return e;
            var n = Object.create(null);
            if (r.r(n), Object.defineProperty(n, "default", {
                enumerable: !0,
                value: e
            }), 2 & t && "string" != typeof e) for(var o in e)r.d(n, o, (function(t) {
                return e[t];
            }).bind(null, o));
            return n;
        }, r.n = function(e) {
            var t = e && e.__esModule ? function() {
                return e.default;
            } : function() {
                return e;
            };
            return r.d(t, "a", t), t;
        }, r.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }, r.p = "", r(r.s = 3);
    }([
        function(t, r) {
            t.exports = e;
        },
        function(e, t, r) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.Validate = t.Time = void 0;
            var n = u(r(5)), o = u(r(6));
            function u(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            }
            t.Time = n.default, t.Validate = o.default;
        },
        function(e, t, r) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.useInterval = void 0;
            var n = function(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            }(r(7));
            t.useInterval = n.default;
        },
        function(e, t, r) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.useTime = t.useStopwatch = t.useTimer = void 0;
            var n = Object.assign || function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var r = arguments[t];
                    for(var n in r)Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
                }
                return e;
            };
            t.default = function(e) {
                if ((0, o.useEffect)(function() {
                    console.warn("react-timer-hook: default export useTimer is deprecated, use named exports { useTimer, useStopwatch, useTime } instead");
                }, []), e.expiryTimestamp) {
                    var t = (0, u.default)(e);
                    return n({}, t, {
                        startTimer: t.start,
                        stopTimer: t.pause,
                        resetTimer: function() {}
                    });
                }
                var r = (0, i.default)(e);
                return n({}, r, {
                    startTimer: r.start,
                    stopTimer: r.pause,
                    resetTimer: r.reset
                });
            };
            var o = r(0), u = c(r(4)), i = c(r(8)), a = c(r(9));
            function c(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            }
            t.useTimer = u.default, t.useStopwatch = i.default, t.useTime = a.default;
        },
        function(e, t, r) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var n = Object.assign || function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var r = arguments[t];
                    for(var n in r)Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
                }
                return e;
            }, o = function() {
                return function(e, t) {
                    if (Array.isArray(e)) return e;
                    if (Symbol.iterator in Object(e)) return function(e, t) {
                        var r = [], n = !0, o = !1, u = void 0;
                        try {
                            for(var i, a = e[Symbol.iterator](); !(n = (i = a.next()).done) && (r.push(i.value), !t || r.length !== t); n = !0);
                        } catch (e) {
                            o = !0, u = e;
                        } finally{
                            try {
                                !n && a.return && a.return();
                            } finally{
                                if (o) throw u;
                            }
                        }
                        return r;
                    }(e, t);
                    throw new TypeError("Invalid attempt to destructure non-iterable instance");
                };
            }();
            t.default = function(e) {
                var t = e.expiryTimestamp, r = e.onExpire, s = e.autoStart, l = void 0 === s || s, d = (0, u.useState)(t), m = o(d, 2), v = m[0], p = m[1], y = (0, u.useState)(i.Time.getSecondsFromExpiry(v)), T = o(y, 2), g = T[0], b = T[1], h = (0, u.useState)(l), S = o(h, 2), w = S[0], O = S[1], j = (0, u.useState)(l), x = o(j, 2), _ = x[0], M = x[1], P = (0, u.useState)(f(v)), F = o(P, 2), E = F[0], k = F[1];
                function I(e) {
                    var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                    k(f(e)), M(t), O(t), p(e), b(i.Time.getSecondsFromExpiry(e));
                }
                function D() {
                    var e = new Date;
                    e.setMilliseconds(e.getMilliseconds() + 1e3 * g), I(e);
                }
                return (0, a.useInterval)(function() {
                    E !== c && k(c);
                    var e = i.Time.getSecondsFromExpiry(v);
                    b(e), e <= 0 && (i.Validate.onExpire(r) && r(), O(!1), k(null));
                }, w ? E : null), n({}, i.Time.getTimeFromSeconds(g), {
                    start: function() {
                        _ ? (b(i.Time.getSecondsFromExpiry(v)), O(!0)) : D();
                    },
                    pause: function() {
                        O(!1);
                    },
                    resume: D,
                    restart: I,
                    isRunning: w
                });
            };
            var u = r(0), i = r(1), a = r(2), c = 1e3;
            function f(e) {
                if (!i.Validate.expiryTimestamp(e)) return null;
                var t = i.Time.getSecondsFromExpiry(e), r = Math.floor(1e3 * (t - Math.floor(t)));
                return r > 0 ? r : c;
            }
        },
        function(e, t, r) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var n = function() {
                function e(e, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
                    }
                }
                return function(t, r, n) {
                    return r && e(t.prototype, r), n && e(t, n), t;
                };
            }();
            var o = function() {
                function e() {
                    !function(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }(this, e);
                }
                return n(e, null, [
                    {
                        key: "getTimeFromSeconds",
                        value: function(e) {
                            var t = Math.ceil(e), r = Math.floor(t / 86400), n = Math.floor(t % 86400 / 3600), o = Math.floor(t % 3600 / 60);
                            return {
                                seconds: Math.floor(t % 60),
                                minutes: o,
                                hours: n,
                                days: r
                            };
                        }
                    },
                    {
                        key: "getSecondsFromExpiry",
                        value: function(e, t) {
                            var r = e - (new Date).getTime();
                            if (r > 0) {
                                var n = r / 1e3;
                                return t ? Math.round(n) : n;
                            }
                            return 0;
                        }
                    },
                    {
                        key: "getSecondsFromPrevTime",
                        value: function(e, t) {
                            var r = (new Date).getTime() - e;
                            if (r > 0) {
                                var n = r / 1e3;
                                return t ? Math.round(n) : n;
                            }
                            return 0;
                        }
                    },
                    {
                        key: "getSecondsFromTimeNow",
                        value: function() {
                            var e = new Date;
                            return e.getTime() / 1e3 - 60 * e.getTimezoneOffset();
                        }
                    },
                    {
                        key: "getFormattedTimeFromSeconds",
                        value: function(t, r) {
                            var n = e.getTimeFromSeconds(t), o = n.seconds, u = n.minutes, i = n.hours, a = "", c = i;
                            return "12-hour" === r && (a = i >= 12 ? "pm" : "am", c = i % 12), {
                                seconds: o,
                                minutes: u,
                                hours: c,
                                ampm: a
                            };
                        }
                    }
                ]), e;
            }();
            t.default = o;
        },
        function(e, t, r) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var n = function() {
                function e(e, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
                    }
                }
                return function(t, r, n) {
                    return r && e(t.prototype, r), n && e(t, n), t;
                };
            }();
            var o = function() {
                function e() {
                    !function(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }(this, e);
                }
                return n(e, null, [
                    {
                        key: "expiryTimestamp",
                        value: function(e) {
                            var t = new Date(e).getTime() > 0;
                            return t || console.warn("react-timer-hook: { useTimer } Invalid expiryTimestamp settings", e), t;
                        }
                    },
                    {
                        key: "onExpire",
                        value: function(e) {
                            var t = e && "function" == typeof e;
                            return e && !t && console.warn("react-timer-hook: { useTimer } Invalid onExpire settings function", e), t;
                        }
                    }
                ]), e;
            }();
            t.default = o;
        },
        function(e, t, r) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.default = function(e, t) {
                var r = (0, n.useRef)();
                (0, n.useEffect)(function() {
                    r.current = e;
                }), (0, n.useEffect)(function() {
                    if (!t) return function() {};
                    var e = setInterval(function() {
                        r.current && r.current();
                    }, t);
                    return function() {
                        return clearInterval(e);
                    };
                }, [
                    t
                ]);
            };
            var n = r(0);
        },
        function(e, t, r) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var n = Object.assign || function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var r = arguments[t];
                    for(var n in r)Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
                }
                return e;
            }, o = function() {
                return function(e, t) {
                    if (Array.isArray(e)) return e;
                    if (Symbol.iterator in Object(e)) return function(e, t) {
                        var r = [], n = !0, o = !1, u = void 0;
                        try {
                            for(var i, a = e[Symbol.iterator](); !(n = (i = a.next()).done) && (r.push(i.value), !t || r.length !== t); n = !0);
                        } catch (e) {
                            o = !0, u = e;
                        } finally{
                            try {
                                !n && a.return && a.return();
                            } finally{
                                if (o) throw u;
                            }
                        }
                        return r;
                    }(e, t);
                    throw new TypeError("Invalid attempt to destructure non-iterable instance");
                };
            }();
            t.default = function(e) {
                var t = e.autoStart, r = e.offsetTimestamp, c = (0, u.useState)(i.Time.getSecondsFromExpiry(r, !0) || 0), f = o(c, 2), s = f[0], l = f[1], d = (0, u.useState)(new Date), m = o(d, 2), v = m[0], p = m[1], y = (0, u.useState)(s + i.Time.getSecondsFromPrevTime(v || 0, !0)), T = o(y, 2), g = T[0], b = T[1], h = (0, u.useState)(t), S = o(h, 2), w = S[0], O = S[1];
                return (0, a.useInterval)(function() {
                    b(s + i.Time.getSecondsFromPrevTime(v, !0));
                }, w ? 1e3 : null), n({}, i.Time.getTimeFromSeconds(g), {
                    start: function() {
                        var e = new Date;
                        p(e), O(!0), b(s + i.Time.getSecondsFromPrevTime(e, !0));
                    },
                    pause: function() {
                        l(g), O(!1);
                    },
                    reset: function() {
                        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0, t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], r = i.Time.getSecondsFromExpiry(e, !0) || 0, n = new Date;
                        p(n), l(r), O(t), b(r + i.Time.getSecondsFromPrevTime(n, !0));
                    },
                    isRunning: w
                });
            };
            var u = r(0), i = r(1), a = r(2);
        },
        function(e, t, r) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var n = Object.assign || function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var r = arguments[t];
                    for(var n in r)Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
                }
                return e;
            }, o = function() {
                return function(e, t) {
                    if (Array.isArray(e)) return e;
                    if (Symbol.iterator in Object(e)) return function(e, t) {
                        var r = [], n = !0, o = !1, u = void 0;
                        try {
                            for(var i, a = e[Symbol.iterator](); !(n = (i = a.next()).done) && (r.push(i.value), !t || r.length !== t); n = !0);
                        } catch (e) {
                            o = !0, u = e;
                        } finally{
                            try {
                                !n && a.return && a.return();
                            } finally{
                                if (o) throw u;
                            }
                        }
                        return r;
                    }(e, t);
                    throw new TypeError("Invalid attempt to destructure non-iterable instance");
                };
            }();
            t.default = function(e) {
                var t = e.format, r = (0, u.useState)(i.Time.getSecondsFromTimeNow()), c = o(r, 2), f = c[0], s = c[1];
                return (0, a.useInterval)(function() {
                    s(i.Time.getSecondsFromTimeNow());
                }, 1e3), n({}, i.Time.getFormattedTimeFromSeconds(f, t));
            };
            var u = r(0), i = r(1), a = r(2);
        }
    ]);
});






const $3bb91c6efe6d427a$export$4748a2e3a6d34ca5 = 59;
const $3bb91c6efe6d427a$var$getTimeout = ()=>{
    const now = new Date();
    now.setSeconds(now.getSeconds() + $3bb91c6efe6d427a$export$4748a2e3a6d34ca5);
    return now;
};
const $3bb91c6efe6d427a$var$useResendVerificationCode = (type, method, target)=>{
    const { setToast: setToast } = (0, $d1e7a25fbbe7c8e1$export$2e2bcd8739ae039)();
    const { seconds: seconds, isRunning: isRunning, restart: restart } = (0, $3f1cd7f9a7df3e0c$exports.useTimer)({
        autoStart: true,
        expiryTimestamp: $3bb91c6efe6d427a$var$getTimeout()
    });
    const handleError = (0, $7ebd5fdad7a45c9e$export$2e2bcd8739ae039)();
    const sendVerificationCode = (0, $ab5ab705a7d3e209$export$2e2bcd8739ae039)((0, $93b564bd57b019d2$export$6443fa89a66c693a));
    const onResendVerificationCode = (0, $P551f.useCallback)(async ()=>{
        const payload = method === (0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Email ? {
            email: target
        } : {
            phone: target
        };
        const [error, result] = await sendVerificationCode(type, payload);
        if (error) {
            await handleError(error);
            return;
        }
        if (result) {
            setToast((0, $86e325ac3ddbcfa1$export$625550452a3fa3ec)("description.passcode_sent"));
            restart($3bb91c6efe6d427a$var$getTimeout(), true);
        }
    }, [
        handleError,
        method,
        restart,
        sendVerificationCode,
        setToast,
        target,
        type
    ]);
    return {
        seconds: seconds,
        isRunning: isRunning,
        onResendVerificationCode: onResendVerificationCode
    };
};
var $3bb91c6efe6d427a$export$2e2bcd8739ae039 = $3bb91c6efe6d427a$var$useResendVerificationCode;






var $P551f = parcelRequire("P551f");







var $P551f = parcelRequire("P551f");
const $36a9887e6e68947a$var$useGeneralVerificationCodeErrorHandler = ()=>{
    const [errorMessage, setErrorMessage] = (0, $P551f.useState)();
    // Have to wrap up in a useMemo hook otherwise the handler updates on every cycle
    const generalVerificationCodeErrorHandlers = (0, $P551f.useMemo)(()=>({
            "verification_code.expired": (error)=>{
                setErrorMessage(error.message);
            },
            "verification_code.code_mismatch": (error)=>{
                setErrorMessage(error.message);
            }
        }), []);
    return {
        errorMessage: errorMessage,
        generalVerificationCodeErrorHandlers: generalVerificationCodeErrorHandlers,
        clearErrorMessage: ()=>{
            setErrorMessage("");
        }
    };
};
var $36a9887e6e68947a$export$2e2bcd8739ae039 = $36a9887e6e68947a$var$useGeneralVerificationCodeErrorHandler;




var $P551f = parcelRequire("P551f");




var $7a7dd64aa15b6aa3$export$7ba9b85da6ef21b1;
(function(IdentifierErrorType) {
    IdentifierErrorType["IdentifierNotExist"] = "IdentifierNotExist";
    IdentifierErrorType["IdentifierAlreadyExists"] = "IdentifierAlreadyExists";
})($7a7dd64aa15b6aa3$export$7ba9b85da6ef21b1 || ($7a7dd64aa15b6aa3$export$7ba9b85da6ef21b1 = {}));
const $7a7dd64aa15b6aa3$var$useIdentifierErrorAlert = ()=>{
    const { show: show } = (0, $f3ae436b724671df$export$753980156bc86c10)();
    const navigate = (0, $2ed817dc54ac40e6$export$9770f232ac06a008)();
    const { t: t } = (0, $5d79e62c9ff74ac9$export$9fc83ad70ead8663)();
    // Have to wrap up in a useCallback hook otherwise the handler updates on every cycle
    return (0, $P551f.useCallback)(async (errorType, method, value)=>{
        await show({
            type: "alert",
            ModalContent: t(errorType === $7a7dd64aa15b6aa3$export$7ba9b85da6ef21b1.IdentifierAlreadyExists ? "description.create_account_id_exists_alert" : "description.sign_in_id_does_not_exist_alert", {
                type: t(`description.${method === (0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Email ? "email" : "phone_number"}`),
                value: method === (0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Phone ? (0, $dc69be136f5b72f6$export$79abe912f70ec8f5)(value) : value
            }),
            cancelText: "action.change",
            cancelTextI18nProps: {
                method: t(`description.${method === (0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Email ? "email" : "phone_number"}`)
            }
        });
        navigate(-1);
    }, [
        navigate,
        show,
        t
    ]);
};
var $7a7dd64aa15b6aa3$export$2e2bcd8739ae039 = $7a7dd64aa15b6aa3$var$useIdentifierErrorAlert;




var $P551f = parcelRequire("P551f");




var $P551f = parcelRequire("P551f");



const $9fd060c8d3556aef$var$useLinkSocial = ()=>{
    const handleError = (0, $7ebd5fdad7a45c9e$export$2e2bcd8739ae039)();
    const asyncLinkWithSocial = (0, $ab5ab705a7d3e209$export$2e2bcd8739ae039)((0, $72a4b194eaf87ab0$export$75b0bae8270ba103));
    return (0, $P551f.useCallback)(async (connectorId)=>{
        const [error, result] = await asyncLinkWithSocial(connectorId);
        if (error) {
            await handleError(error);
            return;
        }
        if (result === null || result === void 0 ? void 0 : result.redirectTo) window.location.replace(result.redirectTo);
    }, [
        asyncLinkWithSocial,
        handleError
    ]);
};
var $9fd060c8d3556aef$export$2e2bcd8739ae039 = $9fd060c8d3556aef$var$useLinkSocial;



const $341068c1e5c83b17$var$useLinkSocialConfirmModal = ()=>{
    const { show: show } = (0, $f3ae436b724671df$export$753980156bc86c10)();
    const { t: t } = (0, $5d79e62c9ff74ac9$export$9fc83ad70ead8663)();
    const linkWithSocial = (0, $9fd060c8d3556aef$export$2e2bcd8739ae039)();
    const navigate = (0, $2ed817dc54ac40e6$export$9770f232ac06a008)();
    return (0, $P551f.useCallback)(async (method, target, connectorId)=>{
        const [confirm] = await show({
            confirmText: "action.bind_and_continue",
            cancelText: "action.change",
            cancelTextI18nProps: {
                method: t(`description.${method === (0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Email ? "email" : "phone_number"}`)
            },
            ModalContent: t("description.link_account_id_exists", {
                type: t(`description.${method === (0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Email ? "email" : "phone_number"}`),
                value: method === (0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Phone ? (0, $dc69be136f5b72f6$export$79abe912f70ec8f5)(target) : target
            })
        });
        if (!confirm) {
            navigate(-1);
            return;
        }
        await linkWithSocial(connectorId);
    }, [
        linkWithSocial,
        navigate,
        show,
        t
    ]);
};
var $341068c1e5c83b17$export$2e2bcd8739ae039 = $341068c1e5c83b17$var$useLinkSocialConfirmModal;


const $a760157fc8ac6a0b$var$useContinueFlowCodeVerification = (_method, target, errorCallback)=>{
    const [searchParameters] = (0, $efe29403354254eb$export$f1a78c17382fe22a)();
    const handleError = (0, $7ebd5fdad7a45c9e$export$2e2bcd8739ae039)();
    const verifyVerificationCode = (0, $ab5ab705a7d3e209$export$2e2bcd8739ae039)((0, $72a4b194eaf87ab0$export$1f2cf4d85f14ded7));
    const { generalVerificationCodeErrorHandlers: generalVerificationCodeErrorHandlers, errorMessage: errorMessage, clearErrorMessage: clearErrorMessage } = (0, $36a9887e6e68947a$export$2e2bcd8739ae039)();
    const preSignInErrorHandler = (0, $c93ac0a28f6f81db$export$2e2bcd8739ae039)({
        replace: true
    });
    const showIdentifierErrorAlert = (0, $7a7dd64aa15b6aa3$export$2e2bcd8739ae039)();
    const showLinkSocialConfirmModal = (0, $341068c1e5c83b17$export$2e2bcd8739ae039)();
    const identifierExistErrorHandler = (0, $P551f.useCallback)(async (method, target)=>{
        const linkSocial = searchParameters.get((0, $6b1416e8e4d304fe$export$c4eb3ba4f04fab5).LinkSocial);
        // Show bind with social confirm modal
        if (linkSocial) {
            await showLinkSocialConfirmModal(method, target, linkSocial);
            return;
        }
        await showIdentifierErrorAlert((0, $7a7dd64aa15b6aa3$export$7ba9b85da6ef21b1).IdentifierAlreadyExists, method, target);
    }, [
        searchParameters,
        showIdentifierErrorAlert,
        showLinkSocialConfirmModal
    ]);
    const verifyVerificationCodeErrorHandlers = (0, $P551f.useMemo)(()=>(0, $0de5391da8318002$export$581ff339ea0ba762)({
            "user.phone_already_in_use": async ()=>identifierExistErrorHandler((0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Phone, target),
            "user.email_already_in_use": async ()=>identifierExistErrorHandler((0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Email, target)
        }, preSignInErrorHandler, generalVerificationCodeErrorHandlers), [
        preSignInErrorHandler,
        generalVerificationCodeErrorHandlers,
        identifierExistErrorHandler,
        target
    ]);
    const onSubmit = (0, $P551f.useCallback)(async (payload)=>{
        const [error, result] = await verifyVerificationCode(payload);
        if (error) {
            await handleError(error, verifyVerificationCodeErrorHandlers);
            errorCallback === null || errorCallback === void 0 ? void 0 : errorCallback();
            return;
        }
        if (result === null || result === void 0 ? void 0 : result.redirectTo) window.location.replace(result.redirectTo);
    }, [
        errorCallback,
        handleError,
        verifyVerificationCode,
        verifyVerificationCodeErrorHandlers
    ]);
    return {
        errorMessage: errorMessage,
        clearErrorMessage: clearErrorMessage,
        onSubmit: onSubmit
    };
};
var $a760157fc8ac6a0b$export$2e2bcd8739ae039 = $a760157fc8ac6a0b$var$useContinueFlowCodeVerification;




var $P551f = parcelRequire("P551f");







const $c4399ab9c4d185f4$var$useForgotPasswordFlowCodeVerification = (method, target, errorCallback)=>{
    const navigate = (0, $2ed817dc54ac40e6$export$9770f232ac06a008)();
    const handleError = (0, $7ebd5fdad7a45c9e$export$2e2bcd8739ae039)();
    const verifyVerificationCode = (0, $ab5ab705a7d3e209$export$2e2bcd8739ae039)((0, $72a4b194eaf87ab0$export$df60c504f9d9103e));
    const { generalVerificationCodeErrorHandlers: generalVerificationCodeErrorHandlers, errorMessage: errorMessage, clearErrorMessage: clearErrorMessage } = (0, $36a9887e6e68947a$export$2e2bcd8739ae039)();
    const identifierErrorHandler = (0, $7a7dd64aa15b6aa3$export$2e2bcd8739ae039)();
    const errorHandlers = (0, $P551f.useMemo)(()=>(0, $0de5391da8318002$export$581ff339ea0ba762)({
            "user.user_not_exist": async ()=>identifierErrorHandler((0, $7a7dd64aa15b6aa3$export$7ba9b85da6ef21b1).IdentifierNotExist, method, target),
            "user.new_password_required_in_profile": ()=>{
                navigate(`/${(0, $6b1416e8e4d304fe$export$12e44e23ec720850).ForgotPassword}/reset`, {
                    replace: true
                });
            }
        }, generalVerificationCodeErrorHandlers), [
        generalVerificationCodeErrorHandlers,
        identifierErrorHandler,
        method,
        target,
        navigate
    ]);
    const onSubmit = (0, $P551f.useCallback)(async (payload)=>{
        const [error, result] = await verifyVerificationCode(payload);
        if (error) {
            await handleError(error, errorHandlers);
            errorCallback === null || errorCallback === void 0 ? void 0 : errorCallback();
            return;
        }
        if (result) navigate(`/${(0, $6b1416e8e4d304fe$export$12e44e23ec720850).SignIn}`, {
            replace: true
        });
    }, [
        errorCallback,
        errorHandlers,
        handleError,
        navigate,
        verifyVerificationCode
    ]);
    return {
        errorMessage: errorMessage,
        clearErrorMessage: clearErrorMessage,
        onSubmit: onSubmit
    };
};
var $c4399ab9c4d185f4$export$2e2bcd8739ae039 = $c4399ab9c4d185f4$var$useForgotPasswordFlowCodeVerification;






var $P551f = parcelRequire("P551f");











const $0c94d1944804a8b0$var$useRegisterFlowCodeVerification = (method, target, errorCallback)=>{
    const { t: t } = (0, $5d79e62c9ff74ac9$export$9fc83ad70ead8663)();
    const { show: show } = (0, $f3ae436b724671df$export$753980156bc86c10)();
    const navigate = (0, $2ed817dc54ac40e6$export$9770f232ac06a008)();
    const { signInMode: signInMode } = (0, $aa5a893d65a133eb$export$317715a729435b35)();
    const handleError = (0, $7ebd5fdad7a45c9e$export$2e2bcd8739ae039)();
    const signInWithIdentifierAsync = (0, $ab5ab705a7d3e209$export$2e2bcd8739ae039)((0, $72a4b194eaf87ab0$export$85e251dbbdeeea73));
    const verifyVerificationCode = (0, $ab5ab705a7d3e209$export$2e2bcd8739ae039)((0, $72a4b194eaf87ab0$export$1f2cf4d85f14ded7));
    const { errorMessage: errorMessage, clearErrorMessage: clearErrorMessage, generalVerificationCodeErrorHandlers: generalVerificationCodeErrorHandlers } = (0, $36a9887e6e68947a$export$2e2bcd8739ae039)();
    const preSignInErrorHandler = (0, $c93ac0a28f6f81db$export$2e2bcd8739ae039)({
        replace: true
    });
    const showIdentifierErrorAlert = (0, $7a7dd64aa15b6aa3$export$2e2bcd8739ae039)();
    const identifierExistErrorHandler = (0, $P551f.useCallback)(async ()=>{
        // Should not redirect user to sign-in if is register-only mode
        if (signInMode === (0, $3ce2871eb3919730$export$f927bbb3d448dc2b).Register) {
            showIdentifierErrorAlert((0, $7a7dd64aa15b6aa3$export$7ba9b85da6ef21b1).IdentifierAlreadyExists, method, target);
            return;
        }
        const [confirm] = await show({
            confirmText: "action.sign_in",
            ModalContent: t("description.create_account_id_exists", {
                type: t(`description.${method === (0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Email ? "email" : "phone_number"}`),
                value: method === (0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Phone ? (0, $dc69be136f5b72f6$export$79abe912f70ec8f5)(target) : target
            })
        });
        if (!confirm) {
            navigate(-1);
            return;
        }
        const [error, result] = await signInWithIdentifierAsync();
        if (error) {
            await handleError(error, preSignInErrorHandler);
            return;
        }
        if (result === null || result === void 0 ? void 0 : result.redirectTo) window.location.replace(result.redirectTo);
    }, [
        handleError,
        method,
        navigate,
        preSignInErrorHandler,
        show,
        showIdentifierErrorAlert,
        signInMode,
        signInWithIdentifierAsync,
        t,
        target
    ]);
    const errorHandlers = (0, $P551f.useMemo)(()=>(0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({
            "user.email_already_in_use": identifierExistErrorHandler,
            "user.phone_already_in_use": identifierExistErrorHandler
        }, generalVerificationCodeErrorHandlers, preSignInErrorHandler), {
            callback: errorCallback
        }), [
        identifierExistErrorHandler,
        generalVerificationCodeErrorHandlers,
        preSignInErrorHandler,
        errorCallback
    ]);
    const onSubmit = (0, $P551f.useCallback)(async (payload)=>{
        const [error, result] = await verifyVerificationCode(payload);
        if (error) {
            await handleError(error, errorHandlers);
            errorCallback === null || errorCallback === void 0 ? void 0 : errorCallback();
            return;
        }
        if (result === null || result === void 0 ? void 0 : result.redirectTo) window.location.replace(result.redirectTo);
    }, [
        errorCallback,
        errorHandlers,
        handleError,
        verifyVerificationCode
    ]);
    return {
        errorMessage: errorMessage,
        clearErrorMessage: clearErrorMessage,
        onSubmit: onSubmit
    };
};
var $0c94d1944804a8b0$export$2e2bcd8739ae039 = $0c94d1944804a8b0$var$useRegisterFlowCodeVerification;






var $P551f = parcelRequire("P551f");











const $66a4b9909680d062$var$useSignInFlowCodeVerification = (method, target, errorCallback)=>{
    const { t: t } = (0, $5d79e62c9ff74ac9$export$9fc83ad70ead8663)();
    const { show: show } = (0, $f3ae436b724671df$export$753980156bc86c10)();
    const navigate = (0, $2ed817dc54ac40e6$export$9770f232ac06a008)();
    const { signInMode: signInMode } = (0, $aa5a893d65a133eb$export$317715a729435b35)();
    const handleError = (0, $7ebd5fdad7a45c9e$export$2e2bcd8739ae039)();
    const registerWithIdentifierAsync = (0, $ab5ab705a7d3e209$export$2e2bcd8739ae039)((0, $72a4b194eaf87ab0$export$ec172577cee1ef2a));
    const asyncSignInWithVerificationCodeIdentifier = (0, $ab5ab705a7d3e209$export$2e2bcd8739ae039)((0, $72a4b194eaf87ab0$export$e01e93c3ae4f0e08));
    const { errorMessage: errorMessage, clearErrorMessage: clearErrorMessage, generalVerificationCodeErrorHandlers: generalVerificationCodeErrorHandlers } = (0, $36a9887e6e68947a$export$2e2bcd8739ae039)();
    const preSignInErrorHandler = (0, $c93ac0a28f6f81db$export$2e2bcd8739ae039)({
        replace: true
    });
    const showIdentifierErrorAlert = (0, $7a7dd64aa15b6aa3$export$2e2bcd8739ae039)();
    const identifierNotExistErrorHandler = (0, $P551f.useCallback)(async ()=>{
        // Should not redirect user to register if is sign-in only mode or bind social flow
        if (signInMode === (0, $3ce2871eb3919730$export$f927bbb3d448dc2b).SignIn) {
            showIdentifierErrorAlert((0, $7a7dd64aa15b6aa3$export$7ba9b85da6ef21b1).IdentifierNotExist, method, target);
            return;
        }
        const [confirm] = await show({
            confirmText: "action.create",
            ModalContent: t("description.sign_in_id_does_not_exist", {
                type: t(`description.${method === (0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Email ? "email" : "phone_number"}`),
                value: method === (0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Phone ? (0, $dc69be136f5b72f6$export$79abe912f70ec8f5)(target) : target
            })
        });
        if (!confirm) {
            navigate(-1);
            return;
        }
        const [error, result] = await registerWithIdentifierAsync(method === (0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Email ? {
            email: target
        } : {
            phone: target
        });
        if (error) {
            await handleError(error, preSignInErrorHandler);
            return;
        }
        if (result === null || result === void 0 ? void 0 : result.redirectTo) window.location.replace(result.redirectTo);
    }, [
        handleError,
        method,
        navigate,
        registerWithIdentifierAsync,
        preSignInErrorHandler,
        show,
        showIdentifierErrorAlert,
        signInMode,
        t,
        target
    ]);
    const errorHandlers = (0, $P551f.useMemo)(()=>(0, $6c438fc4da5900c8$export$4fa2f4023c9cbda5)((0, $0de5391da8318002$export$581ff339ea0ba762)({
            "user.user_not_exist": identifierNotExistErrorHandler
        }, generalVerificationCodeErrorHandlers, preSignInErrorHandler), {
            callback: errorCallback
        }), [
        errorCallback,
        identifierNotExistErrorHandler,
        preSignInErrorHandler,
        generalVerificationCodeErrorHandlers
    ]);
    const onSubmit = (0, $P551f.useCallback)(async (payload)=>{
        const [error, result] = await asyncSignInWithVerificationCodeIdentifier(payload);
        if (error) {
            await handleError(error, errorHandlers);
            return;
        }
        if (result === null || result === void 0 ? void 0 : result.redirectTo) window.location.replace(result.redirectTo);
    }, [
        asyncSignInWithVerificationCodeIdentifier,
        errorHandlers,
        handleError
    ]);
    return {
        errorMessage: errorMessage,
        clearErrorMessage: clearErrorMessage,
        onSubmit: onSubmit
    };
};
var $66a4b9909680d062$export$2e2bcd8739ae039 = $66a4b9909680d062$var$useSignInFlowCodeVerification;


const $64a3c33bbf62213f$export$31c188ca419e053a = Object.freeze({
    [(0, $6b1416e8e4d304fe$export$12e44e23ec720850).SignIn]: (0, $66a4b9909680d062$export$2e2bcd8739ae039),
    [(0, $6b1416e8e4d304fe$export$12e44e23ec720850).Register]: (0, $0c94d1944804a8b0$export$2e2bcd8739ae039),
    [(0, $6b1416e8e4d304fe$export$12e44e23ec720850).ForgotPassword]: (0, $c4399ab9c4d185f4$export$2e2bcd8739ae039),
    [(0, $6b1416e8e4d304fe$export$12e44e23ec720850).Continue]: (0, $a760157fc8ac6a0b$export$2e2bcd8739ae039)
});
const $64a3c33bbf62213f$export$89feea6263bb6663 = (flow)=>$64a3c33bbf62213f$export$31c188ca419e053a[flow];


const $dc74f20bec4f995c$var$VerificationCode = ({ flow: flow, identifier: identifier, className: className, hasPasswordButton: hasPasswordButton, target: target })=>{
    const [code, setCode] = (0, $P551f.useState)([]);
    const { t: t } = (0, $5d79e62c9ff74ac9$export$9fc83ad70ead8663)();
    const useVerificationCode = (0, $64a3c33bbf62213f$export$89feea6263bb6663)(flow);
    const errorCallback = (0, $P551f.useCallback)(()=>{
        setCode([]);
    }, []);
    const { errorMessage: errorMessage, clearErrorMessage: clearErrorMessage, onSubmit: onSubmit } = useVerificationCode(identifier, target, errorCallback);
    const { seconds: seconds, isRunning: isRunning, onResendVerificationCode: onResendVerificationCode } = (0, $3bb91c6efe6d427a$export$2e2bcd8739ae039)(flow, identifier, target);
    (0, $P551f.useEffect)(()=>{
        if (code.length === (0, $f054060f7cd4db44$export$439d7c9fdf7148d2) && code.every(Boolean)) {
            const payload = identifier === (0, $c0e46a7ec45ea8f3$export$f2322d76aef584c7).Email ? {
                email: target,
                verificationCode: code.join("")
            } : {
                phone: target,
                verificationCode: code.join("")
            };
            onSubmit(payload);
        }
    }, [
        code,
        identifier,
        onSubmit,
        target
    ]);
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)("form", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a6f0144cf2b2d456$exports)))($a351b1bce2c9a3aa$export$6210fa4921d2a466, className),
        children: [
            /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $f054060f7cd4db44$export$2e2bcd8739ae039), {
                name: "passcode",
                className: (0, (/*@__PURE__*/$parcel$interopDefault($a6f0144cf2b2d456$exports)))($a351b1bce2c9a3aa$export$6f2f4d5c38fc8e55, errorMessage && $a351b1bce2c9a3aa$export$60e9e0884ce12b55),
                value: code,
                error: errorMessage,
                onChange: setCode
            }),
            isRunning ? /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("div", {
                className: $a351b1bce2c9a3aa$export$a8ecead220dd38a6,
                children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $f51ffae15bc36a59$export$8d6a9236f2e3f2ce), {
                    components: {
                        span: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)("span", {}, "counter")
                    },
                    children: t("description.resend_after_seconds", {
                        seconds: seconds
                    })
                })
            }) : /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $b6cc3a098ca171c6$export$2e2bcd8739ae039), {
                className: $a351b1bce2c9a3aa$export$9c30223ca0a664fb,
                text: "description.resend_passcode",
                onClick: async ()=>{
                    clearErrorMessage();
                    await onResendVerificationCode();
                    setCode([]);
                }
            }),
            flow === (0, $6b1416e8e4d304fe$export$12e44e23ec720850).SignIn && hasPasswordButton && /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $932257d7966166a2$export$2e2bcd8739ae039), {
                method: identifier,
                target: target,
                className: $a351b1bce2c9a3aa$export$52002a3975269b5d
            })
        ]
    });
};
var $dc74f20bec4f995c$export$2e2bcd8739ae039 = $dc74f20bec4f995c$var$VerificationCode;







const $75dbb79945775ba4$var$VerificationCode = ()=>{
    const { flow: flow } = (0, $2ed817dc54ac40e6$export$99eaa27ddbbb95ef)();
    const { signInMethods: signInMethods } = (0, $aa5a893d65a133eb$export$317715a729435b35)();
    const { state: state } = (0, $2ed817dc54ac40e6$export$45d76561a5302f2b)();
    const [, identifierState] = (0, $8a18d710f1d13368$export$a22775fa5e2eebd9)(state, (0, $4ffc90f7233cdad4$export$1e0c25ccbe67b008));
    const [, useFlow] = (0, $8a18d710f1d13368$export$a22775fa5e2eebd9)(flow, (0, $4ffc90f7233cdad4$export$76ad0037102e2eeb));
    if (!useFlow) return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $bcc9cc4bed8427a6$export$2e2bcd8739ae039), {});
    if (!identifierState) return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $bcc9cc4bed8427a6$export$2e2bcd8739ae039), {
        title: "error.invalid_session"
    });
    const { identifier: identifier, value: value } = identifierState;
    const methodSettings = signInMethods.find((method)=>method.identifier === identifier);
    // SignIn Method not enabled
    if (!methodSettings && flow !== (0, $6b1416e8e4d304fe$export$12e44e23ec720850).ForgotPassword) return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $bcc9cc4bed8427a6$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $3dc734e3f6636ef1$export$2e2bcd8739ae039), {
        title: `description.verify_${identifier}`,
        description: "description.enter_passcode",
        descriptionProps: {
            address: (0, $86e325ac3ddbcfa1$export$625550452a3fa3ec)(`description.${identifier === "email" ? "email" : "phone_number"}`),
            target: identifier === "phone" ? (0, $dc69be136f5b72f6$export$79abe912f70ec8f5)(value) : value
        },
        children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $dc74f20bec4f995c$export$2e2bcd8739ae039), {
            flow: useFlow,
            identifier: identifier,
            target: value,
            hasPasswordButton: useFlow === (0, $6b1416e8e4d304fe$export$12e44e23ec720850).SignIn && (methodSettings === null || methodSettings === void 0 ? void 0 : methodSettings.password)
        })
    });
};
var $75dbb79945775ba4$export$2e2bcd8739ae039 = $75dbb79945775ba4$var$VerificationCode;





(0, $43897e40155c833c$export$24c2f7fddd6751e5)();
const $d0894540bc20c740$var$App = ()=>{
    return /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $efe29403354254eb$export$9ba4e89fdfa1fc54), {
        children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $3b4c3e5c846a9406$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $c16df7251a343c37$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $8ab2267ce4741904$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $989ece0370d3b835$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $b463edcd3feef6e8$export$2e2bcd8739ae039), {
                            cloudRole: "ui",
                            children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $2ed817dc54ac40e6$export$3565eb3d00ca5a74), {
                                children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)((0, $2ed817dc54ac40e6$export$e7b0ac011bb776c6), {
                                    element: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $7df47bd2f5575fc8$export$2e2bcd8739ae039), {}),
                                    children: [
                                        /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $2ed817dc54ac40e6$export$e7b0ac011bb776c6), {
                                            path: "springboard",
                                            element: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $6160caab2f3e5c0d$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $2ed817dc54ac40e6$export$e7b0ac011bb776c6), {
                                            path: "callback/:connectorId",
                                            element: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $a82510b1f88da2d3$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $2ed817dc54ac40e6$export$e7b0ac011bb776c6), {
                                            path: "callback/social/:connectorId",
                                            element: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $5fc75cc17bf86447$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $2ed817dc54ac40e6$export$e7b0ac011bb776c6), {
                                            path: "direct/:method/:target?",
                                            element: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $21435978485dd732$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)((0, $2ed817dc54ac40e6$export$e7b0ac011bb776c6), {
                                            element: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $e0aef99e4cad3e2b$export$2e2bcd8739ae039), {}),
                                            children: [
                                                /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $2ed817dc54ac40e6$export$e7b0ac011bb776c6), {
                                                    path: "unknown-session",
                                                    element: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $bcc9cc4bed8427a6$export$2e2bcd8739ae039), {
                                                        message: "error.invalid_session"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)((0, $2ed817dc54ac40e6$export$e7b0ac011bb776c6), {
                                                    path: (0, $a0052762c6755033$export$45794d16c9d83fe2).routes.signIn,
                                                    children: [
                                                        /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $2ed817dc54ac40e6$export$e7b0ac011bb776c6), {
                                                            index: true,
                                                            element: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $a292010c85feba82$export$2e2bcd8739ae039), {})
                                                        }),
                                                        /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $2ed817dc54ac40e6$export$e7b0ac011bb776c6), {
                                                            path: "password",
                                                            element: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $11c0c069669583be$export$2e2bcd8739ae039), {})
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)((0, $2ed817dc54ac40e6$export$e7b0ac011bb776c6), {
                                                    path: (0, $a0052762c6755033$export$45794d16c9d83fe2).routes.register,
                                                    children: [
                                                        /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $2ed817dc54ac40e6$export$e7b0ac011bb776c6), {
                                                            index: true,
                                                            element: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $017128ca51452c7d$export$2e2bcd8739ae039), {})
                                                        }),
                                                        /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $2ed817dc54ac40e6$export$e7b0ac011bb776c6), {
                                                            path: "password",
                                                            element: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $aa9af0979d19e376$export$2e2bcd8739ae039), {})
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)((0, $2ed817dc54ac40e6$export$e7b0ac011bb776c6), {
                                                    path: "forgot-password",
                                                    children: [
                                                        /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $2ed817dc54ac40e6$export$e7b0ac011bb776c6), {
                                                            index: true,
                                                            element: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $58d5e993209d607f$export$2e2bcd8739ae039), {})
                                                        }),
                                                        /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $2ed817dc54ac40e6$export$e7b0ac011bb776c6), {
                                                            path: "reset",
                                                            element: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $d94b40f4ca3d298b$export$2e2bcd8739ae039), {})
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $2ed817dc54ac40e6$export$e7b0ac011bb776c6), {
                                                    path: ":flow/verification-code",
                                                    element: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $75dbb79945775ba4$export$2e2bcd8739ae039), {})
                                                }),
                                                /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)((0, $2ed817dc54ac40e6$export$e7b0ac011bb776c6), {
                                                    path: (0, $6b1416e8e4d304fe$export$6a49be5b3307a2d).MfaBinding,
                                                    children: [
                                                        /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $2ed817dc54ac40e6$export$e7b0ac011bb776c6), {
                                                            index: true,
                                                            element: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $c6e46251486b8cf2$export$2e2bcd8739ae039), {})
                                                        }),
                                                        /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $2ed817dc54ac40e6$export$e7b0ac011bb776c6), {
                                                            path: (0, $c0e46a7ec45ea8f3$export$c62e7669a75c5961).TOTP,
                                                            element: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $b5d659fa14e7bd68$export$2e2bcd8739ae039), {})
                                                        }),
                                                        /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $2ed817dc54ac40e6$export$e7b0ac011bb776c6), {
                                                            path: (0, $c0e46a7ec45ea8f3$export$c62e7669a75c5961).WebAuthn,
                                                            element: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $237d9bc7df8064df$export$2e2bcd8739ae039), {})
                                                        }),
                                                        /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $2ed817dc54ac40e6$export$e7b0ac011bb776c6), {
                                                            path: (0, $c0e46a7ec45ea8f3$export$c62e7669a75c5961).BackupCode,
                                                            element: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $02fd4339abc7ac9a$export$2e2bcd8739ae039), {})
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)((0, $2ed817dc54ac40e6$export$e7b0ac011bb776c6), {
                                                    path: (0, $6b1416e8e4d304fe$export$6a49be5b3307a2d).MfaVerification,
                                                    children: [
                                                        /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $2ed817dc54ac40e6$export$e7b0ac011bb776c6), {
                                                            index: true,
                                                            element: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $302be2f1a49c3daf$export$2e2bcd8739ae039), {})
                                                        }),
                                                        /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $2ed817dc54ac40e6$export$e7b0ac011bb776c6), {
                                                            path: (0, $c0e46a7ec45ea8f3$export$c62e7669a75c5961).TOTP,
                                                            element: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $93353585ff980d81$export$2e2bcd8739ae039), {})
                                                        }),
                                                        /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $2ed817dc54ac40e6$export$e7b0ac011bb776c6), {
                                                            path: (0, $c0e46a7ec45ea8f3$export$c62e7669a75c5961).WebAuthn,
                                                            element: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $5526df7bfc055688$export$2e2bcd8739ae039), {})
                                                        }),
                                                        /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $2ed817dc54ac40e6$export$e7b0ac011bb776c6), {
                                                            path: (0, $c0e46a7ec45ea8f3$export$c62e7669a75c5961).BackupCode,
                                                            element: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $6d8f4031aa915671$export$2e2bcd8739ae039), {})
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $2ed817dc54ac40e6$export$e7b0ac011bb776c6), {
                                                    path: "continue",
                                                    children: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $2ed817dc54ac40e6$export$e7b0ac011bb776c6), {
                                                        path: ":method",
                                                        element: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $720c4ec3fe81222b$export$2e2bcd8739ae039), {})
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)((0, $2ed817dc54ac40e6$export$e7b0ac011bb776c6), {
                                                    path: "social",
                                                    children: [
                                                        /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $2ed817dc54ac40e6$export$e7b0ac011bb776c6), {
                                                            path: "link/:connectorId",
                                                            element: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $67837aa82fc0a64d$export$2e2bcd8739ae039), {})
                                                        }),
                                                        /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $2ed817dc54ac40e6$export$e7b0ac011bb776c6), {
                                                            path: "landing/:connectorId",
                                                            element: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $c923ad08dcea5115$export$2e2bcd8739ae039), {})
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsxs)((0, $2ed817dc54ac40e6$export$e7b0ac011bb776c6), {
                                                    path: (0, $a0052762c6755033$export$45794d16c9d83fe2).routes.sso,
                                                    element: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $7df47bd2f5575fc8$export$2e2bcd8739ae039), {}),
                                                    children: [
                                                        /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $2ed817dc54ac40e6$export$e7b0ac011bb776c6), {
                                                            path: "email",
                                                            element: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $5bba50cfe1a799bc$export$2e2bcd8739ae039), {})
                                                        }),
                                                        /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $2ed817dc54ac40e6$export$e7b0ac011bb776c6), {
                                                            path: "connectors",
                                                            element: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $91b600b6f8274192$export$2e2bcd8739ae039), {})
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $2ed817dc54ac40e6$export$e7b0ac011bb776c6), {
                                                    path: "consent",
                                                    element: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $419e526a97bad927$export$2e2bcd8739ae039), {})
                                                }),
                                                /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $2ed817dc54ac40e6$export$e7b0ac011bb776c6), {
                                                    path: "*",
                                                    element: /*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $bcc9cc4bed8427a6$export$2e2bcd8739ae039), {})
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        })
                    })
                })
            })
        })
    });
};
var $d0894540bc20c740$export$2e2bcd8739ae039 = $d0894540bc20c740$var$App;


const $f36a3aebbe4bf1d2$var$app = document.querySelector("#app");
const $f36a3aebbe4bf1d2$var$root = $f36a3aebbe4bf1d2$var$app && (0, $1f7064be4a077270$export$882461b6382ed46c)($f36a3aebbe4bf1d2$var$app);
(0, (/*@__PURE__*/$parcel$interopDefault($e479b6ac5364ae16$exports))).setAppElement("#app");
$f36a3aebbe4bf1d2$var$root === null || $f36a3aebbe4bf1d2$var$root === void 0 ? void 0 : $f36a3aebbe4bf1d2$var$root.render(/*#__PURE__*/ (0, $b1404a408b0d045c$exports.jsx)((0, $d0894540bc20c740$export$2e2bcd8739ae039), {}));


//# sourceMappingURL=index.7b29e72a.js.map
